export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
   [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
   { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
   { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
   ID: string
   String: string
   Boolean: boolean
   Int: number
   Float: number
}

export type AwAssigneeHierarchyLog = {
   __typename?: 'AWAssigneeHierarchyLog'
   assignedFrom?: Maybe<BaseUser>
   assignedTo?: Maybe<BaseUser>
   fieldId: Scalars['String']
   isAssigneeHierarchyField: Scalars['Boolean']
}

export type AcceptTdrTransactionByOwnerParams = {
   otp: Scalars['String']
   transactionId: Scalars['String']
}

export type AcceptTdrTransactionByOwnerResponse =
   | AcceptTdrTransactionByOwnerResult
   | InvalidOtp
   | NotAllowedTdrAccountTransactionStatus
   | NotAllowedUtilizationTransactionStatus
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | OtpRequiredForTransactionAcceptance
   | OnlyUtilizeTransactionCanBeAcceptedByOwner
   | OwnerAlreadyAcceptedTransaction
   | TdrAccountTransactionNotFound
   | TdrRequestAcceptanceFailedError

export type AcceptTdrTransactionByOwnerResult = {
   __typename?: 'AcceptTDRTransactionByOwnerResult'
   transaction: TdrAccountTransaction
}

export type AccessDenied = GraphQlBaseError & {
   __typename?: 'AccessDenied'
   message?: Maybe<Scalars['String']>
   requiredAuthority?: Maybe<Scalars['String']>
   requiredPermission?: Maybe<Scalars['String']>
   requiredRole?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type AccessDeniedForPinnedByUser = GraphQlBaseError & {
   __typename?: 'AccessDeniedForPinnedByUser'
   message?: Maybe<Scalars['String']>
   pinnedByUserId: Scalars['String']
}

export type AccessDeniedForScheduledByUser = GraphQlBaseError & {
   __typename?: 'AccessDeniedForScheduledByUser'
   message?: Maybe<Scalars['String']>
   scheduledByUserId: Scalars['String']
}

export type AccessDeniedForUser = GraphQlBaseError & {
   __typename?: 'AccessDeniedForUser'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type AccessDeniedToTriggerAutomationWorkflowsOnActivity = GraphQlBaseError & {
   __typename?: 'AccessDeniedToTriggerAutomationWorkflowsOnActivity'
   activityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AccessDeniedToUser = GraphQlBaseError & {
   __typename?: 'AccessDeniedToUser'
   message?: Maybe<Scalars['String']>
   name?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type Account = {
   __typename?: 'Account'
   createdBy: User
   id: Scalars['String']
   name: Scalars['String']
   pipelines: Array<Pipeline>
}

export type AccountAccessDeniedToAssignee = GraphQlBaseError & {
   __typename?: 'AccountAccessDeniedToAssignee'
   message?: Maybe<Scalars['String']>
}

export type AccountAccessDeniedToAssignees = GraphQlBaseError & {
   __typename?: 'AccountAccessDeniedToAssignees'
   assigneeIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AccountNotFound = GraphQlBaseError & {
   __typename?: 'AccountNotFound'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AccountPlugin = {
   __typename?: 'AccountPlugin'
   accountPluginId: Scalars['String']
   isEnabled: Scalars['Boolean']
   plugin: Plugin
   /** @deprecated Don't resolve this value, Using for retool only. */
   pluginServiceAccounts: Array<PluginServiceAccount>
   pluginType: PluginType
   webhookUrl?: Maybe<Scalars['String']>
}

export type AccountPluginIdNotFound = GraphQlBaseError & {
   __typename?: 'AccountPluginIdNotFound'
   accountPluginId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AccountPluginIsDisabled = GraphQlBaseError & {
   __typename?: 'AccountPluginIsDisabled'
   accountPluginId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AccountPluginNotFound = GraphQlBaseError & {
   __typename?: 'AccountPluginNotFound'
   message?: Maybe<Scalars['String']>
   pluginType: Scalars['String']
}

export type AccountPlugins = {
   __typename?: 'AccountPlugins'
   accountPlugins?: Maybe<Array<Maybe<AccountPlugin>>>
}

export enum AccountUnitType {
   SqYards = 'SQ_YARDS'
}

export type AccountUsers = {
   __typename?: 'AccountUsers'
   totalCount: Scalars['Int']
   users: Array<User>
}

export type AccountWithThisPhoneNumberAlreadyExists = GraphQlBaseError & {
   __typename?: 'AccountWithThisPhoneNumberAlreadyExists'
   message?: Maybe<Scalars['String']>
}

export enum ActOnApplicationFunctionExecutionEnum {
   InitiatedScrutiny = 'INITIATED_SCRUTINY',
   PaymentsCreated = 'PAYMENTS_CREATED'
}

export type ActOnApplicationInPortalMetaData = {
   __typename?: 'ActOnApplicationInPortalMetaData'
   functionExecutionResults: Array<TransitionFunctionExecutionResult>
}

export type ActOnApplicationInPortalParams = {
   applicationId: Scalars['String']
   captchaToken: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   stageTransitionCheckpoints?: InputMaybe<
      Array<InputMaybe<StageTransitionCheckpointStatusParams>>
   >
   stageTransitionId: Scalars['String']
}

export type ActOnApplicationInPortalResponse =
   | ActOnApplicationInPortalResult
   | AddAnotherGoFLimitValidationRuleFailed
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ApplicationStageFieldNotConfigured
   | AtleastOneTdrRequestRequiredForPipelineItem
   | CaptchaExpired
   | DuplicateFieldResponsesExistAmongFields
   | EmptyTdrAccountBalance
   | InvalidCaptcha
   | InvalidPrecisionForTransactionValue
   | NeedToPayPendingOrders
   | NotHaveSufficientBalanceInTdrAccount
   | NotTdrAccountHolderUser
   | PortalNotFound
   | RequestedAndProposedTdrValuationIsDifferent
   | RequiredGofResponseFieldsNotFilled
   | SaleTransactionAlreadyExistsForApplication
   | StageTransitionCheckpointsNotFilled
   | StageTransitionCheckpointsNotFound
   | StageTransitionNotFound
   | StageTransitionNotInApplicationDisplayStage
   | SurveyNumberAreaSumMismatchWithPlotArea
   | TdrAccountNotExistsForAccountNo
   | TdrAvailAreaShouldBePositive
   | TdrRequestsInitiationFailed
   | TdrRequestsOwnershipNotVerified
   | TdrRequestsReleaseFailed
   | TdrTransactionRequestValueIsGreaterThanAvailableValueError
   | TGbPassFileNumberNotFound
   | UnverifiedPhoneNumberGofResponseFieldsFound
   | ValidationRulesFailedForFields

export type ActOnApplicationInPortalResult = {
   __typename?: 'ActOnApplicationInPortalResult'
   applicationId: Scalars['String']
   metaData?: Maybe<ActOnApplicationInPortalMetaData>
   portalId: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type ActOnPipelineItemParams = {
   checkpoints: Array<CheckPointTextParams>
   customFields: Array<FieldResponseParams>
   pipelineItemId: Scalars['String']
   pipelineItemRemarkId?: InputMaybe<Scalars['String']>
   remarks?: InputMaybe<PipelineItemRemarksParams>
   stageTransitionId: Scalars['String']
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type ActOnPipelineItemResult = {
   __typename?: 'ActOnPipelineItemResult'
   changedFields: Array<FieldResponse>
   stageResponse: FieldResponse
}

export type ActOnTdrApplicationParams = {
   checkpoints: Array<CheckPointTextParams>
   customFields: Array<FieldResponseParams>
   pipelineItemId: Scalars['String']
   pipelineItemRemarkId?: InputMaybe<Scalars['String']>
   remarks?: InputMaybe<PipelineItemRemarksParams>
   stageTransitionId: Scalars['String']
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type ActOnTdrApplicationResponse =
   | AccountAccessDeniedToAssignee
   | ActOnTdrApplicationResult
   | AddAnotherFieldsAreNotSupported
   | CannotPublishRemarksAddedByOtherUser
   | ContactAssigneeIsDeactivated
   | ContactAssigneeNotFound
   | DecimalPrecisionExceeded
   | DuplicateFieldIds
   | DuplicateFieldResponsesExistAmongFields
   | DuplicateGeoPoints
   | FeeCreationMandatoryInAction
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidOrdersAmount
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NewObjectionsWereRaisedOnApplication
   | NotADraftedPipelineItemRemarks
   | NotAllowedFileFormats
   | NotRecordStageTransition
   | ParentFieldNotFilled
   | PaymentGatewayFailure
   | PendingTdrRequestsShouldBeAccepted
   | PendingTasksExistOnPipelineItem
   | PipelineAccessDeniedToAssignee
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineItemNotInFromStage
   | PipelineItemNotInPipeline
   | PipelineItemRemarksCannotBeEmpty
   | PipelineItemRemarksIdNotFound
   | RemarkNotLinkedToPipelineItem
   | RequiredFieldsNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | StageTransitionAccessDenied
   | StageTransitionCheckpointsNotFilled
   | StageTransitionCheckpointsNotFound
   | StageTransitionNotFound
   | TdrTransactionRequestValueIsGreaterThanAvailableValue
   | TdrTransactionSumExceedsAccountBalance
   | TdrTransactionUtilizationDateIsInvalid
   | UnVerifiedPhoneNumberFields
   | UnfilledStageRequiredFields
   | UniqueFieldResponseAlreadyExists
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type ActOnTdrApplicationResult = {
   __typename?: 'ActOnTDRApplicationResult'
   changedFields: Array<FieldResponse>
   stageResponse: FieldResponse
}

export type ActionNodesLimitExceededInAutomationWorkflowExecType = GraphQlBaseError & {
   __typename?: 'ActionNodesLimitExceededInAutomationWorkflowExecType'
   automationWorkflowId: Scalars['String']
   execType: AutomationWorkflowExecType
   maxLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type ActionNotPermitted = GraphQlBaseError & {
   __typename?: 'ActionNotPermitted'
   actionType: Scalars['String']
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export enum ActionType {
   ApplicationSla = 'APPLICATION_SLA',
   AutoFillResponse = 'AUTO_FILL_RESPONSE',
   CanAssignFriend = 'CAN_ASSIGN_FRIEND',
   CopyResponse = 'COPY_RESPONSE',
   ErrorMessage = 'ERROR_MESSAGE',
   Hide = 'HIDE',
   MakeRequired = 'MAKE_REQUIRED',
   MandatoryFeeHeader = 'MANDATORY_FEE_HEADER',
   OfficerSla = 'OFFICER_SLA',
   Reconciliation = 'RECONCILIATION',
   SendBackFriend = 'SEND_BACK_FRIEND',
   Show = 'SHOW',
   ShowEmptyFeeHeadersAlertMessage = 'SHOW_EMPTY_FEE_HEADERS_ALERT_MESSAGE',
   ShowPipelineItemBannerMessage = 'SHOW_PIPELINE_ITEM_BANNER_MESSAGE',
   TdrBank = 'TDR_BANK',
   TdrBankAccountNumberPattern = 'TDR_BANK_ACCOUNT_NUMBER_PATTERN',
   Validate = 'VALIDATE',
   ValidateRegex = 'VALIDATE_REGEX',
   Write = 'WRITE'
}

export type ActivatePluginServiceAccountParams = {
   pluginServiceAccountId: Scalars['String']
}

export type ActivatePluginServiceAccountResponse =
   | ActivatePluginServiceAccountResult
   | InvalidPluginState
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator

export type ActivatePluginServiceAccountResult = BasePluginServiceAccount & {
   __typename?: 'ActivatePluginServiceAccountResult'
   isActive: Scalars['Boolean']
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
}

export type ActivateUserParams = {
   userId: Scalars['String']
}

export type ActivateUserResponse =
   | ActivateUserResult
   | UserAndAdminAreNotInSameAccount
   | UserIsNotAnAdministrator
   | UserNotFound

export type ActivateUserResult = {
   __typename?: 'ActivateUserResult'
   userId: Scalars['String']
}

export type ActiveAppealDoesNotExistsForPipelineItem = GraphQlBaseError & {
   __typename?: 'ActiveAppealDoesNotExistsForPipelineItem'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type ActiveLeadDistributionExistsWithLeadAssigneeField = GraphQlBaseError & {
   __typename?: 'ActiveLeadDistributionExistsWithLeadAssigneeField'
   leadAssigneeFieldId: Scalars['String']
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ActiveLineDepartmentRequestExists = GraphQlBaseError & {
   __typename?: 'ActiveLineDepartmentRequestExists'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   verificationId: Scalars['String']
}

export type ActivitiesTab = BaseTab & {
   __typename?: 'ActivitiesTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type Activity = {
   __typename?: 'Activity'
   activityId: Scalars['String']
   activityTemplateId: Scalars['String']
   fields: Array<SystemFieldEnumResponseResult>
   title: Scalars['String']
   whatsappConsentGivenPhoneNumberFieldIds: Array<Scalars['String']>
}

export type ActivityFieldsArgs = {
   systemFieldEnums: Array<ActivitySystemFieldEnum>
}

export type ActivityAccessDenied = GraphQlBaseError & {
   __typename?: 'ActivityAccessDenied'
   activityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ActivityFieldResult =
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldNotFound
   | FieldResponse
   | NotActivityField
   | NotPermittedField

export type ActivityIsNotCreatedForField = GraphQlBaseError & {
   __typename?: 'ActivityIsNotCreatedForField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ActivityNotFound = GraphQlBaseError & {
   __typename?: 'ActivityNotFound'
   activityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ActivityPipelineItemCreationConfig = {
   __typename?: 'ActivityPipelineItemCreationConfig'
   activityTemplateId: Scalars['String']
   phoneNumberIdentificationField?: Maybe<PhoneNumberFieldResult>
   /** @deprecated Support SRMP */
   stage?: Maybe<Stage>
}

export type ActivityReferenceIdsAreMissing = GraphQlBaseError & {
   __typename?: 'ActivityReferenceIdsAreMissing'
   message?: Maybe<Scalars['String']>
}

export type ActivityResult = Activity | ActivityNotFound

export enum ActivitySystemFieldEnum {
   ActivityDateTime = 'ACTIVITY_DATE_TIME'
}

export type ActivityTemplate = {
   __typename?: 'ActivityTemplate'
   activityTemplateId: Scalars['String']
   canInitiateLead: Scalars['Boolean']
   canTriggerAutomationWorkflows: Scalars['Boolean']
   createdAt: Scalars['String']
   description?: Maybe<Scalars['String']>
   gofs: Array<GoF>
   name: Scalars['String']
   orderedGofIds: Array<Scalars['String']>
   pipelineConfigs: Array<ActivityTemplatePipelineConfig>
   /** @deprecated Support SRMP */
   pipelineId?: Maybe<Scalars['String']>
   pipelineItemCreationConfig: ActivityPipelineItemCreationConfig
   pipelineItemTemplateId: Scalars['String']
   referenceId?: Maybe<Scalars['String']>
}

export type ActivityTemplateAccessDenied = GraphQlBaseError & {
   __typename?: 'ActivityTemplateAccessDenied'
   activityTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ActivityTemplateAndStageAreNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'ActivityTemplateAndStageAreNotInSamePipeline'
   activityTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type ActivityTemplateFilterFields = {
   __typename?: 'ActivityTemplateFilterFields'
   activityTemplateId: Scalars['String']
   fieldIds: Array<Scalars['String']>
}

export type ActivityTemplateIdentificationsForTriggerAutomationWorkflows = {
   __typename?: 'ActivityTemplateIdentificationsForTriggerAutomationWorkflows'
   activityTemplateId: Scalars['String']
   identifications: Array<IdentificationOverviewDetails>
}

export type ActivityTemplateNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'ActivityTemplateNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type ActivityTemplateNotFound = GraphQlBaseError & {
   __typename?: 'ActivityTemplateNotFound'
   activityTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ActivityTemplateNotInAccount = GraphQlBaseError & {
   __typename?: 'ActivityTemplateNotInAccount'
   activityTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ActivityTemplatePipelineConfig = {
   __typename?: 'ActivityTemplatePipelineConfig'
   pipeline: BasePipeline
   pipelineItemCreationStage?: Maybe<Stage>
}

export type ActivityTemplatePipelineStage = {
   __typename?: 'ActivityTemplatePipelineStage'
   pipelineId: Scalars['String']
   pipelineItemCreationStageId?: Maybe<Scalars['String']>
}

export type ActivityTemplatePipelineStageParams = {
   pipelineId: Scalars['String']
   pipelineItemCreationStageId?: InputMaybe<Scalars['String']>
}

export type ActivityTemplateReferenceIdAlreadyExists = GraphQlBaseError & {
   __typename?: 'ActivityTemplateReferenceIdAlreadyExists'
   message?: Maybe<Scalars['String']>
}

export type ActivityTemplateReferenceIdMaxLengthExceeded = GraphQlBaseError & {
   __typename?: 'ActivityTemplateReferenceIdMaxLengthExceeded'
   message?: Maybe<Scalars['String']>
}

export type ActivityTemplateResult =
   | ActivityTemplate
   | ActivityTemplateAccessDenied
   | ActivityTemplateNotFound
   | ActivityTemplateNotInAccount

export type ActivityTemplatesAccessDenied = GraphQlBaseError & {
   __typename?: 'ActivityTemplatesAccessDenied'
   activityTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ActivityTemplatesNotFound = GraphQlBaseError & {
   __typename?: 'ActivityTemplatesNotFound'
   activityTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ActivityTemplatesNotInAccount = GraphQlBaseError & {
   __typename?: 'ActivityTemplatesNotInAccount'
   activityTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ActivityTemplatesParams = {
   activityTemplateIds: Array<Scalars['String']>
}

export type ActonPipelineItemResponse =
   | AccountAccessDeniedToAssignee
   | ActOnPipelineItemResult
   | AddAnotherFieldsAreNotSupported
   | CannotPublishRemarksAddedByOtherUser
   | ContactAssigneeIsDeactivated
   | ContactAssigneeNotFound
   | DecimalPrecisionExceeded
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | ErrorFieldsFound
   | FeeCreationMandatoryInAction
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidOrdersAmount
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NewObjectionsWereRaisedOnApplication
   | NotADraftedPipelineItemRemarks
   | NotAllowedFileFormats
   | NotRecordStageTransition
   | ParentFieldNotFilled
   | PaymentGatewayFailure
   | PendingTdrRequestsShouldBeAccepted
   | PendingTasksExistOnPipelineItem
   | PipelineAccessDeniedToAssignee
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineItemNotInFromStage
   | PipelineItemNotInPipeline
   | PipelineItemRemarksCannotBeEmpty
   | PipelineItemRemarksIdNotFound
   | RemarkNotLinkedToPipelineItem
   | RequiredFieldsNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | StageTransitionAccessDenied
   | StageTransitionCheckpointsNotFilled
   | StageTransitionCheckpointsNotFound
   | StageTransitionNotFound
   | TdrTransactionRequestValueIsGreaterThanAvailableValue
   | TermsSetNotFoundForEntity
   | UnVerifiedPhoneNumberFields
   | UnfilledStageRequiredFields
   | UniqueFieldResponseAlreadyExists
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type AddActionTypesToIdentificationParams = {
   actionTypes: Array<UserPermission>
   identificationId: Scalars['String']
}

export type AddActionTypesToIdentificationResponse =
   | AddActionTypesToIdentificationResult
   | IdentificationAndUserAreNotInSameAccount
   | IdentificationNotFound
   | UserIsNotAnAdministrator

export type AddActionTypesToIdentificationResult = {
   __typename?: 'AddActionTypesToIdentificationResult'
   actionTypes: Array<UserPermission>
   identificationId: Scalars['String']
}

export type AddActivityTemplatesToPipelineParams = {
   activityTemplateIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type AddActivityTemplatesToPipelineResponse =
   | ActivityTemplatesAccessDenied
   | ActivityTemplatesNotFound
   | ActivityTemplatesNotInAccount
   | AddActivityTemplatesToPipelineResult
   | NotAllowedToLinkActivityTemplatesAndPipeline
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type AddActivityTemplatesToPipelineResult = {
   __typename?: 'AddActivityTemplatesToPipelineResult'
   activityTemplateIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type AddAnotherFieldIsNotSupported = GraphQlBaseError & {
   __typename?: 'AddAnotherFieldIsNotSupported'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AddAnotherFieldReferenceIdsAreNotSupported = GraphQlBaseError & {
   __typename?: 'AddAnotherFieldReferenceIdsAreNotSupported'
   fieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export enum AddAnotherFieldSelectionStrategy {
   All = 'ALL',
   First = 'FIRST',
   Last = 'LAST'
}

export type AddAnotherFieldsAreNotSupported = GraphQlBaseError & {
   __typename?: 'AddAnotherFieldsAreNotSupported'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AddAnotherGoFLimitValidationRuleFailed = GraphQlBaseError & {
   __typename?: 'AddAnotherGoFLimitValidationRuleFailed'
   message?: Maybe<Scalars['String']>
   ruleId: Scalars['String']
}

export type AddAnotherGoFNode = BaseNode & {
   __typename?: 'AddAnotherGoFNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   gofId?: Maybe<Scalars['String']>
   gofResponses: Array<NodeGoFResponseFieldsMapping>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
}

export type AddAnotherGoFNodeExecLog = BaseNodeExecLog & {
   __typename?: 'AddAnotherGoFNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<AddAnotherGoFNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type AddAnotherGoFNodeExecLogResult = {
   __typename?: 'AddAnotherGoFNodeExecLogResult'
   gofId: Scalars['String']
   gofResponses: Array<AddGoFResponseRemarks>
}

export type AddAnotherGoFPermissions = {
   __typename?: 'AddAnotherGoFPermissions'
   createAddAnotherGofPermissionIds: Array<Scalars['String']>
   createAddAnotherGofPermissions: Array<IdentificationOverviewDetails>
   gofId: Scalars['String']
   removeAddAnotherGofPermissionIds: Array<Scalars['String']>
   removeAddAnotherGofPermissions: Array<IdentificationOverviewDetails>
}

export enum AddAnotherGoFResponseStatus {
   Done = 'DONE',
   Failed = 'FAILED'
}

export type AddAnotherGoFResponsesLimitReached = GraphQlBaseError & {
   __typename?: 'AddAnotherGoFResponsesLimitReached'
   limit?: Maybe<Scalars['Int']>
   message?: Maybe<Scalars['String']>
}

export type AddAnotherGoFResult = {
   __typename?: 'AddAnotherGoFResult'
   gofId: Scalars['String']
   gofResponses: Array<GoFResponse>
}

export type AddApplicationTabGoFParams = {
   fieldIds: Array<Scalars['String']>
   gofId: Scalars['String']
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type AddApplicationTabGoFResponse =
   | DependentFieldsSelectedWithoutParent
   | FieldsAreDeleted
   | FieldsNotFound
   | FieldsNotInGoF
   | GoFIsDeleted
   | GoFNotFound
   | GofAlreadyExistsInPortalApplicationTab
   | NotApplicationPipelineTemplateGoF
   | PortalApplicationNotFound
   | PortalApplicationTabGoF
   | PortalApplicationTabNotFound
   | UnsupportedSystemGoF
   | UserIsNotAnAdministrator

export type AddApplicationTabParams = {
   category?: InputMaybe<Scalars['String']>
   iconInfo?: InputMaybe<IconParams>
   name: Scalars['String']
   portalApplicationId: Scalars['String']
   tabEnum?: InputMaybe<ApplicationTabEnum>
}

export type AddApplicationTabResponse =
   | ApplicationTabIconInfoIsRequired
   | PortalApplicationNotFound
   | PortalApplicationTab
   | TabNameAlreadyExists
   | UserIsNotAnAdministrator

export type AddAttachmentsForRemarksInTaskDraftParams = {
   attachments: Array<RemarksAttachmentParams>
   taskId: Scalars['String']
}

export type AddAttachmentsForRemarksInTaskDraftResponse =
   | AddAttachmentsForRemarksInTaskDraftResult
   | AttachmentMustBeValidS3Url
   | CanNotUpdateCompletedTask
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | TaskTemplateAccessDenied

export type AddAttachmentsForRemarksInTaskDraftResult = {
   __typename?: 'AddAttachmentsForRemarksInTaskDraftResult'
   attachments: Array<RemarksAttachment>
   taskId: Scalars['String']
}

export type AddAttachmentsForRemarksParams = {
   attachments: Array<RemarksAttachmentParams>
   pipelineItemRemarksId: Scalars['String']
}

export type AddAttachmentsForRemarksResponse =
   | AddAttachmentsForRemarksResult
   | AttachmentMustBeValidS3Url
   | CannotAddAttachmentsToRemarksAddedByOtherUser
   | PipelineItemRemarksIdNotFound

export type AddAttachmentsForRemarksResult = {
   __typename?: 'AddAttachmentsForRemarksResult'
   attachments: Array<RemarksAttachment>
   pipelineItemRemarksId: Scalars['String']
}

export type AddCallLogsToTaskDraftParams = {
   callLogIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type AddCallLogsToTaskDraftResponse =
   | AddCallLogsToTaskDraftResult
   | CallLogIdsAndTaskAreLinkedToDifferentPipelineItem
   | CallLogsAlreadyLinkedToAnotherCompletedTask
   | CanNotUpdateCompletedTask
   | CloudCallingCallLogsNotFound
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound

export type AddCallLogsToTaskDraftResult = {
   __typename?: 'AddCallLogsToTaskDraftResult'
   callLogIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type AddFeeHeadLog = {
   __typename?: 'AddFeeHeadLog'
   actionDoneBy?: Maybe<BaseUser>
   addedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeCreatedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeRemovedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeUpdatedAppliedFeeHeads: Array<UpdateAppliedFeeHeadLog>
   eventDatetime: Scalars['String']
   logId: Scalars['String']
}

export type AddFeeHeadersInEntityFeeRuleSetParams = {
   entityRuleSetId: Scalars['String']
   feeHeaderIds: Array<Scalars['String']>
}

export type AddFeeHeadersInEntityFeeRuleSetResponse =
   | AddFeeHeadersInEntityFeeRuleSetResult
   | EntityFeeRuleSetAccessDenied
   | EntityFeeRuleSetNotFound
   | FeeHeadersAreAlreadyDeletedInEntityFeeRuleSet
   | FeeHeadersNotFound

export type AddFeeHeadersInEntityFeeRuleSetResult = {
   __typename?: 'AddFeeHeadersInEntityFeeRuleSetResult'
   appliedFeeHeaders: Array<AppliedFeeHeader>
   changedFeeAppliedHeaders: Array<AppliedFeeHeader>
   entityRuleSetId: Scalars['String']
   groups: Array<EntityFeeRuleSetGroup>
   totalAdjustedAmount: Scalars['Float']
   totalCalculatedAmount: Scalars['Float']
   totalNetAmount: Scalars['Float']
}

export type AddFieldConditionalOptionsParams = {
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldId: Scalars['String']
   parentFieldOption: Scalars['String']
}

export type AddFieldConditionalOptionsResponse =
   | AddFieldConditionalOptionsResult
   | CannotEditSystemField
   | CircularParentIsNotAllowed
   | FieldsAreDeleted
   | FieldsAreNotInSameGoF
   | FieldsMustBeOfSameGoFWhenFieldInAddAnotherGoF
   | FieldsNotFound
   | NotConditionalOptionsValueType
   | NotSupportedFieldTypes
   | ParentFieldMustBeDropdownField
   | ParentOptionsShouldBeInExistingOptions
   | UserIsNotAnAdministrator

export type AddFieldConditionalOptionsResult = {
   __typename?: 'AddFieldConditionalOptionsResult'
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldId: Scalars['String']
   parentFieldOption: Scalars['String']
}

export type AddFieldRolesParams = {
   fieldId: Scalars['String']
   readRoles: Array<Scalars['String']>
   writeRoles: Array<Scalars['String']>
}

export type AddFieldRolesResponse =
   | AddFieldRolesResult
   | CannotAddWriteRolesToUserPropertiesSystemFields
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | ReadRolesNotFound
   | UserIsNotAnAdministrator
   | WriteRolesNotFound

export type AddFieldRolesResult = {
   __typename?: 'AddFieldRolesResult'
   fieldId: Scalars['String']
   readRoles: Array<Scalars['String']>
   writeRoles: Array<Scalars['String']>
}

export type AddGallaboxAccountParams = {
   apiKey: Scalars['String']
   apiSecret: Scalars['String']
   enableReadReceipts: Scalars['Boolean']
   gallaboxAccountId: Scalars['String']
   name: Scalars['String']
}

export type AddGallaboxAccountResponse =
   | AccountPluginIsDisabled
   | GallaboxAccount
   | GallaboxAccountNameAlreadyExists
   | ParameterIdsNotFound
   | UserIsNotAnAdministrator

export type AddGoFResponseRemarks = {
   __typename?: 'AddGoFResponseRemarks'
   failureReason?: Maybe<Scalars['String']>
   gofResponseUniqueId: Scalars['String']
   status: AddAnotherGoFResponseStatus
}

export type AddGraphQuickFilterFieldIdResponse =
   | DataSourceIsRequiredForAdvancedAnalyticsLevelGraph
   | FieldIdNotInGraphPipeline
   | FieldIsDeleted
   | FieldNotFound
   | GraphFieldDataSourceAlreadyExists
   | GraphNotFound
   | GraphQuickFilterField
   | UnSupportedDataSourceField
   | UserIsNotAnAdministrator

export type AddGraphQuickFilterFieldParams = {
   dataSource?: InputMaybe<AnalyticsDataSourceType>
   fieldId: Scalars['String']
   graphId: Scalars['String']
}

export type AddGraphQuickFilterFieldResponse =
   | FieldIdsNotInGraphPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | GraphFieldsAlreadyExists
   | GraphNotFound
   | GraphQuickFilterFields
   | NotSupportedFieldsForGraphSalesEntityType
   | UnSupportedDataSourceFields
   | UserIsNotAnAdministrator

export type AddGraphQuickFilterFieldsParams = {
   fieldIds: Array<Scalars['String']>
   graphId: Scalars['String']
}

export type AddGupShupAccountParams = {
   enableReadReceipts: Scalars['Boolean']
   encryptionKey?: InputMaybe<Scalars['String']>
   isEncryptionEnabled: Scalars['Boolean']
   name: Scalars['String']
   password: Scalars['String']
   userId: Scalars['String']
}

export type AddGupShupAccountResponse =
   | AccountPluginIsDisabled
   | EncryptionKeyIsRequiredIfEncryptionEnabled
   | GupShupAccount
   | GupShupAccountNameAlreadyExists
   | ParameterIdsNotFound
   | UserIsNotAnAdministrator

export type AddIdentificationsToDashboardParams = {
   dashboardId: Scalars['String']
   identificationIds: Array<Scalars['String']>
}

export type AddIdentificationsToDashboardResponse =
   | AddIdentificationsToDashboardResult
   | DashboardAccessDenied
   | DashboardNotFound
   | IdentificationsNotFound
   | UserAndIdentificationsAreNotInSameAccount

export type AddIdentificationsToDashboardResult = {
   __typename?: 'AddIdentificationsToDashboardResult'
   dashboardId: Scalars['String']
   identificationIds: Array<Scalars['String']>
}

export type AddKnowlarityAccountParams = {
   applicationAccessKey: Scalars['String']
   channelType: KnowlarityChannelType
   kNumber: PhoneNumberParams
   name: Scalars['String']
   srApiKey: Scalars['String']
}

export type AddKnowlarityAccountResponse =
   | AccountPluginIsDisabled
   | ApplicationAccessKeyAlreadyExists
   | KNumberAlreadyExists
   | KnowlarityAccount
   | ParameterIdsNotFound
   | SrApiKeyAlreadyExists
   | UserIsNotAnAdministrator

export type AddLayoutToFormParams = {
   backgroundColourHexCode?: InputMaybe<Scalars['String']>
   bannerImageUrl?: InputMaybe<Scalars['String']>
   formId: Scalars['String']
   headerBackgroundColourHexCode?: InputMaybe<Scalars['String']>
   layoutCode?: InputMaybe<Scalars['String']>
   layoutType: FormLayoutType
   logoImageUrl: Scalars['String']
}

export type AddLayoutToFormResponse =
   | EmptyFormLayoutLogoImageUrl
   | FormLayout
   | FormLayoutAlreadyExists
   | FormNotFound
   | InvalidBannerImageUrl
   | InvalidLogoImageUrl
   | UserIsNotAnAdministrator

export type AddOptionsToCheckboxGroupFieldParams = {
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type AddOptionsToCheckboxGroupFieldResponse =
   | AddOptionsToCheckboxGroupFieldResult
   | CannotEditSystemField
   | DoubleHashIsNotSupportedInOptions
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotCheckboxGroupField
   | UserIsNotAnAdministrator

export type AddOptionsToCheckboxGroupFieldResult = {
   __typename?: 'AddOptionsToCheckboxGroupFieldResult'
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type AddOptionsToDropdownFieldParams = {
   fieldId: Scalars['String']
   optionColors?: InputMaybe<Array<OptionColorParams>>
   options: Array<Scalars['String']>
}

export type AddOptionsToDropdownFieldResponse =
   | AddOptionsToDropdownFieldResult
   | CannotEditSystemField
   | DoubleHashIsNotSupportedInOptions
   | DuplicateOptionsInLabelColorConfig
   | FieldIsDeleted
   | FieldLabelsConfigNotEnabled
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotDropdownField
   | OptionsWithColorsNotGivenInFieldConfig
   | UserIsNotAnAdministrator

export type AddOptionsToDropdownFieldResult = {
   __typename?: 'AddOptionsToDropdownFieldResult'
   fieldId: Scalars['String']
   optionColors: Array<OptionColorConfig>
   options: Array<Scalars['String']>
}

export type AddOptionsToFieldsSelectorFieldParams = {
   dependentFields: Array<DependentFieldsParams>
   fieldId: Scalars['String']
}

export type AddOptionsToFieldsSelectorFieldResponse =
   | AddOptionsToFieldsSelectorFieldResult
   | AlreadyUsedDependentFieldIds
   | CannotEditSystemField
   | CircularParentFieldsAreNotAllowed
   | DependentFieldsMustBeOfSameGoF
   | DoubleHashIsNotSupportedInOptions
   | DuplicateFieldsSelectorDependentOptions
   | FieldIsDeleted
   | FieldNotFound
   | InvalidFieldsSelectorDependentOptions
   | LinkedFieldUpdateRestricted
   | NonDependentFields
   | NotFieldsSelectorField
   | OptionsAlreadyExists
   | RecursiveParentFieldOptions
   | UserIsNotAnAdministrator

export type AddOptionsToFieldsSelectorFieldResult = {
   __typename?: 'AddOptionsToFieldsSelectorFieldResult'
   dependentFields: Array<DependentFields>
   fieldId: Scalars['String']
}

export type AddOptionsToMultiSelectFieldParams = {
   fieldId: Scalars['String']
   optionColors?: InputMaybe<Array<OptionColorParams>>
   options: Array<Scalars['String']>
}

export type AddOptionsToMultiSelectFieldResponse =
   | AddOptionsToMultiSelectFieldResult
   | CannotEditSystemField
   | DoubleHashIsNotSupportedInOptions
   | DuplicateOptionsInLabelColorConfig
   | FieldIsDeleted
   | FieldLabelsConfigNotEnabled
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotMultiSelectField
   | OptionsWithColorsNotGivenInFieldConfig
   | UserIsNotAnAdministrator

export type AddOptionsToMultiSelectFieldResult = {
   __typename?: 'AddOptionsToMultiSelectFieldResult'
   fieldId: Scalars['String']
   optionColors: Array<OptionColorConfig>
   options: Array<Scalars['String']>
}

export type AddOptionsToRadioGroupFieldParams = {
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type AddOptionsToRadioGroupFieldResponse =
   | AddOptionsToRadioGroupFieldResult
   | CannotEditSystemField
   | DoubleHashIsNotSupportedInOptions
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotRadioGroupField
   | UserIsNotAnAdministrator

export type AddOptionsToRadioGroupFieldResult = {
   __typename?: 'AddOptionsToRadioGroupFieldResult'
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type AddPipelineIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type AddPipelineIdentificationsResponse =
   | AddPipelineIdentificationsResult
   | IdentificationsNotFound
   | PipelineAndAdminAreNotInSameAccount
   | PipelineAndIdentificationsAreNotInSameAccount
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type AddPipelineIdentificationsResult = {
   __typename?: 'AddPipelineIdentificationsResult'
   identificationIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type AddPipelineItemRemarksParams = {
   attachments?: InputMaybe<Array<RemarksAttachmentParams>>
   fieldId?: InputMaybe<Scalars['String']>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   remarks?: InputMaybe<Scalars['String']>
}

export type AddPipelineItemRemarksResponse =
   | EitherRemarksOrVoiceNoteIsRequired
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineItemRemarks

export type AddPipelineItemTemplatesAdminPermissionForUserParams = {
   pipelineItemTemplateIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type AddPipelineItemTemplatesAdminPermissionForUserResponse =
   | AddPipelineItemTemplatesAdminPermissionForUserResult
   | DeactivatedUserId
   | PipelineItemTemplatesNotFound
   | UserIsNotAnAdministrator
   | UserNotFound

export type AddPipelineItemTemplatesAdminPermissionForUserResult = {
   __typename?: 'AddPipelineItemTemplatesAdminPermissionForUserResult'
   pipelineItemTemplateIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type AddPipelinesAdminPermissionForUserParams = {
   pipelineIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type AddPipelinesAdminPermissionForUserResponse =
   | AddPipelinesAdminPermissionForUserResult
   | DeactivatedUserId
   | PipelinesNotFound
   | UserIsNotAnAdministrator
   | UserNotFound

export type AddPipelinesAdminPermissionForUserResult = {
   __typename?: 'AddPipelinesAdminPermissionForUserResult'
   pipelineIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type AddRelatedEntitiesParams = {
   currentEntityId: Scalars['String']
   relatedEntityIds: Array<Scalars['String']>
   relationId: Scalars['String']
}

export type AddRelatedEntitiesResponse =
   | AddRelatedEntitiesResult
   | AlreadyOneEntityExistInOneToManyRelation
   | AlreadyOneEntityExistInOneToOneRelation
   | CurrentEntityAlreadyLinkedToAnotherEntityInOneToMany
   | CurrentEntityIsDeleted
   | CurrentEntityNotFound
   | MultipleEntitiesNotSupportedInOneToManyRelation
   | MultipleEntitiesNotSupportedInOneToOneRelation
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | RelatedEntitiesAreDeleted
   | RelatedEntitiesMaxCountExceeded
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntitiesNotFound
   | RelatedEntityAlreadyExistInOneToOneRelation
   | RelationIsDeleted
   | RelationNotFound
   | YouCanLinkRelatedEntitiesToOnlyOneEntityInOneToMany

export type AddRelatedEntitiesResult = {
   __typename?: 'AddRelatedEntitiesResult'
   currentEntityId: Scalars['String']
   relatedEntityIds: Array<Scalars['String']>
   relationId: Scalars['String']
}

export type AddRelatedPipelineItemRemarksParams = {
   attachments: Array<RemarksAttachmentParams>
   currentEntityId: Scalars['String']
   relatedEntityId: Scalars['String']
   relatedEntityPipelineId?: InputMaybe<Scalars['String']>
   relationId: Scalars['String']
   remarks?: InputMaybe<Scalars['String']>
}

export type AddRelatedPipelineItemRemarksResponse =
   | CurrentEntityNotBelongsToRelation
   | EitherRemarksOrVoiceNoteIsRequired
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | PipelineItemRemarks
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | RelatedEntitiesNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound

export type AddSmartfloAccountParams = {
   name: Scalars['String']
   permanentAccessToken: Scalars['String']
}

export type AddSmartfloAccountResponse =
   | AccountPluginIsDisabled
   | ParameterIdNotFound
   | SmartfloAccount
   | SmartfloAccountNameAlreadyExists
   | UserIsNotAnAdministrator

export type AddSortByFieldsParams = {
   sortByFields: Array<Sort>
   viewId: Scalars['String']
}

export type AddSortByFieldsResponse =
   | AddSortByFieldsResult
   | FieldsAreDeleted
   | FieldsNotFound
   | NotAllowedSortFields
   | NotPermittedFields
   | NotSalesTemplateFieldIds
   | ViewAccessDenied
   | ViewNotFound

export type AddSortByFieldsResult = {
   __typename?: 'AddSortByFieldsResult'
   sortByFields: Array<SortResponse>
   viewId: Scalars['String']
}

export type AddStageUpdatePermissionParams = {
   fromStageId: Scalars['String']
   roleIds: Array<Scalars['String']>
   toStageIds: Array<Scalars['String']>
}

export type AddStageUpdatePermissionResponse =
   | AddStageUpdatePermissionResult
   | FromStageAndToStagesAreNotInSamePipeline
   | FromStageNotFound
   | PipelineAccessDenied
   | RolesAndStagesAreNotInSamePipeline
   | RolesNotFound
   | ToStagesNotFound
   | UserIsNotAnAdministrator

export type AddStageUpdatePermissionResult = {
   __typename?: 'AddStageUpdatePermissionResult'
   fromStageId: Scalars['String']
   roleIds: Array<Scalars['String']>
   toStageIds: Array<Scalars['String']>
}

export type AddSubmissionConfigToFormParams = {
   formId: Scalars['String']
   messageTemplate?: InputMaybe<Scalars['String']>
   queryParamsFieldIds: Array<Scalars['String']>
   redirectionUrl?: InputMaybe<Scalars['String']>
   responseType: FormSubmissionResponseType
}

export type AddSubmissionConfigToFormResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | FilledNotRequiredConfig
   | FormNotFound
   | FormSubmissionConfig
   | FormSubmissionConfigAlreadyExists
   | InvalidRedirectionUrl
   | NotExistsReferenceIdForFields
   | NotFilledRequiredConfig
   | NotFormTemplateFields
   | UserIsNotAnAdministrator

export type AddUserGroupsForBoardListParams = {
   listId: Scalars['String']
   userGroupIds: Array<Scalars['String']>
}

export type AddUserGroupsForBoardListResponse =
   | AddUserGroupsForBoardListResult
   | BoardListEditAccessDenied
   | BoardListNotFound
   | UserGroupsNotFound
   | UserIsNotAnAdministrator

export type AddUserGroupsForBoardListResult = {
   __typename?: 'AddUserGroupsForBoardListResult'
   listId: Scalars['String']
   userGroups: Array<UserGroupConfig>
}

export type AddUserGroupsForBoardParams = {
   boardId: Scalars['String']
   userGroupIds: Array<Scalars['String']>
}

export type AddUserGroupsForBoardResponse =
   | AddUserGroupsForBoardResult
   | BoardEditAccessDenied
   | BoardNotFound
   | UserGroupsNotFound

export type AddUserGroupsForBoardResult = {
   __typename?: 'AddUserGroupsForBoardResult'
   boardId: Scalars['String']
   userGroups: Array<UserGroupConfig>
}

export type AddUserIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type AddUserIdentificationsResponse =
   | AddUserIdentificationsResult
   | DeactivatedUser
   | IdentificationsNotFound
   | UserAndIdentificationsAreNotInSameAccount
   | UserIsNotAnAdministrator
   | UserNotFound

export type AddUserIdentificationsResult = {
   __typename?: 'AddUserIdentificationsResult'
   identificationIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type AddUsersToIdentificationParams = {
   identificationId: Scalars['String']
   userIds: Array<Scalars['String']>
}

export type AddUsersToIdentificationResponse =
   | AddUsersToIdentificationResult
   | IdentificationAndUserAreNotInSameAccount
   | IdentificationNotFound
   | UserIsNotAnAdministrator
   | UsersNotFound
   | UsersNotInAccount

export type AddUsersToIdentificationResult = {
   __typename?: 'AddUsersToIdentificationResult'
   identificationId: Scalars['String']
   users: Array<User>
}

export type AddWatiAccountParams = {
   accessToken: Scalars['String']
   baseUrl: Scalars['String']
   enableReadReceipts: Scalars['Boolean']
   name: Scalars['String']
}

export type AddWatiAccountResponse =
   | AccountPluginIsDisabled
   | ParameterIdsNotFound
   | UserIsNotAnAdministrator
   | WatiAccount
   | WatiAccountNameAlreadyExists

export type AddWhatsAppBusinessNumberParams = {
   gallaboxChannelId?: InputMaybe<Scalars['String']>
   phoneNumber: PhoneNumberParams
   pluginServiceAccountId: Scalars['String']
}

export type AddWhatsAppBusinessNumberResponse =
   | AccountPluginIsDisabled
   | AddWhatsAppBusinessNumberResult
   | GallaboxChannelIdIsRequired
   | InvalidWhatsAppBusinessPhoneNumber
   | NotAWhatsAppPluginServiceAccount
   | PluginServiceAccountIsNotActive
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator
   | WhatsAppBusinessPhoneNumberAlreadyExists

export type AddWhatsAppBusinessNumberResult = {
   __typename?: 'AddWhatsAppBusinessNumberResult'
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type AddWhatsAppBusinessPhoneNumberParams = {
   gallaboxChannelId?: InputMaybe<Scalars['String']>
   phoneNumber: PhoneNumberParams
   pipelineId: Scalars['String']
   pluginServiceAccountId: Scalars['String']
   userIds: Array<Scalars['String']>
}

export type AddWhatsAppBusinessPhoneNumberResponse =
   | AccountPluginIsDisabled
   | AddWhatsAppBusinessPhoneNumberResult
   | DeactivatedUsers
   | GallaboxChannelIdIsRequired
   | InvalidWhatsAppBusinessPhoneNumber
   | NotAWhatsAppPluginServiceAccount
   | PipelineAccessDeniedToUsers
   | PipelineNotFound
   | PipelineWhatsAppBusinessPhoneNumberAlreadyExists
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator
   | UsersAreAlreadyToLinkedPipeline
   | UsersNotFound
   | WatiPluginServiceAccountNotFound

export type AddWhatsAppBusinessPhoneNumberResult = {
   __typename?: 'AddWhatsAppBusinessPhoneNumberResult'
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
}

export type AddWhatsAppBusinessPhoneNumberUsersParams = {
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
   userIds: Array<Scalars['String']>
}

export type AddWhatsAppBusinessPhoneNumberUsersResponse =
   | AccountPluginIsDisabled
   | AddWhatsAppBusinessPhoneNumberUsersResult
   | DeactivatedUsers
   | PipelineAccessDeniedToUsers
   | PipelineWhatsAppBusinessPhoneNumberNotFound
   | PluginServiceAccountIsNotActive
   | UserIsNotAnAdministrator
   | UsersAreAlreadyToLinkedPipeline
   | UsersNotFound

export type AddWhatsAppBusinessPhoneNumberUsersResult = {
   __typename?: 'AddWhatsAppBusinessPhoneNumberUsersResult'
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
   users: Array<BaseUser>
}

export type AdhocAgentAllocationGroupExecLog = {
   __typename?: 'AdhocAgentAllocationGroupExecLog'
   assignedLeadsCount: Scalars['Int']
   status?: Maybe<AllocationGroupExecLogStatus>
   users: Array<BaseUser>
}

export type AdhocAgentAllocationGroupSummary = {
   __typename?: 'AdhocAgentAllocationGroupSummary'
   quota?: Maybe<Scalars['Int']>
   users: Array<BaseUser>
}

export type AdminCrmAccountFeature = {
   __typename?: 'AdminCrmAccountFeature'
   feature: CrmAccountFeatureEnum
   identifications: Array<IdentificationOverviewDetails>
   isDisabled: Scalars['Boolean']
}

export type AdminCrmPipelineFeature = {
   __typename?: 'AdminCrmPipelineFeature'
   feature: CrmPipelineFeatureEnum
   identifications: Array<IdentificationOverviewDetails>
   isDisabled: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type AdminDocumentTemplate = {
   __typename?: 'AdminDocumentTemplate'
   createdAt: Scalars['String']
   createdBy: BaseUser
   customTemplateConfig?: Maybe<CustomDocumentTemplateConfig>
   description?: Maybe<Scalars['String']>
   documentTemplateFile?: Maybe<FileUploaderUrlResponse>
   documentTemplateId: Scalars['String']
   documentTemplateVersionId: Scalars['String']
   enableDigitalSign: Scalars['Boolean']
   formFields: Array<DocumentTemplateFormField>
   isDeleted: Scalars['Boolean']
   lastUpdatedAt: Scalars['String']
   name: Scalars['String']
   qrCodeConfig?: Maybe<DocumentTemplateQrCodeConfig>
   shouldGenerateQrCode: Scalars['Boolean']
   signatureFieldIdentifications: Array<
      DocumentTemplateSignatureFieldIdentifications
   >
   templateType: DocumentTemplateType
   totalNoOfPages: Scalars['Int']
}

export type AdminProfile = {
   __typename?: 'AdminProfile'
   dataLoadingActionTypes: Array<InitiateDataLoadingActionType>
   isAccountAdmin: Scalars['Boolean']
   permittedPipelineItemTemplates: Array<BasePipelineItemTemplate>
   permittedPipelines: Array<BasePipeline>
}

export type AdminRecordCreationConfig = BaseRecordCreationConfig & {
   __typename?: 'AdminRecordCreationConfig'
   autoAssignCreatorToFields: Array<Field>
   creationAllowedStages: Array<Stage>
   fields: Array<Field>
   identifications: Array<IdentificationOverviewDetails>
   incompleteRules: Array<RecordCreationConfigRuleEnum>
   name: Scalars['String']
   pipelinesAllowedStages: Array<PipelineRecordCreationConfigAllowedStages>
   recordCreationConfigId: Scalars['Int']
   salesTemplateId: Scalars['String']
   salesTemplateType: RecordCreationSupportedSalesTemplateType
   status: RecordCreationConfigStatus
   syncAssigneeGroups: Array<AssigneeGroup>
}

export type AdminRecordCreationConfigsForSalesTemplate = {
   __typename?: 'AdminRecordCreationConfigsForSalesTemplate'
   recordCreationConfigs: Array<AdminRecordCreationConfig>
   salesTemplateId: Scalars['String']
}

export type AdminRecordCreationConfigsForSalesTemplatesResult =
   | AdminRecordCreationConfigsForSalesTemplate
   | SalesTemplateNotFound
   | UserIsNotAnAdministrator

export type AdminSetUserPinParams = {
   pin: Scalars['String']
   pinPurpose: PinPurpose
   targetUserId: Scalars['String']
}

export type AdminSetUserPinResponse =
   | AdminSetUserPinResult
   | OtpVerificationRequired
   | PinComplexityValidationFailed
   | PinMatchesPreviousPin
   | UserIsNotAnAdministrator
   | UserNotFound

export type AdminSetUserPinResult = {
   __typename?: 'AdminSetUserPinResult'
   expiresAt: Scalars['String']
   lastChangedAt: Scalars['String']
   success: Scalars['Boolean']
}

export type AdminWhatsAppMessageTemplate = BaseWhatsAppMessageTemplate & {
   __typename?: 'AdminWhatsAppMessageTemplate'
   body?: Maybe<Scalars['String']>
   buttons: Array<WhatsAppMessageButton>
   footer?: Maybe<Scalars['String']>
   formattedMessageText: Scalars['String']
   header?: Maybe<Scalars['String']>
   mediaInfo?: Maybe<WhatsAppMessageTemplateMediaInfo>
   mediaName?: Maybe<Scalars['String']>
   mediaType?: Maybe<WhatsAppMessageMediaType>
   messageType: WhatsAppMessageType
   name: Scalars['String']
   pipelineConfigs: Array<WhatsAppMessageTemplatePipelineConfig>
   whatsappMessageTemplateId: Scalars['String']
}

export type AfterBoardIdNotFoundInSamePipeline = GraphQlBaseError & {
   __typename?: 'AfterBoardIdNotFoundInSamePipeline'
   message?: Maybe<Scalars['String']>
}

export type AfterBoardListNotFound = GraphQlBaseError & {
   __typename?: 'AfterBoardListNotFound'
   listId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AfterBoardListNotInSameParent = GraphQlBaseError & {
   __typename?: 'AfterBoardListNotInSameParent'
   listId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AfterBoardNotFound = GraphQlBaseError & {
   __typename?: 'AfterBoardNotFound'
   boardId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AfterGraphMetricNotFound = GraphQlBaseError & {
   __typename?: 'AfterGraphMetricNotFound'
   message?: Maybe<Scalars['String']>
   metricId: Scalars['String']
}

export type AfterGraphQuickFilterFieldNotFound = GraphQlBaseError & {
   __typename?: 'AfterGraphQuickFilterFieldNotFound'
   graphQuickFilterFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AfterLayoutTabNotFound = GraphQlBaseError & {
   __typename?: 'AfterLayoutTabNotFound'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type AfterLayoutTabNotInSameLayout = GraphQlBaseError & {
   __typename?: 'AfterLayoutTabNotInSameLayout'
   afterTabId: Scalars['String']
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type AfterTabNotInSameParent = GraphQlBaseError & {
   __typename?: 'AfterTabNotInSameParent'
   afterTabId: Scalars['String']
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type AfterViewAccessDenied = GraphQlBaseError & {
   __typename?: 'AfterViewAccessDenied'
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export type AfterViewNotFound = GraphQlBaseError & {
   __typename?: 'AfterViewNotFound'
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export type AgentAllocationGroup = {
   __typename?: 'AgentAllocationGroup'
   agentAllocationGroupId: Scalars['String']
   configStatus: AgentAllocationGroupConfigStatus
   createdAt: Scalars['String']
   filterSetId: Scalars['String']
   name: Scalars['String']
   totalAgents: Scalars['Int']
   totalFilters: Scalars['Int']
}

export enum AgentAllocationGroupConfigStatus {
   Configured = 'CONFIGURED',
   PartiallyConfigured = 'PARTIALLY_CONFIGURED'
}

export type AgentAllocationGroupExecLog = {
   __typename?: 'AgentAllocationGroupExecLog'
   agentAllocationGroupId: Scalars['String']
   assignedLeadsCount: Scalars['Int']
   name: Scalars['String']
   status?: Maybe<AllocationGroupExecLogStatus>
}

export type AgentAllocationGroupNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'AgentAllocationGroupNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type AgentAllocationGroupNotFound = GraphQlBaseError & {
   __typename?: 'AgentAllocationGroupNotFound'
   agentAllocationGroupId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AgentAllocationGroupSummary = {
   __typename?: 'AgentAllocationGroupSummary'
   agentAllocationGroupId: Scalars['String']
   name: Scalars['String']
   quota?: Maybe<Scalars['Int']>
}

export type AgentAllocationGroupsAlreadyExistsInDistributionThroughEntity = GraphQlBaseError & {
   __typename?: 'AgentAllocationGroupsAlreadyExistsInDistributionThroughEntity'
   agentAllocationGroupIds: Array<Scalars['String']>
   distributionThrough: DistributionThroughType
   distributionThroughEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AgentAllocationGroupsNotFound = GraphQlBaseError & {
   __typename?: 'AgentAllocationGroupsNotFound'
   agentAllocationGroupIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AgentAllocationGroupsNotInUserAccount = GraphQlBaseError & {
   __typename?: 'AgentAllocationGroupsNotInUserAccount'
   agentAllocationGroupIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AgentGlobalQuota = {
   __typename?: 'AgentGlobalQuota'
   agentId: Scalars['String']
   dayQuota?: Maybe<Scalars['Int']>
   monthQuota?: Maybe<Scalars['Int']>
   weekQuota?: Maybe<Scalars['Int']>
}

export type AgentNotFound = GraphQlBaseError & {
   __typename?: 'AgentNotFound'
   agentId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AgentQuotaMismatch = GraphQlBaseError & {
   __typename?: 'AgentQuotaMismatch'
   message?: Maybe<Scalars['String']>
}

export type AgentsAlreadyExistsInDistributionThroughEntity = GraphQlBaseError & {
   __typename?: 'AgentsAlreadyExistsInDistributionThroughEntity'
   agentIds: Array<Scalars['String']>
   distributionThrough: DistributionThroughType
   distributionThroughEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AgentsAreDeactivated = GraphQlBaseError & {
   __typename?: 'AgentsAreDeactivated'
   agentIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AgentsNotFound = GraphQlBaseError & {
   __typename?: 'AgentsNotFound'
   agentIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AllPublicSearchCategoryFieldsAreRequired = {
   __typename?: 'AllPublicSearchCategoryFieldsAreRequired'
   category: Scalars['String']
   missedFieldIds: Array<Scalars['String']>
}

export enum AllocationGroupExecLogStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS'
}

export type AllocationGroupItemExecLog =
   | AdhocAgentAllocationGroupExecLog
   | AgentAllocationGroupExecLog

export type AllocationGroupItemSummary =
   | AdhocAgentAllocationGroupSummary
   | AgentAllocationGroupSummary

export type AllocationGroupSet = {
   __typename?: 'AllocationGroupSet'
   allocationGroupSetId: Scalars['String']
   configStatus: LeadDistributionEntityConfigStatus
   items: Array<AllocationGroupSetItem>
   quota?: Maybe<Scalars['Int']>
   quotaType: AllocationGroupSetQuotaType
   setType: AllocationGroupSetType
}

export type AllocationGroupSetItem = AgentAllocationGroup | BaseUser

export type AllocationGroupSetNotFound = GraphQlBaseError & {
   __typename?: 'AllocationGroupSetNotFound'
   allocationGroupSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum AllocationGroupSetQuotaType {
   AgentGlobalQuotaPct = 'AGENT_GLOBAL_QUOTA_PCT',
   Count = 'COUNT'
}

export enum AllocationGroupSetType {
   Agent = 'AGENT',
   AgentAllocationGroup = 'AGENT_ALLOCATION_GROUP'
}

export type AllocationGroupSetTypeMismatch = GraphQlBaseError & {
   __typename?: 'AllocationGroupSetTypeMismatch'
   message?: Maybe<Scalars['String']>
}

export type AllocationGroupSetsExistsInLeadPool = GraphQlBaseError & {
   __typename?: 'AllocationGroupSetsExistsInLeadPool'
   message?: Maybe<Scalars['String']>
}

export type AllocationGroupSetsNotFound = GraphQlBaseError & {
   __typename?: 'AllocationGroupSetsNotFound'
   allocationGroupSetIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AllocationGroupSetsNotInSameDistributionThroughEntity = GraphQlBaseError & {
   __typename?: 'AllocationGroupSetsNotInSameDistributionThroughEntity'
   allocationGroupSetIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AlreadyAutoGenerationEnabledWhileCreation = GraphQlBaseError & {
   __typename?: 'AlreadyAutoGenerationEnabledWhileCreation'
   message?: Maybe<Scalars['String']>
}

export type AlreadyOneEntityExistInOneToManyRelation = GraphQlBaseError & {
   __typename?: 'AlreadyOneEntityExistInOneToManyRelation'
   message?: Maybe<Scalars['String']>
}

export type AlreadyOneEntityExistInOneToOneRelation = GraphQlBaseError & {
   __typename?: 'AlreadyOneEntityExistInOneToOneRelation'
   message?: Maybe<Scalars['String']>
}

export type AlreadyUsedDependentFieldIds = GraphQlBaseError & {
   __typename?: 'AlreadyUsedDependentFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AmbiguousSignerForBlock = GraphQlBaseError & {
   __typename?: 'AmbiguousSignerForBlock'
   blockFieldName: Scalars['String']
   message?: Maybe<Scalars['String']>
   resolvedUserIds: Array<Scalars['String']>
}

export type AmountGivenByEditorCannotBeNegative = {
   __typename?: 'AmountGivenByEditorCannotBeNegative'
   amountGivenByEditor?: Maybe<Scalars['Float']>
}

export type AmountSplitDetails = {
   __typename?: 'AmountSplitDetails'
   amount: Scalars['Float']
   name: Scalars['String']
}

export type AnalyticsBarGraph = {
   __typename?: 'AnalyticsBarGraph'
   averageDisplayValue?: Maybe<Scalars['String']>
   averageValue?: Maybe<Scalars['String']>
   data: Array<AnalyticsBarGraphData>
   totalValue?: Maybe<Scalars['String']>
   xAxisName: Scalars['String']
   yAxisName: Scalars['String']
}

export type AnalyticsBarGraphData = {
   __typename?: 'AnalyticsBarGraphData'
   displayValue: Scalars['String']
   percentage?: Maybe<Scalars['String']>
   xAxisValue: Scalars['String']
   yAxisValue: Scalars['String']
}

export type AnalyticsCoPilotScoreCardData = {
   __typename?: 'AnalyticsCoPilotScoreCardData'
   comparisonDiff?: Maybe<Scalars['String']>
   value?: Maybe<Scalars['String']>
   xAxisMetricName: Scalars['String']
}

export type AnalyticsCoPilotTableData = {
   __typename?: 'AnalyticsCoPilotTableData'
   columns: Array<AnalyticsCopilotColumnHeader>
   rows: Array<AnalyticsCopilotRow>
}

export type AnalyticsCopilotColumnHeader = {
   __typename?: 'AnalyticsCopilotColumnHeader'
   headerId: Scalars['String']
   headerValue: Scalars['String']
}

export type AnalyticsCopilotHistory = {
   __typename?: 'AnalyticsCopilotHistory'
   requestedAt: Scalars['String']
   userQuery: Scalars['String']
}

export type AnalyticsCopilotRow = {
   __typename?: 'AnalyticsCopilotRow'
   rowId: Scalars['String']
   rowValues: Array<Scalars['String']>
}

export enum AnalyticsDataSourceType {
   Activity = 'ACTIVITY',
   Application = 'APPLICATION',
   CallLog = 'CALL_LOG',
   CustomObject = 'CUSTOM_OBJECT',
   Deal = 'DEAL',
   Lead = 'LEAD',
   StageHistory = 'STAGE_HISTORY',
   Task = 'TASK'
}

export type AnalyticsDonut = {
   __typename?: 'AnalyticsDonut'
   data: Array<AnalyticsPieChartData>
   dimensionName: Scalars['String']
   metricName: Scalars['String']
   totalValue: Scalars['String']
}

export type AnalyticsFunnelGraph = {
   __typename?: 'AnalyticsFunnelGraph'
   metrics: Array<AnalyticsFunnelGraphMetric>
}

export type AnalyticsFunnelGraphMetric = {
   __typename?: 'AnalyticsFunnelGraphMetric'
   displayValue: Scalars['String']
   metricId: Scalars['String']
   name: Scalars['String']
   value: Scalars['String']
}

export enum AnalyticsLevel {
   Advanced = 'ADVANCED',
   Basic = 'BASIC'
}

export type AnalyticsLineGraph = {
   __typename?: 'AnalyticsLineGraph'
   data: Array<AnalyticsLineGraphData>
   lineLabels: Array<AnalyticsLineLabel>
   xAxisName: Scalars['String']
   yAxisName: Scalars['String']
}

export type AnalyticsLineGraphData = {
   __typename?: 'AnalyticsLineGraphData'
   xAxisId: Scalars['String']
   xAxisValue: Scalars['String']
   yAxisDataPoints: Array<AnalyticsLineGraphDataPoint>
}

export type AnalyticsLineGraphDataPoint = {
   __typename?: 'AnalyticsLineGraphDataPoint'
   dataPointId: Scalars['String']
   displayValue: Scalars['String']
   value: Scalars['String']
}

export type AnalyticsLineLabel = {
   __typename?: 'AnalyticsLineLabel'
   displayName: Scalars['String']
   lineId: Scalars['String']
}

export type AnalyticsPieChart = {
   __typename?: 'AnalyticsPieChart'
   data: Array<AnalyticsPieChartData>
   dimensionName: Scalars['String']
   metricName: Scalars['String']
   totalValue: Scalars['String']
}

export type AnalyticsPieChartData = {
   __typename?: 'AnalyticsPieChartData'
   displayValue: Scalars['String']
   name: Scalars['String']
   percentage?: Maybe<Scalars['String']>
   value: Scalars['String']
}

export type AnalyticsVisualizations =
   | AnalyticsBarGraph
   | AnalyticsCoPilotScoreCardData
   | AnalyticsCoPilotTableData
   | AnalyticsDonut
   | AnalyticsFunnelGraph
   | AnalyticsLineGraph
   | AnalyticsPieChart

export type Animation = {
   __typename?: 'Animation'
   stateMachines: Array<Scalars['String']>
   url: Scalars['String']
}

export type AnotherSigningFeatureToggleIsEnabled = GraphQlBaseError & {
   __typename?: 'AnotherSigningFeatureToggleIsEnabled'
   feature: CrmAccountFeatureEnum
   message?: Maybe<Scalars['String']>
}

export enum ApiRequestContentTypeEnum {
   ApplicationJson = 'APPLICATION_JSON',
   ApplicationXWwwFormUrlencoded = 'APPLICATION_X_WWW_FORM_URLENCODED',
   TextPlain = 'TEXT_PLAIN'
}

export type AppealDoesNotExists = {
   __typename?: 'AppealDoesNotExists'
   appealId: Scalars['String']
}

export type AppealDoesNotExistsForPipelineItem = GraphQlBaseError & {
   __typename?: 'AppealDoesNotExistsForPipelineItem'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export enum AppealStatus {
   Accepted = 'ACCEPTED',
   CanShow = 'CAN_SHOW',
   Draft = 'DRAFT',
   Expired = 'EXPIRED',
   Rejected = 'REJECTED',
   Requested = 'REQUESTED'
}

export type AppealTab = BaseTab & {
   __typename?: 'AppealTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
   taskTemplateId: Scalars['String']
}

export type AppealTask = {
   __typename?: 'AppealTask'
   appealReason?: Maybe<Scalars['String']>
   taskIconId?: Maybe<Scalars['String']>
   taskId: Scalars['String']
   taskName: Scalars['String']
   taskOverallRemarks: Scalars['String']
}

export type AppealTaskDoesNotExists = GraphQlBaseError & {
   __typename?: 'AppealTaskDoesNotExists'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type AppealTaskVerificationRecommendation = {
   __typename?: 'AppealTaskVerificationRecommendation'
   recommendation: AppealTaskVerificationRecommendationEnum
   taskId: Scalars['String']
}

export enum AppealTaskVerificationRecommendationEnum {
   Accepted = 'ACCEPTED',
   Rejected = 'REJECTED'
}

export type AppealTaskVerificationRemarks = {
   __typename?: 'AppealTaskVerificationRemarks'
   remarks?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type ApplicationAccessDenied = GraphQlBaseError & {
   __typename?: 'ApplicationAccessDenied'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationAccessKeyAlreadyExists = GraphQlBaseError & {
   __typename?: 'ApplicationAccessKeyAlreadyExists'
   message?: Maybe<Scalars['String']>
}

export type ApplicationAlreadyExists = GraphQlBaseError & {
   __typename?: 'ApplicationAlreadyExists'
   applicationId: Scalars['String']
   hasPermission: Scalars['Boolean']
   leadTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type ApplicationAssigneeIsDeactivated = GraphQlBaseError & {
   __typename?: 'ApplicationAssigneeIsDeactivated'
   assigneeId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationAssigneeNotFound = GraphQlBaseError & {
   __typename?: 'ApplicationAssigneeNotFound'
   message?: Maybe<Scalars['String']>
}

export type ApplicationCreatedOnShouldBeInPast = GraphQlBaseError & {
   __typename?: 'ApplicationCreatedOnShouldBeInPast'
   createdOn: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationCreationNotSupportedFields = GraphQlBaseError & {
   __typename?: 'ApplicationCreationNotSupportedFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ApplicationCustomerIdNotFound = GraphQlBaseError & {
   __typename?: 'ApplicationCustomerIdNotFound'
   customerId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationCustomizationAlerts = {
   __typename?: 'ApplicationCustomizationAlerts'
   emptyFeeHeadersAlertMessage?: Maybe<Scalars['String']>
   pipelineItemBannerMessage?: Maybe<Scalars['String']>
   tdrRequestBannerMessage?: Maybe<Scalars['String']>
}

export type ApplicationCustomizationsInPortalResult = {
   __typename?: 'ApplicationCustomizationsInPortalResult'
   tdrRequestBannerMessage?: Maybe<Scalars['String']>
}

export type ApplicationData = {
   __typename?: 'ApplicationData'
   applicationId: Scalars['String']
   proceedingLetters: Array<PublishedDocument>
   properties: Array<ApplicationProperty>
}

export type ApplicationDisplayStageNotConfiguredForPipeline = GraphQlBaseError & {
   __typename?: 'ApplicationDisplayStageNotConfiguredForPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type ApplicationDisplayStageNotFound = GraphQlBaseError & {
   __typename?: 'ApplicationDisplayStageNotFound'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type ApplicationDisplayStageNotInRelationPipeline = GraphQlBaseError & {
   __typename?: 'ApplicationDisplayStageNotInRelationPipeline'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type ApplicationDisplayStagesNotFound = GraphQlBaseError & {
   __typename?: 'ApplicationDisplayStagesNotFound'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export type ApplicationDrawingFileLog = {
   __typename?: 'ApplicationDrawingFileLog'
   applicationId: Scalars['String']
   cadFileUrl?: Maybe<Scalars['String']>
   drawingFileUrl?: Maybe<Scalars['String']>
   logDatetime: Scalars['String']
   preSignedCadFileUrl?: Maybe<Scalars['String']>
   scrutinyReportUrl?: Maybe<Scalars['String']>
   scrutinyStatus: ScrutinyStatus
   workloadId: Scalars['String']
}

export enum ApplicationFeeHeadRefundStatus {
   Completed = 'COMPLETED',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   NonRefundable = 'NON_REFUNDABLE',
   PartiallyFailed = 'PARTIALLY_FAILED',
   YetToRefund = 'YET_TO_REFUND'
}

export type ApplicationFieldHasEmtpyResponse = GraphQlBaseError & {
   __typename?: 'ApplicationFieldHasEmtpyResponse'
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationFieldResponse = {
   __typename?: 'ApplicationFieldResponse'
   applicationId: Scalars['String']
   fieldResponse: FieldResponse
}

export type ApplicationFieldResult =
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldNotFound
   | FieldResponse
   | NotApplicationField
   | NotPermittedField

export type ApplicationForScrutiny = {
   __typename?: 'ApplicationForScrutiny'
   applicationId: Scalars['String']
   fileNumber: Scalars['String']
   overviewFields: Array<FieldResponse>
   pipelineItemTemplateId: Scalars['String']
}

export type ApplicationGoFResponseIdAlreadyLinked = GraphQlBaseError & {
   __typename?: 'ApplicationGoFResponseIdAlreadyLinked'
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationHasPendingPayments = GraphQlBaseError & {
   __typename?: 'ApplicationHasPendingPayments'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pendingOrderIds: Array<Scalars['String']>
}

export type ApplicationHasTdrOrders = GraphQlBaseError & {
   __typename?: 'ApplicationHasTDROrders'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationInApplicationManagement = {
   __typename?: 'ApplicationInApplicationManagement'
   fileNumber: Scalars['String']
   mainPipelineId?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
}

export type ApplicationIsDeleted = GraphQlBaseError & {
   __typename?: 'ApplicationIsDeleted'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationIsNotEligibleForDeemedApproval = GraphQlBaseError & {
   __typename?: 'ApplicationIsNotEligibleForDeemedApproval'
   applicationId?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ApplicationIsNotInCitizenPortal = GraphQlBaseError & {
   __typename?: 'ApplicationIsNotInCitizenPortal'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationKeyIsAlreadyUsed = GraphQlBaseError & {
   __typename?: 'ApplicationKeyIsAlreadyUsed'
   message?: Maybe<Scalars['String']>
}

export type ApplicationManagementAccessDenied = GraphQlBaseError & {
   __typename?: 'ApplicationManagementAccessDenied'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export enum ApplicationManagementActionType {
   ApplicationUpdates = 'APPLICATION_UPDATES',
   TaskShortfall = 'TASK_SHORTFALL',
   TransferApplication = 'TRANSFER_APPLICATION',
   UpdateApplication = 'UPDATE_APPLICATION'
}

export type ApplicationManagementAttachment = {
   __typename?: 'ApplicationManagementAttachment'
   attachmentId?: Maybe<Scalars['String']>
   mimeType?: Maybe<Scalars['String']>
   name: Scalars['String']
   sizeInBytes?: Maybe<Scalars['Int']>
   url: Scalars['String']
}

export type ApplicationManagementAttachmentInput = {
   attachmentId?: InputMaybe<Scalars['String']>
   mimeType?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   sizeInBytes?: InputMaybe<Scalars['Int']>
   url: Scalars['String']
}

export type ApplicationManagementLog = TaskShortfallLog

export type ApplicationNotEligibleForRefund = GraphQlBaseError & {
   __typename?: 'ApplicationNotEligibleForRefund'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
}

export type ApplicationNotFound = GraphQlBaseError & {
   __typename?: 'ApplicationNotFound'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum ApplicationOverallRecommendation {
   Approved = 'APPROVED',
   Rejected = 'REJECTED',
   Shortfall = 'SHORTFALL'
}

export type ApplicationPipelineAlreadyExistsInPortal = GraphQlBaseError & {
   __typename?: 'ApplicationPipelineAlreadyExistsInPortal'
   applicationPipelineId: Scalars['String']
   message?: Maybe<Scalars['String']>
   portalId: Scalars['String']
}

export type ApplicationPrimaryDetails = BasePipelineItemPrimaryDetails & {
   __typename?: 'ApplicationPrimaryDetails'
   name: PipelineItemPrimaryFieldResult
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   stage: PipelineItemPrimaryFieldResult
}

export type ApplicationPrimaryDisplayNameFieldExistsInGoF = GraphQlBaseError & {
   __typename?: 'ApplicationPrimaryDisplayNameFieldExistsInGoF'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationProfile = BasePipelineItem & {
   __typename?: 'ApplicationProfile'
   createdAt: Scalars['String']
   fields: Array<SystemFieldEnumResponseResult>
   latestActivity?: Maybe<Activity>
   latestRemarks?: Maybe<PipelineItemRemarks>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   task?: Maybe<Task>
}

export type ApplicationProfileFieldsArgs = {
   systemFieldEnums: Array<CustomObjectSystemFieldEnum>
}

export type ApplicationProperties = BasePipelineItemProperties & {
   __typename?: 'ApplicationProperties'
   createdAt: Scalars['String']
   fields: Array<FieldResponseResult>
   latestRemarks?: Maybe<PipelineItemRemarks>
   pipelineItemId: Scalars['String']
   pipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemSchedule?: Maybe<PipelineItemSchedule>
   pipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   scheduledPipelineItem?: Maybe<ScheduledPipelineItem>
}

export type ApplicationPropertiesFieldsArgs = {
   fieldIds: Array<Scalars['String']>
}

export type ApplicationPropertiesAsOpen = {
   __typename?: 'ApplicationPropertiesAsOpen'
   createdAt: Scalars['String']
   fields: Array<FieldResponseResult>
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
}

export type ApplicationPropertiesAsOpenFieldsArgs = {
   fieldIds: Array<Scalars['String']>
}

export type ApplicationPropertiesAsOpenResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ApplicationPropertiesAsOpen

export type ApplicationPropertiesInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | PortalApplicationProperties

export type ApplicationPropertiesResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ApplicationProperties

export type ApplicationProperty = {
   __typename?: 'ApplicationProperty'
   fieldId: Scalars['String']
   name: Scalars['String']
   response?: Maybe<ExtFieldResponseType>
}

export type ApplicationPropertyConfig = {
   __typename?: 'ApplicationPropertyConfig'
   category: Scalars['String']
   dependentOptions?: Maybe<ApplicationPropertyDependentOptionsConfig>
   fieldId: Scalars['String']
   name: Scalars['String']
   options?: Maybe<Array<Maybe<Scalars['String']>>>
   propertyType: ApplicationPropertyType
}

export type ApplicationPropertyDependentOptionMapping = {
   __typename?: 'ApplicationPropertyDependentOptionMapping'
   dependentOptions: Array<Scalars['String']>
   parentFieldOption: Scalars['String']
}

export type ApplicationPropertyDependentOptionsConfig = {
   __typename?: 'ApplicationPropertyDependentOptionsConfig'
   optionsMappings: Array<ApplicationPropertyDependentOptionMapping>
   parentFieldId: Scalars['String']
}

export enum ApplicationPropertyType {
   CheckboxGroup = 'CHECKBOX_GROUP',
   Date = 'DATE',
   DateTime = 'DATE_TIME',
   Dropdown = 'DROPDOWN',
   Email = 'EMAIL',
   Float = 'FLOAT',
   GeoLocation = 'GEO_LOCATION',
   GeoShape = 'GEO_SHAPE',
   Integer = 'INTEGER',
   LongText = 'LONG_TEXT',
   MultiSelect = 'MULTI_SELECT',
   PhoneNumber = 'PHONE_NUMBER',
   PlainText = 'PLAIN_TEXT',
   RadioGroup = 'RADIO_GROUP',
   ShortText = 'SHORT_TEXT',
   Stage = 'STAGE',
   Time = 'TIME',
   Url = 'URL'
}

export type ApplicationRefundDetails = {
   __typename?: 'ApplicationRefundDetails'
   applicationId: Scalars['String']
   applicationNumber: Scalars['String']
   applicationRefundId: Scalars['String']
   budgetHeadBreakdown: Array<RefundBudgetHeadBreakdown>
   createdAt: Scalars['String']
   initiatedLogs: Array<RefundInitiatedLog>
   refundStatus: ApplicationRefundStatus
   totalPaidAmount: Scalars['Float']
   totalRefundAmount: Scalars['Float']
   updatedAt?: Maybe<Scalars['String']>
}

export type ApplicationRefundNotFound = GraphQlBaseError & {
   __typename?: 'ApplicationRefundNotFound'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum ApplicationRefundParamsStatus {
   Completed = 'COMPLETED',
   InProgress = 'IN_PROGRESS',
   YetToRefund = 'YET_TO_REFUND'
}

export enum ApplicationRefundStatus {
   Completed = 'COMPLETED',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   PartiallyFailed = 'PARTIALLY_FAILED',
   YetToRefund = 'YET_TO_REFUND'
}

export type ApplicationScrutinyStateNotAllowed = GraphQlBaseError & {
   __typename?: 'ApplicationScrutinyStateNotAllowed'
   message?: Maybe<Scalars['String']>
}

export type ApplicationSortParams = {
   fieldId: Scalars['String']
   order: SortValue
}

export type ApplicationStageFieldNotConfigured = GraphQlBaseError & {
   __typename?: 'ApplicationStageFieldNotConfigured'
   applicationTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationStageNotFound = GraphQlBaseError & {
   __typename?: 'ApplicationStageNotFound'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationStageSummary = {
   __typename?: 'ApplicationStageSummary'
   actions: Array<ApplicationStageTransitionAction>
   applicationId: Scalars['String']
   applicationShortfallFieldIds: Array<Scalars['String']>
   hasTdrRequests: Scalars['Boolean']
   lineDepartmentStatuses: Array<LineDepartmentStatus>
   mortgageTaskTemplateId?: Maybe<Scalars['String']>
   overallRecommendation?: Maybe<ApplicationOverallRecommendation>
   revisedFeeAmount?: Maybe<Scalars['Float']>
   shortfallCounterInfo?: Maybe<ShortfallCounterInfo>
   stageId: Scalars['String']
   tabUnVerifiedPhoneNumberFields: Array<TabUnVerifiedPhoneNumberFields>
   tabUnfilledRequiredFields: Array<TabUnfilledRequiredFields>
   taskRecommendations: Array<LayoutTabTaskRecommendation>
   tdrInfo?: Maybe<ApplicationTdrInfo>
   titleVerificationTaskTemplateId?: Maybe<Scalars['String']>
   tvoAssignee?: Maybe<BaseUser>
   unsignedDocuments: Array<Document>
   workCommencedStatus: WorkCommencementStatus
}

export type ApplicationStageSummaryConfigIsNotConfigured = GraphQlBaseError & {
   __typename?: 'ApplicationStageSummaryConfigIsNotConfigured'
   message?: Maybe<Scalars['String']>
}

export enum ApplicationStageSummaryEnum {
   CluApprove = 'CLU_APPROVE',
   CluIssueShortfall = 'CLU_ISSUE_SHORTFALL',
   CluReject = 'CLU_REJECT',
   CluReleaseTheGo = 'CLU_RELEASE_THE_GO',
   CluSendToApplicant = 'CLU_SEND_TO_APPLICANT',
   CluSendToNextLevel = 'CLU_SEND_TO_NEXT_LEVEL',
   IaApproved = 'IA_APPROVED',
   IaIntimateRevisedFee = 'IA_INTIMATE_REVISED_FEE',
   IaIssueShortFall = 'IA_ISSUE_SHORT_FALL',
   IaOnHoldLineDepartment = 'IA_ON_HOLD_LINE_DEPARTMENT',
   IaReject = 'IA_REJECT',
   IaRejectWithoutRefund = 'IA_REJECT_WITHOUT_REFUND',
   IaRejectWithRefund = 'IA_REJECT_WITH_REFUND',
   IaSendBack = 'IA_SEND_BACK',
   IaSendToNextLevel = 'IA_SEND_TO_NEXT_LEVEL',
   IaSendToNextLevelWithLineDepartment = 'IA_SEND_TO_NEXT_LEVEL_WITH_LINE_DEPARTMENT',
   IicApprove = 'IIC_APPROVE',
   IicIssueProceedings = 'IIC_ISSUE_PROCEEDINGS',
   IicIssueShortfall = 'IIC_ISSUE_SHORTFALL',
   IicReject = 'IIC_REJECT',
   IicSendToApplicant = 'IIC_SEND_TO_APPLICANT',
   IicSendToNextLevel = 'IIC_SEND_TO_NEXT_LEVEL',
   IrApproved = 'IR_APPROVED',
   IrIssueShortFall = 'IR_ISSUE_SHORT_FALL',
   IrOnHoldLineDepartment = 'IR_ON_HOLD_LINE_DEPARTMENT',
   IrReject = 'IR_REJECT',
   IrSendBack = 'IR_SEND_BACK',
   IrSendToNextLevel = 'IR_SEND_TO_NEXT_LEVEL',
   IrSendToNextLevelWithLineDepartment = 'IR_SEND_TO_NEXT_LEVEL_WITH_LINE_DEPARTMENT',
   LpIssueShortfall = 'LP_ISSUE_SHORTFALL',
   LpIssueShortfallDtcpApproval = 'LP_ISSUE_SHORTFALL_DTCP_APPROVAL',
   LpRecommendDtcp = 'LP_RECOMMEND_DTCP',
   LpSendToNextLevelLn_1 = 'LP_SEND_TO_NEXT_LEVEL_LN_1',
   LpVerified = 'LP_VERIFIED',
   RvdApprove = 'RVD_APPROVE',
   RvdIntimateRevisedFee = 'RVD_INTIMATE_REVISED_FEE',
   RvdIssueShortfall = 'RVD_ISSUE_SHORTFALL',
   RvdSendToNextLevel = 'RVD_SEND_TO_NEXT_LEVEL',
   RvdSendToNextLevelForShortfall = 'RVD_SEND_TO_NEXT_LEVEL_FOR_SHORTFALL',
   SwApprove = 'SW_APPROVE',
   SwApproveTdr = 'SW_APPROVE_TDR',
   SwConfirmTdrDetails = 'SW_CONFIRM_TDR_DETAILS',
   SwIssueProceedings = 'SW_ISSUE_PROCEEDINGS',
   SwIssueProceedingsByL2 = 'SW_ISSUE_PROCEEDINGS_BY_L2',
   SwIssueShortfall = 'SW_ISSUE_SHORTFALL',
   SwOnHoldForLineDepartment = 'SW_ON_HOLD_FOR_LINE_DEPARTMENT',
   SwReject = 'SW_REJECT',
   SwRejectionVerificationByL2 = 'SW_REJECTION_VERIFICATION_BY_L2',
   SwSendBack = 'SW_SEND_BACK',
   SwSendBackToTvo = 'SW_SEND_BACK_TO_TVO',
   SwSendToApplicant = 'SW_SEND_TO_APPLICANT',
   SwSendToL2SkipTvo = 'SW_SEND_TO_L2_SKIP_TVO',
   SwSendToNextLevel = 'SW_SEND_TO_NEXT_LEVEL',
   SwSendToNextLevelTvo = 'SW_SEND_TO_NEXT_LEVEL_TVO',
   SwSendToNextLevelWithoutShortfallCounter = 'SW_SEND_TO_NEXT_LEVEL_WITHOUT_SHORTFALL_COUNTER',
   SwTdrShortfall = 'SW_TDR_SHORTFALL',
   SwWaitingForTvoRemarks = 'SW_WAITING_FOR_TVO_REMARKS',
   TdrApprove = 'TDR_APPROVE',
   TdrIssueProceedings = 'TDR_ISSUE_PROCEEDINGS',
   TdrIssueShortfall = 'TDR_ISSUE_SHORTFALL',
   TdrOnHoldForLineDepartment = 'TDR_ON_HOLD_FOR_LINE_DEPARTMENT',
   TdrReject = 'TDR_REJECT',
   TdrSendToNextLevel = 'TDR_SEND_TO_NEXT_LEVEL',
   TdrWaitingForTvoRemarks = 'TDR_WAITING_FOR_TVO_REMARKS'
}

export type ApplicationStageTransitionAction = {
   __typename?: 'ApplicationStageTransitionAction'
   actionName?: Maybe<Scalars['String']>
   fromStage: BaseStage
   fromStageId: Scalars['String']
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   mandatoryTasks: Array<StageTransitionMandatoryTaskStatus>
   stageTransitionId: Scalars['String']
   stageTransitionType: StageTransitionType
   status: StageTransitionActionStatus
   summaryEnum?: Maybe<ApplicationStageSummaryEnum>
   toStage: BaseStage
   toStageId: Scalars['String']
}

export enum ApplicationSubmitPermissionStatus {
   Allow = 'ALLOW',
   NotAllow = 'NOT_ALLOW'
}

export enum ApplicationSystemFieldEnum {
   ApplicationAssignedOn = 'APPLICATION_ASSIGNED_ON',
   ApplicationAssignee = 'APPLICATION_ASSIGNEE',
   ApplicationCreatedOn = 'APPLICATION_CREATED_ON',
   ApplicationCustomerId = 'APPLICATION_CUSTOMER_ID',
   ApplicationCustomId = 'APPLICATION_CUSTOM_ID',
   ApplicationDisplayStage = 'APPLICATION_DISPLAY_STAGE',
   ApplicationId = 'APPLICATION_ID',
   ApplicationScore = 'APPLICATION_SCORE',
   ApplicationStage = 'APPLICATION_STAGE',
   ArchitectId = 'ARCHITECT_ID'
}

export type ApplicationSystemFieldResult = {
   __typename?: 'ApplicationSystemFieldResult'
   applicationId: Scalars['String']
   fields: Array<SystemFieldEnumResponseResult>
}

export type ApplicationSystemFieldsResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ApplicationSystemFieldResult

export type ApplicationTdrInfo = {
   __typename?: 'ApplicationTDRInfo'
   availTdr?: Maybe<AvailTdrEnum>
   tdrBuildupAreaFromDrawing?: Maybe<Scalars['Float']>
   tdrTaskTemplateId?: Maybe<Scalars['String']>
}

export enum ApplicationTabEnum {
   Icon = 'ICON',
   Progress = 'PROGRESS'
}

export type ApplicationTabIconInfoIsRequired = GraphQlBaseError & {
   __typename?: 'ApplicationTabIconInfoIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ApplicationTableCard = BaseCard & {
   __typename?: 'ApplicationTableCard'
   cardType: TabCardType
   columns: Array<ApplicationTableColumn>
   name: Scalars['String']
   rows: Array<ApplicationTableRow>
}

export type ApplicationTableCell = {
   __typename?: 'ApplicationTableCell'
   allowNegativeNumber?: Maybe<Scalars['Boolean']>
   columnName: Scalars['String']
   fieldId?: Maybe<Scalars['String']>
   formula?: Maybe<Scalars['String']>
   label?: Maybe<Scalars['String']>
   noOfDigitsRoundOff?: Maybe<Scalars['Int']>
}

export type ApplicationTableColumn = {
   __typename?: 'ApplicationTableColumn'
   allowNegativeNumber?: Maybe<Scalars['Boolean']>
   columnName: Scalars['String']
   columnType: ApplicationTableColumnType
   formula?: Maybe<Scalars['String']>
   isMainField?: Maybe<Scalars['Boolean']>
   isNestedRowsDecider?: Maybe<Scalars['Boolean']>
   noOfDigitsRoundOff?: Maybe<Scalars['Int']>
}

export enum ApplicationTableColumnType {
   Field = 'FIELD',
   Formula = 'FORMULA',
   RowHeader = 'ROW_HEADER',
   SNo = 'S_NO'
}

export type ApplicationTableRow = {
   __typename?: 'ApplicationTableRow'
   cells: Array<ApplicationTableCell>
   rowId: Scalars['String']
}

export type ApplicationTemplateNotFound = GraphQlBaseError & {
   __typename?: 'ApplicationTemplateNotFound'
   applicationTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ApplicationTemplatePluralNameIsRequired = GraphQlBaseError & {
   __typename?: 'ApplicationTemplatePluralNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ApplicationTemplateProperties = {
   __typename?: 'ApplicationTemplateProperties'
   pluralName: Scalars['String']
   primaryDisplayNameFieldId: Scalars['String']
   singularName: Scalars['String']
   subStatusConfig: ApplicationTemplateSubStatusFieldsConfig
}

export type ApplicationTemplateSingularNameIsRequired = GraphQlBaseError & {
   __typename?: 'ApplicationTemplateSingularNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ApplicationTemplateSubStatusFieldsConfig = {
   __typename?: 'ApplicationTemplateSubStatusFieldsConfig'
   fieldIds: Array<Scalars['String']>
   isSubStatusEnabled: Scalars['Boolean']
}

export enum ApplicationTypeEnum {
   Default = 'DEFAULT',
   Tdr = 'TDR'
}

export type ApplicationUpdatedDummyMutationParams = {
   response: Scalars['String']
}

export type ApplicationUpdatedDummyMutationResult = {
   __typename?: 'ApplicationUpdatedDummyMutationResult'
   displayStage?: Maybe<StageDetailsInSubscription>
   displayStageFieldId?: Maybe<Scalars['String']>
   permittedUserIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineIds: Array<Scalars['String']>
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   stage?: Maybe<StageDetailsInSubscription>
   stageFieldId?: Maybe<Scalars['String']>
   updateType: ApplicationUpdatedType
   updatedFieldIds: Array<Scalars['String']>
}

export enum ApplicationUpdatedType {
   DisplayStageUpdated = 'DISPLAY_STAGE_UPDATED',
   FieldResponseUpdated = 'FIELD_RESPONSE_UPDATED',
   PaymentCompleted = 'PAYMENT_COMPLETED',
   PaymentCreated = 'PAYMENT_CREATED',
   ScrutinyProgressUpdated = 'SCRUTINY_PROGRESS_UPDATED',
   StageUpdated = 'STAGE_UPDATED'
}

export type ApplicationViewType = {
   __typename?: 'ApplicationViewType'
   permittedActions: Array<PmuActionType>
   tabFieldResponses: Array<TabFieldResponsesType>
}

export type ApplicationsAccessDenied = GraphQlBaseError & {
   __typename?: 'ApplicationsAccessDenied'
   applicationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ApplicationsAreDeleted = GraphQlBaseError & {
   __typename?: 'ApplicationsAreDeleted'
   applicationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ApplicationsInPortalResult = {
   __typename?: 'ApplicationsInPortalResult'
   applications: Array<PortalApplication>
   portalId: Scalars['String']
   totalCount: Scalars['Int']
}

export type ApplicationsNotFound = GraphQlBaseError & {
   __typename?: 'ApplicationsNotFound'
   applicationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AppliedFeeHeader = {
   __typename?: 'AppliedFeeHeader'
   adjustedAmount: Scalars['Float']
   amountCalculatedBySystem: Scalars['Float']
   amountGivenByEditor?: Maybe<Scalars['Float']>
   appliedFeeHeaderId: Scalars['String']
   feeHeader: FeeHeader
   formula?: Maybe<Scalars['String']>
   isDeleted: Scalars['Boolean']
   modifiedBy?: Maybe<BaseUser>
   netAmount: Scalars['Float']
   order: Scalars['Int']
   remarks?: Maybe<Scalars['String']>
   remarksLastUpdatedAt?: Maybe<Scalars['String']>
   remarksLastUpdatedBy?: Maybe<BaseUser>
}

export type AppliedFeeHeaderNotFound = {
   __typename?: 'AppliedFeeHeaderNotFound'
   appliedFeeHeaderId: Scalars['String']
}

export enum ApplyAutomationWorkflowsFiltersOn {
   Leads = 'LEADS',
   RelatedObjects = 'RELATED_OBJECTS',
   UserProperties = 'USER_PROPERTIES'
}

export enum ApplyConditionNodeFiltersOn {
   Leads = 'LEADS',
   RelatedObjects = 'RELATED_OBJECTS'
}

export type ApplyForDeemedApprovalInPortalParams = {
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type ApplyForDeemedApprovalInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationIsNotEligibleForDeemedApproval
   | ApplicationNotFound
   | ApplyForDeemedApprovalInPortalResult
   | DeemedApprovalConfigIsEmpty
   | PortalNotFound

export type ApplyForDeemedApprovalInPortalResult = {
   __typename?: 'ApplyForDeemedApprovalInPortalResult'
   applicationId: Scalars['String']
   changedFields: Array<FieldResponse>
}

export type ApplyPortalApplicationKeyParams = {
   applicationConfig?: InputMaybe<ApplyPortalApplicationPipelineConfigParams>
   key: Scalars['String']
   portalId: Scalars['String']
}

export type ApplyPortalApplicationKeyResponse =
   | ApplicationKeyIsAlreadyUsed
   | ApplicationScrutinyStateNotAllowed
   | ApplyPortalApplicationKeyResult
   | CustomIdFieldIsNotConfiguredInApplicationPipeline
   | DisplayStageNotFound
   | GivenPipelineIsNotAllowedForApplication
   | InvalidApplicationKey
   | PipelineNotInPortal
   | PortalPipelineIdsNotConfigured
   | StageNotInPipeline

export type ApplyPortalApplicationKeyResult = {
   __typename?: 'ApplyPortalApplicationKeyResult'
   displayStageId?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type ApplyPortalApplicationPipelineConfigParams = {
   displayStageId?: InputMaybe<Scalars['String']>
   fieldReferenceId?: InputMaybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type ApproveLineDepartmentRecommendationParams = {
   remarks?: InputMaybe<Scalars['String']>
   requestId: Scalars['String']
}

export type ApproveLineDepartmentRecommendationResponse =
   | ApproveLineDepartmentRecommendationResult
   | LayoutTabNotFound
   | LineDepartmentActionNotPermittedForUser
   | LineDepartmentRequestMustBeRecommended
   | LineDepartmentRequestNotFoundError
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TabNotInPipelineItemTemplate
   | VerificationNotFound

export type ApproveLineDepartmentRecommendationResult = {
   __typename?: 'ApproveLineDepartmentRecommendationResult'
   remarks?: Maybe<Scalars['String']>
   requestId: Scalars['String']
   verificationStage?: Maybe<Stage>
   verificationStageId: Scalars['String']
}

export type Architect = {
   __typename?: 'Architect'
   caRegNumberValidity?: Maybe<Scalars['String']>
   caRegistrationNumber?: Maybe<Scalars['String']>
   email?: Maybe<Scalars['String']>
   firstName?: Maybe<Scalars['String']>
   isCaRegisteredArchitect?: Maybe<Scalars['Boolean']>
   isDisclaimerAccepted?: Maybe<Scalars['Boolean']>
   lastName?: Maybe<Scalars['String']>
   licenceNumber?: Maybe<Scalars['String']>
   licenceValidity?: Maybe<Scalars['String']>
   phoneNumber?: Maybe<PhoneNumberResponse>
   profilePic?: Maybe<ArchitectProfileAttachment>
   signature?: Maybe<ArchitectProfileAttachment>
   userId: Scalars['String']
}

export type ArchitectProfileAttachment = {
   __typename?: 'ArchitectProfileAttachment'
   mimeType?: Maybe<Scalars['String']>
   name?: Maybe<Scalars['String']>
   sizeInBytes?: Maybe<Scalars['Float']>
   url: Scalars['String']
}

export enum ArchitectProfileAttachmentEnum {
   ProfilePic = 'PROFILE_PIC',
   Signature = 'SIGNATURE'
}

export type ArchitectProfileAttachmentParams = {
   mimeType?: InputMaybe<Scalars['String']>
   name?: InputMaybe<Scalars['String']>
   sizeInBytes?: InputMaybe<Scalars['Float']>
   url: Scalars['String']
}

export type AreaFieldNotFound = GraphQlBaseError & {
   __typename?: 'AreaFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AreaFieldRequiredWhenGoFProvided = GraphQlBaseError & {
   __typename?: 'AreaFieldRequiredWhenGoFProvided'
   message?: Maybe<Scalars['String']>
}

export enum ArithmeticOperation {
   Add = 'ADD',
   Subtract = 'SUBTRACT'
}

export type AskQueryInThreadParams = {
   query: Scalars['String']
   threadId: Scalars['Int']
}

export type AskQueryInThreadResponse =
   | AskQueryInThreadResult
   | ThreadAccessDenied
   | ThreadNotFound

export type AskQueryInThreadResult = {
   __typename?: 'AskQueryInThreadResult'
   message: ThreadMessage
}

export type AssignDocumentVerificationUserParams = {
   assigneeFieldId: Scalars['String']
   assigneeId: Scalars['String']
   pipelineItemId: Scalars['String']
   tabId: Scalars['String']
}

export type AssignDocumentVerificationUserResponse =
   | AssignDocumentVerificationUserResult
   | AssigneeFieldNotConfigured
   | DocumentVerificationConfigurationMissing
   | DocumentVerificationTabNotFound
   | InvalidDocumentVerificationTabType
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TaskAssigneeDoesNotHavePipelineItemAccess
   | TaskAssigneeIsDeactivated
   | TaskAssigneeNotFound

export type AssignDocumentVerificationUserResult = {
   __typename?: 'AssignDocumentVerificationUserResult'
   assigneeFieldId: Scalars['String']
   assigneeId: Scalars['String']
   pipelineItemId: Scalars['String']
   task: Task
   taskId: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type AssignFriendActionDetails = {
   __typename?: 'AssignFriendActionDetails'
   assignablePipelineIds?: Maybe<Array<Maybe<Scalars['String']>>>
   canAssignFriend: Scalars['Boolean']
}

export type AssignFriendJsonConfigurationNotFound = GraphQlBaseError & {
   __typename?: 'AssignFriendJsonConfigurationNotFound'
   message?: Maybe<Scalars['String']>
}

export type AssignFriendParams = {
   friendOfficerId: Scalars['String']
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type AssignFriendResponse =
   | AssignFriendResult
   | FriendAlreadyAssigned
   | FriendConfigurationNotFound
   | FriendFeatureDisabled
   | FriendFieldsExhausted
   | InvalidFriendOfficerId
   | NotAllowedSelfAssignment
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemRemarksCannotBeEmpty
   | PipelineNotFound
   | UnauthorizedFriendAssignment

export type AssignFriendResult = {
   __typename?: 'AssignFriendResult'
   friendFieldId: Scalars['String']
   friendOfficerId: Scalars['String']
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type AssignedFriendApplication = {
   __typename?: 'AssignedFriendApplication'
   accessType: PipelineItemAccessType
   applicationId: Scalars['String']
   applicationTemplateId: Scalars['String']
   mainPipelineId?: Maybe<Scalars['String']>
   properties: Array<ApplicationProperty>
}

export enum AssigneeEntityType {
   ApplicationOnHold = 'APPLICATION_ON_HOLD',
   Architect = 'ARCHITECT',
   Assignee = 'ASSIGNEE',
   Citizen = 'CITIZEN',
   LineDepartmentOnHold = 'LINE_DEPARTMENT_ON_HOLD',
   Na = 'NA',
   TdrOwner = 'TDR_OWNER'
}

export type AssigneeFieldIdRequired = GraphQlBaseError & {
   __typename?: 'AssigneeFieldIdRequired'
   message?: Maybe<Scalars['String']>
}

export type AssigneeFieldMapping = {
   __typename?: 'AssigneeFieldMapping'
   assignedOnFieldId: Scalars['String']
   assigneeFieldId: Scalars['String']
}

export type AssigneeFieldNotConfigured = GraphQlBaseError & {
   __typename?: 'AssigneeFieldNotConfigured'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type AssigneeFieldParams = {
   assigneeId: Scalars['String']
   fieldId: Scalars['String']
}

export type AssigneeFieldsAlreadyExistsInAnotherGroup = GraphQlBaseError & {
   __typename?: 'AssigneeFieldsAlreadyExistsInAnotherGroup'
   assigneeFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AssigneeFieldsConfig = {
   __typename?: 'AssigneeFieldsConfig'
   assigneeFieldIds: Array<Scalars['String']>
   considerStageAsSubmission: Scalars['Boolean']
   entityTypes: Array<AssigneeEntityType>
   /** @deprecated Use entity_types parameter instead. This field will be removed in a future version. */
   trackArchitect?: Maybe<Scalars['Boolean']>
   /** @deprecated Use entity_types parameter instead. This field will be removed in a future version. */
   trackCitizen?: Maybe<Scalars['Boolean']>
}

export type AssigneeFieldsGroupNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'AssigneeFieldsGroupNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type AssigneeGroup = {
   __typename?: 'AssigneeGroup'
   assigneeFieldIds: Array<Scalars['String']>
   assigneeGroupId: Scalars['String']
   name: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
}

export type AssigneeGroupNotFound = GraphQlBaseError & {
   __typename?: 'AssigneeGroupNotFound'
   assigneeGroupId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AssigneeGroups = {
   __typename?: 'AssigneeGroups'
   assigneeGroups: Array<AssigneeGroup>
   totalCount: Scalars['Int']
}

export type AssigneeGroupsNotFound = GraphQlBaseError & {
   __typename?: 'AssigneeGroupsNotFound'
   assigneeGroupIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AssigneeGroupsNotInSalesTemplate = GraphQlBaseError & {
   __typename?: 'AssigneeGroupsNotInSalesTemplate'
   assigneeGroupIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type AssigneeIsDeactivated = GraphQlBaseError & {
   __typename?: 'AssigneeIsDeactivated'
   assigneeId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AssigneeNotFound = GraphQlBaseError & {
   __typename?: 'AssigneeNotFound'
   assigneeId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum AssigneeStageMovementDirectionEnum {
   Backward = 'BACKWARD',
   Forward = 'FORWARD'
}

export type AssigneeTimeSpentLogsForSubmission = {
   __typename?: 'AssigneeTimeSpentLogsForSubmission'
   assigneeTimeSpentLogSummary: Array<StageAssigneeTimespentLogSummary>
   assigneeTimeSpentLogs: Array<StageAssigneeTimespentLog>
   submissionDate: Scalars['String']
   submissionNumber: Scalars['Int']
}

export type AssigneeTimespentLogInPortal = {
   __typename?: 'AssigneeTimespentLogInPortal'
   designation?: Maybe<Scalars['String']>
   entityType: AssigneeEntityType
   movementDirection: AssigneeStageMovementDirectionEnum
   participantType?: Maybe<ParticipantType>
   timeSpentInSec: Scalars['Float']
   user: BaseUser
}

export type AssigneesAreDeactivated = GraphQlBaseError & {
   __typename?: 'AssigneesAreDeactivated'
   assigneeIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AssigneesNotFound = GraphQlBaseError & {
   __typename?: 'AssigneesNotFound'
   assigneeIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export enum AsyncJobStatus {
   Completed = 'COMPLETED',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   Pending = 'PENDING'
}

export enum AsyncJobType {
   ResetSiteInspectionTask = 'RESET_SITE_INSPECTION_TASK',
   ResetVerificationTask = 'RESET_VERIFICATION_TASK',
   ScheduleSiteInspection = 'SCHEDULE_SITE_INSPECTION',
   VerifyAllSiteInspection = 'VERIFY_ALL_SITE_INSPECTION'
}

export type AtLeastOneActionNodeIsRequired = GraphQlBaseError & {
   __typename?: 'AtLeastOneActionNodeIsRequired'
   message?: Maybe<Scalars['String']>
}

export type AtLeastOneApplicationIdentificationFieldIsRequired = GraphQlBaseError & {
   __typename?: 'AtLeastOneApplicationIdentificationFieldIsRequired'
   message?: Maybe<Scalars['String']>
}

export type AtLeastOneCustomObjectIdentificationFieldIsRequired = GraphQlBaseError & {
   __typename?: 'AtLeastOneCustomObjectIdentificationFieldIsRequired'
   message?: Maybe<Scalars['String']>
}

export type AtLeastOneParameterRequired = GraphQlBaseError & {
   __typename?: 'AtLeastOneParameterRequired'
   message?: Maybe<Scalars['String']>
}

export type AtLeastOneSystemUniqueFieldIsRequiredForContact = GraphQlBaseError & {
   __typename?: 'AtLeastOneSystemUniqueFieldIsRequiredForContact'
   message?: Maybe<Scalars['String']>
   systemUniqueFields: Array<SystemFieldEnum>
}

export type AtLeastOneWhatsAppBusinessPhoneNumberConfigIsRequired = GraphQlBaseError & {
   __typename?: 'AtLeastOneWhatsAppBusinessPhoneNumberConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type AtleastOneTdrRequestRequiredForPipelineItem = GraphQlBaseError & {
   __typename?: 'AtleastOneTDRRequestRequiredForPipelineItem'
   message?: Maybe<Scalars['String']>
}

export type Attachment = {
   __typename?: 'Attachment'
   attachmentId: Scalars['String']
   mimeType?: Maybe<Scalars['String']>
   name?: Maybe<Scalars['String']>
   preSignedUrl: Scalars['String']
   sizeInBytes?: Maybe<Scalars['Float']>
   url: Scalars['String']
}

export type AttachmentMustBeValidS3Url = GraphQlBaseError & {
   __typename?: 'AttachmentMustBeValidS3Url'
   message?: Maybe<Scalars['String']>
}

export type AttendanceTrackingConfig = {
   __typename?: 'AttendanceTrackingConfig'
   defaultClockOutTime?: Maybe<Scalars['String']>
}

export type AttendanceTrackingConfigNotFound = GraphQlBaseError & {
   __typename?: 'AttendanceTrackingConfigNotFound'
   message?: Maybe<Scalars['String']>
}

export type AttendanceTrackingConfigResponse =
   | AttendanceTrackingConfig
   | AttendanceTrackingConfigNotFound
   | UserIsNotAnAdministrator

export enum AttendanceTrackingSettingsEnum {
   DefaultClockOutTime = 'DEFAULT_CLOCK_OUT_TIME'
}

export enum Authority {
   Dtcp = 'DTCP',
   Ghmc = 'GHMC',
   Hmda = 'HMDA'
}

export type AuthorityFieldNotFilled = GraphQlBaseError & {
   __typename?: 'AuthorityFieldNotFilled'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AuthorityFieldNotFound = GraphQlBaseError & {
   __typename?: 'AuthorityFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AuthorityMismatch = {
   __typename?: 'AuthorityMismatch'
   message?: Maybe<Scalars['String']>
}

export enum AuthorityType {
   All = 'ALL',
   Dtcp = 'DTCP',
   Ghmc = 'GHMC',
   Hmda = 'HMDA'
}

export type AuthorizeGoogleUserParams = {
   authClientType: GoogleAuthClientType
   authorizationCode: Scalars['String']
   email?: InputMaybe<Scalars['String']>
}

export type AuthorizeGoogleUserResponse =
   | AuthorizeGoogleUserResult
   | InvalidAuthorizationCode

export type AuthorizeGoogleUserResult = {
   __typename?: 'AuthorizeGoogleUserResult'
   isAuthorized: Scalars['Boolean']
}

export type AutoApplicationIdGenerationConfig = {
   __typename?: 'AutoApplicationIdGenerationConfig'
   authorityFieldId?: Maybe<Scalars['String']>
   caseTypeFieldId?: Maybe<Scalars['String']>
   circleNoFieldId?: Maybe<Scalars['String']>
   gpCodeFieldId?: Maybe<Scalars['String']>
   headOfficeCodeFieldId?: Maybe<Scalars['String']>
   isEnabled: Scalars['Boolean']
   proposalTypeFieldId?: Maybe<Scalars['String']>
   templateAndProjectTypeFieldId?: Maybe<Scalars['String']>
   templateCounterPrefixFieldId?: Maybe<Scalars['String']>
   udaCodeFieldId?: Maybe<Scalars['String']>
   ulbCodeFieldId?: Maybe<Scalars['String']>
   zonalCodeFieldId?: Maybe<Scalars['String']>
}

export enum AutomationWorkFlowExecLogStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   PartiallyFailed = 'PARTIALLY_FAILED',
   Processing = 'PROCESSING'
}

export enum AutomationWorkFlowStatus {
   Active = 'ACTIVE',
   Inactive = 'INACTIVE',
   Paused = 'PAUSED'
}

export type AutomationWorkflow = {
   __typename?: 'AutomationWorkflow'
   automationWorkflowId: Scalars['String']
   createdAt: Scalars['String']
   execType?: Maybe<AutomationWorkflowExecType>
   isWorkflowPublished: Scalars['Boolean']
   name: Scalars['String']
   nodeActions: Array<NodeActionsConfig>
   nodes: Array<Node>
   pipelineDetails: PipelineOverviewDetails
   pipelineId: Scalars['String']
   status: AutomationWorkFlowStatus
   trigger: Trigger
   workflowState: AutomationWorkflowStateEnum
}

export type AutomationWorkflowCondition = {
   __typename?: 'AutomationWorkflowCondition'
   conditionId: Scalars['String']
   fieldId: Scalars['String']
   fieldSource: FilterFieldSourceType
   multiValues: Array<AutomationWorkflowConditionValue>
   operator: AutomationWorkflowOperator
   upRefAssigneeFieldId?: Maybe<Scalars['String']>
   value?: Maybe<AutomationWorkflowConditionValue>
}

export type AutomationWorkflowConditionValue = {
   __typename?: 'AutomationWorkflowConditionValue'
   upRefAssigneeFieldId?: Maybe<Scalars['String']>
   value: AutomationWorkflowConditionValueResult
   valueSource: FilterConditionValueSourceType
}

export type AutomationWorkflowConditionValueParams = {
   upRefAssigneeFieldId?: InputMaybe<Scalars['String']>
   value: Scalars['String']
   valueSource: FilterConditionValueSourceType
}

export type AutomationWorkflowConditionValueResult =
   | AutomationWorkflowDateFilterReferenceRelativeConfig
   | AutomationWorkflowDateFilterRelativeConfig
   | AutomationWorkflowDateRangeFilterReferenceRelativeConfig
   | AutomationWorkflowDateRangeFilterRelativeConfig
   | AutomationWorkflowDateTimeFilterReferenceRelativeConfig
   | AutomationWorkflowDateTimeFilterRelativeConfig
   | AutomationWorkflowDateTimeRangeFilterReferenceRelativeConfig
   | BaseUser
   | DateRange
   | DateTimeRange
   | FloatRange
   | GqlBooleanType
   | GqlDateTimeType
   | GqlDateType
   | GqlFloatType
   | GqlIntType
   | GqlStringType
   | GqlTaskStatusObj
   | GqlTimeType
   | IntegerRange
   | PhoneNumberResponse
   | Stage
   | TimeRange

export type AutomationWorkflowConfig = {
   __typename?: 'AutomationWorkflowConfig'
   eventBasedWorkflowConfig: EventBasedAutomationWorkflowConfig
   scheduledWorkflowConfig: ScheduledAutomationWorkflowConfig
}

export type AutomationWorkflowDateFilterReferenceRelativeConfig = BaseAutomationWorkflowDateRelativeFilterConfig & {
   __typename?: 'AutomationWorkflowDateFilterReferenceRelativeConfig'
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   referenceField: AutomationWorkflowReferenceFilterField
   relativeFrom: AutomationWorkflowRelativeFromEnum
}

export type AutomationWorkflowDateFilterRelativeConfig = BaseAutomationWorkflowDateRelativeFilterConfig & {
   __typename?: 'AutomationWorkflowDateFilterRelativeConfig'
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   relativeFrom: AutomationWorkflowRelativeFromEnum
}

export type AutomationWorkflowDateRangeFilterReferenceRelativeConfig = {
   __typename?: 'AutomationWorkflowDateRangeFilterReferenceRelativeConfig'
   fromField: AutomationWorkflowDateFilterReferenceRelativeConfig
   relativeFrom: AutomationWorkflowRelativeFromEnum
   toField: AutomationWorkflowDateFilterReferenceRelativeConfig
}

export type AutomationWorkflowDateRangeFilterRelativeConfig = {
   __typename?: 'AutomationWorkflowDateRangeFilterRelativeConfig'
   relativeDateRange: AutomationWorkflowRelativeDateRangeEnum
   relativeFrom: AutomationWorkflowRelativeFromEnum
}

export type AutomationWorkflowDateTimeFilterReferenceRelativeConfig = BaseAutomationWorkflowDateTimeRelativeFilterConfig & {
   __typename?: 'AutomationWorkflowDateTimeFilterReferenceRelativeConfig'
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   minutesCount: Scalars['Int']
   referenceField: AutomationWorkflowReferenceFilterField
   relativeFrom: AutomationWorkflowRelativeFromEnum
}

export type AutomationWorkflowDateTimeFilterRelativeConfig = BaseAutomationWorkflowDateTimeRelativeFilterConfig & {
   __typename?: 'AutomationWorkflowDateTimeFilterRelativeConfig'
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   minutesCount: Scalars['Int']
   relativeFrom: AutomationWorkflowRelativeFromEnum
   relativeTime?: Maybe<Scalars['String']>
}

export type AutomationWorkflowDateTimeRangeFilterReferenceRelativeConfig = {
   __typename?: 'AutomationWorkflowDateTimeRangeFilterReferenceRelativeConfig'
   fromField: AutomationWorkflowDateTimeFilterReferenceRelativeConfig
   relativeFrom: AutomationWorkflowRelativeFromEnum
   toField: AutomationWorkflowDateTimeFilterReferenceRelativeConfig
}

export type AutomationWorkflowExecConfig = {
   __typename?: 'AutomationWorkflowExecConfig'
   automationWorkflowId: Scalars['String']
   createdAt: Scalars['String']
   execConfigId: Scalars['String']
   execType?: Maybe<AutomationWorkflowExecType>
   name: Scalars['String']
   nodes: Array<Node>
   pipelineId: Scalars['String']
   trigger: Trigger
}

export type AutomationWorkflowExecConfigNotFound = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowExecConfigNotFound'
   automationWorkflowExecConfigId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AutomationWorkflowExecConfigPipelineAccessDenied = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowExecConfigPipelineAccessDenied'
   automationWorkflowExecConfigId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AutomationWorkflowExecConfigResult =
   | AutomationWorkflowExecConfig
   | AutomationWorkflowExecConfigNotFound
   | AutomationWorkflowExecConfigPipelineAccessDenied
   | UserIsNotAnAdministrator

export type AutomationWorkflowExecLog = {
   __typename?: 'AutomationWorkflowExecLog'
   assigneesProperties: Array<AwLogAssigneeProperties>
   automationWorkflowExecConfigId: Scalars['String']
   automationWorkflowExecLogId: Scalars['String']
   automationWorkflowId: Scalars['String']
   automationWorkflowName: Scalars['String']
   executedAt: Scalars['String']
   latestLeadFields: Array<FieldIdResponse>
   nodeExecLogs: Array<NodeExecLog>
   payload: Array<FieldIdResponse>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemName?: Maybe<Scalars['String']>
   status: AutomationWorkFlowExecLogStatus
}

export type AutomationWorkflowExecLogNotFound = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowExecLogNotFound'
   automationWorkflowExecLogId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AutomationWorkflowExecLogResult =
   | AutomationWorkflowExecConfigPipelineAccessDenied
   | AutomationWorkflowExecLog
   | AutomationWorkflowExecLogNotFound
   | UserIsNotAnAdministrator

export type AutomationWorkflowExecLogsExecutedAtRangeFilter = {
   __typename?: 'AutomationWorkflowExecLogsExecutedAtRangeFilter'
   endDatetime?: Maybe<Scalars['String']>
   startDatetime?: Maybe<Scalars['String']>
}

export type AutomationWorkflowExecLogsExecutedAtRangeFilterParams = {
   endDatetime?: InputMaybe<Scalars['String']>
   startDatetime?: InputMaybe<Scalars['String']>
}

export type AutomationWorkflowExecLogsFilter = {
   __typename?: 'AutomationWorkflowExecLogsFilter'
   automationWorkflows: Array<BaseAutomationWorkflow>
   entityLevel: AwLogsEntityLevel
   execLogsTab?: Maybe<AutomationWorkflowExecLogsTab>
   executedAtRange?: Maybe<AutomationWorkflowExecLogsExecutedAtRangeFilter>
   filterByPipelineIds: Array<Scalars['String']>
   pipelineId?: Maybe<Scalars['String']>
   /** @deprecated use filter_by_pipeline_ids */
   pipelineIds: Array<Scalars['String']>
   pipelineItemId?: Maybe<Scalars['String']>
   scheduledAwExecLogId?: Maybe<Scalars['String']>
   statuses?: Maybe<Array<WorkFlowExecLogFilterStatus>>
}

export enum AutomationWorkflowExecLogsTab {
   CompletedLogs = 'COMPLETED_LOGS',
   FailedLogs = 'FAILED_LOGS',
   InProgressLogs = 'IN_PROGRESS_LOGS'
}

export type AutomationWorkflowExecLogsTabCustomization = {
   __typename?: 'AutomationWorkflowExecLogsTabCustomization'
   execLogsTab: AutomationWorkflowExecLogsTab
   filter?: Maybe<AutomationWorkflowExecLogsFilter>
   sortValue: SortValue
}

export enum AutomationWorkflowExecType {
   Background = 'BACKGROUND',
   Foreground = 'FOREGROUND'
}

export type AutomationWorkflowExecTypeAlreadyConfiguredInTrigger = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowExecTypeAlreadyConfiguredInTrigger'
   entity: TriggerEntity
   entityTemplateId: Scalars['String']
   execType: AutomationWorkflowExecType
   message?: Maybe<Scalars['String']>
   triggerEventType: TriggerEventType
}

export type AutomationWorkflowExecTypeNotSupportedInTrigger = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowExecTypeNotSupportedInTrigger'
   entity: TriggerEntity
   execType: AutomationWorkflowExecType
   message?: Maybe<Scalars['String']>
   triggerEventType: TriggerEventType
}

export type AutomationWorkflowFieldValueMapping = {
   __typename?: 'AutomationWorkflowFieldValueMapping'
   addAnotherSelectionStrategy?: Maybe<AddAnotherFieldSelectionStrategy>
   phoneNumberValueFormat?: Maybe<PhoneNumberValueFormatEnum>
   upRefAssigneeFieldId?: Maybe<Scalars['String']>
   upRefAssigneeValueFrom?: Maybe<FieldSourceType>
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type AutomationWorkflowFieldValueMappingParams = {
   addAnotherSelectionStrategy?: InputMaybe<AddAnotherFieldSelectionStrategy>
   phoneNumberValueFormat?: InputMaybe<PhoneNumberValueFormatEnum>
   upRefAssigneeFieldId?: InputMaybe<Scalars['String']>
   upRefAssigneeValueFrom?: InputMaybe<FieldSourceType>
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type AutomationWorkflowFilter = {
   __typename?: 'AutomationWorkflowFilter'
   conditions: Array<AutomationWorkflowCondition>
   conditionsLogicalOperator: LogicalOperator
   filterId: Scalars['String']
   name: Scalars['String']
}

export enum AutomationWorkflowFilterSetEntityType {
   ConditionNode = 'CONDITION_NODE',
   UpdatePipelineItemAssigneeNode = 'UPDATE_PIPELINE_ITEM_ASSIGNEE_NODE',
   UpdateRelatedRecordsNode = 'UPDATE_RELATED_RECORDS_NODE'
}

export type AutomationWorkflowFilterSetNotFound = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowFilterSetNotFound'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AutomationWorkflowFiltersResult = {
   __typename?: 'AutomationWorkflowFiltersResult'
   filters: Array<AutomationWorkflowFilter>
   filtersLogicalOperator: LogicalOperator
}

export type AutomationWorkflowIsInProgress = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowIsInProgress'
   automationWorkflowId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AutomationWorkflowIsNotInActiveState = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowIsNotInActiveState'
   automationWorkflowId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AutomationWorkflowNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type AutomationWorkflowNodeActions = {
   __typename?: 'AutomationWorkflowNodeActions'
   automationWorkflowId: Scalars['String']
   nodeActions: Array<NodeActionsConfig>
}

export type AutomationWorkflowNodeActionsParams = {
   automationWorkflowId: Scalars['String']
}

export type AutomationWorkflowNodeActionsResponse =
   | AutomationWorkflowNodeActions
   | AutomationWorkflowNotFound
   | NodeActionsConfigNotSupportedInAutomationWorkflow
   | UserIsNotAnAdministrator

export type AutomationWorkflowNodesAreNotEditable = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowNodesAreNotEditable'
   message?: Maybe<Scalars['String']>
   nodeIds: Array<Scalars['String']>
}

export type AutomationWorkflowNotFound = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowNotFound'
   automationWorkflowId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum AutomationWorkflowOperator {
   Contains = 'CONTAINS',
   Empty = 'EMPTY',
   Eq = 'EQ',
   Gt = 'GT',
   Gte = 'GTE',
   In = 'IN',
   InTheLast = 'IN_THE_LAST',
   InTheNext = 'IN_THE_NEXT',
   Is = 'IS',
   IsAfter = 'IS_AFTER',
   IsBefore = 'IS_BEFORE',
   IsChanged = 'IS_CHANGED',
   IsIn = 'IS_IN',
   Lt = 'LT',
   Lte = 'LTE',
   Ne = 'NE',
   NotEmpty = 'NOT_EMPTY',
   NotIn = 'NOT_IN',
   Range = 'RANGE'
}

export type AutomationWorkflowParams = {
   automationWorkflowId: Scalars['String']
   workflowState: AutomationWorkflowStateEnum
}

export type AutomationWorkflowPipelineItemNotification = {
   __typename?: 'AutomationWorkflowPipelineItemNotification'
   message?: Maybe<Scalars['String']>
   notificationId: Scalars['String']
   notificationType: NotificationTypes
   pipelineItemDetails: NotificationPipelineItemDetails
   readAt?: Maybe<Scalars['String']>
   sentAt: Scalars['String']
   title: Scalars['String']
}

export type AutomationWorkflowPublishedVersionNotExists = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowPublishedVersionNotExists'
   automationWorkflowId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type AutomationWorkflowReferenceFilterField = {
   __typename?: 'AutomationWorkflowReferenceFilterField'
   fieldId: Scalars['String']
   fieldSource: FilterFieldSourceType
}

export enum AutomationWorkflowRelativeDateRangeEnum {
   LastMonth = 'LAST_MONTH',
   LastWeek = 'LAST_WEEK',
   NextMonth = 'NEXT_MONTH',
   NextWeek = 'NEXT_WEEK',
   ThisMonth = 'THIS_MONTH',
   ThisWeek = 'THIS_WEEK'
}

export enum AutomationWorkflowRelativeFromEnum {
   FieldReference = 'FIELD_REFERENCE',
   Now = 'NOW',
   Today = 'TODAY',
   Tomorrow = 'TOMORROW',
   Yesterday = 'YESTERDAY'
}

export type AutomationWorkflowResult =
   | AutomationWorkflow
   | AutomationWorkflowNotFound
   | AutomationWorkflowStateNotFound
   | PipelineAccessDenied
   | UserIsNotAnAdministrator

export enum AutomationWorkflowStateEnum {
   Editable = 'EDITABLE',
   Published = 'PUBLISHED'
}

export type AutomationWorkflowStateNotFound = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowStateNotFound'
   automationWorkflowId: Scalars['String']
   message?: Maybe<Scalars['String']>
   state: AutomationWorkflowStateEnum
}

export type AutomationWorkflowTriggerConfig =
   | PipelineItemUpdatedTriggerConfig
   | StageUpdatedTriggerConfig
   | TaskUpdatedTriggerConfig

export enum AutomationWorkflowUniqueFieldsSupportedFilterSetEntity {
   UpdatePipelineItemAssigneeNode = 'UPDATE_PIPELINE_ITEM_ASSIGNEE_NODE'
}

export type AutomationWorkflowsAccessDenied = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowsAccessDenied'
   automationWorkflowIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AutomationWorkflowsAreNotInPipeline = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowsAreNotInPipeline'
   automationWorkflowIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type AutomationWorkflowsAreNotInSync = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowsAreNotInSync'
   automationWorkflowIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type AutomationWorkflowsNotFound = GraphQlBaseError & {
   __typename?: 'AutomationWorkflowsNotFound'
   automationWorkflowIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export enum AvailTdrEnum {
   No = 'NO',
   Yes = 'YES'
}

export enum AwComputationOperator {
   Addition = 'ADDITION',
   Subtraction = 'SUBTRACTION'
}

export type AwComputedValueConfig =
   | AwDateComputedValueConfig
   | AwDateTimeComputedValueConfig
   | AwTimeComputedValueConfig

export type AwCustomVariableFieldMapping = {
   __typename?: 'AwCustomVariableFieldMapping'
   phoneNumberValueFormat?: Maybe<PhoneNumberValueFormatEnum>
   value: Scalars['String']
   valueFrom: FieldSourceType
   variable: Scalars['String']
}

export type AwCustomVariableFieldMappingParams = {
   phoneNumberValueFormat?: InputMaybe<PhoneNumberValueFormatEnum>
   value: Scalars['String']
   valueFrom: FieldSourceType
   variable: Scalars['String']
}

export type AwDateComputedValueConfig = {
   __typename?: 'AwDateComputedValueConfig'
   days: Scalars['Int']
   operator: AwComputationOperator
}

export type AwDateTimeComputedValueConfig = {
   __typename?: 'AwDateTimeComputedValueConfig'
   days: Scalars['Int']
   hours: Scalars['Int']
   minutes: Scalars['Int']
   operator: AwComputationOperator
}

export enum AwDateTimeRelativeOperator {
   Now = 'NOW',
   Today = 'TODAY'
}

export type AwDocumentSignFieldMapping = {
   __typename?: 'AwDocumentSignFieldMapping'
   assignee?: Maybe<BaseUser>
   assigneeFieldId?: Maybe<Scalars['String']>
   assigneeId?: Maybe<Scalars['String']>
   formField: Scalars['String']
}

export type AwDocumentSignFieldMappingParams = {
   assigneeFieldId?: InputMaybe<Scalars['String']>
   assigneeId?: InputMaybe<Scalars['String']>
   formField: Scalars['String']
}

export type AwFileUploaderFieldMappingResult = {
   __typename?: 'AwFileUploaderFieldMappingResult'
   failureReason?: Maybe<Scalars['String']>
   status: GenerateDocumentStatus
}

export type AwLogAssigneeProperties = {
   __typename?: 'AwLogAssigneeProperties'
   assignee: BaseUser
   assigneeFieldId: Scalars['String']
   properties: Array<FieldIdResponse>
}

export enum AwLogsEntityLevel {
   Account = 'ACCOUNT',
   Pipeline = 'PIPELINE'
}

export type AwRelativeValueConfig = {
   __typename?: 'AwRelativeValueConfig'
   relativeValue: AwDateTimeRelativeOperator
}

export type AwStageUpdatedTransition = {
   __typename?: 'AwStageUpdatedTransition'
   fromStageId: Scalars['String']
   toStageId: Scalars['String']
}

export type AwStageUpdatedTransitionParams = {
   fromStageId: Scalars['String']
   toStageId: Scalars['String']
}

export type AwTimeComputedValueConfig = {
   __typename?: 'AwTimeComputedValueConfig'
   hours: Scalars['Int']
   minutes: Scalars['Int']
   operator: AwComputationOperator
}

export type AwVariablesNotDefined = GraphQlBaseError & {
   __typename?: 'AwVariablesNotDefined'
   message?: Maybe<Scalars['String']>
   variables: Array<Scalars['String']>
}

export enum BpsConfigFieldEnum {
   ArchitectName = 'ARCHITECT_NAME',
   CitizenName = 'CITIZEN_NAME',
   MultipleOwnerNames = 'MULTIPLE_OWNER_NAMES',
   OwnerName = 'OWNER_NAME'
}

export type BarGraph = {
   __typename?: 'BarGraph'
   averageDisplayValue: Scalars['String']
   averageValue: Scalars['String']
   data: Array<BarGraphData>
   graphId: Scalars['String']
   totalValue: Scalars['String']
   xAxisName: Scalars['String']
   yAxisName: Scalars['String']
}

export type BarGraphConfig = {
   __typename?: 'BarGraphConfig'
   analyticsLevel: AnalyticsLevel
   dataLabelsType: GraphDataLabelsType
   dataSources: Array<AnalyticsDataSourceType>
   dataSourcesWithDisplayNames: Array<DataSourceDisplayName>
   description?: Maybe<Scalars['String']>
   dimension: GraphDimension
   filterSetId: Scalars['String']
   graphId: Scalars['String']
   isOwner: Scalars['Boolean']
   layout: BarGraphLayout
   metric: GraphMetric
   name: Scalars['String']
   numberOfBars: Scalars['Int']
   pipelineId: Scalars['String']
   quickFilterFields: Array<GraphQuickFilterField>
   roles: Array<Role>
}

export type BarGraphData = {
   __typename?: 'BarGraphData'
   displayValue: Scalars['String']
   percentage: Scalars['String']
   xAxisValue: GraphDimensionValue
   yAxisValue: Scalars['String']
}

export enum BarGraphLayout {
   Horizontal = 'HORIZONTAL',
   Vertical = 'VERTICAL'
}

export type BarGraphResult =
   | BarGraph
   | DashboardAccessDenied
   | DashboardNotFound
   | GraphAccessDenied
   | GraphMetricNotFound
   | GraphNotFound
   | InvalidLimit
   | InvalidOffset
   | NotSupportedGraphParenType
   | ViewAccessDenied
   | ViewNotFound

export type BaseActivityTemplate = {
   __typename?: 'BaseActivityTemplate'
   activityTemplateId: Scalars['String']
   createdAt: Scalars['String']
   description?: Maybe<Scalars['String']>
   name: Scalars['String']
   pipelineConfigs: Array<ActivityTemplatePipelineConfig>
   /** @deprecated Support SRMP */
   pipelineId?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
}

export type BaseApplicationManagementLog = {
   actionType: Scalars['String']
   applicationNo: Scalars['String']
   attachments: Array<ApplicationManagementAttachment>
   createdAt: Scalars['String']
   doneBy: BaseUser
   id: Scalars['String']
   pipelineItemId: Scalars['String']
   remarks: Scalars['String']
}

export type BaseAutomationWorkflow = {
   __typename?: 'BaseAutomationWorkflow'
   automationWorkflowId: Scalars['String']
   name: Scalars['String']
   pipelineDetails: PipelineOverviewDetails
   pipelineId: Scalars['String']
}

export type BaseAutomationWorkflowDateRelativeFilterConfig = {
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   relativeFrom: AutomationWorkflowRelativeFromEnum
}

export type BaseAutomationWorkflowDateTimeRelativeFilterConfig = {
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   minutesCount: Scalars['Int']
   relativeFrom: AutomationWorkflowRelativeFromEnum
}

export type BaseCard = {
   cardType: TabCardType
}

export type BaseDataLoadingRequest = {
   actionType: DataLoadingActionType
   cloudCallingServiceAccountId?: Maybe<Scalars['String']>
   completedAt?: Maybe<Scalars['String']>
   creationConfig?: Maybe<LeadsOrContactsCreationConfig>
   dataLoadingRequestId: Scalars['String']
   dataSourceType: DataSourceType
   entityId?: Maybe<Scalars['String']>
   failureReason?: Maybe<Scalars['String']>
   leadAssigneeFieldReferenceIdsToNotify: Array<Scalars['String']>
   noOfRecords: Scalars['Int']
   noOfRecordsProcessed: Scalars['Int']
   operationType?: Maybe<DataLoadingOperationType>
   pipelineId?: Maybe<Scalars['String']>
   preSignedRemarksS3Url?: Maybe<Scalars['String']>
   requestedAt: Scalars['String']
   shouldResetEmptyValues?: Maybe<Scalars['Boolean']>
   skipAutomationWorkflows: Scalars['Boolean']
   status: DataLoadingReqStatus
   updationConfig?: Maybe<LeadsOrContactsUpdationConfig>
}

export type BaseDocumentTemplateBlock = {
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   order: Scalars['Int']
}

export type BaseEventTriggerDateRelativeFilterConfig = {
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   relativeFrom: EventTriggerRelativeFromEnum
}

export type BaseEventTriggerDateTimeRelativeFilterConfig = {
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   minutesCount: Scalars['Int']
   relativeFrom: EventTriggerRelativeFromEnum
}

export type BaseField = {
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type BaseFieldResponse = {
   field: FieldPrimaryDetails
   fieldId: Scalars['String']
   response?: Maybe<FieldResponseType>
   systemFieldEnum?: Maybe<SystemFieldEnum>
}

export type BaseIdentification = {
   actions: Array<UserPermission>
   identificationId: Scalars['String']
   identificationType: IdentificationType
   name: Scalars['String']
   profilePicUrl?: Maybe<Scalars['String']>
}

export type BaseLeadDistributionRuleSettings = {
   assignBasedOnAvailability: Scalars['Boolean']
   assigneeFieldIdsToNotify: Array<Scalars['String']>
   configStatus: LeadDistributionEntityConfigStatus
   distributionType: LeadDistributionRuleType
   leadDistributionRuleId: Scalars['String']
   managerFields: Array<LeadDistributionRuleManagerField>
   syncAssigneeHierarchy: Scalars['Boolean']
}

export type BaseLtpUserManagementLog = {
   createdDatetime: Scalars['String']
   id: Scalars['String']
   licenseNumber: Scalars['String']
   logType: Scalars['String']
   name?: Maybe<Scalars['String']>
   reason?: Maybe<Scalars['String']>
   updatedBy?: Maybe<BaseUser>
   userId: Scalars['String']
}

export type BaseNode = {
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
}

export type BaseNodeExecLog = {
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   status: NodeExecLogStatusEnum
}

export type BaseOfficerManagementRequest = {
   accountId: Scalars['String']
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   id: Scalars['String']
   initiatedBy: Scalars['String']
   initiatedUser: User
   operationType: OfficerManagementOperationType
   reason?: Maybe<Scalars['String']>
   status: OfficerManagementStatusType
   updatedAt: Scalars['String']
}

export type BasePipeline = {
   __typename?: 'BasePipeline'
   color?: Maybe<Scalars['String']>
   displayName: Scalars['String']
   isActivitiesFeatureEnabled: Scalars['Boolean']
   isAdvancedAnalyticsEnabled: Scalars['Boolean']
   isMainPipeline: Scalars['Boolean']
   isTasksFeatureEnabled: Scalars['Boolean']
   isWhatsappConsentRequired: Scalars['Boolean']
   name: Scalars['String']
   pipelineIconId?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemTemplateConfig: PipelineItemTemplateConfig
   pipelineItemTemplateId: Scalars['String']
   pipelineItemType: PipelineItemType
   pipelineType: PipelineTypeEnum
   stageTransitionStyle: PipelineStageTransitionUiStyle
}

export type BasePipelineItem = {
   createdAt: Scalars['String']
   latestRemarks?: Maybe<PipelineItemRemarks>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   task?: Maybe<Task>
}

export type BasePipelineItemHistory = {
   data?: Maybe<PipelineItemHistoryData>
   eventDatetime: Scalars['String']
   pipelineItemHistoryEventType: PipelineItemHistoryEventType
   pipelineItemId: Scalars['String']
}

export type BasePipelineItemPrimaryDetails = {
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   stage: PipelineItemPrimaryFieldResult
}

export type BasePipelineItemProperties = {
   createdAt: Scalars['String']
   fields: Array<FieldResponseResult>
   latestRemarks?: Maybe<PipelineItemRemarks>
   pipelineItemId: Scalars['String']
   pipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemSchedule?: Maybe<PipelineItemSchedule>
   pipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   scheduledPipelineItem?: Maybe<ScheduledPipelineItem>
}

export type BasePipelineItemPropertiesFieldsArgs = {
   fieldIds: Array<Scalars['String']>
}

export type BasePipelineItemSchedule = {
   order: Scalars['Int']
   pipelineItem: PipelineItemPrimaryDetails
   pipelineItemScheduledId: Scalars['String']
   remindBeforeInMins?: Maybe<Scalars['Int']>
   remindersInMins: Array<Scalars['Int']>
   scheduledByUser: BaseUser
   scheduledDateTime: Scalars['String']
   status: PipelineItemScheduledStatus
   title?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type BasePipelineItemTemplate = {
   __typename?: 'BasePipelineItemTemplate'
   name: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   recordType: RecordType
}

export type BasePluginServiceAccount = {
   isActive: Scalars['Boolean']
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
}

export type BaseRecordCreationConfig = {
   autoAssignCreatorToFields: Array<Field>
   creationAllowedStages: Array<Stage>
   fields: Array<Field>
   name: Scalars['String']
   pipelinesAllowedStages: Array<PipelineRecordCreationConfigAllowedStages>
   recordCreationConfigId: Scalars['Int']
   salesTemplateId: Scalars['String']
   salesTemplateType: RecordCreationSupportedSalesTemplateType
   syncAssigneeGroups: Array<AssigneeGroup>
}

export type BaseStage = {
   __typename?: 'BaseStage'
   color?: Maybe<ColorEnum>
   name: Scalars['String']
   stageId: Scalars['String']
}

export type BaseTdrAccount = {
   __typename?: 'BaseTDRAccount'
   accountId: Scalars['String']
   accountNo: Scalars['String']
}

export type BaseTab = {
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type BaseTabInfoDetails = BaseTab & {
   __typename?: 'BaseTabInfoDetails'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type BaseTaskTemplate = {
   __typename?: 'BaseTaskTemplate'
   color: Scalars['String']
   configuredAwExecTypes: Array<AutomationWorkflowExecType>
   description?: Maybe<Scalars['String']>
   foregroundAutomationWorkflow?: Maybe<BaseAutomationWorkflow>
   iconUrl: Scalars['String']
   name: Scalars['String']
   pipelineId: Scalars['String']
   taskTemplateId: Scalars['String']
   taskType: TaskType
   visibilityFieldId?: Maybe<Scalars['String']>
}

export type BaseTrigger = {
   automationWorkflowId: Scalars['String']
   entity: TriggerEntity
   entityTemplateId: Scalars['String']
   name?: Maybe<Scalars['String']>
   rootNodeIds: Array<Scalars['String']>
   triggerId: Scalars['String']
   triggerType: TriggerType
}

export type BaseUser = {
   __typename?: 'BaseUser'
   attendance?: Maybe<BaseUserAttendance>
   circle?: Maybe<Scalars['String']>
   designation?: Maybe<Scalars['String']>
   email?: Maybe<Scalars['String']>
   isActive: Scalars['Boolean']
   name?: Maybe<Scalars['String']>
   phoneNumber?: Maybe<PhoneNumberResponse>
   profilePicUrl?: Maybe<Scalars['String']>
   userId: Scalars['String']
   username?: Maybe<Scalars['String']>
}

export type BaseUserAttendance = {
   __typename?: 'BaseUserAttendance'
   clockIn?: Maybe<Scalars['String']>
}

export type BaseWhatsAppBusinessNumber = {
   __typename?: 'BaseWhatsAppBusinessNumber'
   phoneNumber?: Maybe<PhoneNumberResponse>
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type BaseWhatsAppBusinessNumberWithPluginServiceAccount = {
   __typename?: 'BaseWhatsAppBusinessNumberWithPluginServiceAccount'
   phoneNumber?: Maybe<PhoneNumberResponse>
   pluginServiceAccountId: Scalars['String']
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type BaseWhatsAppMessageTemplate = {
   body?: Maybe<Scalars['String']>
   buttons: Array<WhatsAppMessageButton>
   footer?: Maybe<Scalars['String']>
   header?: Maybe<Scalars['String']>
   mediaInfo?: Maybe<WhatsAppMessageTemplateMediaInfo>
   mediaName?: Maybe<Scalars['String']>
   mediaType?: Maybe<WhatsAppMessageMediaType>
   messageType: WhatsAppMessageType
   name: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type Board = {
   __typename?: 'Board'
   boardEntityType: BoardEntityType
   boardId: Scalars['String']
   boardType: BoardType
   createdBy?: Maybe<BaseUser>
   defaultProperties: Array<Scalars['String']>
   description?: Maybe<Scalars['String']>
   displayName: Scalars['String']
   filterSetId: Scalars['String']
   hasPipelineItemCreationAccess: Scalars['Boolean']
   isOwner: Scalars['Boolean']
   itemsCount?: Maybe<Scalars['Int']>
   lists: Array<BoardList>
   name: Scalars['String']
   order: Scalars['Int']
   parentId: Scalars['String']
   parentType: BoardParentType
   userGroups: Array<UserGroupConfig>
}

export type BoardItemsCountArgs = {
   itemsCountParams?: InputMaybe<ItemsCountInBoardParams>
}

export type BoardAndIdentificationsNotInSameAccount = GraphQlBaseError & {
   __typename?: 'BoardAndIdentificationsNotInSameAccount'
   boardId: Scalars['String']
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type BoardDisplayNameIsRequired = GraphQlBaseError & {
   __typename?: 'BoardDisplayNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type BoardEditAccessDenied = GraphQlBaseError & {
   __typename?: 'BoardEditAccessDenied'
   boardId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type BoardEntityNotFound = GraphQlBaseError & {
   __typename?: 'BoardEntityNotFound'
   entityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum BoardEntityType {
   Activity = 'ACTIVITY',
   Application = 'APPLICATION',
   Contact = 'CONTACT',
   CustomObject = 'CUSTOM_OBJECT',
   Deal = 'DEAL',
   Lead = 'LEAD',
   Task = 'TASK'
}

export type BoardList = {
   __typename?: 'BoardList'
   filterSetId: Scalars['String']
   isOwner: Scalars['Boolean']
   listId: Scalars['String']
   name: Scalars['String']
   order: Scalars['Int']
   userGroups: Array<UserGroupConfig>
}

export type BoardListEditAccessDenied = GraphQlBaseError & {
   __typename?: 'BoardListEditAccessDenied'
   listId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type BoardListNotFound = GraphQlBaseError & {
   __typename?: 'BoardListNotFound'
   listId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type BoardListReadAccessDenied = GraphQlBaseError & {
   __typename?: 'BoardListReadAccessDenied'
   listId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type BoardListUserGroups = {
   __typename?: 'BoardListUserGroups'
   listId: Scalars['String']
   userGroups: Array<UserGroupConfig>
}

export type BoardListUserGroupsResult =
   | BoardListNotFound
   | BoardListReadAccessDenied
   | BoardListUserGroups

export type BoardListsInBoardResponse =
   | BoardListsResult
   | BoardNotFound
   | BoardReadAccessDenied

export type BoardListsResult = {
   __typename?: 'BoardListsResult'
   boardLists: Array<BoardList>
}

export type BoardNotFound = GraphQlBaseError & {
   __typename?: 'BoardNotFound'
   boardId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum BoardParentType {
   Account = 'ACCOUNT',
   Pipeline = 'PIPELINE',
   PipelineItemTemplate = 'PIPELINE_ITEM_TEMPLATE'
}

export type BoardReadAccessDenied = GraphQlBaseError & {
   __typename?: 'BoardReadAccessDenied'
   boardId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type BoardSharedPermissions = {
   __typename?: 'BoardSharedPermissions'
   boardId: Scalars['String']
   sharedEntities: Array<SharableEntity>
}

export enum BoardType {
   AllPipelineItemsBoard = 'ALL_PIPELINE_ITEMS_BOARD',
   CustomBoard = 'CUSTOM_BOARD',
   ScheduledPipelineItemBoard = 'SCHEDULED_PIPELINE_ITEM_BOARD',
   StageBoard = 'STAGE_BOARD'
}

export type BoardUserGroups = {
   __typename?: 'BoardUserGroups'
   boardId: Scalars['String']
   userGroups: Array<UserGroupConfig>
}

export type BoardUserGroupsResult =
   | BoardNotFound
   | BoardReadAccessDenied
   | BoardUserGroups

export type Boards = {
   __typename?: 'Boards'
   boards: Array<Board>
}

export type BoardsResult = Boards | PipelineAccessDenied | PipelineNotFound

export enum BooleanFromSheetsEnum {
   No = 'NO',
   Yes = 'YES'
}

export type BothContactsHaveActivePipelineItems = GraphQlBaseError & {
   __typename?: 'BothContactsHaveActivePipelineItems'
   message?: Maybe<Scalars['String']>
   pipelineIds: Array<Scalars['String']>
}

export type BothFieldsCannotBeSame = GraphQlBaseError & {
   __typename?: 'BothFieldsCannotBeSame'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   parentFieldId: Scalars['String']
}

export type BothNodeAndParentNodeCannotBeSame = GraphQlBaseError & {
   __typename?: 'BothNodeAndParentNodeCannotBeSame'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   parentNodeId: Scalars['String']
}

export type BothPipelineItemPinnedIdsCannotBeSame = GraphQlBaseError & {
   __typename?: 'BothPipelineItemPinnedIdsCannotBeSame'
   message?: Maybe<Scalars['String']>
}

export type BothPipelineItemScheduledIdsCannotBeSame = GraphQlBaseError & {
   __typename?: 'BothPipelineItemScheduledIdsCannotBeSame'
   message?: Maybe<Scalars['String']>
}

export type BothPipelineItemsCannotBeSame = GraphQlBaseError & {
   __typename?: 'BothPipelineItemsCannotBeSame'
   message?: Maybe<Scalars['String']>
}

export type BothStagesShouldBeSameType = GraphQlBaseError & {
   __typename?: 'BothStagesShouldBeSameType'
   message?: Maybe<Scalars['String']>
}

export type BpsTaskFieldObservation = {
   __typename?: 'BpsTaskFieldObservation'
   fieldId: Scalars['String']
   recommendation: BpsVerificationRecommendationEnum
}

export type BpsTaskFieldObservationParams = {
   fieldId: Scalars['String']
   recommendation: BpsVerificationRecommendationEnum
}

export type BpsTaskVerificationData = {
   __typename?: 'BpsTaskVerificationData'
   appealTaskWiseRecommendation: Array<AppealTaskVerificationRecommendation>
   appealTaskWiseRemarks: Array<AppealTaskVerificationRemarks>
   fieldWiseRecommendation: Array<TaskVerificationFieldRecommendation>
   fieldWiseRemarks: Array<TaskVerificationFieldRemarks>
   paymentWiseRecommendation: Array<TaskVerificationPaymentRecommendation>
   paymentWiseRemarks: Array<TaskVerificationPaymentRemarks>
   recommendation?: Maybe<BpsVerificationRecommendationEnum>
   relatedObjectionsData: RelatedObjectionOverallData
   remarks?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type BpsTemplateConfig = {
   __typename?: 'BpsTemplateConfig'
   bpsConfigFieldEnum?: Maybe<BpsConfigFieldEnum>
   fieldId?: Maybe<Scalars['String']>
}

export enum BpsVerificationRecommendationEnum {
   Accepted = 'ACCEPTED',
   Rejected = 'REJECTED',
   Shortfall = 'SHORTFALL'
}

export type BpsVerificationRemarksBlockParams = {
   allowedRemarksSections?: InputMaybe<Array<Scalars['String']>>
   assigneeFieldIds?: InputMaybe<Array<Scalars['String']>>
   recommendationEnums?: InputMaybe<Array<BpsVerificationRecommendationEnum>>
   tableHeading: Scalars['String']
   taskTemplateId: Scalars['String']
}

export enum BpsVerificationTaskFieldProperty {
   OverallRecommendation = 'OVERALL_RECOMMENDATION',
   OverallRemarks = 'OVERALL_REMARKS'
}

export type BuildingAreaCannotBeNegative = GraphQlBaseError & {
   __typename?: 'BuildingAreaCannotBeNegative'
   area: Scalars['Float']
   message?: Maybe<Scalars['String']>
}

export type BuildingHeightCannotBeNegative = GraphQlBaseError & {
   __typename?: 'BuildingHeightCannotBeNegative'
   height: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type BulkSurveyNumberGoFFieldResponse = {
   __typename?: 'BulkSurveyNumberGoFFieldResponse'
   fieldResponse: FieldResponse
   gofResponseId: Scalars['String']
   surveyNumberRemarks?: Maybe<SurveyNumberRemarkEnum>
}

export type BulkSurveyNumberGoFFieldResponseParams = {
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type CaRegistrationNumberExpired = GraphQlBaseError & {
   __typename?: 'CARegistrationNumberExpired'
   message?: Maybe<Scalars['String']>
}

export type CaRegistrationNumberIsRequired = GraphQlBaseError & {
   __typename?: 'CARegistrationNumberIsRequired'
   message?: Maybe<Scalars['String']>
}

export type CaRegistrationNumberValidityIsRequired = GraphQlBaseError & {
   __typename?: 'CARegistrationNumberValidityIsRequired'
   message?: Maybe<Scalars['String']>
}

export type CliNumberFormatIsNotValid = GraphQlBaseError & {
   __typename?: 'CLINumberFormatIsNotValid'
   message?: Maybe<Scalars['String']>
}

export type CsvDataLoadingRequest = BaseDataLoadingRequest & {
   __typename?: 'CSVDataLoadingRequest'
   actionType: DataLoadingActionType
   cloudCallingServiceAccountId?: Maybe<Scalars['String']>
   completedAt?: Maybe<Scalars['String']>
   creationConfig?: Maybe<LeadsOrContactsCreationConfig>
   dataFile: FileUploaderUrlResponse
   dataLoadingRequestId: Scalars['String']
   dataSourceType: DataSourceType
   entityId?: Maybe<Scalars['String']>
   failureReason?: Maybe<Scalars['String']>
   leadAssigneeFieldReferenceIdsToNotify: Array<Scalars['String']>
   noOfRecords: Scalars['Int']
   noOfRecordsProcessed: Scalars['Int']
   operationType?: Maybe<DataLoadingOperationType>
   pipelineId?: Maybe<Scalars['String']>
   preSignedRemarksS3Url?: Maybe<Scalars['String']>
   requestedAt: Scalars['String']
   shouldResetEmptyValues?: Maybe<Scalars['Boolean']>
   skipAutomationWorkflows: Scalars['Boolean']
   status: DataLoadingReqStatus
   updationConfig?: Maybe<LeadsOrContactsUpdationConfig>
}

export type CalculatedTdrAreaIsLessThanScrutinyTdrArea = GraphQlBaseError & {
   __typename?: 'CalculatedTDRAreaIsLessThanScrutinyTDRArea'
   calculatedTdrArea: Scalars['Float']
   message?: Maybe<Scalars['String']>
   scrutinyTdrArea: Scalars['Float']
}

export type CalendarEventDoesNotExistForSchedule = GraphQlBaseError & {
   __typename?: 'CalendarEventDoesNotExistForSchedule'
   message?: Maybe<Scalars['String']>
   pipelineItemScheduleId: Scalars['String']
}

export type CalendarEventDurationCannotBeNegative = GraphQlBaseError & {
   __typename?: 'CalendarEventDurationCannotBeNegative'
   durationInMins: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type CalendarEventsDateTimeRangeParams = {
   fromDatetime: Scalars['String']
   toDatetime: Scalars['String']
}

export type CalendarPipelineItemSchedule = BasePipelineItemSchedule & {
   __typename?: 'CalendarPipelineItemSchedule'
   durationInMins: Scalars['Int']
   googleCalendarEventId?: Maybe<Scalars['String']>
   googleMeetLink?: Maybe<Scalars['String']>
   guestEmailFieldIds: Array<Scalars['String']>
   guestEmailIds: Array<Scalars['String']>
   order: Scalars['Int']
   pipelineItem: PipelineItemPrimaryDetails
   pipelineItemScheduledId: Scalars['String']
   remindBeforeInMins?: Maybe<Scalars['Int']>
   remindersInMins: Array<Scalars['Int']>
   scheduledByUser: BaseUser
   scheduledDateTime: Scalars['String']
   status: PipelineItemScheduledStatus
   title?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type CallLog = {
   __typename?: 'CallLog'
   agent: BaseUser
   callCategory?: Maybe<CallStatus>
   callDuration?: Maybe<Scalars['Int']>
   callDurationInSeconds?: Maybe<Scalars['Int']>
   callEventStatus: CloudCallingEventStatus
   callLogId: Scalars['String']
   callRecordingUrl?: Maybe<Scalars['String']>
   callStartDatetime?: Maybe<Scalars['String']>
   callStatus: CloudCallingEventStatus
   callType: CallType
   customerNumber: PhoneNumberResponse
   customerNumberFieldIds: Array<Scalars['String']>
   isPermittedPipelineItem: Scalars['Boolean']
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemName?: Maybe<Scalars['String']>
}

export type CallLogIdsAndTaskAreLinkedToDifferentPipelineItem = GraphQlBaseError & {
   __typename?: 'CallLogIdsAndTaskAreLinkedToDifferentPipelineItem'
   callLogIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export enum CallLogStatus {
   Failed = 'FAILED',
   Success = 'SUCCESS'
}

export type CallLogsAlreadyLinkedToAnotherCompletedTask = GraphQlBaseError & {
   __typename?: 'CallLogsAlreadyLinkedToAnotherCompletedTask'
   callLogIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CallLogsCallStartDatetimeRangeParams = {
   endDatetime?: InputMaybe<Scalars['String']>
   startDatetime?: InputMaybe<Scalars['String']>
}

export type CallLogsTab = BaseTab & {
   __typename?: 'CallLogsTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export enum CallStatus {
   IncomingAnswered = 'INCOMING_ANSWERED',
   IncomingMissed = 'INCOMING_MISSED',
   OutgoingAnswered = 'OUTGOING_ANSWERED',
   OutgoingNotAnswered = 'OUTGOING_NOT_ANSWERED'
}

export type CallStatusFieldIsRequired = GraphQlBaseError & {
   __typename?: 'CallStatusFieldIsRequired'
   message?: Maybe<Scalars['String']>
}

export enum CallStatusFieldOptions {
   CallBack = 'CALL_BACK',
   CallBusy = 'CALL_BUSY',
   CallDone = 'CALL_DONE',
   CallRejected = 'CALL_REJECTED',
   NotAnswered = 'NOT_ANSWERED',
   NotReachable = 'NOT_REACHABLE',
   SwitchOff = 'SWITCH_OFF',
   WrongNumber = 'WRONG_NUMBER'
}

export enum CallType {
   Inbound = 'INBOUND',
   Outbound = 'OUTBOUND'
}

export type CallWebhookNode = BaseNode & {
   __typename?: 'CallWebhookNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   contentType?: Maybe<ApiRequestContentTypeEnum>
   endPoint?: Maybe<Scalars['String']>
   headers: Array<Header>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   payload: Array<CustomKeyFieldValueMapping>
}

export type CallWebhookNodeExecLog = BaseNodeExecLog & {
   __typename?: 'CallWebhookNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<CallWebhookNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type CallWebhookNodeExecLogResult = {
   __typename?: 'CallWebhookNodeExecLogResult'
   responseJson: Scalars['String']
   statusCode: Scalars['Int']
}

export enum CallingEntityType {
   Activity = 'ACTIVITY',
   Contact = 'CONTACT',
   PipelineItem = 'PIPELINE_ITEM',
   Task = 'TASK'
}

export type CallingPermissions = {
   __typename?: 'CallingPermissions'
   allowDirectCallingForFailedCloudCalling?: Maybe<FailedCallType>
   allowedCallingType: OutBoundCallType
}

export type CallingPermissionsResult = CallingPermissions | NoCallingPermission

export type CanNotRemoveDefaultValue = GraphQlBaseError & {
   __typename?: 'CanNotRemoveDefaultValue'
   defaultValue: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CanNotRemoveDefaultValues = GraphQlBaseError & {
   __typename?: 'CanNotRemoveDefaultValues'
   defaultValues: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CanNotUpdateCompletedTask = GraphQlBaseError & {
   __typename?: 'CanNotUpdateCompletedTask'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type CancelTdrOrderInPortalParams = {
   portalId: Scalars['String']
   portalType: PortalType
   tdrOrderId: Scalars['String']
}

export type CancelTdrOrderInPortalResponse =
   | ApplicationAccessDenied
   | CancelTdrOrderInPortalResult
   | PortalNotFound
   | TdrOrderIsNotInYetToPayStatus
   | TdrOrderNotFound
   | TdrPaymentsNotInInitiatedState

export type CancelTdrOrderInPortalResult = {
   __typename?: 'CancelTDROrderInPortalResult'
   tdrOrderId: Scalars['String']
}

export type CancelTdrPaymentInPortalParams = {
   portalId: Scalars['String']
   portalType: PortalType
   tdrRequestId: Scalars['String']
}

export type CancelTdrPaymentInPortalResponse =
   | CancelTdrPaymentInPortalResult
   | NotAllowedActionOnTdrRequests
   | PortalNotFound
   | TdrPaymentIsNotInitiated
   | TdrRequestIsNotTdrPayment
   | TdrRequestNotFound
   | TdrRequestsNotFound

export type CancelTdrPaymentInPortalResult = {
   __typename?: 'CancelTDRPaymentInPortalResult'
   tdrRequestId: Scalars['String']
}

export type CannotAddActivityTemplateToDealsPipeline = GraphQlBaseError & {
   __typename?: 'CannotAddActivityTemplateToDealsPipeline'
   message?: Maybe<Scalars['String']>
}

export type CannotAddAttachmentsToRemarksAddedByOtherUser = GraphQlBaseError & {
   __typename?: 'CannotAddAttachmentsToRemarksAddedByOtherUser'
   message?: Maybe<Scalars['String']>
}

export type CannotAddIdentifierFieldInAddAnotherGof = GraphQlBaseError & {
   __typename?: 'CannotAddIdentifierFieldInAddAnotherGof'
   message?: Maybe<Scalars['String']>
}

export type CannotAddPipelineEventTemplateToPipelineItemType = GraphQlBaseError & {
   __typename?: 'CannotAddPipelineEventTemplateToPipelineItemType'
   message?: Maybe<Scalars['String']>
   pipelineItemType: PipelineItemType
}

export type CannotAddUniqueFieldInAddAnotherGof = GraphQlBaseError & {
   __typename?: 'CannotAddUniqueFieldInAddAnotherGof'
   message?: Maybe<Scalars['String']>
}

export type CannotAddWriteRolesToUserPropertiesSystemFields = GraphQlBaseError & {
   __typename?: 'CannotAddWriteRolesToUserPropertiesSystemFields'
   message?: Maybe<Scalars['String']>
   roles: Array<Scalars['String']>
}

export type CannotCreateFieldsSelectorFieldToUserPropertiesGoF = GraphQlBaseError & {
   __typename?: 'CannotCreateFieldsSelectorFieldToUserPropertiesGoF'
   message?: Maybe<Scalars['String']>
}

export type CannotDeleteFormGoF = GraphQlBaseError & {
   __typename?: 'CannotDeleteFormGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotDeleteIdentificationField = GraphQlBaseError & {
   __typename?: 'CannotDeleteIdentificationField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotDeleteLastAddAnotherGoFResponse = GraphQlBaseError & {
   __typename?: 'CannotDeleteLastAddAnotherGoFResponse'
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotDeletePrimaryDisplayNameField = GraphQlBaseError & {
   __typename?: 'CannotDeletePrimaryDisplayNameField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotDeleteRemarkAttachmentsAddedByOtherUser = GraphQlBaseError & {
   __typename?: 'CannotDeleteRemarkAttachmentsAddedByOtherUser'
   message?: Maybe<Scalars['String']>
}

export type CannotDeleteSystemGoF = GraphQlBaseError & {
   __typename?: 'CannotDeleteSystemGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotDeleteTaskTemplatesVisibilityField = GraphQlBaseError & {
   __typename?: 'CannotDeleteTaskTemplatesVisibilityField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   taskTemplateIds: Array<Scalars['String']>
}

export type CannotDuplicateEventBasedLeadDistributionRule = GraphQlBaseError & {
   __typename?: 'CannotDuplicateEventBasedLeadDistributionRule'
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotEditDeletedAppliedFeeHeader = {
   __typename?: 'CannotEditDeletedAppliedFeeHeader'
   appliedFeeHeaderId: Scalars['String']
}

export type CannotEditIsUniqueForIdentifierField = GraphQlBaseError & {
   __typename?: 'CannotEditIsUniqueForIdentifierField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotEditSystemField = GraphQlBaseError & {
   __typename?: 'CannotEditSystemField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotEditSystemGoF = GraphQlBaseError & {
   __typename?: 'CannotEditSystemGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotEnableFormulaStatusInAddAnotherField = GraphQlBaseError & {
   __typename?: 'CannotEnableFormulaStatusInAddAnotherField'
   message?: Maybe<Scalars['String']>
}

export type CannotEnableFormulaStatusOnUniqueField = GraphQlBaseError & {
   __typename?: 'CannotEnableFormulaStatusOnUniqueField'
   message?: Maybe<Scalars['String']>
}

export type CannotEnableMultipleSigningFeatures = GraphQlBaseError & {
   __typename?: 'CannotEnableMultipleSigningFeatures'
   features: Array<CrmAccountFeatureEnum>
   message?: Maybe<Scalars['String']>
}

export type CannotEnableShortTextFieldOptionsOnFormulaField = GraphQlBaseError & {
   __typename?: 'CannotEnableShortTextFieldOptionsOnFormulaField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotFindApplicationPipelineWithGivenValues = GraphQlBaseError & {
   __typename?: 'CannotFindApplicationPipelineWithGivenValues'
   area: Scalars['Float']
   height: Scalars['Float']
   message?: Maybe<Scalars['String']>
}

export type CannotInitiatePartialPaymentsOnDirectOrder = {
   __typename?: 'CannotInitiatePartialPaymentsOnDirectOrder'
   paymentOrderId: Scalars['String']
}

export type CannotMakeActiveDueToIncompleteConfiguration = GraphQlBaseError & {
   __typename?: 'CannotMakeActiveDueToIncompleteConfiguration'
   message?: Maybe<Scalars['String']>
}

export type CannotMoveFieldFromAddAnotherGoF = GraphQlBaseError & {
   __typename?: 'CannotMoveFieldFromAddAnotherGoF'
   message?: Maybe<Scalars['String']>
}

export type CannotMoveFieldIntoSystemGoF = GraphQlBaseError & {
   __typename?: 'CannotMoveFieldIntoSystemGoF'
   fieldId: Scalars['String']
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotMoveFieldToAddAnotherGoF = GraphQlBaseError & {
   __typename?: 'CannotMoveFieldToAddAnotherGoF'
   message?: Maybe<Scalars['String']>
}

export type CannotPublishRemarksAddedByOtherUser = GraphQlBaseError & {
   __typename?: 'CannotPublishRemarksAddedByOtherUser'
   message?: Maybe<Scalars['String']>
}

export type CannotRemoveAdjustedAmountAppliedFeeHeaders = {
   __typename?: 'CannotRemoveAdjustedAmountAppliedFeeHeaders'
   appliedFeeHeaderIds: Array<Scalars['String']>
}

export type CannotRemoveMandatorySystemFields = GraphQlBaseError & {
   __typename?: 'CannotRemoveMandatorySystemFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CannotRemoveSystemFieldDefaultReadRoles = GraphQlBaseError & {
   __typename?: 'CannotRemoveSystemFieldDefaultReadRoles'
   message?: Maybe<Scalars['String']>
   roles: Array<Scalars['String']>
}

export type CannotRemoveSystemFieldDefaultWriteRoles = GraphQlBaseError & {
   __typename?: 'CannotRemoveSystemFieldDefaultWriteRoles'
   message?: Maybe<Scalars['String']>
   roles: Array<Scalars['String']>
}

export type CannotRemoveTaskFieldDefaultWriteRoles = GraphQlBaseError & {
   __typename?: 'CannotRemoveTaskFieldDefaultWriteRoles'
   message?: Maybe<Scalars['String']>
   roles: Array<Scalars['String']>
}

export type CannotReorderSystemFields = GraphQlBaseError & {
   __typename?: 'CannotReorderSystemFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CannotReorderSystemGoF = GraphQlBaseError & {
   __typename?: 'CannotReorderSystemGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CannotSubmitEmptyFeedback = GraphQlBaseError & {
   __typename?: 'CannotSubmitEmptyFeedback'
   message?: Maybe<Scalars['String']>
}

export type CannotUpdateCustomTaskTypeTemplate = GraphQlBaseError & {
   __typename?: 'CannotUpdateCustomTaskTypeTemplate'
   message?: Maybe<Scalars['String']>
}

export type CannotUpdatePipelineItemSystemField = GraphQlBaseError & {
   __typename?: 'CannotUpdatePipelineItemSystemField'
   message?: Maybe<Scalars['String']>
   systemFieldEnum: UnsupportedPipelineItemSystemFieldsInTaskDraft
}

export type CannotUpdatePipelineItemSystemFields = GraphQlBaseError & {
   __typename?: 'CannotUpdatePipelineItemSystemFields'
   message?: Maybe<Scalars['String']>
   systemFieldEnums: Array<UnsupportedPipelineItemSystemFieldsInTaskDraft>
}

export type CannotUpdateRemarksAddedByOtherUser = GraphQlBaseError & {
   __typename?: 'CannotUpdateRemarksAddedByOtherUser'
   message?: Maybe<Scalars['String']>
}

export type CannotUpdateTaskSubmittedLocationField = GraphQlBaseError & {
   __typename?: 'CannotUpdateTaskSubmittedLocationField'
   message?: Maybe<Scalars['String']>
}

export type CaptchaExpired = GraphQlBaseError & {
   __typename?: 'CaptchaExpired'
   errorMsg: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CardVisibilityCondition = {
   __typename?: 'CardVisibilityCondition'
   conditionId: Scalars['String']
   fieldId: Scalars['String']
   fieldSource: RuleConditionFieldSourceType
   operator: RuleConditionOperator
   value?: Maybe<Scalars['String']>
}

export enum Cardinality {
   ManyToMany = 'MANY_TO_MANY',
   OneToMany = 'ONE_TO_MANY',
   OneToOne = 'ONE_TO_ONE'
}

export type CardinalityUpdateNotSupported = GraphQlBaseError & {
   __typename?: 'CardinalityUpdateNotSupported'
   allowedCardinalities: Array<Cardinality>
   message?: Maybe<Scalars['String']>
}

export type CardsTab = BaseTab & {
   __typename?: 'CardsTab'
   cards: Array<TabCard>
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type CategoriesNotFound = GraphQlBaseError & {
   __typename?: 'CategoriesNotFound'
   categoryIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CategoryCheckpoint = {
   __typename?: 'CategoryCheckpoint'
   checkpointId: Scalars['String']
   checkpointType: CategoryCheckpointType
   text: Scalars['String']
}

export type CategoryCheckpointNotFound = GraphQlBaseError & {
   __typename?: 'CategoryCheckpointNotFound'
   checkpointId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum CategoryCheckpointType {
   Custom = 'CUSTOM',
   System = 'SYSTEM'
}

export type CategoryCheckpointsNotFound = GraphQlBaseError & {
   __typename?: 'CategoryCheckpointsNotFound'
   checkpointIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CategoryCheckpointsTab = BaseTab & {
   __typename?: 'CategoryCheckpointsTab'
   categoryIds: Array<Scalars['String']>
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type CategoryEntityAccessDenied = GraphQlBaseError & {
   __typename?: 'CategoryEntityAccessDenied'
   entityId: Scalars['String']
   entityType: CategoryEntityType
   message?: Maybe<Scalars['String']>
}

export type CategoryEntityNotFound = GraphQlBaseError & {
   __typename?: 'CategoryEntityNotFound'
   entityId: Scalars['String']
   entityType: CategoryEntityType
   message?: Maybe<Scalars['String']>
}

export enum CategoryEntityType {
   PipelineItem = 'PIPELINE_ITEM'
}

export type CategoryNotFound = GraphQlBaseError & {
   __typename?: 'CategoryNotFound'
   categoryId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CategoryPipelineBoardsResult =
   | CategoryWisePipelineBoards
   | PipelineAccessDenied
   | PipelineNotFound

export type CategoryWisePipelineBoards = {
   __typename?: 'CategoryWisePipelineBoards'
   allPipelineItemsBoard?: Maybe<Board>
   customBoards: Array<Board>
   pipelineId: Scalars['String']
   scheduledPipelineItemBoard: Board
   stageBoards: Array<Board>
}

export type CertificateNoExistsForOtherTdrRequests = GraphQlBaseError & {
   __typename?: 'CertificateNoExistsForOtherTDRRequests'
   certificateNo: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ChallanOrdersInitiatedOnApplication = GraphQlBaseError & {
   __typename?: 'ChallanOrdersInitiatedOnApplication'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
   razorpayOrderIds: Array<Scalars['String']>
}

export type ChangeApplicationDisplayStageShortFallFieldsStatusParams = {
   shouldShowShortfallFields: Scalars['Boolean']
   stageId: Scalars['String']
}

export type ChangeApplicationDisplayStageShortFallFieldsStatusResponse =
   | ApplicationDisplayStageNotFound
   | ChangeApplicationDisplayStageShortFallFieldsStatusResult
   | NotApplicationDisplayStage
   | UserIsNotAnAdministrator

export type ChangeApplicationDisplayStageShortFallFieldsStatusResult = {
   __typename?: 'ChangeApplicationDisplayStageShortFallFieldsStatusResult'
   shouldShowShortfallFields: Scalars['Boolean']
   stageId: Scalars['String']
}

export type ChangeAutoGenerateApplicationIdInCreationStatusParams = {
   fieldId: Scalars['String']
   shouldEnable: Scalars['Boolean']
}

export type ChangeAutoGenerateApplicationIdInCreationStatusResponse =
   | ChangeAutoGenerateApplicationIdInCreationStatusResult
   | FieldNotFound
   | NotApplicationIdField
   | UserIsNotAnAdministrator

export type ChangeAutoGenerateApplicationIdInCreationStatusResult = {
   __typename?: 'ChangeAutoGenerateApplicationIdInCreationStatusResult'
   fieldId: Scalars['String']
   shouldEnable: Scalars['Boolean']
}

export type ChangeFieldTypeParams = {
   fieldId: Scalars['String']
   targetFieldType: FieldType
}

export type ChangeFieldTypeResponse =
   | CannotEditSystemField
   | ChangeFieldTypeResult
   | ConditionalOptionFieldIsNotSupported
   | FieldIsDeleted
   | FieldNotFound
   | NotSupportedSourceFieldType
   | NotSupportedTargetFieldType
   | UserIsNotAnAdministrator

export type ChangeFieldTypeResult = {
   __typename?: 'ChangeFieldTypeResult'
   fieldId: Scalars['String']
   targetFieldType: FieldType
}

export type ChangeMakeApplicationFieldsAsShortfallValueParams = {
   canMakeApplicationFieldsAsShortfall: Scalars['Boolean']
   stageId: Scalars['String']
}

export type ChangeMakeApplicationFieldsAsShortfallValueResponse =
   | ChangeMakeApplicationFieldsAsShortfallValueResult
   | StageNotFound
   | UserIsNotAnAdministrator

export type ChangeMakeApplicationFieldsAsShortfallValueResult = {
   __typename?: 'ChangeMakeApplicationFieldsAsShortfallValueResult'
   canMakeApplicationFieldsAsShortfall: Scalars['Boolean']
   stageId: Scalars['String']
}

export type ChangeStageColorParams = {
   color?: InputMaybe<ColorEnum>
   stageId: Scalars['String']
}

export type ChangeStageColorResponse =
   | ChangeStageColorResult
   | ColorIsNotAllowed
   | PipelineAccessDenied
   | StageIsDeleted
   | StageNotFound
   | UserIsNotAnAdministrator

export type ChangeStageColorResult = {
   __typename?: 'ChangeStageColorResult'
   color?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type CheckAllowApplicationSubmitParams = {
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type CheckAllowApplicationSubmitResponse =
   | CheckAllowApplicationSubmitResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelinesAccessDenied
   | PipelinesNotFound

export type CheckAllowApplicationSubmitResult = {
   __typename?: 'CheckAllowApplicationSubmitResult'
   errorMsg?: Maybe<Scalars['String']>
   status: ApplicationSubmitPermissionStatus
}

export type CheckCaRegistrationNumberLinkedToOtherUsersParams = {
   caRegistrationNumber: Scalars['String']
}

export type CheckCaRegistrationNumberLinkedToOtherUsersResponse = CheckCaRegistrationNumberLinkedToOtherUsersResult

export type CheckCaRegistrationNumberLinkedToOtherUsersResult = {
   __typename?: 'CheckCARegistrationNumberLinkedToOtherUsersResult'
   isLinkedToOtherUsers: Scalars['Boolean']
   linkedPhoneNumbers: Array<UserPhoneNumber>
}

export type CheckItemsExistInViewParams = {
   itemIds: Array<Scalars['String']>
   viewId: Scalars['String']
}

export type CheckItemsExistInViewResponse =
   | CheckItemsExistInViewResult
   | ViewAccessDenied
   | ViewNotFound

export type CheckItemsExistInViewResult = {
   __typename?: 'CheckItemsExistInViewResult'
   items: Array<ItemExistenceInView>
}

export type CheckPointTextParams = {
   checkpointId: Scalars['String']
   text: Scalars['String']
}

export type CheckboxGroupField = BaseField & {
   __typename?: 'CheckboxGroupField'
   defaultValues: Array<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type CheckpointsNotLinkedToEntity = GraphQlBaseError & {
   __typename?: 'CheckpointsNotLinkedToEntity'
   checkpointIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ChildAndParentNodeCannotBeSame = GraphQlBaseError & {
   __typename?: 'ChildAndParentNodeCannotBeSame'
   childNodeId: Scalars['String']
   message?: Maybe<Scalars['String']>
   parentNodeId: Scalars['String']
}

export type ChildNode = {
   __typename?: 'ChildNode'
   nodeId: Scalars['String']
   parentNodeResult?: Maybe<NodeResultEnum>
}

export type ChildNodeIdIsRequired = GraphQlBaseError & {
   __typename?: 'ChildNodeIdIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ChildParentNodeResultIsRequired = GraphQlBaseError & {
   __typename?: 'ChildParentNodeResultIsRequired'
   message?: Maybe<Scalars['String']>
}

export type CircularConditionalOptionsAreNotAllowed = GraphQlBaseError & {
   __typename?: 'CircularConditionalOptionsAreNotAllowed'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   parentFieldIds: Array<Scalars['String']>
}

export type CircularParentFieldsAreNotAllowed = GraphQlBaseError & {
   __typename?: 'CircularParentFieldsAreNotAllowed'
   message?: Maybe<Scalars['String']>
   parentFieldIds: Array<Scalars['String']>
}

export type CircularParentIsNotAllowed = GraphQlBaseError & {
   __typename?: 'CircularParentIsNotAllowed'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   parentFieldId: Scalars['String']
}

export type CircularRelatedEntitiesFound = GraphQlBaseError & {
   __typename?: 'CircularRelatedEntitiesFound'
   message?: Maybe<Scalars['String']>
   relatedEntityIds: Array<Scalars['String']>
}

export type CitizenAccountNotFoundForGivenPhoneNumber = GraphQlBaseError & {
   __typename?: 'CitizenAccountNotFoundForGivenPhoneNumber'
   dialCode: Scalars['String']
   message?: Maybe<Scalars['String']>
   phoneNumber: Scalars['String']
}

export type CitizenPhoneNumberRequired = GraphQlBaseError & {
   __typename?: 'CitizenPhoneNumberRequired'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CitizenPipelineDetailsRequired = GraphQlBaseError & {
   __typename?: 'CitizenPipelineDetailsRequired'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ClearApplicationAddAnotherGoFInPortalParams = {
   applicationId: Scalars['String']
   gofResponseId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type ClearApplicationAddAnotherGoFInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ClearApplicationAddAnotherGoFInPortalResult
   | GoFResponseIdNotFound
   | NotApplicationAddAnotherGoFResponse
   | PortalIsDeleted
   | PortalNotFound

export type ClearApplicationAddAnotherGoFInPortalResult = {
   __typename?: 'ClearApplicationAddAnotherGoFInPortalResult'
   applicationId: Scalars['String']
   gofResponseId: Scalars['String']
   portalId: Scalars['String']
}

export type ClearApplicationAddAnotherGoFParams = {
   applicationId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type ClearApplicationAddAnotherGoFResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ClearApplicationAddAnotherGoFResult
   | GoFResponseIdNotFound
   | NotApplicationAddAnotherGoFResponse

export type ClearApplicationAddAnotherGoFResult = {
   __typename?: 'ClearApplicationAddAnotherGoFResult'
   applicationId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type ClearAutomationWorkflowExecLogsFilterParams = {
   entityLevel?: InputMaybe<AwLogsEntityLevel>
   /** @deprecated Field no longer supported */
   execLogsTab?: InputMaybe<AutomationWorkflowExecLogsTab>
   pipelineId?: InputMaybe<Scalars['String']>
}

export type ClearAutomationWorkflowExecLogsFilterResponse =
   | ClearAutomationWorkflowExecLogsFilterResult
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type ClearAutomationWorkflowExecLogsFilterResult = {
   __typename?: 'ClearAutomationWorkflowExecLogsFilterResult'
   entityLevel: AwLogsEntityLevel
   /** @deprecated Field no longer supported */
   execLogsTab?: Maybe<AutomationWorkflowExecLogsTab>
   pipelineId?: Maybe<Scalars['String']>
}

export type ClearDealAddAnotherGoFParams = {
   dealId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type ClearDealAddAnotherGoFResponse =
   | ClearDealAddAnotherGoFResult
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound
   | GoFResponseIdNotFound
   | NotDealAddAnotherGoFResponse

export type ClearDealAddAnotherGoFResult = {
   __typename?: 'ClearDealAddAnotherGoFResult'
   dealId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type ClearDistributionThroughEntitiesParams = {
   distributionThrough: DistributionThroughType
   leadDistributionRuleId: Scalars['String']
}

export type ClearDistributionThroughEntitiesResponse =
   | ClearDistributionThroughEntitiesResult
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | UserIsNotAnAdministrator

export type ClearDistributionThroughEntitiesResult = {
   __typename?: 'ClearDistributionThroughEntitiesResult'
   distributionThrough: DistributionThroughType
   leadDistributionRuleId: Scalars['String']
}

export type ClearFieldConditionalOptionsConfigParams = {
   fieldId: Scalars['String']
}

export type ClearFieldConditionalOptionsConfigResponse =
   | CannotEditSystemField
   | ClearFieldConditionalOptionsConfigResult
   | FieldIsDeleted
   | FieldNotFound
   | NotSupportedFieldType
   | UserIsNotAnAdministrator

export type ClearFieldConditionalOptionsConfigResult = {
   __typename?: 'ClearFieldConditionalOptionsConfigResult'
   fieldId: Scalars['String']
}

export type ClearLeadAddAnotherGoFParams = {
   gofResponseId: Scalars['String']
   leadId: Scalars['String']
}

export type ClearLeadAddAnotherGoFResponse =
   | ClearLeadAddAnotherGoFResult
   | GoFResponseIdNotFound
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound
   | NotLeadAddAnotherGoFResponse

export type ClearLeadAddAnotherGoFResult = {
   __typename?: 'ClearLeadAddAnotherGoFResult'
   gofResponseId: Scalars['String']
   leadId: Scalars['String']
}

export type ClearPipelineCustomObjectAddAnotherGoFParams = {
   customObjectId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type ClearPipelineCustomObjectAddAnotherGoFResponse =
   | ClearPipelineCustomObjectAddAnotherGoFResult
   | GoFResponseIdNotFound
   | NotPipelineCustomObjectAddAnotherGoFResponse
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound

export type ClearPipelineCustomObjectAddAnotherGoFResult = {
   __typename?: 'ClearPipelineCustomObjectAddAnotherGoFResult'
   customObjectId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type ClearRelatedEntityAddAnotherGoFParams = {
   currentEntityId: Scalars['String']
   gofResponseId: Scalars['String']
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
}

export type ClearRelatedEntityAddAnotherGoFResponse =
   | ClearRelatedEntityAddAnotherGoFResult
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | GoFResponseIdNotFound
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntityIsDeleted
   | RelatedEntityNotFound
   | RelationIsDeleted
   | RelationNotFound

export type ClearRelatedEntityAddAnotherGoFResult = {
   __typename?: 'ClearRelatedEntityAddAnotherGoFResult'
   currentEntityId: Scalars['String']
   gofResponseId: Scalars['String']
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
}

export type ClearScheduledAutomationWorkflowExecLogsFilterParams = {
   entityLevel?: InputMaybe<AwLogsEntityLevel>
   pipelineId?: InputMaybe<Scalars['String']>
}

export type ClearScheduledAutomationWorkflowExecLogsFilterResponse =
   | ClearScheduledAutomationWorkflowExecLogsFilterResult
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type ClearScheduledAutomationWorkflowExecLogsFilterResult = {
   __typename?: 'ClearScheduledAutomationWorkflowExecLogsFilterResult'
   entityLevel: AwLogsEntityLevel
   pipelineId?: Maybe<Scalars['String']>
}

export type ClearTaskAddAnotherGoFParams = {
   gofResponseId: Scalars['String']
   taskId: Scalars['String']
}

export type ClearTaskAddAnotherGoFResponse =
   | ClearTaskAddAnotherGoFResult
   | GoFResponseIdNotFound
   | NotTaskAddAnotherGoFResponse
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound

export type ClearTaskAddAnotherGoFResult = {
   __typename?: 'ClearTaskAddAnotherGoFResult'
   gofResponseId: Scalars['String']
   taskId: Scalars['String']
}

export type ClearTaskDraftParams = {
   taskId: Scalars['String']
}

export type ClearTaskDraftResponse =
   | CanNotUpdateCompletedTask
   | Task
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | TaskTemplateAccessDenied

export type ClearUndoneLeadTasksNode = BaseNode & {
   __typename?: 'ClearUndoneLeadTasksNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   taskTemplateIds: Array<Scalars['String']>
}

export type ClearUndoneLeadTasksNodeExecLog = BaseNodeExecLog & {
   __typename?: 'ClearUndoneLeadTasksNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   status: NodeExecLogStatusEnum
}

export type ClearUsersTabFiltersResponse =
   | ClearUsersTabFiltersResult
   | UserIsNotAnAdministrator

export type ClearUsersTabFiltersResult = {
   __typename?: 'ClearUsersTabFiltersResult'
   userId: Scalars['String']
}

export type ClockInAlreadyAttempted = GraphQlBaseError & {
   __typename?: 'ClockInAlreadyAttempted'
   clockInTime: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ClockInNotAttempted = GraphQlBaseError & {
   __typename?: 'ClockInNotAttempted'
   message?: Maybe<Scalars['String']>
}

export type ClockInResponse =
   | ClockInAlreadyAttempted
   | ClockInResult
   | FeatureNotEnabled

export type ClockInResult = {
   __typename?: 'ClockInResult'
   clockInTime: Scalars['String']
   userId: Scalars['String']
}

export type ClockOutResponse =
   | ClockInNotAttempted
   | ClockOutResult
   | FeatureNotEnabled

export type ClockOutResult = {
   __typename?: 'ClockOutResult'
   userId: Scalars['String']
}

export type CloneAutomationWorkflowParams = {
   automationWorkflowId: Scalars['String']
}

export type CloneAutomationWorkflowResponse =
   | AutomationWorkflow
   | AutomationWorkflowNotFound
   | AutomationWorkflowPublishedVersionNotExists
   | UserIsNotAnAdministrator

export type CloneGraphParams = {
   dashboardId?: InputMaybe<Scalars['String']>
   graphId: Scalars['String']
   viewId?: InputMaybe<Scalars['String']>
}

export type CloneGraphResponse =
   | DashboardGraphAccessDenied
   | DashboardNotFound
   | GraphIsNotLinkedToDashboard
   | GraphIsNotLinkedToView
   | GraphNotFound
   | UserGraph
   | UserIsNotAnAdministrator
   | ViewGraphAccessDenied
   | ViewNotFound

export type CloneLeadDistributionRuleParams = {
   leadDistributionRuleId: Scalars['String']
}

export type CloneLeadDistributionRuleResponse =
   | CannotDuplicateEventBasedLeadDistributionRule
   | LeadDistributionRule
   | LeadDistributionRuleNotFound
   | UserIsNotAnAdministrator

export type CloudCallingCallLogsNotFound = GraphQlBaseError & {
   __typename?: 'CloudCallingCallLogsNotFound'
   callLogIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CloudCallingConfigurationNotProvided = GraphQlBaseError & {
   __typename?: 'CloudCallingConfigurationNotProvided'
   message?: Maybe<Scalars['String']>
}

export enum CloudCallingEventStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   Initiated = 'INITIATED',
   InProgress = 'IN_PROGRESS'
}

export type CloudCallingLog = {
   __typename?: 'CloudCallingLog'
   agentPhoneNumber?: Maybe<PhoneNumberResponse>
   callLogId: Scalars['String']
   cliNumber?: Maybe<PhoneNumberResponse>
   customerPhoneNumber: PhoneNumberResponse
   failureReason?: Maybe<Scalars['String']>
   payload: Scalars['String']
   receivedAt: Scalars['String']
   status: CallLogStatus
}

export type CloudCallingServiceAccountAndAdminAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'CloudCallingServiceAccountAndAdminAreNotInSameAccount'
   message?: Maybe<Scalars['String']>
}

export type CloudCallingServiceAccountIdIsRequired = GraphQlBaseError & {
   __typename?: 'CloudCallingServiceAccountIdIsRequired'
   message?: Maybe<Scalars['String']>
}

export type CloudCallingServiceAccountIsDeactivated = GraphQlBaseError & {
   __typename?: 'CloudCallingServiceAccountIsDeactivated'
   cloudCallingServiceAccountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CloudCallingServiceAccountNotFound = GraphQlBaseError & {
   __typename?: 'CloudCallingServiceAccountNotFound'
   cloudCallingServiceAccountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CloudCallingServiceError = GraphQlBaseError & {
   __typename?: 'CloudCallingServiceError'
   message?: Maybe<Scalars['String']>
}

export enum ColorEnum {
   Blue = 'BLUE',
   BlueDark = 'BLUE_DARK',
   BlueLight = 'BLUE_LIGHT',
   Cyan = 'CYAN',
   Fuchsia = 'FUCHSIA',
   Green = 'GREEN',
   GreenLight = 'GREEN_LIGHT',
   Indigo = 'INDIGO',
   Moss = 'MOSS',
   Orange = 'ORANGE',
   OrangeDark = 'ORANGE_DARK',
   Pink = 'PINK',
   Purple = 'PURPLE',
   Rose = 'ROSE',
   Teal = 'TEAL',
   Violet = 'VIOLET',
   Yellow = 'YELLOW'
}

export type ColorIsNotAllowed = GraphQlBaseError & {
   __typename?: 'ColorIsNotAllowed'
   color?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ColorResponse = {
   __typename?: 'ColorResponse'
   colorEnum?: Maybe<ColorEnum>
}

export type ColumnHeader = {
   __typename?: 'ColumnHeader'
   headerId: Scalars['String']
   headerValue: ColumnHeaderValue
}

export type ColumnHeaderValue =
   | BaseActivityTemplate
   | BaseTaskTemplate
   | BaseUser
   | GqlStringType
   | Stage

export type ColumnTotal = {
   __typename?: 'ColumnTotal'
   columnId: Scalars['String']
   total: Scalars['String']
}

export type ColumnTotals = {
   __typename?: 'ColumnTotals'
   columnTotals: Array<ColumnTotal>
   totalLeads: Scalars['String']
}

export type ColumnTotalsResult =
   | ColumnTotals
   | GraphAccessDenied
   | GraphNotFound
   | ViewAccessDenied
   | ViewNotFound

export type ComparisonMetricConfigIsRequired = GraphQlBaseError & {
   __typename?: 'ComparisonMetricConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ComparisonValue = GqlStringType | GraphMetric

export type CompletedPipelineItemScheduledIds = GraphQlBaseError & {
   __typename?: 'CompletedPipelineItemScheduledIds'
   message?: Maybe<Scalars['String']>
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export type CompletedTasksTab = BaseTab & {
   __typename?: 'CompletedTasksTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type ComputedUpdateConfig = {
   __typename?: 'ComputedUpdateConfig'
   isComputedUpdate: Scalars['Boolean']
   longTextSeparator?: Maybe<Scalars['String']>
   numberFieldOperator?: Maybe<NumberFieldOperator>
}

export type ComputedUpdateConfigParams = {
   isComputedUpdate: Scalars['Boolean']
   longTextSeparator?: InputMaybe<Scalars['String']>
   numberFieldOperator?: InputMaybe<NumberFieldOperator>
}

export type ComputedUpdateFieldValueMapping = {
   __typename?: 'ComputedUpdateFieldValueMapping'
   computedUpdateConfig?: Maybe<ComputedUpdateConfig>
   computedValueConfig?: Maybe<AwComputedValueConfig>
   directValue?: Maybe<FieldMappingDirectValue>
   enableDeepCopy?: Maybe<Scalars['Boolean']>
   fieldId: Scalars['String']
   upRefAssigneeFieldId?: Maybe<Scalars['String']>
   value?: Maybe<Scalars['String']>
   valueFrom: FieldSourceType
}

export type ComputedUpdateFieldValueMappingParams = {
   computedUpdateConfig?: InputMaybe<ComputedUpdateConfigParams>
   computedValueConfig?: InputMaybe<Scalars['String']>
   enableDeepCopy?: InputMaybe<Scalars['Boolean']>
   fieldId: Scalars['String']
   upRefAssigneeFieldId?: InputMaybe<Scalars['String']>
   value?: InputMaybe<Scalars['String']>
   valueFrom: FieldSourceType
}

export type ConcatenatedSurveyNumbersFieldNotFound = GraphQlBaseError & {
   __typename?: 'ConcatenatedSurveyNumbersFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type Condition = {
   __typename?: 'Condition'
   conditionId: Scalars['String']
   dataSource?: Maybe<AnalyticsDataSourceType>
   fieldId: Scalars['String']
   operator: FilterOperator
   status: FilterConditionStatus
   templateId?: Maybe<Scalars['String']>
   value?: Maybe<ValueResponseType>
}

export type ConditionFieldShouldBeUniqueFieldType = GraphQlBaseError & {
   __typename?: 'ConditionFieldShouldBeUniqueFieldType'
   fieldId: Scalars['String']
   filterSetEntity: AutomationWorkflowUniqueFieldsSupportedFilterSetEntity
   message?: Maybe<Scalars['String']>
}

export type ConditionFieldShouldBelongsToRelatedSalesTemplate = GraphQlBaseError & {
   __typename?: 'ConditionFieldShouldBelongsToRelatedSalesTemplate'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   relatedSalesTemplateId: Scalars['String']
}

export type ConditionMultiValueResponse = {
   __typename?: 'ConditionMultiValueResponse'
   responses: Array<ConditionValue>
}

export type ConditionNode = BaseNode & {
   __typename?: 'ConditionNode'
   applyFiltersOn: ApplyAutomationWorkflowsFiltersOn
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   filterSetId: Scalars['String']
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   relation?: Maybe<Relation>
}

export type ConditionNodeExecLog = BaseNodeExecLog & {
   __typename?: 'ConditionNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<ConditionNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type ConditionNodeExecLogResult = {
   __typename?: 'ConditionNodeExecLogResult'
   execResult: ConditionNodeResultEnum
   filterWiseExecResult: Array<ConditionNodeFilterWiseExecResult>
}

export enum ConditionNodeFilterResultEnum {
   False = 'FALSE',
   True = 'TRUE'
}

export type ConditionNodeFilterWiseExecResult = {
   __typename?: 'ConditionNodeFilterWiseExecResult'
   execResult: ConditionNodeFilterResultEnum
   filterId: Scalars['String']
}

export type ConditionNodeFiltersResponse =
   | AutomationWorkflowFiltersResult
   | NodeNotFound
   | NotExistsNodeFilterSet
   | UserIsNotAnAdministrator

export enum ConditionNodeResultEnum {
   False = 'FALSE',
   True = 'TRUE'
}

export type ConditionNotFound = GraphQlBaseError & {
   __typename?: 'ConditionNotFound'
   conditionId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ConditionOperatorIsNotSupportedForField = GraphQlBaseError & {
   __typename?: 'ConditionOperatorIsNotSupportedForField'
   message?: Maybe<Scalars['String']>
   operator: ScoringConditionOperator
}

export type ConditionOptionsParentFieldIsNotDropdownField = GraphQlBaseError & {
   __typename?: 'ConditionOptionsParentFieldIsNotDropdownField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ConditionScoreOutOfRange = GraphQlBaseError & {
   __typename?: 'ConditionScoreOutOfRange'
   maxScore: Scalars['Float']
   message?: Maybe<Scalars['String']>
   minScore: Scalars['Float']
}

export type ConditionValue =
   | BaseActivityTemplate
   | BasePipeline
   | BaseTaskTemplate
   | BaseUser
   | DateFilterRelativeConfig
   | DateRange
   | DateTimeFilterRelativeConfig
   | DateTimeRange
   | FloatRange
   | GqlBooleanType
   | GqlDateTimeType
   | GqlDateType
   | GqlFloatType
   | GqlIntType
   | GqlStringType
   | GqlTaskStatusObj
   | GqlTimeType
   | IntegerRange
   | PhoneNumberResponse
   | Stage
   | TimeRange

export type ConditionValueResponse = {
   __typename?: 'ConditionValueResponse'
   response?: Maybe<ConditionValue>
}

export type ConditionalFieldOptions = {
   __typename?: 'ConditionalFieldOptions'
   options: Array<ConditionalOptions>
   parentFieldId: Scalars['String']
}

export type ConditionalFieldOptionsParams = {
   options: Array<ConditionalOptionsParams>
   parentFieldId: Scalars['String']
}

export type ConditionalFieldParentsHaveEmptyResponse = GraphQlBaseError & {
   __typename?: 'ConditionalFieldParentsHaveEmptyResponse'
   message?: Maybe<Scalars['String']>
   parentFieldIds: Array<Scalars['String']>
}

export type ConditionalOptionFieldIsNotSupported = GraphQlBaseError & {
   __typename?: 'ConditionalOptionFieldIsNotSupported'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ConditionalOptions = {
   __typename?: 'ConditionalOptions'
   options: Array<Scalars['String']>
   parentFieldOption: Scalars['String']
}

export type ConditionalOptionsNotSupportedForFieldType = GraphQlBaseError & {
   __typename?: 'ConditionalOptionsNotSupportedForFieldType'
   fieldType: FieldType
   message?: Maybe<Scalars['String']>
}

export type ConditionalOptionsParams = {
   options: Array<Scalars['String']>
   parentFieldOption: Scalars['String']
}

export type ConditionalOptionsParentFieldTypeNotSupported = GraphQlBaseError & {
   __typename?: 'ConditionalOptionsParentFieldTypeNotSupported'
   fieldIds: Array<Scalars['String']>
   fieldTypes: Array<FieldType>
   message?: Maybe<Scalars['String']>
}

export type ConditionalOptionsParentFieldsAreNotInSameGof = GraphQlBaseError & {
   __typename?: 'ConditionalOptionsParentFieldsAreNotInSameGof'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ConditionsNotBelongsToScoringParameter = GraphQlBaseError & {
   __typename?: 'ConditionsNotBelongsToScoringParameter'
   message?: Maybe<Scalars['String']>
   parameterConditionIds: Array<Scalars['String']>
}

export enum ConfigurableTaskType {
   Call = 'CALL',
   Default = 'DEFAULT'
}

export type ConfigureAdvancedAnalyticsParams = {
   isAdvancedAnalyticsEnabled: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type ConfigureAdvancedAnalyticsResponse =
   | ConfigureAdvancedAnalyticsResult
   | NotSupportedAdvancedAnalyticsForPipeline
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type ConfigureAdvancedAnalyticsResult = {
   __typename?: 'ConfigureAdvancedAnalyticsResult'
   isAdvancedAnalyticsEnabled: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type ConfigureDealsFeatureParams = {
   isDealsFeatureEnabled: Scalars['Boolean']
}

export type ConfigureDealsFeatureResponse =
   | ConfigureDealsFeatureResult
   | UserIsNotAnAdministrator

export type ConfigureDealsFeatureResult = {
   __typename?: 'ConfigureDealsFeatureResult'
   isDealsFeatureEnabled: Scalars['Boolean']
}

export type ConfirmationPopupTitleIsRequired = GraphQlBaseError & {
   __typename?: 'ConfirmationPopupTitleIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ConflictedAssociatedPipelineItems = {
   __typename?: 'ConflictedAssociatedPipelineItems'
   canMerge: Scalars['Boolean']
   notPermittedPipelineItemIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItems: Array<PipelineItemPrimaryDetails>
   pipelineName: Scalars['String']
   remarks?: Maybe<MergeConflictedAssociatedPipelineItemsStatus>
}

export type ConflictedAssociatedPipelineItemsResponse =
   | BothPipelineItemsCannotBeSame
   | ConflictedAssociatedPipelineItemsResult
   | OnlyLeadPipelineItemsAllowed
   | PipelineItemsAccessDenied
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | PipelineItemsNotInSamePipelineItemTemplate

export type ConflictedAssociatedPipelineItemsResult = {
   __typename?: 'ConflictedAssociatedPipelineItemsResult'
   conflictedPipelineItems: Array<ConflictedAssociatedPipelineItems>
}

export type ConflictedAssociatedRelatedEntities = {
   __typename?: 'ConflictedAssociatedRelatedEntities'
   relatedEntities: Array<ConflictedAssociatedRelatedEntity>
   relationId: Scalars['String']
   relationName: Scalars['String']
}

export type ConflictedAssociatedRelatedEntitiesResponse =
   | BothPipelineItemsCannotBeSame
   | ConflictedAssociatedRelatedEntitiesResult
   | PipelineItemsAccessDenied
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | PipelineItemsNotInSamePipelineItemTemplate

export type ConflictedAssociatedRelatedEntitiesResult = {
   __typename?: 'ConflictedAssociatedRelatedEntitiesResult'
   conflictedRelatedEntities: Array<ConflictedAssociatedRelatedEntities>
}

export type ConflictedAssociatedRelatedEntity = {
   __typename?: 'ConflictedAssociatedRelatedEntity'
   pipelineItemId: Scalars['String']
   relatedEntity: PipelineItemPrimaryDetails
}

export type ConflictingRelationsForMergedPipelineItems = GraphQlBaseError & {
   __typename?: 'ConflictingRelationsForMergedPipelineItems'
   message?: Maybe<Scalars['String']>
   relationIds: Array<Scalars['String']>
}

export type ConsentPhoneNumberWithField = {
   __typename?: 'ConsentPhoneNumberWithField'
   fieldId: Scalars['String']
   phoneNumber: PhoneNumberResponse
}

export type Contact = {
   __typename?: 'Contact'
   contactId: Scalars['String']
   contactTemplateId: Scalars['String']
   fields: Array<ContactFieldResult>
}

export type ContactFieldsArgs = {
   fieldIds?: InputMaybe<Array<Scalars['String']>>
}

export type ContactAccessDenied = GraphQlBaseError & {
   __typename?: 'ContactAccessDenied'
   contactId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ContactAlreadyExists = GraphQlBaseError & {
   __typename?: 'ContactAlreadyExists'
   contactId: Scalars['String']
   hasPermission: Scalars['Boolean']
   message?: Maybe<Scalars['String']>
}

export type ContactAlreadyPushed = GraphQlBaseError & {
   __typename?: 'ContactAlreadyPushed'
   leadId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ContactAndStageAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'ContactAndStageAreNotInSameAccount'
   message?: Maybe<Scalars['String']>
}

export type ContactAssigneeIsDeactivated = GraphQlBaseError & {
   __typename?: 'ContactAssigneeIsDeactivated'
   assigneeId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ContactAssigneeNotFound = GraphQlBaseError & {
   __typename?: 'ContactAssigneeNotFound'
   message?: Maybe<Scalars['String']>
}

export type ContactFieldResult =
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldNotFound
   | FieldResponse
   | NotContactField
   | NotPermittedField

export type ContactFieldsNotSupported = GraphQlBaseError & {
   __typename?: 'ContactFieldsNotSupported'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ContactIsDeleted = GraphQlBaseError & {
   __typename?: 'ContactIsDeleted'
   contactId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ContactNotFound = GraphQlBaseError & {
   __typename?: 'ContactNotFound'
   contactId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ContactPhoneNumberIsRequiredToMakeCall = GraphQlBaseError & {
   __typename?: 'ContactPhoneNumberIsRequiredToMakeCall'
   message?: Maybe<Scalars['String']>
}

export type ContactResult =
   | Contact
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound

export enum ContactSystemFieldEnum {
   ContactAssignedOn = 'CONTACT_ASSIGNED_ON',
   ContactAssignee = 'CONTACT_ASSIGNEE',
   ContactCustomId = 'CONTACT_CUSTOM_ID',
   ContactEmail = 'CONTACT_EMAIL',
   ContactFirstName = 'CONTACT_FIRST_NAME',
   ContactLastName = 'CONTACT_LAST_NAME',
   ContactPhoneNumber = 'CONTACT_PHONE_NUMBER'
}

export type ContactSystemFieldResult = {
   __typename?: 'ContactSystemFieldResult'
   contactId: Scalars['String']
   fields: Array<SystemFieldEnumResponseResult>
}

export type ContactSystemFieldsResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | ContactSystemFieldResult

export type ContactTemplate = {
   __typename?: 'ContactTemplate'
   accountId: Scalars['String']
   assigneeFieldsMapping: Array<AssigneeFieldMapping>
   contactTemplateId: Scalars['String']
   gofs: Array<GoF>
   identificationFieldIds: Array<Scalars['String']>
   name: Scalars['String']
   orderedGofIds: Array<Scalars['String']>
}

export type ContactTemplateFilterFields = {
   __typename?: 'ContactTemplateFilterFields'
   contactTemplateId: Scalars['String']
   fieldIds: Array<Scalars['String']>
}

export type ContactTemplateNotFound = GraphQlBaseError & {
   __typename?: 'ContactTemplateNotFound'
   contactTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ContactTemplateWithoutPermission = {
   __typename?: 'ContactTemplateWithoutPermission'
   accountId: Scalars['String']
   contactTemplateId: Scalars['String']
   gofs: Array<GoFWithoutPermission>
   name: Scalars['String']
   orderedGofIds: Array<Scalars['String']>
}

export enum ContentDisposition {
   Download = 'DOWNLOAD',
   Read = 'READ'
}

export type ContextField = {
   __typename?: 'ContextField'
   field: Field
   fieldId: Scalars['String']
   taskTemplateId?: Maybe<Scalars['String']>
}

export type CopilotEmptyQueryResponse = GraphQlBaseError & {
   __typename?: 'CopilotEmptyQueryResponse'
   message?: Maybe<Scalars['String']>
}

export type CopilotResponseNotFound = GraphQlBaseError & {
   __typename?: 'CopilotResponseNotFound'
   copilotResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CopilotSqlData = {
   __typename?: 'CopilotSQLData'
   explanation?: Maybe<Scalars['String']>
   query?: Maybe<Scalars['String']>
}

export type CreateActivityLeadCreationConfig = {
   phoneNumberIdentificationFieldId?: InputMaybe<Scalars['String']>
   /** @deprecated Support SRMP */
   stageId?: InputMaybe<Scalars['String']>
}

export type CreateActivityTemplateGoFParams = {
   activityTemplateId: Scalars['String']
   description?: InputMaybe<Scalars['String']>
   name: Scalars['String']
}

export type CreateActivityTemplateGoFResponse =
   | ActivityTemplateNotFound
   | GoF
   | GoFNameAlreadyExists
   | UserIsNotAnAdministrator

export type CreateActivityTemplateParams = {
   description?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   pipelineConfigs: Array<CreateActivityTemplatePipelineConfigParams>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemCreationConfig?: InputMaybe<CreateActivityLeadCreationConfig>
   pipelineItemTemplateId: Scalars['String']
   referenceId?: InputMaybe<Scalars['String']>
}

export type CreateActivityTemplatePipelineConfigParams = {
   pipelineId: Scalars['String']
   pipelineItemCreationStageId?: InputMaybe<Scalars['String']>
}

export type CreateActivityTemplateResponse =
   | ActivityTemplate
   | ActivityTemplateNameAlreadyExists
   | ActivityTemplateReferenceIdAlreadyExists
   | ActivityTemplateReferenceIdMaxLengthExceeded
   | ApplicationDisplayStageNotFound
   | CannotAddActivityTemplateToDealsPipeline
   | DisplayStageIdOnlySupportedInApplicationPipeline
   | InvalidActivityTemplateReferenceIdFormat
   | NotAPhoneNumberIdentificationField
   | PhoneNumberIdentificationFieldNotSupportedPipeline
   | PhoneNumberIdentificationFieldNotSupportedPipelineItemTemplate
   | PipelineIdsNotInPipelineItemTemplate
   | PipelineItemTemplateNotFound
   | StageNotFound
   | StageNotInPipeline
   | StagesNotFound
   | StagesNotInPipelineItemTemplatePipelines
   | UserIsNotAnAdministrator

export type CreateAgentAllocationGroupParams = {
   name: Scalars['String']
}

export type CreateAgentAllocationGroupResponse =
   | AgentAllocationGroup
   | AgentAllocationGroupNameAlreadyExists
   | EmptyAgentAllocationGroupName
   | UserIsNotAnAdministrator

export type CreateAllocationGroupSetForAgentAllocationGroupsParams = {
   agentAllocationGroupIds: Array<Scalars['String']>
   distributionThrough: DistributionThroughType
   distributionThroughEntityId: Scalars['String']
   leadDistributionRuleId: Scalars['String']
   quota?: InputMaybe<Scalars['Int']>
   quotaType?: InputMaybe<AllocationGroupSetQuotaType>
}

export type CreateAllocationGroupSetForAgentAllocationGroupsResponse =
   | AgentAllocationGroupsAlreadyExistsInDistributionThroughEntity
   | AgentAllocationGroupsNotFound
   | AgentAllocationGroupsNotInUserAccount
   | AllocationGroupSet
   | DistributionThroughEntityNotFound
   | InvalidAllocationGroupSetQuota
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | LeadDistributionThroughShouldBeLeadBucket
   | LeadDistributionThroughShouldBeLeadPool
   | PartiallyConfiguredAgentAllocationGroups
   | UserIsNotAnAdministrator

export type CreateAllocationGroupSetForAgentsParams = {
   agentIds: Array<Scalars['String']>
   distributionThrough: DistributionThroughType
   distributionThroughEntityId: Scalars['String']
   leadDistributionRuleId: Scalars['String']
   quota?: InputMaybe<Scalars['Int']>
   quotaType?: InputMaybe<AllocationGroupSetQuotaType>
}

export type CreateAllocationGroupSetForAgentsResponse =
   | AgentsAlreadyExistsInDistributionThroughEntity
   | AgentsAreDeactivated
   | AgentsNotFound
   | AllocationGroupSet
   | DistributionThroughEntityNotFound
   | InvalidAllocationGroupSetQuota
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | LeadDistributionThroughShouldBeLeadBucket
   | LeadDistributionThroughShouldBeLeadPool
   | PipelineAccessDeniedToAgents
   | UserIsNotAnAdministrator

export type CreateApplicationAddAnotherGoFInPortalParams = {
   applicationId: Scalars['String']
   gofId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type CreateApplicationAddAnotherGoFInPortalResponse =
   | AddAnotherGoFResponsesLimitReached
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GoFAccessDenied
   | GoFIsDeleted
   | GoFNotFound
   | GoFResponse
   | NotAddAnotherGoF
   | NotApplicationPipelineGoF
   | PortalIsDeleted
   | PortalNotFound

export type CreateApplicationAddAnotherGoFParams = {
   applicationId: Scalars['String']
   gofId: Scalars['String']
}

export type CreateApplicationAddAnotherGoFResponse =
   | AddAnotherGoFResponsesLimitReached
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GoFIsDeleted
   | GoFNotFound
   | GoFResponse
   | NotAddAnotherGoF
   | NotApplicationPipelineGoF

export type CreateApplicationInPortalParams = {
   displayStageId?: InputMaybe<Scalars['String']>
   pipelineId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   relatedEntities?: InputMaybe<Array<LinkRelatedEntityParams>>
   unifiedResponses?: InputMaybe<Array<FieldReferenceResponseParams>>
}

export type CreateApplicationInPortalResponse =
   | AlreadyOneEntityExistInOneToOneRelation
   | ApplicationDisplayStageNotConfiguredForPipeline
   | CircularRelatedEntitiesFound
   | CreateApplicationInPortalResult
   | CurrentEntityAlreadyLinkedToAnotherEntityInOneToMany
   | DisplayStageNotFound
   | MultipleEntitiesNotSupportedInOneToManyRelation
   | NotApplicationPipeline
   | PipelineNotFound
   | PortalNotFound
   | RelatedEntitiesMaxCountExceeded
   | RelatedEntitiesNotFound
   | RelatedEntityAlreadyExistInOneToOneRelation
   | RelationAreDeleted
   | RelationDirectionIsRequiredForSelfRelations
   | RelationsNotFound
   | StageNotConfiguredForPipeline
   | TGbPassFileNumberNotFound
   | YouCanLinkRelatedEntitiesToOnlyOneEntityInOneToMany

export type CreateApplicationInPortalResult = {
   __typename?: 'CreateApplicationInPortalResult'
   applicationId: Scalars['String']
   applicationTemplateId: Scalars['String']
   displayStageId?: Maybe<Scalars['String']>
   isCopyingRelatedApplicationFieldsInitiated: Scalars['Boolean']
   pipelineId: Scalars['String']
   portalId: Scalars['String']
}

export type CreateApplicationParams = {
   assigneeFieldIdsToNotify: Array<Scalars['String']>
   fieldResponses: Array<FieldResponseParams>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
   recordCreationConfigId: Scalars['Int']
}

export type CreateApplicationResponse =
   | AccountAccessDeniedToAssignees
   | AddAnotherFieldsAreNotSupported
   | ApplicationAlreadyExists
   | ApplicationCreatedOnShouldBeInPast
   | ApplicationCreationNotSupportedFields
   | ApplicationCustomerIdNotFound
   | AssigneesAreDeactivated
   | AssigneesNotFound
   | AtLeastOneApplicationIdentificationFieldIsRequired
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | CreateApplicationResult
   | DecimalPrecisionExceeded
   | DuplicateAssigneeFieldIdsToNotify
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | FieldIdsNotInPipeline
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsAreNotInRecordCreationConfig
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidAssigneeFieldIdsToNotify
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldsWritePermission
   | NotAllowedFileFormats
   | NotApplicationFields
   | NotApplicationPipeline
   | ParentFieldsNotFilled
   | PipelineAccessDenied
   | PipelineAccessDeniedToAssignees
   | PipelineNotFound
   | RecordCreationConfigAccessDenied
   | RecordCreationConfigNotFound
   | RequiredFieldsNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageIsRequiredInPipelineItemCreation
   | StageNotAllowedInRecordCreationConfig
   | StageNotFound
   | StageNotInPipeline
   | UnSupportedSystemFieldIdsToEdit
   | UniqueFieldsResponseAlreadyExists
   | UserDoesNotHaveAccessToCreateApplication
   | YouDonNotHavePermissionToSetGivenUsersAsAssignees

export type CreateApplicationResult = {
   __typename?: 'CreateApplicationResult'
   applicationId: Scalars['String']
   applicationTemplateId: Scalars['String']
   hasPermission: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type CreateAssigneeFieldParams = {
   name: Scalars['String']
   referenceId?: InputMaybe<Scalars['String']>
   systemGofId: Scalars['String']
}

export type CreateAssigneeFieldResponse =
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | InvalidFieldReferenceIdFormat
   | NameIsRequired
   | PlainTextField
   | ReferenceIdAlreadyExistsInTemplate
   | UnsupportedSystemGoF
   | UserIsNotAnAdministrator

export type CreateAssigneeGroupParams = {
   assigneeFieldIds: Array<Scalars['String']>
   name: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
}

export type CreateAssigneeGroupResponse =
   | AssigneeFieldsAlreadyExistsInAnotherGroup
   | AssigneeFieldsGroupNameAlreadyExists
   | AssigneeGroup
   | DuplicateAssigneeFieldsInGroup
   | FieldsAreDeleted
   | FieldsNotFound
   | NotPipelineItemAssigneeFieldIds
   | PipelineItemTemplateNotFound
   | UserIsNotAnAdministrator

export type CreateAutomationWorkflowConditionParams = {
   fieldId: Scalars['String']
   fieldSource: FilterFieldSourceType
   filterId: Scalars['String']
   filterSetEntity: AutomationWorkflowFilterSetEntityType
   multiValues?: InputMaybe<Array<AutomationWorkflowConditionValueParams>>
   operator: AutomationWorkflowOperator
   upRefAssigneeFieldId?: InputMaybe<Scalars['String']>
   value?: InputMaybe<AutomationWorkflowConditionValueParams>
}

export type CreateAutomationWorkflowConditionResponse =
   | AutomationWorkflowCondition
   | ConditionFieldShouldBeUniqueFieldType
   | ConditionFieldShouldBelongsToRelatedSalesTemplate
   | FieldReferenceIsNotSupportedForGivenOperators
   | FieldSourceIsNotSupportedForOperator
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FilterNotFound
   | InvalidConditionDirectValue
   | InvalidFilterFieldOptions
   | NotConditionNodeFilterSet
   | NotEditableNode
   | NotEditableTrigger
   | NotFilterSetEntityFilterSet
   | NotPipelineItemAssigneeFieldIds
   | NotScheduledTriggerFilterSet
   | NotSupportedFilterSetEntityForRelativeOperators
   | NotSupportedValueSourceForRelativeOperators
   | OperatorIsNotSupportedForField
   | OperatorIsNotSupportedForTrigger
   | OperatorIsNotSupportedForUpdatePipelineItemAssigneeFilterSet
   | PayloadIsNotSupportedInScheduledTrigger
   | StagesNotFound
   | UnSupportedFieldTypeForApplyAutomationWorkflowFiltersOn
   | UnSupportedFilterFieldSourceForApplyAutomationWorkflowFiltersOn
   | UnSupportedFilterValueFromForApplyAutomationWorkflowFiltersOn
   | UnSupportedOperatorForApplyAutomationWorkflowFiltersOn
   | UpRefAssigneeFieldIsRequired
   | UserIsNotAnAdministrator
   | UsersNotFound

export type CreateAutomationWorkflowFilterParams = {
   conditionsLogicalOperator: LogicalOperator
   filterSetId: Scalars['String']
   name: Scalars['String']
}

export type CreateAutomationWorkflowFilterResponse =
   | AutomationWorkflowFilter
   | AutomationWorkflowFilterSetNotFound
   | NotEditableNode
   | UserIsNotAnAdministrator

export type CreateAutomationWorkflowNodeParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   name?: InputMaybe<Scalars['String']>
   nodeType: NodeType
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
}

export type CreateAutomationWorkflowNodeResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | CreateAutomationWorkflowNodeResult
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateAutomationWorkflowNodeResult = {
   __typename?: 'CreateAutomationWorkflowNodeResult'
   node: Node
}

export type CreateBarGraphParams = {
   analyticsLevel: AnalyticsLevel
   dashboardId?: InputMaybe<Scalars['String']>
   dataSources: Array<AnalyticsDataSourceType>
   description?: InputMaybe<Scalars['String']>
   dimension?: InputMaybe<GraphDimensionParams>
   metric?: InputMaybe<GraphMetricParams>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateBarGraphResponse =
   | BarGraphConfig
   | DashboardAnalyticsLevelMismatch
   | DashboardNotFound
   | DashboardNotInPipeline
   | EmptyGraphDataSources
   | GraphCreationNotAllowedInExternalDashboard
   | GraphNameIsRequired
   | LeadOrDealDataSourceMustExists
   | NotSupportedDataSources
   | NotSupportedMultipleDataSources
   | PipelineAccessDenied
   | PipelineNotFound
   | UnsupportedDataSourcesForPipeline
   | UserIsNotAnAdministrator

export type CreateBoardListParams = {
   boardId: Scalars['String']
   name: Scalars['String']
}

export type CreateBoardListResponse =
   | BoardList
   | BoardNotFound
   | UserIsNotAnAdministrator
   | UserNotHavePermissionToCreateBoardList

export type CreateBoardParams = {
   description?: InputMaybe<Scalars['String']>
   displayName?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: BoardParentType
}

export type CreateBoardResponse =
   | Board
   | BoardDisplayNameIsRequired
   | PipelineAccessDenied
   | PipelineNotFound
   | UserNotHavePermissionToCreateBoard

export type CreateCalendarPipelineItemScheduleParams = {
   durationInMins: Scalars['Int']
   guestEmailFieldIds: Array<Scalars['String']>
   guestEmailIds: Array<Scalars['String']>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   remindersInMins: Array<Scalars['Int']>
   scheduledDatetime: Scalars['String']
   title: Scalars['String']
}

export type CreateCalendarPipelineItemScheduleResponse =
   | CalendarEventDurationCannotBeNegative
   | CalendarPipelineItemSchedule
   | EmailFieldsHasEmptyResponse
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | GoogleAuthConsentNotGiven
   | GoogleAuthConsentRefreshRequired
   | GoogleCalendarApiRequestsQuotaExceeded
   | InvalidGuestEmailIds
   | NotEmailFields
   | NotPermittedFields
   | PipelineItemAccessDenied
   | PipelineItemAlreadyScheduled
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineItemsAreAlreadyScheduled
   | RemindBeforeInMinsCannotBeNegative
   | RemindersInMinsCannotBeNegative
   | RemindersLimitExceeded
   | ScheduledDatetimeMustBeInFuture
   | ScheduledReminderMustBeInFuture
   | ScheduledRemindersMustBeInFuture

export type CreateCheckboxGroupFieldParams = {
   defaultValues: Array<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
}

export type CreateCheckboxGroupFieldResponse =
   | CannotEditSystemGoF
   | CheckboxGroupField
   | DefaultValuesMustBeInGivenOptions
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | DoubleHashIsNotSupportedInOptions
   | EmptyValuesForFieldValues
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateConditionNodeFilterParams = {
   conditionsLogicalOperator: LogicalOperator
   name: Scalars['String']
   nodeId: Scalars['String']
}

export type CreateConditionNodeFilterResponse =
   | AutomationWorkflowFilter
   | NodeNotFound
   | NotConditionNode
   | NotConditionNodeFilterSet
   | NotEditableNode
   | UserIsNotAnAdministrator

export type CreateConditionParams = {
   dataSource?: InputMaybe<AnalyticsDataSourceType>
   fieldId: Scalars['String']
   filterId: Scalars['String']
   filterSetEntity: FilterSetEntityType
   operator: FilterOperator
   /** @deprecated No need of templateId here */
   templateId?: InputMaybe<Scalars['String']>
   value?: InputMaybe<Scalars['String']>
}

export type CreateConditionResponse =
   | ActivityTemplatesNotFound
   | Condition
   | DataSourceIsRequiredForFilterSetEntity
   | DataSourceNotInFilterSetEntityDataSources
   | FieldIsDeleted
   | FieldNotFound
   | FilterNotFound
   | FilterSetAccessDenied
   | FilterSetNotLinkedToBoard
   | FilterSetNotLinkedToBoardList
   | FilterSetNotLinkedToGivenEntity
   | FilterSetNotLinkedToGraph
   | FilterSetNotLinkedToView
   | FiltersNotSupportedForExternalDashboard
   | GraphMetricNotFound
   | InvalidFilterFieldOptions
   | InvalidFilterFieldValue
   | MetricNotLinkedToGraph
   | NotAllowedFilterField
   | NotAllowedToEditBoardFilterSet
   | NotAllowedToEditBoardListFilterSet
   | NotEditableFilterSetEntity
   | NotPermittedField
   | NotSalesTemplateFieldId
   | NotSupportedCallAnalyticsFilterFieldOperator
   | NotSupportedContactFilterFieldOperator
   | NotSupportedDynamicFilterFieldOperator
   | NotSupportedFieldTypeOperator
   | NotSupportedFilterFieldOperator
   | NotSupportedFilterSetEntityForCallAnalyticsFilterField
   | NotSupportedSystemFieldOperator
   | NotUserFilterSet
   | PhoneNumberValueFormatIsNotValid
   | PipelinesAccessDenied
   | PipelinesNotFound
   | StagesNotFound
   | TaskTemplatesNotFound
   | UserIsNotAnAdministrator
   | UsersNotFound
   | ViewAccessDenied

export type CreateContactTemplateGoFParams = {
   contactTemplateId: Scalars['String']
   description?: InputMaybe<Scalars['String']>
   name: Scalars['String']
}

export type CreateContactTemplateGoFResponse =
   | ContactTemplateNotFound
   | GoF
   | GoFNameAlreadyExists
   | UserIsNotAnAdministrator

export type CreateCustomIdFieldParams = {
   enableAutoGenerate: Scalars['Boolean']
   name: Scalars['String']
   referenceId?: InputMaybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type CreateCustomIdFieldResponse =
   | CustomIdFieldIsNotSupportedInSalesTemplate
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | InvalidFieldReferenceIdFormat
   | PlainTextField
   | ReferenceIdAlreadyExistsInTemplate
   | SalesTemplateNotFound
   | SalesTemplateSystemFieldAlreadyExists
   | UserIsNotAnAdministrator

export type CreateDashboardParams = {
   analyticsLevel?: InputMaybe<AnalyticsLevel>
   externalDashboardUrl?: InputMaybe<Scalars['String']>
   identificationIds: Array<Scalars['String']>
   isExternalDashboard: Scalars['Boolean']
   name: Scalars['String']
   pipelineId?: InputMaybe<Scalars['String']>
   userHierarchyFilter?: InputMaybe<UserHierarchyFilter>
}

export type CreateDashboardResponse =
   | Dashboard
   | IdentificationsNotFound
   | InvalidExternalDashboardUrl
   | PipelineAccessDenied
   | PipelineNotFound
   | ProvideValidLookerStudioUrl
   | UserAndIdentificationsAreNotInSameAccount
   | UserIsNotAnAdministrator

export type CreateDateFieldParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   relativeDefaultValueConfig?: InputMaybe<DateRelativeDefaultValueConfigParams>
   tooltip?: InputMaybe<Scalars['String']>
}

export type CreateDateFieldResponse =
   | CannotEditSystemGoF
   | DateField
   | DaysShouldBePositive
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | OnlySingleTypeOfDefaultValueIsAllowed
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateDateTimeFieldParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   relativeDefaultValueConfig?: InputMaybe<
      DateTimeRelativeDefaultValueConfigParams
   >
   tooltip?: InputMaybe<Scalars['String']>
}

export type CreateDateTimeFieldResponse =
   | CannotEditSystemGoF
   | DateTimeField
   | DaysShouldBePositive
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | OnlySingleTypeOfDefaultValueIsAllowed
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | SecondsShouldBePositive
   | UserIsNotAnAdministrator

export type CreateDealAddAnotherGoFParams = {
   dealId: Scalars['String']
   gofId: Scalars['String']
}

export type CreateDealAddAnotherGoFResponse =
   | AddAnotherGoFResponsesLimitReached
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound
   | GoFIsDeleted
   | GoFNotFound
   | GoFResponse
   | NotAddAnotherGoF
   | NotDealTemplateGoF

export type CreateDocumentLogParams = {
   documentId: Scalars['String']
   logType: DocumentLogType
   portalType: DocumentLogPortalType
}

export type CreateDocumentLogResponse =
   | CreateDocumentLogResult
   | DocumentNotFound

export type CreateDocumentLogResult = {
   __typename?: 'CreateDocumentLogResult'
   documentLog: DocumentLog
}

export type CreateDocumentTemplateParams = {
   description?: InputMaybe<Scalars['String']>
   documentTemplateFile?: InputMaybe<FileUploaderUrlParams>
   name: Scalars['String']
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
   templateType?: InputMaybe<DocumentTemplateType>
   validateEmptyFormFields: Scalars['Boolean']
}

export type CreateDocumentTemplateResponse =
   | AdminDocumentTemplate
   | DocumentTemplateFileTooLarge
   | DocumentTemplateHasEmptyFormFields
   | DocumentTemplateNameAlreadyExists
   | NotPdfFileUrl
   | PipelineItemTemplateNotFound
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type CreateDonutChartParams = {
   analyticsLevel: AnalyticsLevel
   dashboardId?: InputMaybe<Scalars['String']>
   dataSources: Array<AnalyticsDataSourceType>
   description?: InputMaybe<Scalars['String']>
   dimension?: InputMaybe<GraphDimensionParams>
   metric?: InputMaybe<GraphMetricParams>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateDonutChartResponse =
   | DashboardAnalyticsLevelMismatch
   | DashboardNotFound
   | DashboardNotInPipeline
   | DonutChartConfig
   | EmptyGraphDataSources
   | GraphCreationNotAllowedInExternalDashboard
   | GraphNameIsRequired
   | LeadOrDealDataSourceMustExists
   | NotSupportedDataSources
   | NotSupportedMultipleDataSources
   | PipelineAccessDenied
   | PipelineNotFound
   | UnsupportedDataSourcesForPipeline
   | UserIsNotAnAdministrator

export type CreateDropdownFieldParams = {
   allowOtherOptions?: InputMaybe<Scalars['Boolean']>
   conditionalOptions?: InputMaybe<Array<ConditionalFieldOptionsParams>>
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isLabelsEnabled?: InputMaybe<Scalars['Boolean']>
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   optionColors?: InputMaybe<Array<OptionColorParams>>
   options: Array<Scalars['String']>
   optionsValueType?: InputMaybe<OptionsValueType>
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
   uiStyle?: InputMaybe<DropdownFieldUiStyleEnum>
}

export type CreateDropdownFieldResponse =
   | CannotEditSystemGoF
   | ConditionalOptionsNotSupportedForFieldType
   | ConditionalOptionsParentFieldTypeNotSupported
   | ConditionalOptionsParentFieldsAreNotInSameGof
   | DefaultValueMustBeInGivenOptions
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | DoubleHashIsNotSupportedInOptions
   | DropdownField
   | DuplicateOptionsInLabelColorConfig
   | EmptyValuesForFieldValues
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | OptionsWithColorsNotGivenInFieldConfig
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateEmailFieldParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   regexErrorMessage?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
   validationRegex?: InputMaybe<Scalars['String']>
}

export type CreateEmailFieldResponse =
   | CannotAddUniqueFieldInAddAnotherGof
   | CannotEditSystemGoF
   | DefaultValueNotAllowedForUniqueField
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | EmailField
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | GoFIsDeleted
   | GoFNotFound
   | InvalidDefaultValue
   | InvalidFieldReferenceIdFormat
   | InvalidValidationRegex
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateEntityCustomCheckpointParams = {
   categoryId: Scalars['String']
   entityId: Scalars['String']
   entityType: CategoryEntityType
   text: Scalars['String']
}

export type CreateEntityCustomCheckpointResponse =
   | CategoryEntityAccessDenied
   | CategoryEntityNotFound
   | CategoryNotFound
   | CreateEntityCustomCheckpointResult

export type CreateEntityCustomCheckpointResult = {
   __typename?: 'CreateEntityCustomCheckpointResult'
   categoryId: Scalars['String']
   checkpoint: CategoryCheckpoint
   entityId: Scalars['String']
   entityType: CategoryEntityType
}

export type CreateEntityDealParams = {
   assigneeFieldIdsToNotify?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   assigneeId?: InputMaybe<Scalars['String']>
   assignees: Array<AssigneeFieldParams>
   dealEntityId: Scalars['String']
   dealEntityType: DealEntityType
   stageId: Scalars['String']
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
   title?: InputMaybe<Scalars['String']>
}

export type CreateEntityDealResponse =
   | Deal
   | DealAssigneeIsDeactivated
   | DealAssigneeNotFound
   | DealAssigneesAreDeactivated
   | DealAssigneesNotFound
   | DealEntityAccessDenied
   | DealEntityIsDeleted
   | DealEntityNotFound
   | DuplicateAssigneeFieldIdsToNotify
   | DuplicateFieldIds
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidAssigneeFieldIdsToNotify
   | NeedFieldsWritePermission
   | NotAssigneeFieldIds
   | NotDealPipelineStage
   | NotDealTemplateFields
   | PipelineAccessDenied
   | PipelineAccessDeniedToAssignee
   | RequiredFieldsNotFilled
   | StageNotFound

export type CreateEntityFeeRuleSetParams = {
   entityId: Scalars['String']
   feeRuleSetId: Scalars['String']
   mandatoryFields?: InputMaybe<Array<InputMaybe<FieldResponseParams>>>
   version?: InputMaybe<GraphqlApiVersionEnum>
}

export type CreateEntityFeeRuleSetResponse =
   | AddAnotherFieldsAreNotSupported
   | CreateEntityFeeRuleSetResult
   | DecimalPrecisionExceeded
   | DraftEntityFeeRuleSetAlreadyExists
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | EntityFeeRuleSet
   | EntityFeeRuleSetAlreadyExists
   | FeeRuleSetNotFound
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MandatoryFieldsResponseNotFilled
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotSalesTemplateFieldIds
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UniqueFieldResponseAlreadyExists

export type CreateEntityFeeRuleSetResult = {
   __typename?: 'CreateEntityFeeRuleSetResult'
   changedFields: Array<FieldResponse>
   entityFeeRuleSet: EntityFeeRuleSet
}

export type CreateEventBasedAutomationWorkflowParams = {
   eventTrigger: CreateEventTriggerParams
   execType?: InputMaybe<AutomationWorkflowExecType>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateEventBasedAutomationWorkflowResponse =
   | AutomationWorkflow
   | AutomationWorkflowExecTypeAlreadyConfiguredInTrigger
   | AutomationWorkflowExecTypeNotSupportedInTrigger
   | AutomationWorkflowNameAlreadyExists
   | EntityTemplateNotFound
   | FieldsAreDeleted
   | FieldsAreNotSupportedInPipelineItemUpdatedTrigger
   | FieldsNotFound
   | NotSupportedEventBasedTriggerForPipeline
   | PipelineAccessDenied
   | PipelineItemUpdatedTriggerConfigIsRequired
   | PipelineNotFound
   | StageUpdatedTriggerConfigIsRequired
   | StagesNotFound
   | TaskUpdatedTriggerConfigIsRequired
   | UnsupportedEventBasedTrigger
   | UserIsNotAnAdministrator

export type CreateEventBasedLeadDistributionRuleParams = {
   name: Scalars['String']
   pipelineId: Scalars['String']
   trigger: EventBasedLeadDistributionRuleTriggerParams
}

export type CreateEventBasedLeadDistributionRuleResponse =
   | EventBasedLeadDistributionRuleAlreadyExistsForTrigger
   | LdRuleStageUpdatedTriggerConfigIsRequired
   | LeadDistributionEventTriggerEntityTemplateNotFound
   | LeadDistributionRule
   | LeadDistributionRuleNameAlreadyExists
   | NotLeadPipeline
   | PipelineNotFound
   | UnsupportedLeadDistributionEventBasedTrigger
   | UserIsNotAnAdministrator

export type CreateEventTriggerConditionParams = {
   fieldId: Scalars['String']
   fieldSource: EventTriggerFilterFieldSourceType
   filterId: Scalars['String']
   filterSetEntity: EventTriggerFilterSetEntity
   multiValues?: InputMaybe<Array<EventTriggerConditionValueParams>>
   operator: EventTriggerOperator
   value?: InputMaybe<EventTriggerConditionValueParams>
}

export type CreateEventTriggerConditionResponse =
   | EventTriggerCondition
   | EventTriggerFilterFieldSourceIsNotSupportedForOperator
   | EventTriggerFilterNotFound
   | EventTriggerFilterSetNotLinkedToGivenEntity
   | EventTriggerOperatorIsNotSupportedForField
   | EventTriggerOperatorIsNotSupportedForTrigger
   | FieldReferenceIsNotSupportedForGivenEventTriggerOperators
   | FieldsAreDeleted
   | FieldsAreNotSupportedInEventTrigger
   | FieldsNotFound
   | InvalidEventTriggerConditionDirectValue
   | InvalidEventTriggerFilterFieldOptions
   | NotEditableEventTriggerFilterSetEntity
   | NotSupportedValueFieldSourceForEventTriggerRelativeOperators
   | StagesNotFound
   | UserIsNotAnAdministrator
   | UsersNotFound

export type CreateEventTriggerFilterParams = {
   conditionsLogicalOperator: LogicalOperator
   filterSetEntity: EventTriggerFilterSetEntity
   filterSetId: Scalars['String']
   name: Scalars['String']
}

export type CreateEventTriggerFilterResponse =
   | EventTriggerFilter
   | EventTriggerFilterSetNotFound
   | EventTriggerFilterSetNotLinkedToGivenEntity
   | NotEditableEventTriggerFilterSetEntity
   | UserIsNotAnAdministrator

export type CreateEventTriggerParams = {
   entity: TriggerEntity
   entityTemplateId: Scalars['String']
   pipelineItemUpdatedConfig?: InputMaybe<
      PipelineItemUpdatedTriggerConfigParams
   >
   stageUpdatedConfig?: InputMaybe<StageUpdatedTriggerConfigParams>
   taskUpdatedConfig?: InputMaybe<TaskUpdatedTriggerConfigParams>
   triggerEventType: TriggerEventType
}

export type CreateFieldsSelectorFieldParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   dependentFields: Array<DependentFieldsParams>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
   uiStyle?: InputMaybe<FieldSelectorFieldUiStyleEnum>
}

export type CreateFieldsSelectorFieldResponse =
   | AlreadyUsedDependentFieldIds
   | CannotCreateFieldsSelectorFieldToUserPropertiesGoF
   | CannotEditSystemGoF
   | CircularParentFieldsAreNotAllowed
   | DefaultValueMustBeInGivenOptions
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | DoubleHashIsNotSupportedInOptions
   | DuplicateFieldsSelectorDependentOptions
   | EmptyValuesForFieldValues
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | FieldsSelectorField
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | InvalidFieldsSelectorDependentOptions
   | NonDependentFields
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateFileUploaderFieldParams = {
   allowPublicAccess: Scalars['Boolean']
   allowedFormats: Array<Scalars['String']>
   canDownload: Scalars['Boolean']
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   eachFileMaxSizeInKb: Scalars['Int']
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   maxNumberOfFilesToUpload: Scalars['Int']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
}

export type CreateFileUploaderFieldResponse =
   | CannotAddUniqueFieldInAddAnotherGof
   | CannotEditSystemGoF
   | DefaultValueFormatNotInAllowedFormats
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | FileSizeCannotBeNegativeOrZero
   | FileSizeMaxLimitExceeded
   | FileUploaderField
   | GoFIsDeleted
   | GoFNotFound
   | InvalidAllowedFormats
   | InvalidFieldReferenceIdFormat
   | MaxNumberOfFilesCannotBeNegativeOrZero
   | NumberOfFilesMaxLimitExceeded
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateFilterForBoardListParams = {
   boardListId: Scalars['String']
   conditionsLogicalOperator: LogicalOperator
   name: Scalars['String']
}

export type CreateFilterForBoardListResponse =
   | BoardListNotFound
   | Filter
   | UserIsNotAnAdministrator

export type CreateFilterForBoardParams = {
   boardId: Scalars['String']
   conditionsLogicalOperator: LogicalOperator
   name: Scalars['String']
}

export type CreateFilterForBoardResponse =
   | BoardNotFound
   | Filter
   | UserIsNotAnAdministrator

export type CreateFilterForViewParams = {
   conditionsLogicalOperator: LogicalOperator
   name: Scalars['String']
   viewId: Scalars['String']
}

export type CreateFilterForViewResponse =
   | Filter
   | ViewAccessDenied
   | ViewNotFound

export type CreateFilterParams = {
   conditionsLogicalOperator: LogicalOperator
   filterSetEntity: FilterSetEntityType
   filterSetId: Scalars['String']
   name: Scalars['String']
}

export type CreateFilterResponse =
   | Filter
   | FilterSetAccessDenied
   | FilterSetNotFound
   | FilterSetNotLinkedToBoard
   | FilterSetNotLinkedToBoardList
   | FilterSetNotLinkedToGivenEntity
   | FilterSetNotLinkedToGraph
   | FilterSetNotLinkedToView
   | FiltersNotSupportedForExternalDashboard
   | NotAllowedToEditBoardFilterSet
   | NotAllowedToEditBoardListFilterSet
   | NotEditableFilterSetEntity
   | NotUserFilterSet
   | UserIsNotAnAdministrator

export type CreateFloatFieldParams = {
   decimalPrecisionLimit?: InputMaybe<Scalars['Int']>
   defaultValue?: InputMaybe<Scalars['Float']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   formulaExpression?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isFormulaEnabled?: InputMaybe<Scalars['Boolean']>
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   rangeConfig?: InputMaybe<FloatRangeParams>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
}

export type CreateFloatFieldResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotAddUniqueFieldInAddAnotherGof
   | CannotEditSystemGoF
   | CannotEnableFormulaStatusInAddAnotherField
   | DecimalPrecisionLimitMustBePositive
   | DefaultValueAllowedForNonUniqueFields
   | DefaultValueMustSatisfyGivenFloatRange
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | FieldsAreDeleted
   | FieldsNotFound
   | FloatField
   | FormulaExpressionIsRequired
   | FormulaFieldsAreNotAllowed
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | InvalidFormulaExpression
   | MaxValueLessThanMinValue
   | NotSupportedFieldTypes
   | NotSupportedFields
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | RangeCannotBeConfiguredForUniqueFields
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateFormParams = {
   activityTemplateId?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: FormParentType
}

export type CreateFormResponse =
   | ActivityTemplateNotFound
   | Form
   | IncompatibleActivityTemplateWithParent
   | IncompatibleUserAccountWithParent
   | ParentIdIsRequired
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type CreateFunnelGraphParams = {
   dashboardId: Scalars['String']
   dataSources: Array<AnalyticsDataSourceType>
   description?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateFunnelGraphResponse =
   | DashboardAccessDenied
   | DashboardAnalyticsLevelMismatch
   | DashboardNotFound
   | DashboardNotInPipeline
   | EmptyGraphDataSources
   | FunnelGraphConfig
   | GraphCreationNotAllowedInExternalDashboard
   | GraphNameIsRequired
   | NotSupportedDataSources
   | PipelineNotFound
   | UnsupportedDataSourcesForPipeline
   | UserIsNotAnAdministrator

export type CreateGeoLocationFieldParams = {
   addressFieldIds?: InputMaybe<Array<Scalars['String']>>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
}

export type CreateGeoLocationFieldResponse =
   | CannotEditSystemGoF
   | DeletedFieldExistsWithFieldName
   | DeletedFieldExistsWithFieldReferenceId
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | FieldsAreDeleted
   | FieldsNotFound
   | GeoLocationField
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | NotSupportedFieldTypes
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateGeoShapeFieldParams = {
   addressFieldIds?: InputMaybe<Array<Scalars['String']>>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
   variantType: GeoShapeVariantType
}

export type CreateGeoShapeFieldResponse =
   | CannotEditSystemGoF
   | DeletedFieldExistsWithFieldName
   | DeletedFieldExistsWithFieldReferenceId
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | FieldsAreDeleted
   | FieldsNotFound
   | GeoShapeField
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | NotSupportedFieldTypes
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateGraphDimensionParams = {
   dataSource: AnalyticsDataSourceType
   fieldId: Scalars['String']
   graphId: Scalars['String']
   groupByType: GraphAggType
   histogramInterval?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   ranges: Array<Range>
   sortValue?: InputMaybe<SortValue>
}

export type CreateGraphDimensionResponse =
   | EmptyHistogramIntervalForHistogramGroupByType
   | EmptyRangesForRangeGroupByType
   | FieldIdNotInPipeline
   | FieldIsDeleted
   | FieldNotFound
   | GraphDimension
   | GraphDimensionFieldsShouldBeUnique
   | GraphHasMultipleMetrics
   | GraphNotFound
   | InvalidDateHistogramInterval
   | InvalidGraphFieldValue
   | NotAllowedToCreateGraphDimension
   | NotAllowedToCreateMoreThanTwoGraphDimensions
   | UnSupportedDataSourceField
   | UnSupportedGroupByFieldDataSource
   | UnSupportedGroupByFieldType
   | UnSupportedGroupByTypeField
   | UnSupportedGroupByTypeFieldType
   | UserIsNotAnAdministrator

export type CreateGraphMetricParams = {
   canShowMetric: Scalars['Boolean']
   dataSource?: InputMaybe<AnalyticsDataSourceType>
   fieldId?: InputMaybe<Scalars['String']>
   formulaNodes?: InputMaybe<Array<MetricFormulaNodeParams>>
   graphId: Scalars['String']
   metricType: MetricType
   name?: InputMaybe<Scalars['String']>
}

export type CreateGraphMetricResponse =
   | CustomMetricsNotAllowedInFormula
   | DataSourceIsNotRequired
   | DataSourceIsRequired
   | FieldIdNotInPipeline
   | FieldIsDeleted
   | FieldNotFound
   | FormulaIsNotValid
   | GraphHasMultipleDimensions
   | GraphMetric
   | GraphNotFound
   | MetricsInFormulaNotLinkedToSameGraph
   | NotAllowedToCreateGraphMetric
   | NotSupportedGraphMetricField
   | UnSupportedDataSourceField
   | UnSupportedMetricField
   | UnSupportedMetricFieldDataSource
   | UserIsNotAnAdministrator
   | ZeroDivisionFound

export type CreateGroupedBarGraphParams = {
   analyticsLevel: AnalyticsLevel
   dataSources: Array<AnalyticsDataSourceType>
   description?: InputMaybe<Scalars['String']>
   firstDimension?: InputMaybe<GraphDimensionParams>
   metric?: InputMaybe<GraphMetricParams>
   name: Scalars['String']
   pipelineId: Scalars['String']
   secondDimension?: InputMaybe<GraphDimensionParams>
}

export type CreateGroupedBarGraphResponse =
   | GraphNameIsRequired
   | GroupedBarGraphConfig
   | NotSupportedGraphSalesEntityType
   | NotSupportedPipelineForGraphSalesEntityType
   | PipelineAccessDenied
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type CreateIdentificationParams = {
   identificationType: IdentificationType
   name: Scalars['String']
   profilePicUrl?: InputMaybe<Scalars['String']>
}

export type CreateIntegerFieldParams = {
   defaultValue?: InputMaybe<Scalars['Int']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   formulaExpression?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isFormulaEnabled?: InputMaybe<Scalars['Boolean']>
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   rangeConfig?: InputMaybe<IntegerRangeParams>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
}

export type CreateIntegerFieldResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotAddUniqueFieldInAddAnotherGof
   | CannotEditSystemGoF
   | CannotEnableFormulaStatusInAddAnotherField
   | DefaultValueAllowedForNonUniqueFields
   | DefaultValueMustSatisfyGivenIntegerRange
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | FieldsAreDeleted
   | FieldsNotFound
   | FormulaExpressionIsRequired
   | FormulaFieldsAreNotAllowed
   | GoFIsDeleted
   | GoFNotFound
   | IntegerField
   | InvalidFieldReferenceIdFormat
   | InvalidFormulaExpression
   | MaxValueLessThanMinValue
   | NotSupportedFieldTypes
   | NotSupportedFields
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | RangeCannotBeConfiguredForUniqueFields
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateLayoutParams = {
   entityId: Scalars['String']
   entityType: LayoutEntityType
   pipelineId?: InputMaybe<Scalars['String']>
}

export type CreateLayoutResponse =
   | Layout
   | LayoutConfigAlreadyExistsForEntity
   | LayoutEntityNotFound
   | LayoutEntityNotInPipeline
   | PipelineAccessDenied
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type CreateLeadAddAnotherGoFParams = {
   gofId: Scalars['String']
   leadId: Scalars['String']
}

export type CreateLeadAddAnotherGoFResponse =
   | AddAnotherGoFResponsesLimitReached
   | GoFIsDeleted
   | GoFNotFound
   | GoFResponse
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound
   | NotAddAnotherGoF
   | NotLeadTemplateGoF

export type CreateLeadBucketParams = {
   leadDistributionRuleId: Scalars['String']
   name: Scalars['String']
}

export type CreateLeadBucketResponse =
   | AllocationGroupSetsExistsInLeadPool
   | EmptyLeadBucketName
   | LeadBucket
   | LeadBucketNameAlreadyExists
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | UserIsNotAnAdministrator

export type CreateLeadDistributionRuleParams = {
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateLeadDistributionRuleResponse =
   | EmptyLeadDistributionRuleName
   | LeadDistributionRule
   | LeadDistributionRuleNameAlreadyExists
   | NotLeadPipeline
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type CreateLeadWithContactParams = {
   assigneeFieldIdsToNotify?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   fieldResponses: Array<FieldResponseParams>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
   recordCreationConfigId?: InputMaybe<Scalars['Int']>
}

export type CreateLeadWithContactResponse =
   | AccountAccessDeniedToAssignees
   | AddAnotherFieldsAreNotSupported
   | AssigneesAreDeactivated
   | AssigneesNotFound
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | ContactAlreadyExists
   | CreateLeadWithContactResult
   | DecimalPrecisionExceeded
   | DuplicateAssigneeFieldIdsToNotify
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | FieldIdsNotInPipeline
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsAreNotInRecordCreationConfig
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidAssigneeFieldIdsToNotify
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | LeadAlreadyExists
   | LeadCreatedOnShouldBeInPast
   | LeadCreationNotSupportedFields
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | MultipleContactsFound
   | NeedFieldsWritePermission
   | NotAllowedFileFormats
   | NotLeadOrContactFields
   | NotLeadPipeline
   | ParentFieldsNotFilled
   | PipelineAccessDenied
   | PipelineAccessDeniedToAssignees
   | PipelineNotFound
   | RecordCreationConfigAccessDenied
   | RecordCreationConfigNotFound
   | RequiredFieldsNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageIsRequiredInPipelineItemCreation
   | StageNotAllowedInRecordCreationConfig
   | StageNotFound
   | StageNotInPipeline
   | UnSupportedSystemFieldIdsToEdit
   | UniqueFieldsResponseAlreadyExists
   | UserDoesNotHaveAccessToCreateLeadWithContact
   | YouDonNotHavePermissionToSetGivenUsersAsAssignees

export type CreateLeadWithContactResult = {
   __typename?: 'CreateLeadWithContactResult'
   contactId: Scalars['String']
   hasPermission: Scalars['Boolean']
   leadId: Scalars['String']
   leadTemplateId: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateLineGraphParams = {
   analyticsLevel: AnalyticsLevel
   dashboardId?: InputMaybe<Scalars['String']>
   dataSources: Array<AnalyticsDataSourceType>
   description?: InputMaybe<Scalars['String']>
   dimension?: InputMaybe<GraphDimensionParams>
   drillDownDimension?: InputMaybe<GraphDimensionParams>
   metrics: Array<GraphMetricParams>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateLineGraphResponse =
   | DashboardAnalyticsLevelMismatch
   | DashboardNotFound
   | DashboardNotInPipeline
   | EmptyGraphDataSources
   | GraphCreationNotAllowedInExternalDashboard
   | GraphNameIsRequired
   | LeadOrDealDataSourceMustExists
   | LineGraphConfig
   | NotSupportedDataSources
   | NotSupportedMultipleDataSources
   | PipelineAccessDenied
   | PipelineNotFound
   | UnsupportedDataSourcesForPipeline
   | UserIsNotAnAdministrator

export type CreateLinkedFieldParams = {
   gofId: Scalars['String']
   isDependent: Scalars['Boolean']
   linkedSourceFieldId: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
}

export type CreateLinkedFieldResponse =
   | BothFieldsCannotBeSame
   | CannotEditSystemField
   | CannotEditSystemGoF
   | CircularParentIsNotAllowed
   | CreateLinkedFieldResult
   | DependentFieldNotFound
   | DependentFieldsMustBeOfSameGoF
   | FieldIsDeleted
   | FieldNameAlreadyExistsInGof
   | FieldNotFound
   | GoFIsDeleted
   | GoFNotFound
   | GofNotSupportedForLinkedField
   | LinkedFieldAndSourceFieldAreInSameTemplate
   | LinkedFieldsNotEnabledForTaskTemplate
   | LinkedSourceFieldNotFound
   | NotDependentField
   | OptionsShouldNotBeEmpty
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | SalesTemplateTypeNotSupportedForLinking
   | SourceFieldAlreadyLinkedInTemplate
   | SourceFieldAndSalesTemplateAreNotInSamePipeline
   | SystemFieldIsNotSupportedForLinking
   | UserIsNotAnAdministrator

export type CreateLinkedFieldResult = {
   __typename?: 'CreateLinkedFieldResult'
   linkedField: Field
   linkedSourceFieldId: Scalars['String']
}

export type CreateLongTextFieldParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   formulaExpression?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isFormulaEnabled?: InputMaybe<Scalars['Boolean']>
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   regexErrorMessage?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
   validationRegex?: InputMaybe<Scalars['String']>
}

export type CreateLongTextFieldResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotEditSystemGoF
   | CannotEnableFormulaStatusInAddAnotherField
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | FieldsAreDeleted
   | FieldsNotFound
   | FormulaExpressionIsRequired
   | FormulaFieldsAreNotAllowed
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | InvalidFormulaExpression
   | LongTextField
   | NotSupportedFieldTypes
   | NotSupportedFields
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UnSupportedOperators
   | UserIsNotAnAdministrator

export type CreateMultiSelectFieldParams = {
   allowOtherOptions?: InputMaybe<Scalars['Boolean']>
   conditionalOptions?: InputMaybe<Array<ConditionalFieldOptionsParams>>
   defaultValues: Array<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isLabelsEnabled?: InputMaybe<Scalars['Boolean']>
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   optionColors?: InputMaybe<Array<OptionColorParams>>
   options: Array<Scalars['String']>
   optionsValueType?: InputMaybe<OptionsValueType>
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
   uiStyle?: InputMaybe<MultiSelectFieldUiStyleEnum>
}

export type CreateMultiSelectFieldResponse =
   | CannotEditSystemGoF
   | ConditionalOptionsNotSupportedForFieldType
   | ConditionalOptionsParentFieldTypeNotSupported
   | ConditionalOptionsParentFieldsAreNotInSameGof
   | DefaultValuesMustBeInGivenOptions
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | DoubleHashIsNotSupportedInOptions
   | DuplicateOptionsInLabelColorConfig
   | EmptyValuesForFieldValues
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | MultiSelectField
   | OptionsWithColorsNotGivenInFieldConfig
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateNodeAddAnotherGoFParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   gofId?: InputMaybe<Scalars['String']>
   gofResponses: Array<NodeGoFResponseFieldsMappingParams>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
}

export type CreateNodeAddAnotherGoFResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AddAnotherGoFNode
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DirectValueNotSupportedOnUniqueFields
   | DuplicateGoFResponseUniqueIds
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FieldsNotInGoF
   | FormulaEvaluationLogicFailedInField
   | GoFNotFound
   | InvalidFieldValuesErrors
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotAddAnotherGoF
   | NotCompatibleValueFieldIds
   | NotGivenAutomationWorkflowNodes
   | NotLeadTemplateFieldIds
   | NotParentNode
   | NotSupportedComputedUpdateConfigForFields
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | UnSupportedFieldsForEnableDeepCopy
   | UnSupportedTriggerNodeType
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UserIsNotAnAdministrator

export type CreateNodeCallWebhookParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   contentType?: InputMaybe<ApiRequestContentTypeEnum>
   endPoint?: InputMaybe<Scalars['String']>
   headers: Array<HeaderParams>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   payload: Array<RequestPayloadMappingParams>
}

export type CreateNodeCallWebhookResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | CallWebhookNode
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DuplicateHeaderKeys
   | DuplicatePayloadKeys
   | EmptyHeaderValues
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidEndpoint
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotActivityTemplateFieldIds
   | NotEventBasedTriggerForStageFields
   | NotGivenAutomationWorkflowNodes
   | NotLeadTemplateFieldIds
   | NotParentNode
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParameterIdsNotFound
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | PhoneNumberValueFormatIsNotSupportedForFields
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeClearUndoneLeadTasksParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   taskTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type CreateNodeClearUndoneLeadTasksResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | ClearUndoneLeadTasksNode
   | InvalidTaskTemplateIds
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | TaskTemplatesNotInPipeline
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeConditionParams = {
   applyFiltersOn?: InputMaybe<ApplyConditionNodeFiltersOn>
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   relationId?: InputMaybe<Scalars['String']>
}

export type CreateNodeConditionResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | ConditionNode
   | DealPipelineRelationIsNotSupported
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | RelationIsDeleted
   | RelationIsRequiredForRelatedObjectsAutomationWorkflowsFilterSet
   | RelationNotFound
   | RelationNotInPipeline
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeCreatePipelineEventParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   fieldsMapping?: InputMaybe<Array<InputMaybe<FieldValueMappingParams>>>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   pipelineEventTemplateId?: InputMaybe<Scalars['String']>
   pipelineId?: InputMaybe<Scalars['String']>
}

export type CreateNodeCreatePipelineEventResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | CreatePipelineEventNode
   | DirectValueNotSupportedOnUniqueFields
   | DuplicateFieldIds
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormulaEvaluationLogicFailedInField
   | InvalidFieldValuesErrors
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotCompatibleValueFieldIds
   | NotEventBasedTriggerForStageFields
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | NotPipelineEventTemplateFieldIds
   | NotSupportedComputedUpdateConfigForFields
   | NotSupportedSystemFields
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | PipelineEventTemplateNotInGivenPipeline
   | PipelineNotFound
   | TriggerPipelineCannotBeSameWithCreatePipelineEventNode
   | UnSupportedPipelineItemTypeForNodeType
   | UnSupportedTriggerNodeType
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UserIsNotAnAdministrator

export type CreateNodeCreateRelatedRecordParams = {
   assignees: Array<CreateRelatedRecordNodeAssigneeParams>
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   customFields: Array<FieldValueMappingParams>
   displayStageId?: InputMaybe<Scalars['String']>
   mandatoryFields: Array<FieldValueMappingParams>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   pipelineStageValues?: InputMaybe<Array<PipelineStageValuesParams>>
   relationFields?: InputMaybe<Array<RelationFieldValueMappingParams>>
   relationId: Scalars['String']
   stageId?: InputMaybe<Scalars['String']>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type CreateNodeCreateRelatedRecordResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | ApplicationDisplayStageNotFound
   | ApplicationDisplayStageNotInRelationPipeline
   | AssigneesAreDeactivated
   | AssigneesNotFound
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | CreateRelatedRecordNode
   | DealPipelineRelationIsNotSupported
   | DirectValueNotSupportedInRelationFieldValueMappings
   | DirectValueNotSupportedOnUniqueFields
   | DisplayStagesNotFound
   | DuplicateFieldIds
   | DuplicatePipelineIds
   | DuplicateRelationFieldMappings
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormulaEvaluationLogicFailedInField
   | InvalidCreateRelatedRecordNodeMandatoryFields
   | InvalidFieldValuesErrors
   | InvalidPipelineStageIds
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotApplicationDisplayStage
   | NotCompatibleValueFieldIds
   | NotEventBasedTriggerForStageFields
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | NotRelatedPipelineTemplateFields
   | NotRelationFields
   | NotSupportedComputedUpdateConfigForFields
   | NotSupportedSystemFields
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | PipelineAccessDeniedToAssignees
   | PipelineAssigneeFieldsNotFound
   | PipelineNotFound
   | RelatedPipelineItemTemplateNotLinkedToPipelineIds
   | RelationIsDeleted
   | RelationNotFound
   | RelationNotInPipeline
   | RelationPipelineAssigneeFieldsNotFound
   | RelationsAreDeleted
   | RelationsAreNotFound
   | RelationsInAutomationWorkflowPipeline
   | RelationsNotInRelatedPipeline
   | StageNotFound
   | StageNotInRelationPipeline
   | StagesNotFound
   | UnSupportedFieldsForEnableDeepCopy
   | UnSupportedTriggerNodeType
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UserIsNotAnAdministrator

export type CreateNodeCreateTaskParams = {
   assignee?: InputMaybe<TaskAssigneeEnum>
   assigneeFieldId?: InputMaybe<Scalars['String']>
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   startDate?: InputMaybe<StartDateValueConfigParams>
   startTime?: InputMaybe<StartTimeValueConfigParams>
   taskTemplateId?: InputMaybe<Scalars['String']>
}

export type CreateNodeCreateTaskResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AssigneeFieldIdRequired
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | CreateTaskNode
   | DeletedAssigneeFieldId
   | DuplicateFieldIds
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidAssigneeFieldId
   | InvalidDateResponseFormat
   | InvalidTimeResponseFormat
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotActivityTemplateFieldIds
   | NotCompatibleValueFieldIds
   | NotEventBasedTriggerForStageFields
   | NotGivenAutomationWorkflowNodes
   | NotLeadTemplateFieldIds
   | NotParentNode
   | NotPipelineTaskTemplate
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | StartDateConfigIsRequired
   | TaskTemplateIdRequired
   | TaskTemplateNotFound
   | TriggerTaskAssigneeOnlySupportedToTaskTrigger
   | UnSupportedAssigneeFieldId
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator
   | ValueFieldSourceIsRequired
   | ValueIsRequired

export type CreateNodeExecuteFunctionParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   fieldId?: InputMaybe<Scalars['String']>
   functionId?: InputMaybe<Scalars['String']>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
}

export type CreateNodeExecuteFunctionResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DirectValueNotSupportedOnUniqueFields
   | DuplicateFieldIds
   | ExecuteFunctionNode
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormulaEvaluationLogicFailedInField
   | FunctionNotFound
   | InvalidComputedValueConfigFormat
   | InvalidFieldValuesErrors
   | InvalidHoursForComputedValueConfig
   | InvalidMinutesForComputedValueConfig
   | InvalidValuesForRelativeFieldSourceTypes
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotActivityTemplateFieldIds
   | NotCompatibleValueFieldIds
   | NotEventBasedTriggerForStageFields
   | NotGivenAutomationWorkflowNodes
   | NotLeadTemplateFieldIds
   | NotParentNode
   | NotSupportedComputedUpdateConfigForFields
   | NotSupportedRelativeValuesForFields
   | NotSupportedSystemFields
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | UnSupportedFieldsForEnableDeepCopy
   | UnSupportedTriggerNodeType
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UpRefAssigneeFieldsAreRequiredForFields
   | UpRefFieldsAreNotAssigneeFields
   | UserIsNotAnAdministrator

export type CreateNodeGenerateDocumentParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   copyDocumentUrlToField?: InputMaybe<Scalars['String']>
   documentTemplateId?: InputMaybe<Scalars['String']>
   documentVersionState?: InputMaybe<DocumentVersionState>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   title?: InputMaybe<GenerateDocumentTitleParams>
   variableMappings?: InputMaybe<
      Array<InputMaybe<AwCustomVariableFieldMappingParams>>
   >
}

export type CreateNodeGenerateDocumentResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DocumentTemplateIsDeleted
   | DocumentTemplateNotFound
   | DocumentTemplateNotLinkedToPipeline
   | DuplicateFormFieldsMapping
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormFieldsNotFound
   | GenerateDocumentNode
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotFileUploaderField
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeGenerateNumberParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   forceRegenerate?: InputMaybe<Scalars['Boolean']>
   generationType?: InputMaybe<NumberGenerationType>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   targetFieldId?: InputMaybe<Scalars['String']>
}

export type CreateNodeGenerateNumberResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | FieldsNotFound
   | GenerateNumberNode
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeInitiateRefundParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   feeRuleSetId?: InputMaybe<Scalars['String']>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
}

export type CreateNodeInitiateRefundResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | FeeRuleSetNotFound
   | InitiateRefundNode
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | UnSupportedNodeForPipelineItemTypes
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeRemoveAssigneesParams = {
   assigneeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type CreateNodeRemoveAssigneesResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | InvalidAssigneeFieldIds
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | RemoveAssigneesNode
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeRequestPaymentParams = {
   amount?: InputMaybe<Scalars['String']>
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   displayStageId?: InputMaybe<Scalars['String']>
   expiryInDays?: InputMaybe<Scalars['Int']>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   paymentGatewayCode?: InputMaybe<Scalars['String']>
   paymentSplit?: InputMaybe<Array<RequestPaymentSplitCategoryParams>>
   paymentStatus?: InputMaybe<PaymentStatus>
   paymentTowards?: InputMaybe<Scalars['String']>
   pipelineStages?: InputMaybe<Array<PipelineStageValuesParams>>
   recordStageId?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
}

export type CreateNodeRequestPaymentResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | ApplicationDisplayStageNotFound
   | ApplicationDisplayStagesNotFound
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DuplicatePipelineIds
   | FieldsAreNotSupportedInAutomationWorkflow
   | FormulaEvaluationLogicFailed
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotApplicationDisplayStage
   | NotApplicationDisplayStages
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | NotPipelineStages
   | NotSupportedFieldTypesForAmountFormulaExp
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PaymentAmountMustBeGreaterThanZero
   | PaymentGatewayCodeNotFound
   | RecordStageMustNotApplicationDisplayStage
   | RequestPaymentNode
   | StageNotFound
   | StagesNotFound
   | UnSupportedNodeForPipelineItemTypes
   | UnSupportedTriggerNodeType
   | UnsupportedFieldFormatsInFormulaValue
   | UserIsNotAnAdministrator

export type CreateNodeRequestPaymentWithFeeRulesParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   expiryInDays?: InputMaybe<Scalars['Int']>
   feePaymentOrderCreationConfigIds?: InputMaybe<Array<Scalars['String']>>
   name?: InputMaybe<Scalars['String']>
   numberOfInstallments?: InputMaybe<NumberOfInstallmentsConfigParams>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   paymentRuleSetId?: InputMaybe<Scalars['String']>
   paymentStatus?: InputMaybe<PaymentStatus>
   paymentTowards?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
}

export type CreateNodeRequestPaymentWithFeeRulesResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | FeePaymentOrderCreationConfigsNotFound
   | FieldsAreNotSupportedInAutomationWorkflow
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PaymentRuleSetNotFound
   | RequestPaymentWithFeeRulesNode
   | UnSupportedNodeForPipelineItemTypes
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeSendDataToSegmentParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   eventType?: InputMaybe<SegmentEventType>
   identifyEvent?: InputMaybe<IdentifyEventConfigParams>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   trackEvent?: InputMaybe<TrackEventConfigParams>
   writeKeyParameterId?: InputMaybe<Scalars['String']>
}

export type CreateNodeSendDataToSegmentResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DuplicateIdentifyEventIntegrationKeys
   | DuplicatePropertiesKeys
   | DuplicateTrackEventIntegrationKeys
   | DuplicateTraitKeys
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidIdentifyEventTimeStampConfig
   | InvalidIdentifyEventUniqueIdConfig
   | InvalidTrackEventTimeStampConfig
   | InvalidTrackEventUniqueIdConfig
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotActivityTemplateFieldIds
   | NotEventBasedTriggerForStageFields
   | NotGivenAutomationWorkflowNodes
   | NotLeadTemplateFieldIds
   | NotParentNode
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParameterIdNotFound
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | SendDataToSegmentNode
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeSendPipelineItemNotificationParams = {
   assigneeFieldsToNotify: Array<NotificationNodeAssigneeFieldConfigParams>
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   description?: InputMaybe<Scalars['String']>
   enableVariablesMapping?: InputMaybe<Scalars['Boolean']>
   name?: InputMaybe<Scalars['String']>
   notifyApplicationCustomer?: InputMaybe<Scalars['Boolean']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   title?: InputMaybe<Scalars['String']>
   variableMappings?: InputMaybe<
      Array<InputMaybe<AwCustomVariableFieldMappingParams>>
   >
}

export type CreateNodeSendPipelineItemNotificationResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | AwVariablesNotDefined
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DirectValueIsNotSupportedInNotificationNodeFieldMapping
   | DuplicateAwVariablesMapping
   | DuplicateNotificationNodeAssigneeFields
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidManagerLevels
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotAssigneeFieldIds
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | NotificationDescriptionFieldsLimitExceeded
   | NotificationDescriptionLengthExceeded
   | NotificationTitleFieldsLimitExceeded
   | NotificationTitleLengthExceeded
   | NotifyApplicationCustomerNotSupportedForPipeline
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PhoneNumberValueFormatIsNotSupportedForFields
   | SendPipelineItemNotificationNode
   | UnSupportedFieldFormatInNotificationNode
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeSendWhatsAppMessageNodeParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   name?: InputMaybe<Scalars['String']>
   notifyApplicationArchitect?: InputMaybe<Scalars['Boolean']>
   notifyApplicationCustomer?: InputMaybe<Scalars['Boolean']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   phoneNumberField?: InputMaybe<AutomationWorkflowFieldValueMappingParams>
   phoneNumberFields?: InputMaybe<
      Array<InputMaybe<AutomationWorkflowFieldValueMappingParams>>
   >
   variableMappings?: InputMaybe<
      Array<InputMaybe<AwCustomVariableFieldMappingParams>>
   >
   whatsappBusinessPhoneNumberId?: InputMaybe<Scalars['String']>
   whatsappMessageTemplateId?: InputMaybe<Scalars['String']>
}

export type CreateNodeSendWhatsAppMessageNodeResponse =
   | AccountPluginIsDisabled
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DirectValueIsNotSupportedForPhoneNumberField
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidPhoneNumber
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | NotPipelineItemAssigneeField
   | NotPipelineItemTemplatePhoneNumberField
   | NotSupportedSalesTemplateFields
   | NotUserPropertiesTemplatePhoneNumberField
   | NotifyApplicationArchitectNotSupportedForPipeline
   | NotifyApplicationCustomerNotSupportedForPipeline
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PhoneNumberValueFormatIsNotValid
   | PluginServiceAccountIsNotActive
   | SendWhatsAppMessageNode
   | UnSupportedTriggerNodeType
   | UpRefAssigneeFieldIsRequired
   | UserIsNotAnAdministrator
   | WhatsAppBusinessPhoneNumberNotFound
   | WhatsAppBusinessPhoneNumberNotLinkedToPipeline
   | WhatsAppMessageTemplateNotFound
   | WhatsAppMessageTemplateVariablesNotFound
   | WhatsAppMsgTemplateAndBusinessPhoneNumberNotLinkedToSameAccount
   | WhatsAppMsgTemplateVariableNamesNotFound

export type CreateNodeSignDocumentParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   copyDocumentUrlToField?: InputMaybe<Scalars['String']>
   documentTemplateId?: InputMaybe<Scalars['String']>
   documentVersionState?: InputMaybe<DocumentVersionState>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   signFieldMappings?: InputMaybe<Array<AwDocumentSignFieldMappingParams>>
   title?: InputMaybe<GenerateDocumentTitleParams>
}

export type CreateNodeSignDocumentResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DocumentTemplateIsDeleted
   | DocumentTemplateNotFound
   | DuplicateSignFieldsMapping
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidAssigneeIds
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotAssigneeFieldIds
   | NotFileUploaderField
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | SignDocumentNode
   | SignatureFieldsNotFound
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeSwiftsellOutboundWebhookParams = {
   authorizationToken?: InputMaybe<Scalars['String']>
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   customAttributes: Array<CustomKeyFieldValueMappingParams>
   fixedAttributes?: InputMaybe<
      SwiftsellOutboundWebhookNodeFixedAtrributesParams
   >
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   webhookUrl?: InputMaybe<Scalars['String']>
}

export type CreateNodeSwiftsellOutboundWebhookResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DirectValueIsNotSupportedForSwiftsellFixedIdentificationAttributes
   | DuplicateSwiftsellCustomAttributes
   | EmailReferenceFieldMustBeIdentifierEmail
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidWebhookUrl
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParameterIdsNotFound
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PhoneNumberReferenceFieldMustBeIdentifierPhoneNumber
   | PhoneNumberValueFormatIsNotSupportedForFields
   | SwiftsellOutboundWebhookNode
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type CreateNodeUpdateDisplayStageParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   stageFieldResponses?: InputMaybe<Array<InputMaybe<StageFieldResponseParams>>>
   stageId?: InputMaybe<Scalars['String']>
}

export type CreateNodeUpdateDisplayStageResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | ApplicationDisplayStageNotFound
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DuplicateStageFieldIds
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotApplicationDisplayStage
   | NotApplicationDisplayStages
   | NotDisplayStageFieldIds
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | NotSupportedStageForStageFieldIds
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | StageNotInPipeline
   | UnSupportedTriggerNodeType
   | UpdateDisplayStageNode
   | UserIsNotAnAdministrator

export type CreateNodeUpdateLeadParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   fieldIdsToClear?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   fieldsMapping: Array<ComputedUpdateFieldValueMappingParams>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
}

export type CreateNodeUpdateLeadResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DirectValueNotSupportedOnUniqueFields
   | DuplicateFieldIds
   | FieldClearingNotAllowed
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormulaEvaluationLogicFailedInField
   | InvalidComputedValueConfigFormat
   | InvalidFieldValuesErrors
   | InvalidHoursForComputedValueConfig
   | InvalidMinutesForComputedValueConfig
   | InvalidValuesForRelativeFieldSourceTypes
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotActivityTemplateFieldIds
   | NotCompatibleValueFieldIds
   | NotEventBasedTriggerForStageFields
   | NotGivenAutomationWorkflowNodes
   | NotLeadTemplateFieldIds
   | NotParentNode
   | NotSupportedComputedUpdateConfigForFields
   | NotSupportedRelativeValuesForFields
   | NotSupportedSystemFields
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | UnSupportedFieldsForEnableDeepCopy
   | UnSupportedTriggerNodeType
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UpRefAssigneeFieldsAreRequiredForFields
   | UpRefFieldsAreNotAssigneeFields
   | UpdateLeadNode
   | UserIsNotAnAdministrator

export type CreateNodeUpdateLeadStageParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   stageFieldResponses?: InputMaybe<Array<InputMaybe<StageFieldResponseParams>>>
   stageId?: InputMaybe<Scalars['String']>
}

export type CreateNodeUpdateLeadStageResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DuplicateStageFieldIds
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | NotStageFieldIds
   | NotSupportedStageForStageFieldIds
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | StageNotFound
   | StageNotInPipeline
   | StagesNotFound
   | UnSupportedTriggerNodeType
   | UpdateLeadStageNode
   | UserIsNotAnAdministrator

export type CreateNodeUpdatePipelineItemAssigneeParams = {
   assigneeFieldId?: InputMaybe<Scalars['String']>
   assigneeFieldIdsToNotify?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   assigneeSelectionType?: InputMaybe<
      UpdatePipelineItemAssigneeNodeAssigneeSelectionType
   >
   assigneeUserId?: InputMaybe<Scalars['String']>
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   dynamicAssigneeConfig?: InputMaybe<
      UpdateAssigneeNodeDynamicAssigneeConfigParams
   >
   managerFields: Array<UpdateAssigneeNodeManagerFieldParams>
   name?: InputMaybe<Scalars['String']>
   overrideAssignee?: InputMaybe<Scalars['Boolean']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   referenceAssigneeConfig?: InputMaybe<
      UpdateAssigneeNodeReferenceAssigneeConfigParams
   >
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type CreateNodeUpdatePipelineItemAssigneeResponse =
   | AccessDeniedToUser
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DeactivatedUser
   | DirectValueNotSupportedForReferenceAssigneeConfig
   | DuplicateAssigneeFieldIdsToNotify
   | DuplicateManagerFieldIds
   | InvalidAssigneeFieldIdsToNotify
   | InvalidDynamicAssigneeConditionConfig
   | InvalidManagerFieldIds
   | InvalidManagerFieldsLevel
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PipelineItemAssigneeAccessDenied
   | PipelineItemAssigneeFieldCanNotBeManagerField
   | PipelineItemAssigneeFieldNotFound
   | PipelineItemAssigneeIsDeactivated
   | PipelineItemAssigneeNotFound
   | ReferenceAssigneeConfigFieldShouldBeAssigneeField
   | UnSupportedTriggerNodeType
   | UpdatePipelineItemAssigneeNode
   | UserIsNotAnAdministrator
   | UserNotFound

export type CreateNodeUpdateRelatedRecordsParams = {
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   fields: Array<ComputedUpdateFieldValueMappingParams>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   relationId: Scalars['String']
}

export type CreateNodeUpdateRelatedRecordsResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DealPipelineRelationIsNotSupported
   | DirectValueNotSupportedOnUniqueFields
   | DuplicateFieldIds
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormulaEvaluationLogicFailedInField
   | InvalidComputedValueConfigFormat
   | InvalidFieldValuesErrors
   | InvalidHoursForComputedValueConfig
   | InvalidMinutesForComputedValueConfig
   | InvalidValuesForRelativeFieldSourceTypes
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotApplicationDisplayStages
   | NotCompatibleValueFieldIds
   | NotEventBasedTriggerForStageFields
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | NotRecordStages
   | NotRelatedPipelineTemplateFields
   | NotSupportedComputedUpdateConfigForFields
   | NotSupportedRelativeValuesForFields
   | NotSupportedSystemFields
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | RelationIsDeleted
   | RelationNotFound
   | RelationNotInPipeline
   | StageFieldsCannotHaveEmptyResponse
   | StagesNotFound
   | StagesNotInPipeline
   | UnSupportedFieldValueSourcesForStageFields
   | UnSupportedFieldsForEnableDeepCopy
   | UnSupportedTriggerNodeType
   | UniqueFieldsAreNotSupportedForMultiCardinalityRelation
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UpdateRelatedRecordsNode
   | UserIsNotAnAdministrator

export type CreateNodeUpdateTaskParams = {
   assignee?: InputMaybe<TaskAssigneeEnum>
   assigneeFieldId?: InputMaybe<Scalars['String']>
   automationWorkflowId: Scalars['String']
   childNodeId?: InputMaybe<Scalars['String']>
   childParentNodeResult?: InputMaybe<NodeResultEnum>
   discardTask?: InputMaybe<Scalars['Boolean']>
   name?: InputMaybe<Scalars['String']>
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
   startDate?: InputMaybe<StartDateValueConfigParams>
   startTime?: InputMaybe<StartTimeValueConfigParams>
}

export type CreateNodeUpdateTaskResponse =
   | ActionNodesLimitExceededInAutomationWorkflowExecType
   | AutomationWorkflowNodesAreNotEditable
   | AutomationWorkflowNotFound
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | DuplicateFieldIds
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidDateResponseFormat
   | InvalidTimeResponseFormat
   | MaxNodesLimitExceeded
   | MultipleChildrenNotSupported
   | NodeNotSupportedInAutomationWorkflowExecType
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotActivityTemplateFieldIds
   | NotCompatibleValueFieldIds
   | NotEventBasedTriggerForStageFields
   | NotGivenAutomationWorkflowNodes
   | NotLeadTemplateFieldIds
   | NotParentNode
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | StartDateConfigIsRequired
   | UnSupportedTriggerNodeType
   | UpdateTaskNode
   | UserIsNotAnAdministrator
   | ValueFieldSourceIsRequired
   | ValueIsRequired

export type CreateNoteParams = {
   color?: InputMaybe<Scalars['String']>
   content: Scalars['String']
   entityId: Scalars['String']
   entityType: NoteEntityType
}

export type CreateNoteResponse =
   | CreateNoteResult
   | NoteEntityAccessDenied
   | NoteEntityNotFound

export type CreateNoteResult = {
   __typename?: 'CreateNoteResult'
   note: Note
}

export type CreateObjectionTaskAddAnotherGoFBulkParams = {
   gofId: Scalars['String']
   objectionGofResponseIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type CreateObjectionTaskAddAnotherGoFBulkResponse =
   | CreateObjectionTaskAddAnotherGoFBulkResult
   | GoFIsDeleted
   | GoFNotFound
   | NotAddAnotherGoF
   | NotTaskGoF
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound

export type CreateObjectionTaskAddAnotherGoFBulkResult = {
   __typename?: 'CreateObjectionTaskAddAnotherGoFBulkResult'
   gofResponses: Array<GoFResponse>
   objectionAndTaskGofResponses: Array<RelatedObjectionAndTaskGoFResponseId>
   taskId: Scalars['String']
}

export type CreateObjectionTaskParams = {
   pipelineItemId: Scalars['String']
   relationId: Scalars['String']
   taskId?: InputMaybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type CreateObjectionTaskResponse =
   | CreateObjectionTaskResult
   | NoRelatedEntitiesLinkedForRelation
   | PipelineItemAccessDenied
   | RelationIsDeleted
   | RelationNotFound
   | TaskNotFound
   | TaskNotLinkedToGivenTaskTemplate
   | TaskNotLinkedToPipelineItem
   | TaskTemplateAccessDenied
   | TaskTemplateIsDisabled
   | TaskTemplateNotFound
   | VerificationTaskAlreadyExists

export type CreateObjectionTaskResult = {
   __typename?: 'CreateObjectionTaskResult'
   task: Task
}

export type CreateParameterConditionParams = {
   operator: ScoringConditionOperator
   parameterId: Scalars['String']
   score: Scalars['Float']
   value?: InputMaybe<Scalars['String']>
}

export type CreateParameterConditionResponse =
   | ConditionOperatorIsNotSupportedForField
   | ConditionScoreOutOfRange
   | InvalidConditionValue
   | InvalidFieldOptions
   | ParameterCondition
   | ScoringParameterNotFound
   | UserIsNotAnAdministrator

export type CreateParameterParams = {
   key: Scalars['String']
   value: Scalars['String']
}

export type CreateParameterResponse =
   | Parameter
   | ParameterKeyAlreadyExistsInAccount
   | ParameterKeyCanNotBeEmpty
   | ParameterValueCanNotBeEmpty
   | UserIsNotAnAdministrator

export type CreatePhoneNumberFieldParams = {
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   enableOtpVerification?: InputMaybe<Scalars['Boolean']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isIdentificationField?: InputMaybe<Scalars['Boolean']>
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
}

export type CreatePhoneNumberFieldResponse =
   | CannotAddIdentifierFieldInAddAnotherGof
   | CannotAddUniqueFieldInAddAnotherGof
   | CannotEditSystemGoF
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | GoFIsDeleted
   | GoFNotFound
   | IdentificationFieldNotSupportedSalesTemplate
   | IdentificationFieldsAreOnlySupportedForContactTemplate
   | InvalidFieldReferenceIdFormat
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | PhoneNumberField
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreatePieChartParams = {
   analyticsLevel: AnalyticsLevel
   dashboardId?: InputMaybe<Scalars['String']>
   dataSources: Array<AnalyticsDataSourceType>
   description?: InputMaybe<Scalars['String']>
   dimension?: InputMaybe<GraphDimensionParams>
   metric?: InputMaybe<GraphMetricParams>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreatePieChartResponse =
   | DashboardAnalyticsLevelMismatch
   | DashboardNotFound
   | DashboardNotInPipeline
   | EmptyGraphDataSources
   | GraphCreationNotAllowedInExternalDashboard
   | GraphNameIsRequired
   | LeadOrDealDataSourceMustExists
   | NotSupportedDataSources
   | NotSupportedMultipleDataSources
   | PieChartConfig
   | PipelineAccessDenied
   | PipelineNotFound
   | UnsupportedDataSourcesForPipeline
   | UserIsNotAnAdministrator

export type CreatePipelineCustomObjectAddAnotherGoFParams = {
   customObjectId: Scalars['String']
   gofId: Scalars['String']
}

export type CreatePipelineCustomObjectAddAnotherGoFResponse =
   | AddAnotherGoFResponsesLimitReached
   | GoFIsDeleted
   | GoFNotFound
   | GoFResponse
   | NotAddAnotherGoF
   | NotPipelineCustomObjectGoF
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound

export type CreatePipelineCustomObjectParams = {
   assigneeFieldIdsToNotify?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   fieldResponses: Array<FieldResponseParams>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
   recordCreationConfigId?: InputMaybe<Scalars['Int']>
}

export type CreatePipelineCustomObjectResponse =
   | AccountAccessDeniedToAssignees
   | AddAnotherFieldsAreNotSupported
   | AssigneesAreDeactivated
   | AssigneesNotFound
   | AtLeastOneCustomObjectIdentificationFieldIsRequired
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | CreatePipelineCustomObjectResult
   | CustomObjectCreatedOnShouldBeInPast
   | CustomObjectCreationNotSupportedFields
   | DecimalPrecisionExceeded
   | DuplicateAssigneeFieldIdsToNotify
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | FieldIdsNotInPipeline
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsAreNotInRecordCreationConfig
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidAssigneeFieldIdsToNotify
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldsWritePermission
   | NotAllowedFileFormats
   | NotCustomObjectPipeline
   | NotPipelineCustomObjectFields
   | ParentFieldsNotFilled
   | PipelineAccessDenied
   | PipelineAccessDeniedToAssignees
   | PipelineCustomObjectAlreadyExists
   | PipelineNotFound
   | RecordCreationConfigAccessDenied
   | RecordCreationConfigNotFound
   | RequiredFieldsNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageIsRequiredInPipelineItemCreation
   | StageNotAllowedInRecordCreationConfig
   | StageNotFound
   | StageNotInPipeline
   | UnSupportedSystemFieldIdsToEdit
   | UniqueFieldsResponseAlreadyExists
   | UserDoesNotHaveAccessToCreatePipelineCustomObject
   | YouDonNotHavePermissionToSetGivenUsersAsAssignees

export type CreatePipelineCustomObjectResult = {
   __typename?: 'CreatePipelineCustomObjectResult'
   customObjectId: Scalars['String']
   customObjectTemplateId: Scalars['String']
   hasPermission: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type CreatePipelineEventLeadCreationConfig = {
   stageId: Scalars['String']
}

export type CreatePipelineEventNode = BaseNode & {
   __typename?: 'CreatePipelineEventNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   fieldsMapping?: Maybe<Array<Maybe<FieldValueMapping>>>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   pipelineEventTemplateId?: Maybe<Scalars['String']>
   pipelineId?: Maybe<Scalars['String']>
}

export type CreatePipelineEventNodeExecLog = BaseNodeExecLog & {
   __typename?: 'CreatePipelineEventNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<CreatePipelineEventNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type CreatePipelineEventNodeExecLogResult = {
   __typename?: 'CreatePipelineEventNodeExecLogResult'
   pipelineEventLogId: Scalars['String']
}

export type CreatePipelineEventTemplateGoFParams = {
   description?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   pipelineEventTemplateId: Scalars['String']
}

export type CreatePipelineEventTemplateGoFResponse =
   | GoF
   | GoFNameAlreadyExists
   | PipelineEventTemplateNotFound
   | UserIsNotAnAdministrator

export type CreatePipelineEventTemplateParams = {
   description?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   pipelineId: Scalars['String']
   pipelineItemCreationConfig: CreatePipelineEventLeadCreationConfig
}

export type CreatePipelineEventTemplateResponse =
   | CannotAddPipelineEventTemplateToPipelineItemType
   | PipelineEventTemplate
   | PipelineEventTemplateNameAlreadyExists
   | PipelineNotFound
   | StageNotFound
   | StageNotInPipeline
   | UserIsNotAnAdministrator

export type CreatePipelineItemPaymentRequestParams = {
   customRuleIds: Array<Scalars['String']>
   pipelineItemId: Scalars['String']
   ruleSetId: Scalars['String']
   ruleWiseEdits: Array<PipelineItemPaymentRuleEditsParams>
}

export type CreatePipelineItemPaymentRequestResponse =
   | CreatePipelineItemPaymentResult
   | PaymentAmountMustBeGreaterThanZero
   | PaymentRuleSetNotFound
   | PaymentRulesNotFound
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemPaymentRulesWereNotSatisfied

export type CreatePipelineItemPaymentResult = {
   __typename?: 'CreatePipelineItemPaymentResult'
   paymentRequests: Array<PipelineItemPaymentRequest>
}

export type CreatePipelineItemReminderParams = {
   pipelineItemId: Scalars['String']
   reminderAt: Scalars['String']
   reminderText: Scalars['String']
}

export type CreatePipelineItemReminderResponse =
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineItemReminder
   | ReminderAtShouldNotBePreviousDateTime

export type CreatePipelineItemScheduleParams = {
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   remindersInMins: Array<Scalars['Int']>
   scheduledDatetime: Scalars['String']
   title?: InputMaybe<Scalars['String']>
}

export type CreatePipelineItemScheduleResponse =
   | PipelineItemAccessDenied
   | PipelineItemIsAlreadyScheduled
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | RemindersInMinsCannotBeNegative
   | RemindersLimitExceeded
   | ScheduledDatetimeMustBeInFuture
   | ScheduledPipelineItem
   | ScheduledRemindersMustBeInFuture

export type CreatePipelineItemTemplateGofResponse =
   | GoF
   | GoFNameAlreadyExists
   | PipelineItemTemplateNotFound
   | UserIsNotAnAdministrator

export type CreatePipelineItemTemplateGoFParams = {
   addAnotherGofResponsesLimit?: InputMaybe<Scalars['Int']>
   description?: InputMaybe<Scalars['String']>
   enableAddAnother?: InputMaybe<Scalars['Boolean']>
   name: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
}

export type CreatePipelineItemTemplateParams = {
   displayConfig?: InputMaybe<PipelineItemTemplateDisplayConfigParams>
   icon?: InputMaybe<IconConfigParams>
   name: Scalars['String']
   recordType: RecordType
}

export type CreatePipelineItemTemplateResponse =
   | DealsFeatureIsDisabled
   | PipelineItemTemplate
   | PipelineItemTemplateDisplayConfigIsRequired
   | PipelineItemTemplateNameAlreadyExists
   | PipelineNameAlreadyExistsInAccount
   | UserIsNotAnAdministrator

export type CreatePipelineParams = {
   color?: InputMaybe<Scalars['String']>
   displayName?: InputMaybe<Scalars['String']>
   existingTemplateConfig?: InputMaybe<PipelineItemTemplateConfigParams>
   name: Scalars['String']
   pipelineIconId?: InputMaybe<Scalars['String']>
   /** @deprecated Support SRMP */
   pipelineItemPluralName?: InputMaybe<Scalars['String']>
   /** @deprecated Support SRMP */
   pipelineItemPrimaryDisplayFieldName?: InputMaybe<Scalars['String']>
   /** @deprecated Support SRMP */
   pipelineItemSingularName?: InputMaybe<Scalars['String']>
   /** @deprecated Support SRMP */
   pipelineItemType?: InputMaybe<PipelineItemType>
}

export type CreatePipelineResponse =
   | DealsFeatureIsDisabled
   | DuplicatePipelineItemTemplateFieldNamesExists
   | Pipeline
   | PipelineDisplayNameAlreadyExistsInAccount
   | PipelineDisplayNameIsRequired
   | PipelineItemPluralNameIsRequired
   | PipelineItemPrimaryDisplayFieldNameIsRequired
   | PipelineItemSingularNameIsRequired
   | PipelineItemTemplateAssigneeFieldNameAlreadyExist
   | PipelineItemTemplateConfigIsRequired
   | PipelineItemTemplateDisplayStageFieldNameAlreadyExist
   | PipelineItemTemplateDisplayStageFieldNameIsRequired
   | PipelineItemTemplateNotFound
   | PipelineItemTemplateStageFieldNameAlreadyExist
   | PipelineNameAlreadyExistsInAccount
   | PipelineNameIsRequired
   | UserIsNotAnAdministrator

export type CreatePivotTableGraphParams = {
   analyticsLevel: AnalyticsLevel
   columnDimension?: InputMaybe<GraphDimensionParams>
   dashboardId?: InputMaybe<Scalars['String']>
   dataSources: Array<AnalyticsDataSourceType>
   description?: InputMaybe<Scalars['String']>
   enableColumnTotals?: InputMaybe<Scalars['Boolean']>
   enableRowTotals?: InputMaybe<Scalars['Boolean']>
   metric?: InputMaybe<GraphMetricParams>
   name: Scalars['String']
   pipelineId: Scalars['String']
   rowDimension?: InputMaybe<GraphDimensionParams>
}

export type CreatePivotTableGraphResponse =
   | DashboardAnalyticsLevelMismatch
   | DashboardNotFound
   | DashboardNotInPipeline
   | EmptyGraphDataSources
   | FieldIdsNotInGraphPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | GraphCreationNotAllowedInExternalDashboard
   | GraphNameIsRequired
   | LeadOrDealDataSourceMustExists
   | NotAllowedToConfigureOnlyOneDimension
   | NotSupportedDataSources
   | NotSupportedGraphMetricFieldIds
   | NotSupportedMultipleDataSources
   | PipelineAccessDenied
   | PipelineNotFound
   | PivotTableGraphConfig
   | RowAndColumnDimensionShouldNotHaveSameField
   | UnSupportedDataSourceFields
   | UnSupportedGroupByFieldTypes
   | UnSupportedGroupByFields
   | UnSupportedGroupByFieldsDataSource
   | UnSupportedGroupByTypeFieldIds
   | UnSupportedMetricFields
   | UnSupportedMetricFieldsDataSource
   | UnsupportedDataSourcesForPipeline
   | UserIsNotAnAdministrator

export type CreatePlainTextFieldParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   formulaExpression?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isFormulaEnabled?: InputMaybe<Scalars['Boolean']>
   isIdentificationField?: InputMaybe<Scalars['Boolean']>
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   regexErrorMessage?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
   validationRegex?: InputMaybe<Scalars['String']>
}

export type CreatePlainTextFieldResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotAddIdentifierFieldInAddAnotherGof
   | CannotAddUniqueFieldInAddAnotherGof
   | CannotEditSystemGoF
   | CannotEnableFormulaStatusInAddAnotherField
   | CannotEnableFormulaStatusOnUniqueField
   | DefaultValueNotAllowedForUniqueField
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | FieldsAreDeleted
   | FieldsNotFound
   | FormulaExpressionIsRequired
   | FormulaFieldsAreNotAllowed
   | GoFIsDeleted
   | GoFNotFound
   | IdentificationFieldNotSupportedSalesTemplate
   | IdentificationFieldsAreOnlySupportedForContactTemplate
   | InvalidDefaultValue
   | InvalidFieldReferenceIdFormat
   | InvalidFormulaExpression
   | InvalidValidationRegex
   | NotSupportedFieldTypes
   | NotSupportedFields
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | PlainTextField
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreatePortalApplicationParams = {
   applicationPipelineId: Scalars['String']
   bgImageUrl?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   portalId: Scalars['String']
}

export type CreatePortalApplicationResponse =
   | ApplicationPipelineAlreadyExistsInPortal
   | InvalidUrl
   | NotApplicationPipeline
   | PipelineNotFound
   | PortalApplication
   | PortalNotFound
   | UserIsNotAnAdministrator

export type CreatePortalParams = {
   brandBgImg?: InputMaybe<Scalars['String']>
   brandLogo?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   domainUrl: Scalars['String']
   title: Scalars['String']
}

export type CreatePortalResponse =
   | InvalidBrandBgImg
   | InvalidBrandLogo
   | InvalidDomainUrl
   | Portal
   | PortalDomainUrlAlreadyUsed
   | UserIsNotAnAdministrator

export type CreateRadioGroupFieldParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
}

export type CreateRadioGroupFieldResponse =
   | CannotEditSystemGoF
   | DefaultValueMustBeInGivenOptions
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | DoubleHashIsNotSupportedInOptions
   | EmptyValuesForFieldValues
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | RadioGroupField
   | ReferenceIdAlreadyExistsInTemplate
   | UserIsNotAnAdministrator

export type CreateRazorpayOrderInPortalParams = {
   applicationId: Scalars['String']
   orderContributedEntityIds: Array<Scalars['String']>
   payPartialPaidContributedEntitiesPenalty?: InputMaybe<Scalars['Boolean']>
   paymentOrderId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type CreateRazorpayOrderInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | CannotInitiatePartialPaymentsOnDirectOrder
   | CreateRazorpayOrderInPortalResult
   | EmptyPartiallyPaidContributedEntitiesFound
   | OrderAmountRecalculationError
   | OrderAmountsChanged
   | OrderContributedEntityIdsNotFound
   | PaidOrderContributedEntityIdsFound
   | PaymentOrderAccessDenied
   | PaymentOrderAlreadyPaid
   | PaymentOrderIsInitiated
   | PaymentOrderIsProcessing
   | PaymentOrderNotFound
   | PortalNotFound
   | RazorpayPaymentNotApplicableForTdrSelectedContributedEntities

export type CreateRazorpayOrderInPortalResult = {
   __typename?: 'CreateRazorpayOrderInPortalResult'
   applicationId: Scalars['String']
   razorpayOrder: RazorpayOrder
}

export type CreateRecordCreationConfigParams = {
   name: Scalars['String']
   salesTemplateId: Scalars['String']
   salesTemplateType: RecordCreationSupportedSalesTemplateType
}

export type CreateRecordCreationConfigResponse =
   | AdminRecordCreationConfig
   | RecordCreationConfigNameAlreadyExists
   | SalesTemplateNotFound
   | UserIsNotAnAdministrator

export type CreateRelatedApplicationInPortalParams = {
   pipelineId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
   unifiedResponses: Array<UnifiedApplicationParams>
}

export type CreateRelatedApplicationInPortalResponse =
   | AlreadyOneEntityExistInOneToOneRelation
   | ApplicationDisplayStageNotConfiguredForPipeline
   | CannotFindApplicationPipelineWithGivenValues
   | CircularRelatedEntitiesFound
   | CreateRelatedApplicationInPortalResult
   | CurrentEntityAlreadyLinkedToAnotherEntityInOneToMany
   | MultipleEntitiesNotSupportedInOneToManyRelation
   | NotApplicationPipeline
   | NotPortalUserRelatedEntities
   | PipelineNotFound
   | PortalNotFound
   | PortalPipelineIdsNotConfigured
   | RelatedEntitiesMaxCountExceeded
   | RelatedEntitiesNotFound
   | RelatedEntityAlreadyExistInOneToOneRelation
   | RelationAreDeleted
   | RelationDirectionIsRequiredForSelfRelations
   | RelationsNotFound
   | StageNotConfiguredForPipeline
   | YouCanLinkRelatedEntitiesToOnlyOneEntityInOneToMany

export type CreateRelatedApplicationInPortalResult = {
   __typename?: 'CreateRelatedApplicationInPortalResult'
   applicationId: Scalars['String']
   applicationTemplateId: Scalars['String']
   isCopyingRelatedApplicationFieldsInitiated: Scalars['Boolean']
   pipelineId: Scalars['String']
   portalId: Scalars['String']
}

export type CreateRelatedApplicationParams = {
   applicationTemplateId: Scalars['String']
   assigneeFieldIdsToNotify?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   currentEntityId: Scalars['String']
   fieldResponses: Array<FieldResponseParams>
   recordCreationConfigId: Scalars['Int']
   relationId: Scalars['String']
}

export type CreateRelatedApplicationResponse =
   | AccountAccessDeniedToAssignees
   | AddAnotherFieldsAreNotSupported
   | AlreadyOneEntityExistInOneToOneRelation
   | ApplicationAlreadyExists
   | ApplicationCreatedOnShouldBeInPast
   | ApplicationCreationNotSupportedFields
   | ApplicationTemplateNotFound
   | AssigneesAreDeactivated
   | AssigneesNotFound
   | AtLeastOneApplicationIdentificationFieldIsRequired
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | CreateRelatedApplicationResult
   | CurrentEntityAlreadyLinkedToAnotherEntityInOneToMany
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | DecimalPrecisionExceeded
   | DisplayStageIsRequiredInPipelineItemCreation
   | DuplicateAssigneeFieldIdsToNotify
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | FieldIdsNotInPipeline
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsAreNotInRecordCreationConfig
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidAssigneeFieldIdsToNotify
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldsWritePermission
   | NotAllowedFileFormats
   | NotApplicationFields
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | ParentFieldsNotFilled
   | PipelineAccessDenied
   | PipelineAccessDeniedToAssignees
   | RecordCreationConfigAccessDenied
   | RecordCreationConfigNotFound
   | RelatedEntitiesMaxCountExceeded
   | RelatedRecordCreationSalesTemplateNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound
   | RequiredFieldsNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageIsRequiredInPipelineItemCreation
   | StageNotAllowedInRecordCreationConfig
   | StageNotFound
   | StageNotInPipeline
   | UnSupportedSystemFieldIdsToEdit
   | UniqueFieldsResponseAlreadyExists
   | UserDoesNotHaveAccessToCreateApplication
   | YouDonNotHavePermissionToSetGivenUsersAsAssignees

export type CreateRelatedApplicationResult = {
   __typename?: 'CreateRelatedApplicationResult'
   applicationId: Scalars['String']
   applicationTemplateId: Scalars['String']
   hasPermission: Scalars['Boolean']
   name?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelines: Array<RelatedObjectPipeline>
}

export type CreateRelatedEntityAddAnotherGoFParams = {
   currentEntityId: Scalars['String']
   gofId: Scalars['String']
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
}

export type CreateRelatedEntityAddAnotherGoFResponse =
   | AddAnotherGoFResponsesLimitReached
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | GoFIsDeleted
   | GoFNotFound
   | GoFResponse
   | NotAddAnotherGoF
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | NotRelatedEntityTemplateGoF
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntityIsDeleted
   | RelatedEntityNotFound
   | RelationIsDeleted
   | RelationNotFound

export type CreateRelatedLeadWithContactParams = {
   assigneeFieldIdsToNotify?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   currentEntityId: Scalars['String']
   fieldResponses: Array<FieldResponseParams>
   leadTemplateId: Scalars['String']
   recordCreationConfigId: Scalars['Int']
   relationId: Scalars['String']
}

export type CreateRelatedLeadWithContactResponse =
   | AccountAccessDeniedToAssignees
   | AddAnotherFieldsAreNotSupported
   | AlreadyOneEntityExistInOneToOneRelation
   | AssigneesAreDeactivated
   | AssigneesNotFound
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | ContactAlreadyExists
   | CreateRelatedLeadWithContactResult
   | CurrentEntityAlreadyLinkedToAnotherEntityInOneToMany
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | DecimalPrecisionExceeded
   | DuplicateAssigneeFieldIdsToNotify
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | FieldIdsNotInPipeline
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsAreNotInRecordCreationConfig
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidAssigneeFieldIdsToNotify
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | LeadAlreadyExists
   | LeadCreatedOnShouldBeInPast
   | LeadCreationNotSupportedFields
   | LeadTemplateNotFound
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | MultipleContactsFound
   | NotAllowedFileFormats
   | NotLeadOrContactFields
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | ParentFieldsNotFilled
   | PipelineAccessDenied
   | PipelineAccessDeniedToAssignees
   | RecordCreationConfigAccessDenied
   | RecordCreationConfigNotFound
   | RelatedEntitiesMaxCountExceeded
   | RelatedRecordCreationSalesTemplateNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound
   | RequiredFieldsNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageIsRequiredInPipelineItemCreation
   | StageNotAllowedInRecordCreationConfig
   | StageNotFound
   | StageNotInPipeline
   | UnSupportedSystemFieldIdsToEdit
   | UniqueFieldsResponseAlreadyExists
   | UserDoesNotHaveAccessToCreateLeadWithContact
   | YouDonNotHavePermissionToSetGivenUsersAsAssignees

export type CreateRelatedLeadWithContactResult = {
   __typename?: 'CreateRelatedLeadWithContactResult'
   contactId: Scalars['String']
   hasPermission: Scalars['Boolean']
   leadId: Scalars['String']
   leadTemplateId: Scalars['String']
   name?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelines: Array<RelatedObjectPipeline>
}

export type CreateRelatedPipelineCustomObjectParams = {
   assigneeFieldIdsToNotify?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   currentEntityId: Scalars['String']
   customObjectTemplateId: Scalars['String']
   fieldResponses: Array<FieldResponseParams>
   recordCreationConfigId: Scalars['Int']
   relationId: Scalars['String']
}

export type CreateRelatedPipelineCustomObjectResponse =
   | AccountAccessDeniedToAssignees
   | AddAnotherFieldsAreNotSupported
   | AlreadyOneEntityExistInOneToOneRelation
   | AssigneesAreDeactivated
   | AssigneesNotFound
   | AtLeastOneCustomObjectIdentificationFieldIsRequired
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | CreateRelatedPipelineCustomObjectResult
   | CurrentEntityAlreadyLinkedToAnotherEntityInOneToMany
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | CustomObjectCreatedOnShouldBeInPast
   | CustomObjectCreationNotSupportedFields
   | CustomObjectTemplateNotFound
   | DecimalPrecisionExceeded
   | DuplicateAssigneeFieldIdsToNotify
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | FieldIdsNotInPipeline
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsAreNotInRecordCreationConfig
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidAssigneeFieldIdsToNotify
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NotAllowedFileFormats
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | NotPipelineCustomObjectFields
   | ParentFieldsNotFilled
   | PipelineAccessDenied
   | PipelineAccessDeniedToAssignees
   | PipelineCustomObjectAlreadyExists
   | RecordCreationConfigAccessDenied
   | RecordCreationConfigNotFound
   | RelatedEntitiesMaxCountExceeded
   | RelatedRecordCreationSalesTemplateNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound
   | RequiredFieldsNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageIsRequiredInPipelineItemCreation
   | StageNotAllowedInRecordCreationConfig
   | StageNotFound
   | StageNotInPipeline
   | UnSupportedSystemFieldIdsToEdit
   | UniqueFieldsResponseAlreadyExists
   | UserDoesNotHaveAccessToCreatePipelineCustomObject
   | YouDonNotHavePermissionToSetGivenUsersAsAssignees

export type CreateRelatedPipelineCustomObjectResult = {
   __typename?: 'CreateRelatedPipelineCustomObjectResult'
   customObjectId: Scalars['String']
   customObjectTemplateId: Scalars['String']
   hasPermission: Scalars['Boolean']
   name?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelines: Array<RelatedObjectPipeline>
}

export type CreateRelatedRecordAssigneeDetails = {
   __typename?: 'CreateRelatedRecordAssigneeDetails'
   assignee?: Maybe<FieldValueMapping>
   managerFields: Array<CreateRelatedRecordNodeManagerField>
}

export type CreateRelatedRecordNode = BaseNode & {
   __typename?: 'CreateRelatedRecordNode'
   assignees: Array<CreateRelatedRecordAssigneeDetails>
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   customFields: Array<FieldValueMapping>
   displayStage?: Maybe<Stage>
   mandatoryFields: Array<FieldValueMapping>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   pipelineStageValues: Array<PipelineStageValues>
   relation: Relation
   relationFieldMappings: Array<RelationFieldValueMapping>
   stage?: Maybe<Stage>
   syncAssigneeHierarchy?: Maybe<Scalars['Boolean']>
}

export type CreateRelatedRecordNodeAssigneeParams = {
   assignee?: InputMaybe<FieldValueMappingParams>
   managerFields: Array<CreateRelatedRecordNodeManagerFieldParams>
}

export type CreateRelatedRecordNodeExecLog = BaseNodeExecLog & {
   __typename?: 'CreateRelatedRecordNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<CreateRelatedRecordNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type CreateRelatedRecordNodeExecLogResult = {
   __typename?: 'CreateRelatedRecordNodeExecLogResult'
   assigneeHierarchy: Array<AwAssigneeHierarchyLog>
   pipeline: BasePipeline
   pipelineItemId: Scalars['String']
   pipelineItemName?: Maybe<Scalars['String']>
   pipelines: Array<BasePipeline>
   relations: Array<RelationFieldMappingExecResult>
}

export type CreateRelatedRecordNodeManagerField = {
   __typename?: 'CreateRelatedRecordNodeManagerField'
   level: Scalars['Int']
   managerFieldId: Scalars['String']
}

export type CreateRelatedRecordNodeManagerFieldParams = {
   level: Scalars['Int']
   managerFieldId: Scalars['String']
}

export type CreateRelationFieldParams = {
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   relationId: Scalars['String']
   secondDegreeRelationId?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
   valueType: RelationFieldValueType
}

export type CreateRelationFieldResponse =
   | CannotEditSystemGoF
   | DeletedFieldExistsWithFieldName
   | DeletedFieldExistsWithFieldReferenceId
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | FirstRelationPipelineItemTemplateShouldNotInSecondDegreeRelation
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | MultiselectIsNotSupportedForSingleCardinalityRelation
   | NotSupportedForDealPipelineItemTypes
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | RelationField
   | RelationFieldNotSupportedInGoFCrmTemplate
   | RelationNotFound
   | RelationNotInGoFPipelineItemTemplate
   | SecondDegreeRelationNotInFirstRelationPipelineItemTemplate
   | UserIsNotAnAdministrator

export type CreateRelationParams = {
   cardinality: Cardinality
   fromAddIdentifications: Array<Scalars['String']>
   fromOverviewFields: Array<Scalars['String']>
   fromRemoveIdentifications: Array<Scalars['String']>
   fromSalesTemplateDisplayName: Scalars['String']
   fromSalesTemplateId: Scalars['String']
   identifications: Array<Scalars['String']>
   name: Scalars['String']
   toAddIdentifications: Array<Scalars['String']>
   toOverviewFields: Array<Scalars['String']>
   toRemoveIdentifications: Array<Scalars['String']>
   toSalesTemplateDisplayName: Scalars['String']
   toSalesTemplateId: Scalars['String']
}

export type CreateRelationResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | FieldsNotLinkedToRelatedSalesTemplate
   | FromSalesTemplateIdNotFound
   | IdentificationsNotFound
   | NotPermittedFields
   | NotSupportedCardinalitiesForSelfRelation
   | NotSupportedSalesTemplatesForRelation
   | Relation
   | RelationAndIdentificationsAreNotInSameAccount
   | SelfRelationIsNotSupported
   | ToSalesTemplateIdNotFound
   | UserIsNotAnAdministrator

export type CreateResourceParams = {
   description: Scalars['String']
   pipelineId: Scalars['String']
   title: Scalars['String']
}

export type CreateResourceResponse =
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | NotAssigneeFieldIds
   | NotSupportedSalesTemplateFields
   | NotUserPropertyFieldIds
   | PipelineAccessDenied
   | PipelineNotFound
   | PlaceholdersNotFound
   | ResourceConfig
   | ResourceDescriptionIsRequired
   | ResourceTitleIsRequired
   | UserIsNotAnAdministrator

export type CreateScheduledAutomationWorkflowParams = {
   name: Scalars['String']
   pipelineId: Scalars['String']
   scheduleTrigger: CreateScheduledTriggerParams
}

export type CreateScheduledAutomationWorkflowResponse =
   | AutomationWorkflow
   | AutomationWorkflowNameAlreadyExists
   | EmptyScheduleDayConfig
   | EmptyScheduleMinutesConfig
   | EmptyScheduleMonthConfig
   | EmptyScheduleWeekConfig
   | EntityTemplateNotFound
   | EntityTemplateNotInPipeline
   | InvalidDaysCountInMonthScheduleConfig
   | InvalidScheduleMinutesConfig
   | PipelineAccessDenied
   | PipelineNotFound
   | ScheduledWeekdaysShouldNotBeEmpty
   | UnsupportedScheduleTriggerEntity
   | UnsupportedScheduledMinutesConfig
   | UserIsNotAnAdministrator

export type CreateScheduledDayConfigParams = {
   time: Scalars['String']
}

export type CreateScheduledMonthConfigParams = {
   daysCount: Scalars['Int']
   monthDay: MonthDayEnum
   time: Scalars['String']
}

export type CreateScheduledTriggerParams = {
   allowManualTrigger?: InputMaybe<Scalars['Boolean']>
   dayConfig?: InputMaybe<CreateScheduledDayConfigParams>
   entity: TriggerEntity
   entityTemplateId: Scalars['String']
   minutes?: InputMaybe<Scalars['Int']>
   monthConfig?: InputMaybe<Array<CreateScheduledMonthConfigParams>>
   scheduleType?: InputMaybe<ScheduleTypeEnum>
   weekConfig?: InputMaybe<CreateScheduledWeekConfigParams>
}

export type CreateScheduledWeekConfigParams = {
   time: Scalars['String']
   weekDays: Array<WeekDayEnum>
}

export type CreateScorecardChartParams = {
   analyticsLevel: AnalyticsLevel
   comparisonMetric?: InputMaybe<GraphMetricParams>
   comparisonType: ScorecardComparisonType
   comparisonValue?: InputMaybe<Scalars['String']>
   dashboardId?: InputMaybe<Scalars['String']>
   dataSources: Array<AnalyticsDataSourceType>
   description?: InputMaybe<Scalars['String']>
   metric?: InputMaybe<GraphMetricParams>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateScorecardChartResponse =
   | DashboardAnalyticsLevelMismatch
   | DashboardNotFound
   | DashboardNotInPipeline
   | EmptyGraphDataSources
   | GraphCreationNotAllowedInExternalDashboard
   | GraphNameIsRequired
   | NotSupportedDataSources
   | NotSupportedMultipleDataSources
   | PipelineNotFound
   | ScorecardChartConfig
   | UnsupportedDataSourcesForPipeline
   | UserIsNotAnAdministrator

export type CreateScoringParameterParams = {
   fieldId: Scalars['String']
   scoringConfigId: Scalars['String']
   weightage?: InputMaybe<Scalars['Float']>
}

export type CreateScoringParameterResponse =
   | FieldIsDeleted
   | FieldNotFound
   | InvalidWeightageValue
   | NotSupportedScoringParameterField
   | ScoringConfigNotFound
   | ScoringParameter
   | UserIsNotAnAdministrator

export type CreateScoringParametersParams = {
   parameters: Array<ScoringParameterParams>
   scoringConfigId: Scalars['String']
}

export type CreateScoringParametersResponse =
   | CreateScoringParametersResult
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidWeightageValues
   | NotSupportedScoringParameterFields
   | ScoringConfigNotFound
   | UserIsNotAnAdministrator

export type CreateScoringParametersResult = {
   __typename?: 'CreateScoringParametersResult'
   parameters: Array<ScoringParameter>
}

export type CreateShortTextFieldParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   formulaExpression?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isFormulaEnabled?: InputMaybe<Scalars['Boolean']>
   isIdentificationField?: InputMaybe<Scalars['Boolean']>
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   prefixOptions?: InputMaybe<PrefixOptionsParams>
   referenceId?: InputMaybe<Scalars['String']>
   regexErrorMessage?: InputMaybe<Scalars['String']>
   suffixOptions?: InputMaybe<SuffixOptionsParams>
   tooltip?: InputMaybe<Scalars['String']>
   validationRegex?: InputMaybe<Scalars['String']>
}

export type CreateShortTextFieldResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotAddIdentifierFieldInAddAnotherGof
   | CannotAddUniqueFieldInAddAnotherGof
   | CannotEditSystemGoF
   | CannotEnableFormulaStatusInAddAnotherField
   | CannotEnableFormulaStatusOnUniqueField
   | DefaultValueNotAllowedForUniqueField
   | DeletedFieldExistsWithFieldName
   | DeletedFieldExistsWithFieldReferenceId
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | FieldsAreDeleted
   | FieldsNotFound
   | FormulaExpressionIsRequired
   | FormulaFieldsAreNotAllowed
   | GoFIsDeleted
   | GoFNotFound
   | IdentificationFieldNotSupportedSalesTemplate
   | IdentificationFieldsAreOnlySupportedForContactTemplate
   | InvalidFieldReferenceIdFormat
   | InvalidFormulaExpression
   | NeedAtLeastOnePrefixValue
   | NeedAtLeastOneSuffixValue
   | NotSupportedFieldTypes
   | NotSupportedFields
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | ShortTextField
   | ShortTextFieldOptionsAreEnabled
   | UserIsNotAnAdministrator

export type CreateSiteInspectionTaskAddAnotherGoFBulkParams = {
   applicationGofResponseIds: Array<Scalars['String']>
   gofId: Scalars['String']
   taskId: Scalars['String']
}

export type CreateSiteInspectionTaskAddAnotherGoFBulkResponse =
   | AddAnotherGoFResponsesLimitReached
   | CreateSiteInspectionTaskAddAnotherGoFBulkResult
   | GoFIsDeleted
   | GoFNotFound
   | NotAddAnotherGoF
   | NotTaskGoF
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound

export type CreateSiteInspectionTaskAddAnotherGoFBulkResult = {
   __typename?: 'CreateSiteInspectionTaskAddAnotherGoFBulkResult'
   gofResponses: Array<GoFResponse>
   taskAndApplicationGofResponses: Array<
      SiteInspectionApplicationAndTaskGoFResponseId
   >
   taskId: Scalars['String']
}

export type CreateSiteInspectionTaskAddAnotherGoFParams = {
   applicationGofResponseId: Scalars['String']
   gofId: Scalars['String']
   taskId: Scalars['String']
}

export type CreateSiteInspectionTaskAddAnotherGoFResponse =
   | AddAnotherGoFResponsesLimitReached
   | ApplicationGoFResponseIdAlreadyLinked
   | CreateSiteInspectionTaskAddAnotherGoFResult
   | GoFIsDeleted
   | GoFNotFound
   | NotAddAnotherGoF
   | NotTaskGoF
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound

export type CreateSiteInspectionTaskAddAnotherGoFResult = {
   __typename?: 'CreateSiteInspectionTaskAddAnotherGoFResult'
   applicationGofResponseId: Scalars['String']
   gofResponse: GoFResponse
   taskId: Scalars['String']
}

export type CreateStackedBarGraphParams = {
   analyticsLevel: AnalyticsLevel
   dataSources: Array<AnalyticsDataSourceType>
   description?: InputMaybe<Scalars['String']>
   firstDimension?: InputMaybe<GraphDimensionParams>
   metric?: InputMaybe<GraphMetricParams>
   name: Scalars['String']
   pipelineId: Scalars['String']
   secondDimension?: InputMaybe<GraphDimensionParams>
}

export type CreateStackedBarGraphResponse =
   | DashboardAnalyticsLevelMismatch
   | GraphNameIsRequired
   | NotSupportedGraphSalesEntityType
   | NotSupportedPipelineForGraphSalesEntityType
   | PipelineAccessDenied
   | PipelineNotFound
   | StackedBarGraphConfig
   | UserIsNotAnAdministrator

export type CreateStageParams = {
   color?: InputMaybe<ColorEnum>
   isApplicationDisplayStage?: InputMaybe<Scalars['Boolean']>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateStageResponse =
   | ColorIsNotAllowed
   | PipelineAccessDenied
   | PipelineNotFound
   | Stage
   | StageNameAlreadyUsedInPipeline
   | UserIsNotAnAdministrator

export type CreateStageTransitionParams = {
   actionName?: InputMaybe<Scalars['String']>
   fromStageId: Scalars['String']
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   toStageId: Scalars['String']
}

export type CreateStageTransitionResponse =
   | BothStagesShouldBeSameType
   | FromStageAndToStageCannotBeSame
   | StageTransition
   | StageTransitionAlreadyExists
   | StagesAreNotInSamePipeline
   | StagesNotFound
   | UserIsNotAnAdministrator

export type CreateTdrAccountPurchaseRequestParams = {
   accountId: Scalars['String']
   name: Scalars['String']
   phoneNumber: Scalars['String']
   remarks: Scalars['String']
}

export type CreateTdrAccountPurchaseRequestResponse =
   | CreateTdrAccountPurchaseRequestResult
   | PurchaseRequestAlreadyRaised
   | TdrAccountNotFound

export type CreateTdrAccountPurchaseRequestResult = {
   __typename?: 'CreateTDRAccountPurchaseRequestResult'
   requestId: Scalars['String']
}

export type CreateTdrDigitalizationApplicationFieldResponse = {
   fieldId: Scalars['String']
   response: Scalars['String']
}

export type CreateTdrDigitalizationApplicationParams = {
   certificateNumber: Scalars['String']
   fieldResponses: Array<CreateTdrDigitalizationApplicationFieldResponse>
}

export type CreateTdrDigitalizationApplicationResponse =
   | AlreadyOneEntityExistInOneToOneRelation
   | ApplicationDisplayStageNotConfiguredForPipeline
   | CircularRelatedEntitiesFound
   | CreateTdrDigitalizationApplicationResult
   | CurrentEntityAlreadyLinkedToAnotherEntityInOneToMany
   | InvalidCertificateNumber
   | MultipleEntitiesNotSupportedInOneToManyRelation
   | NotApplicationPipeline
   | PipelineNotFound
   | RelatedEntitiesMaxCountExceeded
   | RelatedEntitiesNotFound
   | RelatedEntityAlreadyExistInOneToOneRelation
   | RelationAreDeleted
   | RelationDirectionIsRequiredForSelfRelations
   | RelationsNotFound
   | StageNotConfiguredForPipeline
   | TdrApplicationFieldsNotFound
   | TdrDigitalizationApplicationAlreadyExists
   | TdrPipelineItemTemplateConfigNotFound
   | TdrPipelineItemTemplateDigitalizationConfigNotFound
   | YouCanLinkRelatedEntitiesToOnlyOneEntityInOneToMany

export type CreateTdrDigitalizationApplicationResult = {
   __typename?: 'CreateTDRDigitalizationApplicationResult'
   applicationId: Scalars['String']
   applicationTemplateId: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateTdrOrderInPortalParams = {
   applicationId: Scalars['String']
   orderContributedEntityIds: Array<Scalars['String']>
   paymentOrderId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type CreateTdrOrderInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | CreateTdrOrderInPortalResult
   | OrderContributedEntityIdsNotFound
   | PaidOrderContributedEntityIdsFound
   | PaymentOrderAccessDenied
   | PaymentOrderAlreadyPaid
   | PaymentOrderIsInitiated
   | PaymentOrderIsProcessing
   | PaymentOrderNotFound
   | PortalNotFound
   | TdrOrderAccessDenied
   | TdrOrderAlreadyPaid
   | TdrOrderNotFound
   | TdrOrderUnderVerification
   | TdrPaymentCanInitiateOnlyForPartialPayments
   | TdrPaymentNotApplicableForInstallmentOrder
   | TdrPaymentNotApplicableForNonFeeHeadContributedEntities
   | TdrPaymentNotApplicableForNonTdrApplicableContributedEntities
   | TdrPaymentNotApplicableForRazorpaySelectedContributedEntities

export type CreateTdrOrderInPortalResult = {
   __typename?: 'CreateTDROrderInPortalResult'
   applicationId: Scalars['String']
   tdrOrder: TdrOrder
}

export type CreateTdrPaymentInPortalParams = {
   authority: Scalars['String']
   certificateAttachment?: InputMaybe<TdrCertificateAttachmentParams>
   certificateNumber: Scalars['String']
   marketValueOfUsageArea: Scalars['Float']
   portalId: Scalars['String']
   portalType: PortalType
   requestedArea: Scalars['Float']
   tdrOrderId: Scalars['String']
}

export type CreateTdrPaymentInPortalResponse =
   | ApplicationAccessDenied
   | CreateTdrPaymentInPortalResult
   | InvalidTdrRequestAuthority
   | MarketValueShouldBePositiveValue
   | NotHaveSufficientBalanceInTdrAccount
   | PortalNotFound
   | PrecisionLimitExceededForTdrMarketValue
   | PrecisionLimitExceededForTdrRequestedArea
   | RequestedAreaGreaterThanAllocatedArea
   | SameCertificateAlreadyExistsInTdrOrder
   | TdrOrderNotFound
   | TdrRequestCertificateNumberNotFound
   | TdrRequestedAreaShouldBePositive
   | TdrRequestedAreaShouldNotBeNegative

export type CreateTdrPaymentInPortalResult = {
   __typename?: 'CreateTDRPaymentInPortalResult'
   tdrPayment: TdrPayment
}

export type CreateTdrRequestInPortalAndSendOtpParams = {
   authority: Scalars['String']
   certificateAttachment?: InputMaybe<TdrCertificateAttachmentParams>
   certificateNumber: Scalars['String']
   entityId: Scalars['String']
   entityType: TdrEntityType
   marketValueOfUsageArea?: InputMaybe<Scalars['Float']>
   portalId: Scalars['String']
   portalType: PortalType
   requestedArea: Scalars['Float']
}

export type CreateTdrRequestInPortalAndSendOtpResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | CertificateNoExistsForOtherTdrRequests
   | CreateTdrRequestInPortalAndSendOtpResult
   | InvalidTdrRequestAuthority
   | MarketValueShouldBePositiveValue
   | NotHaveSufficientBalanceInTdrAccount
   | PortalNotFound
   | PrecisionLimitExceededForTdrRequestedArea
   | RequestedAreaGreaterThanAllocatedArea
   | TdrRequestCertificateNumberNotFound
   | TdrRequestedAreaShouldBePositive
   | TdrRequestedAreaShouldNotBeNegative
   | UserDoesNotHavePhoneNumber

export type CreateTdrRequestInPortalAndSendOtpResult = {
   __typename?: 'CreateTDRRequestInPortalAndSendOTPResult'
   maskedPhoneNumber: Scalars['String']
   tdrRequest: TdrRequest
}

export type CreateTdrRequestInPortalParams = {
   entityId: Scalars['String']
   entityType: TdrEntityType
   portalId: Scalars['String']
   portalType: PortalType
}

export type CreateTdrRequestInPortalResponse =
   | CreateTdrRequestInPortalResult
   | PortalAccessDenied
   | PortalIsDeleted
   | PortalNotFound
   | TdrRequestEntityAccessDenied
   | TdrRequestEntityNotFound

export type CreateTdrRequestInPortalResult = {
   __typename?: 'CreateTDRRequestInPortalResult'
   tdrRequest: TdrRequest
}

export type CreateTabParams = {
   enableCompletionIcon?: InputMaybe<Scalars['Boolean']>
   filesVerificationConfig?: InputMaybe<FilesVerificationTabConfigParams>
   iconConfig?: InputMaybe<IconConfigParams>
   layoutId: Scalars['String']
   name: Scalars['String']
   parentTabId?: InputMaybe<Scalars['String']>
   sectionsConfig?: InputMaybe<SectionsConfigParams>
   tabType: TabType
}

export type CreateTabResponse =
   | AddAnotherFieldsAreNotSupported
   | CreateTabResult
   | DependentFieldsNotSupported
   | FieldsAreDeleted
   | FieldsNotFound
   | FilesVerificationTabConfigIsRequired
   | GoFsNotFound
   | InvalidFileVerificationFieldType
   | InvalidOrderFieldIds
   | LayoutNotFound
   | LayoutTabNameAlreadyExists
   | MissingGofIds
   | MissingOrderFieldIds
   | NestedTabCreationNotAllowedInNestedTab
   | ParentTabDoesNotBelongToLayout
   | ParentTabNotFound
   | ParentTabShouldBeNestedTab
   | UserIsNotAnAdministrator

export type CreateTabResult = {
   __typename?: 'CreateTabResult'
   tab: Tab
}

export type CreateTableGraphParams = {
   analyticsLevel: AnalyticsLevel
   dashboardId?: InputMaybe<Scalars['String']>
   dataSources: Array<AnalyticsDataSourceType>
   description?: InputMaybe<Scalars['String']>
   dimension?: InputMaybe<GraphDimensionParams>
   enableColumnTotals?: InputMaybe<Scalars['Boolean']>
   metrics?: InputMaybe<Array<GraphMetricParams>>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type CreateTableGraphResponse =
   | DashboardAnalyticsLevelMismatch
   | DashboardNotFound
   | DashboardNotInPipeline
   | EmptyGraphDataSources
   | GraphCreationNotAllowedInExternalDashboard
   | GraphNameIsRequired
   | LeadOrDealDataSourceMustExists
   | NotSupportedDataSources
   | NotSupportedMultipleDataSources
   | PipelineAccessDenied
   | PipelineNotFound
   | TableGraphConfig
   | UnsupportedDataSourcesForPipeline
   | UserIsNotAnAdministrator

export type CreateTaskAddAnotherGoFParams = {
   gofId: Scalars['String']
   taskId: Scalars['String']
}

export type CreateTaskAddAnotherGoFResponse =
   | AddAnotherGoFResponsesLimitReached
   | CreateTaskAddAnotherGoFResult
   | GoFIsDeleted
   | GoFNotFound
   | NotAddAnotherGoF
   | NotTaskGoF
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound

export type CreateTaskAddAnotherGoFResult = {
   __typename?: 'CreateTaskAddAnotherGoFResult'
   gofResponse: GoFResponse
   taskId: Scalars['String']
}

export type CreateTaskNode = BaseNode & {
   __typename?: 'CreateTaskNode'
   assignee?: Maybe<TaskAssigneeEnum>
   assigneeFieldId?: Maybe<Scalars['String']>
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   startDate?: Maybe<StartDateValueConfig>
   startTime?: Maybe<StartTimeValueConfig>
   taskTemplateId?: Maybe<Scalars['String']>
}

export type CreateTaskNodeExecLog = BaseNodeExecLog & {
   __typename?: 'CreateTaskNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<CreateTaskNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type CreateTaskNodeExecLogResult = {
   __typename?: 'CreateTaskNodeExecLogResult'
   taskId: Scalars['String']
}

export type CreateTaskParams = {
   assigneeId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   startDate?: InputMaybe<Scalars['String']>
   startTime?: InputMaybe<Scalars['String']>
   templateId: Scalars['String']
   title?: InputMaybe<Scalars['String']>
}

export type CreateTaskResponse =
   | OnlyCustomTaskTypeHasTitle
   | PipelineItemAccessDenied
   | PipelineItemAndTaskTemplateFromDifferentPipeline
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | Task
   | TaskAssigneeDoesNotHavePipelineItemAccess
   | TaskAssigneeIsDeactivated
   | TaskAssigneeNotFound
   | TaskStartDateTimeShouldBeInFuture
   | TaskStartTimeNotAllowedWithoutStartDate
   | TaskTemplateIsDisabled
   | TaskTemplateNotFound
   | TitleIsRequiredForCustomTaskType

export type CreateTaskTemplateGoFParams = {
   addAnotherGofResponsesLimit?: InputMaybe<Scalars['Int']>
   description?: InputMaybe<Scalars['String']>
   enableAddAnother?: InputMaybe<Scalars['Boolean']>
   name: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type CreateTaskTemplateGoFResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | GoF
   | GoFNameAlreadyExists
   | NotSupportedForLinkedFieldsEnabledTaskTemplate
   | TaskTemplateNotFound
   | UserIsNotAnAdministrator

export type CreateTaskTemplateParams = {
   color: Scalars['String']
   description?: InputMaybe<Scalars['String']>
   iconUrl: Scalars['String']
   isLinkedFieldsEnabled?: InputMaybe<Scalars['Boolean']>
   name: Scalars['String']
   pipelineId: Scalars['String']
   taskApproxDurationInMins?: InputMaybe<Scalars['Int']>
   taskPipelineItemCardOverviewConfig?: InputMaybe<
      TaskPipelineItemCardOverviewConfigParams
   >
   taskType?: InputMaybe<ConfigurableTaskType>
}

export type CreateTaskTemplateResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | FieldsShouldBelongsToGivenPipelineItemTemplates
   | FieldsShouldNotBelongsToTaskTemplate
   | PipelineNotFound
   | TaskApproxDurationInMinsShouldBePositive
   | TaskTemplate
   | TaskTemplateNameAlreadyExists
   | UserIsNotAnAdministrator

export type CreateThreadParams = {
   entityId: Scalars['String']
   entityType: ThreadEntityType
}

export type CreateThreadResponse = CreateThreadResult | ThreadEntityNotFound

export type CreateThreadResult = {
   __typename?: 'CreateThreadResult'
   thread: Thread
}

export type CreateTimeFieldParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   relativeDefaultValueConfig?: InputMaybe<TimeRelativeDefaultValueConfigParams>
   tooltip?: InputMaybe<Scalars['String']>
}

export type CreateTimeFieldResponse =
   | CannotEditSystemGoF
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | GoFIsDeleted
   | GoFNotFound
   | InvalidFieldReferenceIdFormat
   | OnlySingleTypeOfDefaultValueIsAllowed
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | SecondsShouldBePositive
   | TimeField
   | UserIsNotAnAdministrator

export type CreateUnifiedApplicationInPortalParams = {
   buildingAreaInSquareMeter: Scalars['Float']
   buildingHeightInMeter: Scalars['Float']
   portalId: Scalars['String']
}

export type CreateUnifiedApplicationInPortalResponse =
   | ApplicationDisplayStageNotConfiguredForPipeline
   | BuildingAreaCannotBeNegative
   | BuildingHeightCannotBeNegative
   | CannotFindApplicationPipelineWithGivenValues
   | CreateUnifiedApplicationInPortalResult
   | NotApplicationPipeline
   | PipelineNotFound
   | PortalNotFound
   | PortalPipelineIdsNotConfigured
   | StageNotConfiguredForPipeline

export type CreateUnifiedApplicationInPortalResult = {
   __typename?: 'CreateUnifiedApplicationInPortalResult'
   applicationId: Scalars['String']
   applicationTemplateId: Scalars['String']
   pipelineId: Scalars['String']
   portalId: Scalars['String']
}

export type CreateUrlFieldParams = {
   alternateDisplayText?: InputMaybe<Scalars['String']>
   defaultValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   dynamicLabel?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
   helpTextType?: InputMaybe<HelpTextType>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   name: Scalars['String']
   parentFieldOptions?: InputMaybe<ParentFieldOptionsParams>
   placeholderText?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
   regexErrorMessage?: InputMaybe<Scalars['String']>
   tooltip?: InputMaybe<Scalars['String']>
   validationRegex?: InputMaybe<Scalars['String']>
}

export type CreateUrlFieldResponse =
   | CannotAddUniqueFieldInAddAnotherGof
   | CannotEditSystemGoF
   | DefaultValueNotAllowedForUniqueField
   | DeletedFieldExistsWithFieldName
   | DependentFieldsMustBeOfSameGoF
   | FieldNameAlreadyExistsInGof
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | GoFIsDeleted
   | GoFNotFound
   | InvalidDefaultValue
   | InvalidFieldReferenceIdFormat
   | InvalidValidationRegex
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentFieldNotInGoF
   | ParentFieldOptionsIsRequiredForDependentField
   | ParentOptionsShouldBeInExistingOptions
   | ReferenceIdAlreadyExistsInTemplate
   | UrlField
   | UserIsNotAnAdministrator

export type CreateUserInOfficerManagementParams = {
   designation?: InputMaybe<Scalars['String']>
   firstName: Scalars['String']
   lastName?: InputMaybe<Scalars['String']>
   phoneNumber: PhoneNumberParams
}

export type CreateUserInOfficerManagementResponse =
   | AccountWithThisPhoneNumberAlreadyExists
   | CreateUserInOfficerManagementResult
   | DuplicateFieldResponsesExistAmongFields
   | EmptyTdrAccountBalance
   | InvalidPhoneNumberFormat
   | OfficerManagementAccessDenied
   | RequiredFieldsNotFilled
   | TGbPassFileNumberNotFound
   | UnverifiedPhoneNumberGofResponseFieldsFound

export type CreateUserInOfficerManagementResult = {
   __typename?: 'CreateUserInOfficerManagementResult'
   firstName: Scalars['String']
   lastName?: Maybe<Scalars['String']>
   phoneNumber: PhoneNumberResponse
   user: User
   userId: Scalars['String']
}

export type CreateUserParams = {
   dob?: InputMaybe<Scalars['String']>
   email: Scalars['String']
   firstName?: InputMaybe<Scalars['String']>
   gender?: InputMaybe<Gender>
   isAdmin: Scalars['Boolean']
   lastName?: InputMaybe<Scalars['String']>
   phoneNumber: PhoneNumberParams
   profilePicUrl?: InputMaybe<Scalars['String']>
   username: Scalars['String']
}

export type CreateUserPropertiesTemplateGofResponse =
   | GoF
   | GoFNameAlreadyExists
   | UserIsNotAnAdministrator
   | UserPropertiesTemplateNotFound

export type CreateUserPropertiesTemplateGoFParams = {
   description?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   userPropertiesTemplateId: Scalars['String']
}

export type CreateUserResponse =
   | InvalidEmail
   | InvalidPhoneNumber
   | InvalidUsername
   | User
   | UserAlreadyExistWithEmail
   | UserAlreadyExistWithUsername
   | UserEmailAlreadyExistsInAnotherAccount
   | UserIsNotAnAdministrator
   | UserPhoneNumberAlreadyExist
   | UsernameAlreadyExists
   | UsernameAlreadyExistsInAnotherAccount

export type CreateVerificationTaskFromExistingTaskParams = {
   startDatetime?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
}

export type CreateVerificationTaskFromExistingTaskResponse =
   | CreateVerificationTaskFromExistingTaskResult
   | PipelineItemAccessDenied
   | TaskAccessDenied
   | TaskNotFound
   | TaskStartDateTimeShouldBeInFuture
   | VerificationTaskAlreadyExists

export type CreateVerificationTaskFromExistingTaskResult = {
   __typename?: 'CreateVerificationTaskFromExistingTaskResult'
   task: Task
}

export type CreateViewInBoardListParams = {
   listId: Scalars['String']
   name: Scalars['String']
   viewType?: InputMaybe<ViewType>
}

export type CreateViewInBoardListResponse = BoardListNotFound | View

export type CreateViewInBoardParams = {
   boardId: Scalars['String']
   name: Scalars['String']
   viewType?: InputMaybe<ViewType>
}

export type CreateViewInBoardResponse = BoardNotFound | View

export enum CreationRefType {
   DataLoading = 'DATA_LOADING',
   Digitalization = 'DIGITALIZATION',
   NewApplication = 'NEW_APPLICATION',
   SaleAndTransfer = 'SALE_AND_TRANSFER'
}

export type CrmAccountFeature = {
   __typename?: 'CrmAccountFeature'
   feature: CrmAccountFeatureEnum
   isDisabled: Scalars['Boolean']
}

export enum CrmAccountFeatureEnum {
   AiChatSupport = 'AI_CHAT_SUPPORT',
   ApplicationManagement = 'APPLICATION_MANAGEMENT',
   AttendanceTracking = 'ATTENDANCE_TRACKING',
   Contacts = 'CONTACTS',
   DataCopilot = 'DATA_COPILOT',
   Docusign = 'DOCUSIGN',
   FlowwSign = 'FLOWW_SIGN',
   GoogleCalendarIntegration = 'GOOGLE_CALENDAR_INTEGRATION',
   LtpUserManagement = 'LTP_USER_MANAGEMENT',
   OfficerManagement = 'OFFICER_MANAGEMENT',
   Scheduling = 'SCHEDULING',
   ScrutinyKeyGeneration = 'SCRUTINY_KEY_GENERATION',
   TdrManagement = 'TDR_MANAGEMENT'
}

export type CrmEntityFieldHasEmtpyResponse = GraphQlBaseError & {
   __typename?: 'CrmEntityFieldHasEmtpyResponse'
   crmEntityId: Scalars['String']
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CrmEntityLinkedRelatedObjectResult = {
   __typename?: 'CrmEntityLinkedRelatedObjectResult'
   relations: Array<RelationWiseRelatedEntities>
}

export type CrmEntityParentFieldsHasEmtpyResponse = GraphQlBaseError & {
   __typename?: 'CrmEntityParentFieldsHasEmtpyResponse'
   crmEntityId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CrmEntityTemplateNotFound = GraphQlBaseError & {
   __typename?: 'CrmEntityTemplateNotFound'
   crmTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CrmPipelineFeature = {
   __typename?: 'CrmPipelineFeature'
   feature: CrmPipelineFeatureEnum
   isDisabled: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export enum CrmPipelineFeatureEnum {
   Activities = 'ACTIVITIES',
   Calls = 'CALLS',
   ManualWhatsappMsgs = 'MANUAL_WHATSAPP_MSGS',
   ShareableResources = 'SHAREABLE_RESOURCES',
   Tasks = 'TASKS'
}

export type CrmPipelineItemTemplateNotLinkedToRelation = GraphQlBaseError & {
   __typename?: 'CrmPipelineItemTemplateNotLinkedToRelation'
   message?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   relationId: Scalars['String']
}

export type CrmTemplateNotFound = GraphQlBaseError & {
   __typename?: 'CrmTemplateNotFound'
   crmTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CrmTemplateScoringConfigBulkParams = {
   crmTemplateIds: Array<Scalars['String']>
   scoringConfigState: ScoringConfigState
}

export type CrmTemplateScoringConfigBulkResponse =
   | CrmTemplateScoringConfigBulkResult
   | CrmTemplatesNotFound
   | UserIsNotAnAdministrator

export type CrmTemplateScoringConfigBulkResult = {
   __typename?: 'CrmTemplateScoringConfigBulkResult'
   scoringConfigs: Array<ScoringConfig>
}

export type CrmTemplatesAccessDenied = GraphQlBaseError & {
   __typename?: 'CrmTemplatesAccessDenied'
   crmTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CrmTemplatesNotFound = GraphQlBaseError & {
   __typename?: 'CrmTemplatesNotFound'
   crmTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CurrentEntityAlreadyLinkedToAnotherEntityInOneToMany = GraphQlBaseError & {
   __typename?: 'CurrentEntityAlreadyLinkedToAnotherEntityInOneToMany'
   message?: Maybe<Scalars['String']>
}

export type CurrentEntityIsDeleted = GraphQlBaseError & {
   __typename?: 'CurrentEntityIsDeleted'
   currentEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CurrentEntityNotBelongsToRelation = GraphQlBaseError & {
   __typename?: 'CurrentEntityNotBelongsToRelation'
   currentEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
}

export type CurrentEntityNotFound = GraphQlBaseError & {
   __typename?: 'CurrentEntityNotFound'
   currentEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CustomAddAnotherSectionCard = BaseCard & {
   __typename?: 'CustomAddAnotherSectionCard'
   cardType: TabCardType
   gofId: Scalars['String']
   name: Scalars['String']
}

export type CustomDocumentTemplateConfig = {
   __typename?: 'CustomDocumentTemplateConfig'
   blocks: Array<DocumentTemplateBlock>
}

export type CustomFilter = {
   fieldId: Scalars['String']
   operator: FilterOperator
   templateId: Scalars['String']
   value?: InputMaybe<Scalars['String']>
}

export type CustomIdFieldIsNotConfiguredInApplicationPipeline = GraphQlBaseError & {
   __typename?: 'CustomIdFieldIsNotConfiguredInApplicationPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type CustomIdFieldIsNotSupportedInSalesTemplate = GraphQlBaseError & {
   __typename?: 'CustomIdFieldIsNotSupportedInSalesTemplate'
   message?: Maybe<Scalars['String']>
   salesEntityType: SalesEntityType
   salesTemplateId: Scalars['String']
}

export type CustomKeyFieldValueMapping = {
   __typename?: 'CustomKeyFieldValueMapping'
   key: Scalars['String']
   phoneNumberValueFormat?: Maybe<PhoneNumberValueFormatEnum>
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type CustomKeyFieldValueMappingParams = {
   key: Scalars['String']
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type CustomMetricsNotAllowedInFormula = GraphQlBaseError & {
   __typename?: 'CustomMetricsNotAllowedInFormula'
   message?: Maybe<Scalars['String']>
   metricIds: Array<Scalars['String']>
}

export type CustomObjPrimaryDisplayNameFieldExistsInGoF = GraphQlBaseError & {
   __typename?: 'CustomObjPrimaryDisplayNameFieldExistsInGoF'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CustomObjectCreatedOnShouldBeInPast = GraphQlBaseError & {
   __typename?: 'CustomObjectCreatedOnShouldBeInPast'
   createdOn: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CustomObjectCreationNotSupportedFields = GraphQlBaseError & {
   __typename?: 'CustomObjectCreationNotSupportedFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type CustomObjectPrimaryDetails = BasePipelineItemPrimaryDetails & {
   __typename?: 'CustomObjectPrimaryDetails'
   name: PipelineItemPrimaryFieldResult
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   stage: PipelineItemPrimaryFieldResult
}

export enum CustomObjectSystemFieldEnum {
   CustomObjectAssignedOn = 'CUSTOM_OBJECT_ASSIGNED_ON',
   CustomObjectAssignee = 'CUSTOM_OBJECT_ASSIGNEE',
   CustomObjectCreatedOn = 'CUSTOM_OBJECT_CREATED_ON',
   CustomObjectCustomId = 'CUSTOM_OBJECT_CUSTOM_ID',
   CustomObjectScore = 'CUSTOM_OBJECT_SCORE',
   CustomObjectStage = 'CUSTOM_OBJECT_STAGE'
}

export type CustomObjectTemplateNotFound = GraphQlBaseError & {
   __typename?: 'CustomObjectTemplateNotFound'
   customObjectTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type CustomObjectTemplatePluralNameIsRequired = GraphQlBaseError & {
   __typename?: 'CustomObjectTemplatePluralNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type CustomObjectTemplateProperties = {
   __typename?: 'CustomObjectTemplateProperties'
   pluralName: Scalars['String']
   primaryDisplayNameFieldId: Scalars['String']
   singularName: Scalars['String']
}

export type CustomObjectTemplateSingularNameIsRequired = GraphQlBaseError & {
   __typename?: 'CustomObjectTemplateSingularNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type CustomSection = {
   __typename?: 'CustomSection'
   customSectionId: Scalars['String']
   name: Scalars['String']
   orderedFieldIds: Array<Scalars['String']>
   sectionType: SectionType
   sectionUiStyle: SectionTabUiStyle
   table?: Maybe<SectionCustomTable>
   visibilityConditions: Array<CardVisibilityCondition>
}

export type CustomSectionCard = BaseCard & {
   __typename?: 'CustomSectionCard'
   cardType: TabCardType
   name: Scalars['String']
   orderedFieldIds: Array<Scalars['String']>
}

export type CustomSectionVisibilityCondition = {
   __typename?: 'CustomSectionVisibilityCondition'
   conditionId: Scalars['String']
   fieldId: Scalars['String']
   fieldSource: RuleConditionFieldSourceType
   operator: RuleConditionOperator
   value?: Maybe<Scalars['String']>
}

export type CustomSectionsNotFoundInPortalApplicationTab = GraphQlBaseError & {
   __typename?: 'CustomSectionsNotFoundInPortalApplicationTab'
   message?: Maybe<Scalars['String']>
   portalApplicationId: Scalars['String']
   sectionIds: Array<Scalars['String']>
   tabId: Scalars['String']
}

export type CustomerPhoneNumberIsRequiredToMakeCall = GraphQlBaseError & {
   __typename?: 'CustomerPhoneNumberIsRequiredToMakeCall'
   message?: Maybe<Scalars['String']>
}

export type CustomerPortalUserFeedback = {
   __typename?: 'CustomerPortalUserFeedback'
   feedback?: Maybe<Scalars['String']>
   feedbackId: Scalars['String']
   portalId: Scalars['String']
   rating?: Maybe<Scalars['Float']>
}

export type DndError = GraphQlBaseError & {
   __typename?: 'DNDError'
   message?: Maybe<Scalars['String']>
}

export type DaApplicabilityFieldConfig = {
   __typename?: 'DaApplicabilityFieldConfig'
   eligibleResponse: Scalars['String']
   field: Field
   fieldId: Scalars['String']
   notEligibleResponse: Scalars['String']
}

export type DaStatusFieldConfig = {
   __typename?: 'DaStatusFieldConfig'
   appliedResponse: Scalars['String']
   autoApprovedResponse: Scalars['String']
   field: Field
   fieldId: Scalars['String']
}

export type DaTimestampFieldConfig = {
   __typename?: 'DaTimestampFieldConfig'
   fieldId: Scalars['String']
}

export type Dashboard = {
   __typename?: 'Dashboard'
   analyticsLevel: AnalyticsLevel
   createdAt: Scalars['String']
   dashboardId: Scalars['String']
   externalDashboardUrl?: Maybe<Scalars['String']>
   identifications: Array<Identification>
   isExternalDashboard: Scalars['Boolean']
   name: Scalars['String']
   pipelineId?: Maybe<Scalars['String']>
   userFilterSetId?: Maybe<Scalars['String']>
   userHierarchyFilter: UserHierarchyFilter
}

export type DashboardAccessDenied = GraphQlBaseError & {
   __typename?: 'DashboardAccessDenied'
   dashboardId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DashboardAnalyticsLevelMismatch = GraphQlBaseError & {
   __typename?: 'DashboardAnalyticsLevelMismatch'
   message?: Maybe<Scalars['String']>
}

export type DashboardGraphAccessDenied = GraphQlBaseError & {
   __typename?: 'DashboardGraphAccessDenied'
   dashboardId: Scalars['String']
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DashboardNotFound = GraphQlBaseError & {
   __typename?: 'DashboardNotFound'
   dashboardId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DashboardNotInPipeline = GraphQlBaseError & {
   __typename?: 'DashboardNotInPipeline'
   dashboardId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export enum DataExportActionType {
   ExportContacts = 'EXPORT_CONTACTS',
   ExportFailedActivityLogs = 'EXPORT_FAILED_ACTIVITY_LOGS',
   ExportPipelineItems = 'EXPORT_PIPELINE_ITEMS',
   ExportPipelineItemsByIdentificationValue = 'EXPORT_PIPELINE_ITEMS_BY_IDENTIFICATION_VALUE',
   ExportPipelineItemRemarks = 'EXPORT_PIPELINE_ITEM_REMARKS',
   ExportUsers = 'EXPORT_USERS',
   ExportUserCallingConfigs = 'EXPORT_USER_CALLING_CONFIGS'
}

export enum DataExportReqStatus {
   Expired = 'EXPIRED',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   Success = 'SUCCESS'
}

export type DataExportRequest = {
   __typename?: 'DataExportRequest'
   actionType: DataExportActionType
   activityReferenceId?: Maybe<Scalars['String']>
   cloudCallingServiceAccountId?: Maybe<Scalars['String']>
   completedAt?: Maybe<Scalars['String']>
   dataExportRequestId: Scalars['String']
   dataFile?: Maybe<FileUploaderUrlResponse>
   expiryDatetime?: Maybe<Scalars['String']>
   exportType: DataExportType
   failureReason?: Maybe<Scalars['String']>
   fieldIds: Array<Scalars['String']>
   fileName?: Maybe<Scalars['String']>
   noOfItemsExported?: Maybe<Scalars['Int']>
   noOfItemsToBeExport?: Maybe<Scalars['Int']>
   pagination?: Maybe<PaginationResponse>
   pipelineId?: Maybe<Scalars['String']>
   pipelineItemId?: Maybe<Scalars['String']>
   preSignedExportedDataS3Url?: Maybe<Scalars['String']>
   requestedAt: Scalars['String']
   status: DataExportReqStatus
   viewId?: Maybe<Scalars['String']>
}

export type DataExportRequestNotFound = GraphQlBaseError & {
   __typename?: 'DataExportRequestNotFound'
   dataExportRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DataExportRequestStatusNotFailed = GraphQlBaseError & {
   __typename?: 'DataExportRequestStatusNotFailed'
   dataExportRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum DataExportType {
   Csv = 'CSV',
   Excel = 'EXCEL',
   Pdf = 'PDF',
   Zip = 'ZIP'
}

export type DataFileNotFound = GraphQlBaseError & {
   __typename?: 'DataFileNotFound'
   message?: Maybe<Scalars['String']>
}

export type DataFileNotFoundInS3 = GraphQlBaseError & {
   __typename?: 'DataFileNotFoundInS3'
   message?: Maybe<Scalars['String']>
}

export enum DataLoadingActionType {
   CompareFeeRuleSets = 'COMPARE_FEE_RULE_SETS',
   DeleteFieldRoles = 'DELETE_FIELD_ROLES',
   DeleteRecordValidationRules = 'DELETE_RECORD_VALIDATION_RULES',
   ExportFeeEngineVariables = 'EXPORT_FEE_ENGINE_VARIABLES',
   LetterActions = 'LETTER_ACTIONS',
   LoadActivities = 'LOAD_ACTIVITIES',
   LoadApplications = 'LOAD_APPLICATIONS',
   LoadApplicationIdConfig = 'LOAD_APPLICATION_ID_CONFIG',
   LoadAssignFriendConfiguration = 'LOAD_ASSIGN_FRIEND_CONFIGURATION',
   LoadBigQueryApplicationsBasicOverviewData = 'LOAD_BIG_QUERY_APPLICATIONS_BASIC_OVERVIEW_DATA',
   LoadBoardDefaultProperties = 'LOAD_BOARD_DEFAULT_PROPERTIES',
   LoadBoardLists = 'LOAD_BOARD_LISTS',
   LoadBoardPipelineItemCreationPermissions = 'LOAD_BOARD_PIPELINE_ITEM_CREATION_PERMISSIONS',
   LoadBoardViews = 'LOAD_BOARD_VIEWS',
   LoadCardsTableTab = 'LOAD_CARDS_TABLE_TAB',
   LoadCategoryConditions = 'LOAD_CATEGORY_CONDITIONS',
   LoadConditionalFieldOptions = 'LOAD_CONDITIONAL_FIELD_OPTIONS',
   LoadContacts = 'LOAD_CONTACTS',
   LoadCrmFunctions = 'LOAD_CRM_FUNCTIONS',
   LoadCustomObjects = 'LOAD_CUSTOM_OBJECTS',
   LoadDefaultSectionGofCustomTable = 'LOAD_DEFAULT_SECTION_GOF_CUSTOM_TABLE',
   LoadDocumentTemplates = 'LOAD_DOCUMENT_TEMPLATES',
   LoadDocumentTemplateBlocks = 'LOAD_DOCUMENT_TEMPLATE_BLOCKS',
   LoadEntityHolidaySchedule = 'LOAD_ENTITY_HOLIDAY_SCHEDULE',
   LoadEntityRuleSets = 'LOAD_ENTITY_RULE_SETS',
   LoadEntityWorkSchedule = 'LOAD_ENTITY_WORK_SCHEDULE',
   LoadFeeEngineConfig = 'LOAD_FEE_ENGINE_CONFIG',
   LoadFeeEngineRules = 'LOAD_FEE_ENGINE_RULES',
   LoadFieldRoles = 'LOAD_FIELD_ROLES',
   LoadLayouts = 'LOAD_LAYOUTS',
   LoadLayoutDocumentFieldsConfig = 'LOAD_LAYOUT_DOCUMENT_FIELDS_CONFIG',
   LoadLayoutExportNotesConfig = 'LOAD_LAYOUT_EXPORT_NOTES_CONFIG',
   LoadLayoutFeatureToggles = 'LOAD_LAYOUT_FEATURE_TOGGLES',
   LoadLayoutHeaderFields = 'LOAD_LAYOUT_HEADER_FIELDS',
   LoadLeads = 'LOAD_LEADS',
   LoadLeadDistributionRulesConfig = 'LOAD_LEAD_DISTRIBUTION_RULES_CONFIG',
   LoadLeadWithContacts = 'LOAD_LEAD_WITH_CONTACTS',
   LoadNumberGenerationConfigs = 'LOAD_NUMBER_GENERATION_CONFIGS',
   LoadObjectionTab = 'LOAD_OBJECTION_TAB',
   LoadOcSiteInspectionTab = 'LOAD_OC_SITE_INSPECTION_TAB',
   LoadPaymentRules = 'LOAD_PAYMENT_RULES',
   LoadPipelineItemDetailsDocumentTemplate = 'LOAD_PIPELINE_ITEM_DETAILS_DOCUMENT_TEMPLATE',
   LoadPipelineItemTasksAssignees = 'LOAD_PIPELINE_ITEM_TASKS_ASSIGNEES',
   LoadPipelineWhatsappBusinessPhoneNumbers = 'LOAD_PIPELINE_WHATSAPP_BUSINESS_PHONE_NUMBERS',
   LoadPortalCustomSections = 'LOAD_PORTAL_CUSTOM_SECTIONS',
   LoadPortalPipelineDocumentFields = 'LOAD_PORTAL_PIPELINE_DOCUMENT_FIELDS',
   LoadPortalPipelineTabs = 'LOAD_PORTAL_PIPELINE_TABS',
   LoadProposalFlowTabs = 'LOAD_PROPOSAL_FLOW_TABS',
   LoadReconciliationBankAccounts = 'LOAD_RECONCILIATION_BANK_ACCOUNTS',
   LoadReconciliationConfig = 'LOAD_RECONCILIATION_CONFIG',
   LoadReconciliationOnHoldFeeHeaders = 'LOAD_RECONCILIATION_ON_HOLD_FEE_HEADERS',
   LoadRecordValidationsConditions = 'LOAD_RECORD_VALIDATIONS_CONDITIONS',
   LoadRecordValidationsRules = 'LOAD_RECORD_VALIDATIONS_RULES',
   LoadRuleActions = 'LOAD_RULE_ACTIONS',
   LoadRvrCriteria = 'LOAD_RVR_CRITERIA',
   LoadRvrCriteriaConditions = 'LOAD_RVR_CRITERIA_CONDITIONS',
   LoadRvrCriteriaMapping = 'LOAD_RVR_CRITERIA_MAPPING',
   LoadShortTextPrefixConditionalOptions = 'LOAD_SHORT_TEXT_PREFIX_CONDITIONAL_OPTIONS',
   LoadSiteInspectionTab = 'LOAD_SITE_INSPECTION_TAB',
   LoadStageCompletionTabs = 'LOAD_STAGE_COMPLETION_TABS',
   LoadStagePermittedDocuments = 'LOAD_STAGE_PERMITTED_DOCUMENTS',
   LoadStagePermittedTabs = 'LOAD_STAGE_PERMITTED_TABS',
   LoadStageSlaFields = 'LOAD_STAGE_SLA_FIELDS',
   LoadStageTransitionFunctions = 'LOAD_STAGE_TRANSITION_FUNCTIONS',
   LoadStageTransitionSuccessPopupConfig = 'LOAD_STAGE_TRANSITION_SUCCESS_POPUP_CONFIG',
   LoadStageTransitionSummaryConfig = 'LOAD_STAGE_TRANSITION_SUMMARY_CONFIG',
   LoadSurveyNumbers = 'LOAD_SURVEY_NUMBERS',
   LoadTabs = 'LOAD_TABS',
   LoadTabGofCustomTable = 'LOAD_TAB_GOF_CUSTOM_TABLE',
   LoadTabGofGroups = 'LOAD_TAB_GOF_GROUPS',
   LoadTabGofMultipleTables = 'LOAD_TAB_GOF_MULTIPLE_TABLES',
   LoadTaskAssigneeConfigs = 'LOAD_TASK_ASSIGNEE_CONFIGS',
   LoadTaskTableTab = 'LOAD_TASK_TABLE_TAB',
   LoadTdrRequestAutomationConfig = 'LOAD_TDR_REQUEST_AUTOMATION_CONFIG',
   LoadTdrRequestDisplayStageConfig = 'LOAD_TDR_REQUEST_DISPLAY_STAGE_CONFIG',
   LoadTdrRequestPipelineItemTemplateConfig = 'LOAD_TDR_REQUEST_PIPELINE_ITEM_TEMPLATE_CONFIG',
   LoadTeamsData = 'LOAD_TEAMS_DATA',
   LoadTemplateBoards = 'LOAD_TEMPLATE_BOARDS',
   LoadTgBPassApplications = 'LOAD_TG_B_PASS_APPLICATIONS',
   LoadUsernames = 'LOAD_USERNAMES',
   LoadUsers = 'LOAD_USERS',
   LoadUserCallingConfigs = 'LOAD_USER_CALLING_CONFIGS',
   LoadViews = 'LOAD_VIEWS',
   LoadViewAndEditSanctionDetailsConfig = 'LOAD_VIEW_AND_EDIT_SANCTION_DETAILS_CONFIG',
   MoveApplicationOrders = 'MOVE_APPLICATION_ORDERS',
   UpdatePipelineConfig = 'UPDATE_PIPELINE_CONFIG'
}

export enum DataLoadingFieldsUpdateType {
   AllFields = 'ALL_FIELDS',
   SelectedFields = 'SELECTED_FIELDS'
}

export enum DataLoadingOperationType {
   CreateOnly = 'CREATE_ONLY',
   UpdateIfExists = 'UPDATE_IF_EXISTS'
}

export enum DataLoadingReqStatus {
   Accepted = 'ACCEPTED',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   PartiallyFailed = 'PARTIALLY_FAILED',
   Success = 'SUCCESS'
}

export type DataLoadingRequest = CsvDataLoadingRequest | SheetDataLoadingRequest

export type DataLoadingRequestNotFound = GraphQlBaseError & {
   __typename?: 'DataLoadingRequestNotFound'
   dataLoadingRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DataPoint = {
   __typename?: 'DataPoint'
   dataPointId: Scalars['String']
   displayValue: Scalars['String']
   value: Scalars['String']
}

export type DataSheetAccessDenied = GraphQlBaseError & {
   __typename?: 'DataSheetAccessDenied'
   dataSheetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DataSheetNotFound = GraphQlBaseError & {
   __typename?: 'DataSheetNotFound'
   dataSheetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DataSourceDisplayName = {
   __typename?: 'DataSourceDisplayName'
   dataSource: AnalyticsDataSourceType
   displayName: Scalars['String']
}

export type DataSourceIsNotRequired = GraphQlBaseError & {
   __typename?: 'DataSourceIsNotRequired'
   message?: Maybe<Scalars['String']>
}

export type DataSourceIsRequired = GraphQlBaseError & {
   __typename?: 'DataSourceIsRequired'
   message?: Maybe<Scalars['String']>
}

export type DataSourceIsRequiredForAdvancedAnalyticsLevelGraph = GraphQlBaseError & {
   __typename?: 'DataSourceIsRequiredForAdvancedAnalyticsLevelGraph'
   message?: Maybe<Scalars['String']>
}

export type DataSourceIsRequiredForFilterSetEntity = GraphQlBaseError & {
   __typename?: 'DataSourceIsRequiredForFilterSetEntity'
   filterSetEntity: FilterSetEntityType
   message?: Maybe<Scalars['String']>
}

export type DataSourceNotInFilterSetEntityDataSources = GraphQlBaseError & {
   __typename?: 'DataSourceNotInFilterSetEntityDataSources'
   dataSource: AnalyticsDataSourceType
   filterSetEntityDataSources: Array<AnalyticsDataSourceType>
   message?: Maybe<Scalars['String']>
}

export enum DataSourceType {
   Csv = 'CSV',
   Sheet = 'SHEET',
   Zip = 'ZIP'
}

export type DateField = BaseField & {
   __typename?: 'DateField'
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   relativeDefaultValueConfig?: Maybe<DateRelativeDefaultValueConfig>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type DateFilterRelativeConfig = {
   __typename?: 'DateFilterRelativeConfig'
   arithmeticOperator: RelativeFilterArithmeticOperator
   daysCount: Scalars['Int']
   monthsCount?: Maybe<Scalars['Int']>
   relativeFrom: RelativeFromEnum
   yearsCount?: Maybe<Scalars['Int']>
}

export type DateRange = {
   __typename?: 'DateRange'
   fromValue?: Maybe<Scalars['String']>
   toValue?: Maybe<Scalars['String']>
}

export type DateRangeParams = {
   fromDate?: InputMaybe<Scalars['String']>
   toDate?: InputMaybe<Scalars['String']>
}

export type DateRelativeDefaultValueConfig = {
   __typename?: 'DateRelativeDefaultValueConfig'
   noOfDays: Scalars['Int']
   operator: ArithmeticOperation
   valueEnum: DateValueEnum
}

export type DateRelativeDefaultValueConfigParams = {
   noOfDays: Scalars['Int']
   operator: ArithmeticOperation
   valueEnum: DateValueEnum
}

export type DateRelativeValueConfig = {
   __typename?: 'DateRelativeValueConfig'
   noOfDays: Scalars['Int']
}

export type DateRelativeValueConfigParams = {
   noOfDays: Scalars['Int']
}

export type DateTimeField = BaseField & {
   __typename?: 'DateTimeField'
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   relativeDefaultValueConfig?: Maybe<DateTimeRelativeDefaultValueConfig>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type DateTimeFilterRelativeConfig = {
   __typename?: 'DateTimeFilterRelativeConfig'
   arithmeticOperator: RelativeFilterArithmeticOperator
   daysCount: Scalars['Int']
   minutesCount?: Maybe<Scalars['Int']>
   monthsCount?: Maybe<Scalars['Int']>
   relativeFrom: RelativeFromEnum
   relativeTime?: Maybe<Scalars['String']>
   yearsCount?: Maybe<Scalars['Int']>
}

export type DateTimeRange = {
   __typename?: 'DateTimeRange'
   fromValue?: Maybe<Scalars['String']>
   toValue?: Maybe<Scalars['String']>
}

export type DateTimeRangeParams = {
   fromDatetime?: InputMaybe<Scalars['String']>
   toDatetime?: InputMaybe<Scalars['String']>
}

export type DateTimeRelativeDefaultValueConfig = {
   __typename?: 'DateTimeRelativeDefaultValueConfig'
   dateConfig?: Maybe<DateRelativeDefaultValueConfig>
   timeConfig?: Maybe<TimeRelativeDefaultValueConfig>
}

export type DateTimeRelativeDefaultValueConfigParams = {
   dateConfig?: InputMaybe<DateRelativeDefaultValueConfigParams>
   timeConfig?: InputMaybe<TimeRelativeDefaultValueConfigParams>
}

export enum DateValueEnum {
   CurrentDate = 'CURRENT_DATE'
}

export type DaysShouldBePositive = GraphQlBaseError & {
   __typename?: 'DaysShouldBePositive'
   message?: Maybe<Scalars['String']>
}

export type DeactivatePluginServiceAccountParams = {
   pluginServiceAccountId: Scalars['String']
}

export type DeactivatePluginServiceAccountResponse =
   | DeactivatePluginServiceAccountResult
   | InvalidPluginState
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator

export type DeactivatePluginServiceAccountResult = BasePluginServiceAccount & {
   __typename?: 'DeactivatePluginServiceAccountResult'
   isActive: Scalars['Boolean']
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
}

export type DeactivateUserParams = {
   userId: Scalars['String']
}

export type DeactivateUserResponse =
   | DeactivateUserResult
   | UserAndAdminAreNotInSameAccount
   | UserIsNotAnAdministrator
   | UserNotFound

export type DeactivateUserResult = {
   __typename?: 'DeactivateUserResult'
   userId: Scalars['String']
}

export type DeactivatedManager = GraphQlBaseError & {
   __typename?: 'DeactivatedManager'
   message?: Maybe<Scalars['String']>
}

export type DeactivatedUser = GraphQlBaseError & {
   __typename?: 'DeactivatedUser'
   message?: Maybe<Scalars['String']>
}

export type DeactivatedUserId = GraphQlBaseError & {
   __typename?: 'DeactivatedUserId'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type DeactivatedUsers = GraphQlBaseError & {
   __typename?: 'DeactivatedUsers'
   message?: Maybe<Scalars['String']>
   userIds: Array<Scalars['String']>
}

export type Deal = BasePipelineItem & {
   __typename?: 'Deal'
   contact: Contact
   createdAt: Scalars['String']
   dealEntityId: Scalars['String']
   dealEntityType: DealEntityType
   fields: Array<SystemFieldEnumResponseResult>
   latestRemarks?: Maybe<PipelineItemRemarks>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   task?: Maybe<Task>
}

export type DealFieldsArgs = {
   systemFieldEnums: Array<DealSystemFieldEnum>
}

export type DealAccessDenied = GraphQlBaseError & {
   __typename?: 'DealAccessDenied'
   dealId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DealAssigneeIsDeactivated = GraphQlBaseError & {
   __typename?: 'DealAssigneeIsDeactivated'
   assigneeId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DealAssigneeNotFound = GraphQlBaseError & {
   __typename?: 'DealAssigneeNotFound'
   assigneeId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DealAssigneesAreDeactivated = GraphQlBaseError & {
   __typename?: 'DealAssigneesAreDeactivated'
   assigneeIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DealAssigneesNotFound = GraphQlBaseError & {
   __typename?: 'DealAssigneesNotFound'
   assigneeIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DealEntityAccessDenied = GraphQlBaseError & {
   __typename?: 'DealEntityAccessDenied'
   dealEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DealEntityIsDeleted = GraphQlBaseError & {
   __typename?: 'DealEntityIsDeleted'
   dealEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DealEntityNotFound = GraphQlBaseError & {
   __typename?: 'DealEntityNotFound'
   dealEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum DealEntityType {
   Contact = 'CONTACT',
   Lead = 'LEAD'
}

export type DealFieldResponse = {
   __typename?: 'DealFieldResponse'
   dealId: Scalars['String']
   fieldResponse: FieldResponse
}

export type DealFieldResult =
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldNotFound
   | FieldResponse
   | NotDealField
   | NotPermittedField

export type DealHistory = BasePipelineItemHistory & {
   __typename?: 'DealHistory'
   data?: Maybe<PipelineItemHistoryData>
   eventDatetime: Scalars['String']
   pipelineItemHistoryEventType: PipelineItemHistoryEventType
   pipelineItemId: Scalars['String']
}

export type DealHistoryParams = {
   dealId: Scalars['String']
}

export type DealHistoryResponse =
   | DealAccessDenied
   | DealHistoryResult
   | DealIsDeleted
   | DealNotFound

export type DealHistoryResult = {
   __typename?: 'DealHistoryResult'
   history: Array<DealHistory>
}

export type DealIsDeleted = GraphQlBaseError & {
   __typename?: 'DealIsDeleted'
   dealId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DealNotFound = GraphQlBaseError & {
   __typename?: 'DealNotFound'
   dealId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DealPipelineIsNotSupported = GraphQlBaseError & {
   __typename?: 'DealPipelineIsNotSupported'
   message?: Maybe<Scalars['String']>
}

export type DealPipelineRelationIsNotSupported = GraphQlBaseError & {
   __typename?: 'DealPipelineRelationIsNotSupported'
   message?: Maybe<Scalars['String']>
}

export type DealPrimaryDetails = BasePipelineItemPrimaryDetails & {
   __typename?: 'DealPrimaryDetails'
   contactId: Scalars['String']
   dealEntityId: Scalars['String']
   dealEntityType: DealEntityType
   firstName: PipelineItemPrimaryFieldResult
   lastName: PipelineItemPrimaryFieldResult
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   stage: PipelineItemPrimaryFieldResult
   title: PipelineItemPrimaryFieldResult
}

export type DealProperties = BasePipelineItemProperties & {
   __typename?: 'DealProperties'
   contactId: Scalars['String']
   createdAt: Scalars['String']
   dealEntityId: Scalars['String']
   dealEntityType: DealEntityType
   fields: Array<FieldResponseResult>
   latestRemarks?: Maybe<PipelineItemRemarks>
   pipelineItemId: Scalars['String']
   pipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemSchedule?: Maybe<PipelineItemSchedule>
   pipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   scheduledPipelineItem?: Maybe<ScheduledPipelineItem>
}

export type DealPropertiesFieldsArgs = {
   fieldIds: Array<Scalars['String']>
}

export type DealPropertiesResponse =
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound
   | DealProperties

export enum DealSystemFieldEnum {
   ContactAssignedOn = 'CONTACT_ASSIGNED_ON',
   ContactAssignee = 'CONTACT_ASSIGNEE',
   ContactCustomId = 'CONTACT_CUSTOM_ID',
   ContactEmail = 'CONTACT_EMAIL',
   ContactFirstName = 'CONTACT_FIRST_NAME',
   ContactLastName = 'CONTACT_LAST_NAME',
   ContactPhoneNumber = 'CONTACT_PHONE_NUMBER',
   DealAssignedOn = 'DEAL_ASSIGNED_ON',
   DealAssignee = 'DEAL_ASSIGNEE',
   DealCreatedOn = 'DEAL_CREATED_ON',
   DealScore = 'DEAL_SCORE',
   DealStage = 'DEAL_STAGE',
   DealTitle = 'DEAL_TITLE'
}

export type DealSystemFieldResult = {
   __typename?: 'DealSystemFieldResult'
   contactId: Scalars['String']
   dealId: Scalars['String']
   fields: Array<SystemFieldEnumResponseResult>
}

export type DealSystemFieldsResponse =
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound
   | DealSystemFieldResult

export enum DealTemplateSystemFieldEnum {
   DealAssignedOn = 'DEAL_ASSIGNED_ON',
   DealAssignee = 'DEAL_ASSIGNEE',
   DealCreatedOn = 'DEAL_CREATED_ON',
   DealScore = 'DEAL_SCORE',
   DealStage = 'DEAL_STAGE',
   DealTitle = 'DEAL_TITLE'
}

export type DealTemplateSystemFields = {
   __typename?: 'DealTemplateSystemFields'
   dealTemplateId: Scalars['String']
   fields: Array<Field>
}

export type DealTemplateSystemFieldsResult = {
   __typename?: 'DealTemplateSystemFieldsResult'
   dealTemplateSystemFields: Array<DealTemplateSystemFields>
}

export type DealTemplatesAccessDenied = GraphQlBaseError & {
   __typename?: 'DealTemplatesAccessDenied'
   dealTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DealTemplatesNotFound = GraphQlBaseError & {
   __typename?: 'DealTemplatesNotFound'
   dealTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DealsAccessDenied = GraphQlBaseError & {
   __typename?: 'DealsAccessDenied'
   dealIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DealsAreDeleted = GraphQlBaseError & {
   __typename?: 'DealsAreDeleted'
   dealIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DealsFeatureIsDisabled = GraphQlBaseError & {
   __typename?: 'DealsFeatureIsDisabled'
   message?: Maybe<Scalars['String']>
}

export type DealsNotFound = GraphQlBaseError & {
   __typename?: 'DealsNotFound'
   dealIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DecimalPrecisionExceeded = GraphQlBaseError & {
   __typename?: 'DecimalPrecisionExceeded'
   decimalPrecision: Scalars['Int']
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type DecimalPrecisionLimitMustBePositive = GraphQlBaseError & {
   __typename?: 'DecimalPrecisionLimitMustBePositive'
   decimalPrecisionLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type DeemedApprovalConfigIsEmpty = GraphQlBaseError & {
   __typename?: 'DeemedApprovalConfigIsEmpty'
   message?: Maybe<Scalars['String']>
   pipelineItemTemplateId?: Maybe<Scalars['String']>
}

export type DeemedApprovalFieldsConfig = {
   __typename?: 'DeemedApprovalFieldsConfig'
   daApplicabilityField: DaApplicabilityFieldConfig
   daStatusField: DaStatusFieldConfig
   daTimestampField: DaTimestampFieldConfig
   officerCheckStatusField: OfficerCheckStatusFieldConfig
   pipelineItemTemplateId: Scalars['String']
}

export type DefaultNotification = {
   __typename?: 'DefaultNotification'
   message?: Maybe<Scalars['String']>
   notificationId: Scalars['String']
   notificationType: NotificationTypes
   readAt?: Maybe<Scalars['String']>
   sentAt: Scalars['String']
   title: Scalars['String']
}

export type DefaultSection = {
   __typename?: 'DefaultSection'
   gofId: Scalars['String']
   sectionType: SectionType
   sectionUiStyle: SectionTabUiStyle
}

export type DefaultStageValuesToPipeline = {
   __typename?: 'DefaultStageValuesToPipeline'
   displayStage: Stage
   stage: Stage
}

export type DefaultValueAllowedForNonUniqueFields = GraphQlBaseError & {
   __typename?: 'DefaultValueAllowedForNonUniqueFields'
   message?: Maybe<Scalars['String']>
}

export type DefaultValueFormatNotInAllowedFormats = GraphQlBaseError & {
   __typename?: 'DefaultValueFormatNotInAllowedFormats'
   message?: Maybe<Scalars['String']>
}

export type DefaultValueFormatNotInAllowedFormatsForLinkedFields = GraphQlBaseError & {
   __typename?: 'DefaultValueFormatNotInAllowedFormatsForLinkedFields'
   defaultValues: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DefaultValueMustBeInGivenOptions = GraphQlBaseError & {
   __typename?: 'DefaultValueMustBeInGivenOptions'
   defaultValue: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DefaultValueMustSatisfyGivenFloatRange = GraphQlBaseError & {
   __typename?: 'DefaultValueMustSatisfyGivenFloatRange'
   defaultValue?: Maybe<Scalars['Float']>
   maxValue?: Maybe<Scalars['Float']>
   message?: Maybe<Scalars['String']>
   minValue?: Maybe<Scalars['Float']>
}

export type DefaultValueMustSatisfyGivenFloatRangeForLinkedFields = GraphQlBaseError & {
   __typename?: 'DefaultValueMustSatisfyGivenFloatRangeForLinkedFields'
   defaultValues: Array<Scalars['Float']>
   maxValue?: Maybe<Scalars['Float']>
   message?: Maybe<Scalars['String']>
   minValue?: Maybe<Scalars['Float']>
}

export type DefaultValueMustSatisfyGivenIntegerRange = GraphQlBaseError & {
   __typename?: 'DefaultValueMustSatisfyGivenIntegerRange'
   defaultValue?: Maybe<Scalars['Int']>
   maxValue?: Maybe<Scalars['Int']>
   message?: Maybe<Scalars['String']>
   minValue?: Maybe<Scalars['Int']>
}

export type DefaultValueMustSatisfyGivenIntegerRangeForLinkedFields = GraphQlBaseError & {
   __typename?: 'DefaultValueMustSatisfyGivenIntegerRangeForLinkedFields'
   defaultValues: Array<Scalars['Int']>
   maxValue?: Maybe<Scalars['Int']>
   message?: Maybe<Scalars['String']>
   minValue?: Maybe<Scalars['Int']>
}

export type DefaultValueNotAllowedForUniqueField = GraphQlBaseError & {
   __typename?: 'DefaultValueNotAllowedForUniqueField'
   message?: Maybe<Scalars['String']>
}

export type DefaultValuesMustBeInGivenOptions = GraphQlBaseError & {
   __typename?: 'DefaultValuesMustBeInGivenOptions'
   defaultValues: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DeleteAllocationGroupSetParams = {
   allocationGroupSetId: Scalars['String']
}

export type DeleteAllocationGroupSetResponse =
   | AllocationGroupSetNotFound
   | DeleteAllocationGroupSetResult
   | LeadDistributionRuleIsNotInEditMode
   | NotEditableAllocationGroupSet
   | UserIsNotAnAdministrator

export type DeleteAllocationGroupSetResult = {
   __typename?: 'DeleteAllocationGroupSetResult'
   allocationGroupSetId: Scalars['String']
}

export type DeleteApplicationAddAnotherGoFInPortalParams = {
   applicationId: Scalars['String']
   gofResponseId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type DeleteApplicationAddAnotherGoFInPortalResponse =
   | AddAnotherGoFLimitValidationRuleFailed
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | CannotDeleteLastAddAnotherGoFResponse
   | DeleteApplicationAddAnotherGoFInPortalResult
   | GoFResponseIdNotFound
   | GoFResponseIsAlreadyDeleted
   | NotApplicationAddAnotherGoFResponse
   | PortalIsDeleted
   | PortalNotFound

export type DeleteApplicationAddAnotherGoFInPortalResult = {
   __typename?: 'DeleteApplicationAddAnotherGoFInPortalResult'
   applicationId: Scalars['String']
   gofResponseId: Scalars['String']
   portalId: Scalars['String']
}

export type DeleteApplicationAddAnotherGoFParams = {
   applicationId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type DeleteApplicationAddAnotherGoFResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | CannotDeleteLastAddAnotherGoFResponse
   | DeleteApplicationAddAnotherGoFResult
   | GoFResponseIdNotFound
   | GoFResponseIsAlreadyDeleted
   | NotApplicationAddAnotherGoFResponse

export type DeleteApplicationAddAnotherGoFResult = {
   __typename?: 'DeleteApplicationAddAnotherGoFResult'
   applicationId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type DeleteApplicationInPortalParams = {
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type DeleteApplicationInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ApplicationStageNotFound
   | DeleteApplicationInPortalResult
   | NoDeletionStageConfigured
   | NoStageTransitionToDeletionStage
   | PortalNotFound

export type DeleteApplicationInPortalResult = {
   __typename?: 'DeleteApplicationInPortalResult'
   applicationId: Scalars['String']
   availableActions: Array<PortalApplicationAction>
   isApplicationDeleted: Scalars['Boolean']
   isDeleted: Scalars['Boolean']
   portalId: Scalars['String']
}

export type DeleteApplicationTabGofsParams = {
   gofIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type DeleteApplicationTabGofsResponse =
   | DeleteApplicationTabGofsResult
   | PortalApplicationNotFound
   | TabNotFoundInPortalApplication
   | UserIsNotAnAdministrator

export type DeleteApplicationTabGofsResult = {
   __typename?: 'DeleteApplicationTabGofsResult'
   gofIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type DeleteApplicationTabParams = {
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type DeleteApplicationTabResponse =
   | DeleteApplicationTabResult
   | PortalApplicationNotFound
   | UserIsNotAnAdministrator

export type DeleteApplicationTabResult = {
   __typename?: 'DeleteApplicationTabResult'
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type DeleteApplicationTabSectionsParams = {
   customSectionIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type DeleteApplicationTabSectionsResponse =
   | CustomSectionsNotFoundInPortalApplicationTab
   | DeleteApplicationTabSectionsResult
   | GoFsNotFoundInPortalApplicationTab
   | NoSectionsSpecifiedForDeletion
   | PortalApplicationNotFound
   | TabNotFoundInPortalApplication
   | UserIsNotAnAdministrator

export type DeleteApplicationTabSectionsResult = {
   __typename?: 'DeleteApplicationTabSectionsResult'
   deletedCustomSectionIds: Array<Scalars['String']>
   deletedGofIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type DeleteAssigneeGroupParams = {
   assigneeGroupId: Scalars['String']
}

export type DeleteAssigneeGroupResponse =
   | AssigneeGroupNotFound
   | DeleteAssigneeGroupResult
   | UserIsNotAnAdministrator

export type DeleteAssigneeGroupResult = {
   __typename?: 'DeleteAssigneeGroupResult'
   assigneeGroupId: Scalars['String']
}

export type DeleteAutomationWorkflowConditionParams = {
   conditionId: Scalars['String']
   filterSetEntity: AutomationWorkflowFilterSetEntityType
}

export type DeleteAutomationWorkflowConditionResponse =
   | ConditionNotFound
   | DeleteAutomationWorkflowConditionResult
   | NotConditionNodeFilterSet
   | NotEditableNode
   | NotEditableTrigger
   | NotScheduledTriggerFilterSet
   | UserIsNotAnAdministrator

export type DeleteAutomationWorkflowConditionResult = {
   __typename?: 'DeleteAutomationWorkflowConditionResult'
   conditionId: Scalars['String']
   filterSetEntity: AutomationWorkflowFilterSetEntityType
}

export type DeleteAutomationWorkflowFilterParams = {
   filterId: Scalars['String']
   filterSetEntity: AutomationWorkflowFilterSetEntityType
}

export type DeleteAutomationWorkflowFilterResponse =
   | DeleteAutomationWorkflowFilterResult
   | FilterNotFound
   | NotConditionNodeFilterSet
   | NotEditableNode
   | NotEditableTrigger
   | NotScheduledTriggerFilterSet
   | UserIsNotAnAdministrator

export type DeleteAutomationWorkflowFilterResult = {
   __typename?: 'DeleteAutomationWorkflowFilterResult'
   filterId: Scalars['String']
   filterSetEntity: AutomationWorkflowFilterSetEntityType
}

export type DeleteAutomationWorkflowParams = {
   automationWorkflowId: Scalars['String']
}

export type DeleteAutomationWorkflowResponse =
   | AutomationWorkflowNotFound
   | DeleteAutomationWorkflowResult
   | PipelineAccessDenied
   | UserIsNotAnAdministrator

export type DeleteAutomationWorkflowResult = {
   __typename?: 'DeleteAutomationWorkflowResult'
   automationWorkflowId: Scalars['String']
}

export type DeleteBoardListParams = {
   listId: Scalars['String']
}

export type DeleteBoardListResponse =
   | BoardListEditAccessDenied
   | BoardListNotFound
   | DeleteBoardListResult
   | UserIsNotAnAdministrator

export type DeleteBoardListResult = {
   __typename?: 'DeleteBoardListResult'
   listId: Scalars['String']
}

export type DeleteBoardParams = {
   boardId: Scalars['String']
}

export type DeleteBoardResponse =
   | BoardEditAccessDenied
   | BoardNotFound
   | DeleteBoardResult
   | YouAreNotAllowedToEditSystemBoards

export type DeleteBoardResult = {
   __typename?: 'DeleteBoardResult'
   boardId: Scalars['String']
}

export type DeleteConditionParams = {
   conditionId: Scalars['String']
   filterSetEntity: FilterSetEntityType
}

export type DeleteConditionResponse =
   | ConditionNotFound
   | DeleteConditionResult
   | FilterSetAccessDenied
   | FilterSetNotLinkedToBoard
   | FilterSetNotLinkedToBoardList
   | FilterSetNotLinkedToGivenEntity
   | FilterSetNotLinkedToGraph
   | FilterSetNotLinkedToView
   | FiltersNotSupportedForExternalDashboard
   | NotAllowedToEditBoardFilterSet
   | NotAllowedToEditBoardListFilterSet
   | NotEditableFilterSetEntity
   | NotUserFilterSet
   | UserIsNotAnAdministrator

export type DeleteConditionResult = {
   __typename?: 'DeleteConditionResult'
   conditionId: Scalars['String']
}

export type DeleteDashboardParams = {
   dashboardId: Scalars['String']
}

export type DeleteDashboardResponse =
   | DashboardAccessDenied
   | DashboardNotFound
   | DeleteDashboardResult

export type DeleteDashboardResult = {
   __typename?: 'DeleteDashboardResult'
   dashboardId: Scalars['String']
}

export type DeleteDealAddAnotherGoFParams = {
   dealId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type DeleteDealAddAnotherGoFResponse =
   | CannotDeleteLastAddAnotherGoFResponse
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound
   | DeleteDealAddAnotherGoFResult
   | GoFResponseIdNotFound
   | GoFResponseIsAlreadyDeleted
   | NotDealAddAnotherGoFResponse

export type DeleteDealAddAnotherGoFResult = {
   __typename?: 'DeleteDealAddAnotherGoFResult'
   dealId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type DeleteDocumentParams = {
   documentId: Scalars['String']
}

export type DeleteDocumentResponse =
   | DeleteDocumentResult
   | DocumentNotFound
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted

export type DeleteDocumentResult = {
   __typename?: 'DeleteDocumentResult'
   documentId: Scalars['String']
}

export type DeleteDocumentTemplateParams = {
   documentTemplateId: Scalars['String']
}

export type DeleteDocumentTemplateResponse =
   | AdminDocumentTemplate
   | DocumentTemplateNotFound
   | UserIsNotAnAdministrator

export type DeleteEventTriggerConditionParams = {
   conditionId: Scalars['String']
   filterSetEntity: EventTriggerFilterSetEntity
}

export type DeleteEventTriggerConditionResponse =
   | DeleteEventTriggerConditionResult
   | EventTriggerConditionNotFound
   | EventTriggerFilterSetNotLinkedToGivenEntity
   | NotEditableEventTriggerFilterSetEntity
   | UserIsNotAnAdministrator

export type DeleteEventTriggerConditionResult = {
   __typename?: 'DeleteEventTriggerConditionResult'
   conditionId: Scalars['String']
   filterSetEntity: EventTriggerFilterSetEntity
}

export type DeleteEventTriggerFilterParams = {
   filterId: Scalars['String']
   filterSetEntity: EventTriggerFilterSetEntity
}

export type DeleteEventTriggerFilterResponse =
   | DeleteEventTriggerFilterResult
   | EventTriggerFilterNotFound
   | EventTriggerFilterSetNotLinkedToGivenEntity
   | NotEditableEventTriggerFilterSetEntity
   | UserIsNotAnAdministrator

export type DeleteEventTriggerFilterResult = {
   __typename?: 'DeleteEventTriggerFilterResult'
   filterId: Scalars['String']
   filterSetEntity: EventTriggerFilterSetEntity
}

export type DeleteFieldParams = {
   fieldId: Scalars['String']
   removeAsIdentifier?: InputMaybe<Scalars['Boolean']>
}

export type DeleteFieldResponse =
   | CannotDeleteIdentificationField
   | CannotDeletePrimaryDisplayNameField
   | CannotDeleteTaskTemplatesVisibilityField
   | CannotEditSystemField
   | DeleteFieldResult
   | FieldConfiguredInFormulaFields
   | FieldExistsInChildConditionFields
   | FieldIsDeleted
   | FieldNotFound
   | FieldsInConditionOptionsConfig
   | IdentificationFieldLinkedToForms
   | LinkedFieldsAreNotDeleted
   | UserIsNotAnAdministrator

export type DeleteFieldResult = {
   __typename?: 'DeleteFieldResult'
   deletedDependentFieldIds: Array<Scalars['String']>
   fieldId: Scalars['String']
   removeAsIdentifier?: Maybe<Scalars['Boolean']>
}

export type DeleteFilterParams = {
   filterId: Scalars['String']
   filterSetEntity: FilterSetEntityType
}

export type DeleteFilterResponse =
   | DeleteFilterResult
   | FilterNotFound
   | FilterSetAccessDenied
   | FilterSetNotLinkedToBoard
   | FilterSetNotLinkedToBoardList
   | FilterSetNotLinkedToGivenEntity
   | FilterSetNotLinkedToGraph
   | FilterSetNotLinkedToView
   | FiltersNotSupportedForExternalDashboard
   | NotAllowedToEditBoardFilterSet
   | NotAllowedToEditBoardListFilterSet
   | NotEditableFilterSetEntity
   | NotUserFilterSet
   | UserIsNotAnAdministrator

export type DeleteFilterResult = {
   __typename?: 'DeleteFilterResult'
   filterId: Scalars['String']
}

export type DeleteGoFParams = {
   gofId: Scalars['String']
}

export type DeleteGoFResponse =
   | ApplicationPrimaryDisplayNameFieldExistsInGoF
   | CannotDeleteFormGoF
   | CannotDeleteSystemGoF
   | CustomObjPrimaryDisplayNameFieldExistsInGoF
   | DeleteGoFResult
   | GoFNotFound
   | IdentificationFieldIdsExistsInGoF
   | LinkedFieldsAreNotDeleted
   | NotSupportedForLinkedFieldsEnabledTaskTemplate
   | UserIsNotAnAdministrator

export type DeleteGoFResult = {
   __typename?: 'DeleteGoFResult'
   gofId: Scalars['String']
}

export type DeleteGraphDimensionParams = {
   graphDimensionId: Scalars['String']
}

export type DeleteGraphDimensionResponse =
   | DeleteGraphDimensionResult
   | GraphDimensionNotFound
   | GraphNotFound
   | GraphShouldHaveAtLeastOneDimension
   | NotAllowedToDeleteGraphDimension
   | UserIsNotAnAdministrator

export type DeleteGraphDimensionResult = {
   __typename?: 'DeleteGraphDimensionResult'
   graphDimensionId: Scalars['String']
}

export type DeleteGraphsParams = {
   graphIds: Array<Scalars['String']>
}

export type DeleteGraphsResponse =
   | DeleteGraphsResult
   | GraphsNotFound
   | UserIsNotAnAdministrator

export type DeleteGraphsResult = {
   __typename?: 'DeleteGraphsResult'
   graphIds: Array<Scalars['String']>
}

export type DeleteIdentificationParams = {
   identificationId: Scalars['String']
}

export type DeleteIdentificationResponse =
   | DeleteIdentificationResult
   | IdentificationAndUserAreNotInSameAccount
   | IdentificationNotFound
   | UserIsNotAnAdministrator

export type DeleteIdentificationResult = {
   __typename?: 'DeleteIdentificationResult'
   identificationId: Scalars['String']
}

export type DeleteLeadAddAnotherGoFParams = {
   gofResponseId: Scalars['String']
   leadId: Scalars['String']
}

export type DeleteLeadAddAnotherGoFResponse =
   | CannotDeleteLastAddAnotherGoFResponse
   | DeleteLeadAddAnotherGoFResult
   | GoFResponseIdNotFound
   | GoFResponseIsAlreadyDeleted
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound
   | NotLeadAddAnotherGoFResponse

export type DeleteLeadAddAnotherGoFResult = {
   __typename?: 'DeleteLeadAddAnotherGoFResult'
   gofResponseId: Scalars['String']
   leadId: Scalars['String']
}

export type DeleteLeadBucketParams = {
   leadBucketId: Scalars['String']
}

export type DeleteLeadBucketResponse =
   | DeleteLeadBucketResult
   | LeadBucketNotFound
   | LeadDistributionRuleIsNotInEditMode
   | NotEditableLeadBucket
   | UserIsNotAnAdministrator

export type DeleteLeadBucketResult = {
   __typename?: 'DeleteLeadBucketResult'
   leadBucketId: Scalars['String']
}

export type DeleteMetricParams = {
   metricId: Scalars['String']
}

export type DeleteMetricResponse =
   | DeleteMetricResult
   | GraphMetricNotFound
   | MetricUsedInCustomMetricsFormula
   | MinimumOneMetricIsRequiredForGraph
   | NotAllowedToCreateGraphMetric
   | NotAllowedToDeleteGraphMetric
   | UserIsNotAnAdministrator

export type DeleteMetricResult = {
   __typename?: 'DeleteMetricResult'
   metricId: Scalars['String']
}

export type DeleteNodeParams = {
   nodeId: Scalars['String']
}

export type DeleteNodeResponse =
   | DeleteNodeResult
   | NodeNotFound
   | NotEditableNode
   | NotLeafNode
   | PipelineAccessDenied
   | UserIsNotAnAdministrator

export type DeleteNodeResult = {
   __typename?: 'DeleteNodeResult'
   nodeActions: Array<NodeActionsConfig>
   nodeId: Scalars['String']
}

export type DeleteParameterConditionParams = {
   parameterConditionId: Scalars['String']
}

export type DeleteParameterConditionResponse =
   | DeleteParameterConditionResult
   | ParameterConditionNotFound
   | UserIsNotAnAdministrator

export type DeleteParameterConditionResult = {
   __typename?: 'DeleteParameterConditionResult'
   parameterConditionId: Scalars['String']
}

export type DeleteParameterParams = {
   parameterId: Scalars['String']
}

export type DeleteParameterResponse =
   | DeleteParameterResult
   | ParameterHasReferences
   | ParameterIdNotFound
   | UserIsNotAnAdministrator

export type DeleteParameterResult = {
   __typename?: 'DeleteParameterResult'
   key: Scalars['String']
   parameterId: Scalars['String']
}

export type DeletePipelineCustomObjectAddAnotherGoFParams = {
   customObjectId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type DeletePipelineCustomObjectAddAnotherGoFResponse =
   | CannotDeleteLastAddAnotherGoFResponse
   | DeletePipelineCustomObjectAddAnotherGoFResult
   | GoFResponseIdNotFound
   | GoFResponseIsAlreadyDeleted
   | NotPipelineCustomObjectAddAnotherGoFResponse
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound

export type DeletePipelineCustomObjectAddAnotherGoFResult = {
   __typename?: 'DeletePipelineCustomObjectAddAnotherGoFResult'
   customObjectId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type DeletePipelineItemRemindersParams = {
   reminderIds: Array<Scalars['String']>
}

export type DeletePipelineItemRemindersResponse =
   | DeletePipelineItemRemindersResponseResult
   | PipelineItemRemindersAccessDenied
   | PipelineItemRemindersNotFound

export type DeletePipelineItemRemindersResponseResult = {
   __typename?: 'DeletePipelineItemRemindersResponseResult'
   reminderIds: Array<Scalars['String']>
}

export type DeleteRecordCreationConfigParams = {
   recordCreationConfigId: Scalars['Int']
}

export type DeleteRecordCreationConfigResponse =
   | DeleteRecordCreationConfigResult
   | UserIsNotAnAdministrator

export type DeleteRecordCreationConfigResult = {
   __typename?: 'DeleteRecordCreationConfigResult'
   recordCreationConfigId: Scalars['Int']
}

export type DeleteRelatedEntityAddAnotherGoFParams = {
   currentEntityId: Scalars['String']
   gofResponseId: Scalars['String']
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
}

export type DeleteRelatedEntityAddAnotherGoFResponse =
   | CannotDeleteLastAddAnotherGoFResponse
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | DeleteRelatedEntityAddAnotherGoFResult
   | GoFResponseIsAlreadyDeleted
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntityIsDeleted
   | RelatedEntityNotFound
   | RelationIsDeleted
   | RelationNotFound

export type DeleteRelatedEntityAddAnotherGoFResult = {
   __typename?: 'DeleteRelatedEntityAddAnotherGoFResult'
   currentEntityId: Scalars['String']
   gofResponseId: Scalars['String']
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
}

export type DeleteRelationParams = {
   relationId: Scalars['String']
}

export type DeleteRelationResponse =
   | DeleteRelationResult
   | RelationNotFound
   | UserIsNotAnAdministrator

export type DeleteRelationResult = {
   __typename?: 'DeleteRelationResult'
   relationId: Scalars['String']
}

export type DeleteSchedulePipelineItemsResult = {
   __typename?: 'DeleteSchedulePipelineItemsResult'
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export type DeleteScheduledPipelineItemsParams = {
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export type DeleteScheduledPipelineItemsResponse =
   | CompletedPipelineItemScheduledIds
   | DeleteSchedulePipelineItemsResult
   | GoogleAuthConsentNotGiven
   | GoogleAuthConsentRefreshRequired
   | GoogleCalendarApiRequestsQuotaExceeded
   | PipelineItemScheduledIdsAccessDenied
   | PipelineItemScheduledIdsNotFound

export type DeleteScoringParameterParams = {
   parameterId: Scalars['String']
}

export type DeleteScoringParameterResponse =
   | DeleteScoringParameterResult
   | ScoringParameterNotFound
   | UserIsNotAnAdministrator

export type DeleteScoringParameterResult = {
   __typename?: 'DeleteScoringParameterResult'
   parameterId: Scalars['String']
}

export type DeleteStageAddAnotherGoFsPermissionsParams = {
   gofIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type DeleteStageAddAnotherGoFsPermissionsResponse =
   | DeleteStageAddAnotherGoFsPermissionsResult
   | GoFsAreDeleted
   | GoFsNotFound
   | GoFsNotInPipeline
   | NotAddAnotherGoFs
   | StageAccessDenied
   | StageNotFound
   | UserIsNotAnAdministrator

export type DeleteStageAddAnotherGoFsPermissionsResult = {
   __typename?: 'DeleteStageAddAnotherGoFsPermissionsResult'
   gofIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type DeleteStageTransitionCheckpointParams = {
   checkpointId: Scalars['String']
}

export type DeleteStageTransitionCheckpointResponse =
   | DeleteStageTransitionCheckpointResult
   | StageTransitionCheckpointNotFound
   | UserIsNotAnAdministrator

export type DeleteStageTransitionCheckpointResult = {
   __typename?: 'DeleteStageTransitionCheckpointResult'
   checkpointId: Scalars['String']
}

export type DeleteStageTransitionParams = {
   stageTransitionId: Scalars['String']
}

export type DeleteStageTransitionResponse =
   | DeleteStageTransitionResult
   | UserIsNotAnAdministrator

export type DeleteStageTransitionResult = {
   __typename?: 'DeleteStageTransitionResult'
   stageTransitionId: Scalars['String']
}

export type DeleteTdrRequestsInPortalParams = {
   portalId: Scalars['String']
   portalType: PortalType
   tdrRequestIds: Array<Scalars['String']>
}

export type DeleteTdrRequestsInPortalResponse =
   | DeleteTdrRequestsInPortalResult
   | NotAllowedActionOnTdrRequests
   | PortalAccessDenied
   | PortalIsDeleted
   | PortalNotFound
   | TdrRequestEntityAccessDenied
   | TdrRequestsNotFound

export type DeleteTdrRequestsInPortalResult = {
   __typename?: 'DeleteTDRRequestsInPortalResult'
   tdrRequestIds: Array<Scalars['String']>
}

export type DeleteTabParams = {
   tabId: Scalars['String']
}

export type DeleteTabResponse =
   | DeleteTabResult
   | LayoutTabNotFound
   | UserIsNotAnAdministrator

export type DeleteTabResult = {
   __typename?: 'DeleteTabResult'
   tabId: Scalars['String']
}

export type DeleteTaskAddAnotherGoFParams = {
   gofResponseId: Scalars['String']
   taskId: Scalars['String']
}

export type DeleteTaskAddAnotherGoFResponse =
   | CannotDeleteLastAddAnotherGoFResponse
   | DeleteTaskAddAnotherGoFResult
   | GoFResponseIdNotFound
   | GoFResponseIsAlreadyDeleted
   | NotTaskAddAnotherGoFResponse
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound

export type DeleteTaskAddAnotherGoFResult = {
   __typename?: 'DeleteTaskAddAnotherGoFResult'
   gofResponseId: Scalars['String']
   taskId: Scalars['String']
}

export type DeleteUserKmlFileParams = {
   fileId: Scalars['String']
}

export type DeleteUserKmlFileResponse =
   | DeleteUserKmlFileResult
   | NotUserKmlFile
   | UserKmlFileNotFound

export type DeleteUserKmlFileResult = {
   __typename?: 'DeleteUserKmlFileResult'
   fileId: Scalars['String']
}

export type DeleteViewParams = {
   viewId: Scalars['String']
}

export type DeleteViewResponse =
   | DeleteViewResult
   | ViewAccessDenied
   | ViewNotFound

export type DeleteViewResult = {
   __typename?: 'DeleteViewResult'
   viewId: Scalars['String']
}

export type DeletedAssigneeFieldId = GraphQlBaseError & {
   __typename?: 'DeletedAssigneeFieldId'
   assigneeFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DeletedFieldExistsWithFieldName = GraphQlBaseError & {
   __typename?: 'DeletedFieldExistsWithFieldName'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type DeletedFieldExistsWithFieldReferenceId = GraphQlBaseError & {
   __typename?: 'DeletedFieldExistsWithFieldReferenceId'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   referenceId: Scalars['String']
}

export type DependentFieldNamesAlreadyExistsInGof = GraphQlBaseError & {
   __typename?: 'DependentFieldNamesAlreadyExistsInGof'
   message?: Maybe<Scalars['String']>
   names: Array<Scalars['String']>
}

export type DependentFieldNotFound = GraphQlBaseError & {
   __typename?: 'DependentFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DependentFields = {
   __typename?: 'DependentFields'
   dependentFieldIds: Array<Scalars['String']>
   option: Scalars['String']
}

export type DependentFieldsCannotBeRestoredWithoutParentFields = GraphQlBaseError & {
   __typename?: 'DependentFieldsCannotBeRestoredWithoutParentFields'
   dependentFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DependentFieldsMustBeOfSameGoF = GraphQlBaseError & {
   __typename?: 'DependentFieldsMustBeOfSameGoF'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DependentFieldsNotSupported = GraphQlBaseError & {
   __typename?: 'DependentFieldsNotSupported'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DependentFieldsParams = {
   dependentFieldIds: Array<Scalars['String']>
   option: Scalars['String']
}

export type DependentFieldsSelectedWithoutParent = GraphQlBaseError & {
   __typename?: 'DependentFieldsSelectedWithoutParent'
   dependentFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DigitalSignNotEnabledForBlock = GraphQlBaseError & {
   __typename?: 'DigitalSignNotEnabledForBlock'
   blockFieldName: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DigitalSignNotEnabledForTemplate = GraphQlBaseError & {
   __typename?: 'DigitalSignNotEnabledForTemplate'
   documentTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DirectCallingFallBackWhenCloudCallingFailedIsRequired = GraphQlBaseError & {
   __typename?: 'DirectCallingFallBackWhenCloudCallingFailedIsRequired'
   message?: Maybe<Scalars['String']>
}

export type DirectValueIsNotSupportedForPhoneNumberField = GraphQlBaseError & {
   __typename?: 'DirectValueIsNotSupportedForPhoneNumberField'
   message?: Maybe<Scalars['String']>
}

export type DirectValueIsNotSupportedForSwiftsellFixedIdentificationAttributes = GraphQlBaseError & {
   __typename?: 'DirectValueIsNotSupportedForSwiftsellFixedIdentificationAttributes'
   message?: Maybe<Scalars['String']>
}

export type DirectValueIsNotSupportedInNotificationNodeFieldMapping = GraphQlBaseError & {
   __typename?: 'DirectValueIsNotSupportedInNotificationNodeFieldMapping'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DirectValueNotSupportedForReferenceAssigneeConfig = GraphQlBaseError & {
   __typename?: 'DirectValueNotSupportedForReferenceAssigneeConfig'
   message?: Maybe<Scalars['String']>
}

export type DirectValueNotSupportedInRelationFieldValueMappings = GraphQlBaseError & {
   __typename?: 'DirectValueNotSupportedInRelationFieldValueMappings'
   message?: Maybe<Scalars['String']>
}

export type DirectValueNotSupportedOnUniqueFields = GraphQlBaseError & {
   __typename?: 'DirectValueNotSupportedOnUniqueFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DisableAccountFeaturesParams = {
   features: Array<CrmAccountFeatureEnum>
}

export type DisableAccountFeaturesResponse =
   | DisableAccountFeaturesResult
   | UserIsNotAnAdministrator

export type DisableAccountFeaturesResult = {
   __typename?: 'DisableAccountFeaturesResult'
   features: Array<CrmAccountFeatureEnum>
}

export type DisableAutoGenerateCustomIdParams = {
   fieldId: Scalars['String']
}

export type DisableAutoGenerateCustomIdResponse =
   | DisableAutoGenerateCustomIdResult
   | FieldNotFound
   | NotCustomIdField
   | UserIsNotAnAdministrator

export type DisableAutoGenerateCustomIdResult = {
   __typename?: 'DisableAutoGenerateCustomIdResult'
   autoGenerateCustomId: Scalars['Boolean']
   fieldId: Scalars['String']
}

export type DisablePipelineFeaturesParams = {
   features: Array<CrmPipelineFeatureEnum>
   pipelineId: Scalars['String']
}

export type DisablePipelineFeaturesResponse =
   | DisablePipelineFeaturesResult
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type DisablePipelineFeaturesResult = {
   __typename?: 'DisablePipelineFeaturesResult'
   features: Array<CrmPipelineFeatureEnum>
}

export type DisablePluginForAccountParams = {
   pluginType: PluginType
}

export type DisablePluginForAccountResponse =
   | AccountPluginNotFound
   | DisablePluginForAccountResult
   | UserIsNotAnAdministrator

export type DisablePluginForAccountResult = {
   __typename?: 'DisablePluginForAccountResult'
   isEnabled: Scalars['Boolean']
   pluginType: Scalars['String']
}

export type DisableWhatsAppBusinessPhoneNumberParams = {
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type DisableWhatsAppBusinessPhoneNumberResponse =
   | AccountPluginIsDisabled
   | DisableWhatsAppBusinessPhoneNumberResult
   | UserIsNotAnAdministrator
   | WhatsAppBusinessPhoneNumberNotFound

export type DisableWhatsAppBusinessPhoneNumberResult = {
   __typename?: 'DisableWhatsAppBusinessPhoneNumberResult'
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type DiscardPipelineItemPaymentRequestParams = {
   paymentRequestId: Scalars['String']
}

export type DiscardPipelineItemPaymentRequestResponse =
   | DiscardPipelineItemPaymentRequestResult
   | PaymentRequestNotFound

export type DiscardPipelineItemPaymentRequestResult = {
   __typename?: 'DiscardPipelineItemPaymentRequestResult'
   paymentRequestId: Scalars['String']
}

export type DisplayStageIdOnlySupportedInApplicationPipeline = GraphQlBaseError & {
   __typename?: 'DisplayStageIdOnlySupportedInApplicationPipeline'
   message?: Maybe<Scalars['String']>
}

export type DisplayStageIsRequiredInPipelineItemCreation = GraphQlBaseError & {
   __typename?: 'DisplayStageIsRequiredInPipelineItemCreation'
   message?: Maybe<Scalars['String']>
}

export type DisplayStageNotFound = GraphQlBaseError & {
   __typename?: 'DisplayStageNotFound'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type DisplayStageNotInPipeline = GraphQlBaseError & {
   __typename?: 'DisplayStageNotInPipeline'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type DisplayStagesNotFound = GraphQlBaseError & {
   __typename?: 'DisplayStagesNotFound'
   displayStageIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DistributeThroughItemExecLog =
   | LeadBucketExecLog
   | LeadPoolAllocationGroupItemExecLog

export type DistributeThroughItemSummary =
   | LeadBucketSummary
   | LeadPoolAllocationGroupItemSummary

export type DistributionThroughEntityNotFound = GraphQlBaseError & {
   __typename?: 'DistributionThroughEntityNotFound'
   distributionThroughEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DistributionThroughItem = AllocationGroupSet | LeadBucket

export enum DistributionThroughType {
   LeadBucket = 'LEAD_BUCKET',
   LeadPool = 'LEAD_POOL'
}

export type DistrictFieldNotFound = GraphQlBaseError & {
   __typename?: 'DistrictFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum DmsFormFieldMappingSource {
   Fixed = 'FIXED',
   LeadDetails = 'LEAD_DETAILS'
}

export type Document = {
   __typename?: 'Document'
   checkedCheckpointsCount: Scalars['Int']
   documentId: Scalars['String']
   documentTemplate?: Maybe<DocumentTemplate>
   documentTemplateId: Scalars['String']
   file: FileUploaderUrlResponse
   hasPendingSign: Scalars['Boolean']
   isRejected: Scalars['Boolean']
   lastUpdationDatetime: Scalars['String']
   latestVersion: DocumentVersion
   latestVersionId: Scalars['String']
   name: Scalars['String']
   pendingSignsInfo?: Maybe<DocumentPendingSignsInfo>
   pipelineItemId: Scalars['String']
   signatureFieldsStatus: Array<SignatureFieldStatus>
   variables: Array<DocumentVariable>
}

export type DocumentSignatureFieldsStatusArgs = {
   stageId: Scalars['String']
}

export type DocumentAccessDenied = GraphQlBaseError & {
   __typename?: 'DocumentAccessDenied'
   documentId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DocumentAlreadySentError = GraphQlBaseError & {
   __typename?: 'DocumentAlreadySentError'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type DocumentFieldsConfig = {
   __typename?: 'DocumentFieldsConfig'
   contextFields: Array<ContextField>
   documentFieldIds: Array<Scalars['String']>
}

export enum DocumentFormFieldTypes {
   Choice = 'CHOICE',
   Text = 'TEXT'
}

export type DocumentGenerationConfig = {
   __typename?: 'DocumentGenerationConfig'
   actionName?: Maybe<Scalars['String']>
   documentTemplateId: Scalars['String']
}

export type DocumentIsDeleted = GraphQlBaseError & {
   __typename?: 'DocumentIsDeleted'
   documentId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DocumentLog = {
   __typename?: 'DocumentLog'
   date: Scalars['String']
   documentId: Scalars['String']
   documentLogId: Scalars['String']
   logType: DocumentLogType
   portalType: DocumentLogPortalType
   time: Scalars['String']
   userId: Scalars['String']
}

export enum DocumentLogPortalType {
   CitizenPortal = 'CITIZEN_PORTAL',
   OfficerPortal = 'OFFICER_PORTAL'
}

export enum DocumentLogType {
   Download = 'DOWNLOAD',
   Preview = 'PREVIEW'
}

export type DocumentNotFound = GraphQlBaseError & {
   __typename?: 'DocumentNotFound'
   documentId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DocumentPendingSignsInfo = {
   __typename?: 'DocumentPendingSignsInfo'
   pendingSignFields: Array<DocumentSignatureField>
}

export type DocumentSignatureField = {
   __typename?: 'DocumentSignatureField'
   fieldName: Scalars['String']
   pageNumber: Scalars['Int']
   xPixel: Scalars['Int']
   yPixel: Scalars['Int']
}

export type DocumentTemplate = {
   __typename?: 'DocumentTemplate'
   description?: Maybe<Scalars['String']>
   documentTemplateId: Scalars['String']
   enableDigitalSign: Scalars['Boolean']
   name: Scalars['String']
}

export type DocumentTemplateBlock =
   | DtBpsVerificationRemarksBlock
   | DtConditionsBlock
   | DtDynamicTableBlock
   | DtEnforcementBlock
   | DtFooterBlock
   | DtGridBlock
   | DtHeaderBlock
   | DtListBlock
   | DtOcSiteInspectionFinalReportBlock
   | DtOcSiteInspectionInternalReportBlock
   | DtParagraphBlock
   | DtPaymentBlock
   | DtPaymentReceiptBlock
   | DtRemarksBlock
   | DtRepeatedTableBlock
   | DtSignatureBlock
   | DtSiteInspectionBlock
   | DtTdrRequestsBlock
   | DtTableBlock

export type DocumentTemplateBlockParams = {
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   bpsVerificationRemarksBlock?: InputMaybe<BpsVerificationRemarksBlockParams>
   conditionsBlock?: InputMaybe<DtConditionsBlockParams>
   dynamicTableBlock?: InputMaybe<DtDynamicTableBlockParams>
   footerBlock?: InputMaybe<DtFooterBlockParams>
   gridBlock?: InputMaybe<DtGridBlockParams>
   headerBlock?: InputMaybe<DtHeaderBlockParams>
   listBlock?: InputMaybe<DtListBlockParams>
   order: Scalars['Int']
   paragraphBlock?: InputMaybe<DtParagraphBlockParams>
   paymentBlock?: InputMaybe<DtPaymentBlockParams>
   repeatedTableBlock?: InputMaybe<DtRepeatedTableBlockParams>
   signatureBlock?: InputMaybe<DtTableSignatureBlockParams>
   siteInspectionBlock?: InputMaybe<DtSiteInspectionBlockParams>
   tableBlock?: InputMaybe<DtTableBlockParams>
}

export enum DocumentTemplateBlockType {
   AddAnotherGofTable = 'ADD_ANOTHER_GOF_TABLE',
   ApplicationDetailsTab = 'APPLICATION_DETAILS_TAB',
   BpsVerificationRemarks = 'BPS_VERIFICATION_REMARKS',
   Conditions = 'CONDITIONS',
   DynamicTable = 'DYNAMIC_TABLE',
   Enforcement = 'ENFORCEMENT',
   Footer = 'FOOTER',
   Grid = 'GRID',
   Header = 'HEADER',
   List = 'LIST',
   OcSiteInspectionFinalReport = 'OC_SITE_INSPECTION_FINAL_REPORT',
   OcSiteInspectionInternalReport = 'OC_SITE_INSPECTION_INTERNAL_REPORT',
   Paragraph = 'PARAGRAPH',
   Payment = 'PAYMENT',
   PaymentReceipt = 'PAYMENT_RECEIPT',
   Remarks = 'REMARKS',
   RepeatedTable = 'REPEATED_TABLE',
   ShortfallFieldRemarks = 'SHORTFALL_FIELD_REMARKS',
   Signature = 'SIGNATURE',
   SiteInspection = 'SITE_INSPECTION',
   Table = 'TABLE',
   TdrLedger = 'TDR_LEDGER',
   TdrRequests = 'TDR_REQUESTS'
}

export type DocumentTemplateFileTooLarge = GraphQlBaseError & {
   __typename?: 'DocumentTemplateFileTooLarge'
   maxLimitInBytes: Scalars['Float']
   message?: Maybe<Scalars['String']>
}

export type DocumentTemplateFormField = {
   __typename?: 'DocumentTemplateFormField'
   crmFieldMapping?: Maybe<DocumentTemplateFormFieldMapping>
   fieldType: DocumentFormFieldTypes
   name: Scalars['String']
}

export type DocumentTemplateFormFieldMapping = {
   __typename?: 'DocumentTemplateFormFieldMapping'
   source: DmsFormFieldMappingSource
   value: DocumentTemplateFormFieldMappingValue
}

export type DocumentTemplateFormFieldMappingParams = {
   source: DmsFormFieldMappingSource
   value: Scalars['String']
}

export type DocumentTemplateFormFieldMappingValue =
   | GqlDateTimeType
   | GqlDateType
   | GqlFloatType
   | GqlIntType
   | GqlListStringType
   | GqlStringType
   | GqlTimeType
   | GeoLocationFieldResponse
   | PhoneNumberResponse

export type DocumentTemplateFormFieldParams = {
   crmFieldMapping?: InputMaybe<DocumentTemplateFormFieldMappingParams>
   name: Scalars['String']
}

export type DocumentTemplateHasEmptyFormFields = GraphQlBaseError & {
   __typename?: 'DocumentTemplateHasEmptyFormFields'
   message?: Maybe<Scalars['String']>
}

export type DocumentTemplateIsDeleted = GraphQlBaseError & {
   __typename?: 'DocumentTemplateIsDeleted'
   documentTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum DocumentTemplateMappingFieldErrorCode {
   FieldCrmTemplatesAreNotSupported = 'FIELD_CRM_TEMPLATES_ARE_NOT_SUPPORTED',
   FieldTypesAreNotSupported = 'FIELD_TYPES_ARE_NOT_SUPPORTED'
}

export type DocumentTemplateNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'DocumentTemplateNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type DocumentTemplateNotFound = GraphQlBaseError & {
   __typename?: 'DocumentTemplateNotFound'
   documentTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DocumentTemplateNotLinkedToPipeline = GraphQlBaseError & {
   __typename?: 'DocumentTemplateNotLinkedToPipeline'
   documentTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type DocumentTemplateOverviewDetails = {
   __typename?: 'DocumentTemplateOverviewDetails'
   documentTemplateId: Scalars['String']
   isDeleted: Scalars['Boolean']
   latestFormFields: Array<Scalars['String']>
   name: Scalars['String']
   pipelineId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   signatureFields: Array<Scalars['String']>
}

export type DocumentTemplatePagesNotFound = GraphQlBaseError & {
   __typename?: 'DocumentTemplatePagesNotFound'
   message?: Maybe<Scalars['String']>
   pages: Array<Scalars['Int']>
}

export type DocumentTemplatePermittedActions = {
   __typename?: 'DocumentTemplatePermittedActions'
   documentTemplateId: Scalars['String']
   permittedActions: Array<EntityActionType>
}

export type DocumentTemplateQrCodeConfig = {
   __typename?: 'DocumentTemplateQRCodeConfig'
   pages: Array<Scalars['Int']>
   qrPositions: Array<QrCodePosition>
   qrSize: QrCodeSize
}

export type DocumentTemplateQrCodeConfigParams = {
   pages: Array<Scalars['Int']>
   qrPositions: Array<QrCodePosition>
   qrSize: QrCodeSize
}

export type DocumentTemplateSignatureFieldIdentifications = {
   __typename?: 'DocumentTemplateSignatureFieldIdentifications'
   fieldName: Scalars['String']
   identifications: Array<IdentificationOverviewDetails>
}

export type DocumentTemplateSignatureFieldIdentificationsParams = {
   fieldName: Scalars['String']
   identificationIds: Array<Scalars['String']>
}

export enum DocumentTemplateType {
   BlocksTemplate = 'BLOCKS_TEMPLATE',
   FormFieldsTemplate = 'FORM_FIELDS_TEMPLATE'
}

export type DocumentTemplateVersionNotFound = GraphQlBaseError & {
   __typename?: 'DocumentTemplateVersionNotFound'
   documentTemplateVersionId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DocumentTemplatesNotFound = GraphQlBaseError & {
   __typename?: 'DocumentTemplatesNotFound'
   documentTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DocumentVariable = {
   __typename?: 'DocumentVariable'
   name: Scalars['String']
   response?: Maybe<Scalars['String']>
   variableId: Scalars['String']
}

export type DocumentVariableParams = {
   response?: InputMaybe<Scalars['String']>
   variableId: Scalars['String']
}

export type DocumentVerificationButtonNotFount = GraphQlBaseError & {
   __typename?: 'DocumentVerificationButtonNotFount'
   buttonId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DocumentVerificationConfigurationMissing = GraphQlBaseError & {
   __typename?: 'DocumentVerificationConfigurationMissing'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type DocumentVerificationTabContextFieldsMapping = {
   __typename?: 'DocumentVerificationTabContextFieldsMapping'
   contextFieldIds: Array<Scalars['String']>
   questionFieldId: Scalars['String']
   responseRecommendations: Array<FieldResponseRecommendation>
   showWhenNoAttachment: Scalars['Boolean']
}

export type DocumentVerificationTabNotFound = GraphQlBaseError & {
   __typename?: 'DocumentVerificationTabNotFound'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type DocumentVerificationTabNotFount = GraphQlBaseError & {
   __typename?: 'DocumentVerificationTabNotFount'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type DocumentVerificationUser = {
   __typename?: 'DocumentVerificationUser'
   circle?: Maybe<Scalars['String']>
   user: BaseUser
   userId: Scalars['String']
   zone?: Maybe<Scalars['String']>
}

export type DocumentVersion = {
   __typename?: 'DocumentVersion'
   documentId: Scalars['String']
   documentVersionId: Scalars['String']
   file: FileUploaderUrlResponse
   generatedAt: Scalars['String']
   state: DocumentVersionState
}

export type DocumentVersionAccessDenied = GraphQlBaseError & {
   __typename?: 'DocumentVersionAccessDenied'
   documentVersionId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DocumentVersionIsDeleted = GraphQlBaseError & {
   __typename?: 'DocumentVersionIsDeleted'
   documentVersionId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type DocumentVersionNotFound = GraphQlBaseError & {
   __typename?: 'DocumentVersionNotFound'
   documentVersionId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum DocumentVersionState {
   Draft = 'DRAFT',
   Published = 'PUBLISHED'
}

export enum DocumentsFilterEnum {
   All = 'ALL',
   DocumentTemplateIds = 'DOCUMENT_TEMPLATE_IDS'
}

export type DocumentsTab = BaseTab & {
   __typename?: 'DocumentsTab'
   customDocumentFieldIds: Array<Scalars['String']>
   documentTemplateIds: Array<Scalars['String']>
   documentsFilterEnum: DocumentsFilterEnum
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type DocumentsVerificationAttachmentField = {
   __typename?: 'DocumentsVerificationAttachmentField'
   attachmentFieldId: Scalars['String']
   contextFieldsMapping: Array<DocumentVerificationTabContextFieldsMapping>
   showWhenNoResponse: Scalars['Boolean']
}

export type DocumentsVerificationTab = BaseTab & {
   __typename?: 'DocumentsVerificationTab'
   attachmentFieldIds: Array<Scalars['String']>
   attachmentFields: Array<DocumentsVerificationAttachmentField>
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
   taskTemplateId: Scalars['String']
   tvoTabConfig?: Maybe<TvoTab>
}

export type DocusignEmbedUrlApiFailed = GraphQlBaseError & {
   __typename?: 'DocusignEmbedUrlAPIFailed'
   errorCode?: Maybe<Scalars['String']>
   errorReason?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DocusignEnvelopeApiFailed = GraphQlBaseError & {
   __typename?: 'DocusignEnvelopeAPIFailed'
   errorCode?: Maybe<Scalars['String']>
   errorReason?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DocusignPluginNotConfigured = GraphQlBaseError & {
   __typename?: 'DocusignPluginNotConfigured'
   message?: Maybe<Scalars['String']>
}

export type DonutChart = {
   __typename?: 'DonutChart'
   data: Array<DonutChartData>
   dimensionName: Scalars['String']
   graphId: Scalars['String']
   metricName: Scalars['String']
   totalValue: Scalars['String']
}

export type DonutChartConfig = {
   __typename?: 'DonutChartConfig'
   analyticsLevel: AnalyticsLevel
   dataLabelsType: GraphDataLabelsType
   dataSources: Array<AnalyticsDataSourceType>
   dataSourcesWithDisplayNames: Array<DataSourceDisplayName>
   description?: Maybe<Scalars['String']>
   dimension: GraphDimension
   filterSetId: Scalars['String']
   graphId: Scalars['String']
   isOwner: Scalars['Boolean']
   metric: GraphMetric
   name: Scalars['String']
   numberOfSlices: Scalars['Int']
   pipelineId: Scalars['String']
   quickFilterFields: Array<GraphQuickFilterField>
   roles: Array<Role>
}

export type DonutChartData = {
   __typename?: 'DonutChartData'
   displayValue: Scalars['String']
   name: GraphDimensionValue
   percentage: Scalars['String']
   value: Scalars['String']
}

export type DonutChartResult =
   | DashboardAccessDenied
   | DashboardNotFound
   | DonutChart
   | GraphAccessDenied
   | GraphMetricNotFound
   | GraphNotFound
   | InvalidLimit
   | InvalidOffset
   | NotSupportedGraphParenType
   | ViewAccessDenied
   | ViewNotFound

export type DoubleHashIsNotSupportedInOptions = GraphQlBaseError & {
   __typename?: 'DoubleHashIsNotSupportedInOptions'
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type DraftEntityFeeRuleSetAlreadyExists = {
   __typename?: 'DraftEntityFeeRuleSetAlreadyExists'
   entityId: Scalars['String']
   feeRuleSetId: Scalars['String']
}

export type DropdownField = BaseField & {
   __typename?: 'DropdownField'
   allowOtherOptions: Scalars['Boolean']
   conditionalOptions: Array<ConditionalFieldOptions>
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dropdownFieldUiStyle: DropdownFieldUiStyleEnum
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isLabelsEnabled: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   optionColors: Array<OptionColorConfig>
   options: Array<Scalars['String']>
   optionsValueType: OptionsValueType
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export enum DropdownFieldUiStyleEnum {
   Dropdown = 'DROPDOWN',
   RadioGroup = 'RADIO_GROUP'
}

export type DtBpsVerificationRemarksBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtBpsVerificationRemarksBlock'
   assigneeFieldIds: Array<Scalars['String']>
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   order: Scalars['Int']
   recommendationEnums: Array<BpsVerificationRecommendationEnum>
   tableHeading: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type DtConditionsBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtConditionsBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   body?: Maybe<Scalars['String']>
   order: Scalars['Int']
   skipBlockInEmptyConditions: Scalars['Boolean']
   title: Scalars['String']
}

export type DtConditionsBlockParams = {
   body?: InputMaybe<Scalars['String']>
   categoryIds?: InputMaybe<Array<Scalars['String']>>
   skipBlockInEmptyConditions: Scalars['Boolean']
   title: Scalars['String']
}

export type DtDynamicTableBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtDynamicTableBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   heading?: Maybe<Scalars['String']>
   order: Scalars['Int']
   rows: Array<DtDynamicTableRow>
}

export type DtDynamicTableBlockParams = {
   heading?: InputMaybe<Scalars['String']>
   rows: Array<DtDynamicTableRowParams>
}

export type DtDynamicTableCell = {
   __typename?: 'DtDynamicTableCell'
   cellWidth: Scalars['Float']
   text?: Maybe<Scalars['String']>
}

export type DtDynamicTableCellParams = {
   cellWidth: Scalars['Float']
   text?: InputMaybe<Scalars['String']>
}

export type DtDynamicTableRow = {
   __typename?: 'DtDynamicTableRow'
   cells: Array<DtDynamicTableCell>
}

export type DtDynamicTableRowParams = {
   cells: Array<DtDynamicTableCellParams>
}

export type DtEnforcementBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtEnforcementBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   geoLocationFieldIds: Array<Scalars['String']>
   heading?: Maybe<Scalars['String']>
   order: Scalars['Int']
   photographFieldIds: Array<Scalars['String']>
   sectionId?: Maybe<Scalars['String']>
   tabId?: Maybe<Scalars['String']>
}

export type DtFooterBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtFooterBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   order: Scalars['Int']
   rightCornerText?: Maybe<Scalars['String']>
   signatureFieldName?: Maybe<Scalars['String']>
}

export type DtFooterBlockParams = {
   rightCornerText?: InputMaybe<Scalars['String']>
   signatureFieldName?: InputMaybe<Scalars['String']>
}

export type DtGridBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtGridBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   gridUnits: Array<DtGridUnit>
   heading?: Maybe<Scalars['String']>
   order: Scalars['Int']
}

export type DtGridBlockParams = {
   gridUnits: Array<DtGridUnitParams>
   heading?: InputMaybe<Scalars['String']>
}

export type DtGridUnit = {
   __typename?: 'DtGridUnit'
   alignment: TextAlignment
   textLines: Array<Scalars['String']>
   unitWidth: Scalars['Float']
}

export type DtGridUnitParams = {
   alignment: TextAlignment
   textLines: Array<Scalars['String']>
   unitWidth: Scalars['Float']
}

export type DtHeaderBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtHeaderBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   description?: Maybe<Scalars['String']>
   headerLogoUrl?: Maybe<Scalars['String']>
   order: Scalars['Int']
   rightCornerText?: Maybe<Scalars['String']>
   subtitle?: Maybe<Scalars['String']>
   title: Scalars['String']
}

export type DtHeaderBlockParams = {
   description?: InputMaybe<Scalars['String']>
   headerLogoUrl?: InputMaybe<Scalars['String']>
   rightCornerText?: InputMaybe<Scalars['String']>
   subtitle?: InputMaybe<Scalars['String']>
   title: Scalars['String']
}

export type DtListBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtListBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   description?: Maybe<Scalars['String']>
   heading?: Maybe<Scalars['String']>
   order: Scalars['Int']
   presentationType: DtListBlockPresentationType
   textLines: Array<Scalars['String']>
}

export type DtListBlockParams = {
   description?: InputMaybe<Scalars['String']>
   heading?: InputMaybe<Scalars['String']>
   presentationType: DtListBlockPresentationType
   textLines: Array<Scalars['String']>
}

export enum DtListBlockPresentationType {
   OrderedList = 'ORDERED_LIST',
   UnorderedList = 'UNORDERED_LIST'
}

export type DtOcSiteInspectionFinalReportBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtOCSiteInspectionFinalReportBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   heading?: Maybe<Scalars['String']>
   order: Scalars['Int']
   taskTemplateId: Scalars['String']
}

export type DtOcSiteInspectionInternalReportBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtOCSiteInspectionInternalReportBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   heading?: Maybe<Scalars['String']>
   order: Scalars['Int']
   taskTemplateId: Scalars['String']
}

export type DtParagraphBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtParagraphBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   heading?: Maybe<Scalars['String']>
   order: Scalars['Int']
   textLines: Array<Scalars['String']>
}

export type DtParagraphBlockParams = {
   heading?: InputMaybe<Scalars['String']>
   textLines: Array<Scalars['String']>
}

export type DtPaymentBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtPaymentBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   columnWidthPercentages: Array<Scalars['Float']>
   order: Scalars['Int']
   paymentRefId?: Maybe<Scalars['String']>
   title?: Maybe<Scalars['String']>
}

export type DtPaymentBlockParams = {
   columnWidthPercentages?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
   paymentRefId?: InputMaybe<Scalars['String']>
   title?: InputMaybe<Scalars['String']>
}

export type DtPaymentReceiptBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtPaymentReceiptBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   order: Scalars['Int']
   paymentRefId?: Maybe<Scalars['String']>
   title?: Maybe<Scalars['String']>
}

export type DtRemarksBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtRemarksBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   order: Scalars['Int']
   showSign?: Maybe<Scalars['Boolean']>
   signContent: Array<Scalars['String']>
}

export type DtRepeatedTableBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtRepeatedTableBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   dataSource: RepeatedTableDataSourceType
   heading?: Maybe<Scalars['String']>
   order: Scalars['Int']
   rows: Array<DtRepeatedTableRow>
}

export type DtRepeatedTableBlockParams = {
   dataSource: RepeatedTableDataSourceType
   heading?: InputMaybe<Scalars['String']>
   rows: Array<DtRepeatedTableRowParams>
}

export type DtRepeatedTableCell = {
   __typename?: 'DtRepeatedTableCell'
   cellWidth: Scalars['Float']
   text?: Maybe<Scalars['String']>
}

export type DtRepeatedTableCellParams = {
   cellWidth: Scalars['Float']
   text?: InputMaybe<Scalars['String']>
}

export type DtRepeatedTableRow = {
   __typename?: 'DtRepeatedTableRow'
   cells: Array<DtRepeatedTableCell>
}

export type DtRepeatedTableRowParams = {
   cells: Array<DtRepeatedTableCellParams>
}

export type DtSignatureBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtSignatureBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   captureCurrentDate: Scalars['Boolean']
   captureCurrentTime: Scalars['Boolean']
   description?: Maybe<Scalars['String']>
   fieldIds: Array<Scalars['String']>
   order: Scalars['Int']
   signatureFieldName: Scalars['String']
}

export type DtSiteInspectionBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtSiteInspectionBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   order: Scalars['Int']
   tableHeading: Scalars['String']
}

export type DtSiteInspectionBlockParams = {
   tableHeading: Scalars['String']
}

export type DtTdrRequestsBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtTDRRequestsBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   heading?: Maybe<Scalars['String']>
   order: Scalars['Int']
   tdrRequestStatuses: Array<Scalars['String']>
}

export type DtTableBlock = BaseDocumentTemplateBlock & {
   __typename?: 'DtTableBlock'
   blockId: Scalars['String']
   blockType: DocumentTemplateBlockType
   columnWidthPercentages: Array<Scalars['Float']>
   fieldIds: Array<Scalars['String']>
   order: Scalars['Int']
   title?: Maybe<Scalars['String']>
}

export type DtTableBlockParams = {
   columnWidthPercentages: Array<Scalars['Float']>
   fieldIds: Array<Scalars['String']>
   title?: InputMaybe<Scalars['String']>
}

export type DtTableSignatureBlockParams = {
   captureCurrentDate: Scalars['Boolean']
   captureCurrentTime: Scalars['Boolean']
   description?: InputMaybe<Scalars['String']>
   fieldIds: Array<Scalars['String']>
   signatureFieldName: Scalars['String']
}

export type DummyMutationResult = {
   __typename?: 'DummyMutationResult'
   response: Scalars['String']
   threadId: Scalars['Int']
}

export type DuplicateApplicationAssigneeFieldReferenceIdsToNotify = GraphQlBaseError & {
   __typename?: 'DuplicateApplicationAssigneeFieldReferenceIdsToNotify'
   assigneeFieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateAssigneeFieldIdsToNotify = GraphQlBaseError & {
   __typename?: 'DuplicateAssigneeFieldIdsToNotify'
   assigneeFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateAssigneeFieldsInGroup = GraphQlBaseError & {
   __typename?: 'DuplicateAssigneeFieldsInGroup'
   assigneeFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateAwVariablesMapping = GraphQlBaseError & {
   __typename?: 'DuplicateAwVariablesMapping'
   message?: Maybe<Scalars['String']>
   variables: Array<Scalars['String']>
}

export type DuplicateColumnHeaders = GraphQlBaseError & {
   __typename?: 'DuplicateColumnHeaders'
   message?: Maybe<Scalars['String']>
}

export type DuplicateCustomObjectAssigneeFieldReferenceIdsToNotify = GraphQlBaseError & {
   __typename?: 'DuplicateCustomObjectAssigneeFieldReferenceIdsToNotify'
   assigneeFieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateDependentFieldIds = GraphQlBaseError & {
   __typename?: 'DuplicateDependentFieldIds'
   dependentFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateEmails = GraphQlBaseError & {
   __typename?: 'DuplicateEmails'
   emails: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateFieldIds = GraphQlBaseError & {
   __typename?: 'DuplicateFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateFieldResponsesExistAmongFields = GraphQlBaseError & {
   __typename?: 'DuplicateFieldResponsesExistAmongFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateFieldsSelectorDependentOptions = GraphQlBaseError & {
   __typename?: 'DuplicateFieldsSelectorDependentOptions'
   dependentOptions: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateFormFieldsMapping = GraphQlBaseError & {
   __typename?: 'DuplicateFormFieldsMapping'
   formFields: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateGeoPoints = GraphQlBaseError & {
   __typename?: 'DuplicateGeoPoints'
   geoPoints: Array<GeoPoint>
   message?: Maybe<Scalars['String']>
}

export type DuplicateGoFResponseUniqueIds = GraphQlBaseError & {
   __typename?: 'DuplicateGoFResponseUniqueIds'
   gofResponseUniqueIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateHeaderKeys = GraphQlBaseError & {
   __typename?: 'DuplicateHeaderKeys'
   headerKeys: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateIdentifyEventIntegrationKeys = GraphQlBaseError & {
   __typename?: 'DuplicateIdentifyEventIntegrationKeys'
   integrationKeys: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateLeadAssigneeFieldReferenceIdsToNotify = GraphQlBaseError & {
   __typename?: 'DuplicateLeadAssigneeFieldReferenceIdsToNotify'
   assigneeFieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateManagerFieldIds = GraphQlBaseError & {
   __typename?: 'DuplicateManagerFieldIds'
   managerFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateNotificationNodeAssigneeFields = GraphQlBaseError & {
   __typename?: 'DuplicateNotificationNodeAssigneeFields'
   assigneeFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateOptionsInLabelColorConfig = GraphQlBaseError & {
   __typename?: 'DuplicateOptionsInLabelColorConfig'
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type DuplicatePayloadKeys = GraphQlBaseError & {
   __typename?: 'DuplicatePayloadKeys'
   message?: Maybe<Scalars['String']>
   payloadKeys: Array<Scalars['String']>
}

export type DuplicatePipelineIds = GraphQlBaseError & {
   __typename?: 'DuplicatePipelineIds'
   message?: Maybe<Scalars['String']>
   pipelineIds: Array<Scalars['String']>
}

export type DuplicatePipelineItemTemplateFieldNamesExists = GraphQlBaseError & {
   __typename?: 'DuplicatePipelineItemTemplateFieldNamesExists'
   fieldNames: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicatePropertiesKeys = GraphQlBaseError & {
   __typename?: 'DuplicatePropertiesKeys'
   keys: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateReferenceFieldsToCompareFromCsv = GraphQlBaseError & {
   __typename?: 'DuplicateReferenceFieldsToCompareFromCSV'
   fieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateReferenceFieldsToCompareFromSheet = GraphQlBaseError & {
   __typename?: 'DuplicateReferenceFieldsToCompareFromSheet'
   fieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateReferenceFieldsToCompareInRecords = GraphQlBaseError & {
   __typename?: 'DuplicateReferenceFieldsToCompareInRecords'
   fieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateRelationFieldMappings = GraphQlBaseError & {
   __typename?: 'DuplicateRelationFieldMappings'
   message?: Maybe<Scalars['String']>
   relationFieldMapping: Array<RelationIdFieldIdMapping>
}

export type DuplicateRelationsFound = GraphQlBaseError & {
   __typename?: 'DuplicateRelationsFound'
   message?: Maybe<Scalars['String']>
   relationIds: Array<Scalars['String']>
}

export type DuplicateResponsesForUniqueFieldResult = {
   __typename?: 'DuplicateResponsesForUniqueFieldResult'
   fieldId: Scalars['String']
   responses: Array<Scalars['String']>
}

export type DuplicateResponsesForUniqueFieldsResponse = GraphQlBaseError & {
   __typename?: 'DuplicateResponsesForUniqueFieldsResponse'
   message?: Maybe<Scalars['String']>
   responses: Array<DuplicateResponsesForUniqueFieldResult>
}

export type DuplicateSelectedFieldReferenceIds = GraphQlBaseError & {
   __typename?: 'DuplicateSelectedFieldReferenceIds'
   fieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateSignFieldsMapping = GraphQlBaseError & {
   __typename?: 'DuplicateSignFieldsMapping'
   message?: Maybe<Scalars['String']>
   sigFormFields: Array<Scalars['String']>
}

export type DuplicateStageFieldIds = GraphQlBaseError & {
   __typename?: 'DuplicateStageFieldIds'
   message?: Maybe<Scalars['String']>
   stageFieldIds: Array<Scalars['String']>
}

export type DuplicateSwiftsellCustomAttributes = GraphQlBaseError & {
   __typename?: 'DuplicateSwiftsellCustomAttributes'
   duplicateAttributes: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateTaskTemplateIds = GraphQlBaseError & {
   __typename?: 'DuplicateTaskTemplateIds'
   message?: Maybe<Scalars['String']>
   taskTemplateIds: Array<Scalars['String']>
}

export type DuplicateTimeIntervals = GraphQlBaseError & {
   __typename?: 'DuplicateTimeIntervals'
   message?: Maybe<Scalars['String']>
   timeIntervals: Array<Scalars['String']>
}

export type DuplicateTrackEventIntegrationKeys = GraphQlBaseError & {
   __typename?: 'DuplicateTrackEventIntegrationKeys'
   integrationKeys: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateTraitKeys = GraphQlBaseError & {
   __typename?: 'DuplicateTraitKeys'
   message?: Maybe<Scalars['String']>
   traitKeys: Array<Scalars['String']>
}

export type DuplicateUserPropertyFilterConditions = GraphQlBaseError & {
   __typename?: 'DuplicateUserPropertyFilterConditions'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type DuplicateViewParams = {
   viewId: Scalars['String']
}

export type DuplicateViewResponse = View | ViewAccessDenied | ViewNotFound

export type DuplicateWeekDays = GraphQlBaseError & {
   __typename?: 'DuplicateWeekDays'
   message?: Maybe<Scalars['String']>
   weekDays: Array<WeekDayEnum>
}

export type DynamicAssigneeConditionConfig = {
   __typename?: 'DynamicAssigneeConditionConfig'
   fieldId: Scalars['String']
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export enum DynamicAssigneeConditionConfigErrorCode {
   ConditionFieldShouldBeUniqueFieldType = 'CONDITION_FIELD_SHOULD_BE_UNIQUE_FIELD_TYPE',
   ConditionFieldShouldBeUserPropertiesField = 'CONDITION_FIELD_SHOULD_BE_USER_PROPERTIES_FIELD',
   FieldsAndSourcesAreMismatched = 'FIELDS_AND_SOURCES_ARE_MISMATCHED',
   FieldsAreDeleted = 'FIELDS_ARE_DELETED',
   FieldsAreNotCompatible = 'FIELDS_ARE_NOT_COMPATIBLE',
   FieldsNotFound = 'FIELDS_NOT_FOUND',
   FieldsNotInTriggerEntityTemplates = 'FIELDS_NOT_IN_TRIGGER_ENTITY_TEMPLATES',
   FieldsNotSupportedForTrigger = 'FIELDS_NOT_SUPPORTED_FOR_TRIGGER',
   FieldSourcesAreNotSupported = 'FIELD_SOURCES_ARE_NOT_SUPPORTED'
}

export type DynamicAssigneeConditionConfigParams = {
   fieldId: Scalars['String']
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type ESignBlocksAlreadySigned = GraphQlBaseError & {
   __typename?: 'ESignBlocksAlreadySigned'
   blockFieldNames: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type EitherEntityIdOrTdrRequestIdRequired = GraphQlBaseError & {
   __typename?: 'EitherEntityIdOrTDRRequestIdRequired'
   message?: Maybe<Scalars['String']>
}

export type EitherRemarksOrVoiceNoteIsRequired = GraphQlBaseError & {
   __typename?: 'EitherRemarksOrVoiceNoteIsRequired'
   message?: Maybe<Scalars['String']>
}

export type EmailField = BaseField & {
   __typename?: 'EmailField'
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   regexErrorMessage?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
   validationRegex?: Maybe<Scalars['String']>
}

export type EmailFieldsHasEmptyResponse = GraphQlBaseError & {
   __typename?: 'EmailFieldsHasEmptyResponse'
   emailFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type EmailNotFoundForOfficer = GraphQlBaseError & {
   __typename?: 'EmailNotFoundForOfficer'
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
   userId: Scalars['String']
}

export type EmailRefColumnIsNeeded = GraphQlBaseError & {
   __typename?: 'EmailRefColumnIsNeeded'
   emailFieldRefId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type EmailReferenceFieldMustBeIdentifierEmail = GraphQlBaseError & {
   __typename?: 'EmailReferenceFieldMustBeIdentifierEmail'
   message?: Maybe<Scalars['String']>
}

export type EmptyAgentAllocationGroupName = GraphQlBaseError & {
   __typename?: 'EmptyAgentAllocationGroupName'
   message?: Maybe<Scalars['String']>
}

export type EmptyFailedActivityLogsFound = GraphQlBaseError & {
   __typename?: 'EmptyFailedActivityLogsFound'
   message?: Maybe<Scalars['String']>
}

export type EmptyFieldReferenceIdsConfigured = GraphQlBaseError & {
   __typename?: 'EmptyFieldReferenceIdsConfigured'
   message?: Maybe<Scalars['String']>
}

export type EmptyFormLayoutLogoImageUrl = GraphQlBaseError & {
   __typename?: 'EmptyFormLayoutLogoImageURL'
   message?: Maybe<Scalars['String']>
}

export type EmptyGraphDataSources = GraphQlBaseError & {
   __typename?: 'EmptyGraphDataSources'
   message?: Maybe<Scalars['String']>
}

export type EmptyHeaderValues = GraphQlBaseError & {
   __typename?: 'EmptyHeaderValues'
   headerKeys: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type EmptyHistogramIntervalForHistogramGroupByType = GraphQlBaseError & {
   __typename?: 'EmptyHistogramIntervalForHistogramGroupByType'
   message?: Maybe<Scalars['String']>
}

export type EmptyLeadBucketName = GraphQlBaseError & {
   __typename?: 'EmptyLeadBucketName'
   message?: Maybe<Scalars['String']>
}

export type EmptyLeadDistributionRuleName = GraphQlBaseError & {
   __typename?: 'EmptyLeadDistributionRuleName'
   message?: Maybe<Scalars['String']>
}

export type EmptyMappingValueForFormFieldsMapping = GraphQlBaseError & {
   __typename?: 'EmptyMappingValueForFormFieldsMapping'
   formFields: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type EmptyPartiallyPaidContributedEntitiesFound = GraphQlBaseError & {
   __typename?: 'EmptyPartiallyPaidContributedEntitiesFound'
   message?: Maybe<Scalars['String']>
}

export type EmptyRangesForRangeGroupByType = GraphQlBaseError & {
   __typename?: 'EmptyRangesForRangeGroupByType'
   message?: Maybe<Scalars['String']>
}

export type EmptyScheduleDayConfig = GraphQlBaseError & {
   __typename?: 'EmptyScheduleDayConfig'
   message?: Maybe<Scalars['String']>
}

export type EmptyScheduleMinutesConfig = GraphQlBaseError & {
   __typename?: 'EmptyScheduleMinutesConfig'
   message?: Maybe<Scalars['String']>
}

export type EmptyScheduleMonthConfig = GraphQlBaseError & {
   __typename?: 'EmptyScheduleMonthConfig'
   message?: Maybe<Scalars['String']>
}

export type EmptyScheduleWeekConfig = GraphQlBaseError & {
   __typename?: 'EmptyScheduleWeekConfig'
   message?: Maybe<Scalars['String']>
}

export type EmptySignatureFields = GraphQlBaseError & {
   __typename?: 'EmptySignatureFields'
   message?: Maybe<Scalars['String']>
}

export type EmptyTdrAccountBalance = GraphQlBaseError & {
   __typename?: 'EmptyTDRAccountBalance'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type EmptyValuesForFieldValues = GraphQlBaseError & {
   __typename?: 'EmptyValuesForFieldValues'
   message?: Maybe<Scalars['String']>
}

export type EnableAccountFeaturesParams = {
   features: Array<CrmAccountFeatureEnum>
}

export type EnableAccountFeaturesResponse =
   | AnotherSigningFeatureToggleIsEnabled
   | CannotEnableMultipleSigningFeatures
   | EnableAccountFeaturesResult
   | UserIsNotAnAdministrator

export type EnableAccountFeaturesResult = {
   __typename?: 'EnableAccountFeaturesResult'
   features: Array<CrmAccountFeatureEnum>
}

export type EnableAutoGenerateCustomIdParams = {
   fieldId: Scalars['String']
}

export type EnableAutoGenerateCustomIdResponse =
   | EnableAutoGenerateCustomIdResult
   | FieldNotFound
   | NotCustomIdField
   | UserIsNotAnAdministrator

export type EnableAutoGenerateCustomIdResult = {
   __typename?: 'EnableAutoGenerateCustomIdResult'
   autoGenerateCustomId: Scalars['Boolean']
   fieldId: Scalars['String']
}

export type EnablePipelineFeaturesParams = {
   features: Array<CrmPipelineFeatureEnum>
   pipelineId: Scalars['String']
}

export type EnablePipelineFeaturesResponse =
   | EnablePipelineFeaturesResult
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type EnablePipelineFeaturesResult = {
   __typename?: 'EnablePipelineFeaturesResult'
   features: Array<CrmPipelineFeatureEnum>
}

export type EnablePluginForAccountParams = {
   pluginType: PluginType
}

export type EnablePluginForAccountResponse =
   | EnablePluginForAccountResult
   | UserIsNotAnAdministrator

export type EnablePluginForAccountResult = {
   __typename?: 'EnablePluginForAccountResult'
   isEnabled: Scalars['Boolean']
   pluginType: Scalars['String']
}

export type EnableWhatsAppBusinessPhoneNumberParams = {
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type EnableWhatsAppBusinessPhoneNumberResponse =
   | AccountPluginIsDisabled
   | EnableWhatsAppBusinessPhoneNumberResult
   | UserIsNotAnAdministrator
   | WhatsAppBusinessPhoneNumberNotFound

export type EnableWhatsAppBusinessPhoneNumberResult = {
   __typename?: 'EnableWhatsAppBusinessPhoneNumberResult'
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export enum EnabledStatus {
   Disabled = 'DISABLED',
   Enabled = 'ENABLED'
}

export type EncryptionKeyIsRequiredIfEncryptionEnabled = GraphQlBaseError & {
   __typename?: 'EncryptionKeyIsRequiredIfEncryptionEnabled'
   message?: Maybe<Scalars['String']>
}

export type EndOfficerLeaveParams = {
   leaveRequestId: Scalars['String']
}

export type EndOfficerLeaveResponse =
   | InvalidLeaveRequestId
   | OfficerIsDeactivated
   | OfficerLeaveLog
   | OfficerManagementAccessDenied

export type EnforcementRelatedComplaintsTab = BaseTab & {
   __typename?: 'EnforcementRelatedComplaintsTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export enum EntityActionType {
   Create = 'CREATE',
   Delete = 'DELETE',
   Update = 'UPDATE'
}

export type EntityCategoryCheckpoint = {
   __typename?: 'EntityCategoryCheckpoint'
   checkpointId: Scalars['String']
   checkpointType: CategoryCheckpointType
   editableText: Scalars['String']
   isDefault: Scalars['Boolean']
   isResetAllowed: Scalars['Boolean']
   readableText: Scalars['String']
}

export type EntityFeeRuleSet = {
   __typename?: 'EntityFeeRuleSet'
   appliedFeeHeaders: Array<AppliedFeeHeader>
   entityFeeRuleSetId: Scalars['String']
   entityId: Scalars['String']
   groups: Array<EntityFeeRuleSetGroup>
   status: EntityFeeRuleSetStatus
   totalAdjustedAmount: Scalars['Float']
   totalCalculatedAmount: Scalars['Float']
   totalNetAmount: Scalars['Float']
   version?: Maybe<EntityFeeRuleSetVersion>
}

export type EntityFeeRuleSetAccessDenied = {
   __typename?: 'EntityFeeRuleSetAccessDenied'
   actionType: EntityActionType
   entityFeeRuleSetId: Scalars['String']
}

export type EntityFeeRuleSetAlreadyExists = {
   __typename?: 'EntityFeeRuleSetAlreadyExists'
   entityId: Scalars['String']
   feeRuleSetId: Scalars['String']
}

export type EntityFeeRuleSetGroup = {
   __typename?: 'EntityFeeRuleSetGroup'
   appliedFeeHeaders: Array<AppliedFeeHeader>
   group: FeeRuleSetGroup
}

export type EntityFeeRuleSetNotFound = {
   __typename?: 'EntityFeeRuleSetNotFound'
   entityFeeRuleSetId: Scalars['String']
}

export type EntityFeeRuleSetOrdersCreated = {
   __typename?: 'EntityFeeRuleSetOrdersCreated'
   entityFeeRuleSetId: Scalars['String']
}

export enum EntityFeeRuleSetStatus {
   Draft = 'DRAFT',
   OrdersCreated = 'ORDERS_CREATED'
}

export enum EntityFeeRuleSetVersion {
   V1 = 'V1'
}

export type EntityFeeRuleSetsNotFound = {
   __typename?: 'EntityFeeRuleSetsNotFound'
   entityFeeRuleSetIds: Array<Scalars['String']>
}

export type EntityJsonConfigurationDoesNotExists = GraphQlBaseError & {
   __typename?: 'EntityJsonConfigurationDoesNotExists'
   entityId?: Maybe<Scalars['String']>
   entityType: JsonConfigurationEntityType
   message?: Maybe<Scalars['String']>
}

export type EntityTemplateNotFound = GraphQlBaseError & {
   __typename?: 'EntityTemplateNotFound'
   entityTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type EntityTemplateNotInPipeline = GraphQlBaseError & {
   __typename?: 'EntityTemplateNotInPipeline'
   entityTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type ErrorField = {
   __typename?: 'ErrorField'
   errorMessage: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
}

export type ErrorFieldsFound = GraphQlBaseError & {
   __typename?: 'ErrorFieldsFound'
   errorFields: Array<ErrorField>
   message?: Maybe<Scalars['String']>
}

export type EvaluateRuleSetsInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
   ruleSetIds: Array<Scalars['String']>
}

export type EvaluateRuleSetsInPortalResponse =
   | EvaluateRuleSetsInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type EvaluateRuleSetsInPortalResult = {
   __typename?: 'EvaluateRuleSetsInPortalResult'
   result: Array<EvaluatedRuleSet>
}

export type EvaluatedRuleSet = {
   __typename?: 'EvaluatedRuleSet'
   actionType?: Maybe<ActionType>
   entityId: Scalars['String']
   entityType: RuleEntityType
   isMatched: Scalars['Boolean']
   purpose: RuleSetPurpose
   ruleSetId: Scalars['String']
}

export type EventBasedAutomationWorkflowConfig = {
   __typename?: 'EventBasedAutomationWorkflowConfig'
   triggers: Array<EventBasedTriggerConfig>
}

export type EventBasedLdRuleAlreadyExistsForStageAssignee = GraphQlBaseError & {
   __typename?: 'EventBasedLdRuleAlreadyExistsForStageAssignee'
   assigneeFieldId: Scalars['String']
   entityTemplateId: Scalars['String']
   existingRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
   stageFieldId: Scalars['String']
}

export type EventBasedLdRuleTriggerConfig = LdRuleStageUpdatedTriggerConfig

export type EventBasedLeadDistributionRuleAlreadyExistsForTrigger = GraphQlBaseError & {
   __typename?: 'EventBasedLeadDistributionRuleAlreadyExistsForTrigger'
   entity: LeadDistributionTriggerEntity
   entityTemplateId: Scalars['String']
   eventType: LeadDistributionTriggerEventType
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type EventBasedLeadDistributionRuleAssigneeLog = {
   __typename?: 'EventBasedLeadDistributionRuleAssigneeLog'
   assignedFrom?: Maybe<BaseUser>
   assignedTo?: Maybe<BaseUser>
   fieldId: Scalars['String']
   isAssigneeHierarchyField: Scalars['Boolean']
}

export type EventBasedLeadDistributionRuleExecLog = {
   __typename?: 'EventBasedLeadDistributionRuleExecLog'
   assignedTo?: Maybe<BaseUser>
   assigneeHierarchy: Array<EventBasedLeadDistributionRuleAssigneeLog>
   completedAt?: Maybe<Scalars['String']>
   distributedEntityName?: Maybe<Scalars['String']>
   leadAssigneeFieldId: Scalars['String']
   leadDistributionRuleExecLogId: Scalars['String']
   leadId?: Maybe<Scalars['String']>
   leadName?: Maybe<Scalars['String']>
   name: Scalars['String']
   pipelineId: Scalars['String']
   remarks?: Maybe<Scalars['String']>
   status: EventBasedLeadDistributionRuleExecLogStatus
   syncAssigneeHierarchy: Scalars['Boolean']
   trigger: EventBasedLeadDistributionRuleTrigger
   triggeredAt: Scalars['String']
}

export enum EventBasedLeadDistributionRuleExecLogStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   Skipped = 'SKIPPED'
}

export type EventBasedLeadDistributionRuleIsNotSupported = GraphQlBaseError & {
   __typename?: 'EventBasedLeadDistributionRuleIsNotSupported'
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type EventBasedLeadDistributionRuleSettings = BaseLeadDistributionRuleSettings & {
   __typename?: 'EventBasedLeadDistributionRuleSettings'
   assignBasedOnAvailability: Scalars['Boolean']
   assigneeFieldIdsToNotify: Array<Scalars['String']>
   configStatus: LeadDistributionEntityConfigStatus
   distributionType: LeadDistributionRuleType
   leadDistributionRuleId: Scalars['String']
   managerFields: Array<LeadDistributionRuleManagerField>
   overrideGlobalQuota: Scalars['Boolean']
   syncAssigneeHierarchy: Scalars['Boolean']
}

export enum EventBasedLeadDistributionRuleStatus {
   Active = 'ACTIVE',
   Inactive = 'INACTIVE'
}

export type EventBasedLeadDistributionRuleSummary = {
   __typename?: 'EventBasedLeadDistributionRuleSummary'
   distributionThrough: DistributionThroughType
   distributionThroughItems: Array<EventBasedRuleDistributeThroughItemSummary>
   leadDistributionRuleId: Scalars['String']
   leadPool?: Maybe<EventBasedLeadPoolSummary>
   name: Scalars['String']
   pipelineId: Scalars['String']
   settings?: Maybe<EventBasedLeadDistributionRuleSettings>
   trigger?: Maybe<EventBasedLeadDistributionRuleTrigger>
}

export type EventBasedLeadDistributionRuleTrigger = {
   __typename?: 'EventBasedLeadDistributionRuleTrigger'
   config?: Maybe<EventBasedLdRuleTriggerConfig>
   entity: LeadDistributionTriggerEntity
   entityTemplateId: Scalars['String']
   eventType: LeadDistributionTriggerEventType
}

export type EventBasedLeadDistributionRuleTriggerParams = {
   entity: LeadDistributionTriggerEntity
   entityTemplateId: Scalars['String']
   eventType: LeadDistributionTriggerEventType
   stageUpdatedTriggerConfig?: InputMaybe<LdRuleStageUpdatedTriggerConfigParams>
}

export type EventBasedLeadPoolSummary = {
   __typename?: 'EventBasedLeadPoolSummary'
   leadAssigneeFieldConditionEnum: LeadPoolAssigneeConditionEnum
   leadAssigneeFieldId?: Maybe<Scalars['String']>
   leadDistributionRuleId: Scalars['String']
}

export type EventBasedRuleDistributeThroughItemSummary =
   | EventBasedRuleLeadBucketSummary
   | LeadPoolAllocationGroupItemSummary

export type EventBasedRuleLeadBucketSummary = {
   __typename?: 'EventBasedRuleLeadBucketSummary'
   allocationGroupItems: Array<AllocationGroupItemSummary>
   filterSetId: Scalars['String']
   leadBucketId: Scalars['String']
   name: Scalars['String']
}

export type EventBasedTrigger = BaseTrigger & {
   __typename?: 'EventBasedTrigger'
   automationWorkflowId: Scalars['String']
   config?: Maybe<AutomationWorkflowTriggerConfig>
   entity: TriggerEntity
   entityTemplateId: Scalars['String']
   name?: Maybe<Scalars['String']>
   rootNodeIds: Array<Scalars['String']>
   triggerEventType: TriggerEventType
   triggerId: Scalars['String']
   triggerType: TriggerType
}

export type EventBasedTriggerConfig = {
   __typename?: 'EventBasedTriggerConfig'
   execType: AutomationWorkflowExecType
   nodes: Array<NodeType>
   triggerEntity: TriggerEntity
   triggerEventType: TriggerEventType
}

export type EventDoneBy = {
   __typename?: 'EventDoneBy'
   entity?: Maybe<EventDoneByEntity>
   entityType: EventDoneByEntityType
}

export type EventDoneByEntity = BaseUser

export enum EventDoneByEntityType {
   System = 'SYSTEM',
   User = 'USER'
}

export type EventTriggerCondition = {
   __typename?: 'EventTriggerCondition'
   conditionId: Scalars['String']
   fieldId: Scalars['String']
   fieldSource: EventTriggerFilterFieldSourceType
   multiValues: Array<EventTriggerConditionValue>
   operator: EventTriggerOperator
   value?: Maybe<EventTriggerConditionValue>
}

export type EventTriggerConditionNotFound = GraphQlBaseError & {
   __typename?: 'EventTriggerConditionNotFound'
   conditionId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type EventTriggerConditionValue = {
   __typename?: 'EventTriggerConditionValue'
   value: EventTriggerConditionValueResult
   valueSource: EventTriggerFieldSourceType
}

export type EventTriggerConditionValueParams = {
   value: Scalars['String']
   valueSource: EventTriggerFieldSourceType
}

export type EventTriggerConditionValueResult =
   | BaseUser
   | DateRange
   | DateTimeRange
   | EventTriggerDateFilterReferenceRelativeConfig
   | EventTriggerDateFilterRelativeConfig
   | EventTriggerDateRangeFilterReferenceRelativeConfig
   | EventTriggerDateRangeFilterRelativeConfig
   | EventTriggerDateTimeFilterReferenceRelativeConfig
   | EventTriggerDateTimeFilterRelativeConfig
   | EventTriggerDateTimeRangeFilterReferenceRelativeConfig
   | FloatRange
   | GqlBooleanType
   | GqlDateTimeType
   | GqlDateType
   | GqlFloatType
   | GqlIntType
   | GqlStringType
   | GqlTaskStatusObj
   | GqlTimeType
   | IntegerRange
   | PhoneNumberResponse
   | Stage
   | TimeRange

export type EventTriggerDateFilterReferenceRelativeConfig = BaseEventTriggerDateRelativeFilterConfig & {
   __typename?: 'EventTriggerDateFilterReferenceRelativeConfig'
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   referenceField: EventTriggerReferenceFilterField
   relativeFrom: EventTriggerRelativeFromEnum
}

export type EventTriggerDateFilterRelativeConfig = BaseEventTriggerDateRelativeFilterConfig & {
   __typename?: 'EventTriggerDateFilterRelativeConfig'
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   relativeFrom: EventTriggerRelativeFromEnum
}

export type EventTriggerDateRangeFilterReferenceRelativeConfig = {
   __typename?: 'EventTriggerDateRangeFilterReferenceRelativeConfig'
   fromField: EventTriggerDateFilterReferenceRelativeConfig
   relativeFrom: EventTriggerRelativeFromEnum
   toField: EventTriggerDateFilterReferenceRelativeConfig
}

export type EventTriggerDateRangeFilterRelativeConfig = {
   __typename?: 'EventTriggerDateRangeFilterRelativeConfig'
   relativeDateRange: EventTriggerRelativeDateRangeEnum
   relativeFrom: EventTriggerRelativeFromEnum
}

export type EventTriggerDateTimeFilterReferenceRelativeConfig = BaseEventTriggerDateTimeRelativeFilterConfig & {
   __typename?: 'EventTriggerDateTimeFilterReferenceRelativeConfig'
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   minutesCount: Scalars['Int']
   referenceField: EventTriggerReferenceFilterField
   relativeFrom: EventTriggerRelativeFromEnum
}

export type EventTriggerDateTimeFilterRelativeConfig = BaseEventTriggerDateTimeRelativeFilterConfig & {
   __typename?: 'EventTriggerDateTimeFilterRelativeConfig'
   arithmeticOperator: ArithmeticOperation
   daysCount: Scalars['Int']
   minutesCount: Scalars['Int']
   relativeFrom: EventTriggerRelativeFromEnum
   relativeTime?: Maybe<Scalars['String']>
}

export type EventTriggerDateTimeRangeFilterReferenceRelativeConfig = {
   __typename?: 'EventTriggerDateTimeRangeFilterReferenceRelativeConfig'
   fromField: EventTriggerDateTimeFilterReferenceRelativeConfig
   relativeFrom: EventTriggerRelativeFromEnum
   toField: EventTriggerDateTimeFilterReferenceRelativeConfig
}

export enum EventTriggerFieldSourceType {
   DirectValue = 'DIRECT_VALUE',
   LeadDetails = 'LEAD_DETAILS',
   TriggerEntityDetails = 'TRIGGER_ENTITY_DETAILS'
}

export type EventTriggerFilter = {
   __typename?: 'EventTriggerFilter'
   conditions: Array<EventTriggerCondition>
   conditionsLogicalOperator: LogicalOperator
   filterId: Scalars['String']
   name: Scalars['String']
}

export type EventTriggerFilterFieldSourceIsNotSupportedForOperator = GraphQlBaseError & {
   __typename?: 'EventTriggerFilterFieldSourceIsNotSupportedForOperator'
   filterFieldSource: EventTriggerFilterFieldSourceType
   message?: Maybe<Scalars['String']>
}

export enum EventTriggerFilterFieldSourceType {
   LeadDetails = 'LEAD_DETAILS',
   TriggerEntityDetails = 'TRIGGER_ENTITY_DETAILS'
}

export type EventTriggerFilterNotFound = GraphQlBaseError & {
   __typename?: 'EventTriggerFilterNotFound'
   filterId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum EventTriggerFilterSetEntity {
   LeadBucket = 'LEAD_BUCKET',
   LeadPool = 'LEAD_POOL'
}

export type EventTriggerFilterSetNotFound = GraphQlBaseError & {
   __typename?: 'EventTriggerFilterSetNotFound'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type EventTriggerFilterSetNotLinkedToGivenEntity = GraphQlBaseError & {
   __typename?: 'EventTriggerFilterSetNotLinkedToGivenEntity'
   filterSetEntity: EventTriggerFilterSetEntity
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type EventTriggerFiltersResult = {
   __typename?: 'EventTriggerFiltersResult'
   filters: Array<EventTriggerFilter>
   filtersLogicalOperator: LogicalOperator
}

export enum EventTriggerOperator {
   Contains = 'CONTAINS',
   Empty = 'EMPTY',
   Eq = 'EQ',
   Gt = 'GT',
   Gte = 'GTE',
   In = 'IN',
   InTheLast = 'IN_THE_LAST',
   InTheNext = 'IN_THE_NEXT',
   Is = 'IS',
   IsAfter = 'IS_AFTER',
   IsBefore = 'IS_BEFORE',
   IsChanged = 'IS_CHANGED',
   IsIn = 'IS_IN',
   Lt = 'LT',
   Lte = 'LTE',
   Ne = 'NE',
   NotEmpty = 'NOT_EMPTY',
   NotIn = 'NOT_IN',
   Range = 'RANGE'
}

export type EventTriggerOperatorIsNotSupportedForField = GraphQlBaseError & {
   __typename?: 'EventTriggerOperatorIsNotSupportedForField'
   message?: Maybe<Scalars['String']>
   operator: EventTriggerOperator
}

export type EventTriggerOperatorIsNotSupportedForTrigger = GraphQlBaseError & {
   __typename?: 'EventTriggerOperatorIsNotSupportedForTrigger'
   message?: Maybe<Scalars['String']>
   operator: EventTriggerOperator
}

export type EventTriggerReferenceFilterField = {
   __typename?: 'EventTriggerReferenceFilterField'
   fieldId: Scalars['String']
   fieldSource: EventTriggerFilterFieldSourceType
}

export enum EventTriggerRelativeDateRangeEnum {
   LastMonth = 'LAST_MONTH',
   LastWeek = 'LAST_WEEK',
   NextMonth = 'NEXT_MONTH',
   NextWeek = 'NEXT_WEEK',
   ThisMonth = 'THIS_MONTH',
   ThisWeek = 'THIS_WEEK'
}

export enum EventTriggerRelativeFromEnum {
   FieldReference = 'FIELD_REFERENCE',
   Now = 'NOW',
   Today = 'TODAY',
   Tomorrow = 'TOMORROW',
   Yesterday = 'YESTERDAY'
}

export type ExcludeGofField = {
   __typename?: 'ExcludeGOFField'
   fieldIds: Array<Scalars['String']>
   gofResponseId: Scalars['String']
}

export type ExcludeGofFieldParams = {
   fieldIds: Array<Scalars['String']>
   gofResponseId: Scalars['String']
}

export type ExecuteFunctionNode = BaseNode & {
   __typename?: 'ExecuteFunctionNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   fieldId?: Maybe<Scalars['String']>
   function?: Maybe<Function>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
}

export type ExecuteFunctionNodeExecLog = BaseNodeExecLog & {
   __typename?: 'ExecuteFunctionNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<Scalars['String']>
   status: NodeExecLogStatusEnum
}

export type ExpectedPhoneNumberFieldType = GraphQlBaseError & {
   __typename?: 'ExpectedPhoneNumberFieldType'
   fieldId: Scalars['String']
   fieldType: FieldType
   message?: Maybe<Scalars['String']>
}

export type ExportContactsParams = {
   pagination?: InputMaybe<Pagination>
}

export type ExportContactsResponse =
   | DataExportRequest
   | EmptyFieldReferenceIdsConfigured
   | InvalidLimit
   | InvalidOffset
   | UserIsNotAnAdministrator

export type ExportFailedActivityLogsLimitExceeded = GraphQlBaseError & {
   __typename?: 'ExportFailedActivityLogsLimitExceeded'
   limit: Scalars['Int']
   maxLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type ExportFailedActivityLogsParams = {
   activityReferenceId: Scalars['String']
   datetimeRange?: InputMaybe<DateTimeRangeParams>
   fileName: Scalars['String']
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
}

export type ExportFailedActivityLogsResponse =
   | DataExportRequest
   | EmptyFailedActivityLogsFound
   | ExportFailedActivityLogsLimitExceeded
   | InvalidDateTimeRange
   | InvalidLimit
   | InvalidOffset
   | PipelineAccessDenied
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type ExportLimitExceeded = GraphQlBaseError & {
   __typename?: 'ExportLimitExceeded'
   limit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type ExportPipelineItemRemarksParams = {
   /** @deprecated Calculating file name manually */
   fileName?: InputMaybe<Scalars['String']>
   layoutId?: InputMaybe<Scalars['String']>
   pagination?: InputMaybe<Pagination>
   pipelineIds: Array<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type ExportPipelineItemRemarksResponse =
   | DataExportRequest
   | ExportLimitExceeded
   | InvalidLimit
   | InvalidOffset
   | LayoutNotFound
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type ExportPipelineItemsByIdentificationValueParams = {
   dataFile: FileUploaderUrlParams
   fieldIds: Array<Scalars['String']>
   fileName: Scalars['String']
   pipelineId: Scalars['String']
}

export type ExportPipelineItemsByIdentificationValueResponse =
   | DataExportRequest
   | DataFileNotFoundInS3
   | EmptyFieldReferenceIdsConfigured
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | HasSameFieldReferenceIdsInContactAndLead
   | NotSupportedForDealPipelineItemTypes
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type ExportPipelineItemsInViewParams = {
   viewId: Scalars['String']
}

export type ExportPipelineItemsInViewResponse =
   | ExportPipelineItemsInViewResult
   | LeadsNotFoundForPagination
   | ViewAccessDenied
   | ViewBoardNotLinkedToPipeline
   | ViewNotFound

export type ExportPipelineItemsInViewResult = {
   __typename?: 'ExportPipelineItemsInViewResult'
   fileName: Scalars['String']
   preSignedUrl: Scalars['String']
}

export type ExportPipelineItemsParams = {
   canIncludeContactFields?: InputMaybe<Scalars['Boolean']>
   fieldIds: Array<Scalars['String']>
   fileName: Scalars['String']
   pagination?: InputMaybe<Pagination>
   viewId: Scalars['String']
}

export type ExportPipelineItemsResponse =
   | DataExportRequest
   | EmptyFieldReferenceIdsConfigured
   | ExportLimitExceeded
   | FieldsAreDeleted
   | FieldsNotFound
   | HasSameFieldReferenceIdsInContactAndLead
   | InvalidLimit
   | InvalidOffset
   | LeadsNotFoundForPagination
   | NotPermittedFields
   | UserIsNotAnAdministrator
   | ViewAccessDenied
   | ViewBoardNotLinkedToPipeline
   | ViewNotFound

export type ExportUserCallingConfigsParams = {
   cloudCallingServiceAccountId: Scalars['String']
}

export type ExportUserCallingConfigsResponse =
   | CloudCallingServiceAccountAndAdminAreNotInSameAccount
   | CloudCallingServiceAccountNotFound
   | DataExportRequest
   | UserIsNotAnAdministrator

export type ExportUsersResponse = DataExportRequest | UserIsNotAnAdministrator

export type ExtFieldResponseType =
   | ExtFileUploaderFieldResponse
   | ExtGqlDateTimeType
   | ExtGqlDateType
   | ExtGqlFloatType
   | ExtGqlIntType
   | ExtGqlListStringType
   | ExtGqlStringType
   | ExtGqlTimeType
   | ExtGeoLocationFieldResponse
   | ExtGeoShapeFieldResponse
   | ExtPhoneNumberResponse
   | ExtShortTextFieldResponse
   | ExtStageResponse

export type ExtFileUploaderFieldResponse = {
   __typename?: 'ExtFileUploaderFieldResponse'
   urlResponses: Array<ExtFileUploaderUrlResponse>
}

export type ExtFileUploaderUrlResponse = {
   __typename?: 'ExtFileUploaderUrlResponse'
   fileId: Scalars['String']
   mimeType: Scalars['String']
   name?: Maybe<Scalars['String']>
   sizeInBytes: Scalars['Float']
   url: Scalars['String']
}

export type ExtGqlDateTimeType = {
   __typename?: 'ExtGQLDateTimeType'
   value?: Maybe<Scalars['String']>
}

export type ExtGqlDateType = {
   __typename?: 'ExtGQLDateType'
   value?: Maybe<Scalars['String']>
}

export type ExtGqlFloatType = {
   __typename?: 'ExtGQLFloatType'
   value?: Maybe<Scalars['Float']>
}

export type ExtGqlIntType = {
   __typename?: 'ExtGQLIntType'
   value?: Maybe<Scalars['Int']>
}

export type ExtGqlListStringType = {
   __typename?: 'ExtGQLListStringType'
   value: Array<Scalars['String']>
}

export type ExtGqlStringType = {
   __typename?: 'ExtGQLStringType'
   value?: Maybe<Scalars['String']>
}

export type ExtGqlTimeType = {
   __typename?: 'ExtGQLTimeType'
   value?: Maybe<Scalars['String']>
}

export type ExtGeoLocationFieldResponse = {
   __typename?: 'ExtGeoLocationFieldResponse'
   latitude: Scalars['Float']
   longitude: Scalars['Float']
}

export type ExtGeoPoint = {
   __typename?: 'ExtGeoPoint'
   latitude: Scalars['Float']
   longitude: Scalars['Float']
}

export type ExtGeoShapeFieldResponse = {
   __typename?: 'ExtGeoShapeFieldResponse'
   geoPoints: Array<ExtGeoPoint>
}

export type ExtPhoneNumberResponse = {
   __typename?: 'ExtPhoneNumberResponse'
   dialCode: Scalars['String']
   iso2CountryCode?: Maybe<Scalars['String']>
   phoneNumber: Scalars['String']
}

export type ExtShortTextFieldResponse = {
   __typename?: 'ExtShortTextFieldResponse'
   prefix?: Maybe<Scalars['String']>
   suffix?: Maybe<Scalars['String']>
   value: Scalars['String']
}

export type ExtStageResponse = {
   __typename?: 'ExtStageResponse'
   color?: Maybe<ColorEnum>
   name: Scalars['String']
   stageId: Scalars['String']
}

export type FailedActivityLogIdsNotFound = GraphQlBaseError & {
   __typename?: 'FailedActivityLogIdsNotFound'
   failedActivityLogIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   preSignedFailedActivityLogsS3Key: Scalars['String']
}

export enum FailedCallType {
   AnyError = 'ANY_ERROR',
   OnlyDnd = 'ONLY_DND'
}

export type FailedFormSubmissionLog = {
   __typename?: 'FailedFormSubmissionLog'
   failureReason?: Maybe<Scalars['String']>
   formId: Scalars['String']
   formSubmissionLogId: Scalars['String']
   publishedFormVersion?: Maybe<PublishedFormVersionResult>
   requestedData?: Maybe<Scalars['String']>
   submittedAt: Scalars['String']
}

export type FailedTrackActivityLog = {
   __typename?: 'FailedTrackActivityLog'
   activityLogId: Scalars['String']
   activityTemplateId?: Maybe<Scalars['String']>
   failedReason?: Maybe<Scalars['String']>
   pipelineId?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   requestedAt?: Maybe<Scalars['String']>
   requestedData?: Maybe<Scalars['String']>
}

export enum FeatureEnum {
   PinnedPipelineItems = 'PINNED_PIPELINE_ITEMS',
   ScheduledPipelineItems = 'SCHEDULED_PIPELINE_ITEMS'
}

export type FeatureNotEnabled = GraphQlBaseError & {
   __typename?: 'FeatureNotEnabled'
   feature: CrmAccountFeatureEnum
   message?: Maybe<Scalars['String']>
}

export type FeeCalculateParams = {
   feeRuleSetId: Scalars['String']
   officerCode: Scalars['String']
}

export type FeeCalculateResponse =
   | DataSheetAccessDenied
   | DataSheetNotFound
   | FeeCalculateResult
   | FeeRuleSetNotFound

export type FeeCalculateResult = {
   __typename?: 'FeeCalculateResult'
   entityFeeRuleSet: EntityFeeRuleSet
}

export type FeeCreatedLog = {
   __typename?: 'FeeCreatedLog'
   actionDoneBy?: Maybe<BaseUser>
   createdAppliedFeeHeads: Array<AppliedFeeHeader>
   eventDatetime: Scalars['String']
   logId: Scalars['String']
}

export type FeeCreationMandatoryInAction = {
   __typename?: 'FeeCreationMandatoryInAction'
   stageTransitionId: Scalars['String']
}

export type FeeEngineTab = BaseTab & {
   __typename?: 'FeeEngineTab'
   enableTabStatusIcon: Scalars['Boolean']
   feeRuleSet: FeeRuleSet
   feeRuleSetId: Scalars['String']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type FeeHeader = {
   __typename?: 'FeeHeader'
   execType: FeeHeaderExecType
   feeHeaderGos: Array<FeeHeaderGo>
   feeHeaderId: Scalars['String']
   name: Scalars['String']
   order: Scalars['Int']
}

export type FeeHeaderChange = {
   __typename?: 'FeeHeaderChange'
   feeHeaderId: Scalars['String']
   name: Scalars['String']
   newAmount: Scalars['Float']
   previousAmount: Scalars['Float']
}

export enum FeeHeaderExecType {
   Default = 'DEFAULT',
   Dependent = 'DEPENDENT',
   PenaltyBased = 'PENALTY_BASED',
   TotalBased = 'TOTAL_BASED'
}

export type FeeHeaderGo = {
   __typename?: 'FeeHeaderGO'
   description?: Maybe<Scalars['String']>
   feeHeaderId: Scalars['String']
   goId: Scalars['String']
   link: Scalars['String']
   name: Scalars['String']
}

export type FeeHeadersAreAlreadyDeletedInEntityFeeRuleSet = {
   __typename?: 'FeeHeadersAreAlreadyDeletedInEntityFeeRuleSet'
   feeHeaderIds: Array<Scalars['String']>
}

export type FeeHeadersAreNotDeletedInEntityFeeRuleSet = {
   __typename?: 'FeeHeadersAreNotDeletedInEntityFeeRuleSet'
   appliedFeeHeaderIds: Array<Scalars['String']>
}

export type FeeHeadersNotFound = {
   __typename?: 'FeeHeadersNotFound'
   feeHeaderIds: Array<Scalars['String']>
}

export type FeeOrdersCreatedLog = {
   __typename?: 'FeeOrdersCreatedLog'
   actionDoneBy?: Maybe<BaseUser>
   entityFeeRuleSetId: Scalars['String']
   eventDatetime: Scalars['String']
   logId: Scalars['String']
}

export type FeePaymentOrderCreationConfig = {
   __typename?: 'FeePaymentOrderCreationConfig'
   name: Scalars['String']
   orderCreationConfigId: Scalars['String']
}

export type FeePaymentOrderCreationConfigsNotFound = {
   __typename?: 'FeePaymentOrderCreationConfigsNotFound'
   feePaymentOrderCreationConfigIds: Array<Scalars['String']>
}

export type FeePaymentsTab = BaseTab & {
   __typename?: 'FeePaymentsTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type FeeResetLog = {
   __typename?: 'FeeResetLog'
   actionDoneBy?: Maybe<BaseUser>
   cascadeCreatedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeRemovedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeUpdatedAppliedFeeHeads: Array<UpdateAppliedFeeHeadLog>
   eventDatetime: Scalars['String']
   logId: Scalars['String']
}

export type FeeRevisedLog = {
   __typename?: 'FeeRevisedLog'
   actionDoneBy?: Maybe<BaseUser>
   createdAppliedFeeHeads: Array<AppliedFeeHeader>
   eventDatetime: Scalars['String']
   logId: Scalars['String']
}

export type FeeRuleSet = {
   __typename?: 'FeeRuleSet'
   entityId: Scalars['String']
   entityType: FeeRuleSetEntity
   feeRuleSetId: Scalars['String']
   mandatoryInputFieldIds: Array<Scalars['String']>
   name: Scalars['String']
}

export enum FeeRuleSetEntity {
   PipelineTemplate = 'PIPELINE_TEMPLATE'
}

export type FeeRuleSetGroup = {
   __typename?: 'FeeRuleSetGroup'
   feeRuleSetGroupId: Scalars['String']
   name: Scalars['String']
   order: Scalars['Int']
}

export type FeeRuleSetLog =
   | AddFeeHeadLog
   | FeeCreatedLog
   | FeeOrdersCreatedLog
   | FeeResetLog
   | FeeRevisedLog
   | RemoveFeeHeadLog
   | RestoreFeeHeadLog
   | UpdateFeeHeadLog

export type FeeRuleSetNotFound = {
   __typename?: 'FeeRuleSetNotFound'
   feeRuleSetId: Scalars['String']
}

export type FeeUpdatedDummyMutationParams = {
   response: Scalars['String']
}

export type FeeUpdatedDummyMutationResult = {
   __typename?: 'FeeUpdatedDummyMutationResult'
   applicationId: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type FeedbackRegexValidationFailed = GraphQlBaseError & {
   __typename?: 'FeedbackRegexValidationFailed'
   message?: Maybe<Scalars['String']>
}

export type Field =
   | CheckboxGroupField
   | DateField
   | DateTimeField
   | DropdownField
   | EmailField
   | FieldsSelectorField
   | FileUploaderField
   | FloatField
   | GeoLocationField
   | GeoShapeField
   | IntegerField
   | LongTextField
   | MultiSelectField
   | PhoneNumberField
   | PlainTextField
   | RadioGroupField
   | RelationField
   | ShortTextField
   | TimeField
   | UrlField

export type FieldAndGoFAreNotInSameTemplate = GraphQlBaseError & {
   __typename?: 'FieldAndGoFAreNotInSameTemplate'
   fieldId: Scalars['String']
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FieldClearingNotAllowed = GraphQlBaseError & {
   __typename?: 'FieldClearingNotAllowed'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldConfiguredInFormulaFields = GraphQlBaseError & {
   __typename?: 'FieldConfiguredInFormulaFields'
   formulaFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export enum FieldExecutionRoleFilter {
   All = 'ALL',
   ExcludeFieldExecution = 'EXCLUDE_FIELD_EXECUTION',
   FieldExecutionOnly = 'FIELD_EXECUTION_ONLY'
}

export type FieldExistsInChildConditionFields = GraphQlBaseError & {
   __typename?: 'FieldExistsInChildConditionFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldIdNotInGraphPipeline = GraphQlBaseError & {
   __typename?: 'FieldIdNotInGraphPipeline'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FieldIdNotInPipeline = GraphQlBaseError & {
   __typename?: 'FieldIdNotInPipeline'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type FieldIdResponse = {
   __typename?: 'FieldIdResponse'
   fieldId: Scalars['String']
   response?: Maybe<FieldResponseType>
}

export type FieldIdsNotInGraphPipeline = GraphQlBaseError & {
   __typename?: 'FieldIdsNotInGraphPipeline'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldIdsNotInPipeline = GraphQlBaseError & {
   __typename?: 'FieldIdsNotInPipeline'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type FieldIsDeleted = GraphQlBaseError & {
   __typename?: 'FieldIsDeleted'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   systemFieldEnum?: Maybe<SystemFieldEnum>
}

export type FieldIsNotConditionOptionsValueType = GraphQlBaseError & {
   __typename?: 'FieldIsNotConditionOptionsValueType'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FieldIsNotCreated = GraphQlBaseError & {
   __typename?: 'FieldIsNotCreated'
   entityId: Scalars['String']
   entityType: SalesEntityType
   fieldId: Scalars['String']
   linkedSourceFieldResponse?: Maybe<FieldResponse>
   message?: Maybe<Scalars['String']>
   systemFieldEnum?: Maybe<SystemFieldEnum>
}

export type FieldLabelsConfigNotEnabled = GraphQlBaseError & {
   __typename?: 'FieldLabelsConfigNotEnabled'
   message?: Maybe<Scalars['String']>
}

export type FieldLogNotFound = GraphQlBaseError & {
   __typename?: 'FieldLogNotFound'
   logId: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type FieldMappingDirectValue =
   | AwRelativeValueConfig
   | GqlStringType
   | Stage

export type FieldNameAlreadyExistsInGof = GraphQlBaseError & {
   __typename?: 'FieldNameAlreadyExistsInGof'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type FieldNotFound = GraphQlBaseError & {
   __typename?: 'FieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FieldObservation = {
   __typename?: 'FieldObservation'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   observation?: Maybe<SiteInspectionObservationEnum>
}

export type FieldObservationParams = {
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   observation: SiteInspectionObservationEnum
}

export type FieldOptionsAreRequired = GraphQlBaseError & {
   __typename?: 'FieldOptionsAreRequired'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FieldOptionsForApplicationInPortalResult = {
   __typename?: 'FieldOptionsForApplicationInPortalResult'
   matchedOptions: Array<Scalars['String']>
   options: Array<OptionWithColor>
   otherOptionsStartingIndex?: Maybe<Scalars['Int']>
   totalCount: Scalars['Int']
}

export type FieldOptionsForCrmEntityResult = {
   __typename?: 'FieldOptionsForCrmEntityResult'
   matchedOptions: Array<Scalars['String']>
   options: Array<OptionWithColor>
   otherOptionsStartingIndex?: Maybe<Scalars['Int']>
   totalCount: Scalars['Int']
}

export type FieldOptionsForRecordCreationResult = {
   __typename?: 'FieldOptionsForRecordCreationResult'
   matchedOptions: Array<Scalars['String']>
   options: Array<OptionWithColor>
   otherOptionsStartingIndex?: Maybe<Scalars['Int']>
   totalCount: Scalars['Int']
}

export type FieldOptionsForRelatedEntityResult = {
   __typename?: 'FieldOptionsForRelatedEntityResult'
   matchedOptions: Array<Scalars['String']>
   options: Array<OptionWithColor>
   otherOptionsStartingIndex?: Maybe<Scalars['Int']>
   totalCount: Scalars['Int']
}

export type FieldOptionsForSearchAndMonitoringResult = {
   __typename?: 'FieldOptionsForSearchAndMonitoringResult'
   matchedOptions: Array<Scalars['String']>
   options: Array<OptionWithColor>
   otherOptionsStartingIndex?: Maybe<Scalars['Int']>
   totalCount: Scalars['Int']
}

export type FieldOptionsNotFound = GraphQlBaseError & {
   __typename?: 'FieldOptionsNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type FieldPermissionType = {
   __typename?: 'FieldPermissionType'
   canRead: Scalars['Boolean']
   canWrite: Scalars['Boolean']
   fieldId: Scalars['String']
}

export type FieldPrimaryDetails = {
   __typename?: 'FieldPrimaryDetails'
   fieldId: Scalars['String']
   fieldType: FieldType
   gofId: Scalars['String']
   name: Scalars['String']
   referenceId?: Maybe<Scalars['String']>
}

export type FieldReferenceIdIsReserved = GraphQlBaseError & {
   __typename?: 'FieldReferenceIdIsReserved'
   message?: Maybe<Scalars['String']>
   referenceId: Scalars['String']
   reservedFieldReferenceIds: Array<Scalars['String']>
}

export type FieldReferenceIdMaxLengthExceeded = GraphQlBaseError & {
   __typename?: 'FieldReferenceIdMaxLengthExceeded'
   message?: Maybe<Scalars['String']>
}

export type FieldReferenceIdsExistsInMultipleTemplates = GraphQlBaseError & {
   __typename?: 'FieldReferenceIdsExistsInMultipleTemplates'
   fieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldReferenceIsNotSupportedForGivenEventTriggerOperators = GraphQlBaseError & {
   __typename?: 'FieldReferenceIsNotSupportedForGivenEventTriggerOperators'
   message?: Maybe<Scalars['String']>
   operators: Array<EventTriggerOperator>
}

export type FieldReferenceIsNotSupportedForGivenOperators = GraphQlBaseError & {
   __typename?: 'FieldReferenceIsNotSupportedForGivenOperators'
   message?: Maybe<Scalars['String']>
   operators: Array<AutomationWorkflowOperator>
}

export type FieldReferenceResponseParams = {
   fieldReferenceId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type FieldReferencesAreDeleted = GraphQlBaseError & {
   __typename?: 'FieldReferencesAreDeleted'
   fieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldReferencesNotFound = GraphQlBaseError & {
   __typename?: 'FieldReferencesNotFound'
   fieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldResponse = BaseFieldResponse & {
   __typename?: 'FieldResponse'
   entityId: Scalars['String']
   entityType: SalesEntityType
   field: FieldPrimaryDetails
   fieldId: Scalars['String']
   fieldResponseId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   response?: Maybe<FieldResponseType>
   systemFieldEnum?: Maybe<SystemFieldEnum>
}

export type FieldResponseDraft = BaseFieldResponse & {
   __typename?: 'FieldResponseDraft'
   field: FieldPrimaryDetails
   fieldId: Scalars['String']
   response?: Maybe<FieldResponseType>
   systemFieldEnum?: Maybe<SystemFieldEnum>
}

export type FieldResponseDraftResult = {
   __typename?: 'FieldResponseDraftResult'
   fieldResponses: Array<FieldResponseDraft>
}

export type FieldResponseIsRequired = GraphQlBaseError & {
   __typename?: 'FieldResponseIsRequired'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FieldResponseMustBeFilled = GraphQlBaseError & {
   __typename?: 'FieldResponseMustBeFilled'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FieldResponseParams = {
   fieldId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type FieldResponseRecommendation = {
   __typename?: 'FieldResponseRecommendation'
   recommendation: BpsVerificationRecommendationEnum
   response: Scalars['String']
}

export type FieldResponseRegexValidationFailed = GraphQlBaseError & {
   __typename?: 'FieldResponseRegexValidationFailed'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   regexErrorMessage: Scalars['String']
   response: Scalars['String']
}

export type FieldResponseResult =
   | ActivityIsNotCreatedForField
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldNotFound
   | FieldResponse
   | NotPermittedField
   | NotPipelineItemSalesEntityField
   | TaskFieldNotSupported

export type FieldResponseType =
   | BasePipeline
   | BaseUser
   | FileUploaderFieldResponse
   | GqlDateTimeType
   | GqlDateType
   | GqlFloatType
   | GqlIntType
   | GqlListStringType
   | GqlStringType
   | GqlTimeType
   | GeoLocationFieldResponse
   | GeoShapeFieldResponse
   | PhoneNumberResponse
   | PipelineItemOverviewDetails
   | RelationFieldResponse
   | ShortTextFieldResponse
   | Stage
   | StageIsDeleted
   | StageNotFound

export type FieldResult =
   | CheckboxGroupField
   | DateField
   | DateTimeField
   | DropdownField
   | EmailField
   | FieldIsDeleted
   | FieldNotFound
   | FieldsSelectorField
   | FileUploaderField
   | FloatField
   | GeoLocationField
   | GeoShapeField
   | IntegerField
   | LongTextField
   | MultiSelectField
   | NotPermittedField
   | PhoneNumberField
   | PlainTextField
   | RadioGroupField
   | RelationField
   | ShortTextField
   | TimeField
   | UrlField

export type FieldRoles = {
   __typename?: 'FieldRoles'
   fieldId: Scalars['String']
   readRoles: Array<Role>
   writeRoles: Array<Role>
}

export type FieldRolesResult =
   | FieldIsDeleted
   | FieldNotFound
   | FieldRoles
   | NotPermittedField

export enum FieldSelectorFieldUiStyleEnum {
   Dropdown = 'DROPDOWN',
   RadioGroup = 'RADIO_GROUP'
}

export type FieldSourceIsNotSupportedForOperator = GraphQlBaseError & {
   __typename?: 'FieldSourceIsNotSupportedForOperator'
   fieldSource: FilterFieldSourceType
   message?: Maybe<Scalars['String']>
}

export enum FieldSourceType {
   DirectValue = 'DIRECT_VALUE',
   Formula = 'FORMULA',
   Function = 'FUNCTION',
   LeadDetails = 'LEAD_DETAILS',
   RelativeValue = 'RELATIVE_VALUE',
   TriggerEntityDetails = 'TRIGGER_ENTITY_DETAILS',
   UserPropertiesDetails = 'USER_PROPERTIES_DETAILS'
}

export enum FieldTag {
   FeeCalculation = 'FEE_CALCULATION',
   Letters = 'LETTERS',
   RulesEngine = 'RULES_ENGINE',
   ScrutinyReport = 'SCRUTINY_REPORT'
}

export enum FieldType {
   CheckboxGroup = 'CHECKBOX_GROUP',
   Date = 'DATE',
   DateTime = 'DATE_TIME',
   Dropdown = 'DROPDOWN',
   Email = 'EMAIL',
   FieldsSelector = 'FIELDS_SELECTOR',
   FileUploader = 'FILE_UPLOADER',
   Float = 'FLOAT',
   GeoLocation = 'GEO_LOCATION',
   GeoShape = 'GEO_SHAPE',
   Integer = 'INTEGER',
   LongText = 'LONG_TEXT',
   MultiSelect = 'MULTI_SELECT',
   PhoneNumber = 'PHONE_NUMBER',
   PlainText = 'PLAIN_TEXT',
   RadioGroup = 'RADIO_GROUP',
   Relation = 'RELATION',
   ShortText = 'SHORT_TEXT',
   Time = 'TIME',
   Url = 'URL'
}

export type FieldTypeOperators = {
   __typename?: 'FieldTypeOperators'
   fieldType: FieldType
   operators: Array<FilterOperator>
}

export type FieldValidationRulesFailed = GraphQlBaseError & {
   __typename?: 'FieldValidationRulesFailed'
   errors: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldValidationRulesFailedErrData = {
   __typename?: 'FieldValidationRulesFailedErrData'
   error: Scalars['String']
   fieldId: Scalars['String']
}

export enum FieldValueErrorEnum {
   DecimalPrecisionLimitExceed = 'DECIMAL_PRECISION_LIMIT_EXCEED',
   FieldResponseRegexValidationFailed = 'FIELD_RESPONSE_REGEX_VALIDATION_FAILED',
   FileFormatIsNotAllowed = 'FILE_FORMAT_IS_NOT_ALLOWED',
   FloatFieldResponseOutOfRange = 'FLOAT_FIELD_RESPONSE_OUT_OF_RANGE',
   IntegerFieldResponseOutOfRange = 'INTEGER_FIELD_RESPONSE_OUT_OF_RANGE',
   InvalidCheckboxFieldResponse = 'INVALID_CHECKBOX_FIELD_RESPONSE',
   InvalidDateFieldResponseFormat = 'INVALID_DATE_FIELD_RESPONSE_FORMAT',
   InvalidDateTimeFieldResponseFormat = 'INVALID_DATE_TIME_FIELD_RESPONSE_FORMAT',
   InvalidDropdownFieldResponse = 'INVALID_DROPDOWN_FIELD_RESPONSE',
   InvalidDropdownFieldResponseForConditionalOptions = 'INVALID_DROPDOWN_FIELD_RESPONSE_FOR_CONDITIONAL_OPTIONS',
   InvalidEmailFieldResponse = 'INVALID_EMAIL_FIELD_RESPONSE',
   InvalidFieldsSelectorFieldResponse = 'INVALID_FIELDS_SELECTOR_FIELD_RESPONSE',
   InvalidFileUploaderFieldResponse = 'INVALID_FILE_UPLOADER_FIELD_RESPONSE',
   InvalidFloatFieldResponse = 'INVALID_FLOAT_FIELD_RESPONSE',
   InvalidIntegerFieldResponse = 'INVALID_INTEGER_FIELD_RESPONSE',
   InvalidMultiSelectFieldResponse = 'INVALID_MULTI_SELECT_FIELD_RESPONSE',
   InvalidMultiSelectFieldResponseForConditionalOptions = 'INVALID_MULTI_SELECT_FIELD_RESPONSE_FOR_CONDITIONAL_OPTIONS',
   InvalidPhoneNumberFieldResponse = 'INVALID_PHONE_NUMBER_FIELD_RESPONSE',
   InvalidRadioGroupFieldResponse = 'INVALID_RADIO_GROUP_FIELD_RESPONSE',
   InvalidShortTextFieldResponseForPrefixConditionalOptions = 'INVALID_SHORT_TEXT_FIELD_RESPONSE_FOR_PREFIX_CONDITIONAL_OPTIONS',
   InvalidTimeFieldResponseFormat = 'INVALID_TIME_FIELD_RESPONSE_FORMAT',
   InvalidUrlFieldResponse = 'INVALID_URL_FIELD_RESPONSE',
   UniqueFieldResponseAlreadyExists = 'UNIQUE_FIELD_RESPONSE_ALREADY_EXISTS'
}

export type FieldValueMapping = {
   __typename?: 'FieldValueMapping'
   directValue?: Maybe<FieldMappingDirectValue>
   enableDeepCopy?: Maybe<Scalars['Boolean']>
   fieldId: Scalars['String']
   upRefAssigneeFieldId?: Maybe<Scalars['String']>
   value?: Maybe<Scalars['String']>
   valueFrom: FieldSourceType
}

export type FieldValueMappingParams = {
   enableDeepCopy?: InputMaybe<Scalars['Boolean']>
   fieldId: Scalars['String']
   upRefAssigneeFieldId?: InputMaybe<Scalars['String']>
   value?: InputMaybe<Scalars['String']>
   valueFrom: FieldSourceType
}

export type FieldsAreDeleted = GraphQlBaseError & {
   __typename?: 'FieldsAreDeleted'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsAreNotDeleted = GraphQlBaseError & {
   __typename?: 'FieldsAreNotDeleted'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsAreNotInRecordCreationConfig = GraphQlBaseError & {
   __typename?: 'FieldsAreNotInRecordCreationConfig'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   recordCreationConfigId: Scalars['Int']
}

export type FieldsAreNotInSameGoF = GraphQlBaseError & {
   __typename?: 'FieldsAreNotInSameGoF'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsAreNotSupportedInAutomationWorkflow = GraphQlBaseError & {
   __typename?: 'FieldsAreNotSupportedInAutomationWorkflow'
   errorCode: UnsupportedAutomationWorkflowFieldErrorCode
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsAreNotSupportedInDocumentTemplateMapping = GraphQlBaseError & {
   __typename?: 'FieldsAreNotSupportedInDocumentTemplateMapping'
   errCode: DocumentTemplateMappingFieldErrorCode
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsAreNotSupportedInEventTrigger = GraphQlBaseError & {
   __typename?: 'FieldsAreNotSupportedInEventTrigger'
   errorCode: UnsupportedEventTriggerFieldErrorCode
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsAreNotSupportedInPipelineItemUpdatedTrigger = GraphQlBaseError & {
   __typename?: 'FieldsAreNotSupportedInPipelineItemUpdatedTrigger'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export enum FieldsContextType {
   DimensionFields = 'DIMENSION_FIELDS',
   FilterFields = 'FILTER_FIELDS',
   MetricFields = 'METRIC_FIELDS'
}

export type FieldsInConditionOptionsConfig = GraphQlBaseError & {
   __typename?: 'FieldsInConditionOptionsConfig'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsInputArgs = {
   fieldIds: Array<Scalars['String']>
}

export type FieldsMustBeOfSameGoFWhenFieldInAddAnotherGoF = GraphQlBaseError & {
   __typename?: 'FieldsMustBeOfSameGoFWhenFieldInAddAnotherGoF'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsNotAllowedInPortalApplication = GraphQlBaseError & {
   __typename?: 'FieldsNotAllowedInPortalApplication'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsNotBelongsToSameGoF = GraphQlBaseError & {
   __typename?: 'FieldsNotBelongsToSameGoF'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsNotFound = GraphQlBaseError & {
   __typename?: 'FieldsNotFound'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsNotInApplicationDisplayStageWritableFields = GraphQlBaseError & {
   __typename?: 'FieldsNotInApplicationDisplayStageWritableFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type FieldsNotInGoF = GraphQlBaseError & {
   __typename?: 'FieldsNotInGoF'
   fieldIds: Array<Scalars['String']>
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FieldsNotInSalesTemplate = GraphQlBaseError & {
   __typename?: 'FieldsNotInSalesTemplate'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type FieldsNotInSameGoF = GraphQlBaseError & {
   __typename?: 'FieldsNotInSameGoF'
   fieldIds: Array<Scalars['String']>
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FieldsNotInStageAllowedSections = GraphQlBaseError & {
   __typename?: 'FieldsNotInStageAllowedSections'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsNotLinkedToRelatedSalesTemplate = GraphQlBaseError & {
   __typename?: 'FieldsNotLinkedToRelatedSalesTemplate'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsResponseIsRequired = GraphQlBaseError & {
   __typename?: 'FieldsResponseIsRequired'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsSelectorField = BaseField & {
   __typename?: 'FieldsSelectorField'
   defaultValue?: Maybe<Scalars['String']>
   dependentFields: Array<DependentFields>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   fieldsSelectorFieldUiStyle: FieldSelectorFieldUiStyleEnum
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type FieldsShouldBelongsToGivenPipelineItemTemplates = GraphQlBaseError & {
   __typename?: 'FieldsShouldBelongsToGivenPipelineItemTemplates'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FieldsShouldNotBelongsToTaskTemplate = GraphQlBaseError & {
   __typename?: 'FieldsShouldNotBelongsToTaskTemplate'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FileFormatIsNotAllowed = GraphQlBaseError & {
   __typename?: 'FileFormatIsNotAllowed'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
   selectedFormat?: Maybe<Scalars['String']>
}

export type FileNumberNotFound = GraphQlBaseError & {
   __typename?: 'FileNumberNotFound'
   fileNumber: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FileSizeCannotBeNegativeOrZero = GraphQlBaseError & {
   __typename?: 'FileSizeCannotBeNegativeOrZero'
   message?: Maybe<Scalars['String']>
}

export type FileSizeLimitExceeded = GraphQlBaseError & {
   __typename?: 'FileSizeLimitExceeded'
   maxLimitInKb: Scalars['Int']
   message?: Maybe<Scalars['String']>
   urls: Array<Scalars['String']>
}

export type FileSizeMaxLimitExceeded = GraphQlBaseError & {
   __typename?: 'FileSizeMaxLimitExceeded'
   maxLimitInKb: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type FileStatusFieldMapping = {
   __typename?: 'FileStatusFieldMapping'
   fileStatusFieldId: Scalars['String']
   fileUploaderFieldId: Scalars['String']
}

export type FileStatusFieldMappingParams = {
   fileStatusFieldId: Scalars['String']
   fileUploaderFieldId: Scalars['String']
}

export type FileUploaderField = BaseField & {
   __typename?: 'FileUploaderField'
   allowPublicAccess: Scalars['Boolean']
   allowedFormats: Array<Scalars['String']>
   canDownload: Scalars['Boolean']
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   eachFileMaxSizeInKb: Scalars['Int']
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   maxNumberOfFilesToUpload: Scalars['Int']
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type FileUploaderFieldResponse = {
   __typename?: 'FileUploaderFieldResponse'
   urlResponses: Array<FileUploaderUrlResponse>
}

export type FileUploaderFileIdNotFound = GraphQlBaseError & {
   __typename?: 'FileUploaderFileIdNotFound'
   fileId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum FileUploaderSupportedDataExportActionType {
   ExportPipelineItemsByIdentificationValue = 'EXPORT_PIPELINE_ITEMS_BY_IDENTIFICATION_VALUE'
}

export type FileUploaderUrlParams = {
   mimeType: Scalars['String']
   name?: InputMaybe<Scalars['String']>
   sizeInBytes: Scalars['Float']
   url: Scalars['String']
}

export type FileUploaderUrlResponse = {
   __typename?: 'FileUploaderUrlResponse'
   fileId: Scalars['String']
   mimeType: Scalars['String']
   name?: Maybe<Scalars['String']>
   sizeInBytes: Scalars['Float']
   url: Scalars['String']
}

export type FileUploaderUrlsDomainIsNotAllowed = GraphQlBaseError & {
   __typename?: 'FileUploaderUrlsDomainIsNotAllowed'
   fileIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   urls?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type FilesVerificationTab = BaseTab & {
   __typename?: 'FilesVerificationTab'
   enableTabStatusIcon: Scalars['Boolean']
   fileStatusFieldsMappings: Array<FileStatusFieldMapping>
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type FilesVerificationTabConfigIsRequired = GraphQlBaseError & {
   __typename?: 'FilesVerificationTabConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type FilesVerificationTabConfigParams = {
   fileStatusFieldsMappings: Array<FileStatusFieldMappingParams>
}

export type FilledNotRequiredConfig = GraphQlBaseError & {
   __typename?: 'FilledNotRequiredConfig'
   message?: Maybe<Scalars['String']>
}

export type Filter = {
   __typename?: 'Filter'
   conditions: Array<Condition>
   conditionsLogicalOperator: LogicalOperator
   filterId: Scalars['String']
   name: Scalars['String']
}

export enum FilterConditionStatus {
   Disabled = 'DISABLED',
   Enabled = 'ENABLED'
}

export enum FilterConditionValueSourceType {
   DirectValue = 'DIRECT_VALUE',
   LeadDetails = 'LEAD_DETAILS',
   TriggerEntityDetails = 'TRIGGER_ENTITY_DETAILS',
   UserPropertiesDetails = 'USER_PROPERTIES_DETAILS'
}

export type FilterEntitiesCount = {
   __typename?: 'FilterEntitiesCount'
   filterId: Scalars['String']
   totalEntities: Scalars['Int']
}

export type FilterEntitiesCountResult = FilterEntitiesCount | FilterNotFound

export enum FilterFieldSourceType {
   LeadDetails = 'LEAD_DETAILS',
   TriggerEntityDetails = 'TRIGGER_ENTITY_DETAILS',
   UserPropertiesDetails = 'USER_PROPERTIES_DETAILS'
}

export type FilterFieldsResponse = FilterFieldsResult

export type FilterFieldsResult = {
   __typename?: 'FilterFieldsResult'
   activitiesFilterFields: Array<ActivityTemplateFilterFields>
   contactFilterFields: ContactTemplateFilterFields
   fieldTypeOperators: Array<FieldTypeOperators>
   leadFilterFields: LeadTemplateFilterFields
}

export type FilterNotFound = GraphQlBaseError & {
   __typename?: 'FilterNotFound'
   filterId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum FilterOperator {
   Contains = 'CONTAINS',
   Empty = 'EMPTY',
   Eq = 'EQ',
   Gt = 'GT',
   Gte = 'GTE',
   In = 'IN',
   InTheLast = 'IN_THE_LAST',
   InTheNext = 'IN_THE_NEXT',
   Is = 'IS',
   IsAfter = 'IS_AFTER',
   IsBefore = 'IS_BEFORE',
   IsIn = 'IS_IN',
   IsNot = 'IS_NOT',
   Lt = 'LT',
   Lte = 'LTE',
   Ne = 'NE',
   NotEmpty = 'NOT_EMPTY',
   NotIn = 'NOT_IN',
   NotInRange = 'NOT_IN_RANGE',
   Range = 'RANGE'
}

export type FilterSetAccessDenied = GraphQlBaseError & {
   __typename?: 'FilterSetAccessDenied'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FilterSetEntitiesCount = {
   __typename?: 'FilterSetEntitiesCount'
   filterSetId: Scalars['String']
   totalEntities: Scalars['Int']
}

export enum FilterSetEntityType {
   AgentAllocationGroup = 'AGENT_ALLOCATION_GROUP',
   AutomationWorkflowScheduledTrigger = 'AUTOMATION_WORKFLOW_SCHEDULED_TRIGGER',
   Board = 'BOARD',
   BoardList = 'BOARD_LIST',
   Dashboard = 'DASHBOARD',
   Graph = 'GRAPH',
   LeadBucket = 'LEAD_BUCKET',
   LeadPool = 'LEAD_POOL',
   ScoringRecalculationConfig = 'SCORING_RECALCULATION_CONFIG',
   View = 'VIEW'
}

export type FilterSetNotFound = GraphQlBaseError & {
   __typename?: 'FilterSetNotFound'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FilterSetNotLinkedToBoard = GraphQlBaseError & {
   __typename?: 'FilterSetNotLinkedToBoard'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FilterSetNotLinkedToBoardList = GraphQlBaseError & {
   __typename?: 'FilterSetNotLinkedToBoardList'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FilterSetNotLinkedToGivenEntity = GraphQlBaseError & {
   __typename?: 'FilterSetNotLinkedToGivenEntity'
   filterSetEntity: FilterSetEntityType
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FilterSetNotLinkedToGraph = GraphQlBaseError & {
   __typename?: 'FilterSetNotLinkedToGraph'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FilterSetNotLinkedToView = GraphQlBaseError & {
   __typename?: 'FilterSetNotLinkedToView'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FiltersAreNotInSameFilterSet = GraphQlBaseError & {
   __typename?: 'FiltersAreNotInSameFilterSet'
   message?: Maybe<Scalars['String']>
}

export type FiltersNotSupportedForExternalDashboard = GraphQlBaseError & {
   __typename?: 'FiltersNotSupportedForExternalDashboard'
   message?: Maybe<Scalars['String']>
}

export type FiltersResult = {
   __typename?: 'FiltersResult'
   filters: Array<Filter>
   filtersLogicalOperator: LogicalOperator
}

export type FirebaseApiCallFailed = GraphQlBaseError & {
   __typename?: 'FirebaseAPICallFailed'
   message?: Maybe<Scalars['String']>
   reason?: Maybe<Scalars['String']>
}

export type FirebaseAppUsersLimitExceeded = GraphQlBaseError & {
   __typename?: 'FirebaseAppUsersLimitExceeded'
   message?: Maybe<Scalars['String']>
}

export type FirstRelationPipelineItemTemplateShouldNotInSecondDegreeRelation = GraphQlBaseError & {
   __typename?: 'FirstRelationPipelineItemTemplateShouldNotInSecondDegreeRelation'
   crmTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FloatField = BaseField & {
   __typename?: 'FloatField'
   decimalPrecisionLimit?: Maybe<Scalars['Int']>
   defaultValue?: Maybe<Scalars['Float']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   formulaExpression?: Maybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isFormulaEnabled: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   rangeConfig?: Maybe<FloatRangeConfig>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type FloatFieldResponseOutOfRange = GraphQlBaseError & {
   __typename?: 'FloatFieldResponseOutOfRange'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['Float']
}

export type FloatRange = {
   __typename?: 'FloatRange'
   fromValue?: Maybe<Scalars['Float']>
   toValue?: Maybe<Scalars['Float']>
}

export type FloatRangeConfig = {
   __typename?: 'FloatRangeConfig'
   maxValue?: Maybe<Scalars['Float']>
   minValue?: Maybe<Scalars['Float']>
}

export type FloatRangeParams = {
   maxValue?: InputMaybe<Scalars['Float']>
   minValue?: InputMaybe<Scalars['Float']>
}

export type Form = {
   __typename?: 'Form'
   activityTemplate?: Maybe<BaseActivityTemplate>
   formId: Scalars['String']
   formLayout?: Maybe<FormLayout>
   formTemplate: FormTemplate
   identificationFieldId?: Maybe<Scalars['String']>
   latestPublishedAt?: Maybe<Scalars['String']>
   parentId: Scalars['String']
   parentType: FormParentType
   submissionConfig?: Maybe<FormSubmissionConfig>
}

export type FormFieldsNotFound = GraphQlBaseError & {
   __typename?: 'FormFieldsNotFound'
   formFields: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FormLayout = {
   __typename?: 'FormLayout'
   backgroundColourHexCode?: Maybe<Scalars['String']>
   bannerImageUrl?: Maybe<Scalars['String']>
   headerBackgroundColourHexCode?: Maybe<Scalars['String']>
   layoutCode?: Maybe<Scalars['String']>
   layoutId: Scalars['String']
   layoutType: FormLayoutType
   logoImageUrl: Scalars['String']
}

export type FormLayoutAlreadyExists = GraphQlBaseError & {
   __typename?: 'FormLayoutAlreadyExists'
   formId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FormLayoutIsRequired = GraphQlBaseError & {
   __typename?: 'FormLayoutIsRequired'
   formId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FormLayoutNotFound = GraphQlBaseError & {
   __typename?: 'FormLayoutNotFound'
   layoutId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum FormLayoutType {
   Default = 'DEFAULT'
}

export type FormNotFound = GraphQlBaseError & {
   __typename?: 'FormNotFound'
   formId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum FormParentType {
   Account = 'ACCOUNT',
   Pipeline = 'PIPELINE'
}

export type FormResult = Form | FormNotFound | UserIsNotAnAdministrator

export type FormSubmissionConfig = {
   __typename?: 'FormSubmissionConfig'
   messageTemplate?: Maybe<Scalars['String']>
   queryParamsFieldIds: Array<Scalars['String']>
   redirectionUrl?: Maybe<Scalars['String']>
   responseType: FormSubmissionResponseType
   submissionConfigId: Scalars['String']
}

export type FormSubmissionConfigAlreadyExists = GraphQlBaseError & {
   __typename?: 'FormSubmissionConfigAlreadyExists'
   formId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FormSubmissionConfigIsRequired = GraphQlBaseError & {
   __typename?: 'FormSubmissionConfigIsRequired'
   formId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FormSubmissionConfigNotFound = GraphQlBaseError & {
   __typename?: 'FormSubmissionConfigNotFound'
   message?: Maybe<Scalars['String']>
   submissionConfigId: Scalars['String']
}

export enum FormSubmissionResponseType {
   RedirectionUrl = 'REDIRECTION_URL',
   SuccessMessage = 'SUCCESS_MESSAGE'
}

export type FormTemplate = {
   __typename?: 'FormTemplate'
   description?: Maybe<Scalars['String']>
   formTemplateId: Scalars['String']
   gofs: Array<GoF>
   name: Scalars['String']
   orderedGofIds: Array<Scalars['String']>
}

export type FormTemplateNameIsRequired = GraphQlBaseError & {
   __typename?: 'FormTemplateNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type FormTemplateNotFound = GraphQlBaseError & {
   __typename?: 'FormTemplateNotFound'
   formTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FormattedFieldResponse = {
   __typename?: 'FormattedFieldResponse'
   fieldId: Scalars['String']
   response?: Maybe<Scalars['String']>
}

export type FormulaEvaluationLogicFailed = GraphQlBaseError & {
   __typename?: 'FormulaEvaluationLogicFailed'
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
}

export type FormulaEvaluationLogicFailedInField = GraphQlBaseError & {
   __typename?: 'FormulaEvaluationLogicFailedInField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
}

export type FormulaExpressionIsRequired = GraphQlBaseError & {
   __typename?: 'FormulaExpressionIsRequired'
   message?: Maybe<Scalars['String']>
}

export type FormulaFieldsAreNotAllowed = GraphQlBaseError & {
   __typename?: 'FormulaFieldsAreNotAllowed'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FormulaFieldsAreSystemEditable = GraphQlBaseError & {
   __typename?: 'FormulaFieldsAreSystemEditable'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FormulaIsNotValid = GraphQlBaseError & {
   __typename?: 'FormulaIsNotValid'
   formula: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum FormulaNodeType {
   Brace = 'BRACE',
   Constant = 'CONSTANT',
   Metric = 'METRIC',
   Operator = 'OPERATOR'
}

export type FormulaSyntaxError = GraphQlBaseError & {
   __typename?: 'FormulaSyntaxError'
   formula: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FriendActionVisibilityResult = {
   __typename?: 'FriendActionVisibilityResult'
   assignFriendActionDetails: AssignFriendActionDetails
   sendBackActionDetails: SendBackActionDetails
}

export type FriendAlreadyAssigned = GraphQlBaseError & {
   __typename?: 'FriendAlreadyAssigned'
   friendOfficerId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type FriendConfigCustomField = {
   __typename?: 'FriendConfigCustomField'
   customFieldId: Scalars['String']
   fieldType: ApplicationPropertyType
   name: Scalars['String']
   pipelineItemTemplateFields: Array<FriendConfigPipelineItemTemplateField>
}

export type FriendConfigPipelineItemTemplateField = {
   __typename?: 'FriendConfigPipelineItemTemplateField'
   field: Field
   fieldId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
}

export type FriendConfigurationNotFound = GraphQlBaseError & {
   __typename?: 'FriendConfigurationNotFound'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type FriendFeatureDisabled = GraphQlBaseError & {
   __typename?: 'FriendFeatureDisabled'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type FriendFieldsExhausted = GraphQlBaseError & {
   __typename?: 'FriendFieldsExhausted'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type FromRelatedSalesTemplateDisplayNameIsRequired = GraphQlBaseError & {
   __typename?: 'FromRelatedSalesTemplateDisplayNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type FromSalesTemplateIdNotFound = GraphQlBaseError & {
   __typename?: 'FromSalesTemplateIdNotFound'
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type FromStageAndToStageCannotBeSame = GraphQlBaseError & {
   __typename?: 'FromStageAndToStageCannotBeSame'
   fromStageId: Scalars['String']
   message?: Maybe<Scalars['String']>
   toStageId: Scalars['String']
}

export type FromStageAndToStagesAreNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'FromStageAndToStagesAreNotInSamePipeline'
   fromStageId: Scalars['String']
   message?: Maybe<Scalars['String']>
   toStageIds: Array<Scalars['String']>
}

export type FromStageNotFound = GraphQlBaseError & {
   __typename?: 'FromStageNotFound'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type Function = {
   __typename?: 'Function'
   functionId: Scalars['String']
   name: Scalars['String']
}

export type FunctionNotFound = GraphQlBaseError & {
   __typename?: 'FunctionNotFound'
   functionId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type FunctionsNotFound = GraphQlBaseError & {
   __typename?: 'FunctionsNotFound'
   functionIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type FunctionsResult = {
   __typename?: 'FunctionsResult'
   functions: Array<Function>
}

export enum FunnelDropValueComparisonType {
   BaseMetric = 'BASE_METRIC',
   ImmediateMetric = 'IMMEDIATE_METRIC',
   None = 'NONE'
}

export type FunnelGraph = {
   __typename?: 'FunnelGraph'
   graphId: Scalars['String']
   metrics: Array<GraphMetricValue>
}

export type FunnelGraphConfig = {
   __typename?: 'FunnelGraphConfig'
   analyticsLevel: AnalyticsLevel
   dataSources: Array<AnalyticsDataSourceType>
   dataSourcesWithDisplayNames: Array<DataSourceDisplayName>
   description?: Maybe<Scalars['String']>
   dropValueComparisonType: FunnelDropValueComparisonType
   filterSetId: Scalars['String']
   graphId: Scalars['String']
   isOwner: Scalars['Boolean']
   metrics: Array<GraphMetric>
   name: Scalars['String']
   pipelineId: Scalars['String']
   quickFilterFields: Array<GraphQuickFilterField>
   roles: Array<Role>
}

export type FunnelGraphResult =
   | DashboardAccessDenied
   | DashboardNotFound
   | FunnelGraph
   | GraphAccessDenied
   | GraphNotFound
   | ViewAccessDenied
   | ViewNotFound

export type GisTab = BaseTab & {
   __typename?: 'GISTab'
   enableTabStatusIcon: Scalars['Boolean']
   geoShapeFieldId: Scalars['String']
   heightFieldId: Scalars['String']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   propertiesFieldIds: Array<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type GqlBooleanType = {
   __typename?: 'GQLBooleanType'
   value?: Maybe<Scalars['Boolean']>
}

export type GqlDateTimeType = {
   __typename?: 'GQLDateTimeType'
   value?: Maybe<Scalars['String']>
}

export type GqlDateType = {
   __typename?: 'GQLDateType'
   value?: Maybe<Scalars['String']>
}

export type GqlDisplayStageConfig = {
   __typename?: 'GQLDisplayStageConfig'
   canEditTdrRequests: Scalars['Boolean']
   stageId: Scalars['String']
}

export type GqlFloatType = {
   __typename?: 'GQLFloatType'
   value?: Maybe<Scalars['Float']>
}

export type GqlIntType = {
   __typename?: 'GQLIntType'
   value?: Maybe<Scalars['Int']>
}

export type GqlListStringType = {
   __typename?: 'GQLListStringType'
   value: Array<Scalars['String']>
}

export type GqlStringType = {
   __typename?: 'GQLStringType'
   value?: Maybe<Scalars['String']>
}

export type GqlTaskStatusObj = {
   __typename?: 'GQLTaskStatusObj'
   taskStatus: TaskStatus
}

export type GqlTimeType = {
   __typename?: 'GQLTimeType'
   value?: Maybe<Scalars['String']>
}

export type GallaBoxAccountResult =
   | GallaboxAccount
   | PluginServiceAccountNotFound

export type GallaboxAccount = BasePluginServiceAccount & {
   __typename?: 'GallaboxAccount'
   apiKey: Scalars['String']
   apiSecret: Scalars['String']
   creationDatetime: Scalars['String']
   enableReadReceipts: Scalars['Boolean']
   gallaboxAccountId: Scalars['String']
   isActive: Scalars['Boolean']
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
}

export type GallaboxAccountNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'GallaboxAccountNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type GallaboxChannelIdIsRequired = GraphQlBaseError & {
   __typename?: 'GallaboxChannelIdIsRequired'
   message?: Maybe<Scalars['String']>
}

export type GallaboxServiceAccounts = {
   __typename?: 'GallaboxServiceAccounts'
   gallaboxAccounts: Array<GallaBoxAccountResult>
}

export enum Gender {
   Female = 'FEMALE',
   Male = 'MALE',
   Other = 'OTHER'
}

export type GenerateApplicationDrawingPdfParams = {
   applicationId: Scalars['String']
   portalId?: InputMaybe<Scalars['String']>
   portalType?: InputMaybe<PortalType>
}

export type GenerateApplicationDrawingPdfResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GenerateApplicationDrawingPdfResult
   | ScrutinyNotInitiated

export type GenerateApplicationDrawingPdfResult = {
   __typename?: 'GenerateApplicationDrawingPDFResult'
   applicationId: Scalars['String']
   portalId?: Maybe<Scalars['String']>
}

export type GenerateDocumentNode = BaseNode & {
   __typename?: 'GenerateDocumentNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   copyDocumentUrlToField?: Maybe<Scalars['String']>
   documentTemplate?: Maybe<DocumentTemplateOverviewDetails>
   documentVersionState?: Maybe<DocumentVersionState>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   title?: Maybe<GenerateDocumentTitle>
   variableMappings: Array<AwCustomVariableFieldMapping>
}

export type GenerateDocumentNodeExecLog = BaseNodeExecLog & {
   __typename?: 'GenerateDocumentNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<GenerateDocumentNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type GenerateDocumentNodeExecLogResult = {
   __typename?: 'GenerateDocumentNodeExecLogResult'
   copyDocumentUrlToField?: Maybe<AwFileUploaderFieldMappingResult>
   document: GenerateDocumentResult
}

export type GenerateDocumentResult = {
   __typename?: 'GenerateDocumentResult'
   documentId: Scalars['String']
   documentUrlResponse: FileUploaderUrlResponse
}

export enum GenerateDocumentStatus {
   Failed = 'FAILED',
   Success = 'SUCCESS'
}

export type GenerateDocumentTitle = {
   __typename?: 'GenerateDocumentTitle'
   prefix?: Maybe<Scalars['String']>
   reference?: Maybe<AutomationWorkflowFieldValueMapping>
   suffix?: Maybe<Scalars['String']>
}

export type GenerateDocumentTitleParams = {
   prefix?: InputMaybe<Scalars['String']>
   reference?: InputMaybe<AutomationWorkflowFieldValueMappingParams>
   suffix?: InputMaybe<Scalars['String']>
}

export type GenerateDocusignEmbedUrlForPipelineItemDocumentParams = {
   documentId: Scalars['String']
}

export type GenerateDocusignEmbedUrlForPipelineItemDocumentResponse =
   | DocumentIsDeleted
   | DocumentNotFound
   | DocusignEmbedUrlApiFailed
   | DocusignEnvelopeApiFailed
   | DocusignPluginNotConfigured
   | GenerateDocusignEmbedUrlForPipelineItemDocumentResult
   | InvalidDocusignGrantSignatureKey
   | InvalidDocusignPrivateKey
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | YouDontHaveAnyPendingSigns

export type GenerateDocusignEmbedUrlForPipelineItemDocumentResult = {
   __typename?: 'GenerateDocusignEmbedUrlForPipelineItemDocumentResult'
   documentId: Scalars['String']
   embedUrl: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type GenerateNumberNode = BaseNode & {
   __typename?: 'GenerateNumberNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   forceRegenerate?: Maybe<Scalars['Boolean']>
   generationType?: Maybe<NumberGenerationType>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   targetFieldId?: Maybe<Scalars['String']>
}

export type GenerateNumberNodeExecLog = BaseNodeExecLog & {
   __typename?: 'GenerateNumberNodeExecLog'
   configId?: Maybe<Scalars['String']>
   counterValue?: Maybe<Scalars['Int']>
   failureReason?: Maybe<Scalars['String']>
   generatedNumber?: Maybe<Scalars['String']>
   generationType?: Maybe<Scalars['String']>
   isRegenerated?: Maybe<Scalars['Boolean']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   previousNumber?: Maybe<Scalars['String']>
   status: NodeExecLogStatusEnum
   targetFieldId?: Maybe<Scalars['String']>
}

export type GeneratePaymentReceiptInPortalParams = {
   contentDispositionType: ContentDisposition
   paymentId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GeneratePaymentReceiptInPortalResponse =
   | GeneratePaymentReceiptInPortalResult
   | PaymentNotFound
   | PaymentReceiptNotExists
   | ReceiptCannotBeGeneratedForUnpaidPayment

export type GeneratePaymentReceiptInPortalResult = {
   __typename?: 'GeneratePaymentReceiptInPortalResult'
   paymentId: Scalars['String']
   portalId: Scalars['String']
   preSignedUrl: Scalars['String']
   receipt?: Maybe<FileUploaderUrlResponse>
}

export type GeneratePaymentReceiptParams = {
   contentDispositionType: ContentDisposition
   paymentId: Scalars['String']
}

export type GeneratePaymentReceiptResponse =
   | GeneratePaymentReceiptResult
   | PaymentNotFound
   | PaymentReceiptNotExists

export type GeneratePaymentReceiptResult = {
   __typename?: 'GeneratePaymentReceiptResult'
   paymentId: Scalars['String']
   preSignedUrl: Scalars['String']
   receipt?: Maybe<FileUploaderUrlResponse>
}

export type GeneratePipelineItemDocumentParams = {
   documentTemplateId: Scalars['String']
   documentVersionState?: InputMaybe<DocumentVersionState>
   pipelineItemId: Scalars['String']
   shouldSignDocument?: InputMaybe<Scalars['Boolean']>
   taskTemplateId?: InputMaybe<Scalars['String']>
}

export type GeneratePipelineItemDocumentResponse =
   | DocumentAlreadySentError
   | DocumentTemplateIsDeleted
   | DocumentTemplateNotFound
   | GeneratePipelineItemDocumentResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TaskTemplateNotFound

export type GeneratePipelineItemDocumentResult = {
   __typename?: 'GeneratePipelineItemDocumentResult'
   document: Document
   pipelineItemId: Scalars['String']
}

export type GeneratePipelineItemDocumentWithUrlParams = {
   contentDispositionType?: InputMaybe<ContentDisposition>
   documentTemplateId: Scalars['String']
   documentVersionState?: InputMaybe<DocumentVersionState>
   pipelineItemId: Scalars['String']
   shouldSignDocument?: InputMaybe<Scalars['Boolean']>
   taskTemplateId?: InputMaybe<Scalars['String']>
}

export type GeneratePipelineItemDocumentWithUrlResponse =
   | DocumentAlreadySentError
   | DocumentIsDeleted
   | DocumentNotFound
   | DocumentTemplateIsDeleted
   | DocumentTemplateNotFound
   | GeneratePipelineItemDocumentWithUrlResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TaskTemplateNotFound

export type GeneratePipelineItemDocumentWithUrlResult = {
   __typename?: 'GeneratePipelineItemDocumentWithUrlResult'
   document: Document
   documentId: Scalars['String']
   pipelineItemId: Scalars['String']
   preSignedUrl: Scalars['String']
}

export type GenerateReconciliationPreviewParams = {
   applicationType: ReconciliationApplicationType
   csvFile: FileUploaderUrlParams
   otp?: InputMaybe<Scalars['String']>
   requestId?: InputMaybe<Scalars['String']>
}

export type GenerateReconciliationPreviewResponse =
   | InvalidOtp
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | ReconciliationRequest
   | UserIsNotAnAdministrator

export type GenerateScrutinyKeyAttachment = {
   __typename?: 'GenerateScrutinyKeyAttachment'
   attachmentId: Scalars['String']
   mimeType?: Maybe<Scalars['String']>
   name?: Maybe<Scalars['String']>
   sizeInBytes?: Maybe<Scalars['Float']>
   url: Scalars['String']
}

export type GenerateScrutinyKeyAttachmentsParams = {
   mimeType: Scalars['String']
   name: Scalars['String']
   sizeInBytes: Scalars['Int']
   url: Scalars['String']
}

export type GenerateScrutinyKeyParams = {
   applicationId: Scalars['String']
   architectDisplayStageId?: InputMaybe<Scalars['String']>
   architectPipelineId?: InputMaybe<Scalars['String']>
   attachments: Array<InputMaybe<GenerateScrutinyKeyAttachmentsParams>>
   displayStageId?: InputMaybe<Scalars['String']>
   phoneNumber?: InputMaybe<PhoneNumberParams>
   pipelineId?: InputMaybe<Scalars['String']>
   remarks: Scalars['String']
}

export type GenerateScrutinyKeyResponse =
   | ApplicationIsNotInCitizenPortal
   | ApplicationNotFound
   | CitizenAccountNotFoundForGivenPhoneNumber
   | CitizenPhoneNumberRequired
   | CitizenPipelineDetailsRequired
   | GenerateScrutinyKeyResult
   | InvalidStageForPipeline
   | MaxNumberOfFilesLimitExceeded
   | ScrutinyAlreadyGenerated
   | ScrutinyDataNotFound
   | ScrutinyKeyGenerationAccessDenied
   | ScrutinyKeyGenerationIsDisabled

export type GenerateScrutinyKeyResult = {
   __typename?: 'GenerateScrutinyKeyResult'
   scrutinyLog: GenerateScrutinyLog
}

export type GenerateScrutinyLog = {
   __typename?: 'GenerateScrutinyLog'
   applicationId: Scalars['String']
   architectDisplayStage?: Maybe<BaseStage>
   architectPipeline?: Maybe<BasePipeline>
   attachments: Array<GenerateScrutinyKeyAttachment>
   fileNumber?: Maybe<Scalars['String']>
   generatedAt: Scalars['String']
   generatedBy: BaseUser
   id: Scalars['String']
   phoneNumber?: Maybe<PhoneNumberResponse>
   pipeline?: Maybe<BasePipeline>
   remarks: Scalars['String']
   scrutinyKey: Scalars['String']
   stage?: Maybe<BaseStage>
}

export type GeoCoordinatesTab = BaseTab & {
   __typename?: 'GeoCoordinatesTab'
   enableTabStatusIcon: Scalars['Boolean']
   geoFieldId: Scalars['String']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type GeoLocationField = BaseField & {
   __typename?: 'GeoLocationField'
   addressFieldIds: Array<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type GeoLocationFieldResponse = {
   __typename?: 'GeoLocationFieldResponse'
   latitude: Scalars['Float']
   longitude: Scalars['Float']
}

export type GeoPoint = {
   __typename?: 'GeoPoint'
   latitude: Scalars['Float']
   longitude: Scalars['Float']
}

export type GeoShapeField = BaseField & {
   __typename?: 'GeoShapeField'
   addressFieldIds: Array<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
   variantType: GeoShapeVariantType
}

export type GeoShapeFieldResponse = {
   __typename?: 'GeoShapeFieldResponse'
   geoPoints: Array<GeoPoint>
}

export enum GeoShapeVariantType {
   Line = 'LINE',
   MultiPoint = 'MULTI_POINT',
   Point = 'POINT',
   Polygon = 'POLYGON'
}

export type GetAccountAutomationWorkflowExecLogsResponse =
   | GetAccountAutomationWorkflowExecLogsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineIsRequired
   | PipelineNotFound
   | PipelinesNotFound
   | UserIsNotAnAdministrator

export type GetAccountAutomationWorkflowExecLogsResult = {
   __typename?: 'GetAccountAutomationWorkflowExecLogsResult'
   automationWorkflowExecLogs: Array<AutomationWorkflowExecLog>
   totalCount: Scalars['Int']
}

export type GetAccountAutomationWorkflowsExecLogsParams = {
   entityLevel?: InputMaybe<AwLogsEntityLevel>
   execLogsTab?: InputMaybe<AutomationWorkflowExecLogsTab>
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
   /** @deprecated Multiple pipelines not supported in args */
   pipelineIds?: InputMaybe<Array<Scalars['String']>>
}

export type GetAccountLeadDistributionRuleExecLogsParams = {
   pagination: Pagination
   pipelineIds?: InputMaybe<Array<Scalars['String']>>
}

export type GetAccountLeadDistributionRuleExecLogsResponse =
   | GetAccountLeadDistributionRuleExecLogsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelinesNotFound
   | UserIsNotAnAdministrator

export type GetAccountLeadDistributionRuleExecLogsResult = {
   __typename?: 'GetAccountLeadDistributionRuleExecLogsResult'
   execLogs: Array<LeadDistributionRuleExecLog>
   totalCount: Scalars['Int']
}

export type GetAccountLeadDistributionRulesParams = {
   pagination: Pagination
   pipelineIds?: InputMaybe<Array<Scalars['String']>>
}

export type GetAccountPluginsResult = AccountPlugins | UserIsNotAnAdministrator

export type GetAccountScheduledAutomationWorkflowLogsParams = {
   entityLevel?: InputMaybe<AwLogsEntityLevel>
   executionMode?: InputMaybe<ScheduledAwExecutionMode>
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
}

export type GetAccountScheduledAutomationWorkflowLogsResponse =
   | GetAccountScheduledAutomationWorkflowLogsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetAccountScheduledAutomationWorkflowLogsResult = {
   __typename?: 'GetAccountScheduledAutomationWorkflowLogsResult'
   execLogs: Array<ScheduledAutomationWorkflowExecLog>
   totalCount: Scalars['Int']
}

export type GetActivitiesParams = {
   activityIds: Array<Scalars['String']>
}

export type GetActivityFieldsParams = {
   activityId: Scalars['String']
   fieldIds: Array<Scalars['String']>
}

export type GetActivityFieldsResponse =
   | ActivityNotFound
   | GetActivityFieldsResult

export type GetActivityFieldsResult = {
   __typename?: 'GetActivityFieldsResult'
   fields: Array<ActivityFieldResult>
   whatsappConsentGivenPhoneNumberFieldIds: Array<Scalars['String']>
}

export type GetAdminRecordCreationConfigsForSalesTemplatesParams = {
   salesTemplateIds: Array<Scalars['String']>
}

export type GetAdminWhatsAppAccountMessageTemplatesResult = {
   __typename?: 'GetAdminWhatsAppAccountMessageTemplatesResult'
   messageTemplates: Array<AdminWhatsAppMessageTemplate>
   totalCount?: Maybe<Scalars['Int']>
}

export type GetAgentAllocationGroupsInAccountParams = {
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetAgentAllocationGroupsInAccountResponse =
   | GetAgentAllocationGroupsInAccountResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type GetAgentAllocationGroupsInAccountResult = {
   __typename?: 'GetAgentAllocationGroupsInAccountResult'
   agentAllocationGroups: Array<AgentAllocationGroup>
   totalCount: Scalars['Int']
}

export type GetAgentAllocationGroupsParams = {
   agentAllocationGroupIds: Array<Scalars['String']>
}

export type GetAgentAllocationGroupsResult =
   | AgentAllocationGroup
   | AgentAllocationGroupNotFound
   | UserIsNotAnAdministrator

export type GetAgentsForManagerResponse =
   | DeactivatedManager
   | GetAgentsForManagerResult
   | InvalidLimit
   | InvalidOffset
   | ManagerNotFound
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type GetAgentsForManagerResult = {
   __typename?: 'GetAgentsForManagerResult'
   agents: Array<BaseUser>
   managerId: Scalars['String']
   totalCount: Scalars['Int']
}

export type GetAgentsforManager = {
   managerId: Scalars['String']
   pagination: Pagination
}

export type GetAnalyticsCopilotHistoryParams = {
   pagination: Pagination
   pipelineId: Scalars['String']
}

export type GetAnalyticsCopilotHistoryResponse = {
   __typename?: 'GetAnalyticsCopilotHistoryResponse'
   history: Array<AnalyticsCopilotHistory>
   totalCount?: Maybe<Scalars['Int']>
}

export type GetAnalyticsCopilotHistoryResult =
   | GetAnalyticsCopilotHistoryResponse
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineNotFound

export type GetAnalyticsCopilotResponse = {
   __typename?: 'GetAnalyticsCopilotResponse'
   copilotResponseId: Scalars['String']
   irrelevantQueryResponse?: Maybe<Scalars['String']>
   sqlData?: Maybe<CopilotSqlData>
   tableData?: Maybe<AnalyticsCoPilotTableData>
}

export type GetAnalyticsCopilotResult =
   | CopilotEmptyQueryResponse
   | GetAnalyticsCopilotResponse
   | PipelineAccessDenied
   | PipelineNotFound

export type GetAnalyticsCopilotVisualizationParams = {
   copilotResponseId: Scalars['String']
}

export type GetAnalyticsCopilotVisualizationResponse = {
   __typename?: 'GetAnalyticsCopilotVisualizationResponse'
   graphData?: Maybe<AnalyticsVisualizations>
   graphType?: Maybe<GraphType>
   textualAnswer?: Maybe<Scalars['String']>
}

export type GetAnalyticsCopilotVisualizationResult =
   | CopilotEmptyQueryResponse
   | CopilotResponseNotFound
   | GetAnalyticsCopilotVisualizationResponse

export type GetAnalyticsQueryResponseParams = {
   pipelineId: Scalars['String']
   searchQuery: Scalars['String']
}

export type GetApplicationAddAnotherFieldsInPortalParams = {
   applicationId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofResponseIds: Array<Scalars['String']>
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type GetApplicationAddAnotherFieldsInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | GetApplicationAddAnotherGoFsFieldsResult
   | GoFResponseIdsNotFound
   | NotAddAnotherFields
   | NotApplicationAddAnotherGoFResponsesBulk
   | NotPermittedFields
   | PortalNotFound

export type GetApplicationAddAnotherFieldsParams = {
   applicationId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofResponseIds: Array<Scalars['String']>
}

export type GetApplicationAddAnotherFieldsResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | GetApplicationAddAnotherGoFsFieldsResult
   | GoFResponseIdsNotFound
   | NotAddAnotherFields
   | NotApplicationAddAnotherGoFResponsesBulk
   | NotPermittedFields

export type GetApplicationAddAnotherGoFsFieldsInPortalParams = {
   applicationId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type GetApplicationAddAnotherGoFsFieldsInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | GetApplicationAddAnotherGoFsFieldsResult
   | GoFsAreDeleted
   | GoFsNotFound
   | NotAddAnotherGoFs
   | NotPermittedFields
   | PortalNotFound

export type GetApplicationAddAnotherGoFsFieldsParams = {
   applicationId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
}

export type GetApplicationAddAnotherGoFsFieldsResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | GetApplicationAddAnotherGoFsFieldsResult
   | GoFsAreDeleted
   | GoFsNotFound
   | NotAddAnotherGoFs
   | NotPermittedFields

export type GetApplicationAddAnotherGoFsFieldsResult = {
   __typename?: 'GetApplicationAddAnotherGoFsFieldsResult'
   applicationId: Scalars['String']
   gofResponses: Array<AddAnotherGoFResult>
}

export type GetApplicationCustomizationsInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
}

export type GetApplicationCustomizationsInPortalResponse =
   | ApplicationCustomizationsInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PortalAccessDenied
   | PortalIsDeleted
   | PortalNotFound

export type GetApplicationCustomizationsParams = {
   pipelineItemId: Scalars['String']
}

export type GetApplicationCustomizationsResponse =
   | GetApplicationCustomizationsResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetApplicationCustomizationsResult = {
   __typename?: 'GetApplicationCustomizationsResult'
   alerts: ApplicationCustomizationAlerts
}

export type GetApplicationDocumentsInPortalParams = {
   applicationId: Scalars['String']
   pagination: Pagination
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetApplicationDocumentsInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GetApplicationDocumentsInPortalResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PortalNotFound

export type GetApplicationDocumentsInPortalResult = {
   __typename?: 'GetApplicationDocumentsInPortalResult'
   documents: Array<Document>
   totalCount: Scalars['Int']
}

export type GetApplicationDrawingFileLogsParams = {
   applicationId: Scalars['String']
}

export type GetApplicationDrawingFileLogsResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GetApplicationDrawingFileLogsResult

export type GetApplicationDrawingFileLogsResult = {
   __typename?: 'GetApplicationDrawingFileLogsResult'
   logs: Array<ApplicationDrawingFileLog>
}

export type GetApplicationEnforcementComplaintsParams = {
   pipelineItemId: Scalars['String']
}

export type GetApplicationEnforcementComplaintsResponse =
   | GetApplicationEnforcementComplaintsResult
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetApplicationEnforcementComplaintsResult = {
   __typename?: 'GetApplicationEnforcementComplaintsResult'
   complaintApplications: Array<ApplicationProperties>
}

export type GetApplicationErrorFieldsInPortalParams = {
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   stageTransitionId: Scalars['String']
}

export type GetApplicationErrorFieldsInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ApplicationStageFieldNotConfigured
   | GetApplicationErrorFieldsInPortalResult
   | PortalNotFound
   | StageTransitionNotFound
   | StageTransitionNotInApplicationDisplayStage
   | SurveyNumberAreaSumMismatchWithPlotArea

export type GetApplicationErrorFieldsInPortalResult = {
   __typename?: 'GetApplicationErrorFieldsInPortalResult'
   redirectToPendingOrders?: Maybe<Scalars['Boolean']>
   unVerifiedPhoneNumberFields: Array<UnVerifiedGofResponsePhoneNumberFields>
   unfilledRequiredFields: Array<UnfilledGofResponseFields>
}

export type GetApplicationFieldsParams = {
   applicationId: Scalars['String']
   fieldIds: Array<Scalars['String']>
}

export type GetApplicationFieldsResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GetApplicationFieldsResult

export type GetApplicationFieldsResult = {
   __typename?: 'GetApplicationFieldsResult'
   fields: Array<ApplicationFieldResult>
}

export type GetApplicationGoFSurveyNumberRemarksInPortalParams = {
   applicationId: Scalars['String']
   gofId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetApplicationGoFSurveyNumberRemarksInPortalResponse =
   | GetApplicationGoFSurveyNumberRemarksInPortalResult
   | GivenFieldIsNotSurveyNumberField
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PortalNotFound

export type GetApplicationGoFSurveyNumberRemarksInPortalResult = {
   __typename?: 'GetApplicationGoFSurveyNumberRemarksInPortalResult'
   applicationId: Scalars['String']
   gofId: Scalars['String']
   portalId: Scalars['String']
   surveyNumberRemarks: Array<GoFSurveyNumberRemarkEntry>
}

export type GetApplicationGoFSurveyNumberRemarksParams = {
   applicationId: Scalars['String']
   gofId: Scalars['String']
}

export type GetApplicationGoFSurveyNumberRemarksResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | FieldIsDeleted
   | FieldNotFound
   | GetApplicationGoFSurveyNumberRemarksResult

export type GetApplicationGoFSurveyNumberRemarksResult = {
   __typename?: 'GetApplicationGoFSurveyNumberRemarksResult'
   applicationId: Scalars['String']
   gofId: Scalars['String']
   surveyNumberRemarks: Array<GoFSurveyNumberRemarkEntry>
}

export type GetApplicationLatestDataInPortalParams = {
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetApplicationLatestDataInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GetApplicationLatestDataInPortalResult
   | PortalNotFound

export type GetApplicationLatestDataInPortalResult = {
   __typename?: 'GetApplicationLatestDataInPortalResult'
   availableActions: Array<PortalApplicationAction>
   fields: Array<PortalFieldResponseResult>
   isApplicationDeleted: Scalars['Boolean']
   paymentsInfo?: Maybe<PaymentsInfo>
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   scrutinyReport?: Maybe<ScrutinyReportStatusDetails>
}

export type GetApplicationLatestDataInPortalResultFieldsArgs = {
   params: PortalApplicationFieldResponseParams
}

export type GetApplicationLatestPublishedDocumentsInPortalParams = {
   applicationId: Scalars['String']
   pipelineIds?: InputMaybe<Array<Scalars['String']>>
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetApplicationLatestPublishedDocumentsInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GetApplicationLatestPublishedDocumentsInPortalResult
   | PortalNotFound

export type GetApplicationLatestPublishedDocumentsInPortalResult = {
   __typename?: 'GetApplicationLatestPublishedDocumentsInPortalResult'
   documents: Array<PublishedDocument>
}

export type GetApplicationManagementLogsParams = {
   actionType?: InputMaybe<Scalars['String']>
   fromDate?: InputMaybe<Scalars['String']>
   limit: Scalars['Int']
   offset: Scalars['Int']
   pipelineItemId?: InputMaybe<Scalars['String']>
   toDate?: InputMaybe<Scalars['String']>
}

export type GetApplicationManagementLogsResponse =
   | ApplicationManagementAccessDenied
   | GetApplicationManagementLogsResult

export type GetApplicationManagementLogsResult = {
   __typename?: 'GetApplicationManagementLogsResult'
   logs: Array<ApplicationManagementLog>
   totalCount: Scalars['Int']
}

export type GetApplicationNotFilledRequiredFieldsInPortalResult = {
   __typename?: 'GetApplicationNotFilledRequiredFieldsInPortalResult'
   gofFields: Array<UnfilledGofResponseFields>
   redirectToPendingOrders?: Maybe<Scalars['Boolean']>
}

export type GetApplicationObjectionTabVisibleStatusResult = {
   __typename?: 'GetApplicationObjectionTabVisibleStatusResult'
   objectionsSummary: Array<TabObjectionsSummary>
   tabStatuses: Array<LayoutTabEnableStatus>
}

export type GetApplicationObjectionTabsVisibleStatusParams = {
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type GetApplicationObjectionTabsVisibleStatusResponse =
   | GetApplicationObjectionTabVisibleStatusResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetApplicationProfileParams = {
   applicationId: Scalars['String']
}

export type GetApplicationProfileResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ApplicationProfile

export type GetApplicationPropertiesInPortalResponse =
   | GetApplicationPropertiesInPortalResult
   | PortalNotFound

export type GetApplicationPropertiesInPortalResult = {
   __typename?: 'GetApplicationPropertiesInPortalResult'
   applicationProperties: Array<ApplicationPropertiesInPortalResponse>
}

export type GetApplicationRefundDetailsParams = {
   applicationId?: InputMaybe<Scalars['String']>
   fileNo?: InputMaybe<Scalars['String']>
}

export type GetApplicationRefundDetailsResponse =
   | ApplicationAccessDenied
   | ApplicationNotFound
   | ApplicationRefundDetails
   | RefundNotApplicable

export type GetApplicationScrutinyReportDetailsParams = {
   applicationId: Scalars['String']
   pipelineId?: InputMaybe<Scalars['String']>
   portalId?: InputMaybe<Scalars['String']>
   portalType?: InputMaybe<PortalType>
}

export type GetApplicationScrutinyReportDetailsResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GetApplicationScrutinyReportDetailsResult
   | ScrutinyNotInitiated

export type GetApplicationScrutinyReportDetailsResult = {
   __typename?: 'GetApplicationScrutinyReportDetailsResult'
   completedAt?: Maybe<Scalars['String']>
   completionPercentage: Scalars['Float']
   currentDatetime?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   drawingCompletedAt?: Maybe<Scalars['String']>
   drawingPdfUrl?: Maybe<Scalars['String']>
   isScrutinyInitiated: Scalars['Boolean']
   scrutinyMultimedia?: Maybe<ScrutinyReportMultimedia>
   scrutinyReportUrl?: Maybe<Scalars['String']>
   scrutinyStatus?: Maybe<ScrutinyStatus>
   scrutinySteps: Array<ScrutinyStep>
   scrutinySubmittedDatetime?: Maybe<Scalars['String']>
   showDrawingPdf: Scalars['Boolean']
   showDrawingPdfGeneration?: Maybe<Scalars['Boolean']>
   showScrutinyReport: Scalars['Boolean']
   startedAt?: Maybe<Scalars['String']>
   title?: Maybe<Scalars['String']>
   workloadId?: Maybe<Scalars['String']>
}

export type GetApplicationStageSummaryParams = {
   applicationId: Scalars['String']
   stageId: Scalars['String']
}

export type GetApplicationStageSummaryResponse =
   | ApplicationStageSummary
   | ApplicationStageSummaryConfigIsNotConfigured
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | StageAccessDenied
   | StageNotFound

export type GetApplicationStageTransitionCheckpointsConfigInPortalParams = {
   applicationId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   stageTransitionId: Scalars['String']
}

export type GetApplicationStageTransitionCheckpointsConfigInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | StageTransitionCheckpointsConfig
   | StageTransitionNotFound

export type GetApplicationStageTransitionCheckpointsConfigParams = {
   applicationId: Scalars['String']
   stageTransitionIds: Array<Scalars['String']>
}

export type GetApplicationStageTransitionCheckpointsConfigResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | StageTransitionsCheckpointsConfig
   | StageTransitionsNotFound

export type GetApplicationSurveyNumberRemarksInPortalParams = {
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
   surveyNumberFieldId: Scalars['String']
}

export type GetApplicationSurveyNumberRemarksInPortalResponse =
   | GetApplicationSurveyNumberRemarksInPortalResult
   | GivenFieldIsNotSurveyNumberField
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PortalNotFound

export type GetApplicationSurveyNumberRemarksInPortalResult = {
   __typename?: 'GetApplicationSurveyNumberRemarksInPortalResult'
   applicationId: Scalars['String']
   portalId: Scalars['String']
   remarks?: Maybe<SurveyNumberRemarkEnum>
   surveyNumberFieldId: Scalars['String']
}

export type GetApplicationSurveyNumberRemarksParams = {
   applicationId: Scalars['String']
   surveyNumberFieldId: Scalars['String']
}

export type GetApplicationSurveyNumberRemarksResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | FieldIsDeleted
   | FieldNotFound
   | GetApplicationSurveyNumberRemarksResult

export type GetApplicationSurveyNumberRemarksResult = {
   __typename?: 'GetApplicationSurveyNumberRemarksResult'
   applicationId: Scalars['String']
   remarks?: Maybe<SurveyNumberRemarkEnum>
   surveyNumberFieldId: Scalars['String']
}

export type GetApplicationSystemFieldsParams = {
   applicationIds: Array<Scalars['String']>
   systemFieldEnums: Array<ApplicationSystemFieldEnum>
}

export type GetApplicationUnfilledRequiredFieldsInPortalParams = {
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   stageTransitionId: Scalars['String']
}

export type GetApplicationUnfilledRequiredFieldsInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ApplicationStageFieldNotConfigured
   | GetApplicationNotFilledRequiredFieldsInPortalResult
   | PortalNotFound
   | StageTransitionNotFound
   | StageTransitionNotInApplicationDisplayStage
   | SurveyNumberAreaSumMismatchWithPlotArea

export type GetApplicationValidationsStatusInPortalParams = {
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   stageTransitionId: Scalars['String']
}

export type GetApplicationValidationsStatusInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ApplicationStageFieldNotConfigured
   | GetApplicationValidationsStatusInPortalResult
   | PortalNotFound
   | StageTransitionNotFound
   | StageTransitionNotInApplicationDisplayStage
   | SurveyNumberAreaSumMismatchWithPlotArea

export type GetApplicationValidationsStatusInPortalResult = {
   __typename?: 'GetApplicationValidationsStatusInPortalResult'
   emptyRequiredFields: Array<UnfilledGofResponseFields>
   failedValidationRules: Array<FieldValidationRulesFailedErrData>
   redirectToPendingOrders?: Maybe<Scalars['Boolean']>
}

export type GetApplicationVisibleGoFsInPortalParams = {
   applicationId: Scalars['String']
   portalType: PortalType
}

export type GetApplicationVisibleGoFsInPortalResponse =
   | GetApplicationVisibleGoFsInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetApplicationVisibleGoFsInPortalResult = {
   __typename?: 'GetApplicationVisibleGoFsInPortalResult'
   gofVisibilities: Array<GoFVisibility>
}

export type GetApplicationVrVisibleEntitiesInPortalParams = {
   applicationId: Scalars['String']
   portalType: PortalType
   ruleIds: Array<Scalars['String']>
}

export type GetApplicationVrVisibleEntitiesInPortalResponse =
   | GetApplicationVrVisibleEntitiesInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | VisibilityRulesNotFound
   | VisibilityRulesNotLinkedToApplicationTemplate

export type GetApplicationVrVisibleEntitiesInPortalResult = {
   __typename?: 'GetApplicationVrVisibleEntitiesInPortalResult'
   visibilities: Array<VrEntityVisibility>
}

export type GetApplicationsForFileNumbersParams = {
   fileNumbers: Array<Scalars['String']>
}

export type GetApplicationsForFileNumbersResponse =
   | GetApplicationsForFileNumbersResult
   | InvalidFileNumbers

export type GetApplicationsForFileNumbersResult = {
   __typename?: 'GetApplicationsForFileNumbersResult'
   applications: Array<ApplicationForScrutiny>
   fields: Array<Field>
}

export type GetApplicationsInApplicationManagementParams = {
   actionType?: InputMaybe<ApplicationManagementActionType>
   pagination?: InputMaybe<Pagination>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetApplicationsInApplicationManagementResponse =
   | ApplicationManagementAccessDenied
   | GetApplicationsInApplicationManagementResult
   | InvalidLimit
   | InvalidOffset

export type GetApplicationsInApplicationManagementResult = {
   __typename?: 'GetApplicationsInApplicationManagementResult'
   applications: Array<ApplicationInApplicationManagement>
   totalCount: Scalars['Int']
}

export type GetApplicationsInPortalParams = {
   pagination: Pagination
   portalId: Scalars['String']
}

export type GetApplicationsInPortalResponse =
   | ApplicationsInPortalResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PortalNotFound
   | UserIsNotAnAdministrator

export type GetAssignFriendActionVisibilityParams = {
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type GetAssignFriendActionVisibilityResponse =
   | FriendActionVisibilityResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetAssignFriendConfigResponse =
   | AssignFriendJsonConfigurationNotFound
   | GetAssignFriendConfigResult

export type GetAssignFriendConfigResult = {
   __typename?: 'GetAssignFriendConfigResult'
   customFields: Array<FriendConfigCustomField>
   overviewCustomFieldIds: Array<Scalars['String']>
}

export type GetAssignedFriendApplicationsParams = {
   pagination: Pagination
}

export type GetAssignedFriendApplicationsResponse =
   | AssignFriendJsonConfigurationNotFound
   | GetAssignedFriendApplicationsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded

export type GetAssignedFriendApplicationsResult = {
   __typename?: 'GetAssignedFriendApplicationsResult'
   applications: Array<AssignedFriendApplication>
   totalCount: Scalars['Int']
}

export type GetAssigneeGroupsParams = {
   pagination: Pagination
   pipelineItemTemplateId: Scalars['String']
}

export type GetAssigneeGroupsResponse =
   | AssigneeGroups
   | InvalidLimit
   | InvalidOffset
   | PipelineAccessDenied
   | PipelineItemTemplateAccessDenied
   | PipelineItemTemplateNotFound

export type GetAssigneeTimespentLogInPortalParams = {
   pipelineIds?: InputMaybe<Array<Scalars['String']>>
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetAssigneeTimespentLogParams = {
   pipelineIds?: InputMaybe<Array<Scalars['String']>>
   pipelineItemId: Scalars['String']
}

export type GetAssigneeTimespentLogsBulkParams = {
   applicationId: Scalars['String']
   pipelineIdsList: Array<Array<Scalars['String']>>
}

export type GetAssigneeTimespentLogsBulkResponse =
   | GetAssigneeTimespentLogsBulkResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetAssigneeTimespentLogsBulkResult = {
   __typename?: 'GetAssigneeTimespentLogsBulkResult'
   pipelineGroupLogs: Array<PipelineGroupLogsResult>
}

export type GetAssigneeTimespentLogsInPortalBulkParams = {
   applicationId: Scalars['String']
   pipelineIdsList: Array<Array<Scalars['String']>>
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetAssigneeTimespentLogsInPortalBulkResponse =
   | GetAssigneeTimespentLogsInPortalBulkResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PortalNotFound

export type GetAssigneeTimespentLogsInPortalBulkResult = {
   __typename?: 'GetAssigneeTimespentLogsInPortalBulkResult'
   pipelineGroupLogs: Array<PipelineGroupLogsInPortalResult>
}

export type GetAssigneeTimespentLogsInPortalResponse =
   | GetAssigneeTimespentLogsInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PortalNotFound

export type GetAssigneeTimespentLogsInPortalResult = {
   __typename?: 'GetAssigneeTimespentLogsInPortalResult'
   assigneeTimeSpentLogSummary: Array<StageAssigneeTimespentLogSummary>
   assigneeTimeSpentLogs: Array<StageAssigneeTimespentLog>
   submissions: Array<AssigneeTimeSpentLogsForSubmission>
}

export type GetAssigneeTimespentLogsResponse =
   | GetAssigneeTimespentLogsResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetAssigneeTimespentLogsResult = {
   __typename?: 'GetAssigneeTimespentLogsResult'
   assigneeTimeSpentLogSummary: Array<StageAssigneeTimespentLogSummary>
   assigneeTimeSpentLogs: Array<StageAssigneeTimespentLog>
   submissions: Array<AssigneeTimeSpentLogsForSubmission>
}

export type GetAssociatedPipelinesForPipelineItemTemplatesParams = {
   pipelineItemTemplateIds: Array<Scalars['String']>
}

export type GetAssociatedPipelinesForPipelineItemTemplatesResponse =
   | GetAssociatedPipelinesForPipelineItemTemplatesResult
   | PipelineItemTemplatesNotFound
   | UserIsNotAnAdministrator

export type GetAssociatedPipelinesForPipelineItemTemplatesResult = {
   __typename?: 'GetAssociatedPipelinesForPipelineItemTemplatesResult'
   pipelineItemTemplates: Array<PipelineItemTemplatePipelines>
}

export type GetAttachmentsParams = {
   attachmentIds: Array<Scalars['String']>
}

export type GetAutomationWorkflowExecConfigsParams = {
   automationWorkflowExecConfigIds: Array<Scalars['String']>
}

export type GetAutomationWorkflowExecLogsFilterParams = {
   entityLevel?: InputMaybe<AwLogsEntityLevel>
   pipelineId?: InputMaybe<Scalars['String']>
}

export type GetAutomationWorkflowExecLogsFilterResponse =
   | AutomationWorkflowExecLogsFilter
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetAutomationWorkflowExecLogsParams = {
   automationWorkflowExecLogIds: Array<Scalars['String']>
}

export type GetAutomationWorkflowExecLogsTabCustomizationParams = {
   execLogsTab: AutomationWorkflowExecLogsTab
   pipelineId?: InputMaybe<Scalars['String']>
}

export type GetAutomationWorkflowExecLogsTabCustomizationResponse =
   | AutomationWorkflowExecLogsTabCustomization
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetAutomationWorkflowsParams = {
   automationWorkflows: Array<AutomationWorkflowParams>
}

export type GetAvailableCallLogsForTaskParams = {
   pagination: Pagination
   pipelineIds?: InputMaybe<Array<Scalars['String']>>
   pipelineItemId: Scalars['String']
}

export type GetAvailableCallLogsForTaskResponse =
   | GetAvailableCallLogsForTaskResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetAvailableCallLogsForTaskResult = {
   __typename?: 'GetAvailableCallLogsForTaskResult'
   callLogs: Array<CallLog>
   totalCount: Scalars['Int']
}

export type GetBpsPendingTaskOnPipelineItemParams = {
   assigneeFieldIds?: InputMaybe<Array<Scalars['String']>>
   pipelineItemId: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type GetBpsPendingTaskOnPipelineItemResponse =
   | NotPipelineItemTaskTemplate
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | Task
   | TaskTemplateAccessDenied
   | TaskTemplateIsDisabled
   | TaskTemplateIsNotPermittedInCurrentStage
   | TaskTemplateNotFound
   | VerificationAssigneeNotAssigned

export type GetBpsShortFallCounterInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetBpsShortFallCounterInPortalResponse =
   | GetBpsShortFallCounterInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PortalNotFound

export type GetBpsShortFallCounterInPortalResult = {
   __typename?: 'GetBPSShortFallCounterInPortalResult'
   pipelineItemId: Scalars['String']
   shortfallCounterValue?: Maybe<Scalars['Int']>
   thresholdValue?: Maybe<Scalars['Int']>
}

export type GetBpsShortFallCounterParams = {
   pipelineItemId: Scalars['String']
}

export type GetBpsShortFallCounterResponse =
   | GetBpsShortFallCounterResult
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetBpsShortFallCounterResult = {
   __typename?: 'GetBPSShortFallCounterResult'
   pipelineItemId: Scalars['String']
   shortfallCounterValue?: Maybe<Scalars['Int']>
   thresholdValue?: Maybe<Scalars['Int']>
}

export type GetBpsTaskConfigForPipelineItemParams = {
   pipelineItemId: Scalars['String']
}

export type GetBpsTaskConfigForPipelineItemResponse =
   | GetBpsTaskConfigForPipelineItemResult
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetBpsTaskConfigForPipelineItemResult = {
   __typename?: 'GetBPSTaskConfigForPipelineItemResult'
   disabledObservations: Array<SiteInspectionObservationEnum>
   enabledObservations: Array<SiteInspectionObservationEnum>
   pipelineItemId: Scalars['String']
}

export type GetBarGraphParams = {
   graphId: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
}

export type GetBoardFiltersParams = {
   boardId: Scalars['String']
}

export type GetBoardFiltersResponse =
   | BoardNotFound
   | FiltersResult
   | UserIsNotAnAdministrator

export type GetBoardListFiltersParams = {
   boardListId: Scalars['String']
}

export type GetBoardListFiltersResponse =
   | BoardListNotFound
   | FiltersResult
   | UserIsNotAnAdministrator

export type GetBoardListsInBoardParams = {
   boardId: Scalars['String']
}

export type GetBoardParams = {
   boardId: Scalars['String']
}

export type GetBoardResult = Board | BoardNotFound | BoardReadAccessDenied

export type GetBoardsForPipelinesParams = {
   pipelineIds: Array<Scalars['String']>
}

export type GetBoardsParams = {
   parentId?: InputMaybe<Scalars['String']>
   parentType: BoardParentType
}

export type GetBoardsSharedPermissionsParams = {
   boardIds: Array<Scalars['String']>
   entityTypes: Array<SharingEntityType>
   identificationTypes: Array<IdentificationType>
}

export type GetBoardsSharedPermissionsResult =
   | BoardEditAccessDenied
   | BoardNotFound
   | BoardSharedPermissions

export type GetBpsTemplateConfigParams = {
   pipelineItemTemplateId: Scalars['String']
}

export type GetBpsTemplateConfigResponse =
   | GetBpsTemplateConfigResult
   | PipelineItemTemplateAccessDenied
   | PipelineItemTemplateNotFound

export type GetBpsTemplateConfigResult = {
   __typename?: 'GetBpsTemplateConfigResult'
   fieldsConfig?: Maybe<Array<Maybe<BpsTemplateConfig>>>
   pipelineItemTemplateId: Scalars['String']
}

export type GetCallLogsWithFiltersParams = {
   callStartDatetimeRange?: InputMaybe<CallLogsCallStartDatetimeRangeParams>
   callStatuses: Array<CallStatus>
   customerPhoneNumber?: InputMaybe<PhoneNumberParams>
   filterByUserId?: InputMaybe<Scalars['String']>
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
}

export type GetCallLogsWithFiltersResponse =
   | AccessDeniedToUser
   | GetCallLogsWithFiltersResult
   | InvalidCallLogsCallStartDatetimeRange
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineNotFound
   | UserNotFound

export type GetCallLogsWithFiltersResult = {
   __typename?: 'GetCallLogsWithFiltersResult'
   callLogs: Array<CallLog>
   callStartDatetimeRange?: Maybe<Scalars['String']>
   callStatuses?: Maybe<Scalars['String']>
   customerPhoneNumber?: Maybe<Scalars['String']>
   filterByUserId?: Maybe<Scalars['String']>
   requestPipelineId?: Maybe<Scalars['String']>
   totalCount: Scalars['Int']
}

export type GetCardsVisibilityStatusInLayoutForPipelineItemResult = {
   __typename?: 'GetCardsVisibilityStatusInLayoutForPipelineItemResult'
   visibilities: Array<LayoutCustomSectionVisibilityStatus>
}

export type GetChildTabsForParentTabsParams = {
   pipelineItemId: Scalars['String']
   tabIds: Array<Scalars['String']>
}

export type GetChildTabsForParentTabsResponse =
   | GetChildTabsForParentTabsResult
   | LayoutTabsNotFound
   | NotNestedTabTypes
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetChildTabsForParentTabsResult = {
   __typename?: 'GetChildTabsForParentTabsResult'
   tabs: Array<ParentChildTabs>
}

export type GetCitizenAccountStatusParams = {
   dialCode: Scalars['String']
   phoneNumber: Scalars['String']
}

export type GetCitizenAccountStatusResponse = GetCitizenAccountStatusResult

export type GetCitizenAccountStatusResult = {
   __typename?: 'GetCitizenAccountStatusResult'
   hasAccount: Scalars['Boolean']
   userId?: Maybe<Scalars['String']>
}

export type GetConflictedAssociatedPipelineItemsParams = {
   pipelineItemIds: Array<Scalars['String']>
}

export type GetConflictedAssociatedRelatedEntitiesParams = {
   pipelineItemIds: Array<Scalars['String']>
}

export type GetContactFieldsParams = {
   contactId: Scalars['String']
   fieldIds: Array<Scalars['String']>
}

export type GetContactFieldsResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | GetContactFieldsResult

export type GetContactFieldsResult = {
   __typename?: 'GetContactFieldsResult'
   fields: Array<ContactFieldResult>
}

export type GetContactLeadsParams = {
   contactId: Scalars['String']
}

export type GetContactLeadsResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | Leads

export type GetContactParams = {
   contactId: Scalars['String']
}

export type GetContactPipelineResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | GetContactPipelineResult

export type GetContactPipelineResult = {
   __typename?: 'GetContactPipelineResult'
   pipelines: Array<BasePipeline>
}

export type GetContactPipelinesParams = {
   contactId: Scalars['String']
   pipelineItemTypes: Array<PipelineItemType>
}

export type GetContactsSystemFieldsParams = {
   contactIds: Array<Scalars['String']>
   systemFieldEnums: Array<ContactSystemFieldEnum>
}

export type GetCrmEntityLinkedRelatedObjectsParams = {
   crmEntityId: Scalars['String']
   excludeRelationIds?: InputMaybe<Array<Scalars['String']>>
   includeRelationIds?: InputMaybe<Array<Scalars['String']>>
}

export type GetCrmEntityLinkedRelatedObjectsResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | CrmEntityLinkedRelatedObjectResult
   | InvalidCrmEntityId
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetCustomSectionsVisibilityStatusInLayoutForPipelineItemParams = {
   customSectionIds: Array<Scalars['String']>
   layoutId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type GetCustomSectionsVisibilityStatusInLayoutForPipelineItemResponse =
   | GetCardsVisibilityStatusInLayoutForPipelineItemResult
   | InvalidLayoutCustomSectionIds
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetDashboardCountByIdentificationResult = {
   __typename?: 'GetDashboardCountByIdentificationResult'
   identificationCounts: Array<IdentificationDashboardCount>
}

export type GetDashboardResponse =
   | Dashboard
   | DashboardAccessDenied
   | DashboardNotFound

export type GetDashboardsCountByIdentificationParams = {
   filterByIdentificationIds: Array<Scalars['String']>
   pipelineId?: InputMaybe<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
   userDashboardType: UserDashboardType
}

export type GetDashboardsCountByIdentificationResponse =
   | GetDashboardCountByIdentificationResult
   | IdentificationsNotFound
   | PipelineNotFound

export type GetDataExportRequestsParams = {
   actionTypes: Array<DataExportActionType>
   cloudCallingServiceAccountIds: Array<Scalars['String']>
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   statuses: Array<DataExportReqStatus>
}

export type GetDataExportRequestsResponse =
   | GetDataExportRequestsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelinesAccessDenied
   | PipelinesNotFound
   | UserIsNotAnAdministrator

export type GetDataExportRequestsResult = {
   __typename?: 'GetDataExportRequestsResult'
   dataExportRequests: Array<DataExportRequest>
   totalCount: Scalars['Int']
}

export type GetDataLoadingRequestsParams = {
   actionTypes: Array<DataLoadingActionType>
   cloudCallingServiceAccountIds: Array<Scalars['String']>
   crmTemplateId?: InputMaybe<Scalars['String']>
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   pluginServiceAccountId?: InputMaybe<Scalars['String']>
   statuses: Array<DataLoadingReqStatus>
}

export type GetDataLoadingRequestsResponse =
   | GetDataLoadingRequestsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelinesAccessDenied
   | PipelinesNotFound
   | UserIsNotAnAdministrator

export type GetDataLoadingRequestsResult = {
   __typename?: 'GetDataLoadingRequestsResult'
   dataLoadingRequests: Array<DataLoadingRequest>
   totalCount: Scalars['Int']
}

export type GetDealAddAnotherFieldsParams = {
   dealId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofResponseIds: Array<Scalars['String']>
}

export type GetDealAddAnotherFieldsResponse =
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | GetDealAddAnotherGoFsFieldsResult
   | GoFResponseIdsNotFound
   | NotAddAnotherFields
   | NotDealAddAnotherGoFResponsesBulk
   | NotPermittedFields

export type GetDealAddAnotherGoFsFieldsParams = {
   dealId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
}

export type GetDealAddAnotherGoFsFieldsResponse =
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | GetDealAddAnotherGoFsFieldsResult
   | GoFsAreDeleted
   | GoFsNotFound
   | NotAddAnotherGoFs
   | NotPermittedFields

export type GetDealAddAnotherGoFsFieldsResult = {
   __typename?: 'GetDealAddAnotherGoFsFieldsResult'
   dealId: Scalars['String']
   gofResponses: Array<AddAnotherGoFResult>
}

export type GetDealFieldsParams = {
   dealId: Scalars['String']
   fieldIds: Array<Scalars['String']>
}

export type GetDealFieldsResponse =
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound
   | GetDealFieldsResult

export type GetDealFieldsResult = {
   __typename?: 'GetDealFieldsResult'
   fields: Array<DealFieldResult>
}

export type GetDealProfileParams = {
   dealId: Scalars['String']
}

export type GetDealProfileResponse =
   | Deal
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound

export type GetDealTemplateSystemFieldsParams = {
   dealTemplateIds: Array<Scalars['String']>
   systemFieldEnums: Array<DealTemplateSystemFieldEnum>
}

export type GetDealTemplateSystemFieldsResponse =
   | DealTemplateSystemFieldsResult
   | DealTemplatesAccessDenied
   | DealTemplatesNotFound

export type GetDealsSystemFieldsParams = {
   dealIds: Array<Scalars['String']>
   systemFieldEnums: Array<DealSystemFieldEnum>
}

export type GetDeletedFieldsForGofsParams = {
   gofIds: Array<Scalars['String']>
}

export type GetDeletedGofsForSalesTemplatesParams = {
   salesTemplateIds: Array<Scalars['String']>
}

export type GetDocumentHistoryParams = {
   documentId: Scalars['String']
   pagination: Pagination
}

export type GetDocumentHistoryResponse =
   | DocumentIsDeleted
   | DocumentNotFound
   | GetDocumentHistoryResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted

export type GetDocumentHistoryResult = {
   __typename?: 'GetDocumentHistoryResult'
   documentVersions: Array<DocumentVersion>
   totalCount: Scalars['Int']
}

export type GetDocumentTemplatePreviewWithMockDataParams = {
   documentTemplateId: Scalars['String']
}

export type GetDocumentTemplatePreviewWithMockDataResponse =
   | DocumentTemplateIsDeleted
   | DocumentTemplateNotFound
   | GetDocumentTemplatePreviewWithMockDataResult

export type GetDocumentTemplatePreviewWithMockDataResult = {
   __typename?: 'GetDocumentTemplatePreviewWithMockDataResult'
   documentTemplateId: Scalars['String']
   s3FileUrl: Scalars['String']
}

export type GetDocumentTemplatesByVersionForAdminParams = {
   documentTemplateVersionIds: Array<Scalars['String']>
}

export type GetDocumentTemplatesByVersionForAdminResponse =
   | GetDocumentTemplatesByVersionForAdminResult
   | InvalidDocumentTemplateVersionIds
   | UserIsNotAnAdministrator

export type GetDocumentTemplatesByVersionForAdminResult = {
   __typename?: 'GetDocumentTemplatesByVersionForAdminResult'
   documentTemplates: Array<AdminDocumentTemplate>
}

export type GetDocumentTemplatesForPipelineItemTemplateByAdminParams = {
   pagination: Pagination
   pipelineIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   pipelineItemTemplateId: Scalars['String']
}

export type GetDocumentTemplatesForPipelineItemTemplateByAdminResponse =
   | InvalidLimit
   | InvalidOffset
   | PipelineItemTemplateDocumentTemplatesByAdminResult
   | PipelineItemTemplateNotFound
   | UserIsNotAnAdministrator

export type GetDocumentTemplatesForPipelineItemTemplateParams = {
   pagination: Pagination
   pipelineItemTemplateId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetDocumentTemplatesForPipelineItemTemplateResponse =
   | InvalidLimit
   | InvalidOffset
   | PipelineItemTemplateDocumentTemplatesResult
   | PipelineItemTemplateNotFound

export type GetDocumentTemplatesForPipelineItemTemplateResult = {
   __typename?: 'GetDocumentTemplatesForPipelineItemTemplateResult'
   documentTemplates: Array<DocumentTemplate>
   totalCount: Scalars['Int']
}

export type GetDocumentTemplatesForPipelineItemTemplatesParams = {
   pagination: Pagination
   pipelineIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   pipelineItemTemplateId: Scalars['String']
}

export type GetDocumentTemplatesForPipelineItemTemplatesResponse =
   | GetDocumentTemplatesForPipelineItemTemplateResult
   | InvalidLimit
   | InvalidOffset
   | PipelineItemTemplateNotFound

export type GetDocumentTemplatesInPipelineParams = {
   pagination: Pagination
   pipelineId: Scalars['String']
}

export type GetDocumentTemplatesInPipelineResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineDocumentTemplatesForAdminResult
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetDocumentTemplatesParams = {
   documentTemplateIds: Array<Scalars['String']>
}

export type GetDocumentTemplatesPermittedActionsParams = {
   documentTemplateIds: Array<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type GetDocumentTemplatesPermittedActionsResponse =
   | DocumentTemplatesNotFound
   | GetDocumentTemplatesPermittedActionsResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetDocumentTemplatesPermittedActionsResult = {
   __typename?: 'GetDocumentTemplatesPermittedActionsResult'
   documentTemplates: Array<DocumentTemplatePermittedActions>
   pipelineItemId: Scalars['String']
}

export type GetDocumentTemplatesResponse =
   | DocumentTemplatesNotFound
   | GetDocumentTemplatesResult

export type GetDocumentTemplatesResult = {
   __typename?: 'GetDocumentTemplatesResult'
   documentTemplates?: Maybe<Array<Maybe<DocumentTemplate>>>
}

export type GetDocumentsForDocumentTemplatesParams = {
   documentTemplateIds: Array<Scalars['String']>
   pagination: Pagination
   pipelineItemId: Scalars['String']
}

export type GetDocumentsForDocumentTemplatesResponse =
   | DocumentTemplatesNotFound
   | GetDocumentsForDocumentTemplatesResult

export type GetDocumentsForDocumentTemplatesResult = {
   __typename?: 'GetDocumentsForDocumentTemplatesResult'
   documents: Array<Document>
   totalCount: Scalars['Int']
}

export type GetDonutChartParams = {
   graphId: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
}

export type GetEligibleTdrBanksInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetEligibleTdrBanksInPortalResponse =
   | GetEligibleTdrBanksInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetEligibleTdrBanksInPortalResult = {
   __typename?: 'GetEligibleTDRBanksInPortalResult'
   eligibleBanks: Array<Maybe<TdrBankOption>>
}

export type GetEntitiesCountForFiltersParams = {
   filterIds: Array<Scalars['String']>
   filterSetEntity: FilterSetEntityType
}

export type GetEntitiesCountForFiltersResponse =
   | FilterSetNotLinkedToGivenEntity
   | FiltersAreNotInSameFilterSet
   | GetEntitiesCountForFiltersResult
   | NotSupportedFilterSetEntity
   | NotUserFilterSet
   | UserIsNotAnAdministrator

export type GetEntitiesCountForFiltersResult = {
   __typename?: 'GetEntitiesCountForFiltersResult'
   filterWiseCounts: Array<FilterEntitiesCountResult>
   totalFilterSetEntities: Scalars['Int']
}

export type GetEntityBoardsParams = {
   entityId: Scalars['String']
   entityType: BoardParentType
}

export type GetEntityBoardsResponse =
   | BoardEntityNotFound
   | GetEntityBoardsResult

export type GetEntityBoardsResult = {
   __typename?: 'GetEntityBoardsResult'
   boards: Array<Board>
}

export type GetEntityCheckedCheckpointsParams = {
   categoryIds: Array<Scalars['String']>
   entityId: Scalars['String']
   entityType: CategoryEntityType
}

export type GetEntityCheckedCheckpointsResponse =
   | CategoriesNotFound
   | CategoryEntityAccessDenied
   | CategoryEntityNotFound
   | GetEntityCheckedCheckpointsResult

export type GetEntityCheckedCheckpointsResult = {
   __typename?: 'GetEntityCheckedCheckpointsResult'
   addedCheckpoints: Array<EntityCategoryCheckpoint>
   defaultCheckpoints: Array<EntityCategoryCheckpoint>
}

export type GetEntityDealsParams = {
   dealEntityId: Scalars['String']
   dealEntityType: DealEntityType
   pagination: Pagination
}

export type GetEntityDealsResponse =
   | DealEntityAccessDenied
   | DealEntityIsDeleted
   | DealEntityNotFound
   | GetEntityDealsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded

export type GetEntityDealsResult = {
   __typename?: 'GetEntityDealsResult'
   deals: Array<Deal>
   totalCount: Scalars['Int']
}

export type GetEntityFeeRuleSetForEntityParams = {
   entityId: Scalars['String']
   feeRuleSetId: Scalars['String']
}

export type GetEntityFeeRuleSetForEntityResponse =
   | FeeRuleSetNotFound
   | GetEntityFeeRuleSetForEntityResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetEntityFeeRuleSetForEntityResult = {
   __typename?: 'GetEntityFeeRuleSetForEntityResult'
   entityFeeRuleSet?: Maybe<EntityFeeRuleSet>
}

export type GetEntityFeeRuleSetOrdersPreviewParams = {
   entityFeeRuleSetId: Scalars['String']
}

export type GetEntityFeeRuleSetOrdersPreviewResponse =
   | EntityFeeRuleSetAccessDenied
   | EntityFeeRuleSetNotFound
   | GetEntityFeeRuleSetOrdersPreviewResult

export type GetEntityFeeRuleSetOrdersPreviewResult = {
   __typename?: 'GetEntityFeeRuleSetOrdersPreviewResult'
   orders: Array<OrderPreview>
}

export type GetEntityFeeRuleSetsForEntityParams = {
   entityId: Scalars['String']
   feeRuleSetId: Scalars['String']
}

export type GetEntityFeeRuleSetsForEntityResponse =
   | FeeRuleSetNotFound
   | GetEntityFeeRuleSetsForEntityResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetEntityFeeRuleSetsForEntityResult = {
   __typename?: 'GetEntityFeeRuleSetsForEntityResult'
   entityFeeRuleSets: Array<EntityFeeRuleSet>
}

export type GetEntityJsonConfigurationParams = {
   entityId?: InputMaybe<Scalars['String']>
   entityType: JsonConfigurationEntityType
}

export type GetEntityJsonConfigurationResponse =
   | EntityJsonConfigurationDoesNotExists
   | GetEntityJsonConfigurationResult
   | NotSupportedJsonConfigurationEntity
   | PortalNotFound

export type GetEntityJsonConfigurationResult = {
   __typename?: 'GetEntityJsonConfigurationResult'
   jsonConfiguration: JsonConfiguration
}

export type GetEntityNotesParams = {
   entityId: Scalars['String']
   entityType: NoteEntityType
   pagination?: InputMaybe<Pagination>
}

export type GetEntityNotesResponse =
   | GetEntityNotesResult
   | NoteEntityAccessDenied
   | NoteEntityNotFound

export type GetEntityNotesResult = {
   __typename?: 'GetEntityNotesResult'
   notes: Array<Note>
   totalCount: Scalars['Int']
}

export type GetEntityRuleSetsParams = {
   entityIds: Array<Scalars['String']>
   entityType: RuleEntityType
   purpose: RuleSetPurpose
}

export type GetEntityRuleSetsResponse = GetEntityRuleSetsResult

export type GetEntityRuleSetsResult = {
   __typename?: 'GetEntityRuleSetsResult'
   ruleSets: Array<RuleSet>
}

export type GetEntityTdrRequestsInPortalParams = {
   entityId: Scalars['String']
   entityType: TdrEntityType
   pagination: Pagination
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetEntityTdrRequestsInPortalResponse =
   | GetEntityTdrRequestsInPortalResult
   | InvalidLimit
   | InvalidOffset
   | PortalAccessDenied
   | PortalIsDeleted
   | PortalNotFound
   | TdrRequestEntityAccessDenied
   | TdrRequestEntityNotFound

export type GetEntityTdrRequestsInPortalResult = {
   __typename?: 'GetEntityTDRRequestsInPortalResult'
   displayStageConfig: Array<GqlDisplayStageConfig>
   recommendation?: Maybe<BpsVerificationRecommendationEnum>
   remarks?: Maybe<Scalars['String']>
   tdrRequests: Array<TdrRequest>
   totalCount: Scalars['Int']
}

export type GetEntityTdrRequestsParams = {
   entityId: Scalars['String']
   entityType: TdrEntityType
   pagination: Pagination
}

export type GetEntityTdrRequestsResponse =
   | GetEntityTdrRequestsResult
   | InvalidLimit
   | InvalidOffset
   | TdrRequestEntityAccessDenied
   | TdrRequestEntityNotFound

export type GetEntityTdrRequestsResult = {
   __typename?: 'GetEntityTDRRequestsResult'
   tdrRequests: Array<TdrRequest>
   totalCount: Scalars['Int']
}

export type GetEntityUncheckedCheckpointsParams = {
   categoryIds: Array<Scalars['String']>
   entityId: Scalars['String']
   entityType: CategoryEntityType
}

export type GetEntityUncheckedCheckpointsResponse =
   | CategoriesNotFound
   | CategoryEntityAccessDenied
   | CategoryEntityNotFound
   | GetEntityUncheckedCheckpointsResult

export type GetEntityUncheckedCheckpointsResult = {
   __typename?: 'GetEntityUncheckedCheckpointsResult'
   checkpoints: Array<CategoryCheckpoint>
}

export type GetEventBasedLeadDistributionRuleSummaryParams = {
   leadDistributionRuleId: Scalars['String']
}

export type GetEventBasedLeadDistributionRuleSummaryResponse =
   | EventBasedLeadDistributionRuleSummary
   | LeadDistributionRuleNotFound
   | NotEventBasedLeadDistributionRule
   | UserIsNotAnAdministrator

export type GetFailedTrackActivityLogResponse = {
   __typename?: 'GetFailedTrackActivityLogResponse'
   activityLogs: Array<FailedTrackActivityLog>
   totalCount: Scalars['Int']
}

export type GetFailedTrackActivityLogResult =
   | ActivityTemplatesAccessDenied
   | ActivityTemplatesNotFound
   | GetFailedTrackActivityLogResponse
   | InvalidDateRange
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineItemTemplateAccessDenied
   | PipelineItemTemplateNotFound
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetFailedTrackActivityLogsParams = {
   activityTemplateIds: Array<Scalars['String']>
   dateRange?: InputMaybe<DateRangeParams>
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetFeeRuleSetLogsParams = {
   entityFeeRuleSetIds: Array<Scalars['String']>
   pagination: Pagination
   pipelineItemId: Scalars['String']
}

export type GetFeeRuleSetLogsResponse =
   | EntityFeeRuleSetsNotFound
   | GetFeeRuleSetLogsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetFeeRuleSetLogsResult = {
   __typename?: 'GetFeeRuleSetLogsResult'
   logs: Array<FeeRuleSetLog>
   totalCount: Scalars['Int']
}

export type GetFieldEntityRuleSetsInPortalParams = {
   pipelineId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
   purpose: RuleSetPurpose
}

export type GetFieldEntityRuleSetsInPortalResponse =
   | GetFieldEntityRuleSetsInPortalResult
   | PortalApplicationNotFound

export type GetFieldEntityRuleSetsInPortalResult = {
   __typename?: 'GetFieldEntityRuleSetsInPortalResult'
   ruleSets: Array<RuleSet>
}

export type GetFieldOptionsForApplicationInPortalParams = {
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   pagination: Pagination
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetFieldOptionsForApplicationInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ConditionalFieldParentsHaveEmptyResponse
   | FieldIsDeleted
   | FieldNotFound
   | FieldOptionsForApplicationInPortalResult
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | InvalidLimit
   | InvalidOffset
   | NeedFieldReadPermission
   | NoConditionalOptionsWereConfigured
   | NotApplicationAddAnotherGoFResponse
   | NotConditionalOptionsValueType
   | NotGoFResponseFieldId
   | NotSupportedFieldType
   | PaginationLimitExceeded
   | PortalNotFound

export type GetFieldOptionsForCrmEntityParams = {
   crmEntityId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetFieldOptionsForCrmEntityResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | CrmEntityParentFieldsHasEmtpyResponse
   | FieldIsDeleted
   | FieldNotFound
   | FieldOptionsForCrmEntityResult
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | InvalidCrmEntityId
   | InvalidLimit
   | InvalidOffset
   | NeedFieldReadPermission
   | NoConditionalOptionsWereConfigured
   | NotConditionalOptionsValueType
   | NotContactField
   | NotCrmEntityGoFResponseId
   | NotGoFResponseFieldId
   | NotPipelineItemField
   | NotSupportedFieldType
   | NotTaskField
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TaskAccessDenied
   | TaskDiscarded
   | TaskIsAlreadyCompleted
   | TaskNotFound

export type GetFieldOptionsForRecordCreationParams = {
   fieldId: Scalars['String']
   pagination: Pagination
   parentOptions: Array<ParentFieldOptionsParams>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetFieldOptionsForRecordCreationResponse =
   | FieldOptionsAreRequired
   | FieldOptionsForRecordCreationResult
   | FieldOptionsNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidLimit
   | InvalidOffset
   | NeedFieldsReadPermission
   | NoConditionalOptionsWereConfigured
   | NotConditionalOptionsValueType
   | NotSupportedFieldType
   | PaginationLimitExceeded

export type GetFieldOptionsForRelatedEntityFieldParams = {
   currentEntityId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   pagination: Pagination
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetFieldOptionsForRelatedEntityFieldResponse =
   | FieldIsDeleted
   | FieldNotFound
   | FieldOptionsForRelatedEntityResult
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | InvalidLimit
   | InvalidOffset
   | NeedFieldWritePermission
   | NoConditionalOptionsWereConfigured
   | NotConditionalOptionsValueType
   | NotGoFResponseFieldId
   | NotPermittedCurrentEntity
   | NotPermittedRelation
   | NotRelatedEntityGoFResponseId
   | NotRelatedEntityTemplateField
   | NotSupportedFieldType
   | PaginationLimitExceeded
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntityParentFieldHasEmptyResponse
   | RelationIsDeleted
   | RelationNotFound

export type GetFieldOptionsForSearchAndMonitoringParams = {
   fieldId: Scalars['String']
   pagination: Pagination
   parentOptions: Array<ParentFieldOptionsForSearchAndMonitoringParams>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetFieldOptionsForSearchAndMonitoringResponse =
   | FieldOptionsAreRequired
   | FieldOptionsForSearchAndMonitoringResult
   | FieldOptionsNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidLimit
   | InvalidOffset
   | NoConditionalOptionsWereConfigured
   | NotSupportedDefaultOptionsTypeField
   | NotSupportedFieldType

export type GetFieldRolesParams = {
   fieldIds: Array<Scalars['String']>
}

export type GetFieldsInPortalParams = {
   fieldIds: Array<Scalars['String']>
   portalId: Scalars['String']
}

export type GetFieldsInPortalResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | GetFieldsInPortalResult
   | NotPermittedFields
   | NotPortalUser
   | PortalAccessDenied
   | PortalIsDeleted
   | PortalNotFound

export type GetFieldsInPortalResult = {
   __typename?: 'GetFieldsInPortalResult'
   fields: Array<Field>
   portalId: Scalars['String']
}

export type GetFieldsIncludingConstantFieldsInputArgs = {
   fieldIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type GetFieldsIncludingConstantFieldsResponse =
   | GetFieldsIncludingConstantFieldsResult
   | PipelineAccessDenied
   | PipelineNotFound

export type GetFieldsIncludingConstantFieldsResult = {
   __typename?: 'GetFieldsIncludingConstantFieldsResult'
   fields: Array<FieldResult>
}

export type GetFieldsRolesResponse = GetFieldsRolesResult

export type GetFieldsRolesResult = {
   __typename?: 'GetFieldsRolesResult'
   fields: Array<FieldRolesResult>
}

export type GetFilterFieldsParams = {
   pipelineId: Scalars['String']
}

export type GetFilterSetEntitiesCountParams = {
   filterSetEntity: FilterSetEntityType
   filterSetId: Scalars['String']
}

export type GetFilterSetEntitiesCountResponse =
   | FilterSetEntitiesCount
   | FilterSetNotLinkedToGivenEntity
   | NotSupportedFilterSetEntity
   | NotUserFilterSet
   | UserIsNotAnAdministrator

export type GetFiltersForAutomationWorkflowFilterSetParams = {
   filterSetId: Scalars['String']
}

export type GetFiltersForAutomationWorkflowFilterSetResponse =
   | AutomationWorkflowFilterSetNotFound
   | AutomationWorkflowFiltersResult
   | UserIsNotAnAdministrator

export type GetFiltersForConditionNodeParams = {
   nodeId: Scalars['String']
}

export type GetFiltersForEventTriggerFilterSetParams = {
   filterSetEntity: EventTriggerFilterSetEntity
   filterSetId: Scalars['String']
}

export type GetFiltersForEventTriggerFilterSetResponse =
   | EventTriggerFilterSetNotFound
   | EventTriggerFilterSetNotLinkedToGivenEntity
   | EventTriggerFiltersResult
   | UserIsNotAnAdministrator

export type GetFiltersParams = {
   filterSetEntity: FilterSetEntityType
   filterSetId: Scalars['String']
}

export type GetFiltersResponse =
   | FilterSetAccessDenied
   | FilterSetNotFound
   | FilterSetNotLinkedToBoard
   | FilterSetNotLinkedToBoardList
   | FilterSetNotLinkedToGivenEntity
   | FilterSetNotLinkedToGraph
   | FilterSetNotLinkedToView
   | FiltersResult
   | NotUserFilterSet
   | UserIsNotAnAdministrator

export type GetFormFailedSubmissionLogsParams = {
   dateRange?: InputMaybe<DateRangeParams>
   formId: Scalars['String']
   pagination: Pagination
}

export type GetFormFailedSubmissionLogsResponse =
   | FormNotFound
   | GetFormFailedSubmissionLogsResult
   | InvalidDateRange
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type GetFormFailedSubmissionLogsResult = {
   __typename?: 'GetFormFailedSubmissionLogsResult'
   formSubmissions: Array<FailedFormSubmissionLog>
   totalCount: Scalars['Int']
}

export type GetFormFieldsInPdfParams = {
   pdfUrl: Scalars['String']
}

export type GetFormFieldsInPdfResponse =
   | GetFormFieldsInPdfResult
   | NotPdfFileUrl
   | UserIsNotAnAdministrator

export type GetFormFieldsInPdfResult = {
   __typename?: 'GetFormFieldsInPdfResult'
   formFields: Array<Scalars['String']>
   pdfUrl: Scalars['String']
}

export type GetFormIdentificationFieldsParams = {
   formId: Scalars['String']
}

export type GetFormIdentificationFieldsResponse =
   | FormNotFound
   | GetFormIdentificationFieldsResult
   | UserIsNotAnAdministrator

export type GetFormIdentificationFieldsResult = {
   __typename?: 'GetFormIdentificationFieldsResult'
   formId: Scalars['String']
   identificationFields: Array<Field>
}

export type GetFormParams = {
   formId: Scalars['String']
}

export type GetFormsForParentParams = {
   pagination: Pagination
   parentId?: InputMaybe<Scalars['String']>
   parentType: FormParentType
}

export type GetFormsForParentResponse =
   | GetFormsForParentResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | ParentIdIsRequired
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetFormsForParentResult = {
   __typename?: 'GetFormsForParentResult'
   forms: Array<Form>
   totalForms: Scalars['Int']
}

export type GetFunctionsResponse = FunctionsResult

export type GetFunnelGraphParams = {
   graphId: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
}

export type GetGallaAccountPluginServiceAccountsResult = {
   __typename?: 'GetGallaAccountPluginServiceAccountsResult'
   gallaboxAccounts: Array<GallaboxAccount>
   totalCount: Scalars['Int']
}

export type GetGallaboxAccountPluginServiceAccountsParams = {
   accountPluginId: Scalars['String']
   pagination: Pagination
}

export type GetGallaboxAccountPluginServiceAccountsResponse =
   | AccountPluginIdNotFound
   | GetGallaAccountPluginServiceAccountsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type GetGallaboxPluginServiceAccountsParams = {
   pluginServiceAccountIds: Array<Scalars['String']>
}

export type GetGallaboxPluginServiceAccountsResponse =
   | GallaboxServiceAccounts
   | UserIsNotAnAdministrator

export type GetGraphParams = {
   graphId: Scalars['String']
}

export type GetGraphsInDashboardParams = {
   dashboardId: Scalars['String']
   graphTypes?: InputMaybe<Array<InputMaybe<GraphType>>>
   pagination?: InputMaybe<Pagination>
}

export type GetGraphsInDashboardResponse =
   | DashboardAccessDenied
   | DashboardNotFound
   | GetGraphsInDashboardResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded

export type GetGraphsInDashboardResult = {
   __typename?: 'GetGraphsInDashboardResult'
   dashboard: Dashboard
   graphs: Array<UserGraph>
   totalGraphs: Scalars['Int']
}

export type GetGraphsInViewParams = {
   pagination?: InputMaybe<Pagination>
   viewId: Scalars['String']
}

export type GetGraphsInViewResult =
   | GraphsInView
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | ViewAccessDenied
   | ViewNotFound

export type GetGupShupAccountPluginServiceAccountsParams = {
   accountPluginId: Scalars['String']
   pagination: Pagination
}

export type GetGupShupAccountPluginServiceAccountsResponse =
   | AccountPluginIdNotFound
   | GetGupShupAccountPluginServiceAccountsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type GetGupShupAccountPluginServiceAccountsResult = {
   __typename?: 'GetGupShupAccountPluginServiceAccountsResult'
   gupshupAccounts: Array<GupShupAccount>
   totalCount: Scalars['Int']
}

export type GetGupShupPluginServiceAccountsParams = {
   pluginServiceAccountIds: Array<Scalars['String']>
}

export type GetGupShupPluginServiceAccountsResponse =
   | GupShupServiceAccounts
   | UserIsNotAnAdministrator

export type GetIdentificationsInAccountParams = {
   fieldExecutionRoleFilter?: InputMaybe<FieldExecutionRoleFilter>
   identificationTypes: Array<IdentificationType>
   pagination?: InputMaybe<Pagination>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetItemIdsInViewParams = {
   customFilters: Array<CustomFilter>
   pagination: Pagination
   userHierarchyFilter?: InputMaybe<UserHierarchyFilter>
   viewId: Scalars['String']
}

export type GetJsonConfigurationsParams = {
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetJsonConfigurationsResponse =
   | GetJsonConfigurationsResult
   | InvalidLimit
   | InvalidOffset

export type GetJsonConfigurationsResult = {
   __typename?: 'GetJsonConfigurationsResult'
   jsonConfigurations: Array<JsonConfiguration>
   totalCount: Scalars['Int']
}

export type GetKnowlarityAccountPluginServiceAccountsParams = {
   accountPluginId: Scalars['String']
}

export type GetKnowlarityAccountPluginServiceAccountsResponse =
   | AccountPluginIdNotFound
   | GetKnowlarityAccountPluginServiceAccountsResult
   | UserIsNotAnAdministrator

export type GetKnowlarityAccountPluginServiceAccountsResult = {
   __typename?: 'GetKnowlarityAccountPluginServiceAccountsResult'
   knowlarityAccounts: Array<KnowlarityAccount>
}

export type GetKnowlarityServiceAccountsParams = {
   pluginServiceAccountIds: Array<Scalars['String']>
}

export type GetKnowlarityServiceAccountsResponse =
   | KnowlarityServiceAccounts
   | UserIsNotAnAdministrator

export type GetLatestPendingPipelineItemTasksParams = {
   pipelineItemId: Scalars['String']
   taskTemplateIds: Array<Scalars['String']>
}

export type GetLatestPendingPipelineItemTasksResponse =
   | GetLatestPendingPipelineItemTasksResult
   | InvalidTaskTemplateIds
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TaskTemplatesNotInPipelineItemPipeline

export type GetLatestPendingPipelineItemTasksResult = {
   __typename?: 'GetLatestPendingPipelineItemTasksResult'
   tasks: Array<Task>
}

export type GetLatestPipelineItemTaskFieldsForFieldsParams = {
   fieldIds: Array<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type GetLatestPipelineItemTaskFieldsForFieldsResponse =
   | GetLatestPipelineItemTaskFieldsForFieldsResult
   | NotTaskTemplateFields

export type GetLatestPipelineItemTaskFieldsForFieldsResult = {
   __typename?: 'GetLatestPipelineItemTaskFieldsForFieldsResult'
   fields: Array<LatestTaskFieldResult>
}

export type GetLayoutForEntityDetailsParams = {
   entityId: Scalars['String']
   entityType: LayoutEntityType
   pipelineId?: InputMaybe<Scalars['String']>
}

export type GetLayoutForEntityDetailsResponse =
   | Layout
   | LayoutConfigDoesNotExistForEntity
   | LayoutEntityAccessDenied
   | LayoutEntityNotFound
   | PipelineAccessDenied
   | PipelineNotFound

export type GetLayoutParentTabsForEntityDetailsParams = {
   entityId: Scalars['String']
   entityType: LayoutEntityType
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type GetLayoutParentTabsForEntityDetailsResponse =
   | GetLayoutParentTabsForEntityDetailsResult
   | LayoutConfigDoesNotExistForEntity
   | LayoutEntityAccessDenied
   | LayoutEntityNotFound
   | PipelineAccessDenied
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineNotFound

export type GetLayoutParentTabsForEntityDetailsResult = {
   __typename?: 'GetLayoutParentTabsForEntityDetailsResult'
   entityId: Scalars['String']
   entityType: LayoutEntityType
   headerFieldIds: Array<Scalars['String']>
   layoutId: Scalars['String']
   orderedParentTabs: Array<Tab>
   pipelineId?: Maybe<Scalars['String']>
   quickActions: Array<LayoutQuickActionType>
}

export type GetLayoutTabsForPipelineTemplateParams = {
   pipelineItemTemplateId: Scalars['String']
   tabTypes: Array<TabType>
}

export type GetLayoutTabsForPipelineTemplateResponse =
   | GetLayoutTabsForPipelineTemplateResult
   | PipelineItemTemplateNotFound

export type GetLayoutTabsForPipelineTemplateResult = {
   __typename?: 'GetLayoutTabsForPipelineTemplateResult'
   tabs: Array<PipelineLayoutTab>
}

export type GetLeadAddAnotherFieldsParams = {
   fieldIds: Array<Scalars['String']>
   gofResponseIds: Array<Scalars['String']>
   leadId: Scalars['String']
}

export type GetLeadAddAnotherFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | GetLeadAddAnotherGoFsFieldsResult
   | GoFResponseIdsNotFound
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound
   | NotAddAnotherFields
   | NotLeadAddAnotherGoFResponsesBulk
   | NotPermittedFields

export type GetLeadAddAnotherGoFsFieldsParams = {
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
   leadId: Scalars['String']
}

export type GetLeadAddAnotherGoFsFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | GetLeadAddAnotherGoFsFieldsResult
   | GoFsAreDeleted
   | GoFsNotFound
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound
   | NotAddAnotherGoFs
   | NotPermittedFields

export type GetLeadAddAnotherGoFsFieldsResult = {
   __typename?: 'GetLeadAddAnotherGoFsFieldsResult'
   gofResponses: Array<AddAnotherGoFResult>
   leadId: Scalars['String']
}

export type GetLeadDistributionRuleExecLogParams = {
   leadDistributionRuleExecLogId: Scalars['String']
}

export type GetLeadDistributionRuleExecLogResponse =
   | EventBasedLeadDistributionRuleExecLog
   | LeadDistributionRuleExecLog
   | LeadDistributionRuleExecLogNotFound
   | ManualLeadDistributionRuleExecLog
   | ScheduledLeadDistributionRuleExecLog
   | UserIsNotAnAdministrator

export type GetLeadDistributionRuleSummaryParams = {
   leadDistributionRuleId: Scalars['String']
}

export type GetLeadDistributionRuleSummaryResponse =
   | EventBasedLeadDistributionRuleIsNotSupported
   | LeadDistributionRuleNotFound
   | LeadDistributionRuleSummary
   | UserIsNotAnAdministrator

export type GetLeadDistributionRulesParams = {
   leadDistributions: Array<LeadDistributionRuleParams>
}

export type GetLeadDistributionRulesResponse =
   | GetLeadDistributionRulesResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelinesAccessDenied
   | PipelinesNotFound
   | UserIsNotAnAdministrator

export type GetLeadDistributionRulesResult = {
   __typename?: 'GetLeadDistributionRulesResult'
   leadDistributionRules: Array<LeadDistributionRule>
   totalCount: Scalars['Int']
}

export type GetLeadFieldsParams = {
   fieldIds: Array<Scalars['String']>
   leadId: Scalars['String']
}

export type GetLeadFieldsResponse =
   | GetLeadFieldsResult
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound

export type GetLeadFieldsResult = {
   __typename?: 'GetLeadFieldsResult'
   fields: Array<LeadFieldResult>
}

export type GetLeadInitiationRolesOnActivityParams = {
   activityTemplateIds: Array<Scalars['String']>
}

export type GetLeadInitiationRolesOnActivityResponse =
   | GetLeadInitiationRolesOnActivityResult
   | UserIsNotAnAdministrator

export type GetLeadInitiationRolesOnActivityResult = {
   __typename?: 'GetLeadInitiationRolesOnActivityResult'
   leadInitiationRolesOnActivities: Array<LeadInitiationRolesOnActivityResult>
}

export type GetLeadProfileParams = {
   leadId: Scalars['String']
}

export type GetLeadProfileResponse =
   | Lead
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound

export type GetLeadTemplateSystemFieldsParams = {
   leadTemplateIds: Array<Scalars['String']>
   systemFieldEnums: Array<LeadTemplateSystemFieldEnum>
}

export type GetLeadTemplateSystemFieldsResponse =
   | LeadTemplateSystemFieldsResult
   | LeadTemplatesAccessDenied
   | LeadTemplatesNotFound

export type GetLeadsSystemFieldsParams = {
   leadIds: Array<Scalars['String']>
   systemFieldEnums: Array<LeadSystemFieldEnum>
}

export type GetLineDepartmentRequestHistoryLogsParams = {
   pipelineItemId: Scalars['String']
   tabId: Scalars['String']
   verificationId: Scalars['String']
}

export type GetLineDepartmentRequestHistoryLogsResponse =
   | GetLineDepartmentRequestHistoryLogsResult
   | LayoutTabNotFound
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TabNotInPipelineItemTemplate
   | VerificationNotFound

export type GetLineDepartmentRequestHistoryLogsResult = {
   __typename?: 'GetLineDepartmentRequestHistoryLogsResult'
   logs: Array<VerificationRequestHistoryLog>
}

export type GetLineGraphParams = {
   graphId: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
}

export type GetLoadBankAccountRequestParams = {
   pagination: Pagination
   status?: InputMaybe<LoadBankAccountRequestStatus>
}

export type GetLoadBankAccountRequestResponse =
   | GetLoadBankAccountRequestResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type GetLoadBankAccountRequestResult = {
   __typename?: 'GetLoadBankAccountRequestResult'
   items: Array<TestTransferBankAmountRequest>
   totalCount: Scalars['Int']
}

export type GetLtpUserManagementLogsParams = {
   fromDatetime?: InputMaybe<Scalars['String']>
   licenseNumber?: InputMaybe<Scalars['String']>
   ltpName?: InputMaybe<Scalars['String']>
   pagination: Pagination
   toDatetime?: InputMaybe<Scalars['String']>
   updatedBy?: InputMaybe<Scalars['String']>
}

export type GetLtpUserManagementLogsResponse =
   | GetLtpUserManagementLogsResult
   | LtpUserManagementAccessDenied

export type GetLtpUserManagementLogsResult = {
   __typename?: 'GetLtpUserManagementLogsResult'
   logs: Array<LtpUserManagementLog>
   totalCount: Scalars['Int']
}

export type GetLtpUsersForLtpManagementParams = {
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetLtpUsersForLtpManagementResponse =
   | GetLtpUsersResult
   | LtpUserManagementAccessDenied

export type GetLtpUsersResult = {
   __typename?: 'GetLtpUsersResult'
   ltpUsers: Array<LtpUser>
   totalCount: Scalars['Int']
}

export type GetMessagesForThreadParams = {
   pagination: Pagination
   threadId: Scalars['Int']
}

export type GetMessagesForThreadResponse =
   | GetMessagesForThreadResult
   | InvalidLimit
   | InvalidOffset
   | ThreadAccessDenied
   | ThreadNotFound

export type GetMessagesForThreadResult = {
   __typename?: 'GetMessagesForThreadResult'
   messages: Array<ThreadMessage>
   totalCount: Scalars['Int']
}

export type GetNodesParams = {
   nodeIds: Array<Scalars['String']>
}

export type GetOfficerLeaveLogsParams = {
   endDate?: InputMaybe<Scalars['String']>
   officerUserId?: InputMaybe<Scalars['String']>
   pagination?: InputMaybe<Pagination>
   showOnlyCompleted?: InputMaybe<Scalars['Boolean']>
   startDate?: InputMaybe<Scalars['String']>
}

export type GetOfficerLeaveLogsResponse =
   | InvalidLimit
   | InvalidOffset
   | OfficerLeaveLogsResult
   | OfficerManagementAccessDenied
   | PaginationLimitExceeded

export type GetOfficerManagementLogsParams = {
   filters?: InputMaybe<OfficerManagementLogFilters>
}

export type GetOfficerManagementLogsResponse =
   | InvalidLimit
   | InvalidOffset
   | OfficerManagementAccessDenied
   | OfficerManagementLogsResult
   | OfficerManagementRequestAccessDenied
   | OfficerManagementRequestNotFound
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type GetOfficerManagementUserParams = {
   pagination?: InputMaybe<Pagination>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetOfficerManagementUserResponse =
   | GetOfficerManagementUserResult
   | OfficerManagementAccessDenied

export type GetOfficerManagementUserResult = {
   __typename?: 'GetOfficerManagementUserResult'
   totalCount: Scalars['Int']
   users: Array<User>
}

export type GetOnHoldTdrAccountLogsParams = {
   pagination?: InputMaybe<Pagination>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetOnHoldTdrAccountLogsResponse =
   | GetOnHoldTdrAccountLogsResult
   | InvalidLimit
   | InvalidOffset
   | TdrManagementAccessDenied

export type GetOnHoldTdrAccountLogsResult = {
   __typename?: 'GetOnHoldTdrAccountLogsResult'
   onHoldAccounts: Array<TdrManagementLog>
   totalCount: Scalars['Int']
}

export type GetOpenSearchTdrAccountByAccountNoParams = {
   tdrAccountNo: Scalars['String']
}

export type GetOpenSearchTdrAccountByAccountNoResponse =
   | OpenSearchTdrAccount
   | TdrAccountNotExistsForAccountNo

export type GetOpenSearchTdrAccountParams = {
   tdrAccountId: Scalars['String']
}

export type GetOpenSearchTdrAccountResponse =
   | OpenSearchTdrAccount
   | OpenSearchTdrAccountNotFound

export type GetOpenSearchTdrAccountsParams = {
   captchaToken?: InputMaybe<Scalars['String']>
   pagination?: InputMaybe<Pagination>
   searchQuery?: InputMaybe<Scalars['String']>
   sortByFields?: InputMaybe<Array<InputMaybe<TdrAccountSortByFieldExtGraphql>>>
}

export type GetOpenSearchTdrAccountsResponse =
   | CaptchaExpired
   | GetOpenSearchTdrAccountsResult
   | InvalidCaptcha
   | InvalidLimit
   | InvalidOffset

export type GetOpenSearchTdrAccountsResult = {
   __typename?: 'GetOpenSearchTDRAccountsResult'
   tdrAccounts: Array<OpenSearchTdrAccount>
   totalCount: Scalars['Int']
}

export type GetOrdersOnPipelineItemInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetOrdersOnPipelineItemInPortalResponse =
   | GetOrdersOnPipelineItemInPortalResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetOrdersOnPipelineItemInPortalResult = {
   __typename?: 'GetOrdersOnPipelineItemInPortalResult'
   orders: Array<Order>
   totalCount: Scalars['Int']
}

export type GetOrdersOnPipelineItemParams = {
   filterEnum?: InputMaybe<OrdersOnPipelineItemFilter>
   pipelineItemId: Scalars['String']
}

export type GetOrdersOnPipelineItemResponse =
   | GetOrdersOnPipelineItemResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetOrdersOnPipelineItemResult = {
   __typename?: 'GetOrdersOnPipelineItemResult'
   orders: Array<Order>
   overdueOrdersCount: Scalars['Int']
   totalCount: Scalars['Int']
}

export type GetPmuActionLogDetailParams = {
   pmuActionLogId: Scalars['ID']
}

export type GetPmuActionLogDetailResponse =
   | ApplicationNotFound
   | AuthorityMismatch
   | PmuActionLogDetailType

export type GetPmuActionLogsPaginationParams = {
   limit: Scalars['Int']
   offset: Scalars['Int']
}

export type GetPmuActionLogsParams = {
   actionType?: InputMaybe<PmuActionType>
   applicationId?: InputMaybe<Scalars['String']>
   initiatorUserId?: InputMaybe<Scalars['String']>
   pagination: GetPmuActionLogsPaginationParams
   status?: InputMaybe<PmuActionLogStatus>
}

export type GetPmuActionLogsResponse =
   | ApplicationManagementAccessDenied
   | AuthorityMismatch
   | GetPmuActionLogsResult
   | InvalidLimit
   | InvalidOffset

export type GetPmuActionLogsResult = {
   __typename?: 'GetPMUActionLogsResult'
   actionLogs: Array<PmuActionLogType>
   totalCount: Scalars['Int']
}

export type GetParametersParams = {
   parameterIds: Array<Scalars['String']>
}

export type GetParametersResponse =
   | GetParametersResult
   | MultipleAccountsParameters
   | UserIsNotAnAdministrator

export type GetParametersResult = {
   __typename?: 'GetParametersResult'
   parameters: Array<ParameterResult>
}

export type GetPaymentParams = {
   paymentId: Scalars['String']
}

export type GetPaymentRequestsParams = {
   paymentRequestIds: Array<Scalars['String']>
}

export type GetPaymentRequestsResponse =
   | GetPaymentRequestsResult
   | PaymentRequestsNotFound

export type GetPaymentRequestsResult = {
   __typename?: 'GetPaymentRequestsResult'
   paymentRequests: Array<PipelineItemPaymentRequest>
}

export type GetPaymentResponse = Payment | PaymentAccessDenied | PaymentNotFound

export type GetPaymentTransactionsOnPipelineItemInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetPaymentTransactionsOnPipelineItemInPortalResponse =
   | GetPaymentTransactionsOnPipelineItemInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetPaymentTransactionsOnPipelineItemInPortalResult = {
   __typename?: 'GetPaymentTransactionsOnPipelineItemInPortalResult'
   payments: Array<PaymentTransaction>
   paymentsVerificationRemarks: PaymentsVerificationRemarks
   transactions: Array<PaymentTransactionHistory>
}

export type GetPendingTaskApplicationsResponse = GetPendingTaskApplicationsResult

export type GetPendingTaskApplicationsResult = {
   __typename?: 'GetPendingTaskApplicationsResult'
   taskApplications: Array<TaskApplicationDetails>
}

export type GetPendingTaskOnPipelineItemParams = {
   pipelineItemId: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type GetPendingTaskOnPipelineItemResponse =
   | NotPipelineItemTaskTemplate
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | Task
   | TaskTemplateAccessDenied
   | TaskTemplateIsDisabled
   | TaskTemplateNotFound

export type GetPendingTasksApplicationsParams = {
   date: Scalars['String']
}

export type GetPermittedStagesParams = {
   fromStageId: Scalars['String']
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetPieChartParams = {
   graphId: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
}

export type GetPinnedPipelineItemIdsInViewParams = {
   customFilters: Array<CustomFilter>
   pagination: Pagination
   pinnedByUserId: Scalars['String']
   viewId: Scalars['String']
}

export type GetPinnedPipelineItemsCountForUserParams = {
   pipelineItemTypes: Array<PipelineItemType>
}

export type GetPinnedPipelineItemsForUserParams = {
   pagination: Pagination
   pipelineItemTypes: Array<PipelineItemType>
}

export type GetPinnedPipelineItemsForUserResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PinnedPipelineItemsResult

export type GetPipelineApplicationsInPortalResponse =
   | GetPipelineApplicationsInPortalResult
   | InvalidLimit
   | InvalidOffset
   | NotApplicationPipeline
   | PaginationLimitExceeded
   | PipelineNotFound
   | PipelineNotInPortal
   | PortalNotFound

export type GetPipelineApplicationsInPortalResult = {
   __typename?: 'GetPipelineApplicationsInPortalResult'
   items: Array<PortalApplicationProperties>
   totalCount: Scalars['Int']
}

export type GetPipelineApplicationsPropertiesInPortalParams = {
   filters?: InputMaybe<Array<InputMaybe<PortalApplicationFilterParams>>>
   pagination: Pagination
   pipelineId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   searchQuery?: InputMaybe<Scalars['String']>
   sortBy?: InputMaybe<ApplicationSortParams>
}

export type GetPipelineCustomObjectAddAnotherFieldsParams = {
   customObjectId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofResponseIds: Array<Scalars['String']>
}

export type GetPipelineCustomObjectAddAnotherFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | GetPipelineCustomObjectAddAnotherGoFsFieldsResult
   | GoFResponseIdsNotFound
   | NotAddAnotherFields
   | NotCustomObjectAddAnotherGoFResponsesBulk
   | NotPermittedFields
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound

export type GetPipelineCustomObjectAddAnotherGoFsFieldsParams = {
   customObjectId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
}

export type GetPipelineCustomObjectAddAnotherGoFsFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | GetPipelineCustomObjectAddAnotherGoFsFieldsResult
   | GoFsAreDeleted
   | GoFsNotFound
   | NotAddAnotherGoFs
   | NotPermittedFields
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound

export type GetPipelineCustomObjectAddAnotherGoFsFieldsResult = {
   __typename?: 'GetPipelineCustomObjectAddAnotherGoFsFieldsResult'
   gofResponses: Array<AddAnotherGoFResult>
   pipelineCustomObjectId: Scalars['String']
}

export type GetPipelineCustomObjectFieldsParams = {
   fieldIds: Array<Scalars['String']>
   pipelineCustomObjectId: Scalars['String']
}

export type GetPipelineCustomObjectFieldsResponse =
   | GetPipelineCustomObjectFieldsResult
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound

export type GetPipelineCustomObjectFieldsResult = {
   __typename?: 'GetPipelineCustomObjectFieldsResult'
   fields: Array<PipelineCustomObjectFieldResult>
}

export type GetPipelineCustomObjectProfileParams = {
   pipelineCustomObjectId: Scalars['String']
}

export type GetPipelineCustomObjectProfileResponse =
   | PipelineCustomObject
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound

export type GetPipelineCustomObjectsSystemFieldsParams = {
   pipelineCustomObjectIds: Array<Scalars['String']>
   systemFieldEnums: Array<CustomObjectSystemFieldEnum>
}

export type GetPipelineDocumentTemplatesParams = {
   pagination: Pagination
   pipelineId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetPipelineDocumentTemplatesResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineDocumentTemplatesResult
   | PipelineNotFound

export type GetPipelineEventBasedLeadDistributionRuleExecLogsResponse =
   | GetPipelineEventBasedLeadDistributionRuleExecLogsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetPipelineEventBasedLeadDistributionRuleExecLogsResult = {
   __typename?: 'GetPipelineEventBasedLeadDistributionRuleExecLogsResult'
   execLogs: Array<EventBasedLeadDistributionRuleExecLog>
   totalCount: Scalars['Int']
}

export type GetPipelineEventFieldsParams = {
   fieldIds: Array<Scalars['String']>
   pipelineEventId: Scalars['String']
}

export type GetPipelineEventFieldsResponse =
   | GetPipelineEventFieldsResult
   | PipelineEventAccessDenied
   | PipelineEventNotFound

export type GetPipelineEventFieldsResult = {
   __typename?: 'GetPipelineEventFieldsResult'
   fields: Array<PipelineEventFieldResult>
}

export type GetPipelineFeeRuleSetsParams = {
   pipelineId: Scalars['String']
}

export type GetPipelineFeeRuleSetsResponse =
   | GetPipelineFeeRuleSetsResult
   | LayoutConfigDoesNotExistForEntity
   | PipelineAccessDenied
   | PipelineNotFound

export type GetPipelineFeeRuleSetsResult = {
   __typename?: 'GetPipelineFeeRuleSetsResult'
   feeRuleSets: Array<FeeRuleSet>
}

export type GetPipelineIdentificationsParams = {
   identificationTypes: Array<IdentificationType>
   pagination?: InputMaybe<Pagination>
   pipelineId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetPipelineInPortalParams = {
   applicationPipelineId: Scalars['String']
   portalId: Scalars['String']
}

export type GetPipelineInPortalResponse =
   | NotApplicationPipeline
   | PipelineNotFound
   | PipelineNotInPortal
   | PortalAccessDenied
   | PortalIsDeleted
   | PortalNotFound
   | PortalPipeline

export type GetPipelineItemActivitiesParams = {
   activityTemplateIds?: InputMaybe<Array<Scalars['String']>>
   pagination: Pagination
   pipelineItemId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type GetPipelineItemAppealTasksParams = {
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemAppealTasksResponse =
   | ActiveAppealDoesNotExistsForPipelineItem
   | AppealDoesNotExistsForPipelineItem
   | PipelineItemAccessDenied
   | PipelineItemAppealTasks
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemAssigneeUpdateHierarchyParams = {
   assigneeFieldId: Scalars['String']
   assigneeUserId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemAssigneeUpdateHierarchyResponse =
   | AssigneeIsDeactivated
   | AssigneeNotFound
   | FieldIsDeleted
   | FieldNotFound
   | GetPipelineItemAssigneeUpdateHierarchyResult
   | NotPipelineItemAssigneeField
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemAssigneeUpdateHierarchyResult = {
   __typename?: 'GetPipelineItemAssigneeUpdateHierarchyResult'
   canSyncHierarchy: Scalars['Boolean']
   pipelineItemId: Scalars['String']
   updatedHierarchy: Array<PipelineItemAssignee>
}

export type GetPipelineItemBannerMessageParams = {
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemBannerMessageResponse = GetPipelineItemBannerMessageResult

export type GetPipelineItemBannerMessageResult = {
   __typename?: 'GetPipelineItemBannerMessageResult'
   bannerMessage?: Maybe<Scalars['String']>
}

export type GetPipelineItemCallLogsParams = {
   pagination: Pagination
   pipelineIds?: InputMaybe<Array<Scalars['String']>>
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemCallLogsResponse =
   | GetPipelineItemCallLogsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemCallLogsResult = {
   __typename?: 'GetPipelineItemCallLogsResult'
   callLogs: Array<CallLog>
   totalCount: Scalars['Int']
}

export type GetPipelineItemCompletionPercentageInPortalParams = {
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type GetPipelineItemCompletionPercentageInPortalResponse =
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineItemTypeNotSupported
   | PortalNotFound
   | PortalPipelineItemCompletionPercentageResult

export type GetPipelineItemConsentPhoneNumbersParams = {
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemConsentPhoneNumbersResponse =
   | GetPipelineItemConsentPhoneNumbersResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemConsentPhoneNumbersResult = {
   __typename?: 'GetPipelineItemConsentPhoneNumbersResult'
   consentPhoneNumbers: Array<ConsentPhoneNumberWithField>
}

export type GetPipelineItemCurrentStageSlaFieldInPipelineParams = {
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemDocumentTemplatesParams = {
   pagination: Pagination
   pipelineItemId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetPipelineItemDocumentTemplatesResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemDocumentTemplatesResult
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemDocumentsForDocumentTemplateParams = {
   documentTemplateId: Scalars['String']
   pagination?: InputMaybe<Pagination>
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemDocumentsForDocumentTemplateResponse =
   | DocumentTemplateIsDeleted
   | DocumentTemplateNotFound
   | GetPipelineItemDocumentsForDocumentTemplateResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemDocumentsForDocumentTemplateResult = {
   __typename?: 'GetPipelineItemDocumentsForDocumentTemplateResult'
   documents: Array<Document>
   totalCount: Scalars['Int']
}

export type GetPipelineItemFieldLogsInPortalParams = {
   fieldIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   gofResponseId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   userTypesFilter?: InputMaybe<Array<InputMaybe<UserType>>>
}

export type GetPipelineItemFieldLogsInPortalResponse =
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | GetPipelineItemFieldLogsInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PortalNotFound

export type GetPipelineItemFieldLogsInPortalResult = {
   __typename?: 'GetPipelineItemFieldLogsInPortalResult'
   fieldLogs: Array<PipelineItemFieldLogInPortal>
}

export type GetPipelineItemFieldLogsResponse =
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | GetPipelineItemFieldsLogsResult
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetPipelineItemFieldPermissionsParams = {
   pipelineItemId: Scalars['String']
   salesTemplateIds: Array<Scalars['String']>
}

export type GetPipelineItemFieldShortfallLogsInPortalParams = {
   fieldId: Scalars['String']
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetPipelineItemFieldShortfallLogsParams = {
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemFieldsInTaskDraftParams = {
   taskId: Scalars['String']
}

export type GetPipelineItemFieldsInTaskDraftResponse =
   | FieldResponseDraftResult
   | TaskAccessDenied
   | TaskNotFound

export type GetPipelineItemFieldsLogCountInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   userTypesFilter?: InputMaybe<Array<InputMaybe<UserType>>>
}

export type GetPipelineItemFieldsLogCountInPortalResponse =
   | GetPipelineItemFieldsLogCountInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PortalNotFound

export type GetPipelineItemFieldsLogCountInPortalResult = {
   __typename?: 'GetPipelineItemFieldsLogCountInPortalResult'
   fieldsLogCount: Array<PipelineItemFieldsLogCountInPortal>
}

export type GetPipelineItemFieldsLogCountParams = {
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemFieldsLogCountResponse =
   | GetPipelineItemFieldsLogCountResult
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | StageNotFound

export type GetPipelineItemFieldsLogCountResult = {
   __typename?: 'GetPipelineItemFieldsLogCountResult'
   fieldsLogCount?: Maybe<Array<Maybe<PipelineItemFieldsLogCount>>>
}

export type GetPipelineItemFieldsLogParams = {
   fieldIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   gofResponseId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemFieldsLogsResult = {
   __typename?: 'GetPipelineItemFieldsLogsResult'
   fieldLogs?: Maybe<Array<Maybe<PipelineItemFieldLog>>>
}

export type GetPipelineItemFieldsToLogParams = {
   stageId: Scalars['String']
}

export type GetPipelineItemFieldsToLogResponse =
   | GetPipelineItemFieldsToLogResult
   | StageNotFound

export type GetPipelineItemFieldsToLogResult = {
   __typename?: 'GetPipelineItemFieldsToLogResult'
   fields?: Maybe<Array<Maybe<PipelineItemFieldToLog>>>
}

export type GetPipelineItemGeneratedRemarksParams = {
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemGeneratedRemarksResponse =
   | PipelineItemAccessDenied
   | PipelineItemGeneratedRemarks
   | PipelineItemNotFound
   | PipelineNotFound

export type GetPipelineItemHistoryParams = {
   activityTemplateIds?: InputMaybe<Array<Scalars['String']>>
   dateTimeRange?: InputMaybe<DateTimeRangeParams>
   filterSystemEvents?: InputMaybe<Scalars['Boolean']>
   pagination: Pagination
   pipelineItemHistoryEventTypes?: InputMaybe<
      Array<InputMaybe<PipelineItemHistoryEventType>>
   >
   pipelineItemId: Scalars['String']
   taskCallStatuses?: InputMaybe<Array<CallStatusFieldOptions>>
   taskTemplateIds?: InputMaybe<Array<Scalars['String']>>
}

export type GetPipelineItemHistoryResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemHistoryResult
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemLatestTasksParams = {
   excludeTaskTemplateIds?: InputMaybe<Array<Scalars['String']>>
   pagination: Pagination
   pipelineItemId: Scalars['String']
   taskStatuses?: InputMaybe<Array<TaskStatus>>
   taskTemplateIds?: InputMaybe<Array<Scalars['String']>>
   userTasksFilter?: InputMaybe<UserTasksFilter>
}

export type GetPipelineItemLayoutTabsVisibilityStatusParams = {
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemLayoutTabsVisibilityStatusResponse =
   | GetPipelineItemLayoutTabsVisibilityStatusResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemLayoutTabsVisibilityStatusResult = {
   __typename?: 'GetPipelineItemLayoutTabsVisibilityStatusResult'
   tabs: Array<LayoutTabVisibilityStatus>
}

export type GetPipelineItemMergeInProgressStatusParams = {
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemMergeInProgressStatusResponse =
   | GetPipelineItemMergeInProgressStatusResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemMergeInProgressStatusResult = {
   __typename?: 'GetPipelineItemMergeInProgressStatusResult'
   isMergeInProgress: Scalars['Boolean']
}

export type GetPipelineItemMessageTemplatesParams = {
   pagination: Pagination
   pipelineItemId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetPipelineItemMessageTemplatesResponse =
   | GetPipelineItemMessageTemplatesResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemMessageTemplatesResult = {
   __typename?: 'GetPipelineItemMessageTemplatesResult'
   messageTemplates: Array<PipelineItemMessageTemplate>
   totalCount: Scalars['Int']
}

export type GetPipelineItemNoteSheetPermissionsParams = {
   pipelineItemId: Scalars['String']
   stageId: Scalars['String']
}

export type GetPipelineItemNoteSheetPermissionsResponse =
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineItemNoteSheetPermissionsResult

export type GetPipelineItemOrdersAndPaymentsParams = {
   fileNumber: Scalars['String']
}

export type GetPipelineItemOrdersAndPaymentsResponse =
   | FileNumberNotFound
   | PipelineItemOrdersAndPaymentsType

export type GetPipelineItemPaymentRuleSetParams = {
   paymentRequestId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   ruleSetId: Scalars['String']
}

export type GetPipelineItemPaymentRuleSetResponse =
   | GetPipelineItemPaymentRuleSetResult
   | PaymentRequestNotFound
   | PaymentRuleSetNotFound
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemPaymentRulesWereNotSatisfied

export type GetPipelineItemPaymentRuleSetResult = {
   __typename?: 'GetPipelineItemPaymentRuleSetResult'
   pipelineItemId: Scalars['String']
   ruleSet: PipelineItemPaymentRuleSet
}

export type GetPipelineItemPaymentRulesParams = {
   pipelineItemId: Scalars['String']
   ruleIds: Array<Scalars['String']>
   ruleSetId?: InputMaybe<Scalars['String']>
}

export type GetPipelineItemPaymentRulesResponse =
   | GetPipelineItemPaymentRulesResult
   | PaymentRuleSetNotFound
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetPipelineItemPaymentRulesResult = {
   __typename?: 'GetPipelineItemPaymentRulesResult'
   pipelineItemId: Scalars['String']
   rules: Array<PipelineItemPaymentRule>
}

export type GetPipelineItemPaymentsParams = {
   pagination: Pagination
   pipelineItemId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetPipelineItemPaymentsResponse =
   | GetPipelineItemPaymentsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetPipelineItemPaymentsResult = {
   __typename?: 'GetPipelineItemPaymentsResult'
   payments: Array<PipelineItemPaymentRequest>
   pipelineItemId: Scalars['String']
   totalCount: Scalars['Int']
}

export type GetPipelineItemPermittedStagesParams = {
   fromStageId: Scalars['String']
   pagination: Pagination
   pipelineItemId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetPipelineItemRecommendedTaskTemplatesParams = {
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemRecommendedTaskTemplatesResponse =
   | GetPipelineItemRecommendedTaskTemplatesResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemRecommendedTaskTemplatesResult = {
   __typename?: 'GetPipelineItemRecommendedTaskTemplatesResult'
   pipelineItemId: Scalars['String']
   taskTemplates: Array<BaseTaskTemplate>
}

export type GetPipelineItemRemarksAttachmentsInTaskDraftParams = {
   attachmentIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type GetPipelineItemRemarksAttachmentsInTaskDraftResponse =
   | RemarkAttachments
   | TaskAccessDenied
   | TaskNotFound

export type GetPipelineItemRemarksInTaskDraftParams = {
   taskId: Scalars['String']
}

export type GetPipelineItemRemarksInTaskDraftResponse =
   | PipelineItemRemarksDraft
   | TaskAccessDenied
   | TaskNotFound

export type GetPipelineItemRemarksParams = {
   pagination: Pagination
   pipelineIds?: InputMaybe<Array<Scalars['String']>>
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemRemarksResponse =
   | GetPipelineItemRemarksResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemRemarksResult = {
   __typename?: 'GetPipelineItemRemarksResult'
   draftedRemarks: PipelineItemRemarks
   remarks: Array<PipelineItemRemarks>
   totalCount: Scalars['Int']
}

export type GetPipelineItemRemindersForUserParams = {
   pagination: Pagination
   pipelineItemTypes: Array<PipelineItemType>
   remindersDate?: InputMaybe<Scalars['String']>
}

export type GetPipelineItemRemindersForUserResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemRemindersResult

export type GetPipelineItemResourcesParams = {
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemSlaFieldsParams = {
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemShortfallFieldsInPortalParams = {
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type GetPipelineItemShortfallFieldsInPortalResponse =
   | GetPipelineItemShortfallFieldsInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PortalNotFound

export type GetPipelineItemShortfallFieldsInPortalResult = {
   __typename?: 'GetPipelineItemShortfallFieldsInPortalResult'
   fields: Array<ShortfallFieldDetails>
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemShortfallFieldsParams = {
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemShortfallFieldsResponse =
   | GetPipelineItemShortfallFieldsResult
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetPipelineItemShortfallFieldsResult = {
   __typename?: 'GetPipelineItemShortfallFieldsResult'
   fields: Array<ShortfallFieldDetails>
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemShortfallLogFieldsInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetPipelineItemShortfallLogFieldsInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GetPipelineItemShortfallLogFieldsInPortalResult
   | PortalNotFound

export type GetPipelineItemShortfallLogFieldsInPortalResult = {
   __typename?: 'GetPipelineItemShortfallLogFieldsInPortalResult'
   fieldIds: Array<Scalars['String']>
}

export type GetPipelineItemShortfallLogFieldsParams = {
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemShortfallLogFieldsResponse =
   | GetPipelineItemShortfallLogFieldsResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemShortfallLogFieldsResult = {
   __typename?: 'GetPipelineItemShortfallLogFieldsResult'
   fieldIds: Array<Scalars['String']>
   fields: Array<PipelineItemShortfallLogField>
}

export type GetPipelineItemShortfallLogsInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetPipelineItemShortfallLogsParams = {
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemStagePermissionsParams = {
   pipelineItemId: Scalars['String']
   stageId: Scalars['String']
}

export type GetPipelineItemStagePermissionsResponse =
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemStagePermissions
   | StageNotFound

export type GetPipelineItemStageTransitionMandatoryEntitiesStatusBulkParams = {
   pipelineItemId: Scalars['String']
   stageTransitionIds: Array<Scalars['String']>
}

export type GetPipelineItemStageTransitionMandatoryEntitiesStatusParams = {
   pipelineItemId: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type GetPipelineItemStageTransitionMandatoryEntitiesStatusResponse =
   | InvalidStageTransitionForPipelineItem
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemStageTransitionMandatoryEntitiesStatusResult
   | StageTransitionNotFound

export type GetPipelineItemStageTransitionMandatoryTasksStatusBulkParams = {
   pipelineItemId: Scalars['String']
   stageTransitionIds: Array<Scalars['String']>
}

export type GetPipelineItemStageTransitionMandatoryTasksStatusBulkResponse =
   | InvalidStageTransitionsForPipelineItem
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemStageTransitionMandatoryTasksStatusBulkResult
   | StageTransitionsNotFound

export type GetPipelineItemStageTransitionMandatoryTasksStatusParams = {
   pipelineItemId: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type GetPipelineItemStageTransitionMandatoryTasksStatusResponse =
   | InvalidStageTransitionForPipelineItem
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemStageTransitionMandatoryTasksStatusResult
   | StageTransitionNotFound

export type GetPipelineItemStageTransitionOverallObservationParams = {
   pipelineItemId: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type GetPipelineItemStageTransitionOverallObservationResponse =
   | InvalidStageTransitionForPipelineItem
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemStageTransitionOverallObservationResult
   | StageTransitionNotFound

export type GetPipelineItemStageTransitionsParams = {
   fromStageId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemStageTransitionsResponse =
   | FromStageNotFound
   | GetPipelineItemStageTransitionsResult
   | PipelineAccessDenied
   | PipelineItemAccessDenied
   | PipelineItemNotFound

export type GetPipelineItemStageTransitionsResult = {
   __typename?: 'GetPipelineItemStageTransitionsResult'
   disabledStageTransitions: Array<StageTransitionMandatoryEntitiesStatus>
   feeCreatedBy?: Maybe<Scalars['String']>
   feeNotCreatedTransitionIds: Array<Scalars['String']>
   fromStageId: Scalars['String']
   isDraftNotesPresent: Scalars['Boolean']
   isEntityFeeRuleSetPresent: Scalars['Boolean']
   pipelineItemId: Scalars['String']
   tabErrorFields: Array<TabErrorFields>
   tabUnVerifiedPhoneNumberFields: Array<TabUnVerifiedPhoneNumberFields>
   tabUnfilledRequiredFields: Array<TabUnfilledRequiredFields>
   transitions: Array<StageTransitionMandatoryEntitiesStatus>
   unsignedDocuments: Array<Document>
}

export type GetPipelineItemSubmissionGroupsParams = {
   pipelineItemId: Scalars['String']
}

export type GetPipelineItemSubmissionGroupsResponse =
   | GetPipelineItemSubmissionGroupsResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemSubmissionGroupsResult = {
   __typename?: 'GetPipelineItemSubmissionGroupsResult'
   submissionGroups: Array<PipelineItemSubmissionGroup>
}

export type GetPipelineItemTabsDetailsParams = {
   pipelineItemId: Scalars['String']
   tabIds: Array<Scalars['String']>
}

export type GetPipelineItemTabsDetailsResponse =
   | GetPipelineItemTabsDetailsResult
   | LayoutTabsNotFound
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemTabsDetailsResult = {
   __typename?: 'GetPipelineItemTabsDetailsResult'
   tabs: Array<Tab>
}

export type GetPipelineItemTasksParams = {
   excludeTaskTemplateIds?: InputMaybe<Array<Scalars['String']>>
   pagination: Pagination
   pipelineItemId: Scalars['String']
   taskStatus?: InputMaybe<TaskStatus>
   taskTemplateIds?: InputMaybe<Array<Scalars['String']>>
   userTasksFilter?: InputMaybe<UserTasksFilter>
}

export type GetPipelineItemTasksResponse =
   | GetPipelineItemTasksResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type GetPipelineItemTasksResult = {
   __typename?: 'GetPipelineItemTasksResult'
   tasks: Array<Task>
   totalCount: Scalars['Int']
}

export type GetPipelineItemTemplateAdminsBulkParams = {
   pipelineItemTemplateIds: Array<Scalars['String']>
}

export type GetPipelineItemTemplateAdminsBulkResponse =
   | GetPipelineItemTemplateAdminsBulkResult
   | PipelineItemTemplatesNotFound
   | UserIsNotAnAdministrator

export type GetPipelineItemTemplateAdminsBulkResult = {
   __typename?: 'GetPipelineItemTemplateAdminsBulkResult'
   templateWiseAdmins: Array<PipelineItemTemplateAdmins>
}

export type GetPipelineItemTemplateFieldsToLogParams = {
   pipelineItemTemplateId: Scalars['String']
}

export type GetPipelineItemTemplateFieldsToLogResponse =
   | GetPipelineItemTemplateFieldsToLogResult
   | PipelineItemTemplateNotFound
   | UserIsNotAnAdministrator

export type GetPipelineItemTemplateFieldsToLogResult = {
   __typename?: 'GetPipelineItemTemplateFieldsToLogResult'
   fields?: Maybe<Array<Maybe<PipelineItemTemplateFieldsToLog>>>
}

export type GetPipelineItemTemplateIdentificationsParams = {
   pagination: Pagination
   pipelineItemTemplateId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetPipelineItemTemplateIdentificationsResponse =
   | GetPipelineItemTemplateIdentificationsResult
   | InvalidLimit
   | InvalidOffset
   | PipelineItemTemplateNotFound
   | UserIsNotAnAdministrator

export type GetPipelineItemTemplateIdentificationsResult = {
   __typename?: 'GetPipelineItemTemplateIdentificationsResult'
   identifications: Array<IdentificationOverviewDetails>
   totalCount: Scalars['Int']
}

export type GetPipelineItemTemplatesParams = {
   pagination: Pagination
   recordType: RecordType
}

export type GetPipelineItemTemplatesResponse =
   | GetPipelineItemTemplatesResult
   | InvalidLimit
   | InvalidOffset
   | UserIsNotAnAdministrator

export type GetPipelineItemTemplatesResult = {
   __typename?: 'GetPipelineItemTemplatesResult'
   pipelineItemTemplates: Array<BasePipelineItemTemplate>
   totalCount: Scalars['Int']
}

export type GetPipelineItemVerificationsParams = {
   pipelineItemId: Scalars['String']
   tabId: Scalars['String']
}

export type GetPipelineItemVerificationsResponse =
   | GetPipelineItemVerificationsResult
   | LayoutTabNotFound
   | NotRequestVerificationTab
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TabNotInPipelineItemTemplate

export type GetPipelineItemVerificationsResult = {
   __typename?: 'GetPipelineItemVerificationsResult'
   verifications: Array<PipelineItemVerification>
}

export type GetPipelineItemVrVisibleEntitiesParams = {
   pipelineItemId: Scalars['String']
   ruleIds: Array<Scalars['String']>
}

export type GetPipelineItemVrVisibleEntitiesResponse =
   | GetPipelineItemVrVisibleEntitiesResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | VisibilityRulesNotFound
   | VisibilityRulesNotLinkedToApplicationTemplate

export type GetPipelineItemVrVisibleEntitiesResult = {
   __typename?: 'GetPipelineItemVrVisibleEntitiesResult'
   visibilities: Array<VrEntityVisibility>
}

export type GetPipelineManualLeadDistributionRuleExecLogsParams = {
   pagination: Pagination
   pipelineId: Scalars['String']
}

export type GetPipelineManualLeadDistributionRuleExecLogsResponse =
   | GetPipelineManualLeadDistributionRuleExecLogsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetPipelineManualLeadDistributionRuleExecLogsResult = {
   __typename?: 'GetPipelineManualLeadDistributionRuleExecLogsResult'
   execLogs: Array<ManualLeadDistributionRuleExecLog>
   totalCount: Scalars['Int']
}

export type GetPipelineResourcesParams = {
   pagination?: InputMaybe<Pagination>
   pipelineId: Scalars['String']
}

export type GetPipelineScheduledLeadDistributionRuleExecLogsParams = {
   pagination: Pagination
   pipelineId: Scalars['String']
}

export type GetPipelineScheduledLeadDistributionRuleExecLogsResponse =
   | GetPipelineScheduledLeadDistributionRuleExecLogsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetPipelineScheduledLeadDistributionRuleExecLogsResult = {
   __typename?: 'GetPipelineScheduledLeadDistributionRuleExecLogsResult'
   execLogs: Array<ScheduledLeadDistributionRuleExecLog>
   totalCount: Scalars['Int']
}

export type GetPipelineSettingsBulkParams = {
   pipelineIds: Array<Scalars['String']>
}

export type GetPipelineSettingsBulkResult =
   | PipelineNotFound
   | PipelineSettings
   | UserIsNotAnAdministrator

export type GetPipelineTemplatesSystemFieldsParams = {
   activityTemplateIds: Array<Scalars['String']>
   pipelineItemTemplateIds: Array<Scalars['String']>
   systemFieldEnums: Array<SystemFieldEnum>
   taskTemplateIds: Array<Scalars['String']>
}

export type GetPipelineTemplatesSystemFieldsResponse =
   | GetPipelineTemplatesSystemFieldsResult
   | SalesTemplatesAccessDenied
   | SalesTemplatesNotFound

export type GetPipelineTemplatesSystemFieldsResult = {
   __typename?: 'GetPipelineTemplatesSystemFieldsResult'
   pipelineSystemFields: Array<PipelineSystemFields>
}

export type GetPipelineWhatsAppBusinessPhoneNumbersParams = {
   pagination?: InputMaybe<Pagination>
   pipelineId: Scalars['String']
}

export type GetPipelineWhatsAppBusinessPhoneNumbersResponse =
   | GetPipelineWhatsAppBusinessPhoneNumbersResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetPipelineWhatsAppBusinessPhoneNumbersResult = {
   __typename?: 'GetPipelineWhatsAppBusinessPhoneNumbersResult'
   pipelineId: Scalars['String']
   totalCount?: Maybe<Scalars['Int']>
   whatsappBusinessPhoneNumbers: Array<
      BaseWhatsAppBusinessNumberWithPluginServiceAccount
   >
}

export type GetPipelineWhatsappMessageTemplatesParams = {
   pagination: Pagination
   pipelineId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetPipelineWhatsappMessageTemplatesResponse =
   | GetPipelineWhatsappMessageTemplatesResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineNotFound

export type GetPipelineWhatsappMessageTemplatesResult = {
   __typename?: 'GetPipelineWhatsappMessageTemplatesResult'
   messageTemplates: Array<PipelineItemMessageTemplate>
   totalCount: Scalars['Int']
}

export type GetPipelinesAutomationWorkflowsParams = {
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
   triggerEntity?: InputMaybe<TriggerEntity>
   triggerEventType?: InputMaybe<TriggerEventType>
   triggerType?: InputMaybe<TriggerType>
   workflowState: AutomationWorkflowStateEnum
}

export type GetPipelinesForPipelineItemTemplateParams = {
   pipelineItemTemplateIds: Array<Scalars['String']>
}

export type GetPipelinesForPipelineItemTemplateResponse =
   | GetPipelinesForPipelineItemTemplateResult
   | PipelineItemTemplatesNotFound

export type GetPipelinesForPipelineItemTemplateResult = {
   __typename?: 'GetPipelinesForPipelineItemTemplateResult'
   pipelines: Array<BasePipeline>
}

export type GetPipelinesForPipelineItemsParams = {
   pipelineItemIds: Array<Scalars['String']>
}

export type GetPipelinesForPipelineItemsResponse =
   | PipelineItemsAccessDenied
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | PipelinesForPipelineItemsResult

export type GetPipelinesInPortalParams = {
   portalId: Scalars['String']
}

export type GetPipelinesLayoutParams = {
   pipelineIds: Array<Scalars['String']>
}

export type GetPipelinesLayoutResponse =
   | GetPipelinesLayoutResult
   | PipelinesAccessDenied
   | PipelinesNotFound

export type GetPipelinesLayoutResult = {
   __typename?: 'GetPipelinesLayoutResult'
   layouts: Array<Layout>
}

export type GetPipelinesParams = {
   pipelineIds: Array<Scalars['String']>
}

export type GetPipelinesResult =
   | BasePipeline
   | PipelineAccessDenied
   | PipelineNotFound

export type GetPivotTableParams = {
   columnIds?: InputMaybe<Array<Scalars['String']>>
   graphId: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
   rowPagination?: InputMaybe<Pagination>
   searchAfter?: InputMaybe<PivotTableSearchAfterParams>
   sortValues?: InputMaybe<TableSort>
}

export type GetPluginServiceAccountCallLogsParams = {
   agentPhoneNumber?: InputMaybe<PhoneNumberParams>
   callLogId?: InputMaybe<Scalars['String']>
   cliNumber?: InputMaybe<PhoneNumberParams>
   customerPhoneNumber?: InputMaybe<PhoneNumberParams>
   pagination: Pagination
   pluginServiceAccountId: Scalars['String']
   receivedAt?: InputMaybe<DateTimeRangeParams>
   status?: InputMaybe<CallLogStatus>
}

export type GetPluginServiceAccountCallLogsResponse =
   | GetPluginServiceAccountCallLogsResult
   | InvalidDateTimeRange
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator

export type GetPluginServiceAccountCallLogsResult = {
   __typename?: 'GetPluginServiceAccountCallLogsResult'
   callLogs: Array<CloudCallingLog>
   totalCount: Scalars['Int']
}

export type GetPluginServiceAccountWhatsappMessageTemplatesSyncStatusParams = {
   pluginServiceAccountId: Scalars['String']
}

export type GetPluginServiceAccountWhatsappMessageTemplatesSyncStatusResponse =
   | AccountPluginIsDisabled
   | NotAWhatsAppPluginServiceAccount
   | PluginServiceAccountIsNotActive
   | PluginServiceAccountWhatsappMessageTemplatesSyncStatus
   | UserIsNotAnAdministrator
   | WatiPluginServiceAccountNotFound

export type GetPluginsResult = Plugins | UserIsNotAnAdministrator

export type GetPortalApplicationConfigBulkParams = {
   portalApplicationIds: Array<Scalars['String']>
}

export type GetPortalApplicationConfigBulkResponse =
   | PortalApplicationConfigBulkResult
   | PortalApplicationIdsNotFound
   | UserIsNotAnAdministrator

export type GetPortalApplicationsParams = {
   portalApplicationIds: Array<Scalars['String']>
}

export type GetPortalApplicationsResponse =
   | PortalApplicationIdsNotFound
   | PortalApplicationsResult
   | UserIsNotAnAdministrator

export type GetPortalUnifiedApplicationCreationConfigParams = {
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetPortalUnifiedApplicationCreationConfigResponse =
   | GetPortalUnifiedApplicationCreationConfigResult
   | PortalNotFound

export type GetPortalUnifiedApplicationCreationConfigResult = {
   __typename?: 'GetPortalUnifiedApplicationCreationConfigResult'
   config?: Maybe<Scalars['String']>
}

export type GetPortalsInAccountParams = {
   pagination: Pagination
}

export type GetPortalsInAccountResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PortalsInAccountResult
   | UserIsNotAnAdministrator

export type GetPortalsParams = {
   portalIds: Array<Scalars['String']>
}

export type GetPortalsResponse =
   | PortalIdsNotFound
   | PortalsResult
   | UserIsNotAnAdministrator

export type GetPreSignedGetUrlForApplicationDocumentInPortalParams = {
   applicationId: Scalars['String']
   contentDispositionType: ContentDisposition
   documentId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetPreSignedGetUrlForApplicationDocumentInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | DocumentNotFound
   | GetPreSignedGetUrlForApplicationDocumentInPortalResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PortalNotFound

export type GetPreSignedGetUrlForApplicationDocumentInPortalResult = {
   __typename?: 'GetPreSignedGetUrlForApplicationDocumentInPortalResult'
   applicationId: Scalars['String']
   documentId: Scalars['String']
   portalId: Scalars['String']
   preSignedUrl: Scalars['String']
}

export type GetPreSignedGetUrlForApplicationFieldInPortalParams = {
   applicationId: Scalars['String']
   contentDispositionType: ContentDisposition
   fieldId: Scalars['String']
   fileId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type GetPreSignedGetUrlForApplicationFieldInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationFieldHasEmtpyResponse
   | ApplicationIsDeleted
   | ApplicationNotFound
   | FieldIsDeleted
   | FieldNotFound
   | FileUploaderFileIdNotFound
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | NeedFieldReadPermission
   | NotApplicationAddAnotherGoFResponse
   | NotFileUploaderField
   | NotGoFResponseFieldId
   | PortalNotFound
   | PreSignedGetUrlForApplicationFieldInPortalResult

export type GetPreSignedGetUrlForArchitectProfileAttachmentParams = {
   attachmentType: ArchitectProfileAttachmentEnum
   contentDispositionType: ContentDisposition
}

export type GetPreSignedGetUrlForArchitectProfileAttachmentResponse = GetPreSignedGetUrlForArchitectProfileAttachmentResult

export type GetPreSignedGetUrlForArchitectProfileAttachmentResult = {
   __typename?: 'GetPreSignedGetUrlForArchitectProfileAttachmentResult'
   preSignedUrl?: Maybe<Scalars['String']>
}

export type GetPreSignedGetUrlForCrmEntityFieldLogParams = {
   contentDispositionType: ContentDisposition
   crmEntityId: Scalars['String']
   fieldId: Scalars['String']
   fileId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   logId: Scalars['Int']
}

export type GetPreSignedGetUrlForCrmEntityFieldLogResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | FieldIsDeleted
   | FieldLogNotFound
   | FieldNotFound
   | FileUploaderFileIdNotFound
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | InvalidCrmEntityId
   | NeedFieldReadPermission
   | NotContactField
   | NotCrmEntityGoFResponseId
   | NotFileUploaderField
   | NotGoFResponseFieldId
   | NotPipelineItemField
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PreSignedGetUrlForCrmEntityFieldLogResult

export type GetPreSignedGetUrlForCrmEntityFieldParams = {
   contentDispositionType: ContentDisposition
   crmEntityId: Scalars['String']
   fieldId: Scalars['String']
   fileId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedGetUrlForCrmEntityFieldResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | CrmEntityFieldHasEmtpyResponse
   | FieldIsDeleted
   | FieldNotFound
   | FileUploaderFileIdNotFound
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | InvalidCrmEntityId
   | NeedFieldReadPermission
   | NotContactField
   | NotCrmEntityGoFResponseId
   | NotFileUploaderField
   | NotGoFResponseFieldId
   | NotPipelineItemField
   | NotTaskField
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PreSignedGetUrlForCrmEntityFieldResult
   | TaskAccessDenied
   | TaskDiscarded
   | TaskIsAlreadyCompleted
   | TaskNotFound

export type GetPreSignedGetUrlForDataExportRequestParams = {
   contentDispositionType: ContentDisposition
   dataExportRequestId: Scalars['String']
}

export type GetPreSignedGetUrlForDataExportRequestResponse =
   | DataExportRequestNotFound
   | DataFileNotFound
   | PreSignedUrlForDataExportResult
   | UserIsNotAnAdministrator

export type GetPreSignedGetUrlForDataLoadingRequestParams = {
   contentDispositionType: ContentDisposition
   dataLoadingRequestId: Scalars['String']
}

export type GetPreSignedGetUrlForDataLoadingRequestResponse =
   | DataLoadingRequestNotFound
   | GetPreSignedGetUrlForDataLoadingRequestResult
   | NotCsvDataLoadingRequest
   | UserIsNotAnAdministrator

export type GetPreSignedGetUrlForDataLoadingRequestResult = {
   __typename?: 'GetPreSignedGetUrlForDataLoadingRequestResult'
   preSignedUrl: Scalars['String']
}

export type GetPreSignedGetUrlForDocumentParams = {
   contentDispositionType: ContentDisposition
   documentId: Scalars['String']
}

export type GetPreSignedGetUrlForDocumentResponse =
   | DocumentIsDeleted
   | DocumentNotFound
   | GetPreSignedGetUrlForDocumentResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted

export type GetPreSignedGetUrlForDocumentResult = {
   __typename?: 'GetPreSignedGetUrlForDocumentResult'
   documentId: Scalars['String']
   preSignedUrl: Scalars['String']
}

export type GetPreSignedGetUrlForDocumentTemplateParams = {
   contentDispositionType: ContentDisposition
   documentTemplateVersionId: Scalars['String']
}

export type GetPreSignedGetUrlForDocumentTemplateResponse =
   | DocumentTemplateVersionNotFound
   | GetPreSignedGetUrlForDocumentTemplateResult
   | UserIsNotAnAdministrator

export type GetPreSignedGetUrlForDocumentTemplateResult = {
   __typename?: 'GetPreSignedGetUrlForDocumentTemplateResult'
   documentTemplateId: Scalars['String']
   documentTemplateVersionId: Scalars['String']
   preSignedUrl: Scalars['String']
}

export type GetPreSignedGetUrlForDocumentVersionParams = {
   contentDispositionType: ContentDisposition
   documentVersionId: Scalars['String']
}

export type GetPreSignedGetUrlForDocumentVersionResponse =
   | DocumentVersionIsDeleted
   | DocumentVersionNotFound
   | GetPreSignedGetUrlForDocumentVersionResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted

export type GetPreSignedGetUrlForDocumentVersionResult = {
   __typename?: 'GetPreSignedGetUrlForDocumentVersionResult'
   documentVersionId: Scalars['String']
   preSignedUrl: Scalars['String']
}

export type GetPreSignedGetUrlForEntityParams = {
   contentDispositionType: ContentDisposition
   entityId: Scalars['String']
   entityType: PreSignedUrlEntityType
   fileId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedGetUrlForPaymentReceiptInPortalParams = {
   contentDispositionType: ContentDisposition
   paymentId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetPreSignedGetUrlForPaymentReceiptInPortalResponse =
   | GetPreSignedGetUrlForPaymentReceiptInPortalResult
   | PaymentNotFound
   | PaymentReceiptNotExists

export type GetPreSignedGetUrlForPaymentReceiptInPortalResult = {
   __typename?: 'GetPreSignedGetUrlForPaymentReceiptInPortalResult'
   paymentId: Scalars['String']
   portalId: Scalars['String']
   preSignedUrl: Scalars['String']
}

export type GetPreSignedGetUrlForPaymentReceiptParams = {
   contentDispositionType: ContentDisposition
   paymentId: Scalars['String']
}

export type GetPreSignedGetUrlForPaymentReceiptResponse =
   | GetPreSignedGetUrlForPaymentReceiptResult
   | PaymentNotFound
   | PaymentReceiptNotExists

export type GetPreSignedGetUrlForPaymentReceiptResult = {
   __typename?: 'GetPreSignedGetUrlForPaymentReceiptResult'
   paymentId: Scalars['String']
   preSignedUrl: Scalars['String']
}

export type GetPreSignedGetUrlForPipelineItemRemarksInTaskDraftParams = {
   attachmentId: Scalars['String']
   contentDispositionType: ContentDisposition
   taskId: Scalars['String']
}

export type GetPreSignedGetUrlForPipelineItemRemarksInTaskDraftResponse =
   | PreSignedGetUrlForPipelineItemRemarksInTaskDraftResult
   | RemarksAttachmentIdNotFound
   | TaskAccessDenied
   | TaskDiscarded
   | TaskDraftHasEmptyRemarks
   | TaskIsAlreadyCompleted
   | TaskNotFound

export type GetPreSignedGetUrlForPipelineItemRemarksParams = {
   contentDispositionType: ContentDisposition
   remarksAttachmentId: Scalars['String']
}

export type GetPreSignedGetUrlForPipelineItemRemarksResponse =
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PreSignedGetUrlForPipelineItemRemarksResult
   | RemarksAttachmentIdNotFound

export type GetPreSignedGetUrlForPortalBgImageResponse =
   | PortalBackgroundImageIsEmpty
   | PortalNotFound
   | PreSignedGetUrlForPortal
   | UserIsNotAnAdministrator

export type GetPreSignedGetUrlForPortalLogoResponse =
   | PortalBrandLogoIsEmpty
   | PortalNotFound
   | PreSignedGetUrlForPortal
   | UserIsNotAnAdministrator

export type GetPreSignedGetUrlForPortalParams = {
   contentDispositionType: ContentDisposition
   portalId: Scalars['String']
}

export type GetPreSignedGetUrlForRelatedEntityFieldParams = {
   contentDispositionType: ContentDisposition
   currentEntityId: Scalars['String']
   fieldId: Scalars['String']
   fileId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
   taskId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedGetUrlForRelatedEntityFieldResponse =
   | FieldIsDeleted
   | FieldNotFound
   | FileUploaderFileIdNotFound
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | NeedFieldReadPermission
   | NotFileUploaderField
   | NotGoFResponseFieldId
   | NotPermittedCurrentEntity
   | NotPermittedRelation
   | NotRelatedEntityGoFResponseId
   | NotRelatedEntityTemplateField
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | PreSignedGetUrlForRelatedEntityFieldResult
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntityFieldHasEmptyResponse
   | RelationIsDeleted
   | RelationNotFound

export type GetPreSignedGetUrlForRelatedEntityRemarksParams = {
   contentDispositionType: ContentDisposition
   currentEntityId: Scalars['String']
   relatedEntityRemarksAttachmentId: Scalars['String']
   relationId: Scalars['String']
}

export type GetPreSignedGetUrlForRelatedEntityRemarksResponse =
   | NotPermittedCurrentEntity
   | NotPermittedRelation
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | PreSignedGetUrlForRelatedEntityRemarksResult
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntityRemarksAttachmentIdNotFound
   | RelationIsDeleted
   | RelationNotFound

export type GetPreSignedGetUrlForTdrAccountCertificateParams = {
   accountId: Scalars['String']
   contentDispositionType: ContentDisposition
}

export type GetPreSignedGetUrlForTdrAccountCertificateResponse =
   | GetPreSignedGetUrlForTdrAccountCertificateResult
   | TdrAccountAccessDenied
   | TdrAccountNotFound

export type GetPreSignedGetUrlForTdrAccountCertificateResult = {
   __typename?: 'GetPreSignedGetUrlForTDRAccountCertificateResult'
   preSignedUrl?: Maybe<Scalars['String']>
}

export type GetPreSignedGetUrlForTdrAccountParams = {
   contentDispositionType: ContentDisposition
   fileId: Scalars['String']
   propertyId: Scalars['String']
   sectionId?: InputMaybe<Scalars['String']>
   tdrAccountId: Scalars['String']
}

export type GetPreSignedGetUrlForTdrAccountResponse =
   | GetPreSignedGetUrlForTdrAccountResult
   | PropertyNotFound
   | TdrAccountAccessDenied
   | TdrAccountNotFound

export type GetPreSignedGetUrlForTdrAccountResult = {
   __typename?: 'GetPreSignedGetUrlForTDRAccountResult'
   preSignedUrl?: Maybe<Scalars['String']>
}

export type GetPreSignedGetUrlForTdrCertificateInPortalParams = {
   contentDispositionType: ContentDisposition
   portalId: Scalars['String']
   portalType: PortalType
   tdrRequestId: Scalars['String']
}

export type GetPreSignedGetUrlForTdrCertificateInPortalResponse =
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PreSignedGetUrlForTdrCertificateInPortalResult
   | TdrRequestNotFound

export type GetPreSignedGetUrlForTdrCertificateParams = {
   contentDispositionType: ContentDisposition
   tdrRequestId: Scalars['String']
}

export type GetPreSignedGetUrlForTdrCertificateResponse =
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PreSignedGetUrlForTdrCertificateInPortalResult
   | TdrRequestNotFound

export type GetPreSignedGetUrlForUserKmlFileParams = {
   contentDispositionType: ContentDisposition
   fileId: Scalars['String']
}

export type GetPreSignedGetUrlForUserKmlFileResponse =
   | GetPreSignedGetUrlForUserKmlFileResult
   | NotUserKmlFile
   | UserKmlFileNotFound

export type GetPreSignedGetUrlForUserKmlFileResult = {
   __typename?: 'GetPreSignedGetUrlForUserKmlFileResult'
   preSignedUrl: Scalars['String']
}

export type GetPreSignedGetUrlResponse =
   | GetPreSignedGetUrlResult
   | InvalidPreSignedUrlEntityId
   | PreSignedUrlEntityAccessDenied
   | PresignedUrlFileIdNotFound
   | ScrutinyKeyGenerationAccessDenied
   | ScrutinyKeyGenerationIsDisabled
   | UserIsNotAnAdministrator

export type GetPreSignedGetUrlResult = {
   __typename?: 'GetPreSignedGetUrlResult'
   entityId: Scalars['String']
   entityType: PreSignedUrlEntityType
   fileId?: Maybe<Scalars['String']>
   preSignedGetUrl: Scalars['String']
}

export type GetPreSignedPostUrlForApplicationFieldInPortalParams = {
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type GetPreSignedPostUrlForApplicationFieldInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | FieldIsDeleted
   | FieldNotFound
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | NeedFieldWritePermission
   | NotApplicationAddAnotherGoFResponse
   | NotFileUploaderField
   | NotGoFResponseFieldId
   | PortalNotFound
   | PreSignedPostUrlForApplicationFieldInPortalResult

export type GetPreSignedPostUrlForArchitectProfileAttachmentParams = {
   attachmentType: ArchitectProfileAttachmentEnum
}

export type GetPreSignedPostUrlForArchitectProfileAttachmentResponse = GetPreSignedPostUrlForArchitectProfileAttachmentResult

export type GetPreSignedPostUrlForArchitectProfileAttachmentResult = {
   __typename?: 'GetPreSignedPostUrlForArchitectProfileAttachmentResult'
   postUrlData: PreSignedPostUrlData
   preSignedGetUrl: Scalars['String']
}

export type GetPreSignedPostUrlForCrmEntityFieldParams = {
   crmEntityId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedPostUrlForCrmEntityFieldResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | FieldIsDeleted
   | FieldNotFound
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | InvalidCrmEntityId
   | NeedFieldWritePermission
   | NotContactField
   | NotCrmEntityGoFResponseId
   | NotFileUploaderField
   | NotGoFResponseFieldId
   | NotPipelineItemField
   | NotTaskField
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PreSignedPostUrlForCrmEntityFieldResult
   | TaskAccessDenied
   | TaskDiscarded
   | TaskIsAlreadyCompleted
   | TaskNotFound

export type GetPreSignedPostUrlForDataExportRequestParams = {
   actionType: FileUploaderSupportedDataExportActionType
   pipelineId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedPostUrlForDataExportRequestResponse =
   | PipelineIsRequired
   | PipelineNotFound
   | PreSignedPostUrlForDataExportRequestResult
   | UserIsNotAnAdministrator

export type GetPreSignedPostUrlForDataLoadingRequestParams = {
   actionType: DataLoadingActionType
   pipelineId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedPostUrlForDataLoadingRequestResponse =
   | GetPreSignedPostUrlForDataLoadingRequestResult
   | PipelineIsRequired
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetPreSignedPostUrlForDataLoadingRequestResult = {
   __typename?: 'GetPreSignedPostUrlForDataLoadingRequestResult'
   postUrlData: PreSignedPostUrlData
}

export type GetPreSignedPostUrlForDocumentTemplateParams = {
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedPostUrlForDocumentTemplateResponse =
   | GetPreSignedPostUrlForDocumentTemplateResult
   | PipelineItemTemplateNotFound
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetPreSignedPostUrlForDocumentTemplateResult = {
   __typename?: 'GetPreSignedPostUrlForDocumentTemplateResult'
   postUrlData: PreSignedPostUrlData
   preSignedGetUrl: Scalars['String']
}

export type GetPreSignedPostUrlForPipelineItemRemarksInTaskDraftParams = {
   taskId: Scalars['String']
}

export type GetPreSignedPostUrlForPipelineItemRemarksInTaskDraftResponse =
   | GetPreSignedPostUrlForPipelineItemRemarksInTaskDraftResult
   | TaskAccessDenied
   | TaskDiscarded
   | TaskIsAlreadyCompleted
   | TaskNotFound

export type GetPreSignedPostUrlForPipelineItemRemarksInTaskDraftResult = {
   __typename?: 'GetPreSignedPostUrlForPipelineItemRemarksInTaskDraftResult'
   postUrlData: PreSignedPostUrlData
   taskId: Scalars['String']
}

export type GetPreSignedPostUrlForPipelineItemRemarksParams = {
   pipelineItemId: Scalars['String']
}

export type GetPreSignedPostUrlForPipelineItemRemarksResponse =
   | GetPreSignedPostUrlForPipelineItemRemarksResult
   | PipelineItemAccessDenied

export type GetPreSignedPostUrlForPipelineItemRemarksResult = {
   __typename?: 'GetPreSignedPostUrlForPipelineItemRemarksResult'
   postUrlData: PreSignedPostUrlData
   preSignedGetUrl: Scalars['String']
}

export type GetPreSignedPostUrlForRelatedEntityFieldParams = {
   currentEntityId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
}

export type GetPreSignedPostUrlForRelatedEntityFieldResponse =
   | FieldIsDeleted
   | FieldNotFound
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | NeedFieldWritePermission
   | NotFileUploaderField
   | NotGoFResponseFieldId
   | NotPermittedCurrentEntity
   | NotPermittedRelation
   | NotRelatedEntityGoFResponseId
   | NotRelatedEntityTemplateField
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | PreSignedPostUrlForRelatedEntityFieldResult
   | RelatedEntitiesNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound

export type GetPreSignedPostUrlForRelatedEntityRemarksResponse =
   | GetPreSignedPostUrlForRelatedEntityRemarksResult
   | NotPermittedCurrentEntity
   | NotPermittedRelation
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | RelatedEntitiesNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound

export type GetPreSignedPostUrlForRelatedEntityRemarksResult = {
   __typename?: 'GetPreSignedPostUrlForRelatedEntityRemarksResult'
   currentEntityId: Scalars['String']
   postUrlData: PreSignedPostUrlData
   preSignedGetUrl: Scalars['String']
   relatedEntityId: Scalars['String']
}

export type GetPreSignedPostUrlForStageTransitionPipelineItemRemarksParams = {
   pipelineItemId: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type GetPreSignedPostUrlForStageTransitionPipelineItemRemarksResponse =
   | GetPreSignedPostUrlForStageTransitionPipelineItemRemarksResult
   | PipelineItemAccessDenied
   | StageTransitionNotFound

export type GetPreSignedPostUrlForStageTransitionPipelineItemRemarksResult = {
   __typename?: 'GetPreSignedPostUrlForStageTransitionPipelineItemRemarksResult'
   postUrlData: PreSignedPostUrlData
   preSignedGetUrl: Scalars['String']
}

export type GetPreSignedPostUrlForTdrCertificateInPortalParams = {
   entityId?: InputMaybe<Scalars['String']>
   entityType?: InputMaybe<TdrPreSignedUrlsEntityType>
   portalId: Scalars['String']
   portalType: PortalType
   tdrRequestId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedPostUrlForTdrCertificateInPortalResponse =
   | EitherEntityIdOrTdrRequestIdRequired
   | GetPreSignedPostUrlForTdrCertificateInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | TdrRequestNotFound

export type GetPreSignedPostUrlForTdrCertificateInPortalResult = {
   __typename?: 'GetPreSignedPostUrlForTDRCertificateInPortalResult'
   postUrlData: PreSignedPostUrlData
   preSignedGetUrl: Scalars['String']
}

export type GetPreSignedPutUrlForApplicationFieldInPortalParams = {
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type GetPreSignedPutUrlForApplicationFieldInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | FieldIsDeleted
   | FieldNotFound
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | NeedFieldWritePermission
   | NotApplicationAddAnotherGoFResponse
   | NotFileUploaderField
   | NotGoFResponseFieldId
   | PortalNotFound
   | PreSignedPutUrlForApplicationFieldInPortalResult

export type GetPreSignedPutUrlForArchitectProfileAttachmentParams = {
   attachmentType: ArchitectProfileAttachmentEnum
}

export type GetPreSignedPutUrlForArchitectProfileAttachmentResponse = GetPreSignedPutUrlForArchitectProfileAttachmentResult

export type GetPreSignedPutUrlForArchitectProfileAttachmentResult = {
   __typename?: 'GetPreSignedPutUrlForArchitectProfileAttachmentResult'
   preSignedUrl: Scalars['String']
}

export type GetPreSignedPutUrlForCrmEntityFieldParams = {
   crmEntityId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedPutUrlForCrmEntityFieldResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | FieldIsDeleted
   | FieldNotFound
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | InvalidCrmEntityId
   | NeedFieldWritePermission
   | NotContactField
   | NotCrmEntityGoFResponseId
   | NotFileUploaderField
   | NotGoFResponseFieldId
   | NotPipelineItemField
   | NotTaskField
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PreSignedPutUrlForCrmEntityFieldResult
   | TaskAccessDenied
   | TaskDiscarded
   | TaskIsAlreadyCompleted
   | TaskNotFound

export type GetPreSignedPutUrlForDataExportRequestParams = {
   actionType: FileUploaderSupportedDataExportActionType
   pipelineId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedPutUrlForDataExportRequestResponse =
   | PipelineIsRequired
   | PipelineNotFound
   | PreSignedPutUrlForDataExportRequestResult
   | UserIsNotAnAdministrator

export type GetPreSignedPutUrlForDataLoadingRequestParams = {
   actionType: DataLoadingActionType
   pipelineId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedPutUrlForDataLoadingRequestResponse =
   | GetPreSignedPutUrlForDataLoadingRequestResult
   | PipelineIsRequired
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetPreSignedPutUrlForDataLoadingRequestResult = {
   __typename?: 'GetPreSignedPutUrlForDataLoadingRequestResult'
   preSignedUrl: Scalars['String']
}

export type GetPreSignedPutUrlForDocumentTemplateParams = {
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedPutUrlForDocumentTemplateResponse =
   | GetPreSignedPutUrlForDocumentTemplateResult
   | PipelineItemTemplateNotFound
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetPreSignedPutUrlForDocumentTemplateResult = {
   __typename?: 'GetPreSignedPutUrlForDocumentTemplateResult'
   preSignedGetUrl: Scalars['String']
   preSignedPutUrl: Scalars['String']
}

export type GetPreSignedPutUrlForEntityParams = {
   entityId?: InputMaybe<Scalars['String']>
   entityType: PreSignedUrlEntityType
}

export type GetPreSignedPutUrlForPipelineItemRemarksInTaskDraftParams = {
   taskId: Scalars['String']
}

export type GetPreSignedPutUrlForPipelineItemRemarksInTaskDraftResponse =
   | GetPreSignedPutUrlForPipelineItemRemarksInTaskDraftResult
   | TaskAccessDenied
   | TaskDiscarded
   | TaskIsAlreadyCompleted
   | TaskNotFound

export type GetPreSignedPutUrlForPipelineItemRemarksInTaskDraftResult = {
   __typename?: 'GetPreSignedPutUrlForPipelineItemRemarksInTaskDraftResult'
   preSignedPutUrl: Scalars['String']
   taskId: Scalars['String']
}

export type GetPreSignedPutUrlForPipelineItemRemarksParams = {
   pipelineItemId: Scalars['String']
}

export type GetPreSignedPutUrlForPipelineItemRemarksResponse =
   | GetPreSignedPutUrlForPipelineItemRemarksResult
   | PipelineItemAccessDenied

export type GetPreSignedPutUrlForPipelineItemRemarksResult = {
   __typename?: 'GetPreSignedPutUrlForPipelineItemRemarksResult'
   preSignedGetUrl: Scalars['String']
   preSignedPutUrl: Scalars['String']
}

export type GetPreSignedPutUrlForPortalResponse =
   | PreSignedPutUrlForPortal
   | UserIsNotAnAdministrator

export type GetPreSignedPutUrlForRelatedEntityFieldParams = {
   currentEntityId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
}

export type GetPreSignedPutUrlForRelatedEntityFieldResponse =
   | FieldIsDeleted
   | FieldNotFound
   | GoFResponseIdNotFound
   | GoFResponseIdRequiredForAddAnotherField
   | NeedFieldWritePermission
   | NotFileUploaderField
   | NotGoFResponseFieldId
   | NotPermittedCurrentEntity
   | NotPermittedRelation
   | NotRelatedEntityGoFResponseId
   | NotRelatedEntityTemplateField
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | PreSignedPutUrlForRelatedEntityFieldResult
   | RelatedEntitiesNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound

export type GetPreSignedPutUrlForRelatedEntityRemarksParams = {
   currentEntityId: Scalars['String']
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
}

export type GetPreSignedPutUrlForRelatedEntityRemarksResponse =
   | GetPreSignedPutUrlForRelatedEntityRemarksResult
   | NotPermittedCurrentEntity
   | NotPermittedRelation
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | RelatedEntitiesNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound

export type GetPreSignedPutUrlForRelatedEntityRemarksResult = {
   __typename?: 'GetPreSignedPutUrlForRelatedEntityRemarksResult'
   currentEntityId: Scalars['String']
   preSignedGetUrl: Scalars['String']
   preSignedPutUrl: Scalars['String']
   relatedEntityId: Scalars['String']
}

export type GetPreSignedPutUrlForStageTransitionPipelineItemRemarksParams = {
   pipelineItemId: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type GetPreSignedPutUrlForStageTransitionPipelineItemRemarksResponse =
   | GetPreSignedPutUrlForStageTransitionPipelineItemRemarksResult
   | PipelineItemAccessDenied
   | StageTransitionNotFound

export type GetPreSignedPutUrlForStageTransitionPipelineItemRemarksResult = {
   __typename?: 'GetPreSignedPutUrlForStageTransitionPipelineItemRemarksResult'
   preSignedGetUrl: Scalars['String']
   preSignedPutUrl: Scalars['String']
}

export type GetPreSignedPutUrlForTdrAccountCertificateParams = {
   accountId: Scalars['String']
}

export type GetPreSignedPutUrlForTdrAccountCertificateResponse =
   | GetPreSignedPutUrlForTdrAccountCertificateResult
   | TdrAccountAccessDenied
   | TdrAccountNotFound

export type GetPreSignedPutUrlForTdrAccountCertificateResult = {
   __typename?: 'GetPreSignedPutUrlForTDRAccountCertificateResult'
   preSignedUrl: Scalars['String']
}

export type GetPreSignedPutUrlForTdrCertificateInPortalParams = {
   entityId?: InputMaybe<Scalars['String']>
   entityType?: InputMaybe<TdrPreSignedUrlsEntityType>
   portalId: Scalars['String']
   portalType: PortalType
   tdrRequestId?: InputMaybe<Scalars['String']>
}

export type GetPreSignedPutUrlForTdrCertificateInPortalResponse =
   | EitherEntityIdOrTdrRequestIdRequired
   | GetPreSignedPutUrlForTdrCertificateInPortaleResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | TdrRequestNotFound

export type GetPreSignedPutUrlForTdrCertificateInPortaleResult = {
   __typename?: 'GetPreSignedPutUrlForTDRCertificateInPortaleResult'
   preSignedGetUrl: Scalars['String']
   preSignedPutUrl: Scalars['String']
}

export type GetPreSignedPutUrlForUserKmlFileResponse = GetPreSignedPutUrlForUserKmlFileResult

export type GetPreSignedPutUrlForUserKmlFileResult = {
   __typename?: 'GetPreSignedPutUrlForUserKmlFileResult'
   preSignedUrl: Scalars['String']
}

export type GetPreSignedPutUrlResponse =
   | GetPreSignedPutUrlResult
   | InvalidPreSignedUrlEntityId
   | PreSignedUrlEntityAccessDenied
   | ScrutinyKeyGenerationAccessDenied
   | ScrutinyKeyGenerationIsDisabled
   | UserIsNotAnAdministrator

export type GetPreSignedPutUrlResult = {
   __typename?: 'GetPreSignedPutUrlResult'
   entityId?: Maybe<Scalars['String']>
   entityType: PreSignedUrlEntityType
   preSignedPutUrl: Scalars['String']
}

export type GetPrefilledPipelineItemCheckpointsParams = {
   checkpointIds: Array<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type GetPrefilledPipelineItemCheckpointsResponse =
   | GetPrefilledPipelineItemCheckpointsResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | StageTransitionCheckpointsNotFound

export type GetPrefilledPipelineItemCheckpointsResult = {
   __typename?: 'GetPrefilledPipelineItemCheckpointsResult'
   checkpoints: Array<StageTransitionCheckpoint>
   pipelineItemId: Scalars['String']
}

export type GetPreviewForDocumentTemplateParams = {
   documentTemplateId: Scalars['String']
   pipelineItemId: Scalars['String']
   siteInspectionTaskTemplateId?: InputMaybe<Scalars['String']>
}

export type GetPreviewForDocumentTemplateResponse =
   | DocumentTemplateIsDeleted
   | DocumentTemplateNotFound
   | GetPreviewForDocumentTemplateResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TaskTemplateNotFound

export type GetPreviewForDocumentTemplateResult = {
   __typename?: 'GetPreviewForDocumentTemplateResult'
   documentTemplateId: Scalars['String']
   pipelineItemId: Scalars['String']
   previewUrl: Scalars['String']
}

export type GetPropertiesForApplicationsAsOpenParams = {
   applicationIds: Array<Scalars['String']>
}

export type GetPropertiesForApplicationsInPortalParams = {
   applicationIds: Array<Scalars['String']>
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type GetPropertiesForApplicationsParams = {
   applicationIds: Array<Scalars['String']>
}

export type GetPropertiesForContactsParams = {
   contactIds: Array<Scalars['String']>
}

export type GetPropertiesForDealsParams = {
   dealIds: Array<Scalars['String']>
}

export type GetPropertiesForLeadsParams = {
   leadIds: Array<Scalars['String']>
}

export type GetPropertiesForPipelineCustomObjectsParams = {
   pipelineCustomObjectIds: Array<Scalars['String']>
}

export type GetPropertiesForPipelineItemsWithoutPermissionParams = {
   contactSystemFieldEnums: Array<ContactSystemFieldEnum>
   pipelineItemIds: Array<Scalars['String']>
   shouldIncludeContactFields: Scalars['Boolean']
}

export type GetPropertiesForPipelineItemsWithoutPermissionResponse =
   | PipelineItemPropertiesWithoutPermissionResult
   | PipelineItemsNotInSamePipelineItemTemplate

export type GetReconciliationCsvDataParams = {
   requestIds: Array<Scalars['String']>
}

export type GetReconciliationCsvDataResponse =
   | GetReconciliationCsvDataResult
   | UserIsNotAnAdministrator

export type GetReconciliationCsvDataResult = {
   __typename?: 'GetReconciliationCSVDataResult'
   csvData: Array<ReconciliationRequestCsvResult>
}

export type GetReconciliationRequestsParams = {
   applicationType?: InputMaybe<ReconciliationApplicationType>
   pagination: Pagination
   status?: InputMaybe<ReconciliationRequestStatus>
}

export type GetReconciliationRequestsResponse =
   | GetReconciliationRequestsResult
   | UserIsNotAnAdministrator

export type GetReconciliationRequestsResult = {
   __typename?: 'GetReconciliationRequestsResult'
   items: Array<ReconciliationRequest>
   totalCount: Scalars['Int']
}

export type GetRecordCreationConfigsForAdminParams = {
   recordCreationConfigIds: Array<Scalars['Int']>
}

export type GetRecordCreationConfigsParams = {
   recordCreationConfigIds: Array<Scalars['Int']>
}

export type GetRecordMergePermissionsForSalesTemplatesParams = {
   salesTemplateIds: Array<Scalars['String']>
}

export type GetRecordMergePermissionsForSalesTemplatesResponse =
   | GetRecordMergePermissionsForSalesTemplatesResult
   | UserIsNotAnAdministrator

export type GetRecordMergePermissionsForSalesTemplatesResult = {
   __typename?: 'GetRecordMergePermissionsForSalesTemplatesResult'
   salesTemplates: Array<SalesTemplateRecordMergePermissionsUnion>
}

export type GetRefundApplicationsParams = {
   dateRange?: InputMaybe<DateRangeParams>
   pagination: Pagination
   refundStatus?: InputMaybe<ApplicationRefundParamsStatus>
   searchTerm?: InputMaybe<Scalars['String']>
   sort?: InputMaybe<Sort>
}

export type GetRefundApplicationsResponse =
   | GetRefundApplicationsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded

export type GetRefundApplicationsResult = {
   __typename?: 'GetRefundApplicationsResult'
   applications: Array<ApplicationRefundDetails>
   totalCount: Scalars['Int']
}

export type GetRelatedApplicationCopyFieldsLogInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetRelatedApplicationCopyFieldsLogInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GetRelatedApplicationCopyFieldsLogInPortalResultResponse
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PortalNotFound

export type GetRelatedApplicationCopyFieldsLogInPortalResult = {
   __typename?: 'GetRelatedApplicationCopyFieldsLogInPortalResult'
   applicationCopyLogId: Scalars['String']
   applicationId: Scalars['String']
   failureReason?: Maybe<Scalars['String']>
   status: RelatedApplicationCopyFieldsLogStatus
}

export type GetRelatedApplicationCopyFieldsLogInPortalResultResponse = {
   __typename?: 'GetRelatedApplicationCopyFieldsLogInPortalResultResponse'
   applicationCopyLog?: Maybe<GetRelatedApplicationCopyFieldsLogInPortalResult>
}

export type GetRelatedEntitiesAddAnotherGoFsFieldsBulkParams = {
   currentEntityId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
   relatedEntityIds: Array<Scalars['String']>
   relationId: Scalars['String']
   taskId?: InputMaybe<Scalars['String']>
}

export type GetRelatedEntitiesAddAnotherGoFsFieldsBulkResponse =
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | GetRelatedEntitiesAddAnotherGoFsFieldsBulkResult
   | GoFsAreDeleted
   | GoFsNotFound
   | NotAddAnotherGoFs
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | RelatedEntitiesNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound

export type GetRelatedEntitiesAddAnotherGoFsFieldsBulkResult = {
   __typename?: 'GetRelatedEntitiesAddAnotherGoFsFieldsBulkResult'
   results: Array<GetRelatedEntityAddAnotherGoFsFieldsResult>
}

export type GetRelatedEntitiesFieldResponsesParams = {
   currentEntityId: Scalars['String']
   relatedEntityIds: Array<Scalars['String']>
   relationId: Scalars['String']
   taskId?: InputMaybe<Scalars['String']>
}

export type GetRelatedEntityAddAnotherFieldsParams = {
   currentEntityId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofResponseIds: Array<Scalars['String']>
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
   taskId?: InputMaybe<Scalars['String']>
}

export type GetRelatedEntityAddAnotherFieldsResponse =
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | GetRelatedEntityAddAnotherGoFsFieldsResult
   | GoFResponseIdsNotFound
   | NotAddAnotherFields
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | NotRelatedEntityAddAnotherGoFResponsesBulk
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntityIsDeleted
   | RelatedEntityNotFound
   | RelationIsDeleted
   | RelationNotFound

export type GetRelatedEntityAddAnotherGoFsFieldsParams = {
   currentEntityId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
   taskId?: InputMaybe<Scalars['String']>
}

export type GetRelatedEntityAddAnotherGoFsFieldsResponse =
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | GetRelatedEntityAddAnotherGoFsFieldsResult
   | GoFsAreDeleted
   | GoFsNotFound
   | NotAddAnotherGoFs
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntityIsDeleted
   | RelatedEntityNotFound
   | RelationIsDeleted
   | RelationNotFound

export type GetRelatedEntityAddAnotherGoFsFieldsResult = {
   __typename?: 'GetRelatedEntityAddAnotherGoFsFieldsResult'
   gofResponses: Array<AddAnotherGoFResult>
   relatedEntityId: Scalars['String']
}

export type GetRelatedObjectsCountInPortalParams = {
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
   relations: Array<PortalRelationParams>
}

export type GetRelatedObjectsCountInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GetRelatedObjectsCountInPortalResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PortalNotFound
   | RelationsNotFound

export type GetRelatedObjectsCountInPortalResult = {
   __typename?: 'GetRelatedObjectsCountInPortalResult'
   counts: Array<RelatedObjectsCountInPortal>
}

export type GetRelatedObjectsInPortalParams = {
   applicationId: Scalars['String']
   pagination: Pagination
   portalId: Scalars['String']
   portalType: PortalType
   relationId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
   target?: InputMaybe<SelfRelationTarget>
}

export type GetRelatedObjectsInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PortalNotFound
   | PortalRelatedObjectsResult
   | RelationNotFound

export type GetRelatedObjectsParams = {
   currentEntityId: Scalars['String']
   excludeRelatedEntityIds?: InputMaybe<Array<Scalars['String']>>
   filterByRelatedEntityId?: InputMaybe<Scalars['String']>
   pagination: Pagination
   relationId: Scalars['String']
   relationTarget?: InputMaybe<SelfRelationTarget>
   searchQuery?: InputMaybe<Scalars['String']>
   secondDegreeRelationId?: InputMaybe<Scalars['String']>
}

export type GetRelatedObjectsResponse =
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | InvalidLimit
   | InvalidOffset
   | NotPermittedCurrentEntity
   | NotPermittedRelation
   | PaginationLimitExceeded
   | RelatedObjectsResult
   | RelationIsDeleted
   | RelationNotFound
   | TargetEntityDirectionIsRequiredForSelfRelation

export type GetRelatedObjectsToLinkParams = {
   currentEntityId: Scalars['String']
   pagination: Pagination
   relationId: Scalars['String']
   relationTarget?: InputMaybe<SelfRelationTarget>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetRelatedObjectsToLinkResponse =
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | InvalidLimit
   | InvalidOffset
   | NotPermittedCurrentEntity
   | NotPermittedRelation
   | PaginationLimitExceeded
   | RelatedObjectsResult
   | RelationIsDeleted
   | RelationNotFound

export type GetRelatedPipelineItemAttachmentsParams = {
   attachmentIds: Array<Scalars['String']>
   currentEntityId: Scalars['String']
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
}

export type GetRelatedPipelineItemAttachmentsResponse =
   | GetRelatedPipelineItemAttachmentsResult
   | NotPermittedCurrentEntity
   | NotPermittedRelation
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | RelatedEntitiesNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound
   | RemarksAttachmentIdsNotFound
   | RemarksAttachmentsNotLinkedToPipelineItem

export type GetRelatedPipelineItemAttachmentsResult = {
   __typename?: 'GetRelatedPipelineItemAttachmentsResult'
   attachments: Array<RemarksAttachment>
}

export type GetRelatedPipelineItemRemarksParams = {
   currentEntityId: Scalars['String']
   pagination: Pagination
   relatedEntityId: Scalars['String']
   relatedEntityPipelineIds?: InputMaybe<Array<Scalars['String']>>
   relationId: Scalars['String']
}

export type GetRelatedPipelineItemRemarksResponse =
   | CurrentEntityNotBelongsToRelation
   | GetRelatedPipelineItemRemarksResult
   | InvalidLimit
   | InvalidOffset
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | RelatedEntitiesNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound

export type GetRelatedPipelineItemRemarksResult = {
   __typename?: 'GetRelatedPipelineItemRemarksResult'
   remarks: Array<PipelineItemRemarks>
   totalCount: Scalars['Int']
}

export type GetRelationsParams = {
   excludePipelineItemTypes?: InputMaybe<Array<PipelineItemType>>
   excludeRelatedPipelineIds?: InputMaybe<Array<Scalars['String']>>
   pagination?: InputMaybe<Pagination>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetRelationsPipelineItemTemplateResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineItemTemplateNotFound
   | Relations

export type GetRelationsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineItemTemplateAccessDenied
   | PipelineItemTemplateNotFound
   | PipelineNotFound
   | Relations

export type GetRelationsToPipelineItemTemplateParams = {
   pagination: Pagination
   pipelineItemTemplateId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetRemindersOnPipelineItemParams = {
   pagination: Pagination
   pipelineItemId: Scalars['String']
   remindersDate?: InputMaybe<Scalars['String']>
}

export type GetRemindersOnPipelineItemResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineItemRemindersResult

export type GetRetoolAppEmbedUrlParams = {
   branch?: InputMaybe<Scalars['String']>
   environment?: InputMaybe<Scalars['String']>
   groupIds: Array<Scalars['String']>
   landingPageUuid: Scalars['String']
   metadataJson?: InputMaybe<Scalars['String']>
   releaseVersion?: InputMaybe<Scalars['String']>
   sessionDurationMinutes?: InputMaybe<Scalars['String']>
   userInfoJson?: InputMaybe<Scalars['String']>
}

export type GetSalesTemplateRecordCreationConfigFieldsParams = {
   salesTemplateId: Scalars['String']
}

export type GetSalesTemplateRecordCreationConfigFieldsResponse =
   | GetSalesTemplateRecordCreationConfigFieldsResult
   | NotSupportedSalesTemplateType
   | SalesTemplateNotFound
   | SalesTemplateNotInUserAccount

export type GetSalesTemplateRecordCreationConfigFieldsResult = {
   __typename?: 'GetSalesTemplateRecordCreationConfigFieldsResult'
   fields: Array<Field>
   salesTemplateId: Scalars['String']
}

export type GetSalesTemplateResponse = GetSalesTemplateResult

export type GetSalesTemplateResult = {
   __typename?: 'GetSalesTemplateResult'
   salesTemplates: Array<SalesTemplatesUnion>
}

export type GetSalesTemplateTypes = {
   salesTemplateTypes: Array<SupportedSalesTemplateTypesForRelation>
}

export type GetSalesTemplatesInPortalParams = {
   portalId: Scalars['String']
   portalType: PortalType
   salesTemplateIds: Array<Scalars['String']>
}

export type GetSalesTemplatesInPortalResponse = GetSalesTemplateResult

export type GetSalesTemplatesParams = {
   salesTemplateIds: Array<Scalars['String']>
}

export type GetSalesTemplatesWithoutPermissionParams = {
   salesTemplateIds: Array<Scalars['String']>
}

export type GetSalesTemplatesWithoutPermissionResponse = GetSalesTemplatesWithoutPermissionResult

export type GetSalesTemplatesWithoutPermissionResult = {
   __typename?: 'GetSalesTemplatesWithoutPermissionResult'
   salesTemplates: Array<SalesTemplatesWithoutPermissionUnion>
}

export type GetSchedulePipelineItemsCountForUserParams = {
   pipelineItemTypes: Array<PipelineItemType>
}

export type GetSchedulePipelineItemsCountInDateRangeParams = {
   fromDate: Scalars['String']
   statuses: Array<PipelineItemScheduledStatus>
   toDate: Scalars['String']
}

export type GetSchedulePipelineItemsForUserParams = {
   datetimeRange?: InputMaybe<DateTimeRangeParams>
   featureEnum?: InputMaybe<FeatureEnum>
   pagination?: InputMaybe<Pagination>
   pipelineItemTypes: Array<PipelineItemType>
   scheduledByUserId?: InputMaybe<Scalars['String']>
   statuses?: InputMaybe<Array<PipelineItemScheduledStatus>>
}

export type GetSchedulePipelineItemsForUserResponse =
   | AccessDeniedForScheduledByUser
   | InvalidDateTimeRange
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | ScheduledByUserNotFound
   | ScheduledPipelineItemsResult

export type GetSchedulePipelineItemsForUserV2Params = {
   datetimeRange?: InputMaybe<DateTimeRangeParams>
   pagination?: InputMaybe<Pagination>
   pipelineItemTypes: Array<PipelineItemType>
   scheduledByUserId?: InputMaybe<Scalars['String']>
   statuses?: InputMaybe<Array<PipelineItemScheduledStatus>>
}

export type GetSchedulePipelineItemsForUserV2Response =
   | AccessDeniedForScheduledByUser
   | InvalidDateTimeRange
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | ScheduledByUserNotFound
   | ScheduledPipelineItemsV2Result

export type GetScheduledAutomationWorkflowExecLogsFilterParams = {
   entityLevel?: InputMaybe<AwLogsEntityLevel>
   pipelineId?: InputMaybe<Scalars['String']>
}

export type GetScheduledAutomationWorkflowExecLogsFilterResponse =
   | PipelineNotFound
   | ScheduledAutomationWorkflowExecLogsFilter
   | UserIsNotAnAdministrator

export type GetScheduledPipelineItemIdsInViewParams = {
   customFilters: Array<CustomFilter>
   featureEnum?: InputMaybe<FeatureEnum>
   pagination: Pagination
   scheduledByUserId: Scalars['String']
   userHierarchyFilter?: InputMaybe<UserHierarchyFilter>
   viewId: Scalars['String']
}

export type GetScheduledPipelineItemsTeamMetricsParams = {
   dateRange: DateRangeParams
   excludeApiUser?: InputMaybe<Scalars['Boolean']>
}

export type GetScheduledPipelineItemsTeamStatsParams = {
   datetimeRange?: InputMaybe<DateTimeRangeParams>
   excludeApiUser?: InputMaybe<Scalars['Boolean']>
   pagination: Pagination
}

export type GetScheduledPipelineItemsUserMetricsParams = {
   dateRange: DateRangeParams
   userId: Scalars['String']
}

export type GetSchedulesOnPipelineItemParams = {
   pipelineItemId: Scalars['String']
}

export type GetSchedulesOnPipelineItemV2Params = {
   pipelineItemId: Scalars['String']
}

export type GetScorecardChartParams = {
   graphId: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
}

export type GetScoringRecalculationExecLogsParams = {
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
}

export type GetScoringRecalculationExecLogsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemTemplateNotFound
   | PipelineNotFound
   | ScoringRecalculationExecLogsResult
   | UserIsNotAnAdministrator

export type GetScrutinyKeyLogsParams = {
   applicationId?: InputMaybe<Scalars['String']>
   pagination: Pagination
}

export type GetScrutinyKeyLogsResponse = GetScrutinyKeyLogsResult

export type GetScrutinyKeyLogsResult = {
   __typename?: 'GetScrutinyKeyLogsResult'
   logs: Array<GenerateScrutinyLog>
   totalCount: Scalars['Int']
}

export type GetSearchAndMonitoringConfigResponse =
   | GetSearchAndMonitoringConfigResult
   | SearchAndMonitoringAccessControlConfigNotFound
   | UserAuthorityNotFound
   | UserDesignationNotFound
   | UserOrganizationLevelNotFound

export type GetSearchAndMonitoringConfigResult = {
   __typename?: 'GetSearchAndMonitoringConfigResult'
   fields: Array<SearchAndMonitoringFieldConfig>
   filterFields: Array<SearchAndMonitoringFilterField>
   overviewFieldIds: Array<Scalars['String']>
}

export type GetSharableEntitiesParams = {
   entityTypes: Array<SharingEntityType>
   identificationTypes: Array<IdentificationType>
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetSharableEntitiesResponse =
   | GetSharableEntitiesResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded

export type GetSharableEntitiesResult = {
   __typename?: 'GetSharableEntitiesResult'
   sharableEntities: Array<SharableEntity>
   totalCount: Scalars['Int']
}

export type GetSiteInspectionTaskJobStatusParams = {
   taskId: Scalars['String']
}

export type GetSiteInspectionTasksParams = {
   pagination: Pagination
   pipelineItemId: Scalars['String']
   taskStatuses: Array<TaskStatus>
   taskTemplateIds: Array<Scalars['String']>
}

export type GetSiteInspectionTasksResponse =
   | GetSiteInspectionTasksResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TaskTemplatesNotFound

export type GetSiteInspectionTasksResult = {
   __typename?: 'GetSiteInspectionTasksResult'
   tasks: Array<Task>
   totalCount: Scalars['Int']
}

export type GetSmartfloAccountPluginServiceAccountsParams = {
   accountPluginId: Scalars['String']
   pagination: Pagination
}

export type GetSmartfloAccountPluginServiceAccountsResponse =
   | AccountPluginIdNotFound
   | GetSmartfloAccountPluginServiceAccountsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type GetSmartfloAccountPluginServiceAccountsResult = {
   __typename?: 'GetSmartfloAccountPluginServiceAccountsResult'
   smartfloAccounts: Array<SmartfloAccount>
   totalCount: Scalars['Int']
}

export type GetSmartfloPluginServiceAccountsParams = {
   pluginServiceAccountIds: Array<Scalars['String']>
}

export type GetSmartfloPluginServiceAccountsResponse =
   | SmartfloServiceAccounts
   | UserIsNotAnAdministrator

export type GetStageAssigneeTimespentLogInPortalParams = {
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type GetStageAssigneeTimespentLogInPortalResponse =
   | GetStageAssigneeTimespentLogInPortalResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PortalNotFound

export type GetStageAssigneeTimespentLogInPortalResult = {
   __typename?: 'GetStageAssigneeTimespentLogInPortalResult'
   assigneeTimeSpentLogs: Array<AssigneeTimespentLogInPortal>
   stageAssigneeTimeSpentLogs: Array<StageAssigneeTimespentLogInPortal>
}

export type GetStageBoardRolesParams = {
   stageIds: Array<Scalars['String']>
}

export type GetStageBoardsRolesResponse =
   | GetStageBoardsRolesResult
   | UserIsNotAnAdministrator

export type GetStageBoardsRolesResult = {
   __typename?: 'GetStageBoardsRolesResult'
   stages: Array<StageBoardRolesResult>
}

export type GetStageUpdatePermissionParams = {
   pipelineId: Scalars['String']
}

export type GetStageUpdatePermissionResult = {
   __typename?: 'GetStageUpdatePermissionResult'
   stageUpdatePermissions: Array<StageUpdatePermissions>
}

export type GetStageUpdatePermissionsResponse =
   | GetStageUpdatePermissionResult
   | PipelineAccessDenied
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type GetStagesParams = {
   stageIds: Array<Scalars['String']>
}

export type GetStagesTransitionsInPortalParams = {
   portalId: Scalars['String']
   stageIds: Array<Scalars['String']>
}

export type GetStagesTransitionsInPortalResponse =
   | GetStagesTransitionsInPortalResult
   | PortalNotFound

export type GetStagesTransitionsInPortalResult = {
   __typename?: 'GetStagesTransitionsInPortalResult'
   transitions: Array<StageWiseTransitionsInPortalResponse>
}

export type GetStagesTransitionsParams = {
   stageIds: Array<Scalars['String']>
}

export type GetStagesTransitionsResult =
   | StageNotFound
   | StageWiseTransitions
   | UserIsNotAnAdministrator

export type GetStatsForLeadBucketsParams = {
   leadBucketIds: Array<Scalars['String']>
}

export type GetStatsForLeadBucketsResponse =
   | GetStatsForLeadBucketsResult
   | LeadBucketsAreNotInSameLeadDistributionRule
   | UserIsNotAnAdministrator

export type GetStatsForLeadBucketsResult = {
   __typename?: 'GetStatsForLeadBucketsResult'
   leadBuckets: Array<LeadBucketStatsResult>
}

export type GetStructuredEntityJsonConfigParams = {
   entityId?: InputMaybe<Scalars['String']>
   entityType: JsonConfigEntityType
}

export type GetStructuredEntityJsonConfigResponse =
   | EntityJsonConfigurationDoesNotExists
   | GetStructuredEntityJsonConfigResult
   | NotSupportedJsonConfigurationEntity

export type GetStructuredEntityJsonConfigResult = {
   __typename?: 'GetStructuredEntityJsonConfigResult'
   configuration: StructuredEntityJsonConfiguration
}

export type GetTdrAccount = {
   accountId: Scalars['String']
}

export type GetTdrAccountAddAnotherFieldsParams = {
   fieldIds: Array<Scalars['String']>
   gofResponseIds: Array<Scalars['String']>
   tdrAccountId: Scalars['String']
}

export type GetTdrAccountAddAnotherFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | GetTdrAccountAddAnotherGoFsFieldsResult
   | GoFResponseIdsNotFound
   | NotAddAnotherFields
   | NotApplicationAddAnotherGoFResponsesBulk
   | NotPermittedFields
   | TdrAccountNotFound

export type GetTdrAccountAddAnotherGoFsFieldsParams = {
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
   tdrAccountId: Scalars['String']
}

export type GetTdrAccountAddAnotherGoFsFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | GetTdrAccountAddAnotherGoFsFieldsResult
   | GoFsAreDeleted
   | GoFsNotFound
   | NotAddAnotherFields
   | NotAddAnotherGoFs
   | TdrAccountNotFound

export type GetTdrAccountAddAnotherGoFsFieldsResult = {
   __typename?: 'GetTDRAccountAddAnotherGoFsFieldsResult'
   gofResponses: Array<AddAnotherGoFResult>
   tdrAccountId: Scalars['String']
}

export type GetTdrAccountByAccountNoParams = {
   accountNo: Scalars['String']
}

export type GetTdrAccountByAccountNoResponse =
   | GetTdrAccountByAccountNoResult
   | TdrAccountAccessDenied
   | TdrAccountNotExistsForAccountNo

export type GetTdrAccountByAccountNoResult = {
   __typename?: 'GetTDRAccountByAccountNoResult'
   account: TdrAccount
}

export type GetTdrAccountRequestsForUserParams = {
   pagination?: InputMaybe<Pagination>
   readStatusFilter?: InputMaybe<TdrAccountRequestStatusFilter>
   tdrRequestTypes?: InputMaybe<Array<InputMaybe<TdrAccountRequestType>>>
}

export type GetTdrAccountRequestsForUserResponse =
   | GetTdrAccountRequestsForUserResult
   | InvalidLimit
   | InvalidOffset

export type GetTdrAccountRequestsForUserResult = {
   __typename?: 'GetTDRAccountRequestsForUserResult'
   requests: Array<TdrAccountRequest>
   totalCount: Scalars['Int']
}

export type GetTdrAccountResponse =
   | GetTdrAccountResult
   | TdrAccountAccessDenied
   | TdrAccountNotFound

export type GetTdrAccountResult = {
   __typename?: 'GetTDRAccountResult'
   account: TdrAccount
}

export type GetTdrAccountsForHolderUserParams = {
   pagination?: InputMaybe<Pagination>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetTdrAccountsForHolderUserResponse =
   | GetTdrAccountsForHolderUserResult
   | InvalidLimit
   | InvalidOffset

export type GetTdrAccountsForHolderUserResult = {
   __typename?: 'GetTDRAccountsForHolderUserResult'
   accounts: Array<TdrAccount>
   totalCount: Scalars['Int']
}

export type GetTdrAccountsForTdrManagementParams = {
   pagination?: InputMaybe<Pagination>
   searchQuery?: InputMaybe<Scalars['String']>
   status?: InputMaybe<TdrAccountStatus>
}

export type GetTdrAccountsForTdrManagementResponse =
   | GetTdrAccountsForTdrManagementResult
   | InvalidLimit
   | InvalidOffset
   | TdrManagementAccessDenied

export type GetTdrAccountsForTdrManagementResult = {
   __typename?: 'GetTDRAccountsForTDRManagementResult'
   tdrAccounts: Array<TdrAccount>
   totalCount: Scalars['Int']
}

export type GetTdrOrdersInPipelineItemParams = {
   pipelineItemId: Scalars['String']
}

export type GetTdrOrdersInPipelineItemResponse =
   | GetTdrOrdersInPipelineItemResult
   | PipelineItemNotFound

export type GetTdrOrdersInPipelineItemResult = {
   __typename?: 'GetTDROrdersInPipelineItemResult'
   tdrOrders: Array<TdrOrder>
}

export type GetTdrPaymentsForTdrOrderInPortalParams = {
   portalId: Scalars['String']
   portalType: PortalType
   tdrOrderId: Scalars['String']
}

export type GetTdrPaymentsForTdrOrderInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | GetTdrPaymentsForTdrOrderInPortalResult
   | PortalNotFound
   | TdrOrderNotFound

export type GetTdrPaymentsForTdrOrderInPortalResult = {
   __typename?: 'GetTDRPaymentsForTDROrderInPortalResult'
   tdrPayments: Array<TdrPayment>
}

export type GetTGbPassApplicationIdByFileNumberResponse =
   | FileNumberNotFound
   | GetTGbPassApplicationIdByFileNumberResult

export type GetTGbPassApplicationTabDetailsParams = {
   applicationId: Scalars['String']
   tabType: TGbPassTabTypeEnum
}

export type GetTGbPassApplicationTabDetailsResponse =
   | GetTGbPassApplicationTabDetailsResult
   | InvalidApplicationId

export type GetTGbPassApplicationTabDetailsResult = {
   __typename?: 'GetTGbPASSApplicationTabDetailsResult'
   tabDetails: Scalars['String']
}

export type GetTGbPassApplicationTabsParams = {
   applicationId: Scalars['String']
}

export type GetTGbPassApplicationTabsResponse =
   | GetTGbPassApplicationTabsResult
   | InvalidApplicationId

export type GetTGbPassApplicationTabsResult = {
   __typename?: 'GetTGbPASSApplicationTabsResult'
   fileNo: Scalars['String']
   tabs: Array<TGbPassTab>
}

export type GetTGbPassApplicationsFiltersParams = {
   approvedOrRejectedOn?: InputMaybe<Scalars['String']>
   authority?: InputMaybe<Authority>
   projectType?: InputMaybe<Scalars['String']>
   submittedOn?: InputMaybe<Scalars['String']>
}

export type GetTGbPassApplicationsParams = {
   applicationType?: InputMaybe<TGbPassApplicationTypeEnum>
   filters?: InputMaybe<GetTGbPassApplicationsFiltersParams>
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetTGbPassApplicationsResponse =
   | GetTGbPassApplicationsResult
   | InvalidLimit
   | InvalidOffset

export type GetTGbPassApplicationsResult = {
   __typename?: 'GetTGbPASSApplicationsResult'
   applications: Array<TGbPassApplication>
   totalCount: Scalars['Int']
}

export type GetTGbPassApplicationIdByFileNumberParams = {
   fileNumber: Scalars['String']
}

export type GetTGbPassApplicationIdByFileNumberResult = {
   __typename?: 'GetTGbPassApplicationIdByFileNumberResult'
   applicationId: Scalars['String']
}

export type GetTGbPassFileNumberIsValidParams = {
   fileNumber: Scalars['String']
}

export type GetTGbPassFileNumberValid = {
   __typename?: 'GetTGbPassFileNumberValid'
   isValid: Scalars['Boolean']
}

export type GetTableParams = {
   graphId: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
   rowPagination: Pagination
   sortValues?: InputMaybe<TableSort>
}

export type GetTaskAddAnotherFieldsParams = {
   fieldIds: Array<Scalars['String']>
   gofResponseIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type GetTaskAddAnotherFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | GetTaskAddAnotherGoFsFieldsResult
   | GoFResponseIdsNotFound
   | NotAddAnotherFields
   | NotPermittedFields
   | NotTaskAddAnotherGoFResponsesBulk
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound

export type GetTaskAddAnotherGoFsFieldsParams = {
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type GetTaskAddAnotherGoFsFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | GetTaskAddAnotherGoFsFieldsResult
   | GoFsAreDeleted
   | GoFsNotFound
   | NotAddAnotherGoFs
   | NotPermittedFields
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound

export type GetTaskAddAnotherGoFsFieldsResult = {
   __typename?: 'GetTaskAddAnotherGoFsFieldsResult'
   gofResponses: Array<AddAnotherGoFResult>
   taskId: Scalars['String']
}

export type GetTaskFieldsParams = {
   fieldIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type GetTaskFieldsResponse =
   | GetTaskFieldsResult
   | TaskDiscarded
   | TaskNotFound

export type GetTaskFieldsResult = {
   __typename?: 'GetTaskFieldsResult'
   fields: Array<TaskFieldResult>
}

export type GetTaskGeneratedOverallRemarksParams = {
   taskId: Scalars['String']
}

export type GetTaskGeneratedRemarksResponse =
   | TaskAccessDenied
   | TaskDiscarded
   | TaskGeneratedOverallRemarks
   | TaskNotFound

export type GetTaskShortfallTaskTemplatesParams = {
   pipelineItemId: Scalars['String']
}

export type GetTaskShortfallTaskTemplatesResponse =
   | ApplicationManagementAccessDenied
   | GetTaskShortfallTaskTemplatesResult
   | PipelineItemNotFound

export type GetTaskShortfallTaskTemplatesResult = {
   __typename?: 'GetTaskShortfallTaskTemplatesResult'
   taskTemplates: Array<TaskShortfallTaskTemplate>
}

export type GetTaskTemplatesIdentificationsParams = {
   taskTemplateIds: Array<Scalars['String']>
}

export type GetTaskTemplatesIdentificationsResponse =
   | GetTaskTemplatesIdentificationsResult
   | TaskTemplatesNotFound
   | UserIsNotAnAdministrator

export type GetTaskTemplatesIdentificationsResult = {
   __typename?: 'GetTaskTemplatesIdentificationsResult'
   taskTemplatesIdentifications: Array<TaskTemplateIdentifications>
}

export type GetTasksParams = {
   taskIds: Array<Scalars['String']>
}

export type GetTasksWithFiltersParams = {
   date: Scalars['String']
   endTime?: InputMaybe<Scalars['String']>
   filters: Array<TasksFilterParams>
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   startTime?: InputMaybe<Scalars['String']>
}

export type GetTasksWithFiltersResponse =
   | GetTasksWithFiltersResult
   | InvalidLimit
   | InvalidOffset
   | InvalidTaskTemplateIds
   | PaginationLimitExceeded
   | PipelinesAccessDenied
   | PipelinesNotFound

export type GetTasksWithFiltersResult = {
   __typename?: 'GetTasksWithFiltersResult'
   tasks: Array<TaskWithPipelineItemBaseDetails>
   totalCount: Scalars['Int']
}

export type GetTdrManagementLogsParams = {
   filters?: InputMaybe<TdrManagementLogFilters>
   pagination?: InputMaybe<Pagination>
}

export type GetTdrManagementLogsResponse =
   | GetTdrManagementLogsResult
   | InvalidLimit
   | InvalidOffset
   | TdrManagementAccessDenied

export type GetTdrManagementLogsResult = {
   __typename?: 'GetTdrManagementLogsResult'
   logs: Array<TdrManagementLog>
   totalCount: Scalars['Int']
}

export type GetTemplateEntityVisibilityRulesInPortalParams = {
   entityTypes: Array<RuleEntityType>
   pipelineItemTemplateId: Scalars['String']
   portalId: Scalars['String']
}

export type GetTemplateEntityVisibilityRulesInPortalResponse =
   | GetTemplateEntityVisibilityRulesInPortalResult
   | PipelineItemTemplateNotFound
   | PipelineItemTemplateNotInPortal
   | PortalNotFound

export type GetTemplateEntityVisibilityRulesInPortalResult = {
   __typename?: 'GetTemplateEntityVisibilityRulesInPortalResult'
   rules: Array<Rule>
}

export type GetTemplateEntityVisibilityRulesParams = {
   entityTypes: Array<RuleEntityType>
   pipelineItemTemplateId: Scalars['String']
}

export type GetTemplateEntityVisibilityRulesResponse =
   | GetTemplateEntityVisibilityRulesResult
   | PipelineItemTemplateNotFound

export type GetTemplateEntityVisibilityRulesResult = {
   __typename?: 'GetTemplateEntityVisibilityRulesResult'
   rules: Array<Rule>
}

export type GetTemplateGoFVisibilityRulesInPortalParams = {
   pipelineItemTemplateId: Scalars['String']
   portalId: Scalars['String']
}

export type GetTemplateGoFVisibilityRulesInPortalResponse =
   | GetTemplateGoFVisibilityRulesInPortalResult
   | PipelineItemTemplateNotFound
   | PipelineItemTemplateNotInPortal
   | PortalNotFound

export type GetTemplateGoFVisibilityRulesInPortalResult = {
   __typename?: 'GetTemplateGoFVisibilityRulesInPortalResult'
   rules: Array<Rule>
}

export type GetTemplatesForPipelinesParams = {
   pipelineIds: Array<Scalars['String']>
}

export type GetTemplatesInPipelineItemTemplateParams = {
   pipelineItemTemplateId: Scalars['String']
}

export type GetTemplatesInPipelineItemTemplateResponse =
   | PipelineItemTemplateAccessDenied
   | PipelineItemTemplateNotFound
   | TemplatesInPipelineItemTemplate

export type GetTestTransferBankAmountPreviewParams = {
   csvFile: FileUploaderUrlParams
}

export type GetTestTransferBankAmountPreviewResponse =
   | GetTestTransferBankAmountPreviewResult
   | TransferBankAmountPreviewFailed
   | TransferReceiverAccountsMissingBeneId
   | UserIsNotAnAdministrator

export type GetTestTransferBankAmountPreviewResult = {
   __typename?: 'GetTestTransferBankAmountPreviewResult'
   totalAmount: Scalars['Float']
}

export type GetTestTransferBankAmountRequestParams = {
   pagination: Pagination
   status?: InputMaybe<TestTransferBankAmountRequestStatus>
}

export type GetTestTransferBankAmountRequestResponse =
   | GetTestTransferBankAmountRequestResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type GetTestTransferBankAmountRequestResult = {
   __typename?: 'GetTestTransferBankAmountRequestResult'
   items: Array<TestTransferBankAmountRequest>
   totalCount: Scalars['Int']
}

export type GetThreadsForUserParams = {
   entityId: Scalars['String']
   entityType: ThreadEntityType
   pagination: Pagination
}

export type GetThreadsForUserResponse =
   | GetThreadsForUserResponseResult
   | InvalidLimit
   | InvalidOffset
   | ThreadEntityNotFound

export type GetThreadsForUserResponseResult = {
   __typename?: 'GetThreadsForUserResponseResult'
   threads: Array<Thread>
   totalCount: Scalars['Int']
}

export type GetTransactionsForTdrAccountParams = {
   accountId: Scalars['String']
   pagination?: InputMaybe<Pagination>
}

export type GetTransactionsForTdrAccountResponse =
   | GetTransactionsForTdrAccountResult
   | InvalidLimit
   | InvalidOffset
   | TdrAccountAccessDenied
   | TdrAccountNotFound

export type GetTransactionsForTdrAccountResult = {
   __typename?: 'GetTransactionsForTDRAccountResult'
   totalCount: Scalars['Int']
   transactions: Array<TdrAccountTransaction>
}

export type GetTriggerAutomationWorkflowsIdentificationsForActivityTemplatesParams = {
   activityTemplateIds: Array<Scalars['String']>
}

export type GetTriggerAutomationWorkflowsIdentificationsForActivityTemplatesResponse =
   | ActivityTemplatesAccessDenied
   | ActivityTemplatesNotFound
   | ActivityTemplatesNotInAccount
   | GetTriggerAutomationWorkflowsIdentificationsForActivityTemplatesResult
   | UserIsNotAnAdministrator

export type GetTriggerAutomationWorkflowsIdentificationsForActivityTemplatesResult = {
   __typename?: 'GetTriggerAutomationWorkflowsIdentificationsForActivityTemplatesResult'
   activityTemplates: Array<
      ActivityTemplateIdentificationsForTriggerAutomationWorkflows
   >
}

export type GetUnlinkedFieldsParams = {
   pagination?: InputMaybe<Pagination>
   salesTemplateId: Scalars['String']
   salesTemplateType: LinkedFieldsSupportedSalesTemplateType
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetUnlinkedFieldsResponse =
   | GetUnlinkedFieldsResult
   | InvalidLimit
   | InvalidOffset
   | LinkedFieldsNotEnabledForTaskTemplate
   | PaginationLimitExceeded
   | SalesTemplateNotFound
   | UserIsNotAnAdministrator

export type GetUnlinkedFieldsResult = {
   __typename?: 'GetUnlinkedFieldsResult'
   salesTemplateId: Scalars['String']
   salesTemplateType: LinkedFieldsSupportedSalesTemplateType
   totalCount: Scalars['Int']
   unlinkedFields: Array<Field>
}

export type GetUserCloudCallingConfigParams = {
   cloudCallingServiceAccountId: Scalars['String']
   pagination?: InputMaybe<Pagination>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type GetUserCustomPropertiesParams = {
   userId: Scalars['String']
}

export type GetUserCustomPropertiesResponse =
   | GetUserCustomPropertiesResult
   | PropertiesUserAccessDenied
   | PropertiesUserNotFound

export type GetUserCustomPropertiesResult = {
   __typename?: 'GetUserCustomPropertiesResult'
   properties: Array<FieldResponse>
}

export type GetUserDashboardParams = {
   dashboardId: Scalars['String']
}

export type GetUserDashboardsParams = {
   filterByIdentificationIds?: InputMaybe<Array<Scalars['String']>>
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
   userDashboardType: UserDashboardType
}

export type GetUserDashboardsResponse =
   | GetUserDashboardsResult
   | IdentificationsNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineNotFound

export type GetUserDashboardsResult = {
   __typename?: 'GetUserDashboardsResult'
   dashboards: Array<Dashboard>
   totalCount: Scalars['Int']
}

export type GetUserFormattedCustomPropertiesParams = {
   userId: Scalars['String']
}

export type GetUserFormattedCustomPropertiesResponse =
   | GetUserFormattedCustomPropertiesResult
   | PropertiesUserAccessDenied
   | PropertiesUserNotFound

export type GetUserFormattedCustomPropertiesResult = {
   __typename?: 'GetUserFormattedCustomPropertiesResult'
   properties: Array<FormattedFieldResponse>
}

export type GetUserGraphParams = {
   graphId: Scalars['String']
}

export type GetUserGraphsParams = {
   dataSources: Array<AnalyticsDataSourceType>
   pagination: Pagination
   parentId?: InputMaybe<Scalars['String']>
   parentType?: GraphParentType
   pipelineId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
   userGraphType: UserGraphType
}

export type GetUserGraphsResult =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineNotFound
   | UserGraphsResponse
   | ViewAccessDenied
   | ViewNotFound

export type GetUserGroupsForBoardListsParams = {
   listIds: Array<Scalars['String']>
}

export type GetUserGroupsForBoardsParams = {
   boardIds: Array<Scalars['String']>
}

export type GetUserNotificationCountParams = {
   notificationCategory?: InputMaybe<NotificationCategory>
}

export type GetUserNotificationsCountResponse = GetUserNotificationsCountResult

export type GetUserNotificationsCountResult = {
   __typename?: 'GetUserNotificationsCountResult'
   totalCount: Scalars['Int']
}

export type GetUserNotificationsParams = {
   notificationCategory: NotificationCategory
   pagination: Pagination
}

export type GetUserNotificationsResponse =
   | GetUserNotificationsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded

export type GetUserNotificationsResult = {
   __typename?: 'GetUserNotificationsResult'
   notifications: Array<Notification>
   totalCount: Scalars['Int']
}

export type GetUserPinStatusForAdminParams = {
   pinPurpose: PinPurpose
   targetUserId: Scalars['String']
}

export type GetUserPinStatusForAdminResponse =
   | UserIsNotAnAdministrator
   | UserNotFound
   | UserPinExpired
   | UserPinLocked
   | UserPinNotConfigured
   | UserPinStatus

export type GetUserPinStatusParams = {
   pinPurpose: PinPurpose
}

export type GetUserPinStatusResponse =
   | UserPinExpired
   | UserPinLocked
   | UserPinNotConfigured
   | UserPinStatus

export type GetUserPortalSettingsParams = {
   portalId: Scalars['String']
}

export type GetUserPortalSettingsResponse =
   | NotPortalUser
   | PortalNotFound
   | UserPortalSettings

export type GetUsersInAccountParams = {
   applySavedFilters?: InputMaybe<Scalars['Boolean']>
   /** @deprecated Deprecated because of user tab customization */
   managerUserIds?: InputMaybe<Array<Scalars['String']>>
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
   usersFilter?: InputMaybe<UsersFilter>
}

export type GetUsersParams = {
   userIds: Array<Scalars['String']>
}

export type GetUsersTabCustomizationResponse =
   | UserIsNotAnAdministrator
   | UsersTabCustomizationFilters

export type GetViewFiltersParams = {
   viewId: Scalars['String']
}

export type GetViewFiltersResponse =
   | FiltersResult
   | ViewAccessDenied
   | ViewNotFound

export type GetViewsInBoardsAndListsParams = {
   boardId: Scalars['String']
}

export type GetViewsParams = {
   viewIds: Array<Scalars['String']>
}

export type GetWatiAccountPluginServiceAccountsParams = {
   accountPluginId: Scalars['String']
   pagination: Pagination
}

export type GetWatiAccountPluginServiceAccountsResponse =
   | AccountPluginIdNotFound
   | GetWatiAccountPluginServiceAccountsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type GetWatiAccountPluginServiceAccountsResult = {
   __typename?: 'GetWatiAccountPluginServiceAccountsResult'
   totalCount: Scalars['Int']
   watiAccounts: Array<WatiAccount>
}

export type GetWatiPluginServiceAccountsParams = {
   pluginServiceAccountIds: Array<Scalars['String']>
}

export type GetWatiPluginServiceAccountsResponse =
   | UserIsNotAnAdministrator
   | WatiServiceAccounts

export type GetWhatsAppAccountMessageTemplatesForAdminParams = {
   pagination: Pagination
   pluginServiceAccountId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
   whatsappBusinessPhoneNumberId?: InputMaybe<Scalars['String']>
}

export type GetWhatsAppAccountMessageTemplatesForAdminResponse =
   | GetAdminWhatsAppAccountMessageTemplatesResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator
   | WhatsAppBusinessPhoneNumberNotFound

export type GetWhatsAppBusinessNumbersParams = {
   pagination: Pagination
   pluginServiceAccountId: Scalars['String']
}

export type GetWhatsAppBusinessNumbersResponse =
   | GetWhatsAppBusinessNumbersResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator

export type GetWhatsAppBusinessNumbersResult = {
   __typename?: 'GetWhatsAppBusinessNumbersResult'
   totalCount?: Maybe<Scalars['Int']>
   whatsappBusinessNumbers: Array<WhatsAppBusinessNumber>
}

export type GetWhatsAppBusinessPhoneNumberMessageTemplatesForPipelineItemParams = {
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type GetWhatsAppBusinessPhoneNumberMessageTemplatesForPipelineItemResponse =
   | GetWhatsAppBusinessPhoneNumberMessageTemplatesForPipelineItemResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineWhatsAppBusinessPhoneNumberAccessDenied
   | WhatsAppBusinessPhoneNumberNotFound
   | WhatsAppBusinessPhoneNumberNotLinkedToPipeline

export type GetWhatsAppBusinessPhoneNumberMessageTemplatesForPipelineItemResult = {
   __typename?: 'GetWhatsAppBusinessPhoneNumberMessageTemplatesForPipelineItemResult'
   messageTemplates: Array<PipelineItemMessageTemplate>
   totalCount: Scalars['Int']
}

export type GetWhatsAppBusinessPhoneNumbersParams = {
   pagination?: InputMaybe<Pagination>
   pluginServiceAccountId: Scalars['String']
}

export type GetWhatsAppBusinessPhoneNumbersResponse =
   | GetWhatsAppBusinessPhoneNumbersResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator

export type GetWhatsAppBusinessPhoneNumbersResult = {
   __typename?: 'GetWhatsAppBusinessPhoneNumbersResult'
   totalCount: Scalars['Int']
   whatsappBusinessPhoneNumbers: Array<WhatsAppBusinessPhoneNumber>
}

export type GivenFieldIsNotAvailTdrCreditsField = GraphQlBaseError & {
   __typename?: 'GivenFieldIsNotAvailTDRCreditsField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GivenFieldIsNotSurveyNumberField = GraphQlBaseError & {
   __typename?: 'GivenFieldIsNotSurveyNumberField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GivenFieldIsNotTdrSalesAndTransferField = GraphQlBaseError & {
   __typename?: 'GivenFieldIsNotTDRSalesAndTransferField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GivenNonExistingDependentFieldIds = GraphQlBaseError & {
   __typename?: 'GivenNonExistingDependentFieldIds'
   dependentFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GivenPipelineIsNotAllowedForApplication = GraphQlBaseError & {
   __typename?: 'GivenPipelineIsNotAllowedForApplication'
   message: Scalars['String']
   pipelineId: Scalars['String']
}

export type GoF = {
   __typename?: 'GoF'
   activeFieldsCount: Scalars['Int']
   addAnotherGofResponsesLimit?: Maybe<Scalars['Int']>
   category: GoFCategory
   dependentFieldIds: Array<Scalars['String']>
   description?: Maybe<Scalars['String']>
   enableAddAnother: Scalars['Boolean']
   fields: Array<Field>
   gofId: Scalars['String']
   name: Scalars['String']
   orderedFieldIds: Array<Scalars['String']>
}

export type GoFAccessDenied = GraphQlBaseError & {
   __typename?: 'GoFAccessDenied'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum GoFCategory {
   CustomGof = 'CUSTOM_GOF',
   SystemGof = 'SYSTEM_GOF'
}

export type GoFDeletedFields = {
   __typename?: 'GoFDeletedFields'
   fields: Array<Field>
   gofId: Scalars['String']
   orderedFieldIds: Array<Scalars['String']>
}

export type GoFDeletedFieldsResult =
   | GoFDeletedFields
   | GoFNotFound
   | UserIsNotAnAdministrator

export type GoFFieldsParams = {
   fieldIds: Array<Scalars['String']>
   gofId: Scalars['String']
}

export type GoFIdRequiredWhenAreaFieldProvided = GraphQlBaseError & {
   __typename?: 'GoFIdRequiredWhenAreaFieldProvided'
   areaFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GoFIdRequiredWhenConcatenatedFieldProvided = GraphQlBaseError & {
   __typename?: 'GoFIdRequiredWhenConcatenatedFieldProvided'
   concatenatedFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GoFIsDeleted = GraphQlBaseError & {
   __typename?: 'GoFIsDeleted'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GoFMismatchFields = GraphQlBaseError & {
   __typename?: 'GoFMismatchFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GoFNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'GoFNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type GoFNotFound = GraphQlBaseError & {
   __typename?: 'GoFNotFound'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GoFNotFoundInPortalApplicationTab = GraphQlBaseError & {
   __typename?: 'GoFNotFoundInPortalApplicationTab'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type GoFResponse = {
   __typename?: 'GoFResponse'
   fieldResponses: Array<FieldResponse>
   gofId: Scalars['String']
   gofResponseId: Scalars['String']
   order: Scalars['Int']
}

export type GoFResponseFieldIds = {
   __typename?: 'GoFResponseFieldIds'
   fieldIds: Array<Scalars['String']>
   gofId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
}

export type GoFResponseIdNotFound = GraphQlBaseError & {
   __typename?: 'GoFResponseIdNotFound'
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GoFResponseIdRequiredForAddAnotherField = GraphQlBaseError & {
   __typename?: 'GoFResponseIdRequiredForAddAnotherField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GoFResponseIdsNotFound = GraphQlBaseError & {
   __typename?: 'GoFResponseIdsNotFound'
   gofResponseIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GoFResponseIsAlreadyDeleted = GraphQlBaseError & {
   __typename?: 'GoFResponseIsAlreadyDeleted'
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GoFResult = GoF | GoFNotFound | UserIsNotAnAdministrator

export type GoFSurveyNumberRemarkEntry = {
   __typename?: 'GoFSurveyNumberRemarkEntry'
   gofResponseId: Scalars['String']
   remarks?: Maybe<SurveyNumberRemarkEnum>
   surveyNumber?: Maybe<Scalars['String']>
   surveyNumberFieldId: Scalars['String']
}

export type GoFVisibility = {
   __typename?: 'GoFVisibility'
   gofId: Scalars['String']
   isVisible: Scalars['Boolean']
}

export type GoFWithoutPermission = {
   __typename?: 'GoFWithoutPermission'
   category: GoFCategory
   description?: Maybe<Scalars['String']>
   fields: Array<Field>
   gofId: Scalars['String']
   name: Scalars['String']
   orderedFieldIds: Array<Scalars['String']>
}

export type GoFsAreDeleted = GraphQlBaseError & {
   __typename?: 'GoFsAreDeleted'
   gofIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GoFsAreNotBelongsToSameTemplate = GraphQlBaseError & {
   __typename?: 'GoFsAreNotBelongsToSameTemplate'
   gofIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GoFsAreNotDeleted = GraphQlBaseError & {
   __typename?: 'GoFsAreNotDeleted'
   gofIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GoFsAreNotSupportedForLayoutEntity = GraphQlBaseError & {
   __typename?: 'GoFsAreNotSupportedForLayoutEntity'
   gofIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GoFsInputArgs = {
   gofIds: Array<Scalars['String']>
}

export type GoFsNotFound = GraphQlBaseError & {
   __typename?: 'GoFsNotFound'
   gofIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GoFsNotFoundInPortalApplicationTab = GraphQlBaseError & {
   __typename?: 'GoFsNotFoundInPortalApplicationTab'
   gofIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type GoFsNotInPipeline = GraphQlBaseError & {
   __typename?: 'GoFsNotInPipeline'
   gofIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type GofAlreadyExistsInPortalApplicationTab = GraphQlBaseError & {
   __typename?: 'GofAlreadyExistsInPortalApplicationTab'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type GofNotSupportedForLinkedField = GraphQlBaseError & {
   __typename?: 'GofNotSupportedForLinkedField'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum GoogleAuthClientType {
   Android = 'ANDROID',
   Web = 'WEB'
}

export type GoogleAuthConsentNotGiven = GraphQlBaseError & {
   __typename?: 'GoogleAuthConsentNotGiven'
   message?: Maybe<Scalars['String']>
}

export type GoogleAuthConsentRefreshRequired = GraphQlBaseError & {
   __typename?: 'GoogleAuthConsentRefreshRequired'
   message?: Maybe<Scalars['String']>
}

export type GoogleCalendarApiRequestsQuotaExceeded = GraphQlBaseError & {
   __typename?: 'GoogleCalendarApiRequestsQuotaExceeded'
   message?: Maybe<Scalars['String']>
}

export type GraphAccessDenied = GraphQlBaseError & {
   __typename?: 'GraphAccessDenied'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum GraphAggType {
   DateHistogram = 'DATE_HISTOGRAM',
   DateRange = 'DATE_RANGE',
   Default = 'DEFAULT',
   Histogram = 'HISTOGRAM',
   Range = 'RANGE'
}

export type GraphAndDimensionAreNotLinked = GraphQlBaseError & {
   __typename?: 'GraphAndDimensionAreNotLinked'
   graphDimensionId: Scalars['String']
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GraphCreationNotAllowedInExternalDashboard = GraphQlBaseError & {
   __typename?: 'GraphCreationNotAllowedInExternalDashboard'
   dashboardId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum GraphDataLabelsType {
   None = 'NONE',
   Percentage = 'PERCENTAGE',
   Value = 'VALUE',
   ValueAndPercentage = 'VALUE_AND_PERCENTAGE'
}

export type GraphDataSourceFields = {
   __typename?: 'GraphDataSourceFields'
   dataSource: AnalyticsDataSourceType
   dataSourceName: Scalars['String']
   fields: Array<Field>
   salesTemplateId?: Maybe<Scalars['String']>
   salesTemplateName?: Maybe<Scalars['String']>
   salesTemplateType?: Maybe<SalesTemplateType>
}

export type GraphDataSourceFieldsResult = {
   __typename?: 'GraphDataSourceFieldsResult'
   graphDataSourceFields: Array<GraphDataSourceFields>
}

export type GraphDimension = {
   __typename?: 'GraphDimension'
   dataSource: AnalyticsDataSourceType
   field: FieldResult
   graphDimensionId: Scalars['String']
   groupByType: GraphAggType
   histogramInterval?: Maybe<Scalars['String']>
   name: Scalars['String']
   ranges: Array<RangeResponse>
   sortValue?: Maybe<SortValue>
}

export type GraphDimensionFieldsShouldBeUnique = GraphQlBaseError & {
   __typename?: 'GraphDimensionFieldsShouldBeUnique'
   message?: Maybe<Scalars['String']>
}

export type GraphDimensionNotFound = GraphQlBaseError & {
   __typename?: 'GraphDimensionNotFound'
   graphDimensionId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GraphDimensionParams = {
   dataSource: AnalyticsDataSourceType
   fieldId: Scalars['String']
   groupByType: GraphAggType
   histogramInterval?: InputMaybe<Scalars['String']>
   name?: InputMaybe<Scalars['String']>
   ranges?: InputMaybe<Array<InputMaybe<Range>>>
   sortValue?: InputMaybe<SortValue>
}

export type GraphDimensionValue =
   | BaseActivityTemplate
   | BaseTaskTemplate
   | BaseUser
   | GqlStringType
   | Stage

export type GraphFieldAlreadyExists = GraphQlBaseError & {
   __typename?: 'GraphFieldAlreadyExists'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GraphFieldDataSourceAlreadyExists = GraphQlBaseError & {
   __typename?: 'GraphFieldDataSourceAlreadyExists'
   dataSource: AnalyticsDataSourceType
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GraphFieldsAlreadyExists = GraphQlBaseError & {
   __typename?: 'GraphFieldsAlreadyExists'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GraphHasMultipleDimensions = GraphQlBaseError & {
   __typename?: 'GraphHasMultipleDimensions'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GraphHasMultipleMetrics = GraphQlBaseError & {
   __typename?: 'GraphHasMultipleMetrics'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GraphIsNotLinkedToDashboard = GraphQlBaseError & {
   __typename?: 'GraphIsNotLinkedToDashboard'
   dashboardId: Scalars['String']
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GraphIsNotLinkedToView = GraphQlBaseError & {
   __typename?: 'GraphIsNotLinkedToView'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export type GraphMetric = {
   __typename?: 'GraphMetric'
   canShowMetric: Scalars['Boolean']
   dataSource?: Maybe<AnalyticsDataSourceType>
   field?: Maybe<FieldResult>
   filterSetId: Scalars['String']
   formulaNodes?: Maybe<Array<MetricFormulaNode>>
   metricId: Scalars['String']
   metricType: MetricType
   name: Scalars['String']
   order: Scalars['Int']
}

export type GraphMetricNotFound = GraphQlBaseError & {
   __typename?: 'GraphMetricNotFound'
   message?: Maybe<Scalars['String']>
   metricId: Scalars['String']
}

export type GraphMetricParams = {
   dataSource: AnalyticsDataSourceType
   fieldId: Scalars['String']
   metricType: MetricType
   name?: InputMaybe<Scalars['String']>
}

export type GraphMetricValue = {
   __typename?: 'GraphMetricValue'
   displayValue: Scalars['String']
   metricId: Scalars['String']
   name: Scalars['String']
   value: Scalars['String']
}

export type GraphNameIsRequired = GraphQlBaseError & {
   __typename?: 'GraphNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type GraphNotFound = GraphQlBaseError & {
   __typename?: 'GraphNotFound'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum GraphParentType {
   AnalyticsBuilder = 'ANALYTICS_BUILDER',
   Dashboard = 'DASHBOARD',
   View = 'VIEW'
}

export type GraphQlBaseError = {
   message?: Maybe<Scalars['String']>
}

export type GraphQuickFilterField = {
   __typename?: 'GraphQuickFilterField'
   dataSource: AnalyticsDataSourceType
   field: FieldResult
   graphId: Scalars['String']
   graphQuickFilterFieldId: Scalars['String']
}

export type GraphQuickFilterFieldNotFound = GraphQlBaseError & {
   __typename?: 'GraphQuickFilterFieldNotFound'
   graphQuickFilterFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type GraphQuickFilterFields = {
   __typename?: 'GraphQuickFilterFields'
   quickFilterFields: Array<GraphQuickFilterField>
}

export type GraphQuickFilterFieldsNotFound = GraphQlBaseError & {
   __typename?: 'GraphQuickFilterFieldsNotFound'
   graphQuickFilterFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GraphResult =
   | BarGraphConfig
   | DonutChartConfig
   | FunnelGraphConfig
   | GraphAccessDenied
   | GraphNotFound
   | LineGraphConfig
   | PieChartConfig
   | PivotTableGraphConfig
   | ScorecardChartConfig
   | TableGraphConfig

export type GraphShouldHaveAtLeastOneDimension = GraphQlBaseError & {
   __typename?: 'GraphShouldHaveAtLeastOneDimension'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum GraphType {
   Bar = 'BAR',
   Donut = 'DONUT',
   Funnel = 'FUNNEL',
   Line = 'LINE',
   Pie = 'PIE',
   PivotTable = 'PIVOT_TABLE',
   Scorecard = 'SCORECARD',
   Table = 'TABLE'
}

export enum GraphqlApiVersionEnum {
   Default = 'DEFAULT',
   V2 = 'V2'
}

export type Graphs =
   | BarGraphConfig
   | DonutChartConfig
   | FunnelGraphConfig
   | LineGraphConfig
   | PieChartConfig
   | PivotTableGraphConfig
   | ScorecardChartConfig
   | TableGraphConfig

export type GraphsAccessDenied = GraphQlBaseError & {
   __typename?: 'GraphsAccessDenied'
   graphIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GraphsInView = {
   __typename?: 'GraphsInView'
   graphs: Array<UserGraph>
   totalGraphs: Scalars['Int']
}

export type GraphsNotFound = GraphQlBaseError & {
   __typename?: 'GraphsNotFound'
   graphIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GraphsNotInViewPipeline = GraphQlBaseError & {
   __typename?: 'GraphsNotInViewPipeline'
   graphIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type GroupedBarGraphConfig = {
   __typename?: 'GroupedBarGraphConfig'
   analyticsLevel: AnalyticsLevel
   dataSources: Array<AnalyticsDataSourceType>
   dataSourcesWithDisplayNames: Array<DataSourceDisplayName>
   description?: Maybe<Scalars['String']>
   filterSetId: Scalars['String']
   firstDimension: GraphDimension
   graphId: Scalars['String']
   isOwner: Scalars['Boolean']
   metric: GraphMetric
   name: Scalars['String']
   pipelineId: Scalars['String']
   quickFilterFields: Array<GraphQuickFilterField>
   roles: Array<Role>
   secondDimension: GraphDimension
}

export type GroupsInGoF = {
   __typename?: 'GroupsInGoF'
   fieldIds: Array<Scalars['String']>
   name: Scalars['String']
}

export type GroupsInPortalApplicationTabGoF = {
   __typename?: 'GroupsInPortalApplicationTabGoF'
   fieldIds: Array<Scalars['String']>
   name: Scalars['String']
}

export type GupShupAccount = BasePluginServiceAccount & {
   __typename?: 'GupShupAccount'
   creationDatetime: Scalars['String']
   enableReadReceipts: Scalars['Boolean']
   encryptionKey?: Maybe<Scalars['String']>
   isActive: Scalars['Boolean']
   isEncryptionEnabled: Scalars['Boolean']
   name: Scalars['String']
   password: Scalars['String']
   pluginServiceAccountId: Scalars['String']
   userId: Scalars['String']
   webhookUrl?: Maybe<Scalars['String']>
}

export type GupShupAccountNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'GupShupAccountNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type GupShupAccountResult = GupShupAccount | PluginServiceAccountNotFound

export type GupShupServiceAccounts = {
   __typename?: 'GupShupServiceAccounts'
   gupshupAccounts: Array<GupShupAccountResult>
}

export type HasSameFieldReferenceIdsInContactAndLead = GraphQlBaseError & {
   __typename?: 'HasSameFieldReferenceIdsInContactAndLead'
   message?: Maybe<Scalars['String']>
}

export type Header = {
   __typename?: 'Header'
   key: Scalars['String']
   value: Scalars['String']
   valueFrom: WebhookNodeHeaderFieldSourceType
}

export type HeaderParams = {
   key: Scalars['String']
   value: Scalars['String']
   valueFrom: WebhookNodeHeaderFieldSourceType
}

export enum HelpTextType {
   Default = 'DEFAULT',
   Warning = 'WARNING'
}

export type HistoryLogsTab = BaseTab & {
   __typename?: 'HistoryLogsTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type HoldTdrAccountParams = {
   accountId: Scalars['String']
   attachments?: InputMaybe<Array<InputMaybe<TdrManagementAttachmentParams>>>
   otp: Scalars['String']
   reason: Scalars['String']
   shouldSendNotificationToOwner: Scalars['Boolean']
}

export type HoldTdrAccountResponse =
   | HoldTdrAccountResult
   | InvalidOtp
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | TdrAccountAlreadyOnHold
   | TdrAccountHasActiveChildAccounts
   | TdrAccountNotFound
   | TdrManagementAccessDenied

export type HoldTdrAccountResult = {
   __typename?: 'HoldTdrAccountResult'
   accountId: Scalars['String']
   reason: Scalars['String']
}

export type IconConfig = {
   __typename?: 'IconConfig'
   color: Scalars['String']
   iconId: Scalars['String']
}

export type IconConfigParams = {
   color: Scalars['String']
   iconId: Scalars['String']
}

export type IconInfo = {
   __typename?: 'IconInfo'
   iconColor: Scalars['String']
   iconId: Scalars['String']
}

export type IconParams = {
   iconColor: Scalars['String']
   iconId: Scalars['String']
}

export type Identification = RoleConfig | UserGroupConfig

export type IdentificationAndUserAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'IdentificationAndUserAreNotInSameAccount'
   identificationId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type IdentificationDashboardCount = {
   __typename?: 'IdentificationDashboardCount'
   dashboardCount: Scalars['Int']
   identification: Identification
}

export type IdentificationFieldIdsExistsInGoF = GraphQlBaseError & {
   __typename?: 'IdentificationFieldIdsExistsInGoF'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type IdentificationFieldIsNotActivityTemplateField = GraphQlBaseError & {
   __typename?: 'IdentificationFieldIsNotActivityTemplateField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type IdentificationFieldIsNotPhoneNumberField = GraphQlBaseError & {
   __typename?: 'IdentificationFieldIsNotPhoneNumberField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type IdentificationFieldLinkedToActivityTemplates = GraphQlBaseError & {
   __typename?: 'IdentificationFieldLinkedToActivityTemplates'
   activityTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type IdentificationFieldLinkedToForms = GraphQlBaseError & {
   __typename?: 'IdentificationFieldLinkedToForms'
   formIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type IdentificationFieldNotSupportedSalesTemplate = GraphQlBaseError & {
   __typename?: 'IdentificationFieldNotSupportedSalesTemplate'
   message?: Maybe<Scalars['String']>
}

export type IdentificationFieldResponseIsEmpty = GraphQlBaseError & {
   __typename?: 'IdentificationFieldResponseIsEmpty'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type IdentificationFieldsAreOnlySupportedForContactTemplate = GraphQlBaseError & {
   __typename?: 'IdentificationFieldsAreOnlySupportedForContactTemplate'
   message?: Maybe<Scalars['String']>
}

export type IdentificationNameAlreadyExist = GraphQlBaseError & {
   __typename?: 'IdentificationNameAlreadyExist'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type IdentificationNotFound = GraphQlBaseError & {
   __typename?: 'IdentificationNotFound'
   identificationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type IdentificationOverviewDetails = {
   __typename?: 'IdentificationOverviewDetails'
   identificationId: Scalars['String']
   identificationType: IdentificationType
   isFieldExecutionRole: Scalars['Boolean']
   name: Scalars['String']
   profilePicUrl?: Maybe<Scalars['String']>
}

export type IdentificationPipelineActions = {
   __typename?: 'IdentificationPipelineActions'
   actions: Array<PipelineActionType>
   identificationId: Scalars['String']
}

export type IdentificationResponse =
   | IdentificationNameAlreadyExist
   | RoleConfig
   | UserGroupConfig
   | UserIsNotAnAdministrator

export enum IdentificationType {
   Role = 'ROLE',
   UserGroup = 'USER_GROUP'
}

export type IdentificationValueIsMissing = GraphQlBaseError & {
   __typename?: 'IdentificationValueIsMissing'
   message?: Maybe<Scalars['String']>
}

export type IdentificationsInAccountResponse =
   | IdentificationsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator

export type IdentificationsNotFound = GraphQlBaseError & {
   __typename?: 'IdentificationsNotFound'
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type IdentificationsNotSupportedForFormFields = GraphQlBaseError & {
   __typename?: 'IdentificationsNotSupportedForFormFields'
   formFields: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type IdentificationsPipelineActionsExists = GraphQlBaseError & {
   __typename?: 'IdentificationsPipelineActionsExists'
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type IdentificationsResult = {
   __typename?: 'IdentificationsResult'
   identifications: Array<Identification>
   totalCount: Scalars['Int']
}

export type IdentificationsToTriggerAutomationWorkflowsOnActivityExists = GraphQlBaseError & {
   __typename?: 'IdentificationsToTriggerAutomationWorkflowsOnActivityExists'
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type IdentifierFieldIsRequired = GraphQlBaseError & {
   __typename?: 'IdentifierFieldIsRequired'
   formId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type IdentifyEventConfig = {
   __typename?: 'IdentifyEventConfig'
   integrationsConfig?: Maybe<SegmentIntegrationConfig>
   timestampConfig?: Maybe<SegmentEventTimeStampConfig>
   traitsMapping: Array<CustomKeyFieldValueMapping>
   uniqueIdValueConfig?: Maybe<SegmentUniqueIdValueConfig>
}

export type IdentifyEventConfigParams = {
   integrationsConfig?: InputMaybe<SegmentIntegrationConfigParams>
   timestampConfig?: InputMaybe<SegmentEventTimeStampConfigParams>
   traitsMapping: Array<CustomKeyFieldValueMappingParams>
   uniqueIdValueConfig?: InputMaybe<SegmentUniqueIdValueConfigParams>
}

export type InProgressDataLoadingRequestLimitExceeded = GraphQlBaseError & {
   __typename?: 'InProgressDataLoadingRequestLimitExceeded'
   limit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type IncompatibleActivityTemplateWithParent = GraphQlBaseError & {
   __typename?: 'IncompatibleActivityTemplateWithParent'
   message?: Maybe<Scalars['String']>
}

export type IncompatibleUserAccountWithParent = GraphQlBaseError & {
   __typename?: 'IncompatibleUserAccountWithParent'
   message?: Maybe<Scalars['String']>
}

export type IncompleteTriggerConfig = GraphQlBaseError & {
   __typename?: 'IncompleteTriggerConfig'
   message?: Maybe<Scalars['String']>
}

export type InitiateApplicationRefundParams = {
   applicationId: Scalars['String']
}

export type InitiateApplicationRefundResponse =
   | ApplicationAccessDenied
   | ApplicationHasPendingPayments
   | ApplicationHasTdrOrders
   | ApplicationNotEligibleForRefund
   | ApplicationNotFound
   | ApplicationRefundDetails
   | ChallanOrdersInitiatedOnApplication

export enum InitiateDataLoadingActionType {
   CompareFeeRuleSets = 'COMPARE_FEE_RULE_SETS',
   DeleteFieldRoles = 'DELETE_FIELD_ROLES',
   DeleteRecordValidationRules = 'DELETE_RECORD_VALIDATION_RULES',
   ExportFeeEngineVariables = 'EXPORT_FEE_ENGINE_VARIABLES',
   LetterActions = 'LETTER_ACTIONS',
   LoadApplicationIdConfig = 'LOAD_APPLICATION_ID_CONFIG',
   LoadAssignFriendConfiguration = 'LOAD_ASSIGN_FRIEND_CONFIGURATION',
   LoadBigQueryApplicationsBasicOverviewData = 'LOAD_BIG_QUERY_APPLICATIONS_BASIC_OVERVIEW_DATA',
   LoadBoardDefaultProperties = 'LOAD_BOARD_DEFAULT_PROPERTIES',
   LoadBoardPipelineItemCreationPermissions = 'LOAD_BOARD_PIPELINE_ITEM_CREATION_PERMISSIONS',
   LoadBoardViews = 'LOAD_BOARD_VIEWS',
   LoadCardsTableTab = 'LOAD_CARDS_TABLE_TAB',
   LoadCategoryConditions = 'LOAD_CATEGORY_CONDITIONS',
   LoadConditionalFieldOptions = 'LOAD_CONDITIONAL_FIELD_OPTIONS',
   LoadCrmFunctions = 'LOAD_CRM_FUNCTIONS',
   LoadDefaultSectionGofCustomTable = 'LOAD_DEFAULT_SECTION_GOF_CUSTOM_TABLE',
   LoadDocumentTemplates = 'LOAD_DOCUMENT_TEMPLATES',
   LoadDocumentTemplateBlocks = 'LOAD_DOCUMENT_TEMPLATE_BLOCKS',
   LoadEntityHolidaySchedule = 'LOAD_ENTITY_HOLIDAY_SCHEDULE',
   LoadEntityRuleSets = 'LOAD_ENTITY_RULE_SETS',
   LoadEntityWorkSchedule = 'LOAD_ENTITY_WORK_SCHEDULE',
   LoadFeeEngineConfig = 'LOAD_FEE_ENGINE_CONFIG',
   LoadFeeEngineRules = 'LOAD_FEE_ENGINE_RULES',
   LoadFieldRoles = 'LOAD_FIELD_ROLES',
   LoadLayoutDocumentFieldsConfig = 'LOAD_LAYOUT_DOCUMENT_FIELDS_CONFIG',
   LoadLayoutExportNotesConfig = 'LOAD_LAYOUT_EXPORT_NOTES_CONFIG',
   LoadLayoutFeatureToggles = 'LOAD_LAYOUT_FEATURE_TOGGLES',
   LoadLayoutHeaderFields = 'LOAD_LAYOUT_HEADER_FIELDS',
   LoadLeadDistributionRulesConfig = 'LOAD_LEAD_DISTRIBUTION_RULES_CONFIG',
   LoadNumberGenerationConfigs = 'LOAD_NUMBER_GENERATION_CONFIGS',
   LoadObjectionTab = 'LOAD_OBJECTION_TAB',
   LoadOcSiteInspectionTab = 'LOAD_OC_SITE_INSPECTION_TAB',
   LoadPaymentRules = 'LOAD_PAYMENT_RULES',
   LoadPipelineItemDetailsDocumentTemplate = 'LOAD_PIPELINE_ITEM_DETAILS_DOCUMENT_TEMPLATE',
   LoadPipelineItemTasksAssignees = 'LOAD_PIPELINE_ITEM_TASKS_ASSIGNEES',
   LoadPortalCustomSections = 'LOAD_PORTAL_CUSTOM_SECTIONS',
   LoadPortalPipelineDocumentFields = 'LOAD_PORTAL_PIPELINE_DOCUMENT_FIELDS',
   LoadPortalPipelineTabs = 'LOAD_PORTAL_PIPELINE_TABS',
   LoadProposalFlowTabs = 'LOAD_PROPOSAL_FLOW_TABS',
   LoadReconciliationBankAccounts = 'LOAD_RECONCILIATION_BANK_ACCOUNTS',
   LoadReconciliationConfig = 'LOAD_RECONCILIATION_CONFIG',
   LoadReconciliationOnHoldFeeHeaders = 'LOAD_RECONCILIATION_ON_HOLD_FEE_HEADERS',
   LoadRecordValidationsConditions = 'LOAD_RECORD_VALIDATIONS_CONDITIONS',
   LoadRecordValidationsRules = 'LOAD_RECORD_VALIDATIONS_RULES',
   LoadRuleActions = 'LOAD_RULE_ACTIONS',
   LoadRvrCriteria = 'LOAD_RVR_CRITERIA',
   LoadRvrCriteriaConditions = 'LOAD_RVR_CRITERIA_CONDITIONS',
   LoadRvrCriteriaMapping = 'LOAD_RVR_CRITERIA_MAPPING',
   LoadShortTextPrefixConditionalOptions = 'LOAD_SHORT_TEXT_PREFIX_CONDITIONAL_OPTIONS',
   LoadSiteInspectionTab = 'LOAD_SITE_INSPECTION_TAB',
   LoadStageCompletionTabs = 'LOAD_STAGE_COMPLETION_TABS',
   LoadStagePermittedDocuments = 'LOAD_STAGE_PERMITTED_DOCUMENTS',
   LoadStagePermittedTabs = 'LOAD_STAGE_PERMITTED_TABS',
   LoadStageSlaFields = 'LOAD_STAGE_SLA_FIELDS',
   LoadStageTransitionFunctions = 'LOAD_STAGE_TRANSITION_FUNCTIONS',
   LoadStageTransitionSuccessPopupConfig = 'LOAD_STAGE_TRANSITION_SUCCESS_POPUP_CONFIG',
   LoadStageTransitionSummaryConfig = 'LOAD_STAGE_TRANSITION_SUMMARY_CONFIG',
   LoadSurveyNumbers = 'LOAD_SURVEY_NUMBERS',
   LoadTabs = 'LOAD_TABS',
   LoadTabGofCustomTable = 'LOAD_TAB_GOF_CUSTOM_TABLE',
   LoadTabGofGroups = 'LOAD_TAB_GOF_GROUPS',
   LoadTabGofMultipleTables = 'LOAD_TAB_GOF_MULTIPLE_TABLES',
   LoadTaskAssigneeConfigs = 'LOAD_TASK_ASSIGNEE_CONFIGS',
   LoadTaskTableTab = 'LOAD_TASK_TABLE_TAB',
   LoadTdrRequestAutomationConfig = 'LOAD_TDR_REQUEST_AUTOMATION_CONFIG',
   LoadTdrRequestDisplayStageConfig = 'LOAD_TDR_REQUEST_DISPLAY_STAGE_CONFIG',
   LoadTdrRequestPipelineItemTemplateConfig = 'LOAD_TDR_REQUEST_PIPELINE_ITEM_TEMPLATE_CONFIG',
   LoadTeamsData = 'LOAD_TEAMS_DATA',
   LoadTemplateBoards = 'LOAD_TEMPLATE_BOARDS',
   LoadTgBPassApplications = 'LOAD_TG_B_PASS_APPLICATIONS',
   LoadUsernames = 'LOAD_USERNAMES',
   LoadViews = 'LOAD_VIEWS',
   LoadViewAndEditSanctionDetailsConfig = 'LOAD_VIEW_AND_EDIT_SANCTION_DETAILS_CONFIG',
   MoveApplicationOrders = 'MOVE_APPLICATION_ORDERS',
   UpdatePipelineConfig = 'UPDATE_PIPELINE_CONFIG'
}

export type InitiateDataLoadingRequestFromCsvParams = {
   actionType: InitiateDataLoadingActionType
   crmTemplateId: Scalars['String']
   dataFile: FileUploaderUrlParams
}

export type InitiateDataLoadingRequestFromCsvResponse =
   | CsvDataLoadingRequest
   | CrmTemplateNotFound
   | DuplicateColumnHeaders
   | FieldReferenceIdsExistsInMultipleTemplates
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InvalidPopulationData
   | NoEntriesFoundInCsv
   | RecordsLimitExceeded
   | UserIsNotAnAdministrator

export type InitiateDeactivateUserInProgress = GraphQlBaseError & {
   __typename?: 'InitiateDeactivateUserInProgress'
   existingRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type InitiateDeactivateUserParams = {
   reason?: InputMaybe<Scalars['String']>
   targetUserId: Scalars['String']
   userId: Scalars['String']
}

export type InitiateDeactivateUserRequest = BaseOfficerManagementRequest & {
   __typename?: 'InitiateDeactivateUserRequest'
   accountId: Scalars['String']
   applicationsCount?: Maybe<Scalars['Int']>
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   errorMessage?: Maybe<Scalars['String']>
   estimatedCompletionTime?: Maybe<Scalars['String']>
   failedApplications?: Maybe<Scalars['Int']>
   id: Scalars['String']
   initiatedBy: Scalars['String']
   initiatedUser: User
   operationType: OfficerManagementOperationType
   processedApplications?: Maybe<Scalars['Int']>
   progressPercentage?: Maybe<Scalars['Float']>
   reason?: Maybe<Scalars['String']>
   status: OfficerManagementStatusType
   targetUser: User
   targetUserId: Scalars['String']
   targetUsername?: Maybe<Scalars['String']>
   updatedAt: Scalars['String']
   user: User
   userId: Scalars['String']
}

export type InitiateDeactivateUserResponse =
   | EmailNotFoundForOfficer
   | InitiateDeactivateUserInProgress
   | InitiateDeactivateUserResult
   | InvalidInitiateDeactivateUserOperation
   | OfficerManagementAccessDenied
   | UsernameNotFound

export type InitiateDeactivateUserResult = {
   __typename?: 'InitiateDeactivateUserResult'
   request: InitiateDeactivateUserRequest
   requestId: Scalars['String']
}

export type InitiateLeadDistributionRuleParams = {
   leadDistributionRuleId: Scalars['String']
}

export type InitiateLeadDistributionRuleResponse =
   | ActiveLeadDistributionExistsWithLeadAssigneeField
   | EventBasedLeadDistributionRuleIsNotSupported
   | InitiateLeadDistributionRuleResult
   | LeadDistributionRuleNotFound
   | NoLeadsExistsInLeadDistributionRule
   | NoPublishedVersionExistsForLeadDistributionRule
   | PartiallyConfiguredLeadDistributionStepsExists
   | UserIsNotAnAdministrator

export type InitiateLeadDistributionRuleResult = {
   __typename?: 'InitiateLeadDistributionRuleResult'
   leadDistributionRuleId: Scalars['String']
}

export type InitiateLeadOnActivityParams = {
   activityId: Scalars['String']
   identificationPhoneNumberFieldId: Scalars['String']
}

export type InitiateLeadOnActivityResponse =
   | ActivityAccessDenied
   | ActivityNotFound
   | FieldIsDeleted
   | FieldNotFound
   | IdentificationFieldIsNotActivityTemplateField
   | IdentificationFieldIsNotPhoneNumberField
   | IdentificationFieldResponseIsEmpty
   | InitiateLeadOnActivityResult
   | LeadAccessDenied
   | LeadIsDeleted
   | UserCannotInitiateLead

export type InitiateLeadOnActivityResult = {
   __typename?: 'InitiateLeadOnActivityResult'
   hasPermission: Scalars['Boolean']
   isCreated: Scalars['Boolean']
   leadId: Scalars['String']
   /** @deprecated Support SRMP */
   pipelineId?: Maybe<Scalars['String']>
}

export type InitiateLoadBankAccountParams = {
   csvFile: FileUploaderUrlParams
}

export type InitiateLoadBankAccountResponse =
   | LoadBankAccountRequest
   | UserIsNotAnAdministrator

export type InitiateMandalAssignmentResponse =
   | InitiateMandalAssignmentResult
   | InvalidMandalAssignment
   | MandalAssignmentInProgress
   | OfficerManagementAccessDenied
   | OfficerNotFound
   | UserIsNotAnAdministrator

export type InitiateMandalAssignmentResult = {
   __typename?: 'InitiateMandalAssignmentResult'
   request: MandalAssignmentRequest
   requestId: Scalars['String']
}

export type InitiateOfficerLeaveParams = {
   officerUserId: Scalars['String']
   reason?: InputMaybe<Scalars['String']>
   replacementOfficerUserId: Scalars['String']
}

export type InitiateOfficerLeaveResponse =
   | EmailNotFoundForOfficer
   | OfficerHasActiveLeave
   | OfficerLeaveLog
   | OfficerManagementAccessDenied
   | ReplacementOfficerHasActiveLeave

export type InitiateOfficerTransferResponse =
   | EmailNotFoundForOfficer
   | InitiateOfficerTransferResult
   | InvalidOfficerTransferOperation
   | OfficerIsDeactivated
   | OfficerManagementAccessDenied
   | OfficerNotFound
   | OfficerTransferInProgress
   | UsernameAlreadyAssigned

export type InitiateOfficerTransferResult = {
   __typename?: 'InitiateOfficerTransferResult'
   request: OfficerTransferRequest
   requestId: Scalars['String']
}

export type InitiatePmuActionParams = {
   applicationId: Scalars['String']
   documents: Array<PmuDocumentInput>
   reason: Scalars['String']
   submittedOverrides: Array<PmuFieldOverrideInput>
}

export type InitiatePmuActionResponse =
   | ActionNotPermitted
   | ApplicationNotFound
   | InitiatePmuActionResult
   | PmuValidationError

export type InitiatePmuActionResult = {
   __typename?: 'InitiatePMUActionResult'
   pmuActionLogId: Scalars['String']
}

export type InitiatePaymentOnPipelineItemParams = {
   paymentId: Scalars['String']
   pipelineItemId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type InitiatePaymentOnPipelineItemResponse =
   | InitiatePaymentOnPipelineItemResult
   | PaymentAccessDenied
   | PaymentAlreadyInitiated
   | PaymentIsInDraftState
   | PaymentNotFound
   | PaymentNotLinkedToPipelineItem
   | PaymentRequestExpired
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | RazorPayNotConfigured
   | RazorPayOrderCreationFailed

export type InitiatePaymentOnPipelineItemResult = {
   __typename?: 'InitiatePaymentOnPipelineItemResult'
   paymentId: Scalars['String']
   pipelineItemId: Scalars['String']
   razorpayKey: Scalars['String']
   razorpayOrderId: Scalars['String']
   status: PaymentStatus
}

export type InitiateReconciliationParams = {
   otp?: InputMaybe<Scalars['String']>
   requestId: Scalars['String']
}

export type InitiateReconciliationResponse =
   | InvalidOtp
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | ReconciliationRequest
   | ReconciliationRequestNotApproved
   | ReconciliationRequestNotFound
   | UserIsNotAnAdministrator

export type InitiateRefundNode = BaseNode & {
   __typename?: 'InitiateRefundNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   feeRuleSet?: Maybe<FeeRuleSet>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
}

export type InitiateRefundNodeExecLog = BaseNodeExecLog & {
   __typename?: 'InitiateRefundNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<InitiateRefundNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type InitiateRefundNodeExecLogResult = {
   __typename?: 'InitiateRefundNodeExecLogResult'
   response: Scalars['String']
}

export type InitiateTestTransferBankAmountParams = {
   csvFile: FileUploaderUrlParams
   otp?: InputMaybe<Scalars['String']>
   requestId?: InputMaybe<Scalars['String']>
}

export type InitiateTestTransferBankAmountResponse =
   | InvalidOtp
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | TestTransferBankAmountRequest
   | TransferBankAmountPreviewFailed
   | TransferReceiverAccountsMissingBeneId
   | UserIsNotAnAdministrator

export type InitiateUpdateUserDetailsResponse =
   | InitiateUpdateUserDetailsResult
   | InvalidDesignationFormat
   | InvalidPhoneNumberFormat
   | InvalidUserDetailsUpdateOperation
   | OfficerManagementAccessDenied
   | OfficerNotFound
   | UserDetailsUpdateInProgress
   | UserIsNotAnAdministrator

export type InitiateUpdateUserDetailsResult = {
   __typename?: 'InitiateUpdateUserDetailsResult'
   request: UpdateUserDetailsRequest
   requestId: Scalars['String']
}

export type InstallmentGroup = {
   __typename?: 'InstallmentGroup'
   amountInInr: Scalars['Float']
   amountSplit: Array<AmountSplitDetails>
   baseAmountInInr: Scalars['Float']
   convenienceFeeInInr: Scalars['Float']
   groupId: Scalars['String']
   name: Scalars['String']
   orders: Array<PaymentOrder>
   penaltyAmountInInr: Scalars['Float']
   refund?: Maybe<InstallmentRefund>
   refundDetails?: Maybe<RefundDetails>
   status: InstallmentGroupStatus
   tenureInDays: Scalars['Int']
   tenureInMonths: Scalars['Int']
   totalAmountInInr: Scalars['Float']
}

export type InstallmentGroupPreview = {
   __typename?: 'InstallmentGroupPreview'
   amountSplit: Array<AmountSplitDetails>
   groupId: Scalars['String']
   name: Scalars['String']
   orders: Array<PaymentOrderPreview>
   tenureInDays: Scalars['Int']
   tenureInMonths: Scalars['Int']
   totalAmountInInr: Scalars['Float']
}

export enum InstallmentGroupStatus {
   Paid = 'PAID',
   PartiallyPaid = 'PARTIALLY_PAID',
   YetToPay = 'YET_TO_PAY'
}

export enum InstallmentOrderRefundStatus {
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   PartiallyRefunded = 'PARTIALLY_REFUNDED',
   Success = 'SUCCESS'
}

export type InstallmentRefund = {
   __typename?: 'InstallmentRefund'
   budgetHeads: Array<RefundBudgetHeadBreakdown>
   failureReason?: Maybe<Scalars['String']>
   initiatedAt: Scalars['String']
   status: InstallmentOrderRefundStatus
   statusUpdateDatetime: Scalars['String']
   totalRefundAmount: Scalars['Float']
}

export type IntegerField = BaseField & {
   __typename?: 'IntegerField'
   defaultValue?: Maybe<Scalars['Int']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   formulaExpression?: Maybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isFormulaEnabled: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   rangeConfig?: Maybe<IntegerRangeConfig>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type IntegerFieldResponseOutOfRange = GraphQlBaseError & {
   __typename?: 'IntegerFieldResponseOutOfRange'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['Int']
}

export type IntegerRange = {
   __typename?: 'IntegerRange'
   fromValue?: Maybe<Scalars['Int']>
   toValue?: Maybe<Scalars['Int']>
}

export type IntegerRangeConfig = {
   __typename?: 'IntegerRangeConfig'
   maxValue?: Maybe<Scalars['Int']>
   minValue?: Maybe<Scalars['Int']>
}

export type IntegerRangeParams = {
   maxValue?: InputMaybe<Scalars['Int']>
   minValue?: InputMaybe<Scalars['Int']>
}

export type InvalidActivityTemplateReferenceIdFormat = GraphQlBaseError & {
   __typename?: 'InvalidActivityTemplateReferenceIdFormat'
   message?: Maybe<Scalars['String']>
}

export type InvalidAgentQuota = GraphQlBaseError & {
   __typename?: 'InvalidAgentQuota'
   message?: Maybe<Scalars['String']>
}

export type InvalidAllocationGroupSetQuota = GraphQlBaseError & {
   __typename?: 'InvalidAllocationGroupSetQuota'
   message?: Maybe<Scalars['String']>
   quota: Scalars['Int']
}

export type InvalidAllowedFormats = GraphQlBaseError & {
   __typename?: 'InvalidAllowedFormats'
   allowedFormats: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidApplicationAssigneeFieldReferenceIdsToNotify = GraphQlBaseError & {
   __typename?: 'InvalidApplicationAssigneeFieldReferenceIdsToNotify'
   assigneeFieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidApplicationId = GraphQlBaseError & {
   __typename?: 'InvalidApplicationId'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidApplicationKey = GraphQlBaseError & {
   __typename?: 'InvalidApplicationKey'
   key: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidAppliedFeeHeaderIds = {
   __typename?: 'InvalidAppliedFeeHeaderIds'
   appliedFeeHeaderIds: Array<Scalars['String']>
}

export type InvalidAssigneeFieldId = GraphQlBaseError & {
   __typename?: 'InvalidAssigneeFieldId'
   assigneeFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidAssigneeFieldIds = GraphQlBaseError & {
   __typename?: 'InvalidAssigneeFieldIds'
   assigneeFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidAssigneeFieldIdsToNotify = GraphQlBaseError & {
   __typename?: 'InvalidAssigneeFieldIdsToNotify'
   assigneeFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidAssigneeIds = GraphQlBaseError & {
   __typename?: 'InvalidAssigneeIds'
   assigneeIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidAuthorizationCode = GraphQlBaseError & {
   __typename?: 'InvalidAuthorizationCode'
   message?: Maybe<Scalars['String']>
}

export type InvalidAutomationWorkflowExecutedAtRange = GraphQlBaseError & {
   __typename?: 'InvalidAutomationWorkflowExecutedAtRange'
   endDatetime: Scalars['String']
   message?: Maybe<Scalars['String']>
   startDatetime: Scalars['String']
}

export type InvalidBannerImageUrl = GraphQlBaseError & {
   __typename?: 'InvalidBannerImageURL'
   bannerImageUrl: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidBrandBgImg = GraphQlBaseError & {
   __typename?: 'InvalidBrandBgImg'
   brandBgImg: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidBrandLogo = GraphQlBaseError & {
   __typename?: 'InvalidBrandLogo'
   brandLogo: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidCallLogsCallStartDatetimeRange = GraphQlBaseError & {
   __typename?: 'InvalidCallLogsCallStartDatetimeRange'
   endDatetime: Scalars['String']
   message?: Maybe<Scalars['String']>
   startDatetime: Scalars['String']
}

export type InvalidCaptcha = GraphQlBaseError & {
   __typename?: 'InvalidCaptcha'
   errorMsg: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidCertificateNumber = GraphQlBaseError & {
   __typename?: 'InvalidCertificateNumber'
   certificateNumber: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidCheckboxFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidCheckboxFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidComparisonValue = GraphQlBaseError & {
   __typename?: 'InvalidComparisonValue'
   message?: Maybe<Scalars['String']>
}

export type InvalidComputedValueConfigFormat = GraphQlBaseError & {
   __typename?: 'InvalidComputedValueConfigFormat'
   config: Scalars['String']
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidConditionDirectValue = GraphQlBaseError & {
   __typename?: 'InvalidConditionDirectValue'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidConditionValue = GraphQlBaseError & {
   __typename?: 'InvalidConditionValue'
   message?: Maybe<Scalars['String']>
   value: Scalars['String']
}

export type InvalidCreateRelatedRecordNodeMandatoryFields = GraphQlBaseError & {
   __typename?: 'InvalidCreateRelatedRecordNodeMandatoryFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidCreationConfig = GraphQlBaseError & {
   __typename?: 'InvalidCreationConfig'
   message?: Maybe<Scalars['String']>
}

export type InvalidCrmEntityId = GraphQlBaseError & {
   __typename?: 'InvalidCrmEntityId'
   crmEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidCustomObjectAssigneeFieldReferenceIdsToNotify = GraphQlBaseError & {
   __typename?: 'InvalidCustomObjectAssigneeFieldReferenceIdsToNotify'
   assigneeFieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidDateFieldResponseFormat = GraphQlBaseError & {
   __typename?: 'InvalidDateFieldResponseFormat'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidDateHistogramInterval = GraphQlBaseError & {
   __typename?: 'InvalidDateHistogramInterval'
   histogramInterval: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidDateRange = GraphQlBaseError & {
   __typename?: 'InvalidDateRange'
   message?: Maybe<Scalars['String']>
}

export type InvalidDateResponseFormat = GraphQlBaseError & {
   __typename?: 'InvalidDateResponseFormat'
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidDateTimeFieldResponseFormat = GraphQlBaseError & {
   __typename?: 'InvalidDateTimeFieldResponseFormat'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidDateTimeRange = GraphQlBaseError & {
   __typename?: 'InvalidDateTimeRange'
   message?: Maybe<Scalars['String']>
}

export type InvalidDaysCountInMonthScheduleConfig = GraphQlBaseError & {
   __typename?: 'InvalidDaysCountInMonthScheduleConfig'
   message?: Maybe<Scalars['String']>
}

export type InvalidDefaultValue = GraphQlBaseError & {
   __typename?: 'InvalidDefaultValue'
   message?: Maybe<Scalars['String']>
}

export type InvalidDesignationFormat = GraphQlBaseError & {
   __typename?: 'InvalidDesignationFormat'
   designation: Scalars['String']
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
}

export type InvalidDocumentTemplateVersionIds = GraphQlBaseError & {
   __typename?: 'InvalidDocumentTemplateVersionIds'
   documentTemplateVersionIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidDocumentVerificationTabType = GraphQlBaseError & {
   __typename?: 'InvalidDocumentVerificationTabType'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType?: Maybe<Scalars['String']>
}

export type InvalidDocusignGrantSignatureKey = GraphQlBaseError & {
   __typename?: 'InvalidDocusignGrantSignatureKey'
   errorCode?: Maybe<Scalars['String']>
   errorReason?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidDocusignPrivateKey = GraphQlBaseError & {
   __typename?: 'InvalidDocusignPrivateKey'
   message?: Maybe<Scalars['String']>
}

export type InvalidDomainUrl = GraphQlBaseError & {
   __typename?: 'InvalidDomainUrl'
   domainUrl: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidDropdownFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidDropdownFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidDropdownFieldResponseForConditionalOptions = GraphQlBaseError & {
   __typename?: 'InvalidDropdownFieldResponseForConditionalOptions'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   parentFieldIds: Array<Scalars['String']>
   response: Scalars['String']
}

export type InvalidDropdownOptions = GraphQlBaseError & {
   __typename?: 'InvalidDropdownOptions'
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type InvalidDynamicAssigneeConditionConfig = GraphQlBaseError & {
   __typename?: 'InvalidDynamicAssigneeConditionConfig'
   errorCode: DynamicAssigneeConditionConfigErrorCode
   message?: Maybe<Scalars['String']>
}

export type InvalidESignBlockFieldNames = GraphQlBaseError & {
   __typename?: 'InvalidESignBlockFieldNames'
   fieldNames: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidEmail = GraphQlBaseError & {
   __typename?: 'InvalidEmail'
   email?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidEmailFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidEmailFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidEmailForUserUpdate = GraphQlBaseError & {
   __typename?: 'InvalidEmailForUserUpdate'
   email: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidEndpoint = GraphQlBaseError & {
   __typename?: 'InvalidEndpoint'
   endPoint: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidEventTriggerConditionDirectValue = GraphQlBaseError & {
   __typename?: 'InvalidEventTriggerConditionDirectValue'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidEventTriggerFilterFieldOptions = GraphQlBaseError & {
   __typename?: 'InvalidEventTriggerFilterFieldOptions'
   fieldId: Scalars['String']
   invalidOptions: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type InvalidExternalDashboardUrl = GraphQlBaseError & {
   __typename?: 'InvalidExternalDashboardUrl'
   message?: Maybe<Scalars['String']>
}

export type InvalidFieldOptionForRuleBasedConditionalOptions = GraphQlBaseError & {
   __typename?: 'InvalidFieldOptionForRuleBasedConditionalOptions'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
   visibleOptions: Array<Scalars['String']>
}

export type InvalidFieldOptions = GraphQlBaseError & {
   __typename?: 'InvalidFieldOptions'
   fieldId: Scalars['String']
   invalidOptions: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type InvalidFieldReferenceIdFormat = GraphQlBaseError & {
   __typename?: 'InvalidFieldReferenceIdFormat'
   message?: Maybe<Scalars['String']>
}

export type InvalidFieldValueError = GraphQlBaseError & {
   __typename?: 'InvalidFieldValueError'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response?: Maybe<Scalars['String']>
   valueErrorEnum: FieldValueErrorEnum
}

export type InvalidFieldValuesErrors = {
   __typename?: 'InvalidFieldValuesErrors'
   errors: Array<InvalidFieldValueError>
}

export type InvalidFieldsSelectorDependentOptions = GraphQlBaseError & {
   __typename?: 'InvalidFieldsSelectorDependentOptions'
   dependentOptions: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidFieldsSelectorFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidFieldsSelectorFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidFileNumbers = GraphQlBaseError & {
   __typename?: 'InvalidFileNumbers'
   invalidFileNumbers: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidFileUploaderFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidFileUploaderFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidFileVerificationFieldType = GraphQlBaseError & {
   __typename?: 'InvalidFileVerificationFieldType'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidFilterFieldOptions = GraphQlBaseError & {
   __typename?: 'InvalidFilterFieldOptions'
   fieldId: Scalars['String']
   invalidOptions: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type InvalidFilterFieldValue = GraphQlBaseError & {
   __typename?: 'InvalidFilterFieldValue'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidFloatFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidFloatFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidFormulaExpression = GraphQlBaseError & {
   __typename?: 'InvalidFormulaExpression'
   formulaExpression: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidFriendOfficerId = GraphQlBaseError & {
   __typename?: 'InvalidFriendOfficerId'
   friendOfficerId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidGeoLocationFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidGeoLocationFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidGeoPoints = GraphQlBaseError & {
   __typename?: 'InvalidGeoPoints'
   geoPoints: Array<GeoPoint>
   message?: Maybe<Scalars['String']>
}

export type InvalidGeoShapeFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidGeoShapeFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
   variantType: GeoShapeVariantType
}

export type InvalidGeoShapeLineVariantResponse = GraphQlBaseError & {
   __typename?: 'InvalidGeoShapeLineVariantResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidGeoShapePolygonVariantResponse = GraphQlBaseError & {
   __typename?: 'InvalidGeoShapePolygonVariantResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidGraphFieldValue = GraphQlBaseError & {
   __typename?: 'InvalidGraphFieldValue'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidGuestEmailIds = GraphQlBaseError & {
   __typename?: 'InvalidGuestEmailIds'
   emailIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidHoursForComputedValueConfig = GraphQlBaseError & {
   __typename?: 'InvalidHoursForComputedValueConfig'
   fieldId: Scalars['String']
   hours: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type InvalidIdentifyEventTimeStampConfig = GraphQlBaseError & {
   __typename?: 'InvalidIdentifyEventTimeStampConfig'
   message?: Maybe<Scalars['String']>
}

export type InvalidIdentifyEventUniqueIdConfig = GraphQlBaseError & {
   __typename?: 'InvalidIdentifyEventUniqueIdConfig'
   message?: Maybe<Scalars['String']>
}

export type InvalidInitiateDeactivateUserOperation = GraphQlBaseError & {
   __typename?: 'InvalidInitiateDeactivateUserOperation'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type InvalidIntegerFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidIntegerFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidJsonConfigurationData = GraphQlBaseError & {
   __typename?: 'InvalidJsonConfigurationData'
   jsonData: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidLayoutCustomSectionIds = GraphQlBaseError & {
   __typename?: 'InvalidLayoutCustomSectionIds'
   customSectionIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidLeadAssigneeFieldReferenceIdsToNotify = GraphQlBaseError & {
   __typename?: 'InvalidLeadAssigneeFieldReferenceIdsToNotify'
   assigneeFieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidLeaveRequestId = GraphQlBaseError & {
   __typename?: 'InvalidLeaveRequestId'
   leaveRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidLimit = GraphQlBaseError & {
   __typename?: 'InvalidLimit'
   message?: Maybe<Scalars['String']>
}

export type InvalidLocationCoOrdinates = GraphQlBaseError & {
   __typename?: 'InvalidLocationCoOrdinates'
   latitude: Scalars['Float']
   longitude: Scalars['Float']
   message?: Maybe<Scalars['String']>
}

export type InvalidLogoImageUrl = GraphQlBaseError & {
   __typename?: 'InvalidLogoImageURL'
   logoImageUrl: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidLtpUserName = GraphQlBaseError & {
   __typename?: 'InvalidLtpUserName'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type InvalidManagerFieldIds = GraphQlBaseError & {
   __typename?: 'InvalidManagerFieldIds'
   managerFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidManagerFieldsLevel = GraphQlBaseError & {
   __typename?: 'InvalidManagerFieldsLevel'
   managerFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidManagerLevels = GraphQlBaseError & {
   __typename?: 'InvalidManagerLevels'
   levels: Array<Scalars['Int']>
   message?: Maybe<Scalars['String']>
}

export type InvalidMandalAssignment = GraphQlBaseError & {
   __typename?: 'InvalidMandalAssignment'
   mandals: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
   userId: Scalars['String']
}

export type InvalidMinutesForComputedValueConfig = GraphQlBaseError & {
   __typename?: 'InvalidMinutesForComputedValueConfig'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   minutes: Scalars['Int']
}

export type InvalidMultiSelectFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidMultiSelectFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidMultiSelectFieldResponseForConditionalOptions = GraphQlBaseError & {
   __typename?: 'InvalidMultiSelectFieldResponseForConditionalOptions'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   parentFieldIds: Array<Scalars['String']>
   response: Scalars['String']
}

export type InvalidMultiselectOptions = GraphQlBaseError & {
   __typename?: 'InvalidMultiselectOptions'
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type InvalidOtp = GraphQlBaseError & {
   __typename?: 'InvalidOTP'
   message?: Maybe<Scalars['String']>
   otp: Scalars['String']
}

export type InvalidOfficerTransferOperation = GraphQlBaseError & {
   __typename?: 'InvalidOfficerTransferOperation'
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
   userId: Scalars['String']
}

export type InvalidOffset = GraphQlBaseError & {
   __typename?: 'InvalidOffset'
   message?: Maybe<Scalars['String']>
}

export type InvalidOrderFieldIds = GraphQlBaseError & {
   __typename?: 'InvalidOrderFieldIds'
   invalidIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type InvalidOrderNameAmount = {
   __typename?: 'InvalidOrderNameAmount'
   amount: Scalars['Float']
   name: Scalars['String']
}

export type InvalidOrdersAmount = GraphQlBaseError & {
   __typename?: 'InvalidOrdersAmount'
   invalidOrders: Array<InvalidOrderNameAmount>
   message?: Maybe<Scalars['String']>
}

export type InvalidPhoneNumber = GraphQlBaseError & {
   __typename?: 'InvalidPhoneNumber'
   dialCode: Scalars['String']
   iso2CountryCode: Scalars['String']
   message?: Maybe<Scalars['String']>
   phoneNumber: Scalars['String']
}

export type InvalidPhoneNumberFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidPhoneNumberFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidPhoneNumberFormat = GraphQlBaseError & {
   __typename?: 'InvalidPhoneNumberFormat'
   message?: Maybe<Scalars['String']>
   phoneNumber: Scalars['String']
   reason: Scalars['String']
}

export type InvalidPipelineStageIds = GraphQlBaseError & {
   __typename?: 'InvalidPipelineStageIds'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export type InvalidPluginState = GraphQlBaseError & {
   __typename?: 'InvalidPluginState'
   message?: Maybe<Scalars['String']>
   pluginType: Scalars['String']
}

export type InvalidPopulationData = GraphQlBaseError & {
   __typename?: 'InvalidPopulationData'
   errorMsg: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidPreSignedUrlEntityId = GraphQlBaseError & {
   __typename?: 'InvalidPreSignedUrlEntityId'
   entityId: Scalars['String']
   entityType: PreSignedUrlEntityType
   message?: Maybe<Scalars['String']>
}

export type InvalidPrecisionForTransactionValue = GraphQlBaseError & {
   __typename?: 'InvalidPrecisionForTransactionValue'
   message?: Maybe<Scalars['String']>
   value: Scalars['Float']
}

export type InvalidRadioGroupFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidRadioGroupFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidReconciliationRequestStatusTransition = {
   __typename?: 'InvalidReconciliationRequestStatusTransition'
   requestId: Scalars['String']
}

export type InvalidRedirectionUrl = GraphQlBaseError & {
   __typename?: 'InvalidRedirectionURL'
   message?: Maybe<Scalars['String']>
   redirectionUrl: Scalars['String']
}

export type InvalidScheduleMinutesConfig = GraphQlBaseError & {
   __typename?: 'InvalidScheduleMinutesConfig'
   message?: Maybe<Scalars['String']>
}

export type InvalidSearchCriteria = GraphQlBaseError & {
   __typename?: 'InvalidSearchCriteria'
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
   searchQuery: Scalars['String']
}

export type InvalidShortTextFieldPrefixOption = GraphQlBaseError & {
   __typename?: 'InvalidShortTextFieldPrefixOption'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   prefix: Scalars['String']
}

export type InvalidShortTextFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidShortTextFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidShortTextFieldResponseForPrefixConditionalOptions = GraphQlBaseError & {
   __typename?: 'InvalidShortTextFieldResponseForPrefixConditionalOptions'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   parentFieldIds: Array<Scalars['String']>
   response: Scalars['String']
}

export type InvalidShortTextFieldSuffixOption = GraphQlBaseError & {
   __typename?: 'InvalidShortTextFieldSuffixOption'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   suffix: Scalars['String']
}

export type InvalidSignatureImgLink = GraphQlBaseError & {
   __typename?: 'InvalidSignatureImgLink'
   message?: Maybe<Scalars['String']>
   signatureImgLink: Scalars['String']
}

export type InvalidStageForPipeline = GraphQlBaseError & {
   __typename?: 'InvalidStageForPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   stageId: Scalars['String']
}

export type InvalidStageTransitionForPipelineItem = GraphQlBaseError & {
   __typename?: 'InvalidStageTransitionForPipelineItem'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type InvalidStageTransitionsForPipelineItem = GraphQlBaseError & {
   __typename?: 'InvalidStageTransitionsForPipelineItem'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type InvalidTdrRequestAuthority = GraphQlBaseError & {
   __typename?: 'InvalidTDRRequestAuthority'
   authority: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type InvalidTaskTemplateIds = GraphQlBaseError & {
   __typename?: 'InvalidTaskTemplateIds'
   message?: Maybe<Scalars['String']>
   taskTemplateIds: Array<Scalars['String']>
}

export type InvalidTaskTemplateRemarksEnableConfig = GraphQlBaseError & {
   __typename?: 'InvalidTaskTemplateRemarksEnableConfig'
   enableRemarks: Scalars['Boolean']
   enableRemarksAttachments: Scalars['Boolean']
   message?: Maybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type InvalidTimeFieldResponseFormat = GraphQlBaseError & {
   __typename?: 'InvalidTimeFieldResponseFormat'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidTimeResponseFormat = GraphQlBaseError & {
   __typename?: 'InvalidTimeResponseFormat'
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidTrackEventTimeStampConfig = GraphQlBaseError & {
   __typename?: 'InvalidTrackEventTimeStampConfig'
   message?: Maybe<Scalars['String']>
}

export type InvalidTrackEventUniqueIdConfig = GraphQlBaseError & {
   __typename?: 'InvalidTrackEventUniqueIdConfig'
   message?: Maybe<Scalars['String']>
}

export type InvalidUrl = GraphQlBaseError & {
   __typename?: 'InvalidUrl'
   message?: Maybe<Scalars['String']>
   url: Scalars['String']
}

export type InvalidUrlFieldResponse = GraphQlBaseError & {
   __typename?: 'InvalidUrlFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type InvalidUserDetailsUpdateOperation = GraphQlBaseError & {
   __typename?: 'InvalidUserDetailsUpdateOperation'
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
   userId: Scalars['String']
}

export type InvalidUserPin = GraphQlBaseError & {
   __typename?: 'InvalidUserPin'
   message?: Maybe<Scalars['String']>
   remainingAttempts: Scalars['Int']
}

export type InvalidUsername = GraphQlBaseError & {
   __typename?: 'InvalidUsername'
   message?: Maybe<Scalars['String']>
   username: Scalars['String']
}

export type InvalidValidationRegex = GraphQlBaseError & {
   __typename?: 'InvalidValidationRegex'
   message?: Maybe<Scalars['String']>
}

export type InvalidValuesForRelativeFieldSourceTypes = GraphQlBaseError & {
   __typename?: 'InvalidValuesForRelativeFieldSourceTypes'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   values: Array<Scalars['String']>
}

export type InvalidWatiServiceAccountEndPoint = GraphQlBaseError & {
   __typename?: 'InvalidWatiServiceAccountEndPoint'
   message?: Maybe<Scalars['String']>
   pluginServiceAccountId: Scalars['String']
}

export type InvalidWebhookUrl = GraphQlBaseError & {
   __typename?: 'InvalidWebhookUrl'
   message?: Maybe<Scalars['String']>
   url: Scalars['String']
}

export type InvalidWeightageSum = GraphQlBaseError & {
   __typename?: 'InvalidWeightageSum'
   message?: Maybe<Scalars['String']>
}

export type InvalidWeightageValue = GraphQlBaseError & {
   __typename?: 'InvalidWeightageValue'
   message?: Maybe<Scalars['String']>
}

export type InvalidWeightageValues = GraphQlBaseError & {
   __typename?: 'InvalidWeightageValues'
   message?: Maybe<Scalars['String']>
   weightageValues: Array<Scalars['Float']>
}

export type InvalidWhatsAppBusinessPhoneNumber = GraphQlBaseError & {
   __typename?: 'InvalidWhatsAppBusinessPhoneNumber'
   message?: Maybe<Scalars['String']>
   phoneNumber: PhoneNumberResponse
}

export type InvalidWhatsAppServiceAccountConfiguration = GraphQlBaseError & {
   __typename?: 'InvalidWhatsAppServiceAccountConfiguration'
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
}

export type IsAutomationWorkflowNameExistsParams = {
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type IsAutomationWorkflowNameExistsResponse =
   | IsAutomationWorkflowNameExistsResult
   | PipelineAccessDenied
   | PipelineNotFound

export type IsAutomationWorkflowNameExistsResult = {
   __typename?: 'IsAutomationWorkflowNameExistsResult'
   alreadyExists: Scalars['Boolean']
}

export type IsDocumentTemplateNameExistsParams = {
   name: Scalars['String']
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
}

export type IsDocumentTemplateNameExistsResponse =
   | IsDocumentTemplateNameExistsResult
   | PipelineItemTemplateNotFound
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type IsDocumentTemplateNameExistsResult = {
   __typename?: 'IsDocumentTemplateNameExistsResult'
   alreadyExists: Scalars['Boolean']
   name: Scalars['String']
   pipelineId?: Maybe<Scalars['String']>
}

export type IsRequiredShouldBeTrueForIdentificationField = GraphQlBaseError & {
   __typename?: 'IsRequiredShouldBeTrueForIdentificationField'
   identificationFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ItemExistenceInView = {
   __typename?: 'ItemExistenceInView'
   exists: Scalars['Boolean']
   itemId: Scalars['String']
}

export type ItemIdsInViewResponse =
   | InvalidLimit
   | InvalidOffset
   | ItemIdsInViewResult
   | PaginationLimitExceeded
   | ViewAccessDenied
   | ViewNotFound

export type ItemIdsInViewResult = {
   __typename?: 'ItemIdsInViewResult'
   itemIds: Array<Scalars['String']>
   totalCount: Scalars['Int']
}

export type ItemsCountInBoardParams = {
   userHierarchyFilter?: InputMaybe<UserHierarchyFilter>
}

export enum JsonConfigEntityType {
   PortalFilters = 'PORTAL_FILTERS'
}

export type JsonConfiguration = {
   __typename?: 'JsonConfiguration'
   entityId?: Maybe<Scalars['String']>
   entityType: JsonConfigurationEntityType
   jsonConfigurationId: Scalars['String']
   jsonData: Scalars['String']
   lastUpdatedAt: Scalars['String']
   name: Scalars['String']
   updatedBy: BaseUser
}

export enum JsonConfigurationEntityType {
   ApplicationPublicSearchConfig = 'APPLICATION_PUBLIC_SEARCH_CONFIG',
   ApplicationReconciliation = 'APPLICATION_RECONCILIATION',
   ApplicationStageSummaryConfig = 'APPLICATION_STAGE_SUMMARY_CONFIG',
   AssignFriend = 'ASSIGN_FRIEND',
   CdmaPtIntegration = 'CDMA_PT_INTEGRATION',
   DeemedApprovalConfig = 'DEEMED_APPROVAL_CONFIG',
   EncumbranceCertificate = 'ENCUMBRANCE_CERTIFICATE',
   GenerateScrutinyApplicationOverviewFieldsConfig = 'GENERATE_SCRUTINY_APPLICATION_OVERVIEW_FIELDS_CONFIG',
   IpassAppeal = 'IPASS_APPEAL',
   IpassApproval = 'IPASS_APPROVAL',
   IpassFeeIntimation = 'IPASS_FEE_INTIMATION',
   IpassRejection = 'IPASS_REJECTION',
   IpassShortfall = 'IPASS_SHORTFALL',
   IPassTemplateConfig = 'I_PASS_TEMPLATE_CONFIG',
   LinkObjectionApplicationConfig = 'LINK_OBJECTION_APPLICATION_CONFIG',
   LrsApplicationDetails = 'LRS_APPLICATION_DETAILS',
   LtpUserManagementConfig = 'LTP_USER_MANAGEMENT_CONFIG',
   MandatoryRevisedFeeApplicationsConfig = 'MANDATORY_REVISED_FEE_APPLICATIONS_CONFIG',
   MarketValue = 'MARKET_VALUE',
   PipelineItemAccessOverrideConfig = 'PIPELINE_ITEM_ACCESS_OVERRIDE_CONFIG',
   PipelineItemBannerConfig = 'PIPELINE_ITEM_BANNER_CONFIG',
   PipelineItemTemplateAccessOverrideConfig = 'PIPELINE_ITEM_TEMPLATE_ACCESS_OVERRIDE_CONFIG',
   PortalCustomTabsVisibilityConfig = 'PORTAL_CUSTOM_TABS_VISIBILITY_CONFIG',
   PortalFilters = 'PORTAL_FILTERS',
   ProceedingNumberSearchConfig = 'PROCEEDING_NUMBER_SEARCH_CONFIG',
   PropertyTaxBuildingPermission = 'PROPERTY_TAX_BUILDING_PERMISSION',
   PropertyTaxOccupancyCertificate = 'PROPERTY_TAX_OCCUPANCY_CERTIFICATE',
   PropertyTaxStatusUpdate = 'PROPERTY_TAX_STATUS_UPDATE',
   PropertyTaxVltValidation = 'PROPERTY_TAX_VLT_VALIDATION',
   PushToLabourDepartment = 'PUSH_TO_LABOUR_DEPARTMENT',
   RegistrationMasters = 'REGISTRATION_MASTERS',
   Rera = 'RERA',
   RunScrutinyInRulesEngine = 'RUN_SCRUTINY_IN_RULES_ENGINE',
   SandManagement = 'SAND_MANAGEMENT',
   SearchAndMonitoring = 'SEARCH_AND_MONITORING',
   SkipAutoCompletionTasksForStageTransitions = 'SKIP_AUTO_COMPLETION_TASKS_FOR_STAGE_TRANSITIONS',
   TdrAccountDetailedViewLayoutConfig = 'TDR_ACCOUNT_DETAILED_VIEW_LAYOUT_CONFIG',
   TdrBankCitizenPortalConfig = 'TDR_BANK_CITIZEN_PORTAL_CONFIG',
   TdrPipelineItemTemplateConfig = 'TDR_PIPELINE_ITEM_TEMPLATE_CONFIG',
   TgiicAllotmentData = 'TGIIC_ALLOTMENT_DATA',
   TgiicFieldConfiguration = 'TGIIC_FIELD_CONFIGURATION',
   TgmdcIntegration = 'TGMDC_INTEGRATION',
   UafDropdownOptions = 'UAF_DROPDOWN_OPTIONS',
   UserRestrictionForApplicationSubmission = 'USER_RESTRICTION_FOR_APPLICATION_SUBMISSION',
   VltFieldConfiguration = 'VLT_FIELD_CONFIGURATION',
   WhatsappBotConfig = 'WHATSAPP_BOT_CONFIG'
}

export type KNumberAlreadyExists = GraphQlBaseError & {
   __typename?: 'KNumberAlreadyExists'
   message?: Maybe<Scalars['String']>
}

export type KnowlarityAccount = BasePluginServiceAccount & {
   __typename?: 'KnowlarityAccount'
   applicationAccessKey: Scalars['String']
   channelType: KnowlarityChannelType
   isActive: Scalars['Boolean']
   kNumber: PhoneNumberResponse
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
   srApiKey: Scalars['String']
}

export type KnowlarityAccountNotFound = GraphQlBaseError & {
   __typename?: 'KnowlarityAccountNotFound'
   message?: Maybe<Scalars['String']>
   pluginServiceAccountId: Scalars['String']
}

export type KnowlarityAccountResult =
   | KnowlarityAccount
   | PluginServiceAccountNotFound

export enum KnowlarityChannelType {
   Advance = 'ADVANCE',
   Basic = 'BASIC',
   Enterprise = 'ENTERPRISE',
   Premium = 'PREMIUM'
}

export type KnowlarityServiceAccounts = {
   __typename?: 'KnowlarityServiceAccounts'
   knowlarityAccounts: Array<KnowlarityAccountResult>
}

export enum LanguageEnum {
   English = 'ENGLISH',
   Hindi = 'HINDI',
   Telugu = 'TELUGU',
   Urdu = 'URDU'
}

export type LatestTaskFieldResult =
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | NotExistTaskFieldResponse
   | NotPermittedField
   | NotTaskField

export type Layout = {
   __typename?: 'Layout'
   documentFieldsConfig?: Maybe<DocumentFieldsConfig>
   entityId: Scalars['String']
   entityType: LayoutEntityType
   featureToggles: Array<LayoutFeatureToggle>
   headerFieldIds: Array<Scalars['String']>
   layoutId: Scalars['String']
   orderedTabIds: Array<Scalars['String']>
   pipelineId?: Maybe<Scalars['String']>
   pipelineItemDetailsDocumentTemplate?: Maybe<
      PipelineItemDetailsDocumentTemplateConfig
   >
   proposalFlowConfig?: Maybe<ProposalFlowTabsConfig>
   quickActions: Array<LayoutQuickActionType>
   tabs: Array<Tab>
   viewAndEditSanctionDetailsConfig?: Maybe<ViewAndEditSanctionDetailsConfig>
}

export type LayoutOrderedTabIdsArgs = {
   params?: InputMaybe<TabsParams>
}

export type LayoutTabsArgs = {
   params?: InputMaybe<TabsParams>
}

export type LayoutConfigAlreadyExistsForEntity = GraphQlBaseError & {
   __typename?: 'LayoutConfigAlreadyExistsForEntity'
   entityId: Scalars['String']
   entityType: LayoutEntityType
   message?: Maybe<Scalars['String']>
}

export type LayoutConfigDoesNotExistForEntity = GraphQlBaseError & {
   __typename?: 'LayoutConfigDoesNotExistForEntity'
   entityId: Scalars['String']
   entityType: LayoutEntityType
   message?: Maybe<Scalars['String']>
}

export type LayoutCustomSectionVisibilityStatus = {
   __typename?: 'LayoutCustomSectionVisibilityStatus'
   customSectionId: Scalars['String']
   isVisible: Scalars['Boolean']
}

export type LayoutEntityAccessDenied = GraphQlBaseError & {
   __typename?: 'LayoutEntityAccessDenied'
   entityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LayoutEntityNotFound = GraphQlBaseError & {
   __typename?: 'LayoutEntityNotFound'
   entityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LayoutEntityNotInPipeline = GraphQlBaseError & {
   __typename?: 'LayoutEntityNotInPipeline'
   entityId: Scalars['String']
   entityType: LayoutEntityType
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export enum LayoutEntityType {
   PipelineItemTemplate = 'PIPELINE_ITEM_TEMPLATE'
}

export enum LayoutFeature {
   Notes = 'NOTES'
}

export enum LayoutFeatureStatus {
   Disabled = 'DISABLED',
   Enabled = 'ENABLED'
}

export type LayoutFeatureToggle = {
   __typename?: 'LayoutFeatureToggle'
   feature: LayoutFeature
   status: LayoutFeatureStatus
}

export type LayoutNotFound = GraphQlBaseError & {
   __typename?: 'LayoutNotFound'
   layoutId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum LayoutQuickActionType {
   Note = 'NOTE'
}

export type LayoutTabEnableStatus = {
   __typename?: 'LayoutTabEnableStatus'
   enabledStatus: EnabledStatus
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type LayoutTabNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'LayoutTabNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type LayoutTabNotFound = GraphQlBaseError & {
   __typename?: 'LayoutTabNotFound'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type LayoutTabTaskRecommendation = {
   __typename?: 'LayoutTabTaskRecommendation'
   overallRecommendation?: Maybe<BpsVerificationRecommendationEnum>
   overallRemarks?: Maybe<Scalars['String']>
   status: TaskStatus
   tab: BaseTabInfoDetails
   taskId?: Maybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export enum LayoutTabTaskStatus {
   Accepted = 'ACCEPTED',
   Discarded = 'DISCARDED',
   FieldRemarksNotFilled = 'FIELD_REMARKS_NOT_FILLED',
   NotStarted = 'NOT_STARTED',
   OverallRemarksNotFilled = 'OVERALL_REMARKS_NOT_FILLED',
   Rejected = 'REJECTED',
   RequiredFieldsNotFilled = 'REQUIRED_FIELDS_NOT_FILLED',
   Shortfall = 'SHORTFALL'
}

export type LayoutTabVisibilityStatus = {
   __typename?: 'LayoutTabVisibilityStatus'
   isVisible: Scalars['Boolean']
   tabId: Scalars['String']
}

export type LayoutTabsNotFound = GraphQlBaseError & {
   __typename?: 'LayoutTabsNotFound'
   message?: Maybe<Scalars['String']>
   tabIds: Array<Scalars['String']>
}

export type LdRuleStageUpdatedTriggerConfig = {
   __typename?: 'LdRuleStageUpdatedTriggerConfig'
   stageFieldId: Scalars['String']
}

export type LdRuleStageUpdatedTriggerConfigIsRequired = GraphQlBaseError & {
   __typename?: 'LdRuleStageUpdatedTriggerConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type LdRuleStageUpdatedTriggerConfigParams = {
   stageFieldId: Scalars['String']
}

export type Lead = BasePipelineItem & {
   __typename?: 'Lead'
   contact: Contact
   createdAt: Scalars['String']
   fields: Array<SystemFieldEnumResponseResult>
   latestActivity?: Maybe<Activity>
   latestRemarks?: Maybe<PipelineItemRemarks>
   pipelineId: Scalars['String']
   pipelineIds: Array<Scalars['String']>
   pipelineItemId: Scalars['String']
   pipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   task?: Maybe<Task>
}

export type LeadFieldsArgs = {
   systemFieldEnums: Array<LeadSystemFieldEnum>
}

export type LeadAccessDenied = GraphQlBaseError & {
   __typename?: 'LeadAccessDenied'
   leadId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LeadAlreadyExists = GraphQlBaseError & {
   __typename?: 'LeadAlreadyExists'
   hasPermission: Scalars['Boolean']
   leadId: Scalars['String']
   leadTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type LeadAssigneeIsDeactivated = GraphQlBaseError & {
   __typename?: 'LeadAssigneeIsDeactivated'
   assigneeId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LeadAssigneeNotFound = GraphQlBaseError & {
   __typename?: 'LeadAssigneeNotFound'
   message?: Maybe<Scalars['String']>
}

export type LeadAssigneesAreDeactivated = GraphQlBaseError & {
   __typename?: 'LeadAssigneesAreDeactivated'
   assigneeIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type LeadAssigneesNotFound = GraphQlBaseError & {
   __typename?: 'LeadAssigneesNotFound'
   assigneeIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type LeadBucket = {
   __typename?: 'LeadBucket'
   allocationGroupSets: Array<AllocationGroupSet>
   configStatus: LeadDistributionEntityConfigStatus
   filterSetId: Scalars['String']
   leadBucketId: Scalars['String']
   name: Scalars['String']
   sortByFields: Array<SortByField>
}

export type LeadBucketExecLog = {
   __typename?: 'LeadBucketExecLog'
   allocationGroupItems: Array<AllocationGroupItemExecLog>
   assignedLeadsCount: Scalars['Int']
   name: Scalars['String']
   status?: Maybe<LeadBucketExecLogStatus>
}

export enum LeadBucketExecLogStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   PartiallyFailed = 'PARTIALLY_FAILED'
}

export type LeadBucketNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'LeadBucketNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type LeadBucketNotFound = GraphQlBaseError & {
   __typename?: 'LeadBucketNotFound'
   leadBucketId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LeadBucketStats = {
   __typename?: 'LeadBucketStats'
   leadBucketId: Scalars['String']
   totalLeads: Scalars['Int']
}

export type LeadBucketStatsResult = LeadBucketNotFound | LeadBucketStats

export type LeadBucketSummary = {
   __typename?: 'LeadBucketSummary'
   allocationGroupItems: Array<AllocationGroupItemSummary>
   filterSetId: Scalars['String']
   leadBucketId: Scalars['String']
   name: Scalars['String']
   totalLeads: Scalars['Int']
}

export type LeadBucketsAreNotInSameLeadDistributionRule = GraphQlBaseError & {
   __typename?: 'LeadBucketsAreNotInSameLeadDistributionRule'
   message?: Maybe<Scalars['String']>
}

export type LeadBucketsNotFound = GraphQlBaseError & {
   __typename?: 'LeadBucketsNotFound'
   leadBucketIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type LeadBucketsNotInSameLeadDistributionRule = GraphQlBaseError & {
   __typename?: 'LeadBucketsNotInSameLeadDistributionRule'
   leadBucketIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type LeadCreatedOnShouldBeInPast = GraphQlBaseError & {
   __typename?: 'LeadCreatedOnShouldBeInPast'
   createdOn: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LeadCreationConfigIsRequired = GraphQlBaseError & {
   __typename?: 'LeadCreationConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type LeadCreationNotSupportedFields = GraphQlBaseError & {
   __typename?: 'LeadCreationNotSupportedFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export enum LeadDistributionEntityConfigStatus {
   Configured = 'CONFIGURED',
   PartiallyConfigured = 'PARTIALLY_CONFIGURED'
}

export type LeadDistributionEventTriggerEntityTemplateNotFound = GraphQlBaseError & {
   __typename?: 'LeadDistributionEventTriggerEntityTemplateNotFound'
   entityTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LeadDistributionRule = {
   __typename?: 'LeadDistributionRule'
   configStatus: LeadDistributionEntityConfigStatus
   createdAt: Scalars['String']
   distributionThrough: DistributionThroughType
   distributionThroughItems: Array<DistributionThroughItem>
   eventBasedLeadDistributionRuleStatus?: Maybe<
      EventBasedLeadDistributionRuleStatus
   >
   eventBasedRuleTrigger?: Maybe<EventBasedLeadDistributionRuleTrigger>
   isInEditMode: Scalars['Boolean']
   leadDistributionRuleId: Scalars['String']
   leadPool: LeadPool
   name: Scalars['String']
   pipelineId: Scalars['String']
   scheduledLeadDistributionRuleStatus?: Maybe<
      ScheduledLeadDistributionRuleStatus
   >
   settings?: Maybe<LeadDistributionRuleSettings>
   stepsWiseStatus: Array<LeadDistributionRuleConfigStepWithStatus>
}

export enum LeadDistributionRuleConfigStep {
   AgentAllocationGroups = 'AGENT_ALLOCATION_GROUPS',
   DistributionSettings = 'DISTRIBUTION_SETTINGS',
   LeadBuckets = 'LEAD_BUCKETS',
   LeadPool = 'LEAD_POOL'
}

export type LeadDistributionRuleConfigStepWithStatus = {
   __typename?: 'LeadDistributionRuleConfigStepWithStatus'
   status: LeadDistributionEntityConfigStatus
   step: LeadDistributionRuleConfigStep
}

export type LeadDistributionRuleExecLog = {
   __typename?: 'LeadDistributionRuleExecLog'
   assignedLeadsCount: Scalars['Int']
   distributionThrough: DistributionThroughType
   distributionThroughItems: Array<DistributeThroughItemExecLog>
   initiatedAt: Scalars['String']
   isPartiallyAssigned: Scalars['Boolean']
   leadDistributionRuleExecLogId: Scalars['String']
   name: Scalars['String']
   pipelineId: Scalars['String']
   status: LeadDistributionRuleExecLogStatus
}

export type LeadDistributionRuleExecLogNotFound = GraphQlBaseError & {
   __typename?: 'LeadDistributionRuleExecLogNotFound'
   leadDistributionRuleExecLogId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum LeadDistributionRuleExecLogStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   PartiallyFailed = 'PARTIALLY_FAILED'
}

export type LeadDistributionRuleIsNotInEditMode = GraphQlBaseError & {
   __typename?: 'LeadDistributionRuleIsNotInEditMode'
   message?: Maybe<Scalars['String']>
}

export type LeadDistributionRuleManagerField = {
   __typename?: 'LeadDistributionRuleManagerField'
   level: Scalars['Int']
   managerFieldId: Scalars['String']
}

export type LeadDistributionRuleManagerFieldParams = {
   level: Scalars['Int']
   managerFieldId: Scalars['String']
}

export type LeadDistributionRuleNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'LeadDistributionRuleNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type LeadDistributionRuleNotFound = GraphQlBaseError & {
   __typename?: 'LeadDistributionRuleNotFound'
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LeadDistributionRuleParams = {
   leadDistributionRuleId: Scalars['String']
   leadDistributionRuleState: LeadDistributionRuleStateEnum
}

export type LeadDistributionRuleResult =
   | LeadDistributionRule
   | LeadDistributionRuleNotFound
   | LeadDistributionRuleStateNotFound
   | UserIsNotAnAdministrator

export type LeadDistributionRuleScheduleConfig = {
   __typename?: 'LeadDistributionRuleScheduleConfig'
   dailyConfig?: Maybe<ScheduledLeadDistributionRuleDailyConfig>
   scheduledType?: Maybe<LeadDistributionRuleScheduledType>
   weekDaysConfig: Array<ScheduledLeadDistributionRuleWeekDaysConfig>
}

export enum LeadDistributionRuleScheduledType {
   Daily = 'DAILY',
   EveryNMinutes = 'EVERY_N_MINUTES',
   WeekDays = 'WEEK_DAYS'
}

export type LeadDistributionRuleSettings =
   | EventBasedLeadDistributionRuleSettings
   | ManualLeadDistributionRuleSettings
   | ScheduledLeadDistributionRuleSettings

export enum LeadDistributionRuleStateEnum {
   Editable = 'EDITABLE',
   Published = 'PUBLISHED'
}

export type LeadDistributionRuleStateNotFound = GraphQlBaseError & {
   __typename?: 'LeadDistributionRuleStateNotFound'
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
   state: LeadDistributionRuleStateEnum
}

export type LeadDistributionRuleSummary = {
   __typename?: 'LeadDistributionRuleSummary'
   distributionThrough: DistributionThroughType
   distributionThroughItems: Array<DistributeThroughItemSummary>
   leadDistributionRuleId: Scalars['String']
   leadPool?: Maybe<LeadPoolSummary>
   name: Scalars['String']
   pipelineId: Scalars['String']
   settings?: Maybe<LeadDistributionRuleSettings>
}

export enum LeadDistributionRuleType {
   EventBased = 'EVENT_BASED',
   Manual = 'MANUAL',
   Scheduled = 'SCHEDULED'
}

export type LeadDistributionSetup = {
   __typename?: 'LeadDistributionSetup'
   currentStep: LeadDistributionSetupStep
   partiallyConfiguredSteps: Array<
      PartiallyConfigurableLeadDistributionSetupStep
   >
}

export enum LeadDistributionSetupStep {
   AgentAllocationGroups = 'AGENT_ALLOCATION_GROUPS',
   GetStarted = 'GET_STARTED',
   LeadDistributionRuleConfig = 'LEAD_DISTRIBUTION_RULE_CONFIG',
   PipelineSelection = 'PIPELINE_SELECTION'
}

export type LeadDistributionThroughShouldBeLeadBucket = GraphQlBaseError & {
   __typename?: 'LeadDistributionThroughShouldBeLeadBucket'
   message?: Maybe<Scalars['String']>
}

export type LeadDistributionThroughShouldBeLeadPool = GraphQlBaseError & {
   __typename?: 'LeadDistributionThroughShouldBeLeadPool'
   message?: Maybe<Scalars['String']>
}

export enum LeadDistributionTriggerEntity {
   Activity = 'ACTIVITY',
   Lead = 'LEAD'
}

export enum LeadDistributionTriggerEventType {
   Created = 'CREATED',
   DisplayStageUpdated = 'DISPLAY_STAGE_UPDATED',
   StageUpdated = 'STAGE_UPDATED'
}

export type LeadFieldResponse = {
   __typename?: 'LeadFieldResponse'
   fieldResponse: FieldResponse
   leadId: Scalars['String']
}

export type LeadFieldResult =
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldNotFound
   | FieldResponse
   | NotLeadField
   | NotPermittedField

export type LeadHistory = BasePipelineItemHistory & {
   __typename?: 'LeadHistory'
   data?: Maybe<PipelineItemHistoryData>
   eventDatetime: Scalars['String']
   pipelineItemHistoryEventType: PipelineItemHistoryEventType
   pipelineItemId: Scalars['String']
}

export type LeadHistoryParams = {
   leadId: Scalars['String']
}

export type LeadHistoryResponse =
   | LeadAccessDenied
   | LeadHistoryResult
   | LeadIsDeleted
   | LeadNotFound

export type LeadHistoryResult = {
   __typename?: 'LeadHistoryResult'
   history: Array<LeadHistory>
}

export type LeadIdIsRequired = GraphQlBaseError & {
   __typename?: 'LeadIdIsRequired'
   message?: Maybe<Scalars['String']>
}

export type LeadInitiationRolesOnActivity = {
   __typename?: 'LeadInitiationRolesOnActivity'
   activityTemplateId: Scalars['String']
   roles: Array<Role>
}

export type LeadInitiationRolesOnActivityParams = {
   activityTemplateId: Scalars['String']
   roleIds: Array<Scalars['String']>
}

export type LeadInitiationRolesOnActivityResponse =
   | ActivityTemplateNotFound
   | LeadCreationConfigIsRequired
   | LeadInitiationRolesOnActivity
   | RolesNotFound
   | RolesNotInUserAccount
   | UserIsNotAnAdministrator

export type LeadInitiationRolesOnActivityResult =
   | ActivityTemplateAccessDenied
   | ActivityTemplateNotFound
   | ActivityTemplateNotInAccount
   | LeadInitiationRolesOnActivity

export type LeadIsDeleted = GraphQlBaseError & {
   __typename?: 'LeadIsDeleted'
   leadId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LeadNotFound = GraphQlBaseError & {
   __typename?: 'LeadNotFound'
   leadId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LeadOrDealDataSourceMustExists = GraphQlBaseError & {
   __typename?: 'LeadOrDealDataSourceMustExists'
   message?: Maybe<Scalars['String']>
}

export type LeadPool = {
   __typename?: 'LeadPool'
   configStatus: LeadDistributionEntityConfigStatus
   filterSetId: Scalars['String']
   leadAssigneeFieldConditionEnum: LeadPoolAssigneeConditionEnum
   leadAssigneeFieldId?: Maybe<Scalars['String']>
   leadDistributionRuleId: Scalars['String']
   sortByFields: Array<SortByField>
}

export type LeadPoolAllocationGroupItemExecLog = {
   __typename?: 'LeadPoolAllocationGroupItemExecLog'
   allocationGroupItem: AllocationGroupItemExecLog
}

export type LeadPoolAllocationGroupItemSummary = {
   __typename?: 'LeadPoolAllocationGroupItemSummary'
   allocationGroupItem: AllocationGroupItemSummary
}

export enum LeadPoolAssigneeConditionEnum {
   Assigned = 'ASSIGNED',
   Unassigned = 'UNASSIGNED'
}

export type LeadPoolAssigneeFieldCanNotBeManagerField = GraphQlBaseError & {
   __typename?: 'LeadPoolAssigneeFieldCanNotBeManagerField'
   leadPoolAssigneeFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LeadPoolSummary = {
   __typename?: 'LeadPoolSummary'
   leadAssigneeFieldConditionEnum: LeadPoolAssigneeConditionEnum
   leadAssigneeFieldId?: Maybe<Scalars['String']>
   leadDistributionRuleId: Scalars['String']
   totalLeads: Scalars['Int']
}

export type LeadPrimaryDetails = BasePipelineItemPrimaryDetails & {
   __typename?: 'LeadPrimaryDetails'
   contactId: Scalars['String']
   firstName: PipelineItemPrimaryFieldResult
   lastName: PipelineItemPrimaryFieldResult
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   stage: PipelineItemPrimaryFieldResult
}

export type LeadProperties = BasePipelineItemProperties & {
   __typename?: 'LeadProperties'
   contactId: Scalars['String']
   createdAt: Scalars['String']
   fields: Array<FieldResponseResult>
   latestRemarks?: Maybe<PipelineItemRemarks>
   pipelineItemId: Scalars['String']
   pipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemSchedule?: Maybe<PipelineItemSchedule>
   pipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   scheduledPipelineItem?: Maybe<ScheduledPipelineItem>
}

export type LeadPropertiesFieldsArgs = {
   fieldIds: Array<Scalars['String']>
}

export type LeadPropertiesResponse =
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound
   | LeadProperties

export enum LeadSystemFieldEnum {
   ContactAssignedOn = 'CONTACT_ASSIGNED_ON',
   ContactAssignee = 'CONTACT_ASSIGNEE',
   ContactCustomId = 'CONTACT_CUSTOM_ID',
   ContactEmail = 'CONTACT_EMAIL',
   ContactFirstName = 'CONTACT_FIRST_NAME',
   ContactLastName = 'CONTACT_LAST_NAME',
   ContactPhoneNumber = 'CONTACT_PHONE_NUMBER',
   LeadAssignedOn = 'LEAD_ASSIGNED_ON',
   LeadAssignee = 'LEAD_ASSIGNEE',
   LeadCreatedOn = 'LEAD_CREATED_ON',
   LeadScore = 'LEAD_SCORE',
   LeadStage = 'LEAD_STAGE'
}

export type LeadSystemFieldResult = {
   __typename?: 'LeadSystemFieldResult'
   contactId: Scalars['String']
   fields: Array<SystemFieldEnumResponseResult>
   leadId: Scalars['String']
}

export type LeadSystemFieldsResponse =
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound
   | LeadSystemFieldResult

export type LeadTemplateFilterFields = {
   __typename?: 'LeadTemplateFilterFields'
   fieldIds: Array<Scalars['String']>
   leadTemplateId: Scalars['String']
}

export type LeadTemplateNotFound = GraphQlBaseError & {
   __typename?: 'LeadTemplateNotFound'
   leadTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum LeadTemplateSystemFieldEnum {
   LeadAssignedOn = 'LEAD_ASSIGNED_ON',
   LeadAssignee = 'LEAD_ASSIGNEE',
   LeadCreatedOn = 'LEAD_CREATED_ON',
   LeadScore = 'LEAD_SCORE',
   LeadStage = 'LEAD_STAGE'
}

export type LeadTemplateSystemFields = {
   __typename?: 'LeadTemplateSystemFields'
   fields: Array<Field>
   leadTemplateId: Scalars['String']
}

export type LeadTemplateSystemFieldsResult = {
   __typename?: 'LeadTemplateSystemFieldsResult'
   leadTemplateSystemFields: Array<LeadTemplateSystemFields>
}

export type LeadTemplatesAccessDenied = GraphQlBaseError & {
   __typename?: 'LeadTemplatesAccessDenied'
   leadTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type LeadTemplatesNotFound = GraphQlBaseError & {
   __typename?: 'LeadTemplatesNotFound'
   leadTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type Leads = {
   __typename?: 'Leads'
   leads: Array<Lead>
}

export type LeadsAccessDenied = GraphQlBaseError & {
   __typename?: 'LeadsAccessDenied'
   leadIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type LeadsAreDeleted = GraphQlBaseError & {
   __typename?: 'LeadsAreDeleted'
   leadIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type LeadsNotFound = GraphQlBaseError & {
   __typename?: 'LeadsNotFound'
   leadIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type LeadsNotFoundForPagination = GraphQlBaseError & {
   __typename?: 'LeadsNotFoundForPagination'
   message?: Maybe<Scalars['String']>
}

export type LeadsOrContactsCreationConfig = {
   __typename?: 'LeadsOrContactsCreationConfig'
   referenceFieldsToCompareFromSheet?: Maybe<Scalars['String']>
   referenceFieldsToCompareInRecords?: Maybe<Scalars['String']>
}

export type LeadsOrContactsCreationConfigParams = {
   referenceFieldsToCompareFromSheet?: InputMaybe<Scalars['String']>
   referenceFieldsToCompareInRecords?: InputMaybe<Scalars['String']>
}

export type LeadsOrContactsUpdationConfig = {
   __typename?: 'LeadsOrContactsUpdationConfig'
   fieldsUpdateType: DataLoadingFieldsUpdateType
   selectedReferenceFieldIds?: Maybe<Scalars['String']>
}

export type LeadsOrContactsUpdationConfigParams = {
   fieldsUpdateType: DataLoadingFieldsUpdateType
   selectedReferenceFieldIds?: InputMaybe<Scalars['String']>
}

export type LedgerHeaderConfig = {
   __typename?: 'LedgerHeaderConfig'
   logoUrl?: Maybe<Scalars['String']>
   title?: Maybe<Scalars['String']>
}

export type LicenceExpired = GraphQlBaseError & {
   __typename?: 'LicenceExpired'
   message?: Maybe<Scalars['String']>
}

export type LicenceIsRequired = GraphQlBaseError & {
   __typename?: 'LicenceIsRequired'
   message?: Maybe<Scalars['String']>
}

export type LicenceValidityIsRequired = GraphQlBaseError & {
   __typename?: 'LicenceValidityIsRequired'
   message?: Maybe<Scalars['String']>
}

export enum LineDepartmentAction {
   Approve = 'APPROVE',
   Recommend = 'RECOMMEND',
   Reject = 'REJECT'
}

export type LineDepartmentActionNotPermittedForUser = GraphQlBaseError & {
   __typename?: 'LineDepartmentActionNotPermittedForUser'
   message?: Maybe<Scalars['String']>
}

export type LineDepartmentRemarksRequired = GraphQlBaseError & {
   __typename?: 'LineDepartmentRemarksRequired'
   action: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LineDepartmentRequestMustBeRecommended = GraphQlBaseError & {
   __typename?: 'LineDepartmentRequestMustBeRecommended'
   currentStatus: LineDepartmentRequestStatus
   message?: Maybe<Scalars['String']>
   requestId: Scalars['String']
}

export type LineDepartmentRequestNotFoundError = GraphQlBaseError & {
   __typename?: 'LineDepartmentRequestNotFoundError'
   message?: Maybe<Scalars['String']>
   requestId: Scalars['String']
}

export enum LineDepartmentRequestStatus {
   Approved = 'APPROVED',
   Recommended = 'RECOMMENDED',
   Rejected = 'REJECTED'
}

export type LineDepartmentStatus = {
   __typename?: 'LineDepartmentStatus'
   pipeline: BasePipeline
   status: LineDepartmentVerificationStatus
}

export enum LineDepartmentVerificationStatus {
   Rejected = 'REJECTED',
   Verified = 'VERIFIED',
   YetToVerify = 'YET_TO_VERIFY'
}

export type LineGraph = {
   __typename?: 'LineGraph'
   data: Array<LineGraphData>
   graphId: Scalars['String']
   lineLabels: Array<LineLabel>
   xAxisName: Scalars['String']
   yAxisName?: Maybe<Scalars['String']>
}

export type LineGraphConfig = {
   __typename?: 'LineGraphConfig'
   analyticsLevel: AnalyticsLevel
   dataSources: Array<AnalyticsDataSourceType>
   dataSourcesWithDisplayNames: Array<DataSourceDisplayName>
   description?: Maybe<Scalars['String']>
   dimension: GraphDimension
   drillDownDimension?: Maybe<GraphDimension>
   filterSetId: Scalars['String']
   graphId: Scalars['String']
   isOwner: Scalars['Boolean']
   metrics: Array<GraphMetric>
   name: Scalars['String']
   pipelineId: Scalars['String']
   quickFilterFields: Array<GraphQuickFilterField>
   roles: Array<Role>
   showPoints: Scalars['Boolean']
   showZeroValues: Scalars['Boolean']
}

export type LineGraphData = {
   __typename?: 'LineGraphData'
   xAxisId: Scalars['String']
   xAxisValue: GraphDimensionValue
   yAxisDataPoints: Array<DataPoint>
}

export type LineGraphResult =
   | DashboardAccessDenied
   | DashboardNotFound
   | GraphAccessDenied
   | GraphMetricNotFound
   | GraphNotFound
   | LineGraph
   | NotSupportedGraphParenType
   | ViewAccessDenied
   | ViewNotFound

export type LineLabel = {
   __typename?: 'LineLabel'
   displayName: LineLabelValue
   lineId: Scalars['String']
}

export type LineLabelValue =
   | BaseActivityTemplate
   | BaseTaskTemplate
   | BaseUser
   | GqlStringType
   | Stage

export type LinkGraphsToViewParams = {
   graphIds: Array<Scalars['String']>
   viewId: Scalars['String']
}

export type LinkGraphsToViewResponse =
   | GraphsAccessDenied
   | GraphsNotFound
   | GraphsNotInViewPipeline
   | LinkGraphsToViewResult
   | NotAnalyticsView
   | NotLeadGraphs
   | ViewAccessDenied
   | ViewNotFound

export type LinkGraphsToViewResult = {
   __typename?: 'LinkGraphsToViewResult'
   graphs: Array<UserGraph>
   viewId: Scalars['String']
}

export type LinkRelatedEntityParams = {
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
   selfRelationTarget?: InputMaybe<SelfRelationTarget>
}

export enum LinkRelatedObjectStatus {
   Failed = 'FAILED',
   Success = 'SUCCESS'
}

export type LinkWhatsAppMessageTemplateToPipelineParams = {
   pipelineId: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type LinkWhatsAppMessageTemplateToPipelineResponse =
   | AccountPluginIsDisabled
   | LinkWhatsAppMessageTemplateToPipelineResult
   | PipelineNotFound
   | UserIsNotAnAdministrator
   | WhatsAppMessageTemplateNotFound

export type LinkWhatsAppMessageTemplateToPipelineResult = {
   __typename?: 'LinkWhatsAppMessageTemplateToPipelineResult'
   pipelineId: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type LinkedFieldAndSourceFieldAreInSameTemplate = GraphQlBaseError & {
   __typename?: 'LinkedFieldAndSourceFieldAreInSameTemplate'
   gofId: Scalars['String']
   linkedSourceFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LinkedFieldUpdateRestricted = GraphQlBaseError & {
   __typename?: 'LinkedFieldUpdateRestricted'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LinkedFieldsAreNotDeleted = GraphQlBaseError & {
   __typename?: 'LinkedFieldsAreNotDeleted'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type LinkedFieldsNotEnabledForTaskTemplate = GraphQlBaseError & {
   __typename?: 'LinkedFieldsNotEnabledForTaskTemplate'
   message?: Maybe<Scalars['String']>
}

export enum LinkedFieldsSupportedSalesTemplateType {
   Activity = 'ACTIVITY',
   Form = 'FORM',
   Task = 'TASK'
}

export type LinkedRelatedObjectDetails = {
   __typename?: 'LinkedRelatedObjectDetails'
   failureReason?: Maybe<Scalars['String']>
   name?: Maybe<Scalars['String']>
   relatedEntityId: Scalars['String']
   status: LinkRelatedObjectStatus
}

export type LinkedRootFieldIsNotIdentificationField = GraphQlBaseError & {
   __typename?: 'LinkedRootFieldIsNotIdentificationField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LinkedSourceFieldNotFound = GraphQlBaseError & {
   __typename?: 'LinkedSourceFieldNotFound'
   linkedSourceFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type LinkedSourceFieldsAreDeleted = GraphQlBaseError & {
   __typename?: 'LinkedSourceFieldsAreDeleted'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type LoadBankAccountRequest = {
   __typename?: 'LoadBankAccountRequest'
   createdAt: Scalars['String']
   csvFiles?: Maybe<LoadBankAccountRequestCsvData>
   requestId: Scalars['String']
   requestedBy: BaseUser
   status: LoadBankAccountRequestStatus
}

export type LoadBankAccountRequestCsvData = {
   __typename?: 'LoadBankAccountRequestCsvData'
   csvData?: Maybe<Scalars['String']>
}

export enum LoadBankAccountRequestStatus {
   ApprovedForInitiation = 'APPROVED_FOR_INITIATION',
   Discarded = 'DISCARDED',
   InitiationCompleted = 'INITIATION_COMPLETED',
   InitiationInProgress = 'INITIATION_IN_PROGRESS',
   InitiationQueued = 'INITIATION_QUEUED'
}

export type LogNotRetryable = GraphQlBaseError & {
   __typename?: 'LogNotRetryable'
   currentStatus: PmuActionLogStatus
   message?: Maybe<Scalars['String']>
   pmuActionLogId: Scalars['String']
}

export enum LogicalOperator {
   And = 'AND',
   Or = 'OR'
}

export type LongTextField = BaseField & {
   __typename?: 'LongTextField'
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   formulaExpression?: Maybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isFormulaEnabled: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   regexErrorMessage?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
   validationRegex?: Maybe<Scalars['String']>
}

export type LtpUser = {
   __typename?: 'LtpUser'
   fieldResponses?: Maybe<Array<Maybe<FieldResponse>>>
   licenseNumber: Scalars['String']
   userId: Scalars['String']
}

export type LtpUserApplicationField = {
   __typename?: 'LtpUserApplicationField'
   canEdit: Scalars['Boolean']
   field?: Maybe<Field>
   fieldId: Scalars['String']
   fieldResponse?: Maybe<FieldResponse>
}

export type LtpUserManagementAccessDenied = GraphQlBaseError & {
   __typename?: 'LtpUserManagementAccessDenied'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type LtpUserManagementLog = UserDetailsUpdateLog

export type LtpUserManagementLogChange = {
   __typename?: 'LtpUserManagementLogChange'
   fieldName: Scalars['String']
   newValue?: Maybe<Scalars['String']>
   previousValue?: Maybe<Scalars['String']>
}

export type LtpUserNotFound = GraphQlBaseError & {
   __typename?: 'LtpUserNotFound'
   licenseNumber: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type MakeCallParams = {
   entityId: Scalars['String']
   entityType: CallingEntityType
   fieldId: Scalars['String']
}

export type MakeCallResponse =
   | ActivityAccessDenied
   | ActivityNotFound
   | CloudCallingConfigurationNotProvided
   | CloudCallingServiceError
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | ContactPhoneNumberIsRequiredToMakeCall
   | CustomerPhoneNumberIsRequiredToMakeCall
   | DndError
   | FieldIsDeleted
   | FieldNotFound
   | MakeCallResult
   | MultipleActiveCloudCallingServicesFoundForUser
   | NotImplementedForService
   | NotPhoneNumberField
   | NotSalesTemplateFieldIds
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | TaskAccessDenied
   | TaskNotFound
   | UserNotHaveAnyActiveCloudCallingService
   | UserPhoneNumberNotFound

export type MakeCallResult = {
   __typename?: 'MakeCallResult'
   entityId: Scalars['String']
   entityType: CallingEntityType
   fieldId: Scalars['String']
}

export type MakeTaskShortfallParams = {
   attachments: Array<ApplicationManagementAttachmentInput>
   officerRemarks: Scalars['String']
   otp: Scalars['String']
   pipelineItemId: Scalars['String']
   taskShortfallRemarks: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type MakeTaskShortfallResponse =
   | ApplicationManagementAccessDenied
   | InvalidOtp
   | MakeTaskShortfallResult
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | PipelineItemNotFound
   | TaskNotFound
   | TaskTemplateNotFoundForPipelineItem

export type MakeTaskShortfallResult = {
   __typename?: 'MakeTaskShortfallResult'
   createdCount: Scalars['Int']
}

export type ManagerHaveNoAccessToUserPipelines = GraphQlBaseError & {
   __typename?: 'ManagerHaveNoAccessToUserPipelines'
   message?: Maybe<Scalars['String']>
}

export type ManagerHaveNoAccessToUsersPipelines = GraphQlBaseError & {
   __typename?: 'ManagerHaveNoAccessToUsersPipelines'
   message?: Maybe<Scalars['String']>
   userIds: Array<Scalars['String']>
}

export type ManagerNotFound = GraphQlBaseError & {
   __typename?: 'ManagerNotFound'
   message?: Maybe<Scalars['String']>
}

export type ManagerNotHaveAnyRoles = GraphQlBaseError & {
   __typename?: 'ManagerNotHaveAnyRoles'
   message?: Maybe<Scalars['String']>
}

export type ManagerToUserCircularDependency = GraphQlBaseError & {
   __typename?: 'ManagerToUserCircularDependency'
   message?: Maybe<Scalars['String']>
}

export type MandalAssignmentInProgress = GraphQlBaseError & {
   __typename?: 'MandalAssignmentInProgress'
   existingRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type MandalAssignmentParams = {
   mandals: Array<Scalars['String']>
   reason: Scalars['String']
   userId: Scalars['String']
}

export type MandalAssignmentRequest = BaseOfficerManagementRequest & {
   __typename?: 'MandalAssignmentRequest'
   accountId: Scalars['String']
   authority?: Maybe<Scalars['String']>
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   errorMessage?: Maybe<Scalars['String']>
   id: Scalars['String']
   initiatedBy: Scalars['String']
   initiatedUser: User
   mandals: Array<Scalars['String']>
   operationType: OfficerManagementOperationType
   reason?: Maybe<Scalars['String']>
   status: OfficerManagementStatusType
   updatedAt: Scalars['String']
   user: User
   userId: Scalars['String']
}

export type MandalFieldNotFound = GraphQlBaseError & {
   __typename?: 'MandalFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type MandatoryFieldsResponseNotFilled = {
   __typename?: 'MandatoryFieldsResponseNotFilled'
   fieldIds: Array<Scalars['String']>
}

export type ManualLeadDistributionRuleExecLog = {
   __typename?: 'ManualLeadDistributionRuleExecLog'
   assignedLeadsCount: Scalars['Int']
   completedAt?: Maybe<Scalars['String']>
   distributionThrough: DistributionThroughType
   distributionThroughItems: Array<DistributeThroughItemExecLog>
   isPartiallyAssigned: Scalars['Boolean']
   leadDistributionRuleExecLogId: Scalars['String']
   name: Scalars['String']
   pipelineId: Scalars['String']
   status: LeadDistributionRuleExecLogStatus
   triggeredAt: Scalars['String']
   triggeredBy: BaseUser
}

export type ManualLeadDistributionRuleSettings = BaseLeadDistributionRuleSettings & {
   __typename?: 'ManualLeadDistributionRuleSettings'
   assignBasedOnAvailability: Scalars['Boolean']
   assigneeFieldIdsToNotify: Array<Scalars['String']>
   configStatus: LeadDistributionEntityConfigStatus
   distributionType: LeadDistributionRuleType
   leadDistributionRuleId: Scalars['String']
   managerFields: Array<LeadDistributionRuleManagerField>
   overrideGlobalQuota?: Maybe<Scalars['Boolean']>
   smartDistribution?: Maybe<Scalars['Boolean']>
   syncAssigneeHierarchy: Scalars['Boolean']
}

export type ManualTriggerIsNotEnabled = GraphQlBaseError & {
   __typename?: 'ManualTriggerIsNotEnabled'
   automationWorkflowId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type MarkNotificationAsReadParams = {
   notificationId: Scalars['String']
}

export type MarkNotificationAsReadResponse =
   | MarkNotificationAsReadResult
   | NotificationNotFound

export type MarkNotificationAsReadResult = {
   __typename?: 'MarkNotificationAsReadResult'
   notificationId: Scalars['String']
}

export type MarkNotificationAsUnreadParams = {
   notificationId: Scalars['String']
}

export type MarkNotificationAsUnreadResponse =
   | MarkNotificationAsUnreadResult
   | NotificationNotFound

export type MarkNotificationAsUnreadResult = {
   __typename?: 'MarkNotificationAsUnreadResult'
   notificationId: Scalars['String']
}

export type MarkScheduledPipelineItemsAsCompletedParams = {
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export type MarkScheduledPipelineItemsAsCompletedResponse =
   | MarkScheduledPipelineItemsAsCompletedResult
   | PipelineItemScheduledIdsAccessDenied
   | PipelineItemScheduledIdsAreAlreadyCompleted
   | PipelineItemScheduledIdsNotFound

export type MarkScheduledPipelineItemsAsCompletedResult = {
   __typename?: 'MarkScheduledPipelineItemsAsCompletedResult'
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export type MarkTdrAccountRequestAsReadParams = {
   tdrAccountRequestId: Scalars['String']
}

export type MarkTdrAccountRequestAsReadResponse =
   | MarkTdrAccountRequestAsReadResult
   | TdrAccountRequestAlreadyRead
   | TdrAccountRequestNotFound

export type MarkTdrAccountRequestAsReadResult = {
   __typename?: 'MarkTDRAccountRequestAsReadResult'
   readAt: Scalars['String']
   tdrAccountRequestId: Scalars['String']
}

export type MarkUnreadNotificationsAsReadResponse = MarkUnreadNotificationsAsReadResult

export type MarkUnreadNotificationsAsReadResult = {
   __typename?: 'MarkUnreadNotificationsAsReadResult'
   isMarkedSuccessfully: Scalars['Boolean']
}

export type MarketValueShouldBePositiveValue = GraphQlBaseError & {
   __typename?: 'MarketValueShouldBePositiveValue'
   marketValue: Scalars['Float']
   message?: Maybe<Scalars['String']>
}

export type MaxNodesLimitExceeded = GraphQlBaseError & {
   __typename?: 'MaxNodesLimitExceeded'
   maxNodesLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type MaxNumberOfFilesCannotBeNegativeOrZero = GraphQlBaseError & {
   __typename?: 'MaxNumberOfFilesCannotBeNegativeOrZero'
   message?: Maybe<Scalars['String']>
}

export type MaxNumberOfFilesLimitExceeded = GraphQlBaseError & {
   __typename?: 'MaxNumberOfFilesLimitExceeded'
   maxLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type MaxValueLessThanMinValue = GraphQlBaseError & {
   __typename?: 'MaxValueLessThanMinValue'
   message?: Maybe<Scalars['String']>
}

export enum MergeConflictedAssociatedPipelineItemsStatus {
   NoMergePermission = 'NO_MERGE_PERMISSION',
   PipelineAccessDenied = 'PIPELINE_ACCESS_DENIED',
   PipelineItemsAccessDenied = 'PIPELINE_ITEMS_ACCESS_DENIED'
}

export type MergePipelineItemsNotification = {
   __typename?: 'MergePipelineItemsNotification'
   customObjectSingularName?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
   notificationId: Scalars['String']
   notificationType: NotificationTypes
   pipelineItemDetails: NotificationPipelineItemDetails
   readAt?: Maybe<Scalars['String']>
   sentAt: Scalars['String']
   title: Scalars['String']
}

export type MergePipelineItemsParams = {
   fieldResponses: Array<MergedFieldResponseParams>
   mergedPipelineItemId: Scalars['String']
   pipelineItemId: Scalars['String']
   relatedEntities?: InputMaybe<Array<InputMaybe<MergedRelatedEntityParams>>>
}

export type MergePipelineItemsResponse =
   | AtLeastOneCustomObjectIdentificationFieldIsRequired
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | BothPipelineItemsCannotBeSame
   | ConflictingRelationsForMergedPipelineItems
   | DecimalPrecisionExceeded
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsNotFound
   | FieldsResponseIsRequired
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MergePipelineItemsResult
   | MergedPipelineItemAccessDenied
   | MergedPipelineItemIsDeleted
   | MergedPipelineItemMergeRequestIsInProgress
   | MergedPipelineItemNotFound
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldsWritePermission
   | NotAllowedFileFormats
   | NotConflictedRelatedEntities
   | NotConflictedRelations
   | NotPipelineItemFields
   | NotPipelineItemTemplateFields
   | ParentFieldsNotFilled
   | PipelineAccessDeniedToAssignee
   | PipelineItemAccessDenied
   | PipelineItemAssigneeIsDeactivated
   | PipelineItemAssigneeNotFound
   | PipelineItemIsDeleted
   | PipelineItemMergeRequestIsInProgress
   | PipelineItemNotFound
   | PipelineItemStageFieldResponseIsRequired
   | PipelineItemsNotInSamePipelineItemTemplate
   | RelatedEntitiesNotFound
   | RelationsAreNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | UniqueFieldsResponseAlreadyExists
   | UserDoesNotHaveMergePermissions
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type MergePipelineItemsResult = {
   __typename?: 'MergePipelineItemsResult'
   mergedFieldResponses: Array<FieldResponse>
   mergedPipelineItemId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type MergePipelineItemsWithContactsParams = {
   mergedFieldResponses: Array<MergedFieldResponseParams>
   mergedPipelineItemId: Scalars['String']
   pipelineItemId: Scalars['String']
   relatedEntities?: InputMaybe<Array<InputMaybe<MergedRelatedEntityParams>>>
}

export type MergePipelineItemsWithContactsResponse =
   | AtLeastOneCustomObjectIdentificationFieldIsRequired
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | BothContactsHaveActivePipelineItems
   | BothPipelineItemsCannotBeSame
   | ConflictingRelationsForMergedPipelineItems
   | DecimalPrecisionExceeded
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsNotFound
   | FieldsResponseIsRequired
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MergePipelineItemsWithContactsResult
   | MergedPipelineItemAccessDenied
   | MergedPipelineItemIsDeleted
   | MergedPipelineItemMergeRequestIsInProgress
   | MergedPipelineItemNotFound
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldsWritePermission
   | NotAllowedFileFormats
   | NotConflictedRelatedEntities
   | NotConflictedRelations
   | NotPipelineItemFields
   | NotSupportedMergePipelineItemsWithContactsActionForPipeline
   | ParentFieldsNotFilled
   | PipelineAccessDeniedToAssignee
   | PipelineItemAccessDenied
   | PipelineItemAssigneeIsDeactivated
   | PipelineItemAssigneeNotFound
   | PipelineItemIsDeleted
   | PipelineItemMergeRequestIsInProgress
   | PipelineItemNotFound
   | PipelineItemStageFieldResponseIsRequired
   | PipelineItemsNotInSamePipelineItemTemplate
   | ProvideAtLeastOneIdentificationField
   | RelatedEntitiesNotFound
   | RelationsAreNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | UniqueFieldsResponseAlreadyExists
   | UserDoesNotHaveMergePermissions
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type MergePipelineItemsWithContactsResult = {
   __typename?: 'MergePipelineItemsWithContactsResult'
   mergedFieldResponses: Array<FieldResponse>
   mergedPipelineItemId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type MergedFieldResponseParams = {
   fieldId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type MergedPipelineItemAccessDenied = GraphQlBaseError & {
   __typename?: 'MergedPipelineItemAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type MergedPipelineItemIsDeleted = GraphQlBaseError & {
   __typename?: 'MergedPipelineItemIsDeleted'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type MergedPipelineItemMergeRequestIsInProgress = GraphQlBaseError & {
   __typename?: 'MergedPipelineItemMergeRequestIsInProgress'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type MergedPipelineItemNotFound = GraphQlBaseError & {
   __typename?: 'MergedPipelineItemNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type MergedRelatedEntityParams = {
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
}

export type MessageTemplateNotFound = GraphQlBaseError & {
   __typename?: 'MessageTemplateNotFound'
   message?: Maybe<Scalars['String']>
   messageTemplateId: Scalars['String']
}

export type MetricFormulaNode = {
   __typename?: 'MetricFormulaNode'
   nodeType: FormulaNodeType
   value: Scalars['String']
}

export type MetricFormulaNodeParams = {
   nodeType: FormulaNodeType
   value: Scalars['String']
}

export type MetricNotLinkedToGraph = GraphQlBaseError & {
   __typename?: 'MetricNotLinkedToGraph'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
   metricId: Scalars['String']
}

export enum MetricType {
   Avg = 'AVG',
   Count = 'COUNT',
   CustomMetric = 'CUSTOM_METRIC',
   Max = 'MAX',
   Min = 'MIN',
   Sum = 'SUM',
   UniqueCount = 'UNIQUE_COUNT'
}

export type MetricUsedInCustomMetricsFormula = GraphQlBaseError & {
   __typename?: 'MetricUsedInCustomMetricsFormula'
   message?: Maybe<Scalars['String']>
   metricIds: Array<Scalars['String']>
}

export type MetricsInFormulaNotLinkedToSameGraph = GraphQlBaseError & {
   __typename?: 'MetricsInFormulaNotLinkedToSameGraph'
   message?: Maybe<Scalars['String']>
   metricIds: Array<Scalars['String']>
}

export type MetricsNotInSameGraph = GraphQlBaseError & {
   __typename?: 'MetricsNotInSameGraph'
   message?: Maybe<Scalars['String']>
   metricId: Scalars['String']
}

export type MimeTypeIsRequiredForFileUploaderResponse = GraphQlBaseError & {
   __typename?: 'MimeTypeIsRequiredForFileUploaderResponse'
   message?: Maybe<Scalars['String']>
   urls: Array<Scalars['String']>
}

export type MinimumOneMetricIsRequiredForGraph = GraphQlBaseError & {
   __typename?: 'MinimumOneMetricIsRequiredForGraph'
   message?: Maybe<Scalars['String']>
}

export type MinimumOneMetricShouldShowInGraph = GraphQlBaseError & {
   __typename?: 'MinimumOneMetricShouldShowInGraph'
   message?: Maybe<Scalars['String']>
}

export type MismatchBetweenMainAndComparisonMetricConfig = GraphQlBaseError & {
   __typename?: 'MismatchBetweenMainAndComparisonMetricConfig'
   message?: Maybe<Scalars['String']>
}

export type MissedParameterConditions = GraphQlBaseError & {
   __typename?: 'MissedParameterConditions'
   message?: Maybe<Scalars['String']>
   parameterConditionIds: Array<Scalars['String']>
}

export type MissedPipelineTaskTemplateIds = GraphQlBaseError & {
   __typename?: 'MissedPipelineTaskTemplateIds'
   message?: Maybe<Scalars['String']>
   taskTemplateIds: Array<Scalars['String']>
}

export type MissingAllocationGroupSets = GraphQlBaseError & {
   __typename?: 'MissingAllocationGroupSets'
   allocationGroupSetIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type MissingDimensionDataSources = GraphQlBaseError & {
   __typename?: 'MissingDimensionDataSources'
   dataSources: Array<AnalyticsDataSourceType>
   message?: Maybe<Scalars['String']>
}

export type MissingFieldIdsInGoF = GraphQlBaseError & {
   __typename?: 'MissingFieldIdsInGoF'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type MissingGofIds = GraphQlBaseError & {
   __typename?: 'MissingGOFIds'
   message?: Maybe<Scalars['String']>
   sectionsNames: Array<Scalars['String']>
}

export type MissingGoFIdsInTemplate = GraphQlBaseError & {
   __typename?: 'MissingGoFIdsInTemplate'
   gofIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type MissingLeadBucketIds = GraphQlBaseError & {
   __typename?: 'MissingLeadBucketIds'
   leadBucketIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type MissingMetricDataSources = GraphQlBaseError & {
   __typename?: 'MissingMetricDataSources'
   dataSources: Array<AnalyticsDataSourceType>
   message?: Maybe<Scalars['String']>
}

export type MissingOrderFieldIds = GraphQlBaseError & {
   __typename?: 'MissingOrderFieldIds'
   message?: Maybe<Scalars['String']>
   sectionsNames: Array<Scalars['String']>
}

export type MissingResourcesInPipeline = GraphQlBaseError & {
   __typename?: 'MissingResourcesInPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type MissingStagesInPipeline = GraphQlBaseError & {
   __typename?: 'MissingStagesInPipeline'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export enum MonthDayEnum {
   FirstDay = 'FIRST_DAY',
   LastDay = 'LAST_DAY'
}

export type MoveNodeNotSupportedInAutomationWorkflowExecType = GraphQlBaseError & {
   __typename?: 'MoveNodeNotSupportedInAutomationWorkflowExecType'
   automationWorkflowId?: Maybe<Scalars['String']>
   execType: AutomationWorkflowExecType
   message?: Maybe<Scalars['String']>
}

export type MoveNodeParams = {
   nodeId: Scalars['String']
   parentNodeId?: InputMaybe<Scalars['String']>
   parentNodeResult?: InputMaybe<NodeResultEnum>
}

export type MoveNodeResponse =
   | BothNodeAndParentNodeCannotBeSame
   | MoveNodeNotSupportedInAutomationWorkflowExecType
   | MoveNodeResult
   | NodeToParentNodeCircularDependency
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotEditableNodes
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PipelineAccessDenied
   | UserIsNotAnAdministrator

export type MoveNodeResult = {
   __typename?: 'MoveNodeResult'
   nodeId: Scalars['String']
   parentNodeId?: Maybe<Scalars['String']>
   parentNodeResult?: Maybe<NodeResultEnum>
}

export type MultiSelectField = BaseField & {
   __typename?: 'MultiSelectField'
   allowOtherOptions: Scalars['Boolean']
   conditionalOptions: Array<ConditionalFieldOptions>
   defaultValues: Array<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isLabelsEnabled: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   multiSelectFieldUiStyle: MultiSelectFieldUiStyleEnum
   name: Scalars['String']
   optionColors: Array<OptionColorConfig>
   options: Array<Scalars['String']>
   optionsValueType: OptionsValueType
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export enum MultiSelectFieldUiStyleEnum {
   CheckboxGroup = 'CHECKBOX_GROUP',
   MultiSelect = 'MULTI_SELECT'
}

export type MultipleAccountsParameters = GraphQlBaseError & {
   __typename?: 'MultipleAccountsParameters'
   message?: Maybe<Scalars['String']>
}

export type MultipleActiveCloudCallingServicesFoundForUser = GraphQlBaseError & {
   __typename?: 'MultipleActiveCloudCallingServicesFoundForUser'
   message?: Maybe<Scalars['String']>
}

export type MultipleChildrenNotSupported = GraphQlBaseError & {
   __typename?: 'MultipleChildrenNotSupported'
   message?: Maybe<Scalars['String']>
   parentNodeId?: Maybe<Scalars['String']>
   parentNodeResult?: Maybe<NodeResultEnum>
}

export type MultipleContactsFound = GraphQlBaseError & {
   __typename?: 'MultipleContactsFound'
   contactIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type MultipleEntitiesNotSupportedInOneToManyRelation = GraphQlBaseError & {
   __typename?: 'MultipleEntitiesNotSupportedInOneToManyRelation'
   message?: Maybe<Scalars['String']>
}

export type MultipleEntitiesNotSupportedInOneToOneRelation = GraphQlBaseError & {
   __typename?: 'MultipleEntitiesNotSupportedInOneToOneRelation'
   message?: Maybe<Scalars['String']>
}

export type MultiselectIsNotSupportedForSingleCardinalityRelation = GraphQlBaseError & {
   __typename?: 'MultiselectIsNotSupportedForSingleCardinalityRelation'
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
}

export type Mutation = {
   __typename?: 'Mutation'
   acceptTdrTransactionByOwner: AcceptTdrTransactionByOwnerResponse
   actOnApplicationInPortal: ActOnApplicationInPortalResponse
   actOnPipelineItem: ActonPipelineItemResponse
   actOnTdrApplication: ActOnTdrApplicationResponse
   activatePluginServiceAccount: ActivatePluginServiceAccountResponse
   activateUser: ActivateUserResponse
   addActionTypesToIdentification: AddActionTypesToIdentificationResponse
   addActivityTemplatesToPipeline: AddActivityTemplatesToPipelineResponse
   addApplicationTab: AddApplicationTabResponse
   addApplicationTabGof: AddApplicationTabGoFResponse
   addAttachmentsForRemarks: AddAttachmentsForRemarksResponse
   addAttachmentsForRemarksInTaskDraft: AddAttachmentsForRemarksInTaskDraftResponse
   addCallLogsToTaskDraft: AddCallLogsToTaskDraftResponse
   addFeeHeadersInEntityFeeRuleSet: AddFeeHeadersInEntityFeeRuleSetResponse
   addFieldConditionalOptions: AddFieldConditionalOptionsResponse
   addFieldRoles: AddFieldRolesResponse
   addGallaboxAccount: AddGallaboxAccountResponse
   addGraphQuickFilterField: AddGraphQuickFilterFieldIdResponse
   addGraphQuickFilterFields: AddGraphQuickFilterFieldResponse
   addGupShupAccount: AddGupShupAccountResponse
   addIdentificationsToDashboard: AddIdentificationsToDashboardResponse
   addKnowlarityAccount: AddKnowlarityAccountResponse
   addLayoutToForm: AddLayoutToFormResponse
   addOptionsToCheckboxGroupField: AddOptionsToCheckboxGroupFieldResponse
   addOptionsToDropdownField: AddOptionsToDropdownFieldResponse
   addOptionsToFieldsSelectorField: AddOptionsToFieldsSelectorFieldResponse
   addOptionsToMultiSelectGroupField: AddOptionsToMultiSelectFieldResponse
   addOptionsToRadioGroupField: AddOptionsToRadioGroupFieldResponse
   addPipelineIdentifications: AddPipelineIdentificationsResponse
   addPipelineItemRemarks: AddPipelineItemRemarksResponse
   addPipelineItemTemplatesAdminPermissionForUser: AddPipelineItemTemplatesAdminPermissionForUserResponse
   addPipelinesAdminPermissionForUser: AddPipelinesAdminPermissionForUserResponse
   addRelatedEntities: AddRelatedEntitiesResponse
   addRelatedPipelineItemRemark: AddRelatedPipelineItemRemarksResponse
   addSmartfloAccount: AddSmartfloAccountResponse
   addStageUpdatePermissions: AddStageUpdatePermissionResponse
   addSubmissionConfigToForm: AddSubmissionConfigToFormResponse
   addUserGroupsForBoard: AddUserGroupsForBoardResponse
   addUserGroupsForBoardList: AddUserGroupsForBoardListResponse
   addUserIdentifications: AddUserIdentificationsResponse
   addUsersToIdentification: AddUsersToIdentificationResponse
   addViewSortByFields: AddSortByFieldsResponse
   addWatiAccount: AddWatiAccountResponse
   addWhatsAppBusinessPhoneNumberUsers: AddWhatsAppBusinessPhoneNumberUsersResponse
   addWhatsappBusinessNumber: AddWhatsAppBusinessNumberResponse
   addWhatsappBusinessPhoneNumber: AddWhatsAppBusinessPhoneNumberResponse
   adminSetUserPin: AdminSetUserPinResponse
   applicationUpdatedDummyMutation: ApplicationUpdatedDummyMutationResult
   applyForDeemedApprovalInPortal: ApplyForDeemedApprovalInPortalResponse
   applyPortalApplicationKey: ApplyPortalApplicationKeyResponse
   approveLineDepartmentRecommendation: ApproveLineDepartmentRecommendationResponse
   askQueryInThread: AskQueryInThreadResponse
   assignDocumentVerificationUser: AssignDocumentVerificationUserResponse
   assignFriend: AssignFriendResponse
   authorizeGoogleUser: AuthorizeGoogleUserResponse
   cancelTdrOrderInPortal: CancelTdrOrderInPortalResponse
   cancelTdrPaymentInPortal: CancelTdrPaymentInPortalResponse
   changeApplicationDisplayStageShortfallFieldsStatus: ChangeApplicationDisplayStageShortFallFieldsStatusResponse
   changeAutoGenerateApplicationIdInCreationStatus: ChangeAutoGenerateApplicationIdInCreationStatusResponse
   changeFieldType: ChangeFieldTypeResponse
   changeMakeApplicationFieldsAsShortfallValue: ChangeMakeApplicationFieldsAsShortfallValueResponse
   changeStageColor: ChangeStageColorResponse
   checkCaRegistrationNumberLinkedToOtherUsers: CheckCaRegistrationNumberLinkedToOtherUsersResponse
   clearApplicationAddAnotherGof: ClearApplicationAddAnotherGoFResponse
   clearApplicationAddAnotherGofInPortal: ClearApplicationAddAnotherGoFInPortalResponse
   clearAutomationWorkflowExecLogsFilter: ClearAutomationWorkflowExecLogsFilterResponse
   clearDealAddAnotherGof: ClearDealAddAnotherGoFResponse
   clearDistributionThroughEntities: ClearDistributionThroughEntitiesResponse
   clearFieldConditionalOptionsConfig: ClearFieldConditionalOptionsConfigResponse
   clearLeadAddAnotherGof: ClearLeadAddAnotherGoFResponse
   clearPipelineCustomObjectAddAnotherGof: ClearPipelineCustomObjectAddAnotherGoFResponse
   clearRelatedEntityAddAnotherGof: ClearRelatedEntityAddAnotherGoFResponse
   clearScheduledAutomationWorkflowExecLogsFilter: ClearScheduledAutomationWorkflowExecLogsFilterResponse
   clearTaskAddAnotherGof: ClearTaskAddAnotherGoFResponse
   clearTaskDraft: ClearTaskDraftResponse
   clearUsersTabFilters: ClearUsersTabFiltersResponse
   clockIn: ClockInResponse
   clockOut: ClockOutResponse
   cloneAutomationWorkflow: CloneAutomationWorkflowResponse
   cloneGraph: CloneGraphResponse
   cloneLeadDistributionRule: CloneLeadDistributionRuleResponse
   configureAdvancedAnalytics: ConfigureAdvancedAnalyticsResponse
   configureDealsFeature: ConfigureDealsFeatureResponse
   createActivityTemplate: CreateActivityTemplateResponse
   createActivityTemplateGof: CreateActivityTemplateGoFResponse
   createAgentAllocationGroup: CreateAgentAllocationGroupResponse
   createAllocationGroupSetForAgentAllocationGroups: CreateAllocationGroupSetForAgentAllocationGroupsResponse
   createAllocationGroupSetForAgents: CreateAllocationGroupSetForAgentsResponse
   createApplication: CreateApplicationResponse
   createApplicationAddAnotherGof: CreateApplicationAddAnotherGoFResponse
   createApplicationAddAnotherGofInPortal: CreateApplicationAddAnotherGoFInPortalResponse
   createApplicationInPortal: CreateApplicationInPortalResponse
   createAssigneeField: CreateAssigneeFieldResponse
   createAssigneeGroup: CreateAssigneeGroupResponse
   createAutomationWorkflowCondition: CreateAutomationWorkflowConditionResponse
   createAutomationWorkflowFilter: CreateAutomationWorkflowFilterResponse
   createAutomationWorkflowNode: CreateAutomationWorkflowNodeResponse
   createBarGraph: CreateBarGraphResponse
   createBoard: CreateBoardResponse
   createBoardList: CreateBoardListResponse
   createCalendarPipelineItemSchedule: CreateCalendarPipelineItemScheduleResponse
   createCheckboxGroupField: CreateCheckboxGroupFieldResponse
   createCondition: CreateConditionResponse
   createConditionNode: CreateNodeConditionResponse
   createConditionNodeFilter: CreateConditionNodeFilterResponse
   createContactTemplateGof: CreateContactTemplateGoFResponse
   createCustomIdField: CreateCustomIdFieldResponse
   createDashboard: CreateDashboardResponse
   createDateField: CreateDateFieldResponse
   createDateTimeField: CreateDateTimeFieldResponse
   createDealAddAnotherGof: CreateDealAddAnotherGoFResponse
   createDocumentLog: CreateDocumentLogResponse
   createDocumentTemplate: CreateDocumentTemplateResponse
   createDonutChart: CreateDonutChartResponse
   createDropdownField: CreateDropdownFieldResponse
   createEmailField: CreateEmailFieldResponse
   createEntityCustomCheckpoint: CreateEntityCustomCheckpointResponse
   createEntityDeal: CreateEntityDealResponse
   createEntityFeeRuleSet: CreateEntityFeeRuleSetResponse
   createEventBasedAutomationWorkflow: CreateEventBasedAutomationWorkflowResponse
   createEventBasedLeadDistributionRule: CreateEventBasedLeadDistributionRuleResponse
   createEventTriggerCondition: CreateEventTriggerConditionResponse
   createEventTriggerFilter: CreateEventTriggerFilterResponse
   createFieldsSelectorField: CreateFieldsSelectorFieldResponse
   createFileUploaderField: CreateFileUploaderFieldResponse
   createFilter: CreateFilterResponse
   createFilterForBoard: CreateFilterForBoardResponse
   createFilterForBoardList: CreateFilterForBoardListResponse
   createFloatField: CreateFloatFieldResponse
   createForm: CreateFormResponse
   createFunnelGraph: CreateFunnelGraphResponse
   createGeoLocationField: CreateGeoLocationFieldResponse
   createGeoShapeField: CreateGeoShapeFieldResponse
   createGraphDimension: CreateGraphDimensionResponse
   createGraphMetric: CreateGraphMetricResponse
   createGroupedBarGraph: CreateGroupedBarGraphResponse
   createIdentification: IdentificationResponse
   createIntegerField: CreateIntegerFieldResponse
   createLayout: CreateLayoutResponse
   createLeadAddAnotherGof: CreateLeadAddAnotherGoFResponse
   createLeadBucket: CreateLeadBucketResponse
   createLeadDistributionRule: CreateLeadDistributionRuleResponse
   createLeadWithContact: CreateLeadWithContactResponse
   createLineGraph: CreateLineGraphResponse
   createLinkedField: CreateLinkedFieldResponse
   createLongTextField: CreateLongTextFieldResponse
   createMultiSelectField: CreateMultiSelectFieldResponse
   createNodeAddAnotherGof: CreateNodeAddAnotherGoFResponse
   createNodeCallWebhook: CreateNodeCallWebhookResponse
   createNodeClearUndoneLeadTasks: CreateNodeClearUndoneLeadTasksResponse
   createNodeCreatePipelineEvent: CreateNodeCreatePipelineEventResponse
   createNodeCreateRelatedRecord: CreateNodeCreateRelatedRecordResponse
   createNodeCreateTask: CreateNodeCreateTaskResponse
   createNodeExecuteFunction: CreateNodeExecuteFunctionResponse
   createNodeGenerateDocument: CreateNodeGenerateDocumentResponse
   createNodeGenerateNumber: CreateNodeGenerateNumberResponse
   createNodeInitiateRefund: CreateNodeInitiateRefundResponse
   createNodeRemoveAssignees: CreateNodeRemoveAssigneesResponse
   createNodeRequestPayment: CreateNodeRequestPaymentResponse
   createNodeRequestPaymentWithFeeRules: CreateNodeRequestPaymentWithFeeRulesResponse
   createNodeSendDataToSegment: CreateNodeSendDataToSegmentResponse
   createNodeSendPipelineItemNotification: CreateNodeSendPipelineItemNotificationResponse
   createNodeSendWhatsappMessageNode: CreateNodeSendWhatsAppMessageNodeResponse
   createNodeSignDocument: CreateNodeSignDocumentResponse
   createNodeSwiftsellOutboundWebhookNode: CreateNodeSwiftsellOutboundWebhookResponse
   createNodeUpdateDisplayStage: CreateNodeUpdateDisplayStageResponse
   createNodeUpdateLead: CreateNodeUpdateLeadResponse
   createNodeUpdateLeadStage: CreateNodeUpdateLeadStageResponse
   createNodeUpdatePipelineItemAssignee: CreateNodeUpdatePipelineItemAssigneeResponse
   createNodeUpdateRelatedRecords: CreateNodeUpdateRelatedRecordsResponse
   createNodeUpdateTask: CreateNodeUpdateTaskResponse
   createNote: CreateNoteResponse
   createObjectionTask: CreateObjectionTaskResponse
   createObjectionTaskAddAnotherGofBulk: CreateObjectionTaskAddAnotherGoFBulkResponse
   createParameter: CreateParameterResponse
   createParameterCondition: CreateParameterConditionResponse
   createPhoneNumberField: CreatePhoneNumberFieldResponse
   createPieChart: CreatePieChartResponse
   createPipeline: CreatePipelineResponse
   createPipelineCustomObject: CreatePipelineCustomObjectResponse
   createPipelineCustomObjectAddAnotherGof: CreatePipelineCustomObjectAddAnotherGoFResponse
   createPipelineEventTemplate: CreatePipelineEventTemplateResponse
   createPipelineEventTemplateGof: CreatePipelineEventTemplateGoFResponse
   createPipelineItemPaymentRequest: CreatePipelineItemPaymentRequestResponse
   createPipelineItemReminder: CreatePipelineItemReminderResponse
   createPipelineItemSchedule: CreatePipelineItemScheduleResponse
   createPipelineItemTemplate: CreatePipelineItemTemplateResponse
   createPipelineItemTemplateGof: CreatePipelineItemTemplateGofResponse
   createPivotTableGraph: CreatePivotTableGraphResponse
   createPlainTextField: CreatePlainTextFieldResponse
   createPortal: CreatePortalResponse
   createPortalApplication: CreatePortalApplicationResponse
   createRadioGroupField: CreateRadioGroupFieldResponse
   createRazorpayOrderInPortal: CreateRazorpayOrderInPortalResponse
   createRecordCreationConfig: CreateRecordCreationConfigResponse
   createRelatedApplication: CreateRelatedApplicationResponse
   createRelatedApplicationInPortal: CreateRelatedApplicationInPortalResponse
   createRelatedEntityAddAnotherGof: CreateRelatedEntityAddAnotherGoFResponse
   createRelatedLeadWithContact: CreateRelatedLeadWithContactResponse
   createRelatedPipelineCustomObject: CreateRelatedPipelineCustomObjectResponse
   createRelation: CreateRelationResponse
   createRelationField: CreateRelationFieldResponse
   createResource: CreateResourceResponse
   createScheduledAutomationWorkflow: CreateScheduledAutomationWorkflowResponse
   createScorecardChart: CreateScorecardChartResponse
   createScoringParameter: CreateScoringParameterResponse
   createScoringParameters: CreateScoringParametersResponse
   createShortTextField: CreateShortTextFieldResponse
   createSiteInspectionTaskAddAnotherGof: CreateSiteInspectionTaskAddAnotherGoFResponse
   createSiteInspectionTaskAddAnotherGofBulk: CreateSiteInspectionTaskAddAnotherGoFBulkResponse
   createStackedBarGraph: CreateStackedBarGraphResponse
   createStage: CreateStageResponse
   createStageTransition: CreateStageTransitionResponse
   createTab: CreateTabResponse
   createTableGraph: CreateTableGraphResponse
   createTask: CreateTaskResponse
   createTaskAddAnotherGof: CreateTaskAddAnotherGoFResponse
   createTaskTemplate: CreateTaskTemplateResponse
   createTaskTemplateGof: CreateTaskTemplateGoFResponse
   createTdrAccountPurchaseRequest: CreateTdrAccountPurchaseRequestResponse
   createTdrDigitalizationApplication: CreateTdrDigitalizationApplicationResponse
   createTdrOrderInPortal: CreateTdrOrderInPortalResponse
   createTdrPaymentInPortal: CreateTdrPaymentInPortalResponse
   createTdrRequestInPortal: CreateTdrRequestInPortalResponse
   createTdrRequestInPortalAndSendOtp: CreateTdrRequestInPortalAndSendOtpResponse
   createThread: CreateThreadResponse
   createTimeField: CreateTimeFieldResponse
   createUnifiedApplicationInPortal: CreateUnifiedApplicationInPortalResponse
   createUrlField: CreateUrlFieldResponse
   createUser: CreateUserResponse
   createUserPropertiesTemplateGof: CreateUserPropertiesTemplateGofResponse
   createUserWithPhoneNumberName: CreateUserInOfficerManagementResponse
   createVerificationTaskFromExistingTask: CreateVerificationTaskFromExistingTaskResponse
   createViewFilter: CreateFilterForViewResponse
   createViewInBoard: CreateViewInBoardResponse
   createViewInBoardList: CreateViewInBoardListResponse
   deactivatePluginServiceAccount: DeactivatePluginServiceAccountResponse
   deactivateUser: DeactivateUserResponse
   deleteAllocationGroupSet: DeleteAllocationGroupSetResponse
   deleteApplicationAddAnotherGof: DeleteApplicationAddAnotherGoFResponse
   deleteApplicationAddAnotherGofInPortal: DeleteApplicationAddAnotherGoFInPortalResponse
   deleteApplicationInPortal: DeleteApplicationInPortalResponse
   deleteApplicationTab: DeleteApplicationTabResponse
   deleteApplicationTabGofs: DeleteApplicationTabGofsResponse
   deleteApplicationTabSections: DeleteApplicationTabSectionsResponse
   deleteAssigneeGroup: DeleteAssigneeGroupResponse
   deleteAutomationWorkflow: DeleteAutomationWorkflowResponse
   deleteAutomationWorkflowCondition: DeleteAutomationWorkflowConditionResponse
   deleteAutomationWorkflowFilter: DeleteAutomationWorkflowFilterResponse
   deleteBoard: DeleteBoardResponse
   deleteBoardList: DeleteBoardListResponse
   deleteCondition: DeleteConditionResponse
   deleteDashboard: DeleteDashboardResponse
   deleteDealAddAnotherGof: DeleteDealAddAnotherGoFResponse
   deleteDocument: DeleteDocumentResponse
   deleteDocumentTemplate: DeleteDocumentTemplateResponse
   deleteEventTriggerCondition: DeleteEventTriggerConditionResponse
   deleteEventTriggerFilter: DeleteEventTriggerFilterResponse
   deleteField: DeleteFieldResponse
   deleteFilter: DeleteFilterResponse
   deleteGof: DeleteGoFResponse
   deleteGraphDimension: DeleteGraphDimensionResponse
   deleteGraphs: DeleteGraphsResponse
   deleteIdentification: DeleteIdentificationResponse
   deleteLeadAddAnotherGof: DeleteLeadAddAnotherGoFResponse
   deleteLeadBucket: DeleteLeadBucketResponse
   deleteMetric: DeleteMetricResponse
   deleteNode: DeleteNodeResponse
   deleteParameter: DeleteParameterResponse
   deleteParameterCondition: DeleteParameterConditionResponse
   deletePipelineCustomObjectAddAnotherGof: DeletePipelineCustomObjectAddAnotherGoFResponse
   deletePipelineItemReminders: DeletePipelineItemRemindersResponse
   deleteRecordCreationConfig: DeleteRecordCreationConfigResponse
   deleteRelatedEntityAddAnotherGof: DeleteRelatedEntityAddAnotherGoFResponse
   deleteRelation: DeleteRelationResponse
   deleteScheduledPipelineItems: DeleteScheduledPipelineItemsResponse
   deleteScoringParameter: DeleteScoringParameterResponse
   deleteStageAddAnotherGofsPermissions: DeleteStageAddAnotherGoFsPermissionsResponse
   deleteStageTransition: DeleteStageTransitionResponse
   deleteStageTransitionCheckpoint: DeleteStageTransitionCheckpointResponse
   deleteTab: DeleteTabResponse
   deleteTaskAddAnotherGof: DeleteTaskAddAnotherGoFResponse
   deleteTdrRequestsInPortal: DeleteTdrRequestsInPortalResponse
   deleteUserKmlFile: DeleteUserKmlFileResponse
   deleteView: DeleteViewResponse
   disableAccountFeatures: DisableAccountFeaturesResponse
   disableAutoGenerateCustomId: DisableAutoGenerateCustomIdResponse
   disablePipelineFeatures: DisablePipelineFeaturesResponse
   disablePlugin: DisablePluginForAccountResponse
   disableWhatsappBusinessPhoneNumber: DisableWhatsAppBusinessPhoneNumberResponse
   discardPipelineItemPaymentRequest: DiscardPipelineItemPaymentRequestResponse
   dummyMutation: DummyMutationResult
   duplicateView: DuplicateViewResponse
   enableAccountFeatures: EnableAccountFeaturesResponse
   enableAutoGenerateCustomId: EnableAutoGenerateCustomIdResponse
   enablePipelineFeatures: EnablePipelineFeaturesResponse
   enablePlugin: EnablePluginForAccountResponse
   enableWhatsappBusinessPhoneNumber: EnableWhatsAppBusinessPhoneNumberResponse
   endOfficerLeave: EndOfficerLeaveResponse
   exportContacts: ExportContactsResponse
   exportFailedActivityLogs: ExportFailedActivityLogsResponse
   exportPipelineItemRemarks: ExportPipelineItemRemarksResponse
   exportPipelineItems: ExportPipelineItemsResponse
   exportPipelineItemsByIdentificationValue: ExportPipelineItemsByIdentificationValueResponse
   exportPipelineItemsInView: ExportPipelineItemsInViewResponse
   exportUserCallingConfigs: ExportUserCallingConfigsResponse
   exportUsers: ExportUsersResponse
   feeUpdatedDummyMutation: FeeUpdatedDummyMutationResult
   generateApplicationDrawingPdfInPortal: GenerateApplicationDrawingPdfResponse
   generatePaymentReceipt: GeneratePaymentReceiptResponse
   generatePaymentReceiptInPortal: GeneratePaymentReceiptInPortalResponse
   generatePipelineItemDocument: GeneratePipelineItemDocumentResponse
   generatePipelineItemDocumentWithUrl: GeneratePipelineItemDocumentWithUrlResponse
   generateReconciliationPreview: GenerateReconciliationPreviewResponse
   generateScrutinyKey: GenerateScrutinyKeyResponse
   holdTdrAccount: HoldTdrAccountResponse
   initiateApplicationRefund: InitiateApplicationRefundResponse
   initiateDataLoadingRequestFromCsv: InitiateDataLoadingRequestFromCsvResponse
   initiateDeactivateUser: InitiateDeactivateUserResponse
   initiateLeadDistributionRule: InitiateLeadDistributionRuleResponse
   initiateLeadOnActivity: InitiateLeadOnActivityResponse
   initiateLoadBankAccount: InitiateLoadBankAccountResponse
   initiateMandalAssignment: InitiateMandalAssignmentResponse
   initiateOfficerLeave: InitiateOfficerLeaveResponse
   initiateOfficerTransfer: InitiateOfficerTransferResponse
   initiatePaymentOnPipelineItem: InitiatePaymentOnPipelineItemResponse
   initiateReconciliation: InitiateReconciliationResponse
   initiateTestTransferBankAmount: InitiateTestTransferBankAmountResponse
   initiateTransferAction: InitiatePmuActionResponse
   initiateUpdateAction: InitiatePmuActionResponse
   initiateUpdateUserDetails: InitiateUpdateUserDetailsResponse
   linkGraphsToView: LinkGraphsToViewResponse
   linkWhatsappMessageTemplateToPipeline: LinkWhatsAppMessageTemplateToPipelineResponse
   makeCall: MakeCallResponse
   makeTaskShortfall: MakeTaskShortfallResponse
   markAllNotificationAsRead: MarkUnreadNotificationsAsReadResponse
   markNotificationAsRead: MarkNotificationAsReadResponse
   markNotificationAsUnread: MarkNotificationAsUnreadResponse
   markScheduledPipelineItemsAsCompleted: MarkScheduledPipelineItemsAsCompletedResponse
   markTdrAccountRequestAsRead: MarkTdrAccountRequestAsReadResponse
   mergePipelineItems: MergePipelineItemsResponse
   mergePipelineItemsWithContacts: MergePipelineItemsWithContactsResponse
   moveNode: MoveNodeResponse
   orderStatusUpdatedDummyMutation: OrderStatusUpdatedDummyMutationResult
   pinPipelineItems: PinPipelineItemsResponse
   pollDigitalSignStatus: PollDigitalSignStatusResponse
   populateActivitiesFromCsv: PopulateActivitiesFromCsvResponse
   populateActivitiesFromSheet: PopulateActivitiesFromSheetResponse
   populateApplicationsFromCsv: PopulateApplicationsFromCsvResponse
   populateConditionalFieldOptionsFromCsv: PopulateConditionalFieldOptionsFromCsvResponse
   populateContactsFromCsv: PopulateContactsFromCsvResponse
   populateContactsFromSheet: PopulateContactsFromSheetResponse
   populateCrmFunctionsFromCsv: PopulateCrmFunctionsFromCsvResponse
   populateCustomObjectsFromCsv: PopulateCustomObjectsFromCsvResponse
   populateCustomObjectsFromSheet: PopulateCustomObjectsFromSheetResponse
   populateLeadsWithContactFromCsv: PopulateLeadsWithContactFromCsvResponse
   populateLeadsWithContactFromSheet: PopulateLeadsWithContactFromSheetResponse
   populatePipelineWhatsappBusinessPhoneNumbers: PopulatePipelineWhatsappBusinessPhoneNumbersFromSheetResponse
   populatePipelineWhatsappBusinessPhoneNumbersFromCsv: PopulatePipelineWhatsappBusinessPhoneNumbersFromCsvResponse
   populateSurveyNumbersFromCsv: PopulateSurveyNumbersFromCsvResponse
   populateUserCallingConfigsFromCsv: PopulateUserCallingConfigFromCsvResponse
   populateUserCallingConfigsFromSheet: PopulateUserCallingConfigFromSheetResponse
   populateUsersFromCsv: PopulateUsersFromCsvResponse
   populateUsersFromSheet: PopulateUsersFromSheetResponse
   publishAutomationWorkflow: PublishAutomationWorkFlowResponse
   publishForm: PublishFormResponse
   publishLeadDistributionRule: PublishLeadDistributionRuleResponse
   publishPipelineItemRemarks: PublishPipelineItemRemarksResponse
   publishScoringConfig: PublishScoringConfigResponse
   pushContactToPipeline: PushContactToPipelineResponse
   reapproveLineDepartmentRecommendation: ReapproveLineDepartmentRecommendationResponse
   recalculateEntityFeeRuleSet: RecalculateEntityFeeRuleSetResponse
   recalculateScore: RecalculateScoreResponse
   recopyRelatedApplicationFields: RecopyRelatedApplicationFieldsResponse
   regenerateConditionsLettersDummyMutation: RegenerateConditionsLettersDummyMutationResult
   regeneratePipelineItemDocument: RegeneratePipelineItemDocumentResponse
   regenerateTdrCertificate: RegenerateTdrCertificateResponse
   reinitiateFailedRefund: ReinitiateFailedApplicationRefundResponse
   rejectLineDepartmentRecommendation: RejectLineDepartmentRecommendationResponse
   releaseTdrAccount: ReleaseTdrAccountResponse
   remindPendingOrder: RemindPendingOrderResponse
   removeActionTypesFromIdentification: RemoveActionTypesFromIdentificationResponse
   removeActivityTemplatesFromPipeline: RemoveActivityTemplatesFromPipelineResponse
   removeApplicationFieldAsShortfall: RemoveApplicationFieldAsShortfallResponse
   removeAsDependentField: RemoveAsDependentFieldResponse
   removeAsIdentificationField: RemoveAsIdentificationFieldResponse
   removeAsUniqueField: RemoveAsUniqueFieldResponse
   removeAttachmentsForRemarks: RemoveAttachmentsForRemarksResponse
   removeAttachmentsForRemarksInTaskDraft: RemoveAttachmentsForRemarksInTaskDraftResponse
   removeBoardAccess: RemoveBoardAccessResponse
   removeCallLogsFromTaskDraft: RemoveCallLogsFromTaskDraftResponse
   removeDashboardIdentifications: RemoveDashboardIdentificationsResponse
   removeFeeHeadersInEntityFeeRuleSet: RemoveFeeHeadersInEntityFeeRuleSetResponse
   removeFieldConditionalOptions: RemoveFieldConditionalOptionsResponse
   removeFieldRoles: RemoveFieldRolesResponse
   removeGraphQuickFilterFields: RemoveGraphQuickFilterFieldsResponse
   removeManager: RemoveManagerResponse
   removeOptionsFromCheckboxGroupField: RemoveOptionsFromCheckboxGroupFieldResponse
   removeOptionsFromDropdownField: RemoveOptionsFromDropdownFieldResponse
   removeOptionsFromFieldsSelectorField: RemoveOptionsFromFieldsSelectorFieldResponse
   removeOptionsFromMultiSelectGroupField: RemoveOptionsFromMultiSelectFieldResponse
   removeOptionsFromRadioGroupField: RemoveOptionsFromRadioGroupFieldResponse
   removePipelineIdentifications: RemovePipelineIdentificationsResponse
   removePipelineItemScheduleFromCalendar: RemovePipelineItemScheduleFromCalendarResponse
   removePipelineItemTemplatesAdminPermissionForUser: RemovePipelineItemTemplatesAdminPermissionForUserResponse
   removePipelinesAdminPermissionForUser: RemovePipelinesAdminPermissionForUserResponse
   removeRelatedEntities: RemoveRelatedEntitiesResponse
   removeScheduledPipelineItems: RemoveScheduledPipelineItemsResponse
   removeStageUpdatePermissions: RemoveStageUpdatePermissionResponse
   removeUserGroupsForBoard: RemoveUserGroupsForBoardResponse
   removeUserGroupsForBoardList: RemoveUserGroupsForBoardListResponse
   removeUserIdentifications: RemoveUserIdentificationsResponse
   removeUsersCallingConfig: RemoveUsersCallingConfigResponse
   removeUsersFromIdentification: RemoveUsersFromIdentificationResponse
   removeWhatsAppBusinessPhoneNumberUsers: RemoveWhatsAppBusinessPhoneNumberUsersResponse
   removeWhatsappBusinessPhoneNumber: RemoveWhatsAppBusinessPhoneNumberResponse
   renameAutomationWorkflow: RenameAutomationWorkflowResponse
   renameAutomationWorkflowFilter: RenameAutomationWorkflowFilterResponse
   renameBoard: RenameBoardResponse
   renameBoardList: RenameBoardListResponse
   renameEventTriggerFilter: RenameEventTriggerFilterResponse
   renameFilter: RenameFilterResponse
   renameIdentification: RenameIdentificationResponse
   renameNode: RenameNodeResponse
   renameStage: RenameStageResponse
   renameTrigger: RenameTriggerResponse
   renameView: RenameViewResponse
   reorderBoardLists: ReOrderBoardListsResponse
   reorderBoards: ReOrderBoardsResponse
   reorderEntityCheckpoints: ReorderEntityCheckpointsResponse
   reorderField: ReorderFieldResponse
   reorderGraphQuickFilterFields: ReorderGraphQuickFilterFieldsResponse
   reorderGraphsInDashboard: ReorderUserGraphInDashboardResponse
   reorderMetrics: ReorderMetricsResponse
   reorderPinnedPipelineItems: ReorderPinnedPipelineItemsResponse
   reorderScheduledPipelineItems: ReorderScheduledPipelineItemsResponse
   reorderTabs: ReorderTabsResponse
   reorderUserGraphInView: ReorderUserGraphInViewResponse
   reorderViews: ReorderViewsResponse
   reschedulePipelineItemReminders: ReschedulePipelineItemRemindersResponse
   reschedulePipelineItems: ReschedulePipelineItemsResponse
   resendRequestToPipelineItemVerification: ResendRequestToPipelineItemVerificationResponse
   resetEntityCheckpointText: ResetEntityCheckpointTextResponse
   resetEntityFeeRuleSet: ResetEntityFeeRuleSetResponse
   resetOfficerOtpRetryCount: ResetOfficerOtpRetryCountResponse
   resetOtpRetryCount: ResetOtpRetryCountResponse
   resetVerificationTask: ResetVerificationTaskResponse
   restoreApplicationInPortal: RestoreApplicationInPortalResponse
   restoreFeeHeadersInEntityFeeRuleSet: RestoreFeeHeadersInEntityFeeRuleSetResponse
   restoreFields: RestoreFieldsResponse
   restoreGofs: RestoreGoFsResponse
   retryExportPipelineItems: RetryExportPipelineItemsResponse
   retryFailedAction: RetryFailedActionResponse
   revokeGoogleAuthorization: RevokeGoogleUserAuthorizationResponse
   savePipelineItemFieldInTaskDraft: SavePipelineItemFieldInTaskDraftResponse
   savePipelineItemFieldInTaskDraftBulk: SavePipelineItemFieldInTaskDraftBulkResponse
   savePipelineItemRemarksInTaskDraft: SavePipelineItemRemarksInTaskDraftResponse
   saveSiteInspectionFieldObservation: SaveSiteInspectionFieldObservationResponse
   schedulePipelineItem: SchedulePipelineItemResponse
   schedulePipelineItems: SchedulePipelineItemsResponse
   scheduleSiteInspection: ScheduleSiteInspectionResponse
   sendBackFriend: SendBackFriendResponse
   sendOtp: SendOtpResponse
   sendOtpForDocumentEsign: SendOtpForDocumentESignResponse
   sendOtpForTaskShortfall: SendOtpForTaskShortfallResponse
   sendOtpForTdrAccountHold: SendOtpForTdrAccountHoldResponse
   sendOtpForTdrAccountRelease: SendOtpForTdrAccountReleaseResponse
   sendOtpForTransactionAcceptance: SendOtpForTransactionAcceptanceResponse
   sendOtpForUpdatingUserPin: SendOtpForUpdatingUserPinResponse
   sendOtpToPipelineItemPhoneNumberField: SendOtpToPipelineItemPhoneNumberFieldResponse
   sendOtpToPipelineItemPhoneNumberFieldInPortal: SendOtpToPipelineItemPhoneNumberFieldInPortalResponse
   sendPipelineItemWhatsappMessage: SendPipelineItemWhatsAppMessageResponse
   sendPipelineItemWhatsappMessageBulk: SendPipelineItemWhatsAppMessageBulkResponse
   sendQueryResponseInThread: SendQueryResponseInThreadResponse
   sendQueryStreamedDataInThread: SendQueryStreamedDataInThreadResponse
   sendRequestToPipelineItemVerification: SendRequestToPipelineItemVerificationResponse
   sendWhatsappMessageToOfficer: SendWhatsAppMessageToOfficerResponse
   setAccountFeatureIdentifications: SetAccountFeatureIdentificationsResponse
   setAgentAllocationGroupsInAllocationGroupSet: SetAgentAllocationGroupsInAllocationGroupSetResponse
   setAgentsInAllocationGroupSet: SetAgentsInAllocationGroupSetResponse
   setApplicationDisplayStageAllowedGofs: SetApplicationDisplayStageAllowedGoFsResponse
   setApplicationDisplayStageRequiredFields: SetApplicationDisplayStageRequiredFieldsResponse
   setApplicationDisplayStageWritableFields: SetApplicationDisplayStageWritableFieldsResponse
   setApplicationDocumentTemplatesInPortal: SetApplicationDocumentTemplatesInPortalResponse
   setApplicationIdGenerationConfigAtDisplayStage: SetApplicationIdGenerationConfigAtDisplayStageResponse
   setApplicationOverviewFieldsInPortal: SetApplicationOverviewFieldsInPortalResponse
   setApplicationSubStatusFields: SetApplicationSubStatusFieldsResponse
   setBpsTemplateConfig: SetBpsTemplateConfigResponse
   setDefaultStageValuesToPipeline: SetDefaultStageValuesToPipelineResponse
   setFieldConditionOptionsParentField: SetFieldConditionOptionsParentFieldResponse
   setFieldReadRoles: SetFieldReadRolesResponse
   setFieldWriteRoles: SetFieldWriteRolesResponse
   setFieldsOrder: SetFieldsOrderResponse
   setFieldsSelectorFieldOptionDependentFieldsOrder: SetFieldsSelectorFieldOptionDependentFieldsOrderResponse
   setGofsOrder: SetGoFsOrderResponse
   setGraphRoles: SetGraphRolesResponse
   setIdentificationsForPipelineAction: SetIdentificationsForPipelineActionResponse
   setIdentificationsToTriggerAutomationWorkflowsOnActivity: SetIdentificationsToTriggerAutomationWorkflowsOnActivityResponse
   setLeadBucketsOrder: SetLeadBucketsOrderResponse
   setLeadCreationAllowedStages: SetLeadCreationAllowedStagesResponse
   setLeadDistributionRuleAssigneeFieldsToNotify: SetLeadDistributionRuleAssigneeFieldsToNotifyResponse
   setLeadDistributionRuleManagerFields: SetLeadDistributionRuleManagerFieldsResponse
   setLeadInitiationRolesOnActivity: LeadInitiationRolesOnActivityResponse
   setManager: SetManagerResponse
   setManagerForAgents: SetManagerForAgentsResponse
   setMessageTemplateVariablesMap: SetWhatsAppMessageTemplateVariableMapResponse
   setOrderForAllocationGroupSets: SetOrderForAllocationGroupSetsResponse
   setParameterConditionsOrder: SetParameterConditionsOrderResponse
   setPermitOrderIdGenerationConfigAtStage: SetPermitOrderIdGenerationConfigAtStageResponse
   setPipelineAdmins: SetPipelineAdminsResponse
   setPipelineFeatureIdentifications: SetPipelineFeatureIdentificationsResponse
   setPipelineIdentifications: SetPipelineIdentificationsResponse
   setPipelineItemFieldsToLog: SetPipelineItemFieldsToLogResponse
   setPipelineItemTemplateAdmins: SetPipelineItemTemplateAdminsResponse
   setPipelineItemTemplateFieldsToLog: SetPipelineItemTemplateFieldsToLogResponse
   setPipelineItemTemplateShortfallConfig: SetPipelineItemTemplateShortfallFieldsConfigResponse
   setPipelinePersonalWhatsappMessageIdentifications: SetPipelinePersonalWhatsAppMessageIdentificationsResponse
   setPipelineWhatsappBusinessPhoneNumberUsers: SetPipelineWhatsAppBusinessPhoneNumberUsersResponse
   setPipelinesToActivityTemplate: SetPipelinesToActivityTemplateResponse
   setPortalApplicationAdditionalVisibleTabs: SetPortalApplicationAdditionalVisibleTabsResponse
   setPortalApplicationDrawingPdfVisibleStages: SetPortalApplicationDrawingPdfVisibleStagesResponse
   setPortalApplicationProposalFlowVisibleStages: SetPortalApplicationProposalFlowVisibleStagesResponse
   setPortalApplicationScrutinyProcessVisibleStages: SetPortalApplicationScrutinyProcessVisibleStagesResponse
   setPortalApplicationTabGofsOrder: SetPortalApplicationTabGoFsOrderResponse
   setPortalApplicationTabsOrder: SetPortalApplicationTabsOrderResponse
   setPortalApplicationTdrVisibleStages: SetPortalApplicationTdrVisibleStagesResponse
   setPortalApplicationsOrder: SetPortalApplicationsOrderResponse
   setPortalPipelineItemTemplateSurveyNumberFieldConfig: SetPortalPipelineItemTemplateSurveyNumberFieldConfigResponse
   setPortalVisibleUserTypesForFieldLogs: SetPortalVisibleUserTypesResponse
   setRecordCreationConfigAutoAssignCreatorToFields: SetRecordCreationConfigAutoAssignCreatorToFieldsResponse
   setRecordCreationConfigCreationAllowedStages: SetRecordCreationConfigCreationAllowedStagesResponse
   setRecordCreationConfigFields: SetRecordCreationConfigFieldsResponse
   setRecordCreationConfigPermissions: SetRecordCreationConfigPermissionsResponse
   setRecordCreationConfigSyncAssigneeGroups: SetRecordCreationConfigSyncAssigneeGroupsResponse
   setRecordMergePermissions: SetRecordMergePermissionsResponse
   setRelatedSalesTemplateOverviewFields: SetRelatedSalesTemplateOverviewFieldsResponse
   setRelationAddPermissionIdentifications: SetRelationEntityAddPermissionIdentificationsResponse
   setRelationIdentifications: SetRelationIdentificationsResponse
   setRelationRemovePermissionIdentifications: SetRelationEntityRemovePermissionIdentificationsResponse
   setResourceRoles: SetResourceRolesResponse
   setResourcesOrder: SetResourcesOrderResponse
   setSalesTemplateRecordCreationPermissions: SetSalesTemplateRecordCreationPermissionsResponse
   setScoringRecalculationSortByFields: SetScoringRecalculationSortByFieldsResponse
   setSiteInspectionFieldObservationBulk: SetSiteInspectionFieldObservationBulkResponse
   setSiteInspectionFieldObservationByExcludeFields: SetSiteInspectionFieldObservationByExcludeFieldsResponse
   setStageAssigneeFieldsToLog: SetStageAssigneeFieldsToLogResponse
   setStageBoardRoles: SetStageBoardRolesResponse
   setStageCreateAddAnotherGofPermissions: SetStageCreateAddAnotherGofPermissionsResponse
   setStageDeletionStatus: SetStageDeletionStatusResponse
   setStageNoteSheetPermissions: SetStageNoteSheetPermissionsResponse
   setStageQuickEditFields: SetStageQuickEditFieldsResponse
   setStageRecommendedFeeRuleSetIdentifications: SetStageRecommendedFeeRuleSetIdentificationsResponse
   setStageRecommendedTaskIdentifications: SetStageRecommendedTaskIdentificationsResponse
   setStageRecommendedTaskTemplates: SetStageRecommendedTaskTemplatesResponse
   setStageRemoveAddAnotherGofPermissions: SetStageRemoveAddAnotherGofPermissionsResponse
   setStageTransitionPermissions: SetStageTransitionPermissionResponse
   setStagesOrder: SetStagesOrderResponse
   setTaskTemplateIdentifications: SetTaskTemplateIdentificationsResponse
   setTaskTemplateQuickEditFields: SetTaskTemplateQuickEditFieldsResponse
   setTaskTemplatesOrder: SetTaskTemplatesOrderResponse
   setUserCallingConfig: UserCallingConfigResult
   setUserPin: SetUserPinResponse
   setWhatsappBusinessPhoneNumberUsers: SetWhatsAppBusinessPhoneNumberUsersResponse
   setWhatsappMessageTemplateIdentifications: SetWhatsAppMessageTemplateIdentificationsResponse
   shareBoard: ShareBoardResponse
   signDocument: SignDocumentResponse
   signDocumentForDigitalSign: SignDocumentForDigitalSignResponse
   signPipelineItemDocument: SignPipelineItemDocumentResponse
   submitAnalyticsQueryResponseFeedback: SubmitAnalyticsQueryResponseFeedbackResponse
   submitBpsVerificationTask: SubmitBpsVerificationTaskResponse
   submitFeedbackInPortal: SubmitFeedbackInPortalResponse
   submitLineDepartmentRecommendation: SubmitLineDepartmentRecommendationResponse
   submitSiteInspection: SubmitSiteInspectionResponse
   submitTask: SubmitTaskResponse
   submitTdrOrderForVerification: SubmitTdrOrderForVerificationResponse
   syncPluginServiceAccountWhatsappMessageTemplates: SyncPluginServiceAccountWhatsappMessageTemplatesResponse
   triggerAutomationWorkflowsOnActivity: TriggerAutomationWorkflowsOnActivityResponse
   triggerScheduleWorkflow: TriggerScheduleWorkflowResponse
   unlinkGraphsToView: UnLinkGraphsToViewResponse
   unlinkWhatsappBusinessPhoneNumberFromPipeline: UnLinkWhatsAppBusinessPhoneNumberFromPipelineResponse
   unlinkWhatsappMessageTemplateFromPipeline: UnLinkWhatsAppMessageTemplateFromPipelineResponse
   unpinPipelineItems: UnPinPipelineItemsResponse
   unschedulePipelineItems: UnschedulePipelineItemsResponse
   updateActivitiesFeatureEnableStatus: UpdateActivitiesFeatureEnableStatusResponse
   updateActivityPipelineItemCreationConfig: UpdateActivityPipelineItemCreationConfigResponse
   updateActivityTemplateDescription: UpdateActivityTemplateDescriptionResponse
   updateActivityTemplateName: UpdateActivityTemplateNameResponse
   updateActivityTemplatePipelineStages: UpdateActivityTemplatePipelineStagesResponse
   updateActivityTemplateReferenceId: UpdateActivityTemplateReferenceIdResponse
   updateAddAnotherGofResponsesLimit: UpdateAddAnotherGofResponsesLimitResponse
   updateAgentAllocationGroupName: UpdateAgentAllocationGroupNameResponse
   updateAgentGlobalQuota: UpdateAgentGlobalQuotaResponse
   updateAllocationGroupSetQuota: UpdateAllocationGroupSetQuotaResponse
   updateAllocationGroupSetType: UpdateAllocationGroupSetTypeResponse
   updateAllowManualTrigger: UpdateAllowManualTriggerResponse
   updateAppealTaskObservation: UpdateAppealTaskObservationResponse
   updateApplicationAddAnotherBulkSurveyNumberField: UpdateApplicationBulkSurveyNumberFieldResponse
   updateApplicationAddAnotherBulkSurveyNumberFieldInPortal: UpdateApplicationBulkSurveyNumberFieldInPortalResponse
   updateApplicationAddAnotherField: UpdateApplicationAddAnotherFieldResponse
   updateApplicationAddAnotherFieldBulk: UpdateApplicationAddAnotherFieldBulkResponse
   updateApplicationAddAnotherFieldInPortal: UpdateApplicationAddAnotherFieldInPortalResponse
   updateApplicationAddAnotherSurveyNumberField: UpdateApplicationAddAnotherSurveyNumberFieldResponse
   updateApplicationAddAnotherSurveyNumberFieldInPortal: UpdateApplicationAddAnotherSurveyNumberFieldInPortalResponse
   updateApplicationAssigneeBulk: UpdateApplicationAssigneeBulkResponse
   updateApplicationAvailTdrCreditsInPortal: UpdateApplicationAvailTdrCreditsInPortalResponse
   updateApplicationField: UpdateApplicationFieldResponse
   updateApplicationFieldAsShortfall: UpdateApplicationFieldAsShortfallResponse
   updateApplicationFieldInPortal: UpdateApplicationFieldInPortalResponse
   updateApplicationSurveyNumberField: UpdateApplicationSurveyNumberFieldResponse
   updateApplicationSurveyNumberFieldInPortal: UpdateApplicationSurveyNumberFieldInPortalResponse
   updateApplicationTab: UpdateApplicationTabResponse
   updateApplicationTabGofFieldIds: UpdateApplicationTabGofFieldIdsResponse
   updateApplicationTabName: UpdateApplicationTabNameResponse
   updateApplicationTdrSalesAndTransferFieldInPortal: UpdateApplicationTdrSalesAndTransferFieldInPortalResponse
   updateApplicationTemplate: UpdateApplicationTemplateResponse
   updateArchitectProfile: UpdateArchitectProfileResponse
   updateAssigneeGroup: UpdateAssigneeGroupResponse
   updateAttendanceTrackingSettings: UpdateAttendanceTrackingSettingsResponse
   updateAutomationWorkflowCondition: UpdateAutomationWorkflowConditionResponse
   updateAutomationWorkflowConditionsLogicalOperator: UpdateAutomationWorkflowConditionsLogicalOperatorResponse
   updateAutomationWorkflowExecLogsFilter: UpdateAutomationWorkflowExecLogsFilterResponse
   updateAutomationWorkflowExecLogsSortValue: UpdateAutomationWorkflowExecLogsSortValueResponse
   updateAutomationWorkflowExecType: UpdateAutomationWorkflowExecTypeResponse
   updateAutomationWorkflowFiltersLogicalOperator: UpdateAutomationWorkflowFiltersLogicalOperatorResponse
   updateAutomationWorkflowStatus: UpdateAutomationWorkflowStatusResponse
   updateAutomationWorkflowTriggerConfig: UpdateAutomationWorkflowTriggerConfigResponse
   updateBarGraph: UpdateBarGraphResponse
   updateBoardDescription: UpdateBoardDescriptionResponse
   updateBoardDisplayName: UpdateBoardDisplayNameResponse
   updateBpsTaskFieldObservation: UpdateBpsTaskFieldObservationResponse
   updateBpsTaskFieldObservationBulk: UpdateBpsTaskFieldObservationBulkResponse
   updateBpsVerificationTabTask: UpdateBpsVerificationTabTaskResponse
   updateBpsVerificationTask: UpdateBpsVerificationTaskResponse
   updateCalendarPipelineItemSchedule: UpdateCalendarPipelineItemScheduleResponse
   updateCanGenerateCustomIdConfig: UpdateCanGenerateCustomIdConfigResponse
   updateCheckboxGroupFieldDefaultValues: UpdateCheckboxGroupFieldDefaultValuesResponse
   updateCondition: UpdateConditionResponse
   updateConditionNodeFiltersLogicalOperator: UpdateConditionNodeFiltersLogicalOperatorResponse
   updateConditionsLogicalOperator: UpdateConditionsLogicalOperatorResponse
   updateContactField: UpdateContactFieldResponse
   updateContactsBoardConfig: UpdateContactsBoardConfigResponse
   updateContactsFeatureEnableStatus: UpdateContactsFeatureEnableStatusResponse
   updateCustomDocumentTemplate: UpdateCustomDocumentTemplateResponse
   updateCustomObjectTemplate: UpdateCustomObjectTemplateResponse
   updateDashboard: UpdateDashboardResponse
   updateDateFieldDefaultValue: UpdateDateFieldDefaultValueResponse
   updateDateFieldRelativeDefaultValueConfig: UpdateDateFieldRelativeDefaultValueConfigResponse
   updateDateTimeFieldDefaultValue: UpdateDateTimeFieldDefaultValueResponse
   updateDateTimeFieldRelativeDefaultValueConfig: UpdateDateTimeFieldRelativeDefaultValueConfigResponse
   updateDealAddAnotherField: UpdateDealAddAnotherFieldResponse
   updateDealAssigneeBulk: UpdateDealAssigneeBulkResponse
   updateDealField: UpdateDealFieldResponse
   updateDisplayStageTransitionConfig: UpdateDisplayStageTransitionConfigResponse
   updateDocumentTemplateDescription: UpdateDocumentTemplateDescriptionResponse
   updateDocumentTemplateName: UpdateDocumentTemplateNameResponse
   updateDocumentTemplateVersionConfig: UpdateDocumentTemplateVersionConfigResponse
   updateDonutChart: UpdateDonutChartResponse
   updateDropdownAllowOtherOptions: UpdateDropdownAllowOtherOptionsResponse
   updateDropdownFieldDefaultValue: UpdateDropdownFieldDefaultValueResponse
   updateDropdownFieldUiStyle: UpdateDropdownFieldUiStyleResponse
   updateDropdownLabelsStatus: UpdateDropdownLabelsStatusResponse
   updateDropdownOptionsColor: UpdateDropdownOptionsColorResponse
   updateEmailFieldDefaultValue: UpdateEmailFieldDefaultValueResponse
   updateEmailFieldValidationRegex: UpdateEmailFieldValidationRegexResponse
   updateEntityCheckpoint: UpdateEntityCheckpointResponse
   updateEntityCheckpointBulk: UpdateEntityCheckpointBulkResponse
   updateEntityCheckpointsStatus: UpdateEntityCheckpointsStatusResponse
   updateEntityJsonConfiguration: UpdateEntityJsonConfigurationResponse
   updateEventBasedLeadDistributionRuleSettings: UpdateEventBasedLeadDistributionRuleSettingsResponse
   updateEventBasedLeadDistributionRuleStatus: UpdateEventBasedLeadDistributionRuleStatusResponse
   updateEventTriggerCondition: UpdateEventTriggerConditionResponse
   updateEventTriggerConditionsLogicalOperator: UpdateEventTriggerConditionsLogicalOperatorResponse
   updateEventTriggerFiltersLogicalOperator: UpdateEventTriggerFiltersLogicalOperatorResponse
   updateFeeHeaderAmountGivenByEditor: UpdateFeeHeaderAmountGivenByEditorResponse
   updateFeeHeaderRemarks: UpdateFeeHeaderRemarksResponse
   updateFieldDescription: UpdateFieldDescriptionResponse
   updateFieldDynamicLabel: UpdateFieldDynamicLabelResponse
   updateFieldGof: UpdateFieldGoFResponse
   updateFieldHelpText: UpdateFieldHelpTextResponse
   updateFieldHelpTextType: UpdateFieldHelpTextTypeResponse
   updateFieldIcon: UpdateFieldIconResponse
   updateFieldName: UpdateFieldNameResponse
   updateFieldOptionsValueType: UpdateFieldOptionsValueTypeResponse
   updateFieldPlaceholderText: UpdateFieldPlaceholderTextResponse
   updateFieldReferenceId: UpdateFieldReferenceIdResponse
   updateFieldRequiredStatus: UpdateFieldRequiredStatusResponse
   updateFieldTooltip: UpdateFieldTooltipResponse
   updateFieldsSelectorFieldDefaultValue: UpdateFieldsSelectorFieldDefaultValueResponse
   updateFieldsSelectorFieldUiStyle: UpdateFieldsSelectorFieldUiStyleResponse
   updateFileUploaderFieldConfig: UpdateFileUploaderFieldConfigResponse
   updateFileUploaderFieldDefaultValue: UpdateFileUploaderFieldDefaultValueResponse
   updateFiltersLogicalOperator: UpdateFiltersLogicalOperatorResponse
   updateFloatFieldDecimalPrecisionLimit: UpdateFloatFieldDecimalPrecisionLimitResponse
   updateFloatFieldDefaultValue: UpdateFloatFieldDefaultValueResponse
   updateFloatFieldFormulaStatus: UpdateFloatFieldFormulaStatusResponse
   updateFloatFieldRange: UpdateFloatFieldRangeResponse
   updateFormIdentificationField: UpdateFormIdentificationFieldResponse
   updateFormLayout: UpdateFormLayoutResponse
   updateFormSubmissionConfig: UpdateFromSubmissionConfigResponse
   updateFormTemplateDescription: UpdateFormTemplateDescriptionResponse
   updateFormTemplateName: UpdateFormTemplateNameResponse
   updateFunnelGraph: UpdateFunnelGraphResponse
   updateGallaboxAccount: UpdateGallaboxAccountResponse
   updateGeoFieldAddressFields: UpdateGeoFieldAddressFieldsResponse
   updateGofDescription: UpdateGoFDescriptionResponse
   updateGofName: UpdateGofNameResponse
   updateGraph: UpdateGraphResponse
   updateGraphDataSources: UpdateGraphDataSourcesResponse
   updateGraphDimension: UpdateGraphDimensionResponse
   updateGraphMetric: UpdateGraphMetricResponse
   updateGraphWidthPercentage: UpdateGraphWidthPercentageResponse
   updateGupShupAccount: UpdateGupShupAccountResponse
   updateIntegerFieldDefaultValue: UpdateIntegerFieldDefaultValueResponse
   updateIntegerFieldFormulaStatus: UpdateIntegerFieldFormulaStatusResponse
   updateIntegerFieldRange: UpdateIntegerFieldRangeResponse
   updateKnowlarityAccount: UpdateKnowlarityAccountDetailsResponse
   updateLayout: UpdateLayoutResponse
   updateLdRuleTriggerConfig: UpdateLdRuleTriggerConfigResponse
   updateLeadAddAnotherField: UpdateLeadAddAnotherFieldResponse
   updateLeadAssigneeBulk: UpdateLeadAssigneeBulkResponse
   updateLeadBucketName: UpdateLeadBucketNameResponse
   updateLeadBucketSortFields: UpdateLeadBucketSortFieldsResponse
   updateLeadDistributionPoolAssigneeFieldConditionEnum: UpdateLeadDistributionPoolAssigneeFieldConditionEnumResponse
   updateLeadDistributionRuleAssigneeField: UpdateLeadDistributionRuleAssigneeFieldResponse
   updateLeadDistributionRuleEditMode: UpdateLeadDistributionRuleEditModeResponse
   updateLeadDistributionRuleName: UpdateLeadDistributionRuleNameResponse
   updateLeadDistributionSetupCurrentStep: UpdateLeadDistributionSetupCurrentStepResponse
   updateLeadField: UpdateLeadFieldResponse
   updateLeadPoolSortFields: UpdateLeadPoolSortFieldsResponse
   updateLineGraph: UpdateLineGraphResponse
   updateLongFieldValidationRegex: UpdateLongTextFieldValidationRegexResponse
   updateLongTextFieldDefaultValue: UpdateLongTextFieldDefaultValueResponse
   updateLongTextFieldFormulaExpression: UpdateLongTextFieldFormulaStatusResponse
   updateLtpUserDetails: UpdateLtpUserDetailsResponse
   updateManualLeadDistributionRuleSettings: UpdateManualLeadDistributionRuleSettingsResponse
   updateMobileCardOverviewFieldsInStage: UpdateCardMobileOverviewFieldsResponse
   updateMultiSelectGroupFieldDefaultValue: UpdateMultiSelectFieldDefaultValuesResponse
   updateMultiselectAllowOtherOptions: UpdateMultiSelectAllowOtherOptionsResponse
   updateMultiselectFieldUiStyle: UpdateMultiSelectFieldUiStyleResponse
   updateMultiselectLabelsStatus: UpdateMultiselectLabelsStatusResponse
   updateMultiselectOptionsColor: UpdateMultiselectOptionsColorResponse
   updateNodeAddAnotherGof: UpdateNodeAddAnotherGoFResponse
   updateNodeCallWebhook: UpdateNodeCallWebhookResponse
   updateNodeClearUndoneLeadTasks: UpdateNodeClearUndoneLeadTasksResponse
   updateNodeCreatePipelineEvent: UpdateNodeCreatePipelineEventResponse
   updateNodeCreateRelatedRecord: UpdateNodeCreateRelatedRecordResponse
   updateNodeCreateTask: UpdateNodeCreateTaskResponse
   updateNodeExecuteFunction: UpdateNodeExecuteFunctionResponse
   updateNodeGenerateDocument: UpdateNodeGenerateDocumentNodeResponse
   updateNodeGenerateNumber: UpdateNodeGenerateNumberResponse
   updateNodeInitiateRefund: UpdateNodeInitiateRefundResponse
   updateNodeRemoveAssignees: UpdateNodeRemoveAssigneesResponse
   updateNodeRemoveFromPipeline: UpdateNodeRemoveFromPipelineResponse
   updateNodeRequestPayment: UpdateNodeRequestPaymentResponse
   updateNodeRequestPaymentWithFeeRules: UpdateNodeRequestPaymentWithFeeRulesResponse
   updateNodeSendDataToSegment: UpdateNodeSendDataToSegmentResponse
   updateNodeSendPipelineItemNotification: UpdateNodeSendPipelineItemNotificationResponse
   updateNodeSendWhatsappMessageNode: UpdateNodeSendWhatsAppMessageNodeResponse
   updateNodeSignDocument: UpdateNodeSignDocumentNodeResponse
   updateNodeSwiftsellOutboundWebhookNode: UpdateNodeSwiftsellOutboundWebhookResponse
   updateNodeUpdateDisplayStage: UpdateNodeUpdateDisplayStageResponse
   updateNodeUpdateLead: UpdateNodeUpdateLeadResponse
   updateNodeUpdateLeadStage: UpdateNodeUpdateLeadStageResponse
   updateNodeUpdatePipelineItemAssignee: UpdateNodeUpdatePipelineItemAssigneeResponse
   updateNodeUpdateRelatedRecords: UpdateNodeUpdateRelatedRecordsResponse
   updateNodeUpdateTask: UpdateNodeUpdateTaskResponse
   updateObjectionApplicationObservation: UpdateObjectionApplicationObservationResponse
   updateOptionsVisibilityRulesStatusForField: UpdateOptionsVisibilityRulesStatusForFieldResponse
   updateOrCreateStageTransitionCheckpoint: UpdateOrCreateStageTransitionCheckpointResponse
   updateParameter: UpdateParameterResponse
   updateParameterCondition: UpdateParameterConditionResponse
   updateParameterKey: UpdateParameterKeyResponse
   updateParentFieldForDependentField: UpdateParentFieldForDependentFieldResponse
   updatePaymentStatusOnUserAction: UpdatePaymentStatusOnUserActionResponse
   updatePhoneNumberFieldOtpVerificationEnabledValue: UpdatePhoneNumberFieldOtpVerificationEnabledValueResponse
   updatePieChart: UpdatePieChartResponse
   updatePipelineCustomObjectAddAnotherField: UpdatePipelineCustomObjectAddAnotherFieldResponse
   updatePipelineCustomObjectAssigneeBulk: UpdatePipelineCustomObjectAssigneeBulkResponse
   updatePipelineCustomObjectField: UpdatePipelineCustomObjectFieldResponse
   updatePipelineDisplayName: UpdatePipelineDisplayNameResponse
   updatePipelineEventPipelineItemCreationConfig: UpdatePipelineEventPipelineItemCreationConfigResponse
   updatePipelineEventTemplate: UpdatePipelineEventTemplateResponse
   updatePipelineEventTemplateDescription: UpdatePipelineEventTemplateDescriptionResponse
   updatePipelineEventTemplateName: UpdatePipelineEventTemplateNameResponse
   updatePipelineIcon: UpdatePipelineIconResponse
   updatePipelineItemPaymentRequest: UpdatePipelineItemPaymentRequestResponse
   updatePipelineItemRemarks: UpdatePipelineItemRemarksResponse
   updatePipelineItemReminder: UpdatePipelineItemReminderResponse
   updatePipelineItemSchedule: UpdatePipelineItemScheduleResponse
   updatePipelineName: UpdatePipelineNameResponse
   updatePipelineSettings: UpdatePipelineSettingsResponse
   updatePipelineStageBoardsOwner: UpdatePipelineStageBoardsOwnerResponse
   updatePipelineStageTransitionStyle: UpdatePipelineStageTransitionStyleResponse
   updatePipelineWhatsappBusinessPhoneNumber: UpdatePipelineWhatsAppBusinessPhoneNumberResponse
   updatePipelineWhatsappConsentRequiredStatus: UpdatePipelineWhatsappConsentRequiredStatusResponse
   updatePivotGraphColumnDimension: UpdatePivotGraphColumnDimensionResponse
   updatePivotGraphRowDimension: UpdatePivotGraphRowDimensionResponse
   updatePivotTableGraph: UpdatePivotTableGraphResponse
   updatePivotTableTotalsConfig: UpdatePivotTableGraphTotalsConfigResponse
   updatePlainFieldValidationRegex: UpdatePlainTextFieldValidationRegexResponse
   updatePlainTextFieldDefaultValue: UpdatePlainTextFieldDefaultValueResponse
   updatePlainTextFieldFormulaStatus: UpdatePlainTextFieldFormulaStatusResponse
   updatePortal: UpdatePortalResponse
   updatePortalApplication: UpdatePortalApplicationResponse
   updatePortalApplicationStatus: UpdatePortalApplicationStatusResponse
   updatePortalBrandBgImg: UpdatePortalBrandBgImageResponse
   updatePortalBrandLogo: UpdatePortalBrandLogoResponse
   updatePortalDescription: UpdatePortalDescriptionResponse
   updatePortalStatus: UpdatePortalStatusResponse
   updatePortalTitle: UpdatePortalTitleResponse
   updateQuickFilterField: UpdateGraphQuickFilterFieldResponse
   updateRadioGroupFieldDefaultValue: UpdateRadioGroupFieldDefaultValueResponse
   updateReconciliationRequestStatus: UpdateReconciliationRequestStatusResponse
   updateRecordCreationConfigName: UpdateRecordCreationConfigNameResponse
   updateRelatedEntityAddAnotherFieldResponse: UpdateRelatedEntityAddAnotherFieldResponseResult
   updateRelatedEntityFieldResponse: UpdateRelatedEntityFieldResponseResult
   updateRelation: UpdateRelationResponse
   updateRelationFieldValueType: UpdateRelationFieldValueTypeResponse
   updateResource: UpdateResourceResponse
   updateSalesTemplateRecordCreationConfig: UpdateSalesTemplateRecordCreationConfigResponse
   updateScheduledAutomationWorkflowExecLogsFilter: UpdateScheduledAutomationWorkflowExecLogsFilterResponse
   updateScheduledLeadDistributionRuleSettings: UpdateScheduledLeadDistributionRuleSettingsResponse
   updateScheduledLeadDistributionRuleStatus: UpdateScheduledLeadDistributionRuleStatusResponse
   updateScheduledTrigger: UpdateScheduledTriggerResponse
   updateScorecardChart: UpdateScorecardChartResponse
   updateScoringConfigStatus: UpdateScoringConfigStatusResponse
   updateScoringParameter: UpdateScoringParameterResponse
   updateShortTextFieldDefaultValue: UpdateShortTextFieldDefaultValueResponse
   updateShortTextFieldFormulaStatus: UpdateShortTextFieldFormulaStatusResponse
   updateShortTextFieldOptions: UpdateShortTextFieldOptionsResponse
   updateShortTextFieldValidationRegex: UpdateShortTextFieldValidationRegexResponse
   updateShowPipelineItemStageQuickEditFieldsToTaskTemplate: UpdateShowPipelineItemStageQuickEitFieldsToTaskTemplateResponse
   updateSmartfloAccount: UpdateSmartfloAccountResponse
   updateStageCategory: UpdateStageCategoryResponse
   updateStageTransitionActionName: UpdateStageTransitionActionNameResponse
   updateStageTransitionCheckpointsConfig: UpdateStageTransitionCheckpointsConfigResponse
   updateStageTransitionConfig: UpdateStageTransitionConfigResponse
   updateStageTransitionOrder: UpdateStageTransitionOrderResponse
   updateTab: UpdateTabResponse
   updateTableGraph: UpdateTableGraphResponse
   updateTableGraphTotalsConfig: UpdateTableGraphTotalsConfigResponse
   updateTaskAddAnotherGofField: UpdateTaskAddAnotherFieldResponse
   updateTaskApproxDurationInMins: UpdateTaskApproxDurationInMinsResponse
   updateTaskField: UpdateTaskFieldResponse
   updateTaskFieldBulk: UpdateTaskFieldBulkResponse
   updateTaskPipelineItemCardConfig: UpdateTaskPipelineItemCardConfigResponse
   updateTaskStartDateTime: UpdateTaskStartDateTimeResponse
   updateTaskTemplateColor: UpdateTaskTemplateColorResponse
   updateTaskTemplateDescription: UpdateTaskTemplateDescriptionResponse
   updateTaskTemplateIconUrl: UpdateTaskTemplateIconUrlResponse
   updateTaskTemplateName: UpdateTaskTemplateNameResponse
   updateTaskTemplateRemarksAttachmentEnableStatus: UpdateTaskTemplateRemarksAttachmentEnableStatusResponse
   updateTaskTemplateSettings: UpdateTaskTemplateSettingsResponse
   updateTaskTemplateStatus: UpdateTaskTemplateStatusResponse
   updateTaskTemplateVisibilityField: UpdateTaskTemplateVisibilityFieldResponse
   updateTasksFeatureEnableStatus: UpdateTasksFeatureEnableStatusResponse
   updateTdrPaymentInPortal: UpdateTdrPaymentInPortalResponse
   updateTdrPaymentObservation: UpdateTdrPaymentObservationResponse
   updateTdrRequest: UpdateTdrRequestResponse
   updateTdrRequestInPortal: UpdateTdrRequestInPortalResponse
   updateTimeFieldDefaultValue: UpdateTimeFieldDefaultValueResponse
   updateTimeFieldRelativeDefaultValueConfig: UpdateTimeFieldRelativeDefaultValueConfigResponse
   updateUrlFieldConfig: UpdateUrlFieldConfigResponse
   updateUrlFieldDefaultValue: UpdateUrlFieldDefaultValueResponse
   updateUrlFieldValidationRegex: UpdateUrlFieldValidationRegexResponse
   updateUserAdminStatus: UpdateUserAdminStatusResponse
   updateUserEmailByAdmin: UpdateUserEmailByAdminResponse
   updateUserFirebaseAppAccess: UpdateUserFireBaseAppAccessResponse
   updateUserPortalLanguage: UpdateUserPortalLanguageResponse
   updateUserProfile: UpdateUserProfileResponse
   updateUserProfileByAdmin: UpdateUserProfileByAdminResponse
   updateUserPropertiesTemplateDesignationFieldId: UpdateUserPropertiesTemplateDesignationFieldIdResponse
   updateUserProperty: UpdateUserPropertyResponse
   updateUsernameByAdmin: UpdateUsernameByAdminResponse
   updateUsersTabCustomization: UpdateUsersTabCustomizationResponse
   updateViewCustomJson: UpdateViewCustomJsonResponse
   updateViewType: UpdateViewTypeResponse
   updateWatiAccount: UpdateWatiAccountResponse
   updateWhatsappBusinessPhoneNumber: UpdateWhatsAppBusinessPhoneNumberResponse
   uploadUserKmlFile: UploadUserKmlFileResponse
   validateTdrRequestCertificateNumberInPortal: ValidateTdrRequestCertificateNumberInPortalResponse
   verifyOtpForUpdatingUserPin: VerifyOtpForUpdatingUserPinResponse
   verifyOtpToPipelineItemPhoneNumberField: VerifyOtpToPipelineItemPhoneNumberFieldResponse
   verifyOtpToPipelineItemPhoneNumberFieldInPortal: VerifyOtpToPipelineItemPhoneNumberFieldInPortalResponse
   verifyTdrRequestOtpInPortal: VerifyTdrRequestOtpInPortalResponse
}

export type MutationAcceptTdrTransactionByOwnerArgs = {
   params: AcceptTdrTransactionByOwnerParams
}

export type MutationActOnApplicationInPortalArgs = {
   params: ActOnApplicationInPortalParams
}

export type MutationActOnPipelineItemArgs = {
   params: ActOnPipelineItemParams
}

export type MutationActOnTdrApplicationArgs = {
   params: ActOnTdrApplicationParams
}

export type MutationActivatePluginServiceAccountArgs = {
   params: ActivatePluginServiceAccountParams
}

export type MutationActivateUserArgs = {
   params: ActivateUserParams
}

export type MutationAddActionTypesToIdentificationArgs = {
   params: AddActionTypesToIdentificationParams
}

export type MutationAddActivityTemplatesToPipelineArgs = {
   params: AddActivityTemplatesToPipelineParams
}

export type MutationAddApplicationTabArgs = {
   params: AddApplicationTabParams
}

export type MutationAddApplicationTabGofArgs = {
   params: AddApplicationTabGoFParams
}

export type MutationAddAttachmentsForRemarksArgs = {
   params: AddAttachmentsForRemarksParams
}

export type MutationAddAttachmentsForRemarksInTaskDraftArgs = {
   params: AddAttachmentsForRemarksInTaskDraftParams
}

export type MutationAddCallLogsToTaskDraftArgs = {
   params: AddCallLogsToTaskDraftParams
}

export type MutationAddFeeHeadersInEntityFeeRuleSetArgs = {
   params: AddFeeHeadersInEntityFeeRuleSetParams
}

export type MutationAddFieldConditionalOptionsArgs = {
   params: AddFieldConditionalOptionsParams
}

export type MutationAddFieldRolesArgs = {
   params: AddFieldRolesParams
}

export type MutationAddGallaboxAccountArgs = {
   params: AddGallaboxAccountParams
}

export type MutationAddGraphQuickFilterFieldArgs = {
   params: AddGraphQuickFilterFieldParams
}

export type MutationAddGraphQuickFilterFieldsArgs = {
   params: AddGraphQuickFilterFieldsParams
}

export type MutationAddGupShupAccountArgs = {
   params: AddGupShupAccountParams
}

export type MutationAddIdentificationsToDashboardArgs = {
   params: AddIdentificationsToDashboardParams
}

export type MutationAddKnowlarityAccountArgs = {
   params: AddKnowlarityAccountParams
}

export type MutationAddLayoutToFormArgs = {
   params: AddLayoutToFormParams
}

export type MutationAddOptionsToCheckboxGroupFieldArgs = {
   params: AddOptionsToCheckboxGroupFieldParams
}

export type MutationAddOptionsToDropdownFieldArgs = {
   params: AddOptionsToDropdownFieldParams
}

export type MutationAddOptionsToFieldsSelectorFieldArgs = {
   params: AddOptionsToFieldsSelectorFieldParams
}

export type MutationAddOptionsToMultiSelectGroupFieldArgs = {
   params: AddOptionsToMultiSelectFieldParams
}

export type MutationAddOptionsToRadioGroupFieldArgs = {
   params: AddOptionsToRadioGroupFieldParams
}

export type MutationAddPipelineIdentificationsArgs = {
   params: AddPipelineIdentificationsParams
}

export type MutationAddPipelineItemRemarksArgs = {
   params: AddPipelineItemRemarksParams
}

export type MutationAddPipelineItemTemplatesAdminPermissionForUserArgs = {
   params: AddPipelineItemTemplatesAdminPermissionForUserParams
}

export type MutationAddPipelinesAdminPermissionForUserArgs = {
   params: AddPipelinesAdminPermissionForUserParams
}

export type MutationAddRelatedEntitiesArgs = {
   params: AddRelatedEntitiesParams
}

export type MutationAddRelatedPipelineItemRemarkArgs = {
   params: AddRelatedPipelineItemRemarksParams
}

export type MutationAddSmartfloAccountArgs = {
   params: AddSmartfloAccountParams
}

export type MutationAddStageUpdatePermissionsArgs = {
   params: AddStageUpdatePermissionParams
}

export type MutationAddSubmissionConfigToFormArgs = {
   params: AddSubmissionConfigToFormParams
}

export type MutationAddUserGroupsForBoardArgs = {
   params: AddUserGroupsForBoardParams
}

export type MutationAddUserGroupsForBoardListArgs = {
   params: AddUserGroupsForBoardListParams
}

export type MutationAddUserIdentificationsArgs = {
   params: AddUserIdentificationsParams
}

export type MutationAddUsersToIdentificationArgs = {
   params: AddUsersToIdentificationParams
}

export type MutationAddViewSortByFieldsArgs = {
   params: AddSortByFieldsParams
}

export type MutationAddWatiAccountArgs = {
   params: AddWatiAccountParams
}

export type MutationAddWhatsAppBusinessPhoneNumberUsersArgs = {
   params: AddWhatsAppBusinessPhoneNumberUsersParams
}

export type MutationAddWhatsappBusinessNumberArgs = {
   params: AddWhatsAppBusinessNumberParams
}

export type MutationAddWhatsappBusinessPhoneNumberArgs = {
   params: AddWhatsAppBusinessPhoneNumberParams
}

export type MutationAdminSetUserPinArgs = {
   params: AdminSetUserPinParams
}

export type MutationApplicationUpdatedDummyMutationArgs = {
   params: ApplicationUpdatedDummyMutationParams
}

export type MutationApplyForDeemedApprovalInPortalArgs = {
   params: ApplyForDeemedApprovalInPortalParams
}

export type MutationApplyPortalApplicationKeyArgs = {
   params: ApplyPortalApplicationKeyParams
}

export type MutationApproveLineDepartmentRecommendationArgs = {
   params: ApproveLineDepartmentRecommendationParams
}

export type MutationAskQueryInThreadArgs = {
   params: AskQueryInThreadParams
}

export type MutationAssignDocumentVerificationUserArgs = {
   params: AssignDocumentVerificationUserParams
}

export type MutationAssignFriendArgs = {
   params: AssignFriendParams
}

export type MutationAuthorizeGoogleUserArgs = {
   params: AuthorizeGoogleUserParams
}

export type MutationCancelTdrOrderInPortalArgs = {
   params: CancelTdrOrderInPortalParams
}

export type MutationCancelTdrPaymentInPortalArgs = {
   params: CancelTdrPaymentInPortalParams
}

export type MutationChangeApplicationDisplayStageShortfallFieldsStatusArgs = {
   params: ChangeApplicationDisplayStageShortFallFieldsStatusParams
}

export type MutationChangeAutoGenerateApplicationIdInCreationStatusArgs = {
   params: ChangeAutoGenerateApplicationIdInCreationStatusParams
}

export type MutationChangeFieldTypeArgs = {
   params: ChangeFieldTypeParams
}

export type MutationChangeMakeApplicationFieldsAsShortfallValueArgs = {
   params: ChangeMakeApplicationFieldsAsShortfallValueParams
}

export type MutationChangeStageColorArgs = {
   params: ChangeStageColorParams
}

export type MutationCheckCaRegistrationNumberLinkedToOtherUsersArgs = {
   params: CheckCaRegistrationNumberLinkedToOtherUsersParams
}

export type MutationClearApplicationAddAnotherGofArgs = {
   params: ClearApplicationAddAnotherGoFParams
}

export type MutationClearApplicationAddAnotherGofInPortalArgs = {
   params: ClearApplicationAddAnotherGoFInPortalParams
}

export type MutationClearAutomationWorkflowExecLogsFilterArgs = {
   params: ClearAutomationWorkflowExecLogsFilterParams
}

export type MutationClearDealAddAnotherGofArgs = {
   params: ClearDealAddAnotherGoFParams
}

export type MutationClearDistributionThroughEntitiesArgs = {
   params: ClearDistributionThroughEntitiesParams
}

export type MutationClearFieldConditionalOptionsConfigArgs = {
   params: ClearFieldConditionalOptionsConfigParams
}

export type MutationClearLeadAddAnotherGofArgs = {
   params: ClearLeadAddAnotherGoFParams
}

export type MutationClearPipelineCustomObjectAddAnotherGofArgs = {
   params: ClearPipelineCustomObjectAddAnotherGoFParams
}

export type MutationClearRelatedEntityAddAnotherGofArgs = {
   params: ClearRelatedEntityAddAnotherGoFParams
}

export type MutationClearScheduledAutomationWorkflowExecLogsFilterArgs = {
   params: ClearScheduledAutomationWorkflowExecLogsFilterParams
}

export type MutationClearTaskAddAnotherGofArgs = {
   params: ClearTaskAddAnotherGoFParams
}

export type MutationClearTaskDraftArgs = {
   params: ClearTaskDraftParams
}

export type MutationCloneAutomationWorkflowArgs = {
   params: CloneAutomationWorkflowParams
}

export type MutationCloneGraphArgs = {
   params: CloneGraphParams
}

export type MutationCloneLeadDistributionRuleArgs = {
   params: CloneLeadDistributionRuleParams
}

export type MutationConfigureAdvancedAnalyticsArgs = {
   params: ConfigureAdvancedAnalyticsParams
}

export type MutationConfigureDealsFeatureArgs = {
   params: ConfigureDealsFeatureParams
}

export type MutationCreateActivityTemplateArgs = {
   params: CreateActivityTemplateParams
}

export type MutationCreateActivityTemplateGofArgs = {
   params: CreateActivityTemplateGoFParams
}

export type MutationCreateAgentAllocationGroupArgs = {
   params: CreateAgentAllocationGroupParams
}

export type MutationCreateAllocationGroupSetForAgentAllocationGroupsArgs = {
   params: CreateAllocationGroupSetForAgentAllocationGroupsParams
}

export type MutationCreateAllocationGroupSetForAgentsArgs = {
   params: CreateAllocationGroupSetForAgentsParams
}

export type MutationCreateApplicationArgs = {
   params: CreateApplicationParams
}

export type MutationCreateApplicationAddAnotherGofArgs = {
   params: CreateApplicationAddAnotherGoFParams
}

export type MutationCreateApplicationAddAnotherGofInPortalArgs = {
   params: CreateApplicationAddAnotherGoFInPortalParams
}

export type MutationCreateApplicationInPortalArgs = {
   params: CreateApplicationInPortalParams
}

export type MutationCreateAssigneeFieldArgs = {
   params: CreateAssigneeFieldParams
}

export type MutationCreateAssigneeGroupArgs = {
   params: CreateAssigneeGroupParams
}

export type MutationCreateAutomationWorkflowConditionArgs = {
   params: CreateAutomationWorkflowConditionParams
}

export type MutationCreateAutomationWorkflowFilterArgs = {
   params: CreateAutomationWorkflowFilterParams
}

export type MutationCreateAutomationWorkflowNodeArgs = {
   params: CreateAutomationWorkflowNodeParams
}

export type MutationCreateBarGraphArgs = {
   params: CreateBarGraphParams
}

export type MutationCreateBoardArgs = {
   params: CreateBoardParams
}

export type MutationCreateBoardListArgs = {
   params: CreateBoardListParams
}

export type MutationCreateCalendarPipelineItemScheduleArgs = {
   params: CreateCalendarPipelineItemScheduleParams
}

export type MutationCreateCheckboxGroupFieldArgs = {
   params: CreateCheckboxGroupFieldParams
}

export type MutationCreateConditionArgs = {
   params: CreateConditionParams
}

export type MutationCreateConditionNodeArgs = {
   params: CreateNodeConditionParams
}

export type MutationCreateConditionNodeFilterArgs = {
   params: CreateConditionNodeFilterParams
}

export type MutationCreateContactTemplateGofArgs = {
   params: CreateContactTemplateGoFParams
}

export type MutationCreateCustomIdFieldArgs = {
   params: CreateCustomIdFieldParams
}

export type MutationCreateDashboardArgs = {
   params: CreateDashboardParams
}

export type MutationCreateDateFieldArgs = {
   params: CreateDateFieldParams
}

export type MutationCreateDateTimeFieldArgs = {
   params: CreateDateTimeFieldParams
}

export type MutationCreateDealAddAnotherGofArgs = {
   params: CreateDealAddAnotherGoFParams
}

export type MutationCreateDocumentLogArgs = {
   params: CreateDocumentLogParams
}

export type MutationCreateDocumentTemplateArgs = {
   params: CreateDocumentTemplateParams
}

export type MutationCreateDonutChartArgs = {
   params: CreateDonutChartParams
}

export type MutationCreateDropdownFieldArgs = {
   params: CreateDropdownFieldParams
}

export type MutationCreateEmailFieldArgs = {
   params: CreateEmailFieldParams
}

export type MutationCreateEntityCustomCheckpointArgs = {
   params: CreateEntityCustomCheckpointParams
}

export type MutationCreateEntityDealArgs = {
   params: CreateEntityDealParams
}

export type MutationCreateEntityFeeRuleSetArgs = {
   params: CreateEntityFeeRuleSetParams
}

export type MutationCreateEventBasedAutomationWorkflowArgs = {
   params: CreateEventBasedAutomationWorkflowParams
}

export type MutationCreateEventBasedLeadDistributionRuleArgs = {
   params: CreateEventBasedLeadDistributionRuleParams
}

export type MutationCreateEventTriggerConditionArgs = {
   params: CreateEventTriggerConditionParams
}

export type MutationCreateEventTriggerFilterArgs = {
   params: CreateEventTriggerFilterParams
}

export type MutationCreateFieldsSelectorFieldArgs = {
   params: CreateFieldsSelectorFieldParams
}

export type MutationCreateFileUploaderFieldArgs = {
   params: CreateFileUploaderFieldParams
}

export type MutationCreateFilterArgs = {
   params: CreateFilterParams
}

export type MutationCreateFilterForBoardArgs = {
   params: CreateFilterForBoardParams
}

export type MutationCreateFilterForBoardListArgs = {
   params: CreateFilterForBoardListParams
}

export type MutationCreateFloatFieldArgs = {
   params: CreateFloatFieldParams
}

export type MutationCreateFormArgs = {
   params: CreateFormParams
}

export type MutationCreateFunnelGraphArgs = {
   params: CreateFunnelGraphParams
}

export type MutationCreateGeoLocationFieldArgs = {
   params: CreateGeoLocationFieldParams
}

export type MutationCreateGeoShapeFieldArgs = {
   params: CreateGeoShapeFieldParams
}

export type MutationCreateGraphDimensionArgs = {
   params: CreateGraphDimensionParams
}

export type MutationCreateGraphMetricArgs = {
   params: CreateGraphMetricParams
}

export type MutationCreateGroupedBarGraphArgs = {
   params: CreateGroupedBarGraphParams
}

export type MutationCreateIdentificationArgs = {
   params: CreateIdentificationParams
}

export type MutationCreateIntegerFieldArgs = {
   params: CreateIntegerFieldParams
}

export type MutationCreateLayoutArgs = {
   params: CreateLayoutParams
}

export type MutationCreateLeadAddAnotherGofArgs = {
   params: CreateLeadAddAnotherGoFParams
}

export type MutationCreateLeadBucketArgs = {
   params: CreateLeadBucketParams
}

export type MutationCreateLeadDistributionRuleArgs = {
   params: CreateLeadDistributionRuleParams
}

export type MutationCreateLeadWithContactArgs = {
   params: CreateLeadWithContactParams
}

export type MutationCreateLineGraphArgs = {
   params: CreateLineGraphParams
}

export type MutationCreateLinkedFieldArgs = {
   params: CreateLinkedFieldParams
}

export type MutationCreateLongTextFieldArgs = {
   params: CreateLongTextFieldParams
}

export type MutationCreateMultiSelectFieldArgs = {
   params: CreateMultiSelectFieldParams
}

export type MutationCreateNodeAddAnotherGofArgs = {
   params: CreateNodeAddAnotherGoFParams
}

export type MutationCreateNodeCallWebhookArgs = {
   params: CreateNodeCallWebhookParams
}

export type MutationCreateNodeClearUndoneLeadTasksArgs = {
   params: CreateNodeClearUndoneLeadTasksParams
}

export type MutationCreateNodeCreatePipelineEventArgs = {
   params: CreateNodeCreatePipelineEventParams
}

export type MutationCreateNodeCreateRelatedRecordArgs = {
   params: CreateNodeCreateRelatedRecordParams
}

export type MutationCreateNodeCreateTaskArgs = {
   params: CreateNodeCreateTaskParams
}

export type MutationCreateNodeExecuteFunctionArgs = {
   params: CreateNodeExecuteFunctionParams
}

export type MutationCreateNodeGenerateDocumentArgs = {
   params: CreateNodeGenerateDocumentParams
}

export type MutationCreateNodeGenerateNumberArgs = {
   params: CreateNodeGenerateNumberParams
}

export type MutationCreateNodeInitiateRefundArgs = {
   params: CreateNodeInitiateRefundParams
}

export type MutationCreateNodeRemoveAssigneesArgs = {
   params: CreateNodeRemoveAssigneesParams
}

export type MutationCreateNodeRequestPaymentArgs = {
   params: CreateNodeRequestPaymentParams
}

export type MutationCreateNodeRequestPaymentWithFeeRulesArgs = {
   params: CreateNodeRequestPaymentWithFeeRulesParams
}

export type MutationCreateNodeSendDataToSegmentArgs = {
   params: CreateNodeSendDataToSegmentParams
}

export type MutationCreateNodeSendPipelineItemNotificationArgs = {
   params: CreateNodeSendPipelineItemNotificationParams
}

export type MutationCreateNodeSendWhatsappMessageNodeArgs = {
   params: CreateNodeSendWhatsAppMessageNodeParams
}

export type MutationCreateNodeSignDocumentArgs = {
   params: CreateNodeSignDocumentParams
}

export type MutationCreateNodeSwiftsellOutboundWebhookNodeArgs = {
   params: CreateNodeSwiftsellOutboundWebhookParams
}

export type MutationCreateNodeUpdateDisplayStageArgs = {
   params: CreateNodeUpdateDisplayStageParams
}

export type MutationCreateNodeUpdateLeadArgs = {
   params: CreateNodeUpdateLeadParams
}

export type MutationCreateNodeUpdateLeadStageArgs = {
   params: CreateNodeUpdateLeadStageParams
}

export type MutationCreateNodeUpdatePipelineItemAssigneeArgs = {
   params: CreateNodeUpdatePipelineItemAssigneeParams
}

export type MutationCreateNodeUpdateRelatedRecordsArgs = {
   params: CreateNodeUpdateRelatedRecordsParams
}

export type MutationCreateNodeUpdateTaskArgs = {
   params: CreateNodeUpdateTaskParams
}

export type MutationCreateNoteArgs = {
   params: CreateNoteParams
}

export type MutationCreateObjectionTaskArgs = {
   params: CreateObjectionTaskParams
}

export type MutationCreateObjectionTaskAddAnotherGofBulkArgs = {
   params: CreateObjectionTaskAddAnotherGoFBulkParams
}

export type MutationCreateParameterArgs = {
   params: CreateParameterParams
}

export type MutationCreateParameterConditionArgs = {
   params: CreateParameterConditionParams
}

export type MutationCreatePhoneNumberFieldArgs = {
   params: CreatePhoneNumberFieldParams
}

export type MutationCreatePieChartArgs = {
   params: CreatePieChartParams
}

export type MutationCreatePipelineArgs = {
   params: CreatePipelineParams
}

export type MutationCreatePipelineCustomObjectArgs = {
   params: CreatePipelineCustomObjectParams
}

export type MutationCreatePipelineCustomObjectAddAnotherGofArgs = {
   params: CreatePipelineCustomObjectAddAnotherGoFParams
}

export type MutationCreatePipelineEventTemplateArgs = {
   params: CreatePipelineEventTemplateParams
}

export type MutationCreatePipelineEventTemplateGofArgs = {
   params: CreatePipelineEventTemplateGoFParams
}

export type MutationCreatePipelineItemPaymentRequestArgs = {
   params: CreatePipelineItemPaymentRequestParams
}

export type MutationCreatePipelineItemReminderArgs = {
   params: CreatePipelineItemReminderParams
}

export type MutationCreatePipelineItemScheduleArgs = {
   params: CreatePipelineItemScheduleParams
}

export type MutationCreatePipelineItemTemplateArgs = {
   params: CreatePipelineItemTemplateParams
}

export type MutationCreatePipelineItemTemplateGofArgs = {
   params: CreatePipelineItemTemplateGoFParams
}

export type MutationCreatePivotTableGraphArgs = {
   params: CreatePivotTableGraphParams
}

export type MutationCreatePlainTextFieldArgs = {
   params: CreatePlainTextFieldParams
}

export type MutationCreatePortalArgs = {
   params: CreatePortalParams
}

export type MutationCreatePortalApplicationArgs = {
   params: CreatePortalApplicationParams
}

export type MutationCreateRadioGroupFieldArgs = {
   params: CreateRadioGroupFieldParams
}

export type MutationCreateRazorpayOrderInPortalArgs = {
   params: CreateRazorpayOrderInPortalParams
}

export type MutationCreateRecordCreationConfigArgs = {
   params: CreateRecordCreationConfigParams
}

export type MutationCreateRelatedApplicationArgs = {
   params: CreateRelatedApplicationParams
}

export type MutationCreateRelatedApplicationInPortalArgs = {
   params: CreateRelatedApplicationInPortalParams
}

export type MutationCreateRelatedEntityAddAnotherGofArgs = {
   params: CreateRelatedEntityAddAnotherGoFParams
}

export type MutationCreateRelatedLeadWithContactArgs = {
   params: CreateRelatedLeadWithContactParams
}

export type MutationCreateRelatedPipelineCustomObjectArgs = {
   params: CreateRelatedPipelineCustomObjectParams
}

export type MutationCreateRelationArgs = {
   params: CreateRelationParams
}

export type MutationCreateRelationFieldArgs = {
   params: CreateRelationFieldParams
}

export type MutationCreateResourceArgs = {
   params: CreateResourceParams
}

export type MutationCreateScheduledAutomationWorkflowArgs = {
   params: CreateScheduledAutomationWorkflowParams
}

export type MutationCreateScorecardChartArgs = {
   params: CreateScorecardChartParams
}

export type MutationCreateScoringParameterArgs = {
   params: CreateScoringParameterParams
}

export type MutationCreateScoringParametersArgs = {
   params: CreateScoringParametersParams
}

export type MutationCreateShortTextFieldArgs = {
   params: CreateShortTextFieldParams
}

export type MutationCreateSiteInspectionTaskAddAnotherGofArgs = {
   params: CreateSiteInspectionTaskAddAnotherGoFParams
}

export type MutationCreateSiteInspectionTaskAddAnotherGofBulkArgs = {
   params: CreateSiteInspectionTaskAddAnotherGoFBulkParams
}

export type MutationCreateStackedBarGraphArgs = {
   params: CreateStackedBarGraphParams
}

export type MutationCreateStageArgs = {
   params: CreateStageParams
}

export type MutationCreateStageTransitionArgs = {
   params: CreateStageTransitionParams
}

export type MutationCreateTabArgs = {
   params: CreateTabParams
}

export type MutationCreateTableGraphArgs = {
   params: CreateTableGraphParams
}

export type MutationCreateTaskArgs = {
   params: CreateTaskParams
}

export type MutationCreateTaskAddAnotherGofArgs = {
   params: CreateTaskAddAnotherGoFParams
}

export type MutationCreateTaskTemplateArgs = {
   params: CreateTaskTemplateParams
}

export type MutationCreateTaskTemplateGofArgs = {
   params: CreateTaskTemplateGoFParams
}

export type MutationCreateTdrAccountPurchaseRequestArgs = {
   params: CreateTdrAccountPurchaseRequestParams
}

export type MutationCreateTdrDigitalizationApplicationArgs = {
   params: CreateTdrDigitalizationApplicationParams
}

export type MutationCreateTdrOrderInPortalArgs = {
   params: CreateTdrOrderInPortalParams
}

export type MutationCreateTdrPaymentInPortalArgs = {
   params: CreateTdrPaymentInPortalParams
}

export type MutationCreateTdrRequestInPortalArgs = {
   params: CreateTdrRequestInPortalParams
}

export type MutationCreateTdrRequestInPortalAndSendOtpArgs = {
   params: CreateTdrRequestInPortalAndSendOtpParams
}

export type MutationCreateThreadArgs = {
   params: CreateThreadParams
}

export type MutationCreateTimeFieldArgs = {
   params: CreateTimeFieldParams
}

export type MutationCreateUnifiedApplicationInPortalArgs = {
   params: CreateUnifiedApplicationInPortalParams
}

export type MutationCreateUrlFieldArgs = {
   params: CreateUrlFieldParams
}

export type MutationCreateUserArgs = {
   params: CreateUserParams
}

export type MutationCreateUserPropertiesTemplateGofArgs = {
   params: CreateUserPropertiesTemplateGoFParams
}

export type MutationCreateUserWithPhoneNumberNameArgs = {
   params: CreateUserInOfficerManagementParams
}

export type MutationCreateVerificationTaskFromExistingTaskArgs = {
   params: CreateVerificationTaskFromExistingTaskParams
}

export type MutationCreateViewFilterArgs = {
   params: CreateFilterForViewParams
}

export type MutationCreateViewInBoardArgs = {
   params: CreateViewInBoardParams
}

export type MutationCreateViewInBoardListArgs = {
   params: CreateViewInBoardListParams
}

export type MutationDeactivatePluginServiceAccountArgs = {
   params: DeactivatePluginServiceAccountParams
}

export type MutationDeactivateUserArgs = {
   params: DeactivateUserParams
}

export type MutationDeleteAllocationGroupSetArgs = {
   params: DeleteAllocationGroupSetParams
}

export type MutationDeleteApplicationAddAnotherGofArgs = {
   params: DeleteApplicationAddAnotherGoFParams
}

export type MutationDeleteApplicationAddAnotherGofInPortalArgs = {
   params: DeleteApplicationAddAnotherGoFInPortalParams
}

export type MutationDeleteApplicationInPortalArgs = {
   params: DeleteApplicationInPortalParams
}

export type MutationDeleteApplicationTabArgs = {
   params: DeleteApplicationTabParams
}

export type MutationDeleteApplicationTabGofsArgs = {
   params: DeleteApplicationTabGofsParams
}

export type MutationDeleteApplicationTabSectionsArgs = {
   params: DeleteApplicationTabSectionsParams
}

export type MutationDeleteAssigneeGroupArgs = {
   params: DeleteAssigneeGroupParams
}

export type MutationDeleteAutomationWorkflowArgs = {
   params: DeleteAutomationWorkflowParams
}

export type MutationDeleteAutomationWorkflowConditionArgs = {
   params: DeleteAutomationWorkflowConditionParams
}

export type MutationDeleteAutomationWorkflowFilterArgs = {
   params: DeleteAutomationWorkflowFilterParams
}

export type MutationDeleteBoardArgs = {
   params: DeleteBoardParams
}

export type MutationDeleteBoardListArgs = {
   params: DeleteBoardListParams
}

export type MutationDeleteConditionArgs = {
   params: DeleteConditionParams
}

export type MutationDeleteDashboardArgs = {
   params: DeleteDashboardParams
}

export type MutationDeleteDealAddAnotherGofArgs = {
   params: DeleteDealAddAnotherGoFParams
}

export type MutationDeleteDocumentArgs = {
   params: DeleteDocumentParams
}

export type MutationDeleteDocumentTemplateArgs = {
   params: DeleteDocumentTemplateParams
}

export type MutationDeleteEventTriggerConditionArgs = {
   params: DeleteEventTriggerConditionParams
}

export type MutationDeleteEventTriggerFilterArgs = {
   params: DeleteEventTriggerFilterParams
}

export type MutationDeleteFieldArgs = {
   params: DeleteFieldParams
}

export type MutationDeleteFilterArgs = {
   params: DeleteFilterParams
}

export type MutationDeleteGofArgs = {
   params: DeleteGoFParams
}

export type MutationDeleteGraphDimensionArgs = {
   params: DeleteGraphDimensionParams
}

export type MutationDeleteGraphsArgs = {
   params: DeleteGraphsParams
}

export type MutationDeleteIdentificationArgs = {
   params: DeleteIdentificationParams
}

export type MutationDeleteLeadAddAnotherGofArgs = {
   params: DeleteLeadAddAnotherGoFParams
}

export type MutationDeleteLeadBucketArgs = {
   params: DeleteLeadBucketParams
}

export type MutationDeleteMetricArgs = {
   params: DeleteMetricParams
}

export type MutationDeleteNodeArgs = {
   params: DeleteNodeParams
}

export type MutationDeleteParameterArgs = {
   params: DeleteParameterParams
}

export type MutationDeleteParameterConditionArgs = {
   params: DeleteParameterConditionParams
}

export type MutationDeletePipelineCustomObjectAddAnotherGofArgs = {
   params: DeletePipelineCustomObjectAddAnotherGoFParams
}

export type MutationDeletePipelineItemRemindersArgs = {
   params: DeletePipelineItemRemindersParams
}

export type MutationDeleteRecordCreationConfigArgs = {
   params: DeleteRecordCreationConfigParams
}

export type MutationDeleteRelatedEntityAddAnotherGofArgs = {
   params: DeleteRelatedEntityAddAnotherGoFParams
}

export type MutationDeleteRelationArgs = {
   params: DeleteRelationParams
}

export type MutationDeleteScheduledPipelineItemsArgs = {
   params: DeleteScheduledPipelineItemsParams
}

export type MutationDeleteScoringParameterArgs = {
   params: DeleteScoringParameterParams
}

export type MutationDeleteStageAddAnotherGofsPermissionsArgs = {
   params: DeleteStageAddAnotherGoFsPermissionsParams
}

export type MutationDeleteStageTransitionArgs = {
   params: DeleteStageTransitionParams
}

export type MutationDeleteStageTransitionCheckpointArgs = {
   params: DeleteStageTransitionCheckpointParams
}

export type MutationDeleteTabArgs = {
   params: DeleteTabParams
}

export type MutationDeleteTaskAddAnotherGofArgs = {
   params: DeleteTaskAddAnotherGoFParams
}

export type MutationDeleteTdrRequestsInPortalArgs = {
   params: DeleteTdrRequestsInPortalParams
}

export type MutationDeleteUserKmlFileArgs = {
   params: DeleteUserKmlFileParams
}

export type MutationDeleteViewArgs = {
   params: DeleteViewParams
}

export type MutationDisableAccountFeaturesArgs = {
   params: DisableAccountFeaturesParams
}

export type MutationDisableAutoGenerateCustomIdArgs = {
   params: DisableAutoGenerateCustomIdParams
}

export type MutationDisablePipelineFeaturesArgs = {
   params: DisablePipelineFeaturesParams
}

export type MutationDisablePluginArgs = {
   params: DisablePluginForAccountParams
}

export type MutationDisableWhatsappBusinessPhoneNumberArgs = {
   params: DisableWhatsAppBusinessPhoneNumberParams
}

export type MutationDiscardPipelineItemPaymentRequestArgs = {
   params: DiscardPipelineItemPaymentRequestParams
}

export type MutationDuplicateViewArgs = {
   params: DuplicateViewParams
}

export type MutationEnableAccountFeaturesArgs = {
   params: EnableAccountFeaturesParams
}

export type MutationEnableAutoGenerateCustomIdArgs = {
   params: EnableAutoGenerateCustomIdParams
}

export type MutationEnablePipelineFeaturesArgs = {
   params: EnablePipelineFeaturesParams
}

export type MutationEnablePluginArgs = {
   params: EnablePluginForAccountParams
}

export type MutationEnableWhatsappBusinessPhoneNumberArgs = {
   params: EnableWhatsAppBusinessPhoneNumberParams
}

export type MutationEndOfficerLeaveArgs = {
   params: EndOfficerLeaveParams
}

export type MutationExportContactsArgs = {
   params: ExportContactsParams
}

export type MutationExportFailedActivityLogsArgs = {
   params: ExportFailedActivityLogsParams
}

export type MutationExportPipelineItemRemarksArgs = {
   params: ExportPipelineItemRemarksParams
}

export type MutationExportPipelineItemsArgs = {
   params: ExportPipelineItemsParams
}

export type MutationExportPipelineItemsByIdentificationValueArgs = {
   params: ExportPipelineItemsByIdentificationValueParams
}

export type MutationExportPipelineItemsInViewArgs = {
   params: ExportPipelineItemsInViewParams
}

export type MutationExportUserCallingConfigsArgs = {
   params: ExportUserCallingConfigsParams
}

export type MutationFeeUpdatedDummyMutationArgs = {
   params: FeeUpdatedDummyMutationParams
}

export type MutationGenerateApplicationDrawingPdfInPortalArgs = {
   params: GenerateApplicationDrawingPdfParams
}

export type MutationGeneratePaymentReceiptArgs = {
   params: GeneratePaymentReceiptParams
}

export type MutationGeneratePaymentReceiptInPortalArgs = {
   params: GeneratePaymentReceiptInPortalParams
}

export type MutationGeneratePipelineItemDocumentArgs = {
   params: GeneratePipelineItemDocumentParams
}

export type MutationGeneratePipelineItemDocumentWithUrlArgs = {
   params: GeneratePipelineItemDocumentWithUrlParams
}

export type MutationGenerateReconciliationPreviewArgs = {
   params: GenerateReconciliationPreviewParams
}

export type MutationGenerateScrutinyKeyArgs = {
   params: GenerateScrutinyKeyParams
}

export type MutationHoldTdrAccountArgs = {
   params: HoldTdrAccountParams
}

export type MutationInitiateApplicationRefundArgs = {
   params: InitiateApplicationRefundParams
}

export type MutationInitiateDataLoadingRequestFromCsvArgs = {
   params: InitiateDataLoadingRequestFromCsvParams
}

export type MutationInitiateDeactivateUserArgs = {
   params: InitiateDeactivateUserParams
}

export type MutationInitiateLeadDistributionRuleArgs = {
   params: InitiateLeadDistributionRuleParams
}

export type MutationInitiateLeadOnActivityArgs = {
   params: InitiateLeadOnActivityParams
}

export type MutationInitiateLoadBankAccountArgs = {
   params: InitiateLoadBankAccountParams
}

export type MutationInitiateMandalAssignmentArgs = {
   params: MandalAssignmentParams
}

export type MutationInitiateOfficerLeaveArgs = {
   params: InitiateOfficerLeaveParams
}

export type MutationInitiateOfficerTransferArgs = {
   params: OfficerTransferParams
}

export type MutationInitiatePaymentOnPipelineItemArgs = {
   params: InitiatePaymentOnPipelineItemParams
}

export type MutationInitiateReconciliationArgs = {
   params: InitiateReconciliationParams
}

export type MutationInitiateTestTransferBankAmountArgs = {
   params: InitiateTestTransferBankAmountParams
}

export type MutationInitiateTransferActionArgs = {
   params: InitiatePmuActionParams
}

export type MutationInitiateUpdateActionArgs = {
   params: InitiatePmuActionParams
}

export type MutationInitiateUpdateUserDetailsArgs = {
   params: UpdateUserDetailsParams
}

export type MutationLinkGraphsToViewArgs = {
   params: LinkGraphsToViewParams
}

export type MutationLinkWhatsappMessageTemplateToPipelineArgs = {
   params: LinkWhatsAppMessageTemplateToPipelineParams
}

export type MutationMakeCallArgs = {
   params: MakeCallParams
}

export type MutationMakeTaskShortfallArgs = {
   params: MakeTaskShortfallParams
}

export type MutationMarkNotificationAsReadArgs = {
   params: MarkNotificationAsReadParams
}

export type MutationMarkNotificationAsUnreadArgs = {
   params: MarkNotificationAsUnreadParams
}

export type MutationMarkScheduledPipelineItemsAsCompletedArgs = {
   params: MarkScheduledPipelineItemsAsCompletedParams
}

export type MutationMarkTdrAccountRequestAsReadArgs = {
   params: MarkTdrAccountRequestAsReadParams
}

export type MutationMergePipelineItemsArgs = {
   params: MergePipelineItemsParams
}

export type MutationMergePipelineItemsWithContactsArgs = {
   params: MergePipelineItemsWithContactsParams
}

export type MutationMoveNodeArgs = {
   params: MoveNodeParams
}

export type MutationOrderStatusUpdatedDummyMutationArgs = {
   params: OrderStatusUpdatedDummyMutationParams
}

export type MutationPinPipelineItemsArgs = {
   params: PinPipelineItemsParams
}

export type MutationPollDigitalSignStatusArgs = {
   params: PollDigitalSignStatusParams
}

export type MutationPopulateActivitiesFromCsvArgs = {
   params: PopulateActivitiesFromCsvParams
}

export type MutationPopulateActivitiesFromSheetArgs = {
   params: PopulateActivitiesFromSheetParams
}

export type MutationPopulateApplicationsFromCsvArgs = {
   params: PopulateApplicationsFromCsvParams
}

export type MutationPopulateConditionalFieldOptionsFromCsvArgs = {
   params: PopulateConditionalFieldOptionsFromCsvParams
}

export type MutationPopulateContactsFromCsvArgs = {
   params: PopulateContactsFromCsvParams
}

export type MutationPopulateContactsFromSheetArgs = {
   params: PopulateContactsFromSheetParams
}

export type MutationPopulateCrmFunctionsFromCsvArgs = {
   params: PopulateCrmFunctionsFromCsvParams
}

export type MutationPopulateCustomObjectsFromCsvArgs = {
   params: PopulateCustomObjectsFromCsvParams
}

export type MutationPopulateCustomObjectsFromSheetArgs = {
   params: PopulateCustomObjectsFromSheetParams
}

export type MutationPopulateLeadsWithContactFromCsvArgs = {
   params: PopulateLeadsWithContactFromCsvParams
}

export type MutationPopulateLeadsWithContactFromSheetArgs = {
   params: PopulateLeadsWithContactFromSheetParams
}

export type MutationPopulatePipelineWhatsappBusinessPhoneNumbersArgs = {
   params: PopulatePipelineWhatsappBusinessPhoneNumbersFromSheetParams
}

export type MutationPopulatePipelineWhatsappBusinessPhoneNumbersFromCsvArgs = {
   params: PopulatePipelineWhatsappBusinessPhoneNumbersFromCsvParams
}

export type MutationPopulateSurveyNumbersFromCsvArgs = {
   params: PopulateSurveyNumbersFromCsvParams
}

export type MutationPopulateUserCallingConfigsFromCsvArgs = {
   params: PopulateUserCallingConfigFromCsvParams
}

export type MutationPopulateUserCallingConfigsFromSheetArgs = {
   params: PopulateUserCallingConfigFromSheetParams
}

export type MutationPopulateUsersFromCsvArgs = {
   params: PopulateUsersFromCsvParams
}

export type MutationPopulateUsersFromSheetArgs = {
   params: PopulateUsersFromSheetParams
}

export type MutationPublishAutomationWorkflowArgs = {
   params: PublishAutomationWorkFlowParams
}

export type MutationPublishFormArgs = {
   params: PublishFormParams
}

export type MutationPublishLeadDistributionRuleArgs = {
   params: PublishLeadDistributionRuleParams
}

export type MutationPublishPipelineItemRemarksArgs = {
   params: PublishPipelineItemRemarksParams
}

export type MutationPublishScoringConfigArgs = {
   params: PublishScoringConfigParams
}

export type MutationPushContactToPipelineArgs = {
   params: PushContactToPipelineParams
}

export type MutationReapproveLineDepartmentRecommendationArgs = {
   params: ReapproveLineDepartmentRecommendationParams
}

export type MutationRecalculateEntityFeeRuleSetArgs = {
   params: RecalculateEntityFeeRuleSetParams
}

export type MutationRecalculateScoreArgs = {
   params: RecalculateScoreParams
}

export type MutationRecopyRelatedApplicationFieldsArgs = {
   params: RecopyRelatedApplicationFieldsParams
}

export type MutationRegenerateConditionsLettersDummyMutationArgs = {
   params: RegenerateConditionsLettersDummyMutationParams
}

export type MutationRegeneratePipelineItemDocumentArgs = {
   params: RegeneratePipelineItemDocumentParams
}

export type MutationRegenerateTdrCertificateArgs = {
   params: RegenerateTdrCertificateParams
}

export type MutationReinitiateFailedRefundArgs = {
   params: ReinitiateFailedRefundParams
}

export type MutationRejectLineDepartmentRecommendationArgs = {
   params: RejectLineDepartmentRecommendationParams
}

export type MutationReleaseTdrAccountArgs = {
   params: ReleaseTdrAccountParams
}

export type MutationRemindPendingOrderArgs = {
   params: RemindPendingOrderParams
}

export type MutationRemoveActionTypesFromIdentificationArgs = {
   params: RemoveActionTypesFromIdentificationParams
}

export type MutationRemoveActivityTemplatesFromPipelineArgs = {
   params: RemoveActivityTemplatesFromPipelineParams
}

export type MutationRemoveApplicationFieldAsShortfallArgs = {
   params: RemoveApplicationFieldAsShortfallParams
}

export type MutationRemoveAsDependentFieldArgs = {
   params: RemoveAsDependentFieldParams
}

export type MutationRemoveAsIdentificationFieldArgs = {
   params: RemoveAsIdentificationFieldParams
}

export type MutationRemoveAsUniqueFieldArgs = {
   params: RemoveAsUniqueFieldParams
}

export type MutationRemoveAttachmentsForRemarksArgs = {
   params: RemoveAttachmentsForRemarksParams
}

export type MutationRemoveAttachmentsForRemarksInTaskDraftArgs = {
   params: RemoveAttachmentsForRemarksInTaskDraftParams
}

export type MutationRemoveBoardAccessArgs = {
   params: RemoveBoardAccessParams
}

export type MutationRemoveCallLogsFromTaskDraftArgs = {
   params: RemoveCallLogsFromTaskDraftParams
}

export type MutationRemoveDashboardIdentificationsArgs = {
   params: RemoveDashboardIdentificationsParams
}

export type MutationRemoveFeeHeadersInEntityFeeRuleSetArgs = {
   params: RemoveFeeHeadersInEntityFeeRuleSetParams
}

export type MutationRemoveFieldConditionalOptionsArgs = {
   params: RemoveFieldConditionalOptionsParams
}

export type MutationRemoveFieldRolesArgs = {
   params: RemoveFieldRolesParams
}

export type MutationRemoveGraphQuickFilterFieldsArgs = {
   params: RemoveGraphQuickFilterFieldsParams
}

export type MutationRemoveManagerArgs = {
   params: RemoveManagerParams
}

export type MutationRemoveOptionsFromCheckboxGroupFieldArgs = {
   params: RemoveOptionsFromCheckboxGroupFieldParams
}

export type MutationRemoveOptionsFromDropdownFieldArgs = {
   params: RemoveOptionsFromDropdownFieldParams
}

export type MutationRemoveOptionsFromFieldsSelectorFieldArgs = {
   params: RemoveOptionsFromFieldsSelectorFieldParams
}

export type MutationRemoveOptionsFromMultiSelectGroupFieldArgs = {
   params: RemoveOptionsFromMultiSelectFieldParams
}

export type MutationRemoveOptionsFromRadioGroupFieldArgs = {
   params: RemoveOptionsFromRadioGroupFieldParams
}

export type MutationRemovePipelineIdentificationsArgs = {
   params: RemovePipelineIdentificationsParams
}

export type MutationRemovePipelineItemScheduleFromCalendarArgs = {
   params: RemovePipelineItemScheduleFromCalendarParams
}

export type MutationRemovePipelineItemTemplatesAdminPermissionForUserArgs = {
   params: RemovePipelineItemTemplatesAdminPermissionForUserParams
}

export type MutationRemovePipelinesAdminPermissionForUserArgs = {
   params: RemovePipelinesAdminPermissionForUserParams
}

export type MutationRemoveRelatedEntitiesArgs = {
   params: RemoveRelatedEntitiesParams
}

export type MutationRemoveScheduledPipelineItemsArgs = {
   params: RemoveScheduledPipelineItemsParams
}

export type MutationRemoveStageUpdatePermissionsArgs = {
   params: RemoveStageUpdatePermissionParams
}

export type MutationRemoveUserGroupsForBoardArgs = {
   params: RemoveUserGroupsForBoardParams
}

export type MutationRemoveUserGroupsForBoardListArgs = {
   params: RemoveUserGroupsForBoardListParams
}

export type MutationRemoveUserIdentificationsArgs = {
   params: RemoveUserIdentificationsParams
}

export type MutationRemoveUsersCallingConfigArgs = {
   params: RemoveUsersCallingConfigParams
}

export type MutationRemoveUsersFromIdentificationArgs = {
   params: RemoveUsersFromIdentificationParams
}

export type MutationRemoveWhatsAppBusinessPhoneNumberUsersArgs = {
   params: RemoveWhatsAppBusinessPhoneNumberUsersParams
}

export type MutationRemoveWhatsappBusinessPhoneNumberArgs = {
   params: RemoveWhatsAppBusinessPhoneNumberParams
}

export type MutationRenameAutomationWorkflowArgs = {
   params: RenameAutomationWorkflowParams
}

export type MutationRenameAutomationWorkflowFilterArgs = {
   params: RenameAutomationWorkflowFilterParams
}

export type MutationRenameBoardArgs = {
   params: RenameBoardParams
}

export type MutationRenameBoardListArgs = {
   params: RenameBoardListParams
}

export type MutationRenameEventTriggerFilterArgs = {
   params: RenameEventTriggerFilterParams
}

export type MutationRenameFilterArgs = {
   params: RenameFilterParams
}

export type MutationRenameIdentificationArgs = {
   params: RenameIdentificationParams
}

export type MutationRenameNodeArgs = {
   params: RenameNodeParams
}

export type MutationRenameStageArgs = {
   params: RenameStageParams
}

export type MutationRenameTriggerArgs = {
   params: RenameTriggerParams
}

export type MutationRenameViewArgs = {
   params: RenameViewParams
}

export type MutationReorderBoardListsArgs = {
   params: ReOrderBoardListsParams
}

export type MutationReorderBoardsArgs = {
   params: ReOrderBoardsParams
}

export type MutationReorderEntityCheckpointsArgs = {
   params: ReorderEntityCheckpointsParams
}

export type MutationReorderFieldArgs = {
   params: ReorderFieldParams
}

export type MutationReorderGraphQuickFilterFieldsArgs = {
   params: ReorderGraphQuickFilterFieldsParams
}

export type MutationReorderGraphsInDashboardArgs = {
   params: ReorderUserGraphInDashboardParams
}

export type MutationReorderMetricsArgs = {
   params: ReorderMetricsParams
}

export type MutationReorderPinnedPipelineItemsArgs = {
   params: ReorderPinnedPipelineItemsParams
}

export type MutationReorderScheduledPipelineItemsArgs = {
   params: ReorderScheduledPipelineItemsParams
}

export type MutationReorderTabsArgs = {
   params: ReorderTabsParams
}

export type MutationReorderUserGraphInViewArgs = {
   params: ReorderUserGraphInViewParams
}

export type MutationReorderViewsArgs = {
   params: ReorderViewsParams
}

export type MutationReschedulePipelineItemRemindersArgs = {
   params: ReschedulePipelineItemRemindersParams
}

export type MutationReschedulePipelineItemsArgs = {
   params: ReschedulePipelineItemsParams
}

export type MutationResendRequestToPipelineItemVerificationArgs = {
   params: ResendRequestToPipelineItemVerificationParams
}

export type MutationResetEntityCheckpointTextArgs = {
   params: ResetEntityCheckpointTextParams
}

export type MutationResetEntityFeeRuleSetArgs = {
   params: ResetEntityFeeRuleSetParams
}

export type MutationResetOfficerOtpRetryCountArgs = {
   params: ResetOfficerOtpRetryCountParams
}

export type MutationResetOtpRetryCountArgs = {
   params: ResetOtpRetryCountParams
}

export type MutationResetVerificationTaskArgs = {
   params: ResetVerificationTaskParams
}

export type MutationRestoreApplicationInPortalArgs = {
   params: RestoreApplicationInPortalParams
}

export type MutationRestoreFeeHeadersInEntityFeeRuleSetArgs = {
   params: RestoreFeeHeadersInEntityFeeRuleSetParams
}

export type MutationRestoreFieldsArgs = {
   params: RestoreFieldsParams
}

export type MutationRestoreGofsArgs = {
   params: RestoreGoFsParams
}

export type MutationRetryExportPipelineItemsArgs = {
   params: RetryExportPipelineItemsParams
}

export type MutationRetryFailedActionArgs = {
   params: RetryFailedActionParams
}

export type MutationSavePipelineItemFieldInTaskDraftArgs = {
   params: SavePipelineItemFieldInTaskDraftParams
}

export type MutationSavePipelineItemFieldInTaskDraftBulkArgs = {
   params: SavePipelineItemFieldInTaskDraftBulkParams
}

export type MutationSavePipelineItemRemarksInTaskDraftArgs = {
   params: SavePipelineItemRemarksInTaskDraftParams
}

export type MutationSaveSiteInspectionFieldObservationArgs = {
   params: SaveSiteInspectionFieldObservationParams
}

export type MutationSchedulePipelineItemArgs = {
   params: SchedulePipelineItemParams
}

export type MutationSchedulePipelineItemsArgs = {
   params: SchedulePipelineItemsParams
}

export type MutationScheduleSiteInspectionArgs = {
   params: ScheduleSiteInspectionParams
}

export type MutationSendBackFriendArgs = {
   params: SendBackFriendParams
}

export type MutationSendOtpArgs = {
   params: SendOtpParams
}

export type MutationSendOtpForDocumentEsignArgs = {
   params: SendOtpForDocumentESignParams
}

export type MutationSendOtpForTaskShortfallArgs = {
   params: SendOtpForTaskShortfallParams
}

export type MutationSendOtpForTdrAccountHoldArgs = {
   params: SendOtpForTdrAccountHoldParams
}

export type MutationSendOtpForTdrAccountReleaseArgs = {
   params: SendOtpForTdrAccountReleaseParams
}

export type MutationSendOtpForTransactionAcceptanceArgs = {
   params: SendOtpForTransactionAcceptanceParams
}

export type MutationSendOtpForUpdatingUserPinArgs = {
   params: SendOtpForUpdatingUserPinParams
}

export type MutationSendOtpToPipelineItemPhoneNumberFieldArgs = {
   params: SendOtpToPipelineItemPhoneNumberFieldParams
}

export type MutationSendOtpToPipelineItemPhoneNumberFieldInPortalArgs = {
   params: SendOtpToPipelineItemPhoneNumberFieldInPortalParams
}

export type MutationSendPipelineItemWhatsappMessageArgs = {
   params: SendPipelineItemWhatsAppMessageParams
}

export type MutationSendPipelineItemWhatsappMessageBulkArgs = {
   params: SendPipelineItemWhatsAppMessageBulkParams
}

export type MutationSendQueryResponseInThreadArgs = {
   params: SendQueryResponseInThreadParams
}

export type MutationSendQueryStreamedDataInThreadArgs = {
   params: SendQueryStreamedDataInThreadParams
}

export type MutationSendRequestToPipelineItemVerificationArgs = {
   params: SendRequestToPipelineItemVerificationParams
}

export type MutationSendWhatsappMessageToOfficerArgs = {
   params: SendWhatsAppMessageToOfficerParams
}

export type MutationSetAccountFeatureIdentificationsArgs = {
   params: SetAccountFeatureIdentificationsParams
}

export type MutationSetAgentAllocationGroupsInAllocationGroupSetArgs = {
   params: SetAgentAllocationGroupsInAllocationGroupSetParams
}

export type MutationSetAgentsInAllocationGroupSetArgs = {
   params: SetAgentsInAllocationGroupSetParams
}

export type MutationSetApplicationDisplayStageAllowedGofsArgs = {
   params: SetApplicationDisplayStageAllowedGoFsParams
}

export type MutationSetApplicationDisplayStageRequiredFieldsArgs = {
   params: SetApplicationDisplayStageRequiredFieldsParams
}

export type MutationSetApplicationDisplayStageWritableFieldsArgs = {
   params: SetApplicationDisplayStageWritableFieldsParams
}

export type MutationSetApplicationDocumentTemplatesInPortalArgs = {
   params: SetApplicationDocumentTemplatesInPortalParams
}

export type MutationSetApplicationIdGenerationConfigAtDisplayStageArgs = {
   params: SetApplicationIdGenerationConfigAtDisplayStageParams
}

export type MutationSetApplicationOverviewFieldsInPortalArgs = {
   params: SetApplicationOverviewFieldsInPortalParams
}

export type MutationSetApplicationSubStatusFieldsArgs = {
   params: SetApplicationSubStatusFieldsParams
}

export type MutationSetBpsTemplateConfigArgs = {
   params: SetBpsTemplateConfigParams
}

export type MutationSetDefaultStageValuesToPipelineArgs = {
   params: SetDefaultStageValuesToPipelineParams
}

export type MutationSetFieldConditionOptionsParentFieldArgs = {
   params: SetFieldConditionOptionsParentFieldParams
}

export type MutationSetFieldReadRolesArgs = {
   params: SetFieldReadRolesParams
}

export type MutationSetFieldWriteRolesArgs = {
   params: SetFieldWriteRolesParams
}

export type MutationSetFieldsOrderArgs = {
   params: SetFieldsOrderParams
}

export type MutationSetFieldsSelectorFieldOptionDependentFieldsOrderArgs = {
   params: SetFieldsSelectorFieldOptionDependentFieldsOrderParams
}

export type MutationSetGofsOrderArgs = {
   params: SetGoFsOrderParams
}

export type MutationSetGraphRolesArgs = {
   params: SetGraphRolesParams
}

export type MutationSetIdentificationsForPipelineActionArgs = {
   params: SetIdentificationsForPipelineActionParams
}

export type MutationSetIdentificationsToTriggerAutomationWorkflowsOnActivityArgs = {
   params: SetIdentificationsToTriggerAutomationWorkflowsOnActivityParams
}

export type MutationSetLeadBucketsOrderArgs = {
   params: SetLeadBucketsOrderParams
}

export type MutationSetLeadCreationAllowedStagesArgs = {
   params: SetLeadCreationAllowedStagesParams
}

export type MutationSetLeadDistributionRuleAssigneeFieldsToNotifyArgs = {
   params: SetLeadDistributionRuleAssigneeFieldsToNotifyParams
}

export type MutationSetLeadDistributionRuleManagerFieldsArgs = {
   params: SetLeadDistributionRuleManagerFieldsParams
}

export type MutationSetLeadInitiationRolesOnActivityArgs = {
   params: LeadInitiationRolesOnActivityParams
}

export type MutationSetManagerArgs = {
   params: SetManagerParams
}

export type MutationSetManagerForAgentsArgs = {
   params: SetManagerForAgentsParams
}

export type MutationSetMessageTemplateVariablesMapArgs = {
   params: SetWhatsAppMessageTemplateVariableMapParams
}

export type MutationSetOrderForAllocationGroupSetsArgs = {
   params: SetOrderForAllocationGroupSetsParams
}

export type MutationSetParameterConditionsOrderArgs = {
   params: SetParameterConditionsOrderParams
}

export type MutationSetPermitOrderIdGenerationConfigAtStageArgs = {
   params: SetPermitOrderIdGenerationConfigAtStageParams
}

export type MutationSetPipelineAdminsArgs = {
   params: SetPipelineAdminsParams
}

export type MutationSetPipelineFeatureIdentificationsArgs = {
   params: SetPipelineFeatureIdentificationsParams
}

export type MutationSetPipelineIdentificationsArgs = {
   params: SetPipelineIdentificationsParams
}

export type MutationSetPipelineItemFieldsToLogArgs = {
   params: SetPipelineItemFieldsToLogParams
}

export type MutationSetPipelineItemTemplateAdminsArgs = {
   params: SetPipelineItemTemplateAdminsParams
}

export type MutationSetPipelineItemTemplateFieldsToLogArgs = {
   params: SetPipelineItemTemplateFieldsToLogParams
}

export type MutationSetPipelineItemTemplateShortfallConfigArgs = {
   params: SetPipelineItemTemplateShortfallFieldsConfigParams
}

export type MutationSetPipelinePersonalWhatsappMessageIdentificationsArgs = {
   params: SetPipelinePersonalWhatsAppMessageIdentificationsParams
}

export type MutationSetPipelineWhatsappBusinessPhoneNumberUsersArgs = {
   params: SetPipelineWhatsAppBusinessPhoneNumberUsersParams
}

export type MutationSetPipelinesToActivityTemplateArgs = {
   params: SetPipelinesToActivityTemplateParams
}

export type MutationSetPortalApplicationAdditionalVisibleTabsArgs = {
   params: SetPortalApplicationAdditionalVisibleTabsParams
}

export type MutationSetPortalApplicationDrawingPdfVisibleStagesArgs = {
   params: SetPortalApplicationDrawingPdfVisibleStagesParams
}

export type MutationSetPortalApplicationProposalFlowVisibleStagesArgs = {
   params: SetPortalApplicationProposalFlowVisibleStagesParams
}

export type MutationSetPortalApplicationScrutinyProcessVisibleStagesArgs = {
   params: SetPortalApplicationScrutinyProcessVisibleStagesParams
}

export type MutationSetPortalApplicationTabGofsOrderArgs = {
   params: SetPortalApplicationTabGoFsOrderParams
}

export type MutationSetPortalApplicationTabsOrderArgs = {
   params: SetPortalApplicationTabsOrderParams
}

export type MutationSetPortalApplicationTdrVisibleStagesArgs = {
   params: SetPortalApplicationTdrVisibleStagesParams
}

export type MutationSetPortalApplicationsOrderArgs = {
   params: SetPortalApplicationsOrderParams
}

export type MutationSetPortalPipelineItemTemplateSurveyNumberFieldConfigArgs = {
   params: SetPortalPipelineItemTemplateSurveyNumberFieldConfigParams
}

export type MutationSetPortalVisibleUserTypesForFieldLogsArgs = {
   params: SetPortalVisibleUserTypesParams
}

export type MutationSetRecordCreationConfigAutoAssignCreatorToFieldsArgs = {
   params: SetRecordCreationConfigAutoAssignCreatorToFieldsParams
}

export type MutationSetRecordCreationConfigCreationAllowedStagesArgs = {
   params: SetRecordCreationConfigCreationAllowedStagesParams
}

export type MutationSetRecordCreationConfigFieldsArgs = {
   params: SetRecordCreationConfigFieldsParams
}

export type MutationSetRecordCreationConfigPermissionsArgs = {
   params: SetRecordCreationConfigPermissionsParams
}

export type MutationSetRecordCreationConfigSyncAssigneeGroupsArgs = {
   params: SetRecordCreationConfigSyncAssigneeGroupsParams
}

export type MutationSetRecordMergePermissionsArgs = {
   params: SetRecordMergePermissionsParams
}

export type MutationSetRelatedSalesTemplateOverviewFieldsArgs = {
   params: SetRelatedSalesTemplateOverviewFieldsParams
}

export type MutationSetRelationAddPermissionIdentificationsArgs = {
   params: SetRelationEntityAddPermissionIdentificationsParams
}

export type MutationSetRelationIdentificationsArgs = {
   params: SetRelationIdentificationsParams
}

export type MutationSetRelationRemovePermissionIdentificationsArgs = {
   params: SetRelationEntityRemovePermissionIdentificationsParams
}

export type MutationSetResourceRolesArgs = {
   params: SetResourceRolesParams
}

export type MutationSetResourcesOrderArgs = {
   params: SetResourcesOrderParams
}

export type MutationSetSalesTemplateRecordCreationPermissionsArgs = {
   params: SetSalesTemplateRecordCreationPermissionsParams
}

export type MutationSetScoringRecalculationSortByFieldsArgs = {
   params: SetScoringRecalculationSortByFieldsParams
}

export type MutationSetSiteInspectionFieldObservationBulkArgs = {
   params: SetSiteInspectionFieldObservationBulkParams
}

export type MutationSetSiteInspectionFieldObservationByExcludeFieldsArgs = {
   params: SetSiteInspectionFieldObservationByExcludeFieldsParams
}

export type MutationSetStageAssigneeFieldsToLogArgs = {
   params: SetStageAssigneeFieldsToLogParams
}

export type MutationSetStageBoardRolesArgs = {
   params: SetStageBoardRolesParams
}

export type MutationSetStageCreateAddAnotherGofPermissionsArgs = {
   params: SetStageCreateAddAnotherGofPermissionsParams
}

export type MutationSetStageDeletionStatusArgs = {
   params: SetStageDeletionStatusParams
}

export type MutationSetStageNoteSheetPermissionsArgs = {
   params: SetStageNoteSheetPermissionsParams
}

export type MutationSetStageQuickEditFieldsArgs = {
   params: SetStageQuickEditFieldsParams
}

export type MutationSetStageRecommendedFeeRuleSetIdentificationsArgs = {
   params: SetStageRecommendedFeeRuleSetIdentificationsParams
}

export type MutationSetStageRecommendedTaskIdentificationsArgs = {
   params: SetStageRecommendedTaskIdentificationsParams
}

export type MutationSetStageRecommendedTaskTemplatesArgs = {
   params: SetStageRecommendedTaskTemplatesParams
}

export type MutationSetStageRemoveAddAnotherGofPermissionsArgs = {
   params: SetStageRemoveAddAnotherGofPermissionsParams
}

export type MutationSetStageTransitionPermissionsArgs = {
   params: SetStageTransitionPermissionParams
}

export type MutationSetStagesOrderArgs = {
   params: SetStagesOrderParams
}

export type MutationSetTaskTemplateIdentificationsArgs = {
   params: SetTaskTemplateIdentificationsParams
}

export type MutationSetTaskTemplateQuickEditFieldsArgs = {
   params: SetTaskTemplateQuickEditFieldsParams
}

export type MutationSetTaskTemplatesOrderArgs = {
   params: SetTaskTemplatesOrderParams
}

export type MutationSetUserCallingConfigArgs = {
   params: UserCallingConfigParams
}

export type MutationSetUserPinArgs = {
   params: SetUserPinParams
}

export type MutationSetWhatsappBusinessPhoneNumberUsersArgs = {
   params: SetWhatsAppBusinessPhoneNumberUsersParams
}

export type MutationSetWhatsappMessageTemplateIdentificationsArgs = {
   params: SetWhatsAppMessageTemplateIdentificationsParams
}

export type MutationShareBoardArgs = {
   params: ShareBoardParams
}

export type MutationSignDocumentArgs = {
   params: SignDocumentParams
}

export type MutationSignDocumentForDigitalSignArgs = {
   params: SignDocumentForDigitalSignParams
}

export type MutationSignPipelineItemDocumentArgs = {
   params: SignPipelineItemDocumentParams
}

export type MutationSubmitAnalyticsQueryResponseFeedbackArgs = {
   params: SubmitAnalyticsQueryResponseFeedbackParams
}

export type MutationSubmitBpsVerificationTaskArgs = {
   params: SubmitBpsVerificationTaskParams
}

export type MutationSubmitFeedbackInPortalArgs = {
   params: SubmitFeedbackInPortalParams
}

export type MutationSubmitLineDepartmentRecommendationArgs = {
   params: SubmitLineDepartmentRecommendationParams
}

export type MutationSubmitSiteInspectionArgs = {
   params: SubmitSiteInspectionParams
}

export type MutationSubmitTaskArgs = {
   params: SubmitTaskParams
}

export type MutationSubmitTdrOrderForVerificationArgs = {
   params: SubmitTdrOrderForVerificationParams
}

export type MutationSyncPluginServiceAccountWhatsappMessageTemplatesArgs = {
   params: SyncPluginServiceAccountWhatsappMessageTemplatesParams
}

export type MutationTriggerAutomationWorkflowsOnActivityArgs = {
   params: TriggerAutomationWorkflowsOnActivityParams
}

export type MutationTriggerScheduleWorkflowArgs = {
   params: TriggerScheduleWorkflowParams
}

export type MutationUnlinkGraphsToViewArgs = {
   params: UnLinkGraphsToViewParams
}

export type MutationUnlinkWhatsappBusinessPhoneNumberFromPipelineArgs = {
   params: UnLinkWhatsAppBusinessPhoneNumberFromPipelineParams
}

export type MutationUnlinkWhatsappMessageTemplateFromPipelineArgs = {
   params: UnLinkWhatsAppMessageTemplateFromPipelineParams
}

export type MutationUnpinPipelineItemsArgs = {
   params: UnPinPipelineItemsParams
}

export type MutationUnschedulePipelineItemsArgs = {
   params: UnschedulePipelineItemsParams
}

export type MutationUpdateActivitiesFeatureEnableStatusArgs = {
   params: UpdateActivitiesFeatureEnableStatusParams
}

export type MutationUpdateActivityPipelineItemCreationConfigArgs = {
   params: UpdateActivityPipelineItemCreationConfigParams
}

export type MutationUpdateActivityTemplateDescriptionArgs = {
   params: UpdateActivityTemplateDescriptionParams
}

export type MutationUpdateActivityTemplateNameArgs = {
   params: UpdateActivityTemplateNameParams
}

export type MutationUpdateActivityTemplatePipelineStagesArgs = {
   params: UpdateActivityTemplatePipelineStagesParams
}

export type MutationUpdateActivityTemplateReferenceIdArgs = {
   params: UpdateActivityTemplateReferenceIdParams
}

export type MutationUpdateAddAnotherGofResponsesLimitArgs = {
   params: UpdateAddAnotherGofResponsesLimitInputParams
}

export type MutationUpdateAgentAllocationGroupNameArgs = {
   params: UpdateAgentAllocationGroupNameParams
}

export type MutationUpdateAgentGlobalQuotaArgs = {
   params: UpdateAgentGlobalQuotaParams
}

export type MutationUpdateAllocationGroupSetQuotaArgs = {
   params: UpdateAllocationGroupSetQuotaParams
}

export type MutationUpdateAllocationGroupSetTypeArgs = {
   params: UpdateAllocationGroupSetTypeParams
}

export type MutationUpdateAllowManualTriggerArgs = {
   params: UpdateAllowManualTriggerParams
}

export type MutationUpdateAppealTaskObservationArgs = {
   params: UpdateAppealTaskObservationParams
}

export type MutationUpdateApplicationAddAnotherBulkSurveyNumberFieldArgs = {
   params: UpdateApplicationBulkSurveyNumberFieldParams
}

export type MutationUpdateApplicationAddAnotherBulkSurveyNumberFieldInPortalArgs = {
   params: UpdateApplicationBulkSurveyNumberFieldInPortalParams
}

export type MutationUpdateApplicationAddAnotherFieldArgs = {
   params: UpdateApplicationAddAnotherFieldParams
}

export type MutationUpdateApplicationAddAnotherFieldBulkArgs = {
   params: UpdateApplicationAddAnotherFieldBulkParams
}

export type MutationUpdateApplicationAddAnotherFieldInPortalArgs = {
   params: UpdateApplicationAddAnotherFieldInPortalParams
}

export type MutationUpdateApplicationAddAnotherSurveyNumberFieldArgs = {
   params: UpdateApplicationAddAnotherSurveyNumberFieldParams
}

export type MutationUpdateApplicationAddAnotherSurveyNumberFieldInPortalArgs = {
   params: UpdateApplicationAddAnotherSurveyNumberFieldInPortalParams
}

export type MutationUpdateApplicationAssigneeBulkArgs = {
   params: UpdateApplicationAssigneeBulkParams
}

export type MutationUpdateApplicationAvailTdrCreditsInPortalArgs = {
   params: UpdateApplicationAvailTdrCreditsInPortalParams
}

export type MutationUpdateApplicationFieldArgs = {
   params: UpdateApplicationParams
}

export type MutationUpdateApplicationFieldAsShortfallArgs = {
   params: UpdateApplicationFieldAsShortfallParams
}

export type MutationUpdateApplicationFieldInPortalArgs = {
   params: UpdateApplicationFieldInPortalParams
}

export type MutationUpdateApplicationSurveyNumberFieldArgs = {
   params: UpdateApplicationSurveyNumberFieldParams
}

export type MutationUpdateApplicationSurveyNumberFieldInPortalArgs = {
   params: UpdateApplicationSurveyNumberFieldInPortalParams
}

export type MutationUpdateApplicationTabArgs = {
   params: UpdateApplicationTabParams
}

export type MutationUpdateApplicationTabGofFieldIdsArgs = {
   params: UpdateApplicationTabGofFieldIdsParams
}

export type MutationUpdateApplicationTabNameArgs = {
   params: UpdateApplicationTabNameParams
}

export type MutationUpdateApplicationTdrSalesAndTransferFieldInPortalArgs = {
   params: UpdateApplicationTdrSalesAndTransferFieldInPortalParams
}

export type MutationUpdateApplicationTemplateArgs = {
   params: UpdateApplicationTemplateParams
}

export type MutationUpdateArchitectProfileArgs = {
   params: UpdateArchitectProfileParams
}

export type MutationUpdateAssigneeGroupArgs = {
   params: UpdateAssigneeGroupParams
}

export type MutationUpdateAttendanceTrackingSettingsArgs = {
   params: UpdateAttendanceTrackingSettingsParams
}

export type MutationUpdateAutomationWorkflowConditionArgs = {
   params: UpdateAutomationWorkflowConditionParams
}

export type MutationUpdateAutomationWorkflowConditionsLogicalOperatorArgs = {
   params: UpdateAutomationWorkflowConditionsLogicalOperatorParams
}

export type MutationUpdateAutomationWorkflowExecLogsFilterArgs = {
   params: UpdateAutomationWorkflowExecLogsFilterParams
}

export type MutationUpdateAutomationWorkflowExecLogsSortValueArgs = {
   params: UpdateAutomationWorkflowExecLogsSortValueParams
}

export type MutationUpdateAutomationWorkflowExecTypeArgs = {
   params: UpdateAutomationWorkflowExecTypeParams
}

export type MutationUpdateAutomationWorkflowFiltersLogicalOperatorArgs = {
   params: UpdateAutomationWorkflowFiltersLogicalOperatorParams
}

export type MutationUpdateAutomationWorkflowStatusArgs = {
   params: UpdateAutomationWorkflowStatusParams
}

export type MutationUpdateAutomationWorkflowTriggerConfigArgs = {
   params: UpdateAutomationWorkflowTriggerConfigParams
}

export type MutationUpdateBarGraphArgs = {
   params: UpdateBarGraphParams
}

export type MutationUpdateBoardDescriptionArgs = {
   params: UpdateBoardDescriptionParams
}

export type MutationUpdateBoardDisplayNameArgs = {
   params: UpdateBoardDisplayNameParams
}

export type MutationUpdateBpsTaskFieldObservationArgs = {
   params: UpdateBpsTaskFieldObservationParams
}

export type MutationUpdateBpsTaskFieldObservationBulkArgs = {
   params: UpdateBpsTaskFieldObservationBulkParams
}

export type MutationUpdateBpsVerificationTabTaskArgs = {
   params: UpdateBpsVerificationTabTaskParams
}

export type MutationUpdateBpsVerificationTaskArgs = {
   params: UpdateBpsVerificationTaskParams
}

export type MutationUpdateCalendarPipelineItemScheduleArgs = {
   params: UpdateCalendarPipelineItemScheduleParams
}

export type MutationUpdateCanGenerateCustomIdConfigArgs = {
   params: UpdateCanGenerateCustomIdConfigParams
}

export type MutationUpdateCheckboxGroupFieldDefaultValuesArgs = {
   params: UpdateCheckboxGroupFieldDefaultValuesParams
}

export type MutationUpdateConditionArgs = {
   params: UpdateConditionParams
}

export type MutationUpdateConditionNodeFiltersLogicalOperatorArgs = {
   params: UpdateConditionNodeFiltersLogicalOperatorParams
}

export type MutationUpdateConditionsLogicalOperatorArgs = {
   params: UpdateConditionsLogicalOperatorParams
}

export type MutationUpdateContactFieldArgs = {
   params: UpdateContactFieldParams
}

export type MutationUpdateContactsBoardConfigArgs = {
   params: UpdateContactsBoardConfigParams
}

export type MutationUpdateContactsFeatureEnableStatusArgs = {
   params: UpdateContactsFeatureEnableStatusParams
}

export type MutationUpdateCustomDocumentTemplateArgs = {
   params: UpdateCustomDocumentTemplateParams
}

export type MutationUpdateCustomObjectTemplateArgs = {
   params: UpdateCustomObjectTemplateParams
}

export type MutationUpdateDashboardArgs = {
   params: UpdateDashboardParams
}

export type MutationUpdateDateFieldDefaultValueArgs = {
   params: UpdateDateFieldDefaultValueParams
}

export type MutationUpdateDateFieldRelativeDefaultValueConfigArgs = {
   params: UpdateDateFieldRelativeDefaultValueConfigParams
}

export type MutationUpdateDateTimeFieldDefaultValueArgs = {
   params: UpdateDateTimeFieldDefaultValueParams
}

export type MutationUpdateDateTimeFieldRelativeDefaultValueConfigArgs = {
   params: UpdateDateTimeFieldRelativeDefaultValueConfigParams
}

export type MutationUpdateDealAddAnotherFieldArgs = {
   params: UpdateDealAddAnotherFieldParams
}

export type MutationUpdateDealAssigneeBulkArgs = {
   params: UpdateDealAssigneeBulkParams
}

export type MutationUpdateDealFieldArgs = {
   params: UpdateDealFieldParams
}

export type MutationUpdateDisplayStageTransitionConfigArgs = {
   params: UpdateDisplayStageTransitionConfigParams
}

export type MutationUpdateDocumentTemplateDescriptionArgs = {
   params: UpdateDocumentTemplateDescriptionParams
}

export type MutationUpdateDocumentTemplateNameArgs = {
   params: UpdateDocumentTemplateNameParams
}

export type MutationUpdateDocumentTemplateVersionConfigArgs = {
   params: UpdateDocumentTemplateVersionConfigParams
}

export type MutationUpdateDonutChartArgs = {
   params: UpdateDonutChartParams
}

export type MutationUpdateDropdownAllowOtherOptionsArgs = {
   params: UpdateDropdownAllowOtherOptionsParams
}

export type MutationUpdateDropdownFieldDefaultValueArgs = {
   params: UpdateDropdownFieldDefaultValueParams
}

export type MutationUpdateDropdownFieldUiStyleArgs = {
   params: UpdateDropdownFieldUiStyleParams
}

export type MutationUpdateDropdownLabelsStatusArgs = {
   params: UpdateDropdownLabelsStatusParams
}

export type MutationUpdateDropdownOptionsColorArgs = {
   params: UpdateDropdownOptionsColorParams
}

export type MutationUpdateEmailFieldDefaultValueArgs = {
   params: UpdateEmailFieldDefaultValueParams
}

export type MutationUpdateEmailFieldValidationRegexArgs = {
   params: UpdateEmailFieldValidationRegexParams
}

export type MutationUpdateEntityCheckpointArgs = {
   params: UpdateEntityCheckpointParams
}

export type MutationUpdateEntityCheckpointBulkArgs = {
   params: UpdateEntityCheckpointBulkParams
}

export type MutationUpdateEntityCheckpointsStatusArgs = {
   params: UpdateEntityCheckpointsStatusParams
}

export type MutationUpdateEntityJsonConfigurationArgs = {
   params: UpdateEntityJsonConfigurationParams
}

export type MutationUpdateEventBasedLeadDistributionRuleSettingsArgs = {
   params: UpdateEventBasedLeadDistributionRuleSettingsParams
}

export type MutationUpdateEventBasedLeadDistributionRuleStatusArgs = {
   params: UpdateEventBasedLeadDistributionRuleStatusParams
}

export type MutationUpdateEventTriggerConditionArgs = {
   params: UpdateEventTriggerConditionParams
}

export type MutationUpdateEventTriggerConditionsLogicalOperatorArgs = {
   params: UpdateEventTriggerConditionsLogicalOperatorParams
}

export type MutationUpdateEventTriggerFiltersLogicalOperatorArgs = {
   params: UpdateEventTriggerFiltersLogicalOperatorParams
}

export type MutationUpdateFeeHeaderAmountGivenByEditorArgs = {
   params: UpdateFeeHeaderAmountGivenByEditorParams
}

export type MutationUpdateFeeHeaderRemarksArgs = {
   params: UpdateFeeHeaderRemarksParams
}

export type MutationUpdateFieldDescriptionArgs = {
   params: UpdateFieldDescriptionParams
}

export type MutationUpdateFieldDynamicLabelArgs = {
   params: UpdateFieldDynamicLabelParams
}

export type MutationUpdateFieldGofArgs = {
   params: UpdateFieldGoFParams
}

export type MutationUpdateFieldHelpTextArgs = {
   params: UpdateFieldHelpTextParams
}

export type MutationUpdateFieldHelpTextTypeArgs = {
   params: UpdateFieldHelpTextTypeParams
}

export type MutationUpdateFieldIconArgs = {
   params: UpdateFieldIconParams
}

export type MutationUpdateFieldNameArgs = {
   params: UpdateFieldNameParams
}

export type MutationUpdateFieldOptionsValueTypeArgs = {
   params: UpdateFieldOptionsValueTypeParams
}

export type MutationUpdateFieldPlaceholderTextArgs = {
   params: UpdateFieldPlaceholderTextParams
}

export type MutationUpdateFieldReferenceIdArgs = {
   params: UpdateFieldReferenceIdParams
}

export type MutationUpdateFieldRequiredStatusArgs = {
   params: UpdateFieldRequiredStatusParams
}

export type MutationUpdateFieldTooltipArgs = {
   params: UpdateFieldTooltipParams
}

export type MutationUpdateFieldsSelectorFieldDefaultValueArgs = {
   params: UpdateFieldsSelectorFieldDefaultValueParams
}

export type MutationUpdateFieldsSelectorFieldUiStyleArgs = {
   params: UpdateFieldsSelectorFieldUiStyleParams
}

export type MutationUpdateFileUploaderFieldConfigArgs = {
   params: UpdateFileUploaderFieldConfigParams
}

export type MutationUpdateFileUploaderFieldDefaultValueArgs = {
   params: UpdateFileUploaderFieldDefaultValueParams
}

export type MutationUpdateFiltersLogicalOperatorArgs = {
   params: UpdateFiltersLogicalOperatorParams
}

export type MutationUpdateFloatFieldDecimalPrecisionLimitArgs = {
   params: UpdateFloatFieldDecimalPrecisionLimitParams
}

export type MutationUpdateFloatFieldDefaultValueArgs = {
   params: UpdateFloatFieldDefaultValueParams
}

export type MutationUpdateFloatFieldFormulaStatusArgs = {
   params: UpdateFloatFieldFormulaStatusParams
}

export type MutationUpdateFloatFieldRangeArgs = {
   params: UpdateFloatFieldRangeParams
}

export type MutationUpdateFormIdentificationFieldArgs = {
   params: UpdateFormIdentificationFieldParams
}

export type MutationUpdateFormLayoutArgs = {
   params: UpdateFormLayoutParams
}

export type MutationUpdateFormSubmissionConfigArgs = {
   params: UpdateFromSubmissionConfigParams
}

export type MutationUpdateFormTemplateDescriptionArgs = {
   params: UpdateFormTemplateDescriptionParams
}

export type MutationUpdateFormTemplateNameArgs = {
   params: UpdateFormTemplateNameParams
}

export type MutationUpdateFunnelGraphArgs = {
   params: UpdateFunnelParams
}

export type MutationUpdateGallaboxAccountArgs = {
   params: UpdateGallaboxAccountParams
}

export type MutationUpdateGeoFieldAddressFieldsArgs = {
   params: UpdateGeoFieldAddressFieldsParams
}

export type MutationUpdateGofDescriptionArgs = {
   params: UpdateGoFDescriptionParams
}

export type MutationUpdateGofNameArgs = {
   params: UpdateGofNameInputParams
}

export type MutationUpdateGraphArgs = {
   params: UpdateGraphParams
}

export type MutationUpdateGraphDataSourcesArgs = {
   params: UpdateGraphDataSourcesParams
}

export type MutationUpdateGraphDimensionArgs = {
   params: UpdateGraphDimensionParams
}

export type MutationUpdateGraphMetricArgs = {
   params: UpdateGraphMetricParams
}

export type MutationUpdateGraphWidthPercentageArgs = {
   params: UpdateGraphWidthPercentageParams
}

export type MutationUpdateGupShupAccountArgs = {
   params: UpdateGupShupAccountParams
}

export type MutationUpdateIntegerFieldDefaultValueArgs = {
   params: UpdateIntegerFieldDefaultValueParams
}

export type MutationUpdateIntegerFieldFormulaStatusArgs = {
   params: UpdateIntegerFieldFormulaStatusParams
}

export type MutationUpdateIntegerFieldRangeArgs = {
   params: UpdateIntegerFieldRangeParams
}

export type MutationUpdateKnowlarityAccountArgs = {
   params: UpdateKnowlarityAccountDetailsParams
}

export type MutationUpdateLayoutArgs = {
   params: UpdateLayoutParams
}

export type MutationUpdateLdRuleTriggerConfigArgs = {
   params: UpdateLdRuleTriggerConfigParams
}

export type MutationUpdateLeadAddAnotherFieldArgs = {
   params: UpdateLeadAddAnotherFieldParams
}

export type MutationUpdateLeadAssigneeBulkArgs = {
   params: UpdateLeadAssigneeBulkParams
}

export type MutationUpdateLeadBucketNameArgs = {
   params: UpdateLeadBucketNameParams
}

export type MutationUpdateLeadBucketSortFieldsArgs = {
   params: UpdateLeadBucketSortFieldsParams
}

export type MutationUpdateLeadDistributionPoolAssigneeFieldConditionEnumArgs = {
   params: UpdateLeadDistributionPoolAssigneeFieldConditionEnumParams
}

export type MutationUpdateLeadDistributionRuleAssigneeFieldArgs = {
   params: UpdateLeadDistributionRuleAssigneeFieldParams
}

export type MutationUpdateLeadDistributionRuleEditModeArgs = {
   params: UpdateLeadDistributionRuleEditModeParams
}

export type MutationUpdateLeadDistributionRuleNameArgs = {
   params: UpdateLeadDistributionRuleNameParams
}

export type MutationUpdateLeadDistributionSetupCurrentStepArgs = {
   params: UpdateLeadDistributionSetupCurrentStepParams
}

export type MutationUpdateLeadFieldArgs = {
   params: UpdateLeadFieldParams
}

export type MutationUpdateLeadPoolSortFieldsArgs = {
   params: UpdateLeadPoolSortFieldsParams
}

export type MutationUpdateLineGraphArgs = {
   params: UpdateLineGraphParams
}

export type MutationUpdateLongFieldValidationRegexArgs = {
   params: UpdateLongTextFieldValidationRegexParams
}

export type MutationUpdateLongTextFieldDefaultValueArgs = {
   params: UpdateLongTextFieldDefaultValueParams
}

export type MutationUpdateLongTextFieldFormulaExpressionArgs = {
   params: UpdateLongTextFieldFormulaStatusParams
}

export type MutationUpdateLtpUserDetailsArgs = {
   params: UpdateLtpUserDetailsParams
}

export type MutationUpdateManualLeadDistributionRuleSettingsArgs = {
   params: UpdateManualLeadDistributionRuleSettingsParams
}

export type MutationUpdateMobileCardOverviewFieldsInStageArgs = {
   params: UpdateCardMobileOverviewFieldsParams
}

export type MutationUpdateMultiSelectGroupFieldDefaultValueArgs = {
   params: UpdateMultiSelectFieldDefaultValuesParams
}

export type MutationUpdateMultiselectAllowOtherOptionsArgs = {
   params: UpdateMultiSelectAllowOtherOptionsParams
}

export type MutationUpdateMultiselectFieldUiStyleArgs = {
   params: UpdateMultiSelectFieldUiStyleParams
}

export type MutationUpdateMultiselectLabelsStatusArgs = {
   params: UpdateMultiselectLabelsStatusParams
}

export type MutationUpdateMultiselectOptionsColorArgs = {
   params: UpdateMultiselectOptionsColorParams
}

export type MutationUpdateNodeAddAnotherGofArgs = {
   params: UpdateNodeAddAnotherGoFParams
}

export type MutationUpdateNodeCallWebhookArgs = {
   params: UpdateNodeCallWebhookParams
}

export type MutationUpdateNodeClearUndoneLeadTasksArgs = {
   params: UpdateNodeClearUndoneLeadTasksParams
}

export type MutationUpdateNodeCreatePipelineEventArgs = {
   params: UpdateNodeCreatePipelineEventParams
}

export type MutationUpdateNodeCreateRelatedRecordArgs = {
   params: UpdateNodeCreateRelatedRecordParams
}

export type MutationUpdateNodeCreateTaskArgs = {
   params: UpdateNodeCreateTaskParams
}

export type MutationUpdateNodeExecuteFunctionArgs = {
   params: UpdateNodeExecuteFunctionParams
}

export type MutationUpdateNodeGenerateDocumentArgs = {
   params: UpdateNodeGenerateDocumentNodeParams
}

export type MutationUpdateNodeGenerateNumberArgs = {
   params: UpdateNodeGenerateNumberParams
}

export type MutationUpdateNodeInitiateRefundArgs = {
   params: UpdateNodeInitiateRefundParams
}

export type MutationUpdateNodeRemoveAssigneesArgs = {
   params: UpdateNodeRemoveAssigneesParams
}

export type MutationUpdateNodeRemoveFromPipelineArgs = {
   params: UpdateNodeRemoveFromPipelineParams
}

export type MutationUpdateNodeRequestPaymentArgs = {
   params: UpdateNodeRequestPaymentParams
}

export type MutationUpdateNodeRequestPaymentWithFeeRulesArgs = {
   params: UpdateNodeRequestPaymentWithFeeRulesParams
}

export type MutationUpdateNodeSendDataToSegmentArgs = {
   params: UpdateNodeSendDataToSegmentParams
}

export type MutationUpdateNodeSendPipelineItemNotificationArgs = {
   params: UpdateNodeSendPipelineItemNotificationParams
}

export type MutationUpdateNodeSendWhatsappMessageNodeArgs = {
   params: UpdateNodeSendWhatsAppMessageNodeParams
}

export type MutationUpdateNodeSignDocumentArgs = {
   params: UpdateNodeSignDocumentNodeParams
}

export type MutationUpdateNodeSwiftsellOutboundWebhookNodeArgs = {
   params: UpdateNodeSwiftsellOutboundWebhookParams
}

export type MutationUpdateNodeUpdateDisplayStageArgs = {
   params: UpdateNodeUpdateDisplayStageParams
}

export type MutationUpdateNodeUpdateLeadArgs = {
   params: UpdateNodeUpdateLeadParams
}

export type MutationUpdateNodeUpdateLeadStageArgs = {
   params: UpdateNodeUpdateLeadStageParams
}

export type MutationUpdateNodeUpdatePipelineItemAssigneeArgs = {
   params: UpdateNodeUpdatePipelineItemAssigneeParams
}

export type MutationUpdateNodeUpdateRelatedRecordsArgs = {
   params: UpdateNodeUpdateRelatedRecordsParams
}

export type MutationUpdateNodeUpdateTaskArgs = {
   params: UpdateNodeUpdateTaskParams
}

export type MutationUpdateObjectionApplicationObservationArgs = {
   params: UpdateObjectionApplicationObservationParams
}

export type MutationUpdateOptionsVisibilityRulesStatusForFieldArgs = {
   params: UpdateOptionsVisibilityRulesStatusForFieldParams
}

export type MutationUpdateOrCreateStageTransitionCheckpointArgs = {
   params: UpdateOrCreateStageTransitionCheckpointParams
}

export type MutationUpdateParameterArgs = {
   params: UpdateParameterParams
}

export type MutationUpdateParameterConditionArgs = {
   params: UpdateParameterConditionParams
}

export type MutationUpdateParameterKeyArgs = {
   params: UpdateParameterKeyParams
}

export type MutationUpdateParentFieldForDependentFieldArgs = {
   params: UpdateParentFieldForDependentFieldParams
}

export type MutationUpdatePaymentStatusOnUserActionArgs = {
   params: UpdatePaymentStatusOnUserActionParams
}

export type MutationUpdatePhoneNumberFieldOtpVerificationEnabledValueArgs = {
   params: UpdatePhoneNumberFieldOtpVerificationEnabledValueParams
}

export type MutationUpdatePieChartArgs = {
   params: UpdatePieChartParams
}

export type MutationUpdatePipelineCustomObjectAddAnotherFieldArgs = {
   params: UpdatePipelineCustomObjectAddAnotherFieldParams
}

export type MutationUpdatePipelineCustomObjectAssigneeBulkArgs = {
   params: UpdatePipelineCustomObjectAssigneeBulkParams
}

export type MutationUpdatePipelineCustomObjectFieldArgs = {
   params: UpdatePipelineCustomObjectFieldParams
}

export type MutationUpdatePipelineDisplayNameArgs = {
   params: UpdatePipelineDisplayNameParams
}

export type MutationUpdatePipelineEventPipelineItemCreationConfigArgs = {
   params: UpdatePipelineEventPipelineItemCreationConfigParams
}

export type MutationUpdatePipelineEventTemplateArgs = {
   params: UpdatePipelineEventTemplateParams
}

export type MutationUpdatePipelineEventTemplateDescriptionArgs = {
   params: UpdatePipelineEventTemplateDescriptionParams
}

export type MutationUpdatePipelineEventTemplateNameArgs = {
   params: UpdatePipelineEventTemplateNameParams
}

export type MutationUpdatePipelineIconArgs = {
   params: UpdatePipelineIconParams
}

export type MutationUpdatePipelineItemPaymentRequestArgs = {
   params: UpdatePipelineItemPaymentRequestParams
}

export type MutationUpdatePipelineItemRemarksArgs = {
   params: UpdatePipelineItemRemarksParams
}

export type MutationUpdatePipelineItemReminderArgs = {
   params: UpdatePipelineItemReminderParams
}

export type MutationUpdatePipelineItemScheduleArgs = {
   params: UpdatePipelineItemScheduleParams
}

export type MutationUpdatePipelineNameArgs = {
   params: UpdatePipelineNameParams
}

export type MutationUpdatePipelineSettingsArgs = {
   params: UpdatePipelineSettingsParams
}

export type MutationUpdatePipelineStageBoardsOwnerArgs = {
   params: UpdatePipelineStageBoardsOwnerParams
}

export type MutationUpdatePipelineStageTransitionStyleArgs = {
   params: UpdatePipelineStageTransitionStyleParams
}

export type MutationUpdatePipelineWhatsappBusinessPhoneNumberArgs = {
   params: UpdatePipelineWhatsAppBusinessPhoneNumberParams
}

export type MutationUpdatePipelineWhatsappConsentRequiredStatusArgs = {
   params: UpdatePipelineWhatsappConsentRequiredStatusParams
}

export type MutationUpdatePivotGraphColumnDimensionArgs = {
   params: UpdatePivotGraphColumnDimensionParams
}

export type MutationUpdatePivotGraphRowDimensionArgs = {
   params: UpdatePivotGraphRowDimensionParams
}

export type MutationUpdatePivotTableGraphArgs = {
   params: UpdatePivotTableGraphParams
}

export type MutationUpdatePivotTableTotalsConfigArgs = {
   params: UpdatePivotTableGraphTotalsConfigParams
}

export type MutationUpdatePlainFieldValidationRegexArgs = {
   params: UpdatePlainTextFieldValidationRegexParams
}

export type MutationUpdatePlainTextFieldDefaultValueArgs = {
   params: UpdatePlainTextFieldDefaultValueParams
}

export type MutationUpdatePlainTextFieldFormulaStatusArgs = {
   params: UpdatePlainTextFieldFormulaStatusParams
}

export type MutationUpdatePortalArgs = {
   params: UpdatePortalParams
}

export type MutationUpdatePortalApplicationArgs = {
   params: UpdatePortalApplicationParams
}

export type MutationUpdatePortalApplicationStatusArgs = {
   params: UpdatePortalApplicationStatusParams
}

export type MutationUpdatePortalBrandBgImgArgs = {
   params: UpdatePortalBrandBgImageParams
}

export type MutationUpdatePortalBrandLogoArgs = {
   params: UpdatePortalBrandLogoParams
}

export type MutationUpdatePortalDescriptionArgs = {
   params: UpdatePortalDescriptionParams
}

export type MutationUpdatePortalStatusArgs = {
   params: UpdatePortalStatusParams
}

export type MutationUpdatePortalTitleArgs = {
   params: UpdatePortalTitleParams
}

export type MutationUpdateQuickFilterFieldArgs = {
   params: UpdateGraphQuickFilterFieldParams
}

export type MutationUpdateRadioGroupFieldDefaultValueArgs = {
   params: UpdateRadioGroupFieldDefaultValueParams
}

export type MutationUpdateReconciliationRequestStatusArgs = {
   params: UpdateReconciliationRequestStatusParams
}

export type MutationUpdateRecordCreationConfigNameArgs = {
   params: UpdateRecordCreationConfigNameParams
}

export type MutationUpdateRelatedEntityAddAnotherFieldResponseArgs = {
   params: UpdateRelatedEntityAddAnotherFieldResponseParams
}

export type MutationUpdateRelatedEntityFieldResponseArgs = {
   params: UpdateRelatedEntityFieldResponseParams
}

export type MutationUpdateRelationArgs = {
   params: UpdateRelationParams
}

export type MutationUpdateRelationFieldValueTypeArgs = {
   params: UpdateRelationFieldValueTypeParams
}

export type MutationUpdateResourceArgs = {
   params: UpdateResourceParams
}

export type MutationUpdateSalesTemplateRecordCreationConfigArgs = {
   params: UpdateSalesTemplateRecordCreationConfigParams
}

export type MutationUpdateScheduledAutomationWorkflowExecLogsFilterArgs = {
   params: UpdateScheduledAutomationWorkflowExecLogsFilterParams
}

export type MutationUpdateScheduledLeadDistributionRuleSettingsArgs = {
   params: UpdateScheduledLeadDistributionRuleSettingsParams
}

export type MutationUpdateScheduledLeadDistributionRuleStatusArgs = {
   params: UpdateScheduledLeadDistributionRuleStatusParams
}

export type MutationUpdateScheduledTriggerArgs = {
   params: UpdateScheduledTriggerParams
}

export type MutationUpdateScorecardChartArgs = {
   params: UpdateScorecardChartParams
}

export type MutationUpdateScoringConfigStatusArgs = {
   params: UpdateScoringConfigStatusParams
}

export type MutationUpdateScoringParameterArgs = {
   params: UpdateScoringParameterParams
}

export type MutationUpdateShortTextFieldDefaultValueArgs = {
   params: UpdateShortTextFieldDefaultValueParams
}

export type MutationUpdateShortTextFieldFormulaStatusArgs = {
   params: UpdateShortTextFieldFormulaStatusParams
}

export type MutationUpdateShortTextFieldOptionsArgs = {
   params: UpdateShortTextFieldOptionsParams
}

export type MutationUpdateShortTextFieldValidationRegexArgs = {
   params: UpdateShortTextFieldValidationRegexParams
}

export type MutationUpdateShowPipelineItemStageQuickEditFieldsToTaskTemplateArgs = {
   params: UpdateShowPipelineItemStageQuickEitFieldsToTaskTemplateParams
}

export type MutationUpdateSmartfloAccountArgs = {
   params: UpdateSmartfloAccountParams
}

export type MutationUpdateStageCategoryArgs = {
   params: UpdateStageCategoryParams
}

export type MutationUpdateStageTransitionActionNameArgs = {
   params: UpdateStageTransitionActionNameParams
}

export type MutationUpdateStageTransitionCheckpointsConfigArgs = {
   params: UpdateStageTransitionCheckpointsConfigParams
}

export type MutationUpdateStageTransitionConfigArgs = {
   params: UpdateStageTransitionConfigParams
}

export type MutationUpdateStageTransitionOrderArgs = {
   params: UpdateStageTransitionOrderParams
}

export type MutationUpdateTabArgs = {
   params: UpdateTabParams
}

export type MutationUpdateTableGraphArgs = {
   params: UpdateTableGraphParams
}

export type MutationUpdateTableGraphTotalsConfigArgs = {
   params: UpdateTableGraphTotalsConfigParams
}

export type MutationUpdateTaskAddAnotherGofFieldArgs = {
   params: UpdateTaskAddAnotherFieldParams
}

export type MutationUpdateTaskApproxDurationInMinsArgs = {
   params: UpdateTaskApproxDurationInMinsParams
}

export type MutationUpdateTaskFieldArgs = {
   params: UpdateTaskFieldParams
}

export type MutationUpdateTaskFieldBulkArgs = {
   params: UpdateTaskFieldBulkParams
}

export type MutationUpdateTaskPipelineItemCardConfigArgs = {
   params: UpdateTaskPipelineItemCardConfigParams
}

export type MutationUpdateTaskStartDateTimeArgs = {
   params: UpdateTaskStartDateTimeParams
}

export type MutationUpdateTaskTemplateColorArgs = {
   params: UpdateTaskTemplateColorParams
}

export type MutationUpdateTaskTemplateDescriptionArgs = {
   params: UpdateTaskTemplateDescriptionParams
}

export type MutationUpdateTaskTemplateIconUrlArgs = {
   params: UpdateTaskTemplateIconUrlParams
}

export type MutationUpdateTaskTemplateNameArgs = {
   params: UpdateTaskTemplateNameParams
}

export type MutationUpdateTaskTemplateRemarksAttachmentEnableStatusArgs = {
   params: UpdateTaskTemplateRemarksAttachmentEnableStatusParams
}

export type MutationUpdateTaskTemplateSettingsArgs = {
   params: UpdateTaskTemplateSettingsParams
}

export type MutationUpdateTaskTemplateStatusArgs = {
   params: UpdateTaskTemplateStatusParams
}

export type MutationUpdateTaskTemplateVisibilityFieldArgs = {
   params: UpdateTaskTemplateVisibilityFieldParams
}

export type MutationUpdateTasksFeatureEnableStatusArgs = {
   params: UpdateTasksFeatureEnableStatusParams
}

export type MutationUpdateTdrPaymentInPortalArgs = {
   params: UpdateTdrPaymentInPortalParams
}

export type MutationUpdateTdrPaymentObservationArgs = {
   params: UpdateTdrPaymentObservationParams
}

export type MutationUpdateTdrRequestArgs = {
   params: UpdateTdrRequestParams
}

export type MutationUpdateTdrRequestInPortalArgs = {
   params: UpdateTdrRequestInPortalParams
}

export type MutationUpdateTimeFieldDefaultValueArgs = {
   params: UpdateTimeFieldDefaultValueParams
}

export type MutationUpdateTimeFieldRelativeDefaultValueConfigArgs = {
   params: UpdateTimeFieldRelativeDefaultValueConfigParams
}

export type MutationUpdateUrlFieldConfigArgs = {
   params: UpdateUrlFieldConfigParams
}

export type MutationUpdateUrlFieldDefaultValueArgs = {
   params: UpdateUrlFieldDefaultValueParams
}

export type MutationUpdateUrlFieldValidationRegexArgs = {
   params: UpdateUrlFieldValidationRegexParams
}

export type MutationUpdateUserAdminStatusArgs = {
   params: UpdateUserAdminStatusParams
}

export type MutationUpdateUserEmailByAdminArgs = {
   params: UpdateUserEmailByAdminParams
}

export type MutationUpdateUserFirebaseAppAccessArgs = {
   params: UpdateUserFireBaseAppAccessParams
}

export type MutationUpdateUserPortalLanguageArgs = {
   params: UpdateUserPortalLanguageParams
}

export type MutationUpdateUserProfileArgs = {
   params: UpdateUserProfileParams
}

export type MutationUpdateUserProfileByAdminArgs = {
   params: UpdateUserProfileByAdminParams
}

export type MutationUpdateUserPropertiesTemplateDesignationFieldIdArgs = {
   params: UpdateUserPropertiesTemplateDesignationFieldIdParams
}

export type MutationUpdateUserPropertyArgs = {
   params: UpdateUserPropertyParams
}

export type MutationUpdateUsernameByAdminArgs = {
   params: UpdateUsernameByAdminParams
}

export type MutationUpdateUsersTabCustomizationArgs = {
   params: UpdateUsersTabCustomizationParams
}

export type MutationUpdateViewCustomJsonArgs = {
   params: UpdateViewCustomJsonParams
}

export type MutationUpdateViewTypeArgs = {
   params: UpdateViewTypeParams
}

export type MutationUpdateWatiAccountArgs = {
   params: UpdateWatiAccountParams
}

export type MutationUpdateWhatsappBusinessPhoneNumberArgs = {
   params: UpdateWhatsAppBusinessPhoneNumberParams
}

export type MutationUploadUserKmlFileArgs = {
   params: UploadUserKmlFileParams
}

export type MutationValidateTdrRequestCertificateNumberInPortalArgs = {
   params: ValidateTdrRequestCertificateNumberInPortalParams
}

export type MutationVerifyOtpForUpdatingUserPinArgs = {
   params: VerifyOtpForUpdatingUserPinParams
}

export type MutationVerifyOtpToPipelineItemPhoneNumberFieldArgs = {
   params: VerifyOtpToPipelineItemPhoneNumberFieldParams
}

export type MutationVerifyOtpToPipelineItemPhoneNumberFieldInPortalArgs = {
   params: VerifyOtpToPipelineItemPhoneNumberFieldInPortalParams
}

export type MutationVerifyTdrRequestOtpInPortalArgs = {
   params: VerifyTdrRequestOtpInPortalParams
}

export type NameIsRequired = GraphQlBaseError & {
   __typename?: 'NameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type NeedAtLeastOnePrefixValue = GraphQlBaseError & {
   __typename?: 'NeedAtLeastOnePrefixValue'
   message?: Maybe<Scalars['String']>
}

export type NeedAtLeastOneSuffixValue = GraphQlBaseError & {
   __typename?: 'NeedAtLeastOneSuffixValue'
   message?: Maybe<Scalars['String']>
}

export type NeedFieldReadPermission = GraphQlBaseError & {
   __typename?: 'NeedFieldReadPermission'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NeedFieldWritePermission = GraphQlBaseError & {
   __typename?: 'NeedFieldWritePermission'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NeedFieldsReadPermission = GraphQlBaseError & {
   __typename?: 'NeedFieldsReadPermission'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NeedFieldsWritePermission = GraphQlBaseError & {
   __typename?: 'NeedFieldsWritePermission'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NeedToPayPendingOrders = GraphQlBaseError & {
   __typename?: 'NeedToPayPendingOrders'
   message?: Maybe<Scalars['String']>
   orderIds: Array<Scalars['String']>
}

export type NestedTab = BaseTab & {
   __typename?: 'NestedTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   orderedChildTabIds: Array<Scalars['String']>
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type NestedTabCreationNotAllowedInNestedTab = GraphQlBaseError & {
   __typename?: 'NestedTabCreationNotAllowedInNestedTab'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type NewObjectionsWereRaisedOnApplication = GraphQlBaseError & {
   __typename?: 'NewObjectionsWereRaisedOnApplication'
   message?: Maybe<Scalars['String']>
   objectionIds: Array<Scalars['String']>
}

export type NoActiveAutomationWorkflowsFound = GraphQlBaseError & {
   __typename?: 'NoActiveAutomationWorkflowsFound'
   message?: Maybe<Scalars['String']>
}

export type NoBlocksPending = GraphQlBaseError & {
   __typename?: 'NoBlocksPending'
   documentId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NoCallingPermission = GraphQlBaseError & {
   __typename?: 'NoCallingPermission'
   message?: Maybe<Scalars['String']>
}

export type NoConditionalOptionsWereConfigured = GraphQlBaseError & {
   __typename?: 'NoConditionalOptionsWereConfigured'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NoDeletionStageConfigured = GraphQlBaseError & {
   __typename?: 'NoDeletionStageConfigured'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NoDocumentVersionForSigning = GraphQlBaseError & {
   __typename?: 'NoDocumentVersionForSigning'
   documentId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NoEntriesFoundInCsv = GraphQlBaseError & {
   __typename?: 'NoEntriesFoundInCSV'
   message?: Maybe<Scalars['String']>
}

export type NoEntriesFoundInSubSheet = GraphQlBaseError & {
   __typename?: 'NoEntriesFoundInSubSheet'
   message?: Maybe<Scalars['String']>
   sheetId: Scalars['String']
   subSheetName: Scalars['String']
}

export type NoFailedRefundsFound = GraphQlBaseError & {
   __typename?: 'NoFailedRefundsFound'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NoFriendToSendBack = GraphQlBaseError & {
   __typename?: 'NoFriendToSendBack'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type NoJobFoundOnTask = GraphQlBaseError & {
   __typename?: 'NoJobFoundOnTask'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type NoLeadsExistsInLeadDistributionRule = GraphQlBaseError & {
   __typename?: 'NoLeadsExistsInLeadDistributionRule'
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NoPendingDigitalSignRequest = GraphQlBaseError & {
   __typename?: 'NoPendingDigitalSignRequest'
   documentId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NoPreviousSubmittedTaskToReset = GraphQlBaseError & {
   __typename?: 'NoPreviousSubmittedTaskToReset'
   message?: Maybe<Scalars['String']>
}

export type NoPublishedVersionExistsForLeadDistributionRule = GraphQlBaseError & {
   __typename?: 'NoPublishedVersionExistsForLeadDistributionRule'
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NoRecordsToLoad = GraphQlBaseError & {
   __typename?: 'NoRecordsToLoad'
   message?: Maybe<Scalars['String']>
}

export type NoRegisteredMobileNumber = GraphQlBaseError & {
   __typename?: 'NoRegisteredMobileNumber'
   message?: Maybe<Scalars['String']>
}

export type NoRelatedEntitiesLinkedForRelation = GraphQlBaseError & {
   __typename?: 'NoRelatedEntitiesLinkedForRelation'
   currentEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
}

export type NoRestoreStageAvailable = GraphQlBaseError & {
   __typename?: 'NoRestoreStageAvailable'
   deletionStageId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NoSectionsSpecifiedForDeletion = GraphQlBaseError & {
   __typename?: 'NoSectionsSpecifiedForDeletion'
   message: Scalars['String']
}

export type NoSignerResolvedForBlock = GraphQlBaseError & {
   __typename?: 'NoSignerResolvedForBlock'
   blockFieldName: Scalars['String']
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NoStageTransitionToDeletionStage = GraphQlBaseError & {
   __typename?: 'NoStageTransitionToDeletionStage'
   currentStageId: Scalars['String']
   deletionStageId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type Node =
   | AddAnotherGoFNode
   | CallWebhookNode
   | ClearUndoneLeadTasksNode
   | ConditionNode
   | CreatePipelineEventNode
   | CreateRelatedRecordNode
   | CreateTaskNode
   | ExecuteFunctionNode
   | GenerateDocumentNode
   | GenerateNumberNode
   | InitiateRefundNode
   | RemoveAssigneesNode
   | RemoveFromPipelineNode
   | RequestPaymentNode
   | RequestPaymentWithFeeRulesNode
   | SendDataToSegmentNode
   | SendPipelineItemNotificationNode
   | SendWhatsAppMessageNode
   | SignDocumentNode
   | SwiftsellOutboundWebhookNode
   | UpdateDisplayStageNode
   | UpdateLeadNode
   | UpdateLeadStageNode
   | UpdatePipelineItemAssigneeNode
   | UpdateRelatedRecordsNode
   | UpdateTaskNode

export type NodeAccessDenied = GraphQlBaseError & {
   __typename?: 'NodeAccessDenied'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NodeActionsConfig = {
   __typename?: 'NodeActionsConfig'
   canCreateNode: Scalars['Boolean']
   nodeId: Scalars['String']
}

export type NodeActionsConfigNotSupportedInAutomationWorkflow = GraphQlBaseError & {
   __typename?: 'NodeActionsConfigNotSupportedInAutomationWorkflow'
   automationWorkflowId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum NodeConfigStatus {
   Configured = 'CONFIGURED',
   PartiallyConfigured = 'PARTIALLY_CONFIGURED'
}

export type NodeExecLog =
   | AddAnotherGoFNodeExecLog
   | CallWebhookNodeExecLog
   | ClearUndoneLeadTasksNodeExecLog
   | ConditionNodeExecLog
   | CreatePipelineEventNodeExecLog
   | CreateRelatedRecordNodeExecLog
   | CreateTaskNodeExecLog
   | ExecuteFunctionNodeExecLog
   | GenerateDocumentNodeExecLog
   | GenerateNumberNodeExecLog
   | InitiateRefundNodeExecLog
   | RemoveAssigneesNodeExecLog
   | RemoveFromPipelineNodeExecLog
   | RequestPaymentNodeExecLog
   | RequestPaymentWithFeeRulesNodeExecLog
   | SendDataToSegmentNodeExecLog
   | SendPipelineItemNotificationNodeExecLog
   | SendWhatsAppMessageNodeExecLog
   | SignDocumentNodeExecLog
   | SwiftsellOutboundWebhookNodeExecLog
   | UpdateDisplayStageNodeExecLog
   | UpdateLeadNodeExecLog
   | UpdateLeadStageNodeExecLog
   | UpdatePipelineItemAssigneeNodeExecLog
   | UpdateRelatedRecordsNodeExecLog
   | UpdateTaskNodeExecLog

export enum NodeExecLogStatusEnum {
   Done = 'DONE',
   Failed = 'FAILED',
   Processing = 'PROCESSING'
}

export type NodeGoFResponseFieldsMapping = {
   __typename?: 'NodeGoFResponseFieldsMapping'
   fields: Array<FieldValueMapping>
   gofResponseUniqueId: Scalars['String']
}

export type NodeGoFResponseFieldsMappingParams = {
   fields: Array<FieldValueMappingParams>
   gofResponseUniqueId: Scalars['String']
}

export type NodeNotFound = GraphQlBaseError & {
   __typename?: 'NodeNotFound'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NodeNotSupportedInAutomationWorkflowExecType = GraphQlBaseError & {
   __typename?: 'NodeNotSupportedInAutomationWorkflowExecType'
   automationWorkflowId: Scalars['String']
   execType: AutomationWorkflowExecType
   message?: Maybe<Scalars['String']>
}

export type NodeResult =
   | AddAnotherGoFNode
   | CallWebhookNode
   | ClearUndoneLeadTasksNode
   | ConditionNode
   | CreatePipelineEventNode
   | CreateRelatedRecordNode
   | CreateTaskNode
   | ExecuteFunctionNode
   | GenerateDocumentNode
   | GenerateNumberNode
   | InitiateRefundNode
   | NodeAccessDenied
   | NodeNotFound
   | RemoveAssigneesNode
   | RemoveFromPipelineNode
   | RequestPaymentNode
   | RequestPaymentWithFeeRulesNode
   | SendDataToSegmentNode
   | SendPipelineItemNotificationNode
   | SendWhatsAppMessageNode
   | SignDocumentNode
   | SwiftsellOutboundWebhookNode
   | UpdateDisplayStageNode
   | UpdateLeadNode
   | UpdateLeadStageNode
   | UpdatePipelineItemAssigneeNode
   | UpdateRelatedRecordsNode
   | UpdateTaskNode
   | UserIsNotAnAdministrator

export enum NodeResultEnum {
   False = 'FALSE',
   True = 'TRUE'
}

export type NodeToParentNodeCircularDependency = GraphQlBaseError & {
   __typename?: 'NodeToParentNodeCircularDependency'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   parentNodeId: Scalars['String']
}

export enum NodeType {
   AddAnotherGof = 'ADD_ANOTHER_GOF',
   CallWebhook = 'CALL_WEBHOOK',
   ClearUndoneLeadTasks = 'CLEAR_UNDONE_LEAD_TASKS',
   Condition = 'CONDITION',
   CreatePipelineEvent = 'CREATE_PIPELINE_EVENT',
   CreateRelatedRecord = 'CREATE_RELATED_RECORD',
   CreateTask = 'CREATE_TASK',
   ExecuteFunction = 'EXECUTE_FUNCTION',
   GenerateDocument = 'GENERATE_DOCUMENT',
   GenerateNumber = 'GENERATE_NUMBER',
   InitiateRefund = 'INITIATE_REFUND',
   RemoveAssignees = 'REMOVE_ASSIGNEES',
   RemoveFromPipeline = 'REMOVE_FROM_PIPELINE',
   RequestPayment = 'REQUEST_PAYMENT',
   RequestPaymentWithFeeRules = 'REQUEST_PAYMENT_WITH_FEE_RULES',
   SendDataToSegment = 'SEND_DATA_TO_SEGMENT',
   SendPipelineItemNotification = 'SEND_PIPELINE_ITEM_NOTIFICATION',
   SendWhatsappMessage = 'SEND_WHATSAPP_MESSAGE',
   SignDocument = 'SIGN_DOCUMENT',
   SwiftsellOutboundWebhookCall = 'SWIFTSELL_OUTBOUND_WEBHOOK_CALL',
   UpdateDisplayStage = 'UPDATE_DISPLAY_STAGE',
   UpdateLead = 'UPDATE_LEAD',
   UpdateLeadStage = 'UPDATE_LEAD_STAGE',
   UpdatePipelineItemAssignee = 'UPDATE_PIPELINE_ITEM_ASSIGNEE',
   UpdateRelatedRecords = 'UPDATE_RELATED_RECORDS',
   UpdateTask = 'UPDATE_TASK'
}

export type NodesNotFound = GraphQlBaseError & {
   __typename?: 'NodesNotFound'
   message?: Maybe<Scalars['String']>
   nodeIds: Array<Scalars['String']>
}

export type NodesNotInSameAutomationWorkflowExecConfig = GraphQlBaseError & {
   __typename?: 'NodesNotInSameAutomationWorkflowExecConfig'
   message?: Maybe<Scalars['String']>
   nodeIds: Array<Scalars['String']>
}

export type NonDependentFields = GraphQlBaseError & {
   __typename?: 'NonDependentFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotACustomObjectPipeline = GraphQlBaseError & {
   __typename?: 'NotACustomObjectPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotADraftedPipelineItemRemarks = GraphQlBaseError & {
   __typename?: 'NotADraftedPipelineItemRemarks'
   message?: Maybe<Scalars['String']>
   pipelineItemRemarksId: Scalars['String']
}

export type NotAGeoField = GraphQlBaseError & {
   __typename?: 'NotAGeoField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAKmlFile = GraphQlBaseError & {
   __typename?: 'NotAKmlFile'
   message?: Maybe<Scalars['String']>
}

export type NotAPhoneNumberIdentificationField = GraphQlBaseError & {
   __typename?: 'NotAPhoneNumberIdentificationField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAWhatsAppPluginServiceAccount = GraphQlBaseError & {
   __typename?: 'NotAWhatsAppPluginServiceAccount'
   message?: Maybe<Scalars['String']>
   pluginServiceAccountId: Scalars['String']
}

export type NotActivityField = GraphQlBaseError & {
   __typename?: 'NotActivityField'
   activityId: Scalars['String']
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotActivityTemplateFieldIds = GraphQlBaseError & {
   __typename?: 'NotActivityTemplateFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotActivityTemplatePipelineIdentifications = GraphQlBaseError & {
   __typename?: 'NotActivityTemplatePipelineIdentifications'
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotActivityTemplatePipelinesIdentifications = GraphQlBaseError & {
   __typename?: 'NotActivityTemplatePipelinesIdentifications'
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAddAnotherFields = GraphQlBaseError & {
   __typename?: 'NotAddAnotherFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAddAnotherGoF = GraphQlBaseError & {
   __typename?: 'NotAddAnotherGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAddAnotherGoFField = GraphQlBaseError & {
   __typename?: 'NotAddAnotherGoFField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAddAnotherGoFFields = GraphQlBaseError & {
   __typename?: 'NotAddAnotherGoFFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAddAnotherGoFNodeType = GraphQlBaseError & {
   __typename?: 'NotAddAnotherGoFNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotAddAnotherGoFResponseField = GraphQlBaseError & {
   __typename?: 'NotAddAnotherGoFResponseField'
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAddAnotherGoFResponseFields = GraphQlBaseError & {
   __typename?: 'NotAddAnotherGoFResponseFields'
   fieldIds: Array<Scalars['String']>
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAddAnotherGoFs = GraphQlBaseError & {
   __typename?: 'NotAddAnotherGoFs'
   gofIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAllowedActionOnPayment = GraphQlBaseError & {
   __typename?: 'NotAllowedActionOnPayment'
   message?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
}

export type NotAllowedActionOnTdrRequest = GraphQlBaseError & {
   __typename?: 'NotAllowedActionOnTDRRequest'
   currentStatus: TdrRequestStatus
   message?: Maybe<Scalars['String']>
   tdrRequestId: Scalars['String']
}

export type NotAllowedActionOnTdrRequests = GraphQlBaseError & {
   __typename?: 'NotAllowedActionOnTDRRequests'
   message?: Maybe<Scalars['String']>
   tdrRequestIds: Array<Scalars['String']>
}

export type NotAllowedDisplayStageWritableFields = GraphQlBaseError & {
   __typename?: 'NotAllowedDisplayStageWritableFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAllowedDisplayStageWritableGoFs = GraphQlBaseError & {
   __typename?: 'NotAllowedDisplayStageWritableGoFs'
   gofIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAllowedFieldsForGlobalSearch = GraphQlBaseError & {
   __typename?: 'NotAllowedFieldsForGlobalSearch'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAllowedFileFormats = GraphQlBaseError & {
   __typename?: 'NotAllowedFileFormats'
   fieldId: Scalars['String']
   fileFormats: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
   urls: Array<Scalars['String']>
}

export type NotAllowedFilterField = GraphQlBaseError & {
   __typename?: 'NotAllowedFilterField'
   fieldId: Scalars['String']
   filterSetEntity: FilterSetEntityType
   message?: Maybe<Scalars['String']>
}

export type NotAllowedSelfAssignment = GraphQlBaseError & {
   __typename?: 'NotAllowedSelfAssignment'
   message?: Maybe<Scalars['String']>
}

export type NotAllowedSortFields = GraphQlBaseError & {
   __typename?: 'NotAllowedSortFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAllowedStageOverviewFields = GraphQlBaseError & {
   __typename?: 'NotAllowedStageOverviewFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAllowedStageQuickEditFields = GraphQlBaseError & {
   __typename?: 'NotAllowedStageQuickEditFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAllowedTdrAccountTransactionStatus = GraphQlBaseError & {
   __typename?: 'NotAllowedTDRAccountTransactionStatus'
   currentStatus: Scalars['String']
   message?: Maybe<Scalars['String']>
   transactionId: Scalars['String']
}

export type NotAllowedTaskTemplateQuickEditFields = GraphQlBaseError & {
   __typename?: 'NotAllowedTaskTemplateQuickEditFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToConfigureOnlyOneDimension = GraphQlBaseError & {
   __typename?: 'NotAllowedToConfigureOnlyOneDimension'
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToCreateGraphDimension = GraphQlBaseError & {
   __typename?: 'NotAllowedToCreateGraphDimension'
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToCreateGraphMetric = GraphQlBaseError & {
   __typename?: 'NotAllowedToCreateGraphMetric'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToCreateMoreThanTwoGraphDimensions = GraphQlBaseError & {
   __typename?: 'NotAllowedToCreateMoreThanTwoGraphDimensions'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToDeleteGraphDimension = GraphQlBaseError & {
   __typename?: 'NotAllowedToDeleteGraphDimension'
   graphDimensionId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToDeleteGraphMetric = GraphQlBaseError & {
   __typename?: 'NotAllowedToDeleteGraphMetric'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToEditBoardFilterSet = GraphQlBaseError & {
   __typename?: 'NotAllowedToEditBoardFilterSet'
   allowedBoardTypes: Array<BoardType>
   boardId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToEditBoardListFilterSet = GraphQlBaseError & {
   __typename?: 'NotAllowedToEditBoardListFilterSet'
   allowedBoardTypes: Array<BoardType>
   boardListId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToLinkActivityTemplatesAndPipeline = GraphQlBaseError & {
   __typename?: 'NotAllowedToLinkActivityTemplatesAndPipeline'
   activityTemplateIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotAllowedToUpdateRelationFields = GraphQlBaseError & {
   __typename?: 'NotAllowedToUpdateRelationFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToUpdateSystemFields = GraphQlBaseError & {
   __typename?: 'NotAllowedToUpdateSystemFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotAllowedToUpdateTransferArea = GraphQlBaseError & {
   __typename?: 'NotAllowedToUpdateTransferArea'
   message?: Maybe<Scalars['String']>
}

export type NotAllowedUtilizationTransactionStatus = GraphQlBaseError & {
   __typename?: 'NotAllowedUtilizationTransactionStatus'
   message?: Maybe<Scalars['String']>
   transactionId: Scalars['String']
}

export type NotAnalyticsView = GraphQlBaseError & {
   __typename?: 'NotAnalyticsView'
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export type NotApplicationAddAnotherGoFResponse = GraphQlBaseError & {
   __typename?: 'NotApplicationAddAnotherGoFResponse'
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotApplicationAddAnotherGoFResponsesBulk = GraphQlBaseError & {
   __typename?: 'NotApplicationAddAnotherGoFResponsesBulk'
   applicationId: Scalars['String']
   gofResponseIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotApplicationAssigneeFields = GraphQlBaseError & {
   __typename?: 'NotApplicationAssigneeFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotApplicationDisplayStage = GraphQlBaseError & {
   __typename?: 'NotApplicationDisplayStage'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type NotApplicationDisplayStages = GraphQlBaseError & {
   __typename?: 'NotApplicationDisplayStages'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export type NotApplicationField = GraphQlBaseError & {
   __typename?: 'NotApplicationField'
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotApplicationFields = GraphQlBaseError & {
   __typename?: 'NotApplicationFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotApplicationIdField = GraphQlBaseError & {
   __typename?: 'NotApplicationIdField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotApplicationPipeline = GraphQlBaseError & {
   __typename?: 'NotApplicationPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotApplicationPipelineField = GraphQlBaseError & {
   __typename?: 'NotApplicationPipelineField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotApplicationPipelineFieldIds = GraphQlBaseError & {
   __typename?: 'NotApplicationPipelineFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotApplicationPipelineFields = GraphQlBaseError & {
   __typename?: 'NotApplicationPipelineFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotApplicationPipelineGoF = GraphQlBaseError & {
   __typename?: 'NotApplicationPipelineGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotApplicationPipelineTemplateGoF = GraphQlBaseError & {
   __typename?: 'NotApplicationPipelineTemplateGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type NotApplicationTypePipeline = GraphQlBaseError & {
   __typename?: 'NotApplicationTypePipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotAssigneeFieldIds = GraphQlBaseError & {
   __typename?: 'NotAssigneeFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotBarGraph = GraphQlBaseError & {
   __typename?: 'NotBarGraph'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotCsvDataLoadingRequest = GraphQlBaseError & {
   __typename?: 'NotCSVDataLoadingRequest'
   dataLoadingRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotCsvFile = GraphQlBaseError & {
   __typename?: 'NotCSVFile'
   message?: Maybe<Scalars['String']>
}

export type NotCallWebhookNode = GraphQlBaseError & {
   __typename?: 'NotCallWebhookNode'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotCheckboxGroupField = GraphQlBaseError & {
   __typename?: 'NotCheckboxGroupField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotClearUndoneTasksOnLeadType = GraphQlBaseError & {
   __typename?: 'NotClearUndoneTasksOnLeadType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotCompatibleValueFieldIds = GraphQlBaseError & {
   __typename?: 'NotCompatibleValueFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotConditionNode = GraphQlBaseError & {
   __typename?: 'NotConditionNode'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotConditionNodeFilterSet = GraphQlBaseError & {
   __typename?: 'NotConditionNodeFilterSet'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotConditionalOptionsValueType = GraphQlBaseError & {
   __typename?: 'NotConditionalOptionsValueType'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotConflictedRelatedEntities = GraphQlBaseError & {
   __typename?: 'NotConflictedRelatedEntities'
   message?: Maybe<Scalars['String']>
   relatedEntityIds: Array<Scalars['String']>
}

export type NotConflictedRelations = GraphQlBaseError & {
   __typename?: 'NotConflictedRelations'
   message?: Maybe<Scalars['String']>
   relationIds: Array<Scalars['String']>
}

export type NotContactField = GraphQlBaseError & {
   __typename?: 'NotContactField'
   contactId: Scalars['String']
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotCreatePipelineEventNodeType = GraphQlBaseError & {
   __typename?: 'NotCreatePipelineEventNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotCreateRelatedRecordNodeType = GraphQlBaseError & {
   __typename?: 'NotCreateRelatedRecordNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotCrmEntityGoFResponseId = GraphQlBaseError & {
   __typename?: 'NotCrmEntityGoFResponseId'
   crmEntityId: Scalars['String']
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotCustomIdField = GraphQlBaseError & {
   __typename?: 'NotCustomIdField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotCustomObjectAddAnotherGoFResponsesBulk = GraphQlBaseError & {
   __typename?: 'NotCustomObjectAddAnotherGoFResponsesBulk'
   customObjectId: Scalars['String']
   gofResponseIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotCustomObjectPipeline = GraphQlBaseError & {
   __typename?: 'NotCustomObjectPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotDateField = GraphQlBaseError & {
   __typename?: 'NotDateField'
   message?: Maybe<Scalars['String']>
}

export type NotDateTimeField = GraphQlBaseError & {
   __typename?: 'NotDateTimeField'
   message?: Maybe<Scalars['String']>
}

export type NotDealAddAnotherGoFResponse = GraphQlBaseError & {
   __typename?: 'NotDealAddAnotherGoFResponse'
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotDealAddAnotherGoFResponsesBulk = GraphQlBaseError & {
   __typename?: 'NotDealAddAnotherGoFResponsesBulk'
   dealId: Scalars['String']
   gofResponseIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotDealAssigneeField = GraphQlBaseError & {
   __typename?: 'NotDealAssigneeField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotDealField = GraphQlBaseError & {
   __typename?: 'NotDealField'
   dealId: Scalars['String']
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotDealPipelineStage = GraphQlBaseError & {
   __typename?: 'NotDealPipelineStage'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type NotDealTemplateFields = GraphQlBaseError & {
   __typename?: 'NotDealTemplateFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotDealTemplateGoF = GraphQlBaseError & {
   __typename?: 'NotDealTemplateGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotDependentField = GraphQlBaseError & {
   __typename?: 'NotDependentField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotDisplayStageFieldIds = GraphQlBaseError & {
   __typename?: 'NotDisplayStageFieldIds'
   message?: Maybe<Scalars['String']>
   stageFieldIds: Array<Scalars['String']>
}

export type NotDonutChart = GraphQlBaseError & {
   __typename?: 'NotDonutChart'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotDropdownField = GraphQlBaseError & {
   __typename?: 'NotDropdownField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotDropdownFields = GraphQlBaseError & {
   __typename?: 'NotDropdownFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotEditableAllocationGroupSet = GraphQlBaseError & {
   __typename?: 'NotEditableAllocationGroupSet'
   allocationGroupSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotEditableDistributionThroughEntity = GraphQlBaseError & {
   __typename?: 'NotEditableDistributionThroughEntity'
   distributionThrough: DistributionThroughType
   distributionThroughEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotEditableEventTriggerFilterSetEntity = GraphQlBaseError & {
   __typename?: 'NotEditableEventTriggerFilterSetEntity'
   filterSetEntity: EventTriggerFilterSetEntity
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotEditableFilterSetEntity = GraphQlBaseError & {
   __typename?: 'NotEditableFilterSetEntity'
   filterSetEntity: FilterSetEntityType
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotEditableGraphMetric = GraphQlBaseError & {
   __typename?: 'NotEditableGraphMetric'
   message?: Maybe<Scalars['String']>
   metricId: Scalars['String']
}

export type NotEditableLeadBucket = GraphQlBaseError & {
   __typename?: 'NotEditableLeadBucket'
   leadBucketId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotEditableLeadDistributionRule = GraphQlBaseError & {
   __typename?: 'NotEditableLeadDistributionRule'
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotEditableNode = GraphQlBaseError & {
   __typename?: 'NotEditableNode'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotEditableNodes = GraphQlBaseError & {
   __typename?: 'NotEditableNodes'
   message?: Maybe<Scalars['String']>
   nodeIds: Array<Scalars['String']>
}

export type NotEditablePivotTableMetricField = GraphQlBaseError & {
   __typename?: 'NotEditablePivotTableMetricField'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotEditableTrigger = GraphQlBaseError & {
   __typename?: 'NotEditableTrigger'
   message?: Maybe<Scalars['String']>
   triggerId: Scalars['String']
}

export type NotEmailField = GraphQlBaseError & {
   __typename?: 'NotEmailField'
   message?: Maybe<Scalars['String']>
}

export type NotEmailFields = GraphQlBaseError & {
   __typename?: 'NotEmailFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotEventBasedLeadDistributionRule = GraphQlBaseError & {
   __typename?: 'NotEventBasedLeadDistributionRule'
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotEventBasedTriggerForStageFields = GraphQlBaseError & {
   __typename?: 'NotEventBasedTriggerForStageFields'
   message?: Maybe<Scalars['String']>
}

export type NotExecuteFunctionNodeType = GraphQlBaseError & {
   __typename?: 'NotExecuteFunctionNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotExistTaskFieldResponse = GraphQlBaseError & {
   __typename?: 'NotExistTaskFieldResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotExistsNodeFilterSet = GraphQlBaseError & {
   __typename?: 'NotExistsNodeFilterSet'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotExistsReferenceIdForFields = GraphQlBaseError & {
   __typename?: 'NotExistsReferenceIdForFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotExportPipelineItemRequest = GraphQlBaseError & {
   __typename?: 'NotExportPipelineItemRequest'
   dataExportRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotFieldsSelectorField = GraphQlBaseError & {
   __typename?: 'NotFieldsSelectorField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotFileUploaderField = GraphQlBaseError & {
   __typename?: 'NotFileUploaderField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotFilledRequiredConfig = GraphQlBaseError & {
   __typename?: 'NotFilledRequiredConfig'
   message?: Maybe<Scalars['String']>
}

export type NotFilterSetEntityFilterSet = GraphQlBaseError & {
   __typename?: 'NotFilterSetEntityFilterSet'
   filterSetEntity: AutomationWorkflowFilterSetEntityType
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotFloatField = GraphQlBaseError & {
   __typename?: 'NotFloatField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotFormTemplateField = GraphQlBaseError & {
   __typename?: 'NotFormTemplateField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotFormTemplateFields = GraphQlBaseError & {
   __typename?: 'NotFormTemplateFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotFunnelGraph = GraphQlBaseError & {
   __typename?: 'NotFunnelGraph'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotGenerateNumberNodeType = GraphQlBaseError & {
   __typename?: 'NotGenerateNumberNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotGivenAutomationWorkflowNodes = GraphQlBaseError & {
   __typename?: 'NotGivenAutomationWorkflowNodes'
   automationWorkflowId: Scalars['String']
   message?: Maybe<Scalars['String']>
   nodeIds: Array<Scalars['String']>
}

export type NotGivenExistingDependentFieldIds = GraphQlBaseError & {
   __typename?: 'NotGivenExistingDependentFieldIds'
   dependentFieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotGoFResponseFieldId = GraphQlBaseError & {
   __typename?: 'NotGoFResponseFieldId'
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotHaveSufficientBalanceInTdrAccount = GraphQlBaseError & {
   __typename?: 'NotHaveSufficientBalanceInTDRAccount'
   allocatedArea: Scalars['Float']
   message?: Maybe<Scalars['String']>
   requestedArea: Scalars['Float']
}

export type NotImplementedForService = GraphQlBaseError & {
   __typename?: 'NotImplementedForService'
   message?: Maybe<Scalars['String']>
   service: Scalars['String']
}

export type NotInitiateRefundNodeType = GraphQlBaseError & {
   __typename?: 'NotInitiateRefundNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotIntegerField = GraphQlBaseError & {
   __typename?: 'NotIntegerField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotLatestDocumentVersion = GraphQlBaseError & {
   __typename?: 'NotLatestDocumentVersion'
   documentVersionId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotLatestFriend = GraphQlBaseError & {
   __typename?: 'NotLatestFriend'
   latestFriendId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type NotLeadAddAnotherGoFResponse = GraphQlBaseError & {
   __typename?: 'NotLeadAddAnotherGoFResponse'
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotLeadAddAnotherGoFResponsesBulk = GraphQlBaseError & {
   __typename?: 'NotLeadAddAnotherGoFResponsesBulk'
   gofResponseIds: Array<Scalars['String']>
   leadId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotLeadAssigneeField = GraphQlBaseError & {
   __typename?: 'NotLeadAssigneeField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotLeadAssigneeFields = GraphQlBaseError & {
   __typename?: 'NotLeadAssigneeFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotLeadField = GraphQlBaseError & {
   __typename?: 'NotLeadField'
   fieldId: Scalars['String']
   leadId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotLeadGraphs = GraphQlBaseError & {
   __typename?: 'NotLeadGraphs'
   graphIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotLeadOrContactFields = GraphQlBaseError & {
   __typename?: 'NotLeadOrContactFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotLeadPipeline = GraphQlBaseError & {
   __typename?: 'NotLeadPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotLeadPipelineStage = GraphQlBaseError & {
   __typename?: 'NotLeadPipelineStage'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type NotLeadPipelines = GraphQlBaseError & {
   __typename?: 'NotLeadPipelines'
   message?: Maybe<Scalars['String']>
   pipelineIds: Array<Scalars['String']>
}

export type NotLeadTemplateFieldIds = GraphQlBaseError & {
   __typename?: 'NotLeadTemplateFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotLeadTemplateGoF = GraphQlBaseError & {
   __typename?: 'NotLeadTemplateGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotLeafNode = GraphQlBaseError & {
   __typename?: 'NotLeafNode'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotLineGraph = GraphQlBaseError & {
   __typename?: 'NotLineGraph'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotLongTextField = GraphQlBaseError & {
   __typename?: 'NotLongTextField'
   message?: Maybe<Scalars['String']>
}

export type NotMultiSelectField = GraphQlBaseError & {
   __typename?: 'NotMultiSelectField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotNestedTabTypes = GraphQlBaseError & {
   __typename?: 'NotNestedTabTypes'
   message?: Maybe<Scalars['String']>
   tabIds: Array<Scalars['String']>
}

export type NotParentNode = GraphQlBaseError & {
   __typename?: 'NotParentNode'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   parentNodeId: Scalars['String']
}

export type NotPdfFileUrl = GraphQlBaseError & {
   __typename?: 'NotPdfFileUrl'
   message?: Maybe<Scalars['String']>
}

export type NotPermittedCurrentEntity = GraphQlBaseError & {
   __typename?: 'NotPermittedCurrentEntity'
   currentEntityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPermittedCurrentEntityRelatedSalesTemplate = GraphQlBaseError & {
   __typename?: 'NotPermittedCurrentEntityRelatedSalesTemplate'
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type NotPermittedField = GraphQlBaseError & {
   __typename?: 'NotPermittedField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   systemFieldEnum?: Maybe<SystemFieldEnum>
}

export type NotPermittedFields = GraphQlBaseError & {
   __typename?: 'NotPermittedFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotPermittedForSignBlocks = GraphQlBaseError & {
   __typename?: 'NotPermittedForSignBlocks'
   blockFieldNames: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type NotPermittedRelation = GraphQlBaseError & {
   __typename?: 'NotPermittedRelation'
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
}

export type NotPhoneNumberField = GraphQlBaseError & {
   __typename?: 'NotPhoneNumberField'
   message?: Maybe<Scalars['String']>
}

export type NotPieChart = GraphQlBaseError & {
   __typename?: 'NotPieChart'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPinnedPipelineItemsView = GraphQlBaseError & {
   __typename?: 'NotPinnedPipelineItemsView'
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export type NotPipelineCustomObjectAddAnotherGoFResponse = GraphQlBaseError & {
   __typename?: 'NotPipelineCustomObjectAddAnotherGoFResponse'
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPipelineCustomObjectAssigneeField = GraphQlBaseError & {
   __typename?: 'NotPipelineCustomObjectAssigneeField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPipelineCustomObjectField = GraphQlBaseError & {
   __typename?: 'NotPipelineCustomObjectField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPipelineCustomObjectFields = GraphQlBaseError & {
   __typename?: 'NotPipelineCustomObjectFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotPipelineCustomObjectGoF = GraphQlBaseError & {
   __typename?: 'NotPipelineCustomObjectGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPipelineEventField = GraphQlBaseError & {
   __typename?: 'NotPipelineEventField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineEventId: Scalars['String']
}

export type NotPipelineEventTemplateFieldIds = GraphQlBaseError & {
   __typename?: 'NotPipelineEventTemplateFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotPipelineFieldIds = GraphQlBaseError & {
   __typename?: 'NotPipelineFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotPipelineIdentifications = GraphQlBaseError & {
   __typename?: 'NotPipelineIdentifications'
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotPipelineItemAssigneeField = GraphQlBaseError & {
   __typename?: 'NotPipelineItemAssigneeField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPipelineItemAssigneeFieldIds = GraphQlBaseError & {
   __typename?: 'NotPipelineItemAssigneeFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotPipelineItemField = GraphQlBaseError & {
   __typename?: 'NotPipelineItemField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type NotPipelineItemFields = GraphQlBaseError & {
   __typename?: 'NotPipelineItemFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotPipelineItemOrContactField = GraphQlBaseError & {
   __typename?: 'NotPipelineItemOrContactField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPipelineItemOrContactFields = GraphQlBaseError & {
   __typename?: 'NotPipelineItemOrContactFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotPipelineItemSalesEntityField = GraphQlBaseError & {
   __typename?: 'NotPipelineItemSalesEntityField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPipelineItemTaskTemplate = GraphQlBaseError & {
   __typename?: 'NotPipelineItemTaskTemplate'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type NotPipelineItemTemplateFieldId = GraphQlBaseError & {
   __typename?: 'NotPipelineItemTemplateFieldId'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPipelineItemTemplateFields = GraphQlBaseError & {
   __typename?: 'NotPipelineItemTemplateFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotPipelineItemTemplatePhoneNumberField = GraphQlBaseError & {
   __typename?: 'NotPipelineItemTemplatePhoneNumberField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPipelineItemTemplatePhoneNumberFields = GraphQlBaseError & {
   __typename?: 'NotPipelineItemTemplatePhoneNumberFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotPipelineStages = GraphQlBaseError & {
   __typename?: 'NotPipelineStages'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   stageIds: Array<Scalars['String']>
}

export type NotPipelineTaskTemplate = GraphQlBaseError & {
   __typename?: 'NotPipelineTaskTemplate'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type NotPivotTableGraph = GraphQlBaseError & {
   __typename?: 'NotPivotTableGraph'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotPlainTextField = GraphQlBaseError & {
   __typename?: 'NotPlainTextField'
   message?: Maybe<Scalars['String']>
}

export type NotPortalLinkedApplications = GraphQlBaseError & {
   __typename?: 'NotPortalLinkedApplications'
   message?: Maybe<Scalars['String']>
   portalApplicationIds: Array<Scalars['String']>
}

export type NotPortalUser = GraphQlBaseError & {
   __typename?: 'NotPortalUser'
   message?: Maybe<Scalars['String']>
}

export type NotPortalUserRelatedEntities = GraphQlBaseError & {
   __typename?: 'NotPortalUserRelatedEntities'
   message?: Maybe<Scalars['String']>
   relatedEntities: Array<Scalars['String']>
}

export type NotRadioGroupField = GraphQlBaseError & {
   __typename?: 'NotRadioGroupField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotRecordStageTransition = GraphQlBaseError & {
   __typename?: 'NotRecordStageTransition'
   message?: Maybe<Scalars['String']>
   stageTransitionId: Scalars['String']
}

export type NotRecordStages = GraphQlBaseError & {
   __typename?: 'NotRecordStages'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export type NotRecordTemplateFields = GraphQlBaseError & {
   __typename?: 'NotRecordTemplateFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotRelatedEntityAddAnotherGoFResponsesBulk = GraphQlBaseError & {
   __typename?: 'NotRelatedEntityAddAnotherGoFResponsesBulk'
   gofResponseIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   relatedEntityId: Scalars['String']
}

export type NotRelatedEntityGoFResponseId = GraphQlBaseError & {
   __typename?: 'NotRelatedEntityGoFResponseId'
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
   relatedEntityId: Scalars['String']
}

export type NotRelatedEntityTemplateField = GraphQlBaseError & {
   __typename?: 'NotRelatedEntityTemplateField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotRelatedEntityTemplateGoF = GraphQlBaseError & {
   __typename?: 'NotRelatedEntityTemplateGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotRelatedPipelineTemplateFields = GraphQlBaseError & {
   __typename?: 'NotRelatedPipelineTemplateFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotRelationField = GraphQlBaseError & {
   __typename?: 'NotRelationField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotRelationFields = GraphQlBaseError & {
   __typename?: 'NotRelationFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotRemoveAssigneesNode = GraphQlBaseError & {
   __typename?: 'NotRemoveAssigneesNode'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotRemoveFromPipelineNodeType = GraphQlBaseError & {
   __typename?: 'NotRemoveFromPipelineNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotRequestPaymentNodeType = GraphQlBaseError & {
   __typename?: 'NotRequestPaymentNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotRequestPaymentWithFeeRulesNodeType = GraphQlBaseError & {
   __typename?: 'NotRequestPaymentWithFeeRulesNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotRequestVerificationTab = GraphQlBaseError & {
   __typename?: 'NotRequestVerificationTab'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type NotSalesTemplateFieldId = GraphQlBaseError & {
   __typename?: 'NotSalesTemplateFieldId'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotSalesTemplateFieldIds = GraphQlBaseError & {
   __typename?: 'NotSalesTemplateFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotSameGraphQuickFilterFields = GraphQlBaseError & {
   __typename?: 'NotSameGraphQuickFilterFields'
   message?: Maybe<Scalars['String']>
}

export type NotScheduledLeadDistributionRule = GraphQlBaseError & {
   __typename?: 'NotScheduledLeadDistributionRule'
   message?: Maybe<Scalars['String']>
}

export type NotScheduledPipelineItemsView = GraphQlBaseError & {
   __typename?: 'NotScheduledPipelineItemsView'
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export type NotScheduledTrigger = GraphQlBaseError & {
   __typename?: 'NotScheduledTrigger'
   message?: Maybe<Scalars['String']>
   triggerId: Scalars['String']
}

export type NotScheduledTriggerFilterSet = GraphQlBaseError & {
   __typename?: 'NotScheduledTriggerFilterSet'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotScorecardChart = GraphQlBaseError & {
   __typename?: 'NotScorecardChart'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotSendDataToSegmentNode = GraphQlBaseError & {
   __typename?: 'NotSendDataToSegmentNode'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotShortTextField = GraphQlBaseError & {
   __typename?: 'NotShortTextField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotStageAssigneeFields = GraphQlBaseError & {
   __typename?: 'NotStageAssigneeFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotStageFieldId = GraphQlBaseError & {
   __typename?: 'NotStageFieldId'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotStageFieldIds = GraphQlBaseError & {
   __typename?: 'NotStageFieldIds'
   message?: Maybe<Scalars['String']>
   stageFieldIds: Array<Scalars['String']>
}

export type NotSupportPaymentRuleSet = GraphQlBaseError & {
   __typename?: 'NotSupportPaymentRuleSet'
   message?: Maybe<Scalars['String']>
   ruleSetId: Scalars['String']
}

export type NotSupportedAdvancedAnalyticsForPipeline = GraphQlBaseError & {
   __typename?: 'NotSupportedAdvancedAnalyticsForPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotSupportedCallAnalyticsFilterFieldOperator = GraphQlBaseError & {
   __typename?: 'NotSupportedCallAnalyticsFilterFieldOperator'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   operator: FilterOperator
   supportedOperators: Array<FilterOperator>
}

export type NotSupportedCardinalitiesForSelfRelation = GraphQlBaseError & {
   __typename?: 'NotSupportedCardinalitiesForSelfRelation'
   message?: Maybe<Scalars['String']>
   supportedCardinalities: Array<Cardinality>
}

export type NotSupportedComputedUpdateConfigForFields = GraphQlBaseError & {
   __typename?: 'NotSupportedComputedUpdateConfigForFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotSupportedContactFilterFieldOperator = GraphQlBaseError & {
   __typename?: 'NotSupportedContactFilterFieldOperator'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   operator: FilterOperator
   supportedOperators: Array<FilterOperator>
}

export type NotSupportedDataSources = GraphQlBaseError & {
   __typename?: 'NotSupportedDataSources'
   dataSources: Array<AnalyticsDataSourceType>
   message?: Maybe<Scalars['String']>
}

export type NotSupportedDefaultOptionsTypeField = GraphQlBaseError & {
   __typename?: 'NotSupportedDefaultOptionsTypeField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotSupportedDynamicFilterFieldOperator = GraphQlBaseError & {
   __typename?: 'NotSupportedDynamicFilterFieldOperator'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   operator: FilterOperator
   supportedOperators: Array<FilterOperator>
}

export type NotSupportedEventBasedTriggerForPipeline = GraphQlBaseError & {
   __typename?: 'NotSupportedEventBasedTriggerForPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   triggerEventType: TriggerEventType
}

export type NotSupportedFieldForGraphMetric = GraphQlBaseError & {
   __typename?: 'NotSupportedFieldForGraphMetric'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotSupportedFieldForGraphSalesEntityType = GraphQlBaseError & {
   __typename?: 'NotSupportedFieldForGraphSalesEntityType'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   salesEntityType: SalesEntityType
}

export type NotSupportedFieldType = GraphQlBaseError & {
   __typename?: 'NotSupportedFieldType'
   fieldType: FieldType
   message?: Maybe<Scalars['String']>
}

export type NotSupportedFieldTypeOperator = GraphQlBaseError & {
   __typename?: 'NotSupportedFieldTypeOperator'
   fieldType: FieldType
   message?: Maybe<Scalars['String']>
   operator: FilterOperator
   supportedOperators: Array<FilterOperator>
}

export type NotSupportedFieldTypes = GraphQlBaseError & {
   __typename?: 'NotSupportedFieldTypes'
   fieldTypes: Array<FieldType>
   message?: Maybe<Scalars['String']>
}

export type NotSupportedFieldTypesForAmountFormulaExp = GraphQlBaseError & {
   __typename?: 'NotSupportedFieldTypesForAmountFormulaExp'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotSupportedFields = GraphQlBaseError & {
   __typename?: 'NotSupportedFields'
   fields: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotSupportedFieldsForGraphSalesEntityType = GraphQlBaseError & {
   __typename?: 'NotSupportedFieldsForGraphSalesEntityType'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   salesEntityType: SalesEntityType
}

export type NotSupportedFilterFieldOperator = GraphQlBaseError & {
   __typename?: 'NotSupportedFilterFieldOperator'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   operator: FilterOperator
   supportedOperators: Array<FilterOperator>
}

export type NotSupportedFilterSetEntity = GraphQlBaseError & {
   __typename?: 'NotSupportedFilterSetEntity'
   filterSetEntity: FilterSetEntityType
   message?: Maybe<Scalars['String']>
}

export type NotSupportedFilterSetEntityForCallAnalyticsFilterField = GraphQlBaseError & {
   __typename?: 'NotSupportedFilterSetEntityForCallAnalyticsFilterField'
   fieldId: Scalars['String']
   filterSetEntity: FilterSetEntityType
   message?: Maybe<Scalars['String']>
}

export type NotSupportedFilterSetEntityForRelativeOperators = GraphQlBaseError & {
   __typename?: 'NotSupportedFilterSetEntityForRelativeOperators'
   filterSetEntity: AutomationWorkflowFilterSetEntityType
   message?: Maybe<Scalars['String']>
}

export type NotSupportedForDealPipelineItemTypes = GraphQlBaseError & {
   __typename?: 'NotSupportedForDealPipelineItemTypes'
   message?: Maybe<Scalars['String']>
}

export type NotSupportedForLinkedFieldsEnabledTaskTemplate = GraphQlBaseError & {
   __typename?: 'NotSupportedForLinkedFieldsEnabledTaskTemplate'
   message?: Maybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type NotSupportedGraphMetricField = GraphQlBaseError & {
   __typename?: 'NotSupportedGraphMetricField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotSupportedGraphMetricFieldIds = GraphQlBaseError & {
   __typename?: 'NotSupportedGraphMetricFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotSupportedGraphParenType = GraphQlBaseError & {
   __typename?: 'NotSupportedGraphParenType'
   message?: Maybe<Scalars['String']>
   parentType: GraphParentType
}

export type NotSupportedGraphSalesEntityType = GraphQlBaseError & {
   __typename?: 'NotSupportedGraphSalesEntityType'
   message?: Maybe<Scalars['String']>
   salesEntityType: SalesEntityType
}

export type NotSupportedJsonConfigurationEntity = GraphQlBaseError & {
   __typename?: 'NotSupportedJsonConfigurationEntity'
   entityType: JsonConfigurationEntityType
   message?: Maybe<Scalars['String']>
}

export type NotSupportedMergePipelineItemsWithContactsActionForPipeline = GraphQlBaseError & {
   __typename?: 'NotSupportedMergePipelineItemsWithContactsActionForPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type NotSupportedMultipleDataSources = GraphQlBaseError & {
   __typename?: 'NotSupportedMultipleDataSources'
   message?: Maybe<Scalars['String']>
}

export type NotSupportedOperatorForUserProperty = GraphQlBaseError & {
   __typename?: 'NotSupportedOperatorForUserProperty'
   fieldId: UserSystemPropertiesEnum
   message?: Maybe<Scalars['String']>
   operator: UserPropertyFilterOperator
   supportedOperators: Array<UserPropertyFilterOperator>
}

export type NotSupportedOptionsVisibilityRulesForAddAnotherField = GraphQlBaseError & {
   __typename?: 'NotSupportedOptionsVisibilityRulesForAddAnotherField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotSupportedOptionsVisibilityRulesForField = GraphQlBaseError & {
   __typename?: 'NotSupportedOptionsVisibilityRulesForField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotSupportedPipelineForGraphSalesEntityType = GraphQlBaseError & {
   __typename?: 'NotSupportedPipelineForGraphSalesEntityType'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   salesEntityType: SalesEntityType
}

export type NotSupportedRelativeValuesForFields = GraphQlBaseError & {
   __typename?: 'NotSupportedRelativeValuesForFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   values: Array<Scalars['String']>
}

export type NotSupportedResetForCheckpoint = GraphQlBaseError & {
   __typename?: 'NotSupportedResetForCheckpoint'
   checkpointId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotSupportedSalesTemplateFields = GraphQlBaseError & {
   __typename?: 'NotSupportedSalesTemplateFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   salesTemplateTypes: Array<SalesTemplateType>
}

export type NotSupportedSalesTemplateType = GraphQlBaseError & {
   __typename?: 'NotSupportedSalesTemplateType'
   message?: Maybe<Scalars['String']>
   salesTemplateType: SalesTemplateType
}

export enum NotSupportedSalesTemplateTypesForRelation {
   Activity = 'ACTIVITY',
   Form = 'FORM',
   Task = 'TASK',
   UserProperties = 'USER_PROPERTIES'
}

export type NotSupportedSalesTemplatesForRelation = GraphQlBaseError & {
   __typename?: 'NotSupportedSalesTemplatesForRelation'
   message?: Maybe<Scalars['String']>
   salesTemplateTypes: Array<NotSupportedSalesTemplateTypesForRelation>
}

export type NotSupportedScoringParameterField = GraphQlBaseError & {
   __typename?: 'NotSupportedScoringParameterField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotSupportedScoringParameterFields = GraphQlBaseError & {
   __typename?: 'NotSupportedScoringParameterFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotSupportedSourceFieldType = GraphQlBaseError & {
   __typename?: 'NotSupportedSourceFieldType'
   fieldType: FieldType
   message?: Maybe<Scalars['String']>
}

export type NotSupportedStageForStageFieldIds = GraphQlBaseError & {
   __typename?: 'NotSupportedStageForStageFieldIds'
   message?: Maybe<Scalars['String']>
   stageFieldIds: Array<Scalars['String']>
}

export type NotSupportedSystemFieldOperator = GraphQlBaseError & {
   __typename?: 'NotSupportedSystemFieldOperator'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   operator: FilterOperator
   supportedOperators: Array<FilterOperator>
   systemFieldEnum: SystemFieldEnum
}

export type NotSupportedSystemFields = GraphQlBaseError & {
   __typename?: 'NotSupportedSystemFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   notSupportedSystemFieldEnums: Array<SystemFieldEnum>
}

export type NotSupportedTargetFieldType = GraphQlBaseError & {
   __typename?: 'NotSupportedTargetFieldType'
   fieldType: FieldType
   message?: Maybe<Scalars['String']>
}

export type NotSupportedValueFieldSourceForEventTriggerRelativeOperators = GraphQlBaseError & {
   __typename?: 'NotSupportedValueFieldSourceForEventTriggerRelativeOperators'
   fieldSource: EventTriggerFieldSourceType
   message?: Maybe<Scalars['String']>
}

export type NotSupportedValueSourceForRelativeOperators = GraphQlBaseError & {
   __typename?: 'NotSupportedValueSourceForRelativeOperators'
   message?: Maybe<Scalars['String']>
   valueSource: FieldSourceType
}

export type NotSwiftsellOutboundWebhookNodeType = GraphQlBaseError & {
   __typename?: 'NotSwiftsellOutboundWebhookNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotTdrAccountHolderUser = GraphQlBaseError & {
   __typename?: 'NotTDRAccountHolderUser'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type NotTableGraph = GraphQlBaseError & {
   __typename?: 'NotTableGraph'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotTaskAddAnotherGoFResponse = GraphQlBaseError & {
   __typename?: 'NotTaskAddAnotherGoFResponse'
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotTaskAddAnotherGoFResponsesBulk = GraphQlBaseError & {
   __typename?: 'NotTaskAddAnotherGoFResponsesBulk'
   gofResponseIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type NotTaskField = GraphQlBaseError & {
   __typename?: 'NotTaskField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type NotTaskGoF = GraphQlBaseError & {
   __typename?: 'NotTaskGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotTaskTemplateFieldIds = GraphQlBaseError & {
   __typename?: 'NotTaskTemplateFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotTaskTemplateFields = GraphQlBaseError & {
   __typename?: 'NotTaskTemplateFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotTaskTemplatePipelineIdentifications = GraphQlBaseError & {
   __typename?: 'NotTaskTemplatePipelineIdentifications'
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotTimeField = GraphQlBaseError & {
   __typename?: 'NotTimeField'
   message?: Maybe<Scalars['String']>
}

export type NotTriggerPayloadFieldSourceForStageFields = GraphQlBaseError & {
   __typename?: 'NotTriggerPayloadFieldSourceForStageFields'
   message?: Maybe<Scalars['String']>
}

export type NotUpdateDisplayStageNodeType = GraphQlBaseError & {
   __typename?: 'NotUpdateDisplayStageNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotUpdateLeadNodeType = GraphQlBaseError & {
   __typename?: 'NotUpdateLeadNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotUpdateLeadStageNodeType = GraphQlBaseError & {
   __typename?: 'NotUpdateLeadStageNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotUpdateLeadStageTriggerForStageFields = GraphQlBaseError & {
   __typename?: 'NotUpdateLeadStageTriggerForStageFields'
   message?: Maybe<Scalars['String']>
}

export type NotUpdatePipelineItemAssigneeNode = GraphQlBaseError & {
   __typename?: 'NotUpdatePipelineItemAssigneeNode'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotUpdateRelatedRecordsNodeType = GraphQlBaseError & {
   __typename?: 'NotUpdateRelatedRecordsNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotUpdateSendWhatsAppMessageNodeType = GraphQlBaseError & {
   __typename?: 'NotUpdateSendWhatsAppMessageNodeType'
   message?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type NotUrlField = GraphQlBaseError & {
   __typename?: 'NotUrlField'
   message?: Maybe<Scalars['String']>
}

export type NotUserDashboardGraphs = GraphQlBaseError & {
   __typename?: 'NotUserDashboardGraphs'
   dashboardId: Scalars['String']
   graphIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotUserFilterSet = GraphQlBaseError & {
   __typename?: 'NotUserFilterSet'
   filterSetId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotUserKmlFile = GraphQlBaseError & {
   __typename?: 'NotUserKmlFile'
   fileId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotUserPropertiesTemplateField = GraphQlBaseError & {
   __typename?: 'NotUserPropertiesTemplateField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotUserPropertiesTemplatePhoneNumberField = GraphQlBaseError & {
   __typename?: 'NotUserPropertiesTemplatePhoneNumberField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NotUserPropertyFieldIds = GraphQlBaseError & {
   __typename?: 'NotUserPropertyFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type NotUserViewGraphs = GraphQlBaseError & {
   __typename?: 'NotUserViewGraphs'
   graphIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export type NotVerificationTab = GraphQlBaseError & {
   __typename?: 'NotVerificationTab'
   message?: Maybe<Scalars['String']>
}

export type Note = {
   __typename?: 'Note'
   attachments: Array<Attachment>
   color?: Maybe<Scalars['String']>
   content: Scalars['String']
   createdAt: Scalars['String']
   createdBy: BaseUser
   noteId: Scalars['Int']
}

export type NoteEntityAccessDenied = GraphQlBaseError & {
   __typename?: 'NoteEntityAccessDenied'
   entityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type NoteEntityNotFound = GraphQlBaseError & {
   __typename?: 'NoteEntityNotFound'
   entityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum NoteEntityType {
   PipelineItem = 'PIPELINE_ITEM'
}

export type Notification =
   | AutomationWorkflowPipelineItemNotification
   | DefaultNotification
   | MergePipelineItemsNotification
   | PipelineItemAssigneeUpdateNotification
   | PipelineItemMissedCallNotification
   | PipelineItemReminderNotification
   | PipelineItemScheduleNotifications
   | PipelineItemsExportFailureNotification
   | PipelineItemsExportSuccessNotification

export enum NotificationCategory {
   All = 'ALL',
   Unread = 'UNREAD'
}

export type NotificationDescriptionFieldsLimitExceeded = GraphQlBaseError & {
   __typename?: 'NotificationDescriptionFieldsLimitExceeded'
   maxLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type NotificationDescriptionLengthExceeded = GraphQlBaseError & {
   __typename?: 'NotificationDescriptionLengthExceeded'
   maxLength: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type NotificationNodeAssigneeFieldConfig = {
   __typename?: 'NotificationNodeAssigneeFieldConfig'
   assigneeFieldId: Scalars['String']
   managerLevels: Array<Scalars['Int']>
}

export type NotificationNodeAssigneeFieldConfigParams = {
   assigneeFieldId: Scalars['String']
   managerLevels: Array<Scalars['Int']>
}

export type NotificationNotFound = GraphQlBaseError & {
   __typename?: 'NotificationNotFound'
   message?: Maybe<Scalars['String']>
   notificationId: Scalars['String']
}

export type NotificationPipelineItemDetails = {
   __typename?: 'NotificationPipelineItemDetails'
   applicationTemplateProperties?: Maybe<ApplicationTemplateProperties>
   customObjectTemplateProperties?: Maybe<CustomObjectTemplateProperties>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemName?: Maybe<Scalars['String']>
   pipelineItemType: PipelineItemType
   pipelineTemplateId: Scalars['String']
}

export type NotificationTitleFieldsLimitExceeded = GraphQlBaseError & {
   __typename?: 'NotificationTitleFieldsLimitExceeded'
   maxLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type NotificationTitleLengthExceeded = GraphQlBaseError & {
   __typename?: 'NotificationTitleLengthExceeded'
   maxLength: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export enum NotificationTypes {
   AwPipelineItemNotificationNode = 'AW_PIPELINE_ITEM_NOTIFICATION_NODE',
   MergePipelineItems = 'MERGE_PIPELINE_ITEMS',
   MissedCall = 'MISSED_CALL',
   Notification = 'NOTIFICATION',
   PaymentsReminder = 'PAYMENTS_REMINDER',
   PipelineItemsExportFailed = 'PIPELINE_ITEMS_EXPORT_FAILED',
   PipelineItemsExportSuccess = 'PIPELINE_ITEMS_EXPORT_SUCCESS',
   PipelineItemAssigneeUpdate = 'PIPELINE_ITEM_ASSIGNEE_UPDATE',
   PipelineItemReminder = 'PIPELINE_ITEM_REMINDER',
   PipelineItemSchedule = 'PIPELINE_ITEM_SCHEDULE',
   UserDetailsUpdates = 'USER_DETAILS_UPDATES'
}

export type NotifyApplicationArchitectNotSupportedForPipeline = GraphQlBaseError & {
   __typename?: 'NotifyApplicationArchitectNotSupportedForPipeline'
   message?: Maybe<Scalars['String']>
}

export type NotifyApplicationCustomerNotSupportedForPipeline = GraphQlBaseError & {
   __typename?: 'NotifyApplicationCustomerNotSupportedForPipeline'
   message?: Maybe<Scalars['String']>
}

export enum NumberFieldOperator {
   Addition = 'ADDITION',
   Subtraction = 'SUBTRACTION'
}

export enum NumberGenerationType {
   ApplicationId = 'APPLICATION_ID',
   FileNumber = 'FILE_NUMBER',
   PermitOrderId = 'PERMIT_ORDER_ID',
   ReceiptNumber = 'RECEIPT_NUMBER',
   ReferenceNumber = 'REFERENCE_NUMBER',
   TdrCertificateNumber = 'TDR_CERTIFICATE_NUMBER',
   TrackingNumber = 'TRACKING_NUMBER'
}

export type NumberOfFilesMaxLimitExceeded = GraphQlBaseError & {
   __typename?: 'NumberOfFilesMaxLimitExceeded'
   maxLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type NumberOfInstallmentsConfig = {
   __typename?: 'NumberOfInstallmentsConfig'
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type NumberOfInstallmentsConfigParams = {
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export enum OcSiteInspectionActionEnum {
   AcceptAll = 'ACCEPT_ALL',
   RejectAll = 'REJECT_ALL',
   ShortfallAll = 'SHORTFALL_ALL'
}

export type OcSiteInspectionColumn = {
   __typename?: 'OCSiteInspectionColumn'
   allowNegativeNumber?: Maybe<Scalars['Boolean']>
   columnId: Scalars['String']
   columnType: SiteInspectionColumnType
   noOfDigitsRoundOff?: Maybe<Scalars['Int']>
   observationConfigs?: Maybe<Array<OcSiteInspectionObservationConfig>>
   observationDependentColumnId?: Maybe<Scalars['String']>
   parentColumnId?: Maybe<Scalars['String']>
   showChildColumnNames?: Maybe<Scalars['Boolean']>
}

export type OcSiteInspectionColumnRow = {
   __typename?: 'OCSiteInspectionColumnRow'
   rowValues: Array<OcSiteInspectionColumnRowValue>
}

export type OcSiteInspectionColumnRowValue = {
   __typename?: 'OCSiteInspectionColumnRowValue'
   columnId: Scalars['String']
   fieldId?: Maybe<Scalars['String']>
   formula?: Maybe<Scalars['String']>
   isEnabled?: Maybe<BooleanFromSheetsEnum>
   isReadOnly?: Maybe<BooleanFromSheetsEnum>
   observationConfigs?: Maybe<Array<OcSiteInspectionObservationConfig>>
}

export type OcSiteInspectionCopyColumnConfig = {
   __typename?: 'OCSiteInspectionCopyColumnConfig'
   copyActionName?: Maybe<Scalars['String']>
   copyFromColumn: Scalars['String']
   copyToColumn: Scalars['String']
}

export type OcSiteInspectionObservationConfig = {
   __typename?: 'OCSiteInspectionObservationConfig'
   condition: Scalars['String']
   observation: BpsVerificationRecommendationEnum
}

export type OcSiteInspectionQuestionFieldMapping = {
   __typename?: 'OCSiteInspectionQuestionFieldMapping'
   contextFieldId?: Maybe<Scalars['String']>
   questionFieldId: Scalars['String']
}

export type OcSiteInspectionTab = BaseTab & {
   __typename?: 'OCSiteInspectionTab'
   actions: Array<OcSiteInspectionTabAction>
   applicationAddAnotherGofId: Scalars['String']
   documentGenerationConfig?: Maybe<DocumentGenerationConfig>
   enableScheduling?: Maybe<Scalars['Boolean']>
   enableTabStatusIcon: Scalars['Boolean']
   fieldsMapping: Array<OcSiteInspectionQuestionFieldMapping>
   formulaResultAllowNegative?: Maybe<BooleanFromSheetsEnum>
   formulaResultMaxDecimalPlaces?: Maybe<Scalars['Int']>
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   photographFieldIds: Array<Scalars['String']>
   showGofResponseCount?: Maybe<Scalars['Boolean']>
   tabId: Scalars['String']
   tabType: TabType
   tables: Array<OcSiteInspectionTable>
   taskAddAnotherGofId: Scalars['String']
   taskStatus?: Maybe<LayoutTabTaskStatus>
   taskTemplateId: Scalars['String']
}

export type OcSiteInspectionTabAction = {
   __typename?: 'OCSiteInspectionTabAction'
   actionType: OcSiteInspectionActionEnum
   name: Scalars['String']
}

export type OcSiteInspectionTable = {
   __typename?: 'OCSiteInspectionTable'
   copyColumnConfig?: Maybe<OcSiteInspectionCopyColumnConfig>
   displayType: OcSiteVerificationTableDisplayType
   name: Scalars['String']
   orderedColumns: Array<OcSiteInspectionColumn>
   rows: Array<OcSiteInspectionColumnRow>
   tableId: Scalars['String']
}

export enum OcSiteVerificationTableDisplayType {
   GofTable = 'GOF_TABLE',
   TabTable = 'TAB_TABLE'
}

export type OtpIsExpired = GraphQlBaseError & {
   __typename?: 'OTPIsExpired'
   message?: Maybe<Scalars['String']>
   otp: Scalars['String']
}

export type OtpLengthMismatched = GraphQlBaseError & {
   __typename?: 'OTPLengthMismatched'
   message?: Maybe<Scalars['String']>
}

export type OtpMaxRetriesExceeded = GraphQlBaseError & {
   __typename?: 'OTPMaxRetriesExceeded'
   maxRetriesCount: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type OtpRequiredForTransactionAcceptance = GraphQlBaseError & {
   __typename?: 'OTPRequiredForTransactionAcceptance'
   message?: Maybe<Scalars['String']>
   transactionId: Scalars['String']
}

export enum OtpVerificationEntityType {
   ApplicationManagement = 'APPLICATION_MANAGEMENT',
   BuildNowTdrBank = 'BUILD_NOW_TDR_BANK',
   DocumentSigning = 'DOCUMENT_SIGNING',
   DocumentVersion = 'DOCUMENT_VERSION',
   LoadBankAccount = 'LOAD_BANK_ACCOUNT',
   PipelineItemPhoneNumberField = 'PIPELINE_ITEM_PHONE_NUMBER_FIELD',
   ReconciliationRequest = 'RECONCILIATION_REQUEST',
   TdrManagement = 'TDR_MANAGEMENT',
   TdrRequest = 'TDR_REQUEST',
   TransferBankAmount = 'TRANSFER_BANK_AMOUNT',
   UserPin = 'USER_PIN'
}

export enum OtpVerificationPurpose {
   DocumentDownloading = 'DOCUMENT_DOWNLOADING',
   DocumentSigning = 'DOCUMENT_SIGNING',
   ESign = 'E_SIGN',
   GeneratePreviewForReconciliationRequest = 'GENERATE_PREVIEW_FOR_RECONCILIATION_REQUEST',
   InitiateReconciliationRequest = 'INITIATE_RECONCILIATION_REQUEST',
   InitiateTransferBankAmount = 'INITIATE_TRANSFER_BANK_AMOUNT',
   LoadBankAccount = 'LOAD_BANK_ACCOUNT',
   PipelineItemPhoneNumberFieldVerification = 'PIPELINE_ITEM_PHONE_NUMBER_FIELD_VERIFICATION',
   TaskShortfall = 'TASK_SHORTFALL',
   TdrAccountHoldVerification = 'TDR_ACCOUNT_HOLD_VERIFICATION',
   TdrAccountReleaseVerification = 'TDR_ACCOUNT_RELEASE_VERIFICATION',
   TdrRequestCertificateNumberVerification = 'TDR_REQUEST_CERTIFICATE_NUMBER_VERIFICATION',
   TdrTransactionOwnerAcceptance = 'TDR_TRANSACTION_OWNER_ACCEPTANCE'
}

export type OtpVerificationRequired = GraphQlBaseError & {
   __typename?: 'OTPVerificationRequired'
   message?: Maybe<Scalars['String']>
}

export type ObjectionApplicationColumn = {
   __typename?: 'ObjectionApplicationColumn'
   columnId: Scalars['String']
   columnType: ObjectionApplicationTableColumnType
   isMainFieldId?: Maybe<Scalars['Boolean']>
   isReadOnly?: Maybe<Scalars['Boolean']>
}

export type ObjectionApplicationColumnRowValue = {
   __typename?: 'ObjectionApplicationColumnRowValue'
   columnId: Scalars['String']
   fieldId?: Maybe<Scalars['String']>
   isReadOnly?: Maybe<BooleanFromSheetsEnum>
}

export type ObjectionApplicationRow = {
   __typename?: 'ObjectionApplicationRow'
   rowValues: Array<ObjectionApplicationColumnRowValue>
}

export type ObjectionApplicationTable = {
   __typename?: 'ObjectionApplicationTable'
   displayType: ObjectionApplicationTableDisplayTypeEnum
   enableRecommendations?: Maybe<BooleanFromSheetsEnum>
   enableRemarks?: Maybe<BooleanFromSheetsEnum>
   name: Scalars['String']
   orderedColumns: Array<ObjectionApplicationColumn>
   relatedRecordApplicationGofId: Scalars['String']
   rows: Array<ObjectionApplicationRow>
   tableId: Scalars['String']
}

export enum ObjectionApplicationTableColumnType {
   Observation = 'OBSERVATION',
   RelatedApplication = 'RELATED_APPLICATION',
   Remarks = 'REMARKS',
   SNo = 'S_NO',
   Task = 'TASK'
}

export enum ObjectionApplicationTableDisplayTypeEnum {
   GofTable = 'GOF_TABLE'
}

export type ObjectionTab = BaseTab & {
   __typename?: 'ObjectionTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   objectionSubmissionDatetimeFieldId?: Maybe<Scalars['String']>
   overviewFieldIds: Array<Scalars['String']>
   parentTabId?: Maybe<Scalars['String']>
   relation: Relation
   relationId: Scalars['String']
   tabId: Scalars['String']
   tabType: TabType
   tables: Array<ObjectionApplicationTable>
   taskTemplateId: Scalars['String']
   viewDetailsFieldIds: Array<Scalars['String']>
}

export type OfficerCheckStatusFieldConfig = {
   __typename?: 'OfficerCheckStatusFieldConfig'
   checkedResponse: Scalars['String']
   fieldId: Scalars['String']
   notCheckedResponse: Scalars['String']
}

export type OfficerHasActiveLeave = GraphQlBaseError & {
   __typename?: 'OfficerHasActiveLeave'
   activeLeaveRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
   officerUserId: Scalars['String']
}

export type OfficerIsDeactivated = GraphQlBaseError & {
   __typename?: 'OfficerIsDeactivated'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type OfficerLeaveLog = BaseOfficerManagementRequest & {
   __typename?: 'OfficerLeaveLog'
   accountId: Scalars['String']
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   endedBy?: Maybe<BaseUser>
   endedByUserId?: Maybe<Scalars['String']>
   id: Scalars['String']
   initiatedBy: Scalars['String']
   initiatedUser: User
   isActive: Scalars['Boolean']
   leaveEndDatetime?: Maybe<Scalars['String']>
   leaveRequestId: Scalars['String']
   leaveStartDatetime: Scalars['String']
   officerUser: BaseUser
   officerUserId: Scalars['String']
   operationType: OfficerManagementOperationType
   reason?: Maybe<Scalars['String']>
   replacementOfficerUser: BaseUser
   replacementOfficerUserId: Scalars['String']
   status: OfficerManagementStatusType
   updatedAt: Scalars['String']
}

export type OfficerLeaveLogsResult = {
   __typename?: 'OfficerLeaveLogsResult'
   leaveLogs: Array<OfficerLeaveLog>
   totalCount: Scalars['Int']
}

export type OfficerManagementAccessDenied = GraphQlBaseError & {
   __typename?: 'OfficerManagementAccessDenied'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type OfficerManagementLogFilters = {
   authority?: InputMaybe<AuthorityType>
   createdAfter?: InputMaybe<Scalars['String']>
   createdBefore?: InputMaybe<Scalars['String']>
   officerId?: InputMaybe<Scalars['String']>
   operation?: InputMaybe<OfficerManagementOperationType>
   pagination?: InputMaybe<Pagination>
   status?: InputMaybe<OfficerManagementStatusType>
}

export type OfficerManagementLogsResult = {
   __typename?: 'OfficerManagementLogsResult'
   requests: Array<OfficerManagementRequest>
   totalCount: Scalars['Int']
}

export enum OfficerManagementOperationType {
   CreateUserWithPhoneNumberName = 'CREATE_USER_WITH_PHONE_NUMBER_NAME',
   MandalAssignment = 'MANDAL_ASSIGNMENT',
   OfficerLeave = 'OFFICER_LEAVE',
   OfficerMerge = 'OFFICER_MERGE',
   OfficerRelieve = 'OFFICER_RELIEVE',
   OfficerTransfer = 'OFFICER_TRANSFER',
   ResetOtpRetryCounter = 'RESET_OTP_RETRY_COUNTER',
   SendWhatsappMessage = 'SEND_WHATSAPP_MESSAGE',
   UpdateUserDetails = 'UPDATE_USER_DETAILS'
}

export type OfficerManagementRequest =
   | InitiateDeactivateUserRequest
   | MandalAssignmentRequest
   | OfficerLeaveLog
   | OfficerTransferRequest
   | ResetOfficerOtpRetryCounterRequest
   | SendWhatsAppMessageRequest
   | UpdateUserDetailsRequest
   | UserCreationRequest

export type OfficerManagementRequestAccessDenied = GraphQlBaseError & {
   __typename?: 'OfficerManagementRequestAccessDenied'
   message?: Maybe<Scalars['String']>
   requestId: Scalars['String']
}

export type OfficerManagementRequestNotFound = GraphQlBaseError & {
   __typename?: 'OfficerManagementRequestNotFound'
   message?: Maybe<Scalars['String']>
   requestId: Scalars['String']
}

export enum OfficerManagementStatusType {
   Cancelled = 'CANCELLED',
   Completed = 'COMPLETED',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   Pending = 'PENDING'
}

export type OfficerNotFound = GraphQlBaseError & {
   __typename?: 'OfficerNotFound'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type OfficerTransferAttachment = {
   __typename?: 'OfficerTransferAttachment'
   attachmentId: Scalars['String']
   mimeType?: Maybe<Scalars['String']>
   name?: Maybe<Scalars['String']>
   sizeInBytes?: Maybe<Scalars['Float']>
   url: Scalars['String']
}

export type OfficerTransferAttachmentParams = {
   mimeType?: InputMaybe<Scalars['String']>
   name?: InputMaybe<Scalars['String']>
   sizeInBytes?: InputMaybe<Scalars['Float']>
   url: Scalars['String']
}

export type OfficerTransferInProgress = GraphQlBaseError & {
   __typename?: 'OfficerTransferInProgress'
   existingRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export enum OfficerTransferMode {
   Standard = 'STANDARD',
   WithHandover = 'WITH_HANDOVER'
}

export enum OfficerTransferOperationType {
   OfficerRelieve = 'OFFICER_RELIEVE',
   OfficerTransfer = 'OFFICER_TRANSFER'
}

export type OfficerTransferParams = {
   attachments: Array<OfficerTransferAttachmentParams>
   handoverOfficerUserId?: InputMaybe<Scalars['String']>
   operationType: OfficerTransferOperationType
   reason: Scalars['String']
   targetUserId: Scalars['String']
   transferMode?: InputMaybe<OfficerTransferMode>
   userId: Scalars['String']
}

export type OfficerTransferRequest = BaseOfficerManagementRequest & {
   __typename?: 'OfficerTransferRequest'
   accountId: Scalars['String']
   applicationsCount?: Maybe<Scalars['Int']>
   attachments?: Maybe<Array<Maybe<OfficerTransferAttachment>>>
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   currentUsername?: Maybe<Scalars['String']>
   errorMessage?: Maybe<Scalars['String']>
   estimatedCompletionTime?: Maybe<Scalars['String']>
   failedApplications?: Maybe<Scalars['Int']>
   handoverOfficer?: Maybe<User>
   handoverOfficerId?: Maybe<Scalars['String']>
   handoverOfficerUsername?: Maybe<Scalars['String']>
   id: Scalars['String']
   initiatedBy: Scalars['String']
   initiatedUser: User
   newHandoverUser?: Maybe<User>
   newHandoverUserId?: Maybe<Scalars['String']>
   operationType: OfficerManagementOperationType
   processedApplications?: Maybe<Scalars['Int']>
   progressPercentage?: Maybe<Scalars['Float']>
   reason?: Maybe<Scalars['String']>
   status: OfficerManagementStatusType
   targetUser: User
   targetUserId: Scalars['String']
   transferMode?: Maybe<OfficerTransferMode>
   transferringAppsCount?: Maybe<Scalars['Int']>
   transferringAppsFailed?: Maybe<Scalars['Int']>
   transferringAppsProcessed?: Maybe<Scalars['Int']>
   updatedAt: Scalars['String']
   updatedUsername: Scalars['String']
   user: User
   userId: Scalars['String']
}

export enum OneTimeCreatableSystemFieldEnum {
   ApplicationCustomId = 'APPLICATION_CUSTOM_ID',
   ApplicationId = 'APPLICATION_ID',
   CustomObjectCustomId = 'CUSTOM_OBJECT_CUSTOM_ID'
}

export type OnlyAdminCanDiscardTask = GraphQlBaseError & {
   __typename?: 'OnlyAdminCanDiscardTask'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type OnlyCustomTaskTypeHasTitle = GraphQlBaseError & {
   __typename?: 'OnlyCustomTaskTypeHasTitle'
   message?: Maybe<Scalars['String']>
}

export type OnlyLeadPipelineItemsAllowed = GraphQlBaseError & {
   __typename?: 'OnlyLeadPipelineItemsAllowed'
   message?: Maybe<Scalars['String']>
}

export type OnlyOneDeletionStageAllowedPerPipeline = GraphQlBaseError & {
   __typename?: 'OnlyOneDeletionStageAllowedPerPipeline'
   existingDeletionStageId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   requestedStageId: Scalars['String']
}

export type OnlyPhoneNumberFieldsSupportedToCompare = GraphQlBaseError & {
   __typename?: 'OnlyPhoneNumberFieldsSupportedToCompare'
   fieldReferenceIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type OnlySingleTypeOfDefaultValueIsAllowed = GraphQlBaseError & {
   __typename?: 'OnlySingleTypeOfDefaultValueIsAllowed'
   message?: Maybe<Scalars['String']>
}

export type OnlyUtilizeTransactionCanBeAcceptedByOwner = GraphQlBaseError & {
   __typename?: 'OnlyUtilizeTransactionCanBeAcceptedByOwner'
   message?: Maybe<Scalars['String']>
   transactionId: Scalars['String']
   transactionOperation: Scalars['String']
}

export type OpenSearchPipelineItemsParams = {
   canSearchOnAllFields: Scalars['Boolean']
   excludePipelineItemIds?: InputMaybe<Array<Scalars['String']>>
   fieldIds: Array<Scalars['String']>
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type OpenSearchPipelineItemsResponse =
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidLimit
   | InvalidOffset
   | NotAllowedFieldsForGlobalSearch
   | NotSupportedSalesTemplateFields
   | OpenSearchPipelineItemsResult
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineItemTemplateAccessDenied
   | PipelineItemTemplateNotFound
   | PipelineNotFound
   | SearchQueryIsRequired

export type OpenSearchPipelineItemsResult = {
   __typename?: 'OpenSearchPipelineItemsResult'
   pipelineItems: Array<SearchPipelineItemPrimaryDetails>
   totalCount: Scalars['Int']
}

export type OpenSearchTdrAccount = {
   __typename?: 'OpenSearchTDRAccount'
   accountId: Scalars['String']
   accountNo: Scalars['String']
   availableBalance: Scalars['Float']
   bankId?: Maybe<Scalars['String']>
   certificateAttachment?: Maybe<TdrCertificateAttachmentExtGraphql>
   certificates: Array<TdrCertificate>
   creationRefType: CreationRefType
   holderUser: BaseUser
   holderUserId: Scalars['String']
   inProgressBalance: Scalars['Float']
   initialBalance: Scalars['Float']
   issuedAt: Scalars['String']
   ledgerHeaderConfig?: Maybe<LedgerHeaderConfig>
   metadata?: Maybe<TdrAccountMetadata>
   purchaseRequestRaised: Scalars['Boolean']
   transactions: Array<OpenSearchTdrAccountTransaction>
   unit: AccountUnitType
   utilizedBalance: Scalars['Float']
}

export type OpenSearchTdrAccountNotFound = {
   __typename?: 'OpenSearchTDRAccountNotFound'
   tdrAccountId: Scalars['String']
}

export type OpenSearchTdrAccountTransaction = {
   __typename?: 'OpenSearchTDRAccountTransaction'
   account: BaseTdrAccount
   accountBalance?: Maybe<Scalars['Float']>
   accountId: Scalars['String']
   closedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   initiatedBy: Scalars['String']
   metaData: Array<TdrProperty>
   status: TransactionStatus
   transactionId: Scalars['String']
   transactionOperation: TransactionOperation
   updatedAt: Scalars['String']
   value: Scalars['Float']
}

export type OperatorIsNotSupportedForField = GraphQlBaseError & {
   __typename?: 'OperatorIsNotSupportedForField'
   message?: Maybe<Scalars['String']>
   operator: AutomationWorkflowOperator
}

export type OperatorIsNotSupportedForTrigger = GraphQlBaseError & {
   __typename?: 'OperatorIsNotSupportedForTrigger'
   message?: Maybe<Scalars['String']>
   operator: AutomationWorkflowOperator
}

export type OperatorIsNotSupportedForUpdatePipelineItemAssigneeFilterSet = GraphQlBaseError & {
   __typename?: 'OperatorIsNotSupportedForUpdatePipelineItemAssigneeFilterSet'
   message?: Maybe<Scalars['String']>
   operator: AutomationWorkflowOperator
   supportedOperators: Array<UpdatePipelineItemAssigneeFilterSetOperator>
}

export type OptionColorConfig = {
   __typename?: 'OptionColorConfig'
   color: ColorEnum
   option: Scalars['String']
}

export type OptionColorParams = {
   color: ColorEnum
   option: Scalars['String']
}

export type OptionShouldBeInExistingOptions = GraphQlBaseError & {
   __typename?: 'OptionShouldBeInExistingOptions'
   message?: Maybe<Scalars['String']>
   option: Scalars['String']
}

export type OptionWithColor = {
   __typename?: 'OptionWithColor'
   color?: Maybe<ColorEnum>
   option: Scalars['String']
}

export type OptionsAlreadyExists = GraphQlBaseError & {
   __typename?: 'OptionsAlreadyExists'
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type OptionsHaveDependentFieldsInLinkedFields = GraphQlBaseError & {
   __typename?: 'OptionsHaveDependentFieldsInLinkedFields'
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type OptionsShouldNotBeEmpty = GraphQlBaseError & {
   __typename?: 'OptionsShouldNotBeEmpty'
   message?: Maybe<Scalars['String']>
}

export type OptionsShouldNotHaveDependentFields = GraphQlBaseError & {
   __typename?: 'OptionsShouldNotHaveDependentFields'
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type OptionsUsedAsDefaultValuesInLinkedFields = GraphQlBaseError & {
   __typename?: 'OptionsUsedAsDefaultValuesInLinkedFields'
   defaultValues: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export enum OptionsValueType {
   ConditionalOptions = 'CONDITIONAL_OPTIONS',
   Default = 'DEFAULT',
   VisibilityRules = 'VISIBILITY_RULES'
}

export type OptionsWithColorsNotGivenInFieldConfig = GraphQlBaseError & {
   __typename?: 'OptionsWithColorsNotGivenInFieldConfig'
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type Order = InstallmentGroup | PaymentOrder

export type OrderAmountRecalculationError = {
   __typename?: 'OrderAmountRecalculationError'
   reason: Scalars['String']
}

export type OrderAmountRecalculationInfo = {
   __typename?: 'OrderAmountRecalculationInfo'
   feeHeaderChanges: Array<FeeHeaderChange>
   newTotal: Scalars['Float']
   orderId: Scalars['String']
   previousTotal: Scalars['Float']
}

export type OrderAmountsChanged = {
   __typename?: 'OrderAmountsChanged'
   feeRecalculationInfo: OrderAmountRecalculationInfo
   order: Order
}

export type OrderBaseDetails = {
   __typename?: 'OrderBaseDetails'
   name: Scalars['String']
   orderId: Scalars['String']
}

export enum OrderConfigButtonActionType {
   Default = 'DEFAULT'
}

export enum OrderConfigUiVariantEnum {
   Default = 'DEFAULT'
}

export type OrderContributedEntityIdsNotFound = {
   __typename?: 'OrderContributedEntityIdsNotFound'
   orderContributedEntityIds: Array<Scalars['String']>
}

export enum OrderContributedEntityStatus {
   Failed = 'FAILED',
   Paid = 'PAID',
   PartiallyPaid = 'PARTIALLY_PAID',
   YetToPay = 'YET_TO_PAY'
}

export enum OrderContributedEntityType {
   FeeHead = 'FEE_HEAD',
   FixedPaymentCategory = 'FIXED_PAYMENT_CATEGORY',
   Installment = 'INSTALLMENT'
}

export enum OrderCreationConfigType {
   Custom = 'CUSTOM',
   Default = 'DEFAULT'
}

export type OrderDetailsType = {
   __typename?: 'OrderDetailsType'
   orderAmount: Scalars['Float']
   orderCreatedDatetime?: Maybe<Scalars['String']>
   orderId: Scalars['String']
   orderName: Scalars['String']
   orderStatus: OrderStatus
   overallTimeline: Array<TimelineEventType>
   payments: Array<PaymentDetailsType>
}

export enum OrderEntityType {
   PipelineItem = 'PIPELINE_ITEM'
}

export type OrderNotFound = {
   __typename?: 'OrderNotFound'
   orderId: Scalars['String']
}

export type OrderPreview = InstallmentGroupPreview | PaymentOrderPreview

export type OrderRefund = {
   __typename?: 'OrderRefund'
   budgetHeads: Array<RefundBudgetHeadBreakdown>
   failureReason?: Maybe<Scalars['String']>
   initiatedAt: Scalars['String']
   status: OrderRefundStatus
   statusUpdateDatetime: Scalars['String']
   totalRefundAmount: Scalars['Float']
}

export enum OrderRefundStatus {
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   PartiallyRefunded = 'PARTIALLY_REFUNDED',
   Success = 'SUCCESS'
}

export enum OrderStatus {
   Cancelled = 'CANCELLED',
   Initiated = 'INITIATED',
   Paid = 'PAID',
   PartiallyPaid = 'PARTIALLY_PAID',
   Processing = 'PROCESSING',
   YetToPay = 'YET_TO_PAY'
}

export type OrderStatusUpdatedDummyMutationParams = {
   response: Scalars['String']
}

export type OrderStatusUpdatedDummyMutationResult = {
   __typename?: 'OrderStatusUpdatedDummyMutationResult'
   allowPartial: Scalars['Boolean']
   entityId: Scalars['String']
   entityType: OrderEntityType
   orderId: Scalars['String']
   partialOrderDetails?: Maybe<PartialOrderDetailsInSubscription>
   status: OrderStatus
}

export type OrderSuccessPopupConfig = {
   __typename?: 'OrderSuccessPopupConfig'
   buttonsConfig: Array<SuccessPopupButtonConfig>
   description?: Maybe<Scalars['String']>
   title?: Maybe<Scalars['String']>
   uiVariant?: Maybe<OrderConfigUiVariantEnum>
}

export enum OrdersOnPipelineItemFilter {
   All = 'ALL',
   Next_30Days = 'NEXT_30_DAYS',
   Overdue = 'OVERDUE',
   Paid = 'PAID'
}

export type OtpVerificationNotEnabledForField = GraphQlBaseError & {
   __typename?: 'OtpVerificationNotEnabledForField'
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum OutBoundCallType {
   CloudCalling = 'CLOUD_CALLING',
   DirectCalling = 'DIRECT_CALLING',
   NotAllowed = 'NOT_ALLOWED'
}

export type OverViewFieldsConfig = {
   __typename?: 'OverViewFieldsConfig'
   mobileCardOverviewFields: Array<Scalars['String']>
}

export type OverallRecommendationAndRemarksCard = BaseCard & {
   __typename?: 'OverallRecommendationAndRemarksCard'
   cardType: TabCardType
   enableOverallObservation: Scalars['Boolean']
   enableOverallRemarks: Scalars['Boolean']
   name: Scalars['String']
}

export enum OverallTransitionStatusEnum {
   Accepted = 'ACCEPTED',
   FieldShortfallRemarksNotFilled = 'FIELD_SHORTFALL_REMARKS_NOT_FILLED',
   OverallRemarksNotFilled = 'OVERALL_REMARKS_NOT_FILLED',
   Rejected = 'REJECTED',
   RequiredFieldsNotFilled = 'REQUIRED_FIELDS_NOT_FILLED',
   Shortfall = 'SHORTFALL'
}

export type OwnerAlreadyAcceptedTransaction = GraphQlBaseError & {
   __typename?: 'OwnerAlreadyAcceptedTransaction'
   message?: Maybe<Scalars['String']>
   transactionId: Scalars['String']
}

export type OwnerIsNotAnAdministrator = GraphQlBaseError & {
   __typename?: 'OwnerIsNotAnAdministrator'
   message?: Maybe<Scalars['String']>
}

export type OwnerNotFound = GraphQlBaseError & {
   __typename?: 'OwnerNotFound'
   message?: Maybe<Scalars['String']>
}

export type PmuActionLogDetailType = {
   __typename?: 'PMUActionLogDetailType'
   actionType: PmuActionType
   applicationId: Scalars['String']
   applicationNumber: Scalars['String']
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   documents: Array<PmuDocumentType>
   errorMessage?: Maybe<Scalars['String']>
   fieldDiffs: Array<PmuFieldDiffType>
   initiatorUserId: Scalars['String']
   leadDistributionLogId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   pmuActionLogId: Scalars['String']
   reason: Scalars['String']
   status: PmuActionLogStatus
   updatedAt?: Maybe<Scalars['String']>
}

export enum PmuActionLogStatus {
   Completed = 'COMPLETED',
   Failed = 'FAILED',
   Initiated = 'INITIATED',
   InProgress = 'IN_PROGRESS',
   PartialSuccess = 'PARTIAL_SUCCESS'
}

export type PmuActionLogType = {
   __typename?: 'PMUActionLogType'
   actionType: PmuActionType
   applicationId: Scalars['String']
   applicationNumber: Scalars['String']
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   initiatorUserId: Scalars['String']
   pmuActionLogId: Scalars['String']
   reason: Scalars['String']
   status: PmuActionLogStatus
}

export enum PmuActionType {
   Transfer = 'TRANSFER',
   Update = 'UPDATE'
}

export type PmuDocumentInput = {
   attachmentId?: InputMaybe<Scalars['String']>
   contentType: Scalars['String']
   fileName: Scalars['String']
   fileSizeBytes: Scalars['Int']
   url: Scalars['String']
}

export type PmuDocumentType = {
   __typename?: 'PMUDocumentType'
   attachmentId: Scalars['String']
   contentType: Scalars['String']
   fileName: Scalars['String']
   presignedUrl?: Maybe<Scalars['String']>
}

export type PmuFieldDiffType = {
   __typename?: 'PMUFieldDiffType'
   fieldId: Scalars['String']
   fieldLabel?: Maybe<Scalars['String']>
   gofName?: Maybe<Scalars['String']>
   gofResponseId?: Maybe<Scalars['String']>
   kind?: Maybe<Scalars['String']>
   newValue?: Maybe<Scalars['String']>
   oldValue?: Maybe<Scalars['String']>
}

export type PmuFieldOverrideInput = {
   fieldId: Scalars['String']
   fieldRefId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   kind?: InputMaybe<Scalars['String']>
   value?: InputMaybe<Scalars['String']>
}

export type PmuFieldResponseType = {
   __typename?: 'PMUFieldResponseType'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   response?: Maybe<Scalars['String']>
}

export type PmuValidationError = {
   __typename?: 'PMUValidationError'
   fieldName: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type Pagination = {
   limit: Scalars['Int']
   offset: Scalars['Int']
}

export type PaginationLimitExceeded = GraphQlBaseError & {
   __typename?: 'PaginationLimitExceeded'
   allowedLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type PaginationResponse = {
   __typename?: 'PaginationResponse'
   limit: Scalars['Int']
   offset: Scalars['Int']
}

export type PaidOrderContributedEntityIdsFound = {
   __typename?: 'PaidOrderContributedEntityIdsFound'
   orderContributedEntityIds: Array<Scalars['String']>
}

export type Parameter = {
   __typename?: 'Parameter'
   accountId: Scalars['String']
   createdAt: Scalars['String']
   hasReferences: Scalars['Boolean']
   key: Scalars['String']
   lastUpdatedAt?: Maybe<Scalars['String']>
   parameterId: Scalars['String']
   references: ParameterReferences
   value: Scalars['String']
}

export type ParameterCondition = {
   __typename?: 'ParameterCondition'
   conditionId: Scalars['String']
   operator: ScoringConditionOperator
   score: Scalars['Float']
   value?: Maybe<ScoringConfigValueResponseType>
}

export type ParameterConditionNotFound = GraphQlBaseError & {
   __typename?: 'ParameterConditionNotFound'
   message?: Maybe<Scalars['String']>
   parameterConditionId: Scalars['String']
}

export type ParameterConditionsNotFound = GraphQlBaseError & {
   __typename?: 'ParameterConditionsNotFound'
   message?: Maybe<Scalars['String']>
   parameterConditionIds: Array<Scalars['String']>
}

export type ParameterHasReferences = GraphQlBaseError & {
   __typename?: 'ParameterHasReferences'
   automationWorkflowIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ParameterIdNotFound = GraphQlBaseError & {
   __typename?: 'ParameterIdNotFound'
   message?: Maybe<Scalars['String']>
   parameterId: Scalars['String']
}

export type ParameterIdsNotFound = GraphQlBaseError & {
   __typename?: 'ParameterIdsNotFound'
   message?: Maybe<Scalars['String']>
   parameterIds: Array<Scalars['String']>
}

export type ParameterKeyAlreadyExistsInAccount = GraphQlBaseError & {
   __typename?: 'ParameterKeyAlreadyExistsInAccount'
   key: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ParameterKeyCanNotBeEmpty = GraphQlBaseError & {
   __typename?: 'ParameterKeyCanNotBeEmpty'
   message?: Maybe<Scalars['String']>
}

export type ParameterReferences = {
   __typename?: 'ParameterReferences'
   automationWorkflowIds: Array<Scalars['String']>
}

export type ParameterResult = Parameter | ParameterIdNotFound

export type ParameterValueCanNotBeEmpty = GraphQlBaseError & {
   __typename?: 'ParameterValueCanNotBeEmpty'
   message?: Maybe<Scalars['String']>
}

export type ParametersInAccountParams = {
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type ParametersInAccountResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | ParametersInAccountResult
   | UserIsNotAnAdministrator

export type ParametersInAccountResult = {
   __typename?: 'ParametersInAccountResult'
   parameters: Array<Parameter>
   totalCount: Scalars['Int']
}

export type ParametersShouldHaveAtLeastOneCondition = GraphQlBaseError & {
   __typename?: 'ParametersShouldHaveAtLeastOneCondition'
   message?: Maybe<Scalars['String']>
   scoringParameterIds: Array<Scalars['String']>
}

export type ParentChildTabs = {
   __typename?: 'ParentChildTabs'
   childTabs: Array<Tab>
   parentTabId: Scalars['String']
}

export type ParentFieldIsNotFieldSelector = GraphQlBaseError & {
   __typename?: 'ParentFieldIsNotFieldSelector'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ParentFieldMustBeDropdownField = GraphQlBaseError & {
   __typename?: 'ParentFieldMustBeDropdownField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ParentFieldNotFilled = GraphQlBaseError & {
   __typename?: 'ParentFieldNotFilled'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   parentFieldId: Scalars['String']
}

export type ParentFieldNotFound = GraphQlBaseError & {
   __typename?: 'ParentFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ParentFieldNotInGoF = GraphQlBaseError & {
   __typename?: 'ParentFieldNotInGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
   parentFieldId: Scalars['String']
}

export type ParentFieldOptions = {
   __typename?: 'ParentFieldOptions'
   options: Array<Scalars['String']>
   parentFieldId: Scalars['String']
}

export type ParentFieldOptionsForSearchAndMonitoringParams = {
   options: Array<Scalars['String']>
   parentFieldId: Scalars['String']
}

export type ParentFieldOptionsIsRequiredForDependentField = GraphQlBaseError & {
   __typename?: 'ParentFieldOptionsIsRequiredForDependentField'
   message?: Maybe<Scalars['String']>
}

export type ParentFieldOptionsParams = {
   options: Array<Scalars['String']>
   parentFieldId: Scalars['String']
}

export type ParentFieldsNotFilled = GraphQlBaseError & {
   __typename?: 'ParentFieldsNotFilled'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ParentIdIsRequired = GraphQlBaseError & {
   __typename?: 'ParentIdIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ParentNodeIdIsRequired = GraphQlBaseError & {
   __typename?: 'ParentNodeIdIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ParentNodeResultIsRequired = GraphQlBaseError & {
   __typename?: 'ParentNodeResultIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ParentOptionsShouldBeInExistingOptions = GraphQlBaseError & {
   __typename?: 'ParentOptionsShouldBeInExistingOptions'
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type ParentTabDoesNotBelongToLayout = GraphQlBaseError & {
   __typename?: 'ParentTabDoesNotBelongToLayout'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type ParentTabNotFound = GraphQlBaseError & {
   __typename?: 'ParentTabNotFound'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type ParentTabShouldBeNestedTab = GraphQlBaseError & {
   __typename?: 'ParentTabShouldBeNestedTab'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type PartialOrderDetailsInSubscription = {
   __typename?: 'PartialOrderDetailsInSubscription'
   dueAmount: Scalars['Float']
}

export enum PartiallyConfigurableLeadDistributionSetupStep {
   AgentAllocationGroups = 'AGENT_ALLOCATION_GROUPS',
   LeadDistributionRuleConfig = 'LEAD_DISTRIBUTION_RULE_CONFIG'
}

export type PartiallyConfiguredAgentAllocationGroups = GraphQlBaseError & {
   __typename?: 'PartiallyConfiguredAgentAllocationGroups'
   agentAllocationGroupIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type PartiallyConfiguredLeadDistributionStepsExists = GraphQlBaseError & {
   __typename?: 'PartiallyConfiguredLeadDistributionStepsExists'
   message?: Maybe<Scalars['String']>
   steps: Array<LeadDistributionRuleConfigStep>
}

export type PartiallyConfiguredNodesExists = GraphQlBaseError & {
   __typename?: 'PartiallyConfiguredNodesExists'
   message?: Maybe<Scalars['String']>
   nodeIds: Array<Maybe<Scalars['String']>>
}

export type PartiallyConfiguredRecordCreationConfig = GraphQlBaseError & {
   __typename?: 'PartiallyConfiguredRecordCreationConfig'
   message?: Maybe<Scalars['String']>
   recordCreationConfigId: Scalars['Int']
}

export enum ParticipantType {
   Architect = 'ARCHITECT',
   Assignee = 'ASSIGNEE',
   Citizen = 'CITIZEN',
   Na = 'NA'
}

export type PayloadIsNotSupportedInScheduledTrigger = GraphQlBaseError & {
   __typename?: 'PayloadIsNotSupportedInScheduledTrigger'
   message?: Maybe<Scalars['String']>
}

export type Payment = {
   __typename?: 'Payment'
   amount: Scalars['Int']
   creationDatetime: Scalars['String']
   description?: Maybe<Scalars['String']>
   expiryDatetime?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
   paymentSplit: Array<PaymentCategorySplit>
   paymentTowards: Scalars['String']
   referenceId?: Maybe<Scalars['String']>
   status: PaymentStatus
   statusUpdatedDatetime?: Maybe<Scalars['String']>
   transactionId?: Maybe<Scalars['String']>
}

export type PaymentAccessDenied = GraphQlBaseError & {
   __typename?: 'PaymentAccessDenied'
   message?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
}

export enum PaymentActionEnum {
   Cancelled = 'CANCELLED'
}

export type PaymentAlreadyInitiated = GraphQlBaseError & {
   __typename?: 'PaymentAlreadyInitiated'
   message?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
}

export type PaymentAmountMustBeGreaterThanZero = GraphQlBaseError & {
   __typename?: 'PaymentAmountMustBeGreaterThanZero'
   message?: Maybe<Scalars['String']>
}

export type PaymentCategorySplit = {
   __typename?: 'PaymentCategorySplit'
   amountInRs: Scalars['Int']
   category: Scalars['String']
}

export type PaymentDetails = {
   __typename?: 'PaymentDetails'
   amountInInr: Scalars['Float']
   baseAmountInInr: Scalars['Float']
   contributedEntities: Array<PaymentOrderContributedEntity>
   convenienceFeeInInr: Scalars['Float']
   orderId?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
   paymentMode?: Maybe<Scalars['String']>
   penaltyAmountInInr: Scalars['Float']
   razorpayOrderId?: Maybe<Scalars['String']>
   receipt?: Maybe<FileUploaderUrlResponse>
   refunds: Array<PaymentRefund>
   status: PaymentStatusEnum
   statusUpdatedDatetime: Scalars['String']
   transactionId?: Maybe<Scalars['String']>
}

export type PaymentDetailsType = {
   __typename?: 'PaymentDetailsType'
   amount: Scalars['Float']
   failedReason?: Maybe<Scalars['String']>
   paymentCurrency?: Maybe<Scalars['String']>
   paymentDatetime: Scalars['String']
   paymentDescription?: Maybe<Scalars['String']>
   paymentFees?: Maybe<Scalars['Float']>
   paymentId: Scalars['String']
   paymentMethodDetails?: Maybe<Scalars['String']>
   paymentMode: Scalars['String']
   paymentNotes?: Maybe<Scalars['String']>
   paymentReferenceNumber?: Maybe<Scalars['String']>
   paymentStatus: PaymentStatusEnum
   paymentTimeline: Array<TimelineEventType>
   razorpayOrderId: Scalars['String']
   refunds: Array<RefundDetailsType>
}

export type PaymentGatewayCodeNotFound = GraphQlBaseError & {
   __typename?: 'PaymentGatewayCodeNotFound'
   message?: Maybe<Scalars['String']>
   paymentGatewayCode: Scalars['String']
}

export type PaymentGatewayFailure = GraphQlBaseError & {
   __typename?: 'PaymentGatewayFailure'
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
}

export type PaymentHistoryOnPipelineItemParams = {
   pagination?: InputMaybe<Pagination>
   pipelineItemId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   statuses: Array<PaymentStatus>
}

export type PaymentHistoryOnPipelineItemResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PaymentHistoryResult
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type PaymentHistoryResult = {
   __typename?: 'PaymentHistoryResult'
   payments: Array<Payment>
   totalCount: Scalars['Int']
}

export type PaymentIsInDraftState = GraphQlBaseError & {
   __typename?: 'PaymentIsInDraftState'
   message?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
}

export type PaymentNotFound = GraphQlBaseError & {
   __typename?: 'PaymentNotFound'
   message?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
}

export type PaymentNotLinkedToPipelineItem = GraphQlBaseError & {
   __typename?: 'PaymentNotLinkedToPipelineItem'
   message?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type PaymentOrder = {
   __typename?: 'PaymentOrder'
   allowPartial: Scalars['Boolean']
   amountInInr: Scalars['Float']
   amountSplit: Array<AmountSplitDetails>
   baseAmountInInr: Scalars['Float']
   contributedEntities: Array<PaymentOrderContributedEntity>
   convenienceFeeInInr: Scalars['Float']
   createdAt: Scalars['String']
   dueDatetime?: Maybe<Scalars['String']>
   name: Scalars['String']
   orderId: Scalars['String']
   paidDatetime?: Maybe<Scalars['String']>
   partialOrderDueAmount?: Maybe<Scalars['Float']>
   partiallyPaidContributedEntityPenaltyAmountInInr: Scalars['Float']
   payments: Array<PaymentDetails>
   penaltyAmountInInr: Scalars['Float']
   pendingPenalty?: Maybe<PenaltyInfo>
   razorpayKey: Scalars['String']
   refund?: Maybe<OrderRefund>
   refundDetails?: Maybe<RefundDetails>
   remainingTimeToInitiatePaymentInSecs?: Maybe<Scalars['Int']>
   rzpayOrderId?: Maybe<Scalars['String']>
   status: OrderStatus
   successPopupConfig?: Maybe<OrderSuccessPopupConfig>
   tdrOrder?: Maybe<TdrOrder>
}

export type PaymentOrderAccessDenied = {
   __typename?: 'PaymentOrderAccessDenied'
   paymentOrderId: Scalars['String']
}

export type PaymentOrderAlreadyPaid = {
   __typename?: 'PaymentOrderAlreadyPaid'
   paymentOrderId: Scalars['String']
}

export type PaymentOrderContributedEntity = {
   __typename?: 'PaymentOrderContributedEntity'
   amount: Scalars['Float']
   canPayWithTdr: Scalars['Boolean']
   contributedEntityId: Scalars['String']
   entityName: Scalars['String']
   entityType: OrderContributedEntityType
   isSelected: Scalars['Boolean']
   orderId: Scalars['String']
   penaltyAmount?: Maybe<Scalars['Float']>
   status: OrderContributedEntityStatus
}

export type PaymentOrderIsInitiated = {
   __typename?: 'PaymentOrderIsInitiated'
   orderId: Scalars['String']
}

export type PaymentOrderIsProcessing = {
   __typename?: 'PaymentOrderIsProcessing'
   orderId: Scalars['String']
}

export type PaymentOrderNotFound = {
   __typename?: 'PaymentOrderNotFound'
   paymentOrderId: Scalars['String']
}

export type PaymentOrderPreview = {
   __typename?: 'PaymentOrderPreview'
   allowPartial: Scalars['Boolean']
   amountInInr: Scalars['Float']
   amountSplit: Array<AmountSplitDetails>
   dueDatetime?: Maybe<Scalars['String']>
   name: Scalars['String']
   orderId: Scalars['String']
}

export type PaymentReceiptNotExists = GraphQlBaseError & {
   __typename?: 'PaymentReceiptNotExists'
   message?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
}

export type PaymentRefund = {
   __typename?: 'PaymentRefund'
   amount: Scalars['Float']
   failureReason?: Maybe<Scalars['String']>
   paymentTransaction: PaymentTransaction
   refundBudgetHeads: Array<RefundBudgetHeadBreakdown>
   refundId: Scalars['String']
   refundMode: RefundRequestedType
   rzpayRefundId?: Maybe<Scalars['String']>
   status: RefundStatus
   statusUpdatedDatetime: Scalars['String']
   transactionId: Scalars['String']
}

export type PaymentRequestExpired = GraphQlBaseError & {
   __typename?: 'PaymentRequestExpired'
   message?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
}

export type PaymentRequestNotFound = GraphQlBaseError & {
   __typename?: 'PaymentRequestNotFound'
   message?: Maybe<Scalars['String']>
   paymentRequestId: Scalars['String']
}

export type PaymentRequestsNotFound = GraphQlBaseError & {
   __typename?: 'PaymentRequestsNotFound'
   message?: Maybe<Scalars['String']>
   paymentRequestIds: Array<Scalars['String']>
}

export type PaymentRuleOverviewDetails = {
   __typename?: 'PaymentRuleOverviewDetails'
   name: Scalars['String']
   ruleId: Scalars['String']
}

export type PaymentRuleSetNotFound = GraphQlBaseError & {
   __typename?: 'PaymentRuleSetNotFound'
   message?: Maybe<Scalars['String']>
   paymentRuleSetId: Scalars['String']
}

export type PaymentRuleSetOverviewDetails = {
   __typename?: 'PaymentRuleSetOverviewDetails'
   name: Scalars['String']
   ruleSetId: Scalars['String']
}

export enum PaymentRuleType {
   CustomRule = 'CUSTOM_RULE',
   SystemRule = 'SYSTEM_RULE'
}

export type PaymentRulesNotFound = GraphQlBaseError & {
   __typename?: 'PaymentRulesNotFound'
   message?: Maybe<Scalars['String']>
   ruleIds: Array<Scalars['String']>
}

export enum PaymentStatus {
   Attempted = 'ATTEMPTED',
   Cancelled = 'CANCELLED',
   Discarded = 'DISCARDED',
   Draft = 'DRAFT',
   Failed = 'FAILED',
   Initiated = 'INITIATED',
   Success = 'SUCCESS',
   UnderReview = 'UNDER_REVIEW',
   YetToPay = 'YET_TO_PAY'
}

export enum PaymentStatusEnum {
   Authorized = 'AUTHORIZED',
   Cancelled = 'CANCELLED',
   Created = 'CREATED',
   Failed = 'FAILED',
   Initiated = 'INITIATED',
   Paid = 'PAID',
   Refunded = 'REFUNDED',
   UnderReview = 'UNDER_REVIEW'
}

export type PaymentTab = BaseTab & {
   __typename?: 'PaymentTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   marketValueFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type PaymentTransaction = {
   __typename?: 'PaymentTransaction'
   amountInInr: Scalars['Float']
   baseAmountInInr: Scalars['Float']
   contributedEntities: Array<PaymentOrderContributedEntity>
   convenienceFeeInInr: Scalars['Float']
   name: Scalars['String']
   paymentId: Scalars['String']
   paymentMode?: Maybe<Scalars['String']>
   penaltyAmountInInr: Scalars['Float']
   receipt?: Maybe<FileUploaderUrlResponse>
   status: PaymentTransactionStatus
   statusUpdatedDatetime: Scalars['String']
   tdrRequest?: Maybe<TdrRequest>
   transactionId?: Maybe<Scalars['String']>
}

export type PaymentTransactionHistory = PaymentRefund | PaymentTransaction

export enum PaymentTransactionStatus {
   Failed = 'FAILED',
   Initiated = 'INITIATED',
   Paid = 'PAID',
   PartialPaid = 'PARTIAL_PAID',
   UnderReview = 'UNDER_REVIEW'
}

export type PaymentWiseRemarks = {
   __typename?: 'PaymentWiseRemarks'
   observation?: Maybe<BpsVerificationRecommendationEnum>
   paymentId: Scalars['String']
   remarks?: Maybe<Scalars['String']>
}

export type PaymentsInfo = {
   __typename?: 'PaymentsInfo'
   hasPendingPayments: Scalars['Boolean']
   pendingPaymentsCount: Scalars['Int']
}

export type PaymentsVerificationRemarks = {
   __typename?: 'PaymentsVerificationRemarks'
   overallObservation?: Maybe<TdrPaymentVerificationRecommendationEnum>
   overallRemarks?: Maybe<Scalars['String']>
   paymentWiseRemarks: Array<PaymentWiseRemarks>
}

export type PenaltyInfo = {
   __typename?: 'PenaltyInfo'
   amountPerUnit: Scalars['Float']
   numberOfUnits: Scalars['Int']
   totalPenaltyAmount: Scalars['Float']
}

export type PendingTdrRequestsShouldBeAccepted = GraphQlBaseError & {
   __typename?: 'PendingTDRRequestsShouldBeAccepted'
   message?: Maybe<Scalars['String']>
}

export type PendingTasksExistOnPipelineItem = GraphQlBaseError & {
   __typename?: 'PendingTasksExistOnPipelineItem'
   message?: Maybe<Scalars['String']>
   names: Array<Scalars['String']>
}

export enum PermissionOverrideType {
   ForceReadOnly = 'FORCE_READ_ONLY',
   NoOverride = 'NO_OVERRIDE'
}

export enum PermissionType {
   Read = 'READ',
   Write = 'WRITE'
}

export type PermitOrderIdGenerationConfig = {
   __typename?: 'PermitOrderIdGenerationConfig'
   districtAdministrationFieldId?: Maybe<Scalars['String']>
   gpCodeFieldId?: Maybe<Scalars['String']>
   isEnabled: Scalars['Boolean']
   permitOrderIdFieldId: Scalars['String']
   projectTypeFieldId?: Maybe<Scalars['String']>
   zonalCodeFieldId?: Maybe<Scalars['String']>
}

export type PermittedStagesResult =
   | FromStageNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | Stages

export type PhoneNumberAlreadyVerified = GraphQlBaseError & {
   __typename?: 'PhoneNumberAlreadyVerified'
   message?: Maybe<Scalars['String']>
   phoneNumber?: Maybe<PhoneNumberResponse>
}

export type PhoneNumberField = BaseField & {
   __typename?: 'PhoneNumberField'
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   enableOtpVerification?: Maybe<Scalars['Boolean']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isIdentificationField: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type PhoneNumberFieldResponseNotFilled = GraphQlBaseError & {
   __typename?: 'PhoneNumberFieldResponseNotFilled'
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type PhoneNumberFieldResponsesDoNotHaveWhatsappConsent = GraphQlBaseError & {
   __typename?: 'PhoneNumberFieldResponsesDoNotHaveWhatsappConsent'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type PhoneNumberFieldResult =
   | FieldIsDeleted
   | FieldNotFound
   | NotPermittedField
   | PhoneNumberField

export type PhoneNumberIdentificationFieldNotSupportedPipeline = GraphQlBaseError & {
   __typename?: 'PhoneNumberIdentificationFieldNotSupportedPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type PhoneNumberIdentificationFieldNotSupportedPipelineItemTemplate = GraphQlBaseError & {
   __typename?: 'PhoneNumberIdentificationFieldNotSupportedPipelineItemTemplate'
   message?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export enum PhoneNumberOtpVerificationStatus {
   UnVerified = 'UN_VERIFIED',
   Verified = 'VERIFIED'
}

export type PhoneNumberParams = {
   dialCode: Scalars['String']
   iso2CountryCode?: InputMaybe<Scalars['String']>
   phoneNumber: Scalars['String']
}

export type PhoneNumberReferenceFieldMustBeIdentifierPhoneNumber = GraphQlBaseError & {
   __typename?: 'PhoneNumberReferenceFieldMustBeIdentifierPhoneNumber'
   message?: Maybe<Scalars['String']>
}

export type PhoneNumberResponse = {
   __typename?: 'PhoneNumberResponse'
   dialCode: Scalars['String']
   iso2CountryCode?: Maybe<Scalars['String']>
   otpVerificationStatus?: Maybe<PhoneNumberOtpVerificationStatus>
   phoneNumber: Scalars['String']
}

export type PhoneNumberUpdatedAgainForField = GraphQlBaseError & {
   __typename?: 'PhoneNumberUpdatedAgainForField'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export enum PhoneNumberValueFormatEnum {
   ExcludeCountryCode = 'EXCLUDE_COUNTRY_CODE',
   IncludeCountryCode = 'INCLUDE_COUNTRY_CODE',
   IncludeCountryCodeWithoutPlusSign = 'INCLUDE_COUNTRY_CODE_WITHOUT_PLUS_SIGN'
}

export type PhoneNumberValueFormatIsNotSupportedForFields = GraphQlBaseError & {
   __typename?: 'PhoneNumberValueFormatIsNotSupportedForFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type PhoneNumberValueFormatIsNotValid = GraphQlBaseError & {
   __typename?: 'PhoneNumberValueFormatIsNotValid'
   message?: Maybe<Scalars['String']>
   value?: Maybe<Scalars['String']>
}

export type PieChart = {
   __typename?: 'PieChart'
   data: Array<PieChartData>
   dimensionName: Scalars['String']
   graphId: Scalars['String']
   metricName: Scalars['String']
   totalValue: Scalars['String']
}

export type PieChartConfig = {
   __typename?: 'PieChartConfig'
   analyticsLevel: AnalyticsLevel
   dataLabelsType: GraphDataLabelsType
   dataSources: Array<AnalyticsDataSourceType>
   dataSourcesWithDisplayNames: Array<DataSourceDisplayName>
   description?: Maybe<Scalars['String']>
   dimension: GraphDimension
   filterSetId: Scalars['String']
   graphId: Scalars['String']
   isOwner: Scalars['Boolean']
   metric: GraphMetric
   name: Scalars['String']
   numberOfSlices: Scalars['Int']
   pipelineId: Scalars['String']
   quickFilterFields: Array<GraphQuickFilterField>
   roles: Array<Role>
}

export type PieChartData = {
   __typename?: 'PieChartData'
   displayValue: Scalars['String']
   name: GraphDimensionValue
   percentage: Scalars['String']
   value: Scalars['String']
}

export type PieChartResult =
   | DashboardAccessDenied
   | DashboardNotFound
   | GraphAccessDenied
   | GraphMetricNotFound
   | GraphNotFound
   | InvalidLimit
   | InvalidOffset
   | NotSupportedGraphParenType
   | PieChart
   | ViewAccessDenied
   | ViewNotFound

export type PinComplexityValidationFailed = GraphQlBaseError & {
   __typename?: 'PinComplexityValidationFailed'
   failures: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type PinMatchesPreviousPin = GraphQlBaseError & {
   __typename?: 'PinMatchesPreviousPin'
   message?: Maybe<Scalars['String']>
}

export type PinPipelineItemsParams = {
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemIds: Array<Scalars['String']>
}

export type PinPipelineItemsResponse =
   | PinPipelineItemsResult
   | PinnedPipelineItemsLimitExceeded
   | PipelineItemsAccessDenied
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound

export type PinPipelineItemsResult = {
   __typename?: 'PinPipelineItemsResult'
   pinnedPipelineItems: Array<PinnedPipelineItem>
}

export enum PinPurpose {
   ESign = 'E_SIGN'
}

export type PinnedByUserNotFound = GraphQlBaseError & {
   __typename?: 'PinnedByUserNotFound'
   message?: Maybe<Scalars['String']>
   pinnedByUserId: Scalars['String']
}

export type PinnedPipelineItem = {
   __typename?: 'PinnedPipelineItem'
   order: Scalars['Int']
   pipelineItem: PipelineItemPrimaryDetails
   pipelineItemPinnedId: Scalars['String']
   userId: Scalars['String']
}

export type PinnedPipelineItemIdsInViewResponse =
   | AccessDeniedForPinnedByUser
   | InvalidLimit
   | InvalidOffset
   | ItemIdsInViewResult
   | NotPinnedPipelineItemsView
   | PaginationLimitExceeded
   | PinnedByUserNotFound
   | ViewAccessDenied
   | ViewNotFound

export type PinnedPipelineItemsCountResult = {
   __typename?: 'PinnedPipelineItemsCountResult'
   totalCount: Scalars['Int']
}

export type PinnedPipelineItemsLimitExceeded = GraphQlBaseError & {
   __typename?: 'PinnedPipelineItemsLimitExceeded'
   maxLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
   pinnedCount: Scalars['Int']
}

export type PinnedPipelineItemsResult = {
   __typename?: 'PinnedPipelineItemsResult'
   pinnedPipelineItems: Array<PinnedPipelineItem>
   totalCount: Scalars['Int']
}

export type Pipeline = {
   __typename?: 'Pipeline'
   accountId: Scalars['String']
   color?: Maybe<Scalars['String']>
   createdBy: User
   displayName: Scalars['String']
   identificationWisePipelineActions: Array<IdentificationPipelineActions>
   isActivitiesFeatureEnabled: Scalars['Boolean']
   isAdvancedAnalyticsEnabled: Scalars['Boolean']
   isMainPipeline: Scalars['Boolean']
   isTasksFeatureEnabled: Scalars['Boolean']
   isWhatsappConsentRequired: Scalars['Boolean']
   name: Scalars['String']
   pipelineIconId?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemCreationAllowedStageIds: Array<Scalars['String']>
   pipelineItemTemplateConfig: PipelineItemTemplateConfig
   pipelineItemTemplateId: Scalars['String']
   pipelineItemType: PipelineItemType
   pipelineType: PipelineTypeEnum
   stageBoardsOwner?: Maybe<BaseUser>
   stageTransitionStyle: PipelineStageTransitionUiStyle
}

export type PipelineAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineAccessDenied'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type PipelineAccessDeniedToAgents = GraphQlBaseError & {
   __typename?: 'PipelineAccessDeniedToAgents'
   agentIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type PipelineAccessDeniedToAssignee = GraphQlBaseError & {
   __typename?: 'PipelineAccessDeniedToAssignee'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type PipelineAccessDeniedToAssignees = GraphQlBaseError & {
   __typename?: 'PipelineAccessDeniedToAssignees'
   assigneeIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type PipelineAccessDeniedToUsers = GraphQlBaseError & {
   __typename?: 'PipelineAccessDeniedToUsers'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   userIds: Array<Scalars['String']>
}

export enum PipelineActionType {
   CreateLeadWithContact = 'CREATE_LEAD_WITH_CONTACT'
}

export type PipelineActivityTemplateIds = {
   __typename?: 'PipelineActivityTemplateIds'
   activityTemplateIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type PipelineAndAdminAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'PipelineAndAdminAreNotInSameAccount'
   message?: Maybe<Scalars['String']>
}

export type PipelineAndIdentificationsAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'PipelineAndIdentificationsAreNotInSameAccount'
   message?: Maybe<Scalars['String']>
}

export type PipelineAssigneeFieldsNotFound = GraphQlBaseError & {
   __typename?: 'PipelineAssigneeFieldsNotFound'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type PipelineAutomationWorkflowConfigParams = {
   pipelineId: Scalars['String']
}

export type PipelineAutomationWorkflowConfigResponse =
   | AutomationWorkflowConfig
   | PipelineNotFound
   | UserIsNotAnAdministrator

export type PipelineConfig = {
   __typename?: 'PipelineConfig'
   pipelineId: Scalars['String']
   pipelineName: Scalars['String']
   pipelineType: PipelineTypeEnum
}

export type PipelineCrmTemplates = {
   __typename?: 'PipelineCrmTemplates'
   activityTemplateIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
   taskTemplateIds: Array<Scalars['String']>
}

export type PipelineCustomObject = BasePipelineItem & {
   __typename?: 'PipelineCustomObject'
   createdAt: Scalars['String']
   fields: Array<SystemFieldEnumResponseResult>
   latestActivity?: Maybe<Activity>
   latestRemarks?: Maybe<PipelineItemRemarks>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   task?: Maybe<Task>
}

export type PipelineCustomObjectFieldsArgs = {
   systemFieldEnums: Array<CustomObjectSystemFieldEnum>
}

export type PipelineCustomObjectAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineCustomObjectAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineCustomObjectId: Scalars['String']
}

export type PipelineCustomObjectAlreadyExists = GraphQlBaseError & {
   __typename?: 'PipelineCustomObjectAlreadyExists'
   customObjectId: Scalars['String']
   hasPermission: Scalars['Boolean']
   leadTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type PipelineCustomObjectAssigneeIsDeactivated = GraphQlBaseError & {
   __typename?: 'PipelineCustomObjectAssigneeIsDeactivated'
   assigneeId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type PipelineCustomObjectAssigneeNotFound = GraphQlBaseError & {
   __typename?: 'PipelineCustomObjectAssigneeNotFound'
   message?: Maybe<Scalars['String']>
}

export type PipelineCustomObjectFieldResponse = {
   __typename?: 'PipelineCustomObjectFieldResponse'
   fieldResponse: FieldResponse
   pipelineCustomObjectId: Scalars['String']
}

export type PipelineCustomObjectFieldResult =
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldNotFound
   | FieldResponse
   | NotPermittedField
   | NotPipelineCustomObjectField

export type PipelineCustomObjectIsDeleted = GraphQlBaseError & {
   __typename?: 'PipelineCustomObjectIsDeleted'
   message?: Maybe<Scalars['String']>
   pipelineCustomObjectId: Scalars['String']
}

export type PipelineCustomObjectNotFound = GraphQlBaseError & {
   __typename?: 'PipelineCustomObjectNotFound'
   message?: Maybe<Scalars['String']>
   pipelineCustomObjectId: Scalars['String']
}

export type PipelineCustomObjectProperties = BasePipelineItemProperties & {
   __typename?: 'PipelineCustomObjectProperties'
   createdAt: Scalars['String']
   fields: Array<FieldResponseResult>
   latestRemarks?: Maybe<PipelineItemRemarks>
   pipelineItemId: Scalars['String']
   pipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemSchedule?: Maybe<PipelineItemSchedule>
   pipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   scheduledPipelineItem?: Maybe<ScheduledPipelineItem>
}

export type PipelineCustomObjectPropertiesFieldsArgs = {
   fieldIds: Array<Scalars['String']>
}

export type PipelineCustomObjectPropertiesResponse =
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound
   | PipelineCustomObjectProperties

export type PipelineCustomObjectSystemFieldResult = {
   __typename?: 'PipelineCustomObjectSystemFieldResult'
   fields: Array<SystemFieldEnumResponseResult>
   pipelineCustomObjectId: Scalars['String']
}

export type PipelineCustomObjectSystemFieldsResponse =
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound
   | PipelineCustomObjectSystemFieldResult

export type PipelineCustomObjectsAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineCustomObjectsAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineCustomObjectIds: Array<Scalars['String']>
}

export type PipelineCustomObjectsAreDeleted = GraphQlBaseError & {
   __typename?: 'PipelineCustomObjectsAreDeleted'
   message?: Maybe<Scalars['String']>
   pipelineCustomObjectIds: Array<Scalars['String']>
}

export type PipelineCustomObjectsNotFound = GraphQlBaseError & {
   __typename?: 'PipelineCustomObjectsNotFound'
   message?: Maybe<Scalars['String']>
   pipelineCustomObjectIds: Array<Scalars['String']>
}

export type PipelineDisplayNameAlreadyExistsInAccount = GraphQlBaseError & {
   __typename?: 'PipelineDisplayNameAlreadyExistsInAccount'
   displayName: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type PipelineDisplayNameIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineDisplayNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineDocumentTemplatesForAdminResult = {
   __typename?: 'PipelineDocumentTemplatesForAdminResult'
   documentTemplates: Array<AdminDocumentTemplate>
   totalCount: Scalars['Int']
}

export type PipelineDocumentTemplatesResult = {
   __typename?: 'PipelineDocumentTemplatesResult'
   documentTemplates?: Maybe<Array<Maybe<DocumentTemplate>>>
   totalCount: Scalars['Int']
}

export type PipelineEvent = {
   __typename?: 'PipelineEvent'
   fields: Array<SystemFieldEnumResponseResult>
   pipelineEventId: Scalars['String']
   pipelineEventTemplateId: Scalars['String']
}

export type PipelineEventFieldsArgs = {
   systemFieldEnums: Array<PipelineEventSystemFieldEnum>
}

export type PipelineEventAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineEventAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineEventId: Scalars['String']
}

export type PipelineEventFieldResult =
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldNotFound
   | FieldResponse
   | NotPermittedField
   | NotPipelineEventField

export type PipelineEventNotFound = GraphQlBaseError & {
   __typename?: 'PipelineEventNotFound'
   message?: Maybe<Scalars['String']>
   pipelineEventId: Scalars['String']
}

export type PipelineEventPipelineItemCreationConfig = {
   __typename?: 'PipelineEventPipelineItemCreationConfig'
   pipelineEventTemplateId: Scalars['String']
   stage?: Maybe<Stage>
}

export enum PipelineEventSystemFieldEnum {
   PipelineEventAssignee = 'PIPELINE_EVENT_ASSIGNEE',
   PipelineEventPipelineId = 'PIPELINE_EVENT_PIPELINE_ID',
   PipelineEventPipelineItemId = 'PIPELINE_EVENT_PIPELINE_ITEM_ID'
}

export type PipelineEventTemplate = {
   __typename?: 'PipelineEventTemplate'
   createdAt: Scalars['String']
   description?: Maybe<Scalars['String']>
   gofs: Array<GoF>
   name: Scalars['String']
   orderedGofIds: Array<Scalars['String']>
   pipelineEventTemplateId: Scalars['String']
   pipelineId: Scalars['String']
   pipelineItemCreationConfig: PipelineEventPipelineItemCreationConfig
}

export type PipelineEventTemplateAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineEventTemplateAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineEventTemplateId: Scalars['String']
}

export type PipelineEventTemplateAndStageAreNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'PipelineEventTemplateAndStageAreNotInSamePipeline'
   message?: Maybe<Scalars['String']>
   pipelineEventTemplateId: Scalars['String']
   stageId: Scalars['String']
}

export type PipelineEventTemplateNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'PipelineEventTemplateNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type PipelineEventTemplateNotFound = GraphQlBaseError & {
   __typename?: 'PipelineEventTemplateNotFound'
   message?: Maybe<Scalars['String']>
   pipelineEventTemplateId: Scalars['String']
}

export type PipelineEventTemplateNotInGivenPipeline = GraphQlBaseError & {
   __typename?: 'PipelineEventTemplateNotInGivenPipeline'
   message?: Maybe<Scalars['String']>
   pipelineEventTemplateId: Scalars['String']
   pipelineId: Scalars['String']
}

export type PipelineEventTemplateResult =
   | PipelineEventTemplate
   | PipelineEventTemplateAccessDenied
   | PipelineEventTemplateNotFound

export type PipelineEventTemplatesParams = {
   pipelineEventTemplateIds: Array<Scalars['String']>
}

export type PipelineGroupLogsInPortalResult = {
   __typename?: 'PipelineGroupLogsInPortalResult'
   assigneeTimeSpentLogSummary: Array<StageAssigneeTimespentLogSummary>
   pipelineIds: Array<Scalars['String']>
   submissions: Array<AssigneeTimeSpentLogsForSubmission>
}

export type PipelineGroupLogsResult = {
   __typename?: 'PipelineGroupLogsResult'
   assigneeTimeSpentLogSummary: Array<StageAssigneeTimespentLogSummary>
   pipelineIds: Array<Scalars['String']>
   submissions: Array<AssigneeTimeSpentLogsForSubmission>
}

export type PipelineIdentificationsResponse =
   | IdentificationsResult
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineNotFound
   | PipelineNotInUserAccount
   | UserIsNotAnAdministrator

export type PipelineIdsNotInPipelineItemTemplate = GraphQlBaseError & {
   __typename?: 'PipelineIdsNotInPipelineItemTemplate'
   message?: Maybe<Scalars['String']>
   pipelineIds: Array<Scalars['String']>
}

export type PipelineIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineItemAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export enum PipelineItemAccessType {
   NoAccess = 'NO_ACCESS',
   Read = 'READ',
   Write = 'WRITE'
}

export type PipelineItemActivities = {
   __typename?: 'PipelineItemActivities'
   activities: Array<Activity>
   totalCount: Scalars['Int']
}

export type PipelineItemActivitiesInPortal = {
   __typename?: 'PipelineItemActivitiesInPortal'
   activities: Array<PortalActivity>
   totalCount: Scalars['Int']
}

export type PipelineItemActivitiesInPortalResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemActivitiesInPortal
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type PipelineItemActivitiesResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemActivities
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type PipelineItemActivityCreatedHistory = {
   __typename?: 'PipelineItemActivityCreatedHistory'
   activityId: Scalars['String']
   activityTemplateId: Scalars['String']
   title: Scalars['String']
}

export type PipelineItemAlreadyMovedToPipeline = GraphQlBaseError & {
   __typename?: 'PipelineItemAlreadyMovedToPipeline'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type PipelineItemAlreadyScheduled = GraphQlBaseError & {
   __typename?: 'PipelineItemAlreadyScheduled'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type PipelineItemAndTaskTemplateFromDifferentPipeline = GraphQlBaseError & {
   __typename?: 'PipelineItemAndTaskTemplateFromDifferentPipeline'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemAppealTasks = {
   __typename?: 'PipelineItemAppealTasks'
   appealId: Scalars['String']
   appealStatus: AppealStatus
   pipelineItemId: Scalars['String']
   tasks: Array<AppealTask>
}

export type PipelineItemAssignee = {
   __typename?: 'PipelineItemAssignee'
   assignee?: Maybe<BaseUser>
   assigneeFieldId: Scalars['String']
   assigneeFieldName: Scalars['String']
   isPermitted: Scalars['Boolean']
}

export type PipelineItemAssigneeAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineItemAssigneeAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineItemAssigneeId: Scalars['String']
}

export type PipelineItemAssigneeFieldCanNotBeManagerField = GraphQlBaseError & {
   __typename?: 'PipelineItemAssigneeFieldCanNotBeManagerField'
   message?: Maybe<Scalars['String']>
   pipelineItemAssigneeFieldId: Scalars['String']
}

export type PipelineItemAssigneeFieldNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemAssigneeFieldNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemAssigneeFieldId: Scalars['String']
}

export type PipelineItemAssigneeHistory = {
   __typename?: 'PipelineItemAssigneeHistory'
   assigneeField?: Maybe<PlainTextField>
   currentAssignee?: Maybe<BaseUser>
   previousAssignee?: Maybe<BaseUser>
}

export type PipelineItemAssigneeIsDeactivated = GraphQlBaseError & {
   __typename?: 'PipelineItemAssigneeIsDeactivated'
   message?: Maybe<Scalars['String']>
   pipelineItemAssigneeId: Scalars['String']
}

export type PipelineItemAssigneeNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemAssigneeNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemAssigneeId: Scalars['String']
}

export type PipelineItemAssigneeUpdateNotification = {
   __typename?: 'PipelineItemAssigneeUpdateNotification'
   message?: Maybe<Scalars['String']>
   notificationId: Scalars['String']
   notificationType: NotificationTypes
   pipelineItemDetails: NotificationPipelineItemDetails
   readAt?: Maybe<Scalars['String']>
   sentAt: Scalars['String']
   title: Scalars['String']
}

export type PipelineItemAssociatedPipeline = {
   __typename?: 'PipelineItemAssociatedPipeline'
   hasPermission: Scalars['Boolean']
   pipeline: BasePipeline
   pipelineItemId: Scalars['String']
   stage: Stage
}

export type PipelineItemBaseDetails = {
   __typename?: 'PipelineItemBaseDetails'
   hasPermission: Scalars['Boolean']
   isDeleted: Scalars['Boolean']
   name?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemType: PipelineItemType
}

export type PipelineItemCallLogHistory = {
   __typename?: 'PipelineItemCallLogHistory'
   callLog: CallLog
}

export type PipelineItemCurrentStageSlaFieldInPipelineResponse =
   | PipelineItemAccessDenied
   | PipelineItemNotExistsInPipeline
   | PipelineItemNotFound
   | PipelineItemSlaFieldResponse
   | PipelineItemSlaFieldResponses
   | PipelineNotFound

export type PipelineItemDetailsDocumentTemplateConfig = {
   __typename?: 'PipelineItemDetailsDocumentTemplateConfig'
   actionName: Scalars['String']
   documentTemplateId: Scalars['String']
}

export type PipelineItemDisplayStageHistory = {
   __typename?: 'PipelineItemDisplayStageHistory'
   fromStage?: Maybe<Stage>
   pipeline: BasePipeline
   toStage: Stage
}

export type PipelineItemDisplayStageUpdateResult = {
   __typename?: 'PipelineItemDisplayStageUpdateResult'
   fromStage?: Maybe<Stage>
   toStage: Stage
}

export type PipelineItemDocumentTemplatesResult = {
   __typename?: 'PipelineItemDocumentTemplatesResult'
   documentTemplates?: Maybe<Array<Maybe<DocumentTemplate>>>
   totalCount: Scalars['Int']
}

export type PipelineItemFieldLog = {
   __typename?: 'PipelineItemFieldLog'
   currentResponse?: Maybe<Scalars['String']>
   currentResponseConv?: Maybe<FieldResponseType>
   field: FieldPrimaryDetails
   gofResponseId?: Maybe<Scalars['String']>
   isGofResponseDeleted?: Maybe<Scalars['Boolean']>
   logId: Scalars['Int']
   previousResponse?: Maybe<Scalars['String']>
   previousResponseConv?: Maybe<FieldResponseType>
   responseUpdatedDatetime: Scalars['String']
   updatedBy?: Maybe<BaseUser>
   userType?: Maybe<UserType>
}

export type PipelineItemFieldLogInPortal = {
   __typename?: 'PipelineItemFieldLogInPortal'
   currentResponse?: Maybe<Scalars['String']>
   field: FieldPrimaryDetails
   gofResponseId?: Maybe<Scalars['String']>
   previousResponse?: Maybe<Scalars['String']>
   responseUpdatedDatetime: Scalars['String']
   updatedBy?: Maybe<BaseUser>
   userType?: Maybe<UserType>
}

export type PipelineItemFieldPermissionsResponse =
   | PipelineItemAccessDenied
   | PipelineItemFieldPermissionsResult
   | PipelineItemNotFound

export type PipelineItemFieldPermissionsResult = {
   __typename?: 'PipelineItemFieldPermissionsResult'
   fieldPermissions?: Maybe<Array<Maybe<FieldPermissionType>>>
}

export type PipelineItemFieldShortfallLogs = {
   __typename?: 'PipelineItemFieldShortfallLogs'
   fieldLogs: Array<PipelineItemShortfallLog>
}

export type PipelineItemFieldShortfallLogsInPortalResponse =
   | PipelineItemAccessDenied
   | PipelineItemFieldShortfallLogs
   | PipelineItemNotFound
   | PortalNotFound

export type PipelineItemFieldShortfallLogsResponse =
   | PipelineItemAccessDenied
   | PipelineItemFieldShortfallLogs
   | PipelineItemNotFound

export type PipelineItemFieldToLog = {
   __typename?: 'PipelineItemFieldToLog'
   field: FieldPrimaryDetails
}

export type PipelineItemFieldsLogCount = {
   __typename?: 'PipelineItemFieldsLogCount'
   field: FieldPrimaryDetails
   gofResponseId?: Maybe<Scalars['String']>
   logCount: Scalars['Int']
}

export type PipelineItemFieldsLogCountInPortal = {
   __typename?: 'PipelineItemFieldsLogCountInPortal'
   field: FieldPrimaryDetails
   gofResponseId?: Maybe<Scalars['String']>
   logCount: Scalars['Int']
}

export type PipelineItemGeneratedRemarks = {
   __typename?: 'PipelineItemGeneratedRemarks'
   remarks?: Maybe<Scalars['String']>
}

export type PipelineItemHistory = {
   __typename?: 'PipelineItemHistory'
   data?: Maybe<PipelineItemHistoryDetails>
   eventDatetime: Scalars['String']
   eventDoneBy?: Maybe<EventDoneBy>
   pipelineItemHistoryEventType: PipelineItemHistoryEventType
   pipelineItemHistoryId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemType: PipelineItemType
}

export type PipelineItemHistoryData = BaseUser | PipelineItemStageHistory

export type PipelineItemHistoryDetails =
   | PipelineItemActivityCreatedHistory
   | PipelineItemAssigneeHistory
   | PipelineItemCallLogHistory
   | PipelineItemDisplayStageHistory
   | PipelineItemPaymentHistory
   | PipelineItemPipelineEventHistory
   | PipelineItemStageHistory
   | PipelineItemTaskCompletedHistory

export enum PipelineItemHistoryEventType {
   ActivityCreated = 'ACTIVITY_CREATED',
   AssigneeUpdated = 'ASSIGNEE_UPDATED',
   CallLog = 'CALL_LOG',
   Created = 'CREATED',
   DisplayStageUpdated = 'DISPLAY_STAGE_UPDATED',
   PaymentHistory = 'PAYMENT_HISTORY',
   PipelineEventCreated = 'PIPELINE_EVENT_CREATED',
   PipelineItemMerged = 'PIPELINE_ITEM_MERGED',
   StageUpdated = 'STAGE_UPDATED',
   TaskCompleted = 'TASK_COMPLETED'
}

export type PipelineItemHistoryResult = {
   __typename?: 'PipelineItemHistoryResult'
   history: Array<PipelineItemHistory>
   totalCount: Scalars['Int']
}

export type PipelineItemIsAlreadyScheduled = GraphQlBaseError & {
   __typename?: 'PipelineItemIsAlreadyScheduled'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type PipelineItemIsDeleted = GraphQlBaseError & {
   __typename?: 'PipelineItemIsDeleted'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type PipelineItemMergeRequestIsInProgress = GraphQlBaseError & {
   __typename?: 'PipelineItemMergeRequestIsInProgress'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type PipelineItemMessageTemplate = {
   __typename?: 'PipelineItemMessageTemplate'
   body?: Maybe<Scalars['String']>
   buttons: Array<WhatsAppMessageButton>
   footer?: Maybe<Scalars['String']>
   header?: Maybe<Scalars['String']>
   mediaName?: Maybe<Scalars['String']>
   mediaType?: Maybe<WhatsAppMessageMediaType>
   mediaUrl?: Maybe<Scalars['String']>
   messageType: WhatsAppMessageType
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type PipelineItemMissedCallNotification = {
   __typename?: 'PipelineItemMissedCallNotification'
   callLogId: Scalars['String']
   message?: Maybe<Scalars['String']>
   notificationId: Scalars['String']
   notificationType: NotificationTypes
   pipelineItemDetails: NotificationPipelineItemDetails
   readAt?: Maybe<Scalars['String']>
   sentAt: Scalars['String']
   title: Scalars['String']
}

export type PipelineItemNotExistsInPipeline = GraphQlBaseError & {
   __typename?: 'PipelineItemNotExistsInPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type PipelineItemNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type PipelineItemNotInFromStage = GraphQlBaseError & {
   __typename?: 'PipelineItemNotInFromStage'
   fromStageId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type PipelineItemNotInPipeline = GraphQlBaseError & {
   __typename?: 'PipelineItemNotInPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type PipelineItemNoteSheetPermissionsResult = {
   __typename?: 'PipelineItemNoteSheetPermissionsResult'
   hasNoteSheetPermission: Scalars['Boolean']
}

export type PipelineItemOrdersAndPaymentsType = {
   __typename?: 'PipelineItemOrdersAndPaymentsType'
   orders: Array<OrderDetailsType>
   pipelineItemId: Scalars['String']
}

export type PipelineItemOverviewDetails = {
   __typename?: 'PipelineItemOverviewDetails'
   name?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
}

export type PipelineItemPaymentCategorySplit = {
   __typename?: 'PipelineItemPaymentCategorySplit'
   amountInRs: Scalars['Int']
   category: Scalars['String']
}

export type PipelineItemPaymentHistory = {
   __typename?: 'PipelineItemPaymentHistory'
   amount: Scalars['Float']
   paymentSplit: Array<PipelineItemPaymentCategorySplit>
   paymentTowards: Scalars['String']
   status: PipelineItemPaymentStatus
   transactionId?: Maybe<Scalars['String']>
}

export type PipelineItemPaymentRequest = {
   __typename?: 'PipelineItemPaymentRequest'
   creationDatetime: Scalars['String']
   description?: Maybe<Scalars['String']>
   name: Scalars['String']
   paymentRequestId: Scalars['String']
   ruleSet: PipelineItemPaymentRuleSet
   status: PaymentStatus
   statusUpdatedDatetime?: Maybe<Scalars['String']>
   transactionId?: Maybe<Scalars['String']>
}

export type PipelineItemPaymentRule = {
   __typename?: 'PipelineItemPaymentRule'
   advanceAdjustedAmount: Scalars['Int']
   computedFormula: Scalars['String']
   computedFormulaAmount: Scalars['Int']
   displayFormula: Scalars['String']
   formula: Scalars['String']
   grossAmount: Scalars['Int']
   modifiedBy?: Maybe<BaseUser>
   name: Scalars['String']
   netAmount: Scalars['Int']
   remarks?: Maybe<Scalars['String']>
   ruleId: Scalars['String']
   ruleType: PaymentRuleType
}

export type PipelineItemPaymentRuleEditsParams = {
   advanceAdjustedAmount?: InputMaybe<Scalars['Int']>
   grossAmount: Scalars['Int']
   remarks?: InputMaybe<Scalars['String']>
   ruleId: Scalars['String']
}

export type PipelineItemPaymentRuleSet = {
   __typename?: 'PipelineItemPaymentRuleSet'
   amount: Scalars['Int']
   name: Scalars['String']
   ruleSetId: Scalars['String']
   rules: Array<PipelineItemPaymentRule>
}

export type PipelineItemPaymentRulesWereNotSatisfied = GraphQlBaseError & {
   __typename?: 'PipelineItemPaymentRulesWereNotSatisfied'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   ruleSetId: Scalars['String']
}

export enum PipelineItemPaymentStatus {
   Cancelled = 'CANCELLED',
   Completed = 'COMPLETED',
   Created = 'CREATED',
   Discarded = 'DISCARDED',
   Failed = 'FAILED'
}

export type PipelineItemPermittedStagesResult =
   | FromStageNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | Stages

export type PipelineItemPinnedIdsAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineItemPinnedIdsAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineItemPinnedIds: Array<Scalars['String']>
}

export type PipelineItemPinnedIdsNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemPinnedIdsNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemPinnedIds: Array<Scalars['String']>
}

export type PipelineItemPipelineEventHistory = {
   __typename?: 'PipelineItemPipelineEventHistory'
   pipelineEvent?: Maybe<PipelineEvent>
}

export type PipelineItemPipelines = {
   __typename?: 'PipelineItemPipelines'
   pipelineItemId: Scalars['String']
   pipelines: Array<PipelineItemAssociatedPipeline>
}

export type PipelineItemPluralNameIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineItemPluralNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemPrimaryDetails =
   | ApplicationPrimaryDetails
   | CustomObjectPrimaryDetails
   | DealPrimaryDetails
   | LeadPrimaryDetails

export type PipelineItemPrimaryDisplayFieldNameIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineItemPrimaryDisplayFieldNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemPrimaryFieldResult = FieldIsNotCreated | FieldResponse

export type PipelineItemPropertiesWithoutPermission = {
   __typename?: 'PipelineItemPropertiesWithoutPermission'
   fields: Array<FieldResponse>
   pipelineItemId: Scalars['String']
}

export type PipelineItemPropertiesWithoutPermissionResult = {
   __typename?: 'PipelineItemPropertiesWithoutPermissionResult'
   pipelineItemProperties: Array<PipelineItemPropertiesWithoutPermissionUnion>
}

export type PipelineItemPropertiesWithoutPermissionUnion =
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineItemPropertiesWithoutPermission

export type PipelineItemRemarks = {
   __typename?: 'PipelineItemRemarks'
   addedAt: Scalars['String']
   addedBy: BaseUser
   attachments: Array<RemarksAttachment>
   fieldId?: Maybe<Scalars['String']>
   lastUpdatedAt?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   pipelineItemRemarksId: Scalars['String']
   remarks?: Maybe<Scalars['String']>
   remarksType: RemarksType
   taskReferenceId?: Maybe<Scalars['String']>
}

export type PipelineItemRemarksCannotBeEmpty = GraphQlBaseError & {
   __typename?: 'PipelineItemRemarksCannotBeEmpty'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemRemarksDraft = {
   __typename?: 'PipelineItemRemarksDraft'
   attachments: Array<RemarksAttachment>
   remarks?: Maybe<Scalars['String']>
}

export type PipelineItemRemarksIdNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemRemarksIdNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemRemarksId: Scalars['String']
}

export type PipelineItemRemarksParams = {
   attachments: Array<RemarksAttachmentParams>
   remarks: Scalars['String']
}

export type PipelineItemReminder = {
   __typename?: 'PipelineItemReminder'
   pipelineItem: PipelineItemPrimaryDetails
   reminderAt: Scalars['String']
   reminderId: Scalars['String']
   reminderText: Scalars['String']
   userId: Scalars['String']
}

export type PipelineItemReminderAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineItemReminderAccessDenied'
   message?: Maybe<Scalars['String']>
   reminderId: Scalars['String']
}

export type PipelineItemReminderNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemReminderNotFound'
   message?: Maybe<Scalars['String']>
   reminderId: Scalars['String']
}

export type PipelineItemReminderNotification = {
   __typename?: 'PipelineItemReminderNotification'
   message?: Maybe<Scalars['String']>
   notificationId: Scalars['String']
   notificationType: NotificationTypes
   pipelineItemDetails: NotificationPipelineItemDetails
   readAt?: Maybe<Scalars['String']>
   reminderAt: Scalars['String']
   reminderId: Scalars['String']
   sentAt: Scalars['String']
   title: Scalars['String']
}

export type PipelineItemReminders = {
   __typename?: 'PipelineItemReminders'
   reminders: Array<PipelineItemReminder>
}

export type PipelineItemRemindersAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineItemRemindersAccessDenied'
   message?: Maybe<Scalars['String']>
   reminderIds: Array<Scalars['String']>
}

export type PipelineItemRemindersNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemRemindersNotFound'
   message?: Maybe<Scalars['String']>
   reminderIds: Array<Scalars['String']>
}

export type PipelineItemRemindersResult = {
   __typename?: 'PipelineItemRemindersResult'
   reminders: Array<PipelineItemReminder>
   totalCount: Scalars['Int']
}

export type PipelineItemResourcesResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineItemResourcesResult

export type PipelineItemResourcesResult = {
   __typename?: 'PipelineItemResourcesResult'
   pipelineItemId: Scalars['String']
   resources: Array<Resource>
   totalCount: Scalars['Int']
}

export type PipelineItemSlaFieldResponse = {
   __typename?: 'PipelineItemSLAFieldResponse'
   description?: Maybe<Scalars['String']>
   endDatetime: Scalars['String']
   fieldId: Scalars['String']
   pipelineItemId: Scalars['String']
   value: Scalars['Float']
}

export type PipelineItemSlaFieldResponses = {
   __typename?: 'PipelineItemSLAFieldResponses'
   slaFieldResponses: Array<PipelineItemSlaFieldResponse>
}

export type PipelineItemSlaFields = {
   __typename?: 'PipelineItemSLAFields'
   slaFields: Array<PipelineItemSlaFieldResponse>
}

export type PipelineItemSlaFieldsInResponse =
   | PipelineItemAccessDenied
   | PipelineItemNotExistsInPipeline
   | PipelineItemNotFound
   | PipelineItemSlaFields
   | PipelineNotFound

export type PipelineItemSchedule =
   | CalendarPipelineItemSchedule
   | ScheduledPipelineItem

export type PipelineItemScheduleAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineItemScheduleAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineItemScheduleId: Scalars['String']
}

export type PipelineItemScheduleIsAlreadyCompleted = GraphQlBaseError & {
   __typename?: 'PipelineItemScheduleIsAlreadyCompleted'
   message?: Maybe<Scalars['String']>
   pipelineItemScheduleId: Scalars['String']
}

export type PipelineItemScheduleNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemScheduleNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemScheduledId: Scalars['String']
}

export type PipelineItemScheduleNotifications = {
   __typename?: 'PipelineItemScheduleNotifications'
   message?: Maybe<Scalars['String']>
   notificationId: Scalars['String']
   notificationType: NotificationTypes
   pipelineItemDetails: NotificationPipelineItemDetails
   pipelineItemScheduledId: Scalars['String']
   readAt?: Maybe<Scalars['String']>
   reminderBeforeInMins: Scalars['Int']
   scheduledDatetime: Scalars['String']
   sentAt: Scalars['String']
   title: Scalars['String']
}

export type PipelineItemScheduledIdsAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineItemScheduledIdsAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export type PipelineItemScheduledIdsAreAlreadyCompleted = GraphQlBaseError & {
   __typename?: 'PipelineItemScheduledIdsAreAlreadyCompleted'
   message?: Maybe<Scalars['String']>
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export type PipelineItemScheduledIdsNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemScheduledIdsNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export enum PipelineItemScheduledStatus {
   Completed = 'COMPLETED',
   NotCompleted = 'NOT_COMPLETED'
}

export type PipelineItemShortfallLog = {
   __typename?: 'PipelineItemShortfallLog'
   currentResponse?: Maybe<FieldResponse>
   fieldId: Scalars['String']
   isGofResponseDeleted?: Maybe<Scalars['Boolean']>
   order?: Maybe<Scalars['Int']>
   previousResponse?: Maybe<FieldResponse>
   remarks?: Maybe<Scalars['String']>
   shortfallBy: BaseUser
   submittedOn: Scalars['String']
}

export type PipelineItemShortfallLogField = {
   __typename?: 'PipelineItemShortfallLogField'
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
}

export type PipelineItemShortfallLogGroup = {
   __typename?: 'PipelineItemShortfallLogGroup'
   fieldLogs: Array<PipelineItemShortfallLog>
   name: Scalars['String']
   submittedOn: Scalars['String']
}

export type PipelineItemShortfallLogs = {
   __typename?: 'PipelineItemShortfallLogs'
   logGroups: Array<PipelineItemShortfallLogGroup>
}

export type PipelineItemShortfallLogsInPortalResponse =
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemShortfallLogs
   | PortalNotFound

export type PipelineItemShortfallLogsResponse =
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemShortfallLogs

export type PipelineItemSingularNameIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineItemSingularNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemStageFieldResponseIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineItemStageFieldResponseIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemStageHistory = {
   __typename?: 'PipelineItemStageHistory'
   assigneeTimespentLogs: Array<StageAssigneeTimespentLog>
   checkpoints: Array<Scalars['String']>
   customFieldResponses: Array<FieldResponseDraft>
   fromStage?: Maybe<Stage>
   pipeline: BasePipeline
   remarks?: Maybe<PipelineItemRemarks>
   toStage: Stage
}

export type PipelineItemStagePermissions = {
   __typename?: 'PipelineItemStagePermissions'
   feePaymentPermissions: StageFeePaymentPermissions
   hasNoteSheetAccess: Scalars['Boolean']
   overviewFieldsConfig: OverViewFieldsConfig
   permissionOverrideType: PermissionOverrideType
   permittedLayoutTabIds: Array<Scalars['String']>
   permittedLayoutTabs: Array<Tab>
   pipelineId: Scalars['String']
   quickEditFields: Array<Scalars['String']>
   recommendedTaskTemplateIds: Array<Scalars['String']>
   stageId: Scalars['String']
   userAddAnotherGofsPermissions: UserAddAnotherGoFsPermissions
}

export type PipelineItemStageTransitionMandatoryEntitiesStatusBulkResult = {
   __typename?: 'PipelineItemStageTransitionMandatoryEntitiesStatusBulkResult'
   isDraftNotesPresent: Scalars['Boolean']
   transitionTasksStatus: Array<StageWiseMandatoryEntitiesStatus>
}

export type PipelineItemStageTransitionMandatoryEntitiesStatusResult = {
   __typename?: 'PipelineItemStageTransitionMandatoryEntitiesStatusResult'
   isDraftNotesPresent: Scalars['Boolean']
   mandatoryTasks: Array<StageTransitionMandatoryTaskStatus>
   pipelineItemId: Scalars['String']
}

export type PipelineItemStageTransitionMandatoryTasksStatusBulkResult = {
   __typename?: 'PipelineItemStageTransitionMandatoryTasksStatusBulkResult'
   transitionTasksStatus: Array<StageWiseMandatoryTaskStatus>
}

export type PipelineItemStageTransitionMandatoryTasksStatusResult = {
   __typename?: 'PipelineItemStageTransitionMandatoryTasksStatusResult'
   mandatoryTasks: Array<StageTransitionMandatoryTaskStatus>
   pipelineItemId: Scalars['String']
}

export type PipelineItemStageTransitionOverallObservationResult = {
   __typename?: 'PipelineItemStageTransitionOverallObservationResult'
   overallObservation: OverallTransitionStatusEnum
   pipelineItemId: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type PipelineItemStageUpdateResult = {
   __typename?: 'PipelineItemStageUpdateResult'
   fromStage?: Maybe<Stage>
   stageFieldId: Scalars['String']
   toStage: Stage
}

export type PipelineItemSubmissionGroup = {
   __typename?: 'PipelineItemSubmissionGroup'
   closedAt?: Maybe<Scalars['String']>
   fieldLogs: Array<PipelineItemFieldLog>
   groupId: Scalars['String']
   initiatedBy: Scalars['String']
   name: Scalars['String']
   pipelineItemId: Scalars['String']
   startedAt: Scalars['String']
   status: PipelineItemSubmissionGroupStatus
}

export enum PipelineItemSubmissionGroupStatus {
   Closed = 'CLOSED',
   Open = 'OPEN'
}

export type PipelineItemSubmissionGroupsTab = BaseTab & {
   __typename?: 'PipelineItemSubmissionGroupsTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type PipelineItemTaskCompletedHistory = {
   __typename?: 'PipelineItemTaskCompletedHistory'
   taskId: Scalars['String']
   taskTemplateId: Scalars['String']
   title: Scalars['String']
}

export type PipelineItemTemplate = {
   __typename?: 'PipelineItemTemplate'
   applicationTemplateProperties?: Maybe<ApplicationTemplateProperties>
   applicationType: ApplicationTypeEnum
   assigneeFieldsMapping: Array<AssigneeFieldMapping>
   backgroundImageUrl?: Maybe<Scalars['String']>
   baseImageUrl?: Maybe<Scalars['String']>
   canCreateRecord: Scalars['Boolean']
   canMergeRecords: Scalars['Boolean']
   customObjectTemplateProperties?: Maybe<CustomObjectTemplateProperties>
   deemedApprovalFields?: Maybe<DeemedApprovalFieldsConfig>
   gofs: Array<GoF>
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   orderedGofIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   pipelineItemType: PipelineItemType
   recordCreationConfigs: Array<RecordCreationConfig>
   shortfallFieldsConfig?: Maybe<ShortFallFieldsConfig>
   slaFieldIds: Array<Scalars['String']>
   surveyNumberFieldConfig?: Maybe<SurveyNumberFieldConfig>
}

export type PipelineItemTemplateAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplateAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export type PipelineItemTemplateAdmins = {
   __typename?: 'PipelineItemTemplateAdmins'
   adminUsers: Array<BaseUser>
   pipelineItemTemplateId: Scalars['String']
}

export type PipelineItemTemplateAssigneeFieldNameAlreadyExist = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplateAssigneeFieldNameAlreadyExist'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemTemplateConfig = {
   __typename?: 'PipelineItemTemplateConfig'
   displayStageFieldId?: Maybe<Scalars['String']>
   stageFieldId: Scalars['String']
   surveyNumberFieldConfig?: Maybe<SurveyNumberFieldConfig>
}

export type PipelineItemTemplateConfigIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplateConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemTemplateConfigParams = {
   /** @deprecated Support SRMP */
   assigneeFieldName?: InputMaybe<Scalars['String']>
   displayStageFieldName?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   stageFieldName: Scalars['String']
}

export type PipelineItemTemplateDisplayConfigIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplateDisplayConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemTemplateDisplayConfigParams = {
   pluralName: Scalars['String']
   primaryDisplayFieldName: Scalars['String']
   singularName: Scalars['String']
}

export type PipelineItemTemplateDisplayStageFieldNameAlreadyExist = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplateDisplayStageFieldNameAlreadyExist'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemTemplateDisplayStageFieldNameIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplateDisplayStageFieldNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemTemplateDocumentTemplatesByAdminResult = {
   __typename?: 'PipelineItemTemplateDocumentTemplatesByAdminResult'
   documentTemplates: Array<AdminDocumentTemplate>
   totalCount: Scalars['Int']
}

export type PipelineItemTemplateDocumentTemplatesResult = {
   __typename?: 'PipelineItemTemplateDocumentTemplatesResult'
   documentTemplates: Array<DocumentTemplate>
   totalCount: Scalars['Int']
}

export type PipelineItemTemplateFieldsToLog = {
   __typename?: 'PipelineItemTemplateFieldsToLog'
   field: FieldPrimaryDetails
}

export type PipelineItemTemplateNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplateNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type PipelineItemTemplateNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplateNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export type PipelineItemTemplateNotInPortal = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplateNotInPortal'
   message?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   portalId: Scalars['String']
}

export type PipelineItemTemplatePipelines = {
   __typename?: 'PipelineItemTemplatePipelines'
   pipelineItemTemplateId: Scalars['String']
   pipelines: Array<PipelineCrmTemplates>
}

export type PipelineItemTemplateStageFieldNameAlreadyExist = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplateStageFieldNameAlreadyExist'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemTemplateWithoutPermission = {
   __typename?: 'PipelineItemTemplateWithoutPermission'
   applicationTemplateProperties?: Maybe<ApplicationTemplateProperties>
   canMergeRecords: Scalars['Boolean']
   customObjectTemplateProperties?: Maybe<CustomObjectTemplateProperties>
   gofs: Array<GoFWithoutPermission>
   name: Scalars['String']
   orderedGofIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   pipelineItemType: PipelineItemType
}

export type PipelineItemTemplatesAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplatesAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineItemTemplateIds: Array<Scalars['String']>
}

export type PipelineItemTemplatesNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemTemplatesNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemTemplateIds: Array<Scalars['String']>
}

export enum PipelineItemType {
   Application = 'APPLICATION',
   CustomObject = 'CUSTOM_OBJECT',
   Deal = 'DEAL',
   Lead = 'LEAD'
}

export type PipelineItemTypeNotSupported = GraphQlBaseError & {
   __typename?: 'PipelineItemTypeNotSupported'
   message?: Maybe<Scalars['String']>
   pipelineItemType: PipelineItemType
}

export type PipelineItemUpdatedTriggerConfig = {
   __typename?: 'PipelineItemUpdatedTriggerConfig'
   fieldIds: Array<Scalars['String']>
}

export type PipelineItemUpdatedTriggerConfigIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineItemUpdatedTriggerConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemUpdatedTriggerConfigParams = {
   fieldIds: Array<Scalars['String']>
}

export type PipelineItemVerification = {
   __typename?: 'PipelineItemVerification'
   isPermitted: Scalars['Boolean']
   pipelineItemId: Scalars['String']
   request?: Maybe<VerificationRequest>
   verificationId: Scalars['String']
   verificationStage?: Maybe<Stage>
}

export type PipelineItemsAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineItemsAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineItemIds: Array<Scalars['String']>
}

export type PipelineItemsAreAlreadyScheduled = GraphQlBaseError & {
   __typename?: 'PipelineItemsAreAlreadyScheduled'
   message?: Maybe<Scalars['String']>
   pipelineItemIds: Array<Scalars['String']>
}

export type PipelineItemsAreDeleted = GraphQlBaseError & {
   __typename?: 'PipelineItemsAreDeleted'
   message?: Maybe<Scalars['String']>
   pipelineItemIds: Array<Scalars['String']>
}

export type PipelineItemsExportFailureNotification = {
   __typename?: 'PipelineItemsExportFailureNotification'
   dataExportRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
   notificationId: Scalars['String']
   notificationType: NotificationTypes
   pipeline: BasePipeline
   readAt?: Maybe<Scalars['String']>
   sentAt: Scalars['String']
   title: Scalars['String']
}

export type PipelineItemsExportSuccessNotification = {
   __typename?: 'PipelineItemsExportSuccessNotification'
   dataExportRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
   notificationId: Scalars['String']
   notificationType: NotificationTypes
   pipeline: BasePipeline
   readAt?: Maybe<Scalars['String']>
   s3SignedUrl: Scalars['String']
   sentAt: Scalars['String']
   title: Scalars['String']
}

export type PipelineItemsNotFound = GraphQlBaseError & {
   __typename?: 'PipelineItemsNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemIds: Array<Scalars['String']>
}

export type PipelineItemsNotInSamePipelineItemTemplate = GraphQlBaseError & {
   __typename?: 'PipelineItemsNotInSamePipelineItemTemplate'
   message?: Maybe<Scalars['String']>
}

export type PipelineItemsNotLinkedToTaskPipelineItemRelation = GraphQlBaseError & {
   __typename?: 'PipelineItemsNotLinkedToTaskPipelineItemRelation'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineItemIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type PipelineLayoutTab = {
   __typename?: 'PipelineLayoutTab'
   layoutId: Scalars['String']
   name: Scalars['String']
   pipeline: BasePipeline
   tabId: Scalars['String']
   tabType: TabType
}

export type PipelineNameAlreadyExistsInAccount = GraphQlBaseError & {
   __typename?: 'PipelineNameAlreadyExistsInAccount'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type PipelineNameIsRequired = GraphQlBaseError & {
   __typename?: 'PipelineNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PipelineNotFound = GraphQlBaseError & {
   __typename?: 'PipelineNotFound'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type PipelineNotInPortal = GraphQlBaseError & {
   __typename?: 'PipelineNotInPortal'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   portalId: Scalars['String']
}

export type PipelineNotInUserAccount = GraphQlBaseError & {
   __typename?: 'PipelineNotInUserAccount'
   message?: Maybe<Scalars['String']>
}

export type PipelineOverviewDetails = {
   __typename?: 'PipelineOverviewDetails'
   displayName: Scalars['String']
   name: Scalars['String']
   pipelineId: Scalars['String']
   pipelineItemType: PipelineItemType
}

export type PipelinePermittedActions = {
   __typename?: 'PipelinePermittedActions'
   actions: Array<PipelineActionType>
   pipelineId: Scalars['String']
}

export type PipelinePersonalWhatsAppMessagePermissionStatus = {
   __typename?: 'PipelinePersonalWhatsAppMessagePermissionStatus'
   hasPersonalWhatsappMessagePermission: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type PipelineRecordCreationConfigAllowedStages = {
   __typename?: 'PipelineRecordCreationConfigAllowedStages'
   pipelineId: Scalars['String']
   stages: Array<Stage>
}

export type PipelineRecordCreationConfigAllowedStagesParams = {
   pipelineId: Scalars['String']
   stageIds: Array<Scalars['String']>
}

export type PipelineResourcesResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineNotFound
   | PipelineResourcesResult
   | UserIsNotAnAdministrator

export type PipelineResourcesResult = {
   __typename?: 'PipelineResourcesResult'
   pipelineId: Scalars['String']
   resources: Array<ResourceConfig>
   totalCount: Scalars['Int']
}

export type PipelineSettings = {
   __typename?: 'PipelineSettings'
   adminUsers: Array<BaseUser>
   color?: Maybe<Scalars['String']>
   defaultStageValues?: Maybe<DefaultStageValuesToPipeline>
   displayName: Scalars['String']
   features: Array<AdminCrmPipelineFeature>
   identifications: Array<IdentificationOverviewDetails>
   isActivitiesFeatureEnabled: Scalars['Boolean']
   isAdvancedAnalyticsEnabled: Scalars['Boolean']
   isPersonalMessageIdentificationsFromPipeline: Scalars['Boolean']
   isTasksFeatureEnabled: Scalars['Boolean']
   isWhatsappConsentRequired: Scalars['Boolean']
   name: Scalars['String']
   personalWhatsappMessagePermissions: Array<IdentificationOverviewDetails>
   pipelineIconId?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemType: PipelineItemType
   stageBoardOwner?: Maybe<BaseUser>
   stageTransitionStyle: PipelineStageTransitionUiStyle
}

export enum PipelineSettingsProperty {
   Name = 'NAME'
}

export enum PipelineStageTransitionUiStyle {
   Buttons = 'BUTTONS',
   Dropdown = 'DROPDOWN'
}

export type PipelineStageValues = {
   __typename?: 'PipelineStageValues'
   displayStage?: Maybe<Stage>
   pipelineId: Scalars['String']
   stage: Stage
}

export type PipelineStageValuesParams = {
   displayStageId?: InputMaybe<Scalars['String']>
   pipelineId: Scalars['String']
   stageId: Scalars['String']
}

export type PipelineStages = {
   __typename?: 'PipelineStages'
   pipelineId: Scalars['String']
   stages: Array<Stage>
}

export type PipelineStagesBulkParams = {
   isApplicationDisplayStage?: InputMaybe<Scalars['Boolean']>
   pipelineIds: Array<Scalars['String']>
}

export type PipelineStagesResponse =
   | PipelineAccessDenied
   | PipelineNotFound
   | PipelineStages

export type PipelineStagesResult = {
   __typename?: 'PipelineStagesResult'
   pipelineStages: Array<PipelineStagesResponse>
}

export type PipelineSystemFields = {
   __typename?: 'PipelineSystemFields'
   pipelineId: Scalars['String']
   systemFields: Array<Field>
}

export type PipelineTemplates = {
   __typename?: 'PipelineTemplates'
   activityTemplates: Array<ActivityTemplate>
   color?: Maybe<Scalars['String']>
   displayName: Scalars['String']
   isActivitiesFeatureEnabled: Scalars['Boolean']
   isAdvancedAnalyticsEnabled: Scalars['Boolean']
   isMainPipeline: Scalars['Boolean']
   isTasksFeatureEnabled: Scalars['Boolean']
   isWhatsappConsentRequired: Scalars['Boolean']
   name: Scalars['String']
   pipelineEventTemplates: Array<PipelineEventTemplate>
   pipelineIconId?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemTemplate: PipelineItemTemplate
   pipelineItemTemplateConfig: PipelineItemTemplateConfig
   pipelineItemTemplateId: Scalars['String']
   pipelineItemType: PipelineItemType
   pipelineType: PipelineTypeEnum
   stageTransitionStyle: PipelineStageTransitionUiStyle
   taskTemplates: Array<TaskTemplate>
}

export type PipelineTemplatesTaskTemplatesArgs = {
   taskTypesParams?: InputMaybe<TaskTemplateTaskTypesParams>
}

export type PipelineTemplatesResult =
   | PipelineAccessDenied
   | PipelineNotFound
   | PipelineTemplates

export enum PipelineTypeEnum {
   LineDepartment = 'LINE_DEPARTMENT',
   Na = 'NA',
   Officer = 'OFFICER'
}

export type PipelineWhatsAppBusinessNumbers = {
   __typename?: 'PipelineWhatsAppBusinessNumbers'
   pipelineId: Scalars['String']
   whatsappBusinessPhoneNumbers: Array<
      BaseWhatsAppBusinessNumberWithPluginServiceAccount
   >
}

export type PipelineWhatsAppBusinessPhoneNumberAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelineWhatsAppBusinessPhoneNumberAccessDenied'
   message?: Maybe<Scalars['String']>
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type PipelineWhatsAppBusinessPhoneNumberAlreadyExists = GraphQlBaseError & {
   __typename?: 'PipelineWhatsAppBusinessPhoneNumberAlreadyExists'
   message?: Maybe<Scalars['String']>
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
}

export type PipelineWhatsAppBusinessPhoneNumberNotFound = GraphQlBaseError & {
   __typename?: 'PipelineWhatsAppBusinessPhoneNumberNotFound'
   message?: Maybe<Scalars['String']>
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
}

export type PipelineWiseFeatures = {
   __typename?: 'PipelineWiseFeatures'
   features: Array<CrmPipelineFeature>
   pipelineId: Scalars['String']
}

export type PipelinesAccessDenied = GraphQlBaseError & {
   __typename?: 'PipelinesAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineIds: Array<Scalars['String']>
}

export type PipelinesAreNotInSync = GraphQlBaseError & {
   __typename?: 'PipelinesAreNotInSync'
   message?: Maybe<Scalars['String']>
   pipelineIds: Array<Scalars['String']>
}

export type PipelinesAutomationWorkflows = {
   __typename?: 'PipelinesAutomationWorkflows'
   automationWorkflows: Array<AutomationWorkflow>
   totalCount: Scalars['Int']
}

export type PipelinesAutomationWorkflowsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelinesAccessDenied
   | PipelinesAutomationWorkflows
   | PipelinesNotFound
   | UserIsNotAnAdministrator

export type PipelinesForPipelineItemsResult = {
   __typename?: 'PipelinesForPipelineItemsResult'
   pipelineItemWisePipelines: Array<PipelineItemPipelines>
}

export type PipelinesNotFound = GraphQlBaseError & {
   __typename?: 'PipelinesNotFound'
   message?: Maybe<Scalars['String']>
   pipelineIds: Array<Scalars['String']>
}

export type PipelinesNotInActivityTemplate = GraphQlBaseError & {
   __typename?: 'PipelinesNotInActivityTemplate'
   activityTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
   pipelineIds: Array<Scalars['String']>
}

export type PivotTable = {
   __typename?: 'PivotTable'
   columnHeaders: Array<ColumnHeader>
   graphId: Scalars['String']
   rows: Array<TableRow>
   searchAfter?: Maybe<PivotTableSearchAfterData>
   totalRows?: Maybe<Scalars['Int']>
}

export type PivotTableColumnTotalParams = {
   columnIds?: InputMaybe<Array<Scalars['String']>>
   graphId: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
}

export type PivotTableGraphConfig = {
   __typename?: 'PivotTableGraphConfig'
   analyticsLevel: AnalyticsLevel
   columnDimension: GraphDimension
   dataSources: Array<AnalyticsDataSourceType>
   dataSourcesWithDisplayNames: Array<DataSourceDisplayName>
   description?: Maybe<Scalars['String']>
   enableColumnTotals: Scalars['Boolean']
   enableRowTotals: Scalars['Boolean']
   filterSetId: Scalars['String']
   graphId: Scalars['String']
   isOwner: Scalars['Boolean']
   metric: GraphMetric
   name: Scalars['String']
   pipelineId: Scalars['String']
   quickFilterFields: Array<GraphQuickFilterField>
   roles: Array<Role>
   rowDimension: GraphDimension
}

export type PivotTableResult =
   | DashboardAccessDenied
   | DashboardNotFound
   | GraphAccessDenied
   | GraphNotFound
   | InvalidLimit
   | InvalidOffset
   | NotSupportedGraphParenType
   | PaginationLimitExceeded
   | PivotTable
   | PivotTableSearchAfterIsRequired
   | RowPaginationIsRequired
   | ViewAccessDenied
   | ViewNotFound

export type PivotTableRowTotalParams = {
   graphId: Scalars['String']
   pagination: Pagination
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
}

export type PivotTableSearchAfterData = {
   __typename?: 'PivotTableSearchAfterData'
   afterKey: Scalars['String']
}

export type PivotTableSearchAfterIsRequired = GraphQlBaseError & {
   __typename?: 'PivotTableSearchAfterIsRequired'
   message?: Maybe<Scalars['String']>
}

export type PivotTableSearchAfterParams = {
   afterKey?: InputMaybe<Scalars['String']>
   size: Scalars['Int']
}

export type PlaceholdersNotFound = GraphQlBaseError & {
   __typename?: 'PlaceholdersNotFound'
   message?: Maybe<Scalars['String']>
   placeholderIds: Array<Scalars['String']>
}

export type PlainTextField = BaseField & {
   __typename?: 'PlainTextField'
   autoGenerateApplicationIdInCreation: Scalars['Boolean']
   autoGenerateCustomId?: Maybe<Scalars['Boolean']>
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   formulaExpression?: Maybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isFormulaEnabled: Scalars['Boolean']
   isIdentificationField: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   regexErrorMessage?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
   validationRegex?: Maybe<Scalars['String']>
}

export type Plugin = {
   __typename?: 'Plugin'
   description?: Maybe<Scalars['String']>
   isActive: Scalars['Boolean']
   name: Scalars['String']
   pluginType: PluginType
   serviceType: PluginServiceType
}

export type PluginServiceAccount = KnowlarityAccount

export type PluginServiceAccountIsNotActive = GraphQlBaseError & {
   __typename?: 'PluginServiceAccountIsNotActive'
   message?: Maybe<Scalars['String']>
   pluginServiceAccountId: Scalars['String']
}

export type PluginServiceAccountNotFound = GraphQlBaseError & {
   __typename?: 'PluginServiceAccountNotFound'
   message?: Maybe<Scalars['String']>
   pluginServiceAccountId: Scalars['String']
}

export type PluginServiceAccountWhatsappMessageTemplatesSyncStatus = {
   __typename?: 'PluginServiceAccountWhatsappMessageTemplatesSyncStatus'
   lastSyncedAt?: Maybe<Scalars['String']>
   pluginServiceAccountId: Scalars['String']
   syncStatus: WhatsAppMessageTemplatesSyncStatus
}

export enum PluginServiceType {
   CloudCalling = 'CLOUD_CALLING',
   Whatsapp = 'WHATSAPP'
}

export enum PluginType {
   Gallabox = 'GALLABOX',
   Gupshup = 'GUPSHUP',
   Knowlarity = 'KNOWLARITY',
   Smartflo = 'SMARTFLO',
   Wati = 'WATI'
}

export type Plugins = {
   __typename?: 'Plugins'
   plugins?: Maybe<Array<Maybe<Plugin>>>
}

export type PollDigitalSignStatusParams = {
   documentId: Scalars['String']
   stageId: Scalars['String']
}

export type PollDigitalSignStatusResponse =
   | NoBlocksPending
   | NoPendingDigitalSignRequest
   | PollDigitalSignStatusResult
   | ZohoSignRateLimited
   | ZohoSignServiceUnavailable

export type PollDigitalSignStatusResult = {
   __typename?: 'PollDigitalSignStatusResult'
   documentId: Scalars['String']
   signatureFieldsStatus: Array<SignatureFieldStatus>
   stageId: Scalars['String']
}

export type PopulateActivitiesFromCsvParams = {
   dataFile: FileUploaderUrlParams
   pipelineId?: InputMaybe<Scalars['String']>
   skipAutomationWorkflows: Scalars['Boolean']
}

export type PopulateActivitiesFromCsvResponse =
   | ActivityReferenceIdsAreMissing
   | CsvDataLoadingRequest
   | DataFileNotFoundInS3
   | DuplicateColumnHeaders
   | FailedActivityLogIdsNotFound
   | IdentificationValueIsMissing
   | InProgressDataLoadingRequestLimitExceeded
   | NoEntriesFoundInCsv
   | NoRecordsToLoad
   | NotCsvFile
   | PipelineNotFound
   | RecordsLimitExceeded
   | ReservedFieldReferenceIdsAreNotAllowed
   | UserIsNotAnAdministrator

export type PopulateActivitiesFromSheetParams = {
   dataSheetId: Scalars['String']
   skipAutomationWorkflows?: InputMaybe<Scalars['Boolean']>
   subSheetName: Scalars['String']
}

export type PopulateActivitiesFromSheetResponse =
   | ActivityReferenceIdsAreMissing
   | DataSheetAccessDenied
   | DataSheetNotFound
   | DuplicateColumnHeaders
   | FailedActivityLogIdsNotFound
   | IdentificationValueIsMissing
   | InProgressDataLoadingRequestLimitExceeded
   | NoEntriesFoundInSubSheet
   | NoRecordsToLoad
   | RecordsLimitExceeded
   | ReservedFieldReferenceIdsAreNotAllowed
   | SheetDataLoadingRequest
   | SheetDataLoadingRequestAlreadyExists
   | SubSheetNotFound
   | UserIsNotAnAdministrator

export type PopulateApplicationsFromCsvParams = {
   assigneeFieldReferenceIdsToNotify: Array<Scalars['String']>
   chunkSize?: InputMaybe<Scalars['Int']>
   creationConfig?: InputMaybe<LeadsOrContactsCreationConfigParams>
   dataFile: FileUploaderUrlParams
   operationType: DataLoadingOperationType
   pipelineId: Scalars['String']
   syncAssigneeGroupIds: Array<Scalars['String']>
   updationConfig?: InputMaybe<LeadsOrContactsUpdationConfigParams>
}

export type PopulateApplicationsFromCsvResponse =
   | AddAnotherFieldReferenceIdsAreNotSupported
   | AssigneeGroupsNotFound
   | AssigneeGroupsNotInSalesTemplate
   | CsvDataLoadingRequest
   | DataFileNotFoundInS3
   | DuplicateApplicationAssigneeFieldReferenceIdsToNotify
   | DuplicateColumnHeaders
   | DuplicateReferenceFieldsToCompareFromCsv
   | DuplicateReferenceFieldsToCompareInRecords
   | DuplicateResponsesForUniqueFieldsResponse
   | DuplicateSelectedFieldReferenceIds
   | FieldReferenceIdsExistsInMultipleTemplates
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidApplicationAssigneeFieldReferenceIdsToNotify
   | InvalidCreationConfig
   | NoEntriesFoundInCsv
   | NotApplicationTypePipeline
   | NotCsvFile
   | OnlyPhoneNumberFieldsSupportedToCompare
   | PipelineAccessDenied
   | PipelineNotFound
   | ProvideAtLeastOneIdentificationField
   | RecordsLimitExceeded
   | ReservedFieldReferenceIdsAreNotAllowed
   | SelectedReferenceFieldIdsRequired
   | UnSupportedSystemFieldReferenceIds
   | UpdationConfigIsRequired
   | UserIsNotAnAdministrator

export type PopulateConditionalFieldOptionsFromCsvParams = {
   crmTemplateId: Scalars['String']
   dataFile: FileUploaderUrlParams
}

export type PopulateConditionalFieldOptionsFromCsvResponse =
   | CsvDataLoadingRequest
   | CrmTemplateNotFound
   | DataFileNotFoundInS3
   | DuplicateColumnHeaders
   | FieldReferenceIdsExistsInMultipleTemplates
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidPopulationData
   | NoEntriesFoundInCsv
   | NotCsvFile
   | RecordsLimitExceeded
   | UserIsNotAnAdministrator

export type PopulateContactsFromCsvParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   creationConfig?: InputMaybe<LeadsOrContactsCreationConfigParams>
   dataFile: FileUploaderUrlParams
   operationType: DataLoadingOperationType
   updationConfig?: InputMaybe<LeadsOrContactsUpdationConfigParams>
}

export type PopulateContactsFromCsvResponse =
   | CsvDataLoadingRequest
   | DataFileNotFoundInS3
   | DuplicateColumnHeaders
   | DuplicateReferenceFieldsToCompareFromCsv
   | DuplicateReferenceFieldsToCompareInRecords
   | DuplicateResponsesForUniqueFieldsResponse
   | DuplicateSelectedFieldReferenceIds
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidCreationConfig
   | NoEntriesFoundInCsv
   | NotCsvFile
   | OnlyPhoneNumberFieldsSupportedToCompare
   | ProvideAtLeastOneIdentificationField
   | RecordsLimitExceeded
   | ReservedFieldReferenceIdsAreNotAllowed
   | SelectedReferenceFieldIdsRequired
   | UnSupportedSystemFieldReferenceIds
   | UpdationConfigIsRequired
   | UserIsNotAnAdministrator

export type PopulateContactsFromSheetParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   creationConfig?: InputMaybe<LeadsOrContactsCreationConfigParams>
   dataSheetId: Scalars['String']
   operationType: DataLoadingOperationType
   subSheetName: Scalars['String']
   updationConfig?: InputMaybe<LeadsOrContactsUpdationConfigParams>
}

export type PopulateContactsFromSheetResponse =
   | DataSheetAccessDenied
   | DataSheetNotFound
   | DuplicateColumnHeaders
   | DuplicateReferenceFieldsToCompareFromSheet
   | DuplicateReferenceFieldsToCompareInRecords
   | DuplicateResponsesForUniqueFieldsResponse
   | DuplicateSelectedFieldReferenceIds
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidCreationConfig
   | NoEntriesFoundInSubSheet
   | OnlyPhoneNumberFieldsSupportedToCompare
   | ProvideAtLeastOneIdentificationField
   | RecordsLimitExceeded
   | ReservedFieldReferenceIdsAreNotAllowed
   | SelectedReferenceFieldIdsRequired
   | SheetDataLoadingRequest
   | SheetDataLoadingRequestAlreadyExists
   | SubSheetNotFound
   | UnSupportedSystemFieldReferenceIds
   | UpdationConfigIsRequired
   | UserIsNotAnAdministrator

export type PopulateCrmFunctionsFromCsvParams = {
   dataFile: FileUploaderUrlParams
}

export type PopulateCrmFunctionsFromCsvResponse =
   | CsvDataLoadingRequest
   | DataFileNotFoundInS3
   | DuplicateColumnHeaders
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidPopulationData
   | NoEntriesFoundInCsv
   | NotCsvFile
   | RecordsLimitExceeded
   | UserIsNotAnAdministrator

export type PopulateCustomObjectsFromCsvParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   creationConfig?: InputMaybe<LeadsOrContactsCreationConfigParams>
   dataFile: FileUploaderUrlParams
   leadAssigneeFieldReferenceIdsToNotify?: InputMaybe<
      Array<InputMaybe<Scalars['String']>>
   >
   operationType: DataLoadingOperationType
   pipelineId: Scalars['String']
   syncAssigneeGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   updationConfig?: InputMaybe<LeadsOrContactsUpdationConfigParams>
}

export type PopulateCustomObjectsFromCsvResponse =
   | AddAnotherFieldReferenceIdsAreNotSupported
   | AssigneeGroupsNotFound
   | AssigneeGroupsNotInSalesTemplate
   | CsvDataLoadingRequest
   | DataFileNotFoundInS3
   | DuplicateColumnHeaders
   | DuplicateCustomObjectAssigneeFieldReferenceIdsToNotify
   | DuplicateReferenceFieldsToCompareFromCsv
   | DuplicateReferenceFieldsToCompareInRecords
   | DuplicateResponsesForUniqueFieldsResponse
   | DuplicateSelectedFieldReferenceIds
   | FieldReferenceIdsExistsInMultipleTemplates
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidCreationConfig
   | InvalidCustomObjectAssigneeFieldReferenceIdsToNotify
   | NoEntriesFoundInCsv
   | NotACustomObjectPipeline
   | NotCsvFile
   | OnlyPhoneNumberFieldsSupportedToCompare
   | PipelineAccessDenied
   | PipelineNotFound
   | ProvideAtLeastOneIdentificationField
   | RecordsLimitExceeded
   | ReservedFieldReferenceIdsAreNotAllowed
   | SelectedReferenceFieldIdsRequired
   | UnSupportedSystemFieldReferenceIds
   | UpdationConfigIsRequired
   | UserIsNotAnAdministrator

export type PopulateCustomObjectsFromSheetParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   creationConfig?: InputMaybe<LeadsOrContactsCreationConfigParams>
   dataSheetId: Scalars['String']
   leadAssigneeFieldReferenceIdsToNotify?: InputMaybe<
      Array<InputMaybe<Scalars['String']>>
   >
   operationType: DataLoadingOperationType
   pipelineId: Scalars['String']
   subSheetName: Scalars['String']
   updationConfig?: InputMaybe<LeadsOrContactsUpdationConfigParams>
}

export type PopulateCustomObjectsFromSheetResponse =
   | AddAnotherFieldReferenceIdsAreNotSupported
   | DataSheetAccessDenied
   | DataSheetNotFound
   | DuplicateColumnHeaders
   | DuplicateCustomObjectAssigneeFieldReferenceIdsToNotify
   | DuplicateReferenceFieldsToCompareFromSheet
   | DuplicateReferenceFieldsToCompareInRecords
   | DuplicateResponsesForUniqueFieldsResponse
   | DuplicateSelectedFieldReferenceIds
   | FieldReferenceIdsExistsInMultipleTemplates
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidCreationConfig
   | InvalidCustomObjectAssigneeFieldReferenceIdsToNotify
   | NoEntriesFoundInSubSheet
   | NotACustomObjectPipeline
   | OnlyPhoneNumberFieldsSupportedToCompare
   | PipelineAccessDenied
   | PipelineNotFound
   | ProvideAtLeastOneIdentificationField
   | RecordsLimitExceeded
   | ReservedFieldReferenceIdsAreNotAllowed
   | SelectedReferenceFieldIdsRequired
   | SheetDataLoadingRequest
   | SheetDataLoadingRequestAlreadyExists
   | SubSheetNotFound
   | UnSupportedSystemFieldReferenceIds
   | UpdationConfigIsRequired
   | UserIsNotAnAdministrator

export type PopulateLeadsWithContactFromCsvParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   creationConfig?: InputMaybe<LeadsOrContactsCreationConfigParams>
   dataFile: FileUploaderUrlParams
   leadAssigneeFieldReferenceIdsToNotify?: InputMaybe<
      Array<InputMaybe<Scalars['String']>>
   >
   operationType: DataLoadingOperationType
   pipelineId: Scalars['String']
   syncAssigneeGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   updationConfig?: InputMaybe<LeadsOrContactsUpdationConfigParams>
}

export type PopulateLeadsWithContactFromCsvResponse =
   | AddAnotherFieldReferenceIdsAreNotSupported
   | AssigneeGroupsNotFound
   | AssigneeGroupsNotInSalesTemplate
   | CsvDataLoadingRequest
   | DataFileNotFoundInS3
   | DealPipelineIsNotSupported
   | DuplicateColumnHeaders
   | DuplicateLeadAssigneeFieldReferenceIdsToNotify
   | DuplicateReferenceFieldsToCompareFromCsv
   | DuplicateReferenceFieldsToCompareInRecords
   | DuplicateResponsesForUniqueFieldsResponse
   | DuplicateSelectedFieldReferenceIds
   | FieldReferenceIdsExistsInMultipleTemplates
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidCreationConfig
   | InvalidLeadAssigneeFieldReferenceIdsToNotify
   | NoEntriesFoundInCsv
   | NotCsvFile
   | OnlyPhoneNumberFieldsSupportedToCompare
   | PipelineAccessDenied
   | PipelineNotFound
   | ProvideAtLeastOneIdentificationField
   | RecordsLimitExceeded
   | ReservedFieldReferenceIdsAreNotAllowed
   | SelectedReferenceFieldIdsRequired
   | UnSupportedSystemFieldReferenceIds
   | UpdationConfigIsRequired
   | UserIsNotAnAdministrator

export type PopulateLeadsWithContactFromSheetParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   creationConfig?: InputMaybe<LeadsOrContactsCreationConfigParams>
   dataSheetId: Scalars['String']
   leadAssigneeFieldReferenceIdsToNotify?: InputMaybe<
      Array<InputMaybe<Scalars['String']>>
   >
   operationType: DataLoadingOperationType
   pipelineId: Scalars['String']
   subSheetName: Scalars['String']
   updationConfig?: InputMaybe<LeadsOrContactsUpdationConfigParams>
}

export type PopulateLeadsWithContactFromSheetResponse =
   | AddAnotherFieldReferenceIdsAreNotSupported
   | DataSheetAccessDenied
   | DataSheetNotFound
   | DealPipelineIsNotSupported
   | DuplicateColumnHeaders
   | DuplicateLeadAssigneeFieldReferenceIdsToNotify
   | DuplicateReferenceFieldsToCompareFromSheet
   | DuplicateReferenceFieldsToCompareInRecords
   | DuplicateResponsesForUniqueFieldsResponse
   | DuplicateSelectedFieldReferenceIds
   | FieldReferenceIdsExistsInMultipleTemplates
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidCreationConfig
   | InvalidLeadAssigneeFieldReferenceIdsToNotify
   | NoEntriesFoundInSubSheet
   | OnlyPhoneNumberFieldsSupportedToCompare
   | PipelineAccessDenied
   | PipelineNotFound
   | ProvideAtLeastOneIdentificationField
   | RecordsLimitExceeded
   | ReservedFieldReferenceIdsAreNotAllowed
   | SelectedReferenceFieldIdsRequired
   | SheetDataLoadingRequest
   | SheetDataLoadingRequestAlreadyExists
   | SubSheetNotFound
   | UnSupportedSystemFieldReferenceIds
   | UpdationConfigIsRequired
   | UserIsNotAnAdministrator

export type PopulatePipelineWhatsappBusinessPhoneNumbersFromCsvParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   dataFile: FileUploaderUrlParams
   pluginServiceAccountId: Scalars['String']
}

export type PopulatePipelineWhatsappBusinessPhoneNumbersFromCsvResponse =
   | AccountPluginIsDisabled
   | CsvDataLoadingRequest
   | DataFileNotFoundInS3
   | DuplicateColumnHeaders
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidPopulationData
   | NoEntriesFoundInCsv
   | NotAWhatsAppPluginServiceAccount
   | NotCsvFile
   | PluginServiceAccountIsNotActive
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator
   | WatiPluginServiceAccountNotFound

export type PopulatePipelineWhatsappBusinessPhoneNumbersFromSheetParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   dataSheetId: Scalars['String']
   pluginServiceAccountId: Scalars['String']
   subSheetName: Scalars['String']
}

export type PopulatePipelineWhatsappBusinessPhoneNumbersFromSheetResponse =
   | AccountPluginIsDisabled
   | DataSheetAccessDenied
   | DataSheetNotFound
   | DuplicateColumnHeaders
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidPopulationData
   | NoEntriesFoundInSubSheet
   | NotAWhatsAppPluginServiceAccount
   | PluginServiceAccountIsNotActive
   | PluginServiceAccountNotFound
   | SheetDataLoadingRequest
   | SheetDataLoadingRequestAlreadyExists
   | SubSheetNotFound
   | UserIsNotAnAdministrator
   | WatiPluginServiceAccountNotFound

export type PopulateSurveyNumbersFromCsvParams = {
   dataFile: FileUploaderUrlParams
}

export type PopulateSurveyNumbersFromCsvResponse =
   | CsvDataLoadingRequest
   | DataFileNotFoundInS3
   | DuplicateColumnHeaders
   | FieldReferenceIdsExistsInMultipleTemplates
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidPopulationData
   | NoEntriesFoundInCsv
   | NotCsvFile
   | RecordsLimitExceeded
   | UserIsNotAnAdministrator

export type PopulateUserCallingConfigFromCsvParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   cloudCallingServiceAccountId: Scalars['String']
   dataFile: FileUploaderUrlParams
}

export type PopulateUserCallingConfigFromCsvResponse =
   | CsvDataLoadingRequest
   | CloudCallingServiceAccountAndAdminAreNotInSameAccount
   | CloudCallingServiceAccountIsDeactivated
   | CloudCallingServiceAccountNotFound
   | DuplicateColumnHeaders
   | DuplicateResponsesForUniqueFieldsResponse
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidPopulationData
   | NoEntriesFoundInCsv
   | NotCsvFile
   | UserIsNotAnAdministrator

export type PopulateUserCallingConfigFromSheetParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   cloudCallingServiceAccountId: Scalars['String']
   dataSheetId: Scalars['String']
   subSheetName: Scalars['String']
}

export type PopulateUserCallingConfigFromSheetResponse =
   | CloudCallingServiceAccountAndAdminAreNotInSameAccount
   | CloudCallingServiceAccountIsDeactivated
   | CloudCallingServiceAccountNotFound
   | DataSheetAccessDenied
   | DataSheetNotFound
   | DuplicateColumnHeaders
   | DuplicateResponsesForUniqueFieldsResponse
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidPopulationData
   | NoEntriesFoundInSubSheet
   | SheetDataLoadingRequest
   | SheetDataLoadingRequestAlreadyExists
   | SubSheetNotFound
   | UserIsNotAnAdministrator

export type PopulateUsersFromCsvParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   dataFile: FileUploaderUrlParams
   shouldResetEmptyValues: Scalars['Boolean']
}

export type PopulateUsersFromCsvResponse =
   | CsvDataLoadingRequest
   | DuplicateColumnHeaders
   | DuplicateEmails
   | EmailRefColumnIsNeeded
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidPopulationData
   | NoEntriesFoundInCsv
   | NoRecordsToLoad
   | UserIsNotAnAdministrator

export type PopulateUsersFromSheetParams = {
   chunkSize?: InputMaybe<Scalars['Int']>
   dataSheetId: Scalars['String']
   shouldResetEmptyValues: Scalars['Boolean']
   subSheetName: Scalars['String']
}

export type PopulateUsersFromSheetResponse =
   | DataSheetAccessDenied
   | DataSheetNotFound
   | DuplicateColumnHeaders
   | DuplicateEmails
   | EmailRefColumnIsNeeded
   | FieldReferencesAreDeleted
   | FieldReferencesNotFound
   | InProgressDataLoadingRequestLimitExceeded
   | InvalidPopulationData
   | NoEntriesFoundInSubSheet
   | NoRecordsToLoad
   | SheetDataLoadingRequest
   | SheetDataLoadingRequestAlreadyExists
   | SubSheetNotFound
   | UserIsNotAnAdministrator

export type Portal = {
   __typename?: 'Portal'
   brandBgImg?: Maybe<Scalars['String']>
   brandLogo?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   description?: Maybe<Scalars['String']>
   domainUrl: Scalars['String']
   pipelineIdsConfig?: Maybe<PortalPipelineIdsConfig>
   portalId: Scalars['String']
   portalPipelines: Array<BasePipeline>
   status: PortalStatus
   title: Scalars['String']
}

export type PortalAccessDenied = GraphQlBaseError & {
   __typename?: 'PortalAccessDenied'
   message?: Maybe<Scalars['String']>
   portalId: Scalars['String']
}

export type PortalActivity = {
   __typename?: 'PortalActivity'
   activityId: Scalars['String']
   activityTemplateId: Scalars['String']
   fields: Array<SystemFieldEnumResponseResult>
   title: Scalars['String']
   whatsappConsentGivenPhoneNumberFieldIds: Array<Scalars['String']>
}

export type PortalApplication = {
   __typename?: 'PortalApplication'
   applicationPipeline: BasePipeline
   bgImageUrl?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   headerFieldIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
   portalId: Scalars['String']
   status: PortalApplicationStatus
}

export enum PortalApplicationAction {
   Delete = 'DELETE',
   Restore = 'RESTORE'
}

export enum PortalApplicationAdditionalTabEnum {
   AssigneeTimeSpentLogs = 'ASSIGNEE_TIME_SPENT_LOGS',
   Blockchain = 'BLOCKCHAIN',
   Documents = 'DOCUMENTS',
   Payments = 'PAYMENTS',
   Scrutiny = 'SCRUTINY',
   ShortfallLogs = 'SHORTFALL_LOGS'
}

export type PortalApplicationConfig = {
   __typename?: 'PortalApplicationConfig'
   additionalVisibleTabEnums: Array<PortalApplicationAdditionalTabEnum>
   customDocumentFieldIds: Array<Scalars['String']>
   documentTabFieldIds: Array<Scalars['String']>
   documentTemplateIds: Array<Scalars['String']>
   documentTemplates: Array<DocumentTemplateOverviewDetails>
   drawingPdfVisibleStageIds: Array<Scalars['String']>
   fieldLogsVisibleUserTypes: Array<UserType>
   overviewFieldIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
   proposalFlowVisibleStageIds: Array<Scalars['String']>
   scrutinyReportVisibleStageIds: Array<Scalars['String']>
   surveyNumberFieldConfig?: Maybe<PortalSurveyNumberFieldConfig>
   tabs: Array<PortalApplicationTab>
   tdrRequestsVisibleStageIds: Array<Scalars['String']>
}

export type PortalApplicationConfigBulkResult = {
   __typename?: 'PortalApplicationConfigBulkResult'
   applicationConfigs: Array<PortalApplicationConfig>
}

export enum PortalApplicationConfigEnum {
   BgImageUrl = 'BG_IMAGE_URL',
   Description = 'DESCRIPTION',
   HeaderFieldIds = 'HEADER_FIELD_IDS'
}

export type PortalApplicationConfigValuesShouldBeEmpty = GraphQlBaseError & {
   __typename?: 'PortalApplicationConfigValuesShouldBeEmpty'
   message?: Maybe<Scalars['String']>
   portalApplicationId: Scalars['String']
   valueEnums: Array<PortalApplicationConfigEnum>
}

export type PortalApplicationCustomSection = {
   __typename?: 'PortalApplicationCustomSection'
   description?: Maybe<Scalars['String']>
   displayOrder: Scalars['Int']
   fieldIds: Array<Scalars['String']>
   isActive: Scalars['Boolean']
   name: Scalars['String']
   portalApplicationId: Scalars['String']
   sectionId: Scalars['String']
   sectionType: Scalars['String']
   tabId: Scalars['String']
}

export type PortalApplicationFieldResponseParams = {
   fieldIds: Array<Scalars['String']>
   systemFieldEnums: Array<ApplicationSystemFieldEnum>
}

export type PortalApplicationFilterParams = {
   fieldId: Scalars['String']
   operator: FilterOperator
   value?: InputMaybe<Scalars['String']>
}

export type PortalApplicationIdsNotFound = GraphQlBaseError & {
   __typename?: 'PortalApplicationIdsNotFound'
   message?: Maybe<Scalars['String']>
   portalApplicationIds: Array<Scalars['String']>
}

export type PortalApplicationNotFound = GraphQlBaseError & {
   __typename?: 'PortalApplicationNotFound'
   message?: Maybe<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type PortalApplicationOverviewFieldsLimitExceeded = GraphQlBaseError & {
   __typename?: 'PortalApplicationOverviewFieldsLimitExceeded'
   maxLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type PortalApplicationProperties = {
   __typename?: 'PortalApplicationProperties'
   availableActions: Array<PortalApplicationAction>
   createdAt: Scalars['String']
   fields: Array<PortalFieldResponseResult>
   isApplicationDeleted: Scalars['Boolean']
   paymentsInfo?: Maybe<PaymentsInfo>
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
}

export type PortalApplicationPropertiesFieldsArgs = {
   params: PortalApplicationFieldResponseParams
}

export enum PortalApplicationStatus {
   Active = 'ACTIVE',
   Inactive = 'INACTIVE'
}

export type PortalApplicationTab = {
   __typename?: 'PortalApplicationTab'
   category: Scalars['String']
   gofs: Array<PortalApplicationTabGoF>
   iconInfo?: Maybe<IconInfo>
   name: Scalars['String']
   portalApplicationId: Scalars['String']
   sections: Array<PortalApplicationTabSection>
   tabEnum: ApplicationTabEnum
   tabId: Scalars['String']
}

export type PortalApplicationTabGoF = {
   __typename?: 'PortalApplicationTabGoF'
   displayOrder: Scalars['Int']
   fieldIds: Array<Scalars['String']>
   gofId: Scalars['String']
   groups: Array<GroupsInPortalApplicationTabGoF>
   portalApplicationId: Scalars['String']
   sectionUiStyle: PortalSectionTabUiStyle
   tabId: Scalars['String']
   table?: Maybe<TabGoFCustomTable>
   tables: Array<TabGoFCustomTable>
}

export type PortalApplicationTabNotFound = GraphQlBaseError & {
   __typename?: 'PortalApplicationTabNotFound'
   message?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type PortalApplicationTabSection =
   | PortalApplicationCustomSection
   | PortalApplicationTabGoF

export type PortalApplicationsNotFound = GraphQlBaseError & {
   __typename?: 'PortalApplicationsNotFound'
   message?: Maybe<Scalars['String']>
   portalApplicationIds: Array<Scalars['String']>
}

export type PortalApplicationsResult = {
   __typename?: 'PortalApplicationsResult'
   applications: Array<PortalApplication>
}

export type PortalBackgroundImageIsEmpty = GraphQlBaseError & {
   __typename?: 'PortalBackgroundImageIsEmpty'
   message?: Maybe<Scalars['String']>
   portalId: Scalars['String']
}

export type PortalBaseTab = {
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   order: Scalars['Int']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: PortalTabType
}

export type PortalBrandBgImageSizeLimitExceeded = GraphQlBaseError & {
   __typename?: 'PortalBrandBgImageSizeLimitExceeded'
   maxLimitInKb: Scalars['Int']
   message?: Maybe<Scalars['String']>
   portalId: Scalars['String']
}

export type PortalBrandLogoIsEmpty = GraphQlBaseError & {
   __typename?: 'PortalBrandLogoIsEmpty'
   message?: Maybe<Scalars['String']>
   portalId: Scalars['String']
}

export type PortalBrandLogoSizeLimitExceeded = GraphQlBaseError & {
   __typename?: 'PortalBrandLogoSizeLimitExceeded'
   maxLimitInKb: Scalars['Int']
   message?: Maybe<Scalars['String']>
   portalId: Scalars['String']
}

export type PortalCustomSection = PortalSection & {
   __typename?: 'PortalCustomSection'
   description?: Maybe<Scalars['String']>
   displayOrder: Scalars['Int']
   fieldIds: Array<Scalars['String']>
   fields: Array<Field>
   isActive: Scalars['Boolean']
   name: Scalars['String']
   sectionId: Scalars['String']
   sectionType: PortalSectionType
}

export type PortalCustomSectionCompletionPercentage = {
   __typename?: 'PortalCustomSectionCompletionPercentage'
   percentage: Scalars['Int']
   sectionId: Scalars['String']
   totalFieldsCount: Scalars['Int']
   totalValidFieldResponsesCount: Scalars['Int']
}

export type PortalCustomTab =
   | PortalNestedTab
   | PortalProposalFlowTab
   | PortalRelationTab
   | PortalTdrRequestTab

export type PortalDomainUrlAlreadyUsed = GraphQlBaseError & {
   __typename?: 'PortalDomainUrlAlreadyUsed'
   domainUrl: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type PortalFieldResponseResult =
   | ActivityIsNotCreatedForField
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldNotFound
   | FieldResponse
   | NotPermittedField
   | NotPipelineItemSalesEntityField
   | SystemFieldNotConfigured
   | TaskFieldNotSupported

export type PortalFiltersConfiguration = {
   __typename?: 'PortalFiltersConfiguration'
   excludeStageIds: Array<Scalars['String']>
}

export type PortalIdsNotFound = GraphQlBaseError & {
   __typename?: 'PortalIdsNotFound'
   message?: Maybe<Scalars['String']>
   portalIds: Array<Scalars['String']>
}

export type PortalIsDeleted = GraphQlBaseError & {
   __typename?: 'PortalIsDeleted'
   message?: Maybe<Scalars['String']>
   portalId: Scalars['String']
}

export type PortalNestedTab = PortalBaseTab & {
   __typename?: 'PortalNestedTab'
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   order: Scalars['Int']
   orderedChildTabIds: Array<Scalars['String']>
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: PortalTabType
}

export type PortalNotFound = GraphQlBaseError & {
   __typename?: 'PortalNotFound'
   message?: Maybe<Scalars['String']>
   portalId: Scalars['String']
}

export type PortalPipeline = {
   __typename?: 'PortalPipeline'
   bgImageUrl?: Maybe<Scalars['String']>
   color?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   displayName: Scalars['String']
   headerFieldIds: Array<Scalars['String']>
   isMainPipeline: Scalars['Boolean']
   name: Scalars['String']
   pipelineDisplayStages: Array<Stage>
   pipelineIconId?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemTemplate: PortalPipelineItemTemplate
   pipelineItemTemplateConfig: PipelineItemTemplateConfig
   pipelineItemTemplateId: Scalars['String']
   pipelineItemType: PipelineItemType
   pipelineType: PipelineTypeEnum
}

export type PortalPipelineIdsConfig = {
   __typename?: 'PortalPipelineIdsConfig'
   enforcementPipelineId?: Maybe<Scalars['String']>
   iaPipelineId: Scalars['String']
   irPipelineId: Scalars['String']
   swPipelineId: Scalars['String']
}

export type PortalPipelineIdsConfigParams = {
   enforcementPipelineId?: InputMaybe<Scalars['String']>
   iaPipelineId: Scalars['String']
   irPipelineId: Scalars['String']
   swPipelineId: Scalars['String']
}

export type PortalPipelineIdsNotConfigured = GraphQlBaseError & {
   __typename?: 'PortalPipelineIdsNotConfigured'
   message?: Maybe<Scalars['String']>
}

export type PortalPipelineItemCompletionPercentageResult = {
   __typename?: 'PortalPipelineItemCompletionPercentageResult'
   gofWisePercentage: Array<RecordGoFCompletionPercentage>
   pipelineItemId: Scalars['String']
   sectionWisePercentage: Array<PortalCustomSectionCompletionPercentage>
   tabWisePercentage: Array<PortalPipelineItemTabPercentage>
}

export type PortalPipelineItemTabPercentage = {
   __typename?: 'PortalPipelineItemTabPercentage'
   percentage: Scalars['Int']
   tabId: Scalars['String']
}

export type PortalPipelineItemTemplate = {
   __typename?: 'PortalPipelineItemTemplate'
   additionalVisibleTabEnums: Array<PortalApplicationAdditionalTabEnum>
   applicationTemplateProperties?: Maybe<ApplicationTemplateProperties>
   customDocumentFieldIds: Array<Scalars['String']>
   customTabs: Array<PortalCustomTab>
   deemedApprovalFields?: Maybe<DeemedApprovalFieldsConfig>
   documentFieldIds: Array<Scalars['String']>
   drawingPdfVisibleStageIds: Array<Scalars['String']>
   fieldLogsVisibleUserTypes: Array<UserType>
   name: Scalars['String']
   overviewFieldIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   pipelineItemType: PipelineItemType
   proposalFlowVisibleStageIds: Array<Scalars['String']>
   scrutinyProcessVisibleStageIds: Array<Scalars['String']>
   surveyNumberFieldConfig?: Maybe<PortalSurveyNumberFieldConfig>
   systemGof: TabGoF
   tabs: Array<PortalTab>
   tdrRequestsVisibleStageIds: Array<Scalars['String']>
}

export type PortalPipelineResult =
   | NotApplicationPipeline
   | PipelineNotFound
   | PipelineNotInPortal
   | PortalAccessDenied
   | PortalIsDeleted
   | PortalNotFound
   | PortalPipeline

export type PortalProposalFlowTab = PortalBaseTab & {
   __typename?: 'PortalProposalFlowTab'
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   order: Scalars['Int']
   parentTabId?: Maybe<Scalars['String']>
   proposalFlowTabs: Array<ProposalFlowTabConfigInPortal>
   tabId: Scalars['String']
   tabType: PortalTabType
}

export type PortalRelatedObject = {
   __typename?: 'PortalRelatedObject'
   displayName?: Maybe<Scalars['String']>
   fields: Array<PortalFieldResponseResult>
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
}

export type PortalRelatedObjectFieldsArgs = {
   params: PortalApplicationFieldResponseParams
}

export type PortalRelatedObjectsResult = {
   __typename?: 'PortalRelatedObjectsResult'
   relatedObjects: Array<PortalRelatedObject>
   totalCount: Scalars['Int']
}

export type PortalRelationParams = {
   relationId: Scalars['String']
   relationTarget?: InputMaybe<SelfRelationTarget>
}

export type PortalRelationTab = PortalBaseTab & {
   __typename?: 'PortalRelationTab'
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   order: Scalars['Int']
   parentTabId?: Maybe<Scalars['String']>
   relation?: Maybe<Relation>
   relationId?: Maybe<Scalars['String']>
   relationTarget?: Maybe<SelfRelationTarget>
   tabId: Scalars['String']
   tabType: PortalTabType
}

export type PortalSection = {
   description?: Maybe<Scalars['String']>
   displayOrder: Scalars['Int']
   fieldIds: Array<Scalars['String']>
   fields: Array<Field>
   name: Scalars['String']
   sectionId: Scalars['String']
   sectionType: PortalSectionType
}

export enum PortalSectionTabUiStyle {
   CustomTable = 'CUSTOM_TABLE',
   Default = 'DEFAULT',
   MultiTable = 'MULTI_TABLE',
   SetbackTable = 'SETBACK_TABLE',
   Table = 'TABLE'
}

export enum PortalSectionType {
   CustomSection = 'CUSTOM_SECTION',
   GofSection = 'GOF_SECTION'
}

export enum PortalStatus {
   Published = 'PUBLISHED',
   Unpublished = 'UNPUBLISHED'
}

export type PortalSurveyNumberFieldConfig = {
   __typename?: 'PortalSurveyNumberFieldConfig'
   areaFieldId?: Maybe<Scalars['String']>
   concatenatedSurveyNumbersFieldId?: Maybe<Scalars['String']>
   districtFieldId: Scalars['String']
   gofId?: Maybe<Scalars['String']>
   mandalFieldId: Scalars['String']
   prohibitingSupportingDocumentFieldId: Scalars['String']
   surveyNumberCategoryFieldId?: Maybe<Scalars['String']>
   surveyNumberFieldId: Scalars['String']
   ulbCodeFieldId: Scalars['String']
   villageFieldId: Scalars['String']
}

export type PortalTdrRequestTab = PortalBaseTab & {
   __typename?: 'PortalTDRRequestTab'
   authorityFieldId?: Maybe<Scalars['String']>
   availTdrCreditsFieldId: Scalars['String']
   caseTypeFieldId?: Maybe<Scalars['String']>
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   order: Scalars['Int']
   parentTabId?: Maybe<Scalars['String']>
   proposedSiteAreaFieldId?: Maybe<Scalars['String']>
   proposedSiteMarketValueFieldId?: Maybe<Scalars['String']>
   scrutinyCalculatedTdrAreaFieldId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: PortalTabType
   takeProposedSiteDetails?: Maybe<Scalars['Boolean']>
   takeTdrCurrentMarketValue?: Maybe<Scalars['Boolean']>
   tdrUtilizationContext?: Maybe<TdrUtilizationContext>
   validateTdrAgainstProposedSite?: Maybe<Scalars['Boolean']>
}

export type PortalTab = {
   __typename?: 'PortalTab'
   category: Scalars['String']
   gofs: Array<TabGoF>
   iconInfo?: Maybe<IconInfo>
   name: Scalars['String']
   orderedGofIds: Array<Scalars['String']>
   sections: Array<TabSection>
   tabEnum: ApplicationTabEnum
   tabId: Scalars['String']
}

export enum PortalTabType {
   NestedTab = 'NESTED_TAB',
   ProposalFlowTab = 'PROPOSAL_FLOW_TAB',
   Relation = 'RELATION',
   TdrRequestTab = 'TDR_REQUEST_TAB'
}

export enum PortalType {
   ArchitectPortal = 'ARCHITECT_PORTAL',
   CitizenPortal = 'CITIZEN_PORTAL'
}

export type PortalsInAccountResult = {
   __typename?: 'PortalsInAccountResult'
   portals: Array<Portal>
   totalCount: Scalars['Int']
}

export type PortalsResult = {
   __typename?: 'PortalsResult'
   portals: Array<Portal>
}

export type PreSignedGetUrlForApplicationFieldInPortalResult = {
   __typename?: 'PreSignedGetUrlForApplicationFieldInPortalResult'
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   portalId: Scalars['String']
   preSignedUrl: Scalars['String']
}

export type PreSignedGetUrlForCrmEntityFieldLogResult = {
   __typename?: 'PreSignedGetUrlForCrmEntityFieldLogResult'
   crmEntityId: Scalars['String']
   fieldId: Scalars['String']
   fieldResponseId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   logId: Scalars['Int']
   preSignedUrl: Scalars['String']
}

export type PreSignedGetUrlForCrmEntityFieldResult = {
   __typename?: 'PreSignedGetUrlForCrmEntityFieldResult'
   crmEntityId: Scalars['String']
   fieldId: Scalars['String']
   fieldResponseId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   preSignedUrl: Scalars['String']
}

export type PreSignedGetUrlForPipelineItemRemarksInTaskDraftResult = {
   __typename?: 'PreSignedGetUrlForPipelineItemRemarksInTaskDraftResult'
   preSignedUrl: Scalars['String']
   taskId: Scalars['String']
}

export type PreSignedGetUrlForPipelineItemRemarksResult = {
   __typename?: 'PreSignedGetUrlForPipelineItemRemarksResult'
   preSignedUrl: Scalars['String']
   remarksAttachmentId: Scalars['String']
}

export type PreSignedGetUrlForPortal = {
   __typename?: 'PreSignedGetUrlForPortal'
   contentDispositionType: ContentDisposition
   preSignedUrl: Scalars['String']
}

export type PreSignedGetUrlForRelatedEntityFieldResult = {
   __typename?: 'PreSignedGetUrlForRelatedEntityFieldResult'
   contentDispositionType: ContentDisposition
   fieldId: Scalars['String']
   fileId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   preSignedUrl: Scalars['String']
   relatedEntityId: Scalars['String']
}

export type PreSignedGetUrlForRelatedEntityRemarksResult = {
   __typename?: 'PreSignedGetUrlForRelatedEntityRemarksResult'
   preSignedUrl: Scalars['String']
   relatedEntityId: Scalars['String']
   relatedEntityRemarksAttachmentId: Scalars['String']
}

export type PreSignedGetUrlForTdrCertificateInPortalResult = {
   __typename?: 'PreSignedGetUrlForTDRCertificateInPortalResult'
   preSignedUrl: Scalars['String']
   tdrRequestId: Scalars['String']
}

export type PreSignedPostUrlData = {
   __typename?: 'PreSignedPostUrlData'
   key: Scalars['String']
   policy: Scalars['String']
   preSignedPostUrl: Scalars['String']
   xAmzAlgorithm: Scalars['String']
   xAmzCredential: Scalars['String']
   xAmzDate: Scalars['String']
   xAmzSignature: Scalars['String']
}

export type PreSignedPostUrlForApplicationFieldInPortalResult = {
   __typename?: 'PreSignedPostUrlForApplicationFieldInPortalResult'
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   portalId: Scalars['String']
   postUrlData: PreSignedPostUrlData
}

export type PreSignedPostUrlForCrmEntityFieldResult = {
   __typename?: 'PreSignedPostUrlForCrmEntityFieldResult'
   crmEntityId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   postUrlData: PreSignedPostUrlData
}

export type PreSignedPostUrlForDataExportRequestResult = {
   __typename?: 'PreSignedPostUrlForDataExportRequestResult'
   postUrlData: PreSignedPostUrlData
}

export type PreSignedPostUrlForRelatedEntityFieldResult = {
   __typename?: 'PreSignedPostUrlForRelatedEntityFieldResult'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   postUrlData: PreSignedPostUrlData
   relatedEntityId: Scalars['String']
}

export type PreSignedPutUrlForApplicationFieldInPortalResult = {
   __typename?: 'PreSignedPutUrlForApplicationFieldInPortalResult'
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   portalId: Scalars['String']
   preSignedPutUrl: Scalars['String']
}

export type PreSignedPutUrlForCrmEntityFieldResult = {
   __typename?: 'PreSignedPutUrlForCrmEntityFieldResult'
   crmEntityId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   preSignedPutUrl: Scalars['String']
}

export type PreSignedPutUrlForDataExportRequestResult = {
   __typename?: 'PreSignedPutUrlForDataExportRequestResult'
   preSignedUrl: Scalars['String']
}

export type PreSignedPutUrlForPortal = {
   __typename?: 'PreSignedPutUrlForPortal'
   preSignedUrl: Scalars['String']
}

export type PreSignedPutUrlForRelatedEntityFieldResult = {
   __typename?: 'PreSignedPutUrlForRelatedEntityFieldResult'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   preSignedUrl: Scalars['String']
   relatedEntityId: Scalars['String']
}

export type PreSignedUrlEntityAccessDenied = GraphQlBaseError & {
   __typename?: 'PreSignedUrlEntityAccessDenied'
   entityId: Scalars['String']
   entityType: PreSignedUrlEntityType
   message?: Maybe<Scalars['String']>
}

export enum PreSignedUrlEntityType {
   ApplicationManagement = 'APPLICATION_MANAGEMENT',
   OfficerTransfer = 'OFFICER_TRANSFER',
   ReconciliationRequest = 'RECONCILIATION_REQUEST',
   ScrutinyKeyGeneration = 'SCRUTINY_KEY_GENERATION',
   TdrManagement = 'TDR_MANAGEMENT'
}

export type PreSignedUrlForDataExportResult = {
   __typename?: 'PreSignedUrlForDataExportResult'
   contentDispositionType: ContentDisposition
   dataExportRequestId: Scalars['String']
   preSignedUrl: Scalars['String']
}

export type PrecisionLimitExceededForTdrMarketValue = GraphQlBaseError & {
   __typename?: 'PrecisionLimitExceededForTDRMarketValue'
   marketValue: Scalars['Float']
   message?: Maybe<Scalars['String']>
}

export type PrecisionLimitExceededForTdrRequestedArea = GraphQlBaseError & {
   __typename?: 'PrecisionLimitExceededForTDRRequestedArea'
   message?: Maybe<Scalars['String']>
   requestedArea: Scalars['Float']
}

export type PrefixOptions = {
   __typename?: 'PrefixOptions'
   conditionalPrefixOptions: Array<ConditionalFieldOptions>
   isEnabled: Scalars['Boolean']
   optionsValueType: OptionsValueType
   values: Array<Scalars['String']>
}

export type PrefixOptionsParams = {
   isEnabled: Scalars['Boolean']
   values: Array<Scalars['String']>
}

export type PresignedUrlFileIdNotFound = GraphQlBaseError & {
   __typename?: 'PresignedUrlFileIdNotFound'
   entityId: Scalars['String']
   entityType: PreSignedUrlEntityType
   fileId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ProhibitingSupportingDocumentFieldNotFound = GraphQlBaseError & {
   __typename?: 'ProhibitingSupportingDocumentFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type PropertiesUserAccessDenied = GraphQlBaseError & {
   __typename?: 'PropertiesUserAccessDenied'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type PropertiesUserNotFound = GraphQlBaseError & {
   __typename?: 'PropertiesUserNotFound'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type PropertyNotFound = GraphQlBaseError & {
   __typename?: 'PropertyNotFound'
   message?: Maybe<Scalars['String']>
   propertyId: Scalars['String']
   sectionId?: Maybe<Scalars['String']>
}

export type ProposalFlowTab = BaseTab & {
   __typename?: 'ProposalFlowTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type ProposalFlowTabConfig = {
   __typename?: 'ProposalFlowTabConfig'
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   order: Scalars['Int']
   pipelines: Array<PipelineConfig>
}

export type ProposalFlowTabConfigInPortal = {
   __typename?: 'ProposalFlowTabConfigInPortal'
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   order: Scalars['Int']
   pipelineIds: Array<Scalars['String']>
   pipelines: Array<PipelineConfig>
}

export type ProposalFlowTabsConfig = {
   __typename?: 'ProposalFlowTabsConfig'
   enableProposalFlow: Scalars['Boolean']
   proposalFlowTabs: Array<ProposalFlowTabConfig>
}

export type ProposalTypeFieldNotFound = GraphQlBaseError & {
   __typename?: 'ProposalTypeFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ProvideAtLeastOneIdentificationField = GraphQlBaseError & {
   __typename?: 'ProvideAtLeastOneIdentificationField'
   message?: Maybe<Scalars['String']>
}

export type ProvideValidLookerStudioUrl = GraphQlBaseError & {
   __typename?: 'ProvideValidLookerStudioUrl'
   message?: Maybe<Scalars['String']>
}

export type PublicApplicationSearchFilterField = {
   __typename?: 'PublicApplicationSearchFilterField'
   fieldId: Scalars['String']
   operator: FilterOperator
}

export type PublicSearchApplicationConfigResult = {
   __typename?: 'PublicSearchApplicationConfigResult'
   categories: Array<PublicSearchFieldsCategory>
   filterFields: Array<PublicApplicationSearchFilterField>
   overViewFieldIds: Array<Scalars['String']>
   properties: Array<ApplicationPropertyConfig>
}

export type PublicSearchFieldsCategory = {
   __typename?: 'PublicSearchFieldsCategory'
   categoryId: Scalars['String']
   iconUrl: Scalars['String']
   isAllFieldsMandatory?: Maybe<Scalars['Boolean']>
   mandatoryFieldIds?: Maybe<Array<Maybe<Scalars['String']>>>
   name: Scalars['String']
}

export type PublishAutomationWorkFlowParams = {
   automationWorkflowId: Scalars['String']
}

export type PublishAutomationWorkFlowResponse =
   | AtLeastOneActionNodeIsRequired
   | AutomationWorkflowNotFound
   | IncompleteTriggerConfig
   | PartiallyConfiguredNodesExists
   | PipelineAccessDenied
   | PublishAutomationWorkFlowResult
   | ScheduledTriggerAtLeastHaveOneFilterCondition
   | UserIsNotAnAdministrator

export type PublishAutomationWorkFlowResult = {
   __typename?: 'PublishAutomationWorkFlowResult'
   automationWorkflowId: Scalars['String']
   status: AutomationWorkFlowStatus
}

export type PublishFormParams = {
   formId: Scalars['String']
}

export type PublishFormResponse =
   | FormLayoutIsRequired
   | FormNotFound
   | FormSubmissionConfigIsRequired
   | IdentifierFieldIsRequired
   | IsRequiredShouldBeTrueForIdentificationField
   | PublishFormResult
   | UserIsNotAnAdministrator

export type PublishFormResult = {
   __typename?: 'PublishFormResult'
   formId: Scalars['String']
}

export type PublishLeadDistributionRuleParams = {
   leadDistributionRuleId: Scalars['String']
}

export type PublishLeadDistributionRuleResponse =
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | PartiallyConfiguredLeadDistributionStepsExists
   | PublishLeadDistributionRuleResult
   | UserIsNotAnAdministrator

export type PublishLeadDistributionRuleResult = {
   __typename?: 'PublishLeadDistributionRuleResult'
   leadDistributionRuleId: Scalars['String']
}

export type PublishPipelineItemRemarksParams = {
   pipelineItemRemarksId: Scalars['String']
}

export type PublishPipelineItemRemarksResponse =
   | CannotPublishRemarksAddedByOtherUser
   | NotADraftedPipelineItemRemarks
   | PipelineItemAccessDenied
   | PipelineItemRemarksCannotBeEmpty
   | PipelineItemRemarksIdNotFound
   | PublishPipelineItemRemarksResult

export type PublishPipelineItemRemarksResult = {
   __typename?: 'PublishPipelineItemRemarksResult'
   draftedRemarks: PipelineItemRemarks
   pipelineItemRemarksId: Scalars['String']
}

export type PublishScoringConfigParams = {
   scoringConfigId: Scalars['String']
}

export type PublishScoringConfigResponse =
   | AtLeastOneParameterRequired
   | InvalidWeightageSum
   | ParametersShouldHaveAtLeastOneCondition
   | PublishScoringConfigResult
   | ScoringConfigNotFound
   | UserIsNotAnAdministrator
   | WeightageNotConfiguredParameters

export type PublishScoringConfigResult = {
   __typename?: 'PublishScoringConfigResult'
   scoringConfigId: Scalars['String']
   status: ScoringConfigStatus
}

export type PublishedDocument = {
   __typename?: 'PublishedDocument'
   documentId: Scalars['String']
   documentTemplateId: Scalars['String']
   file: FileUploaderUrlResponse
   isRejected: Scalars['Boolean']
   lastUpdationDatetime: Scalars['String']
   name: Scalars['String']
}

export type PublishedFormVersion = {
   __typename?: 'PublishedFormVersion'
   publishedAt: Scalars['String']
   publishedFormId: Scalars['String']
   versionNumber: Scalars['Int']
}

export type PublishedFormVersionNotFound = GraphQlBaseError & {
   __typename?: 'PublishedFormVersionNotFound'
   message?: Maybe<Scalars['String']>
   publishedFormId: Scalars['String']
}

export type PublishedFormVersionResult =
   | PublishedFormVersion
   | PublishedFormVersionNotFound

export type PurchaseRequestAlreadyRaised = GraphQlBaseError & {
   __typename?: 'PurchaseRequestAlreadyRaised'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type PushContactToPipelineParams = {
   assigneeFieldIdsToNotify?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   assignees?: InputMaybe<Array<AssigneeFieldParams>>
   contactId: Scalars['String']
   stageId: Scalars['String']
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type PushContactToPipelineResponse =
   | ContactAccessDenied
   | ContactAlreadyPushed
   | ContactAndStageAreNotInSameAccount
   | ContactIsDeleted
   | ContactNotFound
   | DuplicateAssigneeFieldIdsToNotify
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidAssigneeFieldIdsToNotify
   | LeadAssigneesAreDeactivated
   | LeadAssigneesNotFound
   | NotLeadAssigneeFields
   | NotLeadPipelineStage
   | PipelineAccessDenied
   | PipelineAccessDeniedToAssignees
   | PushContactToPipelineResult
   | StageNotFound
   | YouDonNotHavePermissionToSetGivenUsersAsAssignees

export type PushContactToPipelineResult = {
   __typename?: 'PushContactToPipelineResult'
   lead: Lead
}

export enum QrCodePosition {
   BottomLeft = 'BOTTOM_LEFT',
   BottomRight = 'BOTTOM_RIGHT',
   TopLeft = 'TOP_LEFT',
   TopRight = 'TOP_RIGHT'
}

export enum QrCodeSize {
   Large = 'LARGE',
   Medium = 'MEDIUM',
   Small = 'SMALL'
}

export type Query = {
   __typename?: 'Query'
   checkAllowApplicationSubmit: CheckAllowApplicationSubmitResponse
   checkItemsExistInView: CheckItemsExistInViewResponse
   evaluateEntityRuleSetsInPortal: EvaluateRuleSetsInPortalResponse
   feeCalculate: FeeCalculateResponse
   generateDocusignEmbedUrlForPipelineItemDocument: GenerateDocusignEmbedUrlForPipelineItemDocumentResponse
   getAccountAutomationWorkflowExecLogs: GetAccountAutomationWorkflowExecLogsResponse
   getAccountLeadDistributionRuleExecLogs: GetAccountLeadDistributionRuleExecLogsResponse
   getAccountLeadDistributionRules: GetLeadDistributionRulesResponse
   getAccountPlugins: GetAccountPluginsResult
   getAccountScheduledAutomationWorkflowLogs?: Maybe<
      GetAccountScheduledAutomationWorkflowLogsResponse
   >
   getActivities: Array<ActivityResult>
   getActivityFields: GetActivityFieldsResponse
   getActivityTemplates: Array<ActivityTemplateResult>
   getAdminProfile: AdminProfile
   getAdminRecordCreationConfigsForSalesTemplates: Array<
      AdminRecordCreationConfigsForSalesTemplatesResult
   >
   getAgentAllocationGroups: Array<GetAgentAllocationGroupsResult>
   getAgentAllocationGroupsInAccount: GetAgentAllocationGroupsInAccountResponse
   getAgentsForManager: GetAgentsForManagerResponse
   getAnalyticsCopilotHistory: GetAnalyticsCopilotHistoryResult
   getAnalyticsCopilotResponse: GetAnalyticsCopilotResult
   getAnalyticsCopilotVisualization: GetAnalyticsCopilotVisualizationResult
   getApplicationAddAnotherFields: GetApplicationAddAnotherFieldsResponse
   getApplicationAddAnotherFieldsInPortal: GetApplicationAddAnotherFieldsInPortalResponse
   getApplicationAddAnotherGofsFields: GetApplicationAddAnotherGoFsFieldsResponse
   getApplicationAddAnotherGofsFieldsInPortal: GetApplicationAddAnotherGoFsFieldsInPortalResponse
   getApplicationCustomizations: GetApplicationCustomizationsResponse
   getApplicationCustomizationsInPortal: GetApplicationCustomizationsInPortalResponse
   getApplicationDocumentsInPortal: GetApplicationDocumentsInPortalResponse
   getApplicationDrawingFileLogs: GetApplicationDrawingFileLogsResponse
   getApplicationEnforcementComplaints: GetApplicationEnforcementComplaintsResponse
   getApplicationErrorFieldsInPortal: GetApplicationErrorFieldsInPortalResponse
   getApplicationFields: GetApplicationFieldsResponse
   getApplicationGofSurveyNumberRemarks: GetApplicationGoFSurveyNumberRemarksResponse
   getApplicationGofSurveyNumberRemarksInPortal: GetApplicationGoFSurveyNumberRemarksInPortalResponse
   getApplicationLatestDataInPortal: GetApplicationLatestDataInPortalResponse
   getApplicationLatestPublishedDocumentsInPortal: GetApplicationLatestPublishedDocumentsInPortalResponse
   getApplicationManagementLogs?: Maybe<GetApplicationManagementLogsResponse>
   getApplicationObjectionTabsVisibleStatus: GetApplicationObjectionTabsVisibleStatusResponse
   getApplicationProfile: GetApplicationProfileResponse
   getApplicationRefundDetails: GetApplicationRefundDetailsResponse
   getApplicationScrutinyReportDetails: GetApplicationScrutinyReportDetailsResponse
   getApplicationScrutinyReportDetailsV0: GetApplicationScrutinyReportDetailsResponse
   getApplicationStageSummary: GetApplicationStageSummaryResponse
   getApplicationStageTransitionCheckpointsConfig: GetApplicationStageTransitionCheckpointsConfigResponse
   getApplicationStageTransitionCheckpointsConfigInPortal: GetApplicationStageTransitionCheckpointsConfigInPortalResponse
   getApplicationSurveyNumberRemarks: GetApplicationSurveyNumberRemarksResponse
   getApplicationSurveyNumberRemarksInPortal: GetApplicationSurveyNumberRemarksInPortalResponse
   getApplicationSystemFields: Array<ApplicationSystemFieldsResponse>
   /** @deprecated This api will return only required error fields, use get_application_error_fields_in_portal api for returning all types of error */
   getApplicationUnfilledRequiredFieldsInPortal: GetApplicationUnfilledRequiredFieldsInPortalResponse
   getApplicationValidationsStatusInPortal: GetApplicationValidationsStatusInPortalResponse
   getApplicationVisibleGofsInPortal: GetApplicationVisibleGoFsInPortalResponse
   getApplicationVrVisibleEntitiesInPortal: GetApplicationVrVisibleEntitiesInPortalResponse
   getApplicationsForFileNumbers: GetApplicationsForFileNumbersResponse
   getApplicationsInApplicationManagement?: Maybe<
      GetApplicationsInApplicationManagementResponse
   >
   getApplicationsInPortal: GetApplicationsInPortalResponse
   getArchitectProfile: Architect
   getAssignFriendActionVisibility: GetAssignFriendActionVisibilityResponse
   getAssignFriendConfig: GetAssignFriendConfigResponse
   getAssignedFriendApplications: GetAssignedFriendApplicationsResponse
   getAssigneeGroups: GetAssigneeGroupsResponse
   getAssigneeTimespentLogs: GetAssigneeTimespentLogsResponse
   getAssigneeTimespentLogsBulk: GetAssigneeTimespentLogsBulkResponse
   getAssigneeTimespentLogsInPortal: GetAssigneeTimespentLogsInPortalResponse
   getAssigneeTimespentLogsInPortalBulk: GetAssigneeTimespentLogsInPortalBulkResponse
   getAssociatedPipelinesForPipelineItemTemplates: GetAssociatedPipelinesForPipelineItemTemplatesResponse
   getAttachments: Array<RemarkAttachmentResult>
   getAttendanceTrackingConfig: AttendanceTrackingConfigResponse
   getAutomationWorkflowExecConfigs: Array<AutomationWorkflowExecConfigResult>
   getAutomationWorkflowExecLogs: Array<AutomationWorkflowExecLogResult>
   getAutomationWorkflowExecLogsFilter?: Maybe<
      GetAutomationWorkflowExecLogsFilterResponse
   >
   getAutomationWorkflowExecLogsTabCustomization?: Maybe<
      GetAutomationWorkflowExecLogsTabCustomizationResponse
   >
   getAutomationWorkflowNodeActions?: Maybe<
      AutomationWorkflowNodeActionsResponse
   >
   getAutomationWorkflows: Array<AutomationWorkflowResult>
   getAvailableCallLogsForTask: GetAvailableCallLogsForTaskResponse
   getBarGraph: BarGraphResult
   getBoard: GetBoardResult
   getBoardListsInBoard?: Maybe<BoardListsInBoardResponse>
   getBoards: BoardsResult
   getBoardsSharedPermissions: Array<GetBoardsSharedPermissionsResult>
   getBpsPendingTaskOnPipelineItem: GetBpsPendingTaskOnPipelineItemResponse
   getBpsShortfallCounter: GetBpsShortFallCounterResponse
   getBpsShortfallCounterInPortal: GetBpsShortFallCounterInPortalResponse
   getBpsTaskConfigForPipelineItem: GetBpsTaskConfigForPipelineItemResponse
   getBpsTemplateConfig: GetBpsTemplateConfigResponse
   getCallLogsWithFilters: GetCallLogsWithFiltersResponse
   getCategoryWisePipelineBoards: Array<CategoryPipelineBoardsResult>
   getChildTabsForParentTabs: GetChildTabsForParentTabsResponse
   getCitizenAccountStatus: GetCitizenAccountStatusResponse
   getCloudCallingUserConfigs: UserCloudCallingConfigsResult
   getColors: Array<ColorResponse>
   getConflictedAssociatedPipelineItems: ConflictedAssociatedPipelineItemsResponse
   getConflictedAssociatedRelatedEntities: ConflictedAssociatedRelatedEntitiesResponse
   getContact: ContactResult
   getContactFields: GetContactFieldsResponse
   getContactLeads: GetContactLeadsResponse
   getContactPipelines: GetContactPipelineResponse
   getContactsSystemFields: Array<ContactSystemFieldsResponse>
   getCrmEntityLinkedRelatedObjects: GetCrmEntityLinkedRelatedObjectsResponse
   getCrmTemplateScoringConfigBulk: CrmTemplateScoringConfigBulkResponse
   getCustomSectionsVisibilityStatusInLayoutForPipelineItem: GetCustomSectionsVisibilityStatusInLayoutForPipelineItemResponse
   getDashboard: GetDashboardResponse
   getDashboardsCountByIdentification: GetDashboardsCountByIdentificationResponse
   getDataExportRequests: GetDataExportRequestsResponse
   getDataLoadingRequests: GetDataLoadingRequestsResponse
   getDealAddAnotherFields: GetDealAddAnotherFieldsResponse
   getDealAddAnotherGofsFields: GetDealAddAnotherGoFsFieldsResponse
   getDealFields: GetDealFieldsResponse
   getDealHistory: DealHistoryResponse
   getDealProfile: GetDealProfileResponse
   getDealTemplateSystemFields: GetDealTemplateSystemFieldsResponse
   getDealsSystemFields: Array<DealSystemFieldsResponse>
   getDeletedFieldsForGofs: Array<GoFDeletedFieldsResult>
   getDeletedGofsForSalesTemplates: Array<SalesTemplateDeletedGoFsResult>
   getDocumentHistory: GetDocumentHistoryResponse
   getDocumentTemplatePreviewWithMockData: GetDocumentTemplatePreviewWithMockDataResponse
   getDocumentTemplates: GetDocumentTemplatesResponse
   getDocumentTemplatesByVersionForAdmin: GetDocumentTemplatesByVersionForAdminResponse
   getDocumentTemplatesForPipelineItemTemplate: GetDocumentTemplatesForPipelineItemTemplateResponse
   getDocumentTemplatesForPipelineItemTemplates: GetDocumentTemplatesForPipelineItemTemplatesResponse
   getDocumentTemplatesForPipelineItemTemplatesByAdmin: GetDocumentTemplatesForPipelineItemTemplateByAdminResponse
   getDocumentTemplatesPermittedActions: GetDocumentTemplatesPermittedActionsResponse
   getDocumentsForDocumentTemplates: GetDocumentsForDocumentTemplatesResponse
   getDonutChart: DonutChartResult
   getEligibleTdrBanksInPortal: GetEligibleTdrBanksInPortalResponse
   getEntitiesCountForFilters: GetEntitiesCountForFiltersResponse
   getEntityBoards?: Maybe<GetEntityBoardsResponse>
   getEntityCheckedCheckpoints: GetEntityCheckedCheckpointsResponse
   getEntityDeals: GetEntityDealsResponse
   getEntityFeeRuleSetForEntity: GetEntityFeeRuleSetForEntityResponse
   getEntityFeeRuleSetOrdersPreview: GetEntityFeeRuleSetOrdersPreviewResponse
   getEntityFeeRuleSetsForEntity: GetEntityFeeRuleSetsForEntityResponse
   getEntityJsonConfiguration: GetEntityJsonConfigurationResponse
   getEntityNotes: GetEntityNotesResponse
   getEntityRuleSets: GetEntityRuleSetsResponse
   getEntityTdrRequests: GetEntityTdrRequestsResponse
   getEntityTdrRequestsInPortal: GetEntityTdrRequestsInPortalResponse
   getEntityUncheckedCheckpoints: GetEntityUncheckedCheckpointsResponse
   getEventBasedLeadDistributionRuleSummary: GetEventBasedLeadDistributionRuleSummaryResponse
   getFailedTrackActivityLogs: GetFailedTrackActivityLogResult
   getFeeRuleSetLogs: GetFeeRuleSetLogsResponse
   getFieldEntityRuleSetsInPortal: GetFieldEntityRuleSetsInPortalResponse
   getFieldOptionsForApplicationInPortal: GetFieldOptionsForApplicationInPortalResponse
   getFieldOptionsForCrmEntity: GetFieldOptionsForCrmEntityResponse
   getFieldOptionsForRecordCreation: GetFieldOptionsForRecordCreationResponse
   getFieldOptionsForRelatedEntityField: GetFieldOptionsForRelatedEntityFieldResponse
   getFieldOptionsForSearchAndMonitoring: GetFieldOptionsForSearchAndMonitoringResponse
   getFieldRoles: GetFieldsRolesResponse
   getFields: Array<FieldResult>
   getFieldsInPortal: GetFieldsInPortalResponse
   getFieldsIncludingConstantFields: GetFieldsIncludingConstantFieldsResponse
   /** @deprecated Query will be removed */
   getFilterFields?: Maybe<FilterFieldsResponse>
   getFilterSetEntitiesCount: GetFilterSetEntitiesCountResponse
   getFilters?: Maybe<GetFiltersResponse>
   getFiltersForAutomationWorkflowFilterSet: GetFiltersForAutomationWorkflowFilterSetResponse
   getFiltersForBoard?: Maybe<GetBoardFiltersResponse>
   getFiltersForBoardList?: Maybe<GetBoardListFiltersResponse>
   getFiltersForConditionNode: ConditionNodeFiltersResponse
   getFiltersForEventTriggerFilterSet: GetFiltersForEventTriggerFilterSetResponse
   getFiltersForView?: Maybe<GetViewFiltersResponse>
   getForm: FormResult
   getFormFailedSubmissionLogs: GetFormFailedSubmissionLogsResponse
   getFormFieldsInPdf: GetFormFieldsInPdfResponse
   getFormIdentificationFields: GetFormIdentificationFieldsResponse
   getFormsForParent: GetFormsForParentResponse
   getFunctions: GetFunctionsResponse
   getFunnelGraph: FunnelGraphResult
   getGallaboxAccountPluginServiceAccounts: GetGallaboxAccountPluginServiceAccountsResponse
   getGallaboxPluginServiceAccounts: GetGallaboxPluginServiceAccountsResponse
   getGofs: Array<GoFResult>
   getGraph: GraphResult
   getGraphsInDashboard: GetGraphsInDashboardResponse
   getGraphsInView: GetGraphsInViewResult
   getGupShupAccountPluginServiceAccounts: GetGupShupAccountPluginServiceAccountsResponse
   getGupShupPluginServiceAccounts: GetGupShupPluginServiceAccountsResponse
   getIdentificationsInAccount: IdentificationsInAccountResponse
   getIsTgBPassFileNumberValid: GetTGbPassFileNumberValid
   getItemIdsInView: ItemIdsInViewResponse
   getJsonConfigurations: GetJsonConfigurationsResponse
   getKnowlarityAccountPluginServiceAccounts: GetKnowlarityAccountPluginServiceAccountsResponse
   getKnowlarityServiceAccounts: GetKnowlarityServiceAccountsResponse
   getLatestPendingPipelineItemTasks: GetLatestPendingPipelineItemTasksResponse
   getLatestPipelineItemTaskFieldsForFields: GetLatestPipelineItemTaskFieldsForFieldsResponse
   getLayoutForEntityDetails: GetLayoutForEntityDetailsResponse
   getLayoutParentTabsForEntityDetails: GetLayoutParentTabsForEntityDetailsResponse
   getLayoutTabsForPipelineTemplate: GetLayoutTabsForPipelineTemplateResponse
   getLeadAddAnotherFields: GetLeadAddAnotherFieldsResponse
   getLeadAddAnotherGofsFields: GetLeadAddAnotherGoFsFieldsResponse
   getLeadDistributionRuleExecLog: GetLeadDistributionRuleExecLogResponse
   getLeadDistributionRuleSummary: GetLeadDistributionRuleSummaryResponse
   getLeadDistributionRules: Array<LeadDistributionRuleResult>
   getLeadFields: GetLeadFieldsResponse
   getLeadHistory: LeadHistoryResponse
   getLeadInitiationRolesOnActivity?: Maybe<
      GetLeadInitiationRolesOnActivityResponse
   >
   getLeadProfile: GetLeadProfileResponse
   getLeadTemplateSystemFields: GetLeadTemplateSystemFieldsResponse
   getLeadsSystemFields: Array<LeadSystemFieldsResponse>
   getLineDepartmentRequestHistoryLogs: GetLineDepartmentRequestHistoryLogsResponse
   getLineGraph: LineGraphResult
   getLoadBankAccountRequests: GetLoadBankAccountRequestResponse
   getLtpUserManagementLogs?: Maybe<GetLtpUserManagementLogsResponse>
   getLtpUsersForLtpManagement?: Maybe<GetLtpUsersForLtpManagementResponse>
   getMessagesForThread: GetMessagesForThreadResponse
   getNodes: Array<Maybe<NodeResult>>
   getOfficerLeaveLogs: GetOfficerLeaveLogsResponse
   getOfficerManagementLogs?: Maybe<GetOfficerManagementLogsResponse>
   getOfficerManagementUsers?: Maybe<GetOfficerManagementUserResponse>
   getOnHoldTdrAccountLogs: GetOnHoldTdrAccountLogsResponse
   getOpenSearchTdrAccount: GetOpenSearchTdrAccountResponse
   getOpenSearchTdrAccountByAccountNo: GetOpenSearchTdrAccountByAccountNoResponse
   getOpenSearchTdrAccounts: GetOpenSearchTdrAccountsResponse
   getOrCreateViewsInBoardsAndLists: UserViewsInBoardResponse
   getOrdersOnPipelineItem: GetOrdersOnPipelineItemResponse
   getOrdersOnPipelineItemInPortal: GetOrdersOnPipelineItemInPortalResponse
   getParameters: GetParametersResponse
   getParametersInAccount: ParametersInAccountResponse
   getPayment?: Maybe<GetPaymentResponse>
   getPaymentHistoryOnPipelineItem?: Maybe<PaymentHistoryOnPipelineItemResponse>
   getPaymentRequests: GetPaymentRequestsResponse
   getPaymentTransactionsOnPipelineItemInPortal: GetPaymentTransactionsOnPipelineItemInPortalResponse
   getPendingTaskOnPipelineItem: GetPendingTaskOnPipelineItemResponse
   getPendingTasksApplications: GetPendingTaskApplicationsResponse
   getPermittedStages?: Maybe<PermittedStagesResult>
   getPieChart: PieChartResult
   getPinnedPipelineItemIdsInView: PinnedPipelineItemIdsInViewResponse
   getPinnedPipelineItemsCountForUser: PinnedPipelineItemsCountResult
   getPinnedPipelineItemsForUser: GetPinnedPipelineItemsForUserResponse
   getPipelineApplicationsInPortal: GetPipelineApplicationsInPortalResponse
   getPipelineAutomationWorkflowConfig: PipelineAutomationWorkflowConfigResponse
   getPipelineCustomObjectAddAnotherFields: GetPipelineCustomObjectAddAnotherFieldsResponse
   getPipelineCustomObjectAddAnotherGofsFields: GetPipelineCustomObjectAddAnotherGoFsFieldsResponse
   getPipelineCustomObjectFields: GetPipelineCustomObjectFieldsResponse
   getPipelineCustomObjectProfile: GetPipelineCustomObjectProfileResponse
   getPipelineCustomObjectsSystemFields: Array<
      PipelineCustomObjectSystemFieldsResponse
   >
   getPipelineDocumentTemplates: GetPipelineDocumentTemplatesResponse
   getPipelineDocumentTemplatesForAdmin: GetDocumentTemplatesInPipelineResponse
   getPipelineEventBasedLeadDistributionExecLogs: GetPipelineEventBasedLeadDistributionRuleExecLogsResponse
   getPipelineEventFields: GetPipelineEventFieldsResponse
   getPipelineEventTemplates: Array<PipelineEventTemplateResult>
   getPipelineFeeRuleSets: GetPipelineFeeRuleSetsResponse
   getPipelineIdentifications: PipelineIdentificationsResponse
   getPipelineInPortal: GetPipelineInPortalResponse
   getPipelineItemActivities: PipelineItemActivitiesResponse
   getPipelineItemActivitiesInPortal: PipelineItemActivitiesInPortalResponse
   getPipelineItemAppealTasks: GetPipelineItemAppealTasksResponse
   getPipelineItemAssigneeUpdateHierarchy: GetPipelineItemAssigneeUpdateHierarchyResponse
   /** @deprecated This query is deprecated. Please use the get_application_customizations query instead. */
   getPipelineItemBannerMessage: GetPipelineItemBannerMessageResponse
   getPipelineItemCallLogs: GetPipelineItemCallLogsResponse
   getPipelineItemCompletionPercentageInPortal: GetPipelineItemCompletionPercentageInPortalResponse
   getPipelineItemConsentPhoneNumbers: GetPipelineItemConsentPhoneNumbersResponse
   getPipelineItemCurrentStageSlaFieldInPipeline?: Maybe<
      PipelineItemCurrentStageSlaFieldInPipelineResponse
   >
   getPipelineItemCurrentStageSlaFieldResponsesInPipeline?: Maybe<
      PipelineItemCurrentStageSlaFieldInPipelineResponse
   >
   getPipelineItemDocumentTemplates: GetPipelineItemDocumentTemplatesResponse
   getPipelineItemDocumentsForDocumentTemplate: GetPipelineItemDocumentsForDocumentTemplateResponse
   getPipelineItemFieldLogs: GetPipelineItemFieldLogsResponse
   getPipelineItemFieldLogsInPortal: GetPipelineItemFieldLogsInPortalResponse
   getPipelineItemFieldPermissions?: Maybe<PipelineItemFieldPermissionsResponse>
   getPipelineItemFieldShortfallLogs: PipelineItemFieldShortfallLogsResponse
   getPipelineItemFieldShortfallLogsInPortal: PipelineItemFieldShortfallLogsInPortalResponse
   getPipelineItemFieldsInTaskDraft: GetPipelineItemFieldsInTaskDraftResponse
   getPipelineItemFieldsLogCount: GetPipelineItemFieldsLogCountResponse
   getPipelineItemFieldsLogCountInPortal: GetPipelineItemFieldsLogCountInPortalResponse
   getPipelineItemFieldsToLog: GetPipelineItemFieldsToLogResponse
   getPipelineItemGeneratedRemarksFromOverallRemarks: GetPipelineItemGeneratedRemarksResponse
   getPipelineItemHistory: GetPipelineItemHistoryResponse
   getPipelineItemLatestTasks: GetPipelineItemTasksResponse
   getPipelineItemLayoutTabsVisibilityStatus: GetPipelineItemLayoutTabsVisibilityStatusResponse
   getPipelineItemMergeInProgressStatus: GetPipelineItemMergeInProgressStatusResponse
   getPipelineItemMessageTemplates: GetPipelineItemMessageTemplatesResponse
   getPipelineItemNoteSheetPermissions: GetPipelineItemNoteSheetPermissionsResponse
   getPipelineItemOrdersAndPayments: GetPipelineItemOrdersAndPaymentsResponse
   getPipelineItemPaymentRuleSet: GetPipelineItemPaymentRuleSetResponse
   getPipelineItemPaymentRules: GetPipelineItemPaymentRulesResponse
   getPipelineItemPayments: GetPipelineItemPaymentsResponse
   getPipelineItemPermittedStages?: Maybe<PipelineItemPermittedStagesResult>
   getPipelineItemRecommendedTaskTemplates: GetPipelineItemRecommendedTaskTemplatesResponse
   getPipelineItemRemarks: GetPipelineItemRemarksResponse
   getPipelineItemRemarksAttachmentsInTaskDraft: GetPipelineItemRemarksAttachmentsInTaskDraftResponse
   getPipelineItemRemarksInTaskDraft: GetPipelineItemRemarksInTaskDraftResponse
   getPipelineItemRemindersForUser: GetPipelineItemRemindersForUserResponse
   getPipelineItemResources: PipelineItemResourcesResponse
   getPipelineItemShortfallFields: GetPipelineItemShortfallFieldsResponse
   getPipelineItemShortfallFieldsInPortal: GetPipelineItemShortfallFieldsInPortalResponse
   getPipelineItemShortfallLogFields: GetPipelineItemShortfallLogFieldsResponse
   getPipelineItemShortfallLogFieldsInPortal: GetPipelineItemShortfallLogFieldsInPortalResponse
   getPipelineItemShortfallLogs: PipelineItemShortfallLogsResponse
   getPipelineItemShortfallLogsInPortal: PipelineItemShortfallLogsInPortalResponse
   getPipelineItemSlaFields: PipelineItemSlaFieldsInResponse
   getPipelineItemStagePermissions: GetPipelineItemStagePermissionsResponse
   getPipelineItemStageTransitionMandatoryEntitiesStatus?: Maybe<
      GetPipelineItemStageTransitionMandatoryEntitiesStatusResponse
   >
   getPipelineItemStageTransitionMandatoryEntitiesStatusBulk?: Maybe<
      PipelineItemStageTransitionMandatoryEntitiesStatusBulkResult
   >
   getPipelineItemStageTransitionMandatoryTasksStatus?: Maybe<
      GetPipelineItemStageTransitionMandatoryTasksStatusResponse
   >
   getPipelineItemStageTransitionMandatoryTasksStatusBulk?: Maybe<
      GetPipelineItemStageTransitionMandatoryTasksStatusBulkResponse
   >
   getPipelineItemStageTransitionOverallObservation?: Maybe<
      GetPipelineItemStageTransitionOverallObservationResponse
   >
   getPipelineItemStageTransitions: GetPipelineItemStageTransitionsResponse
   getPipelineItemSubmissionGroups: GetPipelineItemSubmissionGroupsResponse
   getPipelineItemTabsDetails: GetPipelineItemTabsDetailsResponse
   getPipelineItemTasks: GetPipelineItemTasksResponse
   getPipelineItemTemplateAdminsBulk: GetPipelineItemTemplateAdminsBulkResponse
   getPipelineItemTemplateFieldsToLog: GetPipelineItemTemplateFieldsToLogResponse
   getPipelineItemTemplateIdentifications: GetPipelineItemTemplateIdentificationsResponse
   getPipelineItemTemplates: GetPipelineItemTemplatesResponse
   getPipelineItemVerifications: GetPipelineItemVerificationsResponse
   getPipelineItemVrVisibleEntities: GetPipelineItemVrVisibleEntitiesResponse
   getPipelineManualLeadDistributionExecLogs: GetPipelineManualLeadDistributionRuleExecLogsResponse
   getPipelineResources: PipelineResourcesResponse
   getPipelineScheduledLeadDistributionExecLogs: GetPipelineScheduledLeadDistributionRuleExecLogsResponse
   getPipelineSettingsBulk: Array<GetPipelineSettingsBulkResult>
   getPipelineStagesBulk: PipelineStagesResult
   getPipelineTemplatesSystemFields: GetPipelineTemplatesSystemFieldsResponse
   getPipelineWhatsappBusinessPhoneNumbers: GetPipelineWhatsAppBusinessPhoneNumbersResponse
   getPipelineWhatsappMessageTemplates: GetPipelineWhatsappMessageTemplatesResponse
   getPipelines: Array<GetPipelinesResult>
   getPipelinesAutomationWorkflows: PipelinesAutomationWorkflowsResponse
   getPipelinesForPipelineItemTemplate: GetPipelinesForPipelineItemTemplateResponse
   getPipelinesForPipelineItems: GetPipelinesForPipelineItemsResponse
   getPipelinesInPortal: Array<PortalPipelineResult>
   getPipelinesLayout: GetPipelinesLayoutResponse
   getPivotTable: PivotTableResult
   getPivotTableColumnTotals: ColumnTotalsResult
   getPivotTableRowTotals: RowTotalsResult
   getPluginServiceAccountCallLogs: GetPluginServiceAccountCallLogsResponse
   getPluginServiceAccountWhatsappMessageTemplatesSyncStatus: GetPluginServiceAccountWhatsappMessageTemplatesSyncStatusResponse
   getPlugins: GetPluginsResult
   getPmuActionLogDetail: GetPmuActionLogDetailResponse
   getPmuActionLogs: GetPmuActionLogsResponse
   getPortalApplicationConfigBulk: GetPortalApplicationConfigBulkResponse
   getPortalApplications: GetPortalApplicationsResponse
   getPortalUnifiedApplicationCreationConfig?: Maybe<
      GetPortalUnifiedApplicationCreationConfigResponse
   >
   getPortals: GetPortalsResponse
   getPortalsInAccount: GetPortalsInAccountResponse
   getPreSignedGetUrlForApplicationDocumentInPortal: GetPreSignedGetUrlForApplicationDocumentInPortalResponse
   getPreSignedGetUrlForApplicationFieldInPortal: GetPreSignedGetUrlForApplicationFieldInPortalResponse
   getPreSignedGetUrlForArchitectProfileAttachment: GetPreSignedGetUrlForArchitectProfileAttachmentResponse
   getPreSignedGetUrlForCrmEntityField: GetPreSignedGetUrlForCrmEntityFieldResponse
   getPreSignedGetUrlForCrmEntityFieldLog: GetPreSignedGetUrlForCrmEntityFieldLogResponse
   getPreSignedGetUrlForDataExportRequest: GetPreSignedGetUrlForDataExportRequestResponse
   getPreSignedGetUrlForDataLoadingRequest: GetPreSignedGetUrlForDataLoadingRequestResponse
   getPreSignedGetUrlForDocument: GetPreSignedGetUrlForDocumentResponse
   getPreSignedGetUrlForDocumentTemplate: GetPreSignedGetUrlForDocumentTemplateResponse
   getPreSignedGetUrlForDocumentVersion: GetPreSignedGetUrlForDocumentVersionResponse
   getPreSignedGetUrlForEntity: GetPreSignedGetUrlResponse
   getPreSignedGetUrlForPaymentReceipt: GetPreSignedGetUrlForPaymentReceiptResponse
   getPreSignedGetUrlForPaymentReceiptInPortal: GetPreSignedGetUrlForPaymentReceiptInPortalResponse
   getPreSignedGetUrlForPipelineItemRemarks: GetPreSignedGetUrlForPipelineItemRemarksResponse
   getPreSignedGetUrlForPipelineItemRemarksInTaskDraft: GetPreSignedGetUrlForPipelineItemRemarksInTaskDraftResponse
   getPreSignedGetUrlForPortalBgImage: GetPreSignedGetUrlForPortalBgImageResponse
   getPreSignedGetUrlForPortalLogo: GetPreSignedGetUrlForPortalLogoResponse
   getPreSignedGetUrlForRelatedEntityField: GetPreSignedGetUrlForRelatedEntityFieldResponse
   getPreSignedGetUrlForRelatedEntityRemarks: GetPreSignedGetUrlForRelatedEntityRemarksResponse
   getPreSignedGetUrlForTdrAccount: GetPreSignedGetUrlForTdrAccountResponse
   getPreSignedGetUrlForTdrAccountCertificate: GetPreSignedGetUrlForTdrAccountCertificateResponse
   getPreSignedGetUrlForTdrCertificate: GetPreSignedGetUrlForTdrCertificateResponse
   getPreSignedGetUrlForTdrCertificateInPortal: GetPreSignedGetUrlForTdrCertificateInPortalResponse
   getPreSignedGetUrlForUserKmlFile: GetPreSignedGetUrlForUserKmlFileResponse
   getPreSignedPostUrlForApplicationFieldInPortal: GetPreSignedPostUrlForApplicationFieldInPortalResponse
   getPreSignedPostUrlForArchitectProfileAttachment: GetPreSignedPostUrlForArchitectProfileAttachmentResponse
   getPreSignedPostUrlForCrmEntityField: GetPreSignedPostUrlForCrmEntityFieldResponse
   getPreSignedPostUrlForDataExportRequest: GetPreSignedPostUrlForDataExportRequestResponse
   getPreSignedPostUrlForDataLoadingRequest: GetPreSignedPostUrlForDataLoadingRequestResponse
   getPreSignedPostUrlForDocumentTemplate: GetPreSignedPostUrlForDocumentTemplateResponse
   getPreSignedPostUrlForPipelineItemRemarks: GetPreSignedPostUrlForPipelineItemRemarksResponse
   getPreSignedPostUrlForPipelineItemRemarksInTaskDraft: GetPreSignedPostUrlForPipelineItemRemarksInTaskDraftResponse
   getPreSignedPostUrlForRelatedEntityField: GetPreSignedPostUrlForRelatedEntityFieldResponse
   getPreSignedPostUrlForRelatedEntityRemarks: GetPreSignedPostUrlForRelatedEntityRemarksResponse
   getPreSignedPostUrlForStageTransitionPipelineItemRemarks: GetPreSignedPostUrlForStageTransitionPipelineItemRemarksResponse
   getPreSignedPostUrlForTdrCertificateInPortal: GetPreSignedPostUrlForTdrCertificateInPortalResponse
   getPreSignedPutUrlForApplicationFieldInPortal: GetPreSignedPutUrlForApplicationFieldInPortalResponse
   getPreSignedPutUrlForArchitectProfileAttachment: GetPreSignedPutUrlForArchitectProfileAttachmentResponse
   getPreSignedPutUrlForCrmEntityField: GetPreSignedPutUrlForCrmEntityFieldResponse
   getPreSignedPutUrlForDataExportRequest: GetPreSignedPutUrlForDataExportRequestResponse
   getPreSignedPutUrlForDataLoadingRequest: GetPreSignedPutUrlForDataLoadingRequestResponse
   getPreSignedPutUrlForDocumentTemplate: GetPreSignedPutUrlForDocumentTemplateResponse
   getPreSignedPutUrlForEntity: GetPreSignedPutUrlResponse
   getPreSignedPutUrlForPipelineItemRemarks: GetPreSignedPutUrlForPipelineItemRemarksResponse
   getPreSignedPutUrlForPipelineItemRemarksInTaskDraft: GetPreSignedPutUrlForPipelineItemRemarksInTaskDraftResponse
   getPreSignedPutUrlForPortalBgImage: GetPreSignedPutUrlForPortalResponse
   getPreSignedPutUrlForPortalLogo: GetPreSignedPutUrlForPortalResponse
   getPreSignedPutUrlForRelatedEntityField: GetPreSignedPutUrlForRelatedEntityFieldResponse
   getPreSignedPutUrlForRelatedEntityRemarks: GetPreSignedPutUrlForRelatedEntityRemarksResponse
   getPreSignedPutUrlForStageTransitionPipelineItemRemarks: GetPreSignedPutUrlForStageTransitionPipelineItemRemarksResponse
   getPreSignedPutUrlForTdrAccountCertificate: GetPreSignedPutUrlForTdrAccountCertificateResponse
   getPreSignedPutUrlForTdrCertificateInPortal: GetPreSignedPutUrlForTdrCertificateInPortalResponse
   getPreSignedPutUrlForUserKmlFile: GetPreSignedPutUrlForUserKmlFileResponse
   getPrefilledPipelineItemCheckpoints: GetPrefilledPipelineItemCheckpointsResponse
   getPreviewForDocumentTemplate: GetPreviewForDocumentTemplateResponse
   getPropertiesForApplications: Array<ApplicationPropertiesResponse>
   getPropertiesForApplicationsAsOpen: Array<
      ApplicationPropertiesAsOpenResponse
   >
   getPropertiesForApplicationsInPortal: GetApplicationPropertiesInPortalResponse
   getPropertiesForContacts: Array<ContactResult>
   getPropertiesForDeals: Array<DealPropertiesResponse>
   getPropertiesForLeads: Array<LeadPropertiesResponse>
   getPropertiesForPipelineCustomObjects: Array<
      PipelineCustomObjectPropertiesResponse
   >
   getPropertiesForPipelineItemsWithoutPermission: GetPropertiesForPipelineItemsWithoutPermissionResponse
   getPublicSearchApplicationConfig: PublicSearchApplicationConfigResult
   getReconciliationCsvData: GetReconciliationCsvDataResponse
   getReconciliationRequests: GetReconciliationRequestsResponse
   getRecordCreationConfigs: Array<RecordCreationConfigResult>
   getRecordCreationConfigsForAdmin: Array<RecordCreationConfigForAdminResult>
   getRecordMergePermissionsForSalesTemplates: GetRecordMergePermissionsForSalesTemplatesResponse
   getRefundApplications: GetRefundApplicationsResponse
   getRelatedApplicationCopyFieldsLogInPortal: GetRelatedApplicationCopyFieldsLogInPortalResponse
   getRelatedEntitiesAddAnotherGofsFieldsBulk: GetRelatedEntitiesAddAnotherGoFsFieldsBulkResponse
   getRelatedEntitiesFieldResponses: RelatedEntityFieldResponsesResponse
   getRelatedEntityAddAnotherFields: GetRelatedEntityAddAnotherFieldsResponse
   getRelatedEntityAddAnotherGofsFields: GetRelatedEntityAddAnotherGoFsFieldsResponse
   getRelatedObjects: GetRelatedObjectsResponse
   getRelatedObjectsCountInPortal: GetRelatedObjectsCountInPortalResponse
   getRelatedObjectsInPortal: GetRelatedObjectsInPortalResponse
   getRelatedObjectsToLink: GetRelatedObjectsToLinkResponse
   getRelatedPipelineItemRemarks: GetRelatedPipelineItemRemarksResponse
   getRelatedPipelineItemRemarksAttachments: GetRelatedPipelineItemAttachmentsResponse
   getRelations: GetRelationsResponse
   getRelationsToPipelineItemTemplate: GetRelationsPipelineItemTemplateResponse
   getRemindersOnPipelineItem: GetRemindersOnPipelineItemResponse
   getRetoolAppEmbedUrl: RetoolAppEmbedUrlResponse
   getSalesTemplateRecordCreationConfigFields: GetSalesTemplateRecordCreationConfigFieldsResponse
   getSalesTemplates: GetSalesTemplateResponse
   getSalesTemplatesInPortal: GetSalesTemplatesInPortalResponse
   getSalesTemplatesToLinkInRelation: SalesTemplatesResponse
   getSalesTemplatesWithoutPermission: GetSalesTemplatesWithoutPermissionResponse
   getScheduledAutomationWorkflowExecLogsFilter?: Maybe<
      GetScheduledAutomationWorkflowExecLogsFilterResponse
   >
   getScheduledPipelineItemIdsInView: ScheduledPipelineItemIdsInViewResponse
   getScheduledPipelineItemsCountForUser: ScheduledPipelineItemsCountResult
   getScheduledPipelineItemsCountInDateRange: ScheduledPipelineItemsDateRangeCountsResponse
   getScheduledPipelineItemsForUser: GetSchedulePipelineItemsForUserResponse
   getScheduledPipelineItemsForUserV2: GetSchedulePipelineItemsForUserV2Response
   getScheduledPipelineItemsTeamMetrics: ScheduledPipelineItemsTeamMetricsResponse
   getScheduledPipelineItemsTeamStats: ScheduledPipelineItemsTeamStatsResponse
   getScheduledPipelineItemsUserMetrics: ScheduledPipelineItemsUserMetricsResponse
   getSchedulesOnPipelineItem: SchedulesOnPipelineItemResponse
   getSchedulesOnPipelineItemV2: SchedulesOnPipelineItemV2Response
   getScorecardChart: ScorecardChartResult
   getScoringRecalculationExecLogs: GetScoringRecalculationExecLogsResponse
   getScrutinyKeyLogs: GetScrutinyKeyLogsResponse
   getSearchAndMonitoringConfig: GetSearchAndMonitoringConfigResponse
   getSharableEntities: GetSharableEntitiesResponse
   getSiteInspectionTaskJobStatus: SiteInspectionTaskJobStatusResponse
   getSiteInspectionTasks: GetSiteInspectionTasksResponse
   getSmartfloAccountPluginServiceAccounts: GetSmartfloAccountPluginServiceAccountsResponse
   getSmartfloPluginServiceAccounts: GetSmartfloPluginServiceAccountsResponse
   getStageAssigneeTimespentLogInPortal: GetStageAssigneeTimespentLogInPortalResponse
   getStageBoardRoles: GetStageBoardsRolesResponse
   getStageUpdatePermissions?: Maybe<GetStageUpdatePermissionsResponse>
   getStageWisePipelineItemsStats?: Maybe<StageWisePipelineItemsStatsResponse>
   getStages: Array<StagesResult>
   getStagesTransitions: Array<GetStagesTransitionsResult>
   getStagesTransitionsInPortal?: Maybe<GetStagesTransitionsInPortalResponse>
   getStatsForLeadBuckets: GetStatsForLeadBucketsResponse
   getStructuredEntityJsonConfig: GetStructuredEntityJsonConfigResponse
   getTable: TableResult
   getTableColumnTotals: ColumnTotalsResult
   getTaskAddAnotherFields: GetTaskAddAnotherFieldsResponse
   getTaskAddAnotherGofsFields: GetTaskAddAnotherGoFsFieldsResponse
   getTaskFields: GetTaskFieldsResponse
   getTaskGeneratedOverallRemarksFromFieldRemarks: GetTaskGeneratedRemarksResponse
   getTaskShortfallTaskTemplates?: Maybe<GetTaskShortfallTaskTemplatesResponse>
   getTaskTemplates: Array<TaskTemplateResult>
   getTaskTemplatesIdentifications: GetTaskTemplatesIdentificationsResponse
   getTasks: Array<TaskResult>
   getTasksWithFilters: GetTasksWithFiltersResponse
   getTdrAccount: GetTdrAccountResponse
   getTdrAccountAddAnotherFields: GetTdrAccountAddAnotherFieldsResponse
   getTdrAccountAddAnotherGofsFields: GetTdrAccountAddAnotherGoFsFieldsResponse
   getTdrAccountByAccountNo: GetTdrAccountByAccountNoResponse
   getTdrAccountRequestsForUser: GetTdrAccountRequestsForUserResponse
   getTdrAccountsForHolderUser: GetTdrAccountsForHolderUserResponse
   getTdrAccountsForTdrManagement: GetTdrAccountsForTdrManagementResponse
   getTdrManagementLogs: GetTdrManagementLogsResponse
   getTdrOrdersInPipelineItem: GetTdrOrdersInPipelineItemResponse
   getTdrPaymentsForTdrOrderInPortal: GetTdrPaymentsForTdrOrderInPortalResponse
   getTemplateEntityVisibilityRules: GetTemplateEntityVisibilityRulesResponse
   getTemplateEntityVisibilityRulesInPortal: GetTemplateEntityVisibilityRulesInPortalResponse
   getTemplateGofVisibilityRulesInPortal: GetTemplateGoFVisibilityRulesInPortalResponse
   getTemplatesForPipelines: Array<PipelineTemplatesResult>
   getTemplatesInPipelineItemTemplate?: Maybe<
      GetTemplatesInPipelineItemTemplateResponse
   >
   getTestTransferBankAmountPreview: GetTestTransferBankAmountPreviewResponse
   getTestTransferBankAmountRequests: GetTestTransferBankAmountRequestResponse
   getTgBPassApplicationIdWithFileNumber: GetTGbPassApplicationIdByFileNumberResponse
   getTgBPassApplicationTabDetails: GetTGbPassApplicationTabDetailsResponse
   getTgBPassApplicationTabs: GetTGbPassApplicationTabsResponse
   getTgBPassApplications: GetTGbPassApplicationsResponse
   getThreadsForUser: GetThreadsForUserResponse
   getTransactionsForTdrAccount: GetTransactionsForTdrAccountResponse
   getTriggerAutomationWorkflowsIdentificationsForActivityTemplates?: Maybe<
      GetTriggerAutomationWorkflowsIdentificationsForActivityTemplatesResponse
   >
   getUnlinkedFields: GetUnlinkedFieldsResponse
   getUserAccount?: Maybe<Account>
   getUserAppConfig: UserAppConfig
   getUserAppConfigForAdmin: UserAppConfigForAdminResponse
   getUserCustomProperties: GetUserCustomPropertiesResponse
   getUserDashboards: GetUserDashboardsResponse
   getUserFormattedCustomProperties: GetUserFormattedCustomPropertiesResponse
   getUserGoogleCalendarEvents: UserGoogleCalendarEventsResponse
   getUserGraph: UserGraphResult
   getUserGraphs: GetUserGraphsResult
   getUserGroupsForBoardLists: Array<BoardListUserGroupsResult>
   getUserGroupsForBoards: Array<BoardUserGroupsResult>
   getUserNotifications: GetUserNotificationsResponse
   getUserNotificationsCount: GetUserNotificationsCountResponse
   getUserPinStatus: GetUserPinStatusResponse
   getUserPinStatusForAdmin: GetUserPinStatusForAdminResponse
   getUserPortalSettings: GetUserPortalSettingsResponse
   getUserProfile: User
   getUserViewsInBoard: UserViewsInBoardResponse
   getUserViewsInBoardList: UserViewsInBoardListResponse
   getUsers: Array<UserResult>
   getUsersInAccount: UsersInAccountResponse
   getUsersTabCustomization: GetUsersTabCustomizationResponse
   getViews: Array<ViewResult>
   getWatiAccountPluginServiceAccounts: GetWatiAccountPluginServiceAccountsResponse
   getWatiPluginServiceAccounts: GetWatiPluginServiceAccountsResponse
   getWhatsappAccountMessageTemplatesForAdmin: GetWhatsAppAccountMessageTemplatesForAdminResponse
   getWhatsappBusinessNumbers: GetWhatsAppBusinessNumbersResponse
   getWhatsappBusinessPhoneNumberMessageTemplatesForPipelineItem: GetWhatsAppBusinessPhoneNumberMessageTemplatesForPipelineItemResponse
   getWhatsappBusinessPhoneNumbers: GetWhatsAppBusinessPhoneNumbersResponse
   isAutomationWorkflowNameExists: IsAutomationWorkflowNameExistsResponse
   isDocumentTemplateNameExists: IsDocumentTemplateNameExistsResponse
   openSearchPipelineItems: OpenSearchPipelineItemsResponse
   resolveApplicationView: ResolveApplicationViewResponse
   searchActivityTemplates?: Maybe<SearchActivityTemplatesResponse>
   searchAgentAllocationGroups: SearchAgentAllocationGroupsResponse
   searchAgentsForManager: SearchAgentsForManagerResponse
   searchAllowedFieldsInPortalApplication: SearchAllowedFieldsInPortalApplicationResponse
   searchAndMonitoringApplications: SearchAndMonitoringApplicationsResponse
   searchApplicationAssignees: SearchApplicationAssigneesResponse
   searchApplications: SearchApplicationsResponse
   searchApplicationsForAlteration: SearchApplicationsForAlterationResponse
   searchApplicationsInPortal: SearchApplicationsInPortalResponse
   searchAssignees: SearchAssigneesResponse
   searchAutomationWorkflows?: Maybe<SearchAutomationWorkflowsResponse>
   searchContactAssignees: SearchContactAssigneesResponse
   searchCustomPaymentRules: SearchCustomPaymentRulesResponse
   searchDealAssignees: SearchDealAssigneesResponse
   searchDeals: SearchDealsResponse
   searchDocumentVerificationUsers: SearchDocumentVerificationUsersResponse
   searchEntityFeeRuleSetCustomHeaders: SearchEntityFeeRuleSetCustomHeadersResponse
   searchFeePaymentOrderCreationConfigs: SearchFeePaymentOrderCreationConfigsResponse
   searchFields: SearchFieldsResponse
   searchFriends: SearchFriendsResponse
   searchGraphFields: SearchGraphFieldsResponse
   searchIdentificationFields: SearchIdentificationFieldsResponse
   searchIdentifications: SearchIdentificationsResponse
   searchLeadAssignees: SearchLeadAssigneesResponse
   searchLeadCreationAllowedStages: SearchLeadCreationAllowedStagesResponse
   searchLeads: SearchLeadsResponse
   searchManagersForAgents: SearchManagerForAgentsResponse
   searchOfficerManagementUsers?: Maybe<SearchOfficerManagementUserResponse>
   searchPaymentRuleSets: SearchPaymentRuleSetsResponse
   searchPipelineCustomObjectAssignees: SearchPipelineCustomObjectAssigneesResponse
   searchPipelineItemFields: SearchPipelineItemFieldsResponse
   searchPipelineItemTemplateFieldsToLog: SearchPipelineItemTemplateFieldsToLogResponse
   searchPipelineItemTemplateLinkedFields: SearchPipelineItemTemplateLinkedFieldsResponse
   searchPipelineItems: SearchPipelineItemsResponse
   searchPortalUserApplications: SearchPortalUserApplicationsResponse
   searchRelationFieldsForMapping: SearchRelationFieldsForMappingResponse
   searchRolesInPipeline: SearchRolesInPipelineResponse
   searchScoringParameterFields: SearchScoringParameterFieldsResponse
   searchStages: SearchStagesResponse
   searchTaskAssignees: SearchTaskAssigneesResponse
   searchTaskTemplates: SearchTaskTemplatesResponse
   searchUserGroups: SearchUserGroupResponse
   searchUsernames?: Maybe<SearchUsernamesResponse>
   searchUsers: SearchUsersResponse
}

export type QueryCheckAllowApplicationSubmitArgs = {
   params: CheckAllowApplicationSubmitParams
}

export type QueryCheckItemsExistInViewArgs = {
   params: CheckItemsExistInViewParams
}

export type QueryEvaluateEntityRuleSetsInPortalArgs = {
   params: EvaluateRuleSetsInPortalParams
}

export type QueryFeeCalculateArgs = {
   params: FeeCalculateParams
}

export type QueryGenerateDocusignEmbedUrlForPipelineItemDocumentArgs = {
   params: GenerateDocusignEmbedUrlForPipelineItemDocumentParams
}

export type QueryGetAccountAutomationWorkflowExecLogsArgs = {
   params: GetAccountAutomationWorkflowsExecLogsParams
}

export type QueryGetAccountLeadDistributionRuleExecLogsArgs = {
   params: GetAccountLeadDistributionRuleExecLogsParams
}

export type QueryGetAccountLeadDistributionRulesArgs = {
   params: GetAccountLeadDistributionRulesParams
}

export type QueryGetAccountScheduledAutomationWorkflowLogsArgs = {
   params: GetAccountScheduledAutomationWorkflowLogsParams
}

export type QueryGetActivitiesArgs = {
   params: GetActivitiesParams
}

export type QueryGetActivityFieldsArgs = {
   params: GetActivityFieldsParams
}

export type QueryGetActivityTemplatesArgs = {
   params: ActivityTemplatesParams
}

export type QueryGetAdminRecordCreationConfigsForSalesTemplatesArgs = {
   params: GetAdminRecordCreationConfigsForSalesTemplatesParams
}

export type QueryGetAgentAllocationGroupsArgs = {
   params: GetAgentAllocationGroupsParams
}

export type QueryGetAgentAllocationGroupsInAccountArgs = {
   params: GetAgentAllocationGroupsInAccountParams
}

export type QueryGetAgentsForManagerArgs = {
   params: GetAgentsforManager
}

export type QueryGetAnalyticsCopilotHistoryArgs = {
   params: GetAnalyticsCopilotHistoryParams
}

export type QueryGetAnalyticsCopilotResponseArgs = {
   params: GetAnalyticsQueryResponseParams
}

export type QueryGetAnalyticsCopilotVisualizationArgs = {
   params: GetAnalyticsCopilotVisualizationParams
}

export type QueryGetApplicationAddAnotherFieldsArgs = {
   params: GetApplicationAddAnotherFieldsParams
}

export type QueryGetApplicationAddAnotherFieldsInPortalArgs = {
   params: GetApplicationAddAnotherFieldsInPortalParams
}

export type QueryGetApplicationAddAnotherGofsFieldsArgs = {
   params: GetApplicationAddAnotherGoFsFieldsParams
}

export type QueryGetApplicationAddAnotherGofsFieldsInPortalArgs = {
   params: GetApplicationAddAnotherGoFsFieldsInPortalParams
}

export type QueryGetApplicationCustomizationsArgs = {
   params: GetApplicationCustomizationsParams
}

export type QueryGetApplicationCustomizationsInPortalArgs = {
   params: GetApplicationCustomizationsInPortalParams
}

export type QueryGetApplicationDocumentsInPortalArgs = {
   params: GetApplicationDocumentsInPortalParams
}

export type QueryGetApplicationDrawingFileLogsArgs = {
   params: GetApplicationDrawingFileLogsParams
}

export type QueryGetApplicationEnforcementComplaintsArgs = {
   params: GetApplicationEnforcementComplaintsParams
}

export type QueryGetApplicationErrorFieldsInPortalArgs = {
   params: GetApplicationErrorFieldsInPortalParams
}

export type QueryGetApplicationFieldsArgs = {
   params: GetApplicationFieldsParams
}

export type QueryGetApplicationGofSurveyNumberRemarksArgs = {
   params: GetApplicationGoFSurveyNumberRemarksParams
}

export type QueryGetApplicationGofSurveyNumberRemarksInPortalArgs = {
   params: GetApplicationGoFSurveyNumberRemarksInPortalParams
}

export type QueryGetApplicationLatestDataInPortalArgs = {
   params: GetApplicationLatestDataInPortalParams
}

export type QueryGetApplicationLatestPublishedDocumentsInPortalArgs = {
   params: GetApplicationLatestPublishedDocumentsInPortalParams
}

export type QueryGetApplicationManagementLogsArgs = {
   params: GetApplicationManagementLogsParams
}

export type QueryGetApplicationObjectionTabsVisibleStatusArgs = {
   params: GetApplicationObjectionTabsVisibleStatusParams
}

export type QueryGetApplicationProfileArgs = {
   params: GetApplicationProfileParams
}

export type QueryGetApplicationRefundDetailsArgs = {
   params: GetApplicationRefundDetailsParams
}

export type QueryGetApplicationScrutinyReportDetailsArgs = {
   params: GetApplicationScrutinyReportDetailsParams
}

export type QueryGetApplicationScrutinyReportDetailsV0Args = {
   params: GetApplicationScrutinyReportDetailsParams
}

export type QueryGetApplicationStageSummaryArgs = {
   params: GetApplicationStageSummaryParams
}

export type QueryGetApplicationStageTransitionCheckpointsConfigArgs = {
   params: GetApplicationStageTransitionCheckpointsConfigParams
}

export type QueryGetApplicationStageTransitionCheckpointsConfigInPortalArgs = {
   params: GetApplicationStageTransitionCheckpointsConfigInPortalParams
}

export type QueryGetApplicationSurveyNumberRemarksArgs = {
   params: GetApplicationSurveyNumberRemarksParams
}

export type QueryGetApplicationSurveyNumberRemarksInPortalArgs = {
   params: GetApplicationSurveyNumberRemarksInPortalParams
}

export type QueryGetApplicationSystemFieldsArgs = {
   params: GetApplicationSystemFieldsParams
}

export type QueryGetApplicationUnfilledRequiredFieldsInPortalArgs = {
   params: GetApplicationUnfilledRequiredFieldsInPortalParams
}

export type QueryGetApplicationValidationsStatusInPortalArgs = {
   params: GetApplicationValidationsStatusInPortalParams
}

export type QueryGetApplicationVisibleGofsInPortalArgs = {
   params: GetApplicationVisibleGoFsInPortalParams
}

export type QueryGetApplicationVrVisibleEntitiesInPortalArgs = {
   params: GetApplicationVrVisibleEntitiesInPortalParams
}

export type QueryGetApplicationsForFileNumbersArgs = {
   params: GetApplicationsForFileNumbersParams
}

export type QueryGetApplicationsInApplicationManagementArgs = {
   params: GetApplicationsInApplicationManagementParams
}

export type QueryGetApplicationsInPortalArgs = {
   params: GetApplicationsInPortalParams
}

export type QueryGetAssignFriendActionVisibilityArgs = {
   params: GetAssignFriendActionVisibilityParams
}

export type QueryGetAssignedFriendApplicationsArgs = {
   params: GetAssignedFriendApplicationsParams
}

export type QueryGetAssigneeGroupsArgs = {
   params: GetAssigneeGroupsParams
}

export type QueryGetAssigneeTimespentLogsArgs = {
   params: GetAssigneeTimespentLogParams
}

export type QueryGetAssigneeTimespentLogsBulkArgs = {
   params: GetAssigneeTimespentLogsBulkParams
}

export type QueryGetAssigneeTimespentLogsInPortalArgs = {
   params: GetAssigneeTimespentLogInPortalParams
}

export type QueryGetAssigneeTimespentLogsInPortalBulkArgs = {
   params: GetAssigneeTimespentLogsInPortalBulkParams
}

export type QueryGetAssociatedPipelinesForPipelineItemTemplatesArgs = {
   params: GetAssociatedPipelinesForPipelineItemTemplatesParams
}

export type QueryGetAttachmentsArgs = {
   params: GetAttachmentsParams
}

export type QueryGetAutomationWorkflowExecConfigsArgs = {
   params: GetAutomationWorkflowExecConfigsParams
}

export type QueryGetAutomationWorkflowExecLogsArgs = {
   params: GetAutomationWorkflowExecLogsParams
}

export type QueryGetAutomationWorkflowExecLogsFilterArgs = {
   params: GetAutomationWorkflowExecLogsFilterParams
}

export type QueryGetAutomationWorkflowExecLogsTabCustomizationArgs = {
   params: GetAutomationWorkflowExecLogsTabCustomizationParams
}

export type QueryGetAutomationWorkflowNodeActionsArgs = {
   params: AutomationWorkflowNodeActionsParams
}

export type QueryGetAutomationWorkflowsArgs = {
   params: GetAutomationWorkflowsParams
}

export type QueryGetAvailableCallLogsForTaskArgs = {
   params: GetAvailableCallLogsForTaskParams
}

export type QueryGetBarGraphArgs = {
   params: GetBarGraphParams
}

export type QueryGetBoardArgs = {
   params: GetBoardParams
}

export type QueryGetBoardListsInBoardArgs = {
   params: GetBoardListsInBoardParams
}

export type QueryGetBoardsArgs = {
   params: GetBoardsParams
}

export type QueryGetBoardsSharedPermissionsArgs = {
   params: GetBoardsSharedPermissionsParams
}

export type QueryGetBpsPendingTaskOnPipelineItemArgs = {
   params: GetBpsPendingTaskOnPipelineItemParams
}

export type QueryGetBpsShortfallCounterArgs = {
   params: GetBpsShortFallCounterParams
}

export type QueryGetBpsShortfallCounterInPortalArgs = {
   params: GetBpsShortFallCounterInPortalParams
}

export type QueryGetBpsTaskConfigForPipelineItemArgs = {
   params: GetBpsTaskConfigForPipelineItemParams
}

export type QueryGetBpsTemplateConfigArgs = {
   params: GetBpsTemplateConfigParams
}

export type QueryGetCallLogsWithFiltersArgs = {
   params: GetCallLogsWithFiltersParams
}

export type QueryGetCategoryWisePipelineBoardsArgs = {
   params: GetBoardsForPipelinesParams
}

export type QueryGetChildTabsForParentTabsArgs = {
   params: GetChildTabsForParentTabsParams
}

export type QueryGetCitizenAccountStatusArgs = {
   params: GetCitizenAccountStatusParams
}

export type QueryGetCloudCallingUserConfigsArgs = {
   params: GetUserCloudCallingConfigParams
}

export type QueryGetConflictedAssociatedPipelineItemsArgs = {
   params: GetConflictedAssociatedPipelineItemsParams
}

export type QueryGetConflictedAssociatedRelatedEntitiesArgs = {
   params: GetConflictedAssociatedRelatedEntitiesParams
}

export type QueryGetContactArgs = {
   params: GetContactParams
}

export type QueryGetContactFieldsArgs = {
   params: GetContactFieldsParams
}

export type QueryGetContactLeadsArgs = {
   params: GetContactLeadsParams
}

export type QueryGetContactPipelinesArgs = {
   params: GetContactPipelinesParams
}

export type QueryGetContactsSystemFieldsArgs = {
   params: GetContactsSystemFieldsParams
}

export type QueryGetCrmEntityLinkedRelatedObjectsArgs = {
   params: GetCrmEntityLinkedRelatedObjectsParams
}

export type QueryGetCrmTemplateScoringConfigBulkArgs = {
   params: CrmTemplateScoringConfigBulkParams
}

export type QueryGetCustomSectionsVisibilityStatusInLayoutForPipelineItemArgs = {
   params: GetCustomSectionsVisibilityStatusInLayoutForPipelineItemParams
}

export type QueryGetDashboardArgs = {
   params: GetUserDashboardParams
}

export type QueryGetDashboardsCountByIdentificationArgs = {
   params: GetDashboardsCountByIdentificationParams
}

export type QueryGetDataExportRequestsArgs = {
   params: GetDataExportRequestsParams
}

export type QueryGetDataLoadingRequestsArgs = {
   params: GetDataLoadingRequestsParams
}

export type QueryGetDealAddAnotherFieldsArgs = {
   params: GetDealAddAnotherFieldsParams
}

export type QueryGetDealAddAnotherGofsFieldsArgs = {
   params: GetDealAddAnotherGoFsFieldsParams
}

export type QueryGetDealFieldsArgs = {
   params: GetDealFieldsParams
}

export type QueryGetDealHistoryArgs = {
   params: DealHistoryParams
}

export type QueryGetDealProfileArgs = {
   params: GetDealProfileParams
}

export type QueryGetDealTemplateSystemFieldsArgs = {
   params: GetDealTemplateSystemFieldsParams
}

export type QueryGetDealsSystemFieldsArgs = {
   params: GetDealsSystemFieldsParams
}

export type QueryGetDeletedFieldsForGofsArgs = {
   params: GetDeletedFieldsForGofsParams
}

export type QueryGetDeletedGofsForSalesTemplatesArgs = {
   params: GetDeletedGofsForSalesTemplatesParams
}

export type QueryGetDocumentHistoryArgs = {
   params: GetDocumentHistoryParams
}

export type QueryGetDocumentTemplatePreviewWithMockDataArgs = {
   params: GetDocumentTemplatePreviewWithMockDataParams
}

export type QueryGetDocumentTemplatesArgs = {
   params: GetDocumentTemplatesParams
}

export type QueryGetDocumentTemplatesByVersionForAdminArgs = {
   params: GetDocumentTemplatesByVersionForAdminParams
}

export type QueryGetDocumentTemplatesForPipelineItemTemplateArgs = {
   params: GetDocumentTemplatesForPipelineItemTemplateParams
}

export type QueryGetDocumentTemplatesForPipelineItemTemplatesArgs = {
   params: GetDocumentTemplatesForPipelineItemTemplatesParams
}

export type QueryGetDocumentTemplatesForPipelineItemTemplatesByAdminArgs = {
   params: GetDocumentTemplatesForPipelineItemTemplateByAdminParams
}

export type QueryGetDocumentTemplatesPermittedActionsArgs = {
   params: GetDocumentTemplatesPermittedActionsParams
}

export type QueryGetDocumentsForDocumentTemplatesArgs = {
   params: GetDocumentsForDocumentTemplatesParams
}

export type QueryGetDonutChartArgs = {
   params: GetDonutChartParams
}

export type QueryGetEligibleTdrBanksInPortalArgs = {
   params: GetEligibleTdrBanksInPortalParams
}

export type QueryGetEntitiesCountForFiltersArgs = {
   params: GetEntitiesCountForFiltersParams
}

export type QueryGetEntityBoardsArgs = {
   params: GetEntityBoardsParams
}

export type QueryGetEntityCheckedCheckpointsArgs = {
   params: GetEntityCheckedCheckpointsParams
}

export type QueryGetEntityDealsArgs = {
   params: GetEntityDealsParams
}

export type QueryGetEntityFeeRuleSetForEntityArgs = {
   params: GetEntityFeeRuleSetForEntityParams
}

export type QueryGetEntityFeeRuleSetOrdersPreviewArgs = {
   params: GetEntityFeeRuleSetOrdersPreviewParams
}

export type QueryGetEntityFeeRuleSetsForEntityArgs = {
   params: GetEntityFeeRuleSetsForEntityParams
}

export type QueryGetEntityJsonConfigurationArgs = {
   params: GetEntityJsonConfigurationParams
}

export type QueryGetEntityNotesArgs = {
   params: GetEntityNotesParams
}

export type QueryGetEntityRuleSetsArgs = {
   params: GetEntityRuleSetsParams
}

export type QueryGetEntityTdrRequestsArgs = {
   params: GetEntityTdrRequestsParams
}

export type QueryGetEntityTdrRequestsInPortalArgs = {
   params: GetEntityTdrRequestsInPortalParams
}

export type QueryGetEntityUncheckedCheckpointsArgs = {
   params: GetEntityUncheckedCheckpointsParams
}

export type QueryGetEventBasedLeadDistributionRuleSummaryArgs = {
   params: GetEventBasedLeadDistributionRuleSummaryParams
}

export type QueryGetFailedTrackActivityLogsArgs = {
   params: GetFailedTrackActivityLogsParams
}

export type QueryGetFeeRuleSetLogsArgs = {
   params: GetFeeRuleSetLogsParams
}

export type QueryGetFieldEntityRuleSetsInPortalArgs = {
   params: GetFieldEntityRuleSetsInPortalParams
}

export type QueryGetFieldOptionsForApplicationInPortalArgs = {
   params: GetFieldOptionsForApplicationInPortalParams
}

export type QueryGetFieldOptionsForCrmEntityArgs = {
   params: GetFieldOptionsForCrmEntityParams
}

export type QueryGetFieldOptionsForRecordCreationArgs = {
   params: GetFieldOptionsForRecordCreationParams
}

export type QueryGetFieldOptionsForRelatedEntityFieldArgs = {
   params: GetFieldOptionsForRelatedEntityFieldParams
}

export type QueryGetFieldOptionsForSearchAndMonitoringArgs = {
   params: GetFieldOptionsForSearchAndMonitoringParams
}

export type QueryGetFieldRolesArgs = {
   params: GetFieldRolesParams
}

export type QueryGetFieldsArgs = {
   params: FieldsInputArgs
}

export type QueryGetFieldsInPortalArgs = {
   params: GetFieldsInPortalParams
}

export type QueryGetFieldsIncludingConstantFieldsArgs = {
   params: GetFieldsIncludingConstantFieldsInputArgs
}

export type QueryGetFilterFieldsArgs = {
   params: GetFilterFieldsParams
}

export type QueryGetFilterSetEntitiesCountArgs = {
   params: GetFilterSetEntitiesCountParams
}

export type QueryGetFiltersArgs = {
   params: GetFiltersParams
}

export type QueryGetFiltersForAutomationWorkflowFilterSetArgs = {
   params: GetFiltersForAutomationWorkflowFilterSetParams
}

export type QueryGetFiltersForBoardArgs = {
   params: GetBoardFiltersParams
}

export type QueryGetFiltersForBoardListArgs = {
   params: GetBoardListFiltersParams
}

export type QueryGetFiltersForConditionNodeArgs = {
   params: GetFiltersForConditionNodeParams
}

export type QueryGetFiltersForEventTriggerFilterSetArgs = {
   params: GetFiltersForEventTriggerFilterSetParams
}

export type QueryGetFiltersForViewArgs = {
   params: GetViewFiltersParams
}

export type QueryGetFormArgs = {
   params: GetFormParams
}

export type QueryGetFormFailedSubmissionLogsArgs = {
   params: GetFormFailedSubmissionLogsParams
}

export type QueryGetFormFieldsInPdfArgs = {
   params: GetFormFieldsInPdfParams
}

export type QueryGetFormIdentificationFieldsArgs = {
   params: GetFormIdentificationFieldsParams
}

export type QueryGetFormsForParentArgs = {
   params: GetFormsForParentParams
}

export type QueryGetFunnelGraphArgs = {
   params: GetFunnelGraphParams
}

export type QueryGetGallaboxAccountPluginServiceAccountsArgs = {
   params: GetGallaboxAccountPluginServiceAccountsParams
}

export type QueryGetGallaboxPluginServiceAccountsArgs = {
   params: GetGallaboxPluginServiceAccountsParams
}

export type QueryGetGofsArgs = {
   params: GoFsInputArgs
}

export type QueryGetGraphArgs = {
   params: GetGraphParams
}

export type QueryGetGraphsInDashboardArgs = {
   params: GetGraphsInDashboardParams
}

export type QueryGetGraphsInViewArgs = {
   params: GetGraphsInViewParams
}

export type QueryGetGupShupAccountPluginServiceAccountsArgs = {
   params: GetGupShupAccountPluginServiceAccountsParams
}

export type QueryGetGupShupPluginServiceAccountsArgs = {
   params: GetGupShupPluginServiceAccountsParams
}

export type QueryGetIdentificationsInAccountArgs = {
   params: GetIdentificationsInAccountParams
}

export type QueryGetIsTgBPassFileNumberValidArgs = {
   params: GetTGbPassFileNumberIsValidParams
}

export type QueryGetItemIdsInViewArgs = {
   params: GetItemIdsInViewParams
}

export type QueryGetJsonConfigurationsArgs = {
   params: GetJsonConfigurationsParams
}

export type QueryGetKnowlarityAccountPluginServiceAccountsArgs = {
   params: GetKnowlarityAccountPluginServiceAccountsParams
}

export type QueryGetKnowlarityServiceAccountsArgs = {
   params: GetKnowlarityServiceAccountsParams
}

export type QueryGetLatestPendingPipelineItemTasksArgs = {
   params: GetLatestPendingPipelineItemTasksParams
}

export type QueryGetLatestPipelineItemTaskFieldsForFieldsArgs = {
   params: GetLatestPipelineItemTaskFieldsForFieldsParams
}

export type QueryGetLayoutForEntityDetailsArgs = {
   params: GetLayoutForEntityDetailsParams
}

export type QueryGetLayoutParentTabsForEntityDetailsArgs = {
   params: GetLayoutParentTabsForEntityDetailsParams
}

export type QueryGetLayoutTabsForPipelineTemplateArgs = {
   params: GetLayoutTabsForPipelineTemplateParams
}

export type QueryGetLeadAddAnotherFieldsArgs = {
   params: GetLeadAddAnotherFieldsParams
}

export type QueryGetLeadAddAnotherGofsFieldsArgs = {
   params: GetLeadAddAnotherGoFsFieldsParams
}

export type QueryGetLeadDistributionRuleExecLogArgs = {
   params: GetLeadDistributionRuleExecLogParams
}

export type QueryGetLeadDistributionRuleSummaryArgs = {
   params: GetLeadDistributionRuleSummaryParams
}

export type QueryGetLeadDistributionRulesArgs = {
   params: GetLeadDistributionRulesParams
}

export type QueryGetLeadFieldsArgs = {
   params: GetLeadFieldsParams
}

export type QueryGetLeadHistoryArgs = {
   params: LeadHistoryParams
}

export type QueryGetLeadInitiationRolesOnActivityArgs = {
   params: GetLeadInitiationRolesOnActivityParams
}

export type QueryGetLeadProfileArgs = {
   params: GetLeadProfileParams
}

export type QueryGetLeadTemplateSystemFieldsArgs = {
   params: GetLeadTemplateSystemFieldsParams
}

export type QueryGetLeadsSystemFieldsArgs = {
   params: GetLeadsSystemFieldsParams
}

export type QueryGetLineDepartmentRequestHistoryLogsArgs = {
   params: GetLineDepartmentRequestHistoryLogsParams
}

export type QueryGetLineGraphArgs = {
   params: GetLineGraphParams
}

export type QueryGetLoadBankAccountRequestsArgs = {
   params: GetLoadBankAccountRequestParams
}

export type QueryGetLtpUserManagementLogsArgs = {
   params: GetLtpUserManagementLogsParams
}

export type QueryGetLtpUsersForLtpManagementArgs = {
   params: GetLtpUsersForLtpManagementParams
}

export type QueryGetMessagesForThreadArgs = {
   params: GetMessagesForThreadParams
}

export type QueryGetNodesArgs = {
   params: GetNodesParams
}

export type QueryGetOfficerLeaveLogsArgs = {
   params: GetOfficerLeaveLogsParams
}

export type QueryGetOfficerManagementLogsArgs = {
   params: GetOfficerManagementLogsParams
}

export type QueryGetOfficerManagementUsersArgs = {
   params: GetOfficerManagementUserParams
}

export type QueryGetOnHoldTdrAccountLogsArgs = {
   params: GetOnHoldTdrAccountLogsParams
}

export type QueryGetOpenSearchTdrAccountArgs = {
   params: GetOpenSearchTdrAccountParams
}

export type QueryGetOpenSearchTdrAccountByAccountNoArgs = {
   params: GetOpenSearchTdrAccountByAccountNoParams
}

export type QueryGetOpenSearchTdrAccountsArgs = {
   params: GetOpenSearchTdrAccountsParams
}

export type QueryGetOrCreateViewsInBoardsAndListsArgs = {
   params: GetViewsInBoardsAndListsParams
}

export type QueryGetOrdersOnPipelineItemArgs = {
   params: GetOrdersOnPipelineItemParams
}

export type QueryGetOrdersOnPipelineItemInPortalArgs = {
   params: GetOrdersOnPipelineItemInPortalParams
}

export type QueryGetParametersArgs = {
   params: GetParametersParams
}

export type QueryGetParametersInAccountArgs = {
   params: ParametersInAccountParams
}

export type QueryGetPaymentArgs = {
   params: GetPaymentParams
}

export type QueryGetPaymentHistoryOnPipelineItemArgs = {
   params: PaymentHistoryOnPipelineItemParams
}

export type QueryGetPaymentRequestsArgs = {
   params: GetPaymentRequestsParams
}

export type QueryGetPaymentTransactionsOnPipelineItemInPortalArgs = {
   params: GetPaymentTransactionsOnPipelineItemInPortalParams
}

export type QueryGetPendingTaskOnPipelineItemArgs = {
   params: GetPendingTaskOnPipelineItemParams
}

export type QueryGetPendingTasksApplicationsArgs = {
   params: GetPendingTasksApplicationsParams
}

export type QueryGetPermittedStagesArgs = {
   params: GetPermittedStagesParams
}

export type QueryGetPieChartArgs = {
   params: GetPieChartParams
}

export type QueryGetPinnedPipelineItemIdsInViewArgs = {
   params: GetPinnedPipelineItemIdsInViewParams
}

export type QueryGetPinnedPipelineItemsCountForUserArgs = {
   params: GetPinnedPipelineItemsCountForUserParams
}

export type QueryGetPinnedPipelineItemsForUserArgs = {
   params: GetPinnedPipelineItemsForUserParams
}

export type QueryGetPipelineApplicationsInPortalArgs = {
   params: GetPipelineApplicationsPropertiesInPortalParams
}

export type QueryGetPipelineAutomationWorkflowConfigArgs = {
   params: PipelineAutomationWorkflowConfigParams
}

export type QueryGetPipelineCustomObjectAddAnotherFieldsArgs = {
   params: GetPipelineCustomObjectAddAnotherFieldsParams
}

export type QueryGetPipelineCustomObjectAddAnotherGofsFieldsArgs = {
   params: GetPipelineCustomObjectAddAnotherGoFsFieldsParams
}

export type QueryGetPipelineCustomObjectFieldsArgs = {
   params: GetPipelineCustomObjectFieldsParams
}

export type QueryGetPipelineCustomObjectProfileArgs = {
   params: GetPipelineCustomObjectProfileParams
}

export type QueryGetPipelineCustomObjectsSystemFieldsArgs = {
   params: GetPipelineCustomObjectsSystemFieldsParams
}

export type QueryGetPipelineDocumentTemplatesArgs = {
   params: GetPipelineDocumentTemplatesParams
}

export type QueryGetPipelineDocumentTemplatesForAdminArgs = {
   params: GetDocumentTemplatesInPipelineParams
}

export type QueryGetPipelineEventBasedLeadDistributionExecLogsArgs = {
   params: GetPipelineScheduledLeadDistributionRuleExecLogsParams
}

export type QueryGetPipelineEventFieldsArgs = {
   params: GetPipelineEventFieldsParams
}

export type QueryGetPipelineEventTemplatesArgs = {
   params: PipelineEventTemplatesParams
}

export type QueryGetPipelineFeeRuleSetsArgs = {
   params: GetPipelineFeeRuleSetsParams
}

export type QueryGetPipelineIdentificationsArgs = {
   params: GetPipelineIdentificationsParams
}

export type QueryGetPipelineInPortalArgs = {
   params: GetPipelineInPortalParams
}

export type QueryGetPipelineItemActivitiesArgs = {
   params: GetPipelineItemActivitiesParams
}

export type QueryGetPipelineItemActivitiesInPortalArgs = {
   params: GetPipelineItemActivitiesParams
}

export type QueryGetPipelineItemAppealTasksArgs = {
   params: GetPipelineItemAppealTasksParams
}

export type QueryGetPipelineItemAssigneeUpdateHierarchyArgs = {
   params: GetPipelineItemAssigneeUpdateHierarchyParams
}

export type QueryGetPipelineItemBannerMessageArgs = {
   params: GetPipelineItemBannerMessageParams
}

export type QueryGetPipelineItemCallLogsArgs = {
   params: GetPipelineItemCallLogsParams
}

export type QueryGetPipelineItemCompletionPercentageInPortalArgs = {
   params: GetPipelineItemCompletionPercentageInPortalParams
}

export type QueryGetPipelineItemConsentPhoneNumbersArgs = {
   params: GetPipelineItemConsentPhoneNumbersParams
}

export type QueryGetPipelineItemCurrentStageSlaFieldInPipelineArgs = {
   params: GetPipelineItemCurrentStageSlaFieldInPipelineParams
}

export type QueryGetPipelineItemCurrentStageSlaFieldResponsesInPipelineArgs = {
   params: GetPipelineItemCurrentStageSlaFieldInPipelineParams
}

export type QueryGetPipelineItemDocumentTemplatesArgs = {
   params: GetPipelineItemDocumentTemplatesParams
}

export type QueryGetPipelineItemDocumentsForDocumentTemplateArgs = {
   params: GetPipelineItemDocumentsForDocumentTemplateParams
}

export type QueryGetPipelineItemFieldLogsArgs = {
   params: GetPipelineItemFieldsLogParams
}

export type QueryGetPipelineItemFieldLogsInPortalArgs = {
   params: GetPipelineItemFieldLogsInPortalParams
}

export type QueryGetPipelineItemFieldPermissionsArgs = {
   params: GetPipelineItemFieldPermissionsParams
}

export type QueryGetPipelineItemFieldShortfallLogsArgs = {
   params: GetPipelineItemFieldShortfallLogsParams
}

export type QueryGetPipelineItemFieldShortfallLogsInPortalArgs = {
   params: GetPipelineItemFieldShortfallLogsInPortalParams
}

export type QueryGetPipelineItemFieldsInTaskDraftArgs = {
   params: GetPipelineItemFieldsInTaskDraftParams
}

export type QueryGetPipelineItemFieldsLogCountArgs = {
   params: GetPipelineItemFieldsLogCountParams
}

export type QueryGetPipelineItemFieldsLogCountInPortalArgs = {
   params: GetPipelineItemFieldsLogCountInPortalParams
}

export type QueryGetPipelineItemFieldsToLogArgs = {
   params: GetPipelineItemFieldsToLogParams
}

export type QueryGetPipelineItemGeneratedRemarksFromOverallRemarksArgs = {
   params: GetPipelineItemGeneratedRemarksParams
}

export type QueryGetPipelineItemHistoryArgs = {
   params: GetPipelineItemHistoryParams
}

export type QueryGetPipelineItemLatestTasksArgs = {
   params: GetPipelineItemLatestTasksParams
}

export type QueryGetPipelineItemLayoutTabsVisibilityStatusArgs = {
   params: GetPipelineItemLayoutTabsVisibilityStatusParams
}

export type QueryGetPipelineItemMergeInProgressStatusArgs = {
   params: GetPipelineItemMergeInProgressStatusParams
}

export type QueryGetPipelineItemMessageTemplatesArgs = {
   params: GetPipelineItemMessageTemplatesParams
}

export type QueryGetPipelineItemNoteSheetPermissionsArgs = {
   params: GetPipelineItemNoteSheetPermissionsParams
}

export type QueryGetPipelineItemOrdersAndPaymentsArgs = {
   params: GetPipelineItemOrdersAndPaymentsParams
}

export type QueryGetPipelineItemPaymentRuleSetArgs = {
   params: GetPipelineItemPaymentRuleSetParams
}

export type QueryGetPipelineItemPaymentRulesArgs = {
   params: GetPipelineItemPaymentRulesParams
}

export type QueryGetPipelineItemPaymentsArgs = {
   params: GetPipelineItemPaymentsParams
}

export type QueryGetPipelineItemPermittedStagesArgs = {
   params: GetPipelineItemPermittedStagesParams
}

export type QueryGetPipelineItemRecommendedTaskTemplatesArgs = {
   params: GetPipelineItemRecommendedTaskTemplatesParams
}

export type QueryGetPipelineItemRemarksArgs = {
   params: GetPipelineItemRemarksParams
}

export type QueryGetPipelineItemRemarksAttachmentsInTaskDraftArgs = {
   params: GetPipelineItemRemarksAttachmentsInTaskDraftParams
}

export type QueryGetPipelineItemRemarksInTaskDraftArgs = {
   params: GetPipelineItemRemarksInTaskDraftParams
}

export type QueryGetPipelineItemRemindersForUserArgs = {
   params: GetPipelineItemRemindersForUserParams
}

export type QueryGetPipelineItemResourcesArgs = {
   params?: InputMaybe<GetPipelineItemResourcesParams>
}

export type QueryGetPipelineItemShortfallFieldsArgs = {
   params: GetPipelineItemShortfallFieldsParams
}

export type QueryGetPipelineItemShortfallFieldsInPortalArgs = {
   params: GetPipelineItemShortfallFieldsInPortalParams
}

export type QueryGetPipelineItemShortfallLogFieldsArgs = {
   params: GetPipelineItemShortfallLogFieldsParams
}

export type QueryGetPipelineItemShortfallLogFieldsInPortalArgs = {
   params: GetPipelineItemShortfallLogFieldsInPortalParams
}

export type QueryGetPipelineItemShortfallLogsArgs = {
   params: GetPipelineItemShortfallLogsParams
}

export type QueryGetPipelineItemShortfallLogsInPortalArgs = {
   params: GetPipelineItemShortfallLogsInPortalParams
}

export type QueryGetPipelineItemSlaFieldsArgs = {
   params: GetPipelineItemSlaFieldsParams
}

export type QueryGetPipelineItemStagePermissionsArgs = {
   params: GetPipelineItemStagePermissionsParams
}

export type QueryGetPipelineItemStageTransitionMandatoryEntitiesStatusArgs = {
   params: GetPipelineItemStageTransitionMandatoryEntitiesStatusParams
}

export type QueryGetPipelineItemStageTransitionMandatoryEntitiesStatusBulkArgs = {
   params: GetPipelineItemStageTransitionMandatoryEntitiesStatusBulkParams
}

export type QueryGetPipelineItemStageTransitionMandatoryTasksStatusArgs = {
   params: GetPipelineItemStageTransitionMandatoryTasksStatusParams
}

export type QueryGetPipelineItemStageTransitionMandatoryTasksStatusBulkArgs = {
   params: GetPipelineItemStageTransitionMandatoryTasksStatusBulkParams
}

export type QueryGetPipelineItemStageTransitionOverallObservationArgs = {
   params: GetPipelineItemStageTransitionOverallObservationParams
}

export type QueryGetPipelineItemStageTransitionsArgs = {
   params: GetPipelineItemStageTransitionsParams
}

export type QueryGetPipelineItemSubmissionGroupsArgs = {
   params: GetPipelineItemSubmissionGroupsParams
}

export type QueryGetPipelineItemTabsDetailsArgs = {
   params: GetPipelineItemTabsDetailsParams
}

export type QueryGetPipelineItemTasksArgs = {
   params: GetPipelineItemTasksParams
}

export type QueryGetPipelineItemTemplateAdminsBulkArgs = {
   params: GetPipelineItemTemplateAdminsBulkParams
}

export type QueryGetPipelineItemTemplateFieldsToLogArgs = {
   params: GetPipelineItemTemplateFieldsToLogParams
}

export type QueryGetPipelineItemTemplateIdentificationsArgs = {
   params: GetPipelineItemTemplateIdentificationsParams
}

export type QueryGetPipelineItemTemplatesArgs = {
   params: GetPipelineItemTemplatesParams
}

export type QueryGetPipelineItemVerificationsArgs = {
   params: GetPipelineItemVerificationsParams
}

export type QueryGetPipelineItemVrVisibleEntitiesArgs = {
   params: GetPipelineItemVrVisibleEntitiesParams
}

export type QueryGetPipelineManualLeadDistributionExecLogsArgs = {
   params: GetPipelineManualLeadDistributionRuleExecLogsParams
}

export type QueryGetPipelineResourcesArgs = {
   params?: InputMaybe<GetPipelineResourcesParams>
}

export type QueryGetPipelineScheduledLeadDistributionExecLogsArgs = {
   params: GetPipelineScheduledLeadDistributionRuleExecLogsParams
}

export type QueryGetPipelineSettingsBulkArgs = {
   params: GetPipelineSettingsBulkParams
}

export type QueryGetPipelineStagesBulkArgs = {
   params: PipelineStagesBulkParams
}

export type QueryGetPipelineTemplatesSystemFieldsArgs = {
   params: GetPipelineTemplatesSystemFieldsParams
}

export type QueryGetPipelineWhatsappBusinessPhoneNumbersArgs = {
   params: GetPipelineWhatsAppBusinessPhoneNumbersParams
}

export type QueryGetPipelineWhatsappMessageTemplatesArgs = {
   params: GetPipelineWhatsappMessageTemplatesParams
}

export type QueryGetPipelinesArgs = {
   params: GetPipelinesParams
}

export type QueryGetPipelinesAutomationWorkflowsArgs = {
   params: GetPipelinesAutomationWorkflowsParams
}

export type QueryGetPipelinesForPipelineItemTemplateArgs = {
   params: GetPipelinesForPipelineItemTemplateParams
}

export type QueryGetPipelinesForPipelineItemsArgs = {
   params: GetPipelinesForPipelineItemsParams
}

export type QueryGetPipelinesInPortalArgs = {
   params: GetPipelinesInPortalParams
}

export type QueryGetPipelinesLayoutArgs = {
   params: GetPipelinesLayoutParams
}

export type QueryGetPivotTableArgs = {
   params: GetPivotTableParams
}

export type QueryGetPivotTableColumnTotalsArgs = {
   params: PivotTableColumnTotalParams
}

export type QueryGetPivotTableRowTotalsArgs = {
   params: PivotTableRowTotalParams
}

export type QueryGetPluginServiceAccountCallLogsArgs = {
   params: GetPluginServiceAccountCallLogsParams
}

export type QueryGetPluginServiceAccountWhatsappMessageTemplatesSyncStatusArgs = {
   params: GetPluginServiceAccountWhatsappMessageTemplatesSyncStatusParams
}

export type QueryGetPmuActionLogDetailArgs = {
   params: GetPmuActionLogDetailParams
}

export type QueryGetPmuActionLogsArgs = {
   params: GetPmuActionLogsParams
}

export type QueryGetPortalApplicationConfigBulkArgs = {
   params: GetPortalApplicationConfigBulkParams
}

export type QueryGetPortalApplicationsArgs = {
   params: GetPortalApplicationsParams
}

export type QueryGetPortalUnifiedApplicationCreationConfigArgs = {
   params: GetPortalUnifiedApplicationCreationConfigParams
}

export type QueryGetPortalsArgs = {
   params: GetPortalsParams
}

export type QueryGetPortalsInAccountArgs = {
   params: GetPortalsInAccountParams
}

export type QueryGetPreSignedGetUrlForApplicationDocumentInPortalArgs = {
   params: GetPreSignedGetUrlForApplicationDocumentInPortalParams
}

export type QueryGetPreSignedGetUrlForApplicationFieldInPortalArgs = {
   params: GetPreSignedGetUrlForApplicationFieldInPortalParams
}

export type QueryGetPreSignedGetUrlForArchitectProfileAttachmentArgs = {
   params: GetPreSignedGetUrlForArchitectProfileAttachmentParams
}

export type QueryGetPreSignedGetUrlForCrmEntityFieldArgs = {
   params: GetPreSignedGetUrlForCrmEntityFieldParams
}

export type QueryGetPreSignedGetUrlForCrmEntityFieldLogArgs = {
   params: GetPreSignedGetUrlForCrmEntityFieldLogParams
}

export type QueryGetPreSignedGetUrlForDataExportRequestArgs = {
   params: GetPreSignedGetUrlForDataExportRequestParams
}

export type QueryGetPreSignedGetUrlForDataLoadingRequestArgs = {
   params: GetPreSignedGetUrlForDataLoadingRequestParams
}

export type QueryGetPreSignedGetUrlForDocumentArgs = {
   params: GetPreSignedGetUrlForDocumentParams
}

export type QueryGetPreSignedGetUrlForDocumentTemplateArgs = {
   params: GetPreSignedGetUrlForDocumentTemplateParams
}

export type QueryGetPreSignedGetUrlForDocumentVersionArgs = {
   params: GetPreSignedGetUrlForDocumentVersionParams
}

export type QueryGetPreSignedGetUrlForEntityArgs = {
   params: GetPreSignedGetUrlForEntityParams
}

export type QueryGetPreSignedGetUrlForPaymentReceiptArgs = {
   params: GetPreSignedGetUrlForPaymentReceiptParams
}

export type QueryGetPreSignedGetUrlForPaymentReceiptInPortalArgs = {
   params: GetPreSignedGetUrlForPaymentReceiptInPortalParams
}

export type QueryGetPreSignedGetUrlForPipelineItemRemarksArgs = {
   params: GetPreSignedGetUrlForPipelineItemRemarksParams
}

export type QueryGetPreSignedGetUrlForPipelineItemRemarksInTaskDraftArgs = {
   params: GetPreSignedGetUrlForPipelineItemRemarksInTaskDraftParams
}

export type QueryGetPreSignedGetUrlForPortalBgImageArgs = {
   params: GetPreSignedGetUrlForPortalParams
}

export type QueryGetPreSignedGetUrlForPortalLogoArgs = {
   params: GetPreSignedGetUrlForPortalParams
}

export type QueryGetPreSignedGetUrlForRelatedEntityFieldArgs = {
   params: GetPreSignedGetUrlForRelatedEntityFieldParams
}

export type QueryGetPreSignedGetUrlForRelatedEntityRemarksArgs = {
   params: GetPreSignedGetUrlForRelatedEntityRemarksParams
}

export type QueryGetPreSignedGetUrlForTdrAccountArgs = {
   params: GetPreSignedGetUrlForTdrAccountParams
}

export type QueryGetPreSignedGetUrlForTdrAccountCertificateArgs = {
   params: GetPreSignedGetUrlForTdrAccountCertificateParams
}

export type QueryGetPreSignedGetUrlForTdrCertificateArgs = {
   params: GetPreSignedGetUrlForTdrCertificateParams
}

export type QueryGetPreSignedGetUrlForTdrCertificateInPortalArgs = {
   params: GetPreSignedGetUrlForTdrCertificateInPortalParams
}

export type QueryGetPreSignedGetUrlForUserKmlFileArgs = {
   params: GetPreSignedGetUrlForUserKmlFileParams
}

export type QueryGetPreSignedPostUrlForApplicationFieldInPortalArgs = {
   params: GetPreSignedPostUrlForApplicationFieldInPortalParams
}

export type QueryGetPreSignedPostUrlForArchitectProfileAttachmentArgs = {
   params: GetPreSignedPostUrlForArchitectProfileAttachmentParams
}

export type QueryGetPreSignedPostUrlForCrmEntityFieldArgs = {
   params: GetPreSignedPostUrlForCrmEntityFieldParams
}

export type QueryGetPreSignedPostUrlForDataExportRequestArgs = {
   params: GetPreSignedPostUrlForDataExportRequestParams
}

export type QueryGetPreSignedPostUrlForDataLoadingRequestArgs = {
   params: GetPreSignedPostUrlForDataLoadingRequestParams
}

export type QueryGetPreSignedPostUrlForDocumentTemplateArgs = {
   params: GetPreSignedPostUrlForDocumentTemplateParams
}

export type QueryGetPreSignedPostUrlForPipelineItemRemarksArgs = {
   params: GetPreSignedPostUrlForPipelineItemRemarksParams
}

export type QueryGetPreSignedPostUrlForPipelineItemRemarksInTaskDraftArgs = {
   params: GetPreSignedPostUrlForPipelineItemRemarksInTaskDraftParams
}

export type QueryGetPreSignedPostUrlForRelatedEntityFieldArgs = {
   params: GetPreSignedPostUrlForRelatedEntityFieldParams
}

export type QueryGetPreSignedPostUrlForRelatedEntityRemarksArgs = {
   params: GetPreSignedPostUrlForRelatedEntityFieldParams
}

export type QueryGetPreSignedPostUrlForStageTransitionPipelineItemRemarksArgs = {
   params: GetPreSignedPostUrlForStageTransitionPipelineItemRemarksParams
}

export type QueryGetPreSignedPostUrlForTdrCertificateInPortalArgs = {
   params: GetPreSignedPostUrlForTdrCertificateInPortalParams
}

export type QueryGetPreSignedPutUrlForApplicationFieldInPortalArgs = {
   params: GetPreSignedPutUrlForApplicationFieldInPortalParams
}

export type QueryGetPreSignedPutUrlForArchitectProfileAttachmentArgs = {
   params: GetPreSignedPutUrlForArchitectProfileAttachmentParams
}

export type QueryGetPreSignedPutUrlForCrmEntityFieldArgs = {
   params: GetPreSignedPutUrlForCrmEntityFieldParams
}

export type QueryGetPreSignedPutUrlForDataExportRequestArgs = {
   params: GetPreSignedPutUrlForDataExportRequestParams
}

export type QueryGetPreSignedPutUrlForDataLoadingRequestArgs = {
   params: GetPreSignedPutUrlForDataLoadingRequestParams
}

export type QueryGetPreSignedPutUrlForDocumentTemplateArgs = {
   params: GetPreSignedPutUrlForDocumentTemplateParams
}

export type QueryGetPreSignedPutUrlForEntityArgs = {
   params: GetPreSignedPutUrlForEntityParams
}

export type QueryGetPreSignedPutUrlForPipelineItemRemarksArgs = {
   params: GetPreSignedPutUrlForPipelineItemRemarksParams
}

export type QueryGetPreSignedPutUrlForPipelineItemRemarksInTaskDraftArgs = {
   params: GetPreSignedPutUrlForPipelineItemRemarksInTaskDraftParams
}

export type QueryGetPreSignedPutUrlForRelatedEntityFieldArgs = {
   params: GetPreSignedPutUrlForRelatedEntityFieldParams
}

export type QueryGetPreSignedPutUrlForRelatedEntityRemarksArgs = {
   params: GetPreSignedPutUrlForRelatedEntityRemarksParams
}

export type QueryGetPreSignedPutUrlForStageTransitionPipelineItemRemarksArgs = {
   params: GetPreSignedPutUrlForStageTransitionPipelineItemRemarksParams
}

export type QueryGetPreSignedPutUrlForTdrAccountCertificateArgs = {
   params: GetPreSignedPutUrlForTdrAccountCertificateParams
}

export type QueryGetPreSignedPutUrlForTdrCertificateInPortalArgs = {
   params: GetPreSignedPutUrlForTdrCertificateInPortalParams
}

export type QueryGetPrefilledPipelineItemCheckpointsArgs = {
   params: GetPrefilledPipelineItemCheckpointsParams
}

export type QueryGetPreviewForDocumentTemplateArgs = {
   params: GetPreviewForDocumentTemplateParams
}

export type QueryGetPropertiesForApplicationsArgs = {
   params: GetPropertiesForApplicationsParams
}

export type QueryGetPropertiesForApplicationsAsOpenArgs = {
   params: GetPropertiesForApplicationsAsOpenParams
}

export type QueryGetPropertiesForApplicationsInPortalArgs = {
   params: GetPropertiesForApplicationsInPortalParams
}

export type QueryGetPropertiesForContactsArgs = {
   params: GetPropertiesForContactsParams
}

export type QueryGetPropertiesForDealsArgs = {
   params: GetPropertiesForDealsParams
}

export type QueryGetPropertiesForLeadsArgs = {
   params: GetPropertiesForLeadsParams
}

export type QueryGetPropertiesForPipelineCustomObjectsArgs = {
   params: GetPropertiesForPipelineCustomObjectsParams
}

export type QueryGetPropertiesForPipelineItemsWithoutPermissionArgs = {
   params: GetPropertiesForPipelineItemsWithoutPermissionParams
}

export type QueryGetReconciliationCsvDataArgs = {
   params: GetReconciliationCsvDataParams
}

export type QueryGetReconciliationRequestsArgs = {
   params: GetReconciliationRequestsParams
}

export type QueryGetRecordCreationConfigsArgs = {
   params: GetRecordCreationConfigsParams
}

export type QueryGetRecordCreationConfigsForAdminArgs = {
   params: GetRecordCreationConfigsForAdminParams
}

export type QueryGetRecordMergePermissionsForSalesTemplatesArgs = {
   params: GetRecordMergePermissionsForSalesTemplatesParams
}

export type QueryGetRefundApplicationsArgs = {
   params: GetRefundApplicationsParams
}

export type QueryGetRelatedApplicationCopyFieldsLogInPortalArgs = {
   params: GetRelatedApplicationCopyFieldsLogInPortalParams
}

export type QueryGetRelatedEntitiesAddAnotherGofsFieldsBulkArgs = {
   params: GetRelatedEntitiesAddAnotherGoFsFieldsBulkParams
}

export type QueryGetRelatedEntitiesFieldResponsesArgs = {
   params: GetRelatedEntitiesFieldResponsesParams
}

export type QueryGetRelatedEntityAddAnotherFieldsArgs = {
   params: GetRelatedEntityAddAnotherFieldsParams
}

export type QueryGetRelatedEntityAddAnotherGofsFieldsArgs = {
   params: GetRelatedEntityAddAnotherGoFsFieldsParams
}

export type QueryGetRelatedObjectsArgs = {
   params: GetRelatedObjectsParams
}

export type QueryGetRelatedObjectsCountInPortalArgs = {
   params: GetRelatedObjectsCountInPortalParams
}

export type QueryGetRelatedObjectsInPortalArgs = {
   params: GetRelatedObjectsInPortalParams
}

export type QueryGetRelatedObjectsToLinkArgs = {
   params: GetRelatedObjectsToLinkParams
}

export type QueryGetRelatedPipelineItemRemarksArgs = {
   params: GetRelatedPipelineItemRemarksParams
}

export type QueryGetRelatedPipelineItemRemarksAttachmentsArgs = {
   params: GetRelatedPipelineItemAttachmentsParams
}

export type QueryGetRelationsArgs = {
   params: GetRelationsParams
}

export type QueryGetRelationsToPipelineItemTemplateArgs = {
   params: GetRelationsToPipelineItemTemplateParams
}

export type QueryGetRemindersOnPipelineItemArgs = {
   params: GetRemindersOnPipelineItemParams
}

export type QueryGetRetoolAppEmbedUrlArgs = {
   params: GetRetoolAppEmbedUrlParams
}

export type QueryGetSalesTemplateRecordCreationConfigFieldsArgs = {
   params: GetSalesTemplateRecordCreationConfigFieldsParams
}

export type QueryGetSalesTemplatesArgs = {
   params: GetSalesTemplatesParams
}

export type QueryGetSalesTemplatesInPortalArgs = {
   params: GetSalesTemplatesInPortalParams
}

export type QueryGetSalesTemplatesToLinkInRelationArgs = {
   params: GetSalesTemplateTypes
}

export type QueryGetSalesTemplatesWithoutPermissionArgs = {
   params: GetSalesTemplatesWithoutPermissionParams
}

export type QueryGetScheduledAutomationWorkflowExecLogsFilterArgs = {
   params: GetScheduledAutomationWorkflowExecLogsFilterParams
}

export type QueryGetScheduledPipelineItemIdsInViewArgs = {
   params: GetScheduledPipelineItemIdsInViewParams
}

export type QueryGetScheduledPipelineItemsCountForUserArgs = {
   params: GetSchedulePipelineItemsCountForUserParams
}

export type QueryGetScheduledPipelineItemsCountInDateRangeArgs = {
   params: GetSchedulePipelineItemsCountInDateRangeParams
}

export type QueryGetScheduledPipelineItemsForUserArgs = {
   params: GetSchedulePipelineItemsForUserParams
}

export type QueryGetScheduledPipelineItemsForUserV2Args = {
   params: GetSchedulePipelineItemsForUserV2Params
}

export type QueryGetScheduledPipelineItemsTeamMetricsArgs = {
   params: GetScheduledPipelineItemsTeamMetricsParams
}

export type QueryGetScheduledPipelineItemsTeamStatsArgs = {
   params: GetScheduledPipelineItemsTeamStatsParams
}

export type QueryGetScheduledPipelineItemsUserMetricsArgs = {
   params: GetScheduledPipelineItemsUserMetricsParams
}

export type QueryGetSchedulesOnPipelineItemArgs = {
   params: GetSchedulesOnPipelineItemParams
}

export type QueryGetSchedulesOnPipelineItemV2Args = {
   params: GetSchedulesOnPipelineItemV2Params
}

export type QueryGetScorecardChartArgs = {
   params: GetScorecardChartParams
}

export type QueryGetScoringRecalculationExecLogsArgs = {
   params: GetScoringRecalculationExecLogsParams
}

export type QueryGetScrutinyKeyLogsArgs = {
   params: GetScrutinyKeyLogsParams
}

export type QueryGetSharableEntitiesArgs = {
   params: GetSharableEntitiesParams
}

export type QueryGetSiteInspectionTaskJobStatusArgs = {
   params: GetSiteInspectionTaskJobStatusParams
}

export type QueryGetSiteInspectionTasksArgs = {
   params: GetSiteInspectionTasksParams
}

export type QueryGetSmartfloAccountPluginServiceAccountsArgs = {
   params: GetSmartfloAccountPluginServiceAccountsParams
}

export type QueryGetSmartfloPluginServiceAccountsArgs = {
   params: GetSmartfloPluginServiceAccountsParams
}

export type QueryGetStageAssigneeTimespentLogInPortalArgs = {
   params: GetStageAssigneeTimespentLogInPortalParams
}

export type QueryGetStageBoardRolesArgs = {
   params: GetStageBoardRolesParams
}

export type QueryGetStageUpdatePermissionsArgs = {
   params: GetStageUpdatePermissionParams
}

export type QueryGetStageWisePipelineItemsStatsArgs = {
   params: StagesWisePipelineItemsStatsParams
}

export type QueryGetStagesArgs = {
   params: GetStagesParams
}

export type QueryGetStagesTransitionsArgs = {
   params: GetStagesTransitionsParams
}

export type QueryGetStagesTransitionsInPortalArgs = {
   params: GetStagesTransitionsInPortalParams
}

export type QueryGetStatsForLeadBucketsArgs = {
   params: GetStatsForLeadBucketsParams
}

export type QueryGetStructuredEntityJsonConfigArgs = {
   params: GetStructuredEntityJsonConfigParams
}

export type QueryGetTableArgs = {
   params: GetTableParams
}

export type QueryGetTableColumnTotalsArgs = {
   params: TableColumnTotalParams
}

export type QueryGetTaskAddAnotherFieldsArgs = {
   params: GetTaskAddAnotherFieldsParams
}

export type QueryGetTaskAddAnotherGofsFieldsArgs = {
   params: GetTaskAddAnotherGoFsFieldsParams
}

export type QueryGetTaskFieldsArgs = {
   params: GetTaskFieldsParams
}

export type QueryGetTaskGeneratedOverallRemarksFromFieldRemarksArgs = {
   params: GetTaskGeneratedOverallRemarksParams
}

export type QueryGetTaskShortfallTaskTemplatesArgs = {
   params: GetTaskShortfallTaskTemplatesParams
}

export type QueryGetTaskTemplatesArgs = {
   params: TaskTemplatesParams
}

export type QueryGetTaskTemplatesIdentificationsArgs = {
   params: GetTaskTemplatesIdentificationsParams
}

export type QueryGetTasksArgs = {
   params: GetTasksParams
}

export type QueryGetTasksWithFiltersArgs = {
   params: GetTasksWithFiltersParams
}

export type QueryGetTdrAccountArgs = {
   params: GetTdrAccount
}

export type QueryGetTdrAccountAddAnotherFieldsArgs = {
   params: GetTdrAccountAddAnotherFieldsParams
}

export type QueryGetTdrAccountAddAnotherGofsFieldsArgs = {
   params: GetTdrAccountAddAnotherGoFsFieldsParams
}

export type QueryGetTdrAccountByAccountNoArgs = {
   params: GetTdrAccountByAccountNoParams
}

export type QueryGetTdrAccountRequestsForUserArgs = {
   params: GetTdrAccountRequestsForUserParams
}

export type QueryGetTdrAccountsForHolderUserArgs = {
   params: GetTdrAccountsForHolderUserParams
}

export type QueryGetTdrAccountsForTdrManagementArgs = {
   params: GetTdrAccountsForTdrManagementParams
}

export type QueryGetTdrManagementLogsArgs = {
   params: GetTdrManagementLogsParams
}

export type QueryGetTdrOrdersInPipelineItemArgs = {
   params: GetTdrOrdersInPipelineItemParams
}

export type QueryGetTdrPaymentsForTdrOrderInPortalArgs = {
   params: GetTdrPaymentsForTdrOrderInPortalParams
}

export type QueryGetTemplateEntityVisibilityRulesArgs = {
   params: GetTemplateEntityVisibilityRulesParams
}

export type QueryGetTemplateEntityVisibilityRulesInPortalArgs = {
   params: GetTemplateEntityVisibilityRulesInPortalParams
}

export type QueryGetTemplateGofVisibilityRulesInPortalArgs = {
   params: GetTemplateGoFVisibilityRulesInPortalParams
}

export type QueryGetTemplatesForPipelinesArgs = {
   params: GetTemplatesForPipelinesParams
}

export type QueryGetTemplatesInPipelineItemTemplateArgs = {
   params: GetTemplatesInPipelineItemTemplateParams
}

export type QueryGetTestTransferBankAmountPreviewArgs = {
   params: GetTestTransferBankAmountPreviewParams
}

export type QueryGetTestTransferBankAmountRequestsArgs = {
   params: GetTestTransferBankAmountRequestParams
}

export type QueryGetTgBPassApplicationIdWithFileNumberArgs = {
   params: GetTGbPassApplicationIdByFileNumberParams
}

export type QueryGetTgBPassApplicationTabDetailsArgs = {
   params: GetTGbPassApplicationTabDetailsParams
}

export type QueryGetTgBPassApplicationTabsArgs = {
   params: GetTGbPassApplicationTabsParams
}

export type QueryGetTgBPassApplicationsArgs = {
   params: GetTGbPassApplicationsParams
}

export type QueryGetThreadsForUserArgs = {
   params: GetThreadsForUserParams
}

export type QueryGetTransactionsForTdrAccountArgs = {
   params: GetTransactionsForTdrAccountParams
}

export type QueryGetTriggerAutomationWorkflowsIdentificationsForActivityTemplatesArgs = {
   params: GetTriggerAutomationWorkflowsIdentificationsForActivityTemplatesParams
}

export type QueryGetUnlinkedFieldsArgs = {
   params: GetUnlinkedFieldsParams
}

export type QueryGetUserCustomPropertiesArgs = {
   params: GetUserCustomPropertiesParams
}

export type QueryGetUserDashboardsArgs = {
   params: GetUserDashboardsParams
}

export type QueryGetUserFormattedCustomPropertiesArgs = {
   params: GetUserFormattedCustomPropertiesParams
}

export type QueryGetUserGoogleCalendarEventsArgs = {
   params: CalendarEventsDateTimeRangeParams
}

export type QueryGetUserGraphArgs = {
   params: GetUserGraphParams
}

export type QueryGetUserGraphsArgs = {
   params: GetUserGraphsParams
}

export type QueryGetUserGroupsForBoardListsArgs = {
   params: GetUserGroupsForBoardListsParams
}

export type QueryGetUserGroupsForBoardsArgs = {
   params: GetUserGroupsForBoardsParams
}

export type QueryGetUserNotificationsArgs = {
   params: GetUserNotificationsParams
}

export type QueryGetUserNotificationsCountArgs = {
   params: GetUserNotificationCountParams
}

export type QueryGetUserPinStatusArgs = {
   params: GetUserPinStatusParams
}

export type QueryGetUserPinStatusForAdminArgs = {
   params: GetUserPinStatusForAdminParams
}

export type QueryGetUserPortalSettingsArgs = {
   params: GetUserPortalSettingsParams
}

export type QueryGetUserViewsInBoardArgs = {
   params: UserViewsInBoardParams
}

export type QueryGetUserViewsInBoardListArgs = {
   params: UserViewsInBoardListParams
}

export type QueryGetUsersArgs = {
   params: GetUsersParams
}

export type QueryGetUsersInAccountArgs = {
   params: GetUsersInAccountParams
}

export type QueryGetViewsArgs = {
   params: GetViewsParams
}

export type QueryGetWatiAccountPluginServiceAccountsArgs = {
   params: GetWatiAccountPluginServiceAccountsParams
}

export type QueryGetWatiPluginServiceAccountsArgs = {
   params: GetWatiPluginServiceAccountsParams
}

export type QueryGetWhatsappAccountMessageTemplatesForAdminArgs = {
   params: GetWhatsAppAccountMessageTemplatesForAdminParams
}

export type QueryGetWhatsappBusinessNumbersArgs = {
   params: GetWhatsAppBusinessNumbersParams
}

export type QueryGetWhatsappBusinessPhoneNumberMessageTemplatesForPipelineItemArgs = {
   params: GetWhatsAppBusinessPhoneNumberMessageTemplatesForPipelineItemParams
}

export type QueryGetWhatsappBusinessPhoneNumbersArgs = {
   params: GetWhatsAppBusinessPhoneNumbersParams
}

export type QueryIsAutomationWorkflowNameExistsArgs = {
   params: IsAutomationWorkflowNameExistsParams
}

export type QueryIsDocumentTemplateNameExistsArgs = {
   params: IsDocumentTemplateNameExistsParams
}

export type QueryOpenSearchPipelineItemsArgs = {
   params: OpenSearchPipelineItemsParams
}

export type QueryResolveApplicationViewArgs = {
   params: ResolveApplicationViewParams
}

export type QuerySearchActivityTemplatesArgs = {
   params: SearchActivityTemplatesParams
}

export type QuerySearchAgentAllocationGroupsArgs = {
   params: SearchAgentAllocationGroupsParams
}

export type QuerySearchAgentsForManagerArgs = {
   params: SearchAgentsForManagerParams
}

export type QuerySearchAllowedFieldsInPortalApplicationArgs = {
   params: SearchAllowedFieldsInPortalApplicationParams
}

export type QuerySearchAndMonitoringApplicationsArgs = {
   params: SearchAndMonitoringApplicationsParams
}

export type QuerySearchApplicationAssigneesArgs = {
   params: SearchApplicationAssigneesParams
}

export type QuerySearchApplicationsArgs = {
   params: SearchApplicationsParams
}

export type QuerySearchApplicationsForAlterationArgs = {
   params: SearchApplicationsForAlterationParams
}

export type QuerySearchApplicationsInPortalArgs = {
   params: SearchApplicationsInPortalParams
}

export type QuerySearchAssigneesArgs = {
   params: SearchAssigneesParams
}

export type QuerySearchAutomationWorkflowsArgs = {
   params: SearchAutomationWorkflowsParams
}

export type QuerySearchContactAssigneesArgs = {
   params: SearchContactAssigneesParams
}

export type QuerySearchCustomPaymentRulesArgs = {
   params: SearchCustomPaymentRulesParams
}

export type QuerySearchDealAssigneesArgs = {
   params: SearchDealAssigneesParams
}

export type QuerySearchDealsArgs = {
   params: SearchDealsParams
}

export type QuerySearchDocumentVerificationUsersArgs = {
   params: SearchDocumentVerificationUsersParams
}

export type QuerySearchEntityFeeRuleSetCustomHeadersArgs = {
   params: SearchEntityFeeRuleSetCustomHeadersParams
}

export type QuerySearchFeePaymentOrderCreationConfigsArgs = {
   params: SearchFeePaymentOrderCreationConfigsParams
}

export type QuerySearchFieldsArgs = {
   params: SearchFieldsParams
}

export type QuerySearchFriendsArgs = {
   params: SearchFriendsParams
}

export type QuerySearchGraphFieldsArgs = {
   params: SearchGraphFieldsParams
}

export type QuerySearchIdentificationFieldsArgs = {
   params: SearchIdentificationFieldsParams
}

export type QuerySearchIdentificationsArgs = {
   params: SearchIdentificationsParams
}

export type QuerySearchLeadAssigneesArgs = {
   params: SearchLeadAssigneesParams
}

export type QuerySearchLeadCreationAllowedStagesArgs = {
   params: SearchLeadCreationAllowedStagesParams
}

export type QuerySearchLeadsArgs = {
   params: SearchLeadsParams
}

export type QuerySearchManagersForAgentsArgs = {
   params: SearchManagerForAgentsParams
}

export type QuerySearchOfficerManagementUsersArgs = {
   params: SearchOfficerManagementUsersParams
}

export type QuerySearchPaymentRuleSetsArgs = {
   params: SearchPaymentRuleSetsParams
}

export type QuerySearchPipelineCustomObjectAssigneesArgs = {
   params: SearchPipelineCustomObjectAssigneesParams
}

export type QuerySearchPipelineItemFieldsArgs = {
   params: SearchPipelineItemFieldsParams
}

export type QuerySearchPipelineItemTemplateFieldsToLogArgs = {
   params: SearchPipelineItemTemplateFieldsToLogParams
}

export type QuerySearchPipelineItemTemplateLinkedFieldsArgs = {
   params: SearchPipelineItemTemplateLinkedFieldsParams
}

export type QuerySearchPipelineItemsArgs = {
   params: SearchPipelineItemsParams
}

export type QuerySearchPortalUserApplicationsArgs = {
   params: SearchPortalUserApplicationsParams
}

export type QuerySearchRelationFieldsForMappingArgs = {
   params: SearchRelationFieldsForMappingParams
}

export type QuerySearchRolesInPipelineArgs = {
   params: SearchRolesInPipelineParams
}

export type QuerySearchScoringParameterFieldsArgs = {
   params: SearchScoringParameterFieldsParams
}

export type QuerySearchStagesArgs = {
   params: SearchStagesParams
}

export type QuerySearchTaskAssigneesArgs = {
   params: SearchTaskAssigneesParams
}

export type QuerySearchTaskTemplatesArgs = {
   params: SearchTaskTemplatesParams
}

export type QuerySearchUserGroupsArgs = {
   params: SearchUserGroupsParams
}

export type QuerySearchUsernamesArgs = {
   params: SearchUsernamesParams
}

export type QuerySearchUsersArgs = {
   params: SearchUsersParams
}

export type QueryResponseNotFound = GraphQlBaseError & {
   __typename?: 'QueryResponseNotFound'
   message?: Maybe<Scalars['String']>
   queryResponseId: Scalars['String']
}

export type RadioGroupField = BaseField & {
   __typename?: 'RadioGroupField'
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type Range = {
   fromValue: Scalars['String']
   toValue: Scalars['String']
}

export type RangeCannotBeConfiguredForUniqueFields = GraphQlBaseError & {
   __typename?: 'RangeCannotBeConfiguredForUniqueFields'
   message?: Maybe<Scalars['String']>
}

export type RangeCannotBeConfiguredForUniqueLinkedFields = GraphQlBaseError & {
   __typename?: 'RangeCannotBeConfiguredForUniqueLinkedFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type RangeResponse = {
   __typename?: 'RangeResponse'
   fromValue: Scalars['String']
   toValue: Scalars['String']
}

export type RazorPayNotConfigured = GraphQlBaseError & {
   __typename?: 'RazorPayNotConfigured'
   message?: Maybe<Scalars['String']>
}

export type RazorPayOrderCreationFailed = GraphQlBaseError & {
   __typename?: 'RazorPayOrderCreationFailed'
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
}

export type RazorpayOrder = {
   __typename?: 'RazorpayOrder'
   amount: Scalars['Float']
   razorpayOrderId: Scalars['String']
   status: RazorpayOrderPaymentStatus
}

export enum RazorpayOrderPaymentStatus {
   Cancelled = 'CANCELLED',
   Paid = 'PAID',
   YetToPay = 'YET_TO_PAY'
}

export type RazorpayPaymentNotApplicableForTdrSelectedContributedEntities = GraphQlBaseError & {
   __typename?: 'RazorpayPaymentNotApplicableForTDRSelectedContributedEntities'
   contributedEntityIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ReOrderBoardListsParams = {
   afterListId?: InputMaybe<Scalars['String']>
   listId: Scalars['String']
}

export type ReOrderBoardListsResponse =
   | AfterBoardListNotFound
   | AfterBoardListNotInSameParent
   | BoardListNotFound
   | BoardListReadAccessDenied
   | ReorderBoardListsResult
   | UserIsNotAnAdministrator

export type ReOrderBoardsParams = {
   afterBoardId?: InputMaybe<Scalars['String']>
   boardId: Scalars['String']
}

export type ReOrderBoardsResponse =
   | AfterBoardIdNotFoundInSamePipeline
   | AfterBoardNotFound
   | BoardNotFound
   | BoardReadAccessDenied
   | ReOrderBoardsResult
   | YouAreNotAllowedToEditSystemBoards

export type ReOrderBoardsResult = {
   __typename?: 'ReOrderBoardsResult'
   afterBoardId?: Maybe<Scalars['String']>
   boardId: Scalars['String']
}

export type ReadRolesNotFound = GraphQlBaseError & {
   __typename?: 'ReadRolesNotFound'
   message?: Maybe<Scalars['String']>
   roleIds: Array<Scalars['String']>
}

export type ReapproveLineDepartmentRecommendationParams = {
   remarks: Scalars['String']
   requestId: Scalars['String']
}

export type ReapproveLineDepartmentRecommendationResponse =
   | LayoutTabNotFound
   | LineDepartmentActionNotPermittedForUser
   | LineDepartmentRequestMustBeRecommended
   | LineDepartmentRequestNotFoundError
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | ReapproveLineDepartmentRecommendationResult
   | TabNotInPipelineItemTemplate
   | VerificationNotFound

export type ReapproveLineDepartmentRecommendationResult = {
   __typename?: 'ReapproveLineDepartmentRecommendationResult'
   remarks?: Maybe<Scalars['String']>
   requestId: Scalars['String']
   verificationStage?: Maybe<Stage>
   verificationStageId: Scalars['String']
}

export type RecalculateEntityFeeRuleSetParams = {
   entityFeeRuleSetId: Scalars['String']
   mandatoryFields: Array<FieldResponseParams>
}

export type RecalculateEntityFeeRuleSetResponse =
   | AddAnotherFieldsAreNotSupported
   | DecimalPrecisionExceeded
   | DuplicateFieldIds
   | DuplicateGeoPoints
   | EntityFeeRuleSetAccessDenied
   | EntityFeeRuleSetNotFound
   | EntityFeeRuleSetOrdersCreated
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MandatoryFieldsResponseNotFilled
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotSalesTemplateFieldIds
   | ParentFieldNotFilled
   | RecalculateEntityFeeRuleSetResult
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UniqueFieldResponseAlreadyExists

export type RecalculateEntityFeeRuleSetResult = {
   __typename?: 'RecalculateEntityFeeRuleSetResult'
   changedFields: Array<FieldResponse>
   entityFeeRuleSet: EntityFeeRuleSet
}

export type RecalculateScoreParams = {
   recalculationConfigId: Scalars['String']
}

export type RecalculateScoreResponse =
   | RecalculateScoreResult
   | ScoringConfigIsNotActive
   | ScoringRecalculationConfigAtLeastHaveOneFilterCondition
   | ScoringRecalculationConfigAtLeastHaveOneSortByField
   | ScoringRecalculationConfigIsInRunningState
   | ScoringRecalculationConfigNotFound
   | UserIsNotAnAdministrator

export type RecalculateScoreResult = {
   __typename?: 'RecalculateScoreResult'
   recalculationConfigId: Scalars['String']
}

export type ReceiptCannotBeGeneratedForUnpaidPayment = GraphQlBaseError & {
   __typename?: 'ReceiptCannotBeGeneratedForUnpaidPayment'
   message?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
}

export enum ReconciliationApplicationType {
   Live = 'LIVE',
   Test = 'TEST'
}

export type ReconciliationCsvData = {
   __typename?: 'ReconciliationCsvData'
   failedApplicationsCsv?: Maybe<Scalars['String']>
   feeHeadAmountsCsv?: Maybe<Scalars['String']>
   feeHeadTransactionsCsv?: Maybe<Scalars['String']>
   uploadedCsvData?: Maybe<Scalars['String']>
}

export type ReconciliationInitiationInfo = {
   __typename?: 'ReconciliationInitiationInfo'
   failedCount?: Maybe<Scalars['Int']>
   initiatedCount?: Maybe<Scalars['Int']>
   queueCount?: Maybe<Scalars['Int']>
   totalApplicationsCount?: Maybe<Scalars['Int']>
}

export type ReconciliationRequest = {
   __typename?: 'ReconciliationRequest'
   applicationType: ReconciliationApplicationType
   createdAt: Scalars['String']
   csvFiles?: Maybe<ReconciliationCsvData>
   file?: Maybe<FileUploaderUrlResponse>
   initiationInfo?: Maybe<ReconciliationInitiationInfo>
   initiationReconciliationVerifiedBy: Array<BaseUser>
   previewGenerationVerifiedBy: Array<BaseUser>
   requestId: Scalars['String']
   requestedBy: BaseUser
   status: ReconciliationRequestStatus
}

export type ReconciliationRequestCsvResult = {
   __typename?: 'ReconciliationRequestCsvResult'
   csvFiles?: Maybe<ReconciliationCsvData>
   requestId: Scalars['String']
}

export type ReconciliationRequestNotApproved = {
   __typename?: 'ReconciliationRequestNotApproved'
   requestId: Scalars['String']
}

export type ReconciliationRequestNotFound = {
   __typename?: 'ReconciliationRequestNotFound'
   requestId: Scalars['String']
}

export enum ReconciliationRequestStatus {
   ApprovedForInitiation = 'APPROVED_FOR_INITIATION',
   Completed = 'COMPLETED',
   Discarded = 'DISCARDED',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   PartiallyFailed = 'PARTIALLY_FAILED',
   PreviewGenerationFailed = 'PREVIEW_GENERATION_FAILED',
   PreviewGenerationInProgress = 'PREVIEW_GENERATION_IN_PROGRESS',
   PreviewGenerationSuccess = 'PREVIEW_GENERATION_SUCCESS',
   Queued = 'QUEUED'
}

export type RecopyRelatedApplicationFieldsParams = {
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
}

export type RecopyRelatedApplicationFieldsResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | PortalNotFound
   | RecopyRelatedApplicationFieldsResult
   | RelatedApplicationCopyLogNotFoundForApplication

export type RecopyRelatedApplicationFieldsResult = {
   __typename?: 'RecopyRelatedApplicationFieldsResult'
   applicationId: Scalars['String']
}

export type RecordCreationConfig = BaseRecordCreationConfig & {
   __typename?: 'RecordCreationConfig'
   autoAssignCreatorToFields: Array<Field>
   creationAllowedStages: Array<Stage>
   dependentFields: Array<Field>
   fields: Array<Field>
   name: Scalars['String']
   pipelinesAllowedStages: Array<PipelineRecordCreationConfigAllowedStages>
   recordCreationConfigId: Scalars['Int']
   salesTemplateId: Scalars['String']
   salesTemplateType: RecordCreationSupportedSalesTemplateType
   syncAssigneeGroups: Array<AssigneeGroup>
}

export type RecordCreationConfigAccessDenied = GraphQlBaseError & {
   __typename?: 'RecordCreationConfigAccessDenied'
   message?: Maybe<Scalars['String']>
   recordCreationConfigId: Scalars['Int']
}

export type RecordCreationConfigForAdminResult =
   | AdminRecordCreationConfig
   | RecordCreationConfigNotFound

export type RecordCreationConfigNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'RecordCreationConfigNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type RecordCreationConfigNotFound = GraphQlBaseError & {
   __typename?: 'RecordCreationConfigNotFound'
   message?: Maybe<Scalars['String']>
   recordCreationConfigId: Scalars['Int']
}

export type RecordCreationConfigResult =
   | PartiallyConfiguredRecordCreationConfig
   | RecordCreationConfig
   | RecordCreationConfigAccessDenied
   | RecordCreationConfigNotFound

export enum RecordCreationConfigRuleEnum {
   ApplicationPrimaryDisplayField = 'APPLICATION_PRIMARY_DISPLAY_FIELD',
   AtLeastOneApplicationIdentifierField = 'AT_LEAST_ONE_APPLICATION_IDENTIFIER_FIELD',
   AtLeastOneContactSystemIdentifierField = 'AT_LEAST_ONE_CONTACT_SYSTEM_IDENTIFIER_FIELD',
   AtLeastOneCreationAllowedStage = 'AT_LEAST_ONE_CREATION_ALLOWED_STAGE',
   AtLeastOneCustomObjIdentifierField = 'AT_LEAST_ONE_CUSTOM_OBJ_IDENTIFIER_FIELD',
   CustomObjPrimaryDisplayField = 'CUSTOM_OBJ_PRIMARY_DISPLAY_FIELD'
}

export enum RecordCreationConfigStatus {
   Configured = 'CONFIGURED',
   PartiallyConfigured = 'PARTIALLY_CONFIGURED'
}

export enum RecordCreationSupportedSalesTemplateType {
   PipelineItem = 'PIPELINE_ITEM'
}

export type RecordGoFCompletionPercentage = {
   __typename?: 'RecordGoFCompletionPercentage'
   gofId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   percentage: Scalars['Int']
   totalFieldsCount: Scalars['Int']
   totalValidFieldResponsesCount: Scalars['Int']
}

export type RecordReviewCheckpoint = {
   __typename?: 'RecordReviewCheckpoint'
   contextFieldId?: Maybe<Scalars['String']>
   questionFieldId: Scalars['String']
}

export type RecordReviewTab = BaseTab & {
   __typename?: 'RecordReviewTab'
   checkpoints: Array<RecordReviewCheckpoint>
   decisionFieldId?: Maybe<Scalars['String']>
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   remarksFieldId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type RecordStageMustNotApplicationDisplayStage = GraphQlBaseError & {
   __typename?: 'RecordStageMustNotApplicationDisplayStage'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export enum RecordType {
   Application = 'APPLICATION',
   CustomObject = 'CUSTOM_OBJECT',
   Deal = 'DEAL',
   Lead = 'LEAD'
}

export type RecordsLimitExceeded = GraphQlBaseError & {
   __typename?: 'RecordsLimitExceeded'
   limit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type RecursiveParentFieldOptions = GraphQlBaseError & {
   __typename?: 'RecursiveParentFieldOptions'
   message?: Maybe<Scalars['String']>
   options: Array<Scalars['String']>
}

export type ReferenceAssigneeConfigFieldShouldBeAssigneeField = GraphQlBaseError & {
   __typename?: 'ReferenceAssigneeConfigFieldShouldBeAssigneeField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ReferenceExistsInUserProperties = GraphQlBaseError & {
   __typename?: 'ReferenceExistsInUserProperties'
   emails: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ReferenceIdAlreadyExistsInLinkedFieldsTemplates = GraphQlBaseError & {
   __typename?: 'ReferenceIdAlreadyExistsInLinkedFieldsTemplates'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type ReferenceIdAlreadyExistsInTemplate = GraphQlBaseError & {
   __typename?: 'ReferenceIdAlreadyExistsInTemplate'
   message?: Maybe<Scalars['String']>
}

export type RefundBudgetHeadBreakdown = {
   __typename?: 'RefundBudgetHeadBreakdown'
   budgetHeadId: Scalars['String']
   budgetHeadName: Scalars['String']
   failureReason?: Maybe<Scalars['String']>
   paidAmount: Scalars['Float']
   refundAmount: Scalars['Float']
   refundStatus: ApplicationFeeHeadRefundStatus
   statusUpdatedDatetime: Scalars['String']
}

export type RefundDetails = {
   __typename?: 'RefundDetails'
   refundStatus: OrderRefundStatus
   refundedAmount: Scalars['Float']
}

export type RefundDetailsType = {
   __typename?: 'RefundDetailsType'
   acquirerReference?: Maybe<Scalars['String']>
   createdAt?: Maybe<Scalars['String']>
   failedReason?: Maybe<Scalars['String']>
   processedAt?: Maybe<Scalars['String']>
   refundArn?: Maybe<Scalars['String']>
   refundCurrency?: Maybe<Scalars['String']>
   refundId: Scalars['String']
   refundInitiatedBy?: Maybe<Scalars['String']>
   refundInitiatedDatetime?: Maybe<Scalars['String']>
   refundNotes?: Maybe<Scalars['String']>
   refundReason?: Maybe<Scalars['String']>
   refundReferenceNumber?: Maybe<Scalars['String']>
   refundStatus?: Maybe<RefundStatus>
   refundTimeline: Array<TimelineEventType>
   refundedAmount?: Maybe<Scalars['Float']>
   speedProcessed?: Maybe<Scalars['String']>
   speedRequested?: Maybe<Scalars['String']>
}

export type RefundInitiatedLog = {
   __typename?: 'RefundInitiatedLog'
   eventTime: Scalars['String']
   logId: Scalars['String']
}

export type RefundIsInProgress = GraphQlBaseError & {
   __typename?: 'RefundIsInProgress'
   message?: Maybe<Scalars['String']>
   refundId: Scalars['String']
}

export type RefundNotApplicable = GraphQlBaseError & {
   __typename?: 'RefundNotApplicable'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
   reason: Scalars['String']
}

export enum RefundRequestedType {
   Instant = 'INSTANT',
   Normal = 'NORMAL'
}

export enum RefundStatus {
   Failed = 'FAILED',
   Initiated = 'INITIATED',
   Pending = 'PENDING',
   Processed = 'PROCESSED'
}

export type RegenerateConditionsLettersDummyMutationParams = {
   response: Scalars['String']
}

export type RegenerateConditionsLettersDummyMutationResult = {
   __typename?: 'RegenerateConditionsLettersDummyMutationResult'
   pipelineItemId: Scalars['String']
}

export type RegeneratePipelineItemDocumentParams = {
   documentId: Scalars['String']
   documentVersionState?: InputMaybe<DocumentVersionState>
   taskTemplateId?: InputMaybe<Scalars['String']>
   variables: Array<DocumentVariableParams>
}

export type RegeneratePipelineItemDocumentResponse =
   | DocumentAccessDenied
   | DocumentNotFound
   | DocumentTemplateIsDeleted
   | RegeneratePipelineItemDocumentResult
   | TaskTemplateNotFound

export type RegeneratePipelineItemDocumentResult = {
   __typename?: 'RegeneratePipelineItemDocumentResult'
   document: Document
}

export type RegenerateTdrCertificateParams = {
   certificateName: Scalars['String']
   tdrAccountId: Scalars['String']
}

export type RegenerateTdrCertificateResponse =
   | NotTdrAccountHolderUser
   | RegenerateTdrCertificateResult
   | TdrAccountNotFound
   | TdrCertificateDoesNotExist

export type RegenerateTdrCertificateResult = {
   __typename?: 'RegenerateTDRCertificateResult'
   certificate: TdrCertificate
}

export type RegexValidationFailedForDefaultValue = GraphQlBaseError & {
   __typename?: 'RegexValidationFailedForDefaultValue'
   message?: Maybe<Scalars['String']>
}

export type RegexValidationFailedForLinkedFieldsDefaultValue = GraphQlBaseError & {
   __typename?: 'RegexValidationFailedForLinkedFieldsDefaultValue'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type RegexValidationRuleActionConfig = {
   __typename?: 'RegexValidationRuleActionConfig'
   errorMessage: Scalars['String']
   expression: Scalars['String']
}

export type ReinitiateFailedApplicationRefundResponse =
   | ApplicationAccessDenied
   | ApplicationNotFound
   | ApplicationRefundDetails
   | ApplicationRefundNotFound
   | NoFailedRefundsFound
   | RefundIsInProgress

export type ReinitiateFailedRefundParams = {
   applicationId: Scalars['String']
}

export type RejectLineDepartmentRecommendationParams = {
   remarks: Scalars['String']
   requestId: Scalars['String']
}

export type RejectLineDepartmentRecommendationResponse =
   | LayoutTabNotFound
   | LineDepartmentActionNotPermittedForUser
   | LineDepartmentRemarksRequired
   | LineDepartmentRequestMustBeRecommended
   | LineDepartmentRequestNotFoundError
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | RejectLineDepartmentRecommendationResult
   | TabNotInPipelineItemTemplate
   | VerificationNotFound

export type RejectLineDepartmentRecommendationResult = {
   __typename?: 'RejectLineDepartmentRecommendationResult'
   remarks: Scalars['String']
   requestId: Scalars['String']
}

export enum RelatedApplicationCopyFieldsLogStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   Initiated = 'INITIATED',
   InProgress = 'IN_PROGRESS'
}

export type RelatedApplicationCopyLogNotFoundForApplication = GraphQlBaseError & {
   __typename?: 'RelatedApplicationCopyLogNotFoundForApplication'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type RelatedEntitiesAreDeleted = GraphQlBaseError & {
   __typename?: 'RelatedEntitiesAreDeleted'
   message?: Maybe<Scalars['String']>
   relatedEntityIds: Array<Scalars['String']>
}

export type RelatedEntitiesMaxCountExceeded = GraphQlBaseError & {
   __typename?: 'RelatedEntitiesMaxCountExceeded'
   entityIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
}

export type RelatedEntitiesNotBelongsToRelation = GraphQlBaseError & {
   __typename?: 'RelatedEntitiesNotBelongsToRelation'
   message?: Maybe<Scalars['String']>
   relatedEntityIds: Array<Scalars['String']>
   relationId: Scalars['String']
}

export type RelatedEntitiesNotFound = GraphQlBaseError & {
   __typename?: 'RelatedEntitiesNotFound'
   message?: Maybe<Scalars['String']>
   relatedEntityIds: Array<Scalars['String']>
}

export type RelatedEntityAlreadyExistInOneToOneRelation = GraphQlBaseError & {
   __typename?: 'RelatedEntityAlreadyExistInOneToOneRelation'
   message?: Maybe<Scalars['String']>
}

export type RelatedEntityFieldHasEmptyResponse = GraphQlBaseError & {
   __typename?: 'RelatedEntityFieldHasEmptyResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   relatedEntityId: Scalars['String']
}

export type RelatedEntityFieldResponses = {
   __typename?: 'RelatedEntityFieldResponses'
   fieldResponses: Array<FieldResponseResult>
   relatedEntityId: Scalars['String']
}

export type RelatedEntityFieldResponsesFieldResponsesArgs = {
   fieldIds: Array<Scalars['String']>
}

export type RelatedEntityFieldResponsesResponse =
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | RelatedEntitiesAreDeleted
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntitiesNotFound
   | RelatedEntityFieldResponsesResult
   | RelationIsDeleted
   | RelationNotFound

export type RelatedEntityFieldResponsesResult = {
   __typename?: 'RelatedEntityFieldResponsesResult'
   relatedEntities: Array<RelatedEntityFieldResponses>
}

export type RelatedEntityIsDeleted = GraphQlBaseError & {
   __typename?: 'RelatedEntityIsDeleted'
   message?: Maybe<Scalars['String']>
   relatedEntityId: Scalars['String']
}

export type RelatedEntityNotFound = GraphQlBaseError & {
   __typename?: 'RelatedEntityNotFound'
   message?: Maybe<Scalars['String']>
   relatedEntityId: Scalars['String']
}

export type RelatedEntityParentFieldHasEmptyResponse = GraphQlBaseError & {
   __typename?: 'RelatedEntityParentFieldHasEmptyResponse'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   relatedEntityId: Scalars['String']
}

export type RelatedEntityRemarksAttachmentIdNotFound = GraphQlBaseError & {
   __typename?: 'RelatedEntityRemarksAttachmentIdNotFound'
   message?: Maybe<Scalars['String']>
   relatedEntityRemarksAttachmentId: Scalars['String']
}

export type RelatedObject = {
   __typename?: 'RelatedObject'
   displayName?: Maybe<Scalars['String']>
   hasPermission: Scalars['Boolean']
   overviewFieldResponses: Array<FieldResponse>
   pipelineId?: Maybe<Scalars['String']>
   pipelineItemType?: Maybe<PipelineItemType>
   pipelines: Array<RelatedObjectPipeline>
   relatedEntityId: Scalars['String']
   salesTemplateId: Scalars['String']
}

export type RelatedObjectPipeline = {
   __typename?: 'RelatedObjectPipeline'
   hasPermission: Scalars['Boolean']
   pipeline: BasePipeline
}

export type RelatedObjectUpdateRemarks = {
   __typename?: 'RelatedObjectUpdateRemarks'
   failureReason?: Maybe<Scalars['String']>
   relatedObjName?: Maybe<Scalars['String']>
   relatedObjectId: Scalars['String']
   status: RelatedObjectUpdateStatus
}

export enum RelatedObjectUpdateStatus {
   Done = 'DONE',
   Failed = 'FAILED'
}

export type RelatedObjectionAndTaskGoFResponseId = {
   __typename?: 'RelatedObjectionAndTaskGoFResponseId'
   objectionGofResponseId: Scalars['String']
   taskGofResponseId: Scalars['String']
}

export type RelatedObjectionOverallData = {
   __typename?: 'RelatedObjectionOverallData'
   objectionAndTaskGofResponses: Array<RelatedObjectionAndTaskGoFResponseId>
   objections: Array<RelatedObject>
   objectionsOverallRecommendation: Array<RelatedObjectionOverallRecommendation>
   objectionsOverallRemarks: Array<RelatedObjectionOverallRemarks>
}

export type RelatedObjectionOverallRecommendation = {
   __typename?: 'RelatedObjectionOverallRecommendation'
   recommendation?: Maybe<BpsVerificationRecommendationEnum>
   relatedEntityId: Scalars['String']
}

export type RelatedObjectionOverallRemarks = {
   __typename?: 'RelatedObjectionOverallRemarks'
   relatedEntityId: Scalars['String']
   remarks?: Maybe<Scalars['String']>
}

export type RelatedObjectsCountInPortal = {
   __typename?: 'RelatedObjectsCountInPortal'
   relationId: Scalars['String']
   relationTarget?: Maybe<SelfRelationTarget>
   totalCount: Scalars['Int']
}

export type RelatedObjectsResult = {
   __typename?: 'RelatedObjectsResult'
   relatedObjects: Array<RelatedObject>
   totalCount: Scalars['Int']
}

export type RelatedPipelineItemTemplateNotLinkedToPipelineIds = GraphQlBaseError & {
   __typename?: 'RelatedPipelineItemTemplateNotLinkedToPipelineIds'
   message?: Maybe<Scalars['String']>
   pipelineIds: Array<Scalars['String']>
   relatedPipelineItemTemplateId: Scalars['String']
}

export type RelatedRecordCreationSalesTemplateNotBelongsToRelation = GraphQlBaseError & {
   __typename?: 'RelatedRecordCreationSalesTemplateNotBelongsToRelation'
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
   salesTemplateId: Scalars['String']
}

export type RelatedSalesTemplate = {
   __typename?: 'RelatedSalesTemplate'
   addIdentifications: Array<Identification>
   canAdd: Scalars['Boolean']
   canRemove: Scalars['Boolean']
   displayName: Scalars['String']
   overviewFieldIds: Array<Scalars['String']>
   overviewFields: Array<Field>
   pipelineItemType?: Maybe<PipelineItemType>
   removeIdentifications: Array<Identification>
   salesTemplateId: Scalars['String']
   salesTemplateName: Scalars['String']
   salesTemplateType: SupportedSalesTemplateTypesForRelation
}

export type RelatedSalesTemplateOverviewDetails = {
   __typename?: 'RelatedSalesTemplateOverviewDetails'
   displayName: Scalars['String']
   pipelineItemType?: Maybe<PipelineItemType>
   salesTemplateId: Scalars['String']
   salesTemplateName: Scalars['String']
   salesTemplateType: SupportedSalesTemplateTypesForRelation
}

export type Relation = {
   __typename?: 'Relation'
   cardinality: Cardinality
   fromSalesTemplateConfig: RelatedSalesTemplate
   identifications: Array<Identification>
   name: Scalars['String']
   relationId: Scalars['String']
   toSalesTemplateConfig: RelatedSalesTemplate
}

export type RelationAndIdentificationsAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'RelationAndIdentificationsAreNotInSameAccount'
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type RelationAreDeleted = GraphQlBaseError & {
   __typename?: 'RelationAreDeleted'
   message?: Maybe<Scalars['String']>
   relationIds: Array<Scalars['String']>
}

export type RelationDirectionIsRequiredForSelfRelations = GraphQlBaseError & {
   __typename?: 'RelationDirectionIsRequiredForSelfRelations'
   message?: Maybe<Scalars['String']>
   relationIds: Array<Scalars['String']>
}

export type RelationField = BaseField & {
   __typename?: 'RelationField'
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   relation: RelationOverviewDetails
   salesTemplateId: Scalars['String']
   secondDegreeRelation?: Maybe<RelationOverviewDetails>
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
   valueType: RelationFieldValueType
}

export type RelationFieldMappingExecResult = {
   __typename?: 'RelationFieldMappingExecResult'
   fieldId: Scalars['String']
   relatedEntities: Array<LinkedRelatedObjectDetails>
   relationId: Scalars['String']
}

export type RelationFieldNotSupportedInCrmEntityTemplate = GraphQlBaseError & {
   __typename?: 'RelationFieldNotSupportedInCrmEntityTemplate'
   crmTemplateId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type RelationFieldNotSupportedInGoFCrmTemplate = GraphQlBaseError & {
   __typename?: 'RelationFieldNotSupportedInGoFCrmTemplate'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type RelationFieldResponse = {
   __typename?: 'RelationFieldResponse'
   pipelineItems: Array<PipelineItemBaseDetails>
}

export type RelationFieldValueMapping = {
   __typename?: 'RelationFieldValueMapping'
   fieldValueMapping: AutomationWorkflowFieldValueMapping
   relation: Relation
}

export type RelationFieldValueMappingParams = {
   fieldValueMapping: AutomationWorkflowFieldValueMappingParams
   relationId: Scalars['String']
}

export enum RelationFieldValueType {
   Multi = 'MULTI',
   Single = 'SINGLE'
}

export type RelationIdFieldIdMapping = {
   __typename?: 'RelationIdFieldIdMapping'
   fieldId: Scalars['String']
   relationId: Scalars['String']
}

export type RelationIsDeleted = GraphQlBaseError & {
   __typename?: 'RelationIsDeleted'
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
}

export type RelationIsRequiredForRelatedObjectsAutomationWorkflowsFilterSet = GraphQlBaseError & {
   __typename?: 'RelationIsRequiredForRelatedObjectsAutomationWorkflowsFilterSet'
   message?: Maybe<Scalars['String']>
}

export type RelationNameIsRequired = GraphQlBaseError & {
   __typename?: 'RelationNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type RelationNotFound = GraphQlBaseError & {
   __typename?: 'RelationNotFound'
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
}

export type RelationNotInGoFPipelineItemTemplate = GraphQlBaseError & {
   __typename?: 'RelationNotInGoFPipelineItemTemplate'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
}

export type RelationNotInPipeline = GraphQlBaseError & {
   __typename?: 'RelationNotInPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   relationId: Scalars['String']
}

export type RelationNotSupportedForLayoutEntity = GraphQlBaseError & {
   __typename?: 'RelationNotSupportedForLayoutEntity'
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
}

export type RelationOverviewDetails = {
   __typename?: 'RelationOverviewDetails'
   cardinality: Cardinality
   fromSalesTemplateConfig: RelatedSalesTemplateOverviewDetails
   name: Scalars['String']
   relationId: Scalars['String']
   toSalesTemplateConfig: RelatedSalesTemplateOverviewDetails
}

export type RelationPipelineAssigneeFieldsNotFound = GraphQlBaseError & {
   __typename?: 'RelationPipelineAssigneeFieldsNotFound'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type RelationTab = BaseTab & {
   __typename?: 'RelationTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   relation?: Maybe<Relation>
   relationId?: Maybe<Scalars['String']>
   relationTarget?: Maybe<SelfRelationTarget>
   tabId: Scalars['String']
   tabType: TabType
}

export type RelationWiseRelatedEntities = {
   __typename?: 'RelationWiseRelatedEntities'
   fromEntities: Array<RelatedObject>
   relation: Relation
   toEntities: Array<RelatedObject>
}

export type Relations = {
   __typename?: 'Relations'
   relations: Array<Relation>
   totalCount: Scalars['Int']
}

export type RelationsAreDeleted = GraphQlBaseError & {
   __typename?: 'RelationsAreDeleted'
   message?: Maybe<Scalars['String']>
   relationIds: Array<Scalars['String']>
}

export type RelationsAreNotFound = GraphQlBaseError & {
   __typename?: 'RelationsAreNotFound'
   message?: Maybe<Scalars['String']>
   relationIds: Array<Scalars['String']>
}

export type RelationsInAutomationWorkflowPipeline = GraphQlBaseError & {
   __typename?: 'RelationsInAutomationWorkflowPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   relationIds: Array<Scalars['String']>
}

export type RelationsNotFound = GraphQlBaseError & {
   __typename?: 'RelationsNotFound'
   message?: Maybe<Scalars['String']>
   relationIds: Array<Scalars['String']>
}

export type RelationsNotInRelatedPipeline = GraphQlBaseError & {
   __typename?: 'RelationsNotInRelatedPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId?: Maybe<Scalars['String']>
   relationIds: Array<Scalars['String']>
}

export enum RelativeFilterArithmeticOperator {
   Add = 'ADD',
   Subtract = 'SUBTRACT'
}

export enum RelativeFromEnum {
   Now = 'NOW',
   ThisMonth = 'THIS_MONTH',
   ThisWeek = 'THIS_WEEK',
   Today = 'TODAY',
   Tomorrow = 'TOMORROW',
   Yesterday = 'YESTERDAY'
}

export type ReleaseTdrAccountParams = {
   accountId: Scalars['String']
   attachments?: InputMaybe<Array<InputMaybe<TdrManagementAttachmentParams>>>
   otp: Scalars['String']
   reason: Scalars['String']
}

export type ReleaseTdrAccountResponse =
   | InvalidOtp
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | ReleaseTdrAccountResult
   | TdrAccountNotFound
   | TdrAccountNotOnHold
   | TdrManagementAccessDenied

export type ReleaseTdrAccountResult = {
   __typename?: 'ReleaseTdrAccountResult'
   accountId: Scalars['String']
}

export type RemarkAttachmentResult =
   | RemarksAttachment
   | RemarksAttachmentAccessDenied
   | RemarksAttachmentNotFound

export type RemarkAttachments = {
   __typename?: 'RemarkAttachments'
   attachments: Array<RemarkAttachmentResult>
}

export type RemarkNotLinkedToPipelineItem = GraphQlBaseError & {
   __typename?: 'RemarkNotLinkedToPipelineItem'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   remarkId: Array<Scalars['String']>
}

export type RemarksAttachment = {
   __typename?: 'RemarksAttachment'
   attachmentId: Scalars['String']
   attachmentType?: Maybe<RemarksAttachmentType>
   mimeType?: Maybe<Scalars['String']>
   name?: Maybe<Scalars['String']>
   preSignedUrl: Scalars['String']
   sizeInBytes?: Maybe<Scalars['Float']>
   url: Scalars['String']
}

export type RemarksAttachmentAccessDenied = GraphQlBaseError & {
   __typename?: 'RemarksAttachmentAccessDenied'
   attachmentId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type RemarksAttachmentIdNotFound = GraphQlBaseError & {
   __typename?: 'RemarksAttachmentIdNotFound'
   message?: Maybe<Scalars['String']>
   remarksAttachmentId: Scalars['String']
}

export type RemarksAttachmentIdsNotFound = GraphQlBaseError & {
   __typename?: 'RemarksAttachmentIdsNotFound'
   attachmentIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type RemarksAttachmentNotFound = GraphQlBaseError & {
   __typename?: 'RemarksAttachmentNotFound'
   attachmentId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type RemarksAttachmentParams = {
   attachmentType?: InputMaybe<RemarksAttachmentType>
   mimeType?: InputMaybe<Scalars['String']>
   name?: InputMaybe<Scalars['String']>
   sizeInBytes?: InputMaybe<Scalars['Float']>
   url: Scalars['String']
}

export enum RemarksAttachmentType {
   VoiceNote = 'VOICE_NOTE'
}

export type RemarksAttachmentsNotLinkedToPipelineItem = GraphQlBaseError & {
   __typename?: 'RemarksAttachmentsNotLinkedToPipelineItem'
   attachmentIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export enum RemarksFieldProperty {
   Attachments = 'ATTACHMENTS',
   Remarks = 'REMARKS'
}

export type RemarksRequiredForAppliedFeeHeader = {
   __typename?: 'RemarksRequiredForAppliedFeeHeader'
   appliedFeeHeaderId: Scalars['String']
}

export type RemarksTab = BaseTab & {
   __typename?: 'RemarksTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export enum RemarksType {
   Default = 'DEFAULT',
   FieldRemarks = 'FIELD_REMARKS',
   Notes = 'NOTES'
}

export type RemindBeforeInMinsCannotBeNegative = GraphQlBaseError & {
   __typename?: 'RemindBeforeInMinsCannotBeNegative'
   message?: Maybe<Scalars['String']>
   remindBeforeInMins: Scalars['Int']
}

export type RemindPendingOrderParams = {
   orderId: Scalars['String']
}

export type RemindPendingOrderResponse =
   | OrderNotFound
   | RemindPendingOrderResult

export type RemindPendingOrderResult = {
   __typename?: 'RemindPendingOrderResult'
   orderId: Scalars['String']
}

export type ReminderAtShouldNotBePreviousDateTime = GraphQlBaseError & {
   __typename?: 'ReminderAtShouldNotBePreviousDateTime'
   message?: Maybe<Scalars['String']>
   reminderAt: Scalars['String']
}

export type RemindersInMinsCannotBeNegative = GraphQlBaseError & {
   __typename?: 'RemindersInMinsCannotBeNegative'
   message?: Maybe<Scalars['String']>
   remindersInMins: Array<Scalars['Int']>
}

export type RemindersLimitExceeded = GraphQlBaseError & {
   __typename?: 'RemindersLimitExceeded'
   message?: Maybe<Scalars['String']>
}

export type RemoveActionTypesFromIdentificationParams = {
   actionTypes: Array<UserPermission>
   identificationId: Scalars['String']
}

export type RemoveActionTypesFromIdentificationResponse =
   | IdentificationAndUserAreNotInSameAccount
   | IdentificationNotFound
   | RemoveActionTypesFromIdentificationResult
   | UserIsNotAnAdministrator

export type RemoveActionTypesFromIdentificationResult = {
   __typename?: 'RemoveActionTypesFromIdentificationResult'
   actionTypes: Array<UserPermission>
   identificationId: Scalars['String']
}

export type RemoveActivityTemplatesFromPipelineParams = {
   activityTemplateIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type RemoveActivityTemplatesFromPipelineResponse =
   | ActivityTemplatesAccessDenied
   | ActivityTemplatesNotFound
   | ActivityTemplatesNotInAccount
   | PipelineNotFound
   | RemoveActivityTemplatesFromPipelineResult
   | UserIsNotAnAdministrator

export type RemoveActivityTemplatesFromPipelineResult = {
   __typename?: 'RemoveActivityTemplatesFromPipelineResult'
   activityTemplateIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type RemoveApplicationFieldAsShortfallParams = {
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
}

export type RemoveApplicationFieldAsShortfallResponse =
   | FieldIsDeleted
   | FieldNotFound
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | RemoveApplicationFieldAsShortfallResult

export type RemoveApplicationFieldAsShortfallResult = {
   __typename?: 'RemoveApplicationFieldAsShortfallResult'
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
}

export type RemoveAsDependentFieldParams = {
   fieldId: Scalars['String']
}

export type RemoveAsDependentFieldResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotDependentField
   | RemoveAsDependentFieldResult
   | UserIsNotAnAdministrator

export type RemoveAsDependentFieldResult = {
   __typename?: 'RemoveAsDependentFieldResult'
   fieldId: Scalars['String']
}

export type RemoveAsIdentificationFieldParams = {
   fieldId: Scalars['String']
}

export type RemoveAsIdentificationFieldResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | IdentificationFieldLinkedToActivityTemplates
   | IdentificationFieldLinkedToForms
   | RemoveAsIdentificationFieldResult
   | UserIsNotAnAdministrator

export type RemoveAsIdentificationFieldResult = {
   __typename?: 'RemoveAsIdentificationFieldResult'
   fieldId: Scalars['String']
}

export type RemoveAsUniqueFieldParams = {
   fieldId: Scalars['String']
}

export type RemoveAsUniqueFieldResponse =
   | CannotEditIsUniqueForIdentifierField
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | RemoveAsUniqueFieldResult
   | UserIsNotAnAdministrator

export type RemoveAsUniqueFieldResult = {
   __typename?: 'RemoveAsUniqueFieldResult'
   fieldId: Scalars['String']
}

export type RemoveAssigneesNode = BaseNode & {
   __typename?: 'RemoveAssigneesNode'
   assigneeFieldIds: Array<Scalars['String']>
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   syncAssigneeHierarchy?: Maybe<Scalars['Boolean']>
}

export type RemoveAssigneesNodeExecLog = BaseNodeExecLog & {
   __typename?: 'RemoveAssigneesNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   removedAssigneeFieldIds: Array<Scalars['String']>
   status: NodeExecLogStatusEnum
}

export type RemoveAttachmentsForRemarksInTaskDraftParams = {
   attachmentIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type RemoveAttachmentsForRemarksInTaskDraftResponse =
   | CanNotUpdateCompletedTask
   | RemarksAttachmentIdsNotFound
   | RemoveAttachmentsForRemarksInTaskDraftResult
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | TaskTemplateAccessDenied

export type RemoveAttachmentsForRemarksInTaskDraftResult = {
   __typename?: 'RemoveAttachmentsForRemarksInTaskDraftResult'
   attachmentIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type RemoveAttachmentsForRemarksParams = {
   attachmentIds: Array<Scalars['String']>
}

export type RemoveAttachmentsForRemarksResponse =
   | CannotDeleteRemarkAttachmentsAddedByOtherUser
   | RemarksAttachmentIdsNotFound
   | RemoveAttachmentsForRemarksResult

export type RemoveAttachmentsForRemarksResult = {
   __typename?: 'RemoveAttachmentsForRemarksResult'
   attachmentIds: Array<Scalars['String']>
}

export type RemoveBoardAccessParams = {
   boardId: Scalars['String']
   sharableEntities: Array<SharableEntityParams>
}

export type RemoveBoardAccessResponse =
   | BoardAndIdentificationsNotInSameAccount
   | BoardEditAccessDenied
   | BoardNotFound
   | IdentificationsNotFound
   | RemoveBoardAccessResult
   | UsersNotFound
   | UsersNotInAccount

export type RemoveBoardAccessResult = {
   __typename?: 'RemoveBoardAccessResult'
   boardId: Scalars['String']
   sharableEntities: Array<SharableEntityResponse>
}

export type RemoveCallLogsFromTaskDraftParams = {
   callLogIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type RemoveCallLogsFromTaskDraftResponse =
   | CanNotUpdateCompletedTask
   | CloudCallingCallLogsNotFound
   | RemoveCallLogsFromTaskDraftResult
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound

export type RemoveCallLogsFromTaskDraftResult = {
   __typename?: 'RemoveCallLogsFromTaskDraftResult'
   callLogIds: Array<Scalars['String']>
   taskId: Scalars['String']
}

export type RemoveDashboardIdentificationsParams = {
   dashboardId: Scalars['String']
   identificationIds: Array<Scalars['String']>
}

export type RemoveDashboardIdentificationsResponse =
   | DashboardAccessDenied
   | DashboardNotFound
   | IdentificationsNotFound
   | RemoveDashboardIdentificationsResult
   | UserAndIdentificationsAreNotInSameAccount

export type RemoveDashboardIdentificationsResult = {
   __typename?: 'RemoveDashboardIdentificationsResult'
   dashboardId: Scalars['String']
   identificationIds: Array<Scalars['String']>
}

export type RemoveFeeHeadLog = {
   __typename?: 'RemoveFeeHeadLog'
   actionDoneBy?: Maybe<BaseUser>
   cascadeCreatedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeRemovedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeUpdatedAppliedFeeHeads: Array<UpdateAppliedFeeHeadLog>
   eventDatetime: Scalars['String']
   logId: Scalars['String']
   removedAppliedFeeHeads: Array<AppliedFeeHeader>
}

export type RemoveFeeHeadersInEntityFeeRuleSetParams = {
   appliedFeeHeaderIds: Array<Scalars['String']>
   entityRuleSetId: Scalars['String']
}

export type RemoveFeeHeadersInEntityFeeRuleSetResponse =
   | CannotRemoveAdjustedAmountAppliedFeeHeaders
   | EntityFeeRuleSetAccessDenied
   | EntityFeeRuleSetNotFound
   | FeeHeadersNotFound
   | RemoveFeeHeadersInEntityFeeRuleSetResult

export type RemoveFeeHeadersInEntityFeeRuleSetResult = {
   __typename?: 'RemoveFeeHeadersInEntityFeeRuleSetResult'
   appliedFeeHeaderIds: Array<Scalars['String']>
   changedFeeAppliedHeaders: Array<AppliedFeeHeader>
   entityRuleSetId: Scalars['String']
   totalAdjustedAmount: Scalars['Float']
   totalCalculatedAmount: Scalars['Float']
   totalNetAmount: Scalars['Float']
}

export type RemoveFieldConditionalOptionsParams = {
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldId: Scalars['String']
   parentFieldOption: Scalars['String']
}

export type RemoveFieldConditionalOptionsResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotConditionalOptionsValueType
   | NotSupportedFieldType
   | RemoveFieldConditionalOptionsResult
   | UserIsNotAnAdministrator

export type RemoveFieldConditionalOptionsResult = {
   __typename?: 'RemoveFieldConditionalOptionsResult'
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldId: Scalars['String']
   parentFieldOption: Scalars['String']
}

export type RemoveFieldRolesParams = {
   fieldId: Scalars['String']
   readRoles: Array<Scalars['String']>
   writeRoles: Array<Scalars['String']>
}

export type RemoveFieldRolesResponse =
   | CannotEditSystemField
   | CannotRemoveSystemFieldDefaultReadRoles
   | CannotRemoveSystemFieldDefaultWriteRoles
   | CannotRemoveTaskFieldDefaultWriteRoles
   | FieldIsDeleted
   | FieldNotFound
   | ReadRolesNotFound
   | RemoveFieldRolesResult
   | UserIsNotAnAdministrator
   | WriteRolesNotFound

export type RemoveFieldRolesResult = {
   __typename?: 'RemoveFieldRolesResult'
   fieldId: Scalars['String']
   readRoles: Array<Scalars['String']>
   writeRoles: Array<Scalars['String']>
}

export type RemoveFromPipelineNode = BaseNode & {
   __typename?: 'RemoveFromPipelineNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   clearProposalFlowLogs?: Maybe<Scalars['Boolean']>
   clearStageLogs?: Maybe<Scalars['Boolean']>
   configStatus: NodeConfigStatus
   discardPendingTasks?: Maybe<Scalars['Boolean']>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
}

export type RemoveFromPipelineNodeExecLog = BaseNodeExecLog & {
   __typename?: 'RemoveFromPipelineNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<Scalars['String']>
   status: NodeExecLogStatusEnum
}

export type RemoveGraphQuickFilterFieldsParams = {
   graphQuickFilterFieldIds: Array<Scalars['String']>
}

export type RemoveGraphQuickFilterFieldsResponse =
   | GraphQuickFilterFieldsNotFound
   | RemoveGraphQuickFilterFieldsResult
   | UserIsNotAnAdministrator

export type RemoveGraphQuickFilterFieldsResult = {
   __typename?: 'RemoveGraphQuickFilterFieldsResult'
   graphQuickFilterFieldIds: Array<Scalars['String']>
}

export type RemoveManagerParams = {
   userId: Scalars['String']
}

export type RemoveManagerResponse =
   | DeactivatedUser
   | RemoveManagerResult
   | UserAndAdminAreNotInSameAccount
   | UserIsNotAnAdministrator
   | UserNotFound

export type RemoveManagerResult = {
   __typename?: 'RemoveManagerResult'
   managerId?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type RemoveOptionsFromCheckboxGroupFieldParams = {
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type RemoveOptionsFromCheckboxGroupFieldResponse =
   | CanNotRemoveDefaultValues
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotCheckboxGroupField
   | OptionsUsedAsDefaultValuesInLinkedFields
   | ReferenceExistsInUserProperties
   | RemoveOptionsFromCheckboxGroupFieldResult
   | UserIsNotAnAdministrator

export type RemoveOptionsFromCheckboxGroupFieldResult = {
   __typename?: 'RemoveOptionsFromCheckboxGroupFieldResult'
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type RemoveOptionsFromDropdownFieldParams = {
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type RemoveOptionsFromDropdownFieldResponse =
   | CanNotRemoveDefaultValue
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotDropdownField
   | OptionsUsedAsDefaultValuesInLinkedFields
   | ReferenceExistsInUserProperties
   | RemoveOptionsFromDropdownFieldResult
   | UserIsNotAnAdministrator

export type RemoveOptionsFromDropdownFieldResult = {
   __typename?: 'RemoveOptionsFromDropdownFieldResult'
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type RemoveOptionsFromFieldsSelectorFieldParams = {
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type RemoveOptionsFromFieldsSelectorFieldResponse =
   | CanNotRemoveDefaultValue
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotFieldsSelectorField
   | OptionsHaveDependentFieldsInLinkedFields
   | OptionsShouldNotHaveDependentFields
   | OptionsUsedAsDefaultValuesInLinkedFields
   | RemoveOptionsFromFieldsSelectorFieldResult
   | UserIsNotAnAdministrator

export type RemoveOptionsFromFieldsSelectorFieldResult = {
   __typename?: 'RemoveOptionsFromFieldsSelectorFieldResult'
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
   unlinkedDependentFieldIds: Array<Scalars['String']>
}

export type RemoveOptionsFromMultiSelectFieldParams = {
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type RemoveOptionsFromMultiSelectFieldResponse =
   | CanNotRemoveDefaultValues
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotMultiSelectField
   | OptionsUsedAsDefaultValuesInLinkedFields
   | ReferenceExistsInUserProperties
   | RemoveOptionsFromMultiSelectFieldResult
   | UserIsNotAnAdministrator

export type RemoveOptionsFromMultiSelectFieldResult = {
   __typename?: 'RemoveOptionsFromMultiSelectFieldResult'
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type RemoveOptionsFromRadioGroupFieldParams = {
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type RemoveOptionsFromRadioGroupFieldResponse =
   | CanNotRemoveDefaultValue
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotRadioGroupField
   | OptionsUsedAsDefaultValuesInLinkedFields
   | ReferenceExistsInUserProperties
   | RemoveOptionsFromRadioGroupFieldResult
   | UserIsNotAnAdministrator

export type RemoveOptionsFromRadioGroupFieldResult = {
   __typename?: 'RemoveOptionsFromRadioGroupFieldResult'
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
}

export type RemovePipelineIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type RemovePipelineIdentificationsResponse =
   | IdentificationsNotFound
   | IdentificationsPipelineActionsExists
   | IdentificationsToTriggerAutomationWorkflowsOnActivityExists
   | PipelineAndAdminAreNotInSameAccount
   | PipelineAndIdentificationsAreNotInSameAccount
   | PipelineNotFound
   | RemovePipelineIdentificationsResult
   | UserIsNotAnAdministrator

export type RemovePipelineIdentificationsResult = {
   __typename?: 'RemovePipelineIdentificationsResult'
   identificationIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type RemovePipelineItemScheduleFromCalendarParams = {
   pipelineItemScheduledId: Scalars['String']
}

export type RemovePipelineItemScheduleFromCalendarResponse =
   | CalendarEventDoesNotExistForSchedule
   | GoogleAuthConsentNotGiven
   | GoogleAuthConsentRefreshRequired
   | GoogleCalendarApiRequestsQuotaExceeded
   | PipelineItemScheduleAccessDenied
   | PipelineItemScheduleNotFound
   | ScheduledPipelineItem

export type RemovePipelineItemTemplatesAdminPermissionForUserParams = {
   pipelineItemTemplateIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type RemovePipelineItemTemplatesAdminPermissionForUserResponse =
   | DeactivatedUserId
   | PipelineItemTemplatesNotFound
   | RemovePipelineItemTemplatesAdminPermissionForUserResult
   | UserIsNotAnAdministrator
   | UserNotFound

export type RemovePipelineItemTemplatesAdminPermissionForUserResult = {
   __typename?: 'RemovePipelineItemTemplatesAdminPermissionForUserResult'
   pipelineItemTemplateIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type RemovePipelinesAdminPermissionForUserParams = {
   pipelineIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type RemovePipelinesAdminPermissionForUserResponse =
   | PipelinesNotFound
   | RemovePipelinesAdminPermissionForUserResult
   | UserIsNotAnAdministrator
   | UserNotFound

export type RemovePipelinesAdminPermissionForUserResult = {
   __typename?: 'RemovePipelinesAdminPermissionForUserResult'
   pipelineIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type RemoveRelatedEntitiesParams = {
   currentEntityId: Scalars['String']
   relatedEntityIds: Array<Scalars['String']>
   relationId: Scalars['String']
}

export type RemoveRelatedEntitiesResponse =
   | CurrentEntityIsDeleted
   | CurrentEntityNotFound
   | NotPermittedRelation
   | RelatedEntitiesAreDeleted
   | RelatedEntitiesNotFound
   | RelationNotFound
   | RemoveRelatedEntitiesResult

export type RemoveRelatedEntitiesResult = {
   __typename?: 'RemoveRelatedEntitiesResult'
   currentEntityId: Scalars['String']
   relatedEntityIds: Array<Scalars['String']>
   relationId: Scalars['String']
}

export type RemoveScheduledPipelineItemsParams = {
   pipelineItemIds: Array<Scalars['String']>
}

export type RemoveScheduledPipelineItemsResponse =
   | PipelineItemsAccessDenied
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | RemoveScheduledPipelineItemsResult

export type RemoveScheduledPipelineItemsResult = {
   __typename?: 'RemoveScheduledPipelineItemsResult'
   pipelineItemIds: Array<Scalars['String']>
}

export type RemoveStageUpdatePermissionParams = {
   fromStageId: Scalars['String']
   roleIds: Array<Scalars['String']>
   toStageIds: Array<Scalars['String']>
}

export type RemoveStageUpdatePermissionResponse =
   | FromStageAndToStagesAreNotInSamePipeline
   | FromStageNotFound
   | PipelineAccessDenied
   | RemoveStageUpdatePermissionResult
   | ToStagesNotFound
   | UserIsNotAnAdministrator

export type RemoveStageUpdatePermissionResult = {
   __typename?: 'RemoveStageUpdatePermissionResult'
   fromStageId: Scalars['String']
   roleIds: Array<Scalars['String']>
   toStageIds: Array<Scalars['String']>
}

export type RemoveUserGroupsForBoardListParams = {
   listId: Scalars['String']
   userGroupIds: Array<Scalars['String']>
}

export type RemoveUserGroupsForBoardListResponse =
   | BoardListEditAccessDenied
   | BoardListNotFound
   | RemoveUserGroupsForBoardListResult
   | UserGroupsNotFound

export type RemoveUserGroupsForBoardListResult = {
   __typename?: 'RemoveUserGroupsForBoardListResult'
   listId: Scalars['String']
   userGroupIds: Array<Scalars['String']>
}

export type RemoveUserGroupsForBoardParams = {
   boardId: Scalars['String']
   userGroupIds: Array<Scalars['String']>
}

export type RemoveUserGroupsForBoardResponse =
   | BoardEditAccessDenied
   | BoardNotFound
   | RemoveUserGroupsForBoardResult
   | UserGroupsNotFound

export type RemoveUserGroupsForBoardResult = {
   __typename?: 'RemoveUserGroupsForBoardResult'
   boardId: Scalars['String']
   userGroupIds: Array<Scalars['String']>
}

export type RemoveUserIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type RemoveUserIdentificationsResponse =
   | DeactivatedUser
   | IdentificationsNotFound
   | RemoveUserIdentificationsResult
   | UserIsNotAnAdministrator
   | UserNotFound

export type RemoveUserIdentificationsResult = {
   __typename?: 'RemoveUserIdentificationsResult'
   identificationIds: Array<Scalars['String']>
   userId: Scalars['String']
}

export type RemoveUsersCallingConfigParams = {
   userIds: Array<Scalars['String']>
}

export type RemoveUsersCallingConfigResponse =
   | RemoveUsersCallingConfigResult
   | UserIsNotAnAdministrator
   | UsersAndAdminAreNotInSameAccount
   | UsersNotFound

export type RemoveUsersCallingConfigResult = {
   __typename?: 'RemoveUsersCallingConfigResult'
   userIds: Array<Scalars['String']>
}

export type RemoveUsersFromIdentificationParams = {
   identificationId: Scalars['String']
   userIds: Array<Scalars['String']>
}

export type RemoveUsersFromIdentificationResponse =
   | IdentificationAndUserAreNotInSameAccount
   | IdentificationNotFound
   | RemoveUsersFromIdentificationResult
   | UserIsNotAnAdministrator
   | UsersNotFound
   | UsersNotInAccount

export type RemoveUsersFromIdentificationResult = {
   __typename?: 'RemoveUsersFromIdentificationResult'
   identificationId: Scalars['String']
   userIds: Array<Scalars['String']>
}

export type RemoveWhatsAppBusinessPhoneNumberParams = {
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
}

export type RemoveWhatsAppBusinessPhoneNumberResponse =
   | AccountPluginIsDisabled
   | PipelineWhatsAppBusinessPhoneNumberNotFound
   | RemoveWhatsAppBusinessPhoneNumberResult
   | UserIsNotAnAdministrator

export type RemoveWhatsAppBusinessPhoneNumberResult = {
   __typename?: 'RemoveWhatsAppBusinessPhoneNumberResult'
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
}

export type RemoveWhatsAppBusinessPhoneNumberUsersParams = {
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
   userIds: Array<Scalars['String']>
}

export type RemoveWhatsAppBusinessPhoneNumberUsersResponse =
   | AccountPluginIsDisabled
   | PipelineWhatsAppBusinessPhoneNumberNotFound
   | PluginServiceAccountIsNotActive
   | RemoveWhatsAppBusinessPhoneNumberUsersResult
   | UserIsNotAnAdministrator

export type RemoveWhatsAppBusinessPhoneNumberUsersResult = {
   __typename?: 'RemoveWhatsAppBusinessPhoneNumberUsersResult'
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
   userIds: Array<Scalars['String']>
}

export type RenameAutomationWorkflowFilterParams = {
   filterId: Scalars['String']
   filterSetEntity: AutomationWorkflowFilterSetEntityType
   name: Scalars['String']
}

export type RenameAutomationWorkflowFilterResponse =
   | FilterNotFound
   | NotConditionNodeFilterSet
   | NotEditableNode
   | NotEditableTrigger
   | NotScheduledTriggerFilterSet
   | RenameAutomationWorkflowFilterResult
   | UserIsNotAnAdministrator

export type RenameAutomationWorkflowFilterResult = {
   __typename?: 'RenameAutomationWorkflowFilterResult'
   filterId: Scalars['String']
   name: Scalars['String']
}

export type RenameAutomationWorkflowParams = {
   automationWorkflowId: Scalars['String']
   name: Scalars['String']
}

export type RenameAutomationWorkflowResponse =
   | AutomationWorkflowNameAlreadyExists
   | AutomationWorkflowNotFound
   | PipelineAccessDenied
   | RenameAutomationWorkflowResult
   | UserIsNotAnAdministrator

export type RenameAutomationWorkflowResult = {
   __typename?: 'RenameAutomationWorkflowResult'
   automationWorkflowId: Scalars['String']
   name: Scalars['String']
}

export type RenameBoardListParams = {
   listId: Scalars['String']
   name: Scalars['String']
}

export type RenameBoardListResponse =
   | BoardListEditAccessDenied
   | BoardListNotFound
   | RenameBoardListResult
   | UserIsNotAnAdministrator

export type RenameBoardListResult = {
   __typename?: 'RenameBoardListResult'
   listId: Scalars['String']
   name: Scalars['String']
}

export type RenameBoardParams = {
   boardId: Scalars['String']
   name: Scalars['String']
}

export type RenameBoardResponse =
   | BoardEditAccessDenied
   | BoardNotFound
   | RenameBoardResult
   | YouAreNotAllowedToEditSystemBoards

export type RenameBoardResult = {
   __typename?: 'RenameBoardResult'
   boardId: Scalars['String']
   name: Scalars['String']
}

export type RenameEventTriggerFilterParams = {
   filterId: Scalars['String']
   filterSetEntity: EventTriggerFilterSetEntity
   name: Scalars['String']
}

export type RenameEventTriggerFilterResponse =
   | EventTriggerFilterNotFound
   | EventTriggerFilterSetNotLinkedToGivenEntity
   | NotEditableEventTriggerFilterSetEntity
   | RenameEventTriggerFilterResult
   | UserIsNotAnAdministrator

export type RenameEventTriggerFilterResult = {
   __typename?: 'RenameEventTriggerFilterResult'
   filterId: Scalars['String']
   name: Scalars['String']
}

export type RenameFilterParams = {
   filterId: Scalars['String']
   filterSetEntity: FilterSetEntityType
   name: Scalars['String']
}

export type RenameFilterResponse =
   | FilterNotFound
   | FilterSetAccessDenied
   | FilterSetNotLinkedToBoard
   | FilterSetNotLinkedToBoardList
   | FilterSetNotLinkedToGivenEntity
   | FilterSetNotLinkedToGraph
   | FilterSetNotLinkedToView
   | FiltersNotSupportedForExternalDashboard
   | NotAllowedToEditBoardFilterSet
   | NotAllowedToEditBoardListFilterSet
   | NotEditableFilterSetEntity
   | NotUserFilterSet
   | RenameFilterResult
   | UserIsNotAnAdministrator

export type RenameFilterResult = {
   __typename?: 'RenameFilterResult'
   filterId: Scalars['String']
   name: Scalars['String']
}

export type RenameIdentificationParams = {
   identificationId: Scalars['String']
   name: Scalars['String']
}

export type RenameIdentificationResponse =
   | IdentificationAndUserAreNotInSameAccount
   | IdentificationNameAlreadyExist
   | IdentificationNotFound
   | RenameIdentificationResult
   | UserIsNotAnAdministrator

export type RenameIdentificationResult = {
   __typename?: 'RenameIdentificationResult'
   identificationId: Scalars['String']
   name: Scalars['String']
}

export type RenameNodeParams = {
   name?: InputMaybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type RenameNodeResponse =
   | NodeNotFound
   | NotEditableNode
   | PipelineAccessDenied
   | RenameNodeResult
   | UserIsNotAnAdministrator

export type RenameNodeResult = {
   __typename?: 'RenameNodeResult'
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type RenameStageParams = {
   name: Scalars['String']
   stageId: Scalars['String']
}

export type RenameStageResponse =
   | PipelineAccessDenied
   | RenameStageResult
   | StageIsDeleted
   | StageNameAlreadyUsedInPipeline
   | StageNotFound
   | UserIsNotAnAdministrator

export type RenameStageResult = {
   __typename?: 'RenameStageResult'
   name: Scalars['String']
   stageId: Scalars['String']
}

export type RenameTriggerParams = {
   name?: InputMaybe<Scalars['String']>
   triggerId: Scalars['String']
}

export type RenameTriggerResponse =
   | NotEditableTrigger
   | PipelineAccessDenied
   | RenameTriggerResult
   | TriggerNotFound
   | UserIsNotAnAdministrator

export type RenameTriggerResult = {
   __typename?: 'RenameTriggerResult'
   name?: Maybe<Scalars['String']>
   triggerId: Scalars['String']
}

export type RenameViewParams = {
   name: Scalars['String']
   viewId: Scalars['String']
}

export type RenameViewResponse = View | ViewAccessDenied | ViewNotFound

export type ReorderBoardListsResult = {
   __typename?: 'ReorderBoardListsResult'
   afterListId?: Maybe<Scalars['String']>
   listId: Scalars['String']
}

export type ReorderEntityCheckpointsParams = {
   checkpointIds: Array<Scalars['String']>
   entityId: Scalars['String']
   entityType: CategoryEntityType
}

export type ReorderEntityCheckpointsResponse =
   | CategoryCheckpointsNotFound
   | CategoryEntityAccessDenied
   | CategoryEntityNotFound
   | ReorderEntityCheckpointsResult

export type ReorderEntityCheckpointsResult = {
   __typename?: 'ReorderEntityCheckpointsResult'
   checkpointIds: Array<Scalars['String']>
   entityId: Scalars['String']
   entityType: CategoryEntityType
}

export type ReorderFieldParams = {
   afterFieldId?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type ReorderFieldResponse =
   | DependentFieldsNotSupported
   | FieldIsDeleted
   | FieldNotFound
   | GoFMismatchFields
   | MissingFieldIdsInGoF
   | ReorderFieldResult
   | UserIsNotAnAdministrator

export type ReorderFieldResult = {
   __typename?: 'ReorderFieldResult'
   afterFieldId?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type ReorderGraphQuickFilterFieldsParams = {
   afterGraphQuickFilterFieldId?: InputMaybe<Scalars['String']>
   graphQuickFilterFieldId: Scalars['String']
}

export type ReorderGraphQuickFilterFieldsResponse =
   | AfterGraphQuickFilterFieldNotFound
   | GraphQuickFilterFieldNotFound
   | NotSameGraphQuickFilterFields
   | ReorderGraphQuickFilterFieldsResult
   | UserIsNotAnAdministrator

export type ReorderGraphQuickFilterFieldsResult = {
   __typename?: 'ReorderGraphQuickFilterFieldsResult'
   afterGraphQuickFilterFieldId?: Maybe<Scalars['String']>
   graphQuickFilterFieldId: Scalars['String']
}

export type ReorderMetricsParams = {
   afterMetricId?: InputMaybe<Scalars['String']>
   metricId: Scalars['String']
}

export type ReorderMetricsResponse =
   | AfterGraphMetricNotFound
   | GraphMetricNotFound
   | MetricsNotInSameGraph
   | ReorderMetricsResult
   | UserIsNotAnAdministrator

export type ReorderMetricsResult = {
   __typename?: 'ReorderMetricsResult'
   afterMetricId?: Maybe<Scalars['String']>
   metricId: Scalars['String']
}

export type ReorderPinnedPipelineItemsParams = {
   afterPipelineItemPinnedId?: InputMaybe<Scalars['String']>
   pipelineItemPinnedId: Scalars['String']
}

export type ReorderPinnedPipelineItemsResponse =
   | BothPipelineItemPinnedIdsCannotBeSame
   | PipelineItemPinnedIdsAccessDenied
   | PipelineItemPinnedIdsNotFound
   | ReorderPinnedPipelineItemsResult

export type ReorderPinnedPipelineItemsResult = {
   __typename?: 'ReorderPinnedPipelineItemsResult'
   afterPipelineItemPinnedId?: Maybe<Scalars['String']>
   pipelineItemPinnedId: Scalars['String']
}

export type ReorderScheduledPipelineItemsParams = {
   afterPipelineItemScheduledId?: InputMaybe<Scalars['String']>
   featureEnum?: InputMaybe<FeatureEnum>
   pipelineItemScheduledId: Scalars['String']
}

export type ReorderScheduledPipelineItemsResponse =
   | BothPipelineItemScheduledIdsCannotBeSame
   | ReorderScheduledPipelineItemsResult
   | ScheduledPipelineItemsAccessDenied
   | ScheduledPipelineItemsNotFound

export type ReorderScheduledPipelineItemsResult = {
   __typename?: 'ReorderScheduledPipelineItemsResult'
   afterPipelineItemScheduledId?: Maybe<Scalars['String']>
   pipelineItemScheduledId: Scalars['String']
}

export type ReorderTabsParams = {
   afterTabId?: InputMaybe<Scalars['String']>
   tabId: Scalars['String']
}

export type ReorderTabsResponse =
   | AfterLayoutTabNotFound
   | AfterLayoutTabNotInSameLayout
   | AfterTabNotInSameParent
   | LayoutTabNotFound
   | ReorderTabsResult
   | UserIsNotAnAdministrator

export type ReorderTabsResult = {
   __typename?: 'ReorderTabsResult'
   afterTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
}

export type ReorderUserGraphInDashboardParams = {
   afterGraphId?: InputMaybe<Scalars['String']>
   dashboardId: Scalars['String']
   graphId: Scalars['String']
}

export type ReorderUserGraphInDashboardResponse =
   | DashboardAccessDenied
   | DashboardNotFound
   | GraphsNotFound
   | NotUserDashboardGraphs
   | ReorderUserGraphInDashboardResult

export type ReorderUserGraphInDashboardResult = {
   __typename?: 'ReorderUserGraphInDashboardResult'
   afterGraphId?: Maybe<Scalars['String']>
   dashboardId: Scalars['String']
   graphId: Scalars['String']
}

export type ReorderUserGraphInViewParams = {
   afterGraphId?: InputMaybe<Scalars['String']>
   graphId: Scalars['String']
   viewId: Scalars['String']
}

export type ReorderUserGraphInViewResponse =
   | GraphsAccessDenied
   | GraphsNotFound
   | NotUserViewGraphs
   | ReorderUserGraphInViewResult
   | ViewAccessDenied
   | ViewNotFound

export type ReorderUserGraphInViewResult = {
   __typename?: 'ReorderUserGraphInViewResult'
   afterGraphId?: Maybe<Scalars['String']>
   graphId: Scalars['String']
   viewId: Scalars['String']
}

export type ReorderViewsParams = {
   afterViewId?: InputMaybe<Scalars['String']>
   viewId: Scalars['String']
}

export type ReorderViewsResponse =
   | AfterViewAccessDenied
   | AfterViewNotFound
   | ReorderViewsResult
   | ViewAccessDenied
   | ViewNotFound

export type ReorderViewsResult = {
   __typename?: 'ReorderViewsResult'
   afterViewId?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export enum RepeatedTableDataSourceType {
   Building = 'BUILDING',
   Floor = 'FLOOR',
   PipelineItem = 'PIPELINE_ITEM',
   Plot = 'PLOT'
}

export type ReplacementOfficerHasActiveLeave = GraphQlBaseError & {
   __typename?: 'ReplacementOfficerHasActiveLeave'
   activeLeaveRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
   replacementOfficerUserId: Scalars['String']
}

export type RequestPayloadMappingParams = {
   key: Scalars['String']
   phoneNumberValueFormat?: InputMaybe<PhoneNumberValueFormatEnum>
   value?: InputMaybe<Scalars['String']>
   valueFrom: FieldSourceType
}

export type RequestPaymentNode = BaseNode & {
   __typename?: 'RequestPaymentNode'
   amount?: Maybe<Scalars['String']>
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   displayStage?: Maybe<Stage>
   expiryInDays?: Maybe<Scalars['Int']>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   paymentGatewayCode?: Maybe<Scalars['String']>
   paymentSplit: Array<RequestPaymentSplitCategory>
   paymentStatus?: Maybe<PaymentStatus>
   paymentTowards?: Maybe<Scalars['String']>
   pipelineStages: Array<PipelineStageValues>
   recordStage?: Maybe<Stage>
   referenceId?: Maybe<Scalars['String']>
}

export type RequestPaymentNodeExecLog = BaseNodeExecLog & {
   __typename?: 'RequestPaymentNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<RequestPaymentNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type RequestPaymentNodeExecLogResult = {
   __typename?: 'RequestPaymentNodeExecLogResult'
   paymentSplit: Array<RequestPaymentSplitCategoryExecLog>
   totalAmountInRs: Scalars['Int']
}

export type RequestPaymentSplitCategory = {
   __typename?: 'RequestPaymentSplitCategory'
   amount: Scalars['String']
   category: Scalars['String']
}

export type RequestPaymentSplitCategoryExecLog = {
   __typename?: 'RequestPaymentSplitCategoryExecLog'
   amountInRs: Scalars['Int']
   category: Scalars['String']
}

export type RequestPaymentSplitCategoryParams = {
   amount: Scalars['String']
   category: Scalars['String']
}

export type RequestPaymentWithFeeRulesNode = BaseNode & {
   __typename?: 'RequestPaymentWithFeeRulesNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   expiryInDays?: Maybe<Scalars['Int']>
   feePaymentOrderCreationConfigs: Array<FeePaymentOrderCreationConfig>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   numberOfInstallments?: Maybe<NumberOfInstallmentsConfig>
   paymentRuleSet?: Maybe<PaymentRuleSetOverviewDetails>
   paymentStatus?: Maybe<PaymentStatus>
   paymentTowards?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
}

export type RequestPaymentWithFeeRulesNodeExecLog = BaseNodeExecLog & {
   __typename?: 'RequestPaymentWithFeeRulesNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<RequestPaymentWithFeeRulesNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type RequestPaymentWithFeeRulesNodeExecLogResult = {
   __typename?: 'RequestPaymentWithFeeRulesNodeExecLogResult'
   paymentRuleSets: Array<PipelineItemPaymentRuleSet>
}

export type RequestVerification = {
   __typename?: 'RequestVerification'
   actions?: Maybe<Array<Maybe<LineDepartmentAction>>>
   contextFieldIds: Array<Scalars['String']>
   icon?: Maybe<IconConfig>
   isApprovalRequired?: Maybe<Scalars['Boolean']>
   stageId: Scalars['String']
   title: Scalars['String']
   verificationFieldIds: Array<Scalars['String']>
   verificationId: Scalars['String']
}

export type RequestVerificationTab = BaseTab & {
   __typename?: 'RequestVerificationTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
   verifications: Array<RequestVerification>
}

export type RequestedAndProposedTdrValuationIsDifferent = GraphQlBaseError & {
   __typename?: 'RequestedAndProposedTDRValuationIsDifferent'
   message?: Maybe<Scalars['String']>
}

export type RequestedAreaGreaterThanAllocatedArea = GraphQlBaseError & {
   __typename?: 'RequestedAreaGreaterThanAllocatedArea'
   allocatedArea: Scalars['Float']
   message?: Maybe<Scalars['String']>
   requestedArea: Scalars['Float']
   tdrRequestId: Scalars['String']
}

export type RequestedUserIsNotManager = GraphQlBaseError & {
   __typename?: 'RequestedUserIsNotManager'
   message?: Maybe<Scalars['String']>
}

export type RequiredFieldsNotFilled = GraphQlBaseError & {
   __typename?: 'RequiredFieldsNotFilled'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type RequiredGofResponseFields = GraphQlBaseError & {
   __typename?: 'RequiredGofResponseFields'
   fieldIds: Array<Scalars['String']>
   gofResponseId?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type RequiredGofResponseFieldsNotFilled = GraphQlBaseError & {
   __typename?: 'RequiredGofResponseFieldsNotFilled'
   gofFields: Array<RequiredGofResponseFields>
   message?: Maybe<Scalars['String']>
}

export type ReschedulePipelineItemRemindersParams = {
   reminderAt: Scalars['String']
   reminderIds: Array<Scalars['String']>
}

export type ReschedulePipelineItemRemindersResponse =
   | PipelineItemReminders
   | PipelineItemRemindersAccessDenied
   | PipelineItemRemindersNotFound
   | ReminderAtShouldNotBePreviousDateTime

export type ReschedulePipelineItemsParams = {
   deleteEventFromCalendar?: InputMaybe<Scalars['Boolean']>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemScheduledIds: Array<Scalars['String']>
   remindBeforeInMins?: InputMaybe<Scalars['Int']>
   remindersInMins?: InputMaybe<Array<Scalars['Int']>>
   scheduledDateTime: Scalars['String']
}

export type ReschedulePipelineItemsResponse =
   | CompletedPipelineItemScheduledIds
   | GoogleAuthConsentNotGiven
   | GoogleAuthConsentRefreshRequired
   | GoogleCalendarApiRequestsQuotaExceeded
   | PipelineItemScheduledIdsAccessDenied
   | PipelineItemScheduledIdsNotFound
   | RemindBeforeInMinsCannotBeNegative
   | RemindersInMinsCannotBeNegative
   | RemindersLimitExceeded
   | SchedulePipelineItemsResult
   | ScheduledDatetimeMustBeInFuture
   | ScheduledReminderMustBeInFuture
   | ScheduledRemindersMustBeInFuture

export type ResendRequestForPipelineItemVerificationResult = {
   __typename?: 'ResendRequestForPipelineItemVerificationResult'
   pipelineItemVerification?: Maybe<PipelineItemVerification>
}

export type ResendRequestToPipelineItemVerificationParams = {
   pipelineItemId: Scalars['String']
   tabId: Scalars['String']
   verificationId: Scalars['String']
}

export type ResendRequestToPipelineItemVerificationResponse =
   | LayoutTabNotFound
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotExistsInPipeline
   | PipelineItemNotFound
   | ResendRequestForPipelineItemVerificationResult
   | TabNotInPipelineItemTemplate
   | VerificationNotFound

export type ReservedFieldReferenceIdsAreNotAllowed = GraphQlBaseError & {
   __typename?: 'ReservedFieldReferenceIdsAreNotAllowed'
   message?: Maybe<Scalars['String']>
   referenceIds: Array<Scalars['String']>
   reservedFieldReferenceIds: Array<Scalars['String']>
}

export type ResetEntityCheckpointTextParams = {
   checkpointId: Scalars['String']
   entityId: Scalars['String']
   entityType: CategoryEntityType
}

export type ResetEntityCheckpointTextResponse =
   | CategoryCheckpointNotFound
   | CategoryEntityAccessDenied
   | CategoryEntityNotFound
   | NotSupportedResetForCheckpoint
   | ResetEntityCheckpointTextResult

export type ResetEntityCheckpointTextResult = {
   __typename?: 'ResetEntityCheckpointTextResult'
   checkpointId: Scalars['String']
   entityId: Scalars['String']
   entityType: CategoryEntityType
   text: Scalars['String']
}

export type ResetEntityFeeRuleSetParams = {
   entityFeeRuleSetId: Scalars['String']
}

export type ResetEntityFeeRuleSetResponse =
   | EntityFeeRuleSet
   | EntityFeeRuleSetAccessDenied
   | EntityFeeRuleSetNotFound

export type ResetOtpRetryCountParams = {
   userId: Scalars['String']
}

export type ResetOtpRetryCountResponse =
   | OwnerNotFound
   | ResetOtpRetryCountResult
   | UserAndAdminAreNotInSameAccount
   | UserIsNotAnAdministrator
   | UserNotFound

export type ResetOtpRetryCountResult = {
   __typename?: 'ResetOTPRetryCountResult'
   message: Scalars['String']
   resetAt: Scalars['String']
   success: Scalars['Boolean']
}

export type ResetOfficerOtpRetryCountParams = {
   userId: Scalars['String']
}

export type ResetOfficerOtpRetryCountResponse =
   | ResetOfficerOtpRetryCountResult
   | UserIsNotAnAdministrator
   | UserNotFound

export type ResetOfficerOtpRetryCountResult = {
   __typename?: 'ResetOfficerOtpRetryCountResult'
   success: Scalars['Boolean']
   successMessage?: Maybe<Scalars['String']>
}

export type ResetOfficerOtpRetryCounterRequest = BaseOfficerManagementRequest & {
   __typename?: 'ResetOfficerOtpRetryCounterRequest'
   accountId: Scalars['String']
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   id: Scalars['String']
   initiatedBy: Scalars['String']
   initiatedUser: User
   operationType: OfficerManagementOperationType
   reason?: Maybe<Scalars['String']>
   status: OfficerManagementStatusType
   updatedAt: Scalars['String']
   user: User
   userId: Scalars['String']
}

export type ResetVerificationTaskParams = {
   tabId: Scalars['String']
   taskId: Scalars['String']
}

export type ResetVerificationTaskResponse =
   | NoPreviousSubmittedTaskToReset
   | PipelineItemAccessDenied
   | ResetVerificationTaskResult
   | TaskAccessDenied
   | TaskNotFound
   | VerificationTaskAlreadyExists
   | YouCanNotResetSubmittedTask

export type ResetVerificationTaskResult = {
   __typename?: 'ResetVerificationTaskResult'
   isProcessingAsynchronously: Scalars['Boolean']
   task: Task
}

export type ResolveApplicationViewParams = {
   applicationId: Scalars['String']
   fieldOverrides?: InputMaybe<Array<PmuFieldOverrideInput>>
}

export type ResolveApplicationViewResponse =
   | ApplicationNotFound
   | ApplicationViewType
   | AuthorityMismatch

export type Resource = {
   __typename?: 'Resource'
   description: Scalars['String']
   resourceId: Scalars['String']
   title: Scalars['String']
}

export type ResourceConfig = {
   __typename?: 'ResourceConfig'
   description: Scalars['String']
   order: Scalars['Int']
   resourceId: Scalars['String']
   roles: Array<Role>
   title: Scalars['String']
}

export type ResourceDescriptionIsRequired = GraphQlBaseError & {
   __typename?: 'ResourceDescriptionIsRequired'
   message?: Maybe<Scalars['String']>
   resourceId: Scalars['String']
}

export type ResourceNotFound = GraphQlBaseError & {
   __typename?: 'ResourceNotFound'
   message?: Maybe<Scalars['String']>
   resourceId: Scalars['String']
}

export type ResourceTitleIsRequired = GraphQlBaseError & {
   __typename?: 'ResourceTitleIsRequired'
   message?: Maybe<Scalars['String']>
   resourceId: Scalars['String']
}

export type ResourcesNotFound = GraphQlBaseError & {
   __typename?: 'ResourcesNotFound'
   message?: Maybe<Scalars['String']>
   resourceIds: Array<Scalars['String']>
}

export type ResourcesNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'ResourcesNotInSamePipeline'
   message?: Maybe<Scalars['String']>
   resourceIds: Array<Scalars['String']>
}

export type RestoreApplicationInPortalParams = {
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type RestoreApplicationInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationNotFound
   | ApplicationStageNotFound
   | NoRestoreStageAvailable
   | PortalNotFound
   | RestoreApplicationInPortalResult

export type RestoreApplicationInPortalResult = {
   __typename?: 'RestoreApplicationInPortalResult'
   applicationId: Scalars['String']
   availableActions: Array<PortalApplicationAction>
   isApplicationDeleted: Scalars['Boolean']
   isRestored: Scalars['Boolean']
   portalId: Scalars['String']
}

export type RestoreFeeHeadLog = {
   __typename?: 'RestoreFeeHeadLog'
   actionDoneBy?: Maybe<BaseUser>
   cascadeCreatedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeRemovedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeUpdatedAppliedFeeHeads: Array<UpdateAppliedFeeHeadLog>
   eventDatetime: Scalars['String']
   logId: Scalars['String']
   restoredAppliedFeeHeads: Array<AppliedFeeHeader>
}

export type RestoreFeeHeadersInEntityFeeRuleSetParams = {
   appliedFeeHeaderIds: Array<Scalars['String']>
   entityRuleSetId: Scalars['String']
}

export type RestoreFeeHeadersInEntityFeeRuleSetResponse =
   | EntityFeeRuleSetAccessDenied
   | EntityFeeRuleSetNotFound
   | FeeHeadersAreNotDeletedInEntityFeeRuleSet
   | InvalidAppliedFeeHeaderIds
   | RestoreFeeHeadersInEntityFeeRuleSetResult

export type RestoreFeeHeadersInEntityFeeRuleSetResult = {
   __typename?: 'RestoreFeeHeadersInEntityFeeRuleSetResult'
   appliedFeeHeaderIds: Array<Scalars['String']>
   changedFeeAppliedHeaders: Array<AppliedFeeHeader>
   entityRuleSetId: Scalars['String']
   totalAdjustedAmount: Scalars['Float']
   totalCalculatedAmount: Scalars['Float']
   totalNetAmount: Scalars['Float']
}

export type RestoreFieldsParams = {
   fieldIds: Array<Scalars['String']>
   forceRestore?: InputMaybe<Scalars['Boolean']>
}

export type RestoreFieldsResponse =
   | DependentFieldsCannotBeRestoredWithoutParentFields
   | FieldsAreNotDeleted
   | FieldsNotFound
   | LinkedSourceFieldsAreDeleted
   | RestoreFieldsResult
   | UserIsNotAnAdministrator

export type RestoreFieldsResult = {
   __typename?: 'RestoreFieldsResult'
   fields: Array<Field>
}

export type RestoreGoFsParams = {
   gofFields: Array<GoFFieldsParams>
}

export type RestoreGoFsResponse =
   | DependentFieldsCannotBeRestoredWithoutParentFields
   | FieldsAreNotDeleted
   | FieldsNotFound
   | FieldsNotInGoF
   | GoFsAreNotDeleted
   | GoFsNotFound
   | LinkedSourceFieldsAreDeleted
   | RestoreGoFsResult
   | UserIsNotAnAdministrator

export type RestoreGoFsResult = {
   __typename?: 'RestoreGoFsResult'
   gofs: Array<GoF>
}

export type RetoolAppEmbedUrlResponse =
   | RetoolAppEmbedUrlResult
   | RetoolEmbedUrlApiFailed
   | UserIsNotAnAdministrator

export type RetoolAppEmbedUrlResult = {
   __typename?: 'RetoolAppEmbedUrlResult'
   embedUrl: Scalars['String']
}

export type RetoolEmbedUrlApiFailed = GraphQlBaseError & {
   __typename?: 'RetoolEmbedUrlAPIFailed'
   message?: Maybe<Scalars['String']>
   reason?: Maybe<Scalars['String']>
}

export type RetryExportPipelineItemsParams = {
   dataExportRequestId: Scalars['String']
}

export type RetryExportPipelineItemsResponse =
   | DataExportRequest
   | DataExportRequestNotFound
   | DataExportRequestStatusNotFailed
   | NotExportPipelineItemRequest
   | UserIsNotAnAdministrator
   | ViewAccessDenied
   | ViewNotFound

export type RetryFailedActionParams = {
   pmuActionLogId: Scalars['String']
}

export type RetryFailedActionResponse =
   | ActionNotPermitted
   | ApplicationNotFound
   | LogNotRetryable
   | RetryFailedActionResult

export type RetryFailedActionResult = {
   __typename?: 'RetryFailedActionResult'
   pmuActionLogId: Scalars['String']
}

export type RevokeGoogleUserAuthorizationResponse =
   | GoogleAuthConsentNotGiven
   | RevokeGoogleUserAuthorizationResult

export type RevokeGoogleUserAuthorizationResult = {
   __typename?: 'RevokeGoogleUserAuthorizationResult'
   isRevoked: Scalars['Boolean']
}

export type Role = {
   __typename?: 'Role'
   name: Scalars['String']
   roleId: Scalars['String']
}

export type RoleConfig = BaseIdentification & {
   __typename?: 'RoleConfig'
   actions: Array<UserPermission>
   identificationId: Scalars['String']
   identificationType: IdentificationType
   isFieldExecutionRole: Scalars['Boolean']
   name: Scalars['String']
   pipelines: Array<BasePipeline>
   profilePicUrl?: Maybe<Scalars['String']>
}

export type RolesAndStagesAreNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'RolesAndStagesAreNotInSamePipeline'
   message?: Maybe<Scalars['String']>
   roleIds: Array<Scalars['String']>
}

export type RolesNotFound = GraphQlBaseError & {
   __typename?: 'RolesNotFound'
   message?: Maybe<Scalars['String']>
   roleIds: Array<Scalars['String']>
}

export type RolesNotInUserAccount = GraphQlBaseError & {
   __typename?: 'RolesNotInUserAccount'
   message?: Maybe<Scalars['String']>
   roleIds: Array<Scalars['String']>
}

export type RowAndColumnDimensionShouldNotHaveSameField = GraphQlBaseError & {
   __typename?: 'RowAndColumnDimensionShouldNotHaveSameField'
   message?: Maybe<Scalars['String']>
}

export type RowPaginationIsRequired = GraphQlBaseError & {
   __typename?: 'RowPaginationIsRequired'
   message?: Maybe<Scalars['String']>
}

export type RowTotal = {
   __typename?: 'RowTotal'
   rowId: Scalars['String']
   total: Scalars['String']
}

export type RowTotals = {
   __typename?: 'RowTotals'
   rowTotals: Array<RowTotal>
   totalCount: Scalars['Int']
}

export type RowTotalsResult =
   | GraphAccessDenied
   | GraphNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | RowTotals
   | ViewAccessDenied
   | ViewNotFound

export type RowValue =
   | BaseActivityTemplate
   | BaseTaskTemplate
   | BaseUser
   | GqlStringType
   | Stage

export type Rule = {
   __typename?: 'Rule'
   actions: Array<RuleAction>
   conditions: Array<RuleCondition>
   conditionsLogicalOperator: LogicalOperator
   entityId: Scalars['String']
   entityType: RuleEntityType
   ruleId: Scalars['String']
}

export type RuleAction = {
   __typename?: 'RuleAction'
   actionId: Scalars['String']
   actionType: ActionType
   config?: Maybe<RuleActionConfig>
}

export type RuleActionConfig = RegexValidationRuleActionConfig

export type RuleCondition = {
   __typename?: 'RuleCondition'
   conditionId: Scalars['String']
   failIfFieldIsNone?: Maybe<Scalars['Boolean']>
   fieldId: Scalars['String']
   fieldSource: RuleConditionFieldSourceType
   isNegated?: Maybe<Scalars['Boolean']>
   operator: RuleConditionOperator
   ruleId: Scalars['String']
   value?: Maybe<Scalars['String']>
}

export enum RuleConditionFieldSourceType {
   DirectValue = 'DIRECT_VALUE',
   FieldReference = 'FIELD_REFERENCE'
}

export enum RuleConditionOperator {
   Contains = 'CONTAINS',
   Empty = 'EMPTY',
   Endswith = 'ENDSWITH',
   Eq = 'EQ',
   Gt = 'GT',
   Gte = 'GTE',
   In = 'IN',
   InTheLast = 'IN_THE_LAST',
   InTheNext = 'IN_THE_NEXT',
   Is = 'IS',
   IsAfter = 'IS_AFTER',
   IsBefore = 'IS_BEFORE',
   IsIn = 'IS_IN',
   IsInShortfall = 'IS_IN_SHORTFALL',
   IsNot = 'IS_NOT',
   Lt = 'LT',
   Lte = 'LTE',
   Ne = 'NE',
   NotEmpty = 'NOT_EMPTY',
   NotIn = 'NOT_IN',
   Range = 'RANGE',
   Startswith = 'STARTSWITH'
}

export enum RuleEntityType {
   ApplicationIdConfig = 'APPLICATION_ID_CONFIG',
   AssignFriend = 'ASSIGN_FRIEND',
   FeeRuleSet = 'FEE_RULE_SET',
   Field = 'FIELD',
   FieldOptionsVisibility = 'FIELD_OPTIONS_VISIBILITY',
   Gof = 'GOF',
   HolidaySchedule = 'HOLIDAY_SCHEDULE',
   LayoutTab = 'LAYOUT_TAB',
   NumberGenerationConfig = 'NUMBER_GENERATION_CONFIG',
   PipelineItemTemplate = 'PIPELINE_ITEM_TEMPLATE',
   ReconciliationRuleSet = 'RECONCILIATION_RULE_SET',
   ShortfallCounter = 'SHORTFALL_COUNTER',
   StageTransition = 'STAGE_TRANSITION',
   TdrBank = 'TDR_BANK',
   TdrBankAccountNumber = 'TDR_BANK_ACCOUNT_NUMBER',
   Template = 'TEMPLATE'
}

export type RuleSet = {
   __typename?: 'RuleSet'
   description?: Maybe<Scalars['String']>
   entityId: Scalars['String']
   entityType: RuleEntityType
   name: Scalars['String']
   purpose: RuleSetPurpose
   ruleSetId: Scalars['String']
   rules: Array<Rule>
}

export enum RuleSetPurpose {
   AddAnotherGofLimitValidation = 'ADD_ANOTHER_GOF_LIMIT_VALIDATION',
   AlertMessage = 'ALERT_MESSAGE',
   ApplicationIdGeneration = 'APPLICATION_ID_GENERATION',
   AssignFriend = 'ASSIGN_FRIEND',
   AutoFillRecordResponse = 'AUTO_FILL_RECORD_RESPONSE',
   MandatoryFeeHeader = 'MANDATORY_FEE_HEADER',
   NumberGeneration = 'NUMBER_GENERATION',
   PipelineItemBannerMessage = 'PIPELINE_ITEM_BANNER_MESSAGE',
   Reconcile = 'RECONCILE',
   RegexValidation = 'REGEX_VALIDATION',
   Required = 'REQUIRED',
   SlaCalculation = 'SLA_CALCULATION',
   TdrBankAccountNumberGeneration = 'TDR_BANK_ACCOUNT_NUMBER_GENERATION',
   TdrBankSelection = 'TDR_BANK_SELECTION',
   Validation = 'VALIDATION',
   Visibility = 'VISIBILITY',
   WritablePermission = 'WRITABLE_PERMISSION'
}

export type SrApiKeyAlreadyExists = GraphQlBaseError & {
   __typename?: 'SRApiKeyAlreadyExists'
   message?: Maybe<Scalars['String']>
}

export type SaleTransactionAlreadyExistsForApplication = GraphQlBaseError & {
   __typename?: 'SaleTransactionAlreadyExistsForApplication'
   message?: Maybe<Scalars['String']>
   referenceApplicationId: Scalars['String']
}

export enum SalesEntityType {
   Activity = 'ACTIVITY',
   Application = 'APPLICATION',
   Calls = 'CALLS',
   Contact = 'CONTACT',
   CustomObject = 'CUSTOM_OBJECT',
   Deal = 'DEAL',
   Lead = 'LEAD',
   PipelineEvent = 'PIPELINE_EVENT',
   Task = 'TASK',
   UserProperties = 'USER_PROPERTIES'
}

export type SalesTemplate = {
   __typename?: 'SalesTemplate'
   name: Scalars['String']
   pipelineItemType?: Maybe<PipelineItemType>
   salesTemplateId: Scalars['String']
   salesTemplateType: SupportedSalesTemplateTypesForRelation
}

export type SalesTemplateAccessDenied = GraphQlBaseError & {
   __typename?: 'SalesTemplateAccessDenied'
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type SalesTemplateDeletedGoFs = {
   __typename?: 'SalesTemplateDeletedGoFs'
   gofs: Array<GoF>
   salesTemplateId: Scalars['String']
}

export type SalesTemplateDeletedGoFsResult =
   | SalesTemplateDeletedGoFs
   | SalesTemplateNotFound
   | UserIsNotAnAdministrator

export type SalesTemplateFields = {
   __typename?: 'SalesTemplateFields'
   fields: Array<Field>
   salesTemplateId: Scalars['String']
   salesTemplateName: Scalars['String']
   salesTemplateType: SalesTemplateType
}

export type SalesTemplateFieldsResult = {
   __typename?: 'SalesTemplateFieldsResult'
   salesTemplateFields: Array<SalesTemplateFields>
   totalCount: Scalars['Int']
}

export type SalesTemplateIdNotInPipeline = GraphQlBaseError & {
   __typename?: 'SalesTemplateIdNotInPipeline'
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type SalesTemplateNotFound = GraphQlBaseError & {
   __typename?: 'SalesTemplateNotFound'
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type SalesTemplateNotInUserAccount = GraphQlBaseError & {
   __typename?: 'SalesTemplateNotInUserAccount'
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type SalesTemplateNotLinkedToRelation = GraphQlBaseError & {
   __typename?: 'SalesTemplateNotLinkedToRelation'
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
   salesTemplateId: Scalars['String']
}

export type SalesTemplateRecordMergePermissions = {
   __typename?: 'SalesTemplateRecordMergePermissions'
   identifications: Array<Identification>
   salesTemplateId: Scalars['String']
}

export type SalesTemplateRecordMergePermissionsUnion =
   | SalesTemplateNotFound
   | SalesTemplateNotInUserAccount
   | SalesTemplateRecordMergePermissions

export type SalesTemplateSystemFieldAlreadyExists = GraphQlBaseError & {
   __typename?: 'SalesTemplateSystemFieldAlreadyExists'
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum: OneTimeCreatableSystemFieldEnum
}

export enum SalesTemplateType {
   Activity = 'ACTIVITY',
   Contact = 'CONTACT',
   Form = 'FORM',
   PipelineEvent = 'PIPELINE_EVENT',
   PipelineItem = 'PIPELINE_ITEM',
   Task = 'TASK',
   UserProperties = 'USER_PROPERTIES'
}

export type SalesTemplateTypeNotSupportedForLinking = GraphQlBaseError & {
   __typename?: 'SalesTemplateTypeNotSupportedForLinking'
   message?: Maybe<Scalars['String']>
   salesTemplateType: SalesTemplateType
}

export type SalesTemplates = {
   __typename?: 'SalesTemplates'
   salesTemplates: Array<SalesTemplate>
}

export type SalesTemplatesAccessDenied = GraphQlBaseError & {
   __typename?: 'SalesTemplatesAccessDenied'
   message?: Maybe<Scalars['String']>
   salesTemplateIds: Array<Scalars['String']>
}

export type SalesTemplatesNotFound = GraphQlBaseError & {
   __typename?: 'SalesTemplatesNotFound'
   message?: Maybe<Scalars['String']>
   salesTemplateIds: Array<Scalars['String']>
}

export type SalesTemplatesResponse = SalesTemplates | UserIsNotAnAdministrator

export type SalesTemplatesUnion =
   | ContactTemplate
   | PipelineItemTemplate
   | SalesTemplateAccessDenied
   | SalesTemplateNotFound

export type SalesTemplatesWithoutPermissionUnion =
   | ContactTemplateWithoutPermission
   | PipelineItemTemplateWithoutPermission
   | SalesTemplateAccessDenied
   | SalesTemplateNotFound

export type SameCertificateAlreadyExistsInTdrOrder = GraphQlBaseError & {
   __typename?: 'SameCertificateAlreadyExistsInTDROrder'
   certificateNumber: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type SavePipelineItemFieldInTaskDraftBulkParams = {
   fieldResponses: Array<FieldResponseParams>
   taskId: Scalars['String']
}

export type SavePipelineItemFieldInTaskDraftBulkResponse =
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | CanNotUpdateCompletedTask
   | CannotUpdatePipelineItemSystemFields
   | ContactFieldsNotSupported
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotPipelineItemOrContactFields
   | NotRecordTemplateFields
   | ParentFieldNotFilled
   | SavePipelineItemFieldInTaskDraftBulkResult
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | TaskTemplateAccessDenied
   | UniqueFieldResponseAlreadyExists

export type SavePipelineItemFieldInTaskDraftBulkResult = {
   __typename?: 'SavePipelineItemFieldInTaskDraftBulkResult'
   changedFields: Array<FieldResponseDraft>
   deletedFieldIds: Array<Scalars['String']>
   fieldResponses: Array<FieldResponseDraft>
   taskId: Scalars['String']
}

export type SavePipelineItemFieldInTaskDraftParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   fieldId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
}

export type SavePipelineItemFieldInTaskDraftResponse =
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | CanNotUpdateCompletedTask
   | CannotUpdatePipelineItemSystemField
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseDraft
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotPipelineItemOrContactField
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | TaskTemplateAccessDenied
   | UniqueFieldResponseAlreadyExists
   | UpdateFieldResponseDraftResult

export type SavePipelineItemRemarksInTaskDraftParams = {
   remarks?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
}

export type SavePipelineItemRemarksInTaskDraftResponse =
   | CanNotUpdateCompletedTask
   | PipelineItemRemarksDraft
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | TaskTemplateAccessDenied

export type SaveSiteInspectionFieldObservationParams = {
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   observation?: InputMaybe<SiteInspectionObservationEnum>
   remarks?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: SiteInspectionFieldProperty
}

export type SaveSiteInspectionFieldObservationResponse =
   | FieldIsDeleted
   | FieldNotFound
   | NotTaskField
   | SaveSiteInspectionFieldObservationResult
   | SiteInspectionIsNotEditable
   | TaskAccessDenied
   | TaskNotFound
   | TaskSiteInspectionNotExists
   | TaskTemplateAccessDenied

export type SaveSiteInspectionFieldObservationResult = {
   __typename?: 'SaveSiteInspectionFieldObservationResult'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   observation?: Maybe<SiteInspectionObservationEnum>
   remarks?: Maybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: SiteInspectionFieldProperty
}

export type SchedulePipelineItemParams = {
   featureEnum?: InputMaybe<FeatureEnum>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type SchedulePipelineItemResponse =
   | PipelineItemAccessDenied
   | PipelineItemAlreadyScheduled
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | ScheduledPipelineItem
   | ScheduledPipelineItemsLimitExceeded

export type SchedulePipelineItemsParams = {
   featureEnum?: InputMaybe<FeatureEnum>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemIds: Array<Scalars['String']>
   remindBeforeInMins?: InputMaybe<Scalars['Int']>
   remindersInMins?: InputMaybe<Array<Scalars['Int']>>
   scheduledDateTime?: InputMaybe<Scalars['String']>
}

export type SchedulePipelineItemsResponse =
   | PipelineItemsAccessDenied
   | PipelineItemsAreAlreadyScheduled
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | RemindBeforeInMinsCannotBeNegative
   | RemindersInMinsCannotBeNegative
   | RemindersLimitExceeded
   | SchedulePipelineItemsResult
   | ScheduledDatetimeIsRequired
   | ScheduledDatetimeMustBeInFuture
   | ScheduledPipelineItemsLimitExceeded
   | ScheduledReminderMustBeInFuture
   | ScheduledRemindersMustBeInFuture

export type SchedulePipelineItemsResult = {
   __typename?: 'SchedulePipelineItemsResult'
   scheduledPipelineItems: Array<ScheduledPipelineItem>
}

export type ScheduleSiteInspectionParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   pipelineItemId: Scalars['String']
   tabId: Scalars['String']
   taskId?: InputMaybe<Scalars['String']>
   taskStartDatetime?: InputMaybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type ScheduleSiteInspectionResponse =
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | ScheduleSiteInspectionResult
   | Task
   | TaskNotFound
   | TaskNotLinkedToGivenTaskTemplate
   | TaskNotLinkedToPipelineItem
   | TaskStartDateTimeShouldBeInFuture
   | TaskTemplateAccessDenied
   | TaskTemplateIsDisabled
   | TaskTemplateNotFound
   | UpcomingSiteInspectionScheduleExists

export type ScheduleSiteInspectionResult = {
   __typename?: 'ScheduleSiteInspectionResult'
   isProcessingAsynchronously: Scalars['Boolean']
   task: Task
}

export enum ScheduleTriggerEntity {
   Installment = 'INSTALLMENT',
   Lead = 'LEAD'
}

export enum ScheduleTypeEnum {
   Day = 'DAY',
   Minutes = 'MINUTES',
   Month = 'MONTH',
   Week = 'WEEK'
}

export type ScheduledAutomationWorkflowConfig = {
   __typename?: 'ScheduledAutomationWorkflowConfig'
   triggers: Array<ScheduledTriggerConfig>
}

export type ScheduledAutomationWorkflowExecLog = {
   __typename?: 'ScheduledAutomationWorkflowExecLog'
   automationWorkflow: BaseAutomationWorkflow
   automationWorkflowExecConfigId: Scalars['String']
   completedAt?: Maybe<Scalars['String']>
   execLogId: Scalars['String']
   failedLeadsCount: Scalars['Int']
   initiatedAt: Scalars['String']
   satisfiedLeadsCount: Scalars['Int']
   status: ScheduledAutomationWorkflowExecLogStatus
   successfulLeadsCount: Scalars['Int']
}

export type ScheduledAutomationWorkflowExecLogNotFound = GraphQlBaseError & {
   __typename?: 'ScheduledAutomationWorkflowExecLogNotFound'
   message?: Maybe<Scalars['String']>
   scheduledAutomationWorkflowExecLogId: Scalars['String']
}

export enum ScheduledAutomationWorkflowExecLogStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   Processing = 'PROCESSING'
}

export type ScheduledAutomationWorkflowExecLogsFilter = {
   __typename?: 'ScheduledAutomationWorkflowExecLogsFilter'
   automationWorkflows: Array<BaseAutomationWorkflow>
   entityId: Scalars['String']
   entityLevel: AwLogsEntityLevel
   executedAtRange?: Maybe<AutomationWorkflowExecLogsExecutedAtRangeFilter>
   filterByPipelineIds: Array<Scalars['String']>
   /** @deprecated use entity_id */
   pipelineId: Scalars['String']
   statuses?: Maybe<Array<ScheduledAutomationWorkflowExecLogStatus>>
}

export type ScheduledAutomationWorkflowNotSupported = GraphQlBaseError & {
   __typename?: 'ScheduledAutomationWorkflowNotSupported'
   message?: Maybe<Scalars['String']>
}

export type ScheduledAwExecLogIdDoesNotLinkedToAutomationWorkflows = GraphQlBaseError & {
   __typename?: 'ScheduledAwExecLogIdDoesNotLinkedToAutomationWorkflows'
   automationWorkflowIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   scheduledAutomationWorkflowExecLogId: Scalars['String']
}

export enum ScheduledAwExecutionMode {
   Manual = 'MANUAL',
   Scheduled = 'SCHEDULED'
}

export type ScheduledByUserNotFound = GraphQlBaseError & {
   __typename?: 'ScheduledByUserNotFound'
   message?: Maybe<Scalars['String']>
   scheduledByUserId: Scalars['String']
}

export type ScheduledDatetimeIsRequired = GraphQlBaseError & {
   __typename?: 'ScheduledDatetimeIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ScheduledDatetimeMustBeInFuture = GraphQlBaseError & {
   __typename?: 'ScheduledDatetimeMustBeInFuture'
   message?: Maybe<Scalars['String']>
   scheduledDatetime: Scalars['String']
}

export type ScheduledLeadDistributionRuleDailyConfig = {
   __typename?: 'ScheduledLeadDistributionRuleDailyConfig'
   timeIntervals: Array<Scalars['String']>
}

export type ScheduledLeadDistributionRuleDailyConfigParams = {
   timeIntervals: Array<Scalars['String']>
}

export type ScheduledLeadDistributionRuleExecLog = {
   __typename?: 'ScheduledLeadDistributionRuleExecLog'
   assignedLeadsCount: Scalars['Int']
   completedAt?: Maybe<Scalars['String']>
   distributionThrough: DistributionThroughType
   distributionThroughItems: Array<DistributeThroughItemExecLog>
   isPartiallyAssigned: Scalars['Boolean']
   leadDistributionRuleExecLogId: Scalars['String']
   name: Scalars['String']
   pipelineId: Scalars['String']
   scheduleConfig: LeadDistributionRuleScheduleConfig
   status: LeadDistributionRuleExecLogStatus
   triggeredAt: Scalars['String']
}

export type ScheduledLeadDistributionRuleSettings = BaseLeadDistributionRuleSettings & {
   __typename?: 'ScheduledLeadDistributionRuleSettings'
   assignBasedOnAvailability: Scalars['Boolean']
   assigneeFieldIdsToNotify: Array<Scalars['String']>
   configStatus: LeadDistributionEntityConfigStatus
   dailyConfig?: Maybe<ScheduledLeadDistributionRuleDailyConfig>
   distributionType: LeadDistributionRuleType
   leadDistributionRuleId: Scalars['String']
   managerFields: Array<LeadDistributionRuleManagerField>
   minutes?: Maybe<Scalars['Int']>
   scheduledType?: Maybe<LeadDistributionRuleScheduledType>
   smartDistribution?: Maybe<Scalars['Boolean']>
   syncAssigneeHierarchy: Scalars['Boolean']
   weekDaysConfig: Array<ScheduledLeadDistributionRuleWeekDaysConfig>
}

export enum ScheduledLeadDistributionRuleStatus {
   Active = 'ACTIVE',
   Inactive = 'INACTIVE'
}

export type ScheduledLeadDistributionRuleWeekDaysConfig = {
   __typename?: 'ScheduledLeadDistributionRuleWeekDaysConfig'
   timeIntervals: Array<Scalars['String']>
   weekDays: Array<WeekDayEnum>
}

export type ScheduledLeadDistributionRuleWeekDaysConfigParams = {
   timeIntervals: Array<Scalars['String']>
   weekDays: Array<WeekDayEnum>
}

export type ScheduledPipelineItem = BasePipelineItemSchedule & {
   __typename?: 'ScheduledPipelineItem'
   order: Scalars['Int']
   pipelineItem: PipelineItemPrimaryDetails
   pipelineItemScheduledId: Scalars['String']
   remindBeforeInMins?: Maybe<Scalars['Int']>
   remindersInMins: Array<Scalars['Int']>
   scheduledByUser: BaseUser
   scheduledDateTime: Scalars['String']
   status: PipelineItemScheduledStatus
   title?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type ScheduledPipelineItemIdsInViewResponse =
   | AccessDeniedForScheduledByUser
   | InvalidLimit
   | InvalidOffset
   | ItemIdsInViewResult
   | NotScheduledPipelineItemsView
   | PaginationLimitExceeded
   | ScheduledByUserNotFound
   | ViewAccessDenied
   | ViewNotFound

export type ScheduledPipelineItemsAccessDenied = GraphQlBaseError & {
   __typename?: 'ScheduledPipelineItemsAccessDenied'
   message?: Maybe<Scalars['String']>
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export type ScheduledPipelineItemsCountResult = {
   __typename?: 'ScheduledPipelineItemsCountResult'
   totalCount: Scalars['Int']
}

export type ScheduledPipelineItemsDateCount = {
   __typename?: 'ScheduledPipelineItemsDateCount'
   date: Scalars['String']
   scheduledPipelineItemsCount: Scalars['Int']
}

export type ScheduledPipelineItemsDateRangeCountsResponse =
   | InvalidDateRange
   | ScheduledPipelineItemsDateRangeCountsResult

export type ScheduledPipelineItemsDateRangeCountsResult = {
   __typename?: 'ScheduledPipelineItemsDateRangeCountsResult'
   dateWiseCounts: Array<ScheduledPipelineItemsDateCount>
}

export type ScheduledPipelineItemsLimitExceeded = GraphQlBaseError & {
   __typename?: 'ScheduledPipelineItemsLimitExceeded'
   maxLimit: Scalars['Int']
   message?: Maybe<Scalars['String']>
}

export type ScheduledPipelineItemsNotFound = GraphQlBaseError & {
   __typename?: 'ScheduledPipelineItemsNotFound'
   message?: Maybe<Scalars['String']>
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export type ScheduledPipelineItemsResult = {
   __typename?: 'ScheduledPipelineItemsResult'
   dateTimeRange?: Maybe<Scalars['String']>
   scheduledByUserId?: Maybe<Scalars['String']>
   scheduledPipelineItems: Array<ScheduledPipelineItem>
   statuses?: Maybe<Scalars['String']>
   totalCount: Scalars['Int']
}

export type ScheduledPipelineItemsTeamMetricsResponse =
   | InvalidDateRange
   | ScheduledPipelineItemsTeamMetricsResult

export type ScheduledPipelineItemsTeamMetricsResult = {
   __typename?: 'ScheduledPipelineItemsTeamMetricsResult'
   completedScheduledCount: Scalars['Int']
   overdueScheduledCount: Scalars['Int']
   totalScheduledCount: Scalars['Int']
}

export type ScheduledPipelineItemsTeamStatsResponse =
   | InvalidDateTimeRange
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | ScheduledPipelineItemsTeamStatsResult

export type ScheduledPipelineItemsTeamStatsResult = {
   __typename?: 'ScheduledPipelineItemsTeamStatsResult'
   dateTimeRange: Scalars['String']
   totalCount: Scalars['Int']
   userWiseStats: Array<ScheduledPipelineItemsUserStats>
}

export type ScheduledPipelineItemsUserMetricsResponse =
   | AccessDeniedForUser
   | InvalidDateRange
   | ScheduledPipelineItemsUserMetricsResult
   | UserNotFound

export type ScheduledPipelineItemsUserMetricsResult = {
   __typename?: 'ScheduledPipelineItemsUserMetricsResult'
   completedScheduledCount: Scalars['Int']
   overdueScheduledCount: Scalars['Int']
   totalScheduledCount: Scalars['Int']
   userId: Scalars['String']
}

export type ScheduledPipelineItemsUserStats = {
   __typename?: 'ScheduledPipelineItemsUserStats'
   completedScheduledCount: Scalars['Int']
   overdueScheduledCount: Scalars['Int']
   totalScheduledCount: Scalars['Int']
   user: BaseUser
}

export type ScheduledPipelineItemsV2Result = {
   __typename?: 'ScheduledPipelineItemsV2Result'
   pipelineItemSchedules: Array<PipelineItemSchedule>
   totalCount: Scalars['Int']
}

export type ScheduledReminderMustBeInFuture = GraphQlBaseError & {
   __typename?: 'ScheduledReminderMustBeInFuture'
   message?: Maybe<Scalars['String']>
   remindBeforeInMins: Scalars['Int']
}

export type ScheduledRemindersMustBeInFuture = GraphQlBaseError & {
   __typename?: 'ScheduledRemindersMustBeInFuture'
   message?: Maybe<Scalars['String']>
   remindersInMins: Array<Scalars['Int']>
}

export type ScheduledTrigger = BaseTrigger & {
   __typename?: 'ScheduledTrigger'
   allowManualTrigger?: Maybe<Scalars['Boolean']>
   automationWorkflowId: Scalars['String']
   dayConfig?: Maybe<ScheduledTriggerDayConfig>
   entity: TriggerEntity
   entityTemplateId: Scalars['String']
   filterSetId: Scalars['String']
   minutes?: Maybe<Scalars['Int']>
   monthConfig: Array<ScheduledTriggerMonthConfig>
   name?: Maybe<Scalars['String']>
   rootNodeIds: Array<Scalars['String']>
   scheduleType?: Maybe<ScheduleTypeEnum>
   triggerId: Scalars['String']
   triggerType: TriggerType
   weekConfig?: Maybe<ScheduledTriggerWeekConfig>
}

export type ScheduledTriggerAtLeastHaveOneFilterCondition = GraphQlBaseError & {
   __typename?: 'ScheduledTriggerAtLeastHaveOneFilterCondition'
   message?: Maybe<Scalars['String']>
   triggerId: Scalars['String']
}

export type ScheduledTriggerConfig = {
   __typename?: 'ScheduledTriggerConfig'
   nodes: Array<NodeType>
   triggerEntity: ScheduleTriggerEntity
}

export type ScheduledTriggerDayConfig = {
   __typename?: 'ScheduledTriggerDayConfig'
   time: Scalars['String']
}

export type ScheduledTriggerMonthConfig = {
   __typename?: 'ScheduledTriggerMonthConfig'
   daysCount: Scalars['Int']
   monthDay: MonthDayEnum
   time: Scalars['String']
}

export type ScheduledTriggerWeekConfig = {
   __typename?: 'ScheduledTriggerWeekConfig'
   time: Scalars['String']
   weekDays: Array<WeekDayEnum>
}

export type ScheduledWeekdaysShouldNotBeEmpty = GraphQlBaseError & {
   __typename?: 'ScheduledWeekdaysShouldNotBeEmpty'
   message?: Maybe<Scalars['String']>
}

export type SchedulesOnPipelineItemResponse =
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | SchedulesOnPipelineItemResult

export type SchedulesOnPipelineItemResult = {
   __typename?: 'SchedulesOnPipelineItemResult'
   schedules: Array<ScheduledPipelineItem>
}

export type SchedulesOnPipelineItemV2Response =
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | SchedulesOnPipelineItemV2Result

export type SchedulesOnPipelineItemV2Result = {
   __typename?: 'SchedulesOnPipelineItemV2Result'
   schedules: Array<PipelineItemSchedule>
}

export type ScorecardChart = {
   __typename?: 'ScorecardChart'
   comparisonDiff?: Maybe<Scalars['String']>
   comparisonDiffDisplayValue?: Maybe<Scalars['String']>
   displayValue: Scalars['String']
   graphId: Scalars['String']
   metricName: Scalars['String']
   value: Scalars['String']
}

export type ScorecardChartConfig = {
   __typename?: 'ScorecardChartConfig'
   analyticsLevel: AnalyticsLevel
   comparisonType: ScorecardComparisonType
   comparisonValue?: Maybe<ComparisonValue>
   dataSources: Array<AnalyticsDataSourceType>
   dataSourcesWithDisplayNames: Array<DataSourceDisplayName>
   description?: Maybe<Scalars['String']>
   filterSetId: Scalars['String']
   graphId: Scalars['String']
   isOwner: Scalars['Boolean']
   metric: GraphMetric
   name: Scalars['String']
   pipelineId: Scalars['String']
   quickFilterFields: Array<GraphQuickFilterField>
   roles: Array<Role>
}

export type ScorecardChartResult =
   | DashboardAccessDenied
   | DashboardNotFound
   | GraphAccessDenied
   | GraphNotFound
   | ScorecardChart
   | ViewAccessDenied
   | ViewNotFound

export enum ScorecardComparisonType {
   Metric = 'METRIC',
   None = 'NONE',
   Value = 'VALUE'
}

export enum ScoringConditionOperator {
   Contains = 'CONTAINS',
   Empty = 'EMPTY',
   Eq = 'EQ',
   Gt = 'GT',
   Gte = 'GTE',
   In = 'IN',
   InTheLast = 'IN_THE_LAST',
   InTheNext = 'IN_THE_NEXT',
   Is = 'IS',
   IsAfter = 'IS_AFTER',
   IsBefore = 'IS_BEFORE',
   IsIn = 'IS_IN',
   IsNot = 'IS_NOT',
   Lt = 'LT',
   Lte = 'LTE',
   Ne = 'NE',
   NotEmpty = 'NOT_EMPTY',
   NotIn = 'NOT_IN',
   NotInRange = 'NOT_IN_RANGE',
   Range = 'RANGE'
}

export type ScoringConfig = {
   __typename?: 'ScoringConfig'
   crmTemplateId: Scalars['String']
   isScoringConfigPublished: Scalars['Boolean']
   parameters: Array<ScoringParameter>
   recalculationConfig: ScoringRecalculationConfig
   scoringConfigId: Scalars['String']
   status: ScoringConfigStatus
}

export type ScoringConfigConditionMultiValueResponse = {
   __typename?: 'ScoringConfigConditionMultiValueResponse'
   responses: Array<ScoringConfigConditionValue>
}

export type ScoringConfigConditionValue =
   | BaseUser
   | DateFilterRelativeConfig
   | DateRange
   | DateTimeFilterRelativeConfig
   | DateTimeRange
   | FloatRange
   | GqlBooleanType
   | GqlDateTimeType
   | GqlDateType
   | GqlFloatType
   | GqlIntType
   | GqlStringType
   | GqlTimeType
   | IntegerRange
   | PhoneNumberResponse
   | Stage
   | TimeRange

export type ScoringConfigConditionValueResponse = {
   __typename?: 'ScoringConfigConditionValueResponse'
   response?: Maybe<ScoringConfigConditionValue>
}

export type ScoringConfigIsNotActive = GraphQlBaseError & {
   __typename?: 'ScoringConfigIsNotActive'
   message?: Maybe<Scalars['String']>
   scoringConfigId: Scalars['String']
}

export type ScoringConfigNotFound = GraphQlBaseError & {
   __typename?: 'ScoringConfigNotFound'
   message?: Maybe<Scalars['String']>
   scoringConfigId: Scalars['String']
}

export type ScoringConfigShouldHaveAtLeastOnePublishedVersion = GraphQlBaseError & {
   __typename?: 'ScoringConfigShouldHaveAtLeastOnePublishedVersion'
   message?: Maybe<Scalars['String']>
   scoringConfigId: Scalars['String']
}

export enum ScoringConfigState {
   Editable = 'EDITABLE',
   Published = 'PUBLISHED'
}

export enum ScoringConfigStatus {
   Active = 'ACTIVE',
   Inactive = 'INACTIVE'
}

export type ScoringConfigValueResponseType =
   | ScoringConfigConditionMultiValueResponse
   | ScoringConfigConditionValueResponse

export type ScoringParameter = {
   __typename?: 'ScoringParameter'
   conditions: Array<ParameterCondition>
   fieldId: Scalars['String']
   parameterId: Scalars['String']
   scoringConfigId: Scalars['String']
   weightage?: Maybe<Scalars['Float']>
}

export type ScoringParameterNotFound = GraphQlBaseError & {
   __typename?: 'ScoringParameterNotFound'
   message?: Maybe<Scalars['String']>
   scoringParameterId: Scalars['String']
}

export type ScoringParameterParams = {
   fieldId: Scalars['String']
   weightage?: InputMaybe<Scalars['Float']>
}

export type ScoringRecalculationConfig = {
   __typename?: 'ScoringRecalculationConfig'
   filterSetId: Scalars['String']
   lastExecutedAt?: Maybe<Scalars['String']>
   recalculationConfigId: Scalars['String']
   sortByFields: Array<SortByField>
   status: ScoringRecalculationStatus
}

export type ScoringRecalculationConfigAtLeastHaveOneFilterCondition = GraphQlBaseError & {
   __typename?: 'ScoringRecalculationConfigAtLeastHaveOneFilterCondition'
   message?: Maybe<Scalars['String']>
   recalculationConfigId: Scalars['String']
}

export type ScoringRecalculationConfigAtLeastHaveOneSortByField = GraphQlBaseError & {
   __typename?: 'ScoringRecalculationConfigAtLeastHaveOneSortByField'
   message?: Maybe<Scalars['String']>
   recalculationConfigId: Scalars['String']
}

export type ScoringRecalculationConfigIsInRunningState = GraphQlBaseError & {
   __typename?: 'ScoringRecalculationConfigIsInRunningState'
   message?: Maybe<Scalars['String']>
   recalculationConfigId: Scalars['String']
}

export type ScoringRecalculationConfigNotFound = GraphQlBaseError & {
   __typename?: 'ScoringRecalculationConfigNotFound'
   message?: Maybe<Scalars['String']>
   recalculationConfigId: Scalars['String']
}

export type ScoringRecalculationExecLog = {
   __typename?: 'ScoringRecalculationExecLog'
   completedAt?: Maybe<Scalars['String']>
   execLogId: Scalars['String']
   failedItemsCount?: Maybe<Scalars['Int']>
   initiatedAt: Scalars['String']
   initiatedBy: BaseUser
   matchedItemsCount: Scalars['Int']
   status: ScoringRecalculationLogStatus
   successfulItemsCount?: Maybe<Scalars['Int']>
}

export type ScoringRecalculationExecLogsResult = {
   __typename?: 'ScoringRecalculationExecLogsResult'
   execLogs: Array<ScoringRecalculationExecLog>
   totalCount: Scalars['Int']
}

export enum ScoringRecalculationLogStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS'
}

export enum ScoringRecalculationStatus {
   InProgress = 'IN_PROGRESS',
   NotStarted = 'NOT_STARTED'
}

export type ScrutinyAlreadyGenerated = GraphQlBaseError & {
   __typename?: 'ScrutinyAlreadyGenerated'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
   scrutinyKey: Scalars['String']
}

export type ScrutinyDataNotFound = GraphQlBaseError & {
   __typename?: 'ScrutinyDataNotFound'
   applicationId: Scalars['String']
   displayText: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ScrutinyKeyGenerationAccessDenied = GraphQlBaseError & {
   __typename?: 'ScrutinyKeyGenerationAccessDenied'
   message: Scalars['String']
}

export type ScrutinyKeyGenerationIsDisabled = GraphQlBaseError & {
   __typename?: 'ScrutinyKeyGenerationIsDisabled'
   message: Scalars['String']
}

export type ScrutinyNotInitiated = GraphQlBaseError & {
   __typename?: 'ScrutinyNotInitiated'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type ScrutinyReportMultimedia = {
   __typename?: 'ScrutinyReportMultimedia'
   animation?: Maybe<Animation>
   backgroundImageUrl?: Maybe<Scalars['String']>
   iconUrl?: Maybe<Scalars['String']>
   imageUrl?: Maybe<Scalars['String']>
}

export type ScrutinyReportStatusDetails = {
   __typename?: 'ScrutinyReportStatusDetails'
   status: ScrutinyStatus
}

export enum ScrutinyStatus {
   Created = 'CREATED',
   Failed = 'FAILED',
   Initiated = 'INITIATED',
   InProgress = 'IN_PROGRESS',
   ProcessingFailed = 'PROCESSING_FAILED',
   Success = 'SUCCESS'
}

export type ScrutinyStep = {
   __typename?: 'ScrutinyStep'
   completionDescription?: Maybe<Scalars['String']>
   completionPercentage?: Maybe<Scalars['Int']>
   completionTitle?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   endDatetime?: Maybe<Scalars['String']>
   failureDescription?: Maybe<Scalars['String']>
   failureTitle?: Maybe<Scalars['String']>
   startDatetime?: Maybe<Scalars['String']>
   status?: Maybe<ScrutinyStepStatus>
   stepActions: Array<ScrutinyStepActionEnum>
   title?: Maybe<Scalars['String']>
}

export enum ScrutinyStepActionEnum {
   DownloadDrawingFile = 'DOWNLOAD_DRAWING_FILE',
   ViewScrutinyReport = 'VIEW_SCRUTINY_REPORT'
}

export enum ScrutinyStepStatus {
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   Success = 'SUCCESS',
   YetToStart = 'YET_TO_START'
}

export type SearchActivityTemplatesParams = {
   pagination: Pagination
   pipelineIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   pipelineItemTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   searchQuery?: InputMaybe<Scalars['String']>
   shouldIgnoreReferenceIdFilter?: InputMaybe<Scalars['Boolean']>
}

export type SearchActivityTemplatesResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelinesAccessDenied
   | PipelinesNotFound
   | SearchActivityTemplatesResult

export type SearchActivityTemplatesResult = {
   __typename?: 'SearchActivityTemplatesResult'
   activityTemplates: Array<BaseActivityTemplate>
   totalCount: Scalars['Int']
}

export type SearchAgentAllocationGroupsParams = {
   excludeAgentAllocationGroupIds: Array<Scalars['String']>
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchAgentAllocationGroupsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchAgentAllocationGroupsResult
   | UserIsNotAnAdministrator

export type SearchAgentAllocationGroupsResult = {
   __typename?: 'SearchAgentAllocationGroupsResult'
   agentAllocationGroups: Array<AgentAllocationGroup>
   totalCount: Scalars['Int']
}

export type SearchAgentsForManagerParams = {
   managerId: Scalars['String']
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchAgentsForManagerResponse =
   | DeactivatedManager
   | InvalidLimit
   | InvalidOffset
   | ManagerNotFound
   | PaginationLimitExceeded
   | SearchAgentsForManagerResult
   | UserIsNotAnAdministrator

export type SearchAgentsForManagerResult = {
   __typename?: 'SearchAgentsForManagerResult'
   agents: Array<BaseUser>
   totalCount: Scalars['Int']
}

export type SearchAllowedFieldsInPortalApplicationParams = {
   pagination: Pagination
   portalApplicationId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchAllowedFieldsInPortalApplicationResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PortalApplicationNotFound
   | SearchAllowedFieldsInPortalApplicationResult
   | UserIsNotAnAdministrator

export type SearchAllowedFieldsInPortalApplicationResult = {
   __typename?: 'SearchAllowedFieldsInPortalApplicationResult'
   fields: Array<Field>
   totalCount: Scalars['Int']
}

export type SearchAndMonitoringAccessControlConfigNotFound = GraphQlBaseError & {
   __typename?: 'SearchAndMonitoringAccessControlConfigNotFound'
   authority: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type SearchAndMonitoringAccessControlRulesNotFound = GraphQlBaseError & {
   __typename?: 'SearchAndMonitoringAccessControlRulesNotFound'
   authority: Scalars['String']
   designation: Scalars['String']
   message?: Maybe<Scalars['String']>
   organizationLevel: Scalars['String']
}

export type SearchAndMonitoringApplicationConditionParams = {
   fieldId: Scalars['String']
   operator: FilterOperator
   value?: InputMaybe<Scalars['String']>
}

export type SearchAndMonitoringApplicationData = {
   __typename?: 'SearchAndMonitoringApplicationData'
   accessType: PipelineItemAccessType
   applicationId: Scalars['String']
   applicationTemplateId: Scalars['String']
   mainPipelineId?: Maybe<Scalars['String']>
   properties: Array<ApplicationProperty>
}

export type SearchAndMonitoringApplicationsParams = {
   conditions: Array<SearchAndMonitoringApplicationConditionParams>
   pagination: Pagination
}

export type SearchAndMonitoringApplicationsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchAndMonitoringAccessControlConfigNotFound
   | SearchAndMonitoringAccessControlRulesNotFound
   | SearchAndMonitoringApplicationsResult
   | UserAuthorityNotFound
   | UserDesignationNotFound
   | UserOrganizationLevelNotFound

export type SearchAndMonitoringApplicationsResult = {
   __typename?: 'SearchAndMonitoringApplicationsResult'
   applications: Array<SearchAndMonitoringApplicationData>
   totalCount: Scalars['Int']
}

export type SearchAndMonitoringFieldConfig = {
   __typename?: 'SearchAndMonitoringFieldConfig'
   dependentOptions?: Maybe<SearchAndMonitoringFieldDependentOptionsConfig>
   fieldId: Scalars['String']
   fieldType: ApplicationPropertyType
   name: Scalars['String']
   optionConfigs: Array<SearchAndMonitoringOptionConfig>
   options?: Maybe<Array<Maybe<Scalars['String']>>>
   parentFieldId?: Maybe<Scalars['String']>
   pipelineItemTemplateFields: Array<
      SearchAndMonitoringPipelineItemTemplateField
   >
}

export type SearchAndMonitoringFieldDependentOptionMapping = {
   __typename?: 'SearchAndMonitoringFieldDependentOptionMapping'
   dependentOptions: Array<Scalars['String']>
   parentFieldOption: Scalars['String']
}

export type SearchAndMonitoringFieldDependentOptionsConfig = {
   __typename?: 'SearchAndMonitoringFieldDependentOptionsConfig'
   optionsMappings: Array<SearchAndMonitoringFieldDependentOptionMapping>
   parentFieldId: Scalars['String']
}

export type SearchAndMonitoringFilterField = {
   __typename?: 'SearchAndMonitoringFilterField'
   fieldId: Scalars['String']
   operators: Array<FilterOperator>
}

export type SearchAndMonitoringOptionConfig = {
   __typename?: 'SearchAndMonitoringOptionConfig'
   option: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
}

export type SearchAndMonitoringPipelineItemTemplateField = {
   __typename?: 'SearchAndMonitoringPipelineItemTemplateField'
   field: Field
   pipelineItemTemplateId: Scalars['String']
}

export type SearchApplicationAssigneesParams = {
   applicationId: Scalars['String']
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchApplicationAssigneesResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchUsers

export type SearchApplicationCondition = {
   fieldId: Scalars['String']
   operator: FilterOperator
   value?: InputMaybe<Scalars['String']>
}

export type SearchApplicationInPortalResult = {
   __typename?: 'SearchApplicationInPortalResult'
   fileNumber: Scalars['String']
   internalPipelineId?: Maybe<Scalars['String']>
   pipeline: BasePipeline
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   stage: Stage
   stageId?: Maybe<Scalars['String']>
}

export type SearchApplicationsForAlterationParams = {
   fieldReferenceId: Scalars['String']
   pagination: Pagination
   portalId: Scalars['String']
   portalType: PortalType
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchApplicationsForAlterationResponse =
   | DisplayStagesNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemTemplatesNotFound
   | PortalNotFound
   | SearchApplicationsForAlterationResult

export type SearchApplicationsForAlterationResult = {
   __typename?: 'SearchApplicationsForAlterationResult'
   pipelineItems: Array<SearchPipelineItemPrimaryDetails>
   totalCount: Scalars['Int']
}

export type SearchApplicationsInPortalParams = {
   pagination: Pagination
   portalId: Scalars['String']
   portalType: PortalType
   searchQuery: Scalars['String']
}

export type SearchApplicationsInPortalResponse =
   | PortalNotFound
   | SearchApplicationsInPortalResult

export type SearchApplicationsInPortalResult = {
   __typename?: 'SearchApplicationsInPortalResult'
   applications: Array<SearchApplicationInPortalResult>
   totalCount: Scalars['Int']
}

export type SearchApplicationsParams = {
   captchaToken?: InputMaybe<Scalars['String']>
   conditions: Array<SearchApplicationCondition>
   pagination: Pagination
}

export type SearchApplicationsResponse =
   | AllPublicSearchCategoryFieldsAreRequired
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchApplicationsResult

export type SearchApplicationsResult = {
   __typename?: 'SearchApplicationsResult'
   applications: Array<ApplicationData>
   totalCount: Scalars['Int']
}

export type SearchAssigneesParams = {
   entity: SalesTemplateType
   leadId?: InputMaybe<Scalars['String']>
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchAssigneesResponse =
   | InvalidLimit
   | InvalidOffset
   | LeadAccessDenied
   | LeadIdIsRequired
   | LeadIsDeleted
   | LeadNotFound
   | PaginationLimitExceeded
   | PipelinesNotFound
   | RequestedUserIsNotManager
   | SearchUsers

export type SearchAutomationWorkflowsParams = {
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
   triggerTypes?: InputMaybe<Array<TriggerType>>
}

export type SearchAutomationWorkflowsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelinesAccessDenied
   | PipelinesNotFound
   | SearchAutomationWorkflowsResult
   | UserIsNotAnAdministrator

export type SearchAutomationWorkflowsResult = {
   __typename?: 'SearchAutomationWorkflowsResult'
   automationWorkflows: Array<BaseAutomationWorkflow>
   totalCount: Scalars['Int']
}

export type SearchContactAssigneesParams = {
   contactId: Scalars['String']
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchContactAssigneesResponse =
   | ContactAccessDenied
   | ContactIsDeleted
   | ContactNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchUsers

export type SearchCustomPaymentRulesParams = {
   pipelineItemTemplateId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchCustomPaymentRulesResponse =
   | PipelineItemTemplateAccessDenied
   | PipelineItemTemplateNotFound
   | SearchCustomPaymentRulesResult

export type SearchCustomPaymentRulesResult = {
   __typename?: 'SearchCustomPaymentRulesResult'
   rules: Array<PaymentRuleOverviewDetails>
}

export type SearchDealAssigneesParams = {
   dealId: Scalars['String']
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchDealAssigneesResponse =
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchUsers

export type SearchDealsParams = {
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchDealsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchDealsResult

export type SearchDealsResult = {
   __typename?: 'SearchDealsResult'
   deals: Array<DealPrimaryDetails>
   totalCount: Scalars['Int']
}

export type SearchDocumentVerificationUsersParams = {
   buttonId: Scalars['String']
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
   tabId: Scalars['String']
}

export type SearchDocumentVerificationUsersResponse =
   | DocumentVerificationButtonNotFount
   | DocumentVerificationTabNotFount
   | SearchDocumentVerificationUsersResult

export type SearchDocumentVerificationUsersResult = {
   __typename?: 'SearchDocumentVerificationUsersResult'
   totalCount: Scalars['Int']
   users: Array<DocumentVerificationUser>
}

export type SearchEntityFeeRuleSetCustomHeadersParams = {
   entityRuleSetId: Scalars['String']
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchEntityFeeRuleSetCustomHeadersResponse =
   | EntityFeeRuleSetNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchEntityFeeRuleSetCustomHeadersResult

export type SearchEntityFeeRuleSetCustomHeadersResult = {
   __typename?: 'SearchEntityFeeRuleSetCustomHeadersResult'
   feeHeaders: Array<FeeHeader>
   totalCount: Scalars['Int']
}

export type SearchFeePaymentOrderCreationConfigsParams = {
   configTypes: Array<OrderCreationConfigType>
   pipelineItemTemplateId: Scalars['String']
}

export type SearchFeePaymentOrderCreationConfigsResponse =
   | PipelineItemTemplateNotFound
   | SearchFeePaymentOrderCreationConfigsResult
   | UserIsNotAnAdministrator

export type SearchFeePaymentOrderCreationConfigsResult = {
   __typename?: 'SearchFeePaymentOrderCreationConfigsResult'
   feePaymentOrderCreationConfigs: Array<FeePaymentOrderCreationConfig>
}

export type SearchFieldsParams = {
   excludeFieldIds?: InputMaybe<Array<Scalars['String']>>
   excludeFieldTypes?: InputMaybe<Array<FieldType>>
   excludeFormulaFields?: InputMaybe<Scalars['Boolean']>
   excludeSystemFields?: InputMaybe<Array<SystemFieldEnum>>
   fieldTypes: Array<FieldType>
   filterAddAnotherFields?: InputMaybe<Scalars['Boolean']>
   filterCustomObjPrimaryDisplayFields?: InputMaybe<Scalars['Boolean']>
   filterDependentFields?: InputMaybe<Scalars['Boolean']>
   filterIdentificationFields?: InputMaybe<Scalars['Boolean']>
   filterUniqueFields?: InputMaybe<Scalars['Boolean']>
   includeSystemFields?: InputMaybe<Array<SystemFieldEnum>>
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
   salesTemplateIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchFieldsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineNotFound
   | SalesTemplateFieldsResult
   | SalesTemplatesAccessDenied
   | SalesTemplatesNotFound

export type SearchFriendsParams = {
   pagination: Pagination
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   searchPipelineIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchFriendsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemNotFound
   | PipelinesNotFound
   | SearchFriendsResult

export type SearchFriendsResult = {
   __typename?: 'SearchFriendsResult'
   totalCount: Scalars['Int']
   users: Array<BaseUser>
}

export type SearchGraphFieldsParams = {
   dataSources: Array<AnalyticsDataSourceType>
   excludeFieldIds?: InputMaybe<Array<Scalars['String']>>
   excludeSystemFields?: InputMaybe<Array<SystemFieldEnum>>
   fieldTypes: Array<FieldType>
   graphContextType: FieldsContextType
   pipelineId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchGraphFieldsResponse =
   | GraphDataSourceFieldsResult
   | PipelineAccessDenied
   | PipelineNotFound

export type SearchIdentificationFieldsParams = {
   fieldTypes: Array<FieldType>
   pagination: Pagination
   salesTemplateIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchIdentificationFieldsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SalesTemplateFieldsResult
   | SalesTemplatesAccessDenied
   | SalesTemplatesNotFound

export type SearchIdentificationsParams = {
   identificationTypes: Array<IdentificationType>
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchIdentificationsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelinesNotFound
   | SearchIdentificationsResult
   | UserIsNotAnAdministrator

export type SearchIdentificationsResult = {
   __typename?: 'SearchIdentificationsResult'
   identifications: Array<IdentificationOverviewDetails>
   totalCount: Scalars['Int']
}

export type SearchLeadAssigneesParams = {
   leadId: Scalars['String']
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchLeadAssigneesResponse =
   | InvalidLimit
   | InvalidOffset
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound
   | PaginationLimitExceeded
   | SearchUsers

export type SearchLeadCreationAllowedStagesParams = {
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchLeadCreationAllowedStagesResponse =
   | InvalidLimit
   | InvalidOffset
   | NotLeadPipelines
   | PaginationLimitExceeded
   | PipelinesAccessDenied
   | PipelinesNotFound
   | Stages

export type SearchLeadsParams = {
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchLeadsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchLeadsResult

export type SearchLeadsResult = {
   __typename?: 'SearchLeadsResult'
   leads: Array<LeadPrimaryDetails>
   totalCount: Scalars['Int']
}

export type SearchManagerForAgentsParams = {
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
   userIds: Array<Scalars['String']>
}

export type SearchManagerForAgentsResponse =
   | DeactivatedUsers
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchManagerForAgentsResult
   | UserIsNotAnAdministrator
   | UsersAreNotInSameAccount
   | UsersNotFound

export type SearchManagerForAgentsResult = {
   __typename?: 'SearchManagerForAgentsResult'
   managers: Array<BaseUser>
   totalCount: Scalars['Int']
}

export type SearchOfficerManagementUserResponse =
   | OfficerManagementAccessDenied
   | SearchOfficerManagementUserResult

export type SearchOfficerManagementUserResult = {
   __typename?: 'SearchOfficerManagementUserResult'
   totalCount: Scalars['Int']
   users: Array<User>
}

export type SearchOfficerManagementUsersParams = {
   includeNewUsers?: InputMaybe<Scalars['Boolean']>
   pagination?: InputMaybe<Pagination>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchPaymentRuleSetsParams = {
   pipelineItemTemplateId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchPaymentRuleSetsResponse =
   | PipelineItemTemplateAccessDenied
   | PipelineItemTemplateNotFound
   | SearchPaymentRuleSetsResult

export type SearchPaymentRuleSetsResult = {
   __typename?: 'SearchPaymentRuleSetsResult'
   ruleSets: Array<PaymentRuleSetOverviewDetails>
}

export type SearchPipelineCustomObjectAssigneesParams = {
   pagination: Pagination
   pipelineCustomObjectId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchPipelineCustomObjectAssigneesResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound
   | SearchUsers

export type SearchPipelineItemFieldsParams = {
   fieldTypes: Array<FieldType>
   pagination: Pagination
   pipelineItemId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchPipelineItemFieldsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | SearchPipelineItemFieldsResult

export type SearchPipelineItemFieldsResult = {
   __typename?: 'SearchPipelineItemFieldsResult'
   fields: Array<FieldResponse>
   totalCount: Scalars['Int']
}

export type SearchPipelineItemPrimaryDetails = {
   __typename?: 'SearchPipelineItemPrimaryDetails'
   customIds: Array<Scalars['String']>
   emails: Array<Scalars['String']>
   name?: Maybe<Scalars['String']>
   phoneNumbers: Array<PhoneNumberResponse>
   pipelineItemId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   stage?: Maybe<Stage>
}

export type SearchPipelineItemTemplateFieldsToLogParams = {
   pipelineItemTemplateId: Scalars['String']
}

export type SearchPipelineItemTemplateFieldsToLogResponse =
   | PipelineItemTemplatesNotFound
   | SearchPipelineItemTemplateFieldsToLogResult
   | UserIsNotAnAdministrator

export type SearchPipelineItemTemplateFieldsToLogResult = {
   __typename?: 'SearchPipelineItemTemplateFieldsToLogResult'
   field: FieldPrimaryDetails
}

export type SearchPipelineItemTemplateLinkedFieldsParams = {
   excludeFieldIds?: InputMaybe<Array<Scalars['String']>>
   excludeFieldTypes?: InputMaybe<Array<FieldType>>
   excludeFormulaFields?: InputMaybe<Scalars['Boolean']>
   excludeSystemFields?: InputMaybe<Array<SystemFieldEnum>>
   fieldTypes: Array<FieldType>
   filterAddAnotherFields?: InputMaybe<Scalars['Boolean']>
   filterCustomObjPrimaryDisplayFields?: InputMaybe<Scalars['Boolean']>
   filterDependentFields?: InputMaybe<Scalars['Boolean']>
   filterIdentificationFields?: InputMaybe<Scalars['Boolean']>
   filterUniqueFields?: InputMaybe<Scalars['Boolean']>
   includeSystemFields?: InputMaybe<Array<SystemFieldEnum>>
   pagination: Pagination
   pipelineItemTemplateIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchPipelineItemTemplateLinkedFieldsResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineItemTemplatesAccessDenied
   | PipelineItemTemplatesNotFound
   | SalesTemplateFieldsResult

export type SearchPipelineItemsParams = {
   canSearchOnAllFields: Scalars['Boolean']
   excludePipelineItemIds?: InputMaybe<Array<Scalars['String']>>
   fieldIds: Array<Scalars['String']>
   pagination: Pagination
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId?: InputMaybe<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchPipelineItemsResponse =
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidLimit
   | InvalidOffset
   | NotAllowedFieldsForGlobalSearch
   | NotSupportedSalesTemplateFields
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineItemTemplateAccessDenied
   | PipelineItemTemplateNotFound
   | PipelineNotFound
   | SearchPipelineItemsResult
   | SearchQueryIsRequired

export type SearchPipelineItemsResult = {
   __typename?: 'SearchPipelineItemsResult'
   pipelineItems: Array<SearchPipelineItemPrimaryDetails>
   totalCount: Scalars['Int']
}

export type SearchPortalUserApplicationsParams = {
   displayStageIds: Array<Scalars['String']>
   pagination: Pagination
   pipelineItemTemplateIds: Array<Scalars['String']>
   portalId: Scalars['String']
   portalType: PortalType
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchPortalUserApplicationsResponse =
   | DisplayStagesNotFound
   | InvalidLimit
   | InvalidOffset
   | NotPortalUser
   | PaginationLimitExceeded
   | PipelineItemTemplatesNotFound
   | PortalNotFound
   | SearchPortalUserApplicationsResult

export type SearchPortalUserApplicationsResult = {
   __typename?: 'SearchPortalUserApplicationsResult'
   pipelineItems: Array<SearchPipelineItemPrimaryDetails>
   totalCount: Scalars['Int']
}

export type SearchQueryIsRequired = GraphQlBaseError & {
   __typename?: 'SearchQueryIsRequired'
   message?: Maybe<Scalars['String']>
}

export type SearchRelationFieldsForMappingParams = {
   crmEntityTemplateId: Scalars['String']
   excludeFieldIds?: InputMaybe<Array<Scalars['String']>>
   mappingRelationId: Scalars['String']
   pagination: Pagination
   relationId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchRelationFieldsForMappingResponse =
   | CrmEntityTemplateNotFound
   | CrmPipelineItemTemplateNotLinkedToRelation
   | DuplicateRelationsFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | RelationFieldNotSupportedInCrmEntityTemplate
   | RelationsAreDeleted
   | RelationsAreNotFound
   | SearchRelationFieldsForMappingResult
   | UserIsNotAnAdministrator

export type SearchRelationFieldsForMappingResult = {
   __typename?: 'SearchRelationFieldsForMappingResult'
   fields: Array<RelationField>
   totalCount: Scalars['Int']
}

export type SearchRolesInPipelineParams = {
   pagination: Pagination
   pipelineId: Scalars['String']
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchRolesInPipelineResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelineAccessDenied
   | PipelineNotFound
   | SearchRolesInPipelineResult

export type SearchRolesInPipelineResult = {
   __typename?: 'SearchRolesInPipelineResult'
   roles: Array<Role>
   totalCount: Scalars['Int']
}

export type SearchScoringParameterFields = {
   __typename?: 'SearchScoringParameterFields'
   fields: Array<Field>
   totalCount: Scalars['Int']
}

export type SearchScoringParameterFieldsParams = {
   crmTemplateIds: Array<Scalars['String']>
   excludeFieldIds: Array<Scalars['String']>
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchScoringParameterFieldsResponse =
   | CrmTemplatesAccessDenied
   | CrmTemplatesNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchScoringParameterFields

export type SearchStagesParams = {
   isApplicationDisplayStage?: InputMaybe<Scalars['Boolean']>
   pagination: Pagination
   pipelineTemplateIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
   stageFieldId?: InputMaybe<Scalars['String']>
}

export type SearchStagesResponse =
   | InvalidLimit
   | InvalidOffset
   | NotStageFieldId
   | PaginationLimitExceeded
   | PipelineItemTemplatesNotFound
   | Stages

export type SearchTaskAssigneesParams = {
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
}

export type SearchTaskAssigneesResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchUsers
   | TaskAccessDenied
   | TaskNotFound

export type SearchTaskTemplatesParams = {
   pagination?: InputMaybe<Pagination>
   pipelineIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchTaskTemplatesResponse =
   | InvalidLimit
   | InvalidOffset
   | PipelinesAccessDenied
   | PipelinesNotFound
   | SearchTaskTemplatesResult

export type SearchTaskTemplatesResult = {
   __typename?: 'SearchTaskTemplatesResult'
   taskTemplates: Array<BaseTaskTemplate>
   totalCount: Scalars['Int']
}

export type SearchUserGroupResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | SearchUserGroupsResult

export type SearchUserGroupsParams = {
   pagination: Pagination
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchUserGroupsResult = {
   __typename?: 'SearchUserGroupsResult'
   totalCount: Scalars['Int']
   userGroups: Array<UserGroup>
}

export type SearchUsernamesParams = {
   pagination?: InputMaybe<Pagination>
   searchQuery?: InputMaybe<Scalars['String']>
}

export type SearchUsernamesResponse =
   | AccessDenied
   | InvalidLimit
   | InvalidOffset
   | InvalidSearchCriteria
   | OfficerManagementAccessDenied
   | PaginationLimitExceeded
   | UsernameSearchResult

export type SearchUsers = {
   __typename?: 'SearchUsers'
   totalCount: Scalars['Int']
   users: Array<BaseUser>
}

export type SearchUsersParams = {
   excludeUserIds?: InputMaybe<Array<Scalars['String']>>
   pagination: Pagination
   pipelineIds: Array<Scalars['String']>
   searchQuery?: InputMaybe<Scalars['String']>
   shouldExcludeDeactivatedUsers?: InputMaybe<Scalars['Boolean']>
}

export type SearchUsersResponse =
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | PipelinesAccessDenied
   | PipelinesNotFound
   | SearchUsers

export type SecondDegreeRelationNotInFirstRelationPipelineItemTemplate = GraphQlBaseError & {
   __typename?: 'SecondDegreeRelationNotInFirstRelationPipelineItemTemplate'
   message?: Maybe<Scalars['String']>
   secondDegreeRelationId: Scalars['String']
}

export type SecondsShouldBePositive = GraphQlBaseError & {
   __typename?: 'SecondsShouldBePositive'
   message?: Maybe<Scalars['String']>
}

export type SectionCard = BaseCard & {
   __typename?: 'SectionCard'
   cardType: TabCardType
   gofId: Scalars['String']
   sectionUiStyle: SectionTabUiStyle
}

export type SectionCustomTable = {
   __typename?: 'SectionCustomTable'
   columns: Array<SectionCustomTableColumn>
   customFieldsSections: Array<SectionCustomTableFieldsSection>
   name: Scalars['String']
   rows: Array<SectionCustomTableRow>
   tableId: Scalars['String']
}

export type SectionCustomTableCell = {
   __typename?: 'SectionCustomTableCell'
   columnName: Scalars['String']
   fieldId?: Maybe<Scalars['String']>
   label?: Maybe<Scalars['String']>
}

export type SectionCustomTableColumn = {
   __typename?: 'SectionCustomTableColumn'
   allowNegativeNumber?: Maybe<Scalars['Boolean']>
   columnName: Scalars['String']
   columnType: SectionCustomTableColumnType
   formula?: Maybe<Scalars['String']>
   isNestedRowsDecider?: Maybe<Scalars['Boolean']>
   noOfDigitsRoundOff?: Maybe<Scalars['Int']>
   parentColumnName?: Maybe<Scalars['String']>
   showChildColumnNames?: Maybe<Scalars['Boolean']>
}

export enum SectionCustomTableColumnType {
   Field = 'FIELD',
   Formula = 'FORMULA',
   NestedColumn = 'NESTED_COLUMN',
   RowHeader = 'ROW_HEADER',
   SNo = 'S_NO'
}

export type SectionCustomTableFieldsSection = {
   __typename?: 'SectionCustomTableFieldsSection'
   fieldIds: Array<Scalars['String']>
   groupName?: Maybe<Scalars['String']>
}

export type SectionCustomTableRow = {
   __typename?: 'SectionCustomTableRow'
   cells: Array<SectionCustomTableCell>
   rowId: Scalars['String']
}

export type SectionParams = {
   gofId?: InputMaybe<Scalars['String']>
   name?: InputMaybe<Scalars['String']>
   orderedFieldIds: Array<Scalars['String']>
   sectionType: SectionType
}

export enum SectionTabUiStyle {
   CustomTable = 'CUSTOM_TABLE',
   Default = 'DEFAULT',
   SetbackTable = 'SETBACK_TABLE',
   Table = 'TABLE'
}

export enum SectionType {
   CustomSection = 'CUSTOM_SECTION',
   Default = 'DEFAULT'
}

export type SectionUnion = CustomSection | DefaultSection

export type SectionsConfigParams = {
   sections: Array<SectionParams>
}

export type SectionsTab = BaseTab & {
   __typename?: 'SectionsTab'
   enableTabStatusIcon: Scalars['Boolean']
   gofIds: Array<Scalars['String']>
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   sections: Array<SectionUnion>
   tabId: Scalars['String']
   tabType: TabType
}

export type SegmentEventTimeStampConfig = {
   __typename?: 'SegmentEventTimeStampConfig'
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type SegmentEventTimeStampConfigParams = {
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export enum SegmentEventType {
   Identify = 'IDENTIFY',
   Track = 'TRACK'
}

export type SegmentIntegrationConfig = {
   __typename?: 'SegmentIntegrationConfig'
   integrations?: Maybe<Array<Scalars['String']>>
   shouldEnableAllIntegrations?: Maybe<Scalars['Boolean']>
}

export type SegmentIntegrationConfigParams = {
   integrations?: InputMaybe<Array<Scalars['String']>>
   shouldEnableAllIntegrations?: InputMaybe<Scalars['Boolean']>
}

export enum SegmentUniqueIdTypeEnum {
   AnonymousId = 'ANONYMOUS_ID',
   UserId = 'USER_ID'
}

export type SegmentUniqueIdValueConfig = {
   __typename?: 'SegmentUniqueIdValueConfig'
   uniqueIdType: SegmentUniqueIdTypeEnum
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type SegmentUniqueIdValueConfigParams = {
   uniqueIdType: SegmentUniqueIdTypeEnum
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type SelectedReferenceFieldIdsRequired = GraphQlBaseError & {
   __typename?: 'SelectedReferenceFieldIdsRequired'
   message?: Maybe<Scalars['String']>
}

export type SelfReferenceIsNotAllowedInFormulaExpression = GraphQlBaseError & {
   __typename?: 'SelfReferenceIsNotAllowedInFormulaExpression'
   formulaExpression: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type SelfRelationIsNotSupported = GraphQlBaseError & {
   __typename?: 'SelfRelationIsNotSupported'
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export enum SelfRelationTarget {
   From = 'FROM',
   To = 'TO'
}

export type SendBackActionDetails = {
   __typename?: 'SendBackActionDetails'
   canSendBackFriend: Scalars['Boolean']
   sendBackToOfficer?: Maybe<BaseUser>
}

export type SendBackFriendParams = {
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type SendBackFriendResponse =
   | FriendConfigurationNotFound
   | FriendFeatureDisabled
   | NoFriendToSendBack
   | NotLatestFriend
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemRemarksCannotBeEmpty
   | PipelineNotFound
   | SendBackFriendResult
   | UnauthorizedSendBack

export type SendBackFriendResult = {
   __typename?: 'SendBackFriendResult'
   clearedFriendFieldId: Scalars['String']
   latestFriendId?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   revertedStageId?: Maybe<Scalars['String']>
}

export type SendDataToSegmentNode = BaseNode & {
   __typename?: 'SendDataToSegmentNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   eventType?: Maybe<SegmentEventType>
   identifyEvent?: Maybe<IdentifyEventConfig>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   trackEvent?: Maybe<TrackEventConfig>
   writeKeyParameterId?: Maybe<Scalars['String']>
}

export type SendDataToSegmentNodeExecLog = BaseNodeExecLog & {
   __typename?: 'SendDataToSegmentNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<SendDataToSegmentNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type SendDataToSegmentNodeExecLogResult = {
   __typename?: 'SendDataToSegmentNodeExecLogResult'
   responseJson: Scalars['String']
   statusCode: Scalars['Int']
}

export type SendOtpForTransactionAcceptanceParams = {
   transactionId: Scalars['String']
}

export type SendOtpForTransactionAcceptanceResponse =
   | NotAllowedTdrAccountTransactionStatus
   | OwnerAlreadyAcceptedTransaction
   | SendOtpForTransactionAcceptanceResult
   | TdrAccountNotFound
   | TdrAccountTransactionNotFound

export type SendOtpForTransactionAcceptanceResult = {
   __typename?: 'SendOTPForTransactionAcceptanceResult'
   maskedPhoneNumber: Scalars['String']
   message: Scalars['String']
}

export type SendOtpParams = {
   entityId: Scalars['String']
   entityType: OtpVerificationEntityType
   verificationPurpose: OtpVerificationPurpose
}

export type SendOtpResponse =
   | DocumentVersionAccessDenied
   | DocumentVersionIsDeleted
   | DocumentVersionNotFound
   | NotLatestDocumentVersion
   | SendOtpResult

export type SendOtpResult = {
   __typename?: 'SendOTPResult'
   email: Scalars['String']
   entityId: Scalars['String']
   entityType: OtpVerificationEntityType
   maskedPhoneNumbers: Array<Scalars['String']>
   phoneNumber?: Maybe<Scalars['String']>
   verificationPurpose: OtpVerificationPurpose
}

export type SendOtpForDocumentESignParams = {
   documentId: Scalars['String']
   pin: Scalars['String']
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   selectedFieldNames: Array<Scalars['String']>
}

export type SendOtpForDocumentESignResponse =
   | DocumentIsDeleted
   | DocumentNotFound
   | ESignBlocksAlreadySigned
   | InvalidESignBlockFieldNames
   | InvalidUserPin
   | NoRegisteredMobileNumber
   | NotPermittedForSignBlocks
   | SendOtpForDocumentESignResult
   | UserPinExpired
   | UserPinLocked
   | UserPinNotConfigured

export type SendOtpForDocumentESignResult = {
   __typename?: 'SendOtpForDocumentESignResult'
   success: Scalars['Boolean']
}

export type SendOtpForTaskShortfallParams = {
   pipelineItemId: Scalars['String']
}

export type SendOtpForTaskShortfallResponse =
   | ApplicationManagementAccessDenied
   | PipelineItemNotFound
   | SendOtpForTaskShortfallResult
   | UserPhoneNumberNotFound

export type SendOtpForTaskShortfallResult = {
   __typename?: 'SendOtpForTaskShortfallResult'
   maskedPhoneNumber: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type SendOtpForTdrAccountHoldParams = {
   accountId: Scalars['String']
}

export type SendOtpForTdrAccountHoldResponse =
   | SendOtpForTdrAccountHoldResult
   | TdrAccountAlreadyOnHold
   | TdrAccountHasActiveChildAccounts
   | TdrAccountNotFound
   | TdrManagementAccessDenied

export type SendOtpForTdrAccountHoldResult = {
   __typename?: 'SendOtpForTdrAccountHoldResult'
   accountId: Scalars['String']
   maskedPhoneNumber: Scalars['String']
}

export type SendOtpForTdrAccountReleaseParams = {
   accountId: Scalars['String']
}

export type SendOtpForTdrAccountReleaseResponse =
   | SendOtpForTdrAccountReleaseResult
   | TdrAccountNotFound
   | TdrAccountNotOnHold
   | TdrManagementAccessDenied

export type SendOtpForTdrAccountReleaseResult = {
   __typename?: 'SendOtpForTdrAccountReleaseResult'
   accountId: Scalars['String']
   maskedPhoneNumber: Scalars['String']
}

export type SendOtpForUpdatingUserPinParams = {
   pinPurpose: PinPurpose
}

export type SendOtpForUpdatingUserPinResponse =
   | NoRegisteredMobileNumber
   | SendOtpForUpdatingUserPinResult

export type SendOtpForUpdatingUserPinResult = {
   __typename?: 'SendOtpForUpdatingUserPinResult'
   success: Scalars['Boolean']
}

export type SendOtpToPipelineItemPhoneNumberFieldInPortalParams = {
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type SendOtpToPipelineItemPhoneNumberFieldInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ExpectedPhoneNumberFieldType
   | FieldsAreDeleted
   | FieldsNotFound
   | NotPermittedFields
   | OtpVerificationNotEnabledForField
   | PhoneNumberAlreadyVerified
   | PhoneNumberFieldResponseNotFilled
   | PortalNotFound
   | SendOtpToPipelineItemPhoneNumberFieldInPortalResult

export type SendOtpToPipelineItemPhoneNumberFieldInPortalResult = {
   __typename?: 'SendOtpToPipelineItemPhoneNumberFieldInPortalResult'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   maskedPhoneNumber: Scalars['String']
   phoneNumberResponse: PhoneNumberResponse
   pipelineItemId: Scalars['String']
}

export type SendOtpToPipelineItemPhoneNumberFieldParams = {
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   pipelineItemId: Scalars['String']
}

export type SendOtpToPipelineItemPhoneNumberFieldResponse =
   | ExpectedPhoneNumberFieldType
   | FieldsAreDeleted
   | FieldsNotFound
   | NotPermittedFields
   | OtpVerificationNotEnabledForField
   | PhoneNumberAlreadyVerified
   | PhoneNumberFieldResponseNotFilled
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | SendOtpToPipelineItemPhoneNumberFieldResult

export type SendOtpToPipelineItemPhoneNumberFieldResult = {
   __typename?: 'SendOtpToPipelineItemPhoneNumberFieldResult'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   maskedPhoneNumber: Scalars['String']
   phoneNumberResponse: PhoneNumberResponse
   pipelineItemId: Scalars['String']
}

export type SendPipelineItemNotificationNode = BaseNode & {
   __typename?: 'SendPipelineItemNotificationNode'
   assigneeFieldsToNotify: Array<NotificationNodeAssigneeFieldConfig>
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   description?: Maybe<Scalars['String']>
   enableVariablesMapping?: Maybe<Scalars['Boolean']>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   notifyApplicationCustomer: Scalars['Boolean']
   title?: Maybe<Scalars['String']>
   variableMappings: Array<AwCustomVariableFieldMapping>
}

export type SendPipelineItemNotificationNodeExecLog = BaseNodeExecLog & {
   __typename?: 'SendPipelineItemNotificationNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<SendPipelineItemNotificationNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type SendPipelineItemNotificationNodeExecLogResult = {
   __typename?: 'SendPipelineItemNotificationNodeExecLogResult'
   description?: Maybe<Scalars['String']>
   notifiedApplicationCustomerId?: Maybe<Scalars['String']>
   notifiedUsers: Array<BaseUser>
   title: Scalars['String']
}

export type SendPipelineItemWhatsAppMessageBulkParams = {
   phoneNumberFieldId: Scalars['String']
   pipelineItemIds: Array<Scalars['String']>
   whatsappBusinessPhoneNumberId: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type SendPipelineItemWhatsAppMessageBulkResponse =
   | AccountPluginIsDisabled
   | FieldIsDeleted
   | FieldNotFound
   | InvalidWhatsAppServiceAccountConfiguration
   | NotPermittedField
   | NotPipelineItemTemplatePhoneNumberField
   | PipelineItemsAccessDenied
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | PipelineItemsNotInSamePipelineItemTemplate
   | PipelineWhatsAppBusinessPhoneNumberAccessDenied
   | PluginServiceAccountIsNotActive
   | SendPipelineItemWhatsAppMessageBulkResult
   | WhatsAppBusinessPhoneNumberNotFound
   | WhatsAppBusinessPhoneNumberNotLinkedToPipeline
   | WhatsAppMessageTemplateNotFound
   | WhatsAppMessageTemplateNotLinkedToPipeline
   | WhatsAppMsgTemplateAndBusinessPhoneNumberNotLinkedToSameAccount

export type SendPipelineItemWhatsAppMessageBulkResult = {
   __typename?: 'SendPipelineItemWhatsAppMessageBulkResult'
   failedData: Array<SendPipelineItemWhatsAppMessageFailureData>
}

export type SendPipelineItemWhatsAppMessageFailureData = {
   __typename?: 'SendPipelineItemWhatsAppMessageFailureData'
   failureReason: Scalars['String']
   phoneNumber?: Maybe<PhoneNumberResponse>
   pipelineItemId: Scalars['String']
   pipelineItemName?: Maybe<Scalars['String']>
}

export type SendPipelineItemWhatsAppMessageParams = {
   phoneNumberFieldIds: Array<Scalars['String']>
   pipelineItemId: Scalars['String']
   whatsappBusinessPhoneNumberId: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type SendPipelineItemWhatsAppMessageResponse =
   | AccountPluginIsDisabled
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidWhatsAppServiceAccountConfiguration
   | NotPermittedFields
   | NotPipelineItemTemplatePhoneNumberFields
   | PhoneNumberFieldResponsesDoNotHaveWhatsappConsent
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | PipelineWhatsAppBusinessPhoneNumberAccessDenied
   | PluginServiceAccountIsNotActive
   | SendPipelineItemWhatsAppMessageResult
   | WhatsAppBusinessPhoneNumberNotFound
   | WhatsAppBusinessPhoneNumberNotLinkedToPipeline
   | WhatsAppMessageTemplateNotFound
   | WhatsAppMessageTemplateNotLinkedToPipeline
   | WhatsAppMsgTemplateAndBusinessPhoneNumberNotLinkedToSameAccount

export type SendPipelineItemWhatsAppMessageResult = {
   __typename?: 'SendPipelineItemWhatsAppMessageResult'
   whatsappMessageIds: Array<Scalars['String']>
}

export type SendQueryResponseInThreadParams = {
   response: Scalars['String']
   threadId: Scalars['Int']
   threadName: Scalars['String']
   threadSummary: Scalars['String']
}

export type SendQueryResponseInThreadResponse =
   | SendQueryResponseInThreadResult
   | ThreadAccessDenied
   | ThreadNotFound

export type SendQueryResponseInThreadResult = {
   __typename?: 'SendQueryResponseInThreadResult'
   threadId: Scalars['Int']
   threadMessage: ThreadMessage
   threadName: Scalars['String']
   threadSummary: Scalars['String']
}

export type SendQueryStreamedDataInThreadParams = {
   response: Scalars['String']
   threadId: Scalars['Int']
}

export type SendQueryStreamedDataInThreadResponse = SendQueryStreamedDataInThreadResult

export type SendQueryStreamedDataInThreadResult = {
   __typename?: 'SendQueryStreamedDataInThreadResult'
   response: Scalars['String']
   threadId: Scalars['Int']
}

export type SendRequestForPipelineItemVerificationResult = {
   __typename?: 'SendRequestForPipelineItemVerificationResult'
   pipelineItemVerification?: Maybe<PipelineItemVerification>
}

export type SendRequestToPipelineItemVerificationParams = {
   pipelineItemId: Scalars['String']
   tabId: Scalars['String']
   verificationId: Scalars['String']
}

export type SendRequestToPipelineItemVerificationResponse =
   | LayoutTabNotFound
   | PipelineItemAccessDenied
   | PipelineItemAlreadyMovedToPipeline
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | SendRequestForPipelineItemVerificationResult
   | TabNotInPipelineItemTemplate
   | VerificationNotFound

export type SendWhatsAppMessageNode = BaseNode & {
   __typename?: 'SendWhatsAppMessageNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   notifyApplicationArchitect: Scalars['Boolean']
   notifyApplicationCustomer: Scalars['Boolean']
   phoneNumberField?: Maybe<AutomationWorkflowFieldValueMapping>
   phoneNumberFields?: Maybe<Array<Maybe<AutomationWorkflowFieldValueMapping>>>
   variableMappings?: Maybe<Array<Maybe<AwCustomVariableFieldMapping>>>
   whatsappBusinessPhoneNumber?: Maybe<
      BaseWhatsAppBusinessNumberWithPluginServiceAccount
   >
   whatsappMessageTemplate?: Maybe<WhatsAppMessageTemplateResponse>
}

export type SendWhatsAppMessageNodeExecLog = BaseNodeExecLog & {
   __typename?: 'SendWhatsAppMessageNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<SendWhatsAppMessageNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type SendWhatsAppMessageNodeExecLogResult = {
   __typename?: 'SendWhatsAppMessageNodeExecLogResult'
   formattedMessage?: Maybe<Scalars['String']>
   mediaInfo?: Maybe<WhatsAppMessageTemplateMediaInfo>
   messageType: WhatsAppMessageType
   msgSentToPhoneNumber?: Maybe<PhoneNumberResponse>
   recipients?: Maybe<Array<Maybe<WhatsAppMessageRecipient>>>
   upRefAssignee?: Maybe<BaseUser>
   whatsappBusinessPhoneNumber?: Maybe<PhoneNumberResponse>
}

export type SendWhatsAppMessageRequest = BaseOfficerManagementRequest & {
   __typename?: 'SendWhatsAppMessageRequest'
   accountId: Scalars['String']
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   errorMessage?: Maybe<Scalars['String']>
   id: Scalars['String']
   initiatedBy: Scalars['String']
   initiatedUser: User
   operationType: OfficerManagementOperationType
   reason?: Maybe<Scalars['String']>
   status: OfficerManagementStatusType
   updatedAt: Scalars['String']
   user: User
   userId: Scalars['String']
   whatsappBusinessPhoneNumberId?: Maybe<Scalars['String']>
   whatsappMessageId?: Maybe<Scalars['String']>
   whatsappMessageTemplateId?: Maybe<Scalars['String']>
   whatsappMessageVariables?: Maybe<Scalars['String']>
   whatsappRecipientPhoneNumber?: Maybe<Scalars['String']>
}

export type SendWhatsAppMessageToOfficerParams = {
   officerId: Scalars['String']
   variables?: InputMaybe<Array<InputMaybe<WhatsAppVariableParams>>>
}

export type SendWhatsAppMessageToOfficerResponse =
   | MessageTemplateNotFound
   | OfficerManagementAccessDenied
   | OfficerNotFound
   | SendWhatsAppMessageToOfficerResult
   | UserIsNotAnAdministrator
   | WhatsAppProviderError

export type SendWhatsAppMessageToOfficerResult = {
   __typename?: 'SendWhatsAppMessageToOfficerResult'
   errorMessage?: Maybe<Scalars['String']>
   messageId?: Maybe<Scalars['String']>
   success: Scalars['Boolean']
}

export type SetAccountFeatureIdentificationsParams = {
   feature: CrmAccountFeatureEnum
   identificationIds: Array<Scalars['String']>
   isDisabled: Scalars['Boolean']
}

export type SetAccountFeatureIdentificationsResponse =
   | IdentificationsNotFound
   | SetAccountFeatureIdentificationsResult
   | UserIsNotAnAdministrator

export type SetAccountFeatureIdentificationsResult = {
   __typename?: 'SetAccountFeatureIdentificationsResult'
   feature: CrmAccountFeatureEnum
   identifications: Array<IdentificationOverviewDetails>
   isDisabled: Scalars['Boolean']
}

export type SetAgentAllocationGroupsInAllocationGroupSetParams = {
   agentAllocationGroupIds: Array<Scalars['String']>
   allocationGroupSetId: Scalars['String']
}

export type SetAgentAllocationGroupsInAllocationGroupSetResponse =
   | AgentAllocationGroupsAlreadyExistsInDistributionThroughEntity
   | AgentAllocationGroupsNotFound
   | AgentAllocationGroupsNotInUserAccount
   | AllocationGroupSetNotFound
   | AllocationGroupSetTypeMismatch
   | LeadDistributionRuleIsNotInEditMode
   | NotEditableAllocationGroupSet
   | PartiallyConfiguredAgentAllocationGroups
   | SetAgentAllocationGroupsInAllocationGroupSetResult
   | UserIsNotAnAdministrator

export type SetAgentAllocationGroupsInAllocationGroupSetResult = {
   __typename?: 'SetAgentAllocationGroupsInAllocationGroupSetResult'
   agentAllocationGroupIds: Array<Scalars['String']>
   allocationGroupSetId: Scalars['String']
}

export type SetAgentsInAllocationGroupSetParams = {
   agentIds: Array<InputMaybe<Scalars['String']>>
   allocationGroupSetId: Scalars['String']
}

export type SetAgentsInAllocationGroupSetResponse =
   | AgentsAlreadyExistsInDistributionThroughEntity
   | AgentsAreDeactivated
   | AgentsNotFound
   | AllocationGroupSetNotFound
   | AllocationGroupSetTypeMismatch
   | LeadDistributionRuleIsNotInEditMode
   | NotEditableAllocationGroupSet
   | PipelineAccessDeniedToAgents
   | SetAgentsInAllocationGroupSetResult
   | UserIsNotAnAdministrator

export type SetAgentsInAllocationGroupSetResult = {
   __typename?: 'SetAgentsInAllocationGroupSetResult'
   agentIds: Array<Maybe<Scalars['String']>>
   allocationGroupSetId: Scalars['String']
}

export type SetApplicationDisplayStageAllowedGoFsParams = {
   gofIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetApplicationDisplayStageAllowedGoFsResponse =
   | ApplicationDisplayStageNotFound
   | GoFsAreDeleted
   | GoFsNotFound
   | GoFsNotInPipeline
   | NotAllowedDisplayStageWritableGoFs
   | NotApplicationDisplayStage
   | SetApplicationDisplayStageAllowedGoFsResult
   | UserIsNotAnAdministrator

export type SetApplicationDisplayStageAllowedGoFsResult = {
   __typename?: 'SetApplicationDisplayStageAllowedGoFsResult'
   gofIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetApplicationDisplayStageRequiredFieldsParams = {
   fieldIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetApplicationDisplayStageRequiredFieldsResponse =
   | ApplicationDisplayStageNotFound
   | FieldsAreDeleted
   | FieldsNotFound
   | FieldsNotInApplicationDisplayStageWritableFields
   | FieldsNotInStageAllowedSections
   | SetApplicationDisplayStageRequiredFieldsResult
   | UserIsNotAnAdministrator

export type SetApplicationDisplayStageRequiredFieldsResult = {
   __typename?: 'SetApplicationDisplayStageRequiredFieldsResult'
   fieldIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetApplicationDisplayStageWritableFieldsParams = {
   fieldIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetApplicationDisplayStageWritableFieldsResponse =
   | ApplicationDisplayStageNotFound
   | DependentFieldsSelectedWithoutParent
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | NotAllowedDisplayStageWritableFields
   | NotApplicationDisplayStage
   | NotSupportedSalesTemplateFields
   | PipelineAccessDenied
   | SetApplicationDisplayStageWritableFieldsResult
   | UserIsNotAnAdministrator

export type SetApplicationDisplayStageWritableFieldsResult = {
   __typename?: 'SetApplicationDisplayStageWritableFieldsResult'
   fieldIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetApplicationDocumentTemplatesInPortalParams = {
   documentTemplateIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetApplicationDocumentTemplatesInPortalResponse =
   | DocumentTemplatesNotFound
   | PortalApplicationNotFound
   | SetApplicationDocumentTemplatesInPortalResult
   | UserIsNotAnAdministrator

export type SetApplicationDocumentTemplatesInPortalResult = {
   __typename?: 'SetApplicationDocumentTemplatesInPortalResult'
   documentTemplateIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetApplicationIdGenerationConfigAtDisplayStageParams = {
   authorityFieldId?: InputMaybe<Scalars['String']>
   caseTypeFieldId?: InputMaybe<Scalars['String']>
   circleNoFieldId?: InputMaybe<Scalars['String']>
   displayStageId?: InputMaybe<Scalars['String']>
   gpCodeFieldId?: InputMaybe<Scalars['String']>
   headOfficeCodeFieldId?: InputMaybe<Scalars['String']>
   proposalTypeFieldId?: InputMaybe<Scalars['String']>
   shouldEnable: Scalars['Boolean']
   stageId?: InputMaybe<Scalars['String']>
   templateAndProjectTypeFieldId?: InputMaybe<Scalars['String']>
   templateCounterPrefixFieldId?: InputMaybe<Scalars['String']>
   udaCodeFieldId?: InputMaybe<Scalars['String']>
   ulbCodeFieldId?: InputMaybe<Scalars['String']>
   zonalCodeFieldId?: InputMaybe<Scalars['String']>
}

export type SetApplicationIdGenerationConfigAtDisplayStageResponse =
   | AlreadyAutoGenerationEnabledWhileCreation
   | AuthorityFieldNotFound
   | DisplayStageNotFound
   | NotApplicationFields
   | ProposalTypeFieldNotFound
   | SetApplicationIdGenerationConfigAtDisplayStageResult
   | StageNotFound
   | UserIsNotAnAdministrator
   | ZonalCodeFieldNotFound

export type SetApplicationIdGenerationConfigAtDisplayStageResult = {
   __typename?: 'SetApplicationIdGenerationConfigAtDisplayStageResult'
   authorityFieldId?: Maybe<Scalars['String']>
   caseTypeFieldId?: Maybe<Scalars['String']>
   circleNoFieldId?: Maybe<Scalars['String']>
   displayStageId: Scalars['String']
   gpCodeFieldId?: Maybe<Scalars['String']>
   headOfficeCodeFieldId?: Maybe<Scalars['String']>
   proposalTypeFieldId?: Maybe<Scalars['String']>
   shouldEnable: Scalars['Boolean']
   stageId: Scalars['String']
   templateAndProjectTypeFieldId?: Maybe<Scalars['String']>
   templateCounterPrefixFieldId?: Maybe<Scalars['String']>
   udaCodeFieldId?: Maybe<Scalars['String']>
   ulbCodeFieldId?: Maybe<Scalars['String']>
   zonalCodeFieldId?: Maybe<Scalars['String']>
}

export type SetApplicationOverviewFieldsInPortalParams = {
   fieldIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetApplicationOverviewFieldsInPortalResponse =
   | FieldsAreDeleted
   | FieldsNotAllowedInPortalApplication
   | FieldsNotFound
   | PortalApplicationNotFound
   | PortalApplicationOverviewFieldsLimitExceeded
   | SetApplicationOverviewFieldsInPortalResult
   | UserIsNotAnAdministrator

export type SetApplicationOverviewFieldsInPortalResult = {
   __typename?: 'SetApplicationOverviewFieldsInPortalResult'
   fieldIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetApplicationSubStatusFieldsParams = {
   applicationTemplateId: Scalars['String']
   fieldIds: Array<Scalars['String']>
   isSubStatusEnabled: Scalars['Boolean']
}

export type SetApplicationSubStatusFieldsResponse =
   | ApplicationTemplateNotFound
   | ApplicationTemplateSubStatusFieldsConfig
   | FieldsAreDeleted
   | FieldsNotFound
   | NotApplicationFields
   | NotDropdownFields
   | UserIsNotAnAdministrator

export type SetBpsTemplateConfigParams = {
   bpsConfigFieldEnum?: InputMaybe<BpsConfigFieldEnum>
   fieldId?: InputMaybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export type SetBpsTemplateConfigResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | PipelineItemTemplateAccessDenied
   | PipelineItemTemplateNotFound
   | SetBpsTemplateConfigResult

export type SetBpsTemplateConfigResult = {
   __typename?: 'SetBpsTemplateConfigResult'
   bpsConfigFieldEnum?: Maybe<BpsConfigFieldEnum>
   fieldId?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export type SetDefaultStageValuesToPipelineParams = {
   displayStageId: Scalars['String']
   pipelineId: Scalars['String']
   stageId: Scalars['String']
}

export type SetDefaultStageValuesToPipelineResponse =
   | DisplayStageNotFound
   | DisplayStageNotInPipeline
   | PipelineAccessDenied
   | PipelineNotFound
   | SetDefaultStageValuesToPipelineResult
   | StageNotFound
   | StageNotInPipeline
   | UserIsNotAnAdministrator

export type SetDefaultStageValuesToPipelineResult = {
   __typename?: 'SetDefaultStageValuesToPipelineResult'
   displayStageId: Scalars['String']
   pipelineId: Scalars['String']
   stageId: Scalars['String']
}

export type SetFieldConditionOptionsParentFieldParams = {
   fieldId: Scalars['String']
   parentFieldId: Scalars['String']
}

export type SetFieldConditionOptionsParentFieldResponse =
   | BothFieldsCannotBeSame
   | CannotEditSystemField
   | CircularParentIsNotAllowed
   | ConditionOptionsParentFieldIsNotDropdownField
   | FieldIsNotConditionOptionsValueType
   | FieldNotFound
   | FieldsAreDeleted
   | FieldsAreNotInSameGoF
   | FieldsMustBeOfSameGoFWhenFieldInAddAnotherGoF
   | LinkedFieldUpdateRestricted
   | NotConditionalOptionsValueType
   | ParentFieldNotFound
   | SetFieldConditionOptionsParentFieldResult
   | UserIsNotAnAdministrator

export type SetFieldConditionOptionsParentFieldResult = {
   __typename?: 'SetFieldConditionOptionsParentFieldResult'
   fieldId: Scalars['String']
   parentFieldId: Scalars['String']
}

export type SetFieldReadRolesParams = {
   fieldId: Scalars['String']
   roles: Array<Scalars['String']>
}

export type SetFieldReadRolesResponse =
   | CannotRemoveSystemFieldDefaultReadRoles
   | FieldIsDeleted
   | FieldNotFound
   | RolesNotFound
   | SetFieldReadRolesResult
   | UserIsNotAnAdministrator

export type SetFieldReadRolesResult = {
   __typename?: 'SetFieldReadRolesResult'
   fieldId: Scalars['String']
   roles: Array<Scalars['String']>
}

export type SetFieldWriteRolesParams = {
   fieldId: Scalars['String']
   roles: Array<Scalars['String']>
}

export type SetFieldWriteRolesResponse =
   | CannotAddWriteRolesToUserPropertiesSystemFields
   | CannotRemoveSystemFieldDefaultWriteRoles
   | CannotRemoveTaskFieldDefaultWriteRoles
   | FieldIsDeleted
   | FieldNotFound
   | RolesNotFound
   | SetFieldWriteRolesResult
   | UserIsNotAnAdministrator

export type SetFieldWriteRolesResult = {
   __typename?: 'SetFieldWriteRolesResult'
   fieldId: Scalars['String']
   roles: Array<Scalars['String']>
}

export type SetFieldsOrderParams = {
   fieldIds: Array<Scalars['String']>
}

export type SetFieldsOrderResponse =
   | CannotReorderSystemFields
   | DependentFieldsNotSupported
   | FieldsNotBelongsToSameGoF
   | FieldsNotFound
   | MissingFieldIdsInGoF
   | SetFieldsOrderResult
   | UserIsNotAnAdministrator

export type SetFieldsOrderResult = {
   __typename?: 'SetFieldsOrderResult'
   fieldIds: Array<Scalars['String']>
}

export type SetFieldsSelectorFieldOptionDependentFieldsOrderParams = {
   dependentFieldIds: Array<Scalars['String']>
   fieldId: Scalars['String']
   option: Scalars['String']
}

export type SetFieldsSelectorFieldOptionDependentFieldsOrderResponse =
   | CannotEditSystemField
   | DuplicateDependentFieldIds
   | FieldIsDeleted
   | FieldNotFound
   | GivenNonExistingDependentFieldIds
   | NotFieldsSelectorField
   | NotGivenExistingDependentFieldIds
   | OptionShouldBeInExistingOptions
   | SetFieldsSelectorFieldOptionDependentFieldsOrderResult
   | UserIsNotAnAdministrator

export type SetFieldsSelectorFieldOptionDependentFieldsOrderResult = {
   __typename?: 'SetFieldsSelectorFieldOptionDependentFieldsOrderResult'
   dependentFieldIds: Array<Scalars['String']>
   fieldId: Scalars['String']
   option: Scalars['String']
}

export type SetGoFsOrderParams = {
   gofIds: Array<Scalars['String']>
}

export type SetGoFsOrderResponse =
   | CannotReorderSystemGoF
   | GoFsAreDeleted
   | GoFsAreNotBelongsToSameTemplate
   | GoFsNotFound
   | MissingGoFIdsInTemplate
   | SetGoFsOrderResult
   | UserIsNotAnAdministrator

export type SetGoFsOrderResult = {
   __typename?: 'SetGoFsOrderResult'
   gofIds: Array<Scalars['String']>
}

export type SetGraphRolesParams = {
   graphId: Scalars['String']
   roleIds: Array<Scalars['String']>
}

export type SetGraphRolesResponse =
   | GraphNotFound
   | RolesNotFound
   | RolesNotInUserAccount
   | SetGraphRolesResult
   | UserIsNotAnAdministrator

export type SetGraphRolesResult = {
   __typename?: 'SetGraphRolesResult'
   graphId: Scalars['String']
   roles: Array<Role>
}

export type SetIdentificationsForPipelineActionParams = {
   action: PipelineActionType
   identificationIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type SetIdentificationsForPipelineActionResponse =
   | IdentificationsNotFound
   | NotPipelineIdentifications
   | PipelineNotFound
   | SetIdentificationsForPipelineActionResult
   | UserIsNotAnAdministrator

export type SetIdentificationsForPipelineActionResult = {
   __typename?: 'SetIdentificationsForPipelineActionResult'
   action: PipelineActionType
   identificationIds: Array<Scalars['String']>
}

export type SetIdentificationsToTriggerAutomationWorkflowsOnActivityParams = {
   activityTemplateId: Scalars['String']
   identificationIds: Array<Scalars['String']>
}

export type SetIdentificationsToTriggerAutomationWorkflowsOnActivityResponse =
   | ActivityTemplateNotFound
   | IdentificationsNotFound
   | NotActivityTemplatePipelineIdentifications
   | NotActivityTemplatePipelinesIdentifications
   | SetIdentificationsToTriggerAutomationWorkflowsOnActivityResult
   | UserAndIdentificationsAreNotInSameAccount
   | UserIsNotAnAdministrator

export type SetIdentificationsToTriggerAutomationWorkflowsOnActivityResult = {
   __typename?: 'SetIdentificationsToTriggerAutomationWorkflowsOnActivityResult'
   activityTemplateId: Scalars['String']
   identificationIds: Array<Scalars['String']>
}

export type SetLeadBucketsOrderParams = {
   leadBucketIds: Array<Scalars['String']>
   leadDistributionRuleId: Scalars['String']
}

export type SetLeadBucketsOrderResponse =
   | LeadBucketsNotFound
   | LeadBucketsNotInSameLeadDistributionRule
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | MissingLeadBucketIds
   | NotEditableLeadDistributionRule
   | SetLeadBucketsOrderResult
   | UserIsNotAnAdministrator

export type SetLeadBucketsOrderResult = {
   __typename?: 'SetLeadBucketsOrderResult'
   leadBucketIds: Array<Scalars['String']>
   leadDistributionRuleId: Scalars['String']
}

export type SetLeadCreationAllowedStagesParams = {
   allowedStageIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type SetLeadCreationAllowedStagesResponse =
   | NotLeadPipeline
   | NotPipelineStages
   | PipelineNotFound
   | SetLeadCreationAllowedStagesResult
   | StagesNotFound
   | UserIsNotAnAdministrator

export type SetLeadCreationAllowedStagesResult = {
   __typename?: 'SetLeadCreationAllowedStagesResult'
   allowedStageIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type SetLeadDistributionRuleAssigneeFieldsToNotifyParams = {
   assigneeFieldIdsToNotify: Array<Scalars['String']>
   leadDistributionRuleId: Scalars['String']
}

export type SetLeadDistributionRuleAssigneeFieldsToNotifyResponse =
   | DuplicateAssigneeFieldIdsToNotify
   | InvalidAssigneeFieldIdsToNotify
   | LeadDistributionRuleNotFound
   | SetLeadDistributionRuleAssigneeFieldsToNotifyResult
   | UserIsNotAnAdministrator

export type SetLeadDistributionRuleAssigneeFieldsToNotifyResult = {
   __typename?: 'SetLeadDistributionRuleAssigneeFieldsToNotifyResult'
   assigneeFieldIdsToNotify: Array<Scalars['String']>
   leadDistributionRuleId: Scalars['String']
}

export type SetLeadDistributionRuleManagerFieldsParams = {
   assignBasedOnAvailability?: InputMaybe<Scalars['Boolean']>
   leadDistributionRuleId: Scalars['String']
   managerFields: Array<LeadDistributionRuleManagerFieldParams>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type SetLeadDistributionRuleManagerFieldsResponse =
   | DuplicateManagerFieldIds
   | InvalidManagerFieldIds
   | InvalidManagerFieldsLevel
   | LeadDistributionRuleNotFound
   | LeadPoolAssigneeFieldCanNotBeManagerField
   | SetLeadDistributionRuleManagerFieldsResult
   | UserIsNotAnAdministrator

export type SetLeadDistributionRuleManagerFieldsResult = {
   __typename?: 'SetLeadDistributionRuleManagerFieldsResult'
   assignBasedOnAvailability: Scalars['Boolean']
   leadDistributionRuleId: Scalars['String']
   managerFields: Array<LeadDistributionRuleManagerField>
   syncAssigneeHierarchy?: Maybe<Scalars['Boolean']>
}

export type SetManagerForAgentsParams = {
   managerId: Scalars['String']
   userIds: Array<Scalars['String']>
}

export type SetManagerForAgentsResponse =
   | DeactivatedManager
   | DeactivatedUsers
   | ManagerHaveNoAccessToUsersPipelines
   | ManagerNotFound
   | ManagerNotHaveAnyRoles
   | ManagerToUserCircularDependency
   | SetManagerForAgentsResult
   | UserAndManagerCannotBeSame
   | UserIsNotAnAdministrator
   | UsersAreNotInSameAccount
   | UsersDoesNotHaveAnyRoles
   | UsersNotFound

export type SetManagerForAgentsResult = {
   __typename?: 'SetManagerForAgentsResult'
   managerId?: Maybe<Scalars['String']>
   userIds: Array<Scalars['String']>
}

export type SetManagerParams = {
   managerId: Scalars['String']
   userId: Scalars['String']
}

export type SetManagerResponse =
   | DeactivatedManager
   | DeactivatedUser
   | ManagerHaveNoAccessToUserPipelines
   | ManagerNotFound
   | ManagerNotHaveAnyRoles
   | ManagerToUserCircularDependency
   | SetManagerResult
   | UserAndAdminAreNotInSameAccount
   | UserAndManagerCannotBeSame
   | UserAndMangerAreNotInSameAccount
   | UserIsNotAnAdministrator
   | UserNotFound
   | UserNotHaveAnyRoles

export type SetManagerResult = {
   __typename?: 'SetManagerResult'
   managerId?: Maybe<Scalars['String']>
   userId?: Maybe<Scalars['String']>
}

export type SetOrderForAllocationGroupSetsParams = {
   distributionThrough: DistributionThroughType
   distributionThroughEntityId: Scalars['String']
   orderedItemIds: Array<Scalars['String']>
}

export type SetOrderForAllocationGroupSetsResponse =
   | AllocationGroupSetsNotFound
   | AllocationGroupSetsNotInSameDistributionThroughEntity
   | DistributionThroughEntityNotFound
   | LeadDistributionRuleIsNotInEditMode
   | MissingAllocationGroupSets
   | NotEditableDistributionThroughEntity
   | SetOrderForAllocationGroupSetsResult
   | UserIsNotAnAdministrator

export type SetOrderForAllocationGroupSetsResult = {
   __typename?: 'SetOrderForAllocationGroupSetsResult'
   distributionThrough: DistributionThroughType
   distributionThroughEntityId: Scalars['String']
   orderedItemIds: Array<Scalars['String']>
}

export type SetParameterConditionsOrderParams = {
   conditionIds: Array<Scalars['String']>
   parameterId: Scalars['String']
}

export type SetParameterConditionsOrderResponse =
   | ConditionsNotBelongsToScoringParameter
   | MissedParameterConditions
   | ParameterConditionsNotFound
   | ScoringParameterNotFound
   | SetParameterConditionsOrderResult
   | UserIsNotAnAdministrator

export type SetParameterConditionsOrderResult = {
   __typename?: 'SetParameterConditionsOrderResult'
   conditionIds: Array<Scalars['String']>
   parameterId: Scalars['String']
}

export type SetPermitOrderIdGenerationConfigAtStageParams = {
   districtAdministrationFieldId?: InputMaybe<Scalars['String']>
   gpCodeFieldId?: InputMaybe<Scalars['String']>
   permitOrderIdFieldId: Scalars['String']
   projectTypeFieldId?: InputMaybe<Scalars['String']>
   shouldEnable: Scalars['Boolean']
   stageId: Scalars['String']
   zonalCodeFieldId?: InputMaybe<Scalars['String']>
}

export type SetPermitOrderIdGenerationConfigAtStageResponse =
   | DisplayStageNotFound
   | FieldsNotFound
   | NotApplicationFields
   | SetPermitOrderIdGenerationConfigAtStageResult
   | StageNotFound
   | UserIsNotAnAdministrator

export type SetPermitOrderIdGenerationConfigAtStageResult = {
   __typename?: 'SetPermitOrderIdGenerationConfigAtStageResult'
   districtAdministrationFieldId?: Maybe<Scalars['String']>
   gpCodeFieldId?: Maybe<Scalars['String']>
   permitOrderIdFieldId: Scalars['String']
   projectTypeFieldId?: Maybe<Scalars['String']>
   shouldEnable: Scalars['Boolean']
   stageId: Scalars['String']
   zonalCodeFieldId?: Maybe<Scalars['String']>
}

export type SetPipelineAdminsParams = {
   adminUserIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type SetPipelineAdminsResponse =
   | DeactivatedUsers
   | PipelineNotFound
   | SetPipelineAdminsResult
   | UserIsNotAnAdministrator
   | UsersNotFound

export type SetPipelineAdminsResult = {
   __typename?: 'SetPipelineAdminsResult'
   adminUserIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type SetPipelineFeatureIdentificationsParams = {
   feature: CrmPipelineFeatureEnum
   identificationIds: Array<Scalars['String']>
   isDisabled: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type SetPipelineFeatureIdentificationsResponse =
   | IdentificationsNotFound
   | NotPipelineIdentifications
   | PipelineNotFound
   | SetPipelineFeatureIdentificationsResult
   | UserIsNotAnAdministrator

export type SetPipelineFeatureIdentificationsResult = {
   __typename?: 'SetPipelineFeatureIdentificationsResult'
   feature: CrmPipelineFeatureEnum
   identifications: Array<IdentificationOverviewDetails>
   isDisabled: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type SetPipelineIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
}

export type SetPipelineIdentificationsResponse =
   | IdentificationsNotFound
   | IdentificationsPipelineActionsExists
   | IdentificationsToTriggerAutomationWorkflowsOnActivityExists
   | PipelineNotFound
   | SetPipelineIdentificationsResult
   | UserIsNotAnAdministrator

export type SetPipelineIdentificationsResult = {
   __typename?: 'SetPipelineIdentificationsResult'
   identifications: Array<IdentificationOverviewDetails>
   pipelineId: Scalars['String']
}

export type SetPipelineItemFieldsToLogParams = {
   fieldIdsToLog: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetPipelineItemFieldsToLogResponse =
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | SetPipelineItemFieldsToLogResult
   | StageIsDeleted
   | StageNotFound
   | UserIsNotAnAdministrator

export type SetPipelineItemFieldsToLogResult = {
   __typename?: 'SetPipelineItemFieldsToLogResult'
   fieldIdsToLog: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetPipelineItemTemplateAdminsParams = {
   adminUserIds: Array<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export type SetPipelineItemTemplateAdminsResponse =
   | DeactivatedUsers
   | PipelineItemTemplateNotFound
   | SetPipelineItemTemplateAdminsResult
   | UserIsNotAnAdministrator
   | UsersNotFound

export type SetPipelineItemTemplateAdminsResult = {
   __typename?: 'SetPipelineItemTemplateAdminsResult'
   adminUserIds: Array<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export type SetPipelineItemTemplateFieldsToLogParams = {
   fieldIdsToLog: Array<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export type SetPipelineItemTemplateFieldsToLogResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | NotPipelineItemTemplateFields
   | PipelineItemTemplateNotFound
   | SetPipelineItemTemplateFieldsToLogResult

export type SetPipelineItemTemplateFieldsToLogResult = {
   __typename?: 'SetPipelineItemTemplateFieldsToLogResult'
   fieldIdsToLog: Array<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export type SetPipelineItemTemplateShortfallFieldsConfigParams = {
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export type SetPipelineItemTemplateShortfallFieldsConfigResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | GoFsNotFound
   | NotPipelineItemTemplateFields
   | PipelineItemTemplateNotFound
   | SetPipelineItemTemplateShortfallFieldsConfigResult

export type SetPipelineItemTemplateShortfallFieldsConfigResult = {
   __typename?: 'SetPipelineItemTemplateShortfallFieldsConfigResult'
   fieldIds: Array<Scalars['String']>
   gofIds: Array<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
}

export type SetPipelinePersonalWhatsAppMessageIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
   shouldConsiderPipelineIdentifications: Scalars['Boolean']
}

export type SetPipelinePersonalWhatsAppMessageIdentificationsResponse =
   | IdentificationsNotFound
   | NotPipelineIdentifications
   | PipelineNotFound
   | SetPipelinePersonalWhatsAppMessageIdentificationsResult
   | UserIsNotAnAdministrator

export type SetPipelinePersonalWhatsAppMessageIdentificationsResult = {
   __typename?: 'SetPipelinePersonalWhatsAppMessageIdentificationsResult'
   identifications: Array<IdentificationOverviewDetails>
   pipelineId: Scalars['String']
   shouldConsiderPipelineIdentifications: Scalars['Boolean']
}

export type SetPipelineWhatsAppBusinessPhoneNumberUsersParams = {
   pipelineId: Scalars['String']
   userIds: Array<Scalars['String']>
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type SetPipelineWhatsAppBusinessPhoneNumberUsersResponse =
   | AccountPluginIsDisabled
   | DeactivatedUsers
   | PipelineAccessDeniedToUsers
   | PipelineNotFound
   | PluginServiceAccountIsNotActive
   | SetPipelineWhatsAppBusinessPhoneNumberUsersResult
   | UserIsNotAnAdministrator
   | UsersAreAlreadyToLinkedPipeline
   | UsersNotFound
   | WhatsAppBusinessPhoneNumberNotFound

export type SetPipelineWhatsAppBusinessPhoneNumberUsersResult = {
   __typename?: 'SetPipelineWhatsAppBusinessPhoneNumberUsersResult'
   pipelineId: Scalars['String']
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
   users: Array<BaseUser>
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type SetPipelinesToActivityTemplateParams = {
   activityTemplateId: Scalars['String']
   pipelineIds: Array<Scalars['String']>
}

export type SetPipelinesToActivityTemplateResponse =
   | ActivityTemplateNotFound
   | PipelinesNotFound
   | SetPipelinesToActivityTemplateResult
   | UserIsNotAnAdministrator

export type SetPipelinesToActivityTemplateResult = {
   __typename?: 'SetPipelinesToActivityTemplateResult'
   activityTemplateId: Scalars['String']
   pipelineIds: Array<Scalars['String']>
}

export type SetPortalApplicationAdditionalVisibleTabsParams = {
   portalApplicationId: Scalars['String']
   tabEnums: Array<PortalApplicationAdditionalTabEnum>
}

export type SetPortalApplicationAdditionalVisibleTabsResponse =
   | PortalApplicationNotFound
   | SetPortalApplicationAdditionalVisibleTabsResult
   | UserIsNotAnAdministrator

export type SetPortalApplicationAdditionalVisibleTabsResult = {
   __typename?: 'SetPortalApplicationAdditionalVisibleTabsResult'
   portalApplicationId: Scalars['String']
   tabEnums: Array<PortalApplicationAdditionalTabEnum>
}

export type SetPortalApplicationDrawingPdfVisibleStagesParams = {
   displayStageIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetPortalApplicationDrawingPdfVisibleStagesResponse =
   | DisplayStagesNotFound
   | PortalApplicationNotFound
   | SetPortalApplicationDrawingPdfVisibleStagesResult
   | UserIsNotAnAdministrator

export type SetPortalApplicationDrawingPdfVisibleStagesResult = {
   __typename?: 'SetPortalApplicationDrawingPDFVisibleStagesResult'
   displayStageIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetPortalApplicationProposalFlowVisibleStagesParams = {
   displayStageIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetPortalApplicationProposalFlowVisibleStagesResponse =
   | DisplayStagesNotFound
   | PortalApplicationNotFound
   | SetPortalApplicationProposalFlowVisibleStagesResult
   | UserIsNotAnAdministrator

export type SetPortalApplicationProposalFlowVisibleStagesResult = {
   __typename?: 'SetPortalApplicationProposalFlowVisibleStagesResult'
   displayStageIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetPortalApplicationScrutinyProcessVisibleStagesParams = {
   displayStageIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetPortalApplicationScrutinyProcessVisibleStagesResponse =
   | DisplayStagesNotFound
   | PortalApplicationNotFound
   | SetPortalApplicationScrutinyProcessVisibleStagesResult
   | UserIsNotAnAdministrator

export type SetPortalApplicationScrutinyProcessVisibleStagesResult = {
   __typename?: 'SetPortalApplicationScrutinyProcessVisibleStagesResult'
   displayStageIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetPortalApplicationTdrVisibleStagesParams = {
   displayStageIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetPortalApplicationTdrVisibleStagesResponse =
   | DisplayStagesNotFound
   | PortalApplicationNotFound
   | SetPortalApplicationTdrVisibleStagesResult
   | UserIsNotAnAdministrator

export type SetPortalApplicationTdrVisibleStagesResult = {
   __typename?: 'SetPortalApplicationTDRVisibleStagesResult'
   displayStageIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
}

export type SetPortalApplicationTabGoFsOrderParams = {
   gofIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type SetPortalApplicationTabGoFsOrderResponse =
   | GoFsNotFoundInPortalApplicationTab
   | PortalApplicationNotFound
   | SetPortalApplicationTabGoFsOrderResult
   | TabNotFoundInPortalApplication
   | UserIsNotAnAdministrator

export type SetPortalApplicationTabGoFsOrderResult = {
   __typename?: 'SetPortalApplicationTabGoFsOrderResult'
   gofIds: Array<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type SetPortalApplicationTabsOrderParams = {
   portalApplicationId: Scalars['String']
   tabIds: Array<Scalars['String']>
}

export type SetPortalApplicationTabsOrderResponse =
   | PortalApplicationNotFound
   | SetPortalApplicationTabsOrderResult
   | TabsNotFoundInPortalApplication
   | UserIsNotAnAdministrator

export type SetPortalApplicationTabsOrderResult = {
   __typename?: 'SetPortalApplicationTabsOrderResult'
   portalApplicationId: Scalars['String']
   tabIds: Array<Scalars['String']>
}

export type SetPortalApplicationsOrderParams = {
   portalApplicationIds: Array<Scalars['String']>
   portalId: Scalars['String']
}

export type SetPortalApplicationsOrderResponse =
   | NotPortalLinkedApplications
   | PortalApplicationsNotFound
   | PortalNotFound
   | SetPortalApplicationsOrderResult
   | UserIsNotAnAdministrator

export type SetPortalApplicationsOrderResult = {
   __typename?: 'SetPortalApplicationsOrderResult'
   portalApplicationIds: Array<Scalars['String']>
   portalId: Scalars['String']
}

export type SetPortalPipelineItemTemplateSurveyNumberFieldConfigParams = {
   areaFieldId?: InputMaybe<Scalars['String']>
   concatenatedSurveyNumbersFieldId?: InputMaybe<Scalars['String']>
   districtFieldId: Scalars['String']
   gofId?: InputMaybe<Scalars['String']>
   mandalFieldId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   portalId: Scalars['String']
   prohibitingSupportingDocumentFieldId: Scalars['String']
   surveyNumberCategoryFieldId: Scalars['String']
   surveyNumberFieldId: Scalars['String']
   ulbCodeFieldId: Scalars['String']
   villageFieldId: Scalars['String']
}

export type SetPortalPipelineItemTemplateSurveyNumberFieldConfigResponse =
   | AreaFieldNotFound
   | AreaFieldRequiredWhenGoFProvided
   | ConcatenatedSurveyNumbersFieldNotFound
   | DistrictFieldNotFound
   | FieldsNotInSameGoF
   | GoFIdRequiredWhenAreaFieldProvided
   | GoFIdRequiredWhenConcatenatedFieldProvided
   | GoFNotFound
   | MandalFieldNotFound
   | NotAddAnotherGoF
   | PipelineItemTemplateNotFound
   | PortalNotFound
   | ProhibitingSupportingDocumentFieldNotFound
   | SetPortalPipelineItemTemplateSurveyNumberFieldConfigResult
   | SurveyNumberFieldNotFound
   | UlbCodeFieldNotFound
   | UserIsNotAnAdministrator
   | VillageFieldNotFound

export type SetPortalPipelineItemTemplateSurveyNumberFieldConfigResult = {
   __typename?: 'SetPortalPipelineItemTemplateSurveyNumberFieldConfigResult'
   areaFieldId?: Maybe<Scalars['String']>
   concatenatedSurveyNumbersFieldId?: Maybe<Scalars['String']>
   districtFieldId: Scalars['String']
   gofId?: Maybe<Scalars['String']>
   mandalFieldId: Scalars['String']
   pipelineItemTemplateId: Scalars['String']
   portalId: Scalars['String']
   prohibitingSupportingDocumentFieldId: Scalars['String']
   surveyNumberCategoryFieldId: Scalars['String']
   surveyNumberFieldId: Scalars['String']
   ulbCodeFieldId: Scalars['String']
   villageFieldId: Scalars['String']
}

export type SetPortalVisibleUserTypesParams = {
   portalApplicationId: Scalars['String']
   visibleUserTypes: Array<UserType>
}

export type SetPortalVisibleUserTypesResponse =
   | PortalApplicationNotFound
   | SetPortalVisibleUserTypesResult
   | UserIsNotAnAdministrator

export type SetPortalVisibleUserTypesResult = {
   __typename?: 'SetPortalVisibleUserTypesResult'
   portalApplicationId: Scalars['String']
   visibleUserTypes: Array<UserType>
}

export type SetRecordCreationConfigAutoAssignCreatorToFieldsParams = {
   fieldIds: Array<Scalars['String']>
   recordCreationConfigId: Scalars['Int']
}

export type SetRecordCreationConfigAutoAssignCreatorToFieldsResponse =
   | AdminRecordCreationConfig
   | FieldsAreDeleted
   | FieldsNotFound
   | NotAssigneeFieldIds
   | RecordCreationConfigNotFound
   | UserIsNotAnAdministrator

export type SetRecordCreationConfigCreationAllowedStagesParams = {
   pipelinesAllowedStages?: InputMaybe<
      Array<InputMaybe<PipelineRecordCreationConfigAllowedStagesParams>>
   >
   recordCreationConfigId: Scalars['Int']
   stageIds: Array<Scalars['String']>
}

export type SetRecordCreationConfigCreationAllowedStagesResponse =
   | AdminRecordCreationConfig
   | PipelinesNotFound
   | RecordCreationConfigNotFound
   | StagesNotInPipeline
   | UserIsNotAnAdministrator

export type SetRecordCreationConfigFieldsParams = {
   fieldIds: Array<Scalars['String']>
   recordCreationConfigId: Scalars['Int']
}

export type SetRecordCreationConfigFieldsResponse =
   | AdminRecordCreationConfig
   | CannotRemoveMandatorySystemFields
   | DependentFieldsNotSupported
   | FieldsAreDeleted
   | FieldsNotFound
   | FieldsNotInSalesTemplate
   | RecordCreationConfigNotFound
   | UserIsNotAnAdministrator

export type SetRecordCreationConfigPermissionsParams = {
   identificationIds: Array<Scalars['String']>
   recordCreationConfigId: Scalars['Int']
}

export type SetRecordCreationConfigPermissionsResponse =
   | AdminRecordCreationConfig
   | IdentificationsNotFound
   | NotPipelineIdentifications
   | RecordCreationConfigNotFound
   | UserIsNotAnAdministrator

export type SetRecordCreationConfigSyncAssigneeGroupsParams = {
   recordCreationConfigId: Scalars['Int']
   syncAssigneeGroupIds: Array<Scalars['String']>
}

export type SetRecordCreationConfigSyncAssigneeGroupsResponse =
   | AdminRecordCreationConfig
   | AssigneeGroupsNotFound
   | AssigneeGroupsNotInSalesTemplate
   | RecordCreationConfigNotFound
   | UserIsNotAnAdministrator

export type SetRecordMergePermissionsParams = {
   identificationIds: Array<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type SetRecordMergePermissionsResponse =
   | IdentificationsNotFound
   | NotSupportedSalesTemplateType
   | SalesTemplateNotFound
   | SalesTemplateNotInUserAccount
   | SetRecordMergePermissionsResult
   | UserAndIdentificationsAreNotInSameAccount
   | UserIsNotAnAdministrator

export type SetRecordMergePermissionsResult = {
   __typename?: 'SetRecordMergePermissionsResult'
   identificationIds: Array<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type SetRelatedSalesTemplateOverviewFieldsParams = {
   overviewFieldIds: Array<Scalars['String']>
   relationId: Scalars['String']
   salesTemplateId: Scalars['String']
}

export type SetRelatedSalesTemplateOverviewFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | FieldsNotLinkedToRelatedSalesTemplate
   | NotPermittedFields
   | RelationNotFound
   | SalesTemplateNotFound
   | SalesTemplateNotLinkedToRelation
   | SetRelatedSalesTemplateOverviewFieldsResult
   | UserIsNotAnAdministrator

export type SetRelatedSalesTemplateOverviewFieldsResult = {
   __typename?: 'SetRelatedSalesTemplateOverviewFieldsResult'
   overviewFieldIds: Array<Scalars['String']>
   relationId: Scalars['String']
   salesTemplateId: Scalars['String']
}

export type SetRelationEntityAddPermissionIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   relationId: Scalars['String']
   salesTemplateId: Scalars['String']
}

export type SetRelationEntityAddPermissionIdentificationsResponse =
   | IdentificationsNotFound
   | RelationAndIdentificationsAreNotInSameAccount
   | RelationNotFound
   | SetRelationEntityAddPermissionIdentificationsResult
   | UserIsNotAnAdministrator

export type SetRelationEntityAddPermissionIdentificationsResult = {
   __typename?: 'SetRelationEntityAddPermissionIdentificationsResult'
   identificationIds: Array<Scalars['String']>
   relationId: Scalars['String']
   salesTemplateId: Scalars['String']
}

export type SetRelationEntityRemovePermissionIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   relationId: Scalars['String']
   salesTemplateId: Scalars['String']
}

export type SetRelationEntityRemovePermissionIdentificationsResponse =
   | IdentificationsNotFound
   | RelationAndIdentificationsAreNotInSameAccount
   | RelationNotFound
   | SetRelationEntityRemovePermissionIdentificationsResult
   | UserIsNotAnAdministrator

export type SetRelationEntityRemovePermissionIdentificationsResult = {
   __typename?: 'SetRelationEntityRemovePermissionIdentificationsResult'
   identificationIds: Array<Scalars['String']>
   relationId: Scalars['String']
   salesTemplateId: Scalars['String']
}

export type SetRelationIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   relationId: Scalars['String']
}

export type SetRelationIdentificationsResponse =
   | IdentificationsNotFound
   | RelationAndIdentificationsAreNotInSameAccount
   | RelationNotFound
   | SetRelationIdentificationsResult
   | UserIsNotAnAdministrator

export type SetRelationIdentificationsResult = {
   __typename?: 'SetRelationIdentificationsResult'
   identificationIds: Array<Scalars['String']>
   relationId: Scalars['String']
}

export type SetResourceRolesParams = {
   resourceId: Scalars['String']
   roleIds: Array<Scalars['String']>
}

export type SetResourceRolesResponse =
   | PipelineAccessDenied
   | ResourceNotFound
   | RolesNotFound
   | RolesNotInUserAccount
   | SetResourceRolesResult
   | UserIsNotAnAdministrator

export type SetResourceRolesResult = {
   __typename?: 'SetResourceRolesResult'
   resourceId: Scalars['String']
   roleIds: Array<Scalars['String']>
}

export type SetResourcesOrderParams = {
   resourceIds: Array<Scalars['String']>
}

export type SetResourcesOrderResponse =
   | MissingResourcesInPipeline
   | PipelineAccessDenied
   | ResourcesNotFound
   | ResourcesNotInSamePipeline
   | SetResourcesOrderResult
   | UserIsNotAnAdministrator

export type SetResourcesOrderResult = {
   __typename?: 'SetResourcesOrderResult'
   resourceIds: Array<Scalars['String']>
}

export type SetSalesTemplateRecordCreationPermissionsParams = {
   identificationIds: Array<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type SetSalesTemplateRecordCreationPermissionsResponse =
   | IdentificationsNotFound
   | NotSupportedSalesTemplateType
   | SalesTemplateNotFound
   | SalesTemplateNotInUserAccount
   | SetSalesTemplateRecordCreationPermissionsResult
   | UserAndIdentificationsAreNotInSameAccount
   | UserIsNotAnAdministrator

export type SetSalesTemplateRecordCreationPermissionsResult = {
   __typename?: 'SetSalesTemplateRecordCreationPermissionsResult'
   identificationIds: Array<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type SetScoringRecalculationSortByFieldsParams = {
   fields: Array<SortByFieldParams>
   recalculationConfigId: Scalars['String']
}

export type SetScoringRecalculationSortByFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | NotSalesTemplateFieldIds
   | ScoringRecalculationConfigIsInRunningState
   | ScoringRecalculationConfigNotFound
   | SetScoringRecalculationSortByFieldsResult
   | UserIsNotAnAdministrator

export type SetScoringRecalculationSortByFieldsResult = {
   __typename?: 'SetScoringRecalculationSortByFieldsResult'
   fields: Array<SortByField>
   recalculationConfigId: Scalars['String']
}

export type SetSiteInspectionFieldObservationBulkParams = {
   fieldObservations: Array<FieldObservationParams>
   taskId: Scalars['String']
}

export type SetSiteInspectionFieldObservationBulkResponse =
   | FieldIsDeleted
   | FieldNotFound
   | FieldsNotFound
   | NotTaskField
   | SetSiteInspectionFieldObservationBulkResult
   | SiteInspectionIsNotEditable
   | TaskAccessDenied
   | TaskNotFound
   | TaskSiteInspectionNotExists
   | TaskTemplateAccessDenied

export type SetSiteInspectionFieldObservationBulkResult = {
   __typename?: 'SetSiteInspectionFieldObservationBulkResult'
   fieldObservations: Array<FieldObservation>
   taskId: Scalars['String']
}

export type SetSiteInspectionFieldObservationByExcludeFieldsParams = {
   excludeAddAnotherFields: Array<ExcludeGofFieldParams>
   excludeNormalFieldIds: Array<Scalars['String']>
   observation: SiteInspectionObservationEnum
   taskId: Scalars['String']
}

export type SetSiteInspectionFieldObservationByExcludeFieldsResponse =
   | FieldIsDeleted
   | FieldNotFound
   | FieldsNotFound
   | NotTaskField
   | SetSiteInspectionFieldObservationByExcludeFieldsResult
   | SiteInspectionIsNotEditable
   | TaskAccessDenied
   | TaskNotFound
   | TaskSiteInspectionNotExists
   | TaskTemplateAccessDenied

export type SetSiteInspectionFieldObservationByExcludeFieldsResult = {
   __typename?: 'SetSiteInspectionFieldObservationByExcludeFieldsResult'
   excludeAddAnotherFields: Array<ExcludeGofField>
   excludeNormalFieldIds: Array<Scalars['String']>
   observation: SiteInspectionObservationEnum
   taskId: Scalars['String']
}

export type SetStageAssigneeFieldsToLogParams = {
   assigneeFieldIds: Array<Scalars['String']>
   considerStageAsSubmission?: InputMaybe<Scalars['Boolean']>
   entityTypes?: InputMaybe<Array<InputMaybe<AssigneeEntityType>>>
   stageId: Scalars['String']
   /** @deprecated Use entity_types parameter instead. This field will be removed in a future version. */
   trackArchitect?: InputMaybe<Scalars['Boolean']>
   /** @deprecated Use entity_types parameter instead. This field will be removed in a future version. */
   trackCitizen?: InputMaybe<Scalars['Boolean']>
}

export type SetStageAssigneeFieldsToLogResponse =
   | AddAnotherFieldsAreNotSupported
   | DependentFieldsNotSupported
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | NotStageAssigneeFields
   | SetStageAssigneeFieldsToLogResult
   | StageIsDeleted
   | StageNotFound
   | UserIsNotAnAdministrator

export type SetStageAssigneeFieldsToLogResult = {
   __typename?: 'SetStageAssigneeFieldsToLogResult'
   assigneeFieldIds: Array<Scalars['String']>
   considerStageAsSubmission?: Maybe<Scalars['Boolean']>
   entityTypes: Array<AssigneeEntityType>
   stageId: Scalars['String']
   /** @deprecated Use entity_types parameter instead. This field will be removed in a future version. */
   trackArchitect?: Maybe<Scalars['Boolean']>
   /** @deprecated Use entity_types parameter instead. This field will be removed in a future version. */
   trackCitizen?: Maybe<Scalars['Boolean']>
}

export type SetStageBoardRolesParams = {
   roleIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetStageBoardRolesResponse =
   | RolesNotFound
   | RolesNotInUserAccount
   | SetStageBoardRolesResult
   | StageAccessDenied
   | StageNotFound
   | UserIsNotAnAdministrator

export type SetStageBoardRolesResult = {
   __typename?: 'SetStageBoardRolesResult'
   identifications: Array<IdentificationOverviewDetails>
   roleIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetStageCreateAddAnotherGofPermissionsParams = {
   createAddAnotherGofIdentificationIds: Array<Scalars['String']>
   gofId: Scalars['String']
   stageId: Scalars['String']
}

export type SetStageCreateAddAnotherGofPermissionsResponse =
   | GoFIsDeleted
   | GoFNotFound
   | GoFsNotInPipeline
   | IdentificationsNotFound
   | NotAddAnotherGoF
   | SetStageCreateAddAnotherGofPermissionsResult
   | StageAccessDenied
   | StageNotFound
   | UserIsNotAnAdministrator

export type SetStageCreateAddAnotherGofPermissionsResult = {
   __typename?: 'SetStageCreateAddAnotherGofPermissionsResult'
   createAddAnotherGofIdentificationIds: Array<Scalars['String']>
   gofId: Scalars['String']
   stageId: Scalars['String']
}

export type SetStageDeletionStatusParams = {
   isDeletionStage: Scalars['Boolean']
   stageId: Scalars['String']
}

export type SetStageDeletionStatusResponse =
   | DisplayStageNotFound
   | OnlyOneDeletionStageAllowedPerPipeline
   | SetStageDeletionStatusResult
   | UserIsNotAnAdministrator

export type SetStageDeletionStatusResult = {
   __typename?: 'SetStageDeletionStatusResult'
   isDeletionStage: Scalars['Boolean']
   stageId: Scalars['String']
}

export type SetStageNoteSheetPermissionsParams = {
   identificationIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetStageNoteSheetPermissionsResponse =
   | IdentificationsNotFound
   | SetStageNoteSheetPermissionsResult
   | StageAccessDenied
   | StageNotFound
   | UserIsNotAnAdministrator

export type SetStageNoteSheetPermissionsResult = {
   __typename?: 'SetStageNoteSheetPermissionsResult'
   identificationIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetStageQuickEditFieldsParams = {
   fieldIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetStageQuickEditFieldsResponse =
   | AddAnotherFieldsAreNotSupported
   | DependentFieldsNotSupported
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | NotAllowedStageQuickEditFields
   | NotSupportedSalesTemplateFields
   | PipelineAccessDenied
   | SetStageQuickEditFieldsResult
   | StageIsDeleted
   | StageNotFound
   | UserIsNotAnAdministrator

export type SetStageQuickEditFieldsResult = {
   __typename?: 'SetStageQuickEditFieldsResult'
   fieldIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetStageRecommendedFeeRuleSetIdentificationsParams = {
   actionType: EntityActionType
   identificationIds: Array<Scalars['String']>
   ruleSetId: Scalars['String']
   stageId: Scalars['String']
}

export type SetStageRecommendedFeeRuleSetIdentificationsResponse =
   | IdentificationsNotFound
   | NotPipelineIdentifications
   | NotSupportPaymentRuleSet
   | StageNotFound
   | StageRecommendedFeeRuleSetIdentifications
   | UserIsNotAnAdministrator

export type SetStageRecommendedTaskIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   stageId: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type SetStageRecommendedTaskIdentificationsResponse =
   | IdentificationsNotFound
   | NotPipelineIdentifications
   | StageAndTaskTemplateAreNotInSamePipeline
   | StageNotFound
   | StageRecommendedTaskIdentifications
   | TaskTemplateNotFound
   | UserIsNotAnAdministrator

export type SetStageRecommendedTaskTemplatesParams = {
   stageId: Scalars['String']
   taskTemplateIds: Array<Scalars['String']>
}

export type SetStageRecommendedTaskTemplatesResponse =
   | SetStageRecommendedTaskTemplatesResult
   | StageAccessDenied
   | StageAndTaskTemplatesNotInSamePipeline
   | StageNotFound
   | TaskTemplatesNotFound
   | UserIsNotAnAdministrator

export type SetStageRecommendedTaskTemplatesResult = {
   __typename?: 'SetStageRecommendedTaskTemplatesResult'
   stageId: Scalars['String']
   taskTemplateIds: Array<Scalars['String']>
}

export type SetStageRemoveAddAnotherGofPermissionsParams = {
   gofId: Scalars['String']
   removeAddAnotherGofIdentificationIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetStageRemoveAddAnotherGofPermissionsResponse =
   | GoFIsDeleted
   | GoFNotFound
   | GoFsNotInPipeline
   | IdentificationsNotFound
   | NotAddAnotherGoF
   | SetStageRemoveAddAnotherGofPermissionsResult
   | StageAccessDenied
   | StageNotFound
   | UserIsNotAnAdministrator

export type SetStageRemoveAddAnotherGofPermissionsResult = {
   __typename?: 'SetStageRemoveAddAnotherGofPermissionsResult'
   gofId: Scalars['String']
   removeAddAnotherGofIdentificationIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type SetStageTransitionPermissionParams = {
   identificationIds: Array<Scalars['String']>
   stageTransitionId: Scalars['String']
}

export type SetStageTransitionPermissionResponse =
   | IdentificationsNotFound
   | NotPipelineIdentifications
   | SetStageTransitionPermissionResult
   | StageTransitionNotFound
   | UserIsNotAnAdministrator

export type SetStageTransitionPermissionResult = {
   __typename?: 'SetStageTransitionPermissionResult'
   identifications: Array<IdentificationOverviewDetails>
   stageTransitionId: Scalars['String']
}

export type SetStagesOrderParams = {
   isApplicationDisplayStage?: InputMaybe<Scalars['Boolean']>
   stageIds: Array<Scalars['String']>
}

export type SetStagesOrderResponse =
   | MissingStagesInPipeline
   | PipelineAccessDenied
   | SetStagesOrderResult
   | StagesNotFound
   | StagesNotInSamePipeline
   | UserIsNotAnAdministrator

export type SetStagesOrderResult = {
   __typename?: 'SetStagesOrderResult'
   stageIds: Array<Scalars['String']>
}

export type SetTaskTemplateIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   taskTemplateId?: InputMaybe<Scalars['String']>
}

export type SetTaskTemplateIdentificationsResponse =
   | IdentificationsNotFound
   | NotTaskTemplatePipelineIdentifications
   | SetTaskTemplateIdentificationsResult
   | TaskTemplateNotFound
   | UserAndIdentificationsAreNotInSameAccount
   | UserIsNotAnAdministrator

export type SetTaskTemplateIdentificationsResult = {
   __typename?: 'SetTaskTemplateIdentificationsResult'
   identificationIds: Array<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type SetTaskTemplateQuickEditFieldsParams = {
   fieldIds: Array<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type SetTaskTemplateQuickEditFieldsResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotUpdateCustomTaskTypeTemplate
   | DependentFieldsNotSupported
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | NotAllowedTaskTemplateQuickEditFields
   | NotSupportedForLinkedFieldsEnabledTaskTemplate
   | NotSupportedSalesTemplateFields
   | PipelineAccessDenied
   | SetTaskTemplateQuickEditFieldsResult
   | TaskTemplateNotFound
   | UserIsNotAnAdministrator

export type SetTaskTemplateQuickEditFieldsResult = {
   __typename?: 'SetTaskTemplateQuickEditFieldsResult'
   fieldIds: Array<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type SetTaskTemplatesOrderParams = {
   taskTemplateIds: Array<Scalars['String']>
}

export type SetTaskTemplatesOrderResponse =
   | DuplicateTaskTemplateIds
   | InvalidTaskTemplateIds
   | MissedPipelineTaskTemplateIds
   | SetTaskTemplatesOrderResult
   | TaskTemplatesAreNotInSamePipeline
   | UserIsNotAnAdministrator

export type SetTaskTemplatesOrderResult = {
   __typename?: 'SetTaskTemplatesOrderResult'
   taskTemplateIds: Array<Scalars['String']>
}

export type SetUserPinParams = {
   pin: Scalars['String']
   pinPurpose: PinPurpose
}

export type SetUserPinResponse =
   | OtpVerificationRequired
   | PinComplexityValidationFailed
   | PinMatchesPreviousPin
   | SetUserPinResult

export type SetUserPinResult = {
   __typename?: 'SetUserPinResult'
   expiresAt: Scalars['String']
   lastChangedAt: Scalars['String']
   success: Scalars['Boolean']
}

export type SetWhatsAppBusinessPhoneNumberUsersParams = {
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
   userIds: Array<Scalars['String']>
}

export type SetWhatsAppBusinessPhoneNumberUsersResponse =
   | AccountPluginIsDisabled
   | DeactivatedUsers
   | PipelineAccessDeniedToUsers
   | PipelineWhatsAppBusinessPhoneNumberNotFound
   | SetWhatsAppBusinessPhoneNumberUsersResult
   | UserIsNotAnAdministrator
   | UsersAreAlreadyToLinkedPipeline
   | UsersNotFound

export type SetWhatsAppBusinessPhoneNumberUsersResult = {
   __typename?: 'SetWhatsAppBusinessPhoneNumberUsersResult'
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
   users: Array<BaseUser>
}

export type SetWhatsAppMessageTemplateIdentificationsParams = {
   identificationIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type SetWhatsAppMessageTemplateIdentificationsResponse =
   | AccountPluginIsDisabled
   | IdentificationsNotFound
   | NotPipelineIdentifications
   | PipelineNotFound
   | SetWhatsAppMessageTemplateIdentificationsResult
   | UserIsNotAnAdministrator
   | WhatsAppMessageTemplateNotFound

export type SetWhatsAppMessageTemplateIdentificationsResult = {
   __typename?: 'SetWhatsAppMessageTemplateIdentificationsResult'
   identifications: Array<IdentificationOverviewDetails>
   pipelineId: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type SetWhatsAppMessageTemplateVariableMapParams = {
   buttonVariableFieldId?: InputMaybe<Scalars['String']>
   pipelineId: Scalars['String']
   variablesMappings: Array<WhatsAppMessageTemplateVariableFieldParams>
   whatsappMessageTemplateId: Scalars['String']
}

export type SetWhatsAppMessageTemplateVariableMapResponse =
   | AccountPluginIsDisabled
   | FieldsAreDeleted
   | FieldsNotFound
   | NotSupportedFields
   | PipelineNotFound
   | SetWhatsAppMessageTemplateVariableMapResult
   | UserIsNotAnAdministrator
   | WhatsAppMessageTemplateNotFound
   | WhatsAppMsgTemplateVariableNamesNotFound

export type SetWhatsAppMessageTemplateVariableMapResult = {
   __typename?: 'SetWhatsAppMessageTemplateVariableMapResult'
   buttonVariableFieldId?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   variablesMappings: Array<WhatsAppMessageTemplateVariableField>
   whatsappMessageTemplateId: Scalars['String']
}

export type SharableEntity = {
   __typename?: 'SharableEntity'
   entity?: Maybe<SharableEntityUnion>
   entityType: SharingEntityType
}

export type SharableEntityParams = {
   entityId: Scalars['String']
   entityType: SharingEntityType
}

export type SharableEntityResponse = {
   __typename?: 'SharableEntityResponse'
   entityId: Scalars['String']
   entityType: SharingEntityType
}

export type SharableEntityUnion = BaseUser | RoleConfig | UserGroupConfig

export type ShareBoardParams = {
   boardId: Scalars['String']
   sharableEntities: Array<SharableEntityParams>
}

export type ShareBoardResponse =
   | BoardAndIdentificationsNotInSameAccount
   | BoardEditAccessDenied
   | BoardNotFound
   | IdentificationsNotFound
   | ShareBoardResult
   | UsersNotFound
   | UsersNotInAccount

export type ShareBoardResult = {
   __typename?: 'ShareBoardResult'
   boardId: Scalars['String']
   sharableEntities: Array<SharableEntityResponse>
}

export enum SharingEntityType {
   Identification = 'IDENTIFICATION',
   User = 'USER'
}

export type SheetDataLoadingRequest = BaseDataLoadingRequest & {
   __typename?: 'SheetDataLoadingRequest'
   actionType: DataLoadingActionType
   cloudCallingServiceAccountId?: Maybe<Scalars['String']>
   completedAt?: Maybe<Scalars['String']>
   creationConfig?: Maybe<LeadsOrContactsCreationConfig>
   dataLoadingRequestId: Scalars['String']
   dataSheetId: Scalars['String']
   dataSourceType: DataSourceType
   entityId?: Maybe<Scalars['String']>
   failureReason?: Maybe<Scalars['String']>
   leadAssigneeFieldReferenceIdsToNotify: Array<Scalars['String']>
   noOfRecords: Scalars['Int']
   noOfRecordsProcessed: Scalars['Int']
   operationType?: Maybe<DataLoadingOperationType>
   pipelineId?: Maybe<Scalars['String']>
   preSignedRemarksS3Url?: Maybe<Scalars['String']>
   requestedAt: Scalars['String']
   shouldResetEmptyValues?: Maybe<Scalars['Boolean']>
   skipAutomationWorkflows: Scalars['Boolean']
   status: DataLoadingReqStatus
   subSheetName: Scalars['String']
   updationConfig?: Maybe<LeadsOrContactsUpdationConfig>
}

export type SheetDataLoadingRequestAlreadyExists = GraphQlBaseError & {
   __typename?: 'SheetDataLoadingRequestAlreadyExists'
   dataLoadingRequestId: Scalars['String']
   dataSheetId: Scalars['String']
   message?: Maybe<Scalars['String']>
   subSheetName: Scalars['String']
}

export enum ShortFallFieldStatus {
   FieldResponseUpdated = 'FIELD_RESPONSE_UPDATED',
   Rejected = 'REJECTED'
}

export type ShortFallFieldsConfig = {
   __typename?: 'ShortFallFieldsConfig'
   fieldIds?: Maybe<Array<Maybe<Scalars['String']>>>
   gofIds?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type ShortTextField = BaseField & {
   __typename?: 'ShortTextField'
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   formulaExpression?: Maybe<Scalars['String']>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isFormulaEnabled: Scalars['Boolean']
   isIdentificationField: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   prefixOptions?: Maybe<PrefixOptions>
   referenceId?: Maybe<Scalars['String']>
   regexErrorMessage?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   suffixOptions?: Maybe<SuffixOptions>
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
   validationRegex?: Maybe<Scalars['String']>
}

export type ShortTextFieldOptionsAreEnabled = GraphQlBaseError & {
   __typename?: 'ShortTextFieldOptionsAreEnabled'
   message?: Maybe<Scalars['String']>
}

export type ShortTextFieldPrefixOptionRequired = GraphQlBaseError & {
   __typename?: 'ShortTextFieldPrefixOptionRequired'
   message?: Maybe<Scalars['String']>
}

export type ShortTextFieldResponse = {
   __typename?: 'ShortTextFieldResponse'
   prefix?: Maybe<Scalars['String']>
   suffix?: Maybe<Scalars['String']>
   value: Scalars['String']
}

export type ShortTextFieldSuffixOptionRequired = GraphQlBaseError & {
   __typename?: 'ShortTextFieldSuffixOptionRequired'
   message?: Maybe<Scalars['String']>
}

export type ShortfallCounterInfo = {
   __typename?: 'ShortfallCounterInfo'
   currentCount: Scalars['Int']
   thresholdValue: Scalars['Int']
}

export type ShortfallFieldDetails = {
   __typename?: 'ShortfallFieldDetails'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   remarks?: Maybe<Scalars['String']>
   status: ShortFallFieldStatus
}

export type ShortfallLogsTab = BaseTab & {
   __typename?: 'ShortfallLogsTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type SignDocumentForDigitalSignParams = {
   documentId: Scalars['String']
   signFieldName: Scalars['String']
}

export type SignDocumentForDigitalSignResponse =
   | AmbiguousSignerForBlock
   | DigitalSignNotEnabledForBlock
   | DigitalSignNotEnabledForTemplate
   | DocumentIsDeleted
   | DocumentNotFound
   | InvalidESignBlockFieldNames
   | NoDocumentVersionForSigning
   | NoSignerResolvedForBlock
   | NotPermittedForSignBlocks
   | SignDocumentForDigitalSignResult
   | ZohoSignRateLimited
   | ZohoSignServiceUnavailable

export type SignDocumentForDigitalSignResult = {
   __typename?: 'SignDocumentForDigitalSignResult'
   signingUrl: Scalars['String']
}

export type SignDocumentNode = BaseNode & {
   __typename?: 'SignDocumentNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   copyDocumentUrlToField?: Maybe<Scalars['String']>
   documentTemplate?: Maybe<DocumentTemplateOverviewDetails>
   documentVersionState?: Maybe<DocumentVersionState>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   signFieldMappings: Array<AwDocumentSignFieldMapping>
   title?: Maybe<GenerateDocumentTitle>
}

export type SignDocumentNodeExecLog = BaseNodeExecLog & {
   __typename?: 'SignDocumentNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<SignDocumentNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type SignDocumentNodeExecLogResult = {
   __typename?: 'SignDocumentNodeExecLogResult'
   copyDocumentUrlToField?: Maybe<AwFileUploaderFieldMappingResult>
   document: GenerateDocumentResult
}

export type SignDocumentParams = {
   documentVersionId: Scalars['String']
   otp: Scalars['String']
   signatureFields: Array<Scalars['String']>
}

export type SignDocumentResponse =
   | DocumentVersion
   | DocumentVersionIsDeleted
   | DocumentVersionNotFound
   | EmptySignatureFields
   | InvalidOtp
   | InvalidSignatureImgLink
   | NotLatestDocumentVersion
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | SignatureFieldsNotFoundInDocumentVersion
   | SigningAlreadyCompletedForFields
   | UserSignatureImgLinkNotConfigured

export type SignPipelineItemDocumentParams = {
   documentId: Scalars['String']
   otp: Scalars['String']
   pin: Scalars['String']
   pipelineId: Scalars['String']
   pipelineItemId: Scalars['String']
   selectedFieldNames: Array<Scalars['String']>
}

export type SignPipelineItemDocumentResponse =
   | DocumentIsDeleted
   | DocumentNotFound
   | ESignBlocksAlreadySigned
   | InvalidESignBlockFieldNames
   | InvalidOtp
   | InvalidUserPin
   | NotPermittedForSignBlocks
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | SignPipelineItemDocumentResult
   | UserPinExpired
   | UserPinLocked
   | UserPinNotConfigured

export type SignPipelineItemDocumentResult = {
   __typename?: 'SignPipelineItemDocumentResult'
   document: Document
}

export type SignatureFieldStatus = {
   __typename?: 'SignatureFieldStatus'
   blockFieldName: Scalars['String']
   isSignMandatoryForStage: Scalars['Boolean']
   isSignableByUser: Scalars['Boolean']
   isSigned: Scalars['Boolean']
   signedAt?: Maybe<Scalars['String']>
   signedBy?: Maybe<BaseUser>
}

export type SignatureFieldsNotFound = GraphQlBaseError & {
   __typename?: 'SignatureFieldsNotFound'
   formFields: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type SignatureFieldsNotFoundInDocumentVersion = GraphQlBaseError & {
   __typename?: 'SignatureFieldsNotFoundInDocumentVersion'
   fieldNames: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type SigningAlreadyCompletedForFields = GraphQlBaseError & {
   __typename?: 'SigningAlreadyCompletedForFields'
   fieldNames: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type SiteInspectionApplicationAndTaskGoFResponseId = {
   __typename?: 'SiteInspectionApplicationAndTaskGoFResponseId'
   applicationGofResponseId: Scalars['String']
   taskGofResponseId: Scalars['String']
}

export type SiteInspectionColumn = {
   __typename?: 'SiteInspectionColumn'
   allowNegativeNumber?: Maybe<Scalars['Boolean']>
   columnId: Scalars['String']
   columnType: SiteInspectionColumnType
   noOfDigitsRoundOff?: Maybe<Scalars['Int']>
}

export type SiteInspectionColumnRow = {
   __typename?: 'SiteInspectionColumnRow'
   enableCopyRow: Scalars['Boolean']
   groupId?: Maybe<Scalars['String']>
   rowValues: Array<SiteInspectionColumnRowValue>
}

export type SiteInspectionColumnRowValue = {
   __typename?: 'SiteInspectionColumnRowValue'
   columnId: Scalars['String']
   fieldId?: Maybe<Scalars['String']>
   formula?: Maybe<Scalars['String']>
   isEnabled?: Maybe<BooleanFromSheetsEnum>
   isReadOnly?: Maybe<BooleanFromSheetsEnum>
}

export enum SiteInspectionColumnType {
   ContextValue = 'CONTEXT_VALUE',
   CustomValue = 'CUSTOM_VALUE',
   Formula = 'FORMULA',
   NestedColumn = 'NESTED_COLUMN',
   Observation = 'OBSERVATION',
   QuestionLabel = 'QUESTION_LABEL',
   QuestionValue = 'QUESTION_VALUE',
   Remarks = 'REMARKS'
}

export type SiteInspectionCopyColumnConfig = {
   __typename?: 'SiteInspectionCopyColumnConfig'
   copyActionName?: Maybe<Scalars['String']>
   copyFromColumn: Scalars['String']
   copyToColumn: Scalars['String']
}

export type SiteInspectionFieldObservation = {
   __typename?: 'SiteInspectionFieldObservation'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   observation: SiteInspectionObservationEnum
}

export enum SiteInspectionFieldProperty {
   Observation = 'OBSERVATION',
   Remarks = 'REMARKS'
}

export type SiteInspectionFieldRemarks = {
   __typename?: 'SiteInspectionFieldRemarks'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   remarks?: Maybe<Scalars['String']>
}

export type SiteInspectionGroup = {
   __typename?: 'SiteInspectionGroup'
   groupId: Scalars['String']
   name: Scalars['String']
}

export type SiteInspectionIsNotEditable = GraphQlBaseError & {
   __typename?: 'SiteInspectionIsNotEditable'
   message?: Maybe<Scalars['String']>
}

export type SiteInspectionObservationBulkUpdateConfig = {
   __typename?: 'SiteInspectionObservationBulkUpdateConfig'
   observationBulkUpdateActionName: Scalars['String']
   observationBulkUpdateValue: SiteInspectionObservationEnum
}

export enum SiteInspectionObservationEnum {
   Accepted = 'ACCEPTED',
   Rejected = 'REJECTED',
   Shortfall = 'SHORTFALL'
}

export type SiteInspectionQuestionFieldMapping = {
   __typename?: 'SiteInspectionQuestionFieldMapping'
   contextFieldId?: Maybe<Scalars['String']>
   questionFieldId: Scalars['String']
}

export type SiteInspectionTab = BaseTab & {
   __typename?: 'SiteInspectionTab'
   copyColumnConfig?: Maybe<SiteInspectionCopyColumnConfig>
   documentGenerationConfig?: Maybe<DocumentGenerationConfig>
   enableScheduling: Scalars['Boolean']
   enableTabStatusIcon: Scalars['Boolean']
   fieldsMapping: Array<SiteInspectionQuestionFieldMapping>
   formulaResultAllowNegative?: Maybe<BooleanFromSheetsEnum>
   formulaResultMaxDecimalPlaces?: Maybe<Scalars['Int']>
   groups: Array<SiteInspectionGroup>
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   observationBulkUpdateConfig?: Maybe<
      SiteInspectionObservationBulkUpdateConfig
   >
   orderedColumns: Array<SiteInspectionColumn>
   parentTabId?: Maybe<Scalars['String']>
   photographFieldIds: Array<Scalars['String']>
   rows: Array<SiteInspectionColumnRow>
   tabId: Scalars['String']
   tabType: TabType
   taskStatus?: Maybe<LayoutTabTaskStatus>
   taskTemplateId: Scalars['String']
}

export type SiteInspectionTaskDetails = {
   __typename?: 'SiteInspectionTaskDetails'
   canSendDocument: Scalars['Boolean']
   documentId?: Maybe<Scalars['String']>
   fieldWiseObservation: Array<SiteInspectionFieldObservation>
   fieldWiseRemarks: Array<SiteInspectionFieldRemarks>
   overallObservation?: Maybe<SiteInspectionObservationEnum>
   overallRemarks?: Maybe<Scalars['String']>
   taskAndApplicationGofResponses: Array<
      SiteInspectionApplicationAndTaskGoFResponseId
   >
   taskId: Scalars['String']
}

export type SiteInspectionTaskJobStatusResponse =
   | NoJobFoundOnTask
   | SiteInspectionTaskJobStatusResult
   | TaskAccessDenied
   | TaskNotFound

export type SiteInspectionTaskJobStatusResult = {
   __typename?: 'SiteInspectionTaskJobStatusResult'
   jobType: AsyncJobType
   numberOfGofResponsesCompleted: Scalars['Int']
   siteInspectionData?: Maybe<SiteInspectionTaskDetails>
   status: AsyncJobStatus
   taskId: Scalars['String']
   totalNumberOfGofResponses: Scalars['Int']
}

export type SizeInBytesIsRequiredForFileUploaderResponse = GraphQlBaseError & {
   __typename?: 'SizeInBytesIsRequiredForFileUploaderResponse'
   message?: Maybe<Scalars['String']>
   urls: Array<Scalars['String']>
}

export type SmartfloAccount = BasePluginServiceAccount & {
   __typename?: 'SmartfloAccount'
   creationDatetime: Scalars['String']
   isActive: Scalars['Boolean']
   name: Scalars['String']
   permanentAccessToken: Scalars['String']
   permanentAccessTokenParameterName: Scalars['String']
   pluginServiceAccountId: Scalars['String']
}

export type SmartfloAccountNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'SmartfloAccountNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type SmartfloAccountResult =
   | PluginServiceAccountNotFound
   | SmartfloAccount

export type SmartfloServiceAccounts = {
   __typename?: 'SmartfloServiceAccounts'
   smartfloAccounts: Array<SmartfloAccountResult>
}

export type Sort = {
   sortBy: Scalars['String']
   sortValue: SortValue
   templateId?: InputMaybe<Scalars['String']>
}

export type SortByField = {
   __typename?: 'SortByField'
   crmTemplateId: Scalars['String']
   fieldId: Scalars['String']
   sortValue: SortValue
}

export type SortByFieldParams = {
   fieldId: Scalars['String']
   sortValue: SortValue
}

export type SortResponse = {
   __typename?: 'SortResponse'
   sortBy: Scalars['String']
   sortValue: SortValue
   templateId?: Maybe<Scalars['String']>
}

export enum SortValue {
   Asc = 'ASC',
   Desc = 'DESC'
}

export type SourceFieldAlreadyLinkedInTemplate = GraphQlBaseError & {
   __typename?: 'SourceFieldAlreadyLinkedInTemplate'
   linkedSourceFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type SourceFieldAndSalesTemplateAreNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'SourceFieldAndSalesTemplateAreNotInSamePipeline'
   linkedSourceFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type StackedBarGraphConfig = {
   __typename?: 'StackedBarGraphConfig'
   analyticsLevel: AnalyticsLevel
   dataSources: Array<AnalyticsDataSourceType>
   dataSourcesWithDisplayNames: Array<DataSourceDisplayName>
   description?: Maybe<Scalars['String']>
   filterSetId: Scalars['String']
   firstDimension: GraphDimension
   graphId: Scalars['String']
   isOwner: Scalars['Boolean']
   metric: GraphMetric
   name: Scalars['String']
   pipelineId: Scalars['String']
   quickFilterFields: Array<GraphQuickFilterField>
   roles: Array<Role>
   secondDimension: GraphDimension
}

export type Stage = {
   __typename?: 'Stage'
   applicationConfig?: Maybe<StageApplicationConfig>
   assigneeFieldsConfig?: Maybe<AssigneeFieldsConfig>
   autoApplicationIdGenerationConfig?: Maybe<AutoApplicationIdGenerationConfig>
   category?: Maybe<StageCategory>
   color?: Maybe<ColorEnum>
   completedLayoutTabIds: Array<Scalars['String']>
   feePaymentPermissions: StageFeePaymentPermissions
   hasNoteSheetAccess: Scalars['Boolean']
   isApplicationDisplayStage: Scalars['Boolean']
   isDeletionStage: Scalars['Boolean']
   name: Scalars['String']
   order: Scalars['Int']
   overviewFieldsConfig: OverViewFieldsConfig
   permitOrderIdGenerationConfig?: Maybe<PermitOrderIdGenerationConfig>
   permittedLayoutTabIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
   quickEditFields: Array<Scalars['String']>
   recommendedTaskTemplateIds: Array<Scalars['String']>
   stageFeeRuleSetIdentifications: Array<
      StageRecommendedFeeRuleSetIdentifications
   >
   stageId: Scalars['String']
   stageTasksIdentifications: Array<StageRecommendedTaskIdentifications>
   transitions: Array<StageTransitionAction>
   userAddAnotherGofsPermissions: UserAddAnotherGoFsPermissions
}

export type StageAccessDenied = GraphQlBaseError & {
   __typename?: 'StageAccessDenied'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type StageAndTaskTemplateAreNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'StageAndTaskTemplateAreNotInSamePipeline'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type StageAndTaskTemplatesNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'StageAndTaskTemplatesNotInSamePipeline'
   message?: Maybe<Scalars['String']>
   taskTemplateIds: Array<Scalars['String']>
}

export type StageApplicationConfig = {
   __typename?: 'StageApplicationConfig'
   addAnotherGofPermissions: Array<AddAnotherGoFPermissions>
   allowedGofIds: Array<Scalars['String']>
   allowedSectionIds: Array<Scalars['String']>
   canMakeApplicationFieldsAsShortfall: Scalars['Boolean']
   noteSheetIdentifications: Array<IdentificationOverviewDetails>
   requiredFieldIds: Array<Scalars['String']>
   shouldShowShortfallFields: Scalars['Boolean']
   writableFieldIds: Array<Scalars['String']>
}

export type StageAssigneeTimespentLog = {
   __typename?: 'StageAssigneeTimespentLog'
   assigneePathNumber: Scalars['Int']
   designation?: Maybe<Scalars['String']>
   enteredDatetime: Scalars['String']
   entityType: AssigneeEntityType
   leftAtDatetime?: Maybe<Scalars['String']>
   movementDirection?: Maybe<AssigneeStageMovementDirectionEnum>
   order: Scalars['Int']
   participantType?: Maybe<ParticipantType>
   timeSpentInSec?: Maybe<Scalars['Float']>
   user?: Maybe<BaseUser>
}

export type StageAssigneeTimespentLogInPortal = {
   __typename?: 'StageAssigneeTimespentLogInPortal'
   assigneeTimeSpentLogs: Array<AssigneeTimespentLogInPortal>
   stage: Stage
}

export type StageAssigneeTimespentLogSummary = {
   __typename?: 'StageAssigneeTimespentLogSummary'
   designation?: Maybe<Scalars['String']>
   entityType: AssigneeEntityType
   totalTimeSpentInSec: Scalars['Float']
   userId: Scalars['String']
   userName?: Maybe<Scalars['String']>
}

export type StageBoardRolesResult =
   | StageAccessDenied
   | StageNotFound
   | StageRoles

export enum StageCategory {
   Failed = 'FAILED',
   Progress = 'PROGRESS',
   Success = 'SUCCESS'
}

export type StageDetailsInSubscription = {
   __typename?: 'StageDetailsInSubscription'
   color?: Maybe<ColorEnum>
   name: Scalars['String']
   order: Scalars['Int']
   stageId: Scalars['String']
}

export type StageFeePaymentPermissions = {
   __typename?: 'StageFeePaymentPermissions'
   canCreateFeePayment: Scalars['Boolean']
   canDeleteFeePayment: Scalars['Boolean']
   canUpdateFeePayment: Scalars['Boolean']
   stageId: Scalars['String']
}

export type StageFieldResponse = {
   __typename?: 'StageFieldResponse'
   stage: Stage
   stageFieldId: Scalars['String']
}

export type StageFieldResponseParams = {
   stageFieldId: Scalars['String']
   stageId: Scalars['String']
}

export type StageFieldsCannotHaveEmptyResponse = GraphQlBaseError & {
   __typename?: 'StageFieldsCannotHaveEmptyResponse'
   message?: Maybe<Scalars['String']>
   stageFieldIds: Array<Scalars['String']>
}

export type StageIsDeleted = GraphQlBaseError & {
   __typename?: 'StageIsDeleted'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type StageIsRequiredInPipelineItemCreation = GraphQlBaseError & {
   __typename?: 'StageIsRequiredInPipelineItemCreation'
   message?: Maybe<Scalars['String']>
}

export type StageNameAlreadyUsedInPipeline = GraphQlBaseError & {
   __typename?: 'StageNameAlreadyUsedInPipeline'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type StageNotAllowedInRecordCreationConfig = GraphQlBaseError & {
   __typename?: 'StageNotAllowedInRecordCreationConfig'
   message?: Maybe<Scalars['String']>
   recordCreationConfigId: Scalars['Int']
   stageId: Scalars['String']
}

export type StageNotConfiguredForPipeline = GraphQlBaseError & {
   __typename?: 'StageNotConfiguredForPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type StageNotFound = GraphQlBaseError & {
   __typename?: 'StageNotFound'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type StageNotInPipeline = GraphQlBaseError & {
   __typename?: 'StageNotInPipeline'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type StageNotInRelationPipeline = GraphQlBaseError & {
   __typename?: 'StageNotInRelationPipeline'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type StageRecommendedFeeRuleSetIdentifications = {
   __typename?: 'StageRecommendedFeeRuleSetIdentifications'
   actionType: EntityActionType
   identifications: Array<IdentificationOverviewDetails>
   ruleSetId: Scalars['String']
   stageId: Scalars['String']
}

export type StageRecommendedTaskIdentifications = {
   __typename?: 'StageRecommendedTaskIdentifications'
   identifications: Array<IdentificationOverviewDetails>
   stageId: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type StageRoles = {
   __typename?: 'StageRoles'
   roles: Array<Role>
   stageId: Scalars['String']
}

export type StageTransition = {
   __typename?: 'StageTransition'
   actionName?: Maybe<Scalars['String']>
   canMovePaymentsFromDraftToYetToPay: Scalars['Boolean']
   canSkipStageRequiredFieldsValidation?: Maybe<Scalars['Boolean']>
   checkpointsConfig?: Maybe<StageTransitionCheckpointsConfig>
   confirmationPopupConfig?: Maybe<StageTransitionConfigConfirmationPopupConfig>
   discardTaskTemplateIds: Array<Scalars['String']>
   fromStageId: Scalars['String']
   functionIds?: Maybe<Array<Scalars['String']>>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   identifications: Array<IdentificationOverviewDetails>
   isFeeCreationMandatory?: Maybe<Scalars['Boolean']>
   isNotesRequired?: Maybe<Scalars['Boolean']>
   mandatoryTaskTemplateIds: Array<Scalars['String']>
   order: Scalars['Int']
   remarksConfig?: Maybe<StageTransitionConfigRemarksConfig>
   requireAllTdrRequestsAccepted?: Maybe<Scalars['Boolean']>
   shouldPayPendingOrders: Scalars['Boolean']
   stageTransitionId: Scalars['String']
   stageTransitionType: StageTransitionType
   tdrSaleAndTransferRequestConfig?: Maybe<TdrSaleAndTransferRequestConfig>
   toStageId: Scalars['String']
   transitionFieldIds: Array<Scalars['String']>
}

export type StageTransitionAccessDenied = GraphQlBaseError & {
   __typename?: 'StageTransitionAccessDenied'
   message?: Maybe<Scalars['String']>
   stageTransitionId: Scalars['String']
}

export type StageTransitionAction = {
   __typename?: 'StageTransitionAction'
   actionName?: Maybe<Scalars['String']>
   canSkipEsignDocumentSigning?: Maybe<Scalars['Boolean']>
   canSkipPhoneNumberFieldsVerification?: Maybe<Scalars['Boolean']>
   canSkipStageRequiredFieldsValidation?: Maybe<Scalars['Boolean']>
   checkpointsConfig?: Maybe<StageTransitionCheckpointsConfig>
   confirmationPopupConfig?: Maybe<StageTransitionConfigConfirmationPopupConfig>
   fromStage: BaseStage
   fromStageId: Scalars['String']
   functionIds?: Maybe<Array<Scalars['String']>>
   hasMandatoryTasks: Scalars['Boolean']
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isFeeCreationMandatory?: Maybe<Scalars['Boolean']>
   isNotesRequired?: Maybe<Scalars['Boolean']>
   order: Scalars['Int']
   remarksConfig?: Maybe<StageTransitionConfigRemarksConfig>
   stageTransitionId: Scalars['String']
   toStage: BaseStage
   toStageId: Scalars['String']
   transitionFieldIds: Array<Scalars['String']>
}

export enum StageTransitionActionStatus {
   Disabled = 'DISABLED',
   Enabled = 'ENABLED'
}

export type StageTransitionAlreadyExists = GraphQlBaseError & {
   __typename?: 'StageTransitionAlreadyExists'
   fromStageId: Scalars['String']
   message?: Maybe<Scalars['String']>
   toStageId: Scalars['String']
}

export enum StageTransitionButtonActionType {
   Default = 'DEFAULT'
}

export type StageTransitionCheckpoint = {
   __typename?: 'StageTransitionCheckpoint'
   checkpointId: Scalars['String']
   description: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type StageTransitionCheckpointNotFound = GraphQlBaseError & {
   __typename?: 'StageTransitionCheckpointNotFound'
   checkpointId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type StageTransitionCheckpointStatusParams = {
   checkpointId: Scalars['String']
   isChecked: Scalars['Boolean']
}

export type StageTransitionCheckpointsConfig = {
   __typename?: 'StageTransitionCheckpointsConfig'
   checkpoints: Array<StageTransitionCheckpoint>
   checkpointsHeaderText?: Maybe<Scalars['String']>
   stageTransitionId: Scalars['String']
}

export type StageTransitionCheckpointsNotFilled = GraphQlBaseError & {
   __typename?: 'StageTransitionCheckpointsNotFilled'
   checkpointIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type StageTransitionCheckpointsNotFound = GraphQlBaseError & {
   __typename?: 'StageTransitionCheckpointsNotFound'
   checkpointIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type StageTransitionConfigConfirmationPopupConfig = {
   __typename?: 'StageTransitionConfigConfirmationPopupConfig'
   description?: Maybe<Scalars['String']>
   enableConfirmationPopup: Scalars['Boolean']
   title?: Maybe<Scalars['String']>
}

export type StageTransitionConfigConfirmationPopupConfigParams = {
   description?: InputMaybe<Scalars['String']>
   enableConfirmationPopup: Scalars['Boolean']
   title?: InputMaybe<Scalars['String']>
}

export enum StageTransitionConfigPropertyEnum {
   MandatoryTaskTemplateIds = 'MANDATORY_TASK_TEMPLATE_IDS',
   RemarksConfig = 'REMARKS_CONFIG',
   StageTransitionFieldIds = 'STAGE_TRANSITION_FIELD_IDS'
}

export type StageTransitionConfigRemarksConfig = {
   __typename?: 'StageTransitionConfigRemarksConfig'
   enableRemarks: Scalars['Boolean']
   isRemarksRequired: Scalars['Boolean']
}

export type StageTransitionConfigRemarksConfigParams = {
   enableRemarks: Scalars['Boolean']
   isRemarksRequired: Scalars['Boolean']
}

export type StageTransitionInPortal = {
   __typename?: 'StageTransitionInPortal'
   actionName?: Maybe<Scalars['String']>
   checkpointsConfig?: Maybe<StageTransitionCheckpointsConfig>
   fromStageId: Scalars['String']
   stageTransitionId: Scalars['String']
   successPopupConfig?: Maybe<StageTransitionSuccessPopupConfigInPortal>
   toStageId: Scalars['String']
}

export type StageTransitionMandatoryEntitiesStatus = {
   __typename?: 'StageTransitionMandatoryEntitiesStatus'
   mandatoryTasks: Array<StageTransitionMandatoryTaskStatus>
   stageTransition: StageTransitionAction
   stageTransitionType: StageTransitionType
}

export type StageTransitionMandatoryTaskStatus = {
   __typename?: 'StageTransitionMandatoryTaskStatus'
   iconUrl: Scalars['String']
   name: Scalars['String']
   status: TaskStatus
   taskTemplateId: Scalars['String']
}

export type StageTransitionNotFound = GraphQlBaseError & {
   __typename?: 'StageTransitionNotFound'
   message?: Maybe<Scalars['String']>
   stageTransitionId: Scalars['String']
}

export type StageTransitionNotInApplicationDisplayStage = GraphQlBaseError & {
   __typename?: 'StageTransitionNotInApplicationDisplayStage'
   applicationId: Scalars['String']
   message?: Maybe<Scalars['String']>
   stageTransitionId: Scalars['String']
}

export type StageTransitionSuccessPopupConfigInPortal = {
   __typename?: 'StageTransitionSuccessPopupConfigInPortal'
   buttonsConfig: Array<StageTransitionsButtonConfig>
   description?: Maybe<Scalars['String']>
   title?: Maybe<Scalars['String']>
   uiVariant?: Maybe<StageTransitionUiVariantEnum>
}

export enum StageTransitionType {
   Default = 'DEFAULT',
   SendBack = 'SEND_BACK',
   Shortfall = 'SHORTFALL',
   TdrSaleAndTransferRequest = 'TDR_SALE_AND_TRANSFER_REQUEST'
}

export enum StageTransitionUiVariantEnum {
   Default = 'DEFAULT'
}

export type StageTransitionsButtonConfig = {
   __typename?: 'StageTransitionsButtonConfig'
   actionType?: Maybe<StageTransitionButtonActionType>
   buttonName?: Maybe<Scalars['String']>
}

export type StageTransitionsCheckpointsConfig = {
   __typename?: 'StageTransitionsCheckpointsConfig'
   stageTransitionCheckpoints: Array<StageTransitionCheckpointsConfig>
}

export type StageTransitionsNotFound = GraphQlBaseError & {
   __typename?: 'StageTransitionsNotFound'
   message?: Maybe<Scalars['String']>
   stageTransitionIds: Array<Scalars['String']>
}

export type StageUpdatePermissions = {
   __typename?: 'StageUpdatePermissions'
   fromStageId: Scalars['String']
   roleIds: Array<Scalars['String']>
   toStageId: Scalars['String']
}

export type StageUpdatedTriggerConfig = {
   __typename?: 'StageUpdatedTriggerConfig'
   stageFieldId: Scalars['String']
   transitions: Array<AwStageUpdatedTransition>
}

export type StageUpdatedTriggerConfigIsRequired = GraphQlBaseError & {
   __typename?: 'StageUpdatedTriggerConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type StageUpdatedTriggerConfigParams = {
   stageFieldId: Scalars['String']
   transitions: Array<AwStageUpdatedTransitionParams>
}

export type StageWiseMandatoryEntitiesStatus = {
   __typename?: 'StageWiseMandatoryEntitiesStatus'
   mandatoryTasks: Array<StageTransitionMandatoryTaskStatus>
   stageTransitionId: Scalars['String']
}

export type StageWiseMandatoryTaskStatus = {
   __typename?: 'StageWiseMandatoryTaskStatus'
   mandatoryTasks: Array<StageTransitionMandatoryTaskStatus>
   stageTransitionId: Scalars['String']
}

export type StageWisePipelineItemsStatsResponse =
   | PipelineAccessDenied
   | PipelineNotFound
   | StageWisePipelineItemsStatsResult

export type StageWisePipelineItemsStatsResult = {
   __typename?: 'StageWisePipelineItemsStatsResult'
   stageWiseStats: Array<StagesWisePipelineItemsStats>
   totalPipelineItems: Scalars['Int']
}

export type StageWiseTransitions = {
   __typename?: 'StageWiseTransitions'
   stageId: Scalars['String']
   transitions: Array<StageTransition>
}

export type StageWiseTransitionsInPortal = {
   __typename?: 'StageWiseTransitionsInPortal'
   stageId: Scalars['String']
   transitions: Array<StageTransitionInPortal>
}

export type StageWiseTransitionsInPortalResponse =
   | StageAccessDenied
   | StageNotFound
   | StageWiseTransitionsInPortal

export type Stages = {
   __typename?: 'Stages'
   stages: Array<Stage>
   totalCount: Scalars['Int']
}

export type StagesAreNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'StagesAreNotInSamePipeline'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export type StagesNotFound = GraphQlBaseError & {
   __typename?: 'StagesNotFound'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export type StagesNotInActivityTemplatePipelines = GraphQlBaseError & {
   __typename?: 'StagesNotInActivityTemplatePipelines'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export type StagesNotInPipeline = GraphQlBaseError & {
   __typename?: 'StagesNotInPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   stageIds: Array<Scalars['String']>
}

export type StagesNotInPipelineItemTemplatePipelines = GraphQlBaseError & {
   __typename?: 'StagesNotInPipelineItemTemplatePipelines'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export type StagesNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'StagesNotInSamePipeline'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export type StagesResult = Stage | StageNotFound

export type StagesWisePipelineItemsStats = {
   __typename?: 'StagesWisePipelineItemsStats'
   pipelineItemsCount: Scalars['Int']
   stage: Stage
}

export type StagesWisePipelineItemsStatsParams = {
   pipelineId: Scalars['String']
   userHierarchyFilter?: InputMaybe<UserHierarchyFilter>
}

export type StartDateConfigIsRequired = GraphQlBaseError & {
   __typename?: 'StartDateConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type StartDateIsRequired = GraphQlBaseError & {
   __typename?: 'StartDateIsRequired'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type StartDateValueConfig = {
   __typename?: 'StartDateValueConfig'
   relativeValueConfig?: Maybe<DateRelativeValueConfig>
   value?: Maybe<Scalars['String']>
   valueFrom?: Maybe<FieldSourceType>
}

export type StartDateValueConfigParams = {
   relativeValueConfig?: InputMaybe<DateRelativeValueConfigParams>
   value?: InputMaybe<Scalars['String']>
   valueFrom?: InputMaybe<FieldSourceType>
}

export type StartTimeValueConfig = {
   __typename?: 'StartTimeValueConfig'
   relativeValueConfig?: Maybe<TimeRelativeValueConfig>
   value?: Maybe<Scalars['String']>
   valueFrom?: Maybe<FieldSourceType>
}

export type StartTimeValueConfigParams = {
   relativeValueConfig?: InputMaybe<TimeRelativeValueConfigParams>
   value?: InputMaybe<Scalars['String']>
   valueFrom?: InputMaybe<FieldSourceType>
}

export type StructuredEntityConfigurationData = PortalFiltersConfiguration

export type StructuredEntityJsonConfiguration = {
   __typename?: 'StructuredEntityJsonConfiguration'
   data: StructuredEntityConfigurationData
   entityType: JsonConfigurationEntityType
   jsonConfigId: Scalars['String']
}

export type SubSheetNotFound = GraphQlBaseError & {
   __typename?: 'SubSheetNotFound'
   dataSheetId: Scalars['String']
   message?: Maybe<Scalars['String']>
   subSheetName: Scalars['String']
}

export type SubmitAnalyticsQueryResponseFeedbackParams = {
   feedback?: InputMaybe<Scalars['String']>
   queryResponseId: Scalars['String']
   reaction?: InputMaybe<UserReaction>
}

export type SubmitAnalyticsQueryResponseFeedbackResponse =
   | QueryResponseNotFound
   | SubmitAnalyticsQueryResponseFeedbackResult

export type SubmitAnalyticsQueryResponseFeedbackResult = {
   __typename?: 'SubmitAnalyticsQueryResponseFeedbackResult'
   feedback?: Maybe<Scalars['String']>
   queryResponseId: Scalars['String']
   reaction?: Maybe<UserReaction>
}

export type SubmitBpsVerificationTaskParams = {
   recommendation: BpsVerificationRecommendationEnum
   remarks?: InputMaybe<Scalars['String']>
   submittedLocation?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
}

export type SubmitBpsVerificationTaskResponse =
   | CallStatusFieldIsRequired
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidGeoLocationFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | NeedFieldWritePermission
   | PipelineItemIsDeleted
   | PipelineItemsNotLinkedToTaskPipelineItemRelation
   | RequiredFieldsNotFilled
   | SubmitBpsVerificationTaskResult
   | TaskAccessDenied
   | TaskDiscarded
   | TaskIsAlreadyCompleted
   | TaskNotFound
   | UniqueFieldResponseAlreadyExists

export type SubmitBpsVerificationTaskResult = {
   __typename?: 'SubmitBpsVerificationTaskResult'
   completedAt: Scalars['String']
   taskId: Scalars['String']
   taskTemplateId: Scalars['String']
   updatedPipelineItemFields: Array<GoFResponseFieldIds>
}

export type SubmitFeedbackInPortalParams = {
   applicationId?: InputMaybe<Scalars['String']>
   feedback?: InputMaybe<Scalars['String']>
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   rating?: InputMaybe<Scalars['Float']>
}

export type SubmitFeedbackInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | CannotSubmitEmptyFeedback
   | CustomerPortalUserFeedback
   | FeedbackRegexValidationFailed
   | PortalNotFound

export type SubmitLineDepartmentRecommendationParams = {
   pipelineItemId: Scalars['String']
   remarks: Scalars['String']
   tabId: Scalars['String']
   verificationId: Scalars['String']
}

export type SubmitLineDepartmentRecommendationResponse =
   | ActiveLineDepartmentRequestExists
   | LayoutTabNotFound
   | LineDepartmentActionNotPermittedForUser
   | LineDepartmentRemarksRequired
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | SubmitLineDepartmentRecommendationResult
   | TabNotInPipelineItemTemplate
   | VerificationNotFound

export type SubmitLineDepartmentRecommendationResult = {
   __typename?: 'SubmitLineDepartmentRecommendationResult'
   remarks: Scalars['String']
   requestId: Scalars['String']
}

export type SubmitSiteInspectionParams = {
   overallObservation: SiteInspectionObservationEnum
   overallRemarks?: InputMaybe<Scalars['String']>
   siteInspectionLocation?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
}

export type SubmitSiteInspectionResponse =
   | CallLogsAlreadyLinkedToAnotherCompletedTask
   | CallStatusFieldIsRequired
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidGeoLocationFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | NeedFieldWritePermission
   | PipelineItemIsDeleted
   | PipelineItemsNotLinkedToTaskPipelineItemRelation
   | RequiredFieldsNotFilled
   | SiteInspectionIsNotEditable
   | SubmitSiteInspectionResult
   | TaskAccessDenied
   | TaskDiscarded
   | TaskIsAlreadyCompleted
   | TaskNotFound
   | UniqueFieldResponseAlreadyExists

export type SubmitSiteInspectionResult = {
   __typename?: 'SubmitSiteInspectionResult'
   completedAt: Scalars['String']
   taskId: Scalars['String']
   taskTemplateId: Scalars['String']
   updatedPipelineItemFields: Array<GoFResponseFieldIds>
}

export type SubmitTdrOrderForVerificationParams = {
   portalId: Scalars['String']
   portalType: PortalType
   tdrOrderId: Scalars['String']
}

export type SubmitTdrOrderForVerificationResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | PaymentOrderNotFound
   | PortalNotFound
   | SubmitTdrOrderForVerificationResult
   | TdrOrderAccessDenied
   | TdrOrderHasNoActivePayments
   | TdrOrderInvalidStatus
   | TdrOrderNotFound
   | TdrPaymentAmountInsufficient
   | TdrPaymentsNotInInitiatedState
   | TdrRequestsInitiationFailed
   | TdrRequestsOwnershipNotVerified
   | TdrRequestsReleaseFailed

export type SubmitTdrOrderForVerificationResult = {
   __typename?: 'SubmitTDROrderForVerificationResult'
   tdrOrderId: Scalars['String']
}

export type SubmitTaskParams = {
   taskId: Scalars['String']
   taskSubmittedLocation?: InputMaybe<Scalars['String']>
}

export type SubmitTaskResponse =
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | CallLogsAlreadyLinkedToAnotherCompletedTask
   | CallStatusFieldIsRequired
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidGeoLocationFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | NeedFieldWritePermission
   | PipelineItemsAreDeleted
   | PipelineItemsNotLinkedToTaskPipelineItemRelation
   | RequiredFieldsNotFilled
   | SubmitTaskResult
   | TaskAccessDenied
   | TaskDiscarded
   | TaskIsAlreadyCompleted
   | TaskNotFound
   | TaskTemplateAccessDenied
   | UniqueFieldResponseAlreadyExists

export type SubmitTaskResult = {
   __typename?: 'SubmitTaskResult'
   completedAt: Scalars['String']
   remarks?: Maybe<PipelineItemRemarks>
   taskId: Scalars['String']
   taskTemplateId: Scalars['String']
   updatedPipelineItemFields: Array<GoFResponseFieldIds>
}

export type Subscription = {
   __typename?: 'Subscription'
   applicationUpdatedInPipelineSubscription?: Maybe<
      ApplicationUpdatedDummyMutationResult
   >
   applicationUpdatedInTemplateSubscription?: Maybe<
      ApplicationUpdatedDummyMutationResult
   >
   applicationUpdatedSubscription?: Maybe<ApplicationUpdatedDummyMutationResult>
   dummySubscription?: Maybe<DummyMutationResult>
   feeUpdatedSubscription?: Maybe<FeeUpdatedDummyMutationResult>
   orderStatusUpdatedSubscription?: Maybe<OrderStatusUpdatedDummyMutationResult>
   regenerateConditionsLettersSubscription?: Maybe<
      RegenerateConditionsLettersDummyMutationResult
   >
   sendQueryResponseInThreadSubscription?: Maybe<
      SendQueryResponseInThreadResponse
   >
   sendQueryStreamedDataInThreadSubscription?: Maybe<
      SendQueryStreamedDataInThreadResponse
   >
}

export type SubscriptionApplicationUpdatedInPipelineSubscriptionArgs = {
   pipelineId: Scalars['String']
}

export type SubscriptionApplicationUpdatedInTemplateSubscriptionArgs = {
   pipelineItemTemplateId: Scalars['String']
}

export type SubscriptionApplicationUpdatedSubscriptionArgs = {
   pipelineItemId: Scalars['String']
}

export type SubscriptionFeeUpdatedSubscriptionArgs = {
   applicationId: Scalars['String']
}

export type SubscriptionOrderStatusUpdatedSubscriptionArgs = {
   entityId: Scalars['String']
   entityType: OrderEntityType
}

export type SubscriptionRegenerateConditionsLettersSubscriptionArgs = {
   pipelineItemId: Scalars['String']
}

export type SubscriptionSendQueryResponseInThreadSubscriptionArgs = {
   threadId: Scalars['Int']
}

export type SubscriptionSendQueryStreamedDataInThreadSubscriptionArgs = {
   threadId: Scalars['Int']
}

export type SuccessPopupButtonConfig = {
   __typename?: 'SuccessPopupButtonConfig'
   actionType?: Maybe<OrderConfigButtonActionType>
   buttonName?: Maybe<Scalars['String']>
}

export type SuccessStageAlreadyConfigured = GraphQlBaseError & {
   __typename?: 'SuccessStageAlreadyConfigured'
   message?: Maybe<Scalars['String']>
   successStageId: Scalars['String']
}

export type SuffixOptions = {
   __typename?: 'SuffixOptions'
   isEnabled: Scalars['Boolean']
   values: Array<Scalars['String']>
}

export type SuffixOptionsParams = {
   isEnabled: Scalars['Boolean']
   values: Array<Scalars['String']>
}

export enum SupportedSalesTemplateTypesForRelation {
   Contact = 'CONTACT',
   PipelineItem = 'PIPELINE_ITEM'
}

export type SurveyNumberAreaSumMismatchWithPlotArea = GraphQlBaseError & {
   __typename?: 'SurveyNumberAreaSumMismatchWithPlotArea'
   calculatedArea: Scalars['String']
   expectedArea: Scalars['String']
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type SurveyNumberFieldConfig = {
   __typename?: 'SurveyNumberFieldConfig'
   areaFieldId?: Maybe<Scalars['String']>
   concatenatedSurveyNumbersFieldId?: Maybe<Scalars['String']>
   districtFieldId: Scalars['String']
   gofId?: Maybe<Scalars['String']>
   mandalFieldId: Scalars['String']
   prohibitingSupportingDocumentFieldId: Scalars['String']
   surveyNumberCategoryFieldId?: Maybe<Scalars['String']>
   surveyNumberFieldId: Scalars['String']
   ulbCodeFieldId: Scalars['String']
   villageFieldId: Scalars['String']
}

export type SurveyNumberFieldNotFound = GraphQlBaseError & {
   __typename?: 'SurveyNumberFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum SurveyNumberRemarkEnum {
   Prohibited = 'PROHIBITED'
}

export type SwiftsellOutboundWebhookNode = BaseNode & {
   __typename?: 'SwiftsellOutboundWebhookNode'
   authorizationToken?: Maybe<Scalars['String']>
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   customAttributes: Array<CustomKeyFieldValueMapping>
   fixedAttributes: SwiftsellOutboundWebhookNodeFixedAtrributes
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   webhookUrl?: Maybe<Scalars['String']>
}

export type SwiftsellOutboundWebhookNodeExecLog = BaseNodeExecLog & {
   __typename?: 'SwiftsellOutboundWebhookNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<SwiftsellOutboundWebhookNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type SwiftsellOutboundWebhookNodeExecLogResult = {
   __typename?: 'SwiftsellOutboundWebhookNodeExecLogResult'
   responseJson: Scalars['String']
   statusCode: Scalars['Int']
}

export type SwiftsellOutboundWebhookNodeFixedAtrributes = {
   __typename?: 'SwiftsellOutboundWebhookNodeFixedAtrributes'
   email?: Maybe<AutomationWorkflowFieldValueMapping>
   name?: Maybe<AutomationWorkflowFieldValueMapping>
   phoneNumber?: Maybe<AutomationWorkflowFieldValueMapping>
}

export type SwiftsellOutboundWebhookNodeFixedAtrributesParams = {
   email?: InputMaybe<AutomationWorkflowFieldValueMappingParams>
   name?: InputMaybe<AutomationWorkflowFieldValueMappingParams>
   phoneNumber?: InputMaybe<AutomationWorkflowFieldValueMappingParams>
}

export type SyncPluginServiceAccountWhatsappMessageTemplatesParams = {
   pluginServiceAccountId: Scalars['String']
}

export type SyncPluginServiceAccountWhatsappMessageTemplatesResponse =
   | AccountPluginIsDisabled
   | AtLeastOneWhatsAppBusinessPhoneNumberConfigIsRequired
   | InvalidWatiServiceAccountEndPoint
   | InvalidWhatsAppServiceAccountConfiguration
   | NotAWhatsAppPluginServiceAccount
   | PluginServiceAccountIsNotActive
   | SyncPluginServiceAccountWhatsappMessageTemplatesResult
   | UserIsNotAnAdministrator
   | WatiPluginServiceAccountNotFound
   | WatiServiceAccountAccessTokenHasExpired
   | WhatsappMessageTemplatesSyncIsInProgress

export type SyncPluginServiceAccountWhatsappMessageTemplatesResult = {
   __typename?: 'SyncPluginServiceAccountWhatsappMessageTemplatesResult'
   pluginServiceAccountId: Scalars['String']
   syncStatus: WhatsAppMessageTemplatesSyncStatus
}

export enum SystemFieldEnum {
   ActivityDateTime = 'ACTIVITY_DATE_TIME',
   ApplicationAssignedOn = 'APPLICATION_ASSIGNED_ON',
   ApplicationAssignee = 'APPLICATION_ASSIGNEE',
   ApplicationCreatedOn = 'APPLICATION_CREATED_ON',
   ApplicationCustomerId = 'APPLICATION_CUSTOMER_ID',
   ApplicationCustomId = 'APPLICATION_CUSTOM_ID',
   ApplicationDisplayStage = 'APPLICATION_DISPLAY_STAGE',
   ApplicationId = 'APPLICATION_ID',
   ApplicationScore = 'APPLICATION_SCORE',
   ApplicationStage = 'APPLICATION_STAGE',
   ArchitectId = 'ARCHITECT_ID',
   ContactAssignedOn = 'CONTACT_ASSIGNED_ON',
   ContactAssignee = 'CONTACT_ASSIGNEE',
   ContactCustomId = 'CONTACT_CUSTOM_ID',
   ContactEmail = 'CONTACT_EMAIL',
   ContactFirstName = 'CONTACT_FIRST_NAME',
   ContactLastName = 'CONTACT_LAST_NAME',
   ContactPhoneNumber = 'CONTACT_PHONE_NUMBER',
   CustomObjectAssignedOn = 'CUSTOM_OBJECT_ASSIGNED_ON',
   CustomObjectAssignee = 'CUSTOM_OBJECT_ASSIGNEE',
   CustomObjectCreatedOn = 'CUSTOM_OBJECT_CREATED_ON',
   CustomObjectCustomId = 'CUSTOM_OBJECT_CUSTOM_ID',
   CustomObjectScore = 'CUSTOM_OBJECT_SCORE',
   CustomObjectStage = 'CUSTOM_OBJECT_STAGE',
   CustomTaskTitle = 'CUSTOM_TASK_TITLE',
   DealAssignedOn = 'DEAL_ASSIGNED_ON',
   DealAssignee = 'DEAL_ASSIGNEE',
   DealCreatedOn = 'DEAL_CREATED_ON',
   DealScore = 'DEAL_SCORE',
   DealStage = 'DEAL_STAGE',
   DealTitle = 'DEAL_TITLE',
   LeadAssignedOn = 'LEAD_ASSIGNED_ON',
   LeadAssignee = 'LEAD_ASSIGNEE',
   LeadCreatedOn = 'LEAD_CREATED_ON',
   LeadScore = 'LEAD_SCORE',
   LeadStage = 'LEAD_STAGE',
   PipelineEventAssignee = 'PIPELINE_EVENT_ASSIGNEE',
   PipelineEventPipelineId = 'PIPELINE_EVENT_PIPELINE_ID',
   PipelineEventPipelineItemId = 'PIPELINE_EVENT_PIPELINE_ITEM_ID',
   TaskAssignee = 'TASK_ASSIGNEE',
   TaskCallStatus = 'TASK_CALL_STATUS',
   TaskStartDate = 'TASK_START_DATE',
   TaskStartTime = 'TASK_START_TIME',
   TaskStatus = 'TASK_STATUS',
   TaskSubmittedLocation = 'TASK_SUBMITTED_LOCATION',
   UserDob = 'USER_DOB',
   UserEmail = 'USER_EMAIL',
   UserFirstName = 'USER_FIRST_NAME',
   UserGender = 'USER_GENDER',
   UserLastName = 'USER_LAST_NAME',
   UserPhoneNumber = 'USER_PHONE_NUMBER',
   UserUsername = 'USER_USERNAME'
}

export type SystemFieldEnumResponseResult =
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldResponse
   | NotPermittedField
   | SystemFieldNotConfigured

export type SystemFieldIsNotSupportedForLinking = GraphQlBaseError & {
   __typename?: 'SystemFieldIsNotSupportedForLinking'
   message?: Maybe<Scalars['String']>
   systemFieldEnum: SystemFieldEnum
}

export type SystemFieldNotConfigured = GraphQlBaseError & {
   __typename?: 'SystemFieldNotConfigured'
   message?: Maybe<Scalars['String']>
   systemFieldEnum: SystemFieldEnum
}

export type TdrAccount = {
   __typename?: 'TDRAccount'
   accountId: Scalars['String']
   accountNo: Scalars['String']
   availableBalance: Scalars['Float']
   certificateAttachment?: Maybe<TdrCertificateAttachment>
   certificates: Array<TdrCertificate>
   creationRefType: CreationRefType
   holderUser: BaseUser
   holderUserId: Scalars['String']
   inProgressBalance: Scalars['Float']
   initialBalance: Scalars['Float']
   issuedAt: Scalars['String']
   metadata?: Maybe<TdrAccountMetadata>
   unit: AccountUnitType
   utilizedBalance: Scalars['Float']
}

export type TdrAccountAccessDenied = GraphQlBaseError & {
   __typename?: 'TDRAccountAccessDenied'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TdrAccountAlreadyOnHold = GraphQlBaseError & {
   __typename?: 'TDRAccountAlreadyOnHold'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TdrAccountHasActiveChildAccounts = GraphQlBaseError & {
   __typename?: 'TDRAccountHasActiveChildAccounts'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TdrAccountMetadata = {
   __typename?: 'TDRAccountMetadata'
   multipleResponses: Array<TdrAccountMultipleResponses>
   singleResponses: Array<TdrProperty>
}

export type TdrAccountMultipleResponses = {
   __typename?: 'TDRAccountMultipleResponses'
   sectionId: Scalars['String']
   sectionResponses: Array<TdrAccountSectionResponse>
}

export type TdrAccountNoNotFound = GraphQlBaseError & {
   __typename?: 'TDRAccountNoNotFound'
   accountNo: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TdrAccountNotExistsForAccountNo = GraphQlBaseError & {
   __typename?: 'TDRAccountNotExistsForAccountNo'
   accountNo: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TdrAccountNotFound = GraphQlBaseError & {
   __typename?: 'TDRAccountNotFound'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TdrAccountNotOnHold = GraphQlBaseError & {
   __typename?: 'TDRAccountNotOnHold'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TdrAccountPurchaseRequestCreatorDetails = {
   __typename?: 'TDRAccountPurchaseRequestCreatorDetails'
   name: Scalars['String']
   phoneNumber: Scalars['String']
   remarks: Scalars['String']
}

export type TdrAccountRequest = {
   __typename?: 'TDRAccountRequest'
   account?: Maybe<BaseTdrAccount>
   accountId?: Maybe<Scalars['String']>
   creatorDetails?: Maybe<TdrAccountPurchaseRequestCreatorDetails>
   readAt?: Maybe<Scalars['String']>
   requestId: Scalars['String']
   requestStatus: TdrAccountRequestStatus
   requestType: TdrAccountRequestType
   transaction?: Maybe<TdrAccountTransaction>
   transactionId?: Maybe<Scalars['String']>
}

export type TdrAccountRequestAlreadyRead = GraphQlBaseError & {
   __typename?: 'TDRAccountRequestAlreadyRead'
   message?: Maybe<Scalars['String']>
   tdrAccountRequestId: Scalars['String']
}

export type TdrAccountRequestNotFound = GraphQlBaseError & {
   __typename?: 'TDRAccountRequestNotFound'
   message?: Maybe<Scalars['String']>
   tdrAccountRequestId: Scalars['String']
}

export enum TdrAccountRequestStatus {
   Done = 'DONE',
   NotDone = 'NOT_DONE'
}

export enum TdrAccountRequestStatusFilter {
   All = 'ALL',
   Read = 'READ',
   Unread = 'UNREAD'
}

export enum TdrAccountRequestType {
   Purchase = 'PURCHASE',
   Utilisation = 'UTILISATION'
}

export type TdrAccountSectionResponse = {
   __typename?: 'TDRAccountSectionResponse'
   properties: Array<TdrProperty>
   sectionResponseId: Scalars['String']
}

export type TdrAccountSortByFieldExtGraphql = {
   field: TdrAccountSortField
   sortValue: SortValue
}

export enum TdrAccountSortField {
   MarketValue = 'MARKET_VALUE',
   Value = 'VALUE'
}

export enum TdrAccountStatus {
   Functional = 'FUNCTIONAL',
   OnHold = 'ON_HOLD'
}

export type TdrAccountTransaction = {
   __typename?: 'TDRAccountTransaction'
   account: BaseTdrAccount
   accountBalance?: Maybe<Scalars['Float']>
   accountId: Scalars['String']
   closedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   initiatedBy: Scalars['String']
   metadata: Array<TdrProperty>
   status: TransactionStatus
   transactionId: Scalars['String']
   transactionOperation: TransactionOperation
   value: Scalars['Float']
}

export type TdrAccountTransactionNotFound = GraphQlBaseError & {
   __typename?: 'TDRAccountTransactionNotFound'
   message?: Maybe<Scalars['String']>
   transactionId: Scalars['String']
}

export type TdrApplicationFieldsNotFound = GraphQlBaseError & {
   __typename?: 'TDRApplicationFieldsNotFound'
   fieldReferenceIds: Array<Maybe<Scalars['String']>>
   message?: Maybe<Scalars['String']>
}

export type TdrAvailAreaShouldBePositive = GraphQlBaseError & {
   __typename?: 'TDRAvailAreaShouldBePositive'
   availArea: Scalars['Float']
   message?: Maybe<Scalars['String']>
}

export type TdrBankOption = {
   __typename?: 'TDRBankOption'
   bankName: Scalars['String']
   bankType: TdrBankType
}

export enum TdrBankType {
   BuildNow = 'BUILD_NOW',
   Manual = 'MANUAL',
   Telangana = 'TELANGANA'
}

export type TdrCertificate = {
   __typename?: 'TDRCertificate'
   certificateName: Scalars['String']
   certificateUrl: Scalars['String']
}

export type TdrCertificateAttachment = {
   __typename?: 'TDRCertificateAttachment'
   mimeType?: Maybe<Scalars['String']>
   name?: Maybe<Scalars['String']>
   preSignedUrl: Scalars['String']
   sizeInBytes?: Maybe<Scalars['Float']>
   url: Scalars['String']
}

export type TdrCertificateAttachmentExtGraphql = {
   __typename?: 'TDRCertificateAttachmentExtGraphql'
   mimeType?: Maybe<Scalars['String']>
   name?: Maybe<Scalars['String']>
   preSignedUrl: Scalars['String']
   sizeInBytes?: Maybe<Scalars['Float']>
   url: Scalars['String']
}

export type TdrCertificateAttachmentParams = {
   mimeType?: InputMaybe<Scalars['String']>
   name?: InputMaybe<Scalars['String']>
   sizeInBytes?: InputMaybe<Scalars['Float']>
   url: Scalars['String']
}

export type TdrCertificateDoesNotExist = GraphQlBaseError & {
   __typename?: 'TDRCertificateDoesNotExist'
   certificateName: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TdrCertificateUrlIsRequired = GraphQlBaseError & {
   __typename?: 'TDRCertificateUrlIsRequired'
   message?: Maybe<Scalars['String']>
}

export type TdrDigitalizationApplicationAlreadyExists = GraphQlBaseError & {
   __typename?: 'TDRDigitalizationApplicationAlreadyExists'
   certificateNumber: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum TdrEntityType {
   Payment = 'PAYMENT',
   PipelineItem = 'PIPELINE_ITEM'
}

export type TdrOrder = {
   __typename?: 'TDROrder'
   amount: Scalars['Float']
   contributedEntities: Array<TdrOrderContributedEntity>
   noOfPayments: Scalars['Int']
   orderBaseDetails: OrderBaseDetails
   orderId: Scalars['String']
   status: TdrOrderStatus
   tdrOrderId: Scalars['String']
   tdrPayments: Array<TdrPayment>
}

export type TdrOrderAccessDenied = GraphQlBaseError & {
   __typename?: 'TDROrderAccessDenied'
   message?: Maybe<Scalars['String']>
   tdrOrderId: Scalars['String']
}

export type TdrOrderAlreadyPaid = GraphQlBaseError & {
   __typename?: 'TDROrderAlreadyPaid'
   message?: Maybe<Scalars['String']>
   tdrOrderId: Scalars['String']
}

export type TdrOrderContributedEntity = {
   __typename?: 'TDROrderContributedEntity'
   amount: Scalars['Float']
   contributedEntityId: Scalars['String']
   entityId: Scalars['String']
   entityName: Scalars['String']
   entityType: OrderContributedEntityType
}

export type TdrOrderHasNoActivePayments = GraphQlBaseError & {
   __typename?: 'TDROrderHasNoActivePayments'
   message?: Maybe<Scalars['String']>
   tdrOrderId: Scalars['String']
}

export type TdrOrderInvalidStatus = GraphQlBaseError & {
   __typename?: 'TDROrderInvalidStatus'
   currentStatus: Scalars['String']
   expectedStatus: Scalars['String']
   message?: Maybe<Scalars['String']>
   tdrOrderId: Scalars['String']
}

export type TdrOrderIsNotInYetToPayStatus = GraphQlBaseError & {
   __typename?: 'TDROrderIsNotInYetToPayStatus'
   message?: Maybe<Scalars['String']>
   tdrOrderId: Scalars['String']
}

export type TdrOrderNotFound = GraphQlBaseError & {
   __typename?: 'TDROrderNotFound'
   message?: Maybe<Scalars['String']>
   tdrOrderId: Scalars['String']
}

export enum TdrOrderStatus {
   Cancelled = 'CANCELLED',
   Paid = 'PAID',
   UnderVerification = 'UNDER_VERIFICATION',
   YetToPay = 'YET_TO_PAY'
}

export type TdrOrderUnderVerification = GraphQlBaseError & {
   __typename?: 'TDROrderUnderVerification'
   message?: Maybe<Scalars['String']>
   tdrOrderId: Scalars['String']
}

export type TdrPayment = {
   __typename?: 'TDRPayment'
   amount: Scalars['Float']
   creationDatetime: Scalars['String']
   paymentId: Scalars['String']
   status: PaymentStatusEnum
   tdrRequest: TdrRequest
}

export type TdrPaymentAmountInsufficient = GraphQlBaseError & {
   __typename?: 'TDRPaymentAmountInsufficient'
   currentAmount: Scalars['Float']
   message?: Maybe<Scalars['String']>
   requiredAmount: Scalars['Float']
   tdrOrderId: Scalars['String']
}

export type TdrPaymentCanInitiateOnlyForPartialPayments = GraphQlBaseError & {
   __typename?: 'TDRPaymentCanInitiateOnlyForPartialPayments'
   message?: Maybe<Scalars['String']>
   orderId: Scalars['String']
}

export type TdrPaymentIsNotInitiated = GraphQlBaseError & {
   __typename?: 'TDRPaymentIsNotInitiated'
   message?: Maybe<Scalars['String']>
   paymentId: Scalars['String']
}

export type TdrPaymentNotApplicableForInstallmentOrder = GraphQlBaseError & {
   __typename?: 'TDRPaymentNotApplicableForInstallmentOrder'
   message?: Maybe<Scalars['String']>
   orderId: Scalars['String']
}

export type TdrPaymentNotApplicableForNonFeeHeadContributedEntities = GraphQlBaseError & {
   __typename?: 'TDRPaymentNotApplicableForNonFeeHeadContributedEntities'
   contributedEntityIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type TdrPaymentNotApplicableForNonTdrApplicableContributedEntities = GraphQlBaseError & {
   __typename?: 'TDRPaymentNotApplicableForNonTDRApplicableContributedEntities'
   contributedEntityIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type TdrPaymentNotApplicableForRazorpaySelectedContributedEntities = GraphQlBaseError & {
   __typename?: 'TDRPaymentNotApplicableForRazorpaySelectedContributedEntities'
   contributedEntityIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export enum TdrPaymentVerificationRecommendationEnum {
   Accepted = 'ACCEPTED',
   Rejected = 'REJECTED',
   Shortfall = 'SHORTFALL'
}

export type TdrPaymentsNotInInitiatedState = GraphQlBaseError & {
   __typename?: 'TDRPaymentsNotInInitiatedState'
   message?: Maybe<Scalars['String']>
   paymentIds: Array<Scalars['String']>
}

export type TdrPaymentsVerificationTab = BaseTab & {
   __typename?: 'TDRPaymentsVerificationTab'
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
   taskTemplateId: Scalars['String']
}

export type TdrPipelineItemTemplateConfigNotFound = GraphQlBaseError & {
   __typename?: 'TDRPipelineItemTemplateConfigNotFound'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TdrPipelineItemTemplateDigitalizationConfigNotFound = GraphQlBaseError & {
   __typename?: 'TDRPipelineItemTemplateDigitalizationConfigNotFound'
   accountId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum TdrPreSignedUrlsEntityType {
   PipelineItem = 'PIPELINE_ITEM',
   TdrRequest = 'TDR_REQUEST'
}

export type TdrProperty = {
   __typename?: 'TDRProperty'
   propertyId: Scalars['String']
   propertyType: FieldType
   response?: Maybe<FieldResponseType>
}

export type TdrRequest = {
   __typename?: 'TDRRequest'
   authority?: Maybe<Scalars['String']>
   bankType: TdrBankType
   certificateAttachment?: Maybe<TdrCertificateAttachment>
   certificateNumber?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   issuedDatetime?: Maybe<Scalars['String']>
   marketValueOfRequestedArea?: Maybe<Scalars['Float']>
   marketValueOfUsageArea?: Maybe<Scalars['Float']>
   requestedArea?: Maybe<Scalars['Float']>
   status: TdrRequestStatus
   tdrRequestId: Scalars['String']
}

export type TdrRequestAcceptanceFailedError = GraphQlBaseError & {
   __typename?: 'TDRRequestAcceptanceFailedError'
   message: Scalars['String']
   tdrRequestId: Scalars['String']
   transactionId: Scalars['String']
}

export type TdrRequestCertificateNumberNotFound = GraphQlBaseError & {
   __typename?: 'TDRRequestCertificateNumberNotFound'
   certificationNumber: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TdrRequestConfig = {
   __typename?: 'TDRRequestConfig'
   requireAllTdrRequestsAccepted?: Maybe<Scalars['Boolean']>
}

export type TdrRequestConfigParams = {
   requireAllTdrRequestsAccepted?: InputMaybe<Scalars['Boolean']>
}

export type TdrRequestEntityAccessDenied = GraphQlBaseError & {
   __typename?: 'TDRRequestEntityAccessDenied'
   entityId: Scalars['String']
   entityType: TdrEntityType
   message?: Maybe<Scalars['String']>
}

export type TdrRequestEntityNotFound = GraphQlBaseError & {
   __typename?: 'TDRRequestEntityNotFound'
   entityId: Scalars['String']
   entityType: TdrEntityType
   message?: Maybe<Scalars['String']>
}

export type TdrRequestFailureResponse = {
   __typename?: 'TDRRequestFailureResponse'
   reason: Scalars['String']
   tdrRequestId: Scalars['String']
}

export type TdrRequestIsNotTdrPayment = GraphQlBaseError & {
   __typename?: 'TDRRequestIsNotTDRPayment'
   message?: Maybe<Scalars['String']>
   tdrRequestId: Scalars['String']
}

export type TdrRequestNotFound = GraphQlBaseError & {
   __typename?: 'TDRRequestNotFound'
   message?: Maybe<Scalars['String']>
   tdrRequestId: Scalars['String']
}

export enum TdrRequestStatus {
   Accepted = 'ACCEPTED',
   CertificateOwnershipVerified = 'CERTIFICATE_OWNERSHIP_VERIFIED',
   CertificateValidated = 'CERTIFICATE_VALIDATED',
   Confirmed = 'CONFIRMED',
   Draft = 'DRAFT',
   Initiated = 'INITIATED'
}

export type TdrRequestedAreaShouldBePositive = GraphQlBaseError & {
   __typename?: 'TDRRequestedAreaShouldBePositive'
   message?: Maybe<Scalars['String']>
   requestedArea: Scalars['Float']
}

export type TdrRequestedAreaShouldNotBeNegative = GraphQlBaseError & {
   __typename?: 'TDRRequestedAreaShouldNotBeNegative'
   message?: Maybe<Scalars['String']>
   requestedArea: Scalars['Float']
   tdrRequestId: Scalars['String']
}

export type TdrRequestsInitiationFailed = GraphQlBaseError & {
   __typename?: 'TDRRequestsInitiationFailed'
   failedTdrRequests: Array<TdrRequestFailureResponse>
   message?: Maybe<Scalars['String']>
}

export type TdrRequestsNotFound = GraphQlBaseError & {
   __typename?: 'TDRRequestsNotFound'
   message?: Maybe<Scalars['String']>
   tdrRequestIds: Array<Scalars['String']>
}

export type TdrRequestsOwnershipNotVerified = GraphQlBaseError & {
   __typename?: 'TDRRequestsOwnershipNotVerified'
   message?: Maybe<Scalars['String']>
   tdrRequestIds: Array<Scalars['String']>
}

export type TdrRequestsReleaseFailed = GraphQlBaseError & {
   __typename?: 'TDRRequestsReleaseFailed'
   failedTdrRequests: Array<TdrRequestFailureResponse>
   message?: Maybe<Scalars['String']>
}

export type TdrSaleAndTransferRequestConfig = {
   __typename?: 'TDRSaleAndTransferRequestConfig'
   tdrAccountNoFieldId?: Maybe<Scalars['String']>
   tdrAuthorityFieldId?: Maybe<Scalars['String']>
   tdrTransactionValueFieldId?: Maybe<Scalars['String']>
}

export type TdrSaleAndTransferRequestConfigParams = {
   tdrAccountNoFieldId?: InputMaybe<Scalars['String']>
   tdrAuthorityFieldId?: InputMaybe<Scalars['String']>
   tdrTransactionValueFieldId?: InputMaybe<Scalars['String']>
}

export type TdrTab = BaseTab & {
   __typename?: 'TDRTab'
   availTdrCreditsFieldId?: Maybe<Scalars['String']>
   caseTypeFieldId?: Maybe<Scalars['String']>
   currentLocationMarketValueFieldId: Scalars['String']
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   proposedSiteTdrAreaFieldId?: Maybe<Scalars['String']>
   scrutinyCalculatedTdrAreaFieldId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
   taskTemplateId: Scalars['String']
   tdrUtilizationContext?: Maybe<TdrUtilizationContext>
}

export type TdrTransactionRequestValueIsGreaterThanAvailableValue = GraphQlBaseError & {
   __typename?: 'TDRTransactionRequestValueIsGreaterThanAvailableValue'
   message?: Maybe<Scalars['String']>
   tdrAvailableValue: Array<Scalars['Float']>
   tdrRequestedValue: Array<Scalars['Float']>
}

export type TdrTransactionRequestValueIsGreaterThanAvailableValueError = GraphQlBaseError & {
   __typename?: 'TDRTransactionRequestValueIsGreaterThanAvailableValueError'
   message?: Maybe<Scalars['String']>
   tdrAvailableValue: Scalars['Float']
   tdrRequestedValue: Scalars['Float']
}

export type TdrTransactionSumExceedsAccountBalance = GraphQlBaseError & {
   __typename?: 'TDRTransactionSumExceedsAccountBalance'
   message?: Maybe<Scalars['String']>
   permissibleBalance: Scalars['Float']
   pipelineItemId: Scalars['String']
   totalUtilized: Scalars['Float']
}

export type TdrTransactionUtilizationDateIsInvalid = GraphQlBaseError & {
   __typename?: 'TDRTransactionUtilizationDateIsInvalid'
   invalidDates: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   originalIssuedDate: Scalars['String']
   pipelineItemId: Scalars['String']
}

export enum TdrUtilizationContext {
   AddRev = 'ADD_REV',
   Default = 'DEFAULT',
   Oc = 'OC'
}

export type TgiicAllotmentNumberInvalid = GraphQlBaseError & {
   __typename?: 'TGIICAllotmentNumberInvalid'
   allotmentNumber: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TGbPassApplication = {
   __typename?: 'TGbPASSApplication'
   applicationId: Scalars['String']
   applicationType: TGbPassApplicationTypeEnum
   dates?: Maybe<TGbPassApplicationDates>
   fileNumber: Scalars['String']
}

export type TGbPassApplicationDates = {
   __typename?: 'TGbPASSApplicationDates'
   approvedOrRejectedDate?: Maybe<Scalars['String']>
   receivedDate?: Maybe<Scalars['String']>
}

export enum TGbPassApplicationTypeEnum {
   Digitalization = 'DIGITALIZATION',
   InstantApproval = 'INSTANT_APPROVAL',
   InstantRegistration = 'INSTANT_REGISTRATION',
   SalesTransfer = 'SALES_TRANSFER',
   SingleWindowApplication = 'SINGLE_WINDOW_APPLICATION',
   TdrApplication = 'TDR_APPLICATION'
}

export type TGbPassChildTab = {
   __typename?: 'TGbPASSChildTab'
   name: Scalars['String']
   tabType: TGbPassTabTypeEnum
}

export type TGbPassFileNumberNotFound = GraphQlBaseError & {
   __typename?: 'TGbPASSFileNumberNotFound'
   fileNumber: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TGbPassTab = {
   __typename?: 'TGbPASSTab'
   childTabs: Array<TGbPassChildTab>
   name: Scalars['String']
   tabType: TGbPassTabTypeEnum
}

export enum TGbPassTabTypeEnum {
   AdditionalDataOfApplication = 'ADDITIONAL_DATA_OF_APPLICATION',
   ApplicantsDetails = 'APPLICANTS_DETAILS',
   ApplicantInfo = 'APPLICANT_INFO',
   ApplicationInformation = 'APPLICATION_INFORMATION',
   AssigneeHistoryLogs = 'ASSIGNEE_HISTORY_LOGS',
   Blockchain = 'BLOCKCHAIN',
   Conditions = 'CONDITIONS',
   DocumentUpload = 'DOCUMENT_UPLOAD',
   DrawingAndLtpDetails = 'DRAWING_AND_LTP_DETAILS',
   Fees = 'FEES',
   FeeChangeLogs = 'FEE_CHANGE_LOGS',
   Instalments = 'INSTALMENTS',
   Letters = 'LETTERS',
   LineDepartmentData = 'LINE_DEPARTMENT_DATA',
   Notes = 'NOTES',
   OfficersData = 'OFFICERS_DATA',
   Payments = 'PAYMENTS',
   PlotDetails = 'PLOT_DETAILS',
   ProposalFlow = 'PROPOSAL_FLOW',
   ProposalInformation = 'PROPOSAL_INFORMATION',
   Reconciliations = 'RECONCILIATIONS',
   Refunds = 'REFUNDS',
   Scrutiny = 'SCRUTINY',
   ShortfallLogs = 'SHORTFALL_LOGS',
   Sla = 'SLA',
   StageHistoryLogs = 'STAGE_HISTORY_LOGS',
   Tasks = 'TASKS',
   ZonesCircleAndHoData = 'ZONES_CIRCLE_AND_HO_DATA'
}

export type TvoTab = BaseTab & {
   __typename?: 'TVOTab'
   buttons: Array<TabButton>
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   tabType: TabType
}

export type Tab =
   | ActivitiesTab
   | AppealTab
   | CallLogsTab
   | CardsTab
   | CategoryCheckpointsTab
   | CompletedTasksTab
   | DocumentsTab
   | DocumentsVerificationTab
   | EnforcementRelatedComplaintsTab
   | FeeEngineTab
   | FeePaymentsTab
   | FilesVerificationTab
   | GisTab
   | GeoCoordinatesTab
   | HistoryLogsTab
   | NestedTab
   | OcSiteInspectionTab
   | ObjectionTab
   | PaymentTab
   | PipelineItemSubmissionGroupsTab
   | ProposalFlowTab
   | RecordReviewTab
   | RelationTab
   | RemarksTab
   | RequestVerificationTab
   | SectionsTab
   | ShortfallLogsTab
   | SiteInspectionTab
   | TdrPaymentsVerificationTab
   | TdrTab
   | TaskTableTab
   | VerificationTab

export type TabButton = {
   __typename?: 'TabButton'
   assigneeFieldId: Scalars['String']
   buttonId: Scalars['String']
   name: Scalars['String']
}

export type TabCard =
   | ApplicationTableCard
   | CustomAddAnotherSectionCard
   | CustomSectionCard
   | OverallRecommendationAndRemarksCard
   | SectionCard
   | TaskTableCard

export enum TabCardType {
   ApplicationTable = 'APPLICATION_TABLE',
   CustomAddAnotherSection = 'CUSTOM_ADD_ANOTHER_SECTION',
   CustomSection = 'CUSTOM_SECTION',
   OverallRecommendationAndRemarks = 'OVERALL_RECOMMENDATION_AND_REMARKS',
   Section = 'SECTION',
   TaskTable = 'TASK_TABLE'
}

export type TabErrorFields = {
   __typename?: 'TabErrorFields'
   errorFields: Array<ErrorField>
   tabId: Scalars['String']
}

export type TabFieldResponsesType = {
   __typename?: 'TabFieldResponsesType'
   visibleFieldResponses: Array<PmuFieldResponseType>
}

export type TabGoF = {
   __typename?: 'TabGoF'
   addAnotherGofResponsesLimit?: Maybe<Scalars['Int']>
   category: GoFCategory
   description?: Maybe<Scalars['String']>
   displayOrder: Scalars['Int']
   enableAddAnother: Scalars['Boolean']
   fields: Array<Field>
   gofId: Scalars['String']
   groups: Array<GroupsInGoF>
   name: Scalars['String']
   orderedFieldIds: Array<Scalars['String']>
   sectionUiStyle: PortalSectionTabUiStyle
   table?: Maybe<TabGoFCustomTable>
   tables: Array<TabGoFCustomTable>
}

export type TabGoFCustomTable = {
   __typename?: 'TabGoFCustomTable'
   columns: Array<TabGoFCustomTableColumn>
   customFieldsSections: Array<TabGoFCustomTableFieldsSection>
   name: Scalars['String']
   rows: Array<TabGoFCustomTableRow>
   tableId: Scalars['String']
}

export type TabGoFCustomTableCell = {
   __typename?: 'TabGoFCustomTableCell'
   columnName: Scalars['String']
   fieldId?: Maybe<Scalars['String']>
   label?: Maybe<Scalars['String']>
}

export type TabGoFCustomTableColumn = {
   __typename?: 'TabGoFCustomTableColumn'
   allowNegativeNumber?: Maybe<Scalars['Boolean']>
   columnName: Scalars['String']
   columnType: TabGoFCustomTableColumnType
   formula?: Maybe<Scalars['String']>
   isNestedRowsDecider?: Maybe<Scalars['Boolean']>
   noOfDigitsRoundOff?: Maybe<Scalars['Int']>
   parentColumnName?: Maybe<Scalars['String']>
   showChildColumnNames?: Maybe<Scalars['Boolean']>
}

export enum TabGoFCustomTableColumnType {
   Field = 'FIELD',
   Formula = 'FORMULA',
   NestedColumn = 'NESTED_COLUMN',
   RowHeader = 'ROW_HEADER',
   SNo = 'S_NO'
}

export type TabGoFCustomTableFieldsSection = {
   __typename?: 'TabGoFCustomTableFieldsSection'
   fieldIds: Array<Scalars['String']>
   groupName?: Maybe<Scalars['String']>
}

export type TabGoFCustomTableRow = {
   __typename?: 'TabGoFCustomTableRow'
   cells: Array<TabGoFCustomTableCell>
   rowId: Scalars['String']
}

export type TabNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'TabNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabName: Scalars['String']
}

export type TabNotFoundInPortalApplication = GraphQlBaseError & {
   __typename?: 'TabNotFoundInPortalApplication'
   message?: Maybe<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type TabNotInPipelineItemTemplate = GraphQlBaseError & {
   __typename?: 'TabNotInPipelineItemTemplate'
   message?: Maybe<Scalars['String']>
   pipelineItemTemplateId: Scalars['String']
   tabId: Scalars['String']
}

export type TabObjectionsSummary = {
   __typename?: 'TabObjectionsSummary'
   latestCompletedTask?: Maybe<Task>
   newObjections: Array<RelatedObject>
   tabId: Scalars['String']
}

export type TabSection = PortalCustomSection | TabGoF

export enum TabType {
   Activities = 'ACTIVITIES',
   Appeal = 'APPEAL',
   CallLogs = 'CALL_LOGS',
   CardsTab = 'CARDS_TAB',
   CategoryCheckpoints = 'CATEGORY_CHECKPOINTS',
   CompletedTasks = 'COMPLETED_TASKS',
   Documents = 'DOCUMENTS',
   DocumentsVerificationTab = 'DOCUMENTS_VERIFICATION_TAB',
   EnforcementRelatedComplaints = 'ENFORCEMENT_RELATED_COMPLAINTS',
   FeeEngineTab = 'FEE_ENGINE_TAB',
   FeePaymentsTab = 'FEE_PAYMENTS_TAB',
   FilesVerificationTab = 'FILES_VERIFICATION_TAB',
   GeoCoordinatesTab = 'GEO_COORDINATES_TAB',
   GisTab = 'GIS_TAB',
   HistoryLogs = 'HISTORY_LOGS',
   NestedTab = 'NESTED_TAB',
   ObjectionTab = 'OBJECTION_TAB',
   OcSiteInspection = 'OC_SITE_INSPECTION',
   Payments = 'PAYMENTS',
   PipelineItemSubmissionGroups = 'PIPELINE_ITEM_SUBMISSION_GROUPS',
   ProposalFlowTab = 'PROPOSAL_FLOW_TAB',
   RecordReviewTab = 'RECORD_REVIEW_TAB',
   Relation = 'RELATION',
   Remarks = 'REMARKS',
   RequestVerificationTab = 'REQUEST_VERIFICATION_TAB',
   Sections = 'SECTIONS',
   ShortfallLogsTab = 'SHORTFALL_LOGS_TAB',
   SiteInspection = 'SITE_INSPECTION',
   TaskTable = 'TASK_TABLE',
   TdrPaymentsVerification = 'TDR_PAYMENTS_VERIFICATION',
   TdrRequestTab = 'TDR_REQUEST_TAB',
   VerificationTab = 'VERIFICATION_TAB'
}

export type TabUnVerifiedPhoneNumberFields = {
   __typename?: 'TabUnVerifiedPhoneNumberFields'
   tabId: Scalars['String']
   unVerifiedPhoneNumberFields: Array<UnVerifiedGofResponsePhoneNumberFields>
}

export type TabUnfilledRequiredFields = {
   __typename?: 'TabUnfilledRequiredFields'
   requiredFields: Array<UnfilledGofResponseFields>
   tabId: Scalars['String']
}

export type Table = {
   __typename?: 'Table'
   columnHeaders: Array<ColumnHeader>
   graphId: Scalars['String']
   rows: Array<TableRow>
   totalRows: Scalars['Int']
}

export type TableColumnTotalParams = {
   graphId: Scalars['String']
   parentId?: InputMaybe<Scalars['String']>
   parentType: GraphParentType
}

export type TableGraphConfig = {
   __typename?: 'TableGraphConfig'
   analyticsLevel: AnalyticsLevel
   dataSources: Array<AnalyticsDataSourceType>
   dataSourcesWithDisplayNames: Array<DataSourceDisplayName>
   description?: Maybe<Scalars['String']>
   dimension: GraphDimension
   enableColumnTotals: Scalars['Boolean']
   filterSetId: Scalars['String']
   graphId: Scalars['String']
   isOwner: Scalars['Boolean']
   metrics: Array<GraphMetric>
   name: Scalars['String']
   pipelineId: Scalars['String']
   quickFilterFields: Array<GraphQuickFilterField>
   roles: Array<Role>
}

export type TableResult =
   | DashboardAccessDenied
   | DashboardNotFound
   | GraphAccessDenied
   | GraphMetricNotFound
   | GraphNotFound
   | InvalidLimit
   | InvalidOffset
   | NotSupportedGraphParenType
   | PaginationLimitExceeded
   | Table
   | ViewAccessDenied
   | ViewNotFound

export type TableRow = {
   __typename?: 'TableRow'
   rowId: Scalars['String']
   rowTotal?: Maybe<Scalars['String']>
   rowValues: Array<RowValue>
}

export type TableSort = {
   columnId: Scalars['String']
   sortValue: SortValue
}

export type TabsNotFoundInPortalApplication = GraphQlBaseError & {
   __typename?: 'TabsNotFoundInPortalApplication'
   message?: Maybe<Scalars['String']>
   portalApplicationId: Scalars['String']
   tabIds: Array<Scalars['String']>
}

export type TabsParams = {
   filterTabTypes?: InputMaybe<Array<TabType>>
}

export type TargetEntityDirectionIsRequiredForSelfRelation = GraphQlBaseError & {
   __typename?: 'TargetEntityDirectionIsRequiredForSelfRelation'
   message?: Maybe<Scalars['String']>
   relationId: Scalars['String']
}

export type Task = {
   __typename?: 'Task'
   bpsVerificationData?: Maybe<BpsTaskVerificationData>
   completedAt?: Maybe<Scalars['String']>
   draftedPipelineItemCallLogs: Array<CallLog>
   draftedPipelineItemFields: Array<FieldResponseDraft>
   draftedPipelineItemRemarks?: Maybe<PipelineItemRemarksDraft>
   fields: Array<SystemFieldEnumResponseResult>
   siteInspectionData?: Maybe<SiteInspectionTaskDetails>
   taskId: Scalars['String']
   taskTemplateId: Scalars['String']
   title: Scalars['String']
}

export type TaskFieldsArgs = {
   systemFieldEnums: Array<TaskSystemFieldEnum>
}

export type TaskAccessDenied = GraphQlBaseError & {
   __typename?: 'TaskAccessDenied'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type TaskApplicationDetails = {
   __typename?: 'TaskApplicationDetails'
   applicationId: FieldResponse
   location?: Maybe<FieldResponse>
   pipelineId: Scalars['String']
   taskId: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type TaskApproxDurationInMinsShouldBePositive = GraphQlBaseError & {
   __typename?: 'TaskApproxDurationInMinsShouldBePositive'
   message?: Maybe<Scalars['String']>
}

export type TaskAssigneeDoesNotHavePipelineItemAccess = GraphQlBaseError & {
   __typename?: 'TaskAssigneeDoesNotHavePipelineItemAccess'
   message?: Maybe<Scalars['String']>
}

export enum TaskAssigneeEnum {
   Agent = 'AGENT',
   Manager = 'MANAGER',
   TriggerTaskAssignee = 'TRIGGER_TASK_ASSIGNEE'
}

export type TaskAssigneeIsDeactivated = GraphQlBaseError & {
   __typename?: 'TaskAssigneeIsDeactivated'
   assigneeId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TaskAssigneeNotFound = GraphQlBaseError & {
   __typename?: 'TaskAssigneeNotFound'
   assigneeId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TaskCallStatusOptionConfig = {
   __typename?: 'TaskCallStatusOptionConfig'
   color: ColorEnum
   option: Scalars['String']
}

export type TaskDiscarded = GraphQlBaseError & {
   __typename?: 'TaskDiscarded'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type TaskDraftHasEmptyRemarks = GraphQlBaseError & {
   __typename?: 'TaskDraftHasEmptyRemarks'
   message?: Maybe<Scalars['String']>
}

export type TaskFieldNotSupported = GraphQlBaseError & {
   __typename?: 'TaskFieldNotSupported'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TaskFieldResult =
   | FieldIsDeleted
   | FieldIsNotCreated
   | FieldNotFound
   | FieldResponse
   | NotPermittedField
   | NotTaskField

export type TaskGeneratedOverallRemarks = {
   __typename?: 'TaskGeneratedOverallRemarks'
   remarks?: Maybe<Scalars['String']>
}

export type TaskIsAlreadyCompleted = GraphQlBaseError & {
   __typename?: 'TaskIsAlreadyCompleted'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type TaskNotFound = GraphQlBaseError & {
   __typename?: 'TaskNotFound'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type TaskNotLinkedToAppeal = GraphQlBaseError & {
   __typename?: 'TaskNotLinkedToAppeal'
   appealId: Scalars['String']
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type TaskNotLinkedToGivenTaskTemplate = GraphQlBaseError & {
   __typename?: 'TaskNotLinkedToGivenTaskTemplate'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type TaskNotLinkedToPipelineItem = GraphQlBaseError & {
   __typename?: 'TaskNotLinkedToPipelineItem'
   message?: Maybe<Scalars['String']>
   pipelineItemId: Scalars['String']
   taskId: Scalars['String']
}

export type TaskPipelineItemCardOverviewConfig = {
   __typename?: 'TaskPipelineItemCardOverviewConfig'
   fieldIds: Array<Scalars['String']>
   showLatestRemarks: Scalars['Boolean']
}

export type TaskPipelineItemCardOverviewConfigParams = {
   fieldIds: Array<Scalars['String']>
   showLatestRemarks: Scalars['Boolean']
}

export type TaskResult = Task | TaskDiscarded | TaskNotFound

export type TaskShortfallLog = BaseApplicationManagementLog & {
   __typename?: 'TaskShortfallLog'
   actionType: Scalars['String']
   applicationNo: Scalars['String']
   attachments: Array<ApplicationManagementAttachment>
   createdAt: Scalars['String']
   doneBy: BaseUser
   id: Scalars['String']
   pipelineItemId: Scalars['String']
   remarks: Scalars['String']
   shortfallFields: Array<Field>
   shortfallRemarks?: Maybe<Scalars['String']>
   taskTemplateId?: Maybe<Scalars['String']>
   taskTemplateName?: Maybe<Scalars['String']>
}

export type TaskShortfallTaskTemplate = {
   __typename?: 'TaskShortfallTaskTemplate'
   name: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type TaskSiteInspectionNotExists = GraphQlBaseError & {
   __typename?: 'TaskSiteInspectionNotExists'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type TaskStartDateTimeHasPassed = GraphQlBaseError & {
   __typename?: 'TaskStartDateTimeHasPassed'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type TaskStartDateTimeShouldBeInFuture = GraphQlBaseError & {
   __typename?: 'TaskStartDateTimeShouldBeInFuture'
   message?: Maybe<Scalars['String']>
}

export type TaskStartTimeNotAllowedWithoutStartDate = GraphQlBaseError & {
   __typename?: 'TaskStartTimeNotAllowedWithoutStartDate'
   message?: Maybe<Scalars['String']>
}

export enum TaskStatus {
   Completed = 'COMPLETED',
   Discarded = 'DISCARDED',
   NotCompleted = 'NOT_COMPLETED'
}

export enum TaskSystemFieldEnum {
   CustomTaskTitle = 'CUSTOM_TASK_TITLE',
   TaskAssignee = 'TASK_ASSIGNEE',
   TaskCallStatus = 'TASK_CALL_STATUS',
   TaskStartDate = 'TASK_START_DATE',
   TaskStartTime = 'TASK_START_TIME',
   TaskStatus = 'TASK_STATUS',
   TaskSubmittedLocation = 'TASK_SUBMITTED_LOCATION'
}

export enum TaskTableActionEnum {
   AcceptAll = 'ACCEPT_ALL',
   RejectAll = 'REJECT_ALL',
   ShortfallAll = 'SHORTFALL_ALL'
}

export type TaskTableCard = BaseCard & {
   __typename?: 'TaskTableCard'
   cardType: TabCardType
   columns: Array<TaskTableColumn>
   copyColumnConfig?: Maybe<TaskTableCopyColumnConfig>
   name: Scalars['String']
   rows: Array<TaskTableRow>
   taskTemplateId: Scalars['String']
}

export type TaskTableCell = {
   __typename?: 'TaskTableCell'
   columnName: Scalars['String']
   fieldId?: Maybe<Scalars['String']>
   label?: Maybe<Scalars['String']>
}

export type TaskTableColumn = {
   __typename?: 'TaskTableColumn'
   allowNegativeNumber?: Maybe<Scalars['Boolean']>
   columnName: Scalars['String']
   columnType: TaskTableColumnType
   formula?: Maybe<Scalars['String']>
   isMainField?: Maybe<Scalars['Boolean']>
   isNestedRowsDecider?: Maybe<Scalars['Boolean']>
   noOfDigitsRoundOff?: Maybe<Scalars['Int']>
}

export enum TaskTableColumnType {
   Field = 'FIELD',
   Formula = 'FORMULA',
   Observation = 'OBSERVATION',
   Remarks = 'REMARKS',
   RowHeader = 'ROW_HEADER',
   SNo = 'S_NO'
}

export type TaskTableCopyColumnConfig = {
   __typename?: 'TaskTableCopyColumnConfig'
   copyActionName?: Maybe<Scalars['String']>
   copyFromColumn: Scalars['String']
   copyToColumn: Scalars['String']
}

export type TaskTableCustomFieldsSection = {
   __typename?: 'TaskTableCustomFieldsSection'
   fieldIds: Array<Scalars['String']>
   groupName: Scalars['String']
}

export type TaskTableObservationConfig = {
   __typename?: 'TaskTableObservationConfig'
   condition: Scalars['String']
   observation: BpsVerificationRecommendationEnum
}

export type TaskTablePhotoGraphSection = {
   __typename?: 'TaskTablePhotoGraphSection'
   photoGraphFieldIds: Array<Scalars['String']>
}

export type TaskTableRow = {
   __typename?: 'TaskTableRow'
   cells: Array<TaskTableCell>
   observationConfigs: Array<TaskTableObservationConfig>
   rowId: Scalars['String']
}

export type TaskTableSettings = {
   __typename?: 'TaskTableSettings'
   copyColumnConfig?: Maybe<TaskTableCopyColumnConfig>
   disableDraftMode?: Maybe<Scalars['Boolean']>
   enableOverallObservation?: Maybe<Scalars['Boolean']>
   enableOverallRecommendationAndRemarks: Scalars['Boolean']
   enableOverallRemarks?: Maybe<Scalars['Boolean']>
   /** @deprecated Moved this configuration to columns */
   enableRecommendation?: Maybe<Scalars['Boolean']>
   /** @deprecated Moved this configuration to columns */
   enableRemarks?: Maybe<Scalars['Boolean']>
   /** @deprecated Moved this configuration to columns */
   enableRowSerialNumber?: Maybe<Scalars['Boolean']>
   needToPrefillCompletedTask: Scalars['Boolean']
   showCompletedTaskTable: Scalars['Boolean']
}

export type TaskTableTab = BaseTab & {
   __typename?: 'TaskTableTab'
   actions: Array<TaskTableTabAction>
   columns: Array<TaskTableColumn>
   customFieldsSections: Array<TaskTableCustomFieldsSection>
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   photoGraphSection?: Maybe<TaskTablePhotoGraphSection>
   rows: Array<TaskTableRow>
   tabId: Scalars['String']
   tabType: TabType
   taskTableSettings?: Maybe<TaskTableSettings>
   taskTemplateId: Scalars['String']
}

export type TaskTableTabAction = {
   __typename?: 'TaskTableTabAction'
   actionType: TaskTableActionEnum
   name: Scalars['String']
}

export type TaskTemplate = {
   __typename?: 'TaskTemplate'
   color: Scalars['String']
   createdAt: Scalars['String']
   description?: Maybe<Scalars['String']>
   foregroundAutomationWorkflow?: Maybe<BaseAutomationWorkflow>
   gofs: Array<GoF>
   hasPermission: Scalars['Boolean']
   iconUrl: Scalars['String']
   isDisabled: Scalars['Boolean']
   isLinkedFieldsEnabled: Scalars['Boolean']
   isRemarksAttachmentEnabled: Scalars['Boolean']
   name: Scalars['String']
   orderedGofIds: Array<Scalars['String']>
   pipelineId: Scalars['String']
   quickEditFieldsConfig?: Maybe<TaskTemplateQuickEditFieldsConfig>
   settings: TaskTemplateSettings
   taskApproxDurationInMins?: Maybe<Scalars['Int']>
   taskPipelineItemCardOverviewConfig?: Maybe<
      TaskPipelineItemCardOverviewConfig
   >
   taskTemplateId: Scalars['String']
   taskType: TaskType
   visibilityFieldId?: Maybe<Scalars['String']>
}

export type TaskTemplateAccessDenied = GraphQlBaseError & {
   __typename?: 'TaskTemplateAccessDenied'
   message?: Maybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type TaskTemplateIdRequired = GraphQlBaseError & {
   __typename?: 'TaskTemplateIdRequired'
   message?: Maybe<Scalars['String']>
}

export type TaskTemplateIdentifications = {
   __typename?: 'TaskTemplateIdentifications'
   identifications: Array<IdentificationOverviewDetails>
   taskTemplateId: Scalars['String']
}

export type TaskTemplateIsDisabled = GraphQlBaseError & {
   __typename?: 'TaskTemplateIsDisabled'
   message?: Maybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type TaskTemplateIsNotPermittedInCurrentStage = GraphQlBaseError & {
   __typename?: 'TaskTemplateIsNotPermittedInCurrentStage'
   message?: Maybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type TaskTemplateNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'TaskTemplateNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type TaskTemplateNotFound = GraphQlBaseError & {
   __typename?: 'TaskTemplateNotFound'
   message?: Maybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type TaskTemplateNotFoundForPipelineItem = GraphQlBaseError & {
   __typename?: 'TaskTemplateNotFoundForPipelineItem'
   message?: Maybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type TaskTemplateQuickEditFieldsConfig = {
   __typename?: 'TaskTemplateQuickEditFieldsConfig'
   fieldIds: Array<Scalars['String']>
   showPipelineItemStageQuickEditFields: Scalars['Boolean']
}

export type TaskTemplateRemarksSettingConfig = {
   __typename?: 'TaskTemplateRemarksSettingConfig'
   enableRemarks: Scalars['Boolean']
   enableRemarksAttachments: Scalars['Boolean']
}

export type TaskTemplateResult =
   | TaskTemplate
   | TaskTemplateAccessDenied
   | TaskTemplateNotFound

export type TaskTemplateSettings = {
   __typename?: 'TaskTemplateSettings'
   captureSubmittedLocation: Scalars['Boolean']
   enablePipelineItemOtherFields: Scalars['Boolean']
   enablePipelineItemScheduling: Scalars['Boolean']
   remarksConfig: TaskTemplateRemarksSettingConfig
   viewStyle?: Maybe<TaskViewStyleEnum>
}

export enum TaskTemplateSettingsEnum {
   CaptureSubmittedLocation = 'CAPTURE_SUBMITTED_LOCATION',
   EnablePipelineItemOtherFields = 'ENABLE_PIPELINE_ITEM_OTHER_FIELDS',
   EnablePipelineItemScheduling = 'ENABLE_PIPELINE_ITEM_SCHEDULING',
   RemarksConfig = 'REMARKS_CONFIG',
   ViewStyle = 'VIEW_STYLE'
}

export type TaskTemplateSettingsShouldBeEmpty = GraphQlBaseError & {
   __typename?: 'TaskTemplateSettingsShouldBeEmpty'
   message?: Maybe<Scalars['String']>
   settings: Array<TaskTemplateSettingsEnum>
   taskTemplateId: Scalars['String']
}

export type TaskTemplateTaskTypesParams = {
   taskTypes: Array<TaskType>
}

export type TaskTemplatesAreNotInSamePipeline = GraphQlBaseError & {
   __typename?: 'TaskTemplatesAreNotInSamePipeline'
   message?: Maybe<Scalars['String']>
}

export type TaskTemplatesNotFound = GraphQlBaseError & {
   __typename?: 'TaskTemplatesNotFound'
   message?: Maybe<Scalars['String']>
   taskTemplateIds: Array<Scalars['String']>
}

export type TaskTemplatesNotInPipeline = GraphQlBaseError & {
   __typename?: 'TaskTemplatesNotInPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   taskTemplateIds: Array<Scalars['String']>
}

export type TaskTemplatesNotInPipelineItemPipeline = GraphQlBaseError & {
   __typename?: 'TaskTemplatesNotInPipelineItemPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   taskTemplateIds: Array<Scalars['String']>
}

export type TaskTemplatesParams = {
   taskTemplateIds: Array<Scalars['String']>
}

export enum TaskType {
   Call = 'CALL',
   Custom = 'CUSTOM',
   Default = 'DEFAULT'
}

export type TaskUpdatedTriggerConfig = {
   __typename?: 'TaskUpdatedTriggerConfig'
   fieldIds: Array<Scalars['String']>
}

export type TaskUpdatedTriggerConfigIsRequired = GraphQlBaseError & {
   __typename?: 'TaskUpdatedTriggerConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type TaskUpdatedTriggerConfigParams = {
   fieldIds: Array<Scalars['String']>
}

export enum TaskVerificationFieldProperty {
   Recommendation = 'RECOMMENDATION',
   Remarks = 'REMARKS'
}

export type TaskVerificationFieldRecommendation = {
   __typename?: 'TaskVerificationFieldRecommendation'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   recommendation: BpsVerificationRecommendationEnum
}

export type TaskVerificationFieldRemarks = {
   __typename?: 'TaskVerificationFieldRemarks'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   remarks?: Maybe<Scalars['String']>
}

export type TaskVerificationNotExists = GraphQlBaseError & {
   __typename?: 'TaskVerificationNotExists'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type TaskVerificationPaymentRecommendation = {
   __typename?: 'TaskVerificationPaymentRecommendation'
   paymentId: Scalars['String']
   recommendation: TdrPaymentVerificationRecommendationEnum
}

export type TaskVerificationPaymentRemarks = {
   __typename?: 'TaskVerificationPaymentRemarks'
   paymentId: Scalars['String']
   remarks?: Maybe<Scalars['String']>
}

export enum TaskViewStyleEnum {
   Popup = 'POPUP',
   SidePeek = 'SIDE_PEEK'
}

export type TaskWithPipelineItemBaseDetails = {
   __typename?: 'TaskWithPipelineItemBaseDetails'
   pipelineItemPrimaryDetails: PipelineItemPrimaryDetails
   task: Task
}

export enum TasksFilterByEnum {
   LeadStage = 'LEAD_STAGE',
   TaskStatus = 'TASK_STATUS',
   TaskTemplate = 'TASK_TEMPLATE'
}

export type TasksFilterParams = {
   filterBy: TasksFilterByEnum
   value: Scalars['String']
}

export type TdrManagementAccessDenied = GraphQlBaseError & {
   __typename?: 'TdrManagementAccessDenied'
   message?: Maybe<Scalars['String']>
}

export enum TdrManagementActionType {
   OnHold = 'ON_HOLD',
   Release = 'RELEASE'
}

export type TdrManagementAttachment = {
   __typename?: 'TdrManagementAttachment'
   attachmentId?: Maybe<Scalars['String']>
   mimeType?: Maybe<Scalars['String']>
   name: Scalars['String']
   sizeInBytes?: Maybe<Scalars['Int']>
   url: Scalars['String']
}

export type TdrManagementAttachmentParams = {
   attachmentId?: InputMaybe<Scalars['String']>
   mimeType?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   sizeInBytes?: InputMaybe<Scalars['Int']>
   url: Scalars['String']
}

export type TdrManagementLog = {
   __typename?: 'TdrManagementLog'
   account: BaseTdrAccount
   accountId: Scalars['String']
   actedBy: Scalars['String']
   actedByUser: BaseUser
   actedOn: Scalars['String']
   actionType: TdrManagementActionType
   attachments: Array<TdrManagementAttachment>
   logId: Scalars['String']
   reason?: Maybe<Scalars['String']>
}

export type TdrManagementLogFilters = {
   actedAfter?: InputMaybe<Scalars['String']>
   actedBefore?: InputMaybe<Scalars['String']>
   actionType?: InputMaybe<TdrManagementActionType>
   tdrAccountId?: InputMaybe<Scalars['String']>
}

export type TemplatesInPipelineItemTemplate = {
   __typename?: 'TemplatesInPipelineItemTemplate'
   activityTemplates: Array<BaseActivityTemplate>
   contactTemplate?: Maybe<ContactTemplate>
   pipelineItemTemplate: PipelineItemTemplate
   taskTemplates: Array<BaseTaskTemplate>
}

export type TermsSetNotFoundForEntity = GraphQlBaseError & {
   __typename?: 'TermsSetNotFoundForEntity'
   entityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TestTransferBankAmountCsvData = {
   __typename?: 'TestTransferBankAmountCsvData'
   failedCsvData?: Maybe<Scalars['String']>
   succeededCsvData?: Maybe<Scalars['String']>
   uploadedCsvData?: Maybe<Scalars['String']>
}

export type TestTransferBankAmountRequest = {
   __typename?: 'TestTransferBankAmountRequest'
   createdAt: Scalars['String']
   csvFiles?: Maybe<TestTransferBankAmountCsvData>
   file: FileUploaderUrlResponse
   initiationInfo?: Maybe<TransferBankAmountRequestInfo>
   otpVerifiedBy: Array<BaseUser>
   requestId: Scalars['String']
   requestedBy: BaseUser
   status: TestTransferBankAmountRequestStatus
}

export enum TestTransferBankAmountRequestStatus {
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS',
   PartiallyFailed = 'PARTIALLY_FAILED',
   Success = 'SUCCESS'
}

export enum TextAlignment {
   Center = 'CENTER',
   Left = 'LEFT',
   Right = 'RIGHT'
}

export type TgiicApiError = GraphQlBaseError & {
   __typename?: 'TgiicApiError'
   allotmentNumber: Scalars['String']
   apiError: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type TgiicIntegrationError = GraphQlBaseError & {
   __typename?: 'TgiicIntegrationError'
   allotmentNumber: Scalars['String']
   errorMessage: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type Thread = {
   __typename?: 'Thread'
   createdBy: Scalars['String']
   entityId: Scalars['String']
   entityType: ThreadEntityType
   name: Scalars['String']
   threadId: Scalars['Int']
}

export type ThreadAccessDenied = GraphQlBaseError & {
   __typename?: 'ThreadAccessDenied'
   message?: Maybe<Scalars['String']>
   threadId: Scalars['Int']
}

export type ThreadEntityNotFound = GraphQlBaseError & {
   __typename?: 'ThreadEntityNotFound'
   entityId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum ThreadEntityType {
   Account = 'ACCOUNT',
   Portal = 'PORTAL'
}

export type ThreadMessage = {
   __typename?: 'ThreadMessage'
   content: Scalars['String']
   createdAt: Scalars['String']
   date: Scalars['String']
   messageId: Scalars['Int']
   senderId: Scalars['String']
   threadId: Scalars['Int']
   timestamp: Scalars['String']
}

export type ThreadNotFound = GraphQlBaseError & {
   __typename?: 'ThreadNotFound'
   message?: Maybe<Scalars['String']>
   threadId: Scalars['Int']
}

export type TimeField = BaseField & {
   __typename?: 'TimeField'
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   relativeDefaultValueConfig?: Maybe<TimeRelativeDefaultValueConfig>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
}

export type TimeRange = {
   __typename?: 'TimeRange'
   fromValue?: Maybe<Scalars['String']>
   toValue?: Maybe<Scalars['String']>
}

export type TimeRelativeDefaultValueConfig = {
   __typename?: 'TimeRelativeDefaultValueConfig'
   noOfSeconds: Scalars['Int']
   operator: ArithmeticOperation
   valueEnum: TimeValueEnum
}

export type TimeRelativeDefaultValueConfigParams = {
   noOfSeconds: Scalars['Int']
   operator: ArithmeticOperation
   valueEnum: TimeValueEnum
}

export type TimeRelativeValueConfig = {
   __typename?: 'TimeRelativeValueConfig'
   noOfMinutes: Scalars['Int']
}

export type TimeRelativeValueConfigParams = {
   noOfMinutes: Scalars['Int']
}

export enum TimeValueEnum {
   CurrentTime = 'CURRENT_TIME'
}

export type TimelineEventType = {
   __typename?: 'TimelineEventType'
   description?: Maybe<Scalars['String']>
   event: Scalars['String']
   status: Scalars['String']
   timestamp: Scalars['String']
}

export type TitleIsRequiredForCustomTaskType = GraphQlBaseError & {
   __typename?: 'TitleIsRequiredForCustomTaskType'
   message?: Maybe<Scalars['String']>
}

export type ToRelatedSalesTemplateDisplayNameIsRequired = GraphQlBaseError & {
   __typename?: 'ToRelatedSalesTemplateDisplayNameIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ToSalesTemplateIdNotFound = GraphQlBaseError & {
   __typename?: 'ToSalesTemplateIdNotFound'
   message?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type ToStagesNotFound = GraphQlBaseError & {
   __typename?: 'ToStagesNotFound'
   message?: Maybe<Scalars['String']>
   stageIds: Array<Scalars['String']>
}

export type TrackEventConfig = {
   __typename?: 'TrackEventConfig'
   eventName?: Maybe<Scalars['String']>
   integrationsConfig?: Maybe<SegmentIntegrationConfig>
   propertiesMapping: Array<CustomKeyFieldValueMapping>
   timestampConfig?: Maybe<SegmentEventTimeStampConfig>
   uniqueIdValueConfig?: Maybe<SegmentUniqueIdValueConfig>
}

export type TrackEventConfigParams = {
   eventName?: InputMaybe<Scalars['String']>
   integrationsConfig?: InputMaybe<SegmentIntegrationConfigParams>
   propertiesMapping: Array<CustomKeyFieldValueMappingParams>
   timestampConfig?: InputMaybe<SegmentEventTimeStampConfigParams>
   uniqueIdValueConfig?: InputMaybe<SegmentUniqueIdValueConfigParams>
}

export enum TransactionOperation {
   Digitalize = 'DIGITALIZE',
   Issue = 'ISSUE',
   Sale = 'SALE',
   Utilize = 'UTILIZE'
}

export enum TransactionStatus {
   Credited = 'CREDITED',
   Digitalized = 'DIGITALIZED',
   SaleCompleted = 'SALE_COMPLETED',
   SaleInitiated = 'SALE_INITIATED',
   SaleReleased = 'SALE_RELEASED',
   UtilizationAcceptedByOfficer = 'UTILIZATION_ACCEPTED_BY_OFFICER',
   UtilizationAcceptedByOwner = 'UTILIZATION_ACCEPTED_BY_OWNER',
   UtilizationInitiated = 'UTILIZATION_INITIATED',
   UtilizationReleased = 'UTILIZATION_RELEASED'
}

export type TransferBankAmountPreviewFailed = {
   __typename?: 'TransferBankAmountPreviewFailed'
   errorMessage: Scalars['String']
}

export type TransferBankAmountRequestInfo = {
   __typename?: 'TransferBankAmountRequestInfo'
   failedCount?: Maybe<Scalars['Int']>
   initiatedCount?: Maybe<Scalars['Int']>
   queueCount?: Maybe<Scalars['Int']>
   totalCount?: Maybe<Scalars['Int']>
}

export type TransferReceiverAccountsMissingBeneId = {
   __typename?: 'TransferReceiverAccountsMissingBeneId'
   accountsWithoutBeneId: Array<Scalars['String']>
}

export type TransitionFunctionExecutionResult = {
   __typename?: 'TransitionFunctionExecutionResult'
   functionEnum: ActOnApplicationFunctionExecutionEnum
   scrutinyWorkloadId?: Maybe<Scalars['String']>
}

export type Trigger = EventBasedTrigger | ScheduledTrigger

export type TriggerAutomationWorkflowsOnActivityParams = {
   activityId: Scalars['String']
}

export type TriggerAutomationWorkflowsOnActivityResponse =
   | AccessDeniedToTriggerAutomationWorkflowsOnActivity
   | ActivityNotFound
   | NoActiveAutomationWorkflowsFound
   | TriggerAutomationWorkflowsOnActivityResult

export type TriggerAutomationWorkflowsOnActivityResult = {
   __typename?: 'TriggerAutomationWorkflowsOnActivityResult'
   activityId: Scalars['String']
}

export type TriggerConfigUpdateNotSupportedForLdRule = GraphQlBaseError & {
   __typename?: 'TriggerConfigUpdateNotSupportedForLdRule'
   leadDistributionRuleId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export enum TriggerEntity {
   Activity = 'ACTIVITY',
   Fee = 'FEE',
   Installment = 'INSTALLMENT',
   Lead = 'LEAD',
   Payment = 'PAYMENT',
   PipelineEvent = 'PIPELINE_EVENT',
   Task = 'TASK'
}

export enum TriggerEventType {
   Completed = 'COMPLETED',
   Created = 'CREATED',
   DisplayStageUpdated = 'DISPLAY_STAGE_UPDATED',
   Scheduled = 'SCHEDULED',
   StageUpdated = 'STAGE_UPDATED',
   Updated = 'UPDATED'
}

export type TriggerNotFound = GraphQlBaseError & {
   __typename?: 'TriggerNotFound'
   message?: Maybe<Scalars['String']>
   triggerId: Scalars['String']
}

export type TriggerPipelineCannotBeSameWithCreatePipelineEventNode = GraphQlBaseError & {
   __typename?: 'TriggerPipelineCannotBeSameWithCreatePipelineEventNode'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type TriggerScheduleWorkflowParams = {
   automationWorkflowId: Scalars['String']
}

export type TriggerScheduleWorkflowResponse =
   | AutomationWorkflowIsInProgress
   | AutomationWorkflowIsNotInActiveState
   | AutomationWorkflowNotFound
   | AutomationWorkflowPublishedVersionNotExists
   | ManualTriggerIsNotEnabled
   | TriggerScheduleWorkflowResult
   | UserIsNotAnAdministrator

export type TriggerScheduleWorkflowResult = {
   __typename?: 'TriggerScheduleWorkflowResult'
   automationWorkflowId: Scalars['String']
}

export type TriggerTaskAssigneeOnlySupportedToTaskTrigger = GraphQlBaseError & {
   __typename?: 'TriggerTaskAssigneeOnlySupportedToTaskTrigger'
   message?: Maybe<Scalars['String']>
}

export enum TriggerType {
   EventBased = 'EVENT_BASED',
   Scheduled = 'SCHEDULED'
}

export type UrlField = BaseField & {
   __typename?: 'URLField'
   alternateDisplayText?: Maybe<Scalars['String']>
   defaultValue?: Maybe<Scalars['String']>
   description?: Maybe<Scalars['String']>
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
   fieldType?: Maybe<FieldType>
   gofId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
   helpTextType?: Maybe<HelpTextType>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isDependent: Scalars['Boolean']
   isRequired: Scalars['Boolean']
   isUnique: Scalars['Boolean']
   linkedSourceFieldId?: Maybe<Scalars['String']>
   name: Scalars['String']
   parentFieldOptions?: Maybe<ParentFieldOptions>
   permissionType: PermissionType
   placeholderText?: Maybe<Scalars['String']>
   referenceId?: Maybe<Scalars['String']>
   regexErrorMessage?: Maybe<Scalars['String']>
   salesTemplateId: Scalars['String']
   systemFieldEnum?: Maybe<SystemFieldEnum>
   tags: Array<FieldTag>
   tooltip?: Maybe<Scalars['String']>
   validationRegex?: Maybe<Scalars['String']>
}

export enum UrlFieldPropertyEnum {
   AlternateDisplayText = 'ALTERNATE_DISPLAY_TEXT'
}

export type UrlFieldPropertyValuesShouldBeEmpty = GraphQlBaseError & {
   __typename?: 'URLFieldPropertyValuesShouldBeEmpty'
   message?: Maybe<Scalars['String']>
   properties: Array<UrlFieldPropertyEnum>
}

export type UlbCodeFieldNotFound = GraphQlBaseError & {
   __typename?: 'UlbCodeFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnLinkGraphsToViewParams = {
   graphIds: Array<Scalars['String']>
   viewId: Scalars['String']
}

export type UnLinkGraphsToViewResponse =
   | GraphsAccessDenied
   | GraphsNotFound
   | UnLinkGraphsToViewResult
   | ViewAccessDenied
   | ViewNotFound

export type UnLinkGraphsToViewResult = {
   __typename?: 'UnLinkGraphsToViewResult'
   graphIds: Array<Scalars['String']>
   viewId: Scalars['String']
}

export type UnLinkWhatsAppBusinessPhoneNumberFromPipelineParams = {
   pipelineId: Scalars['String']
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type UnLinkWhatsAppBusinessPhoneNumberFromPipelineResponse =
   | AccountPluginIsDisabled
   | PipelineNotFound
   | PluginServiceAccountIsNotActive
   | UnLinkWhatsAppBusinessPhoneNumberFromPipelineResult
   | UserIsNotAnAdministrator
   | WhatsAppBusinessPhoneNumberNotFound

export type UnLinkWhatsAppBusinessPhoneNumberFromPipelineResult = {
   __typename?: 'UnLinkWhatsAppBusinessPhoneNumberFromPipelineResult'
   pipelineId: Scalars['String']
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type UnLinkWhatsAppMessageTemplateFromPipelineParams = {
   pipelineId: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type UnLinkWhatsAppMessageTemplateFromPipelineResponse =
   | AccountPluginIsDisabled
   | PipelineNotFound
   | UnLinkWhatsAppMessageTemplateFromPipelineResult
   | UserIsNotAnAdministrator
   | WhatsAppMessageTemplateNotFound

export type UnLinkWhatsAppMessageTemplateFromPipelineResult = {
   __typename?: 'UnLinkWhatsAppMessageTemplateFromPipelineResult'
   pipelineId: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type UnPinPipelineItemsParams = {
   pipelineItemPinnedIds: Array<Scalars['String']>
}

export type UnPinPipelineItemsResponse =
   | PipelineItemPinnedIdsAccessDenied
   | PipelineItemPinnedIdsNotFound
   | UnPinPipelineItemsResult

export type UnPinPipelineItemsResult = {
   __typename?: 'UnPinPipelineItemsResult'
   pipelineItemPinnedIds: Array<Scalars['String']>
}

export type UnSupportedAssigneeFieldId = GraphQlBaseError & {
   __typename?: 'UnSupportedAssigneeFieldId'
   assigneeFieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnSupportedDataSourceField = GraphQlBaseError & {
   __typename?: 'UnSupportedDataSourceField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnSupportedDataSourceFields = GraphQlBaseError & {
   __typename?: 'UnSupportedDataSourceFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnSupportedFieldFormatInNotificationNode = GraphQlBaseError & {
   __typename?: 'UnSupportedFieldFormatInNotificationNode'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnSupportedFieldTypeForApplyAutomationWorkflowFiltersOn = GraphQlBaseError & {
   __typename?: 'UnSupportedFieldTypeForApplyAutomationWorkflowFiltersOn'
   applyFiltersOn: ApplyAutomationWorkflowsFiltersOn
   fieldType: FieldType
   message?: Maybe<Scalars['String']>
}

export type UnSupportedFieldValueSourcesForStageFields = GraphQlBaseError & {
   __typename?: 'UnSupportedFieldValueSourcesForStageFields'
   message?: Maybe<Scalars['String']>
   supportingValueSources: Array<FieldSourceType>
}

export type UnSupportedFieldsForEnableDeepCopy = GraphQlBaseError & {
   __typename?: 'UnSupportedFieldsForEnableDeepCopy'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnSupportedFilterFieldSourceForApplyAutomationWorkflowFiltersOn = GraphQlBaseError & {
   __typename?: 'UnSupportedFilterFieldSourceForApplyAutomationWorkflowFiltersOn'
   applyFiltersOn: ApplyAutomationWorkflowsFiltersOn
   filterFieldSource: FilterFieldSourceType
   message?: Maybe<Scalars['String']>
}

export type UnSupportedFilterValueFromForApplyAutomationWorkflowFiltersOn = GraphQlBaseError & {
   __typename?: 'UnSupportedFilterValueFromForApplyAutomationWorkflowFiltersOn'
   applyFiltersOn: ApplyAutomationWorkflowsFiltersOn
   message?: Maybe<Scalars['String']>
   valueFrom: FieldSourceType
}

export type UnSupportedGroupByFieldDataSource = GraphQlBaseError & {
   __typename?: 'UnSupportedGroupByFieldDataSource'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnSupportedGroupByFieldType = GraphQlBaseError & {
   __typename?: 'UnSupportedGroupByFieldType'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnSupportedGroupByFieldTypes = GraphQlBaseError & {
   __typename?: 'UnSupportedGroupByFieldTypes'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnSupportedGroupByFields = GraphQlBaseError & {
   __typename?: 'UnSupportedGroupByFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnSupportedGroupByFieldsDataSource = GraphQlBaseError & {
   __typename?: 'UnSupportedGroupByFieldsDataSource'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnSupportedGroupByTypeField = GraphQlBaseError & {
   __typename?: 'UnSupportedGroupByTypeField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnSupportedGroupByTypeFieldIds = GraphQlBaseError & {
   __typename?: 'UnSupportedGroupByTypeFieldIds'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnSupportedGroupByTypeFieldType = GraphQlBaseError & {
   __typename?: 'UnSupportedGroupByTypeFieldType'
   fieldId: Scalars['String']
   groupByType: GraphAggType
   message?: Maybe<Scalars['String']>
}

export type UnSupportedMetricField = GraphQlBaseError & {
   __typename?: 'UnSupportedMetricField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnSupportedMetricFieldDataSource = GraphQlBaseError & {
   __typename?: 'UnSupportedMetricFieldDataSource'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnSupportedMetricFields = GraphQlBaseError & {
   __typename?: 'UnSupportedMetricFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnSupportedMetricFieldsDataSource = GraphQlBaseError & {
   __typename?: 'UnSupportedMetricFieldsDataSource'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnSupportedNodeForPipelineItemTypes = GraphQlBaseError & {
   __typename?: 'UnSupportedNodeForPipelineItemTypes'
   message?: Maybe<Scalars['String']>
   nodeType: NodeType
   pipelineItemTypes: Array<PipelineItemType>
}

export type UnSupportedOperatorForApplyAutomationWorkflowFiltersOn = GraphQlBaseError & {
   __typename?: 'UnSupportedOperatorForApplyAutomationWorkflowFiltersOn'
   applyFiltersOn: ApplyAutomationWorkflowsFiltersOn
   message?: Maybe<Scalars['String']>
   operator: AutomationWorkflowOperator
}

export type UnSupportedOperators = GraphQlBaseError & {
   __typename?: 'UnSupportedOperators'
   message?: Maybe<Scalars['String']>
   operators: Array<Scalars['String']>
}

export type UnSupportedPipelineItemTypeForNodeType = GraphQlBaseError & {
   __typename?: 'UnSupportedPipelineItemTypeForNodeType'
   message?: Maybe<Scalars['String']>
   nodeType: NodeType
   pipelineItemType: PipelineItemType
}

export type UnSupportedSystemFieldIdsToEdit = GraphQlBaseError & {
   __typename?: 'UnSupportedSystemFieldIdsToEdit'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnSupportedSystemFieldReferenceIds = GraphQlBaseError & {
   __typename?: 'UnSupportedSystemFieldReferenceIds'
   message?: Maybe<Scalars['String']>
   referenceIds: Array<Scalars['String']>
}

export type UnSupportedTriggerNodeType = GraphQlBaseError & {
   __typename?: 'UnSupportedTriggerNodeType'
   message?: Maybe<Scalars['String']>
   nodeType: NodeType
   supportedNodeTypes: Array<NodeType>
}

export type UnVerifiedGofResponsePhoneNumberFields = {
   __typename?: 'UnVerifiedGofResponsePhoneNumberFields'
   fieldIds: Array<Scalars['String']>
   gofResponseId?: Maybe<Scalars['String']>
}

export type UnVerifiedPhoneNumberFields = GraphQlBaseError & {
   __typename?: 'UnVerifiedPhoneNumberFields'
   message?: Maybe<Scalars['String']>
   unVerifiedPhoneNumberFields: Array<UnVerifiedGofResponsePhoneNumberFields>
}

export type UnauthorizedFriendAssignment = GraphQlBaseError & {
   __typename?: 'UnauthorizedFriendAssignment'
   assignedByOfficerId: Scalars['String']
   friendOfficerId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnauthorizedSendBack = GraphQlBaseError & {
   __typename?: 'UnauthorizedSendBack'
   message?: Maybe<Scalars['String']>
   officerId: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type UnfilledGofResponseFields = {
   __typename?: 'UnfilledGofResponseFields'
   fieldIds: Array<Scalars['String']>
   gofResponseId?: Maybe<Scalars['String']>
}

export type UnfilledStageRequiredFields = GraphQlBaseError & {
   __typename?: 'UnfilledStageRequiredFields'
   message?: Maybe<Scalars['String']>
   requiredFields: Array<UnfilledGofResponseFields>
   stageId: Scalars['String']
}

export type UnifiedApplicationParams = {
   fieldReferenceId: Scalars['String']
   relationId?: InputMaybe<Scalars['String']>
   response?: InputMaybe<Scalars['String']>
   target?: InputMaybe<SelfRelationTarget>
}

export type UniqueFieldResponseAlreadyExists = GraphQlBaseError & {
   __typename?: 'UniqueFieldResponseAlreadyExists'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
   response: Scalars['String']
}

export type UniqueFieldsAreNotSupportedForMultiCardinalityRelation = GraphQlBaseError & {
   __typename?: 'UniqueFieldsAreNotSupportedForMultiCardinalityRelation'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UniqueFieldsResponseAlreadyExists = GraphQlBaseError & {
   __typename?: 'UniqueFieldsResponseAlreadyExists'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnschedulePipelineItemsParams = {
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export type UnschedulePipelineItemsResponse =
   | ScheduledPipelineItemsAccessDenied
   | ScheduledPipelineItemsNotFound
   | UnschedulePipelineItemsResult

export type UnschedulePipelineItemsResult = {
   __typename?: 'UnschedulePipelineItemsResult'
   pipelineItemScheduledIds: Array<Scalars['String']>
}

export enum UnsupportedAutomationWorkflowFieldErrorCode {
   DirectValueNotSupportedFields = 'DIRECT_VALUE_NOT_SUPPORTED_FIELDS',
   FieldsAndSourcesAreMismatched = 'FIELDS_AND_SOURCES_ARE_MISMATCHED',
   FieldsAreNotCompatible = 'FIELDS_ARE_NOT_COMPATIBLE',
   FieldsNotInTriggerEntityTemplates = 'FIELDS_NOT_IN_TRIGGER_ENTITY_TEMPLATES',
   FieldsNotSupportedForTrigger = 'FIELDS_NOT_SUPPORTED_FOR_TRIGGER',
   FieldSourceNotSupportedInFilterSetEntity = 'FIELD_SOURCE_NOT_SUPPORTED_IN_FILTER_SET_ENTITY'
}

export type UnsupportedDataSourcesForPipeline = GraphQlBaseError & {
   __typename?: 'UnsupportedDataSourcesForPipeline'
   dataSources: Array<AnalyticsDataSourceType>
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type UnsupportedEventBasedTrigger = GraphQlBaseError & {
   __typename?: 'UnsupportedEventBasedTrigger'
   message?: Maybe<Scalars['String']>
   triggerEntity: TriggerEntity
   triggerEventType: TriggerEventType
}

export enum UnsupportedEventTriggerFieldErrorCode {
   FieldsAndSourcesAreMismatched = 'FIELDS_AND_SOURCES_ARE_MISMATCHED',
   FieldsAreNotCompatible = 'FIELDS_ARE_NOT_COMPATIBLE',
   FieldsNotInTriggerEntityTemplates = 'FIELDS_NOT_IN_TRIGGER_ENTITY_TEMPLATES',
   FieldsNotSupportedForTrigger = 'FIELDS_NOT_SUPPORTED_FOR_TRIGGER',
   FieldSourceNotSupportedInFilterSetEntity = 'FIELD_SOURCE_NOT_SUPPORTED_IN_FILTER_SET_ENTITY'
}

export type UnsupportedFieldFormatsInFormulaFieldValue = GraphQlBaseError & {
   __typename?: 'UnsupportedFieldFormatsInFormulaFieldValue'
   fieldFormats: Array<Scalars['String']>
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnsupportedFieldFormatsInFormulaValue = GraphQlBaseError & {
   __typename?: 'UnsupportedFieldFormatsInFormulaValue'
   formatStrings: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnsupportedFieldTypeForTaskVisibilityField = GraphQlBaseError & {
   __typename?: 'UnsupportedFieldTypeForTaskVisibilityField'
   fieldId: Scalars['String']
   fieldType: FieldType
   message?: Maybe<Scalars['String']>
}

export type UnsupportedLeadDistributionEventBasedTrigger = GraphQlBaseError & {
   __typename?: 'UnsupportedLeadDistributionEventBasedTrigger'
   message?: Maybe<Scalars['String']>
   triggerEntity: LeadDistributionTriggerEntity
   triggerEventType: LeadDistributionTriggerEventType
}

export enum UnsupportedPipelineItemSystemFieldsInTaskDraft {
   CustomObjectAssignedOn = 'CUSTOM_OBJECT_ASSIGNED_ON',
   CustomObjectAssignee = 'CUSTOM_OBJECT_ASSIGNEE',
   CustomObjectCreatedOn = 'CUSTOM_OBJECT_CREATED_ON',
   CustomObjectCustomId = 'CUSTOM_OBJECT_CUSTOM_ID',
   CustomObjectStage = 'CUSTOM_OBJECT_STAGE',
   DealAssignedOn = 'DEAL_ASSIGNED_ON',
   DealAssignee = 'DEAL_ASSIGNEE',
   DealCreatedOn = 'DEAL_CREATED_ON',
   DealStage = 'DEAL_STAGE',
   LeadAssignedOn = 'LEAD_ASSIGNED_ON',
   LeadAssignee = 'LEAD_ASSIGNEE',
   LeadCreatedOn = 'LEAD_CREATED_ON',
   LeadStage = 'LEAD_STAGE'
}

export type UnsupportedScheduleTriggerEntity = GraphQlBaseError & {
   __typename?: 'UnsupportedScheduleTriggerEntity'
   message?: Maybe<Scalars['String']>
   triggerEntity: TriggerEntity
}

export type UnsupportedScheduledMinutesConfig = GraphQlBaseError & {
   __typename?: 'UnsupportedScheduledMinutesConfig'
   message?: Maybe<Scalars['String']>
}

export type UnsupportedSystemGoF = GraphQlBaseError & {
   __typename?: 'UnsupportedSystemGoF'
   gofId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UnverifiedPhoneNumberGofResponseFields = GraphQlBaseError & {
   __typename?: 'UnverifiedPhoneNumberGofResponseFields'
   fieldIds: Array<Scalars['String']>
   gofResponseId?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UnverifiedPhoneNumberGofResponseFieldsFound = GraphQlBaseError & {
   __typename?: 'UnverifiedPhoneNumberGofResponseFieldsFound'
   message?: Maybe<Scalars['String']>
   phoneNumberGofFields: Array<UnverifiedPhoneNumberGofResponseFields>
}

export type UpRefAssigneeFieldIsRequired = GraphQlBaseError & {
   __typename?: 'UpRefAssigneeFieldIsRequired'
   message?: Maybe<Scalars['String']>
}

export type UpRefAssigneeFieldsAreRequiredForFields = GraphQlBaseError & {
   __typename?: 'UpRefAssigneeFieldsAreRequiredForFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UpRefFieldsAreNotAssigneeFields = GraphQlBaseError & {
   __typename?: 'UpRefFieldsAreNotAssigneeFields'
   fieldIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UpcomingSiteInspectionScheduleExists = GraphQlBaseError & {
   __typename?: 'UpcomingSiteInspectionScheduleExists'
   message?: Maybe<Scalars['String']>
}

export type UpdateActivitiesFeatureEnableStatusParams = {
   isActivitiesFeatureEnabled: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type UpdateActivitiesFeatureEnableStatusResponse =
   | PipelineNotFound
   | UpdateActivitiesFeatureEnableStatusResult
   | UserIsNotAnAdministrator

export type UpdateActivitiesFeatureEnableStatusResult = {
   __typename?: 'UpdateActivitiesFeatureEnableStatusResult'
   isActivitiesFeatureEnabled: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type UpdateActivityPipelineItemCreationConfigParams = {
   activityTemplateId: Scalars['String']
   phoneNumberIdentificationFieldId?: InputMaybe<Scalars['String']>
   /** @deprecated Support SRMP */
   stageId?: InputMaybe<Scalars['String']>
}

export type UpdateActivityPipelineItemCreationConfigResponse =
   | ActivityTemplateAndStageAreNotInSamePipeline
   | ActivityTemplateNotFound
   | ApplicationDisplayStageNotFound
   | DisplayStageIdOnlySupportedInApplicationPipeline
   | NotAPhoneNumberIdentificationField
   | PhoneNumberIdentificationFieldNotSupportedPipeline
   | PhoneNumberIdentificationFieldNotSupportedPipelineItemTemplate
   | StageNotFound
   | UpdateActivityPipelineItemCreationConfigResult
   | UserIsNotAnAdministrator

export type UpdateActivityPipelineItemCreationConfigResult = {
   __typename?: 'UpdateActivityPipelineItemCreationConfigResult'
   activityTemplateId: Scalars['String']
   /** @deprecated Support SRMP */
   displayStageId?: Maybe<Scalars['String']>
   phoneNumberIdentificationFieldId?: Maybe<Scalars['String']>
   /** @deprecated Support SRMP */
   stageId?: Maybe<Scalars['String']>
}

export type UpdateActivityTemplateDescriptionParams = {
   activityTemplateId: Scalars['String']
   description?: InputMaybe<Scalars['String']>
}

export type UpdateActivityTemplateDescriptionResponse =
   | ActivityTemplateNotFound
   | UpdateActivityTemplateDescriptionResult
   | UserIsNotAnAdministrator

export type UpdateActivityTemplateDescriptionResult = {
   __typename?: 'UpdateActivityTemplateDescriptionResult'
   activityTemplateId: Scalars['String']
   description?: Maybe<Scalars['String']>
}

export type UpdateActivityTemplateNameParams = {
   activityTemplateId: Scalars['String']
   name: Scalars['String']
}

export type UpdateActivityTemplateNameResponse =
   | ActivityTemplateNameAlreadyExists
   | ActivityTemplateNotFound
   | UpdateActivityTemplateNameResult
   | UserIsNotAnAdministrator

export type UpdateActivityTemplateNameResult = {
   __typename?: 'UpdateActivityTemplateNameResult'
   activityTemplateId: Scalars['String']
   name: Scalars['String']
}

export type UpdateActivityTemplatePipelineStagesParams = {
   activityTemplateId: Scalars['String']
   pipelineStages: Array<ActivityTemplatePipelineStageParams>
}

export type UpdateActivityTemplatePipelineStagesResponse =
   | ActivityTemplateNotFound
   | DuplicatePipelineIds
   | PipelinesNotInActivityTemplate
   | StagesNotFound
   | StagesNotInActivityTemplatePipelines
   | UpdateActivityTemplatePipelineStagesResult
   | UserIsNotAnAdministrator

export type UpdateActivityTemplatePipelineStagesResult = {
   __typename?: 'UpdateActivityTemplatePipelineStagesResult'
   activityTemplateId: Scalars['String']
   pipelineStages: Array<ActivityTemplatePipelineStage>
}

export type UpdateActivityTemplateReferenceIdParams = {
   activityTemplateId: Scalars['String']
   referenceId?: InputMaybe<Scalars['String']>
}

export type UpdateActivityTemplateReferenceIdResponse =
   | ActivityTemplateNotFound
   | ActivityTemplateReferenceIdAlreadyExists
   | ActivityTemplateReferenceIdMaxLengthExceeded
   | InvalidActivityTemplateReferenceIdFormat
   | UpdateActivityTemplateReferenceIdResult
   | UserIsNotAnAdministrator

export type UpdateActivityTemplateReferenceIdResult = {
   __typename?: 'UpdateActivityTemplateReferenceIdResult'
   activityTemplateId: Scalars['String']
   referenceId?: Maybe<Scalars['String']>
}

export type UpdateAddAnotherGofResponsesLimitInputParams = {
   addAnotherGofResponsesLimit?: InputMaybe<Scalars['Int']>
   gofId: Scalars['String']
}

export type UpdateAddAnotherGofResponsesLimitResponse =
   | CannotEditSystemGoF
   | GoFIsDeleted
   | GoFNotFound
   | UpdateAddAnotherGofResponsesLimitResult
   | UserIsNotAnAdministrator

export type UpdateAddAnotherGofResponsesLimitResult = {
   __typename?: 'UpdateAddAnotherGofResponsesLimitResult'
   addAnotherGofResponsesLimit?: Maybe<Scalars['Int']>
   gofId: Scalars['String']
}

export type UpdateAgentAllocationGroupNameParams = {
   agentAllocationGroupId: Scalars['String']
   name: Scalars['String']
}

export type UpdateAgentAllocationGroupNameResponse =
   | AgentAllocationGroupNameAlreadyExists
   | AgentAllocationGroupNotFound
   | EmptyAgentAllocationGroupName
   | UpdateAgentAllocationGroupNameResult
   | UserIsNotAnAdministrator

export type UpdateAgentAllocationGroupNameResult = {
   __typename?: 'UpdateAgentAllocationGroupNameResult'
   agentAllocationGroupId: Scalars['String']
   name: Scalars['String']
}

export type UpdateAgentGlobalQuotaParams = {
   agentId: Scalars['String']
   dayQuota?: InputMaybe<Scalars['Int']>
   monthQuota?: InputMaybe<Scalars['Int']>
   weekQuota?: InputMaybe<Scalars['Int']>
}

export type UpdateAgentGlobalQuotaResponse =
   | AgentGlobalQuota
   | AgentNotFound
   | AgentQuotaMismatch
   | InvalidAgentQuota
   | UserIsNotAnAdministrator

export type UpdateAllocationGroupSetQuotaParams = {
   allocationGroupSetId: Scalars['String']
   quota: Scalars['Int']
   quotaType?: InputMaybe<AllocationGroupSetQuotaType>
}

export type UpdateAllocationGroupSetQuotaResponse =
   | AllocationGroupSetNotFound
   | InvalidAllocationGroupSetQuota
   | LeadDistributionRuleIsNotInEditMode
   | NotEditableAllocationGroupSet
   | UpdateAllocationGroupSetQuotaResult
   | UserIsNotAnAdministrator

export type UpdateAllocationGroupSetQuotaResult = {
   __typename?: 'UpdateAllocationGroupSetQuotaResult'
   allocationGroupSetId: Scalars['String']
   quota: Scalars['Int']
   quotaType: AllocationGroupSetQuotaType
}

export type UpdateAllocationGroupSetTypeParams = {
   allocationGroupSetId: Scalars['String']
   setType: AllocationGroupSetType
}

export type UpdateAllocationGroupSetTypeResponse =
   | AllocationGroupSetNotFound
   | LeadDistributionRuleIsNotInEditMode
   | NotEditableAllocationGroupSet
   | UpdateAllocationGroupSetTypeResult
   | UserIsNotAnAdministrator

export type UpdateAllocationGroupSetTypeResult = {
   __typename?: 'UpdateAllocationGroupSetTypeResult'
   allocationGroupSetId: Scalars['String']
   setType: AllocationGroupSetType
}

export type UpdateAllowManualTriggerParams = {
   allowManualTrigger: Scalars['Boolean']
   triggerId: Scalars['String']
}

export type UpdateAllowManualTriggerResponse =
   | NotEditableTrigger
   | NotScheduledTrigger
   | TriggerNotFound
   | UpdateAllowManualTriggerResult
   | UserIsNotAnAdministrator

export type UpdateAllowManualTriggerResult = {
   __typename?: 'UpdateAllowManualTriggerResult'
   allowManualTrigger: Scalars['Boolean']
   triggerId: Scalars['String']
}

export type UpdateAppealTaskObservationParams = {
   appealAssociatedTaskId: Scalars['String']
   recommendation?: InputMaybe<AppealTaskVerificationRecommendationEnum>
   remarks?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: TaskVerificationFieldProperty
}

export type UpdateAppealTaskObservationResponse =
   | ActiveAppealDoesNotExistsForPipelineItem
   | AppealDoesNotExists
   | AppealTaskDoesNotExists
   | TaskAccessDenied
   | TaskNotFound
   | TaskNotLinkedToAppeal
   | TaskTemplateAccessDenied
   | TaskVerificationNotExists
   | UpdateAppealTaskObservationResult

export type UpdateAppealTaskObservationResult = {
   __typename?: 'UpdateAppealTaskObservationResult'
   appealAssociatedTaskId: Scalars['String']
   recommendation?: Maybe<AppealTaskVerificationRecommendationEnum>
   remarks?: Maybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: TaskVerificationFieldProperty
}

export type UpdateApplicationAddAnotherFieldBulkParams = {
   applicationId: Scalars['String']
   fieldResponses: Array<FieldResponseParams>
   gofId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
}

export type UpdateApplicationAddAnotherFieldBulkResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsResponseIsRequired
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GoFNotFound
   | GoFResponseIdNotFound
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NeedFieldsWritePermission
   | NotAddAnotherGoF
   | NotAddAnotherGoFField
   | NotAddAnotherGoFFields
   | NotAddAnotherGoFResponseField
   | NotAddAnotherGoFResponseFields
   | NotAllowedFileFormats
   | NotApplicationAddAnotherGoFResponse
   | NotApplicationPipelineFields
   | NotApplicationPipelineGoF
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UpdateFieldResponseBulkResult

export type UpdateApplicationAddAnotherFieldInPortalParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   response?: InputMaybe<Scalars['String']>
}

export type UpdateApplicationAddAnotherFieldInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GoFResponseIdNotFound
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAddAnotherGoFField
   | NotAddAnotherGoFResponseField
   | NotAllowedFileFormats
   | NotApplicationAddAnotherGoFResponse
   | ParentFieldNotFilled
   | PortalIsDeleted
   | PortalNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UpdateFieldResponseResult

export type UpdateApplicationAddAnotherFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type UpdateApplicationAddAnotherFieldResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GoFResponseIdNotFound
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAddAnotherGoFField
   | NotAddAnotherGoFResponseField
   | NotAllowedFileFormats
   | NotApplicationAddAnotherGoFResponse
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UpdateFieldResponseResult

export type UpdateApplicationAddAnotherSurveyNumberFieldInPortalParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   response?: InputMaybe<Scalars['String']>
}

export type UpdateApplicationAddAnotherSurveyNumberFieldInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GivenFieldIsNotSurveyNumberField
   | GoFResponseIdNotFound
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAddAnotherGoFField
   | NotAddAnotherGoFResponseField
   | NotAllowedFileFormats
   | NotApplicationAddAnotherGoFResponse
   | ParentFieldNotFilled
   | PortalIsDeleted
   | PortalNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | SurveyNumberFieldNotFound
   | UpdateApplicationAddAnotherSurveyNumberFieldInPortalResult
   | UpdateFieldResponseResult

export type UpdateApplicationAddAnotherSurveyNumberFieldInPortalResult = {
   __typename?: 'UpdateApplicationAddAnotherSurveyNumberFieldInPortalResult'
   changedFields: Array<FieldResponse>
   fieldResponse: FieldResponse
   surveyNumberRemarks?: Maybe<SurveyNumberRemarkEnum>
}

export type UpdateApplicationAddAnotherSurveyNumberFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type UpdateApplicationAddAnotherSurveyNumberFieldResponse =
   | AddAnotherFieldsAreNotSupported
   | ApplicationAccessDenied
   | ApplicationNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotApplicationPipelineField
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UniqueFieldResponseAlreadyExists
   | UpdateApplicationAddAnotherSurveyNumberFieldResult

export type UpdateApplicationAddAnotherSurveyNumberFieldResult = {
   __typename?: 'UpdateApplicationAddAnotherSurveyNumberFieldResult'
   changedFields: Array<FieldResponse>
   fieldResponse: FieldResponse
   surveyNumberRemarks?: Maybe<SurveyNumberRemarkEnum>
}

export type UpdateApplicationAssigneeBulkParams = {
   applicationIds: Array<Scalars['String']>
   fieldId: Scalars['String']
   response: Scalars['String']
   sendNotification: Scalars['Boolean']
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdateApplicationAssigneeBulkResponse =
   | AccountAccessDeniedToAssignee
   | ApplicationAssigneeIsDeactivated
   | ApplicationAssigneeNotFound
   | ApplicationsAccessDenied
   | ApplicationsAreDeleted
   | ApplicationsNotFound
   | FieldIsDeleted
   | FieldNotFound
   | NeedFieldWritePermission
   | NotApplicationAssigneeFields
   | PipelineAccessDeniedToAssignee
   | UpdateApplicationAssigneeBulkResult
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateApplicationAssigneeBulkResult = {
   __typename?: 'UpdateApplicationAssigneeBulkResult'
   applicationFields: Array<ApplicationFieldResponse>
}

export type UpdateApplicationAvailTdrCreditsInPortalParams = {
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
   response?: InputMaybe<Scalars['String']>
}

export type UpdateApplicationAvailTdrCreditsInPortalResponse =
   | AddAnotherFieldsAreNotSupported
   | ApplicationAccessDenied
   | ApplicationAssigneeIsDeactivated
   | ApplicationAssigneeNotFound
   | ApplicationIsDeleted
   | ApplicationNotFound
   | AtLeastOneApplicationIdentificationFieldIsRequired
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GivenFieldIsNotAvailTdrCreditsField
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotApplicationPipelineField
   | ParentFieldNotFilled
   | PipelineAccessDeniedToAssignee
   | PortalNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | UniqueFieldResponseAlreadyExists
   | UpdateApplicationAvailTdrCreditsInPortalResult
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateApplicationAvailTdrCreditsInPortalResult = {
   __typename?: 'UpdateApplicationAvailTDRCreditsInPortalResult'
   changedFields: Array<FieldResponse>
   fieldResponse: FieldResponse
}

export type UpdateApplicationBulkSurveyNumberFieldInPortalParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   applicationId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   surveyNumberResponses: Array<BulkSurveyNumberGoFFieldResponseParams>
}

export type UpdateApplicationBulkSurveyNumberFieldInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GivenFieldIsNotSurveyNumberField
   | GoFResponseIdNotFound
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAddAnotherGoFField
   | NotAddAnotherGoFResponseField
   | NotAllowedFileFormats
   | NotApplicationAddAnotherGoFResponse
   | ParentFieldNotFilled
   | PortalIsDeleted
   | PortalNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | SurveyNumberFieldNotFound
   | UpdateApplicationBulkSurveyNumberFieldInPortalResult
   | UpdateFieldResponseBulkResult

export type UpdateApplicationBulkSurveyNumberFieldInPortalResult = {
   __typename?: 'UpdateApplicationBulkSurveyNumberFieldInPortalResult'
   changedFields: Array<FieldResponse>
   surveyNumberResponses: Array<BulkSurveyNumberGoFFieldResponse>
}

export type UpdateApplicationBulkSurveyNumberFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   applicationId: Scalars['String']
   surveyNumberResponses: Array<BulkSurveyNumberGoFFieldResponseParams>
}

export type UpdateApplicationBulkSurveyNumberFieldResponse =
   | AddAnotherFieldsAreNotSupported
   | ApplicationAccessDenied
   | ApplicationNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotApplicationPipelineField
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UniqueFieldResponseAlreadyExists
   | UpdateApplicationBulkSurveyNumberFieldResult

export type UpdateApplicationBulkSurveyNumberFieldResult = {
   __typename?: 'UpdateApplicationBulkSurveyNumberFieldResult'
   changedFields: Array<FieldResponse>
   surveyNumberResponses: Array<BulkSurveyNumberGoFFieldResponse>
}

export type UpdateApplicationFieldAsShortfallParams = {
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   remarks: Scalars['String']
}

export type UpdateApplicationFieldAsShortfallResponse =
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseMustBeFilled
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | UpdateApplicationFieldAsShortfallResult

export type UpdateApplicationFieldAsShortfallResult = {
   __typename?: 'UpdateApplicationFieldAsShortfallResult'
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   remarks: Scalars['String']
}

export type UpdateApplicationFieldInPortalParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   response?: InputMaybe<Scalars['String']>
}

export type UpdateApplicationFieldInPortalResponse =
   | AddAnotherFieldsAreNotSupported
   | ApplicationAccessDenied
   | ApplicationAssigneeIsDeactivated
   | ApplicationAssigneeNotFound
   | ApplicationIsDeleted
   | ApplicationNotFound
   | AtLeastOneApplicationIdentificationFieldIsRequired
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotApplicationPipelineField
   | ParentFieldNotFilled
   | PipelineAccessDeniedToAssignee
   | PortalNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | TgiicAllotmentNumberInvalid
   | TGbPassFileNumberNotFound
   | TgiicApiError
   | TgiicIntegrationError
   | UnSupportedSystemFieldIdsToEdit
   | UniqueFieldResponseAlreadyExists
   | UpdateFieldResponseResult
   | UserNotHavePermissionToUpdateToGivenStage
   | VltFormatInvalid
   | VltNotFoundInPropertyTax
   | VltPropertyTaxApiError
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateApplicationFieldResponse =
   | AddAnotherFieldsAreNotSupported
   | ApplicationAccessDenied
   | ApplicationAssigneeIsDeactivated
   | ApplicationAssigneeNotFound
   | ApplicationIsDeleted
   | ApplicationNotFound
   | AtLeastOneApplicationIdentificationFieldIsRequired
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotApplicationPipelineField
   | ParentFieldNotFilled
   | PipelineAccessDeniedToAssignee
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | UnSupportedSystemFieldIdsToEdit
   | UniqueFieldResponseAlreadyExists
   | UpdateFieldResponseResult
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateApplicationParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdateApplicationSurveyNumberFieldInPortalParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
   response?: InputMaybe<Scalars['String']>
}

export type UpdateApplicationSurveyNumberFieldInPortalResponse =
   | AddAnotherFieldsAreNotSupported
   | ApplicationAccessDenied
   | ApplicationAssigneeIsDeactivated
   | ApplicationAssigneeNotFound
   | ApplicationIsDeleted
   | ApplicationNotFound
   | AtLeastOneApplicationIdentificationFieldIsRequired
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GivenFieldIsNotSurveyNumberField
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotApplicationPipelineField
   | ParentFieldNotFilled
   | PipelineAccessDeniedToAssignee
   | PortalNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | SurveyNumberFieldNotFound
   | UnSupportedSystemFieldIdsToEdit
   | UniqueFieldResponseAlreadyExists
   | UpdateApplicationSurveyNumberFieldInPortalResult
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateApplicationSurveyNumberFieldInPortalResult = {
   __typename?: 'UpdateApplicationSurveyNumberFieldInPortalResult'
   changedFields: Array<FieldResponse>
   fieldResponse: FieldResponse
   surveyNumberRemarks?: Maybe<SurveyNumberRemarkEnum>
}

export type UpdateApplicationSurveyNumberFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type UpdateApplicationSurveyNumberFieldResponse =
   | AddAnotherFieldsAreNotSupported
   | ApplicationAccessDenied
   | ApplicationNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotApplicationPipelineField
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UniqueFieldResponseAlreadyExists
   | UpdateApplicationSurveyNumberFieldResult

export type UpdateApplicationSurveyNumberFieldResult = {
   __typename?: 'UpdateApplicationSurveyNumberFieldResult'
   changedFields: Array<FieldResponse>
   fieldResponse: FieldResponse
   surveyNumberRemarks?: Maybe<SurveyNumberRemarkEnum>
}

export type UpdateApplicationTdrSalesAndTransferFieldInPortalParams = {
   applicationId: Scalars['String']
   fieldId: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
   response?: InputMaybe<Scalars['String']>
}

export type UpdateApplicationTdrSalesAndTransferFieldInPortalResponse =
   | AddAnotherFieldsAreNotSupported
   | ApplicationAccessDenied
   | ApplicationAssigneeIsDeactivated
   | ApplicationAssigneeNotFound
   | ApplicationIsDeleted
   | ApplicationNotFound
   | AtLeastOneApplicationIdentificationFieldIsRequired
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | EmptyTdrAccountBalance
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GivenFieldIsNotTdrSalesAndTransferField
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotAllowedToUpdateTransferArea
   | NotApplicationPipelineField
   | NotHaveSufficientBalanceInTdrAccount
   | NotTdrAccountHolderUser
   | ParentFieldNotFilled
   | PipelineAccessDeniedToAssignee
   | PortalNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | TdrAccountNoNotFound
   | UniqueFieldResponseAlreadyExists
   | UpdateApplicationTdrSalesAndTransferFieldInPortalResult
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateApplicationTdrSalesAndTransferFieldInPortalResult = {
   __typename?: 'UpdateApplicationTDRSalesAndTransferFieldInPortalResult'
   changedFields: Array<FieldResponse>
   fieldResponse: FieldResponse
}

export type UpdateApplicationTabGofFieldIdsParams = {
   fieldIds: Array<Scalars['String']>
   gofId: Scalars['String']
   portalApplicationId: Scalars['String']
   sectionUiStyle?: InputMaybe<PortalSectionTabUiStyle>
   tabId: Scalars['String']
}

export type UpdateApplicationTabGofFieldIdsResponse =
   | DependentFieldsSelectedWithoutParent
   | FieldsAreDeleted
   | FieldsNotFound
   | FieldsNotInGoF
   | FormulaFieldsAreNotAllowed
   | GoFNotFoundInPortalApplicationTab
   | PortalApplicationNotFound
   | PortalApplicationTabNotFound
   | TabNotFoundInPortalApplication
   | UnsupportedSystemGoF
   | UpdateApplicationTabGofFieldIdsResult
   | UserIsNotAnAdministrator

export type UpdateApplicationTabGofFieldIdsResult = {
   __typename?: 'UpdateApplicationTabGofFieldIdsResult'
   fieldIds: Array<Scalars['String']>
   gofId: Scalars['String']
   portalApplicationId: Scalars['String']
   sectionUiStyle?: Maybe<PortalSectionTabUiStyle>
   tabId: Scalars['String']
}

export type UpdateApplicationTabNameParams = {
   name: Scalars['String']
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type UpdateApplicationTabNameResponse =
   | PortalApplicationNotFound
   | TabNameAlreadyExists
   | TabNotFoundInPortalApplication
   | UpdateApplicationTabNameResult
   | UserIsNotAnAdministrator

export type UpdateApplicationTabNameResult = {
   __typename?: 'UpdateApplicationTabNameResult'
   name: Scalars['String']
   portalApplicationId: Scalars['String']
   tabId: Scalars['String']
}

export type UpdateApplicationTabParams = {
   category: Scalars['String']
   iconInfo?: InputMaybe<IconParams>
   name: Scalars['String']
   portalApplicationId: Scalars['String']
   tabEnum?: InputMaybe<ApplicationTabEnum>
   tabId: Scalars['String']
}

export type UpdateApplicationTabResponse =
   | ApplicationTabIconInfoIsRequired
   | PortalApplicationNotFound
   | TabNameAlreadyExists
   | TabNotFoundInPortalApplication
   | UpdateApplicationTabResult
   | UserIsNotAnAdministrator

export type UpdateApplicationTabResult = {
   __typename?: 'UpdateApplicationTabResult'
   category: Scalars['String']
   iconInfo?: Maybe<IconInfo>
   name: Scalars['String']
   portalApplicationId: Scalars['String']
   tabEnum: ApplicationTabEnum
   tabId: Scalars['String']
}

export type UpdateApplicationTemplateParams = {
   applicationTemplateId: Scalars['String']
   backgroundImageUrl?: InputMaybe<Scalars['String']>
   baseImageUrl?: InputMaybe<Scalars['String']>
   pluralName: Scalars['String']
   singularName: Scalars['String']
}

export type UpdateApplicationTemplateResponse =
   | ApplicationTemplateNotFound
   | ApplicationTemplatePluralNameIsRequired
   | ApplicationTemplateSingularNameIsRequired
   | UpdateApplicationTemplateResult
   | UserIsNotAnAdministrator

export type UpdateApplicationTemplateResult = {
   __typename?: 'UpdateApplicationTemplateResult'
   applicationTemplateId: Scalars['String']
   backgroundImageUrl?: Maybe<Scalars['String']>
   baseImageUrl?: Maybe<Scalars['String']>
   pluralName: Scalars['String']
   singularName: Scalars['String']
}

export type UpdateAppliedFeeHeadLog = {
   __typename?: 'UpdateAppliedFeeHeadLog'
   previousState: AppliedFeeHeader
   updatedState: AppliedFeeHeader
}

export type UpdateArchitectProfileParams = {
   caRegNumberValidity?: InputMaybe<Scalars['String']>
   caRegistrationNumber?: InputMaybe<Scalars['String']>
   email: Scalars['String']
   firstName: Scalars['String']
   isCaRegisteredArchitect: Scalars['Boolean']
   isDisclaimerAccepted?: InputMaybe<Scalars['Boolean']>
   lastName?: InputMaybe<Scalars['String']>
   licenceNumber?: InputMaybe<Scalars['String']>
   licenceValidity?: InputMaybe<Scalars['String']>
   profilePic?: InputMaybe<ArchitectProfileAttachmentParams>
   signature?: InputMaybe<ArchitectProfileAttachmentParams>
}

export type UpdateArchitectProfileResponse =
   | Architect
   | CaRegistrationNumberExpired
   | CaRegistrationNumberIsRequired
   | CaRegistrationNumberValidityIsRequired
   | DeactivatedUser
   | LicenceExpired
   | LicenceIsRequired
   | LicenceValidityIsRequired
   | UserEmailAlreadyExistsInAnotherAccount

export type UpdateAssigneeGroupParams = {
   assigneeFieldIds: Array<Scalars['String']>
   assigneeGroupId: Scalars['String']
   name: Scalars['String']
}

export type UpdateAssigneeGroupResponse =
   | AssigneeFieldsAlreadyExistsInAnotherGroup
   | AssigneeFieldsGroupNameAlreadyExists
   | AssigneeGroup
   | AssigneeGroupNotFound
   | DuplicateAssigneeFieldsInGroup
   | FieldsAreDeleted
   | FieldsNotFound
   | NotPipelineItemAssigneeFieldIds
   | UserIsNotAnAdministrator

export type UpdateAssigneeNodeDynamicAssigneeConfig = {
   __typename?: 'UpdateAssigneeNodeDynamicAssigneeConfig'
   condition?: Maybe<DynamicAssigneeConditionConfig>
   fallbackUser?: Maybe<BaseUser>
}

export type UpdateAssigneeNodeDynamicAssigneeConfigParams = {
   condition?: InputMaybe<DynamicAssigneeConditionConfigParams>
   fallbackUserId?: InputMaybe<Scalars['String']>
}

export type UpdateAssigneeNodeManagerFieldParams = {
   level: Scalars['Int']
   managerFieldId: Scalars['String']
}

export type UpdateAssigneeNodeReferenceAssigneeConfig = {
   __typename?: 'UpdateAssigneeNodeReferenceAssigneeConfig'
   fallbackUser?: Maybe<BaseUser>
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type UpdateAssigneeNodeReferenceAssigneeConfigParams = {
   fallbackUserId?: InputMaybe<Scalars['String']>
   value: Scalars['String']
   valueFrom: FieldSourceType
}

export type UpdateAttendanceTrackingSettingsParams = {
   clearValues: Array<AttendanceTrackingSettingsEnum>
   defaultClockOutTime?: InputMaybe<Scalars['String']>
}

export type UpdateAttendanceTrackingSettingsResponse =
   | FeatureNotEnabled
   | UpdateAttendanceTrackingSettingsResult
   | UserIsNotAnAdministrator

export type UpdateAttendanceTrackingSettingsResult = {
   __typename?: 'UpdateAttendanceTrackingSettingsResult'
   clearValues: Array<AttendanceTrackingSettingsEnum>
   defaultClockOutTime?: Maybe<Scalars['String']>
}

export type UpdateAutomationWorkflowConditionParams = {
   conditionId: Scalars['String']
   fieldId: Scalars['String']
   fieldSource: FilterFieldSourceType
   filterSetEntity: AutomationWorkflowFilterSetEntityType
   multiValues?: InputMaybe<Array<AutomationWorkflowConditionValueParams>>
   operator: AutomationWorkflowOperator
   upRefAssigneeFieldId?: InputMaybe<Scalars['String']>
   value?: InputMaybe<AutomationWorkflowConditionValueParams>
}

export type UpdateAutomationWorkflowConditionResponse =
   | AutomationWorkflowCondition
   | ConditionFieldShouldBeUniqueFieldType
   | ConditionNotFound
   | FieldReferenceIsNotSupportedForGivenOperators
   | FieldSourceIsNotSupportedForOperator
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidConditionDirectValue
   | InvalidFilterFieldOptions
   | NotConditionNodeFilterSet
   | NotEditableNode
   | NotEditableTrigger
   | NotFilterSetEntityFilterSet
   | NotPipelineItemAssigneeFieldIds
   | NotScheduledTriggerFilterSet
   | NotSupportedFilterSetEntityForRelativeOperators
   | NotSupportedValueSourceForRelativeOperators
   | OperatorIsNotSupportedForField
   | OperatorIsNotSupportedForTrigger
   | OperatorIsNotSupportedForUpdatePipelineItemAssigneeFilterSet
   | PayloadIsNotSupportedInScheduledTrigger
   | StagesNotFound
   | UnSupportedFieldTypeForApplyAutomationWorkflowFiltersOn
   | UnSupportedFilterFieldSourceForApplyAutomationWorkflowFiltersOn
   | UnSupportedFilterValueFromForApplyAutomationWorkflowFiltersOn
   | UnSupportedOperatorForApplyAutomationWorkflowFiltersOn
   | UpRefAssigneeFieldIsRequired
   | UserIsNotAnAdministrator
   | UsersNotFound

export type UpdateAutomationWorkflowConditionsLogicalOperatorParams = {
   filterId: Scalars['String']
   filterSetEntity: AutomationWorkflowFilterSetEntityType
   logicalOperator: LogicalOperator
}

export type UpdateAutomationWorkflowConditionsLogicalOperatorResponse =
   | FilterNotFound
   | NotConditionNodeFilterSet
   | NotEditableNode
   | NotEditableTrigger
   | NotScheduledTriggerFilterSet
   | UpdateAutomationWorkflowConditionsLogicalOperatorResult
   | UserIsNotAnAdministrator

export type UpdateAutomationWorkflowConditionsLogicalOperatorResult = {
   __typename?: 'UpdateAutomationWorkflowConditionsLogicalOperatorResult'
   filterId: Scalars['String']
   filterSetEntity: AutomationWorkflowFilterSetEntityType
   logicalOperator: LogicalOperator
}

export type UpdateAutomationWorkflowExecLogsFilterParams = {
   automationWorkflowIds: Array<Scalars['String']>
   entityLevel?: InputMaybe<AwLogsEntityLevel>
   execLogsTab?: InputMaybe<AutomationWorkflowExecLogsTab>
   executedAtRange?: InputMaybe<
      AutomationWorkflowExecLogsExecutedAtRangeFilterParams
   >
   filterByPipelineIds?: InputMaybe<Array<Scalars['String']>>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineIds: Array<Scalars['String']>
   pipelineItemId?: InputMaybe<Scalars['String']>
   scheduledAwExecLogId?: InputMaybe<Scalars['String']>
   statuses?: InputMaybe<Array<WorkFlowExecLogFilterStatus>>
}

export type UpdateAutomationWorkflowExecLogsFilterResponse =
   | AutomationWorkflowExecLogsFilter
   | AutomationWorkflowsAccessDenied
   | AutomationWorkflowsAreNotInPipeline
   | AutomationWorkflowsAreNotInSync
   | AutomationWorkflowsNotFound
   | InvalidAutomationWorkflowExecutedAtRange
   | PipelineIsRequired
   | PipelineItemAccessDenied
   | PipelineItemNotFound
   | PipelineItemNotInPipeline
   | PipelineNotFound
   | PipelinesAccessDenied
   | PipelinesAreNotInSync
   | PipelinesNotFound
   | ScheduledAutomationWorkflowExecLogNotFound
   | ScheduledAwExecLogIdDoesNotLinkedToAutomationWorkflows
   | UserIsNotAnAdministrator

export type UpdateAutomationWorkflowExecLogsSortValueParams = {
   execLogsTab: AutomationWorkflowExecLogsTab
   sortValue: SortValue
}

export type UpdateAutomationWorkflowExecLogsSortValueResponse =
   | UpdateAutomationWorkflowExecLogsSortValueResult
   | UserIsNotAnAdministrator

export type UpdateAutomationWorkflowExecLogsSortValueResult = {
   __typename?: 'UpdateAutomationWorkflowExecLogsSortValueResult'
   execLogsTab: AutomationWorkflowExecLogsTab
   sortValue: SortValue
}

export type UpdateAutomationWorkflowExecTypeParams = {
   automationWorkflowId: Scalars['String']
   execType: AutomationWorkflowExecType
}

export type UpdateAutomationWorkflowExecTypeResponse =
   | AutomationWorkflowExecTypeNotSupportedInTrigger
   | AutomationWorkflowNotFound
   | ScheduledAutomationWorkflowNotSupported
   | UpdateAutomationWorkflowExecTypeResult
   | UpdateNotAllowedToExecType
   | UserIsNotAnAdministrator

export type UpdateAutomationWorkflowExecTypeResult = {
   __typename?: 'UpdateAutomationWorkflowExecTypeResult'
   automationWorkflowId: Scalars['String']
   execType: AutomationWorkflowExecType
}

export type UpdateAutomationWorkflowFiltersLogicalOperatorParams = {
   filterSetId: Scalars['String']
   filtersLogicalOperator: LogicalOperator
}

export type UpdateAutomationWorkflowFiltersLogicalOperatorResponse =
   | AutomationWorkflowFilterSetNotFound
   | NotEditableNode
   | UpdateAutomationWorkflowFiltersLogicalOperatorResult
   | UserIsNotAnAdministrator

export type UpdateAutomationWorkflowFiltersLogicalOperatorResult = {
   __typename?: 'UpdateAutomationWorkflowFiltersLogicalOperatorResult'
   filterSetId: Scalars['String']
   filtersLogicalOperator: LogicalOperator
}

export type UpdateAutomationWorkflowStatusParams = {
   automationWorkflowId: Scalars['String']
   status: AutomationWorkFlowStatus
}

export type UpdateAutomationWorkflowStatusResponse =
   | AutomationWorkflowNotFound
   | AutomationWorkflowPublishedVersionNotExists
   | PipelineAccessDenied
   | UpdateAutomationWorkflowStatusResult
   | UserIsNotAnAdministrator

export type UpdateAutomationWorkflowStatusResult = {
   __typename?: 'UpdateAutomationWorkflowStatusResult'
   automationWorkflowId: Scalars['String']
   status: AutomationWorkFlowStatus
}

export type UpdateAutomationWorkflowTriggerConfigParams = {
   automationWorkflowId: Scalars['String']
   pipelineItemUpdatedConfig?: InputMaybe<
      PipelineItemUpdatedTriggerConfigParams
   >
   stageUpdatedConfig?: InputMaybe<StageUpdatedTriggerConfigParams>
   taskUpdatedConfig?: InputMaybe<TaskUpdatedTriggerConfigParams>
}

export type UpdateAutomationWorkflowTriggerConfigResponse =
   | AutomationWorkflowNotFound
   | FieldsAreDeleted
   | FieldsAreNotSupportedInPipelineItemUpdatedTrigger
   | FieldsNotFound
   | PipelineItemUpdatedTriggerConfigIsRequired
   | StageUpdatedTriggerConfigIsRequired
   | StagesNotFound
   | TaskUpdatedTriggerConfigIsRequired
   | UpdateAutomationWorkflowTriggerConfigResult
   | UserIsNotAnAdministrator

export type UpdateAutomationWorkflowTriggerConfigResult = {
   __typename?: 'UpdateAutomationWorkflowTriggerConfigResult'
   automationWorkflowId: Scalars['String']
   pipelineItemUpdatedConfig?: Maybe<PipelineItemUpdatedTriggerConfig>
   stageUpdatedConfig?: Maybe<StageUpdatedTriggerConfig>
   taskUpdatedConfig?: Maybe<TaskUpdatedTriggerConfig>
}

export type UpdateBarGraphParams = {
   dataLabelsType: GraphDataLabelsType
   description?: InputMaybe<Scalars['String']>
   graphId: Scalars['String']
   layout: BarGraphLayout
   name: Scalars['String']
   numberOfBars: Scalars['Int']
}

export type UpdateBarGraphResponse =
   | GraphNameIsRequired
   | GraphNotFound
   | NotBarGraph
   | PipelineAccessDenied
   | UpdateBarGraphResult
   | UserIsNotAnAdministrator

export type UpdateBarGraphResult = {
   __typename?: 'UpdateBarGraphResult'
   dataLabelsType: GraphDataLabelsType
   description?: Maybe<Scalars['String']>
   graphId: Scalars['String']
   layout: BarGraphLayout
   name: Scalars['String']
   numberOfBars: Scalars['Int']
}

export type UpdateBoardDescriptionParams = {
   boardId: Scalars['String']
   description?: InputMaybe<Scalars['String']>
}

export type UpdateBoardDescriptionResponse =
   | BoardEditAccessDenied
   | BoardNotFound
   | UpdateBoardDescriptionResult
   | YouAreNotAllowedToEditSystemBoards

export type UpdateBoardDescriptionResult = {
   __typename?: 'UpdateBoardDescriptionResult'
   boardId: Scalars['String']
   description?: Maybe<Scalars['String']>
}

export type UpdateBoardDisplayNameParams = {
   boardId: Scalars['String']
   displayName: Scalars['String']
}

export type UpdateBoardDisplayNameResponse =
   | BoardEditAccessDenied
   | BoardNotFound
   | UpdateBoardDisplayNameResult
   | YouAreNotAllowedToEditSystemBoards

export type UpdateBoardDisplayNameResult = {
   __typename?: 'UpdateBoardDisplayNameResult'
   boardId: Scalars['String']
   displayName: Scalars['String']
}

export type UpdateBpsTaskFieldObservationBulkParams = {
   fieldObservations: Array<BpsTaskFieldObservationParams>
   taskId: Scalars['String']
}

export type UpdateBpsTaskFieldObservationBulkResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | TaskAccessDenied
   | TaskNotFound
   | TaskTemplateAccessDenied
   | TaskVerificationNotExists
   | UpdateBpsTaskFieldObservationBulkResult

export type UpdateBpsTaskFieldObservationBulkResult = {
   __typename?: 'UpdateBpsTaskFieldObservationBulkResult'
   fieldObservations: Array<BpsTaskFieldObservation>
   taskId: Scalars['String']
}

export type UpdateBpsTaskFieldObservationParams = {
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   recommendation?: InputMaybe<BpsVerificationRecommendationEnum>
   remarks?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: TaskVerificationFieldProperty
}

export type UpdateBpsTaskFieldObservationResponse =
   | FieldIsDeleted
   | FieldNotFound
   | TaskAccessDenied
   | TaskNotFound
   | TaskTemplateAccessDenied
   | TaskVerificationNotExists
   | UpdateBpsTaskFieldObservationResult

export type UpdateBpsTaskFieldObservationResult = {
   __typename?: 'UpdateBpsTaskFieldObservationResult'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   recommendation?: Maybe<BpsVerificationRecommendationEnum>
   remarks?: Maybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: TaskVerificationFieldProperty
}

export type UpdateBpsVerificationTabTaskParams = {
   overallRecommendation?: InputMaybe<BpsVerificationRecommendationEnum>
   overallRemarks?: InputMaybe<Scalars['String']>
   tabId: Scalars['String']
   taskId: Scalars['String']
   updateProperty: BpsVerificationTaskFieldProperty
}

export type UpdateBpsVerificationTabTaskResponse =
   | CanNotUpdateCompletedTask
   | LayoutTabNotFound
   | NotVerificationTab
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | UpdateBpsVerificationTabTaskResult

export type UpdateBpsVerificationTabTaskResult = {
   __typename?: 'UpdateBpsVerificationTabTaskResult'
   overallRecommendation?: Maybe<BpsVerificationRecommendationEnum>
   overallRemarks?: Maybe<Scalars['String']>
   tabId: Scalars['String']
   taskId: Scalars['String']
   updateProperty: BpsVerificationTaskFieldProperty
}

export type UpdateBpsVerificationTaskParams = {
   overallRecommendation?: InputMaybe<BpsVerificationRecommendationEnum>
   overallRemarks?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: BpsVerificationTaskFieldProperty
}

export type UpdateBpsVerificationTaskResponse =
   | CalculatedTdrAreaIsLessThanScrutinyTdrArea
   | CanNotUpdateCompletedTask
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | UpdateBpsVerificationTaskResult

export type UpdateBpsVerificationTaskResult = {
   __typename?: 'UpdateBpsVerificationTaskResult'
   overallRecommendation?: Maybe<BpsVerificationRecommendationEnum>
   overallRemarks?: Maybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: BpsVerificationTaskFieldProperty
}

export type UpdateCalendarPipelineItemScheduleParams = {
   durationInMins: Scalars['Int']
   guestEmailFieldIds: Array<Scalars['String']>
   guestEmailIds: Array<Scalars['String']>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemScheduledId: Scalars['String']
   remindersInMins: Array<Scalars['Int']>
   scheduledDatetime: Scalars['String']
   title: Scalars['String']
}

export type UpdateCalendarPipelineItemScheduleResponse =
   | CalendarEventDoesNotExistForSchedule
   | CalendarEventDurationCannotBeNegative
   | CalendarPipelineItemSchedule
   | EmailFieldsHasEmptyResponse
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | GoogleAuthConsentNotGiven
   | GoogleAuthConsentRefreshRequired
   | GoogleCalendarApiRequestsQuotaExceeded
   | InvalidGuestEmailIds
   | NotEmailFields
   | NotPermittedFields
   | PipelineItemScheduleAccessDenied
   | PipelineItemScheduleIsAlreadyCompleted
   | PipelineItemScheduleNotFound
   | RemindBeforeInMinsCannotBeNegative
   | RemindersInMinsCannotBeNegative
   | RemindersLimitExceeded
   | ScheduledDatetimeMustBeInFuture
   | ScheduledReminderMustBeInFuture
   | ScheduledRemindersMustBeInFuture

export type UpdateCanGenerateCustomIdConfigParams = {
   canGenerateCustomId: Scalars['Boolean']
}

export type UpdateCanGenerateCustomIdConfigResponse =
   | UpdateCanGenerateCustomIdConfigResult
   | UserIsNotAnAdministrator

export type UpdateCanGenerateCustomIdConfigResult = {
   __typename?: 'UpdateCanGenerateCustomIdConfigResult'
   canGenerateCustomId: Scalars['Boolean']
}

export type UpdateCardMobileOverviewFieldsParams = {
   fieldIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type UpdateCardMobileOverviewFieldsResponse =
   | AddAnotherFieldsAreNotSupported
   | FieldsAreDeleted
   | FieldsNotFound
   | NotAllowedStageOverviewFields
   | PipelineAccessDenied
   | StageIsDeleted
   | StageNotFound
   | UpdateCardMobileOverviewFieldsResult
   | UserIsNotAnAdministrator

export type UpdateCardMobileOverviewFieldsResult = {
   __typename?: 'UpdateCardMobileOverviewFieldsResult'
   fieldIds: Array<Scalars['String']>
   stageId: Scalars['String']
}

export type UpdateCheckboxGroupFieldDefaultValuesParams = {
   defaultValues: Array<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateCheckboxGroupFieldDefaultValuesResponse =
   | CannotEditSystemField
   | DefaultValuesMustBeInGivenOptions
   | FieldIsDeleted
   | FieldNotFound
   | NotCheckboxGroupField
   | UpdateCheckboxGroupFieldDefaultValuesResult
   | UserIsNotAnAdministrator

export type UpdateCheckboxGroupFieldDefaultValuesResult = {
   __typename?: 'UpdateCheckboxGroupFieldDefaultValuesResult'
   defaultValues: Array<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateCheckpointParams = {
   checkpointId: Scalars['String']
   text: Scalars['String']
}

export type UpdateConditionNodeFiltersLogicalOperatorParams = {
   filtersLogicalOperator: LogicalOperator
   nodeId: Scalars['String']
}

export type UpdateConditionNodeFiltersLogicalOperatorResponse =
   | NodeNotFound
   | NotConditionNode
   | NotConditionNodeFilterSet
   | NotEditableNode
   | UpdateConditionNodeFiltersLogicalOperatorResult
   | UserIsNotAnAdministrator

export type UpdateConditionNodeFiltersLogicalOperatorResult = {
   __typename?: 'UpdateConditionNodeFiltersLogicalOperatorResult'
   filtersLogicalOperator: LogicalOperator
   nodeId: Scalars['String']
}

export type UpdateConditionParams = {
   conditionId: Scalars['String']
   dataSource?: InputMaybe<AnalyticsDataSourceType>
   fieldId: Scalars['String']
   filterSetEntity: FilterSetEntityType
   operator: FilterOperator
   /** @deprecated No need of templateId here */
   templateId?: InputMaybe<Scalars['String']>
   value?: InputMaybe<Scalars['String']>
}

export type UpdateConditionResponse =
   | ActivityTemplatesNotFound
   | Condition
   | ConditionNotFound
   | DataSourceIsRequiredForFilterSetEntity
   | DataSourceNotInFilterSetEntityDataSources
   | FieldIsDeleted
   | FieldNotFound
   | FilterSetAccessDenied
   | FilterSetNotLinkedToBoard
   | FilterSetNotLinkedToBoardList
   | FilterSetNotLinkedToGivenEntity
   | FilterSetNotLinkedToGraph
   | FilterSetNotLinkedToView
   | FiltersNotSupportedForExternalDashboard
   | GraphMetricNotFound
   | InvalidFilterFieldOptions
   | InvalidFilterFieldValue
   | MetricNotLinkedToGraph
   | NotAllowedFilterField
   | NotAllowedToEditBoardFilterSet
   | NotAllowedToEditBoardListFilterSet
   | NotEditableFilterSetEntity
   | NotPermittedField
   | NotSalesTemplateFieldId
   | NotSupportedCallAnalyticsFilterFieldOperator
   | NotSupportedContactFilterFieldOperator
   | NotSupportedDynamicFilterFieldOperator
   | NotSupportedFieldTypeOperator
   | NotSupportedFilterFieldOperator
   | NotSupportedFilterSetEntityForCallAnalyticsFilterField
   | NotSupportedSystemFieldOperator
   | NotUserFilterSet
   | PhoneNumberValueFormatIsNotValid
   | PipelinesAccessDenied
   | PipelinesNotFound
   | StagesNotFound
   | TaskTemplatesNotFound
   | UserIsNotAnAdministrator
   | UsersNotFound

export type UpdateConditionsLogicalOperatorParams = {
   conditionsLogicalOperator: LogicalOperator
   filterId: Scalars['String']
   filterSetEntity: FilterSetEntityType
}

export type UpdateConditionsLogicalOperatorResponse =
   | FilterNotFound
   | FilterSetAccessDenied
   | FilterSetNotLinkedToBoard
   | FilterSetNotLinkedToBoardList
   | FilterSetNotLinkedToGivenEntity
   | FilterSetNotLinkedToGraph
   | FilterSetNotLinkedToView
   | FiltersNotSupportedForExternalDashboard
   | NotAllowedToEditBoardFilterSet
   | NotAllowedToEditBoardListFilterSet
   | NotEditableFilterSetEntity
   | NotUserFilterSet
   | UpdateConditionsLogicalOperatorResult
   | UserIsNotAnAdministrator

export type UpdateConditionsLogicalOperatorResult = {
   __typename?: 'UpdateConditionsLogicalOperatorResult'
   conditionsLogicalOperator: LogicalOperator
   filterId: Scalars['String']
}

export type UpdateContactFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   contactId: Scalars['String']
   fieldId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type UpdateContactFieldResponse =
   | AccountAccessDeniedToAssignee
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | ContactAccessDenied
   | ContactAssigneeIsDeactivated
   | ContactAssigneeNotFound
   | ContactIsDeleted
   | ContactNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotContactField
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UniqueFieldResponseAlreadyExists
   | UpdateFieldResponseResult
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateContactsBoardConfigParams = {
   isContactsBoardsEnabled: Scalars['Boolean']
}

export type UpdateContactsBoardConfigResponse =
   | UpdateContactsBoardConfigResult
   | UserIsNotAnAdministrator

export type UpdateContactsBoardConfigResult = {
   __typename?: 'UpdateContactsBoardConfigResult'
   isContactsBoardsEnabled: Scalars['Boolean']
}

export type UpdateContactsFeatureEnableStatusParams = {
   isContactsFeatureEnabled: Scalars['Boolean']
}

export type UpdateContactsFeatureEnableStatusResponse =
   | UpdateContactsFeatureEnableStatusResult
   | UserIsNotAnAdministrator

export type UpdateContactsFeatureEnableStatusResult = {
   __typename?: 'UpdateContactsFeatureEnableStatusResult'
   isContactsFeatureEnabled: Scalars['Boolean']
}

export type UpdateCustomDocumentTemplateParams = {
   blocks: Array<DocumentTemplateBlockParams>
   documentTemplateId: Scalars['String']
}

export type UpdateCustomDocumentTemplateResponse =
   | AdminDocumentTemplate
   | DocumentTemplateNotFound
   | UserIsNotAnAdministrator

export type UpdateCustomObjectTemplateParams = {
   customObjectTemplateId: Scalars['String']
   pluralName: Scalars['String']
   singularName: Scalars['String']
}

export type UpdateCustomObjectTemplateResponse =
   | CustomObjectTemplateNotFound
   | CustomObjectTemplatePluralNameIsRequired
   | CustomObjectTemplateSingularNameIsRequired
   | UpdateCustomObjectTemplateResult
   | UserIsNotAnAdministrator

export type UpdateCustomObjectTemplateResult = {
   __typename?: 'UpdateCustomObjectTemplateResult'
   customObjectTemplateId: Scalars['String']
   pluralName: Scalars['String']
   singularName: Scalars['String']
}

export type UpdateDashboardParams = {
   dashboardId: Scalars['String']
   externalDashboardUrl?: InputMaybe<Scalars['String']>
   name: Scalars['String']
}

export type UpdateDashboardResponse =
   | Dashboard
   | DashboardAccessDenied
   | DashboardNotFound
   | InvalidExternalDashboardUrl
   | ProvideValidLookerStudioUrl
   | UserIsNotAnAdministrator

export type UpdateDateFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateDateFieldDefaultValueResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotDateField
   | OnlySingleTypeOfDefaultValueIsAllowed
   | UpdateDateFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateDateFieldDefaultValueResult = {
   __typename?: 'UpdateDateFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateDateFieldRelativeDefaultValueConfigParams = {
   fieldId: Scalars['String']
   relativeDefaultValueConfig?: InputMaybe<DateRelativeDefaultValueConfigParams>
}

export type UpdateDateFieldRelativeDefaultValueConfigResponse =
   | CannotEditSystemField
   | DaysShouldBePositive
   | FieldIsDeleted
   | FieldNotFound
   | NotDateField
   | OnlySingleTypeOfDefaultValueIsAllowed
   | UpdateDateFieldRelativeDefaultValueConfigResult
   | UserIsNotAnAdministrator

export type UpdateDateFieldRelativeDefaultValueConfigResult = {
   __typename?: 'UpdateDateFieldRelativeDefaultValueConfigResult'
   fieldId: Scalars['String']
   relativeDefaultValueConfig?: Maybe<DateRelativeDefaultValueConfig>
}

export type UpdateDateTimeFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateDateTimeFieldDefaultValueResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotDateTimeField
   | OnlySingleTypeOfDefaultValueIsAllowed
   | UpdateDateTimeFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateDateTimeFieldDefaultValueResult = {
   __typename?: 'UpdateDateTimeFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateDateTimeFieldRelativeDefaultValueConfigParams = {
   fieldId: Scalars['String']
   relativeDefaultValueConfig?: InputMaybe<
      DateTimeRelativeDefaultValueConfigParams
   >
}

export type UpdateDateTimeFieldRelativeDefaultValueConfigResponse =
   | CannotEditSystemField
   | DaysShouldBePositive
   | FieldIsDeleted
   | FieldNotFound
   | NotDateTimeField
   | OnlySingleTypeOfDefaultValueIsAllowed
   | SecondsShouldBePositive
   | UpdateDateTimeFieldRelativeDefaultValueConfigResult
   | UserIsNotAnAdministrator

export type UpdateDateTimeFieldRelativeDefaultValueConfigResult = {
   __typename?: 'UpdateDateTimeFieldRelativeDefaultValueConfigResult'
   fieldId: Scalars['String']
   relativeDefaultValueConfig?: Maybe<DateTimeRelativeDefaultValueConfig>
}

export type UpdateDealAddAnotherFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   dealId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type UpdateDealAddAnotherFieldResponse =
   | DealAccessDenied
   | DealIsDeleted
   | DealNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GoFResponseIdNotFound
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAddAnotherGoFField
   | NotAllowedFileFormats
   | NotDealAddAnotherGoFResponse
   | NotDealField
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UpdateFieldResponseResult

export type UpdateDealAssigneeBulkParams = {
   dealIds: Array<Scalars['String']>
   fieldId: Scalars['String']
   response: Scalars['String']
   sendNotification?: InputMaybe<Scalars['Boolean']>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdateDealAssigneeBulkResponse =
   | AccountAccessDeniedToAssignee
   | DealAssigneeIsDeactivated
   | DealAssigneeNotFound
   | DealsAccessDenied
   | DealsAreDeleted
   | DealsNotFound
   | FieldIsDeleted
   | FieldNotFound
   | NeedFieldWritePermission
   | NotDealAssigneeField
   | PipelineAccessDeniedToAssignee
   | UpdateDealAssigneeBulkResult
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateDealAssigneeBulkResult = {
   __typename?: 'UpdateDealAssigneeBulkResult'
   dealFields: Array<DealFieldResponse>
}

export type UpdateDealFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   dealId: Scalars['String']
   fieldId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdateDealFieldResponse =
   | AccountAccessDeniedToAssignee
   | AddAnotherFieldsAreNotSupported
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | ContactAssigneeNotFound
   | DealAccessDenied
   | DealAssigneeNotFound
   | DealIsDeleted
   | DealNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotDealField
   | ParentFieldNotFilled
   | PipelineAccessDeniedToAssignee
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | UniqueFieldResponseAlreadyExists
   | UpdateFieldResponseResult
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateDisplayStageNode = BaseNode & {
   __typename?: 'UpdateDisplayStageNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   stage?: Maybe<Stage>
   stageFieldResponses: Array<StageFieldResponse>
}

export type UpdateDisplayStageNodeExecLog = BaseNodeExecLog & {
   __typename?: 'UpdateDisplayStageNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<UpdateDisplayStageNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type UpdateDisplayStageNodeExecLogResult = {
   __typename?: 'UpdateDisplayStageNodeExecLogResult'
   fromStage?: Maybe<Stage>
   toStage?: Maybe<Stage>
   updatedStages: Array<PipelineItemDisplayStageUpdateResult>
}

export type UpdateDisplayStageTransitionConfigParams = {
   shouldPayPendingOrders: Scalars['Boolean']
   stageTransitionId: Scalars['String']
   stageTransitionType?: InputMaybe<StageTransitionType>
   tdrSaleAndTransferRequestConfig?: InputMaybe<
      TdrSaleAndTransferRequestConfigParams
   >
}

export type UpdateDisplayStageTransitionConfigResponse =
   | StageTransitionNotFound
   | UpdateDisplayStageTransitionConfigResult
   | UserIsNotAnAdministrator

export type UpdateDisplayStageTransitionConfigResult = {
   __typename?: 'UpdateDisplayStageTransitionConfigResult'
   shouldPayPendingOrders: Scalars['Boolean']
   stageTransitionId: Scalars['String']
   stageTransitionType?: Maybe<StageTransitionType>
   tdrSaleAndTransferRequestConfig?: Maybe<TdrSaleAndTransferRequestConfig>
}

export type UpdateDocumentTemplateDescriptionParams = {
   description?: InputMaybe<Scalars['String']>
   documentTemplateId: Scalars['String']
}

export type UpdateDocumentTemplateDescriptionResponse =
   | AdminDocumentTemplate
   | DocumentTemplateNotFound
   | UserIsNotAnAdministrator

export type UpdateDocumentTemplateNameParams = {
   documentTemplateId: Scalars['String']
   name: Scalars['String']
}

export type UpdateDocumentTemplateNameResponse =
   | AdminDocumentTemplate
   | DocumentTemplateNameAlreadyExists
   | DocumentTemplateNotFound
   | UserIsNotAnAdministrator

export type UpdateDocumentTemplateVersionConfigParams = {
   documentTemplateVersionId: Scalars['String']
   formFields: Array<DocumentTemplateFormFieldParams>
   qrCodeConfig?: InputMaybe<DocumentTemplateQrCodeConfigParams>
   signatureFieldIdentifications?: InputMaybe<
      Array<InputMaybe<DocumentTemplateSignatureFieldIdentificationsParams>>
   >
}

export type UpdateDocumentTemplateVersionConfigResponse =
   | AdminDocumentTemplate
   | DocumentTemplatePagesNotFound
   | DocumentTemplateVersionNotFound
   | DuplicateFormFieldsMapping
   | EmptyMappingValueForFormFieldsMapping
   | FieldsAreDeleted
   | FieldsAreNotSupportedInDocumentTemplateMapping
   | FieldsNotFound
   | FormFieldsNotFound
   | IdentificationsNotFound
   | IdentificationsNotSupportedForFormFields
   | NotPipelineIdentifications
   | UserIsNotAnAdministrator

export type UpdateDonutChartParams = {
   dataLabelsType: GraphDataLabelsType
   description?: InputMaybe<Scalars['String']>
   graphId: Scalars['String']
   name: Scalars['String']
   numberOfSlices: Scalars['Int']
}

export type UpdateDonutChartResponse =
   | GraphNameIsRequired
   | GraphNotFound
   | NotDonutChart
   | PipelineAccessDenied
   | UpdateDonutChartResult
   | UserIsNotAnAdministrator

export type UpdateDonutChartResult = {
   __typename?: 'UpdateDonutChartResult'
   dataLabelsType: GraphDataLabelsType
   description?: Maybe<Scalars['String']>
   graphId: Scalars['String']
   name: Scalars['String']
   numberOfSlices: Scalars['Int']
}

export type UpdateDropdownAllowOtherOptionsParams = {
   allowOtherOptions: Scalars['Boolean']
   fieldId: Scalars['String']
}

export type UpdateDropdownAllowOtherOptionsResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotDropdownField
   | UpdateDropdownAllowOtherOptionsResult
   | UserIsNotAnAdministrator

export type UpdateDropdownAllowOtherOptionsResult = {
   __typename?: 'UpdateDropdownAllowOtherOptionsResult'
   allowOtherOptions: Scalars['Boolean']
   fieldId: Scalars['String']
}

export type UpdateDropdownFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateDropdownFieldDefaultValueResponse =
   | CannotEditSystemField
   | DefaultValueMustBeInGivenOptions
   | FieldIsDeleted
   | FieldNotFound
   | NotDropdownField
   | UpdateDropdownFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateDropdownFieldDefaultValueResult = {
   __typename?: 'UpdateDropdownFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateDropdownFieldUiStyleParams = {
   fieldId: Scalars['String']
   uiStyle: DropdownFieldUiStyleEnum
}

export type UpdateDropdownFieldUiStyleResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotDropdownField
   | UpdateDropdownFieldUiStyleResult
   | UserIsNotAnAdministrator

export type UpdateDropdownFieldUiStyleResult = {
   __typename?: 'UpdateDropdownFieldUIStyleResult'
   fieldId: Scalars['String']
   uiStyle: DropdownFieldUiStyleEnum
}

export type UpdateDropdownLabelsStatusParams = {
   fieldId: Scalars['String']
   isLabelsEnabled: Scalars['Boolean']
}

export type UpdateDropdownLabelsStatusResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotDropdownField
   | UpdateDropdownLabelsStatusResult
   | UserIsNotAnAdministrator

export type UpdateDropdownLabelsStatusResult = {
   __typename?: 'UpdateDropdownLabelsStatusResult'
   fieldId: Scalars['String']
   isLabelsEnabled: Scalars['Boolean']
}

export type UpdateDropdownOptionsColorParams = {
   fieldId: Scalars['String']
   optionColors: Array<OptionColorParams>
}

export type UpdateDropdownOptionsColorResponse =
   | FieldIsDeleted
   | FieldLabelsConfigNotEnabled
   | FieldNotFound
   | InvalidDropdownOptions
   | NotDropdownField
   | UpdateDropdownOptionsColorResult
   | UserIsNotAnAdministrator

export type UpdateDropdownOptionsColorResult = {
   __typename?: 'UpdateDropdownOptionsColorResult'
   fieldId: Scalars['String']
   optionColors: Array<OptionColorConfig>
}

export type UpdateEmailFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateEmailFieldDefaultValueResponse =
   | CannotEditSystemField
   | DefaultValueNotAllowedForUniqueField
   | FieldIsDeleted
   | FieldNotFound
   | InvalidDefaultValue
   | NotEmailField
   | RegexValidationFailedForDefaultValue
   | UpdateEmailFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateEmailFieldDefaultValueResult = {
   __typename?: 'UpdateEmailFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateEmailFieldValidationRegexParams = {
   fieldId: Scalars['String']
   regexErrorMessage?: InputMaybe<Scalars['String']>
   validationRegex?: InputMaybe<Scalars['String']>
}

export type UpdateEmailFieldValidationRegexResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | InvalidValidationRegex
   | LinkedFieldUpdateRestricted
   | NotEmailField
   | RegexValidationFailedForDefaultValue
   | RegexValidationFailedForLinkedFieldsDefaultValue
   | UpdateEmailFieldValidationRegexResult
   | UserIsNotAnAdministrator

export type UpdateEmailFieldValidationRegexResult = {
   __typename?: 'UpdateEmailFieldValidationRegexResult'
   fieldId: Scalars['String']
   regexErrorMessage?: Maybe<Scalars['String']>
   validationRegex?: Maybe<Scalars['String']>
}

export type UpdateEntityCheckpointBulkParams = {
   editedCheckpoints: Array<UpdateCheckpointParams>
   entityId: Scalars['String']
   entityType: CategoryEntityType
   orderedCheckpointIds: Array<Scalars['String']>
   uncheckedCheckpointIds: Array<Scalars['String']>
}

export type UpdateEntityCheckpointBulkResponse =
   | CategoryCheckpointsNotFound
   | CategoryEntityAccessDenied
   | CategoryEntityNotFound
   | CheckpointsNotLinkedToEntity
   | UpdateEntityCheckpointBulkResult

export type UpdateEntityCheckpointBulkResult = {
   __typename?: 'UpdateEntityCheckpointBulkResult'
   editedCheckpoints: Array<EntityCategoryCheckpoint>
   entityId: Scalars['String']
   entityType: CategoryEntityType
   orderedCheckpointIds: Array<Scalars['String']>
   uncheckedCheckpointIds: Array<Scalars['String']>
}

export type UpdateEntityCheckpointParams = {
   checkpointId: Scalars['String']
   entityId: Scalars['String']
   entityType: CategoryEntityType
   text: Scalars['String']
}

export type UpdateEntityCheckpointResponse =
   | CategoryCheckpointNotFound
   | CategoryEntityAccessDenied
   | CategoryEntityNotFound
   | UpdateEntityCheckpointResult

export type UpdateEntityCheckpointResult = {
   __typename?: 'UpdateEntityCheckpointResult'
   checkpointId: Scalars['String']
   entityId: Scalars['String']
   entityType: CategoryEntityType
   text: Scalars['String']
}

export type UpdateEntityCheckpointsStatusParams = {
   checkedCheckpointIds: Array<Scalars['String']>
   entityId: Scalars['String']
   entityType: CategoryEntityType
   uncheckedCheckpointIds: Array<Scalars['String']>
}

export type UpdateEntityCheckpointsStatusResponse =
   | CategoryCheckpointsNotFound
   | CategoryEntityAccessDenied
   | CategoryEntityNotFound
   | UpdateEntityCheckpointsStatusResult

export type UpdateEntityCheckpointsStatusResult = {
   __typename?: 'UpdateEntityCheckpointsStatusResult'
   checkedCheckpoints: Array<EntityCategoryCheckpoint>
   entityId: Scalars['String']
   entityType: CategoryEntityType
   uncheckedCheckpointIds: Array<Scalars['String']>
}

export type UpdateEntityJsonConfigurationParams = {
   entityId?: InputMaybe<Scalars['String']>
   entityType: JsonConfigurationEntityType
   jsonData: Scalars['String']
   name: Scalars['String']
}

export type UpdateEntityJsonConfigurationResponse =
   | InvalidJsonConfigurationData
   | UpdateEntityJsonConfigurationResult

export type UpdateEntityJsonConfigurationResult = {
   __typename?: 'UpdateEntityJsonConfigurationResult'
   jsonConfiguration: JsonConfiguration
}

export type UpdateEventBasedLeadDistributionRuleSettingsParams = {
   leadDistributionRuleId: Scalars['String']
   overrideGlobalQuota: Scalars['Boolean']
}

export type UpdateEventBasedLeadDistributionRuleSettingsResponse =
   | EventBasedLeadDistributionRuleSettings
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | NotEventBasedLeadDistributionRule
   | UserIsNotAnAdministrator

export type UpdateEventBasedLeadDistributionRuleStatusParams = {
   leadDistributionRuleId: Scalars['String']
   status: EventBasedLeadDistributionRuleStatus
}

export type UpdateEventBasedLeadDistributionRuleStatusResponse =
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | NotEventBasedLeadDistributionRule
   | PartiallyConfiguredLeadDistributionStepsExists
   | UpdateEventBasedLeadDistributionRuleStatusResult
   | UserIsNotAnAdministrator

export type UpdateEventBasedLeadDistributionRuleStatusResult = {
   __typename?: 'UpdateEventBasedLeadDistributionRuleStatusResult'
   leadDistributionRuleId: Scalars['String']
   status: EventBasedLeadDistributionRuleStatus
}

export type UpdateEventTriggerConditionParams = {
   conditionId: Scalars['String']
   fieldId: Scalars['String']
   fieldSource: EventTriggerFilterFieldSourceType
   filterSetEntity: EventTriggerFilterSetEntity
   multiValues?: InputMaybe<Array<EventTriggerConditionValueParams>>
   operator: EventTriggerOperator
   value?: InputMaybe<EventTriggerConditionValueParams>
}

export type UpdateEventTriggerConditionResponse =
   | EventTriggerCondition
   | EventTriggerConditionNotFound
   | EventTriggerFilterFieldSourceIsNotSupportedForOperator
   | EventTriggerFilterSetNotLinkedToGivenEntity
   | EventTriggerOperatorIsNotSupportedForField
   | EventTriggerOperatorIsNotSupportedForTrigger
   | FieldReferenceIsNotSupportedForGivenEventTriggerOperators
   | FieldsAreDeleted
   | FieldsAreNotSupportedInEventTrigger
   | FieldsNotFound
   | InvalidEventTriggerConditionDirectValue
   | InvalidEventTriggerFilterFieldOptions
   | NotEditableEventTriggerFilterSetEntity
   | NotSupportedValueFieldSourceForEventTriggerRelativeOperators
   | StagesNotFound
   | UserIsNotAnAdministrator
   | UsersNotFound

export type UpdateEventTriggerConditionsLogicalOperatorParams = {
   filterId: Scalars['String']
   filterSetEntity: EventTriggerFilterSetEntity
   logicalOperator: LogicalOperator
}

export type UpdateEventTriggerConditionsLogicalOperatorResponse =
   | EventTriggerFilterNotFound
   | EventTriggerFilterSetNotLinkedToGivenEntity
   | NotEditableEventTriggerFilterSetEntity
   | UpdateEventTriggerConditionsLogicalOperatorResult
   | UserIsNotAnAdministrator

export type UpdateEventTriggerConditionsLogicalOperatorResult = {
   __typename?: 'UpdateEventTriggerConditionsLogicalOperatorResult'
   filterId: Scalars['String']
   filterSetEntity: EventTriggerFilterSetEntity
   logicalOperator: LogicalOperator
}

export type UpdateEventTriggerFiltersLogicalOperatorParams = {
   filterSetEntity: EventTriggerFilterSetEntity
   filterSetId: Scalars['String']
   filtersLogicalOperator: LogicalOperator
}

export type UpdateEventTriggerFiltersLogicalOperatorResponse =
   | EventTriggerFilterSetNotFound
   | EventTriggerFilterSetNotLinkedToGivenEntity
   | NotEditableEventTriggerFilterSetEntity
   | UpdateEventTriggerFiltersLogicalOperatorResult
   | UserIsNotAnAdministrator

export type UpdateEventTriggerFiltersLogicalOperatorResult = {
   __typename?: 'UpdateEventTriggerFiltersLogicalOperatorResult'
   filterSetEntity: EventTriggerFilterSetEntity
   filterSetId: Scalars['String']
   filtersLogicalOperator: LogicalOperator
}

export type UpdateFeeHeadLog = {
   __typename?: 'UpdateFeeHeadLog'
   actionDoneBy?: Maybe<BaseUser>
   cascadeCreatedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeRemovedAppliedFeeHeads: Array<AppliedFeeHeader>
   cascadeUpdatedAppliedFeeHeads: Array<UpdateAppliedFeeHeadLog>
   eventDatetime: Scalars['String']
   logId: Scalars['String']
   previousStateAppliedFeeHead?: Maybe<AppliedFeeHeader>
   updatedAppliedFeeHead: AppliedFeeHeader
}

export type UpdateFeeHeaderAmountGivenByEditorParams = {
   amountGivenByEditor?: InputMaybe<Scalars['Float']>
   appliedFeeHeaderId: Scalars['String']
   remarks: Scalars['String']
}

export type UpdateFeeHeaderAmountGivenByEditorResponse =
   | AmountGivenByEditorCannotBeNegative
   | AppliedFeeHeaderNotFound
   | CannotEditDeletedAppliedFeeHeader
   | EntityFeeRuleSetAccessDenied
   | RemarksRequiredForAppliedFeeHeader
   | UpdateFeeHeaderAmountGivenByEditorResult

export type UpdateFeeHeaderAmountGivenByEditorResult = {
   __typename?: 'UpdateFeeHeaderAmountGivenByEditorResult'
   appliedFeeHeader: AppliedFeeHeader
   changedFeeAppliedHeaders: Array<AppliedFeeHeader>
   totalAdjustedAmount: Scalars['Float']
   totalCalculatedAmount: Scalars['Float']
   totalNetAmount: Scalars['Float']
}

export type UpdateFeeHeaderRemarksParams = {
   appliedFeeHeaderId: Scalars['String']
   remarks?: InputMaybe<Scalars['String']>
}

export type UpdateFeeHeaderRemarksResponse =
   | AppliedFeeHeaderNotFound
   | CannotEditDeletedAppliedFeeHeader
   | EntityFeeRuleSetAccessDenied
   | RemarksRequiredForAppliedFeeHeader
   | UpdateFeeHeaderRemarksResult

export type UpdateFeeHeaderRemarksResult = {
   __typename?: 'UpdateFeeHeaderRemarksResult'
   appliedFeeHeader: AppliedFeeHeader
   appliedFeeHeaderId: Scalars['String']
   modifiedBy: BaseUser
   remarks?: Maybe<Scalars['String']>
}

export type UpdateFieldDescriptionParams = {
   description?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateFieldDescriptionResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | UpdateFieldDescriptionResult
   | UserIsNotAnAdministrator

export type UpdateFieldDescriptionResult = {
   __typename?: 'UpdateFieldDescriptionResult'
   description?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateFieldDynamicLabelParams = {
   dynamicLabel?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateFieldDynamicLabelResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | UpdateFieldDynamicLabelResult
   | UserIsNotAnAdministrator

export type UpdateFieldDynamicLabelResult = {
   __typename?: 'UpdateFieldDynamicLabelResult'
   dynamicLabel?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateFieldGoFParams = {
   fieldId: Scalars['String']
   gofId: Scalars['String']
}

export type UpdateFieldGoFResponse =
   | CannotEditSystemField
   | CannotMoveFieldFromAddAnotherGoF
   | CannotMoveFieldIntoSystemGoF
   | CannotMoveFieldToAddAnotherGoF
   | DependentFieldNamesAlreadyExistsInGof
   | FieldAndGoFAreNotInSameTemplate
   | FieldIsDeleted
   | FieldNameAlreadyExistsInGof
   | FieldNotFound
   | FieldsInConditionOptionsConfig
   | UpdateFieldGoFResult
   | UserIsNotAnAdministrator
   | YouAreNotAllowedToMoveDependentField

export type UpdateFieldGoFResult = {
   __typename?: 'UpdateFieldGoFResult'
   fieldId: Scalars['String']
   gofId: Scalars['String']
   movedDependentFieldIds: Array<Scalars['String']>
}

export type UpdateFieldHelpTextParams = {
   fieldId: Scalars['String']
   helpText?: InputMaybe<Scalars['String']>
}

export type UpdateFieldHelpTextResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | UpdateFieldHelpTextResult
   | UserIsNotAnAdministrator

export type UpdateFieldHelpTextResult = {
   __typename?: 'UpdateFieldHelpTextResult'
   fieldId: Scalars['String']
   helpText?: Maybe<Scalars['String']>
}

export type UpdateFieldHelpTextTypeParams = {
   fieldId: Scalars['String']
   helpTextType: HelpTextType
}

export type UpdateFieldHelpTextTypeResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | UpdateFieldHelpTextTypeResult
   | UserIsNotAnAdministrator

export type UpdateFieldHelpTextTypeResult = {
   __typename?: 'UpdateFieldHelpTextTypeResult'
   fieldId: Scalars['String']
   helpTextType: HelpTextType
}

export type UpdateFieldIconParams = {
   fieldId: Scalars['String']
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
}

export type UpdateFieldIconResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNameAlreadyExistsInGof
   | FieldNotFound
   | UpdateFieldIconResult
   | UserIsNotAnAdministrator

export type UpdateFieldIconResult = {
   __typename?: 'UpdateFieldIconResult'
   fieldId: Scalars['String']
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
}

export type UpdateFieldNameParams = {
   fieldId: Scalars['String']
   name: Scalars['String']
}

export type UpdateFieldNameResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNameAlreadyExistsInGof
   | FieldNotFound
   | UpdateFieldNameResult
   | UserIsNotAnAdministrator

export type UpdateFieldNameResult = {
   __typename?: 'UpdateFieldNameResult'
   fieldId: Scalars['String']
   name: Scalars['String']
}

export type UpdateFieldOptionsValueTypeParams = {
   fieldId: Scalars['String']
   optionsValueType: OptionsValueType
}

export type UpdateFieldOptionsValueTypeResponse =
   | CannotEditSystemField
   | CircularConditionalOptionsAreNotAllowed
   | FieldIsDeleted
   | FieldNotFound
   | NotSupportedFieldType
   | UpdateFieldOptionsValueTypeResult
   | UserIsNotAnAdministrator

export type UpdateFieldOptionsValueTypeResult = {
   __typename?: 'UpdateFieldOptionsValueTypeResult'
   fieldId: Scalars['String']
   optionsValueType: OptionsValueType
}

export type UpdateFieldPlaceholderTextParams = {
   fieldId: Scalars['String']
   placeholderText?: InputMaybe<Scalars['String']>
}

export type UpdateFieldPlaceholderTextResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | UpdateFieldPlaceholderTextResult
   | UserIsNotAnAdministrator

export type UpdateFieldPlaceholderTextResult = {
   __typename?: 'UpdateFieldPlaceholderTextResult'
   fieldId: Scalars['String']
   placeholderText?: Maybe<Scalars['String']>
}

export type UpdateFieldReferenceIdParams = {
   fieldId: Scalars['String']
   referenceId?: InputMaybe<Scalars['String']>
}

export type UpdateFieldReferenceIdResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | FieldReferenceIdIsReserved
   | FieldReferenceIdMaxLengthExceeded
   | InvalidFieldReferenceIdFormat
   | LinkedFieldUpdateRestricted
   | ReferenceIdAlreadyExistsInLinkedFieldsTemplates
   | ReferenceIdAlreadyExistsInTemplate
   | UpdateFieldReferenceIdResult
   | UserIsNotAnAdministrator

export type UpdateFieldReferenceIdResult = {
   __typename?: 'UpdateFieldReferenceIdResult'
   fieldId: Scalars['String']
   referenceId?: Maybe<Scalars['String']>
}

export type UpdateFieldRequiredStatusParams = {
   fieldId: Scalars['String']
   isRequired: Scalars['Boolean']
}

export type UpdateFieldRequiredStatusResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | UpdateFieldRequiredStatusResult
   | UserIsNotAnAdministrator

export type UpdateFieldRequiredStatusResult = {
   __typename?: 'UpdateFieldRequiredStatusResult'
   fieldId: Scalars['String']
   isRequired: Scalars['Boolean']
}

export type UpdateFieldResponseBulkResult = {
   __typename?: 'UpdateFieldResponseBulkResult'
   changedFields: Array<FieldResponse>
   fieldResponses: Array<FieldResponse>
}

export type UpdateFieldResponseDraftResult = {
   __typename?: 'UpdateFieldResponseDraftResult'
   changedFields: Array<FieldResponseDraft>
   deletedFieldIds: Array<Scalars['String']>
   fieldResponse: FieldResponseDraft
}

export type UpdateFieldResponseResult = {
   __typename?: 'UpdateFieldResponseResult'
   changedFields: Array<FieldResponse>
   fieldResponse: FieldResponse
}

export type UpdateFieldTooltipParams = {
   fieldId: Scalars['String']
   tooltip?: InputMaybe<Scalars['String']>
}

export type UpdateFieldTooltipResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | UpdateFieldTooltipResult
   | UserIsNotAnAdministrator

export type UpdateFieldTooltipResult = {
   __typename?: 'UpdateFieldTooltipResult'
   fieldId: Scalars['String']
   tooltip?: Maybe<Scalars['String']>
}

export type UpdateFieldsSelectorFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateFieldsSelectorFieldDefaultValueResponse =
   | CannotEditSystemField
   | DefaultValueMustBeInGivenOptions
   | FieldIsDeleted
   | FieldNotFound
   | NotFieldsSelectorField
   | UpdateFieldsSelectorFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateFieldsSelectorFieldDefaultValueResult = {
   __typename?: 'UpdateFieldsSelectorFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateFieldsSelectorFieldUiStyleParams = {
   fieldId: Scalars['String']
   uiStyle: FieldSelectorFieldUiStyleEnum
}

export type UpdateFieldsSelectorFieldUiStyleResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotFieldsSelectorField
   | UpdateFieldsSelectorFieldUiStyleResult
   | UserIsNotAnAdministrator

export type UpdateFieldsSelectorFieldUiStyleResult = {
   __typename?: 'UpdateFieldsSelectorFieldUIStyleResult'
   fieldId: Scalars['String']
   uiStyle: FieldSelectorFieldUiStyleEnum
}

export type UpdateFileUploaderFieldConfigParams = {
   allowPublicAccess: Scalars['Boolean']
   allowedFormats: Array<Scalars['String']>
   canDownload: Scalars['Boolean']
   eachFileMaxSizeInKb: Scalars['Int']
   fieldId: Scalars['String']
   maxNumberOfFilesToUpload: Scalars['Int']
}

export type UpdateFileUploaderFieldConfigResponse =
   | CannotEditSystemField
   | DefaultValueFormatNotInAllowedFormats
   | DefaultValueFormatNotInAllowedFormatsForLinkedFields
   | FieldIsDeleted
   | FieldNotFound
   | FileSizeCannotBeNegativeOrZero
   | FileSizeMaxLimitExceeded
   | InvalidAllowedFormats
   | LinkedFieldUpdateRestricted
   | MaxNumberOfFilesCannotBeNegativeOrZero
   | NotFileUploaderField
   | NumberOfFilesMaxLimitExceeded
   | UpdateFileUploaderFieldConfigResult
   | UserIsNotAnAdministrator

export type UpdateFileUploaderFieldConfigResult = {
   __typename?: 'UpdateFileUploaderFieldConfigResult'
   allowPublicAccess: Scalars['Boolean']
   allowedFormats: Array<Scalars['String']>
   canDownload: Scalars['Boolean']
   eachFileMaxSizeInKb: Scalars['Int']
   fieldId: Scalars['String']
   maxNumberOfFilesToUpload: Scalars['Int']
}

export type UpdateFileUploaderFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateFileUploaderFieldDefaultValueResponse =
   | CannotEditSystemField
   | DefaultValueFormatNotInAllowedFormats
   | FieldIsDeleted
   | FieldNotFound
   | NotFileUploaderField
   | UpdateFileUploaderFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateFileUploaderFieldDefaultValueResult = {
   __typename?: 'UpdateFileUploaderFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateFiltersLogicalOperatorParams = {
   filterSetEntity: FilterSetEntityType
   filterSetId: Scalars['String']
   filtersLogicalOperator: LogicalOperator
}

export type UpdateFiltersLogicalOperatorResponse =
   | FilterSetAccessDenied
   | FilterSetNotFound
   | FilterSetNotLinkedToBoard
   | FilterSetNotLinkedToBoardList
   | FilterSetNotLinkedToGivenEntity
   | FilterSetNotLinkedToGraph
   | FilterSetNotLinkedToView
   | FiltersNotSupportedForExternalDashboard
   | NotAllowedToEditBoardFilterSet
   | NotAllowedToEditBoardListFilterSet
   | NotEditableFilterSetEntity
   | NotUserFilterSet
   | UpdateFiltersLogicalOperatorResult
   | UserIsNotAnAdministrator

export type UpdateFiltersLogicalOperatorResult = {
   __typename?: 'UpdateFiltersLogicalOperatorResult'
   filterSetEntity: FilterSetEntityType
   filterSetId: Scalars['String']
   filtersLogicalOperator: LogicalOperator
}

export type UpdateFloatFieldDecimalPrecisionLimitParams = {
   decimalPrecisionLimit?: InputMaybe<Scalars['Int']>
   fieldId: Scalars['String']
}

export type UpdateFloatFieldDecimalPrecisionLimitResponse =
   | CannotEditSystemField
   | DecimalPrecisionLimitMustBePositive
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotFloatField
   | UpdateFloatFieldDecimalPrecisionLimitResult
   | UserIsNotAnAdministrator

export type UpdateFloatFieldDecimalPrecisionLimitResult = {
   __typename?: 'UpdateFloatFieldDecimalPrecisionLimitResult'
   decimalPrecisionLimit?: Maybe<Scalars['Int']>
   fieldId: Scalars['String']
}

export type UpdateFloatFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['Float']>
   fieldId: Scalars['String']
}

export type UpdateFloatFieldDefaultValueResponse =
   | CannotEditSystemField
   | DefaultValueAllowedForNonUniqueFields
   | DefaultValueMustSatisfyGivenFloatRange
   | FieldIsDeleted
   | FieldNotFound
   | NotFloatField
   | UpdateFloatFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateFloatFieldDefaultValueResult = {
   __typename?: 'UpdateFloatFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['Float']>
   fieldId: Scalars['String']
}

export type UpdateFloatFieldFormulaStatusParams = {
   fieldId: Scalars['String']
   formulaExpression?: InputMaybe<Scalars['String']>
   isFormulaEnabled: Scalars['Boolean']
}

export type UpdateFloatFieldFormulaStatusResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotEditSystemField
   | CannotEnableFormulaStatusInAddAnotherField
   | FieldsAreDeleted
   | FieldsNotFound
   | FormulaExpressionIsRequired
   | FormulaFieldsAreNotAllowed
   | InvalidFormulaExpression
   | NotFloatField
   | NotSupportedFieldTypes
   | NotSupportedFields
   | SelfReferenceIsNotAllowedInFormulaExpression
   | UpdateFloatFieldFormulaStatusResult
   | UserIsNotAnAdministrator

export type UpdateFloatFieldFormulaStatusResult = {
   __typename?: 'UpdateFloatFieldFormulaStatusResult'
   fieldId: Scalars['String']
   formulaExpression?: Maybe<Scalars['String']>
   isFormulaEnabled: Scalars['Boolean']
}

export type UpdateFloatFieldRangeParams = {
   fieldId: Scalars['String']
   rangeConfig?: InputMaybe<FloatRangeParams>
}

export type UpdateFloatFieldRangeResponse =
   | CannotEditSystemField
   | DefaultValueMustSatisfyGivenFloatRange
   | DefaultValueMustSatisfyGivenFloatRangeForLinkedFields
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | MaxValueLessThanMinValue
   | NotFloatField
   | RangeCannotBeConfiguredForUniqueFields
   | RangeCannotBeConfiguredForUniqueLinkedFields
   | UpdateFloatFieldRangeResult
   | UserIsNotAnAdministrator

export type UpdateFloatFieldRangeResult = {
   __typename?: 'UpdateFloatFieldRangeResult'
   fieldId: Scalars['String']
   rangeConfig?: Maybe<FloatRangeConfig>
}

export type UpdateFormIdentificationFieldParams = {
   formId: Scalars['String']
   identificationFieldId: Scalars['String']
}

export type UpdateFormIdentificationFieldResponse =
   | FieldIsDeleted
   | FieldNotFound
   | FormNotFound
   | IsRequiredShouldBeTrueForIdentificationField
   | LinkedRootFieldIsNotIdentificationField
   | NotFormTemplateField
   | UpdateFormIdentificationFieldResult
   | UserIsNotAnAdministrator

export type UpdateFormIdentificationFieldResult = {
   __typename?: 'UpdateFormIdentificationFieldResult'
   formId: Scalars['String']
   identificationFieldId: Scalars['String']
}

export type UpdateFormLayoutParams = {
   backgroundColourHexCode?: InputMaybe<Scalars['String']>
   bannerImageUrl?: InputMaybe<Scalars['String']>
   headerBackgroundColourHexCode?: InputMaybe<Scalars['String']>
   layoutCode?: InputMaybe<Scalars['String']>
   layoutId: Scalars['String']
   layoutType: FormLayoutType
   logoImageUrl: Scalars['String']
}

export type UpdateFormLayoutResponse =
   | EmptyFormLayoutLogoImageUrl
   | FormLayout
   | FormLayoutNotFound
   | InvalidBannerImageUrl
   | InvalidLogoImageUrl
   | UserIsNotAnAdministrator

export type UpdateFormTemplateDescriptionParams = {
   description?: InputMaybe<Scalars['String']>
   formTemplateId: Scalars['String']
}

export type UpdateFormTemplateDescriptionResponse =
   | FormTemplateNotFound
   | UpdateFormTemplateDescriptionResult
   | UserIsNotAnAdministrator

export type UpdateFormTemplateDescriptionResult = {
   __typename?: 'UpdateFormTemplateDescriptionResult'
   description?: Maybe<Scalars['String']>
   formTemplateId: Scalars['String']
}

export type UpdateFormTemplateNameParams = {
   formTemplateId: Scalars['String']
   name: Scalars['String']
}

export type UpdateFormTemplateNameResponse =
   | FormTemplateNameIsRequired
   | FormTemplateNotFound
   | UpdateFormTemplateNameResult
   | UserIsNotAnAdministrator

export type UpdateFormTemplateNameResult = {
   __typename?: 'UpdateFormTemplateNameResult'
   formTemplateId: Scalars['String']
   name: Scalars['String']
}

export type UpdateFromSubmissionConfigParams = {
   messageTemplate?: InputMaybe<Scalars['String']>
   queryParamsFieldIds: Array<Scalars['String']>
   redirectionUrl?: InputMaybe<Scalars['String']>
   responseType: FormSubmissionResponseType
   submissionConfigId: Scalars['String']
}

export type UpdateFromSubmissionConfigResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | FilledNotRequiredConfig
   | FormSubmissionConfig
   | FormSubmissionConfigAlreadyExists
   | FormSubmissionConfigNotFound
   | InvalidRedirectionUrl
   | NotExistsReferenceIdForFields
   | NotFilledRequiredConfig
   | NotFormTemplateFields
   | UserIsNotAnAdministrator

export type UpdateFunnelGraphResponse =
   | GraphNameIsRequired
   | GraphNotFound
   | NotFunnelGraph
   | UpdateFunnelGraphResult
   | UserIsNotAnAdministrator

export type UpdateFunnelGraphResult = {
   __typename?: 'UpdateFunnelGraphResult'
   description?: Maybe<Scalars['String']>
   dropValueComparisonType: FunnelDropValueComparisonType
   graphId: Scalars['String']
   name: Scalars['String']
}

export type UpdateFunnelParams = {
   description?: InputMaybe<Scalars['String']>
   dropValueComparisonType: FunnelDropValueComparisonType
   graphId: Scalars['String']
   name: Scalars['String']
}

export type UpdateGallaboxAccountParams = {
   apiKey: Scalars['String']
   apiSecret: Scalars['String']
   enableReadReceipts: Scalars['Boolean']
   gallaboxAccountId: Scalars['String']
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
}

export type UpdateGallaboxAccountResponse =
   | AccountPluginIsDisabled
   | GallaboxAccount
   | GallaboxAccountNameAlreadyExists
   | ParameterIdsNotFound
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator

export type UpdateGeoFieldAddressFieldsParams = {
   addressFieldIds: Array<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateGeoFieldAddressFieldsResponse =
   | CannotEditSystemField
   | FieldsAreDeleted
   | FieldsNotFound
   | NotAGeoField
   | NotSupportedFieldTypes
   | UpdateGeoFieldAddressFieldsResult
   | UserIsNotAnAdministrator

export type UpdateGeoFieldAddressFieldsResult = {
   __typename?: 'UpdateGeoFieldAddressFieldsResult'
   addressFieldIds: Array<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateGoFDescriptionParams = {
   description?: InputMaybe<Scalars['String']>
   gofId: Scalars['String']
}

export type UpdateGoFDescriptionResponse =
   | CannotEditSystemGoF
   | GoFIsDeleted
   | GoFNotFound
   | UpdateGoFDescriptionResult
   | UserIsNotAnAdministrator

export type UpdateGoFDescriptionResult = {
   __typename?: 'UpdateGoFDescriptionResult'
   description?: Maybe<Scalars['String']>
   gofId: Scalars['String']
}

export type UpdateGoFNameResult = {
   __typename?: 'UpdateGoFNameResult'
   gofId: Scalars['String']
   name: Scalars['String']
}

export type UpdateGofNameInputParams = {
   gofId: Scalars['String']
   name: Scalars['String']
}

export type UpdateGofNameResponse =
   | CannotEditSystemGoF
   | GoFIsDeleted
   | GoFNameAlreadyExists
   | GoFNotFound
   | UpdateGoFNameResult
   | UserIsNotAnAdministrator

export type UpdateGraphDataSourcesParams = {
   dataSources: Array<AnalyticsDataSourceType>
   graphId: Scalars['String']
}

export type UpdateGraphDataSourcesResponse =
   | EmptyGraphDataSources
   | GraphNotFound
   | LeadOrDealDataSourceMustExists
   | MissingDimensionDataSources
   | MissingMetricDataSources
   | NotSupportedDataSources
   | NotSupportedMultipleDataSources
   | UnsupportedDataSourcesForPipeline
   | UpdateGraphDataSourcesResult
   | UserIsNotAnAdministrator

export type UpdateGraphDataSourcesResult = {
   __typename?: 'UpdateGraphDataSourcesResult'
   dataSources: Array<AnalyticsDataSourceType>
   graphId: Scalars['String']
}

export type UpdateGraphDimensionParams = {
   dataSource: AnalyticsDataSourceType
   fieldId: Scalars['String']
   graphDimensionId: Scalars['String']
   graphId: Scalars['String']
   groupByType: GraphAggType
   histogramInterval?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   ranges: Array<Range>
   sortValue?: InputMaybe<SortValue>
}

export type UpdateGraphDimensionResponse =
   | EmptyHistogramIntervalForHistogramGroupByType
   | EmptyRangesForRangeGroupByType
   | FieldIdNotInPipeline
   | FieldIsDeleted
   | FieldNotFound
   | GraphAndDimensionAreNotLinked
   | GraphDimension
   | GraphDimensionFieldsShouldBeUnique
   | GraphDimensionNotFound
   | GraphNotFound
   | InvalidDateHistogramInterval
   | InvalidGraphFieldValue
   | NotSupportedFieldForGraphSalesEntityType
   | SalesTemplateIdNotInPipeline
   | UnSupportedDataSourceField
   | UnSupportedGroupByFieldDataSource
   | UnSupportedGroupByFieldType
   | UnSupportedGroupByTypeField
   | UnSupportedGroupByTypeFieldType
   | UserIsNotAnAdministrator

export type UpdateGraphMetricParams = {
   canShowMetric: Scalars['Boolean']
   dataSource?: InputMaybe<AnalyticsDataSourceType>
   fieldId?: InputMaybe<Scalars['String']>
   formulaNodes?: InputMaybe<Array<MetricFormulaNodeParams>>
   metricId: Scalars['String']
   metricType: MetricType
   name?: InputMaybe<Scalars['String']>
}

export type UpdateGraphMetricResponse =
   | CustomMetricsNotAllowedInFormula
   | DataSourceIsNotRequired
   | DataSourceIsRequired
   | FieldIdNotInPipeline
   | FieldIsDeleted
   | FieldNotFound
   | FormulaIsNotValid
   | GraphMetric
   | GraphMetricNotFound
   | MetricsInFormulaNotLinkedToSameGraph
   | MinimumOneMetricShouldShowInGraph
   | NotEditableGraphMetric
   | NotEditablePivotTableMetricField
   | NotSupportedFieldForGraphMetric
   | NotSupportedFieldForGraphSalesEntityType
   | NotSupportedGraphMetricField
   | SalesTemplateIdNotInPipeline
   | UnSupportedDataSourceField
   | UnSupportedMetricField
   | UnSupportedMetricFieldDataSource
   | UserIsNotAnAdministrator
   | ZeroDivisionFound

export type UpdateGraphParams = {
   description?: InputMaybe<Scalars['String']>
   graphId: Scalars['String']
   name: Scalars['String']
}

export type UpdateGraphQuickFilterFieldParams = {
   dataSource?: InputMaybe<AnalyticsDataSourceType>
   fieldId: Scalars['String']
   graphQuickFilterFieldId: Scalars['String']
}

export type UpdateGraphQuickFilterFieldResponse =
   | DataSourceIsRequiredForAdvancedAnalyticsLevelGraph
   | FieldIdNotInGraphPipeline
   | FieldIsDeleted
   | FieldNotFound
   | GraphFieldAlreadyExists
   | GraphFieldDataSourceAlreadyExists
   | GraphQuickFilterFieldNotFound
   | NotSupportedFieldForGraphSalesEntityType
   | SalesTemplateIdNotInPipeline
   | UnSupportedDataSourceField
   | UpdateGraphQuickFilterFieldResult
   | UserIsNotAnAdministrator

export type UpdateGraphQuickFilterFieldResult = {
   __typename?: 'UpdateGraphQuickFilterFieldResult'
   dataSource: AnalyticsDataSourceType
   fieldId: Scalars['String']
   graphQuickFilterFieldId: Scalars['String']
}

export type UpdateGraphResponse =
   | BarGraphConfig
   | DonutChartConfig
   | FunnelGraphConfig
   | GraphNameIsRequired
   | GraphNotFound
   | LineGraphConfig
   | PieChartConfig
   | PipelineAccessDenied
   | PivotTableGraphConfig
   | ScorecardChartConfig
   | TableGraphConfig
   | UserIsNotAnAdministrator

export type UpdateGraphWidthPercentageParams = {
   graphId: Scalars['String']
   parentId: Scalars['String']
   parentType: GraphParentType
   widthPercentage: Scalars['Float']
}

export type UpdateGraphWidthPercentageResponse =
   | DashboardAccessDenied
   | DashboardNotFound
   | GraphAccessDenied
   | GraphNotFound
   | NotSupportedGraphParenType
   | UpdateGraphWidthPercentageResult
   | ViewAccessDenied
   | ViewNotFound
   | WidthPercentageShouldBePositive

export type UpdateGraphWidthPercentageResult = {
   __typename?: 'UpdateGraphWidthPercentageResult'
   graphId: Scalars['String']
   parentId: Scalars['String']
   parentType: GraphParentType
   widthPercentage: Scalars['Float']
}

export type UpdateGupShupAccountParams = {
   enableReadReceipts: Scalars['Boolean']
   encryptionKey?: InputMaybe<Scalars['String']>
   isEncryptionEnabled: Scalars['Boolean']
   name: Scalars['String']
   password: Scalars['String']
   pluginServiceAccountId: Scalars['String']
   userId: Scalars['String']
}

export type UpdateGupShupAccountResponse =
   | AccountPluginIsDisabled
   | GupShupAccount
   | GupShupAccountNameAlreadyExists
   | ParameterIdsNotFound
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator

export type UpdateIntegerFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['Int']>
   fieldId: Scalars['String']
}

export type UpdateIntegerFieldDefaultValueResponse =
   | CannotEditSystemField
   | DefaultValueAllowedForNonUniqueFields
   | DefaultValueMustSatisfyGivenIntegerRange
   | FieldIsDeleted
   | FieldNotFound
   | NotIntegerField
   | UpdateIntegerFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateIntegerFieldDefaultValueResult = {
   __typename?: 'UpdateIntegerFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['Int']>
   fieldId: Scalars['String']
}

export type UpdateIntegerFieldFormulaStatusParams = {
   fieldId: Scalars['String']
   formulaExpression?: InputMaybe<Scalars['String']>
   isFormulaEnabled: Scalars['Boolean']
}

export type UpdateIntegerFieldFormulaStatusResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotEditSystemField
   | CannotEnableFormulaStatusInAddAnotherField
   | FieldsAreDeleted
   | FieldsNotFound
   | FormulaExpressionIsRequired
   | FormulaFieldsAreNotAllowed
   | InvalidFormulaExpression
   | NotIntegerField
   | NotSupportedFieldTypes
   | NotSupportedFields
   | SelfReferenceIsNotAllowedInFormulaExpression
   | UpdateIntegerFieldFormulaStatusResult
   | UserIsNotAnAdministrator

export type UpdateIntegerFieldFormulaStatusResult = {
   __typename?: 'UpdateIntegerFieldFormulaStatusResult'
   fieldId: Scalars['String']
   formulaExpression?: Maybe<Scalars['String']>
   isFormulaEnabled: Scalars['Boolean']
}

export type UpdateIntegerFieldRangeParams = {
   fieldId: Scalars['String']
   rangeConfig?: InputMaybe<IntegerRangeParams>
}

export type UpdateIntegerFieldRangeResponse =
   | CannotEditSystemField
   | DefaultValueMustSatisfyGivenIntegerRange
   | DefaultValueMustSatisfyGivenIntegerRangeForLinkedFields
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | MaxValueLessThanMinValue
   | NotIntegerField
   | RangeCannotBeConfiguredForUniqueFields
   | RangeCannotBeConfiguredForUniqueLinkedFields
   | UpdateIntegerFieldRangeResult
   | UserIsNotAnAdministrator

export type UpdateIntegerFieldRangeResult = {
   __typename?: 'UpdateIntegerFieldRangeResult'
   fieldId: Scalars['String']
   rangeConfig?: Maybe<IntegerRangeConfig>
}

export type UpdateKnowlarityAccountDetailsParams = {
   applicationAccessKey: Scalars['String']
   channelType: KnowlarityChannelType
   kNumber: PhoneNumberParams
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
   srApiKey: Scalars['String']
}

export type UpdateKnowlarityAccountDetailsResponse =
   | ApplicationAccessKeyAlreadyExists
   | KNumberAlreadyExists
   | KnowlarityAccountNotFound
   | ParameterIdsNotFound
   | SrApiKeyAlreadyExists
   | UpdateKnowlarityAccountDetailsResult
   | UserIsNotAnAdministrator

export type UpdateKnowlarityAccountDetailsResult = {
   __typename?: 'UpdateKnowlarityAccountDetailsResult'
   applicationAccessKey: Scalars['String']
   channelType: KnowlarityChannelType
   kNumber: PhoneNumberResponse
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
   srApiKey: Scalars['String']
}

export type UpdateLayoutParams = {
   enableProposalFlow?: InputMaybe<Scalars['Boolean']>
   layoutId: Scalars['String']
   quickActions: Array<LayoutQuickActionType>
}

export type UpdateLayoutResponse =
   | LayoutNotFound
   | UpdateLayoutResult
   | UserIsNotAnAdministrator

export type UpdateLayoutResult = {
   __typename?: 'UpdateLayoutResult'
   enableProposalFlow?: Maybe<Scalars['Boolean']>
   layoutId: Scalars['String']
   quickActions: Array<LayoutQuickActionType>
}

export type UpdateLdRuleTriggerConfigParams = {
   leadDistributionRuleId: Scalars['String']
   stageUpdatedTriggerConfig?: InputMaybe<LdRuleStageUpdatedTriggerConfigParams>
}

export type UpdateLdRuleTriggerConfigResponse =
   | LdRuleStageUpdatedTriggerConfigIsRequired
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | TriggerConfigUpdateNotSupportedForLdRule
   | UpdateLdRuleTriggerConfigResult
   | UserIsNotAnAdministrator

export type UpdateLdRuleTriggerConfigResult = {
   __typename?: 'UpdateLdRuleTriggerConfigResult'
   leadDistributionRuleId: Scalars['String']
   stageUpdatedTriggerConfig?: Maybe<LdRuleStageUpdatedTriggerConfig>
}

export type UpdateLeadAddAnotherFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   leadId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type UpdateLeadAddAnotherFieldResponse =
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GoFResponseIdNotFound
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | LeadAccessDenied
   | LeadIsDeleted
   | LeadNotFound
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAddAnotherGoFField
   | NotAddAnotherGoFResponseField
   | NotAllowedFileFormats
   | NotLeadAddAnotherGoFResponse
   | NotLeadField
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UpdateFieldResponseResult

export type UpdateLeadAssigneeBulkParams = {
   fieldId: Scalars['String']
   leadIds: Array<Scalars['String']>
   response: Scalars['String']
   sendNotification?: InputMaybe<Scalars['Boolean']>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdateLeadAssigneeBulkResponse =
   | AccountAccessDeniedToAssignee
   | FieldIsDeleted
   | FieldNotFound
   | LeadAssigneeIsDeactivated
   | LeadAssigneeNotFound
   | LeadsAccessDenied
   | LeadsAreDeleted
   | LeadsNotFound
   | NeedFieldWritePermission
   | NotLeadAssigneeField
   | PipelineAccessDeniedToAssignee
   | UpdateLeadAssigneeBulkResult
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateLeadAssigneeBulkResult = {
   __typename?: 'UpdateLeadAssigneeBulkResult'
   leadFields: Array<LeadFieldResponse>
}

export type UpdateLeadBucketNameParams = {
   leadBucketId: Scalars['String']
   name: Scalars['String']
}

export type UpdateLeadBucketNameResponse =
   | EmptyLeadBucketName
   | LeadBucketNameAlreadyExists
   | LeadBucketNotFound
   | LeadDistributionRuleIsNotInEditMode
   | NotEditableLeadBucket
   | UpdateLeadBucketNameResult
   | UserIsNotAnAdministrator

export type UpdateLeadBucketNameResult = {
   __typename?: 'UpdateLeadBucketNameResult'
   leadBucketId: Scalars['String']
   name: Scalars['String']
}

export type UpdateLeadBucketSortFieldsParams = {
   leadBucketId: Scalars['String']
   sortFields: Array<SortByFieldParams>
}

export type UpdateLeadBucketSortFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | LeadBucketNotFound
   | LeadDistributionRuleIsNotInEditMode
   | NotAllowedSortFields
   | NotPermittedFields
   | NotPipelineFieldIds
   | UpdateLeadBucketSortFieldsResult
   | UserIsNotAnAdministrator

export type UpdateLeadBucketSortFieldsResult = {
   __typename?: 'UpdateLeadBucketSortFieldsResult'
   leadBucketId: Scalars['String']
   sortFields: Array<SortByField>
}

export type UpdateLeadDistributionPoolAssigneeFieldConditionEnumParams = {
   leadAssigneeFieldConditionEnum: LeadPoolAssigneeConditionEnum
   leadDistributionRuleId: Scalars['String']
}

export type UpdateLeadDistributionPoolAssigneeFieldConditionEnumResponse =
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | UpdateLeadDistributionPoolAssigneeFieldConditionEnumResult
   | UserIsNotAnAdministrator

export type UpdateLeadDistributionPoolAssigneeFieldConditionEnumResult = {
   __typename?: 'UpdateLeadDistributionPoolAssigneeFieldConditionEnumResult'
   leadAssigneeFieldConditionEnum: LeadPoolAssigneeConditionEnum
   leadDistributionRuleId: Scalars['String']
}

export type UpdateLeadDistributionRuleAssigneeFieldParams = {
   leadAssigneeFieldId: Scalars['String']
   leadDistributionRuleId: Scalars['String']
}

export type UpdateLeadDistributionRuleAssigneeFieldResponse =
   | EventBasedLdRuleAlreadyExistsForStageAssignee
   | FieldIdNotInPipeline
   | FieldIsDeleted
   | FieldNotFound
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | NotLeadAssigneeField
   | UpdateLeadDistributionRuleAssigneeFieldResult
   | UserIsNotAnAdministrator

export type UpdateLeadDistributionRuleAssigneeFieldResult = {
   __typename?: 'UpdateLeadDistributionRuleAssigneeFieldResult'
   leadAssigneeFieldId: Scalars['String']
   leadDistributionRuleId: Scalars['String']
}

export type UpdateLeadDistributionRuleEditModeParams = {
   isInEditMode: Scalars['Boolean']
   leadDistributionRuleId: Scalars['String']
}

export type UpdateLeadDistributionRuleEditModeResponse =
   | LeadDistributionRuleNotFound
   | PartiallyConfiguredLeadDistributionStepsExists
   | UpdateLeadDistributionRuleEditModeResult
   | UserIsNotAnAdministrator

export type UpdateLeadDistributionRuleEditModeResult = {
   __typename?: 'UpdateLeadDistributionRuleEditModeResult'
   isInEditMode: Scalars['Boolean']
   leadDistributionRuleId: Scalars['String']
}

export type UpdateLeadDistributionRuleNameParams = {
   leadDistributionRuleId: Scalars['String']
   name: Scalars['String']
}

export type UpdateLeadDistributionRuleNameResponse =
   | EmptyLeadDistributionRuleName
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNameAlreadyExists
   | LeadDistributionRuleNotFound
   | UpdateLeadDistributionRuleNameResult
   | UserIsNotAnAdministrator

export type UpdateLeadDistributionRuleNameResult = {
   __typename?: 'UpdateLeadDistributionRuleNameResult'
   leadDistributionRuleId: Scalars['String']
   name: Scalars['String']
}

export type UpdateLeadDistributionSetupCurrentStepParams = {
   stepEnum: LeadDistributionSetupStep
}

export type UpdateLeadDistributionSetupCurrentStepResponse =
   | UpdateLeadDistributionSetupCurrentStepResult
   | UserIsNotAnAdministrator

export type UpdateLeadDistributionSetupCurrentStepResult = {
   __typename?: 'UpdateLeadDistributionSetupCurrentStepResult'
   stepEnum: LeadDistributionSetupStep
}

export type UpdateLeadFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   fieldId: Scalars['String']
   leadId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdateLeadFieldResponse =
   | AccountAccessDeniedToAssignee
   | AddAnotherFieldsAreNotSupported
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | ContactAssigneeIsDeactivated
   | ContactAssigneeNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | LeadAccessDenied
   | LeadAssigneeIsDeactivated
   | LeadAssigneeNotFound
   | LeadIsDeleted
   | LeadNotFound
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotLeadField
   | ParentFieldNotFilled
   | PipelineAccessDeniedToAssignee
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | UniqueFieldResponseAlreadyExists
   | UpdateFieldResponseResult
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateLeadNode = BaseNode & {
   __typename?: 'UpdateLeadNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   fieldIdsToClear?: Maybe<Array<Maybe<Scalars['String']>>>
   fieldsMapping: Array<ComputedUpdateFieldValueMapping>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
}

export type UpdateLeadNodeExecLog = BaseNodeExecLog & {
   __typename?: 'UpdateLeadNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   status: NodeExecLogStatusEnum
}

export type UpdateLeadPoolSortFieldsParams = {
   leadDistributionRuleId: Scalars['String']
   sortFields: Array<SortByFieldParams>
}

export type UpdateLeadPoolSortFieldsResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | NotAllowedSortFields
   | NotPermittedFields
   | NotPipelineFieldIds
   | UpdateLeadPoolSortFieldsResult
   | UserIsNotAnAdministrator

export type UpdateLeadPoolSortFieldsResult = {
   __typename?: 'UpdateLeadPoolSortFieldsResult'
   leadDistributionRuleId: Scalars['String']
   sortFields: Array<SortByField>
}

export type UpdateLeadStageNode = BaseNode & {
   __typename?: 'UpdateLeadStageNode'
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   stage?: Maybe<Stage>
   stageFieldResponses: Array<StageFieldResponse>
}

export type UpdateLeadStageNodeExecLog = BaseNodeExecLog & {
   __typename?: 'UpdateLeadStageNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<UpdateLeadStageNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type UpdateLeadStageNodeExecLogResult = {
   __typename?: 'UpdateLeadStageNodeExecLogResult'
   fromStage?: Maybe<Stage>
   toStage?: Maybe<Stage>
   updatedStages: Array<PipelineItemStageUpdateResult>
}

export type UpdateLineGraphParams = {
   description?: InputMaybe<Scalars['String']>
   graphId: Scalars['String']
   name: Scalars['String']
   showPoints: Scalars['Boolean']
   showZeroValues: Scalars['Boolean']
}

export type UpdateLineGraphResponse =
   | GraphNameIsRequired
   | GraphNotFound
   | NotLineGraph
   | PipelineAccessDenied
   | UpdateLineGraphResult
   | UserIsNotAnAdministrator

export type UpdateLineGraphResult = {
   __typename?: 'UpdateLineGraphResult'
   description?: Maybe<Scalars['String']>
   graphId: Scalars['String']
   name: Scalars['String']
   showPoints: Scalars['Boolean']
   showZeroValues: Scalars['Boolean']
}

export type UpdateLongTextFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateLongTextFieldDefaultValueResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotLongTextField
   | UpdateLongTextFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateLongTextFieldDefaultValueResult = {
   __typename?: 'UpdateLongTextFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateLongTextFieldFormulaStatusParams = {
   fieldId: Scalars['String']
   formulaExpression?: InputMaybe<Scalars['String']>
   isFormulaEnabled: Scalars['Boolean']
}

export type UpdateLongTextFieldFormulaStatusResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotEditSystemField
   | CannotEnableFormulaStatusInAddAnotherField
   | FieldsAreDeleted
   | FieldsNotFound
   | FormulaExpressionIsRequired
   | FormulaFieldsAreNotAllowed
   | InvalidFormulaExpression
   | NotLongTextField
   | NotSupportedFieldTypes
   | NotSupportedFields
   | SelfReferenceIsNotAllowedInFormulaExpression
   | UnSupportedOperators
   | UpdateLongTextFieldFormulaStatusResult
   | UserIsNotAnAdministrator

export type UpdateLongTextFieldFormulaStatusResult = {
   __typename?: 'UpdateLongTextFieldFormulaStatusResult'
   fieldId: Scalars['String']
   formulaExpression?: Maybe<Scalars['String']>
   isFormulaEnabled: Scalars['Boolean']
}

export type UpdateLongTextFieldValidationRegexParams = {
   fieldId: Scalars['String']
   regexErrorMessage?: InputMaybe<Scalars['String']>
   validationRegex?: InputMaybe<Scalars['String']>
}

export type UpdateLongTextFieldValidationRegexResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | InvalidValidationRegex
   | LinkedFieldUpdateRestricted
   | NotLongTextField
   | RegexValidationFailedForDefaultValue
   | RegexValidationFailedForLinkedFieldsDefaultValue
   | UpdateLongTextFieldValidationRegexResult
   | UserIsNotAnAdministrator

export type UpdateLongTextFieldValidationRegexResult = {
   __typename?: 'UpdateLongTextFieldValidationRegexResult'
   fieldId: Scalars['String']
   regexErrorMessage?: Maybe<Scalars['String']>
   validationRegex?: Maybe<Scalars['String']>
}

export type UpdateLtpField = {
   fieldId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type UpdateLtpUserDetailsParams = {
   fields: Array<InputMaybe<UpdateLtpField>>
   licenseNumber: Scalars['String']
   ltpName?: InputMaybe<Scalars['String']>
   reason?: InputMaybe<Scalars['String']>
}

export type UpdateLtpUserDetailsResponse =
   | InvalidLtpUserName
   | LtpUserManagementAccessDenied
   | LtpUserNotFound
   | UpdateLtpUserDetailsResult

export type UpdateLtpUserDetailsResult = {
   __typename?: 'UpdateLtpUserDetailsResult'
   licenseNumber: Scalars['String']
}

export type UpdateManualLeadDistributionRuleSettingsParams = {
   leadDistributionRuleId: Scalars['String']
   overrideGlobalQuota: Scalars['Boolean']
   smartDistribution: Scalars['Boolean']
}

export type UpdateManualLeadDistributionRuleSettingsResponse =
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | UpdateManualLeadDistributionRuleSettingsResult
   | UserIsNotAnAdministrator

export type UpdateManualLeadDistributionRuleSettingsResult = {
   __typename?: 'UpdateManualLeadDistributionRuleSettingsResult'
   leadDistributionRuleId: Scalars['String']
   overrideGlobalQuota: Scalars['Boolean']
   smartDistribution: Scalars['Boolean']
}

export type UpdateMultiSelectAllowOtherOptionsParams = {
   allowOtherOptions: Scalars['Boolean']
   fieldId: Scalars['String']
}

export type UpdateMultiSelectAllowOtherOptionsResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotDropdownField
   | UpdateMultiSelectAllowOtherOptionsResult
   | UserIsNotAnAdministrator

export type UpdateMultiSelectAllowOtherOptionsResult = {
   __typename?: 'UpdateMultiSelectAllowOtherOptionsResult'
   allowOtherOptions: Scalars['Boolean']
   fieldId: Scalars['String']
}

export type UpdateMultiSelectFieldDefaultValuesParams = {
   defaultValues: Array<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateMultiSelectFieldDefaultValuesResponse =
   | CannotEditSystemField
   | DefaultValuesMustBeInGivenOptions
   | FieldIsDeleted
   | FieldNotFound
   | NotMultiSelectField
   | UpdateMultiSelectFieldDefaultValuesResult
   | UserIsNotAnAdministrator

export type UpdateMultiSelectFieldDefaultValuesResult = {
   __typename?: 'UpdateMultiSelectFieldDefaultValuesResult'
   defaultValues: Array<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateMultiSelectFieldUiStyleParams = {
   fieldId: Scalars['String']
   uiStyle: MultiSelectFieldUiStyleEnum
}

export type UpdateMultiSelectFieldUiStyleResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotMultiSelectField
   | UpdateMultiSelectFieldUiStyleResult
   | UserIsNotAnAdministrator

export type UpdateMultiSelectFieldUiStyleResult = {
   __typename?: 'UpdateMultiSelectFieldUIStyleResult'
   fieldId: Scalars['String']
   uiStyle: MultiSelectFieldUiStyleEnum
}

export type UpdateMultiselectLabelsStatusParams = {
   fieldId: Scalars['String']
   isLabelsEnabled: Scalars['Boolean']
}

export type UpdateMultiselectLabelsStatusResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotMultiSelectField
   | UpdateMultiselectLabelsStatusResult
   | UserIsNotAnAdministrator

export type UpdateMultiselectLabelsStatusResult = {
   __typename?: 'UpdateMultiselectLabelsStatusResult'
   fieldId: Scalars['String']
   isLabelsEnabled: Scalars['Boolean']
}

export type UpdateMultiselectOptionsColorParams = {
   fieldId: Scalars['String']
   optionColors: Array<OptionColorParams>
}

export type UpdateMultiselectOptionsColorResponse =
   | FieldIsDeleted
   | FieldLabelsConfigNotEnabled
   | FieldNotFound
   | InvalidMultiselectOptions
   | NotMultiSelectField
   | UpdateMultiselectOptionsColorResult
   | UserIsNotAnAdministrator

export type UpdateMultiselectOptionsColorResult = {
   __typename?: 'UpdateMultiselectOptionsColorResult'
   fieldId: Scalars['String']
   optionColors: Array<OptionColorConfig>
}

export type UpdateNodeAddAnotherGoFParams = {
   gofId?: InputMaybe<Scalars['String']>
   gofResponses: Array<NodeGoFResponseFieldsMappingParams>
   nodeId: Scalars['String']
}

export type UpdateNodeAddAnotherGoFResponse =
   | AddAnotherGoFNode
   | DirectValueNotSupportedOnUniqueFields
   | DuplicateGoFResponseUniqueIds
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FieldsNotInGoF
   | FormulaEvaluationLogicFailedInField
   | GoFNotFound
   | InvalidFieldValuesErrors
   | NodeNotFound
   | NotAddAnotherGoF
   | NotAddAnotherGoFNodeType
   | NotCompatibleValueFieldIds
   | NotEditableNode
   | NotLeadTemplateFieldIds
   | NotSupportedComputedUpdateConfigForFields
   | PayloadIsNotSupportedInScheduledTrigger
   | UnSupportedFieldsForEnableDeepCopy
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UserIsNotAnAdministrator

export type UpdateNodeCallWebhookParams = {
   contentType?: InputMaybe<ApiRequestContentTypeEnum>
   endPoint?: InputMaybe<Scalars['String']>
   headers: Array<HeaderParams>
   nodeId: Scalars['String']
   payload: Array<RequestPayloadMappingParams>
}

export type UpdateNodeCallWebhookResponse =
   | CallWebhookNode
   | DuplicateHeaderKeys
   | DuplicatePayloadKeys
   | EmptyHeaderValues
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidEndpoint
   | NodeNotFound
   | NotActivityTemplateFieldIds
   | NotCallWebhookNode
   | NotEditableNode
   | NotEventBasedTriggerForStageFields
   | NotLeadTemplateFieldIds
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParameterIdsNotFound
   | PayloadIsNotSupportedInScheduledTrigger
   | PhoneNumberValueFormatIsNotSupportedForFields
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type UpdateNodeClearUndoneLeadTasksParams = {
   nodeId: Scalars['String']
   taskTemplateIds: Array<Scalars['String']>
}

export type UpdateNodeClearUndoneLeadTasksResponse =
   | ClearUndoneLeadTasksNode
   | InvalidTaskTemplateIds
   | NodeNotFound
   | NotClearUndoneTasksOnLeadType
   | NotEditableNode
   | TaskTemplatesNotInPipeline
   | UserIsNotAnAdministrator

export type UpdateNodeCreatePipelineEventParams = {
   fieldsMapping?: InputMaybe<Array<InputMaybe<FieldValueMappingParams>>>
   nodeId: Scalars['String']
   pipelineEventTemplateId?: InputMaybe<Scalars['String']>
   pipelineId?: InputMaybe<Scalars['String']>
}

export type UpdateNodeCreatePipelineEventResponse =
   | CreatePipelineEventNode
   | DirectValueNotSupportedOnUniqueFields
   | DuplicateFieldIds
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormulaEvaluationLogicFailedInField
   | InvalidFieldValuesErrors
   | NodeNotFound
   | NotCompatibleValueFieldIds
   | NotCreatePipelineEventNodeType
   | NotEditableNode
   | NotEventBasedTriggerForStageFields
   | NotPipelineEventTemplateFieldIds
   | NotSupportedComputedUpdateConfigForFields
   | NotSupportedSystemFields
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | PayloadIsNotSupportedInScheduledTrigger
   | PipelineEventTemplateNotInGivenPipeline
   | PipelineNotFound
   | TriggerPipelineCannotBeSameWithCreatePipelineEventNode
   | UnSupportedPipelineItemTypeForNodeType
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UserIsNotAnAdministrator

export type UpdateNodeCreateRelatedRecordParams = {
   assignees: Array<CreateRelatedRecordNodeAssigneeParams>
   customFields: Array<FieldValueMappingParams>
   displayStageId?: InputMaybe<Scalars['String']>
   mandatoryFields: Array<FieldValueMappingParams>
   nodeId: Scalars['String']
   pipelineStageValues?: InputMaybe<Array<PipelineStageValuesParams>>
   relationFields?: InputMaybe<Array<RelationFieldValueMappingParams>>
   stageId?: InputMaybe<Scalars['String']>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdateNodeCreateRelatedRecordResponse =
   | ApplicationDisplayStageNotFound
   | ApplicationDisplayStageNotInRelationPipeline
   | AssigneesAreDeactivated
   | AssigneesNotFound
   | AutomationWorkflowNodesAreNotEditable
   | ChildAndParentNodeCannotBeSame
   | ChildNodeIdIsRequired
   | ChildParentNodeResultIsRequired
   | CreateRelatedRecordNode
   | DirectValueNotSupportedInRelationFieldValueMappings
   | DirectValueNotSupportedOnUniqueFields
   | DisplayStagesNotFound
   | DuplicateFieldIds
   | DuplicatePipelineIds
   | DuplicateRelationFieldMappings
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormulaEvaluationLogicFailedInField
   | InvalidCreateRelatedRecordNodeMandatoryFields
   | InvalidFieldValuesErrors
   | InvalidPipelineStageIds
   | NodeNotFound
   | NodesNotFound
   | NodesNotInSameAutomationWorkflowExecConfig
   | NotApplicationDisplayStage
   | NotCompatibleValueFieldIds
   | NotCreateRelatedRecordNodeType
   | NotEditableNode
   | NotEventBasedTriggerForStageFields
   | NotGivenAutomationWorkflowNodes
   | NotParentNode
   | NotRelatedPipelineTemplateFields
   | NotRelationFields
   | NotSupportedComputedUpdateConfigForFields
   | NotSupportedSystemFields
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParentNodeIdIsRequired
   | ParentNodeResultIsRequired
   | PayloadIsNotSupportedInScheduledTrigger
   | PipelineAccessDeniedToAssignees
   | PipelineAssigneeFieldsNotFound
   | PipelineNotFound
   | RelatedPipelineItemTemplateNotLinkedToPipelineIds
   | RelationIsDeleted
   | RelationNotFound
   | RelationNotInPipeline
   | RelationPipelineAssigneeFieldsNotFound
   | RelationsAreDeleted
   | RelationsAreNotFound
   | RelationsInAutomationWorkflowPipeline
   | RelationsNotInRelatedPipeline
   | StageNotFound
   | StageNotInRelationPipeline
   | StagesNotFound
   | UnSupportedFieldsForEnableDeepCopy
   | UnSupportedTriggerNodeType
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UserIsNotAnAdministrator

export type UpdateNodeCreateTaskParams = {
   assignee?: InputMaybe<TaskAssigneeEnum>
   assigneeFieldId?: InputMaybe<Scalars['String']>
   nodeId: Scalars['String']
   startDate?: InputMaybe<StartDateValueConfigParams>
   startTime?: InputMaybe<StartTimeValueConfigParams>
   taskTemplateId?: InputMaybe<Scalars['String']>
}

export type UpdateNodeCreateTaskResponse =
   | AssigneeFieldIdRequired
   | CreateTaskNode
   | DeletedAssigneeFieldId
   | DuplicateFieldIds
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidAssigneeFieldId
   | InvalidDateResponseFormat
   | InvalidTimeResponseFormat
   | NodeNotFound
   | NotActivityTemplateFieldIds
   | NotCompatibleValueFieldIds
   | NotEditableNode
   | NotEventBasedTriggerForStageFields
   | NotLeadTemplateFieldIds
   | NotPipelineTaskTemplate
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | PayloadIsNotSupportedInScheduledTrigger
   | StartDateConfigIsRequired
   | TaskTemplateIdRequired
   | TaskTemplateNotFound
   | TriggerTaskAssigneeOnlySupportedToTaskTrigger
   | UnSupportedAssigneeFieldId
   | UserIsNotAnAdministrator
   | ValueFieldSourceIsRequired
   | ValueIsRequired

export type UpdateNodeExecuteFunctionParams = {
   fieldId?: InputMaybe<Scalars['String']>
   functionId?: InputMaybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type UpdateNodeExecuteFunctionResponse =
   | DirectValueNotSupportedOnUniqueFields
   | DuplicateFieldIds
   | ExecuteFunctionNode
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormulaEvaluationLogicFailedInField
   | FunctionNotFound
   | InvalidComputedValueConfigFormat
   | InvalidFieldValuesErrors
   | InvalidHoursForComputedValueConfig
   | InvalidMinutesForComputedValueConfig
   | InvalidValuesForRelativeFieldSourceTypes
   | NodeNotFound
   | NotActivityTemplateFieldIds
   | NotCompatibleValueFieldIds
   | NotEditableNode
   | NotEventBasedTriggerForStageFields
   | NotExecuteFunctionNodeType
   | NotLeadTemplateFieldIds
   | NotSupportedComputedUpdateConfigForFields
   | NotSupportedRelativeValuesForFields
   | NotSupportedSystemFields
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | PayloadIsNotSupportedInScheduledTrigger
   | UnSupportedFieldsForEnableDeepCopy
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UpRefAssigneeFieldsAreRequiredForFields
   | UpRefFieldsAreNotAssigneeFields
   | UserIsNotAnAdministrator

export type UpdateNodeGenerateDocumentNodeParams = {
   copyDocumentUrlToField?: InputMaybe<Scalars['String']>
   documentTemplateId?: InputMaybe<Scalars['String']>
   documentVersionState?: InputMaybe<DocumentVersionState>
   nodeId: Scalars['String']
   title?: InputMaybe<GenerateDocumentTitleParams>
   variableMappings?: InputMaybe<
      Array<InputMaybe<AwCustomVariableFieldMappingParams>>
   >
}

export type UpdateNodeGenerateDocumentNodeResponse =
   | DocumentTemplateIsDeleted
   | DocumentTemplateNotFound
   | DocumentTemplateNotLinkedToPipeline
   | DuplicateFormFieldsMapping
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormFieldsNotFound
   | GenerateDocumentNode
   | NodeNotFound
   | NotEditableNode
   | NotFileUploaderField
   | UserIsNotAnAdministrator

export type UpdateNodeGenerateNumberParams = {
   forceRegenerate?: InputMaybe<Scalars['Boolean']>
   generationType?: InputMaybe<NumberGenerationType>
   nodeId: Scalars['String']
   targetFieldId?: InputMaybe<Scalars['String']>
}

export type UpdateNodeGenerateNumberResponse =
   | FieldsNotFound
   | GenerateNumberNode
   | NodeNotFound
   | NotEditableNode
   | NotGenerateNumberNodeType
   | UserIsNotAnAdministrator

export type UpdateNodeInitiateRefundParams = {
   feeRuleSetId?: InputMaybe<Scalars['String']>
   nodeId: Scalars['String']
}

export type UpdateNodeInitiateRefundResponse =
   | FeeRuleSetNotFound
   | InitiateRefundNode
   | NodeNotFound
   | NotEditableNode
   | NotInitiateRefundNodeType
   | UnSupportedNodeForPipelineItemTypes
   | UserIsNotAnAdministrator

export type UpdateNodeRemoveAssigneesParams = {
   assigneeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   nodeId: Scalars['String']
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdateNodeRemoveAssigneesResponse =
   | InvalidAssigneeFieldIds
   | NodeNotFound
   | NotEditableNode
   | NotRemoveAssigneesNode
   | RemoveAssigneesNode
   | UserIsNotAnAdministrator

export type UpdateNodeRemoveFromPipelineParams = {
   clearProposalFlowLogs?: InputMaybe<Scalars['Boolean']>
   clearStageLogs?: InputMaybe<Scalars['Boolean']>
   discardPendingTasks?: InputMaybe<Scalars['Boolean']>
   nodeId: Scalars['String']
}

export type UpdateNodeRemoveFromPipelineResponse =
   | NodeNotFound
   | NotEditableNode
   | NotRemoveFromPipelineNodeType
   | RemoveFromPipelineNode
   | UserIsNotAnAdministrator

export type UpdateNodeRequestPaymentParams = {
   amount?: InputMaybe<Scalars['String']>
   displayStageId?: InputMaybe<Scalars['String']>
   expiryInDays?: InputMaybe<Scalars['Int']>
   nodeId: Scalars['String']
   paymentGatewayCode?: InputMaybe<Scalars['String']>
   paymentSplit?: InputMaybe<Array<RequestPaymentSplitCategoryParams>>
   paymentStatus?: InputMaybe<PaymentStatus>
   paymentTowards?: InputMaybe<Scalars['String']>
   pipelineStages?: InputMaybe<Array<PipelineStageValuesParams>>
   recordStageId?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
}

export type UpdateNodeRequestPaymentResponse =
   | ApplicationDisplayStageNotFound
   | ApplicationDisplayStagesNotFound
   | DuplicatePipelineIds
   | FieldsAreNotSupportedInAutomationWorkflow
   | FormulaEvaluationLogicFailed
   | FormulaSyntaxError
   | NodeNotFound
   | NotApplicationDisplayStage
   | NotApplicationDisplayStages
   | NotEditableNode
   | NotPipelineStages
   | NotRequestPaymentNodeType
   | NotSupportedFieldTypesForAmountFormulaExp
   | PaymentAmountMustBeGreaterThanZero
   | PaymentGatewayCodeNotFound
   | RecordStageMustNotApplicationDisplayStage
   | RequestPaymentNode
   | StageNotFound
   | StagesNotFound
   | UnSupportedNodeForPipelineItemTypes
   | UnsupportedFieldFormatsInFormulaValue
   | UserIsNotAnAdministrator

export type UpdateNodeRequestPaymentWithFeeRulesParams = {
   expiryInDays?: InputMaybe<Scalars['Int']>
   feePaymentOrderCreationConfigIds?: InputMaybe<Array<Scalars['String']>>
   nodeId: Scalars['String']
   numberOfInstallments?: InputMaybe<NumberOfInstallmentsConfigParams>
   paymentRuleSetId?: InputMaybe<Scalars['String']>
   paymentStatus?: InputMaybe<PaymentStatus>
   paymentTowards?: InputMaybe<Scalars['String']>
   referenceId?: InputMaybe<Scalars['String']>
}

export type UpdateNodeRequestPaymentWithFeeRulesResponse =
   | FeePaymentOrderCreationConfigsNotFound
   | FieldsAreNotSupportedInAutomationWorkflow
   | NodeNotFound
   | NotEditableNode
   | NotRequestPaymentWithFeeRulesNodeType
   | PaymentRuleSetNotFound
   | RequestPaymentWithFeeRulesNode
   | UnSupportedNodeForPipelineItemTypes
   | UserIsNotAnAdministrator

export type UpdateNodeSendDataToSegmentParams = {
   eventType?: InputMaybe<SegmentEventType>
   identifyEvent?: InputMaybe<IdentifyEventConfigParams>
   nodeId: Scalars['String']
   trackEvent?: InputMaybe<TrackEventConfigParams>
   writeKeyParameterId?: InputMaybe<Scalars['String']>
}

export type UpdateNodeSendDataToSegmentResponse =
   | DuplicateIdentifyEventIntegrationKeys
   | DuplicatePropertiesKeys
   | DuplicateTrackEventIntegrationKeys
   | DuplicateTraitKeys
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidIdentifyEventTimeStampConfig
   | InvalidIdentifyEventUniqueIdConfig
   | InvalidTrackEventTimeStampConfig
   | InvalidTrackEventUniqueIdConfig
   | NodeNotFound
   | NotActivityTemplateFieldIds
   | NotEditableNode
   | NotEventBasedTriggerForStageFields
   | NotLeadTemplateFieldIds
   | NotSendDataToSegmentNode
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | ParameterIdNotFound
   | PayloadIsNotSupportedInScheduledTrigger
   | SendDataToSegmentNode
   | UnSupportedTriggerNodeType
   | UserIsNotAnAdministrator

export type UpdateNodeSendPipelineItemNotificationParams = {
   assigneeFieldsToNotify: Array<NotificationNodeAssigneeFieldConfigParams>
   description?: InputMaybe<Scalars['String']>
   enableVariablesMapping?: InputMaybe<Scalars['Boolean']>
   nodeId: Scalars['String']
   notifyApplicationCustomer?: InputMaybe<Scalars['Boolean']>
   title?: InputMaybe<Scalars['String']>
   variableMappings?: InputMaybe<
      Array<InputMaybe<AwCustomVariableFieldMappingParams>>
   >
}

export type UpdateNodeSendPipelineItemNotificationResponse =
   | AwVariablesNotDefined
   | DirectValueIsNotSupportedInNotificationNodeFieldMapping
   | DuplicateAwVariablesMapping
   | DuplicateNotificationNodeAssigneeFields
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidManagerLevels
   | NodeNotFound
   | NotAssigneeFieldIds
   | NotEditableNode
   | NotificationDescriptionFieldsLimitExceeded
   | NotificationDescriptionLengthExceeded
   | NotificationTitleFieldsLimitExceeded
   | NotificationTitleLengthExceeded
   | NotifyApplicationCustomerNotSupportedForPipeline
   | PhoneNumberValueFormatIsNotSupportedForFields
   | SendPipelineItemNotificationNode
   | UnSupportedFieldFormatInNotificationNode
   | UserIsNotAnAdministrator

export type UpdateNodeSendWhatsAppMessageNodeParams = {
   nodeId: Scalars['String']
   notifyApplicationArchitect?: InputMaybe<Scalars['Boolean']>
   notifyApplicationCustomer?: InputMaybe<Scalars['Boolean']>
   phoneNumberField?: InputMaybe<AutomationWorkflowFieldValueMappingParams>
   phoneNumberFields?: InputMaybe<
      Array<InputMaybe<AutomationWorkflowFieldValueMappingParams>>
   >
   variableMappings?: InputMaybe<
      Array<InputMaybe<AwCustomVariableFieldMappingParams>>
   >
   whatsappBusinessPhoneNumberId?: InputMaybe<Scalars['String']>
   whatsappMessageTemplateId?: InputMaybe<Scalars['String']>
}

export type UpdateNodeSendWhatsAppMessageNodeResponse =
   | AccountPluginIsDisabled
   | DirectValueIsNotSupportedForPhoneNumberField
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidPhoneNumber
   | NodeNotFound
   | NotEditableNode
   | NotPipelineItemAssigneeField
   | NotPipelineItemTemplatePhoneNumberField
   | NotSupportedSalesTemplateFields
   | NotUpdateSendWhatsAppMessageNodeType
   | NotUserPropertiesTemplatePhoneNumberField
   | NotifyApplicationArchitectNotSupportedForPipeline
   | NotifyApplicationCustomerNotSupportedForPipeline
   | PhoneNumberValueFormatIsNotValid
   | PluginServiceAccountIsNotActive
   | SendWhatsAppMessageNode
   | UpRefAssigneeFieldIsRequired
   | UserIsNotAnAdministrator
   | WhatsAppBusinessPhoneNumberNotFound
   | WhatsAppBusinessPhoneNumberNotLinkedToPipeline
   | WhatsAppMessageTemplateNotFound
   | WhatsAppMessageTemplateVariablesNotFound
   | WhatsAppMsgTemplateAndBusinessPhoneNumberNotLinkedToSameAccount
   | WhatsAppMsgTemplateVariableNamesNotFound

export type UpdateNodeSignDocumentNodeParams = {
   copyDocumentUrlToField?: InputMaybe<Scalars['String']>
   documentTemplateId?: InputMaybe<Scalars['String']>
   documentVersionState?: InputMaybe<DocumentVersionState>
   nodeId: Scalars['String']
   signFieldMappings?: InputMaybe<Array<AwDocumentSignFieldMappingParams>>
   title?: InputMaybe<GenerateDocumentTitleParams>
}

export type UpdateNodeSignDocumentNodeResponse =
   | DocumentTemplateIsDeleted
   | DocumentTemplateNotFound
   | DuplicateSignFieldsMapping
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidAssigneeIds
   | NodeNotFound
   | NotAssigneeFieldIds
   | NotEditableNode
   | NotFileUploaderField
   | SignDocumentNode
   | SignatureFieldsNotFound
   | UserIsNotAnAdministrator

export type UpdateNodeSwiftsellOutboundWebhookParams = {
   authorizationToken?: InputMaybe<Scalars['String']>
   customAttributes: Array<CustomKeyFieldValueMappingParams>
   fixedAttributes?: InputMaybe<
      SwiftsellOutboundWebhookNodeFixedAtrributesParams
   >
   nodeId: Scalars['String']
   webhookUrl?: InputMaybe<Scalars['String']>
}

export type UpdateNodeSwiftsellOutboundWebhookResponse =
   | DirectValueIsNotSupportedForSwiftsellFixedIdentificationAttributes
   | DuplicateSwiftsellCustomAttributes
   | EmailReferenceFieldMustBeIdentifierEmail
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidWebhookUrl
   | NodeNotFound
   | NotEditableNode
   | NotSwiftsellOutboundWebhookNodeType
   | ParameterIdsNotFound
   | PhoneNumberReferenceFieldMustBeIdentifierPhoneNumber
   | PhoneNumberValueFormatIsNotSupportedForFields
   | SwiftsellOutboundWebhookNode
   | UserIsNotAnAdministrator

export type UpdateNodeUpdateDisplayStageParams = {
   nodeId: Scalars['String']
   stageFieldResponses?: InputMaybe<Array<InputMaybe<StageFieldResponseParams>>>
   stageId?: InputMaybe<Scalars['String']>
}

export type UpdateNodeUpdateDisplayStageResponse =
   | ApplicationDisplayStageNotFound
   | DuplicateStageFieldIds
   | NodeNotFound
   | NotApplicationDisplayStage
   | NotApplicationDisplayStages
   | NotDisplayStageFieldIds
   | NotEditableNode
   | NotSupportedStageForStageFieldIds
   | NotUpdateDisplayStageNodeType
   | StageNotInPipeline
   | UpdateDisplayStageNode
   | UserIsNotAnAdministrator

export type UpdateNodeUpdateLeadParams = {
   fieldIdsToClear?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   fieldsMapping: Array<ComputedUpdateFieldValueMappingParams>
   nodeId: Scalars['String']
}

export type UpdateNodeUpdateLeadResponse =
   | DirectValueNotSupportedOnUniqueFields
   | DuplicateFieldIds
   | FieldClearingNotAllowed
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormulaEvaluationLogicFailedInField
   | InvalidComputedValueConfigFormat
   | InvalidFieldValuesErrors
   | InvalidHoursForComputedValueConfig
   | InvalidMinutesForComputedValueConfig
   | InvalidValuesForRelativeFieldSourceTypes
   | NodeNotFound
   | NotActivityTemplateFieldIds
   | NotCompatibleValueFieldIds
   | NotEditableNode
   | NotEventBasedTriggerForStageFields
   | NotLeadTemplateFieldIds
   | NotSupportedComputedUpdateConfigForFields
   | NotSupportedRelativeValuesForFields
   | NotSupportedSystemFields
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadNodeType
   | NotUpdateLeadStageTriggerForStageFields
   | PayloadIsNotSupportedInScheduledTrigger
   | UnSupportedFieldsForEnableDeepCopy
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UpRefAssigneeFieldsAreRequiredForFields
   | UpRefFieldsAreNotAssigneeFields
   | UpdateLeadNode
   | UserIsNotAnAdministrator

export type UpdateNodeUpdateLeadStageParams = {
   nodeId: Scalars['String']
   stageFieldResponses?: InputMaybe<Array<InputMaybe<StageFieldResponseParams>>>
   stageId?: InputMaybe<Scalars['String']>
}

export type UpdateNodeUpdateLeadStageResponse =
   | DuplicateStageFieldIds
   | NodeNotFound
   | NotEditableNode
   | NotStageFieldIds
   | NotSupportedStageForStageFieldIds
   | NotUpdateLeadStageNodeType
   | StageNotFound
   | StageNotInPipeline
   | StagesNotFound
   | UpdateLeadStageNode
   | UserIsNotAnAdministrator

export type UpdateNodeUpdatePipelineItemAssigneeParams = {
   assigneeFieldId?: InputMaybe<Scalars['String']>
   assigneeFieldIdsToNotify?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   assigneeSelectionType?: InputMaybe<
      UpdatePipelineItemAssigneeNodeAssigneeSelectionType
   >
   assigneeUserId?: InputMaybe<Scalars['String']>
   dynamicAssigneeConfig?: InputMaybe<
      UpdateAssigneeNodeDynamicAssigneeConfigParams
   >
   managerFields: Array<UpdateAssigneeNodeManagerFieldParams>
   nodeId: Scalars['String']
   overrideAssignee?: InputMaybe<Scalars['Boolean']>
   referenceAssigneeConfig?: InputMaybe<
      UpdateAssigneeNodeReferenceAssigneeConfigParams
   >
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdateNodeUpdatePipelineItemAssigneeResponse =
   | AccessDeniedToUser
   | DeactivatedUser
   | DirectValueNotSupportedForReferenceAssigneeConfig
   | DuplicateAssigneeFieldIdsToNotify
   | DuplicateManagerFieldIds
   | InvalidAssigneeFieldIdsToNotify
   | InvalidDynamicAssigneeConditionConfig
   | InvalidManagerFieldIds
   | InvalidManagerFieldsLevel
   | NodeNotFound
   | NotEditableNode
   | NotUpdatePipelineItemAssigneeNode
   | PipelineItemAssigneeAccessDenied
   | PipelineItemAssigneeFieldCanNotBeManagerField
   | PipelineItemAssigneeFieldNotFound
   | PipelineItemAssigneeIsDeactivated
   | PipelineItemAssigneeNotFound
   | ReferenceAssigneeConfigFieldShouldBeAssigneeField
   | UpdatePipelineItemAssigneeNode
   | UserIsNotAnAdministrator
   | UserNotFound

export type UpdateNodeUpdateRelatedRecordsParams = {
   fields: Array<ComputedUpdateFieldValueMappingParams>
   nodeId: Scalars['String']
}

export type UpdateNodeUpdateRelatedRecordsResponse =
   | DirectValueNotSupportedOnUniqueFields
   | DuplicateFieldIds
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | FormulaEvaluationLogicFailedInField
   | InvalidComputedValueConfigFormat
   | InvalidFieldValuesErrors
   | InvalidHoursForComputedValueConfig
   | InvalidMinutesForComputedValueConfig
   | InvalidValuesForRelativeFieldSourceTypes
   | NodeNotFound
   | NotApplicationDisplayStages
   | NotCompatibleValueFieldIds
   | NotEditableNode
   | NotEventBasedTriggerForStageFields
   | NotRecordStages
   | NotRelatedPipelineTemplateFields
   | NotSupportedComputedUpdateConfigForFields
   | NotSupportedRelativeValuesForFields
   | NotSupportedSystemFields
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | NotUpdateRelatedRecordsNodeType
   | PayloadIsNotSupportedInScheduledTrigger
   | StageFieldsCannotHaveEmptyResponse
   | StagesNotFound
   | StagesNotInPipeline
   | UnSupportedFieldValueSourcesForStageFields
   | UnSupportedFieldsForEnableDeepCopy
   | UniqueFieldsAreNotSupportedForMultiCardinalityRelation
   | UnsupportedFieldFormatsInFormulaFieldValue
   | UpdateRelatedRecordsNode
   | UserIsNotAnAdministrator

export type UpdateNodeUpdateTaskParams = {
   assignee?: InputMaybe<TaskAssigneeEnum>
   assigneeFieldId?: InputMaybe<Scalars['String']>
   discardTask?: InputMaybe<Scalars['Boolean']>
   nodeId: Scalars['String']
   startDate?: InputMaybe<StartDateValueConfigParams>
   startTime?: InputMaybe<StartTimeValueConfigParams>
}

export type UpdateNodeUpdateTaskResponse =
   | DuplicateFieldIds
   | FieldsAreDeleted
   | FieldsAreNotSupportedInAutomationWorkflow
   | FieldsNotFound
   | InvalidDateResponseFormat
   | InvalidTimeResponseFormat
   | NodeNotFound
   | NotActivityTemplateFieldIds
   | NotCompatibleValueFieldIds
   | NotEditableNode
   | NotEventBasedTriggerForStageFields
   | NotLeadTemplateFieldIds
   | NotTaskTemplateFieldIds
   | NotTriggerPayloadFieldSourceForStageFields
   | NotUpdateLeadStageTriggerForStageFields
   | PayloadIsNotSupportedInScheduledTrigger
   | StartDateConfigIsRequired
   | UpdateTaskNode
   | UserIsNotAnAdministrator
   | ValueFieldSourceIsRequired
   | ValueIsRequired

export type UpdateNotAllowedToExecType = GraphQlBaseError & {
   __typename?: 'UpdateNotAllowedToExecType'
   execType: AutomationWorkflowExecType
   message?: Maybe<Scalars['String']>
}

export type UpdateObjectionApplicationObservationParams = {
   objectionId: Scalars['String']
   recommendation?: InputMaybe<BpsVerificationRecommendationEnum>
   remarks?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: TaskVerificationFieldProperty
}

export type UpdateObjectionApplicationObservationResponse =
   | TaskAccessDenied
   | TaskTemplateAccessDenied
   | TaskVerificationNotExists
   | UpdateObjectionApplicationObservationResult

export type UpdateObjectionApplicationObservationResult = {
   __typename?: 'UpdateObjectionApplicationObservationResult'
   objectionId: Scalars['String']
   recommendation?: Maybe<BpsVerificationRecommendationEnum>
   remarks?: Maybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: TaskVerificationFieldProperty
}

export type UpdateOptionsVisibilityRulesStatusForFieldParams = {
   fieldId: Scalars['String']
   isOptionsVisibilityRulesEnabled: Scalars['Boolean']
}

export type UpdateOptionsVisibilityRulesStatusForFieldResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | LinkedFieldUpdateRestricted
   | NotSupportedOptionsVisibilityRulesForAddAnotherField
   | NotSupportedOptionsVisibilityRulesForField
   | UpdateOptionsVisibilityRulesStatusForFieldResult
   | UserIsNotAnAdministrator

export type UpdateOptionsVisibilityRulesStatusForFieldResult = {
   __typename?: 'UpdateOptionsVisibilityRulesStatusForFieldResult'
   fieldId: Scalars['String']
   isConditionalOptionsCleared: Scalars['Boolean']
   isOptionsVisibilityRulesEnabled: Scalars['Boolean']
   optionsValueType: OptionsValueType
}

export type UpdateOrCreateStageTransitionCheckpointParams = {
   checkpointId?: InputMaybe<Scalars['String']>
   description: Scalars['String']
   stageTransitionId: Scalars['String']
}

export type UpdateOrCreateStageTransitionCheckpointResponse =
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | NotAssigneeFieldIds
   | NotSupportedSalesTemplateFields
   | NotUserPropertyFieldIds
   | PlaceholdersNotFound
   | StageTransitionCheckpoint
   | StageTransitionCheckpointNotFound
   | StageTransitionNotFound
   | UserIsNotAnAdministrator

export type UpdateParameterConditionParams = {
   conditionId: Scalars['String']
   operator: ScoringConditionOperator
   score: Scalars['Float']
   value?: InputMaybe<Scalars['String']>
}

export type UpdateParameterConditionResponse =
   | ConditionOperatorIsNotSupportedForField
   | ConditionScoreOutOfRange
   | InvalidConditionValue
   | InvalidFieldOptions
   | ParameterCondition
   | ParameterConditionNotFound
   | UserIsNotAnAdministrator

export type UpdateParameterKeyParams = {
   key: Scalars['String']
   parameterId: Scalars['String']
}

export type UpdateParameterKeyResponse =
   | ParameterIdNotFound
   | ParameterKeyAlreadyExistsInAccount
   | ParameterKeyCanNotBeEmpty
   | UpdateParameterKeyResult
   | UserIsNotAnAdministrator

export type UpdateParameterKeyResult = {
   __typename?: 'UpdateParameterKeyResult'
   key: Scalars['String']
   parameterId: Scalars['String']
}

export type UpdateParameterParams = {
   key: Scalars['String']
   parameterId: Scalars['String']
   value: Scalars['String']
}

export type UpdateParameterResponse =
   | Parameter
   | ParameterIdNotFound
   | ParameterKeyAlreadyExistsInAccount
   | ParameterKeyCanNotBeEmpty
   | ParameterValueCanNotBeEmpty
   | UserIsNotAnAdministrator

export type UpdateParentFieldForDependentFieldParams = {
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldId: Scalars['String']
}

export type UpdateParentFieldForDependentFieldResponse =
   | BothFieldsCannotBeSame
   | CannotEditSystemField
   | CircularParentIsNotAllowed
   | DependentFieldNotFound
   | DependentFieldsMustBeOfSameGoF
   | FieldIsDeleted
   | FieldNotFound
   | NotDependentField
   | OptionsShouldNotBeEmpty
   | ParentFieldIsNotFieldSelector
   | ParentFieldNotFound
   | ParentOptionsShouldBeInExistingOptions
   | UpdateParentFieldForDependentFieldResult
   | UserIsNotAnAdministrator

export type UpdateParentFieldForDependentFieldResult = {
   __typename?: 'UpdateParentFieldForDependentFieldResult'
   fieldId: Scalars['String']
   options: Array<Scalars['String']>
   parentFieldId: Scalars['String']
}

export type UpdatePaymentStatusOnUserActionParams = {
   action?: InputMaybe<PaymentActionEnum>
   paymentId: Scalars['String']
   pipelineItemId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type UpdatePaymentStatusOnUserActionResponse =
   | NotAllowedActionOnPayment
   | Payment
   | PaymentAccessDenied
   | PaymentNotFound
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound

export type UpdatePhoneNumberFieldOtpVerificationEnabledValueParams = {
   enableOtpVerification: Scalars['Boolean']
   fieldId: Scalars['String']
}

export type UpdatePhoneNumberFieldOtpVerificationEnabledValueResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotPhoneNumberField
   | UpdatePhoneNumberFieldOtpVerificationEnabledValueResult
   | UserIsNotAnAdministrator

export type UpdatePhoneNumberFieldOtpVerificationEnabledValueResult = {
   __typename?: 'UpdatePhoneNumberFieldOtpVerificationEnabledValueResult'
   enableOtpVerification: Scalars['Boolean']
   fieldId: Scalars['String']
}

export type UpdatePieChartParams = {
   dataLabelsType: GraphDataLabelsType
   description?: InputMaybe<Scalars['String']>
   graphId: Scalars['String']
   name: Scalars['String']
   numberOfSlices: Scalars['Int']
}

export type UpdatePieChartResponse =
   | GraphNameIsRequired
   | GraphNotFound
   | NotPieChart
   | PipelineAccessDenied
   | UpdatePieChartResult
   | UserIsNotAnAdministrator

export type UpdatePieChartResult = {
   __typename?: 'UpdatePieChartResult'
   dataLabelsType: GraphDataLabelsType
   description?: Maybe<Scalars['String']>
   graphId: Scalars['String']
   name: Scalars['String']
   numberOfSlices: Scalars['Int']
}

export type UpdatePipelineCustomObjectAddAnotherFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   customObjectId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type UpdatePipelineCustomObjectAddAnotherFieldResponse =
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GoFResponseIdNotFound
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAddAnotherGoFField
   | NotAddAnotherGoFResponseField
   | NotAllowedFileFormats
   | NotPipelineCustomObjectAddAnotherGoFResponse
   | ParentFieldNotFilled
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UpdateFieldResponseResult

export type UpdatePipelineCustomObjectAssigneeBulkParams = {
   fieldId: Scalars['String']
   pipelineCustomObjectIds: Array<Scalars['String']>
   response: Scalars['String']
   sendNotification?: InputMaybe<Scalars['Boolean']>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdatePipelineCustomObjectAssigneeBulkResponse =
   | AccountAccessDeniedToAssignee
   | FieldIsDeleted
   | FieldNotFound
   | NeedFieldWritePermission
   | NotPipelineCustomObjectAssigneeField
   | PipelineAccessDeniedToAssignee
   | PipelineCustomObjectAssigneeIsDeactivated
   | PipelineCustomObjectAssigneeNotFound
   | PipelineCustomObjectsAccessDenied
   | PipelineCustomObjectsAreDeleted
   | PipelineCustomObjectsNotFound
   | UpdatePipelineCustomObjectAssigneeBulkResult
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdatePipelineCustomObjectAssigneeBulkResult = {
   __typename?: 'UpdatePipelineCustomObjectAssigneeBulkResult'
   customObjFields: Array<PipelineCustomObjectFieldResponse>
}

export type UpdatePipelineCustomObjectFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   fieldId: Scalars['String']
   pipelineCustomObjectId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
   syncAssigneeHierarchy?: InputMaybe<Scalars['Boolean']>
}

export type UpdatePipelineCustomObjectFieldResponse =
   | AddAnotherFieldsAreNotSupported
   | AtLeastOneCustomObjectIdentificationFieldIsRequired
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotPipelineCustomObjectField
   | ParentFieldNotFilled
   | PipelineAccessDeniedToAssignee
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectAssigneeIsDeactivated
   | PipelineCustomObjectAssigneeNotFound
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | UniqueFieldResponseAlreadyExists
   | UpdateFieldResponseResult
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdatePipelineDisplayNameParams = {
   displayName: Scalars['String']
   pipelineId: Scalars['String']
}

export type UpdatePipelineDisplayNameResponse =
   | PipelineDisplayNameAlreadyExistsInAccount
   | PipelineNotFound
   | UpdatePipelineDisplayNameResult
   | UserIsNotAnAdministrator

export type UpdatePipelineDisplayNameResult = {
   __typename?: 'UpdatePipelineDisplayNameResult'
   displayName: Scalars['String']
   pipelineId: Scalars['String']
}

export type UpdatePipelineEventLeadCreationConfig = {
   stageId: Scalars['String']
}

export type UpdatePipelineEventPipelineItemCreationConfigParams = {
   pipelineEventTemplateId: Scalars['String']
   stageId: Scalars['String']
}

export type UpdatePipelineEventPipelineItemCreationConfigResponse =
   | PipelineEventTemplateAndStageAreNotInSamePipeline
   | PipelineEventTemplateNotFound
   | StageNotFound
   | UpdatePipelineEventPipelineItemCreationConfigResult
   | UserIsNotAnAdministrator

export type UpdatePipelineEventPipelineItemCreationConfigResult = {
   __typename?: 'UpdatePipelineEventPipelineItemCreationConfigResult'
   pipelineEventTemplateId: Scalars['String']
   stageId: Scalars['String']
}

export type UpdatePipelineEventTemplateDescriptionParams = {
   description?: InputMaybe<Scalars['String']>
   pipelineEventTemplateId: Scalars['String']
}

export type UpdatePipelineEventTemplateDescriptionResponse =
   | PipelineEventTemplateNotFound
   | UpdatePipelineEventTemplateDescriptionResult
   | UserIsNotAnAdministrator

export type UpdatePipelineEventTemplateDescriptionResult = {
   __typename?: 'UpdatePipelineEventTemplateDescriptionResult'
   description?: Maybe<Scalars['String']>
   pipelineEventTemplateId: Scalars['String']
}

export type UpdatePipelineEventTemplateNameParams = {
   name: Scalars['String']
   pipelineEventTemplateId: Scalars['String']
}

export type UpdatePipelineEventTemplateNameResponse =
   | PipelineEventTemplateNameAlreadyExists
   | PipelineEventTemplateNotFound
   | UpdatePipelineEventTemplateNameResult
   | UserIsNotAnAdministrator

export type UpdatePipelineEventTemplateNameResult = {
   __typename?: 'UpdatePipelineEventTemplateNameResult'
   name: Scalars['String']
   pipelineEventTemplateId: Scalars['String']
}

export type UpdatePipelineEventTemplateParams = {
   description?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   pipelineEventTemplateId: Scalars['String']
   pipelineItemCreationConfig: UpdatePipelineEventLeadCreationConfig
}

export type UpdatePipelineEventTemplateResponse =
   | PipelineEventTemplateNameAlreadyExists
   | PipelineEventTemplateNotFound
   | StageNotFound
   | StageNotInPipeline
   | UpdatePipelineEventTemplateResult
   | UserIsNotAnAdministrator

export type UpdatePipelineEventTemplateResult = {
   __typename?: 'UpdatePipelineEventTemplateResult'
   description?: Maybe<Scalars['String']>
   name: Scalars['String']
   pipelineEventTemplateId: Scalars['String']
   pipelineItemCreationConfig: PipelineEventPipelineItemCreationConfig
}

export type UpdatePipelineIconParams = {
   color?: InputMaybe<Scalars['String']>
   pipelineIconId?: InputMaybe<Scalars['String']>
   pipelineId: Scalars['String']
}

export type UpdatePipelineIconResponse =
   | PipelineNotFound
   | UpdatePipelineIconResult
   | UserIsNotAnAdministrator

export type UpdatePipelineIconResult = {
   __typename?: 'UpdatePipelineIconResult'
   color?: Maybe<Scalars['String']>
   pipelineIconId?: Maybe<Scalars['String']>
}

export enum UpdatePipelineItemAssigneeFilterSetOperator {
   Eq = 'EQ'
}

export type UpdatePipelineItemAssigneeNode = BaseNode & {
   __typename?: 'UpdatePipelineItemAssigneeNode'
   applyFiltersOn?: Maybe<ApplyAutomationWorkflowsFiltersOn>
   assigneeFieldId?: Maybe<Scalars['String']>
   assigneeFieldIdsToNotify: Array<Scalars['String']>
   assigneeSelectionType?: Maybe<
      UpdatePipelineItemAssigneeNodeAssigneeSelectionType
   >
   assigneeUser?: Maybe<BaseUser>
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   dynamicAssigneeConfig?: Maybe<UpdateAssigneeNodeDynamicAssigneeConfig>
   filterSetId?: Maybe<Scalars['String']>
   managerFields: Array<UpdatePipelineItemAssigneeNodeManagerField>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   overrideAssignee?: Maybe<Scalars['Boolean']>
   referenceAssigneeConfig?: Maybe<UpdateAssigneeNodeReferenceAssigneeConfig>
   syncAssigneeHierarchy?: Maybe<Scalars['Boolean']>
}

export enum UpdatePipelineItemAssigneeNodeAssigneeSelectionType {
   Dynamic = 'DYNAMIC',
   Fixed = 'FIXED',
   Reference = 'REFERENCE'
}

export type UpdatePipelineItemAssigneeNodeDynamicUpdateExecLog = {
   __typename?: 'UpdatePipelineItemAssigneeNodeDynamicUpdateExecLog'
   assignedManagers: Array<UpdatePipelineItemAssigneeNodeManagerExecLog>
   assignedUser?: Maybe<BaseUser>
   assignedUserType?: Maybe<UpdatePipelineItemAssigneeNodeDynamicUserType>
   assigneeHierarchy: Array<AwAssigneeHierarchyLog>
   isAssigneeUpdated: Scalars['Boolean']
}

export enum UpdatePipelineItemAssigneeNodeDynamicUserType {
   FallbackUser = 'FALLBACK_USER',
   FilteredUser = 'FILTERED_USER'
}

export type UpdatePipelineItemAssigneeNodeExecLog = BaseNodeExecLog & {
   __typename?: 'UpdatePipelineItemAssigneeNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<UpdatePipelineItemAssigneeNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type UpdatePipelineItemAssigneeNodeExecLogResult =
   | UpdatePipelineItemAssigneeNodeDynamicUpdateExecLog
   | UpdatePipelineItemAssigneeNodeFixedUpdateExecLog
   | UpdatePipelineItemAssigneeNodeReferenceUpdateExecLog

export type UpdatePipelineItemAssigneeNodeFixedUpdateExecLog = {
   __typename?: 'UpdatePipelineItemAssigneeNodeFixedUpdateExecLog'
   assignedManagers: Array<UpdatePipelineItemAssigneeNodeManagerExecLog>
   assignedUser?: Maybe<BaseUser>
   assigneeHierarchy: Array<AwAssigneeHierarchyLog>
   isAssigneeUpdated: Scalars['Boolean']
}

export type UpdatePipelineItemAssigneeNodeManagerExecLog = {
   __typename?: 'UpdatePipelineItemAssigneeNodeManagerExecLog'
   assignedUser?: Maybe<BaseUser>
   managerFieldId: Scalars['String']
}

export type UpdatePipelineItemAssigneeNodeManagerField = {
   __typename?: 'UpdatePipelineItemAssigneeNodeManagerField'
   level: Scalars['Int']
   managerFieldId: Scalars['String']
}

export type UpdatePipelineItemAssigneeNodeReferenceUpdateExecLog = {
   __typename?: 'UpdatePipelineItemAssigneeNodeReferenceUpdateExecLog'
   assignedManagers: Array<UpdatePipelineItemAssigneeNodeManagerExecLog>
   assignedUser?: Maybe<BaseUser>
   assignedUserType?: Maybe<UpdatePipelineItemAssigneeNodeReferenceUserType>
   assigneeHierarchy: Array<AwAssigneeHierarchyLog>
   isAssigneeUpdated: Scalars['Boolean']
}

export enum UpdatePipelineItemAssigneeNodeReferenceUserType {
   FallbackUser = 'FALLBACK_USER',
   ReferenceUser = 'REFERENCE_USER'
}

export type UpdatePipelineItemPaymentRequestParams = {
   customRuleIds: Array<Scalars['String']>
   paymentRequestId: Scalars['String']
   ruleSetId: Scalars['String']
   ruleWiseEdits: Array<PipelineItemPaymentRuleEditsParams>
}

export type UpdatePipelineItemPaymentRequestResponse =
   | PaymentAmountMustBeGreaterThanZero
   | PaymentRequestNotFound
   | PaymentRuleSetNotFound
   | PaymentRulesNotFound
   | PipelineItemAccessDenied
   | PipelineItemPaymentRequest
   | PipelineItemPaymentRulesWereNotSatisfied

export type UpdatePipelineItemRemarksParams = {
   attachments?: InputMaybe<Array<RemarksAttachmentParams>>
   pipelineItemRemarksId: Scalars['String']
   remarks?: InputMaybe<Scalars['String']>
   updateProperty?: InputMaybe<RemarksFieldProperty>
}

export type UpdatePipelineItemRemarksResponse =
   | CannotUpdateRemarksAddedByOtherUser
   | PipelineItemAccessDenied
   | PipelineItemRemarks
   | PipelineItemRemarksCannotBeEmpty
   | PipelineItemRemarksIdNotFound

export type UpdatePipelineItemReminderParams = {
   reminderAt: Scalars['String']
   reminderId: Scalars['String']
   reminderText: Scalars['String']
}

export type UpdatePipelineItemReminderResponse =
   | PipelineItemReminder
   | PipelineItemReminderAccessDenied
   | PipelineItemReminderNotFound
   | ReminderAtShouldNotBePreviousDateTime

export type UpdatePipelineItemScheduleParams = {
   deleteEventFromCalendar?: InputMaybe<Scalars['Boolean']>
   pipelineId?: InputMaybe<Scalars['String']>
   pipelineItemScheduledId: Scalars['String']
   remindersInMins: Array<Scalars['Int']>
   scheduledDatetime: Scalars['String']
   title?: InputMaybe<Scalars['String']>
}

export type UpdatePipelineItemScheduleResponse =
   | GoogleAuthConsentNotGiven
   | GoogleAuthConsentRefreshRequired
   | GoogleCalendarApiRequestsQuotaExceeded
   | PipelineItemScheduleAccessDenied
   | PipelineItemScheduleIsAlreadyCompleted
   | PipelineItemScheduleNotFound
   | RemindersInMinsCannotBeNegative
   | RemindersLimitExceeded
   | ScheduledDatetimeMustBeInFuture
   | ScheduledPipelineItem
   | ScheduledReminderMustBeInFuture
   | ScheduledRemindersMustBeInFuture

export type UpdatePipelineNameParams = {
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type UpdatePipelineNameResponse =
   | PipelineNameAlreadyExistsInAccount
   | PipelineNameIsRequired
   | PipelineNotFound
   | UpdatePipelineNameResult
   | UserIsNotAnAdministrator

export type UpdatePipelineNameResult = {
   __typename?: 'UpdatePipelineNameResult'
   name: Scalars['String']
   pipelineId: Scalars['String']
}

export type UpdatePipelineSettingsParams = {
   pipelineId: Scalars['String']
   updateProperty: PipelineSettingsProperty
}

export type UpdatePipelineSettingsResponse =
   | PipelineNotFound
   | UpdatePipelineSettingsResult
   | UserIsNotAnAdministrator

export type UpdatePipelineSettingsResult = {
   __typename?: 'UpdatePipelineSettingsResult'
   pipelineId: Scalars['String']
   updateProperty: PipelineSettingsProperty
}

export type UpdatePipelineStageBoardsOwnerParams = {
   ownerId: Scalars['String']
   pipelineId: Scalars['String']
}

export type UpdatePipelineStageBoardsOwnerResponse =
   | OwnerIsNotAnAdministrator
   | OwnerNotFound
   | PipelineNotFound
   | UpdatePipelineStageBoardsOwnerResult
   | UserIsNotAnAdministrator

export type UpdatePipelineStageBoardsOwnerResult = {
   __typename?: 'UpdatePipelineStageBoardsOwnerResult'
   ownerId: Scalars['String']
   pipelineId: Scalars['String']
}

export type UpdatePipelineStageTransitionStyleParams = {
   pipelineId: Scalars['String']
   stageTransitionStyle: PipelineStageTransitionUiStyle
}

export type UpdatePipelineStageTransitionStyleResponse =
   | PipelineNotFound
   | UpdatePipelineStageTransitionStyleResult
   | UserIsNotAnAdministrator

export type UpdatePipelineStageTransitionStyleResult = {
   __typename?: 'UpdatePipelineStageTransitionStyleResult'
   pipelineId: Scalars['String']
   stageTransitionStyle: PipelineStageTransitionUiStyle
}

export type UpdatePipelineWhatsAppBusinessPhoneNumberParams = {
   gallaboxChannelId?: InputMaybe<Scalars['String']>
   phoneNumber: PhoneNumberParams
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
}

export type UpdatePipelineWhatsAppBusinessPhoneNumberResponse =
   | AccountPluginIsDisabled
   | GallaboxChannelIdIsRequired
   | InvalidWhatsAppBusinessPhoneNumber
   | NotAWhatsAppPluginServiceAccount
   | PipelineWhatsAppBusinessPhoneNumberAlreadyExists
   | PipelineWhatsAppBusinessPhoneNumberNotFound
   | UpdatePipelineWhatsAppBusinessPhoneNumberResult
   | UserIsNotAnAdministrator

export type UpdatePipelineWhatsAppBusinessPhoneNumberResult = {
   __typename?: 'UpdatePipelineWhatsAppBusinessPhoneNumberResult'
   phoneNumber?: Maybe<PhoneNumberResponse>
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
}

export type UpdatePipelineWhatsappConsentRequiredStatusParams = {
   isWhatsappConsentRequired: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type UpdatePipelineWhatsappConsentRequiredStatusResponse =
   | PipelineNotFound
   | UpdatePipelineWhatsappConsentRequiredStatusResult
   | UserIsNotAnAdministrator

export type UpdatePipelineWhatsappConsentRequiredStatusResult = {
   __typename?: 'UpdatePipelineWhatsappConsentRequiredStatusResult'
   isWhatsappConsentRequired: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type UpdatePivotGraphColumnDimensionParams = {
   dataSource: AnalyticsDataSourceType
   fieldId: Scalars['String']
   graphId: Scalars['String']
   groupByType: GraphAggType
   histogramInterval?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   ranges: Array<Range>
   sortValue?: InputMaybe<SortValue>
}

export type UpdatePivotGraphColumnDimensionResponse =
   | EmptyHistogramIntervalForHistogramGroupByType
   | EmptyRangesForRangeGroupByType
   | FieldIdNotInPipeline
   | FieldIsDeleted
   | FieldNotFound
   | GraphDimension
   | GraphNotFound
   | InvalidDateHistogramInterval
   | InvalidGraphFieldValue
   | NotSupportedFieldForGraphMetric
   | NotSupportedFieldForGraphSalesEntityType
   | RowAndColumnDimensionShouldNotHaveSameField
   | SalesTemplateIdNotInPipeline
   | UnSupportedDataSourceField
   | UnSupportedGroupByFieldDataSource
   | UnSupportedGroupByFieldType
   | UnSupportedGroupByTypeField
   | UnSupportedGroupByTypeFieldType
   | UserIsNotAnAdministrator

export type UpdatePivotGraphRowDimensionParams = {
   dataSource: AnalyticsDataSourceType
   fieldId: Scalars['String']
   graphId: Scalars['String']
   groupByType: GraphAggType
   histogramInterval?: InputMaybe<Scalars['String']>
   name: Scalars['String']
   ranges: Array<Range>
   sortValue?: InputMaybe<SortValue>
}

export type UpdatePivotGraphRowDimensionResponse =
   | EmptyHistogramIntervalForHistogramGroupByType
   | EmptyRangesForRangeGroupByType
   | FieldIdNotInPipeline
   | FieldIsDeleted
   | FieldNotFound
   | GraphDimension
   | GraphNotFound
   | InvalidDateHistogramInterval
   | InvalidGraphFieldValue
   | NotSupportedFieldForGraphSalesEntityType
   | RowAndColumnDimensionShouldNotHaveSameField
   | SalesTemplateIdNotInPipeline
   | UnSupportedDataSourceField
   | UnSupportedGroupByFieldDataSource
   | UnSupportedGroupByFieldType
   | UnSupportedGroupByTypeField
   | UnSupportedGroupByTypeFieldType
   | UserIsNotAnAdministrator

export type UpdatePivotTableGraphParams = {
   description?: InputMaybe<Scalars['String']>
   enableColumnTotals: Scalars['Boolean']
   enableRowTotals: Scalars['Boolean']
   graphId: Scalars['String']
   name: Scalars['String']
}

export type UpdatePivotTableGraphResponse =
   | GraphNameIsRequired
   | GraphNotFound
   | NotPivotTableGraph
   | PipelineAccessDenied
   | UpdatePivotTableGraphResult
   | UserIsNotAnAdministrator

export type UpdatePivotTableGraphResult = {
   __typename?: 'UpdatePivotTableGraphResult'
   description?: Maybe<Scalars['String']>
   enableColumnTotals: Scalars['Boolean']
   enableRowTotals: Scalars['Boolean']
   graphId: Scalars['String']
   name: Scalars['String']
}

export type UpdatePivotTableGraphTotalsConfigParams = {
   enableColumnTotals: Scalars['Boolean']
   enableRowTotals: Scalars['Boolean']
   graphId: Scalars['String']
}

export type UpdatePivotTableGraphTotalsConfigResponse =
   | GraphNotFound
   | UpdatePivotTableGraphTotalsConfigResult
   | UserIsNotAnAdministrator

export type UpdatePivotTableGraphTotalsConfigResult = {
   __typename?: 'UpdatePivotTableGraphTotalsConfigResult'
   enableColumnTotals: Scalars['Boolean']
   enableRowTotals: Scalars['Boolean']
   graphId: Scalars['String']
}

export type UpdatePlainTextFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdatePlainTextFieldDefaultValueResponse =
   | CannotEditSystemField
   | DefaultValueNotAllowedForUniqueField
   | FieldIsDeleted
   | FieldNotFound
   | NotPlainTextField
   | RegexValidationFailedForDefaultValue
   | UpdatePlainTextFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdatePlainTextFieldDefaultValueResult = {
   __typename?: 'UpdatePlainTextFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdatePlainTextFieldFormulaStatusParams = {
   fieldId: Scalars['String']
   formulaExpression?: InputMaybe<Scalars['String']>
   isFormulaEnabled: Scalars['Boolean']
}

export type UpdatePlainTextFieldFormulaStatusResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotEditSystemField
   | CannotEnableFormulaStatusInAddAnotherField
   | CannotEnableFormulaStatusOnUniqueField
   | FieldsAreDeleted
   | FieldsNotFound
   | FormulaExpressionIsRequired
   | FormulaFieldsAreNotAllowed
   | InvalidFormulaExpression
   | NotPlainTextField
   | NotSupportedFieldTypes
   | NotSupportedFields
   | SelfReferenceIsNotAllowedInFormulaExpression
   | UpdatePlainTextFieldFormulaStatusResult
   | UserIsNotAnAdministrator

export type UpdatePlainTextFieldFormulaStatusResult = {
   __typename?: 'UpdatePlainTextFieldFormulaStatusResult'
   fieldId: Scalars['String']
   formulaExpression?: Maybe<Scalars['String']>
   isFormulaEnabled: Scalars['Boolean']
}

export type UpdatePlainTextFieldValidationRegexParams = {
   fieldId: Scalars['String']
   regexErrorMessage?: InputMaybe<Scalars['String']>
   validationRegex?: InputMaybe<Scalars['String']>
}

export type UpdatePlainTextFieldValidationRegexResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | InvalidValidationRegex
   | LinkedFieldUpdateRestricted
   | NotPlainTextField
   | RegexValidationFailedForDefaultValue
   | RegexValidationFailedForLinkedFieldsDefaultValue
   | UpdatePlainTextFieldValidationRegexResult
   | UserIsNotAnAdministrator

export type UpdatePlainTextFieldValidationRegexResult = {
   __typename?: 'UpdatePlainTextFieldValidationRegexResult'
   fieldId: Scalars['String']
   regexErrorMessage?: Maybe<Scalars['String']>
   validationRegex?: Maybe<Scalars['String']>
}

export type UpdatePortalApplicationParams = {
   bgImageUrl?: InputMaybe<Scalars['String']>
   clearValues: Array<PortalApplicationConfigEnum>
   description?: InputMaybe<Scalars['String']>
   headerFieldIds?: InputMaybe<Array<Scalars['String']>>
   portalApplicationId: Scalars['String']
}

export type UpdatePortalApplicationResponse =
   | AddAnotherFieldsAreNotSupported
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidUrl
   | NotApplicationPipelineFieldIds
   | NotSupportedFieldTypes
   | PortalApplicationConfigValuesShouldBeEmpty
   | PortalApplicationNotFound
   | UpdatePortalApplicationResult
   | UserIsNotAnAdministrator

export type UpdatePortalApplicationResult = {
   __typename?: 'UpdatePortalApplicationResult'
   bgImageUrl?: Maybe<Scalars['String']>
   clearValues: Array<PortalApplicationConfigEnum>
   description?: Maybe<Scalars['String']>
   headerFieldIds?: Maybe<Array<Scalars['String']>>
   portalApplicationId: Scalars['String']
}

export type UpdatePortalApplicationStatusParams = {
   portalApplicationId: Scalars['String']
   status: PortalApplicationStatus
}

export type UpdatePortalApplicationStatusResponse =
   | PortalApplicationNotFound
   | UpdatePortalApplicationStatusResult
   | UserIsNotAnAdministrator

export type UpdatePortalApplicationStatusResult = {
   __typename?: 'UpdatePortalApplicationStatusResult'
   portalApplicationId: Scalars['String']
   status: PortalApplicationStatus
}

export type UpdatePortalBrandBgImageParams = {
   brandBgImg?: InputMaybe<FileUploaderUrlParams>
   portalId: Scalars['String']
}

export type UpdatePortalBrandBgImageResponse =
   | PortalBrandBgImageSizeLimitExceeded
   | PortalNotFound
   | UpdatePortalBrandBgImageResult
   | UserIsNotAnAdministrator

export type UpdatePortalBrandBgImageResult = {
   __typename?: 'UpdatePortalBrandBgImageResult'
   brandBgImg?: Maybe<FileUploaderUrlResponse>
   portalId: Scalars['String']
}

export type UpdatePortalBrandLogoParams = {
   brandLogo?: InputMaybe<FileUploaderUrlParams>
   portalId: Scalars['String']
}

export type UpdatePortalBrandLogoResponse =
   | PortalBrandLogoSizeLimitExceeded
   | PortalNotFound
   | UpdatePortalBrandLogoResult
   | UserIsNotAnAdministrator

export type UpdatePortalBrandLogoResult = {
   __typename?: 'UpdatePortalBrandLogoResult'
   brandLogo?: Maybe<FileUploaderUrlResponse>
   portalId: Scalars['String']
}

export type UpdatePortalDescriptionParams = {
   description?: InputMaybe<Scalars['String']>
   portalId: Scalars['String']
}

export type UpdatePortalDescriptionResponse =
   | PortalNotFound
   | UpdatePortalDescriptionResult
   | UserIsNotAnAdministrator

export type UpdatePortalDescriptionResult = {
   __typename?: 'UpdatePortalDescriptionResult'
   description?: Maybe<Scalars['String']>
   portalId: Scalars['String']
}

export type UpdatePortalParams = {
   brandBgImg?: InputMaybe<Scalars['String']>
   brandLogo?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   pipelineIdsConfig?: InputMaybe<PortalPipelineIdsConfigParams>
   portalId: Scalars['String']
   title: Scalars['String']
}

export type UpdatePortalResponse =
   | InvalidBrandBgImg
   | InvalidBrandLogo
   | Portal
   | PortalNotFound
   | UserIsNotAnAdministrator

export type UpdatePortalStatusParams = {
   portalId: Scalars['String']
   status: PortalStatus
}

export type UpdatePortalStatusResponse =
   | PortalNotFound
   | UpdatePortalStatusResult
   | UserIsNotAnAdministrator

export type UpdatePortalStatusResult = {
   __typename?: 'UpdatePortalStatusResult'
   portalId: Scalars['String']
   status: PortalStatus
}

export type UpdatePortalTitleParams = {
   portalId: Scalars['String']
   title: Scalars['String']
}

export type UpdatePortalTitleResponse =
   | PortalNotFound
   | UpdatePortalTitleResult
   | UserIsNotAnAdministrator

export type UpdatePortalTitleResult = {
   __typename?: 'UpdatePortalTitleResult'
   portalId: Scalars['String']
   title: Scalars['String']
}

export type UpdateRadioGroupFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateRadioGroupFieldDefaultValueResponse =
   | CannotEditSystemField
   | DefaultValueMustBeInGivenOptions
   | FieldIsDeleted
   | FieldNotFound
   | NotRadioGroupField
   | UpdateRadioGroupFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateRadioGroupFieldDefaultValueResult = {
   __typename?: 'UpdateRadioGroupFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export enum UpdateReconciliationRequestStatus {
   ApprovedForInitiation = 'APPROVED_FOR_INITIATION',
   Discarded = 'DISCARDED'
}

export type UpdateReconciliationRequestStatusParams = {
   requestId: Scalars['String']
   status: UpdateReconciliationRequestStatus
}

export type UpdateReconciliationRequestStatusResponse =
   | InvalidReconciliationRequestStatusTransition
   | ReconciliationRequest
   | ReconciliationRequestNotFound
   | UserIsNotAnAdministrator

export type UpdateRecordCreationConfigNameParams = {
   name: Scalars['String']
   recordCreationConfigId: Scalars['Int']
}

export type UpdateRecordCreationConfigNameResponse =
   | AdminRecordCreationConfig
   | RecordCreationConfigNameAlreadyExists
   | RecordCreationConfigNotFound
   | UserIsNotAnAdministrator

export type UpdateRelatedEntityAddAnotherFieldResponseParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   currentEntityId: Scalars['String']
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type UpdateRelatedEntityAddAnotherFieldResponseResult =
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GoFResponseIdNotFound
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAddAnotherGoFField
   | NotAllowedFileFormats
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | NotRelatedEntityTemplateField
   | ParentFieldNotFilled
   | RelatedEntitiesNotBelongsToRelation
   | RelatedEntityIsDeleted
   | RelatedEntityNotFound
   | RelationIsDeleted
   | RelationNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UpdateFieldResponseResult

export type UpdateRelatedEntityFieldResponseParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   currentEntityId: Scalars['String']
   fieldId: Scalars['String']
   relatedEntityId: Scalars['String']
   relationId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
}

export type UpdateRelatedEntityFieldResponseResult =
   | AtLeastOneCustomObjectIdentificationFieldIsRequired
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | ContactIsDeleted
   | ContactNotFound
   | CurrentEntityIsDeleted
   | CurrentEntityNotBelongsToRelation
   | CurrentEntityNotFound
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotPermittedCurrentEntity
   | NotPermittedCurrentEntityRelatedSalesTemplate
   | NotPermittedRelation
   | NotPipelineCustomObjectField
   | ParentFieldNotFilled
   | PipelineAccessDeniedToAssignee
   | PipelineCustomObjectAccessDenied
   | PipelineCustomObjectAssigneeIsDeactivated
   | PipelineCustomObjectAssigneeNotFound
   | PipelineCustomObjectIsDeleted
   | PipelineCustomObjectNotFound
   | RelatedEntitiesNotBelongsToRelation
   | RelationIsDeleted
   | RelationNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StageIsDeleted
   | StageNotFound
   | StageNotInPipeline
   | UniqueFieldResponseAlreadyExists
   | UpdateFieldResponseResult
   | UserNotHavePermissionToUpdateToGivenStage
   | YouDonNotHavePermissionToSetGivenUserAsAssignee

export type UpdateRelatedRecordsNode = BaseNode & {
   __typename?: 'UpdateRelatedRecordsNode'
   applyFiltersOn: ApplyAutomationWorkflowsFiltersOn
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   fields: Array<ComputedUpdateFieldValueMapping>
   filterSetId: Scalars['String']
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   relation: Relation
}

export type UpdateRelatedRecordsNodeExecLog = BaseNodeExecLog & {
   __typename?: 'UpdateRelatedRecordsNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   result?: Maybe<UpdateRelatedRecordsNodeExecLogResult>
   status: NodeExecLogStatusEnum
}

export type UpdateRelatedRecordsNodeExecLogResult = {
   __typename?: 'UpdateRelatedRecordsNodeExecLogResult'
   pipeline: BasePipeline
   relatedObjects: Array<RelatedObjectUpdateRemarks>
}

export type UpdateRelationFieldValueTypeParams = {
   fieldId: Scalars['String']
   valueType: RelationFieldValueType
}

export type UpdateRelationFieldValueTypeResponse =
   | FieldIsDeleted
   | FieldNotFound
   | MultiselectIsNotSupportedForSingleCardinalityRelation
   | NotRelationField
   | RelationField
   | UserIsNotAnAdministrator

export type UpdateRelationParams = {
   cardinality: Cardinality
   fromSalesTemplateDisplayName: Scalars['String']
   name: Scalars['String']
   relationId: Scalars['String']
   toSalesTemplateDisplayName: Scalars['String']
}

export type UpdateRelationResponse =
   | CardinalityUpdateNotSupported
   | FromRelatedSalesTemplateDisplayNameIsRequired
   | RelationIsDeleted
   | RelationNameIsRequired
   | RelationNotFound
   | ToRelatedSalesTemplateDisplayNameIsRequired
   | UpdateRelationResult
   | UserIsNotAnAdministrator

export type UpdateRelationResult = {
   __typename?: 'UpdateRelationResult'
   cardinality: Cardinality
   fromSalesTemplateDisplayName: Scalars['String']
   name: Scalars['String']
   relationId: Scalars['String']
   toSalesTemplateDisplayName: Scalars['String']
}

export type UpdateRelationTabParams = {
   selfRelationTarget?: InputMaybe<SelfRelationTarget>
}

export type UpdateResourceParams = {
   description: Scalars['String']
   resourceId: Scalars['String']
   title: Scalars['String']
}

export type UpdateResourceResponse =
   | FieldIdsNotInPipeline
   | FieldsAreDeleted
   | FieldsNotFound
   | NotAssigneeFieldIds
   | NotSupportedSalesTemplateFields
   | NotUserPropertyFieldIds
   | PipelineAccessDenied
   | PlaceholdersNotFound
   | ResourceDescriptionIsRequired
   | ResourceNotFound
   | ResourceTitleIsRequired
   | UpdateResourceResult
   | UserIsNotAnAdministrator

export type UpdateResourceResult = {
   __typename?: 'UpdateResourceResult'
   description: Scalars['String']
   resourceId: Scalars['String']
   title: Scalars['String']
}

export type UpdateSalesTemplateRecordCreationConfigParams = {
   fieldIds: Array<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type UpdateSalesTemplateRecordCreationConfigResponse =
   | FieldsAreDeleted
   | FieldsNotFound
   | NotSalesTemplateFieldIds
   | NotSupportedSalesTemplateType
   | SalesTemplateNotFound
   | SalesTemplateNotInUserAccount
   | UpdateSalesTemplateRecordCreationConfigResult
   | UserIsNotAnAdministrator

export type UpdateSalesTemplateRecordCreationConfigResult = {
   __typename?: 'UpdateSalesTemplateRecordCreationConfigResult'
   fieldIds: Array<Scalars['String']>
   salesTemplateId: Scalars['String']
}

export type UpdateScheduledAutomationWorkflowExecLogsFilterParams = {
   automationWorkflowIds: Array<Scalars['String']>
   entityLevel?: InputMaybe<AwLogsEntityLevel>
   executedAtRange?: InputMaybe<
      AutomationWorkflowExecLogsExecutedAtRangeFilterParams
   >
   filterByPipelineIds?: InputMaybe<Array<Scalars['String']>>
   pipelineId?: InputMaybe<Scalars['String']>
   statuses?: InputMaybe<Array<ScheduledAutomationWorkflowExecLogStatus>>
}

export type UpdateScheduledAutomationWorkflowExecLogsFilterResponse =
   | AutomationWorkflowsAreNotInPipeline
   | AutomationWorkflowsNotFound
   | InvalidAutomationWorkflowExecutedAtRange
   | PipelineNotFound
   | PipelinesNotFound
   | ScheduledAutomationWorkflowExecLogsFilter
   | UserIsNotAnAdministrator

export type UpdateScheduledLeadDistributionRuleSettingsParams = {
   dailyConfig?: InputMaybe<ScheduledLeadDistributionRuleDailyConfigParams>
   leadDistributionRuleId: Scalars['String']
   minutes?: InputMaybe<Scalars['Int']>
   scheduledType?: InputMaybe<LeadDistributionRuleScheduledType>
   smartDistribution?: InputMaybe<Scalars['Boolean']>
   weekDaysConfig?: InputMaybe<
      Array<ScheduledLeadDistributionRuleWeekDaysConfigParams>
   >
}

export type UpdateScheduledLeadDistributionRuleSettingsResponse =
   | DuplicateTimeIntervals
   | DuplicateWeekDays
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | ScheduledLeadDistributionRuleSettings
   | UserIsNotAnAdministrator

export type UpdateScheduledLeadDistributionRuleStatusParams = {
   leadDistributionRuleId: Scalars['String']
   status: ScheduledLeadDistributionRuleStatus
}

export type UpdateScheduledLeadDistributionRuleStatusResponse =
   | LeadDistributionRuleIsNotInEditMode
   | LeadDistributionRuleNotFound
   | NotScheduledLeadDistributionRule
   | PartiallyConfiguredLeadDistributionStepsExists
   | UpdateScheduledLeadDistributionRuleStatusResult
   | UserIsNotAnAdministrator

export type UpdateScheduledLeadDistributionRuleStatusResult = {
   __typename?: 'UpdateScheduledLeadDistributionRuleStatusResult'
   leadDistributionRuleId: Scalars['String']
   status: ScheduledLeadDistributionRuleStatus
}

export type UpdateScheduledTriggerParams = {
   dayConfig?: InputMaybe<CreateScheduledDayConfigParams>
   minutes?: InputMaybe<Scalars['Int']>
   monthConfig?: InputMaybe<Array<CreateScheduledMonthConfigParams>>
   scheduleType: ScheduleTypeEnum
   triggerId: Scalars['String']
   weekConfig?: InputMaybe<CreateScheduledWeekConfigParams>
}

export type UpdateScheduledTriggerResponse =
   | EmptyScheduleDayConfig
   | EmptyScheduleMinutesConfig
   | EmptyScheduleMonthConfig
   | EmptyScheduleWeekConfig
   | InvalidDaysCountInMonthScheduleConfig
   | InvalidScheduleMinutesConfig
   | NotEditableTrigger
   | NotScheduledTrigger
   | ScheduledTrigger
   | ScheduledWeekdaysShouldNotBeEmpty
   | TriggerNotFound
   | UnsupportedScheduledMinutesConfig
   | UserIsNotAnAdministrator

export type UpdateScorecardChartParams = {
   comparisonMetric?: InputMaybe<GraphMetricParams>
   comparisonType: ScorecardComparisonType
   comparisonValue?: InputMaybe<Scalars['String']>
   description?: InputMaybe<Scalars['String']>
   graphId: Scalars['String']
   name: Scalars['String']
}

export type UpdateScorecardChartResponse =
   | ComparisonMetricConfigIsRequired
   | GraphNameIsRequired
   | GraphNotFound
   | InvalidComparisonValue
   | MismatchBetweenMainAndComparisonMetricConfig
   | NotScorecardChart
   | UpdateScorecardChartResult
   | UserIsNotAnAdministrator

export type UpdateScorecardChartResult = {
   __typename?: 'UpdateScorecardChartResult'
   comparisonType: ScorecardComparisonType
   comparisonValue?: Maybe<ComparisonValue>
   description?: Maybe<Scalars['String']>
   graphId: Scalars['String']
   name: Scalars['String']
}

export type UpdateScoringConfigStatusParams = {
   scoringConfigId: Scalars['String']
   status: ScoringConfigStatus
}

export type UpdateScoringConfigStatusResponse =
   | CannotMakeActiveDueToIncompleteConfiguration
   | ScoringConfigNotFound
   | ScoringConfigShouldHaveAtLeastOnePublishedVersion
   | UpdateScoringConfigStatusResult
   | UserIsNotAnAdministrator

export type UpdateScoringConfigStatusResult = {
   __typename?: 'UpdateScoringConfigStatusResult'
   scoringConfigId: Scalars['String']
   status: ScoringConfigStatus
}

export type UpdateScoringParameterParams = {
   fieldId: Scalars['String']
   parameterId: Scalars['String']
   weightage?: InputMaybe<Scalars['Float']>
}

export type UpdateScoringParameterResponse =
   | FieldIsDeleted
   | FieldNotFound
   | InvalidWeightageValue
   | NotSupportedScoringParameterField
   | ScoringConfigNotFound
   | ScoringParameterNotFound
   | UpdateScoringParameterResult
   | UserIsNotAnAdministrator

export type UpdateScoringParameterResult = {
   __typename?: 'UpdateScoringParameterResult'
   fieldId: Scalars['String']
   parameterId: Scalars['String']
   weightage?: Maybe<Scalars['Float']>
}

export type UpdateShortTextFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateShortTextFieldDefaultValueResponse =
   | CannotEditSystemField
   | DefaultValueNotAllowedForUniqueField
   | FieldIsDeleted
   | FieldNotFound
   | NotShortTextField
   | RegexValidationFailedForDefaultValue
   | UpdateShortTextFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateShortTextFieldDefaultValueResult = {
   __typename?: 'UpdateShortTextFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateShortTextFieldFormulaStatusParams = {
   fieldId: Scalars['String']
   formulaExpression?: InputMaybe<Scalars['String']>
   isFormulaEnabled: Scalars['Boolean']
}

export type UpdateShortTextFieldFormulaStatusResponse =
   | AddAnotherFieldsAreNotSupported
   | CannotEditSystemField
   | CannotEnableFormulaStatusInAddAnotherField
   | CannotEnableFormulaStatusOnUniqueField
   | FieldsAreDeleted
   | FieldsNotFound
   | FormulaExpressionIsRequired
   | FormulaFieldsAreNotAllowed
   | InvalidFormulaExpression
   | NotShortTextField
   | NotSupportedFieldTypes
   | NotSupportedFields
   | SelfReferenceIsNotAllowedInFormulaExpression
   | ShortTextFieldOptionsAreEnabled
   | UpdateShortTextFieldFormulaStatusResult
   | UserIsNotAnAdministrator

export type UpdateShortTextFieldFormulaStatusResult = {
   __typename?: 'UpdateShortTextFieldFormulaStatusResult'
   fieldId: Scalars['String']
   formulaExpression?: Maybe<Scalars['String']>
   isFormulaEnabled: Scalars['Boolean']
}

export type UpdateShortTextFieldOptionsParams = {
   fieldId: Scalars['String']
   prefixOptions?: InputMaybe<PrefixOptionsParams>
   suffixOptions?: InputMaybe<SuffixOptionsParams>
}

export type UpdateShortTextFieldOptionsResponse =
   | CannotEditSystemField
   | CannotEnableShortTextFieldOptionsOnFormulaField
   | FieldIsDeleted
   | FieldNotFound
   | NeedAtLeastOnePrefixValue
   | NeedAtLeastOneSuffixValue
   | NotShortTextField
   | UpdateShortTextFieldOptionsResult
   | UserIsNotAnAdministrator

export type UpdateShortTextFieldOptionsResult = {
   __typename?: 'UpdateShortTextFieldOptionsResult'
   fieldId: Scalars['String']
   prefixOptions?: Maybe<PrefixOptions>
   suffixOptions?: Maybe<SuffixOptions>
}

export type UpdateShortTextFieldValidationRegexParams = {
   fieldId: Scalars['String']
   regexErrorMessage?: InputMaybe<Scalars['String']>
   validationRegex?: InputMaybe<Scalars['String']>
}

export type UpdateShortTextFieldValidationRegexResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | InvalidValidationRegex
   | LinkedFieldUpdateRestricted
   | NotShortTextField
   | RegexValidationFailedForDefaultValue
   | RegexValidationFailedForLinkedFieldsDefaultValue
   | UpdateShortTextFieldValidationRegexResult
   | UserIsNotAnAdministrator

export type UpdateShortTextFieldValidationRegexResult = {
   __typename?: 'UpdateShortTextFieldValidationRegexResult'
   fieldId: Scalars['String']
   regexErrorMessage?: Maybe<Scalars['String']>
   validationRegex?: Maybe<Scalars['String']>
}

export type UpdateShowPipelineItemStageQuickEitFieldsToTaskTemplateParams = {
   showPipelineItemStageQuickEditFields: Scalars['Boolean']
   taskTemplateId: Scalars['String']
}

export type UpdateShowPipelineItemStageQuickEitFieldsToTaskTemplateResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | NotSupportedForLinkedFieldsEnabledTaskTemplate
   | TaskTemplateNotFound
   | UpdateShowPipelineItemStageQuickEitFieldsToTaskTemplateResult
   | UserIsNotAnAdministrator

export type UpdateShowPipelineItemStageQuickEitFieldsToTaskTemplateResult = {
   __typename?: 'UpdateShowPipelineItemStageQuickEitFieldsToTaskTemplateResult'
   showPipelineItemStageQuickEditFields: Scalars['Boolean']
   taskTemplateId: Scalars['String']
}

export type UpdateSmartfloAccountParams = {
   name: Scalars['String']
   permanentAccessToken: Scalars['String']
   pluginServiceAccountId: Scalars['String']
}

export type UpdateSmartfloAccountResponse =
   | AccountPluginIsDisabled
   | ParameterIdNotFound
   | PluginServiceAccountNotFound
   | SmartfloAccount
   | SmartfloAccountNameAlreadyExists
   | UserIsNotAnAdministrator

export type UpdateStageCategoryParams = {
   category?: InputMaybe<StageCategory>
   stageId: Scalars['String']
}

export type UpdateStageCategoryResponse =
   | DisplayStageNotFound
   | SuccessStageAlreadyConfigured
   | UpdateStageCategoryResult
   | UserIsNotAnAdministrator

export type UpdateStageCategoryResult = {
   __typename?: 'UpdateStageCategoryResult'
   category?: Maybe<StageCategory>
   stageId: Scalars['String']
}

export type UpdateStageTransitionActionNameParams = {
   actionName?: InputMaybe<Scalars['String']>
   stageTransitionId: Scalars['String']
}

export type UpdateStageTransitionActionNameResponse =
   | StageTransitionNotFound
   | UpdateStageTransitionActionNameResult
   | UserIsNotAnAdministrator

export type UpdateStageTransitionActionNameResult = {
   __typename?: 'UpdateStageTransitionActionNameResult'
   actionName?: Maybe<Scalars['String']>
   stageTransitionId: Scalars['String']
}

export type UpdateStageTransitionCheckpointsConfigParams = {
   checkpointsHeaderText?: InputMaybe<Scalars['String']>
   stageTransitionId: Scalars['String']
}

export type UpdateStageTransitionCheckpointsConfigResponse =
   | StageTransitionCheckpointsConfig
   | StageTransitionNotFound
   | UserIsNotAnAdministrator

export type UpdateStageTransitionConfigParams = {
   canMovePaymentsFromDraftToYetToPay?: InputMaybe<Scalars['Boolean']>
   clearValues: Array<StageTransitionConfigPropertyEnum>
   confirmationPopupConfig?: InputMaybe<
      StageTransitionConfigConfirmationPopupConfigParams
   >
   discardTaskTemplateIds?: InputMaybe<Array<Scalars['String']>>
   functionIds?: InputMaybe<Array<Scalars['String']>>
   iconColor?: InputMaybe<Scalars['String']>
   iconId?: InputMaybe<Scalars['String']>
   isFeeCreationMandatory?: InputMaybe<Scalars['Boolean']>
   isNotesRequired?: InputMaybe<Scalars['Boolean']>
   mandatoryTaskTemplateIds?: InputMaybe<Array<Scalars['String']>>
   remarksConfig?: InputMaybe<StageTransitionConfigRemarksConfigParams>
   stageTransitionConfigId: Scalars['String']
   stageTransitionType?: InputMaybe<StageTransitionType>
   tdrRequestConfig?: InputMaybe<TdrRequestConfigParams>
   transitionFieldIds?: InputMaybe<Array<Scalars['String']>>
}

export type UpdateStageTransitionConfigResponse =
   | ConfirmationPopupTitleIsRequired
   | FunctionsNotFound
   | StageTransitionNotFound
   | UpdateStageTransitionConfigResult
   | UserIsNotAnAdministrator

export type UpdateStageTransitionConfigResult = {
   __typename?: 'UpdateStageTransitionConfigResult'
   canMovePaymentsFromDraftToYetToPay?: Maybe<Scalars['Boolean']>
   confirmationPopupConfig?: Maybe<StageTransitionConfigConfirmationPopupConfig>
   discardTaskTemplateIds?: Maybe<Array<Scalars['String']>>
   functionIds?: Maybe<Array<Scalars['String']>>
   iconColor?: Maybe<Scalars['String']>
   iconId?: Maybe<Scalars['String']>
   isFeeCreationMandatory?: Maybe<Scalars['Boolean']>
   isNotesRequired?: Maybe<Scalars['Boolean']>
   mandatoryTaskTemplateIds?: Maybe<Array<Scalars['String']>>
   remarksConfig?: Maybe<StageTransitionConfigRemarksConfig>
   stageTransitionConfigId: Scalars['String']
   stageTransitionType?: Maybe<StageTransitionType>
   tdrRequestConfig?: Maybe<TdrRequestConfig>
   transitionFieldIds?: Maybe<Array<Scalars['String']>>
}

export type UpdateStageTransitionOrderParams = {
   order: Scalars['Int']
   stageTransitionId: Scalars['String']
}

export type UpdateStageTransitionOrderResponse =
   | StageTransitionNotFound
   | UpdateStageTransitionOrderResult
   | UserIsNotAnAdministrator

export type UpdateStageTransitionOrderResult = {
   __typename?: 'UpdateStageTransitionOrderResult'
   order: Scalars['Int']
   stageTransitionId: Scalars['String']
}

export type UpdateTdrPaymentInPortalParams = {
   authority: Scalars['String']
   certificateAttachment?: InputMaybe<TdrCertificateAttachmentParams>
   certificateNumber: Scalars['String']
   marketValueOfUsageArea?: InputMaybe<Scalars['Float']>
   portalId: Scalars['String']
   portalType: PortalType
   requestedArea: Scalars['Float']
   tdrRequestId: Scalars['String']
}

export type UpdateTdrPaymentInPortalResponse =
   | ApplicationAccessDenied
   | CertificateNoExistsForOtherTdrRequests
   | InvalidTdrRequestAuthority
   | MarketValueShouldBePositiveValue
   | NotAllowedActionOnTdrRequest
   | NotHaveSufficientBalanceInTdrAccount
   | PortalNotFound
   | PrecisionLimitExceededForTdrMarketValue
   | PrecisionLimitExceededForTdrRequestedArea
   | RequestedAreaGreaterThanAllocatedArea
   | TdrPaymentIsNotInitiated
   | TdrRequestCertificateNumberNotFound
   | TdrRequestNotFound
   | TdrRequestedAreaShouldBePositive
   | TdrRequestedAreaShouldNotBeNegative
   | UpdateTdrPaymentInPortalResult

export type UpdateTdrPaymentInPortalResult = {
   __typename?: 'UpdateTDRPaymentInPortalResult'
   tdrPayment: TdrPayment
}

export type UpdateTdrPaymentObservationParams = {
   paymentId: Scalars['String']
   recommendation?: InputMaybe<TdrPaymentVerificationRecommendationEnum>
   remarks?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: TaskVerificationFieldProperty
}

export type UpdateTdrPaymentObservationResponse =
   | PaymentNotFound
   | TaskAccessDenied
   | TaskNotFound
   | TaskTemplateAccessDenied
   | TaskVerificationNotExists
   | UpdateTdrPaymentObservationResult

export type UpdateTdrPaymentObservationResult = {
   __typename?: 'UpdateTDRPaymentObservationResult'
   paymentId: Scalars['String']
   recommendation?: Maybe<TdrPaymentVerificationRecommendationEnum>
   remarks?: Maybe<Scalars['String']>
   taskId: Scalars['String']
   updateProperty: TaskVerificationFieldProperty
}

export type UpdateTdrRequestFailureResponse = {
   __typename?: 'UpdateTDRRequestFailureResponse'
   reason: Scalars['String']
   tdrRequestId: Scalars['String']
}

export type UpdateTdrRequestInPortalParams = {
   certificateAttachment?: InputMaybe<TdrCertificateAttachmentParams>
   certificateNumber?: InputMaybe<Scalars['String']>
   marketValueOfRequestedArea?: InputMaybe<Scalars['Float']>
   portalId: Scalars['String']
   portalType: PortalType
   requestedArea?: InputMaybe<Scalars['Float']>
   tdrRequestId: Scalars['String']
}

export type UpdateTdrRequestInPortalResponse =
   | PortalAccessDenied
   | PortalIsDeleted
   | PortalNotFound
   | TdrRequestEntityAccessDenied
   | TdrRequestNotFound
   | UpdateTdrRequestInPortalResult

export type UpdateTdrRequestInPortalResult = {
   __typename?: 'UpdateTDRRequestInPortalResult'
   tdrRequest?: Maybe<TdrRequest>
}

export type UpdateTdrRequestParams = {
   marketValueOfUsageArea: Scalars['Float']
   tdrRequestId: Scalars['String']
}

export type UpdateTdrRequestResponse =
   | MarketValueShouldBePositiveValue
   | NotAllowedActionOnTdrRequest
   | TdrRequestEntityAccessDenied
   | TdrRequestEntityNotFound
   | TdrRequestNotFound
   | UpdateTdrRequestResult
   | UpdateTdrRequestsFailed

export type UpdateTdrRequestResult = {
   __typename?: 'UpdateTDRRequestResult'
   tdrRequest?: Maybe<TdrRequest>
}

export type UpdateTdrRequestsFailed = GraphQlBaseError & {
   __typename?: 'UpdateTDRRequestsFailed'
   failedTdrRequests: Array<UpdateTdrRequestFailureResponse>
   message?: Maybe<Scalars['String']>
}

export type UpdateTabParams = {
   enableCompletionIcon?: InputMaybe<Scalars['Boolean']>
   filesVerificationConfig?: InputMaybe<FilesVerificationTabConfigParams>
   gofIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
   iconConfig?: InputMaybe<IconConfigParams>
   name: Scalars['String']
   relationConfig?: InputMaybe<UpdateRelationTabParams>
   relationId?: InputMaybe<Scalars['String']>
   sectionsConfig?: InputMaybe<SectionsConfigParams>
   tabId: Scalars['String']
   /** @deprecated Not supported to update tab type */
   tabType?: InputMaybe<TabType>
}

export type UpdateTabResponse =
   | AddAnotherFieldsAreNotSupported
   | DependentFieldsNotSupported
   | FieldsAreDeleted
   | FieldsNotFound
   | FilesVerificationTabConfigIsRequired
   | GoFsAreNotSupportedForLayoutEntity
   | GoFsNotFound
   | InvalidFileVerificationFieldType
   | InvalidOrderFieldIds
   | LayoutTabNameAlreadyExists
   | LayoutTabNotFound
   | MissingGofIds
   | MissingOrderFieldIds
   | RelationNotFound
   | RelationNotSupportedForLayoutEntity
   | UpdateTabResult
   | UserIsNotAnAdministrator

export type UpdateTabResult = {
   __typename?: 'UpdateTabResult'
   tab: Tab
}

export type UpdateTableGraphParams = {
   description?: InputMaybe<Scalars['String']>
   enableColumnTotals: Scalars['Boolean']
   graphId: Scalars['String']
   name: Scalars['String']
}

export type UpdateTableGraphResponse =
   | GraphNameIsRequired
   | GraphNotFound
   | NotTableGraph
   | PipelineAccessDenied
   | UpdateTableGraphResult
   | UserIsNotAnAdministrator

export type UpdateTableGraphResult = {
   __typename?: 'UpdateTableGraphResult'
   description?: Maybe<Scalars['String']>
   enableColumnTotals: Scalars['Boolean']
   graphId: Scalars['String']
   name: Scalars['String']
}

export type UpdateTableGraphTotalsConfigParams = {
   enableColumnTotals: Scalars['Boolean']
   graphId: Scalars['String']
}

export type UpdateTableGraphTotalsConfigResponse =
   | GraphNotFound
   | UpdateTableGraphTotalsConfigResult
   | UserIsNotAnAdministrator

export type UpdateTableGraphTotalsConfigResult = {
   __typename?: 'UpdateTableGraphTotalsConfigResult'
   enableColumnTotals: Scalars['Boolean']
   graphId: Scalars['String']
}

export type UpdateTaskAddAnotherFieldParams = {
   fieldId: Scalars['String']
   gofResponseId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
}

export type UpdateTaskAddAnotherFieldResponse =
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | GoFResponseIdNotFound
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAddAnotherGoFField
   | NotAddAnotherGoFResponseField
   | NotAllowedFileFormats
   | NotTaskAddAnotherGoFResponse
   | ParentFieldNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | UpdateFieldResponseResult

export type UpdateTaskApproxDurationInMinsParams = {
   taskApproxDurationInMins?: InputMaybe<Scalars['Int']>
   taskTemplateId: Scalars['String']
}

export type UpdateTaskApproxDurationInMinsResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | TaskApproxDurationInMinsShouldBePositive
   | TaskTemplateNotFound
   | UpdateTaskApproxDurationInMinsResult
   | UserIsNotAnAdministrator

export type UpdateTaskApproxDurationInMinsResult = {
   __typename?: 'UpdateTaskApproxDurationInMinsResult'
   taskApproxDurationInMins?: Maybe<Scalars['Int']>
   taskTemplateId: Scalars['String']
}

export type UpdateTaskFieldBulkParams = {
   fieldResponses: Array<FieldResponseParams>
   taskId: Scalars['String']
}

export type UpdateTaskFieldBulkResponse =
   | CanNotUpdateCompletedTask
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FieldsAreDeleted
   | FieldsNotFound
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotAllowedToUpdateRelationFields
   | NotAllowedToUpdateSystemFields
   | NotTaskField
   | NotTaskTemplateFields
   | OnlyAdminCanDiscardTask
   | ParentFieldNotFilled
   | RequiredFieldsNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | TaskTemplateAccessDenied
   | UniqueFieldResponseAlreadyExists
   | UpdateTaskFieldBulkResult

export type UpdateTaskFieldBulkResult = {
   __typename?: 'UpdateTaskFieldBulkResult'
   changedFieldResponses: Array<FieldResponse>
   fieldResponses: Array<FieldResponse>
   taskId: Scalars['String']
}

export type UpdateTaskFieldParams = {
   apiVersion?: InputMaybe<GraphqlApiVersionEnum>
   fieldId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
}

export type UpdateTaskFieldResponse =
   | AtLeastOneSystemUniqueFieldIsRequiredForContact
   | CallLogsAlreadyLinkedToAnotherCompletedTask
   | CallStatusFieldIsRequired
   | CanNotUpdateCompletedTask
   | CannotUpdateTaskSubmittedLocationField
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotTaskField
   | OnlyAdminCanDiscardTask
   | ParentFieldNotFilled
   | PipelineItemsAreDeleted
   | PipelineItemsNotFound
   | PipelineItemsNotLinkedToTaskPipelineItemRelation
   | RequiredFieldsNotFilled
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | StartDateIsRequired
   | TaskAccessDenied
   | TaskAssigneeDoesNotHavePipelineItemAccess
   | TaskAssigneeIsDeactivated
   | TaskAssigneeNotFound
   | TaskDiscarded
   | TaskNotFound
   | TaskStartDateTimeHasPassed
   | TaskTemplateAccessDenied
   | UniqueFieldResponseAlreadyExists
   | UpdateFieldResponseResult

export type UpdateTaskNode = BaseNode & {
   __typename?: 'UpdateTaskNode'
   assignee?: Maybe<TaskAssigneeEnum>
   assigneeFieldId?: Maybe<Scalars['String']>
   automationWorkflowId: Scalars['String']
   childNodes: Array<ChildNode>
   configStatus: NodeConfigStatus
   discardTask?: Maybe<Scalars['Boolean']>
   name?: Maybe<Scalars['String']>
   nodeId: Scalars['String']
   nodeType: NodeType
   startDate?: Maybe<StartDateValueConfig>
   startTime?: Maybe<StartTimeValueConfig>
}

export type UpdateTaskNodeExecLog = BaseNodeExecLog & {
   __typename?: 'UpdateTaskNodeExecLog'
   failureReason?: Maybe<Scalars['String']>
   nodeExecLogId: Scalars['String']
   nodeId: Scalars['String']
   status: NodeExecLogStatusEnum
}

export type UpdateTaskPipelineItemCardConfigParams = {
   taskPipelineItemCardOverviewConfig?: InputMaybe<
      TaskPipelineItemCardOverviewConfigParams
   >
   taskTemplateId: Scalars['String']
}

export type UpdateTaskPipelineItemCardConfigResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | FieldsAreDeleted
   | FieldsNotFound
   | FieldsShouldBelongsToGivenPipelineItemTemplates
   | FieldsShouldNotBelongsToTaskTemplate
   | TaskTemplateNotFound
   | UpdateTaskPipelineItemCardConfigResult
   | UserIsNotAnAdministrator

export type UpdateTaskPipelineItemCardConfigResult = {
   __typename?: 'UpdateTaskPipelineItemCardConfigResult'
   taskPipelineItemCardOverviewConfig?: Maybe<
      TaskPipelineItemCardOverviewConfig
   >
   taskTemplateId: Scalars['String']
}

export type UpdateTaskStartDateTimeParams = {
   startDate?: InputMaybe<Scalars['String']>
   startTime?: InputMaybe<Scalars['String']>
   taskId: Scalars['String']
}

export type UpdateTaskStartDateTimeResponse =
   | CanNotUpdateCompletedTask
   | StartDateIsRequired
   | TaskAccessDenied
   | TaskDiscarded
   | TaskNotFound
   | TaskStartDateTimeHasPassed
   | UpdateTaskStartDateTimeResult

export type UpdateTaskStartDateTimeResult = {
   __typename?: 'UpdateTaskStartDateTimeResult'
   startDate: FieldResponse
   startTime: FieldResponse
   taskId: Scalars['String']
}

export type UpdateTaskTemplateColorParams = {
   color: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateColorResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | TaskTemplateNotFound
   | UpdateTaskTemplateColorResult
   | UserIsNotAnAdministrator

export type UpdateTaskTemplateColorResult = {
   __typename?: 'UpdateTaskTemplateColorResult'
   color: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateDescriptionParams = {
   description?: InputMaybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateDescriptionResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | TaskTemplateNotFound
   | UpdateTaskTemplateDescriptionResult
   | UserIsNotAnAdministrator

export type UpdateTaskTemplateDescriptionResult = {
   __typename?: 'UpdateTaskTemplateDescriptionResult'
   description?: Maybe<Scalars['String']>
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateIconUrlParams = {
   iconUrl: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateIconUrlResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | TaskTemplateNotFound
   | UpdateTaskTemplateIconUrlResult
   | UserIsNotAnAdministrator

export type UpdateTaskTemplateIconUrlResult = {
   __typename?: 'UpdateTaskTemplateIconUrlResult'
   iconUrl: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateNameParams = {
   name: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateNameResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | TaskTemplateNameAlreadyExists
   | TaskTemplateNotFound
   | UpdateTaskTemplateNameResult
   | UserIsNotAnAdministrator

export type UpdateTaskTemplateNameResult = {
   __typename?: 'UpdateTaskTemplateNameResult'
   name: Scalars['String']
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateRemarksAttachmentEnableStatusParams = {
   isEnabled: Scalars['Boolean']
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateRemarksAttachmentEnableStatusResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | TaskTemplateNotFound
   | UpdateTaskTemplateRemarksAttachmentEnableStatusResult
   | UserIsNotAnAdministrator

export type UpdateTaskTemplateRemarksAttachmentEnableStatusResult = {
   __typename?: 'UpdateTaskTemplateRemarksAttachmentEnableStatusResult'
   isEnabled: Scalars['Boolean']
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateRemarksConfigParams = {
   enableRemarks: Scalars['Boolean']
   enableRemarksAttachments: Scalars['Boolean']
}

export type UpdateTaskTemplateSettingsParams = {
   captureSubmittedLocation?: InputMaybe<Scalars['Boolean']>
   clearValues: Array<TaskTemplateSettingsEnum>
   enablePipelineItemOtherFields?: InputMaybe<Scalars['Boolean']>
   enablePipelineItemScheduling?: InputMaybe<Scalars['Boolean']>
   remarksConfig?: InputMaybe<UpdateTaskTemplateRemarksConfigParams>
   taskTemplateId: Scalars['String']
   viewStyle?: InputMaybe<TaskViewStyleEnum>
}

export type UpdateTaskTemplateSettingsResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | InvalidTaskTemplateRemarksEnableConfig
   | TaskTemplateNotFound
   | TaskTemplateSettingsShouldBeEmpty
   | UpdateTaskTemplateSettingsResult
   | UserIsNotAnAdministrator

export type UpdateTaskTemplateSettingsResult = {
   __typename?: 'UpdateTaskTemplateSettingsResult'
   captureSubmittedLocation?: Maybe<Scalars['Boolean']>
   clearValues: Array<TaskTemplateSettingsEnum>
   enablePipelineItemOtherFields?: Maybe<Scalars['Boolean']>
   enablePipelineItemScheduling?: Maybe<Scalars['Boolean']>
   remarksConfig?: Maybe<TaskTemplateRemarksSettingConfig>
   taskTemplateId: Scalars['String']
   viewStyle?: Maybe<TaskViewStyleEnum>
}

export type UpdateTaskTemplateStatusParams = {
   isDisabled: Scalars['Boolean']
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateStatusResponse =
   | CannotUpdateCustomTaskTypeTemplate
   | TaskTemplateNotFound
   | UpdateTaskTemplateStatusResult
   | UserIsNotAnAdministrator

export type UpdateTaskTemplateStatusResult = {
   __typename?: 'UpdateTaskTemplateStatusResult'
   isDisabled: Scalars['Boolean']
   taskTemplateId: Scalars['String']
}

export type UpdateTaskTemplateVisibilityFieldParams = {
   taskTemplateId: Scalars['String']
   visibilityFieldId?: InputMaybe<Scalars['String']>
}

export type UpdateTaskTemplateVisibilityFieldResponse =
   | AddAnotherFieldIsNotSupported
   | CannotUpdateCustomTaskTypeTemplate
   | FieldIsDeleted
   | FieldNotFound
   | NotPipelineItemTemplateFieldId
   | TaskTemplateNotFound
   | UnsupportedFieldTypeForTaskVisibilityField
   | UpdateTaskTemplateVisibilityFieldResult
   | UserIsNotAnAdministrator

export type UpdateTaskTemplateVisibilityFieldResult = {
   __typename?: 'UpdateTaskTemplateVisibilityFieldResult'
   taskTemplateId: Scalars['String']
   visibilityFieldId?: Maybe<Scalars['String']>
}

export type UpdateTasksFeatureEnableStatusParams = {
   isTasksFeatureEnabled: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type UpdateTasksFeatureEnableStatusResponse =
   | PipelineNotFound
   | UpdateTasksFeatureEnableStatusResult
   | UserIsNotAnAdministrator

export type UpdateTasksFeatureEnableStatusResult = {
   __typename?: 'UpdateTasksFeatureEnableStatusResult'
   isTasksFeatureEnabled: Scalars['Boolean']
   pipelineId: Scalars['String']
}

export type UpdateTimeFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateTimeFieldDefaultValueResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotTimeField
   | OnlySingleTypeOfDefaultValueIsAllowed
   | UpdateTimeFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateTimeFieldDefaultValueResult = {
   __typename?: 'UpdateTimeFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateTimeFieldRelativeDefaultValueConfigParams = {
   fieldId: Scalars['String']
   relativeDefaultValueConfig?: InputMaybe<TimeRelativeDefaultValueConfigParams>
}

export type UpdateTimeFieldRelativeDefaultValueConfigResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | NotTimeField
   | OnlySingleTypeOfDefaultValueIsAllowed
   | SecondsShouldBePositive
   | UpdateTimeFieldRelativeDefaultValueConfigResult
   | UserIsNotAnAdministrator

export type UpdateTimeFieldRelativeDefaultValueConfigResult = {
   __typename?: 'UpdateTimeFieldRelativeDefaultValueConfigResult'
   fieldId: Scalars['String']
   relativeDefaultValueConfig?: Maybe<TimeRelativeDefaultValueConfig>
}

export type UpdateUrlFieldConfigParams = {
   alternateDisplayText?: InputMaybe<Scalars['String']>
   clearValues: Array<UrlFieldPropertyEnum>
   fieldId: Scalars['String']
}

export type UpdateUrlFieldConfigResponse =
   | FieldIsDeleted
   | FieldNotFound
   | NotUrlField
   | UrlFieldPropertyValuesShouldBeEmpty
   | UpdateUrlFieldConfigResult
   | UserIsNotAnAdministrator

export type UpdateUrlFieldConfigResult = {
   __typename?: 'UpdateUrlFieldConfigResult'
   alternateDisplayText?: Maybe<Scalars['String']>
   clearValues: Array<UrlFieldPropertyEnum>
   fieldId: Scalars['String']
}

export type UpdateUrlFieldDefaultValueParams = {
   defaultValue?: InputMaybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateUrlFieldDefaultValueResponse =
   | CannotEditSystemField
   | DefaultValueNotAllowedForUniqueField
   | FieldIsDeleted
   | FieldNotFound
   | NotUrlField
   | RegexValidationFailedForDefaultValue
   | UpdateUrlFieldDefaultValueResult
   | UserIsNotAnAdministrator

export type UpdateUrlFieldDefaultValueResult = {
   __typename?: 'UpdateUrlFieldDefaultValueResult'
   defaultValue?: Maybe<Scalars['String']>
   fieldId: Scalars['String']
}

export type UpdateUrlFieldValidationRegexParams = {
   fieldId: Scalars['String']
   regexErrorMessage?: InputMaybe<Scalars['String']>
   validationRegex?: InputMaybe<Scalars['String']>
}

export type UpdateUrlFieldValidationRegexResponse =
   | CannotEditSystemField
   | FieldIsDeleted
   | FieldNotFound
   | InvalidValidationRegex
   | LinkedFieldUpdateRestricted
   | NotUrlField
   | RegexValidationFailedForDefaultValue
   | RegexValidationFailedForLinkedFieldsDefaultValue
   | UpdateUrlFieldValidationRegexResult
   | UserIsNotAnAdministrator

export type UpdateUrlFieldValidationRegexResult = {
   __typename?: 'UpdateUrlFieldValidationRegexResult'
   fieldId: Scalars['String']
   regexErrorMessage?: Maybe<Scalars['String']>
   validationRegex?: Maybe<Scalars['String']>
}

export type UpdateUserAdminStatusParams = {
   isAdmin: Scalars['Boolean']
   userId: Scalars['String']
}

export type UpdateUserAdminStatusResponse =
   | DeactivatedUser
   | UpdateUserAdminStatusResult
   | UserAndAdminAreNotInSameAccount
   | UserIsNotAnAdministrator
   | UserNotFound

export type UpdateUserAdminStatusResult = {
   __typename?: 'UpdateUserAdminStatusResult'
   isAdmin: Scalars['Boolean']
   userId: Scalars['String']
}

export type UpdateUserDetailsParams = {
   designation?: InputMaybe<Scalars['String']>
   firstName?: InputMaybe<Scalars['String']>
   lastName?: InputMaybe<Scalars['String']>
   phoneNumber?: InputMaybe<PhoneNumberParams>
   reason?: InputMaybe<Scalars['String']>
   userId: Scalars['String']
}

export type UpdateUserDetailsRequest = BaseOfficerManagementRequest & {
   __typename?: 'UpdateUserDetailsRequest'
   accountId: Scalars['String']
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   designation?: Maybe<Scalars['String']>
   errorMessage?: Maybe<Scalars['String']>
   firstName?: Maybe<Scalars['String']>
   id: Scalars['String']
   initiatedBy: Scalars['String']
   initiatedUser: User
   lastName?: Maybe<Scalars['String']>
   operationType: OfficerManagementOperationType
   phoneNumber?: Maybe<PhoneNumberResponse>
   previousDetails?: Maybe<UserDetailsChange>
   reason?: Maybe<Scalars['String']>
   status: OfficerManagementStatusType
   updatedAt: Scalars['String']
   updatedDetails?: Maybe<UserDetailsChange>
   user: User
   userId: Scalars['String']
}

export type UpdateUserEmailByAdminParams = {
   email: Scalars['String']
   userId: Scalars['String']
}

export type UpdateUserEmailByAdminResponse =
   | DeactivatedUser
   | InvalidEmailForUserUpdate
   | UpdateUserEmailByAdminResult
   | UserAndAdminAreNotInSameAccount
   | UserEmailAlreadyExists
   | UserEmailAlreadyExistsInAnotherAccount
   | UserIsNotAnAdministrator
   | UserNotFound

export type UpdateUserEmailByAdminResult = {
   __typename?: 'UpdateUserEmailByAdminResult'
   email: Scalars['String']
   userId: Scalars['String']
}

export type UpdateUserFireBaseAppAccessParams = {
   accessStatus: Scalars['Boolean']
   userId: Scalars['String']
}

export type UpdateUserFireBaseAppAccessResponse =
   | DeactivatedUser
   | FirebaseApiCallFailed
   | FirebaseAppUsersLimitExceeded
   | UpdateUserFireBaseAppAccessResult
   | UserAndAdminAreNotInSameAccount
   | UserIsNotAnAdministrator
   | UserNotFound

export type UpdateUserFireBaseAppAccessResult = {
   __typename?: 'UpdateUserFireBaseAppAccessResult'
   accessStatus: Scalars['Boolean']
   userId: Scalars['String']
}

export type UpdateUserPortalLanguageParams = {
   language: LanguageEnum
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type UpdateUserPortalLanguageResponse =
   | NotPortalUser
   | PortalNotFound
   | UpdateUserPortalLanguageResult

export type UpdateUserPortalLanguageResult = {
   __typename?: 'UpdateUserPortalLanguageResult'
   language: LanguageEnum
   portalId: Scalars['String']
}

export type UpdateUserProfileByAdminParams = {
   clearValues?: InputMaybe<Array<InputMaybe<UserProfileFieldEnum>>>
   dob?: InputMaybe<Scalars['String']>
   firstName?: InputMaybe<Scalars['String']>
   gender?: InputMaybe<Gender>
   lastName?: InputMaybe<Scalars['String']>
   phoneNumber?: InputMaybe<PhoneNumberParams>
   profilePicUrl?: InputMaybe<Scalars['String']>
   signatureImgLink?: InputMaybe<Scalars['String']>
   userId: Scalars['String']
}

export type UpdateUserProfileByAdminResponse =
   | DeactivatedUser
   | InvalidPhoneNumber
   | InvalidUrl
   | User
   | UserAndAdminAreNotInSameAccount
   | UserIsNotAnAdministrator
   | UserNotFound
   | UserProfileFieldValuesShouldBeEmpty

export type UpdateUserProfileParams = {
   dob?: InputMaybe<Scalars['String']>
   firstName?: InputMaybe<Scalars['String']>
   gender?: InputMaybe<Gender>
   lastName?: InputMaybe<Scalars['String']>
   phoneNumber?: InputMaybe<PhoneNumberParams>
   profilePicUrl?: InputMaybe<Scalars['String']>
}

export type UpdateUserProfileResponse =
   | DeactivatedUser
   | InvalidPhoneNumber
   | User

export type UpdateUserPropertiesTemplateDesignationFieldIdParams = {
   designationFieldId?: InputMaybe<Scalars['String']>
   userPropertiesTemplateId: Scalars['String']
}

export type UpdateUserPropertiesTemplateDesignationFieldIdResponse =
   | FieldIsDeleted
   | FieldNotFound
   | UpdateUserPropertiesTemplateDesignationFieldIdResult
   | UserIsNotAnAdministrator
   | UserPropertiesTemplateNotFound

export type UpdateUserPropertiesTemplateDesignationFieldIdResult = {
   __typename?: 'UpdateUserPropertiesTemplateDesignationFieldIdResult'
   designationFieldId?: Maybe<Scalars['String']>
   userPropertiesTemplateId: Scalars['String']
}

export type UpdateUserPropertyParams = {
   fieldId: Scalars['String']
   response?: InputMaybe<Scalars['String']>
   userId: Scalars['String']
}

export type UpdateUserPropertyResponse =
   | DecimalPrecisionExceeded
   | DuplicateGeoPoints
   | FieldIsDeleted
   | FieldNotFound
   | FieldResponse
   | FieldResponseIsRequired
   | FieldResponseRegexValidationFailed
   | FieldValidationRulesFailed
   | FileFormatIsNotAllowed
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | FloatFieldResponseOutOfRange
   | FormulaFieldsAreSystemEditable
   | IntegerFieldResponseOutOfRange
   | InvalidCheckboxFieldResponse
   | InvalidDateFieldResponseFormat
   | InvalidDateTimeFieldResponseFormat
   | InvalidDropdownFieldResponse
   | InvalidDropdownFieldResponseForConditionalOptions
   | InvalidEmailFieldResponse
   | InvalidFieldOptionForRuleBasedConditionalOptions
   | InvalidFieldsSelectorFieldResponse
   | InvalidFileUploaderFieldResponse
   | InvalidFloatFieldResponse
   | InvalidGeoLocationFieldResponse
   | InvalidGeoPoints
   | InvalidGeoShapeFieldResponse
   | InvalidGeoShapeLineVariantResponse
   | InvalidGeoShapePolygonVariantResponse
   | InvalidIntegerFieldResponse
   | InvalidLocationCoOrdinates
   | InvalidMultiSelectFieldResponse
   | InvalidMultiSelectFieldResponseForConditionalOptions
   | InvalidPhoneNumberFieldResponse
   | InvalidRadioGroupFieldResponse
   | InvalidShortTextFieldPrefixOption
   | InvalidShortTextFieldResponse
   | InvalidShortTextFieldResponseForPrefixConditionalOptions
   | InvalidShortTextFieldSuffixOption
   | InvalidTimeFieldResponseFormat
   | InvalidUrlFieldResponse
   | MaxNumberOfFilesLimitExceeded
   | MimeTypeIsRequiredForFileUploaderResponse
   | NeedFieldWritePermission
   | NotAllowedFileFormats
   | NotUserPropertiesTemplateField
   | PropertiesUserAccessDenied
   | PropertiesUserNotFound
   | ShortTextFieldPrefixOptionRequired
   | ShortTextFieldSuffixOptionRequired
   | SizeInBytesIsRequiredForFileUploaderResponse
   | UniqueFieldResponseAlreadyExists
   | UserPropertiesSystemFieldUpdateIsNotSupported

export type UpdateUsernameByAdminParams = {
   userId: Scalars['String']
   username: Scalars['String']
}

export type UpdateUsernameByAdminResponse =
   | DeactivatedUser
   | InvalidUsername
   | UpdateUsernameByAdminResult
   | UserAndAdminAreNotInSameAccount
   | UserIsNotAnAdministrator
   | UserNotFound
   | UsernameAlreadyExists
   | UsernameAlreadyExistsInAnotherAccount

export type UpdateUsernameByAdminResult = {
   __typename?: 'UpdateUsernameByAdminResult'
   userId: Scalars['String']
   username: Scalars['String']
}

export type UpdateUsersTabCustomizationParams = {
   conditions: Array<UserFilterConditionParams>
}

export type UpdateUsersTabCustomizationResponse =
   | DuplicateUserPropertyFilterConditions
   | InvalidFilterFieldValue
   | NotSupportedOperatorForUserProperty
   | UserIsNotAnAdministrator
   | UsersTabCustomizationFilters

export type UpdateViewCustomJsonParams = {
   mobileViewCustomJson?: InputMaybe<Scalars['String']>
   viewId: Scalars['String']
   webViewCustomJson?: InputMaybe<Scalars['String']>
}

export type UpdateViewCustomJsonResponse =
   | UpdateViewCustomJsonResult
   | ViewAccessDenied
   | ViewNotFound

export type UpdateViewCustomJsonResult = {
   __typename?: 'UpdateViewCustomJsonResult'
   mobileViewCustomJson?: Maybe<Scalars['String']>
   viewId: Scalars['String']
   webViewCustomJson?: Maybe<Scalars['String']>
}

export type UpdateViewTypeParams = {
   viewId: Scalars['String']
   viewType: ViewType
}

export type UpdateViewTypeResponse = View | ViewAccessDenied | ViewNotFound

export type UpdateWatiAccountParams = {
   accessToken: Scalars['String']
   baseUrl: Scalars['String']
   enableReadReceipts: Scalars['Boolean']
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
}

export type UpdateWatiAccountResponse =
   | AccountPluginIsDisabled
   | ParameterIdsNotFound
   | PluginServiceAccountNotFound
   | UserIsNotAnAdministrator
   | WatiAccount
   | WatiAccountNameAlreadyExists

export type UpdateWhatsAppBusinessPhoneNumberParams = {
   gallaboxChannelId?: InputMaybe<Scalars['String']>
   phoneNumber: PhoneNumberParams
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type UpdateWhatsAppBusinessPhoneNumberResponse =
   | AccountPluginIsDisabled
   | GallaboxChannelIdIsRequired
   | InvalidWhatsAppBusinessPhoneNumber
   | PluginServiceAccountIsNotActive
   | UpdateWhatsAppBusinessPhoneNumberResult
   | UserIsNotAnAdministrator
   | WhatsAppBusinessPhoneNumberAlreadyExists
   | WhatsAppBusinessPhoneNumberNotFound

export type UpdateWhatsAppBusinessPhoneNumberResult = {
   __typename?: 'UpdateWhatsAppBusinessPhoneNumberResult'
   gallaboxChannelId?: Maybe<Scalars['String']>
   phoneNumber: PhoneNumberResponse
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type UpdationConfigIsRequired = GraphQlBaseError & {
   __typename?: 'UpdationConfigIsRequired'
   message?: Maybe<Scalars['String']>
}

export type UploadUserKmlFileParams = {
   file: FileUploaderUrlParams
}

export type UploadUserKmlFileResponse =
   | FileSizeLimitExceeded
   | FileUploaderUrlsDomainIsNotAllowed
   | NotAKmlFile
   | UploadUserKmlFileResult

export type UploadUserKmlFileResult = {
   __typename?: 'UploadUserKmlFileResult'
   file: FileUploaderUrlResponse
}

export type User = {
   __typename?: 'User'
   adminPipelineIds: Array<Scalars['String']>
   adminPipelineItemTemplateIds: Array<Scalars['String']>
   attendance?: Maybe<BaseUserAttendance>
   callingType: OutBoundCallType
   circle?: Maybe<Scalars['String']>
   designation?: Maybe<Scalars['String']>
   dob?: Maybe<Scalars['String']>
   email?: Maybe<Scalars['String']>
   firstName?: Maybe<Scalars['String']>
   gender?: Maybe<Gender>
   globalQuota?: Maybe<AgentGlobalQuota>
   googleAuthConsentStatus: UserGoogleAuthConsentStatus
   hasFirebaseAppAccess: Scalars['Boolean']
   identifications: Array<Identification>
   isActive: Scalars['Boolean']
   isAdmin: Scalars['Boolean']
   lastName?: Maybe<Scalars['String']>
   manager?: Maybe<BaseUser>
   name?: Maybe<Scalars['String']>
   permissions: Array<UserPermission>
   phoneNumber?: Maybe<PhoneNumberResponse>
   profilePicUrl?: Maybe<Scalars['String']>
   properties: Array<SystemFieldEnumResponseResult>
   signatureImgLink?: Maybe<Scalars['String']>
   userId: Scalars['String']
   username?: Maybe<Scalars['String']>
}

export type UserPropertiesArgs = {
   systemFieldEnums: Array<UserPropertiesSystemFieldEnum>
}

export type UserAddAnotherGoFsPermissions = {
   __typename?: 'UserAddAnotherGoFsPermissions'
   allowedCreateAddAnotherGofIds: Array<Scalars['String']>
   allowedRemoveAddAnotherGofIds: Array<Scalars['String']>
}

export type UserAlreadyExistWithEmail = GraphQlBaseError & {
   __typename?: 'UserAlreadyExistWithEmail'
   email?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UserAlreadyExistWithUsername = GraphQlBaseError & {
   __typename?: 'UserAlreadyExistWithUsername'
   message?: Maybe<Scalars['String']>
   username: Scalars['String']
}

export type UserAndAdminAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'UserAndAdminAreNotInSameAccount'
   message?: Maybe<Scalars['String']>
}

export type UserAndIdentificationsAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'UserAndIdentificationsAreNotInSameAccount'
   identificationIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type UserAndManagerCannotBeSame = GraphQlBaseError & {
   __typename?: 'UserAndManagerCannotBeSame'
   message?: Maybe<Scalars['String']>
}

export type UserAndMangerAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'UserAndMangerAreNotInSameAccount'
   message?: Maybe<Scalars['String']>
}

export type UserAppConfig = {
   __typename?: 'UserAppConfig'
   accountFeatures: Array<CrmAccountFeature>
   activePluginEnums: Array<PluginType>
   callingPermissions: CallingPermissionsResult
   contactTemplate: ContactTemplate
   isContactsBoardEnabled: Scalars['Boolean']
   isContactsFeatureEnabled: Scalars['Boolean']
   isDealsFeatureEnabled: Scalars['Boolean']
   kmlFiles: Array<FileUploaderUrlResponse>
   leadDistributionSetup?: Maybe<LeadDistributionSetup>
   name: Scalars['String']
   pipelineActivitiesInitiateLeadPermissions: Array<PipelineActivityTemplateIds>
   pipelineWiseFeatures: Array<PipelineWiseFeatures>
   pipelineWisePermittedActions: Array<PipelinePermittedActions>
   pipelineWisePersonalWhatsappMessageStatus: Array<
      PipelinePersonalWhatsAppMessagePermissionStatus
   >
   pipelineWiseWhatsappBusinessPhoneNumbers: Array<
      PipelineWhatsAppBusinessNumbers
   >
   pipelines: Array<BasePipeline>
   taskCallStatusOptions: Array<TaskCallStatusOptionConfig>
   userPropertiesTemplate: UserPropertiesTemplate
}

export type UserAppConfigForAdmin = {
   __typename?: 'UserAppConfigForAdmin'
   accountFeatures: Array<AdminCrmAccountFeature>
   canGenerateCustomId: Scalars['Boolean']
   contactTemplate: ContactTemplate
   isContactsBoardEnabled: Scalars['Boolean']
   isContactsFeatureEnabled: Scalars['Boolean']
   isDealsFeatureEnabled: Scalars['Boolean']
   pipelines: Array<BasePipeline>
   userPropertiesTemplate: UserPropertiesTemplate
}

export type UserAppConfigForAdminResponse =
   | UserAppConfigForAdmin
   | UserIsNotAnAdministrator

export type UserAuthorityNotFound = GraphQlBaseError & {
   __typename?: 'UserAuthorityNotFound'
   fieldRefId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type UserCallingConfig = {
   __typename?: 'UserCallingConfig'
   allowDirectCallingFor?: Maybe<FailedCallType>
   allowDirectCallingForErrors?: Maybe<Array<Maybe<FailedCallType>>>
   allowedCallingType: OutBoundCallType
   cloudCallingCliNumber?: Maybe<PhoneNumberResponse>
   cloudCallingServiceAccountId?: Maybe<Scalars['String']>
   user: BaseUser
   userId: Scalars['String']
}

export type UserCallingConfigParams = {
   /** @deprecated Won't use this variable */
   allowDirectCallingFor?: InputMaybe<FailedCallType>
   allowDirectCallingForErrors?: InputMaybe<Array<InputMaybe<FailedCallType>>>
   allowedCallingType: OutBoundCallType
   cloudCallingCliNumber?: InputMaybe<PhoneNumberParams>
   cloudCallingServiceAccountId?: InputMaybe<Scalars['String']>
   userId: Scalars['String']
}

export type UserCallingConfigResult =
   | CliNumberFormatIsNotValid
   | CloudCallingServiceAccountAndAdminAreNotInSameAccount
   | CloudCallingServiceAccountIdIsRequired
   | CloudCallingServiceAccountIsDeactivated
   | CloudCallingServiceAccountNotFound
   | DeactivatedUser
   | DirectCallingFallBackWhenCloudCallingFailedIsRequired
   | UserAndAdminAreNotInSameAccount
   | UserCallingConfig
   | UserIsNotAnAdministrator
   | UserNotFound
   | UserNotInAccount

export type UserCallingConfigs = {
   __typename?: 'UserCallingConfigs'
   totalCount: Scalars['Int']
   userCallingConfigs: Array<UserCallingConfig>
}

export type UserCannotInitiateLead = GraphQlBaseError & {
   __typename?: 'UserCannotInitiateLead'
   message?: Maybe<Scalars['String']>
}

export type UserCloudCallingConfigsResult =
   | CloudCallingServiceAccountAndAdminAreNotInSameAccount
   | CloudCallingServiceAccountNotFound
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserCallingConfigs
   | UserIsNotAnAdministrator

export type UserCreationRequest = BaseOfficerManagementRequest & {
   __typename?: 'UserCreationRequest'
   accountId: Scalars['String']
   completedAt?: Maybe<Scalars['String']>
   createdAt: Scalars['String']
   designation?: Maybe<Scalars['String']>
   errorMessage?: Maybe<Scalars['String']>
   firstName?: Maybe<Scalars['String']>
   id: Scalars['String']
   initiatedBy: Scalars['String']
   initiatedUser: User
   lastName?: Maybe<Scalars['String']>
   operationType: OfficerManagementOperationType
   phoneNumber?: Maybe<PhoneNumberResponse>
   reason?: Maybe<Scalars['String']>
   status: OfficerManagementStatusType
   updatedAt: Scalars['String']
   user: User
   userId: Scalars['String']
}

export enum UserDashboardType {
   All = 'ALL',
   CreatedBy = 'CREATED_BY',
   Shared = 'SHARED'
}

export type UserDesignationNotFound = GraphQlBaseError & {
   __typename?: 'UserDesignationNotFound'
   fieldRefId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type UserDetailsChange = {
   __typename?: 'UserDetailsChange'
   designation?: Maybe<Scalars['String']>
   firstName?: Maybe<Scalars['String']>
   lastName?: Maybe<Scalars['String']>
   phoneNumber?: Maybe<PhoneNumberResponse>
}

export type UserDetailsUpdateInProgress = GraphQlBaseError & {
   __typename?: 'UserDetailsUpdateInProgress'
   existingRequestId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export type UserDetailsUpdateLog = BaseLtpUserManagementLog & {
   __typename?: 'UserDetailsUpdateLog'
   changes: Array<LtpUserManagementLogChange>
   createdDatetime: Scalars['String']
   id: Scalars['String']
   licenseNumber: Scalars['String']
   logType: Scalars['String']
   name?: Maybe<Scalars['String']>
   reason?: Maybe<Scalars['String']>
   updatedBy?: Maybe<BaseUser>
   userId: Scalars['String']
}

export type UserDoesNotHaveAccessToCreateApplication = GraphQlBaseError & {
   __typename?: 'UserDoesNotHaveAccessToCreateApplication'
   message?: Maybe<Scalars['String']>
}

export type UserDoesNotHaveAccessToCreateLeadWithContact = GraphQlBaseError & {
   __typename?: 'UserDoesNotHaveAccessToCreateLeadWithContact'
   message?: Maybe<Scalars['String']>
}

export type UserDoesNotHaveAccessToCreatePipelineCustomObject = GraphQlBaseError & {
   __typename?: 'UserDoesNotHaveAccessToCreatePipelineCustomObject'
   message?: Maybe<Scalars['String']>
}

export type UserDoesNotHaveMergePermissions = GraphQlBaseError & {
   __typename?: 'UserDoesNotHaveMergePermissions'
   message?: Maybe<Scalars['String']>
}

export type UserDoesNotHavePhoneNumber = GraphQlBaseError & {
   __typename?: 'UserDoesNotHavePhoneNumber'
   message?: Maybe<Scalars['String']>
}

export type UserEmailAlreadyExists = GraphQlBaseError & {
   __typename?: 'UserEmailAlreadyExists'
   message?: Maybe<Scalars['String']>
}

export type UserEmailAlreadyExistsInAnotherAccount = GraphQlBaseError & {
   __typename?: 'UserEmailAlreadyExistsInAnotherAccount'
   message?: Maybe<Scalars['String']>
}

export type UserFilterConditionParams = {
   fieldId: UserSystemPropertiesEnum
   operator: UserPropertyFilterOperator
   value?: InputMaybe<Scalars['String']>
}

export enum UserGoogleAuthConsentStatus {
   Given = 'GIVEN',
   NotGiven = 'NOT_GIVEN'
}

export type UserGoogleCalendarEvent = {
   __typename?: 'UserGoogleCalendarEvent'
   eventId: Scalars['String']
   meetLink?: Maybe<Scalars['String']>
   scheduledAt: Scalars['String']
   title?: Maybe<Scalars['String']>
}

export type UserGoogleCalendarEvents = {
   __typename?: 'UserGoogleCalendarEvents'
   events: Array<UserGoogleCalendarEvent>
   totalCount: Scalars['Int']
}

export type UserGoogleCalendarEventsResponse =
   | GoogleAuthConsentNotGiven
   | GoogleAuthConsentRefreshRequired
   | GoogleCalendarApiRequestsQuotaExceeded
   | UserGoogleCalendarEvents

export type UserGraph = {
   __typename?: 'UserGraph'
   filterSetId?: Maybe<Scalars['String']>
   graph: Graphs
   metricFilterSetId?: Maybe<Scalars['String']>
   widthPercentage: Scalars['Float']
}

export type UserGraphFilterSetIdArgs = {
   params: UserGraphFilterSetParams
}

export type UserGraphMetricFilterSetIdArgs = {
   params: UserGraphFilterSetParams
}

export type UserGraphWidthPercentageArgs = {
   params: UserGraphFilterSetParams
}

export type UserGraphFilterSetParams = {
   graphParentType: GraphParentType
   parentId?: InputMaybe<Scalars['String']>
}

export type UserGraphResult = GraphAccessDenied | GraphNotFound | UserGraph

export enum UserGraphType {
   All = 'ALL',
   CreatedBy = 'CREATED_BY',
   Shared = 'SHARED'
}

export type UserGraphsResponse = {
   __typename?: 'UserGraphsResponse'
   graphs: Array<UserGraph>
   totalGraphs: Scalars['Int']
}

export type UserGroup = {
   __typename?: 'UserGroup'
   name: Scalars['String']
   profilePicUrl?: Maybe<Scalars['String']>
   userGroupId: Scalars['String']
   users: Array<BaseUser>
}

export type UserGroupConfig = BaseIdentification & {
   __typename?: 'UserGroupConfig'
   actions: Array<UserPermission>
   identificationId: Scalars['String']
   identificationType: IdentificationType
   name: Scalars['String']
   profilePicUrl?: Maybe<Scalars['String']>
   users: Array<BaseUser>
}

export type UserGroupsNotFound = GraphQlBaseError & {
   __typename?: 'UserGroupsNotFound'
   message?: Maybe<Scalars['String']>
   userGroupIds: Array<Scalars['String']>
}

export enum UserHierarchyFilter {
   All = 'ALL',
   AssignedToMe = 'ASSIGNED_TO_ME',
   AssignedToMyTeam = 'ASSIGNED_TO_MY_TEAM'
}

export type UserIsNotAnAdministrator = GraphQlBaseError & {
   __typename?: 'UserIsNotAnAdministrator'
   message?: Maybe<Scalars['String']>
}

export type UserKmlFileNotFound = GraphQlBaseError & {
   __typename?: 'UserKmlFileNotFound'
   fileId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UserNotFound = GraphQlBaseError & {
   __typename?: 'UserNotFound'
   message?: Maybe<Scalars['String']>
}

export type UserNotHaveAnyActiveCloudCallingService = GraphQlBaseError & {
   __typename?: 'UserNotHaveAnyActiveCloudCallingService'
   message?: Maybe<Scalars['String']>
}

export type UserNotHaveAnyRoles = GraphQlBaseError & {
   __typename?: 'UserNotHaveAnyRoles'
   message?: Maybe<Scalars['String']>
}

export type UserNotHavePermissionToCreateBoard = GraphQlBaseError & {
   __typename?: 'UserNotHavePermissionToCreateBoard'
   message?: Maybe<Scalars['String']>
}

export type UserNotHavePermissionToCreateBoardList = GraphQlBaseError & {
   __typename?: 'UserNotHavePermissionToCreateBoardList'
   message?: Maybe<Scalars['String']>
}

export type UserNotHavePermissionToUpdateToGivenStage = GraphQlBaseError & {
   __typename?: 'UserNotHavePermissionToUpdateToGivenStage'
   message?: Maybe<Scalars['String']>
   stageId: Scalars['String']
}

export type UserNotInAccount = GraphQlBaseError & {
   __typename?: 'UserNotInAccount'
   message?: Maybe<Scalars['String']>
}

export type UserOrganizationLevelNotFound = GraphQlBaseError & {
   __typename?: 'UserOrganizationLevelNotFound'
   fieldRefId: Scalars['String']
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export enum UserPermission {
   AssigneeHistoryLog = 'ASSIGNEE_HISTORY_LOG',
   CreateBoard = 'CREATE_BOARD',
   MobileAppAccess = 'MOBILE_APP_ACCESS',
   OverallHistoryLog = 'OVERALL_HISTORY_LOG',
   StageHistoryLog = 'STAGE_HISTORY_LOG',
   WebAppAccess = 'WEB_APP_ACCESS'
}

export type UserPhoneNumber = {
   __typename?: 'UserPhoneNumber'
   phoneNumber: PhoneNumberResponse
   userId: Scalars['String']
}

export type UserPhoneNumberAlreadyExist = GraphQlBaseError & {
   __typename?: 'UserPhoneNumberAlreadyExist'
   message?: Maybe<Scalars['String']>
   phoneNumber?: Maybe<PhoneNumberResponse>
}

export type UserPhoneNumberNotFound = GraphQlBaseError & {
   __typename?: 'UserPhoneNumberNotFound'
   message?: Maybe<Scalars['String']>
}

export type UserPinExpired = GraphQlBaseError & {
   __typename?: 'UserPinExpired'
   expiresAt?: Maybe<Scalars['String']>
   lastChangedAt?: Maybe<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type UserPinLocked = GraphQlBaseError & {
   __typename?: 'UserPinLocked'
   expiresAt?: Maybe<Scalars['String']>
   lastChangedAt?: Maybe<Scalars['String']>
   lockedUntil: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type UserPinNotConfigured = GraphQlBaseError & {
   __typename?: 'UserPinNotConfigured'
   message?: Maybe<Scalars['String']>
}

export type UserPinStatus = {
   __typename?: 'UserPinStatus'
   expiresAt?: Maybe<Scalars['String']>
   lastChangedAt?: Maybe<Scalars['String']>
   lockedUntil?: Maybe<Scalars['String']>
}

export type UserPortalSettings = {
   __typename?: 'UserPortalSettings'
   language: LanguageEnum
}

export enum UserProfileFieldEnum {
   SignatureImgLink = 'SIGNATURE_IMG_LINK'
}

export type UserProfileFieldValuesShouldBeEmpty = GraphQlBaseError & {
   __typename?: 'UserProfileFieldValuesShouldBeEmpty'
   fields: Array<UserProfileFieldEnum>
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export enum UserPropertiesSystemFieldEnum {
   UserDob = 'USER_DOB',
   UserEmail = 'USER_EMAIL',
   UserFirstName = 'USER_FIRST_NAME',
   UserGender = 'USER_GENDER',
   UserLastName = 'USER_LAST_NAME',
   UserPhoneNumber = 'USER_PHONE_NUMBER',
   UserUsername = 'USER_USERNAME'
}

export type UserPropertiesSystemFieldUpdateIsNotSupported = GraphQlBaseError & {
   __typename?: 'UserPropertiesSystemFieldUpdateIsNotSupported'
   message?: Maybe<Scalars['String']>
   systemFieldEnum: UserPropertiesSystemFieldEnum
}

export type UserPropertiesTemplate = {
   __typename?: 'UserPropertiesTemplate'
   accountId: Scalars['String']
   config?: Maybe<UserPropertiesTemplateConfig>
   gofs: Array<GoF>
   name: Scalars['String']
   orderedGofIds: Array<Scalars['String']>
   userPropertiesTemplateId: Scalars['String']
}

export type UserPropertiesTemplateConfig = {
   __typename?: 'UserPropertiesTemplateConfig'
   designationFieldId?: Maybe<Scalars['String']>
}

export type UserPropertiesTemplateNotFound = GraphQlBaseError & {
   __typename?: 'UserPropertiesTemplateNotFound'
   message?: Maybe<Scalars['String']>
   userPropertiesTemplateId: Scalars['String']
}

export enum UserPropertyFilterOperator {
   Contains = 'CONTAINS',
   Empty = 'EMPTY',
   In = 'IN',
   Is = 'IS',
   NotEmpty = 'NOT_EMPTY'
}

export enum UserReaction {
   Dislike = 'DISLIKE',
   Like = 'LIKE'
}

export type UserResult = User | UserNotFound

export type UserSignatureImgLinkNotConfigured = GraphQlBaseError & {
   __typename?: 'UserSignatureImgLinkNotConfigured'
   message?: Maybe<Scalars['String']>
   userId: Scalars['String']
}

export enum UserSystemPropertiesEnum {
   Email = 'EMAIL',
   IsAdmin = 'IS_ADMIN',
   Manager = 'MANAGER',
   Name = 'NAME',
   Role = 'ROLE',
   UserGroup = 'USER_GROUP'
}

export type UserTabFilterCondition = {
   __typename?: 'UserTabFilterCondition'
   fieldId: UserSystemPropertiesEnum
   operator: UserPropertyFilterOperator
   value?: Maybe<UsersTabFilterValueResponseType>
}

export enum UserTasksFilter {
   All = 'ALL',
   AssignedToMe = 'ASSIGNED_TO_ME',
   AssignedToMyTeam = 'ASSIGNED_TO_MY_TEAM'
}

export enum UserType {
   Architect = 'ARCHITECT',
   Citizen = 'CITIZEN',
   Officer = 'OFFICER',
   System = 'SYSTEM',
   User = 'USER'
}

export type UserViewsInBoardListParams = {
   listId: Scalars['String']
}

export type UserViewsInBoardListResponse =
   | BoardListNotFound
   | BoardListReadAccessDenied
   | ViewsResult

export type UserViewsInBoardParams = {
   boardId: Scalars['String']
}

export type UserViewsInBoardResponse =
   | BoardNotFound
   | BoardReadAccessDenied
   | ViewsResult

export type UsernameAlreadyAssigned = GraphQlBaseError & {
   __typename?: 'UsernameAlreadyAssigned'
   currentUserId: Scalars['String']
   message?: Maybe<Scalars['String']>
   username: Scalars['String']
}

export type UsernameAlreadyExists = GraphQlBaseError & {
   __typename?: 'UsernameAlreadyExists'
   message?: Maybe<Scalars['String']>
}

export type UsernameAlreadyExistsInAnotherAccount = GraphQlBaseError & {
   __typename?: 'UsernameAlreadyExistsInAnotherAccount'
   message?: Maybe<Scalars['String']>
}

export type UsernameNotFound = GraphQlBaseError & {
   __typename?: 'UsernameNotFound'
   message?: Maybe<Scalars['String']>
   username: Scalars['String']
}

export type UsernameSearchResult = {
   __typename?: 'UsernameSearchResult'
   totalCount: Scalars['Int']
   usernames: Array<Scalars['String']>
}

export type UsersAndAdminAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'UsersAndAdminAreNotInSameAccount'
   message?: Maybe<Scalars['String']>
   userIds: Array<Scalars['String']>
}

export type UsersAreAlreadyToLinkedPipeline = GraphQlBaseError & {
   __typename?: 'UsersAreAlreadyToLinkedPipeline'
   message?: Maybe<Scalars['String']>
   userIds: Array<Scalars['String']>
}

export type UsersAreNotInSameAccount = GraphQlBaseError & {
   __typename?: 'UsersAreNotInSameAccount'
   message?: Maybe<Scalars['String']>
}

export type UsersDoesNotHaveAnyRoles = GraphQlBaseError & {
   __typename?: 'UsersDoesNotHaveAnyRoles'
   message?: Maybe<Scalars['String']>
   userIds: Array<Scalars['String']>
}

export enum UsersFilter {
   AdminUsers = 'ADMIN_USERS',
   NonAdminUsers = 'NON_ADMIN_USERS'
}

export type UsersInAccountResponse =
   | AccountNotFound
   | AccountUsers
   | InvalidLimit
   | InvalidOffset
   | PaginationLimitExceeded
   | UserIsNotAnAdministrator
   | UserNotInAccount
   | UsersNotFound

export type UsersNotFound = GraphQlBaseError & {
   __typename?: 'UsersNotFound'
   message?: Maybe<Scalars['String']>
   userIds: Array<Scalars['String']>
}

export type UsersNotInAccount = GraphQlBaseError & {
   __typename?: 'UsersNotInAccount'
   message?: Maybe<Scalars['String']>
   userIds: Array<Scalars['String']>
}

export type UsersTabCustomizationFilters = {
   __typename?: 'UsersTabCustomizationFilters'
   filterConditions: Array<UserTabFilterCondition>
}

export type UsersTabFilterConditionMultiValueResponse = {
   __typename?: 'UsersTabFilterConditionMultiValueResponse'
   responses: Array<UsersTabFilterConditionValue>
}

export type UsersTabFilterConditionValue =
   | BaseUser
   | GqlBooleanType
   | GqlStringType
   | IdentificationOverviewDetails

export type UsersTabFilterConditionValueResponse = {
   __typename?: 'UsersTabFilterConditionValueResponse'
   response?: Maybe<UsersTabFilterConditionValue>
}

export type UsersTabFilterValueResponseType =
   | UsersTabFilterConditionMultiValueResponse
   | UsersTabFilterConditionValueResponse

export type ValidateTdrRequestCertificateNumberInPortalParams = {
   authority: Scalars['String']
   certificateAttachment?: InputMaybe<TdrCertificateAttachmentParams>
   certificateNumber: Scalars['String']
   marketValueOfUsageArea?: InputMaybe<Scalars['Float']>
   portalId: Scalars['String']
   portalType: PortalType
   requestedArea: Scalars['Float']
   tdrRequestId: Scalars['String']
}

export type ValidateTdrRequestCertificateNumberInPortalResponse =
   | AuthorityFieldNotFilled
   | CertificateNoExistsForOtherTdrRequests
   | InvalidTdrRequestAuthority
   | MarketValueShouldBePositiveValue
   | NotAllowedActionOnTdrRequest
   | PortalAccessDenied
   | PortalIsDeleted
   | PortalNotFound
   | PrecisionLimitExceededForTdrRequestedArea
   | RequestedAreaGreaterThanAllocatedArea
   | TdrCertificateUrlIsRequired
   | TdrRequestCertificateNumberNotFound
   | TdrRequestEntityAccessDenied
   | TdrRequestNotFound
   | TdrRequestedAreaShouldNotBeNegative
   | ValidateTdrRequestCertificateNumberInPortalResult

export type ValidateTdrRequestCertificateNumberInPortalResult = {
   __typename?: 'ValidateTDRRequestCertificateNumberInPortalResult'
   maskedPhoneNumber: Scalars['String']
   tdrRequest: TdrRequest
}

export type ValidationRulesFailedForFields = GraphQlBaseError & {
   __typename?: 'ValidationRulesFailedForFields'
   failedValidationRules: Array<FieldValidationRulesFailedErrData>
   message?: Maybe<Scalars['String']>
}

export type ValueFieldSourceIsRequired = GraphQlBaseError & {
   __typename?: 'ValueFieldSourceIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ValueIsRequired = GraphQlBaseError & {
   __typename?: 'ValueIsRequired'
   message?: Maybe<Scalars['String']>
}

export type ValueResponseType =
   | ConditionMultiValueResponse
   | ConditionValueResponse

export type VerificationAssigneeNotAssigned = GraphQlBaseError & {
   __typename?: 'VerificationAssigneeNotAssigned'
   message?: Maybe<Scalars['String']>
}

export type VerificationNotFound = GraphQlBaseError & {
   __typename?: 'VerificationNotFound'
   message?: Maybe<Scalars['String']>
   verificationId: Scalars['String']
}

export type VerificationRequest = {
   __typename?: 'VerificationRequest'
   remarks?: Maybe<Scalars['String']>
   requestId?: Maybe<Scalars['String']>
   status?: Maybe<LineDepartmentRequestStatus>
}

export type VerificationRequestHistoryLog = {
   __typename?: 'VerificationRequestHistoryLog'
   createdAt: Scalars['String']
   id: Scalars['String']
   performedByUser: BaseUser
   performedByUserId: Scalars['String']
   remarks: Scalars['String']
   status: LineDepartmentRequestStatus
}

export type VerificationTab = BaseTab & {
   __typename?: 'VerificationTab'
   contextFieldsMapping: Array<VerificationTabContextFieldsMapping>
   enableOverallObservationAndRemarks: Scalars['Boolean']
   enableTabStatusIcon: Scalars['Boolean']
   icon?: Maybe<IconConfig>
   name: Scalars['String']
   parentTabId?: Maybe<Scalars['String']>
   shouldEnableHistoryLogs: Scalars['Boolean']
   tabId: Scalars['String']
   tabType: TabType
   taskStatus?: Maybe<LayoutTabTaskStatus>
   taskTemplateId: Scalars['String']
}

export type VerificationTabContextFieldsMapping = {
   __typename?: 'VerificationTabContextFieldsMapping'
   contextFieldIds: Array<Scalars['String']>
   questionFieldId: Scalars['String']
}

export type VerificationTaskAlreadyExists = GraphQlBaseError & {
   __typename?: 'VerificationTaskAlreadyExists'
   message?: Maybe<Scalars['String']>
}

export type VerifyOtpForUpdatingUserPinParams = {
   otp: Scalars['String']
   pinPurpose: PinPurpose
}

export type VerifyOtpForUpdatingUserPinResponse =
   | InvalidOtp
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | VerifyOtpForUpdatingUserPinResult

export type VerifyOtpForUpdatingUserPinResult = {
   __typename?: 'VerifyOtpForUpdatingUserPinResult'
   success: Scalars['Boolean']
}

export type VerifyOtpToPipelineItemPhoneNumberFieldInPortalParams = {
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   otp: Scalars['String']
   pipelineItemId: Scalars['String']
   portalId: Scalars['String']
   portalType?: InputMaybe<PortalType>
}

export type VerifyOtpToPipelineItemPhoneNumberFieldInPortalResponse =
   | ApplicationAccessDenied
   | ApplicationIsDeleted
   | ApplicationNotFound
   | ExpectedPhoneNumberFieldType
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidOtp
   | NotPermittedFields
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | OtpVerificationNotEnabledForField
   | PhoneNumberAlreadyVerified
   | PhoneNumberFieldResponseNotFilled
   | PhoneNumberUpdatedAgainForField
   | PortalNotFound
   | VerifyOtpToPipelineItemPhoneNumberFieldInPortalResult

export type VerifyOtpToPipelineItemPhoneNumberFieldInPortalResult = {
   __typename?: 'VerifyOtpToPipelineItemPhoneNumberFieldInPortalResult'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   phoneNumberResponse: PhoneNumberResponse
   pipelineItemId: Scalars['String']
}

export type VerifyOtpToPipelineItemPhoneNumberFieldParams = {
   fieldId: Scalars['String']
   gofResponseId?: InputMaybe<Scalars['String']>
   otp: Scalars['String']
   pipelineItemId: Scalars['String']
}

export type VerifyOtpToPipelineItemPhoneNumberFieldResponse =
   | ExpectedPhoneNumberFieldType
   | FieldsAreDeleted
   | FieldsNotFound
   | InvalidOtp
   | NotPermittedFields
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | OtpVerificationNotEnabledForField
   | PhoneNumberAlreadyVerified
   | PhoneNumberFieldResponseNotFilled
   | PhoneNumberUpdatedAgainForField
   | PipelineItemAccessDenied
   | PipelineItemIsDeleted
   | PipelineItemNotFound
   | VerifyOtpToPipelineItemPhoneNumberFieldResult

export type VerifyOtpToPipelineItemPhoneNumberFieldResult = {
   __typename?: 'VerifyOtpToPipelineItemPhoneNumberFieldResult'
   fieldId: Scalars['String']
   gofResponseId?: Maybe<Scalars['String']>
   phoneNumberResponse: PhoneNumberResponse
   pipelineItemId: Scalars['String']
}

export type VerifyTdrRequestOtpInPortalParams = {
   otp: Scalars['String']
   portalId: Scalars['String']
   portalType: PortalType
   tdrRequestId: Scalars['String']
}

export type VerifyTdrRequestOtpInPortalResponse =
   | InvalidOtp
   | NotAllowedActionOnTdrRequest
   | OtpIsExpired
   | OtpLengthMismatched
   | OtpMaxRetriesExceeded
   | PortalAccessDenied
   | PortalIsDeleted
   | PortalNotFound
   | TdrRequestEntityAccessDenied
   | TdrRequestNotFound
   | VerifyTdrRequestOtpInPortalResult

export type VerifyTdrRequestOtpInPortalResult = {
   __typename?: 'VerifyTDRRequestOTPInPortalResult'
   tdrRequest: TdrRequest
}

export type View = {
   __typename?: 'View'
   name: Scalars['String']
   viewCustomization: ViewCustomization
   viewId: Scalars['String']
}

export type ViewAccessDenied = GraphQlBaseError & {
   __typename?: 'ViewAccessDenied'
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export enum ViewAndEditSanctionDetailsColumnType {
   FieldLabel = 'FIELD_LABEL',
   FieldValue = 'FIELD_VALUE',
   SNo = 'S_NO'
}

export type ViewAndEditSanctionDetailsConfig = {
   __typename?: 'ViewAndEditSanctionDetailsConfig'
   name: Scalars['String']
   sections: Array<ViewAndEditSanctionDetailsSection>
   tabsToDisplay: Array<Scalars['String']>
}

export enum ViewAndEditSanctionDetailsDisplayType {
   AddAnotherGofTable = 'ADD_ANOTHER_GOF_TABLE',
   Default = 'DEFAULT',
   Table = 'TABLE'
}

export type ViewAndEditSanctionDetailsSection = {
   __typename?: 'ViewAndEditSanctionDetailsSection'
   addAnotherGofId?: Maybe<Scalars['String']>
   displayType: ViewAndEditSanctionDetailsDisplayType
   fieldIds: Array<Scalars['String']>
   name: Scalars['String']
   sectionId: Scalars['String']
   tableColumns?: Maybe<Array<ViewAndEditSanctionDetailsTableColumn>>
   tableRows?: Maybe<Array<ViewAndEditSanctionDetailsTableRow>>
}

export type ViewAndEditSanctionDetailsTableCell = {
   __typename?: 'ViewAndEditSanctionDetailsTableCell'
   columnId: Scalars['String']
   fieldId?: Maybe<Scalars['String']>
}

export type ViewAndEditSanctionDetailsTableColumn = {
   __typename?: 'ViewAndEditSanctionDetailsTableColumn'
   columnGroup?: Maybe<Scalars['String']>
   columnId: Scalars['String']
   columnType: ViewAndEditSanctionDetailsColumnType
   name: Scalars['String']
}

export type ViewAndEditSanctionDetailsTableRow = {
   __typename?: 'ViewAndEditSanctionDetailsTableRow'
   cells: Array<ViewAndEditSanctionDetailsTableCell>
   rowId: Scalars['String']
}

export type ViewBoardNotLinkedToPipeline = GraphQlBaseError & {
   __typename?: 'ViewBoardNotLinkedToPipeline'
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export type ViewCustomization = {
   __typename?: 'ViewCustomization'
   filterSetId?: Maybe<Scalars['String']>
   mobileViewCustomJson?: Maybe<Scalars['String']>
   sortByFields: Array<SortResponse>
   viewType: ViewType
   webViewCustomJson?: Maybe<Scalars['String']>
}

export type ViewGraphAccessDenied = GraphQlBaseError & {
   __typename?: 'ViewGraphAccessDenied'
   graphId: Scalars['String']
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export type ViewNotFound = GraphQlBaseError & {
   __typename?: 'ViewNotFound'
   message?: Maybe<Scalars['String']>
   viewId: Scalars['String']
}

export type ViewResult = View | ViewAccessDenied | ViewNotFound

export enum ViewType {
   Analytics = 'ANALYTICS',
   Kanban = 'KANBAN',
   List = 'LIST',
   Table = 'TABLE'
}

export type ViewsResult = {
   __typename?: 'ViewsResult'
   views: Array<View>
}

export type VillageFieldNotFound = GraphQlBaseError & {
   __typename?: 'VillageFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type VisibilityRulesNotFound = GraphQlBaseError & {
   __typename?: 'VisibilityRulesNotFound'
   message?: Maybe<Scalars['String']>
   ruleIds: Array<Scalars['String']>
}

export type VisibilityRulesNotLinkedToApplicationTemplate = GraphQlBaseError & {
   __typename?: 'VisibilityRulesNotLinkedToApplicationTemplate'
   message?: Maybe<Scalars['String']>
   ruleIds: Array<Scalars['String']>
}

export type VltFormatInvalid = GraphQlBaseError & {
   __typename?: 'VltFormatInvalid'
   expectedFormat: Scalars['String']
   message?: Maybe<Scalars['String']>
   vltNumber: Scalars['String']
}

export type VltNotFoundInPropertyTax = GraphQlBaseError & {
   __typename?: 'VltNotFoundInPropertyTax'
   message?: Maybe<Scalars['String']>
   vltNumber: Scalars['String']
}

export type VltPropertyTaxApiError = GraphQlBaseError & {
   __typename?: 'VltPropertyTaxApiError'
   apiError: Scalars['String']
   message?: Maybe<Scalars['String']>
   vltNumber: Scalars['String']
}

export type VrEntityVisibility = {
   __typename?: 'VrEntityVisibility'
   entityId: Scalars['String']
   entityType: RuleEntityType
   isVisible: Scalars['Boolean']
}

export type WatiAccount = BasePluginServiceAccount & {
   __typename?: 'WatiAccount'
   accessToken: Scalars['String']
   baseUrl: Scalars['String']
   creationDatetime: Scalars['String']
   enableReadReceipts: Scalars['Boolean']
   isActive: Scalars['Boolean']
   name: Scalars['String']
   pluginServiceAccountId: Scalars['String']
   webhookUrl?: Maybe<Scalars['String']>
}

export type WatiAccountNameAlreadyExists = GraphQlBaseError & {
   __typename?: 'WatiAccountNameAlreadyExists'
   message?: Maybe<Scalars['String']>
   name: Scalars['String']
}

export type WatiAccountResult = PluginServiceAccountNotFound | WatiAccount

export type WatiPluginServiceAccountNotFound = GraphQlBaseError & {
   __typename?: 'WatiPluginServiceAccountNotFound'
   message?: Maybe<Scalars['String']>
   pluginServiceAccountId: Scalars['String']
}

export type WatiServiceAccountAccessTokenHasExpired = GraphQlBaseError & {
   __typename?: 'WatiServiceAccountAccessTokenHasExpired'
   message?: Maybe<Scalars['String']>
   pluginServiceAccountId: Scalars['String']
}

export type WatiServiceAccounts = {
   __typename?: 'WatiServiceAccounts'
   watiAccounts: Array<WatiAccountResult>
}

export enum WebhookNodeHeaderFieldSourceType {
   DirectValue = 'DIRECT_VALUE',
   LeadDetails = 'LEAD_DETAILS',
   ParametersStore = 'PARAMETERS_STORE',
   TriggerEntityDetails = 'TRIGGER_ENTITY_DETAILS'
}

export enum WeekDayEnum {
   Friday = 'FRIDAY',
   Monday = 'MONDAY',
   Saturday = 'SATURDAY',
   Sunday = 'SUNDAY',
   Thursday = 'THURSDAY',
   Tuesday = 'TUESDAY',
   Wednesday = 'WEDNESDAY'
}

export type WeightageNotConfiguredParameters = GraphQlBaseError & {
   __typename?: 'WeightageNotConfiguredParameters'
   message?: Maybe<Scalars['String']>
   scoringParameterIds: Array<Scalars['String']>
}

export type WhatsAppBusinessNumber = {
   __typename?: 'WhatsAppBusinessNumber'
   pipelineId: Scalars['String']
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
   users: Array<BaseUser>
   whatsappBusinessPhoneNumber?: Maybe<BaseWhatsAppBusinessNumber>
}

export type WhatsAppBusinessPhoneNumber = {
   __typename?: 'WhatsAppBusinessPhoneNumber'
   gallaboxChannelId?: Maybe<Scalars['String']>
   phoneNumber: PhoneNumberResponse
   pipelineConfigs: Array<WhatsAppBusinessPhoneNumberPipelineConfig>
   pluginServiceAccountId: Scalars['String']
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type WhatsAppBusinessPhoneNumberAlreadyExists = GraphQlBaseError & {
   __typename?: 'WhatsAppBusinessPhoneNumberAlreadyExists'
   message?: Maybe<Scalars['String']>
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type WhatsAppBusinessPhoneNumberNotFound = GraphQlBaseError & {
   __typename?: 'WhatsAppBusinessPhoneNumberNotFound'
   message?: Maybe<Scalars['String']>
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type WhatsAppBusinessPhoneNumberNotLinkedToPipeline = GraphQlBaseError & {
   __typename?: 'WhatsAppBusinessPhoneNumberNotLinkedToPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   whatsappBusinessPhoneNumberId: Scalars['String']
}

export type WhatsAppBusinessPhoneNumberPipelineConfig = {
   __typename?: 'WhatsAppBusinessPhoneNumberPipelineConfig'
   pipelineId: Scalars['String']
   pipelinePermissionLostUserIds: Array<Scalars['String']>
   pipelineWhatsappBusinessPhoneNumberId: Scalars['String']
   users: Array<BaseUser>
}

export type WhatsAppMessageButton = {
   __typename?: 'WhatsAppMessageButton'
   copyOfferCode?: Maybe<Scalars['String']>
   phoneNumber?: Maybe<Scalars['String']>
   text?: Maybe<Scalars['String']>
   type?: Maybe<WhatsAppMessageButtonType>
   url?: Maybe<Scalars['String']>
   urlType?: Maybe<WhatsAppMessageButtonUrlType>
}

export enum WhatsAppMessageButtonType {
   CallToAction = 'CALL_TO_ACTION',
   QuickReply = 'QUICK_REPLY'
}

export enum WhatsAppMessageButtonUrlType {
   Dynamic = 'DYNAMIC',
   Static = 'STATIC'
}

export enum WhatsAppMessageMediaType {
   Audio = 'AUDIO',
   Document = 'DOCUMENT',
   Image = 'IMAGE',
   Sticker = 'STICKER',
   Video = 'VIDEO'
}

export type WhatsAppMessageRecipient = {
   __typename?: 'WhatsAppMessageRecipient'
   assignee?: Maybe<BaseUser>
   msgSentToPhoneNumber?: Maybe<PhoneNumberResponse>
}

export type WhatsAppMessageTemplateIsDeleted = GraphQlBaseError & {
   __typename?: 'WhatsAppMessageTemplateIsDeleted'
   message?: Maybe<Scalars['String']>
   name?: Maybe<Scalars['String']>
   whatsappMessageTemplateId: Scalars['String']
}

export type WhatsAppMessageTemplateMediaInfo = {
   __typename?: 'WhatsAppMessageTemplateMediaInfo'
   link?: Maybe<Scalars['String']>
   mediaName?: Maybe<Scalars['String']>
   mediaType: WhatsAppMessageMediaType
   mediaUrlType: WhatsAppMessageTemplateMediaUrlType
   variable?: Maybe<Scalars['String']>
}

export enum WhatsAppMessageTemplateMediaUrlType {
   Dynamic = 'DYNAMIC',
   Static = 'STATIC'
}

export type WhatsAppMessageTemplateNotFound = GraphQlBaseError & {
   __typename?: 'WhatsAppMessageTemplateNotFound'
   message?: Maybe<Scalars['String']>
   whatsappMessageTemplateId: Scalars['String']
}

export type WhatsAppMessageTemplateNotLinkedToPipeline = GraphQlBaseError & {
   __typename?: 'WhatsAppMessageTemplateNotLinkedToPipeline'
   message?: Maybe<Scalars['String']>
   pipelineId: Scalars['String']
   whatsappMessageTemplateId: Scalars['String']
}

export type WhatsAppMessageTemplatePipelineConfig = {
   __typename?: 'WhatsAppMessageTemplatePipelineConfig'
   buttonVariableFieldId?: Maybe<Scalars['String']>
   identifications: Array<IdentificationOverviewDetails>
   pipelineId: Scalars['String']
   variables: Array<WhatsAppMessageTemplateVariableField>
}

export type WhatsAppMessageTemplateResponse =
   | PipelineItemMessageTemplate
   | WhatsAppMessageTemplateIsDeleted

export type WhatsAppMessageTemplateVariableField = {
   __typename?: 'WhatsAppMessageTemplateVariableField'
   fieldId: Scalars['String']
   variableName: Scalars['String']
}

export type WhatsAppMessageTemplateVariableFieldParams = {
   fieldId: Scalars['String']
   variableName: Scalars['String']
}

export type WhatsAppMessageTemplateVariablesNotFound = GraphQlBaseError & {
   __typename?: 'WhatsAppMessageTemplateVariablesNotFound'
   message?: Maybe<Scalars['String']>
   variableNames: Array<Scalars['String']>
}

export enum WhatsAppMessageTemplatesSyncStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   InProgress = 'IN_PROGRESS'
}

export enum WhatsAppMessageType {
   Media = 'MEDIA',
   Text = 'TEXT'
}

export type WhatsAppMsgTemplateAndBusinessPhoneNumberNotLinkedToSameAccount = GraphQlBaseError & {
   __typename?: 'WhatsAppMsgTemplateAndBusinessPhoneNumberNotLinkedToSameAccount'
   message?: Maybe<Scalars['String']>
}

export type WhatsAppMsgTemplateVariableNamesNotFound = GraphQlBaseError & {
   __typename?: 'WhatsAppMsgTemplateVariableNamesNotFound'
   message?: Maybe<Scalars['String']>
   variableNames: Array<Scalars['String']>
}

export type WhatsAppProviderError = GraphQlBaseError & {
   __typename?: 'WhatsAppProviderError'
   message?: Maybe<Scalars['String']>
   providerError: Scalars['String']
}

export type WhatsAppVariableParams = {
   name: Scalars['String']
   value: Scalars['String']
}

export type WhatsappMessageTemplatesSyncIsInProgress = GraphQlBaseError & {
   __typename?: 'WhatsappMessageTemplatesSyncIsInProgress'
   message?: Maybe<Scalars['String']>
   pluginServiceAccountId: Scalars['String']
}

export type WidthPercentageShouldBePositive = GraphQlBaseError & {
   __typename?: 'WidthPercentageShouldBePositive'
   message?: Maybe<Scalars['String']>
   widthPercentage: Scalars['Float']
}

export enum WorkCommencementStatus {
   No = 'NO',
   Yes = 'YES'
}

export enum WorkFlowExecLogFilterStatus {
   Done = 'DONE',
   Failed = 'FAILED',
   Processing = 'PROCESSING'
}

export type WriteRolesNotFound = GraphQlBaseError & {
   __typename?: 'WriteRolesNotFound'
   message?: Maybe<Scalars['String']>
   roleIds: Array<Scalars['String']>
}

export type YouAreNotAllowedToEditSystemBoards = GraphQlBaseError & {
   __typename?: 'YouAreNotAllowedToEditSystemBoards'
   boardId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type YouAreNotAllowedToMoveDependentField = GraphQlBaseError & {
   __typename?: 'YouAreNotAllowedToMoveDependentField'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}

export type YouCanLinkRelatedEntitiesToOnlyOneEntityInOneToMany = GraphQlBaseError & {
   __typename?: 'YouCanLinkRelatedEntitiesToOnlyOneEntityInOneToMany'
   message?: Maybe<Scalars['String']>
   relatedEntityIds: Array<Scalars['String']>
}

export type YouCanNotResetSubmittedTask = GraphQlBaseError & {
   __typename?: 'YouCanNotResetSubmittedTask'
   message?: Maybe<Scalars['String']>
   taskId: Scalars['String']
}

export type YouDonNotHavePermissionToSetGivenUserAsAssignee = GraphQlBaseError & {
   __typename?: 'YouDonNotHavePermissionToSetGivenUserAsAssignee'
   message?: Maybe<Scalars['String']>
}

export type YouDonNotHavePermissionToSetGivenUsersAsAssignees = GraphQlBaseError & {
   __typename?: 'YouDonNotHavePermissionToSetGivenUsersAsAssignees'
   assigneeIds: Array<Scalars['String']>
   message?: Maybe<Scalars['String']>
}

export type YouDontHaveAnyPendingSigns = GraphQlBaseError & {
   __typename?: 'YouDontHaveAnyPendingSigns'
   message?: Maybe<Scalars['String']>
}

export type ZeroDivisionFound = GraphQlBaseError & {
   __typename?: 'ZeroDivisionFound'
   message?: Maybe<Scalars['String']>
}

export type ZohoSignRateLimited = GraphQlBaseError & {
   __typename?: 'ZohoSignRateLimited'
   message?: Maybe<Scalars['String']>
   retryAfterSeconds?: Maybe<Scalars['Int']>
}

export type ZohoSignServiceUnavailable = GraphQlBaseError & {
   __typename?: 'ZohoSignServiceUnavailable'
   message?: Maybe<Scalars['String']>
   statusCode: Scalars['Int']
}

export type ZonalCodeFieldNotFound = GraphQlBaseError & {
   __typename?: 'ZonalCodeFieldNotFound'
   fieldId: Scalars['String']
   message?: Maybe<Scalars['String']>
}
